var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __hasOwnProp = Object.prototype.hasOwnProperty;
function __accessProp(key) {
  return this[key];
}
var __toCommonJS = (from) => {
  var entry = (__moduleCache ??= new WeakMap).get(from), desc;
  if (entry)
    return entry;
  entry = __defProp({}, "__esModule", { value: true });
  if (from && typeof from === "object" || typeof from === "function") {
    for (var key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(entry, key))
        __defProp(entry, key, {
          get: __accessProp.bind(from, key),
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
  }
  __moduleCache.set(from, entry);
  return entry;
};
var __moduleCache;
var __returnValue = (v) => v;
function __exportSetter(name, newValue) {
  this[name] = __returnValue.bind(null, newValue);
}
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: __exportSetter.bind(all, name)
    });
};
var __esm = (fn, res) => () => (fn && (res = fn(fn = 0)), res);

// Hoisted class definitions

class TextComponentClass {
  _toChatComponent() {
    throw new Error("Not implemented");
  }
}
ConditionTextComponentClass = class ConditionTextComponentClass extends TextComponentClass {
    _toChatComponent() {
      throw new Error("Not implemented");
    }
    _toMinecraftCondition() {
      throw new Error("Not implemented");
    }
  };
VectorClass = class VectorClass {
    values;
    constructor(values) {
      if (!Array.isArray(values) || !values.every((i) => typeof i === "string")) {
        throw new Error(`Expected array of string for Vector values, got ${inspect(values)}`);
      }
      this.values = values;
    }
    toString() {
      return this.values.join(" ");
    }
    toJSON() {
      return this.toString();
    }
    toNBT() {
      return `'${this.toString()}'`;
    }
    [Symbol.iterator]() {
      return this.values[Symbol.iterator]();
    }
    static subtractedFrom(a, b) {
      if (b instanceof VectorClass ? b.values.length > a.values.length : b.length > a.values.length) {
        throw new Error("[VectorClass#subtractedFrom] Attempted to subtract with in-balanced components");
      }
      const bComponents = b instanceof VectorClass ? b.values : b;
      const components = [];
      for (const [_i, component] of Object.entries(a.values)) {
        const i = Number(_i);
        if (bComponents[i] === undefined) {
          components.push(component);
          continue;
        }
        if (component.startsWith("~")) {
          if (bComponents[i].startsWith("~")) {
            components.push(component.slice(1) === "" ? `~${Number(bComponents[i].slice(1)) * -1}` : `~${Number(component.slice(1)) - Number(bComponents[i].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#subtractedFrom] Attempted to subtract ${bComponents[i]} from ${component} (a[${i}]). Incompatible plane.`);
        }
        if (component.startsWith("^")) {
          if (bComponents[i].startsWith("^")) {
            components.push(component.slice(1) === "" ? `^${Number(bComponents[i].slice(1)) * -1}` : `^${Number(component.slice(1)) - Number(bComponents[i].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#subtractedFrom] Attempted to subtract ${bComponents[i]} from ${component} (a[${i}]). Incompatible plane.`);
        }
        if (bComponents[i].startsWith("~") || bComponents[i].startsWith("^")) {
          throw new Error(`[VectorClass#subtractedFrom] Attempted to subtract ${bComponents[i]} from ${component} (a[${i}]). Incompatible plane.`);
        }
        components.push(`${Number(component) - Number(bComponents[i])}`);
      }
      return new VectorClass([...components]);
    }
    static addedTo(a, b) {
      if (b instanceof VectorClass ? b.values.length > a.values.length : b.length > a.values.length) {
        throw new Error("[VectorClass#addedTo] Attempted to add with in-balanced components");
      }
      const bComponents = b instanceof VectorClass ? b.values : b;
      const components = [];
      for (const [_i, component] of Object.entries(a.values)) {
        const i = Number(_i);
        if (bComponents[i] === undefined) {
          components.push(component);
          continue;
        }
        if (component.startsWith("~")) {
          if (bComponents[i].startsWith("~")) {
            components.push(component.slice(1) === "" ? bComponents[i] : `~${Number(component.slice(1)) + Number(bComponents[0].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#addedTo] Attempted to add ${bComponents[i]} to ${component} (a[${i}]). Incompatible plane.`);
        }
        if (component.startsWith("^")) {
          if (bComponents[i].startsWith("^")) {
            components.push(component.slice(1) === "" ? bComponents[i] : `^${Number(component.slice(1)) + Number(bComponents[0].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#addedTo] Attempted to add ${bComponents[i]} to ${component} (a[${i}]). Incompatible plane.`);
        }
        if (bComponents[i].startsWith("~") || bComponents[i].startsWith("^")) {
          throw new Error(`[VectorClass#addedTo] Attempted to add ${bComponents[i]} to ${component} (a[${i}]). Incompatible plane.`);
        }
        components.push(`${Number(component) + Number(bComponents)}`);
      }
      return new VectorClass([...components]);
    }
    static multipliedBy(a, b) {
      if (b instanceof VectorClass ? b.values.length > a.values.length : b.length > a.values.length) {
        throw new Error("[VectorClass#addedTo] Attempted to add with in-balanced components");
      }
      const bComponents = b instanceof VectorClass ? b.values : b;
      const components = [];
      for (const [_i, component] of Object.entries(a.values)) {
        const i = Number(_i);
        if (bComponents[i] === undefined) {
          components.push(component);
          continue;
        }
        if (component.startsWith("~")) {
          if (bComponents[i].startsWith("~")) {
            components.push(component.slice(1) === "" ? bComponents[i] : `~${Number(component.slice(1)) * Number(bComponents[0].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#addedTo] Attempted to multiply ${component} (a[${i}]) by ${bComponents[i]}. Incompatible plane.`);
        }
        if (component.startsWith("^")) {
          if (bComponents[i].startsWith("^")) {
            components.push(component.slice(1) === "" ? bComponents[i] : `^${Number(component.slice(1)) * Number(bComponents[0].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#addedTo] Attempted to multiply ${component} (a[${i}]) by ${bComponents[i]}. Incompatible plane.`);
        }
        if (bComponents[i].startsWith("~") || bComponents[i].startsWith("^")) {
          throw new Error(`[VectorClass#addedTo] Attempted to multiply ${component} (a[${i}]) by ${bComponents[i]}. Incompatible plane.`);
        }
        components.push(`${Number(component) * Number(bComponents)}`);
      }
      return new VectorClass([...components]);
    }
    static dividedBy(a, b) {
      if (b instanceof VectorClass ? b.values.length > a.values.length : b.length > a.values.length) {
        throw new Error("[VectorClass#addedTo] Attempted to add with in-balanced components");
      }
      const bComponents = b instanceof VectorClass ? b.values : b;
      const components = [];
      for (const [_i, component] of Object.entries(a.values)) {
        const i = Number(_i);
        if (bComponents[i] === undefined) {
          components.push(component);
          continue;
        }
        if (component.startsWith("~")) {
          if (bComponents[i].startsWith("~")) {
            components.push(component.slice(1) === "" ? bComponents[i] : `~${Number(component.slice(1)) / Number(bComponents[0].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#addedTo] Attempted to divide ${component} (a[${i}]) by ${bComponents[i]}. Incompatible plane.`);
        }
        if (component.startsWith("^")) {
          if (bComponents[i].startsWith("^")) {
            components.push(component.slice(1) === "" ? bComponents[i] : `^${Number(component.slice(1)) / Number(bComponents[0].slice(1))}`);
            continue;
          }
          throw new Error(`[VectorClass#addedTo] Attempted to divide ${component} (a[${i}]) by ${bComponents[i]}. Incompatible plane.`);
        }
        if (bComponents[i].startsWith("~") || bComponents[i].startsWith("^")) {
          throw new Error(`[VectorClass#addedTo] Attempted to divide ${component} (a[${i}]) by ${bComponents[i]}. Incompatible plane.`);
        }
        components.push(`${Number(component) / Number(bComponents)}`);
      }
      return new VectorClass([...components]);
    }
    static relativeTo(base, anchor) {
      if (base.values.find((component) => component.startsWith("~") || component.startsWith("^")) !== undefined) {
        throw new Error("[VectorClass#relativeTo] Attempted use on non-absolute coordinates");
      }
      const anchorIsArray = Array.isArray(anchor);
      if (!anchorIsArray && anchor.values.find((component) => component.startsWith("~") || component.startsWith("^")) !== undefined) {
        throw new Error("[VectorClass#relativeTo] Attempted use with a non-absolute anchor");
      }
      const newVector = base.values.map((component, i) => {
        const baseN = Number(component);
        const anchorN = Number(anchorIsArray ? anchor[i] : anchor.values[i]);
        return baseN - anchorN;
      });
      return relative(newVector[0], ...newVector.slice(1));
    }
    static fromRelative(base, origin) {
      if (base.values.filter((component) => component.startsWith("~")).length !== base.values.length) {
        throw new Error("[VectorClass#fromRelative] Attempted use on non-relative coordinates");
      }
      const originIsArray = Array.isArray(origin);
      if (!originIsArray && origin.values.find((component) => component.startsWith("~") || component.startsWith("^")) !== undefined) {
        throw new Error("[VectorClass#fromRelative] Attempted use with a non-absolute origin");
      }
      const newVector = base.values.map((component, i) => {
        const baseN = Number(component);
        const originN = Number(originIsArray ? origin[i] : origin.values[i]);
        return originN + baseN;
      });
      return absolute(newVector[0], ...newVector.slice(1));
    }
  };
class MacroArgument {
  sandstoneCore;
  local;
  toMacro;
  constructor(sandstoneCore) {
    this.sandstoneCore = sandstoneCore;
    this.local = new Map;
    this.toMacro = () => {
      let currentMCFunctionName = "";
      try {
        currentMCFunctionName = sandstoneCore.getCurrentMCFunctionOrThrow().resource.name;
      } catch {}
      let result = this.local.get(this.sandstoneCore.currentNode) || this.local.get(currentMCFunctionName);
      if (!result) {
        let path = this.sandstoneCore.currentNode;
        while (path.includes("/")) {
          path = path.substring(0, path.lastIndexOf("/"));
          result = this.local.get(path);
          if (result)
            break;
        }
      }
      if (result === undefined) {
        const location = this.sandstoneCore.currentNode || currentMCFunctionName;
        const registered = [...this.local.keys()];
        throw new Error(`[MacroArgument#toMacro] No macro variable is registered for this argument in \`${location || "<no MCFunction context>"}\`. ` + (registered.length > 0 ? `It is only registered in: ${registered.map((name) => `\`${name}\``).join(", ")}.` : "It is not registered in any MCFunction.") + " A macro argument has to be declared by the MCFunction that uses it —" + " pass it in the env array (`MCFunction(name, [arg], ...)`, `_.with([arg], ...)`)" + " or declare it as a callback parameter.");
      }
      return `$(${result})`;
    };
  }
}
MacroLiteral = class MacroLiteral extends MacroArgument {
    sandstoneCore;
    strings;
    macros;
    toMacro;
    constructor(sandstoneCore, strings, macros) {
      super(sandstoneCore);
      this.sandstoneCore = sandstoneCore;
      this.strings = strings;
      this.macros = macros;
      this.toMacro = () => {
        let result = "";
        for (const [i, string] of this.strings.entries()) {
          result += string;
          const macro = this.macros[i];
          if (macro !== undefined && macro !== null) {
            if (typeof macro === "string" || typeof macro === "number") {
              result += `${macro}`;
            } else {
              result += macro.toMacro();
              if (result.endsWith("}")) {
                console.warn("what", macro);
              }
            }
          }
        }
        return result;
      };
    }
  };
DataPointPickClass = class DataPointPickClass extends MacroArgument {
    _toDataPoint() {
      throw new Error("Not implemented");
    }
  };
ConditionalDataPointPickClass = class ConditionalDataPointPickClass extends DataPointPickClass {
    _toMinecraftCondition() {
      throw new Error("Not implemented");
    }
  };
Set2 = class Set2 extends global.Set {
    constructor(...args) {
      super(...args);
    }
    has(value) {
      return super.has(value);
    }
  };
class NBTClass {
}
NBTPrimitive = class NBTPrimitive extends NBTClass {
    value;
    unit;
    constructor(value, unit) {
      super();
      this.value = value;
      this.unit = unit;
    }
    toJSON() {
      return this.value;
    }
    [util2.inspect.custom] = () => `${this.value}${this.unit}`;
  };
NBTLong = class NBTLong extends NBTPrimitive {
    constructor(value) {
      super(value, "l");
    }
  };
NBTByte = class NBTByte extends NBTPrimitive {
    constructor(value) {
      super(value, "b");
    }
  };
NBTShort = class NBTShort extends NBTPrimitive {
    constructor(value) {
      super(value, "s");
    }
  };
NBTFloat = class NBTFloat extends NBTPrimitive {
    constructor(value) {
      super(value, "f");
    }
  };
NBTInt = class NBTInt extends NBTPrimitive {
    constructor(value) {
      super(value, "i");
    }
  };
NBTDouble = class NBTDouble extends NBTPrimitive {
    constructor(value) {
      super(value, "d");
    }
  };
NBTTypedArray = class NBTTypedArray extends NBTClass {
    values;
    unit;
    constructor(values, unit) {
      super();
      this.values = values;
      this.unit = unit;
    }
    toJSON() {
      return this.values;
    }
    [util2.inspect.custom] = () => `[${this.unit};${this.values.length === 0 ? "" : this.values.join(",")}]`;
  };
NBTLongArray = class NBTLongArray extends NBTTypedArray {
    constructor(values) {
      super(values, "L");
    }
  };
NBTByteArray = class NBTByteArray extends NBTTypedArray {
    constructor(values) {
      super(values, "B");
    }
  };
NBTIntArray = class NBTIntArray extends NBTTypedArray {
    constructor(values) {
      super(values, "I");
    }
  };
NotNBT = class NotNBT extends NBTClass {
    nbt;
    constructor(nbt) {
      super();
      this.nbt = nbt;
    }
    [util2.inspect.custom] = () => `!${nbtResolver(this.nbt)}`;
  };
NBTString = class NBTString extends NBTPrimitive {
  };
NBTAnyValue = class NBTAnyValue extends NBTPrimitive {
  };
Score = class Score extends MacroArgument {
    sandstonePack;
    target;
    display;
    objective;
    commands;
    constructor(sandstonePack, target, display, objective) {
      super(sandstonePack.core);
      this.sandstonePack = sandstonePack;
      this.target = target;
      this.display = display;
      this.objective = objective;
      this.commands = sandstonePack.commands;
      if (display !== undefined) {
        if (sandstonePack.core.currentMCFunction) {
          this.setDisplay(display);
        } else {
          sandstonePack.initMCFunction.push(() => this.setDisplay(display));
        }
      }
    }
    toString() {
      return `${this.target} ${this.objective}`;
    }
    toNBT() {
      return nbtResolver(this._toChatComponent()).toString();
    }
    toJSON() {
      return this._toChatComponent();
    }
    _toChatComponent() {
      return {
        score: { name: `${this.target}`, objective: this.objective }
      };
    }
    _toMinecraftCondition = () => this.sandstonePack._.not(new this.sandstonePack.conditions.Score(this.sandstonePack.core, [
      `${this.target}`,
      `${this.objective}`,
      "matches",
      "0"
    ]));
    unaryOperation(operation, operator, ...args) {
      if (typeof args[0] === "number") {
        if (args[0] < 0 && operation !== "set") {
          return this.binaryOperation(operator, args[0]);
        }
        this.commands.scoreboard.players[operation](this, args[0]);
      } else if (args[0] instanceof Score) {
        this.commands.scoreboard.players.operation(this, operator, args[0].target, args[0].objective);
      } else {
        this.commands.scoreboard.players.operation(this, operator, args[0], args[1] ?? this.objective);
      }
      return this;
    }
    binaryOperation(operator, ...args) {
      if (args[0] instanceof Score) {
        this.commands.scoreboard.players.operation(this, operator, args[0].target, args[0].objective);
        return this;
      }
      let objective = args[1] ?? this.objective;
      if (typeof args[0] === "number") {
        this.sandstonePack.registerNewConstant(args[0]);
        objective = "__sandstone";
      }
      this.commands.scoreboard.players.operation(this, operator, args[0], objective);
      return this;
    }
    setDisplay = (display) => {
      if (display.name) {
        this.commands.scoreboard.players.display.name(this, display.name);
      }
      if (display.numberformat) {
        if (display.numberformat === "blank") {
          this.commands.scoreboard.players.display.numberformat(this, "blank");
        } else if (display.numberformat[0] === "styled") {
          this.commands.scoreboard.players.display.numberformat(this, "styled", display.numberformat[1]);
        } else {
          this.commands.scoreboard.players.display.numberformat(this, "fixed", display.numberformat[1]);
        }
      }
      this.display = display;
      return this;
    };
    reset = () => {
      this.commands.scoreboard.players.reset(this);
    };
    set(...args) {
      if (typeof args[0] === "object" && !(args[0] instanceof SelectorPickClass) && !(args[0] instanceof Score)) {
        const [data, scale] = args;
        this.commands.execute.store.result.score(this).run.data.get[data.type](data.currentTarget, data.path, scale);
        return this;
      }
      return this.unaryOperation("set", "=", ...args);
    }
    "=" = this.set;
    add(...args) {
      return this.unaryOperation("add", "+=", ...args);
    }
    "+=" = this.add;
    remove(...args) {
      return this.unaryOperation("remove", "-=", ...args);
    }
    "-=" = this.remove;
    increase() {
      return this.add(1);
    }
    get "++"() {
      return this.increase();
    }
    decrease() {
      return this.remove(1);
    }
    get "--"() {
      return this.decrease();
    }
    multiply(...args) {
      return this.binaryOperation("*=", ...args);
    }
    "*=" = this.multiply;
    divide(...args) {
      return this.binaryOperation("/=", ...args);
    }
    "/=" = this.divide;
    modulo(...args) {
      return this.binaryOperation("%=", ...args);
    }
    mod = this.modulo;
    "%=" = this.modulo;
    swap(...args) {
      this.binaryOperation("><", ...args);
    }
    "><" = this.swap;
    plus(...args) {
      return createVariable(this.sandstonePack, this).unaryOperation("add", "+=", ...args);
    }
    "+" = this.plus;
    minus(...args) {
      return createVariable(this.sandstonePack, this).unaryOperation("remove", "-=", ...args);
    }
    "-" = this.minus;
    multipliedBy(...args) {
      return createVariable(this.sandstonePack, this).binaryOperation("*=", ...args);
    }
    times = this.multipliedBy;
    "*" = this.multipliedBy;
    dividedBy(...args) {
      return createVariable(this.sandstonePack, this).binaryOperation("/=", ...args);
    }
    "/" = this.dividedBy;
    moduloBy(...args) {
      return createVariable(this.sandstonePack, this).binaryOperation("%=", ...args);
    }
    modBy = this.moduloBy;
    "%" = this.moduloBy;
    comparison(operator, matchesRange, args) {
      const playerScore = this;
      if (typeof args[0] === "number") {
        return {
          __conditionClassBrand: true,
          _toMinecraftCondition: () => new this.sandstonePack.conditions.Score(this.sandstonePack.core, [
            `${playerScore.target}`,
            `${playerScore.objective}`,
            "matches",
            matchesRange
          ])
        };
      }
      const endArgs = args[1] ? args : [args[0]];
      return {
        __conditionClassBrand: true,
        _toMinecraftCondition: () => new this.sandstonePack.conditions.Score(this.sandstonePack.core, [
          `${playerScore.target}`,
          `${playerScore.objective}`,
          operator,
          ...endArgs.map((arg) => arg.toString())
        ])
      };
    }
    greaterThan(...args) {
      return this.comparison(">", `${typeof args[0] === "number" ? args[0] + 1 : null}..`, args);
    }
    ">" = this.greaterThan;
    greaterThanOrEqualTo(...args) {
      return this.comparison(">=", `${args[0]}..`, args);
    }
    ">=" = this.greaterThanOrEqualTo;
    lessThan(...args) {
      return this.comparison("<", `..${typeof args[0] === "number" ? args[0] - 1 : null}`, args);
    }
    "<" = this.lessThan;
    lessThanOrEqualTo(...args) {
      return this.comparison("<=", `..${args[0]}`, args);
    }
    "<=" = this.lessThanOrEqualTo;
    equalTo(...args) {
      return this.comparison("=", args[0].toString(), args);
    }
    equals = this.equalTo;
    "==" = this.equalTo;
    notEqualTo(...args) {
      return this.sandstonePack._.not(this.comparison("=", args[0].toString(), args));
    }
    "!=" = this.notEqualTo;
    matches = (range) => ({
      __conditionClassBrand: true,
      _toMinecraftCondition: () => new this.sandstonePack.conditions.Score(this.sandstonePack.core, [
        `${this.target}`,
        `${this.objective}`,
        "matches",
        rangeParser(this.sandstoneCore, range)
      ])
    });
    match = (minimum, maximum, callback) => {
      const { MCFunction, Macro, core } = this.sandstonePack;
      const { getCurrentMCFunctionOrThrow } = core;
      if (maximum > 1000) {
        console.warn(`
Warning: Score.match() will have to create ${maximum - minimum} mcfunction files, this *will* take a while. ` + "Consider only compiling this once and saving it to external resources.");
      }
      const matcher = matchers++;
      const score = this;
      const parent = getCurrentMCFunctionOrThrow();
      for (let i = minimum;i <= maximum; i++) {
        MCFunction(`./score_match/${matcher}/${i}`, () => callback(i));
      }
      return MCFunction(`./score_match/${matcher}`, [score], () => Macro.returnCmd.run.functionCmd(Macro`${parent.resource.name}/score_match/${matcher}/${score}`));
    };
    getDecomposer(size, splitsOrCount, componentCount = 31, includeSign = true) {
      if (typeof this.target !== "string" || this.target.search(/-|@/) !== -1) {
        throw new Error("[Score#getDecomposer] Must use a fake-player Score for decomposition.");
      }
      const { MCFunction, _, commands } = this.sandstonePack;
      const { execute, returnCmd } = commands;
      const newScore = this.objective.ScoreHolder;
      const components = [];
      const sign = includeSign ? newScore(`${this.target}._32`) : undefined;
      let decompose;
      if (size === "bit" || size === undefined) {
        for (let i = 1;i <= componentCount; i++) {
          components.push(newScore(`${this.target}._${i}`));
        }
        decompose = MCFunction(`__sandstone:score/decompose_bits/${componentCount}_${splitsOrCount === undefined ? 0 : splitsOrCount.size}/${this.target.replaceAll(".", "/").toLowerCase()}`, () => {
          const resetBits = execute.store.result(components[0]);
          for (const component of components.slice(1, -1)) {
            resetBits.store.result(component);
            resetBits.nestedExecute(["\\\n "], false);
          }
          if (includeSign) {
            resetBits.store.result(components.at(-1));
            resetBits.nestedExecute(["\\\n "], false);
            resetBits.run(() => sign["="](0));
          } else {
            resetBits.run(() => components.at(-1)["="](0));
          }
          const input = newScore(`${this.target}._bf_iterator`);
          const splits = splitsOrCount ?? new Set;
          const bitExecute = (bit) => execute.store.success(components[bit - 1]);
          input["="](this);
          _.if(this["=="](0), () => {
            returnCmd(1);
          });
          if (includeSign) {
            execute.store.success(sign).if.score(input, "matches", [null, -1]).run(() => {
              input["*="](-1);
            });
          }
          input.decomposeBits(splits, componentCount, bitExecute);
        }, {
          creator: "sandstone",
          onConflict: "rename",
          addToSandstoneCore: true
        });
      } else {
        throw new Error("[Score#getDecomposer(byte)] Byte decomposition is not yet supported");
      }
      const result = {
        components,
        ...add({ sign })
      };
      return {
        ...result,
        decompose: () => {
          decompose();
          return result;
        }
      };
    }
    decomposeBits(splits, componentCount, bitExecute, extra) {
      const { _ } = this.sandstonePack;
      const sortedSplits = [...splits].filter((s) => s > 0 && s < componentCount).sort((a, b) => b - a);
      const boundaries = [componentCount, ...sortedSplits, 0];
      const processRange = (high, low) => {
        let halvedAgain = 2 ** high;
        for (let bit = high;bit >= low; bit--) {
          halvedAgain /= 2;
          bitExecute(bit, halvedAgain).if.score(this, "matches", [halvedAgain, null]).run(() => {
            this["-="](halvedAgain);
            extra?.(bit, halvedAgain);
          });
        }
      };
      const buildNested = (rangeIndex) => {
        const high = boundaries[rangeIndex];
        const low = boundaries[rangeIndex + 1] + 1;
        if (rangeIndex > 0) {
          const higherMinValue = 2 ** boundaries[rangeIndex];
          _.if(this.matches([higherMinValue, null]), () => {
            buildNested(rangeIndex - 1);
          });
        }
        processRange(high, low);
      };
      if (splits.size === 0) {
        processRange(componentCount, 1);
      } else {
        const lowestRangeIndex = boundaries.length - 2;
        buildNested(lowestRangeIndex);
      }
    }
    [util3.inspect.custom](_depth, options) {
      return formatDebugString(this.constructor.name, {
        target: this.target,
        display: this.display,
        objective: this.objective.name
      }, undefined, options.indent);
    }
  };
DataPointClass = class DataPointClass extends MacroArgument {
    sandstonePack;
    type;
    path;
    currentTarget;
    constructor(sandstonePack, type, target, path) {
      super(sandstonePack.core);
      this.sandstonePack = sandstonePack;
      this.type = type;
      this.path = NBTpathToString(sandstonePack, path);
      this.currentTarget = target;
      if (this.type === "storage" && target.indexOf(":") === -1) {
        this.currentTarget = `${this.sandstonePack.core.pack.defaultNamespace}:${target}`;
      }
    }
    target = (target) => new DataPointClass(this.sandstonePack, this.type, target, [this.path]);
    select = (...path) => new DataPointClass(this.sandstonePack, this.type, this.currentTarget, [this.path, ...path]);
    modify = (cb, value) => {
      const data = cb(this.sandstonePack.commands.data.modify[this.type](this.currentTarget, this.path));
      if (value instanceof StringDataPointClass) {
        if (!value.sliceBounds[1])
          data.string[value.type](value.currentTarget, value.path, value.sliceBounds[0]);
        else
          data.string[value.type](value.currentTarget, value.path, value.sliceBounds[0], value.sliceBounds[1]);
        return this;
      }
      if (value instanceof DataPointClass) {
        data.from[value.type](value.currentTarget, value.path);
        return this;
      }
      if (value instanceof DataPointPickClass) {
        this.set(value._toDataPoint());
        return this;
      }
      data.value(value);
      return this;
    };
    string = (cb, value, start, end) => {
      const data = cb(this.sandstonePack.commands.data.modify[this.type](this.currentTarget, this.path));
      if (!end)
        data.string[value.type](value.currentTarget, value.path, start);
      else
        data.string[value.type](value.currentTarget, value.path, start, end);
    };
    executeStore = (storeType, scale) => this.sandstonePack.commands.execute.store.result[this.type](this.currentTarget, this.path, storeType, scale);
    set(value, storeType, scale = 1) {
      if (value instanceof Score) {
        this.executeStore(storeType || "int", scale).run.scoreboard.players.get(value.target, value.objective);
        return this;
      }
      this.modify((data) => data.set, value);
      return this;
    }
    merge = (value) => this.modify((data) => data.merge, value);
    append = (value) => this.modify((data) => data.append, value);
    prepend = (value) => this.modify((data) => data.prepend, value);
    insert = (value, index) => this.modify((data) => data.insert(index), value);
    remove = () => {
      return this.sandstonePack.commands.data.remove[this.type](this.currentTarget, this.path);
    };
    slice = (start, end) => new StringDataPointClass(this.sandstonePack, this.type, this.currentTarget, this.path, start, end);
    _toMinecraftCondition = () => new this.sandstonePack.conditions.DataPointExists(this.sandstonePack.core, this);
    equals = (value) => new this.sandstonePack.conditions.DataPointEquals(this.sandstonePack.core, this, value);
    _toChatComponent = () => ({
      nbt: this.path,
      [this.type]: this.currentTarget
    });
    toNBT = () => nbtResolver(this._toChatComponent()).toString();
  };
StringDataPointClass = class StringDataPointClass extends DataPointClass {
    sandstonePack;
    type;
    sliceBounds;
    constructor(sandstonePack, type, target, path, start, end) {
      super(sandstonePack, type, target, [path]);
      this.sandstonePack = sandstonePack;
      this.type = type;
      this.sliceBounds = [start];
      if (end)
        this.sliceBounds.push(end);
    }
  };
class PackType {
  type;
  clientPath;
  serverPath;
  rootPath;
  networkSides;
  resourceSubFolder;
  namespaced;
  archiveOutput;
  handleOutput;
  constructor(type, clientPath, serverPath, rootPath, networkSides, archiveOutput = false, resourceSubFolder, namespaced = false) {
    this.type = type;
    this.clientPath = clientPath;
    this.serverPath = serverPath;
    this.rootPath = rootPath;
    this.networkSides = networkSides;
    this.archiveOutput = archiveOutput;
    this.resourceSubFolder = resourceSubFolder;
    this.namespaced = namespaced;
  }
}
DataPackDependencies = class DataPackDependencies extends PackType {
    constructor() {
      super("datapack_dependencies", "saves/$worldName$/datapacks", "world/datapacks", "datapacks", "server", false, undefined, false);
    }
    handleOutput = async (type) => {
      if (type === "output") {}
    };
  };
ResourcePackDependencies = class ResourcePackDependencies extends PackType {
    constructor() {
      super("resourcepack_dependencies", "resourcepacks", "dependency_resources", "resourcepacks", "client", false, undefined, false);
    }
    handleOutput = async (type) => {
      if (type === "output") {}
    };
  };
Node = class Node {
    sandstoneCore;
    constructor(sandstoneCore) {
      this.sandstoneCore = sandstoneCore;
    }
    [util4.inspect.custom](_depth, _options) {
      return `${this.constructor.name}()`;
    }
    type = this.constructor.name;
  };
ContainerNode = class ContainerNode extends Node {
    _body;
    constructor(sandstoneCore) {
      super(sandstoneCore);
      this._body = [];
    }
    get body() {
      return this._body;
    }
    set body(body) {
      this._body = body;
    }
    generateBody(callback) {
      this.sandstoneCore.insideContext(this, () => {
        callback();
      });
      return this.body;
    }
    append(...nodes) {
      this.body.push(...nodes);
      return nodes.length === 1 ? nodes[0] : nodes;
    }
    prepend(...nodes) {
      this.body.unshift(...nodes);
      return nodes.length === 1 ? nodes[0] : nodes;
    }
    [util4.inspect.custom](depth, options) {
      return formatDebugString(this.constructor.name, undefined, this.body, options.indent);
    }
  };
CommandNode = class CommandNode extends Node {
    sandstonePack;
    args;
    commited = false;
    isMacro = false;
    constructor(sandstonePack, ...args) {
      super(sandstonePack.core);
      this.sandstonePack = sandstonePack;
      this.args = args;
    }
    getValue() {
      const filteredArgs = this.command === "" ? [] : [this.command];
      let hasMacroArgs = false;
      for (const arg of this.args) {
        if (arg !== undefined && arg !== null) {
          if (typeof arg === "object") {
            if (arg instanceof ResolvedNBT) {
              if (arg.containsMacro) {
                hasMacroArgs = true;
              }
              filteredArgs.push(arg);
            } else if (isMacroArgument(this.sandstoneCore, arg)) {
              hasMacroArgs = true;
              filteredArgs.push(arg.toMacro());
            } else if (Object.hasOwn(arg, "_hasMacro") && arg._hasMacro) {
              hasMacroArgs = true;
              filteredArgs.push(arg);
            } else if (Object.hasOwn(arg, "toLoop")) {
              filteredArgs.push(arg.toLoop());
            } else {
              filteredArgs.push(arg);
            }
          } else {
            filteredArgs.push(arg);
          }
        }
      }
      if (hasMacroArgs && !this.isMacro) {
        throw new Error(`[${this.constructor.name}#getValue] Received macro argument(s) but was not declared as a macro command.`);
      }
      if (!hasMacroArgs && this.isMacro) {
        throw new Error(`[${this.constructor.name}#getValue] Command was declared as a macro command but received no macro argument(s).`);
      }
      return `${this.isMacro ? "$" : ""}${filteredArgs.join(" ")}`;
    }
    commit() {
      if (this.commited) {
        return this;
      }
      this.commited = true;
      return this.sandstonePack.appendNode(this);
    }
    [util4.inspect.custom](depth, options) {
      return formatDebugString(this.constructor.name, this.args, undefined, options.indent);
    }
  };
ContainerCommandNode = class ContainerCommandNode extends CommandNode {
    _body;
    constructor(sandstonePack, ...args) {
      super(sandstonePack, ...args);
      this._body = [];
    }
    get body() {
      return this._body;
    }
    set body(body) {
      this._body = body;
    }
    generateBody(callback) {
      this.sandstoneCore.insideContext(this, () => {
        callback();
      });
      this._body = this.body;
      return this._body;
    }
    append(node) {
      this.body.push(node);
      return node;
    }
    prepend(node) {
      this.body.unshift(node);
      return node;
    }
    [util4.inspect.custom](depth, options) {
      return formatDebugString(this.constructor.name, this.args, this.body, options.indent);
    }
    createMCFunction = (_currentMCFunction) => ({ node: this });
  };
AwaitNode = class AwaitNode extends ContainerCommandNode {
    mcfunction = undefined;
  };
CommentCommandNode = class CommentCommandNode extends CommandNode {
    command = "#";
    getValue() {
      return this.args[0].join(" ").split(`
`).map((line) => `# ${line}`).join(`
`);
    }
  };
class CommandArguments {
  sandstonePack;
  isMacro;
  previousNode;
  autoCommit;
  NodeType;
  sandstoneCore;
  sandstoneCommands;
  constructor(sandstonePack, isMacro = false, previousNode, autoCommit = true) {
    this.sandstonePack = sandstonePack;
    this.isMacro = isMacro;
    this.previousNode = previousNode;
    this.autoCommit = autoCommit;
    this.sandstoneCore = sandstonePack.core;
    this.sandstoneCommands = sandstonePack.commands;
  }
  getNode = () => {
    if (this.previousNode) {
      return this.previousNode;
    }
    if (this.NodeType) {
      const node = new this.NodeType(this.sandstonePack);
      node.isMacro = node.isMacro || this.isMacro;
      return node;
    }
    throw new Error("No node type specified & no previous node for a non-root-level command");
  };
  finalCommand = (args, currentNode) => {
    const node = currentNode ?? this.getNode();
    if (args) {
      node.args.push(...args);
    }
    if (this.autoCommit) {
      node.commit();
    }
    return new FinalCommandOutput(node);
  };
  subCommand = (args, NextArgumentType, executable = false, additionalNextArgs = [], currentNode) => {
    const node = currentNode ?? this.getNode();
    if (args) {
      node.args.push(...args);
    }
    if (executable && this.autoCommit) {
      node.commit();
    }
    return new NextArgumentType(this.sandstonePack, this.isMacro, node, this.autoCommit, ...additionalNextArgs);
  };
}
CommentCommand = class CommentCommand extends CommandArguments {
    NodeType = CommentCommandNode;
    comment = (...comments) => this.finalCommand([comments]);
  };
RawCommandNode = class RawCommandNode extends CommandNode {
    command = "";
  };
RawCommand = class RawCommand extends CommandArguments {
    NodeType = RawCommandNode;
    raw = (...args) => this.finalCommand([...args]);
  };
CloneCommandNode = class CloneCommandNode extends CommandNode {
    command = "clone";
  };
CloneCommand = class CloneCommand extends CommandArguments {
    NodeType = CloneCommandNode;
    clone(begin, end, destination) {
      if (begin === undefined) {
        return this.subCommand([], CloneFromDimensionCommand, false);
      }
      return this.subCommand([begin, end, destination].map(coordinatesParser), CloneOptionsCommand, true);
    }
  };
CloneFromDimensionCommand = class CloneFromDimensionCommand extends CommandArguments {
    from(dimension, begin, end, destination) {
      if (destination === undefined) {
        return this.subCommand(["from", dimension, coordinatesParser(begin), coordinatesParser(end)], CloneToDimensionCommand, false);
      }
      return this.subCommand(["from", ...[begin, end, destination].map(coordinatesParser)], CloneOptionsCommand, true);
    }
  };
CloneToDimensionCommand = class CloneToDimensionCommand extends CommandArguments {
    to = (dimension, destination) => this.subCommand(["to", dimension, coordinatesParser(destination)], CloneOptionsCommand, true);
  };
CloneOptionsCommand = class CloneOptionsCommand extends CommandArguments {
    replace = () => this.subCommand(["replace"], CloneModeCommand, true);
    strict = () => this.subCommand(["strict"], CloneStrictOptionsCommand, true);
    masked = () => this.subCommand(["masked"], CloneModeCommand, true);
    filtered = (filter) => this.subCommand(["filtered", filter], CloneModeCommand, true);
  };
CloneStrictOptionsCommand = class CloneStrictOptionsCommand extends CommandArguments {
    replace = () => this.subCommand(["replace"], CloneModeCommand, true);
    masked = () => this.subCommand(["masked"], CloneModeCommand, true);
    filtered = (filter) => this.subCommand(["filtered", filter], CloneModeCommand, true);
  };
CloneModeCommand = class CloneModeCommand extends CommandArguments {
    force = () => this.finalCommand(["force"]);
    move = () => this.finalCommand(["move"]);
    normal = () => this.finalCommand(["normal"]);
  };
SetBlockCommandNode = class SetBlockCommandNode extends CommandNode {
    command = "setblock";
  };
SetBlockCommand = class SetBlockCommand extends CommandArguments {
    NodeType = SetBlockCommandNode;
    setblock(pos, block, arg3, arg4, arg5) {
      if (arg3 === undefined && arg4 === undefined) {
        return this.finalCommand([coordinatesParser(pos), block, arg5]);
      }
      const state = typeof arg3 === "undefined" ? "" : blockStateStringifier(arg3);
      const nbt = typeof arg4 === "string" || arg4 === undefined ? "" : nbtResolver(arg4).toString();
      const setblockType = typeof arg4 === "string" ? arg4 : arg5;
      return this.finalCommand([coordinatesParser(pos), `${block}${state}${nbt}`, setblockType]);
    }
  };
FillCommandNode = class FillCommandNode extends CommandNode {
    command = "fill";
  };
FillCommand = class FillCommand extends CommandArguments {
    NodeType = FillCommandNode;
    fill(from, to, block, state, nbt) {
      const stateStr = state && Object.keys(state).length > 0 ? blockStateStringifier(state) : "";
      const nbtStr = nbt ? nbtResolver(nbt).toString() : "";
      const blockArg = `${block}${stateStr}${nbtStr}`;
      return this.subCommand([coordinatesParser(from), coordinatesParser(to), blockArg], FillArgumentsCommand, true);
    }
  };
FillArgumentsCommand = class FillArgumentsCommand extends CommandArguments {
    destroy = () => this.finalCommand(["destroy"]);
    hollow = () => this.finalCommand(["hollow"]);
    keep = () => this.finalCommand(["keep"]);
    outline = () => this.finalCommand(["outline"]);
    strict = () => this.finalCommand(["strict"]);
    replace(filter, filterState, filterNbt) {
      if (filter === undefined) {
        return this.finalCommand(["replace"]);
      }
      const stateStr = filterState && Object.keys(filterState).length > 0 ? blockStateStringifier(filterState) : "";
      const nbtStr = filterNbt ? nbtResolver(filterNbt).toString() : "";
      return this.subCommand(["replace", `${filter}${stateStr}${nbtStr}`], FillReplaceFilterCommand, true);
    }
  };
FillReplaceFilterCommand = class FillReplaceFilterCommand extends CommandArguments {
    destroy = () => this.finalCommand(["destroy"]);
    hollow = () => this.finalCommand(["hollow"]);
    outline = () => this.finalCommand(["outline"]);
    strict = () => this.finalCommand(["strict"]);
  };
PlaceCommandNode = class PlaceCommandNode extends CommandNode {
    command = "place";
  };
PlaceCommand = class PlaceCommand extends CommandArguments {
    NodeType = PlaceCommandNode;
    feature = (feature, pos = "~ ~ ~") => this.finalCommand(["feature", feature, coordinatesParser(pos)]);
    jigsaw = (pool, target, maxDepth, pos = "~ ~ ~") => this.finalCommand([
      "jigsaw",
      pool,
      target,
      `${validateIntegerRange(maxDepth, "Jigsaw max depth", 0, 7)}`,
      coordinatesParser(pos)
    ]);
    structure = (configuredStructure, pos = "~ ~ ~") => this.finalCommand(["structure", configuredStructure, coordinatesParser(pos)]);
    template = (structure, pos = "~ ~ ~", rotation, mirror, integrity = 1, seed = 0, mode) => {
      this.finalCommand([
        "template",
        `${structure}`,
        coordinatesParser(pos),
        structureRotationParser(rotation),
        structureMirrorParser(mirror),
        `${integrity}`,
        `${seed}`,
        ...mode === undefined ? [] : [mode]
      ]);
    };
  };
AttributeCommandNode = class AttributeCommandNode extends CommandNode {
    command = "attribute";
  };
AttributeCommand = class AttributeCommand extends CommandArguments {
    NodeType = AttributeCommandNode;
    attribute = (target, attribute) => this.subCommand([targetParser(target), attribute], AttributeOperationCommand, false);
  };
AttributeOperationCommand = class AttributeOperationCommand extends CommandArguments {
    get = (scale) => this.finalCommand(["get", scale]);
    baseGet = (scale) => this.finalCommand(["base", "get", scale]);
    baseSet = (value) => this.finalCommand(["base", "set", value]);
    baseReset = (value) => this.finalCommand(["base", "reset", value]);
    add = (id2, value, modifier) => this.finalCommand(["modifier", "add", id2, value, modifier]);
    remove = (id2) => this.finalCommand(["modifier", "remove", id2]);
    getModifierValue = (id2, scale) => this.finalCommand(["modifier", "value", "get", id2, scale]);
  };
ClearCommandNode = class ClearCommandNode extends CommandNode {
    command = "clear";
  };
ClearCommand = class ClearCommand extends CommandArguments {
    NodeType = ClearCommandNode;
    clear(targets, itemOrPredicate, maxCount) {
      const itemArg = isMacroArgument(this.sandstoneCore, itemOrPredicate) ? itemOrPredicate : `${itemOrPredicate}`;
      return this.finalCommand([targets === undefined ? undefined : targetParser(targets), itemArg, maxCount]);
    }
  };
DamageCommandNode = class DamageCommandNode extends CommandNode {
    command = "damage";
  };
DamageCauseCommand = class DamageCauseCommand extends CommandArguments {
    from = (cause) => this.finalCommand(["from", targetParser(cause)]);
  };
DamageSourceCommand = class DamageSourceCommand extends CommandArguments {
    by = (entity) => this.subCommand(["by", targetParser(entity)], DamageCauseCommand, true);
    at = (position) => this.finalCommand(["at", coordinatesParser(position)]);
  };
DamageCommand = class DamageCommand extends CommandArguments {
    NodeType = DamageCommandNode;
    damage = (target, amount, damageType) => {
      validateIntegerRange(amount, "amount", 0, 1e6);
      return this.subCommand([targetParser(target), amount, damageType], DamageSourceCommand, true);
    };
  };
EffectCommandNode = class EffectCommandNode extends CommandNode {
    command = "effect";
  };
EffectCommand = class EffectCommand extends CommandArguments {
    NodeType = EffectCommandNode;
    give = (targets, effect, seconds, amplifier, hideParticles) => {
      if (seconds && seconds !== "infinite")
        validateIntegerRange(seconds, "seconds", 0, 1e6);
      if (amplifier)
        validateIntegerRange(amplifier, "amplifier", 0, 127);
      return this.finalCommand(["give", targetParser(targets), effect, seconds, amplifier, hideParticles]);
    };
    clear = (targets, effect) => this.finalCommand(["clear", targets === undefined ? undefined : targetParser(targets), effect]);
  };
EnchantCommandNode = class EnchantCommandNode extends CommandNode {
    command = "enchant";
  };
EnchantCommand = class EnchantCommand extends CommandArguments {
    NodeType = EnchantCommandNode;
    enchant = (targets, enchantment, level) => {
      if (level)
        validateIntegerRange(level, "level", 0, 2147483647);
      return this.finalCommand([targetParser(targets), enchantment, level]);
    };
  };
class ResourceClass {
  core;
  _resourceType;
  node;
  packType;
  fileExtension;
  fileEncoding;
  creator;
  commands;
  pack;
  path;
  addToSandstoneCore;
  onConflict;
  renameIndex = 2;
  constructor(core, file, NodeType, _resourceType, path, args) {
    this.core = core;
    this._resourceType = _resourceType;
    this.node = new NodeType(core, this);
    this.packType = args.packType || file.packType;
    this.fileExtension = file.extension || "json";
    this.fileEncoding = file.encoding ?? "utf8";
    this.pack = core.pack;
    this.commands = core.pack.commands;
    this.path = path;
    this.addToSandstoneCore = args.addToSandstoneCore;
    this.creator = args.creator ?? "sandstone";
    const conflictStrategies = hasContext() ? getSandstoneContext().conflictStrategies : undefined;
    const scopedStrategy = conflictStrategies?.[_resourceType];
    const defaultStrategy = conflictStrategies?.default;
    this.onConflict = args.onConflict ?? scopedStrategy ?? defaultStrategy ?? "throw";
  }
  handleConflicts() {
    const conflict = this.core.resourceNodes.get(this.node);
    let add2 = false;
    if (conflict) {
      const oldResource = conflict.resource;
      const newResource = this.node.resource;
      switch (this.onConflict) {
        case "throw": {
          throw new Error(`Created a ${this._resourceType} with the duplicate name ${newResource.name}, and onConflict was set to "throw".`);
        }
        case "replace":
          {
            this.core.resourceNodes.delete(conflict);
            add2 = true;
          }
          break;
        case "warn":
          {
            console.warn([
              "Warning:",
              `Tried to create a ${this._resourceType} named "${newResource.name}", but found an already existing one.`,
              "The new one has replaced the old one. To remove this warning, please change the options of the resource to { onConflict: '/* other option */' }."
            ].join(`
`));
            this.core.resourceNodes.delete(conflict);
            add2 = true;
          }
          break;
        case "rename":
          {
            this.path[this.path.length - 1] += oldResource.renameIndex.toString();
            oldResource.renameIndex += 1;
            add2 = true;
          }
          break;
        case "prepend":
          {
            oldResource.unshift(newResource);
          }
          break;
        case "append":
          {
            oldResource.push(newResource);
          }
          break;
        default:
          break;
      }
    } else {
      add2 = true;
    }
    if (this.addToSandstoneCore && add2) {
      this.core.resourceNodes.add(this.node);
    }
  }
  getNode = () => this.node;
  get name() {
    return `${this.path[0]}:${this.path.slice(this._resourceType in RESOURCE_PATHS ? RESOURCE_PATHS[this._resourceType].path.length + 1 : 2).join("/")}`;
  }
  get namespace() {
    return this.path[0];
  }
  generate = () => {};
  toString() {
    return this.name;
  }
  toNBT() {
    return `'${this.name}'`;
  }
  toJSON() {
    return this.name;
  }
}
CallableResourceClass = class CallableResourceClass extends ResourceClass {
    _that;
    get asCallable() {
      if (!this._that) {
        throw new Error("Class has not been made callable.");
      }
      return this._that;
    }
  };
ResourceNodesMap = class ResourceNodesMap {
    nodes = new Map;
    constructor(iterable = []) {
      for (const value of iterable) {
        this.add(value);
      }
    }
    forEach(callback) {
      this.nodes.forEach((value) => {
        callback(value);
      });
    }
    getKey(value) {
      return `${value.resource.packType.constructor.name}|${value.resource.path.join("/")}`;
    }
    add(value) {
      this.nodes.set(this.getKey(value), value);
      return this;
    }
    delete(value) {
      return this.nodes.delete(this.getKey(value));
    }
    clear() {
      this.nodes.clear();
    }
    [Symbol.iterator]() {
      return this.nodes.values()[Symbol.iterator]();
    }
    get size() {
      return this.nodes.size;
    }
    get(node) {
      return this.nodes.get(this.getKey(node));
    }
  };
CustomResourceNode = class CustomResourceNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => this.resource.getValue();
  };
CustomResourceClass = class CustomResourceClass extends ResourceClass {
    type;
    folder;
    constructor(sandstoneCore, name, args) {
      sandstoneCore.pack.registerCustomResource(args.type);
      super(sandstoneCore, {
        packType: args.packType || sandstoneCore.pack.dataPack(),
        extension: args.extension || "json",
        encoding: args.encoding
      }, CustomResourceNode, args.type, args.folder ? name.includes("/") ? name.split("/") : [name] : sandstoneCore.pack.resourceToPath(name, args.folder), args);
      this.type = args.type;
      this.folder = args.folder;
      this.handleConflicts();
    }
    get name() {
      return `${this.path[0]}:${this.path.slice(this.folder === undefined ? 2 : this.folder.length + 1).join("/")}`;
    }
    getValue() {
      throw new Error(`Custom Resource '${this.type}' getValue function is not defined!`);
    }
    toString = () => this.name;
  };
AdvancementNode = class AdvancementNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.advancementJSON, this.resource._resourceType);
  };
AdvancementClass = class AdvancementClass extends ResourceClass {
    static resourceType = "advancement";
    advancementJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, AdvancementNode, AdvancementClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[AdvancementClass.resourceType].path), args);
      this.advancementJSON = args.json;
      this.handleConflicts();
    }
    grant(players = "@s", criterion) {
      this.pack.commands.advancement.grant(players).only(this.name, criterion);
    }
    revoke(players = "@s", criterion) {
      this.pack.commands.advancement.revoke(players).only(this.name, criterion);
    }
    grantUntilThis(players = "@s") {
      this.pack.commands.advancement.grant(players).until(this.name);
    }
    revokeUntilThis(players = "@s") {
      this.pack.commands.advancement.revoke(players).until(this.name);
    }
    grantFromThis(players = "@s") {
      this.pack.commands.advancement.grant(players).from(this.name);
    }
    revokeFromThis(players = "@s") {
      this.pack.commands.advancement.revoke(players).from(this.name);
    }
    grantThroughThis(players = "@s") {
      this.pack.commands.advancement.grant(players).through(this.name);
    }
    revokeThroughThis(players = "@s") {
      this.pack.commands.advancement.revoke(players).through(this.name);
    }
    _toMinecraftCondition = () => new this.pack.conditions.Advancement(this.core, this.name);
    criterion(criterion) {
      return new this.pack.conditions.Advancement(this.core, this.name, criterion);
    }
  };
BannerPatternNode = class BannerPatternNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.bannerPatternJSON, this.resource._resourceType);
  };
BannerPatternClass = class BannerPatternClass extends ResourceClass {
    static resourceType = "banner_pattern";
    bannerPatternJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, BannerPatternNode, BannerPatternClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[BannerPatternClass.resourceType].path), args);
      this.bannerPatternJSON = args.json;
      this.handleConflicts();
    }
  };
ChatTypeNode = class ChatTypeNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.chatTypeJSON, this.resource._resourceType);
  };
ChatTypeClass = class ChatTypeClass extends ResourceClass {
    static resourceType = "chat_type";
    chatTypeJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, ChatTypeNode, ChatTypeClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[ChatTypeClass.resourceType].path), args);
      this.chatTypeJSON = args.json;
      this.handleConflicts();
    }
  };
DamageTypeNode = class DamageTypeNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.damageTypeJSON, this.resource._resourceType);
  };
DamageTypeClass = class DamageTypeClass extends ResourceClass {
    static resourceType = "damage_type";
    damageTypeJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, DamageTypeNode, DamageTypeClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[DamageTypeClass.resourceType].path), args);
      this.damageTypeJSON = args.json;
      if (args.flags) {
        for (const flag of args.flags) {
          let tag = damageTypes.get(flag);
          if (!tag) {
            damageTypes.set(flag, sandstoneCore.pack.Tag("damage_type", `minecraft:${flag}`, []));
            tag = damageTypes.get(flag);
          }
          tag.push(this);
        }
      }
      this.handleConflicts();
    }
    get translationKey() {
      return `death.attack.${this.damageTypeJSON.message_id}${this.damageTypeJSON.death_message_type === "intentional_game_design" ? ".link" : ""}`;
    }
    damage(...args) {
      const command = this.core.pack.commands.damage;
      if (typeof args[0] === "number") {
        if (args[1] === "entity") {
          if (args[3]) {
            return command("@s", args[0], this).by(args[2]).from(args[3]);
          }
          return command("@s", args[0], this).by(args[2]);
        }
        if (args[1] === "at") {
          return command("@s", args[0], this).at(args[1]);
        }
        return command("@s", args[0], this);
      }
      if (args[2] === "entity") {
        if (args[4]) {
          return command(args[0], args[1], this).by(args[2]).from(args[4]);
        }
        return command(args[0], args[1], this).by(args[2]);
      }
      return command(args[0], args[1], this);
    }
    _toChatComponent = () => ({ translate: this.translationKey });
    toString = () => this.name;
  };
DecoratedPotPatternNode = class DecoratedPotPatternNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.decoratedPotPatternJSON, this.resource._resourceType);
  };
DecoratedPotPatternClass = class DecoratedPotPatternClass extends ResourceClass {
    static resourceType = "decorated_pot_pattern";
    decoratedPotPatternJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, DecoratedPotPatternNode, DecoratedPotPatternClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[DecoratedPotPatternClass.resourceType].path), args);
      this.decoratedPotPatternJSON = args.json;
      this.handleConflicts();
    }
  };
DialogNode = class DialogNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.dialogJSON, this.resource._resourceType);
  };
DialogClass = class DialogClass extends ResourceClass {
    static resourceType = "dialog";
    dialogJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, DialogNode, DialogClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[DialogClass.resourceType].path), args);
      this.dialogJSON = args.json;
      this.handleConflicts();
    }
  };
EnchantmentNode = class EnchantmentNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.enchantmentJSON, this.resource._resourceType);
  };
EnchantmentClass = class EnchantmentClass extends ResourceClass {
    static resourceType = "enchantment";
    enchantmentJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, EnchantmentNode, EnchantmentClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[EnchantmentClass.resourceType].path), args);
      this.enchantmentJSON = args.json;
      this.handleConflicts();
    }
  };
EnchantmentProviderNode = class EnchantmentProviderNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.enchantmentProviderJSON, this.resource._resourceType);
  };
EnchantmentProviderClass = class EnchantmentProviderClass extends ResourceClass {
    static resourceType = "enchantment_provider";
    enchantmentProviderJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, EnchantmentProviderNode, EnchantmentProviderClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[EnchantmentProviderClass.resourceType].path), args);
      this.enchantmentProviderJSON = args.json;
      this.handleConflicts();
    }
  };
TestEnvironmentNode = class TestEnvironmentNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.testEnvironmentJSON, this.resource._resourceType);
  };
TestEnvironmentClass = class TestEnvironmentClass extends ResourceClass {
    static resourceType = "test_environment";
    testEnvironmentJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TestEnvironmentNode, TestEnvironmentClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[TestEnvironmentClass.resourceType].path), args);
      this.testEnvironmentJSON = args.json;
      this.handleConflicts();
    }
  };
TestInstanceNode = class TestInstanceNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.testInstanceJSON, this.resource._resourceType);
  };
TestInstanceClass = class TestInstanceClass extends ResourceClass {
    static resourceType = "test_instance";
    testInstanceJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TestInstanceNode, TestInstanceClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[TestInstanceClass.resourceType].path), args);
      this.testInstanceJSON = args.json;
      this.handleConflicts();
    }
  };
InstrumentNode = class InstrumentNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.instrumentJSON, this.resource._resourceType);
  };
InstrumentClass = class InstrumentClass extends ResourceClass {
    static resourceType = "instrument";
    instrumentJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, InstrumentNode, InstrumentClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[InstrumentClass.resourceType].path), args);
      this.instrumentJSON = args.json;
      this.handleConflicts();
    }
  };
ItemModifierNode = class ItemModifierNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.itemModifierJSON, this.resource._resourceType);
  };
ItemModifierClass = class ItemModifierClass extends ResourceClass {
    static resourceType = "item_modifier";
    itemModifierJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, ItemModifierNode, ItemModifierClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[ItemModifierClass.resourceType].path), args);
      this.itemModifierJSON = args.json;
      this.handleConflicts();
    }
    push(...modifiers) {
      if (!Array.isArray(this.itemModifierJSON)) {
        this.itemModifierJSON = [this.itemModifierJSON];
      }
      for (const modifier of modifiers) {
        let modifierJSON;
        if (modifier instanceof ItemModifierClass) {
          modifierJSON = modifier.itemModifierJSON;
        } else {
          modifierJSON = modifier;
        }
        if (Array.isArray(modifierJSON)) {
          this.itemModifierJSON.push(...modifierJSON);
        } else {
          this.itemModifierJSON.push(modifierJSON);
        }
      }
    }
    unshift(...modifiers) {
      if (!Array.isArray(this.itemModifierJSON)) {
        this.itemModifierJSON = [this.itemModifierJSON];
      }
      for (const modifier of modifiers) {
        let modifierJSON;
        if (modifier instanceof ItemModifierClass) {
          modifierJSON = modifier.itemModifierJSON;
        } else {
          modifierJSON = modifier;
        }
        if (Array.isArray(modifierJSON)) {
          this.itemModifierJSON.unshift(...modifierJSON);
        } else {
          this.itemModifierJSON.unshift(modifierJSON);
        }
      }
    }
    get modify() {
      return {
        block: (pos, slot) => {
          this.pack.commands.item.modify.block(pos, slot, this);
        },
        entity: (targets, slot) => {
          this.pack.commands.item.modify.entity(targetParser(targets), slot, this);
        }
      };
    }
  };
JukeboxSongNode = class JukeboxSongNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.jukeboxSongJSON, this.resource._resourceType);
  };
JukeboxSongClass = class JukeboxSongClass extends ResourceClass {
    static resourceType = "jukebox_song";
    jukeboxSongJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, JukeboxSongNode, JukeboxSongClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[JukeboxSongClass.resourceType].path), args);
      this.jukeboxSongJSON = args.json;
      this.handleConflicts();
    }
  };
LootTableNode = class LootTableNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.lootTableJSON, this.resource._resourceType);
  };
LootTableClass = class LootTableClass extends ResourceClass {
    static resourceType = "loot_table";
    lootTableJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, LootTableNode, LootTableClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[LootTableClass.resourceType].path), args);
      this.lootTableJSON = args.json;
      this.handleConflicts();
    }
    give(players = "@s") {
      return this.pack.commands.loot.give(players).loot(this.name);
    }
    insert = (targetPos = "~ ~ ~") => this.pack.commands.loot.insert(targetPos).loot(this.name);
    replaceBlock = (targetPos, slot, count) => this.pack.commands.loot.replace.block(targetPos, slot, count).loot(this.name);
    replaceEntity = (entities, slot, count) => this.pack.commands.loot.replace.entity(entities, slot, count).loot(this.name);
    toString = () => this.name;
    toJSON = this.toString;
  };
ResolveNBTNode = class ResolveNBTNode extends ContainerCommandNode {
    dataPoint;
    nbt;
    constructor(sandstonePack, dataPoint, nbt) {
      super(sandstonePack);
      this.dataPoint = dataPoint;
      this.nbt = nbt;
    }
    get command() {
      const first = this._body[0];
      if (!first)
        return "";
      const value = first.getValue();
      return typeof value === "string" ? value : "";
    }
    getValue = () => {
      this.sandstoneCore.currentNode = "ResolveNBTNode";
      const serialized = this._body.map((n) => n.getValue()).filter((v) => v !== null && v !== undefined && v !== "");
      return serialized.length === 0 ? "" : serialized.join(`
`);
    };
    [util5.inspect.custom](_depth, _options) {
      return `${this.constructor.name}(dataPoint=${this.dataPoint.currentTarget} ${this.dataPoint.path})`;
    }
  };
ResolveNBTClass = class ResolveNBTClass extends DataPointPickClass {
    pack;
    dataPoint;
    skipReset;
    constructor(pack, nbt, dataPoint, skipReset) {
      super(pack.core);
      this.pack = pack;
      if (dataPoint) {
        this.dataPoint = dataPoint;
        this.skipReset = skipReset ?? false;
      } else {
        this.dataPoint = this.pack.DataVariable();
        this.skipReset = skipReset ?? true;
      }
      const node = new ResolveNBTNode(pack, this.dataPoint, nbt);
      const realMCFunction = pack.core.getCurrentMCFunctionOrThrow();
      realMCFunction.enterContext(node, true);
      try {
        const out = this._resolveNBT(nbt);
        if (out !== undefined && Object.keys(out).length !== 0) {
          pack.commands.data.modify.storage(this.dataPoint.currentTarget, this.dataPoint.path).merge.value(this._resolveNBT(nbt));
        }
      } finally {
        realMCFunction.exitContext();
      }
    }
    _resolveNBT(nbt, path, index) {
      let resolvedNBT = {};
      if (typeof nbt !== "object") {
        throw new Error(`ResolveNBT expected an object or array, received ${typeof nbt}!`);
      }
      if (Array.isArray(nbt)) {
        resolvedNBT = [];
        if (!this.skipReset)
          this.dataPoint.set([]);
        if (resolvedNBT.length !== 0) {
          for (const [i, value] of nbt.entries()) {
            const resolved = this._resolveNBT(value, `${path === undefined ? "" : path}`, i);
            if (resolved !== undefined) {
              resolvedNBT.push(resolved);
            }
          }
        }
        return resolvedNBT;
      }
      if (nbt instanceof ResolveNBTPartClass) {
        return this[`_resolve${capitalize(nbt.type)}`](nbt, path, index);
      }
      if (nbt instanceof NBTPrimitive) {
        return resolvedNBT;
      }
      if (!this.skipReset)
        this.dataPoint.set({});
      for (const [key, value] of Object.entries(nbt)) {
        const resolved = this._resolveNBT(value, `${path === undefined ? "" : `${path}.`}${key}`);
        if (resolved !== undefined) {
          resolvedNBT[key] = resolved;
        }
      }
      return resolvedNBT;
    }
    _resolveData(part, path, index) {
      const { value } = part;
      const dataPoint = this.dataPoint.select(path);
      if (index) {
        let _value = value;
        if (value instanceof StringDataPointClass) {
          _value = this.pack.DataVariable(value);
        }
        dataPoint.insert(_value, index);
        return;
      }
      if (value instanceof StringDataPointClass) {
        dataPoint.set(value);
        return;
      }
      dataPoint.set(value);
      return;
    }
    _resolveScore(value, path, index) {
      const dataPoint = this.dataPoint.select(path);
      const args = [value.value, value.primitive.toString().split(" ")[1].slice(3).toLowerCase(), value.scale];
      if (index) {
        const temp = this.pack.getTempStorage("Score");
        temp.set(...args);
        dataPoint.insert(temp, index);
      }
      dataPoint.set(...args);
      return;
    }
    _resolveScores(value, path, index) {
      const temp = this.pack.getTempStorage("Score");
      const args = [value.primitive.constructor.name.slice(3).slice(0, -5).toLowerCase(), value.scale];
      const dataPoint = this.dataPoint.select(path);
      if (index) {
        dataPoint.insert(new value.primitive([]), index);
        const _dataPoint = dataPoint.select([index]);
        for (const score of value) {
          temp.set(score, ...args);
          _dataPoint.append(temp);
        }
      }
      dataPoint.set(new value.primitive([]));
      for (const score of value) {
        temp.set(score, ...args);
        dataPoint.append(temp);
      }
    }
    _toDataPoint() {
      return this.dataPoint;
    }
  };
ResolveNBTPartClass = class ResolveNBTPartClass extends NBTClass {
    value;
    type;
    primitive;
    scale;
    constructor(value, type, primitive, scale) {
      super();
      this.value = value;
      this.type = type;
      this.primitive = primitive;
      if (type.indexOf("score") !== -1) {
        this.scale = scale;
      }
    }
    [util5.inspect.custom] = () => "Unresolved NBT! Make sure to run ResolveNBT on the nbt before use.";
  };
TagNode = class TagNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.tagJSON, this.resource._resourceType);
  };
TagClass = class TagClass extends ResourceClass {
    static resourceType = "tag";
    type;
    tagJSON;
    constructor(sandstoneCore, type, name, args) {
      if (type === "entity") {
        console.warn(`[TagClass] Tag type 'entity' is not a valid Minecraft tag registry. Did you mean 'entity_type'?`);
      }
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TagNode, TagClass.resourceType, sandstoneCore.pack.resourceToPath(name, [RESOURCE_PATHS[TagClass.resourceType].path[0], type]), args);
      this.type = type;
      this.tagJSON = {
        replace: args.replace || false,
        values: []
      };
      this.tagJSON.values = Array.from(args.values, objectToString);
      this.handleConflicts();
    }
    get name() {
      return `#${super.name}`;
    }
    push(...resources) {
      for (const resource of resources) {
        const resourceName = objectToString(resource);
        if (resourceName === this.name) {
          if (resource instanceof TagClass) {
            this.tagJSON.values.push(...resource.tagJSON.values);
          } else {
            throw new Error("[TagClass#push] Tags cannot self-reference");
          }
        } else {
          this.tagJSON.values.push(resourceName);
        }
      }
    }
    unshift(...resources) {
      const _resources = [];
      for (const resource of resources) {
        const resourceName = objectToString(resource);
        if (resourceName === this.name) {
          if (resource instanceof TagClass) {
            _resources.push(...resource.tagJSON.values);
          } else {
            throw new Error("[TagClass#push] Tags cannot self-reference");
          }
        } else {
          _resources.push(resourceName);
        }
      }
      this.tagJSON.values.unshift(..._resources);
    }
    has(resource) {
      return this.tagJSON.values.some((tagValue) => (typeof tagValue !== "string" ? tagValue.id : tagValue) === objectToString(resource));
    }
    toString() {
      return this.name;
    }
    toJSON() {
      return this.name;
    }
    _toMinecraftCondition = () => {
      if (this.type === "block" || this.type === "entity_type") {
        return new this.pack.conditions.Tag(this.core, this.type, this.name);
      }
      throw new Error(`Cannot use a ${this.type} group tag as a condition. Only supports 'blocks' or 'entity_types'.`);
    };
  };
MCFunctionNode = class MCFunctionNode extends ContainerNode {
    resource;
    contextStack;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
      this.contextStack = [this];
    }
    get currentContext() {
      return this.contextStack[this.contextStack.length - 1];
    }
    appendNode = (node) => {
      if (Array.isArray(node)) {
        for (const _node of node) {
          this.currentContext.append(_node);
        }
      } else {
        this.currentContext.append(node);
      }
    };
    prependNode = (node) => {
      if (Array.isArray(node)) {
        for (const _node of node) {
          this.currentContext.prepend(_node);
        }
      } else {
        this.currentContext.prepend(node);
      }
    };
    enterContext = (node, addNode = true) => {
      if (addNode) {
        this.currentContext.append(node);
      }
      this.contextStack.push(node);
    };
    insideContext = (node, callback, addNode = true) => {
      this.enterContext(node, addNode);
      callback();
      return this.exitContext();
    };
    exitContext = () => {
      if (this.contextStack.length === 0) {
        throw new Error("No previous context to return to.");
      }
      if (this.contextStack.length === 1) {
        throw new Error("It is forbidden for a MCFunction to exit its latest context, since the MCFunction itself must be in the context stack.");
      }
      return this.contextStack.pop();
    };
    getValue = () => {
      this.sandstoneCore.currentNode = this.resource.name;
      return this.body.filter((node) => node.getValue() !== null).map((node) => node.getValue()).join(`
`);
    };
    [util6.inspect.custom](_depth, options) {
      return formatDebugString(this.constructor.name, {
        name: this.resource.name
      }, this.body, options.indent);
    }
  };
_RawMCFunctionClass = class _RawMCFunctionClass extends CallableResourceClass {
    static resourceType = "function";
    callback;
    nested = 0;
    asyncContext;
    tags;
    lazy;
    env;
    macroPoint;
    constructor(core, name, args, env) {
      if (name.startsWith("./")) {
        const currentMCFunctionName = core.currentMCFunction?.resource.name;
        if (!currentMCFunctionName) {
          throw new Error("Cannot use relative paths outside of an existing MCFunction.");
        }
        name = `${currentMCFunctionName}/${name.slice(2)}`;
      }
      super(core, { packType: core.pack.dataPack(), extension: "mcfunction" }, MCFunctionNode, _RawMCFunctionClass.resourceType, core.pack.resourceToPath(name, ["function"]), {
        ...args,
        addToSandstoneCore: args.lazy ? false : args.addToSandstoneCore
      });
      this.callback = args.callback ?? (() => {});
      if (this.nested !== 0) {
        for (let i = 0;i < this.nested; i++) {
          this.node.exitContext();
        }
      }
      this.asyncContext = args.asyncContext === undefined ? false : args.asyncContext;
      this.lazy = !!args.lazy;
      this.addToSandstoneCore = !!args.addToSandstoneCore;
      this.tags = args.tags;
      if (env && env.length !== 0) {
        this.env = env;
      }
      if (this.env || this.callback.length > 1) {
        this.macroPoint = core.pack.DataVariable();
      } else {
        this.macroPoint = undefined;
      }
      if (args.runOnLoad) {
        this.addToTag(core.pack.loadTags.load);
      } else if (args.runEveryTick || args.runEvery) {
        const runEvery = args.runEvery ?? 1;
        core.pack.registerTicked(runEvery, this);
      }
      if (args.tags) {
        for (const tag of args.tags) {
          this.addToTag(tag);
        }
      }
      this.handleConflicts();
    }
    generated = false;
    generate = () => {
      if (this.generated) {
        return;
      }
      this.generated = true;
      this.push(this.callback.bind(undefined, makeCallable(this, this.__call__)));
    };
    addToTag = (tag) => {
      let func;
      if (this.env !== undefined) {
        func = this.core.pack.MCFunction(`${this.name}/tag_call`, {
          addToSandstoneCore: true,
          creator: "sandstone",
          onConflict: "rename",
          callback: () => this.__call__()
        });
      } else {
        func = this;
      }
      if (typeof tag === "string") {
        const existing = this.core.functionTags.get(tag);
        if (existing) {
          existing.push(func);
        } else {
          const newTag = new TagClass(this.core, "function", tag, {
            values: [func],
            addToSandstoneCore: true,
            creator: "sandstone",
            onConflict: "append"
          });
          this.core.functionTags.set(tag, newTag);
        }
      } else {
        tag.push(func);
      }
    };
    __call__ = (..._params) => {
      if (this.env || _params.length !== 0) {
        const args = {};
        if (this.env) {
          for (const [i, env] of this.env.entries()) {
            args[`env_${i}`] = ResolveNBTPart(env);
            env.local.set(this.name, `env_${i}`);
          }
        }
        if (_params.length !== 0) {
          for (const [i, param] of _params.entries()) {
            args[`param_${i}`] = ResolveNBTPart(param);
            param.local.set(this.name, `param_${i}`);
          }
          this.node.body = [];
          this.core.enterMCFunction(this);
          this.core.insideContext(this.node, () => this.callback(makeCallable(this, this.__call__.bind(undefined, ..._params)), ..._params), false);
          this.core.exitMCFunction();
          this.generated = true;
        } else if (this.callback.length > 1) {
          throw new Error(`[MCFunctionClass] Function ${this.name} expects ${this.callback.length - 1} params at the call-site`);
        }
        return this.commands.functionCmd(this.name, "with", this.pack.ResolveNBT(args, this.macroPoint, true).dataPoint);
      }
      return this.commands.functionCmd(this.name);
    };
    schedule = {
      clear: () => this.commands.schedule.clear(this.name),
      function: (delay, type) => this.commands.schedule.function(this.name, delay, type)
    };
    push(...contents) {
      this.generate();
      if (contents[0] instanceof _RawMCFunctionClass) {
        for (const mcfunction of contents) {
          mcfunction.generate();
          this.node.body.push(...mcfunction.node.body);
        }
      } else {
        this.core.enterMCFunction(this);
        this.core.insideContext(this.node, contents[0], false);
        this.core.exitMCFunction();
      }
    }
    unshift(...contents) {
      this.generate();
      const fake = new MCFunctionClass(this.core, "fake", {
        addToSandstoneCore: false,
        creator: "sandstone",
        onConflict: "ignore"
      });
      if (contents[0] instanceof _RawMCFunctionClass) {
        for (const mcfunction of contents) {
          mcfunction.generate();
          this.node.body.unshift(...mcfunction.node.body);
        }
      } else {
        this.core.enterMCFunction(fake);
        this.core.insideContext(fake.node, contents[0], false);
        this.core.exitMCFunction();
        fake.generate();
        this.node.body.unshift(...fake.node.body);
      }
    }
    splice(start, removeItems, ...contents) {
      const fake = new MCFunctionClass(this.core, "fake", {
        addToSandstoneCore: false,
        creator: "sandstone",
        onConflict: "ignore"
      });
      const fullBody = [];
      if (contents[0] instanceof _RawMCFunctionClass) {
        for (const mcfunction of contents) {
          mcfunction.generate();
          fullBody.push(...mcfunction.node.body);
        }
      } else {
        this.core.enterMCFunction(fake);
        this.core.insideContext(fake.node, contents[0], false);
        this.core.exitMCFunction();
        fake.generate();
        fullBody.push(...fake.node.body);
      }
      this.node.body.splice(start, removeItems === "auto" ? fullBody.length : removeItems, ...fullBody);
    }
  };
MCFunctionClass = makeClassCallable(_RawMCFunctionClass);
PredicateNode = class PredicateNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.predicateJSON, this.resource._resourceType);
  };
PredicateClass = class PredicateClass extends ResourceClass {
    static resourceType = "predicate";
    predicateJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, PredicateNode, PredicateClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[PredicateClass.resourceType].path), args);
      this.predicateJSON = args.json;
      this.handleConflicts();
    }
    push(...predicates) {
      if (!Array.isArray(this.predicateJSON)) {
        this.predicateJSON = { type: "all_of", terms: [this.predicateJSON] };
      }
      for (const predicate of predicates) {
        let predicateJSON;
        if (predicate instanceof PredicateClass) {
          predicateJSON = predicate.predicateJSON;
        } else {
          predicateJSON = predicate;
        }
        if (Array.isArray(predicateJSON)) {
          this.predicateJSON.terms.push(...predicateJSON);
        } else {
          this.predicateJSON.terms.push(predicateJSON);
        }
      }
    }
    unshift(...predicates) {
      if (!Array.isArray(this.predicateJSON)) {
        this.predicateJSON = { type: "all_of", terms: [this.predicateJSON] };
      }
      for (const predicate of predicates) {
        let predicateJSON;
        if (predicate instanceof PredicateClass) {
          predicateJSON = predicate.predicateJSON;
        } else {
          predicateJSON = predicate;
        }
        if (Array.isArray(predicateJSON)) {
          this.predicateJSON.terms.unshift(...predicateJSON);
        } else {
          this.predicateJSON.terms.unshift(predicateJSON);
        }
      }
    }
    _toMinecraftCondition = () => new this.pack.conditions.Predicate(this.core, this.name);
    toJSON() {
      return this.predicateJSON;
    }
  };
RecipeNode = class RecipeNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.recipeJSON, this.resource._resourceType);
  };
RecipeClass = class RecipeClass extends ResourceClass {
    static resourceType = "recipe";
    recipeJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, RecipeNode, RecipeClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[RecipeClass.resourceType].path), args);
      this.recipeJSON = args.json;
      this.handleConflicts();
    }
    give(players = "@s") {
      return this.pack.commands.recipe.give(players, this);
    }
    take(players = "@s") {
      return this.pack.commands.recipe.take(players, this);
    }
  };
SlotSourceNode = class SlotSourceNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.slotSourceJSON, this.resource._resourceType);
  };
SlotSourceClass = class SlotSourceClass extends ResourceClass {
    static resourceType = "slot_source";
    slotSourceJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, SlotSourceNode, SlotSourceClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[SlotSourceClass.resourceType].path), args);
      this.slotSourceJSON = args.json;
      this.handleConflicts();
    }
    _toMinecraftCondition = () => new this.pack.conditions.SlotSource(this.core, this.name);
    toJSON() {
      return this.slotSourceJSON;
    }
  };
StructureNode = class StructureNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => this.resource.structureNBT ? encodeStructure(this.resource.structure()) : this.resource.structureBuffer;
  };
StructureClass = class StructureClass extends ResourceClass {
    static resourceType = "structure";
    structureBuffer;
    structureNBT;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "nbt", encoding: false }, StructureNode, StructureClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[StructureClass.resourceType].path), args);
      if (args.structure === undefined) {
        this.structureBuffer = sandstoneCore.getExistingResource(this, false);
      } else if (typeof args.structure === "string") {
        this.structureBuffer = sandstoneCore.getExistingResource(`${args.structure}${args.structure.endsWith(".nbt") ? "" : ".nbt"}`, false);
      } else if (args.structure instanceof StructureClass) {
        if (args.structure.structureNBT) {
          this.structureNBT = args.structure.structureNBT;
        } else if (args.structure.structureBuffer) {
          this.structureBuffer = args.structure.structureBuffer;
        } else {
          this.structureBuffer = args.structure.structure();
        }
      } else if (Array.isArray(args.structure)) {
        this.structureNBT = this.arrayToNBT(args.structure);
      } else {
        this.structureNBT = args.structure;
      }
      this.handleConflicts();
    }
    structure() {
      if (this.structureNBT) {
        return this.structureNBT;
      }
      if (this.structureBuffer) {
        return this.structureBuffer;
      }
      this.structureBuffer = this.node.sandstoneCore.getExistingResource(this, false);
      return this.structureBuffer;
    }
    async readBuffer() {
      this.structureNBT = await decodeStructure(await this.structureBuffer);
    }
    async array() {
      if (!this.structureNBT) {
        await this.readBuffer();
      }
      const _NBT = this.structureNBT;
      const array = [[[]]];
      const size = _NBT.size;
      for (let x = 0;x < size[0].value; x++) {
        array.push([]);
        for (let y = size[1].value;y--; y > 0) {
          array[x].push([]);
          for (let z = size[2].value;z--; z > 0) {
            array[x][y].push({});
          }
        }
      }
      for (const block of _NBT.blocks) {
        const convert = (_block) => ({
          id: typeof _block === "string" ? _block : _block.id,
          state: typeof _block === "string" ? {} : _block.properties,
          ...add({ nbt: block.nbt })
        });
        array[block.pos[0].value][block.pos[1].value][block.pos[2].value] = {
          block: "palettes" in _NBT ? _NBT.palettes.map((palette) => convert(palette[block.state.value])) : convert(_NBT.palette[block.state.value])
        };
      }
      for (const entity of _NBT.entities) {
        array[entity.blockPos[0].value][entity.blockPos[1].value][entity.blockPos[2].value] += {
          entity: [
            {
              id: entity.nbt.id,
              nbt: (() => {
                const nbt = { ...entity.nbt, id: undefined };
                delete nbt.id;
                return nbt;
              })(),
              offset: (() => [
                diff(extractNumber(entity.pos[0]), entity.blockPos[0].value),
                diff(extractNumber(entity.pos[1]), entity.blockPos[1].value),
                diff(extractNumber(entity.pos[2]), entity.blockPos[2].value)
              ])()
            }
          ]
        };
      }
      return array;
    }
    arrayToNBT(array) {
      const nbt = {
        DataVersion: 3329,
        size: [0, 0, 0],
        blocks: [],
        entities: []
      };
      nbt.size[0] = array.length;
      for (const layer of array.entries()) {
        if (layer.length > nbt.size[1]) {
          nbt.size[1] = layer.length;
        }
        for (const row of layer[1].entries()) {
          if (row.length > nbt.size[2]) {
            nbt.size[2] = row.length;
          }
          for (const entry of row[1].entries()) {
            if (entry[1].block) {
              if (Array.isArray(entry[1].block)) {
                let paletteIndex = -1;
                if (!nbt.palettes) {
                  nbt.palettes = [];
                  for (let i = 0;i < entry[1].block.length; i++) {
                    nbt.palettes.push([]);
                  }
                } else {
                  for (const block of nbt.palettes[0]) {
                    if (same(entry[1].block[0], block[1])) {
                      paletteIndex = block[0];
                    }
                  }
                  if (paletteIndex === -1) {
                    for (const palette of nbt.pallettes.entries()) {
                      palette[1].push({
                        Name: entry[1].block[palette[0]].id,
                        ...add({
                          Properties: entry[1].block[palette[0]].state
                        })
                      });
                    }
                  }
                }
                nbt.blocks.push({
                  state: paletteIndex === -1 ? nbt.palettes.length - 1 : paletteIndex,
                  pos: [layer[0], row[0], entry[0]],
                  ...add({
                    nbt: entry[1].block[0].nbt
                  })
                });
              } else {
                let paletteIndex = -1;
                if (!nbt.palette) {
                  nbt.palette = [];
                }
                for (const block of nbt.palette) {
                  if (same(entry[1].block, block[1])) {
                    paletteIndex = block[0];
                  }
                }
                if (paletteIndex === -1) {
                  nbt.palette.push({
                    Name: entry[1].block.id,
                    ...add({
                      Properties: entry[1].block.state
                    })
                  });
                }
                nbt.blocks.push({
                  state: paletteIndex === -1 ? nbt.palettes.length - 1 : paletteIndex,
                  pos: [layer[0], row[0], entry[0]],
                  ...add({
                    nbt: entry[1].block.nbt
                  })
                });
              }
            }
            if (entry[1].entities) {
              for (const entity of entry[1].entities) {
                nbt.push({
                  pos: entity.offset ? [layer[0] + entity.offset[0], row[0] + entity.offset[1], entry[0] + entity.offset[2]] : [layer[0], row[0], entry[0]],
                  blockPos: [layer[0], row[0], entry[0]],
                  nbt: {
                    id: entity.id,
                    ...add({ ...entity.nbt })
                  }
                });
              }
            }
          }
        }
      }
      return nbt;
    }
    async load(pos = [0, 0, 0], rotation, mirror, integrity, seed) {
      const { Variable, Data, ResolveNBT } = this.pack;
      const { place, fill, setblock, execute } = this.pack.commands;
      const structure = place.template;
      const rel = relative(...pos);
      if (rotation instanceof ConditionClass || mirror instanceof ConditionClass || integrity instanceof ConditionClass || seed instanceof ConditionClass) {
        const currentLevel = Variable();
        const bottomCoordinate = Variable();
        currentLevel.set(Data("entity", "@s", "Position[1]"));
        execute.summon("marker").run(() => {
          Data("entity", "@s", "Position[1]").set(bottomCoordinate, "double");
          const nbt = {
            mode: "LOAD",
            showboundingbox: false,
            powered: false,
            ignoreEntities: false,
            name: structure.name,
            posX: pos[0],
            posY: ResolveNBTPart(currentLevel["+"](pos[1])),
            posZ: pos[2]
          };
          setblock(`~${pos[0]} ~ ~${pos[2]}`, "structure_block");
          Data("block", `~${pos[0]} ~ ~${pos[2]}`, "{}").set(ResolveNBT(nbt));
          setblock(`~${pos[0]} ~ ~${pos[2] + 1}`, "redstone_block");
          setblock(`~${pos[0]} ~ ~${pos[2]}`, "bedrock");
          setblock(`~${pos[0]} ~ ~${pos[2] + 1}`, "bedrock");
        });
      } else if (mirror && (mirror === "^xz" || mirror === "xz")) {
        if (!this.structureNBT) {
          await this.readBuffer();
        }
        const temp = new StructureClass(this.core, "__sandstone:temp", {
          addToSandstoneCore: false,
          creator: "sandstone"
        });
        const coords = this.structureNBT.size;
        const outerCorner = relative(...coords);
        fill(rel, outerCorner, "air");
        structure(this, rel, rotation, "^x");
        temp.save(rel, coords);
        fill(rel, outerCorner, "air");
        structure(temp, rel, "none", "^z", integrity, seed);
      } else {
        structure(this, rel, rotation, mirror, integrity, seed);
      }
    }
    save(_pos = "~ ~ ~", _size) {
      throw new Error("[StructureClass#save] Unimplemented");
    }
    toString() {
      return this.name;
    }
  };
SulfurCubeArchetypeNode = class SulfurCubeArchetypeNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.sulfurCubeArchetypeJSON, this.resource._resourceType);
  };
SulfurCubeArchetypeClass = class SulfurCubeArchetypeClass extends ResourceClass {
    static resourceType = "sulfur_cube_archetype";
    sulfurCubeArchetypeJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, SulfurCubeArchetypeNode, SulfurCubeArchetypeClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[SulfurCubeArchetypeClass.resourceType].path), args);
      this.sulfurCubeArchetypeJSON = args.json;
      this.handleConflicts();
    }
  };
TimelineNode = class TimelineNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.timelineJSON, this.resource._resourceType);
  };
TimelineClass = class TimelineClass extends ResourceClass {
    static resourceType = "timeline";
    timelineJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TimelineNode, TimelineClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[TimelineClass.resourceType].path), args);
      this.timelineJSON = args.json;
      this.handleConflicts();
    }
  };
WorldClockNode = class WorldClockNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.worldClockJSON, this.resource._resourceType);
  };
WorldClockClass = class WorldClockClass extends ResourceClass {
    static resourceType = "world_clock";
    worldClockJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, WorldClockNode, WorldClockClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[WorldClockClass.resourceType].path), args);
      this.worldClockJSON = args.json;
      this.handleConflicts();
    }
    toString() {
      return this.name;
    }
  };
TrialSpawnerNode = class TrialSpawnerNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.trialSpawnerJSON, this.resource._resourceType);
  };
TrialSpawnerClass = class TrialSpawnerClass extends ResourceClass {
    static resourceType = "trial_spawner";
    trialSpawnerJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TrialSpawnerNode, TrialSpawnerClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[TrialSpawnerClass.resourceType].path), args);
      this.trialSpawnerJSON = args.json;
      this.handleConflicts();
    }
  };
TrimMaterialNode = class TrimMaterialNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.trimMaterialJSON, this.resource._resourceType);
  };
TrimMaterialClass = class TrimMaterialClass extends ResourceClass {
    static resourceType = "trim_material";
    trimMaterialJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TrimMaterialNode, TrimMaterialClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[TrimMaterialClass.resourceType].path), args);
      this.trimMaterialJSON = args.json;
      this.handleConflicts();
    }
    get palette() {
      return this.trimMaterialJSON.palette;
    }
  };
TrimPatternNode = class TrimPatternNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.trimPatternJSON, this.resource._resourceType);
  };
TrimPatternClass = class TrimPatternClass extends ResourceClass {
    static resourceType = "trim_pattern";
    trimPatternJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TrimPatternNode, TrimPatternClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[TrimPatternClass.resourceType].path), args);
      this.trimPatternJSON = args.json;
      this.handleConflicts();
    }
  };
VariantNode = class VariantNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.variantJSON, this.resource._resourceType);
  };
VariantClass = class VariantClass extends ResourceClass {
    variantType;
    static resourceType = "variant";
    variantJSON;
    constructor(sandstoneCore, variantType, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, VariantNode, `${variantType}_${VariantClass.resourceType}`, sandstoneCore.pack.resourceToPath(name, [`${variantType}_${VariantClass.resourceType}`]), args);
      this.variantType = variantType;
      this.variantJSON = args.variant;
      this.handleConflicts();
    }
  };
VillagerTradeNode = class VillagerTradeNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.villagerTradeJSON, this.resource._resourceType);
  };
VillagerTradeClass = class VillagerTradeClass extends ResourceClass {
    static resourceType = "villager_trade";
    villagerTradeJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, VillagerTradeNode, VillagerTradeClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[VillagerTradeClass.resourceType].path), args);
      this.villagerTradeJSON = args.json;
      this.handleConflicts();
    }
  };
TradeSetNode = class TradeSetNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.tradeSetJSON, this.resource._resourceType);
  };
TradeSetClass = class TradeSetClass extends ResourceClass {
    static resourceType = "trade_set";
    tradeSetJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.dataPack(), extension: "json" }, TradeSetNode, TradeSetClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[TradeSetClass.resourceType].path), args);
      this.tradeSetJSON = args.json;
      this.handleConflicts();
    }
  };
AtlasNode = class AtlasNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.atlasJSON, this.resource._resourceType);
  };
AtlasClass = class AtlasClass extends ResourceClass {
    static resourceType = "atlas";
    atlasJSON;
    constructor(core, name, args) {
      super(core, { packType: core.pack.resourcePack() }, AtlasNode, AtlasClass.resourceType, core.pack.resourceToPath(name, RESOURCE_PATHS[AtlasClass.resourceType].path), args);
      this.atlasJSON = args.json || { sources: [] };
      this.handleConflicts();
    }
    push(...sources) {
      if (sources[0] instanceof AtlasClass) {
        for (const provider of sources) {
          this.atlasJSON.sources.push(...provider.atlasJSON.sources);
        }
      } else {
        this.atlasJSON.sources.push(...sources);
      }
    }
    unshift(...sources) {
      if (sources[0] instanceof AtlasClass) {
        for (const provider of sources) {
          this.atlasJSON.sources.unshift(...provider.atlasJSON.sources);
        }
      } else {
        this.atlasJSON.sources.unshift(...sources);
      }
    }
  };
BlockStateDefinitionNode = class BlockStateDefinitionNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.blockStateDefinitionJSON, this.resource._resourceType);
  };
BlockStateDefinitionClass = class BlockStateDefinitionClass extends ResourceClass {
    static resourceType = "block_definition";
    blockStateDefinitionJSON;
    type;
    constructor(core, name, args) {
      super(core, { packType: core.pack.resourcePack() }, BlockStateDefinitionNode, BlockStateDefinitionClass.resourceType, core.pack.resourceToPath(name, RESOURCE_PATHS[BlockStateDefinitionClass.resourceType].path), args);
      this.blockStateDefinitionJSON = args.json;
      this.type = Object.keys(this.blockStateDefinitionJSON)[0];
      this.handleConflicts();
    }
    push(...states) {
      if (this.type === "variants") {
        if (states[0] instanceof BlockStateDefinitionClass) {
          for (const state of states) {
            this.blockStateDefinitionJSON.variants = { ...this.blockStateDefinitionJSON.variants, ...state.blockStateDefinitionJSON.variants };
          }
        } else {
          for (const state of states) {
            this.blockStateDefinitionJSON.variants = { ...this.blockStateDefinitionJSON.variants, ...state.variants };
          }
        }
      }
      if (this.type === "multipart") {
        if (states[0] instanceof BlockStateDefinitionClass) {
          for (const state of states) {
            this.blockStateDefinitionJSON.multipart.push(...state.blockStateDefinitionJSON.multipart);
          }
        } else {
          for (const state of states) {
            this.blockStateDefinitionJSON.multipart.push(...state.multipart);
          }
        }
      }
    }
    unshift(...states) {
      if (this.type === "variants") {
        if (states[0] instanceof BlockStateDefinitionClass) {
          for (const state of states) {
            this.blockStateDefinitionJSON.variants = { ...state.blockStateDefinitionJSON.variants, ...this.blockStateDefinitionJSON.variants };
          }
        } else {
          for (const state of states) {
            this.blockStateDefinitionJSON.variants = { ...state.variants, ...this.blockStateDefinitionJSON.variants };
          }
        }
      }
      if (this.type === "multipart") {
        if (states[0] instanceof BlockStateDefinitionClass) {
          for (const state of states) {
            this.blockStateDefinitionJSON.multipart.unshift(...state.blockStateDefinitionJSON.multipart);
          }
        } else {
          for (const state of states) {
            this.blockStateDefinitionJSON.multipart.unshift(...state.multipart);
          }
        }
      }
    }
    async load() {}
  };
EquipmentNode = class EquipmentNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.equipmentJSON, this.resource._resourceType);
  };
EquipmentClass = class EquipmentClass extends ResourceClass {
    static resourceType = "equipment";
    equipmentJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.resourcePack(), extension: "json" }, EquipmentNode, EquipmentClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[EquipmentClass.resourceType].path), args);
      this.equipmentJSON = args.json;
      this.handleConflicts();
    }
  };
FontNode = class FontNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.fontJSON, this.resource._resourceType);
  };
FontClass = class FontClass extends ResourceClass {
    static resourceType = "font";
    fontJSON;
    constructor(core, name, args) {
      super(core, { packType: core.pack.resourcePack() }, FontNode, FontClass.resourceType, core.pack.resourceToPath(name, RESOURCE_PATHS[FontClass.resourceType].path), args);
      this.fontJSON = { providers: args.providers };
      this.handleConflicts();
    }
    push(...providers) {
      if (providers[0] instanceof FontClass) {
        for (const provider of providers) {
          this.fontJSON.providers.push(...provider.fontJSON.providers);
        }
      } else {
        this.fontJSON.providers.push(...providers);
      }
    }
    unshift(...providers) {
      if (providers[0] instanceof FontClass) {
        for (const provider of providers) {
          this.fontJSON.providers.unshift(...provider.fontJSON.providers);
        }
      } else {
        this.fontJSON.providers.unshift(...providers);
      }
    }
  };
LanguageNode = class LanguageNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.languageJSON, this.resource._resourceType);
  };
LanguageClass = class LanguageClass extends ResourceClass {
    static resourceType = "lang";
    languageJSON;
    constructor(core, name, args) {
      super(core, { packType: core.pack.resourcePack() }, LanguageNode, LanguageClass.resourceType, core.pack.resourceToPath(name, RESOURCE_PATHS[LanguageClass.resourceType].path), args);
      this.languageJSON = args.language ?? {};
      this.handleConflicts();
    }
    push(...translations) {
      if (translations[0] instanceof LanguageClass) {
        for (const translation of translations) {
          this.languageJSON = { ...this.languageJSON, ...translation.languageJSON };
        }
      } else {
        for (const translation of translations) {
          this.languageJSON = { ...this.languageJSON, ...translation };
        }
      }
    }
    unshift(...translations) {
      if (translations[0] instanceof LanguageClass) {
        for (const translation of translations) {
          this.languageJSON = { ...translation.languageJSON, ...this.languageJSON };
        }
      } else {
        for (const translation of translations) {
          this.languageJSON = { ...translation, ...this.languageJSON };
        }
      }
    }
  };
ModelNode = class ModelNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.modelJSON, this.resource._resourceType);
  };
ModelClass = class ModelClass extends ResourceClass {
    type;
    static resourceType = "model";
    modelJSON;
    constructor(core, type, name, args) {
      super(core, { packType: core.pack.resourcePack() }, ModelNode, ModelClass.resourceType, core.pack.resourceToPath(name, [...RESOURCE_PATHS[ModelClass.resourceType].path, type]), args);
      this.type = type;
      this.modelJSON = args.json;
      this.handleConflicts();
    }
    toString = () => `${this.path[0]}:${this.path.slice(2).join("/")}`;
  };
ParticleNode = class ParticleNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.particleJSON, this.resource._resourceType);
  };
ParticleClass = class ParticleClass extends ResourceClass {
    static resourceType = "particle";
    particleJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.resourcePack(), extension: "json" }, ParticleNode, ParticleClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[ParticleClass.resourceType].path), args);
      this.particleJSON = args.json;
      this.handleConflicts();
    }
  };
PostEffectNode = class PostEffectNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.postEffectJSON, this.resource._resourceType);
  };
PostEffectClass = class PostEffectClass extends ResourceClass {
    static resourceType = "post_effect";
    postEffectJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.resourcePack(), extension: "json" }, PostEffectNode, PostEffectClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[PostEffectClass.resourceType].path), args);
      this.postEffectJSON = args.json;
      this.handleConflicts();
    }
  };
ShaderNode = class ShaderNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.shaderJSON, this.resource._resourceType);
  };
ShaderClass = class ShaderClass extends ResourceClass {
    static resourceType = "shader";
    shaderJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.resourcePack(), extension: "json" }, ShaderNode, ShaderClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[ShaderClass.resourceType].path), args);
      this.shaderJSON = args.json;
      this.handleConflicts();
    }
  };
SoundEventNode = class SoundEventNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => this.resource.buffer;
  };
SoundEventClass = class SoundEventClass extends ResourceClass {
    type;
    static resourceType = "sound";
    buffer;
    constructor(core, type, name, args) {
      super(core, { packType: core.pack.resourcePack(), extension: "ogg", encoding: false }, SoundEventNode, SoundEventClass.resourceType, core.pack.resourceToPath(name, [...RESOURCE_PATHS[SoundEventClass.resourceType].path, type]), args);
      this.type = type;
      if (args.addToSandstoneCore) {
        if (args.sound === undefined) {
          this.buffer = core.getExistingResource(this, false);
        } else {
          if (typeof args.sound === "string") {
            this.buffer = core.getExistingResource(`${args.sound}${args.sound.endsWith(".ogg") ? "" : ".ogg"}`, false);
          } else {
            this.buffer = args.sound;
          }
        }
        if (args.addToSounds) {
          let def = this.core.sounds.get(this.path[0]);
          if (!def) {
            def = this.core.sounds.set(this.path[0], new SoundsIndexClass(this.core, this.path[0], {
              addToSandstoneCore: true,
              creator: "sandstone",
              definitions: {
                [`${this.type}.${name}`]: {
                  sounds: [`${this.type}.${name}`]
                }
              }
            })).get(this.path[0]);
          } else {
            def.push(this);
          }
        }
      }
      this.handleConflicts();
    }
  };
SoundsIndexNode = class SoundsIndexNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.soundsJSON, this.resource._resourceType);
  };
SoundsIndexClass = class SoundsIndexClass extends ResourceClass {
    static resourceType = "sounds";
    soundsJSON;
    constructor(core, namespace, args) {
      super(core, { packType: core.pack.resourcePack() }, SoundsIndexNode, SoundsIndexClass.resourceType, core.pack.resourceToPath(`${namespace}:sounds`, RESOURCE_PATHS[SoundsIndexClass.resourceType].path), args);
      if (args.definitions !== undefined) {
        this.soundsJSON = args.definitions;
      } else {
        this.soundsJSON = (async () => JSON.parse(await core.getExistingResource(this)))();
      }
      this.handleConflicts();
    }
    async push(...soundEvents) {
      if (soundEvents[0] instanceof SoundsIndexClass) {
        for await (const _sounds of soundEvents) {
          const def = await _sounds.soundsJSON;
          const s = await this.soundsJSON;
          this.soundsJSON = { ...s, ...def };
        }
      } else {
        for await (const _sound of soundEvents) {
          const sound = _sound;
          const s = await this.soundsJSON;
          s[`${sound.type}.${sound.name}`] = {
            sounds: [`${sound.type}.${sound.name}`]
          };
        }
      }
    }
    async unshift(...soundEvents) {
      if (soundEvents[0] instanceof SoundsIndexClass) {
        for await (const _sounds of soundEvents) {
          const def = await _sounds.soundsJSON;
          const s = await this.soundsJSON;
          this.soundsJSON = { ...def, ...s };
        }
      } else {
        for await (const _sound of soundEvents) {
          const sound = _sound;
          const s = await this.soundsJSON;
          s[`${sound.type}.${sound.name}`] = {
            sounds: [`${sound.type}.${sound.name}`]
          };
        }
      }
    }
  };
PlainTextNode = class PlainTextNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => this.resource.texts;
  };
PlainTextClass = class PlainTextClass extends ResourceClass {
    static resourceType = "text";
    texts = "";
    constructor(core, name, args) {
      super(core, { packType: core.pack.resourcePack(), extension: "txt" }, PlainTextNode, PlainTextClass.resourceType, core.pack.resourceToPath(name, ["texts"]), args);
      this.texts = "";
      if (args.text) {
        if (Array.isArray(args.text)) {
          this.push(...args.text);
        } else {
          this.push(args.text);
        }
      }
      this.handleConflicts();
    }
    componentToPlainText(__text) {
      const text = new JSONTextComponentClass(__text).toJSON();
      let converted = "";
      const type = typeof text;
      if (type === "string") {
        converted += text;
      } else if (type === "boolean" || type === "number") {
        converted += `${text}`;
      } else if (Array.isArray(text)) {
        for (const _text of text) {
          converted += this.componentToPlainText(_text);
        }
      } else {
        const currentText = text;
        if (typeof currentText !== "string") {
          if (!("text" in currentText)) {
            throw new Error("Dynamic JSON content is not supported in plaintext");
          }
          if (currentText.color) {
            const { color } = currentText;
            if (color.startsWith("#")) {
              throw new Error("Hex codes are not supported in plaintext");
            }
            const colors = [
              "black",
              "dark_blue",
              "dark_green",
              "dark_aqua",
              "dark_red",
              "dark_purple",
              "gold",
              "gray",
              "dark_gray",
              "blue",
              "green",
              "aqua",
              "red",
              "light_purple",
              "yellow",
              "white"
            ];
            converted = `§${colors.indexOf(color).toString(16)}`;
          }
          if (currentText.obfuscated) {
            converted += "§k";
          }
          if (currentText.bold) {
            converted += "§l";
          }
          if (currentText.strikethrough) {
            converted += "§m";
          }
          if (currentText.underlined) {
            converted += "§n";
          }
          if (currentText.italic) {
            converted += "§o";
          }
          converted += `${currentText.text}`;
          if (currentText.extra) {
            converted += this.componentToPlainText(currentText.extra);
          }
        }
      }
      return converted;
    }
    push(...texts) {
      if (typeof texts[0] === "string") {
        for (const text of texts) {
          this.texts += `${text}
`;
        }
      } else {
        for (const text of texts) {
          this.texts += `${this.componentToPlainText(text)}
`;
        }
      }
    }
    unshift(...texts) {
      if (typeof texts[0] === "string") {
        for (const text of texts) {
          this.texts = `${text}
${this.texts}`;
        }
      } else {
        for (const text of texts) {
          this.texts = `${this.componentToPlainText(text)}
${this.texts}`;
        }
      }
    }
  };
TextureNode = class TextureNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => this.resource.buffer;
  };
TextureClass = class TextureClass extends ResourceClass {
    static resourceType = "texture";
    type;
    isSprite;
    spriteTarget;
    meta;
    buffer;
    constructor(core, type, name, args) {
      super(core, { packType: core.pack.resourcePack(), extension: "png", encoding: false }, TextureNode, TextureClass.resourceType, core.pack.resourceToPath(name, [...RESOURCE_PATHS[TextureClass.resourceType].path, type]), args);
      this.type = type;
      this.buffer = args.texture;
      this.isSprite = args.sprite === undefined ? false : args.sprite !== false;
      this.meta = args.meta;
      if (typeof args.sprite === "string") {
        this.spriteTarget = args.sprite;
      }
      this.handleConflicts();
    }
    toString() {
      return `${this.path[0]}:${this.path.slice(2).join("/")}`;
    }
    videoToAnimation(_path) {
      console.log("[TextureClass#videoToAnimation] Unimplemented");
    }
  };
WaypointStyleNode = class WaypointStyleNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource) {
      super(sandstoneCore);
      this.resource = resource;
    }
    getValue = () => jsonStringify(this.resource.waypointStyleJSON, this.resource._resourceType);
  };
WaypointStyleClass = class WaypointStyleClass extends ResourceClass {
    static resourceType = "waypoint_style";
    waypointStyleJSON;
    constructor(sandstoneCore, name, args) {
      super(sandstoneCore, { packType: sandstoneCore.pack.resourcePack(), extension: "json" }, WaypointStyleNode, WaypointStyleClass.resourceType, sandstoneCore.pack.resourceToPath(name, RESOURCE_PATHS[WaypointStyleClass.resourceType].path), args);
      this.waypointStyleJSON = args.json;
      this.handleConflicts();
    }
  };
DependencyNode = class DependencyNode extends ContainerNode {
    resource;
    constructor(sandstoneCore, resource2) {
      super(sandstoneCore);
      this.resource = resource2;
    }
    getValue = () => this.resource.getValue();
  };
SmithedDependencyClass = class SmithedDependencyClass extends ResourceClass {
    dependency;
    side;
    constructor(sandstoneCore, name, dependency, side) {
      super(sandstoneCore, {
        packType: side === "client" ? sandstoneCore.pack.packTypes.get("resourcepack-dependencies") : sandstoneCore.pack.packTypes.get("datapack-dependencies"),
        extension: "zip",
        encoding: false
      }, DependencyNode, "dependency", [name], {
        addToSandstoneCore: true,
        creator: "sandstone"
      });
      this.dependency = dependency;
      this.side = side;
      this.handleConflicts();
    }
    async getValue() {
      if (this.side === "client" && this.dependency.resourcepack) {
        return await this.dependency.resourcepack();
      }
      return await this.dependency.datapack();
    }
  };
FunctionCommandNode = class FunctionCommandNode extends CommandNode {
    command = "function";
  };
FunctionCommand = class FunctionCommand extends CommandArguments {
    NodeType = FunctionCommandNode;
    function(mcFunction, params, pointOrType, target, path4) {
      const args = [];
      if (params) {
        if (params === "with" && pointOrType) {
          args.push("with");
          if (typeof pointOrType === "string") {
            args.push(pointOrType, target, path4 ?? "{}");
          } else {
            const point = Object.hasOwn(pointOrType, "_toDataPoint") ? pointOrType._toDataPoint : pointOrType;
            args.push(point.type, point.currentTarget, point.path);
          }
        } else {
          args.push(typeof params === "object" && params.toMacro ? params : nbtResolver(params));
        }
      }
      const mcFunctionArg = isMacroArgument(this.sandstoneCore, mcFunction) ? mcFunction : `${mcFunction}`;
      return this.finalCommand([mcFunctionArg, ...args]);
    }
  };
ExecuteCommandPart = class ExecuteCommandPart extends CommandArguments {
    NodeType = ExecuteCommandNode;
    nestedExecute = (args, executable = true) => this.subCommand([args], ExecuteCommand, executable);
  };
ExecuteCommandNode = class ExecuteCommandNode extends ContainerCommandNode {
    command = "execute";
    isFake;
    isSingleExecute;
    givenCallbackName;
    macroStorage;
    pendingCommit;
    createdMCFunction = null;
    constructor(sandstonePack, isMacro = false, args = [], {
      isFake = false,
      isSingleExecute = true,
      givenCallbackName = undefined,
      body = [],
      macroStorage = undefined,
      pendingCommit = false
    } = {}) {
      super(sandstonePack, ...args);
      this.givenCallbackName = givenCallbackName;
      this.isSingleExecute = isSingleExecute;
      this.isFake = isFake;
      this.macroStorage = macroStorage;
      this.pendingCommit = pendingCommit;
      this.isMacro = isMacro;
      this.append(...body);
    }
    get callbackName() {
      return this.givenCallbackName ?? `execute_${this.args[0][0].split(" ")[0]}`;
    }
    append = (...nodes2) => {
      for (const node of nodes2) {
        this.body.push(node);
        if (this.isSingleExecute) {
          this.sandstoneCore.getCurrentMCFunctionOrThrow().exitContext();
          if (this.pendingCommit && !this.commited) {
            this.commit();
          }
        }
      }
      return nodes2.length === 1 ? nodes2[0] : nodes2;
    };
    getValue = () => {
      if (this.body.length > 1) {
        throw new Error("Execute nodes can only have one child node when toString is called.");
      }
      const flattenedArgs = this.args.flat(1);
      const args = [];
      for (const arg of flattenedArgs) {
        if (arg !== undefined && arg !== null) {
          if (typeof arg === "object") {
            if (isMacroArgument(this.sandstoneCore, arg)) {
              this.isMacro = true;
              args.push(arg.toMacro());
            } else {
              args.push(arg);
            }
          } else {
            args.push(arg);
          }
        }
      }
      const executeString = `${this.command} ${args.join(" ")}`;
      if (this.body.length === 0) {
        return executeString;
      }
      let command = this.body[0].getValue();
      if (this.isFake) {
        return command;
      }
      if (command.startsWith("$")) {
        this.isMacro = true;
        command = command.slice(1);
      }
      return `${this.isMacro ? "$" : ""}${executeString} run ${command}`;
    };
    createMCFunction = (currentMCFunction) => {
      if (this.createdMCFunction) {
        return { node: this, mcFunction: this.createdMCFunction.node };
      }
      if (this.isSingleExecute || !currentMCFunction) {
        return { node: this };
      }
      const mcFunction = this.sandstonePack.MCFunction(`${currentMCFunction.resource.name}/${this.callbackName}`, {
        creator: "sandstone",
        onConflict: "rename"
      });
      const mcFunctionNode = mcFunction.node;
      mcFunctionNode.body = this.body;
      for (const node of this.body) {
        if (node && typeof node === "object" && "containingMCFunction" in node) {
          node.containingMCFunction = mcFunctionNode;
        }
      }
      this.createdMCFunction = mcFunction;
      const mcFunctionCall = new FunctionCommandNode(this.sandstonePack, mcFunction);
      if (this.macroStorage) {
        mcFunctionCall.args.push("with", "storage", this.macroStorage.currentTarget, this.macroStorage.path);
      }
      this.body = [mcFunctionCall];
      return { node: this, mcFunction: mcFunctionNode };
    };
  };
ExecuteStoreArgsCommand = class ExecuteStoreArgsCommand extends ExecuteCommandPart {
    block = (targetPos, path4, type, scale) => this.nestedExecute(["block", coordinatesParser(targetPos), path4, type, scale]);
    bossbar = (id2, type) => this.nestedExecute(["bossbar", id2, type]);
    entity = (target, path4, type, scale) => this.nestedExecute(["entity", targetParser(target), path4, type, scale]);
    score(...args) {
      const finalArgs = ["score"];
      if (isScore(args[0])) {
        finalArgs.push(args[0].target, args[0].objective.name);
      } else {
        finalArgs.push(targetParser(args[0]), args[1]);
      }
      return this.nestedExecute(finalArgs);
    }
    storage = (target, path4, type, scale = 1) => this.nestedExecute(["storage", target, path4, type, scale]);
  };
ExecuteStoreCommand = class ExecuteStoreCommand extends ExecuteCommandPart {
    _storeCallable(cmd, target, type, scale) {
      if (isScore(target)) {
        return cmd.score(target.target, target.objective);
      }
      const resolvedType = type ?? "int";
      if (target.type === "block") {
        return cmd.block(coordinatesParser(target.currentTarget), target.path, resolvedType, scale);
      }
      if (target.type === "entity") {
        return cmd.entity(target.currentTarget, target.path, resolvedType, scale);
      }
      return cmd.storage(target.currentTarget, target.path, resolvedType, scale);
    }
    get result() {
      const cmd = this.subCommand([["result"]], ExecuteStoreArgsCommand, false);
      return makeCallable(cmd, (target, type, scale) => this._storeCallable(cmd, target, type, scale), true);
    }
    get success() {
      const cmd = this.subCommand([["success"]], ExecuteStoreArgsCommand, false);
      return makeCallable(cmd, (target, type, scale) => this._storeCallable(cmd, target, type, scale), true);
    }
  };
ExecuteDataArgsCommand = class ExecuteDataArgsCommand extends ExecuteCommandPart {
    block = (pos, path4) => this.nestedExecute(["data", "block", coordinatesParser(pos), path4], true);
    entity = (target, path4) => this.nestedExecute(["data", "entity", targetParser(target), path4], true);
    storage = (source, path4) => this.nestedExecute(["data", "storage", source, path4], true);
  };
ExecuteItemsCommand = class ExecuteItemsCommand extends ExecuteCommandPart {
    block = (sourcePos, slotSource2, itemPredicate) => this.nestedExecute(["items", "block", coordinatesParser(sourcePos), slotSource2, `${itemPredicate}`], true);
    entity = (source, slotSource2, itemPredicate) => this.nestedExecute(["items", "entity", targetParser(source), slotSource2, `${itemPredicate}`], true);
  };
ExecuteSlotsCommand = class ExecuteSlotsCommand extends ExecuteCommandPart {
    block = (sourcePos, slotSource2) => this.nestedExecute(["slots", "block", coordinatesParser(sourcePos), slotSource2], true);
    entity = (source, slotSource2) => this.nestedExecute(["slots", "entity", targetParser(source), slotSource2], true);
  };
ExecuteIfUnlessCommand = class ExecuteIfUnlessCommand extends ExecuteCommandPart {
    block(pos, block, state, nbt) {
      const stateStr = state && typeof state === "object" && Object.keys(state).length > 0 ? blockStateStringifier(state) : "";
      const nbtStr = nbt ? nbtResolver(nbt).toString() : "";
      return this.nestedExecute(["block", coordinatesParser(pos), `${block}${stateStr}${nbtStr}`], true);
    }
    blocks = (start, end, destination, scan_mode) => this.nestedExecute(["blocks", coordinatesParser(start), coordinatesParser(end), coordinatesParser(destination), scan_mode], true);
    entity = (targets) => this.nestedExecute(["entity", targetParser(targets)], true);
    predicate(predicate2) {
      if (typeof predicate2 === "string") {
        return this.nestedExecute(["predicate", predicate2], true);
      }
      if (Object.hasOwn(predicate2, "toMacro")) {
        return this.nestedExecute(["predicate", predicate2], true);
      }
      return this.nestedExecute(["predicate", predicate2.name], true);
    }
    score(...args) {
      const finalArgs = [];
      if (isScore(args[0])) {
        finalArgs.push(args[0].target.toString(), args[0].objective.name, args[1]);
        if (isScore(args[2])) {
          finalArgs.push(args[2].target.toString(), args[2].objective.name);
        } else {
          finalArgs.push(rangeParser(this.sandstoneCore, args[2]));
        }
      } else {
        finalArgs.push(targetParser(args[0]), isObjective(args[1]) ? args[1].name : args[1], args[2]);
        if (args[4]) {
          finalArgs.push(targetParser(args[3]), isObjective(args[4]) ? args[4].name : args[4]);
        } else {
          finalArgs.push(rangeParser(this.sandstoneCore, args[3]));
        }
      }
      return this.nestedExecute(["score", ...finalArgs], true);
    }
    dimension = (dimension) => this.nestedExecute(["dimension", dimension]);
    loaded = (pos) => this.nestedExecute(["loaded", coordinatesParser(pos)]);
    get data() {
      return makeCallable(new ExecuteDataArgsCommand(this.sandstonePack, this.isMacro, this.previousNode), (dataPoint) => this.nestedExecute(dataPoint._toMinecraftCondition().getCondition()));
    }
    get items() {
      return new ExecuteItemsCommand(this.sandstonePack, this.isMacro, this.previousNode);
    }
    get slots() {
      return new ExecuteSlotsCommand(this.sandstonePack, this.isMacro, this.previousNode);
    }
    function(func) {
      if (typeof func === "object" && Object.hasOwn(func, "addToTag")) {
        return this.nestedExecute(["function", func.name]);
      }
      if (typeof func === "string" || Object.hasOwn(func, "toMacro")) {
        return this.nestedExecute(["function", func]);
      }
      const name = `${this.sandstoneCore.getCurrentMCFunctionOrThrow().resource.path.slice(2).join("/")}/execute_if_function`;
      const _func = this.sandstonePack.MCFunction(name, {
        addToSandstoneCore: false,
        creator: "sandstone",
        onConflict: "rename",
        callback: func
      });
      return this.nestedExecute(["function", name]);
    }
  };
ExecuteFacingEntityCommand = class ExecuteFacingEntityCommand extends ExecuteCommandPart {
    entity = (targets, anchor = "feet") => this.nestedExecute(["facing", "entity", targetParser(targets), anchor]);
  };
ExecutePositionedCommand = class ExecutePositionedCommand extends ExecuteCommandPart {
    as = (targets) => this.nestedExecute(["positioned", "as", targetParser(targets)]);
    over = (heightMap) => this.nestedExecute(["positioned", "over", heightMap]);
  };
ExecuteRotatedAsCommand = class ExecuteRotatedAsCommand extends ExecuteCommandPart {
    as = (targets) => this.nestedExecute(["rotated", "as", targetParser(targets)]);
  };
ExecuteCommand = class ExecuteCommand extends ExecuteCommandPart {
    NodeType = ExecuteCommandNode;
    align = (axes) => this.nestedExecute(["align", axes]);
    anchored = (anchor) => this.nestedExecute(["anchored", anchor]);
    as = (targets) => this.nestedExecute(["as", targetParser(targets)]);
    at = (targets) => this.nestedExecute(["at", targetParser(targets)]);
    get facing() {
      return makeCallable(new ExecuteFacingEntityCommand(this.sandstonePack, this.isMacro, this.previousNode), (pos) => this.nestedExecute(["facing", coordinatesParser(pos)]));
    }
    in = (dimension) => this.nestedExecute(["in", dimension]);
    on = (relation) => this.nestedExecute(["on", relation]);
    get positioned() {
      return makeCallable(new ExecutePositionedCommand(this.sandstonePack, this.isMacro, this.previousNode), (pos) => this.nestedExecute(["positioned", coordinatesParser(pos)]));
    }
    get rotated() {
      return makeCallable(new ExecuteRotatedAsCommand(this.sandstonePack, this.isMacro, this.previousNode), (rotation) => this.nestedExecute(["rotated", rotationParser(rotation)]));
    }
    summon(entityType) {
      return this.nestedExecute(["summon", entityType]);
    }
    get if() {
      return this.subCommand([["if"]], ExecuteIfUnlessCommand, false);
    }
    get unless() {
      return this.subCommand([["unless"]], ExecuteIfUnlessCommand, false);
    }
    get store() {
      return this.subCommand([["store"]], ExecuteStoreCommand, false);
    }
    get run() {
      const node = this.getNode();
      const commandsSource = this.sandstonePack[this.isMacro ? "macroCommands" : "commands"];
      const commands = new Proxy(commandsSource, {
        get: (_t, p, _r) => {
          if (!node.commited) {
            node.pendingCommit = true;
          }
          this.sandstoneCore.getCurrentMCFunctionOrThrow().enterContext(node, false);
          return commandsSource[p];
        }
      });
      return makeCallable(commands, (...args) => {
        const callback = args.length === 1 ? args[0] : args[1];
        if (args.length === 2) {
          node.givenCallbackName = args[0];
        }
        node.isSingleExecute = false;
        this.sandstoneCore.insideContext(node, callback, !node.commited);
        return new FinalCommandOutput(node);
      }, true);
    }
  };
KillCommandNode = class KillCommandNode extends CommandNode {
    command = "kill";
  };
KillCommand = class KillCommand extends CommandArguments {
    NodeType = KillCommandNode;
    kill = (targets) => this.finalCommand([targets === undefined ? undefined : targetParser(targets)]);
  };
RideCommandNode = class RideCommandNode extends CommandNode {
    command = "ride";
  };
RideArgumentsCommand = class RideArgumentsCommand extends CommandArguments {
    mount = (target) => this.finalCommand(["mount", targetParser(target)]);
    dismount = () => this.finalCommand(["dismount"]);
  };
RideCommand = class RideCommand extends CommandArguments {
    NodeType = RideCommandNode;
    ride = (target) => this.subCommand([targetParser(target)], RideArgumentsCommand, false);
  };
RotateCommandNode = class RotateCommandNode extends CommandNode {
    command = "rotate";
  };
RotateCommand = class RotateCommand extends CommandArguments {
    NodeType = RotateCommandNode;
    rotate(target, rotation) {
      if (rotation !== undefined) {
        return this.finalCommand([targetParser(target), coordinatesParser(rotation)]);
      }
      return this.subCommand([targetParser(target)], RotateFacingArguments, false);
    }
  };
RotateFacingArguments = class RotateFacingArguments extends CommandArguments {
    facing = (location) => this.finalCommand(["facing", coordinatesParser(location)]);
    facingEntity = (entity, anchor) => this.finalCommand(["facing", "entity", targetParser(entity), anchor]);
  };
JSONTextComponentClass = class JSONTextComponentClass {
    jsonTextComponent;
    constructor(jsonTextComponent) {
      this.jsonTextComponent = jsonTextComponent;
    }
    toString() {
      const component = toComponent(this.jsonTextComponent);
      if (typeof component === "string") {
        return `"${component}"`;
      }
      return JSON.stringify(component, function(key, value) {
        if (Array.isArray(this)) {
          const realValue = this[Number.parseInt(key, 10)];
          return toComponent(realValue);
        }
        return toComponent(value);
      }, 0);
    }
    toJSON() {
      return JSON.parse(this.toString());
    }
    [util7.inspect.custom](depth, options) {
      return formatDebugString(this.constructor.name, this.toString(), undefined, options.indent);
    }
  };
ScoreboardCommandNode = class ScoreboardCommandNode extends CommandNode {
    command = "scoreboard";
  };
ScoreboardObjectivesModifyCommand = class ScoreboardObjectivesModifyCommand extends CommandArguments {
    displayautoupdate = (value) => this.finalCommand(["displayautoupdate", value]);
    displayname = (displayName) => this.finalCommand(["displayname", parseJSONText(this.sandstoneCore, displayName)]);
    numberformat(format, component) {
      if (format === "styled" || format === "fixed") {
        component = parseJSONText(this.sandstoneCore, component);
      }
      return this.finalCommand(["numberformat", format, component]);
    }
    rendertype = (display) => this.finalCommand(["rendertype", display]);
  };
ScoreboardPlayersDisplayCommand = class ScoreboardPlayersDisplayCommand extends CommandArguments {
    NodeType = ScoreboardCommandNode;
    name(...args) {
      const nameIndex = isScore2(args[0]) ? 1 : 2;
      if (args[nameIndex] !== undefined) {
        args[nameIndex] = parseJSONText(this.sandstoneCore, args[nameIndex]);
      }
      return this.finalCommand(["players", "display", "name", ...scoresParser(args)]);
    }
    numberformat(...args) {
      const formatIndex = isScore2(args[0]) ? 1 : 2;
      if (args[formatIndex] === "styled" || args[formatIndex] === "fixed") {
        args[formatIndex + 1] = parseJSONText(this.sandstoneCore, args[formatIndex + 1]);
      }
      return this.finalCommand(["players", "display", "numberformat", ...scoresParser(args)]);
    }
  };
ScoreboardCommand = class ScoreboardCommand extends CommandArguments {
    NodeType = ScoreboardCommandNode;
    objectives = {
      list: () => this.finalCommand(["objectives", "list"]),
      add: (objective, criteria, displayName) => this.finalCommand(["objectives", "add", objective, criteria, parseJSONText(this.sandstoneCore, displayName)]),
      remove: (objective) => this.finalCommand(["objectives", "remove", objective]),
      setdisplay: (slot, objective) => this.finalCommand(["objectives", "setdisplay", slot, objective]),
      modify: (objective) => this.subCommand(["objectives", "modify", objective], ScoreboardObjectivesModifyCommand, false)
    };
    players = {
      list: (target) => this.finalCommand(["players", "list", target === undefined ? undefined : targetParser(target)]),
      get: (...args) => this.finalCommand(["players", "get", ...scoresParser(...args)]),
      set: (...args) => this.finalCommand(["players", "set", ...scoresParser(args)]),
      add: (...args) => this.finalCommand(["players", "add", ...scoresParser(args)]),
      remove: (...args) => this.finalCommand(["players", "remove", ...scoresParser(args)]),
      reset: (...args) => this.finalCommand(["players", "reset", ...scoresParser(...args)]),
      enable: (...args) => this.finalCommand(["players", "enable", ...scoresParser(...args)]),
      operation: (...args) => this.finalCommand(["players", "operation", ...scoresParser(...args)]),
      display: new ScoreboardPlayersDisplayCommand(this.sandstonePack)
    };
  };
SpreadPlayersNode = class SpreadPlayersNode extends CommandNode {
    command = "spreadplayers";
  };
SpreadPlayersCommand = class SpreadPlayersCommand extends CommandArguments {
    NodeType = SpreadPlayersNode;
    spreadplayers(...args) {
      return this.finalCommand([coordinatesParser(args[0]), ...args.slice(1, -1), targetParser(args.at(-1))]);
    }
  };
SummonCommandNode = class SummonCommandNode extends CommandNode {
    command = "summon";
  };
SummonCommand = class SummonCommand extends CommandArguments {
    NodeType = SummonCommandNode;
    summon(entity, pos, nbt) {
      const args = [entity];
      if (pos !== undefined) {
        args.push(coordinatesParser(pos));
      }
      if (nbt !== undefined) {
        args.push(nbtResolver(nbt));
      }
      return this.finalCommand(args);
    }
  };
SwingCommandNode = class SwingCommandNode extends CommandNode {
    command = "swing";
  };
SwingCommand = class SwingCommand extends CommandArguments {
    NodeType = SwingCommandNode;
    swing = (targets = "@s", hand = "mainhand") => this.finalCommand([targetParser(targets), hand]);
  };
TagCommandNode = class TagCommandNode extends CommandNode {
    command = "tag";
  };
TagArgumentsCommand = class TagArgumentsCommand extends CommandArguments {
    add = (name) => this.finalCommand(["add", checkTagName(name)]);
    list = () => this.finalCommand(["list"]);
    remove = (name) => this.finalCommand(["remove", checkTagName(name)]);
  };
TagCommand = class TagCommand extends CommandArguments {
    NodeType = TagCommandNode;
    tag = (targets) => this.subCommand([targetParser(targets)], TagArgumentsCommand, false);
  };
TeamCommandNode = class TeamCommandNode extends CommandNode {
    command = "team";
  };
TeamCommand = class TeamCommand extends CommandArguments {
    NodeType = TeamCommandNode;
    add = (team, displayName) => this.finalCommand(["add", team, parseJSONText(this.sandstoneCore, displayName)]);
    empty = (team) => this.finalCommand(["empty", team]);
    join = (team, members) => this.finalCommand(["join", team, members === undefined ? undefined : targetParser(members)]);
    leave = (members) => this.finalCommand(["leave", targetParser(members)]);
    list = (team) => this.finalCommand(["list", team ? targetParser(team) : undefined]);
    modify(team, option, value) {
      if (["displayName", "prefix", "suffix"].includes(option)) {
        value = parseJSONText(this.sandstoneCore, value);
      }
      this.finalCommand(["modify", team, option, value]);
    }
    remove = (team) => this.finalCommand(["remove", team]);
  };
TeleportCommandNode = class TeleportCommandNode extends CommandNode {
    command = "tp";
  };
TeleportFacingCommand = class TeleportFacingCommand extends CommandArguments {
    facing = (location) => this.finalCommand(["facing", coordinatesParser(location)]);
    facingEntity = (entity, anchor) => this.finalCommand(["facing", targetParser(entity), anchor]);
  };
TeleportCommand = class TeleportCommand extends CommandArguments {
    NodeType = TeleportCommandNode;
    tp(...args) {
      const parsedArgs = [...args.slice(0, 3).map(coordinatesParser), ...args.slice(3).map(targetParser)];
      if (parsedArgs.length === 2 && (parsedArgs[1] instanceof VectorClass || typeof parsedArgs[1] === "string")) {
        return this.subCommand(parsedArgs, TeleportFacingCommand, true);
      }
      return this.finalCommand(parsedArgs);
    }
  };
AdvancementCommandNode = class AdvancementCommandNode extends CommandNode {
    command = "advancement";
  };
AdvancementArgumentsCommand = class AdvancementArgumentsCommand extends CommandArguments {
    everything = () => this.finalCommand(["everything"]);
    only = (advancement2, criterion) => this.finalCommand(["only", advancement2, criterion]);
    from = (advancement2) => this.finalCommand(["from", advancement2]);
    through = (advancement2) => this.finalCommand(["through", advancement2]);
    until = (advancement2) => this.finalCommand(["until", advancement2]);
  };
AdvancementCommand = class AdvancementCommand extends CommandArguments {
    NodeType = AdvancementCommandNode;
    grant = (targets) => this.subCommand(["grant", targetParser(targets)], AdvancementArgumentsCommand, false);
    revoke = (targets) => this.subCommand(["revoke", targetParser(targets)], AdvancementArgumentsCommand, false);
  };
BossBarCommandNode = class BossBarCommandNode extends CommandNode {
    command = "bossbar";
  };
BossBarCommand = class BossBarCommand extends CommandArguments {
    NodeType = BossBarCommandNode;
    add = (id2, name) => this.finalCommand(["add", id2, parseJSONText(this.sandstoneCore, name)]);
    get = (id2, setting) => this.finalCommand(["get", id2, setting]);
    list = () => this.finalCommand(["list"]);
    remove = (id2) => this.finalCommand(["remove", id2]);
    set = (id2) => this.subCommand(["set", id2], BossBarSetCommand, false);
  };
BossBarSetCommand = class BossBarSetCommand extends CommandArguments {
    color = (color) => this.finalCommand(["color", color]);
    max = (max) => this.finalCommand(["max", max]);
    name = (name) => this.finalCommand(["name", parseJSONText(this.sandstoneCore, name)]);
    players = (players) => this.finalCommand(["players", players === undefined ? undefined : targetParser(players)]);
    style = (style) => this.finalCommand(["style", style]);
    value = (value) => this.finalCommand(["value", value]);
    visible = (visible) => this.finalCommand(["visible", visible]);
  };
DialogCommandNode = class DialogCommandNode extends CommandNode {
    command = "dialog";
  };
DialogCommand = class DialogCommand extends CommandArguments {
    NodeType = DialogCommandNode;
    show(targets, dialog2) {
      const dialogArg = typeof dialog2 === "string" || dialog2 instanceof ResourceClass ? dialog2 : nbtResolver(dialog2);
      return this.finalCommand(["show", targetParser(targets), dialogArg]);
    }
    clear = (targets) => this.finalCommand(["clear", targetParser(targets)]);
  };
ExperienceCommandNode = class ExperienceCommandNode extends CommandNode {
    command = "xp";
  };
ExperienceCommand = class ExperienceCommand extends CommandArguments {
    NodeType = ExperienceCommandNode;
    add = (targets, amount, type) => {
      validateIntegerRange(amount, "amount", -2147483648, 2147483647);
      return this.finalCommand(["add", targetParser(targets), amount, type]);
    };
    set = (targets, amount, type) => {
      validateIntegerRange(amount, "amount", 0, 2147483647);
      return this.finalCommand(["set", targets, amount, type]);
    };
    query = (target, type) => this.finalCommand(["query", target, type]);
  };
GameModeCommandNode = class GameModeCommandNode extends CommandNode {
    command = "gamemode";
  };
GameModeCommand = class GameModeCommand extends CommandArguments {
    NodeType = GameModeCommandNode;
    gamemode = (gamemode, targets) => this.finalCommand([targetParser(gamemode), targets]);
  };
GiveCommandNode = class GiveCommandNode extends CommandNode {
    command = "give";
  };
GiveCommand = class GiveCommand extends CommandArguments {
    NodeType = GiveCommandNode;
    give(targets, item, countOrComponents, count) {
      const select = isMacroArgument(this.sandstoneCore, targets) ? targets : targetParser(targets);
      if (typeof countOrComponents === "object" || typeof countOrComponents === "function") {
        const components = countOrComponents;
        const componentsIsMacro = isMacroArgument(this.sandstoneCore, components);
        if (isMacroArgument(this.sandstoneCore, item) || componentsIsMacro) {
          return this.finalCommand([
            select,
            this.sandstonePack.Macro`${item}${componentsIsMacro ? components : componentPatchStringifier(components)}`,
            count
          ]);
        }
        if (components.constructor.name === "Object" && Object.keys(components).length === 0) {
          return this.finalCommand([select, item, count]);
        }
        return this.finalCommand([select, `${item}${componentPatchStringifier(components)}`, count]);
      }
      return this.finalCommand([select, item, countOrComponents]);
    }
  };
ParticleCommandNode = class ParticleCommandNode extends CommandNode {
    command = "particle";
  };
ParticleCommand = class ParticleCommand extends CommandArguments {
    NodeType = ParticleCommandNode;
    particle(name, arg2, arg3, arg4, arg5, arg6, arg7, arg8) {
      const hasOptions = arg2 !== undefined && typeof arg2 === "object" && !isCoordinates(arg2);
      const [particleName, pos, delta, speed, count, mode, viewers] = hasOptions ? [`${name}${nbtResolver(arg2)}`, arg3, arg4, arg5, arg6, arg7, arg8] : [name, arg2, arg3, arg4, arg5, arg6, arg7];
      return this.finalCommand([
        particleName,
        pos === undefined ? "~ ~ ~" : coordinatesParser(pos),
        delta === undefined ? "0 0 0" : coordinatesParser(delta),
        speed ?? "0",
        count ?? "1",
        mode ?? "normal",
        ...viewers === undefined ? [] : [viewers]
      ]);
    }
  };
PlaySoundCommandNode = class PlaySoundCommandNode extends CommandNode {
    command = "playsound";
  };
PlaySoundCommand = class PlaySoundCommand extends CommandArguments {
    NodeType = PlaySoundCommandNode;
    playsound = (sound2, source, targets, sourcePosition, volume, pitch, minVolume) => this.finalCommand([
      sound2,
      source ?? "master",
      targetParser(targets ?? "@s"),
      coordinatesParser(sourcePosition ?? "~ ~ ~"),
      volume ?? 1,
      pitch ?? 1,
      minVolume
    ]);
  };
PostEffectCommandNode = class PostEffectCommandNode extends CommandNode {
    command = "posteffect";
  };
PostEffectCommand = class PostEffectCommand extends CommandArguments {
    NodeType = PostEffectCommandNode;
    add = (player, postEffect2) => this.finalCommand(["add", targetParser(player), postEffect2]);
    clear = (player) => this.finalCommand(["clear", targetParser(player)]);
    list = (target) => this.finalCommand(["list", targetParser(target)]);
    remove = (player, postEffect2) => this.finalCommand(["remove", targetParser(player), postEffect2]);
  };
RecipeCommandNode = class RecipeCommandNode extends CommandNode {
    command = "recipe";
  };
RecipeCommand = class RecipeCommand extends CommandArguments {
    NodeType = RecipeCommandNode;
    give = (targets, recipe2) => this.finalCommand(["give", targetParser(targets), recipe2]);
    take = (targets, recipe2) => this.finalCommand(["take", targetParser(targets), recipe2]);
  };
SpawnPointCommandNode = class SpawnPointCommandNode extends CommandNode {
    command = "spawnpoint";
  };
SpawnPointCommand = class SpawnPointCommand extends CommandArguments {
    NodeType = SpawnPointCommandNode;
    spawnpoint = (targets, pos, angle) => this.finalCommand([
      targets === undefined ? undefined : targetParser(targets),
      coordinatesParser(pos),
      coordinatesParser(angle)
    ]);
  };
SpectateCommandNode = class SpectateCommandNode extends CommandNode {
    command = "spectate";
  };
SpectateCommand = class SpectateCommand extends CommandArguments {
    NodeType = SpectateCommandNode;
    spectate = (target, player) => this.finalCommand([targetParser(target), player]);
  };
StopSoundCommandNode = class StopSoundCommandNode extends CommandNode {
    command = "stopsound";
  };
StopSoundCommand = class StopSoundCommand extends CommandArguments {
    NodeType = StopSoundCommandNode;
    stopsound = (targets, source, sound2) => this.finalCommand([targetParser(targets), source, sound2]);
  };
TitleCommandNode = class TitleCommandNode extends CommandNode {
    command = "title";
  };
TitleArgumentsCommand = class TitleArgumentsCommand extends CommandArguments {
    clear = () => this.finalCommand(["clear"]);
    reset = () => this.finalCommand(["reset"]);
    title = (title) => this.finalCommand(["title", parseJSONText(this.sandstoneCore, title)]);
    subtitle = (subtitle) => this.finalCommand(["subtitle", parseJSONText(this.sandstoneCore, subtitle)]);
    actionbar = (actionbarText) => this.finalCommand(["actionbar", parseJSONText(this.sandstoneCore, actionbarText)]);
    times = (fadeIn, stay, fadeOut) => this.finalCommand(["times", fadeIn, stay, fadeOut]);
  };
TitleCommand = class TitleCommand extends CommandArguments {
    NodeType = TitleCommandNode;
    title = (targets) => this.subCommand([targetParser(targets)], TitleArgumentsCommand, false);
  };
TransferCommandNode = class TransferCommandNode extends CommandNode {
    command = "transfer";
  };
TransferCommand = class TransferCommand extends CommandArguments {
    NodeType = TransferCommandNode;
    transfer(hostname, port, targets) {
      const args = [hostname];
      if (port) {
        args.push(port);
        if (targets !== undefined) {
          args.push(targetParser(targets));
        }
      } else {
        args.push(25565, targets === undefined ? undefined : targetParser(targets));
      }
      return this.finalCommand(args);
    }
  };
WaypointCommandNode = class WaypointCommandNode extends CommandNode {
    command = "waypoint";
  };
WaypointCommand = class WaypointCommand extends CommandArguments {
    NodeType = WaypointCommandNode;
    list = () => this.finalCommand(["list"]);
    modify = (target) => this.subCommand(["modify", targetParser(target)], WaypointModifyArguments, false);
  };
WaypointModifyArguments = class WaypointModifyArguments extends CommandArguments {
    color(type, color) {
      if (type === "hex") {
        if (typeof color !== "number") {
          return this.finalCommand(["color", "hex", color]);
        }
        return this.finalCommand(["color", "hex", color.toString(16).toUpperCase().padStart(6, "0")]);
      }
      if (type === "rgb") {
        if (Array.isArray(color)) {
          const [red, green, blue] = color;
          const hex = (red << 16) + (green << 8) + blue;
          return this.finalCommand(["color", "hex", hex.toString(16).toUpperCase().padStart(6, "0")]);
        }
        throw new Error(`[WaypointModifyArguments#color] Invalid color argument: ${color}`);
      }
      if (type === "rgb%") {
        if (Array.isArray(color)) {
          const [red, green, blue] = color.map((c) => c * 255);
          const hex = (red << 16) + (green << 8) + blue;
          return this.finalCommand(["color", "hex", hex.toString(16).toUpperCase().padStart(6, "0")]);
        }
        throw new Error(`[WaypointModifyArguments#color] Invalid color argument: ${color}`);
      }
      return this.finalCommand(["color", type]);
    }
    style(operation, waypointStyle2) {
      if (operation === "reset") {
        return this.finalCommand(["style", "reset"]);
      }
      return this.finalCommand(["color", "set", waypointStyle2]);
    }
  };
DataPackCommandNode = class DataPackCommandNode extends CommandNode {
    command = "datapack";
  };
DataPackEnableCommand = class DataPackEnableCommand extends CommandArguments {
    first = () => this.finalCommand(["first"]);
    last = () => this.finalCommand(["last"]);
    before = (name) => this.finalCommand(["before", name]);
    after = (name) => this.finalCommand(["after", name]);
  };
DataPackCommand = class DataPackCommand extends CommandArguments {
    NodeType = DataPackCommandNode;
    disable = (name) => this.finalCommand([name]);
    enable = (name) => this.subCommand(["enable", name], DataPackEnableCommand, false);
    list = (type) => this.finalCommand(["list", type]);
  };
DebugCommandNode = class DebugCommandNode extends ContainerCommandNode {
    command = "debug";
    createMCFunction = (currentMCFunction) => {
      if (this.body.length === 0 || this.args[0] === "start" || this.args[0] === "stop" || !currentMCFunction) {
        return { node: this };
      }
      const [_, func] = this.args;
      if (typeof func !== "string" && func !== undefined) {
        throw new Error("Cannot have something else than a string as the argument for a debug function with callback");
      }
      const mcFunction = this.sandstonePack.MCFunction(`${currentMCFunction.resource.name}/${func ?? "debug"}`, {
        addToSandstoneCore: false,
        creator: "sandstone",
        onConflict: "rename"
      });
      const mcFunctionNode = mcFunction.node;
      mcFunctionNode.body = this.body;
      this.body = [];
      this.args = ["function", mcFunction.name];
      return { node: this, mcFunction: mcFunctionNode };
    };
  };
DebugCommand = class DebugCommand extends CommandArguments {
    NodeType = DebugCommandNode;
    start = () => this.finalCommand(["start"]);
    stop = () => this.finalCommand(["stop"]);
    function(func) {
      const node = this.getNode();
      if (typeof func === "function" && Object.hasOwn(func, "addToTag")) {
        return this.finalCommand(["function", func.name], node);
      }
      if (typeof func === "function") {
        this.sandstoneCore.insideContext(node, func, false);
        return this.finalCommand(["function", undefined], node);
      }
      const funcArg = isMacroArgument(this.sandstoneCore, func) ? func : `${func}`;
      return this.finalCommand(["function", funcArg], node);
    }
  };
DefaultGameModeCommandNode = class DefaultGameModeCommandNode extends CommandNode {
    command = "defaultgamemode";
  };
DefaultGameModeCommand = class DefaultGameModeCommand extends CommandArguments {
    NodeType = DefaultGameModeCommandNode;
    defaultgamemode = (mode) => this.finalCommand([mode]);
  };
DifficultyCommandNode = class DifficultyCommandNode extends CommandNode {
    command = "difficulty";
  };
DifficultyCommand = class DifficultyCommand extends CommandArguments {
    NodeType = DifficultyCommandNode;
    difficulty = (difficulty) => this.finalCommand([difficulty]);
  };
GameRuleCommandNode = class GameRuleCommandNode extends CommandNode {
    command = "gamerule";
  };
GameRuleCommand = class GameRuleCommand extends CommandArguments {
    NodeType = GameRuleCommandNode;
    gamerule(gamerule, value) {
      return this.finalCommand([gamerule, value]);
    }
  };
HelpCommandNode = class HelpCommandNode extends CommandNode {
    command = "help";
  };
HelpCommand = class HelpCommand extends CommandArguments {
    NodeType = HelpCommandNode;
    help = (command, ...parameters) => this.finalCommand([command, ...parameters]);
  };
ListCommandNode = class ListCommandNode extends CommandNode {
    command = "list";
  };
ListCommand = class ListCommand extends CommandArguments {
    NodeType = ListCommandNode;
    list = (uuids) => this.finalCommand([uuids ? "uuids" : undefined]);
  };
MeCommandNode = class MeCommandNode extends CommandNode {
    command = "me";
  };
MeCommand = class MeCommand extends CommandArguments {
    NodeType = MeCommandNode;
    me = (...actions) => this.finalCommand(actions.map(targetParser));
  };
PerfCommandNode = class PerfCommandNode extends CommandNode {
    command = "perf";
  };
PerfCommand = class PerfCommand extends CommandArguments {
    NodeType = PerfCommandNode;
    start = () => this.finalCommand(["start"]);
    stop = () => this.finalCommand(["stop"]);
  };
JFRCommandNode = class JFRCommandNode extends CommandNode {
    command = "jfr";
  };
JFRCommand = class JFRCommand extends CommandArguments {
    NodeType = JFRCommandNode;
    start = () => this.finalCommand(["start"]);
    stop = () => this.finalCommand(["stop"]);
  };
RandomCommandNode = class RandomCommandNode extends CommandNode {
    command = "random";
  };
RandomCommand = class RandomCommand extends CommandArguments {
    NodeType = RandomCommandNode;
    value = (range, sequence) => {
      let seq = sequence;
      if (typeof sequence === "string" && !sequence.includes(":")) {
        seq = `${this.sandstonePack.defaultNamespace}:${seq}`;
      }
      return this.finalCommand(["value", rangeParser(this.sandstoneCore, range), seq]);
    };
    roll = (range, sequence) => {
      let seq = sequence;
      if (sequence && typeof sequence === "string" && !sequence.includes(":")) {
        seq = `${this.sandstonePack.defaultNamespace}:${seq}`;
      }
      return this.finalCommand(["roll", rangeParser(this.sandstoneCore, range), seq]);
    };
    reset = (sequence, seed, includeWorldSeed, includeSequenceID) => {
      let seq = sequence;
      if (sequence && typeof sequence === "string" && !sequence.includes(":")) {
        seq = `${this.sandstonePack.defaultNamespace}:${seq}`;
      }
      return this.finalCommand(["reset", seq, seed, includeWorldSeed, includeSequenceID]);
    };
  };
ReloadCommandNode = class ReloadCommandNode extends CommandNode {
    command = "reload";
  };
ReloadCommand = class ReloadCommand extends CommandArguments {
    NodeType = ReloadCommandNode;
    reload = () => this.finalCommand([]);
  };
ReturnRunCommandNode = class ReturnRunCommandNode extends ContainerCommandNode {
    command = "return";
    isSingleExecute;
    isFlowControl;
    isFunctionBoundary;
    constructor(sandstonePack, isMacro = false, args = [], { isSingleExecute = true, body = [], isFlowControl = false, isFunctionBoundary = false } = {}) {
      super(sandstonePack, ...args);
      this.isSingleExecute = isSingleExecute;
      this.isFlowControl = isFlowControl;
      this.isFunctionBoundary = isFunctionBoundary;
      this.append(...body);
    }
    getValue = () => {
      if (this.body.length > 1) {
        throw new Error("Return run nodes can only have one child node when toString is called.");
      }
      let command = this.body[0].getValue();
      if (command.startsWith("$")) {
        this.isMacro = true;
        command = command.slice(1);
      }
      return `${this.isMacro ? "$" : ""}${this.command} run ${command}`;
    };
    createMCFunction = (currentMCFunction) => {
      if (this.isSingleExecute || !currentMCFunction) {
        return { node: this };
      }
      const namespace = currentMCFunction.resource.name.includes(":") ? `${currentMCFunction.resource.name.split(":")[0]}:` : "";
      const mcFunction = this.sandstonePack.MCFunction(`${namespace}${currentMCFunction.resource.path.slice(2).join("/")}/return_run`, {
        addToSandstoneCore: false,
        creator: "sandstone",
        onConflict: "rename"
      });
      const mcFunctionNode = mcFunction.node;
      mcFunctionNode.body = this.body;
      const mcFunctionCall = new FunctionCommandNode(this.sandstonePack, mcFunction);
      this.body = [mcFunctionCall];
      return { node: this, mcFunction: mcFunctionNode };
    };
    append = (...nodes2) => {
      for (const node of nodes2) {
        this.body.push(node);
        if (this.isSingleExecute) {
          this.sandstoneCore.getCurrentMCFunctionOrThrow().exitContext();
        }
      }
      return nodes2.length === 1 ? nodes2[0] : nodes2;
    };
  };
ReturnArgumentsCommand = class ReturnArgumentsCommand extends CommandArguments {
    NodeType = ReturnRunCommandNode;
    get run() {
      const node = this.getNode();
      const commandsSource = this.sandstonePack[this.isMacro ? "macroCommands" : "commands"];
      const commands = new Proxy(commandsSource, {
        get: (_t, p, _r) => {
          this.sandstoneCore.getCurrentMCFunctionOrThrow().enterContext(node);
          return commandsSource[p];
        }
      });
      return makeCallable(commands, (callback) => {
        node.isSingleExecute = false;
        this.sandstoneCore.insideContext(node, callback, true);
        return new FinalCommandOutput(node);
      }, true);
    }
  };
ReturnCommandNode = class ReturnCommandNode extends CommandNode {
    command = "return";
  };
ReturnCommand = class ReturnCommand extends CommandArguments {
    NodeType = ReturnCommandNode;
    get return() {
      const run = new ReturnArgumentsCommand(this.sandstonePack, this.isMacro);
      return makeCallable({
        run: run.run,
        fail: this.fail
      }, (value) => this.finalCommand([value || 0]), true);
    }
    fail = () => this.finalCommand(["fail"]);
  };
SayCommandNode = class SayCommandNode extends CommandNode {
    command = "say";
  };
SayCommand = class SayCommand extends CommandArguments {
    NodeType = SayCommandNode;
    say = (message) => this.finalCommand([message]);
  };
ScheduleCommandNode = class ScheduleCommandNode extends ContainerCommandNode {
    command = "schedule";
    createMCFunction = (currentMCFunction) => {
      if (this.body.length === 0 || this.args[0] === "clear" || !currentMCFunction) {
        return { node: this };
      }
      const [_, func, time, append] = this.args;
      if (typeof func !== "string" && func !== undefined) {
        throw new Error("Cannot have something else than a string as the argument for a scheduled function with callback");
      }
      const mcFunction = this.sandstonePack.MCFunction(`${currentMCFunction.resource.name}/${func ?? "schedule"}`, {
        addToSandstoneCore: false,
        creator: "sandstone",
        onConflict: "rename"
      });
      const mcFunctionNode = mcFunction.node;
      mcFunctionNode.body = this.body;
      this.body = [];
      this.args = ["function", mcFunction.name, time, append];
      return { node: this, mcFunction: mcFunctionNode };
    };
  };
ScheduleCommand = class ScheduleCommand extends CommandArguments {
    NodeType = ScheduleCommandNode;
    clear = (func) => {
      const funcArg = isMacroArgument(this.sandstoneCore, func) ? func : `${func}`;
      const result = this.finalCommand(["clear", funcArg]);
      return result;
    };
    function = (func, delay, type) => {
      const node = this.getNode();
      if (typeof func === "function" && Object.hasOwn(func, "addToTag")) {
        return this.finalCommand(["function", func.name, delay, type], node);
      }
      if (typeof func === "function") {
        console.log("hello!");
        this.sandstoneCore.insideContext(node, func, false);
        return this.finalCommand(["function", undefined, delay, type], node);
      }
      const funcArg = isMacroArgument(this.sandstoneCore, func) ? func : `${func}`;
      return this.finalCommand(["function", funcArg, delay, type], node);
    };
  };
SetIdleTimeoutCommandNode = class SetIdleTimeoutCommandNode extends CommandNode {
    command = "setidletimeout";
  };
SetIdleTimeoutCommand = class SetIdleTimeoutCommand extends CommandArguments {
    NodeType = SetIdleTimeoutCommandNode;
    setidletimeout = (minutes) => this.finalCommand([minutes]);
  };
StopwatchCommandNode = class StopwatchCommandNode extends CommandNode {
    command = "stopwatch";
  };
StopwatchCommand = class StopwatchCommand extends CommandArguments {
    NodeType = StopwatchCommandNode;
    create = (id2) => this.finalCommand(["create", id2]);
    query = (id2, scale) => this.finalCommand(["query", id2, scale]);
    restart = (id2) => this.finalCommand(["restart", id2]);
    remove = (id2) => this.finalCommand(["remove", id2]);
  };
TeamMessageCommandNode = class TeamMessageCommandNode extends CommandNode {
    command = "tm";
  };
TeamMessageCommand = class TeamMessageCommand extends CommandArguments {
    NodeType = TeamMessageCommandNode;
    teammessage = (...messages) => this.finalCommand(messages);
  };
TellCommandNode = class TellCommandNode extends CommandNode {
    command = "w";
  };
TellCommand = class TellCommand extends CommandArguments {
    NodeType = TellCommandNode;
    tell = (targets, ...messages) => this.finalCommand([targetParser(targets), messages]);
  };
TellRawCommandNode = class TellRawCommandNode extends CommandNode {
    command = "tellraw";
  };
TellRawCommand = class TellRawCommand extends CommandArguments {
    NodeType = TellRawCommandNode;
    tellraw = (targets, message) => this.finalCommand([targetParser(targets), parseJSONText(this.sandstoneCore, message)]);
  };
TriggerCommandNode = class TriggerCommandNode extends CommandNode {
    command = "trigger";
  };
TriggerArgumentsCommand = class TriggerArgumentsCommand extends CommandArguments {
    add = (value) => this.finalCommand(["add", value]);
    set = (value) => this.finalCommand(["set", value]);
  };
TriggerCommand = class TriggerCommand extends CommandArguments {
    NodeType = TriggerCommandNode;
    trigger = (objective) => this.subCommand([objective], TriggerArgumentsCommand, false);
  };
VersionCommandNode = class VersionCommandNode extends CommandNode {
    command = "version";
  };
VersionCommand = class VersionCommand extends CommandArguments {
    NodeType = VersionCommandNode;
    version = () => this.finalCommand([]);
  };
DataCommandNode = class DataCommandNode extends CommandNode {
    command = "data";
  };
DataCommand = class DataCommand extends CommandArguments {
    NodeType = DataCommandNode;
    get get() {
      const cmd = this.subCommand(["get"], DataGetCommand, false);
      return makeCallable(cmd, (dataPoint, scale) => {
        if (dataPoint.type === "block") {
          return cmd.block(coordinatesParser(dataPoint.currentTarget), dataPoint.path, scale);
        }
        if (dataPoint.type === "entity") {
          return cmd.entity(dataPoint.currentTarget, dataPoint.path, scale);
        }
        return cmd.storage(dataPoint.currentTarget, dataPoint.path, scale);
      });
    }
    get merge() {
      return this.subCommand(["merge"], DataMergeCommand, false);
    }
    get modify() {
      const cmd = this.subCommand(["modify"], DataModifyCommand, false);
      return makeCallable(cmd, (dataPoint) => {
        if (dataPoint.type === "block") {
          return cmd.block(coordinatesParser(dataPoint.currentTarget), dataPoint.path);
        }
        if (dataPoint.type === "entity") {
          return cmd.entity(dataPoint.currentTarget, dataPoint.path);
        }
        return cmd.storage(dataPoint.currentTarget, dataPoint.path);
      });
    }
    get remove() {
      const cmd = this.subCommand(["remove"], DataRemoveCommand, false);
      return makeCallable(cmd, (dataPoint) => {
        if (dataPoint.type === "block") {
          return cmd.block(coordinatesParser(dataPoint.currentTarget), dataPoint.path);
        }
        if (dataPoint.type === "entity") {
          return cmd.entity(dataPoint.currentTarget, dataPoint.path);
        }
        return cmd.storage(dataPoint.currentTarget, dataPoint.path);
      });
    }
  };
DataGetCommand = class DataGetCommand extends CommandArguments {
    block = (targetPos, path4, scale) => {
      return this.finalCommand(["block", coordinatesParser(targetPos), path4, scale]);
    };
    entity = (target, path4, scale) => {
      return this.finalCommand(["entity", targetParser(target), path4, scale]);
    };
    storage = (target, path4, scale) => {
      return this.finalCommand(["storage", target, path4, scale]);
    };
  };
DataMergeCommand = class DataMergeCommand extends CommandArguments {
    block = (targetPos, nbt) => this.finalCommand(["block", coordinatesParser(targetPos), nbtResolver(nbt)]);
    entity = (target, nbt) => this.finalCommand(["entity", targetParser(target), nbtResolver(nbt)]);
    storage = (target, nbt) => this.finalCommand(["storage", target, nbtResolver(nbt)]);
  };
DataModifyFromCommand = class DataModifyFromCommand extends CommandArguments {
    block = (sourcePosition, sourcePath) => this.finalCommand(["block", coordinatesParser(sourcePosition), sourcePath]);
    entity = (source, sourcePath) => this.finalCommand(["entity", targetParser(source), sourcePath]);
    storage = (source, sourcePath) => {
      return this.finalCommand(["storage", source, sourcePath]);
    };
  };
DataModifyValuesCommand = class DataModifyValuesCommand extends CommandArguments {
    get from() {
      const cmd = this.subCommand(["from"], DataModifyFromCommand, false);
      return makeCallable(cmd, (dataPoint) => {
        if (dataPoint.type === "block") {
          return cmd.block(coordinatesParser(dataPoint.currentTarget), dataPoint.path);
        }
        if (dataPoint.type === "entity") {
          return cmd.entity(dataPoint.currentTarget, dataPoint.path);
        }
        return cmd.storage(dataPoint.currentTarget, dataPoint.path);
      });
    }
    string = {
      block: (sourcePosition, sourcePath, start, end) => {
        const command = [
          "string",
          "block",
          coordinatesParser(sourcePosition),
          sourcePath
        ];
        if (start !== undefined && end !== undefined) {
          command.push(start, end);
        } else if (start !== undefined && start !== 0) {
          command.push(start);
        }
        this.finalCommand(command);
      },
      entity: (source, sourcePath, start, end) => {
        const command = [
          "string",
          "entity",
          targetParser(source),
          sourcePath
        ];
        if (start !== undefined && end !== undefined) {
          command.push(start, end);
        } else if (start !== undefined && start !== 0) {
          command.push(start);
        }
        this.finalCommand(command);
      },
      storage: (source, sourcePath, start, end) => {
        const command = ["string", "storage", source, sourcePath];
        if (start !== undefined && end !== undefined) {
          command.push(start, end);
        } else if (start !== undefined && start !== 0) {
          command.push(start);
        }
        this.finalCommand(command);
      }
    };
    value = (value) => this.finalCommand(["value", nbtResolver(value)]);
  };
DataModifyTypeCommand = class DataModifyTypeCommand extends CommandArguments {
    get append() {
      return this.subCommand(["append"], DataModifyValuesCommand, false);
    }
    insert = (index) => this.subCommand(["insert", index], DataModifyValuesCommand, false);
    get merge() {
      return this.subCommand(["merge"], DataModifyValuesCommand, false);
    }
    get prepend() {
      return this.subCommand(["prepend"], DataModifyValuesCommand, false);
    }
    get set() {
      return this.subCommand(["set"], DataModifyValuesCommand, false);
    }
  };
DataModifyCommand = class DataModifyCommand extends CommandArguments {
    block = (targetPos, targetPath) => {
      return this.subCommand(["block", coordinatesParser(targetPos), targetPath], DataModifyTypeCommand, false);
    };
    entity = (target, targetPath) => {
      return this.subCommand(["entity", targetParser(target), targetPath], DataModifyTypeCommand, false);
    };
    storage = (target, targetPath) => {
      return this.subCommand(["storage", target, targetPath], DataModifyTypeCommand, false);
    };
  };
DataRemoveCommand = class DataRemoveCommand extends CommandArguments {
    block = (targetPos, targetPath) => {
      return this.finalCommand(["block", coordinatesParser(targetPos), targetPath]);
    };
    entity = (target, targetPath) => {
      return this.finalCommand(["entity", targetParser(target), targetPath]);
    };
    storage = (target, targetPath) => {
      return this.finalCommand(["storage", target, targetPath]);
    };
  };
FillBiomeCommandNode = class FillBiomeCommandNode extends CommandNode {
    command = "fillbiome";
  };
FillBiomeCommand = class FillBiomeCommand extends CommandArguments {
    NodeType = FillBiomeCommandNode;
    fillbiome(from, to, biome, filter) {
      if (filter !== undefined) {
        return this.finalCommand([coordinatesParser(from), coordinatesParser(to), biome, "replace", filter]);
      }
      return this.finalCommand([coordinatesParser(from), coordinatesParser(to), biome]);
    }
  };
ForceLoadCommandNode = class ForceLoadCommandNode extends CommandNode {
    command = "forceload";
  };
ForceLoadCommand = class ForceLoadCommand extends CommandArguments {
    NodeType = ForceLoadCommandNode;
    add = (from, to) => {
      validateNumberOfChunks(from, to);
      return this.finalCommand(["add", coordinatesParser(from), coordinatesParser(to)]);
    };
    remove = (from, to) => {
      validateNumberOfChunks(from, to);
      return this.finalCommand(["remove", coordinatesParser(from), coordinatesParser(to)]);
    };
    removeAll = () => this.finalCommand(["remove", "all"]);
    query = (pos) => this.finalCommand(["query", coordinatesParser(pos)]);
  };
ItemCommandNode = class ItemCommandNode extends CommandNode {
    command = "item";
  };
ItemSourceCommand = class ItemSourceCommand extends CommandArguments {
    with(item, countOrNBT, count) {
      if (typeof countOrNBT === "object") {
        return this.finalCommand(["with", `${item}${componentPatchStringifier(countOrNBT)}`, count]);
      }
      return this.finalCommand(["with", item, countOrNBT]);
    }
    from = {
      block: (pos, slotSource2, modifier) => this.finalCommand(["from", "block", pos, slotSource2, modifier]),
      entity: (targets, slotSource2, modifier) => this.finalCommand(["from", "entity", targetParser(targets), slotSource2, modifier])
    };
  };
ItemCommand = class ItemCommand extends CommandArguments {
    NodeType = ItemCommandNode;
    modify = {
      block: (pos, slot, modifier) => this.finalCommand(["modify", "block", coordinatesParser(pos), slot, modifier]),
      entity: (targets, slot, modifier) => this.finalCommand(["modify", "entity", targetParser(targets), slot, modifier])
    };
    replace = {
      block: (pos, slotSource2) => this.subCommand(["replace", "block", pos, slotSource2], ItemSourceCommand, false),
      entity: (targets, slotSource2) => this.subCommand(["replace", "entity", targetParser(targets), slotSource2], ItemSourceCommand, false)
    };
    fill = {
      block: (pos, slotSource2) => this.subCommand(["fill", "block", pos, slotSource2], ItemSourceCommand, false),
      entity: (targets, slotSource2) => this.subCommand(["fill", "entity", targetParser(targets), slotSource2], ItemSourceCommand, false)
    };
    override = {
      block: (pos, slotSource2) => this.subCommand(["override", "block", pos, slotSource2], ItemSourceCommand, false),
      entity: (targets, slotSource2) => this.subCommand(["override", "entity", targetParser(targets), slotSource2], ItemSourceCommand, false)
    };
  };
LocateCommandNode = class LocateCommandNode extends CommandNode {
    command = "locate";
  };
LocateCommand = class LocateCommand extends CommandArguments {
    NodeType = LocateCommandNode;
    structure = (structure2) => this.finalCommand(["structure", structure2]);
    biome = (biome) => this.finalCommand(["biome", biome]);
    poi = (pointOfInterest) => this.finalCommand(["poi", pointOfInterest]);
  };
LootCommandNode = class LootCommandNode extends CommandNode {
    command = "loot";
  };
LootSourceCommand = class LootSourceCommand extends CommandArguments {
    fish = (lootTable2, pos, tool) => this.finalCommand(["fish", lootTable2, coordinatesParser(pos), tool]);
    loot = (lootTable2) => this.finalCommand(["loot", lootTable2]);
    kill(target) {
      return this.finalCommand(["kill", targetParser(target)]);
    }
    mine = (pos, tool) => this.finalCommand(["mine", coordinatesParser(pos), tool]);
  };
LootCommand = class LootCommand extends CommandArguments {
    NodeType = LootCommandNode;
    spawn = (targetPos) => this.subCommand(["spawn", coordinatesParser(targetPos)], LootSourceCommand, false);
    replace = {
      entity: (entities, slot, count) => {
        if (count)
          validateIntegerRange(count, "count", 0, 2147483647);
        return this.subCommand(["replace", "entity", targetParser(entities), slot, count], LootSourceCommand, false);
      },
      block: (targetPos, slot, count) => {
        if (count)
          validateIntegerRange(count, "count", 0, 2147483647);
        return this.subCommand(["replace", "block", coordinatesParser(targetPos), slot, count], LootSourceCommand, false);
      }
    };
    give(players) {
      return this.subCommand(["give", targetParser(players)], LootSourceCommand, false);
    }
    insert = (targetPos) => this.subCommand(["insert", coordinatesParser(targetPos)], LootSourceCommand, false);
  };
SeedCommandNode = class SeedCommandNode extends CommandNode {
    command = "seed";
  };
SeedCommand = class SeedCommand extends CommandArguments {
    NodeType = SeedCommandNode;
    seed = () => this.finalCommand([]);
  };
SetWorldSpawnCommandNode = class SetWorldSpawnCommandNode extends CommandNode {
    command = "setworldspawn";
  };
SetWorldSpawnCommand = class SetWorldSpawnCommand extends CommandArguments {
    NodeType = SetWorldSpawnCommandNode;
    setworldspawn = (pos, angle) => this.finalCommand([coordinatesParser(pos), coordinatesParser(angle)]);
  };
TestCommandNode = class TestCommandNode extends CommandNode {
    command = "test";
  };
TestCommand = class TestCommand extends CommandArguments {
    NodeType = TestCommandNode;
    create(test, width, height, depth) {
      if (width === undefined) {
        return this.finalCommand(["create", test]);
      }
      if (height === undefined) {
        return this.finalCommand(["create", test, width]);
      }
      return this.finalCommand(["create", test, width, height, depth]);
    }
    verify = (testSelector) => this.finalCommand(["verify", testSelector]);
    run(testSelector, repeat = 1, untilFail = false, rotation = 0, gridLength = 8) {
      if (testSelector === "closest" || testSelector === "that" || testSelector === "these") {
        return this.finalCommand([`run${testSelector}`, repeat, untilFail]);
      }
      return this.finalCommand(["run", testSelector, repeat, untilFail, typeof rotation === "number" ? rotation / 90 : rotation, gridLength]);
    }
    runFailed(repeatOrOnlyRequired, untilFailOrRepeat, rotation = 0, gridLength = 8) {
      if (repeatOrOnlyRequired === undefined) {
        return this.finalCommand(["runfailed"]);
      }
      if (typeof repeatOrOnlyRequired === "boolean") {
        untilFailOrRepeat = untilFailOrRepeat ?? 1;
        return this.finalCommand(["runfailed", repeatOrOnlyRequired, untilFailOrRepeat]);
      }
      untilFailOrRepeat = untilFailOrRepeat ?? false;
      return this.finalCommand(["runfailed", repeatOrOnlyRequired, untilFailOrRepeat, typeof rotation === "number" ? rotation / 90 : rotation, gridLength]);
    }
    locate = (testSelector) => this.finalCommand(["locate", testSelector]);
    pos = (variableName) => this.finalCommand(["pos", variableName]);
    reset = (target) => this.finalCommand([`reset${target}`]);
    clear(radiusOrTarget) {
      if (typeof radiusOrTarget === "string") {
        return this.finalCommand([`clear${radiusOrTarget}`]);
      }
      if (radiusOrTarget === undefined) {
        return this.finalCommand(["clearall"]);
      }
      return this.finalCommand(["clearall", radiusOrTarget]);
    }
    stop = () => this.finalCommand(["stop"]);
  };
TimeCommandNode = class TimeCommandNode extends CommandNode {
    command = "time";
  };
TimeArguments = class TimeArguments extends CommandArguments {
    NodeType = TimeCommandNode;
    add = (time) => this.finalCommand(["add", time]);
    query = (type) => this.finalCommand(["query", type]);
    set = (time) => this.finalCommand(["set", time]);
  };
TimeCommand = class TimeCommand extends TimeArguments {
    NodeType = TimeCommandNode;
    of = (worldClock) => this.subCommand(["of", worldClock], TimeArguments, false);
  };
WeatherCommandNode = class WeatherCommandNode extends CommandNode {
    command = "weather";
  };
WeatherCommand = class WeatherCommand extends CommandArguments {
    NodeType = WeatherCommandNode;
    clear = (duration) => this.finalCommand(["clear", duration]);
    rain = (duration) => this.finalCommand(["rain", duration]);
    thunder = (duration) => this.finalCommand(["thunder", duration]);
  };
WorldBorderNode = class WorldBorderNode extends CommandNode {
    command = "worldborder";
  };
WorldBorderCommand = class WorldBorderCommand extends CommandArguments {
    NodeType = WorldBorderNode;
    add = (distance, time) => this.finalCommand(["add", distance, time]);
    center = (pos) => this.finalCommand(["center", coordinatesParser(pos)]);
    damage = {
      amount: (damagePerBlock) => this.finalCommand(["damage", "amount", damagePerBlock]),
      buffer: (distance) => this.finalCommand(["damage", "buffer", distance])
    };
    get = () => this.finalCommand(["get"]);
    set = (distance, time) => this.finalCommand(["set", distance, time]);
    warning = {
      distance: (distance) => this.finalCommand(["warning", "distance", distance]),
      time: (time) => this.finalCommand(["warning", "time", time])
    };
  };
AttachClass = class AttachClass extends AwaitNode {
    command = "tag";
    mcfunction;
    targetFunc;
    targetBranch;
    targetAwaitNodeIdx;
    entrypoint;
    entity;
    constructor(core, opts, logPath) {
      super(core.pack);
      if (logPath) {
        this.stackTrace = Error().stack;
      }
      this.targetFunc = opts.func;
      this.targetBranch = opts.branch;
      this.targetAwaitNodeIdx = opts.awaitNodeIdx;
      this.entrypoint = opts.entrypoint;
      this.entity = opts.entity;
      const currentFunction = core.getCurrentMCFunctionOrThrow();
      currentFunction.resource.nested += 1;
      const baseName = `${currentFunction.resource.path.slice(2).join("/")}/${ATTACH_CHILD_NAME}`;
      this.mcfunction = core.pack.MCFunction(`${baseName}/_continuation`, () => {}, {
        addToSandstoneCore: true,
        lazy: false,
        creator: "sandstone",
        onConflict: "rename",
        packType: currentFunction.resource.packType,
        asyncContext: currentFunction.resource.asyncContext
      });
      currentFunction.enterContext(this);
      core.awaitNodes.add(this);
    }
  };
SleepClass = class SleepClass extends AwaitNode {
    delay;
    command = "schedule";
    mcfunction;
    inSleepFunction;
    logPath;
    stackTrace;
    constructor(core, delay, logPath) {
      super(core.pack);
      this.delay = delay;
      this.logPath = logPath;
      if (this.logPath) {
        this.stackTrace = Error().stack;
      }
      const currentFunction = core.getCurrentMCFunctionOrThrow();
      const { path: path4 } = currentFunction.resource;
      this.inSleepFunction = path4[path4.length - 1].startsWith(SLEEP_CHILD_NAME);
      currentFunction.resource.nested += 1;
      this.mcfunction = core.pack.MCFunction(`${currentFunction.resource.path.slice(2).join("/")}/${SLEEP_CHILD_NAME}`, () => {}, {
        addToSandstoneCore: true,
        lazy: false,
        creator: "sandstone",
        onConflict: "rename",
        packType: currentFunction.resource.packType
      });
      let schedule2 = this.mcfunction.name;
      let type = "append";
      if (currentFunction.resource.asyncContext) {
        const Duration = (() => {
          if (typeof delay === "number") {
            return delay + 1;
          }
          const unit = delay.charAt(delay.length - 1);
          let value = Number(delay.replace(unit, ""));
          if (unit === "s") {
            value *= 20;
          } else if (unit === "d") {
            value *= 24000;
          }
          return value;
        })();
        type = "replace";
        const { commands: commands2, MCFunction, Label, Selector } = core.pack;
        const { execute: execute2 } = commands2;
        const name = `__sandstone:asyncTimer.${currentFunction.resource.name.replace(/[:/]/g, ".")}`;
        const timer = new ObjectiveClass(core.pack, name.replace(":", "."), "dummy", undefined, { creator: "sandstone" });
        core.pack.registerNewObjective(timer);
        execute2.store.result(timer("@s")).run.time.query("gametime");
        timer("@s").add(Duration);
        const label = Label(name);
        label("@s").add();
        this.mcfunction.unshift(() => label("@s").remove());
        schedule2 = MCFunction(`${this.mcfunction.name}/_context`, () => {
          execute2.store.result(timer("#current")).run.time.query("gametime");
          execute2.as(Selector("@e", { tag: label.fullName })).if.score(timer("@s"), "=", timer("#current")).at("@s").run.functionCmd(this.mcfunction);
        }, {
          packType: currentFunction.resource.packType
        }).name;
      }
      this.args = ["function", schedule2, this.delay, type];
      currentFunction.enterContext(this);
      core.awaitNodes.add(this);
    }
  };
UntilClass = class UntilClass extends AwaitNode {
    condition;
    pollRate;
    command = "return";
    mcfunction;
    continuation;
    poller;
    logPath;
    stackTrace;
    constructor(core, condition, pollRate, logPath) {
      super(core.pack);
      this.condition = condition;
      this.pollRate = pollRate;
      this.logPath = logPath;
      if (this.logPath) {
        this.stackTrace = Error().stack;
      }
      const currentFunction = core.getCurrentMCFunctionOrThrow();
      currentFunction.resource.nested += 1;
      const baseName = `${currentFunction.resource.path.slice(2).join("/")}/${UNTIL_CHILD_NAME}`;
      this.continuation = core.pack.MCFunction(`${baseName}/_continuation`, () => {}, {
        addToSandstoneCore: true,
        lazy: false,
        creator: "sandstone",
        onConflict: "rename",
        packType: currentFunction.resource.packType,
        asyncContext: currentFunction.resource.asyncContext
      });
      this.poller = core.pack.MCFunction(`${baseName}/_poller`, () => {
        core.pack._.if(this.condition, () => {
          this.continuation();
        }).else(() => {
          const sleep = new SleepClass(core, this.pollRate, false);
          sleep.mcfunction.node.body.push(new FunctionCommandNode(core.pack, this.poller.name));
        });
      }, {
        addToSandstoneCore: true,
        lazy: false,
        creator: "sandstone",
        onConflict: "rename",
        packType: currentFunction.resource.packType,
        asyncContext: currentFunction.resource.asyncContext
      });
      this.args = ["run", "function", this.poller.name];
      currentFunction.enterContext(this);
      this.mcfunction = this.continuation;
      core.awaitNodes.add(this);
    }
  };
ConditionNode = class ConditionNode extends Node {
    preNodes;
  };
SingleConditionNode = class SingleConditionNode extends ConditionNode {
    getValue = (negated = false) => {
      const keyword = negated ? "unless" : "if";
      return [keyword, ...this.getCondition()].join(" ");
    };
    [util8.inspect.custom](depth, options) {
      return formatDebugString(this.constructor.name, this.getValue(), undefined, options.indent);
    }
  };
SingleExecuteNode = class SingleExecuteNode extends ConditionNode {
    getValue = (_negated = false) => this.getCondition().join(" ");
  };
AndNode = class AndNode extends ConditionNode {
    conditions;
    constructor(sandstoneCore2, conditions) {
      super(sandstoneCore2);
      this.conditions = conditions;
    }
    getValue = (negated = false) => this.conditions.map((condition) => condition.getValue(negated)).join(" ");
  };
NotNode = class NotNode extends ConditionNode {
    condition;
    constructor(sandstoneCore2, condition) {
      super(sandstoneCore2);
      this.condition = condition;
    }
    getValue = (negated = false) => this.condition.getValue(!negated);
  };
OrNode = class OrNode extends ConditionNode {
    conditions;
    constructor(sandstoneCore2, conditions) {
      super(sandstoneCore2);
      this.conditions = conditions;
    }
    getValue = (_negated) => {
      throw new Error("Minecraft does not support OR conditions. This should never happen and must be processed.");
    };
    [util9.inspect.custom](depth, options) {
      return formatDebugString(this.constructor.name, this.conditions, undefined, options.indent);
    }
  };
AdvancementConditionNode = class AdvancementConditionNode extends SingleConditionNode {
    advancementArgument;
    constructor(sandstoneCore2, advancement3, criteria) {
      super(sandstoneCore2);
      if (criteria) {
        this.advancementArgument = {};
        this.advancementArgument[advancement3] = {};
        this.advancementArgument[advancement3][criteria] = true;
      } else {
        this.advancementArgument = {};
        this.advancementArgument[advancement3] = true;
      }
    }
    getCondition() {
      return ["entity", this.sandstoneCore.pack.Selector("@s", { advancements: this.advancementArgument })];
    }
  };
PredicateConditionNode = class PredicateConditionNode extends SingleConditionNode {
    predicate;
    constructor(sandstoneCore2, predicate2) {
      super(sandstoneCore2);
      this.predicate = predicate2;
    }
    getCondition() {
      return ["predicate", this.predicate];
    }
  };
SlotSourceConditionNode = class SlotSourceConditionNode extends SingleConditionNode {
    slotSource;
    constructor(sandstoneCore2, slotSource2) {
      super(sandstoneCore2);
      this.slotSource = slotSource2;
    }
    getCondition() {
      return ["slots", "entity", "@s", this.slotSource];
    }
  };
TagConditionNode = class TagConditionNode extends SingleConditionNode {
    type;
    tag;
    constructor(sandstoneCore2, type, tag3) {
      super(sandstoneCore2);
      this.type = type;
      this.tag = tag3;
    }
    getCondition() {
      if (this.type === "block") {
        return ["block", "~ ~ ~", `#${this.tag}`];
      }
      return ["entity", this.sandstoneCore.pack.Selector("@s", { type: `#${this.tag}` })];
    }
  };
BiomeConditionNode = class BiomeConditionNode extends SingleConditionNode {
    coordinates;
    biome;
    constructor(sandstoneCore2, coordinates, biome) {
      super(sandstoneCore2);
      this.coordinates = coordinates;
      this.biome = biome;
    }
    getCondition() {
      return ["biome", coordinatesParser(this.coordinates), this.biome];
    }
  };
BlockConditionNode = class BlockConditionNode extends SingleConditionNode {
    position;
    block;
    state;
    nbt;
    constructor(sandstoneCore2, position, block, state, nbt) {
      super(sandstoneCore2);
      this.position = position;
      this.block = block;
      this.state = state;
      this.nbt = nbt;
    }
    getCondition() {
      const stateStr = this.state && Object.keys(this.state).length > 0 ? blockStateStringifier(this.state) : "";
      const nbtStr = this.nbt ? nbtResolver(this.nbt).toString() : "";
      return ["block", coordinatesParser(this.position), `${this.block}${stateStr}${nbtStr}`];
    }
  };
BlocksConditionNode = class BlocksConditionNode extends SingleConditionNode {
    start;
    end;
    destination;
    scan_mode;
    constructor(sandstoneCore2, start, end, destination, scan_mode) {
      super(sandstoneCore2);
      this.start = start;
      this.end = end;
      this.destination = destination;
      this.scan_mode = scan_mode;
    }
    getCondition() {
      return [
        "blocks",
        coordinatesParser(this.start),
        coordinatesParser(this.end),
        coordinatesParser(this.destination),
        this.scan_mode
      ];
    }
  };
DataPointExistsConditionNode = class DataPointExistsConditionNode extends SingleConditionNode {
    dataPoint;
    constructor(sandstoneCore2, dataPoint) {
      super(sandstoneCore2);
      this.dataPoint = dataPoint;
    }
    getCondition() {
      return ["data", this.dataPoint.type, this.dataPoint.currentTarget, this.dataPoint.path];
    }
  };
DataPointEqualsConditionNode = class DataPointEqualsConditionNode extends SingleConditionNode {
    dataPoint;
    value;
    conditional;
    constructor(sandstoneCore2, dataPoint, value) {
      super(sandstoneCore2);
      this.dataPoint = dataPoint;
      this.value = value;
      const { DataVariable, Variable, commands: commands2 } = sandstoneCore2.pack;
      const { execute: execute2 } = commands2;
      const mcFunction = sandstoneCore2.getCurrentMCFunctionOrThrow();
      const before = mcFunction.body.length;
      const anon = DataVariable(this.dataPoint);
      this.conditional = Variable();
      execute2.store.result(this.conditional).run(() => anon.set(this.value));
      const after = mcFunction.body.length;
      this.preNodes = mcFunction.body.splice(before, after - before);
    }
    getValue = (negated) => (negated ? ["if", ...this.getCondition()] : ["unless", ...this.getCondition()]).join(" ");
    getCondition() {
      return ["score", this.conditional, "matches", "0.."];
    }
  };
DimensionConditionNode = class DimensionConditionNode extends SingleConditionNode {
    dimension;
    constructor(sandstoneCore2, dimension) {
      super(sandstoneCore2);
      this.dimension = dimension;
    }
    getCondition() {
      return ["dimension", this.dimension];
    }
  };
FunctionConditionNode = class FunctionConditionNode extends SingleConditionNode {
    mcfunction;
    constructor(sandstoneCore2, mcfunction2) {
      super(sandstoneCore2);
      this.mcfunction = mcfunction2;
    }
    getCondition() {
      return ["function", this.mcfunction];
    }
  };
ItemsBlockConditionNode = class ItemsBlockConditionNode extends SingleConditionNode {
    sourcePos;
    slotSource;
    itemPredicate;
    constructor(sandstoneCore2, sourcePos, slotSource3, itemPredicate) {
      super(sandstoneCore2);
      this.sourcePos = sourcePos;
      this.slotSource = slotSource3;
      this.itemPredicate = itemPredicate;
    }
    getCondition() {
      return ["items", "block", coordinatesParser(this.sourcePos), this.slotSource, `${this.itemPredicate}`];
    }
  };
ItemsEntityConditionNode = class ItemsEntityConditionNode extends SingleConditionNode {
    source;
    slotSource;
    itemPredicate;
    constructor(sandstoneCore2, source, slotSource3, itemPredicate) {
      super(sandstoneCore2);
      this.source = source;
      this.slotSource = slotSource3;
      this.itemPredicate = itemPredicate;
    }
    getCondition() {
      return ["items", "entity", targetParser(this.source), this.slotSource, `${this.itemPredicate}`];
    }
  };
SlotsBlockConditionNode = class SlotsBlockConditionNode extends SingleConditionNode {
    sourcePos;
    slotSource;
    constructor(sandstoneCore2, sourcePos, slotSource3) {
      super(sandstoneCore2);
      this.sourcePos = sourcePos;
      this.slotSource = slotSource3;
    }
    getCondition() {
      return ["slots", "block", coordinatesParser(this.sourcePos), this.slotSource];
    }
  };
SlotsEntityConditionNode = class SlotsEntityConditionNode extends SingleConditionNode {
    source;
    slotSource;
    constructor(sandstoneCore2, source, slotSource3) {
      super(sandstoneCore2);
      this.source = source;
      this.slotSource = slotSource3;
    }
    getCondition() {
      return ["slots", "entity", targetParser(this.source), this.slotSource];
    }
  };
CommandConditionNode = class CommandConditionNode extends SingleConditionNode {
    type;
    result;
    variable;
    constructor(sandstoneCore2, type, command, result = "1..") {
      super(sandstoneCore2);
      this.type = type;
      this.result = result;
      const store = sandstoneCore2.pack.commands.execute.store[type];
      this.variable = sandstoneCore2.pack.Variable(undefined, "condition");
      const mcFunction = sandstoneCore2.getCurrentMCFunctionOrThrow();
      const before = mcFunction.body.length;
      command(store(this.variable));
      const after = mcFunction.body.length;
      this.preNodes = mcFunction.body.splice(before, after - before);
    }
    getCondition() {
      if (this.type === "success") {
        return ["score", this.variable, "matches", "1"];
      }
      if (typeof this.result === "function") {
        return this.result(this.variable)._toMinecraftCondition().getCondition();
      }
      return ["score", this.variable, "matches", rangeParser(this.sandstoneCore, this.result)];
    }
  };
LabelConditionNode = class LabelConditionNode extends SingleConditionNode {
    label;
    constructor(sandstoneCore2, label) {
      super(sandstoneCore2);
      this.label = label;
    }
    getCondition() {
      if (typeof this.label.originalSelector === "string") {
        return new CommandConditionNode(this.sandstoneCore, "result", (execute2) => execute2.as(this.label.originalSelector).if.entity(this.label)).getCondition();
      }
      return ["entity", `${this.label._toSelector()}`];
    }
  };
LoadedConditionNode = class LoadedConditionNode extends SingleConditionNode {
    pos;
    constructor(sandstoneCore2, pos) {
      super(sandstoneCore2);
      this.pos = pos;
    }
    getCondition() {
      return ["loaded", coordinatesParser(this.pos)];
    }
  };
ScoreConditionNode = class ScoreConditionNode extends SingleConditionNode {
    args;
    constructor(sandstoneCore2, args) {
      super(sandstoneCore2);
      this.args = args;
    }
    getCondition() {
      return ["score", ...this.args];
    }
  };
SelectorConditionNode = class SelectorConditionNode extends SingleConditionNode {
    selector;
    constructor(sandstoneCore2, selector) {
      super(sandstoneCore2);
      this.selector = selector;
    }
    getCondition() {
      return ["entity", this.selector];
    }
  };
UUIDConditionNode = class UUIDConditionNode extends SingleConditionNode {
    UUID;
    constructor(sandstoneCore2, UUID) {
      super(sandstoneCore2);
      this.UUID = UUID;
    }
    getCondition() {
      if (this.UUID.primarySource === "known") {
        return new CommandConditionNode(this.sandstoneCore, "result", (execute2) => execute2.as(this.UUID).if.entity("@s")).getCondition();
      }
      return ["entity", `${this.UUID._toSelector()}`];
    }
  };
ThrowNode = class ThrowNode extends Node {
    fullError;
    broadcast;
    dataPoint;
    constructor(sandstoneCore2, fullError, broadcast, dataPoint2) {
      super(sandstoneCore2);
      this.fullError = fullError;
      this.broadcast = broadcast;
      this.dataPoint = dataPoint2;
      const mcfunction2 = this.sandstoneCore.getCurrentMCFunctionOrThrow();
      mcfunction2.appendNode(this);
    }
    getValue() {
      return null;
    }
  };
FlowClauseNode = class FlowClauseNode extends ContainerNode {
    singleCommandFunction = null;
    singleCommandDepth = 0;
    addedToBody = false;
    enterSingleCommand = (parentMCFunction) => {
      if (this.singleCommandFunction) {
        return;
      }
      this.singleCommandFunction = parentMCFunction;
      this.singleCommandDepth = parentMCFunction.contextStack.length;
      parentMCFunction.enterContext(this, !this.addedToBody);
      this.addedToBody = true;
    };
    append = (...nodes2) => {
      this.body.push(...nodes2);
      const parentMCFunction = this.singleCommandFunction;
      if (parentMCFunction) {
        this.singleCommandFunction = null;
        while (parentMCFunction.contextStack.length > this.singleCommandDepth) {
          parentMCFunction.exitContext();
        }
      }
      return nodes2.length === 1 ? nodes2[0] : nodes2;
    };
  };
IfNode = class IfNode extends FlowClauseNode {
    condition;
    callback;
    nextFlowNode;
    _isElseIf = false;
    parentMCFunction;
    givenCallbackName;
    resultingExecuteNode;
    constructor(sandstoneCore2, condition2, callback, parentMCFunction) {
      super(sandstoneCore2);
      this.condition = condition2;
      this.callback = callback;
      this.parentMCFunction = parentMCFunction ?? sandstoneCore2.getCurrentMCFunctionOrThrow();
      if (callback && callback.toString() !== "() => {}") {
        const currentNode = this.parentMCFunction;
        const parentDepth = currentNode.contextStack.length;
        currentNode.enterContext(this);
        this.addedToBody = true;
        callback();
        while (currentNode.contextStack.length > parentDepth) {
          currentNode.exitContext();
        }
      }
    }
    getValue = () => {
      throw new Error("Minecraft does not support if statements. This must be postprocessed.");
    };
    [util10.inspect.custom](depth, options) {
      const indent = options.indent || "";
      const currentFormatting = formatDebugString(this.constructor.name, {
        condition: this.condition,
        isElseIf: this._isElseIf
      }, this.body, indent);
      if (!this.nextFlowNode) {
        return currentFormatting;
      }
      const nextFormatting = util10.inspect(this.nextFlowNode, options);
      return `${currentFormatting}
${indent}${nextFormatting}`;
    }
  };
ElseNode = class ElseNode extends FlowClauseNode {
    constructor(sandstoneCore2, callback) {
      super(sandstoneCore2);
      const currentNode = this.sandstoneCore.getCurrentMCFunctionOrThrow();
      const parentDepth = currentNode.contextStack.length;
      currentNode.enterContext(this);
      this.addedToBody = true;
      callback();
      while (currentNode.contextStack.length > parentDepth) {
        currentNode.exitContext();
      }
    }
    getValue = () => null;
  };
LoopNode = class LoopNode extends ContainerNode {
    condition;
    callback;
    loopback;
    parentMCFunction;
    constructor(sandstoneCore2, condition2, callback, loopback) {
      super(sandstoneCore2);
      this.condition = condition2;
      this.callback = callback;
      this.loopback = loopback;
      const currentNode = this.sandstoneCore.getCurrentMCFunctionOrThrow();
      this.parentMCFunction = currentNode;
      if (callback.toString() !== "() => {}") {
        currentNode.enterContext(this);
        const parentDepth = currentNode.contextStack.length - 1;
        this.callback();
        this.loopback();
        while (currentNode.contextStack.length > parentDepth) {
          currentNode.exitContext();
        }
      }
    }
    getValue = () => {
      throw new Error("Minecraft does not support loop statements. This must be postprocessed.");
    };
  };
ForINode = class ForINode extends LoopNode {
    constructor(sandstoneCore2, initialValue, endCondition, iterate, callback) {
      const iterator = sandstoneCore2.pack.Variable(initialValue, "loop_iterator");
      const condition2 = conditionToNode(endCondition(iterator));
      const _continue = () => sandstoneCore2.pack.commands.returnCmd.run(() => new IfStatement(sandstoneCore2, condition2, () => new LoopArgument(sandstoneCore2.pack)));
      super(sandstoneCore2, condition2, () => callback(iterator, _continue), () => {
        iterate(iterator);
        new IfStatement(sandstoneCore2, condition2, () => new LoopArgument(sandstoneCore2.pack));
      });
    }
  };
ForOfNode = class ForOfNode extends LoopNode {
    constructor(sandstoneCore2, iteratorType, direction, iterable, callback) {
      let iterate;
      if (isMultipleVariable(iteratorType)) {
        if (isMapIterator(iteratorType, iterable)) {
          iterate = iterable.iterator((dataPoints) => {
            callback(...[dataPoints[0], dataPoints[1]]);
          }, direction);
        } else {
          const _iterator = sandstoneCore2.pack.Variable(direction === "normal" ? -1 : undefined);
          if (direction === "reverse") {
            _iterator.set(iterable.size());
          }
          iterate = iterable.iterator((dataPoints) => {
            if (direction === "normal") {
              _iterator.increase();
            } else {
              _iterator.decrease();
            }
            if (dataPoints.length === 1) {
              return callback(...[_iterator, dataPoints[0]]);
            }
            return callback(...[_iterator, dataPoints[1]]);
          }, direction);
        }
      } else {
        iterate = iterable.iterator((dataPoints) => {
          if (dataPoints.length === 1) {
            return callback(...[dataPoints[0]]);
          }
          return callback(...[dataPoints[1]]);
        });
      }
      const continueCondition = iterable.continue(direction);
      super(sandstoneCore2, continueCondition, iterate, () => new IfStatement(sandstoneCore2, continueCondition, () => new LoopArgument(sandstoneCore2.pack)));
    }
  };
WhileNode = class WhileNode extends LoopNode {
    constructor(sandstoneCore2, condition2, callback) {
      const _condition = conditionToNode(condition2);
      super(sandstoneCore2, _condition, callback, () => new IfStatement(sandstoneCore2, _condition, () => new LoopArgument(sandstoneCore2.pack)));
    }
  };
WithClass = class WithClass extends ContainerCommandNode {
    command = "function";
    mcfunction;
    enclosingExecute = null;
    isSingleCommand = false;
    hostFunction;
    finalized = false;
    env;
    containingMCFunction = null;
    constructor(core, env, callback) {
      super(core.pack);
      const envArray = env instanceof Set ? Array.from(env) : env;
      this.env = new Set(envArray);
      core.withNodes.add(this);
      const currentFunction = core.getCurrentMCFunctionOrThrow();
      this.hostFunction = currentFunction;
      this.containingMCFunction = currentFunction;
      currentFunction.resource.nested += 1;
      const ctx = currentFunction.contextStack;
      const topCtx = ctx[ctx.length - 1];
      if (ctx.length > 1 && topCtx instanceof ExecuteCommandNode) {
        this.enclosingExecute = topCtx;
      }
      const baseName = `${currentFunction.resource.path.slice(2).join("/")}/${WITH_CHILD_NAME}`;
      this.mcfunction = core.pack.MCFunction(baseName, envArray, () => {}, {
        addToSandstoneCore: true,
        lazy: false,
        creator: "sandstone",
        onConflict: "rename",
        packType: currentFunction.resource.packType
      });
      if (callback) {
        currentFunction.enterContext(this);
        callback();
        currentFunction.exitContext();
        this.finalize();
      }
    }
    enterSingleCommand = () => {
      this.isSingleCommand = true;
      this.hostFunction.enterContext(this);
    };
    append = (...nodes2) => {
      for (const node of nodes2) {
        this.body.push(node);
        if (this.isSingleCommand && !this.finalized) {
          this.hostFunction.exitContext();
          this.finalize();
        }
      }
      return nodes2.length === 1 ? nodes2[0] : nodes2;
    };
    finalize = () => {
      if (this.finalized) {
        return;
      }
      this.finalized = true;
      this.mcfunction();
      const parentBody = this.hostFunction.currentContext.body;
      const myIndex = parentBody.indexOf(this);
      if (myIndex !== -1) {
        let fnCmdIdx = -1;
        for (let i = myIndex + 1;i < parentBody.length; i++) {
          if (parentBody[i] instanceof FunctionCommandNode) {
            this.args = [...parentBody[i].args];
            fnCmdIdx = i;
            break;
          }
        }
        if (fnCmdIdx !== -1) {
          parentBody.splice(fnCmdIdx, 1);
          parentBody.splice(myIndex, 1);
          parentBody.splice(fnCmdIdx - 1, 0, this);
        }
      }
    };
  };
SwitchNode = class SwitchNode extends ContainerNode {
    value;
    staticCases;
    conditionCases;
    defaultCase;
    parentMCFunction;
    constructor(sandstoneCore2, value, staticCases, conditionCases, defaultCase) {
      super(sandstoneCore2);
      this.value = value;
      this.staticCases = staticCases;
      this.conditionCases = conditionCases;
      this.defaultCase = defaultCase;
      this.parentMCFunction = sandstoneCore2.getCurrentMCFunctionOrThrow();
      const parentDepth = this.parentMCFunction.contextStack.length;
      this.parentMCFunction.enterContext(this);
      for (const caseNode of [...staticCases, ...conditionCases]) {
        this.parentMCFunction.enterContext(caseNode);
        const caseDepth = this.parentMCFunction.contextStack.length;
        caseNode.callback();
        while (this.parentMCFunction.contextStack.length > caseDepth) {
          this.parentMCFunction.exitContext();
        }
      }
      if (defaultCase) {
        this.parentMCFunction.enterContext(defaultCase);
        const caseDepth = this.parentMCFunction.contextStack.length;
        defaultCase.callback();
        while (this.parentMCFunction.contextStack.length > caseDepth) {
          this.parentMCFunction.exitContext();
        }
      }
      while (this.parentMCFunction.contextStack.length > parentDepth) {
        this.parentMCFunction.exitContext();
      }
    }
    getValue = () => {
      throw new Error("SwitchNode must be transformed by SwitchTransformationVisitor");
    };
  };
StaticCaseNode = class StaticCaseNode extends ContainerNode {
    value;
    callback;
    constructor(sandstoneCore2, value, callback) {
      super(sandstoneCore2);
      this.value = value;
      this.callback = callback;
    }
    getValue = () => null;
  };
ConditionCaseNode = class ConditionCaseNode extends ContainerNode {
    condition;
    callback;
    constructor(sandstoneCore2, condition2, callback) {
      super(sandstoneCore2);
      this.condition = condition2;
      this.callback = callback;
    }
    getValue = () => null;
  };
DefaultCaseNode = class DefaultCaseNode extends ContainerNode {
    callback;
    constructor(sandstoneCore2, callback) {
      super(sandstoneCore2);
      this.callback = callback;
    }
    getValue = () => null;
  };
class GenericCoreVisitor {
  core;
  methodCache;
  constructor(core) {
    this.core = core;
    this.methodCache = new Map;
  }
  getSingleNodeMethod = (nodeName) => {
    const methodName = `visit${nodeName}`;
    const that = this;
    const method = that[methodName];
    return method;
  };
  getNodeMethods = (prototype) => {
    const key = prototype.name;
    const cachedResult = this.methodCache.get(key);
    if (cachedResult) {
      return cachedResult;
    }
    const names = ancestors(prototype);
    for (const name of names) {
      const method = this.getSingleNodeMethod(name);
      if (method) {
        this.methodCache.set(key, method);
        return method;
      }
    }
    const result = (node_) => node_;
    this.methodCache.set(key, result);
    return result;
  };
  visit = (node) => this.getNodeMethods(node.constructor)(node);
  genericVisit = (node) => {
    if (node instanceof ContainerNode || node instanceof ContainerCommandNode) {
      node.body = node.body.flatMap((n) => this.visit(n));
    }
    return node;
  };
  onStart = () => {};
  onEnd = () => {};
  genericNodeVisitor = () => (node) => this.genericVisit(node);
  visitCommandNode = this.genericNodeVisitor();
  visitContainerCommandNode = this.genericNodeVisitor();
  visitContainerNode = this.genericNodeVisitor();
  visitNode;
  visitMCFunctionNode;
  visitAdvancementNode;
  visitItemModifierNode;
  visitLootTableNode;
  visitPredicateNode;
  visitRecipeNode;
  visitTagNode;
  visitTrimMaterialNode;
  visitTrimPatternNode;
}
GenericSandstoneVisitor = class GenericSandstoneVisitor extends GenericCoreVisitor {
    pack;
    constructor(pack) {
      super(pack.core);
      this.pack = pack;
    }
    visitIfNode;
    visitElseNode;
    visitLoopNode;
    visitSwitchNode;
    visitStaticCaseNode;
    visitConditionCaseNode;
    visitDefaultCaseNode;
    visitLoopArgumentNode;
    visitAdvancementCommandNode;
    visitAttributeCommandNode;
    visitCloneCommandNode;
    visitDataCommandNode;
    visitExecuteCommandNode;
    visitFunctionCommandNode;
    visitGameruleCommandNode;
    visitSayCommandNode;
  };
AwaitBodyVisitor = class AwaitBodyVisitor extends GenericSandstoneVisitor {
    onEnd = () => {
      const { core } = this.pack;
      for (const awaitNode of core.awaitNodes) {
        if (awaitNode instanceof UntilClass) {
          this.cleanupUntil(awaitNode);
          continue;
        }
        awaitNode.mcfunction.node.body.push(...awaitNode.body);
      }
    };
    cleanupUntil(until2) {
      const pollerNode = until2.poller.node;
      const continuationNode = until2.continuation.node;
      if (!pollerNode || !continuationNode)
        return;
      const parent = this.findAwaitParent(until2);
      if (!parent) {
        until2.mcfunction.node.body.push(...until2.body);
        return;
      }
      const awaitIdx = parent.body.indexOf(until2);
      const insertAt = awaitIdx === -1 ? parent.body.length : awaitIdx;
      const toDelete = this.collectTransientHelpers(pollerNode, until2);
      this.inlineTransientCalls(pollerNode, until2.body, continuationNode, toDelete);
      const sleepNode = this.findSiblingMCFunction(pollerNode, "__sleep");
      const contextNode = sleepNode ? this.findSiblingMCFunction(sleepNode, "_context") : undefined;
      if (sleepNode) {
        const tagRemove = sleepNode.body.find((n) => n?.constructor?.name === "TagCommandNode" && n.args?.[1] === "remove");
        if (tagRemove) {
          pollerNode.body.unshift(tagRemove);
        }
      }
      if (contextNode) {
        this.redirectContextSelector(contextNode, sleepNode, pollerNode);
      }
      parent.body.splice(insertAt, 1, ...pollerNode.body);
      for (const fn of toDelete) {
        this.pack.core.resourceNodes.delete(fn);
      }
      if (sleepNode)
        this.pack.core.resourceNodes.delete(sleepNode);
      this.pack.core.resourceNodes.delete(continuationNode);
    }
    redirectContextSelector(contextNode, sleepNode, pollerNode) {
      const oldSleepName = sleepNode?.resource.name;
      const newTargetName = pollerNode.resource.name;
      const visit = (node) => {
        if (!node)
          return;
        if (node.constructor?.name === "FunctionCommandNode") {
          const args = node.args;
          if (Array.isArray(args) && args.length >= 1) {
            const target = args[0];
            if (typeof target === "string" && (!oldSleepName || target === oldSleepName)) {
              args[0] = newTargetName;
            }
          }
        }
        if ("body" in node && Array.isArray(node.body)) {
          for (const child of node.body) {
            visit(child);
          }
        }
      };
      for (const child of contextNode.body) {
        visit(child);
      }
    }
    findSiblingMCFunction(anchor, leaf) {
      const basePath = anchor.resource.path;
      const targetPath = [...basePath, leaf];
      for (const fn of this.pack.core.resourceNodes) {
        if (!(fn instanceof MCFunctionNode))
          continue;
        if (fn.resource.path.length !== targetPath.length)
          continue;
        if (fn.resource.path.every((p, i) => p === targetPath[i]))
          return fn;
      }
      return;
    }
    inlineTransientCalls(root, replacement, continuation, helpers2) {
      const body = root.body;
      if (!Array.isArray(body))
        return;
      for (let i = 0;i < body.length; i++) {
        const child = body[i];
        if (!child)
          continue;
        const spliceNodes = this.tryInlineFunctionCall(child, replacement, continuation, helpers2);
        if (spliceNodes !== "no-change") {
          if (spliceNodes === "in-place") {
            this.inlineTransientCalls(child, replacement, continuation, helpers2);
            continue;
          }
          const newNodes = spliceNodes;
          body.splice(i, 1, ...newNodes);
          for (const nn of newNodes) {
            if (nn instanceof ContainerNode || nn instanceof ContainerCommandNode) {
              this.inlineTransientCalls(nn, replacement, continuation, helpers2);
            }
          }
          continue;
        }
        if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
          this.inlineTransientCalls(child, replacement, continuation, helpers2);
        }
      }
    }
    tryInlineFunctionCall(node, replacement, continuation, helpers2) {
      let wrapper;
      let inner = node;
      if (node instanceof ContainerCommandNode && node.command === "return" && node.body?.length === 1) {
        wrapper = node;
        inner = node.body[0];
      }
      if (!inner || inner.constructor?.name !== "FunctionCommandNode") {
        return "no-change";
      }
      const fnArg = inner.args?.[0];
      if (!fnArg)
        return "no-change";
      let argFn;
      let argFnName;
      if (typeof fnArg === "string") {
        argFnName = fnArg;
      } else {
        argFn = fnArg.node;
        if (!argFn)
          return "no-change";
        argFnName = argFn.resource.name;
      }
      const continuationName = continuation.resource.name;
      const isContinuation = argFnName === continuationName;
      const isKnownHelper = !!argFn && helpers2.includes(argFn);
      if (!isContinuation && !isKnownHelper)
        return "no-change";
      const replacementBody = isContinuation ? [...replacement] : [...argFn.body];
      if (wrapper) {
        wrapper.body = replacementBody;
        return "in-place";
      }
      return replacementBody;
    }
    findAwaitParent(awaitNode) {
      for (const fn of this.pack.core.resourceNodes) {
        if (!(fn instanceof MCFunctionNode))
          continue;
        if (fn === awaitNode.mcfunction)
          continue;
        if (this.containsNode(fn, awaitNode))
          return fn;
      }
      return;
    }
    containsNode(root, target) {
      if (root === target)
        return true;
      for (const child of root.body) {
        if (child === target)
          return true;
        if ((child instanceof ContainerCommandNode || child instanceof ContainerNode) && this.containsNode(child, target)) {
          return true;
        }
      }
      return false;
    }
    collectTransientHelpers(pollerNode, until2) {
      const pollerPath = pollerNode.resource.path.join("/");
      const helpers2 = [];
      for (const fn of this.pack.core.resourceNodes) {
        if (!(fn instanceof MCFunctionNode))
          continue;
        if (fn === pollerNode)
          continue;
        if (fn === until2.continuation.node)
          continue;
        if (fn.resource.creator !== "sandstone")
          continue;
        const fnPath = fn.resource.path.join("/");
        if (!fnPath.startsWith(pollerPath + "/"))
          continue;
        if (/\/__sleep(\b|\/)/.test("/" + fnPath.slice(pollerPath.length)))
          continue;
        helpers2.push(fn);
      }
      return helpers2;
    }
  };
ContainerCommandsToMCFunctionVisitor = class ContainerCommandsToMCFunctionVisitor extends GenericSandstoneVisitor {
    currentMCFunction = null;
    visitContainerCommandNode = (node_) => {
      const { node, mcFunction } = node_.createMCFunction(this.currentMCFunction);
      if (mcFunction) {
        for (const node2 of mcFunction.body) {
          if (node2 instanceof WithClass) {
            node2.containingMCFunction = mcFunction;
          }
        }
        const visitedMCFunction = this.visitMCFunctionNode(mcFunction);
        this.core.resourceNodes.add(visitedMCFunction);
      } else if (node instanceof ContainerCommandNode && node.body) {
        this.genericVisit(node);
      }
      return Array.isArray(node) ? node.flatMap((n) => this.visit(n)) : node;
    };
    visitMCFunctionNode = (node) => {
      const prev = this.currentMCFunction;
      this.currentMCFunction = node;
      this.core.currentNode = node.resource.name;
      const result = this.genericVisit(node);
      if (node.resource.creator === "sandstone" && node.body.length > 0) {
        const lastNode = node.body.at(-1);
        if (lastNode instanceof FunctionCommandNode) {
          const returnRunNode = new ReturnRunCommandNode(this.pack, false, ["run"], {
            isFunctionBoundary: true
          });
          returnRunNode.body = [lastNode];
          node.body[node.body.length - 1] = returnRunNode;
        }
      }
      this.core.currentNode = prev?.resource.name ?? "";
      this.currentMCFunction = prev;
      return result;
    };
  };
GenerateLazyMCFunction = class GenerateLazyMCFunction extends GenericSandstoneVisitor {
    generateLazyFunction(mcFunction) {
      if (!(mcFunction instanceof MCFunctionClass) || !mcFunction.lazy) {
        return;
      }
      const mcFunctionNode = mcFunction.node;
      mcFunction.generate();
      this.visit(mcFunctionNode);
    }
    visitFunctionCommandNode = (node) => {
      this.generateLazyFunction(node.args[0]);
      return node;
    };
    visitScheduleCommandNode = (node) => {
      this.generateLazyFunction(node.args[1]);
      return this.genericVisit(node);
    };
  };
IfElseTransformationVisitor = class IfElseTransformationVisitor extends GenericSandstoneVisitor {
    visitIfNode = (node_) => {
      if (node_._isElseIf) {
        return [];
      }
      const nodes2 = Array.from(flattenIfNode(node_));
      const { parentMCFunction, condition: condition2, givenCallbackName, body } = node_;
      const callbackName = givenCallbackName ?? "if";
      const macroStorage = parentMCFunction.resource.macroPoint;
      if (nodes2.length === 1) {
        const executeNode = new ExecuteCommandNode(this.pack, false, [[condition2.getValue()]], {
          isSingleExecute: false,
          givenCallbackName: callbackName,
          body,
          macroStorage
        });
        node_.resultingExecuteNode = executeNode;
        return this.visit(executeNode);
      }
      if (nodes2.at(-1) === parentMCFunction.body.at(-1)) {
        return handleMultipleNodes(this, nodes2, macroStorage);
      }
      const wrapper = new ExecuteCommandNode(this.pack, false, [], {
        isFake: true,
        isSingleExecute: false,
        givenCallbackName: callbackName,
        body: handleMultipleNodes(this, nodes2, macroStorage),
        macroStorage
      });
      node_.resultingExecuteNode = wrapper;
      return this.visit(wrapper);
    };
  };
InitConstantsVisitor = class InitConstantsVisitor extends GenericSandstoneVisitor {
    onStart = () => {
      const { pack } = this;
      if (pack.constants.size !== 0) {
        for (const constant of pack.constants) {
          pack.initMCFunction.node.body.push(new ScoreboardCommandNode(pack, "players", "set", constant, pack.rootObjective, constant));
        }
      }
    };
  };
InitObjectivesVisitor = class InitObjectivesVisitor extends GenericSandstoneVisitor {
    onStart = () => {
      const { pack } = this;
      const { commands: commands2 } = pack;
      const sandstoneRegisteredObjectives = new Set;
      const userRegisteredObjectives = new Set;
      const objectives = [...pack.objectives.values()];
      if (objectives.length !== 0) {
        pack.initMCFunction.unshift(() => {
          for (const obj of objectives) {
            if (userRegisteredObjectives.has(obj.name)) {
              throw new Error(`An objective named "${obj.name}" has been created twice.`);
            }
            if (obj.creator === "user") {
              userRegisteredObjectives.add(obj.name);
            } else {
              sandstoneRegisteredObjectives.add(obj.name);
            }
            commands2.scoreboard.objectives.add(obj.name, obj.criteria, obj.display?.jsonTextComponent);
          }
        });
      }
    };
  };
InlineFunctionCallVisitor = class InlineFunctionCallVisitor extends GenericSandstoneVisitor {
    deletedMCFunction = null;
    visitFunctionCommandNode = (node) => {
      const _mcFunction = node.args[0];
      if (!this.deletedMCFunction) {
        return node;
      }
      const [deleted, newOne] = this.deletedMCFunction;
      if (node.args[0] instanceof MCFunctionClass && node.args[0] === deleted) {
        node.args[0] = newOne;
      }
      return node;
    };
    visitMCFunctionNode = (functionNode) => {
      if (functionNode.body.length > 1) {
        return functionNode;
      }
      const node = functionNode.body[0];
      if (node instanceof FunctionCommandNode && node.args[0] instanceof MCFunctionClass && node.args[0].creator === "sandstone") {
        const sandstoneCreatedFunction = node.args[0];
        this.core.resourceNodes.delete(sandstoneCreatedFunction.node);
        this.deletedMCFunction = [sandstoneCreatedFunction, functionNode.resource];
        functionNode.body = sandstoneCreatedFunction.node.body;
      }
      this.genericVisit(functionNode);
      this.deletedMCFunction = null;
      return functionNode;
    };
  };
LoopTransformationVisitor = class LoopTransformationVisitor extends GenericSandstoneVisitor {
    currentLoopIfNode = null;
    visitLoopNode = (node_) => {
      const ifNode = new IfNode(this.core, node_.condition, undefined, node_.parentMCFunction);
      ifNode.givenCallbackName = "loop";
      const previousLoopIfNode = this.currentLoopIfNode;
      this.currentLoopIfNode = ifNode;
      ifNode.body = node_.body.flatMap((node) => this.visit(node));
      this.currentLoopIfNode = previousLoopIfNode;
      return ifNode;
    };
    visitLoopArgument = (node_) => {
      if (this.currentLoopIfNode) {
        node_.loopIfNode = this.currentLoopIfNode;
      }
      return node_;
    };
    visitWhileNode = this.visitLoopNode;
    visitForINode = this.visitLoopNode;
    visitForOfNode = this.visitLoopNode;
  };
FunctionReturnConditionNode = class FunctionReturnConditionNode extends ConditionNode {
    sandstoneCore;
    functionName;
    constructor(sandstoneCore2, functionName) {
      super(sandstoneCore2);
      this.sandstoneCore = sandstoneCore2;
      this.functionName = functionName;
    }
    getValue = () => `if function ${this.functionName}`;
  };
OrTransformationVisitor = class OrTransformationVisitor extends GenericSandstoneVisitor {
    visitIfNode = (node_) => {
      const { preNodes, conditionNode } = this.parseConditionNode(node_.condition, node_.parentMCFunction);
      node_.condition = conditionNode;
      return [...preNodes, this.genericVisit(node_)];
    };
    parseConditionNode = (node, parentMCFunction) => {
      if (node instanceof OrNode) {
        return this.parseOrNode(node, parentMCFunction);
      }
      if (node instanceof AndNode) {
        return this.parseAndNode(node, parentMCFunction);
      }
      if (node instanceof NotNode) {
        return this.parseNotNode(node, parentMCFunction);
      }
      return { preNodes: [...node.preNodes ?? []], conditionNode: node };
    };
    parseOrNode = (node, parentMCFunction) => {
      if (node.conditions.length === 1) {
        return this.parseConditionNode(node.conditions[0], parentMCFunction);
      }
      const parentName = parentMCFunction?.resource.name ?? "__sandstone";
      const orMCFunction = new MCFunctionClass(this.core, `${parentName}/or_check`, {
        addToSandstoneCore: true,
        creator: "sandstone",
        onConflict: "rename"
      });
      this.core.enterMCFunction(orMCFunction);
      try {
        for (const condition2 of node.conditions) {
          this.pushCheckBranch(orMCFunction.node, this.parseConditionNode(condition2, orMCFunction.node), false, new ReturnCommandNode(this.pack, [1]));
        }
        orMCFunction.node.body.push(new ReturnCommandNode(this.pack, [0]));
      } finally {
        this.core.exitMCFunction();
      }
      return {
        preNodes: [],
        conditionNode: new FunctionReturnConditionNode(this.core, orMCFunction.name)
      };
    };
    parseAndNode = (node, parentMCFunction) => {
      if (node.conditions.length === 1) {
        return this.parseConditionNode(node.conditions[0], parentMCFunction);
      }
      const parsed = node.conditions.map((condition2) => this.parseConditionNode(condition2, parentMCFunction));
      const anyHasCommands = parsed.some((p) => (p.preNodes ?? []).length > 0);
      if (!anyHasCommands) {
        const finalPreNodes = [];
        const conditionNode = new AndNode(node.sandstoneCore, parsed.map((p) => {
          finalPreNodes.push(...p.preNodes);
          return p.conditionNode;
        }));
        return { preNodes: finalPreNodes, conditionNode };
      }
      const parentName = parentMCFunction?.resource.name ?? "__sandstone";
      const andMCFunction = new MCFunctionClass(this.core, `${parentName}/and_check`, {
        addToSandstoneCore: true,
        creator: "sandstone",
        onConflict: "rename"
      });
      this.core.enterMCFunction(andMCFunction);
      try {
        let batch = { preNodes: [], conditionNodes: [] };
        const flushBatch = () => {
          if (batch.conditionNodes.length === 0 && batch.preNodes.every((pn) => pn.length === 0)) {
            batch = { preNodes: [], conditionNodes: [] };
            return;
          }
          const tracker = this.core.pack.Variable(undefined, "and_batch");
          this.pushBatchedCheckBranch(andMCFunction.node, batch.preNodes.flat(), batch.conditionNodes, tracker);
          batch = { preNodes: [], conditionNodes: [] };
        };
        for (const p of parsed) {
          if (p.preNodes.length === 0) {
            batch.preNodes.push(p.preNodes);
            batch.conditionNodes.push(p.conditionNode);
          } else {
            flushBatch();
            this.pushFailFastBranch(andMCFunction.node, p, new ReturnCommandNode(this.pack, [0]));
          }
        }
        flushBatch();
        andMCFunction.node.body.push(new ReturnCommandNode(this.pack, [1]));
      } finally {
        this.core.exitMCFunction();
      }
      return {
        preNodes: [],
        conditionNode: new FunctionReturnConditionNode(this.core, andMCFunction.name)
      };
    };
    pushBatchedCheckBranch = (targetMCFunction, preNodes, conditionNodes, tracker) => {
      for (const n of preNodes) {
        targetMCFunction.body.push(n);
      }
      targetMCFunction.body.push(new ScoreboardCommandNode(this.pack, "players", "reset", tracker));
      const args = [];
      for (const c of conditionNodes) {
        const condStr = c.getValue(false);
        const match = condStr.match(/^(if|unless)\s+([\s\S]+)$/);
        if (!match) {
          throw new Error(`OrTransformationVisitor: unexpected condition getValue() shape: ${condStr}`);
        }
        const [, keyword, condBody] = match;
        args.push([keyword, condBody]);
      }
      if (args.length === 0) {
        targetMCFunction.body.push(new ScoreboardCommandNode(this.pack, "players", "set", tracker, 1));
      } else {
        const executeNode = new ExecuteCommandNode(this.pack, false, args, {
          isSingleExecute: true,
          body: []
        });
        targetMCFunction.enterContext(executeNode, false);
        executeNode.body = [new ScoreboardCommandNode(this.pack, "players", "set", tracker, 1)];
        targetMCFunction.body.push(executeNode);
        targetMCFunction.exitContext();
      }
      const failCheckNode = new ExecuteCommandNode(this.pack, false, [["unless", `score ${tracker} matches 1`]], {
        isSingleExecute: true,
        body: []
      });
      targetMCFunction.enterContext(failCheckNode, false);
      failCheckNode.body = [new ReturnCommandNode(this.pack, [0])];
      targetMCFunction.body.push(failCheckNode);
      targetMCFunction.exitContext();
    };
    pushCheckBranch = (targetMCFunction, parsed, negated, bodyNode) => {
      for (const n of parsed.preNodes) {
        targetMCFunction.body.push(n);
      }
      const condStr = parsed.conditionNode.getValue(negated);
      const match = condStr.match(/^(if|unless)\s+([\s\S]+)$/);
      if (!match) {
        throw new Error(`OrTransformationVisitor: unexpected condition getValue() shape: ${condStr}`);
      }
      const [, keyword, condBody] = match;
      const executeNode = new ExecuteCommandNode(this.pack, false, [[keyword, condBody]], {
        isSingleExecute: true,
        body: []
      });
      targetMCFunction.enterContext(executeNode, false);
      executeNode.body = [bodyNode];
      targetMCFunction.body.push(executeNode);
      targetMCFunction.exitContext();
    };
    pushFailFastBranch = (targetMCFunction, parsed, bodyNode) => {
      for (const n of parsed.preNodes) {
        targetMCFunction.body.push(n);
      }
      const condStr = parsed.conditionNode.getValue(true);
      const match = condStr.match(/^(if|unless)\s+([\s\S]+)$/);
      if (!match) {
        throw new Error(`OrTransformationVisitor: unexpected condition getValue() shape: ${condStr}`);
      }
      const flippedKeyword = match[1] === "if" ? "unless" : "if";
      const condBody = match[2];
      const executeNode = new ExecuteCommandNode(this.pack, false, [[flippedKeyword, condBody]], {
        isSingleExecute: true,
        body: []
      });
      targetMCFunction.enterContext(executeNode, false);
      executeNode.body = [bodyNode];
      targetMCFunction.body.push(executeNode);
      targetMCFunction.exitContext();
    };
    parseNotNode = (node, parentMCFunction) => {
      const { preNodes, conditionNode } = this.parseConditionNode(node.condition, parentMCFunction);
      return {
        preNodes,
        conditionNode: new NotNode(node.sandstoneCore, conditionNode)
      };
    };
  };
OptimizeMacroTemporariesVisitor = class OptimizeMacroTemporariesVisitor extends GenericSandstoneVisitor {
    visitMCFunctionNode = (functionNode) => {
      this.genericVisit(functionNode);
      for (let callIndex = 0;callIndex < functionNode.body.length; callIndex++) {
        const call = functionNode.body[callIndex];
        if (!(call instanceof FunctionCommandNode))
          continue;
        const callArgs = call.args;
        if (callArgs[1] !== "with" || callArgs[2] !== "storage" || typeof callArgs[3] !== "string" || typeof callArgs[4] !== "string") {
          continue;
        }
        const macroPoint = { target: callArgs[3], path: callArgs[4] };
        const prep = callIndex > 0 ? functionNode.body[callIndex - 1] : undefined;
        if (!(prep instanceof ResolveNBTNode))
          continue;
        const copies = [];
        let setupStart = prep._body.length;
        while (setupStart > 0) {
          const copy = getMacroCopy(prep._body[setupStart - 1], macroPoint);
          if (!copy)
            break;
          copies.unshift(copy);
          setupStart--;
        }
        const resetIndex = setupStart > 0 && isMacroReset(prep._body[setupStart - 1], macroPoint) ? setupStart - 1 : -1;
        if (copies.length === 0)
          continue;
        const producers = [];
        let canOptimize = true;
        for (const copy of copies) {
          const matches = [];
          for (const [index, node] of functionNode.body.slice(0, callIndex - 1).entries()) {
            const store = getExecuteStore(node, copy.source);
            if (store) {
              matches.push({ index, store });
            }
          }
          if (matches.length !== 1 || referencesStoragePoint(functionNode, copy.source) !== 2) {
            canOptimize = false;
            break;
          }
          producers.push({ ...matches[0], destination: copy.destination });
        }
        if (!canOptimize)
          continue;
        const producerIndexes = new Set(producers.map((producer) => producer.index));
        if (producerIndexes.size !== producers.length)
          continue;
        for (const producer of producers) {
          producer.store[1] = producer.destination.target;
          producer.store[2] = producer.destination.path;
        }
        const spliceStart = resetIndex === -1 ? 0 : resetIndex;
        const spliceCount = resetIndex === -1 ? copies.length : copies.length + 1;
        prep._body.splice(spliceStart, spliceCount);
        if (prep._body.length === 0) {
          functionNode.body.splice(callIndex - 1, 1);
          callIndex -= 1;
        }
      }
      return functionNode;
    };
  };
SimplifyExecuteFunctionVisitor = class SimplifyExecuteFunctionVisitor extends GenericSandstoneVisitor {
    depth = 0;
    debugging = DEBUG_SIMPLIFY_EXEC();
    debug = (msg) => {
      if (!this.debugging)
        return;
      console.log(`[SimplifyExec:${"  ".repeat(this.depth)}${msg}`);
    };
    debugEnter = (node) => {
      if (!this.debugging)
        return;
      this.depth++;
      const args = node.args.map((a) => typeof a === "string" ? JSON.stringify(a) : "...");
      this.debug(`> enter callbackName=${node.givenCallbackName ?? "-"} args=[${args.join(",")}] bodyLen=${node.body.length}`);
    };
    debugExit = (msg) => {
      if (!this.debugging)
        return;
      this.debug(`< exit (${msg})`);
      this.depth--;
    };
    visitExecuteCommandNode = (node) => {
      this.debugEnter(node);
      if (node.givenCallbackName === "loop") {
        this.debugExit("loop callback, skipped");
        return this.genericVisit(node);
      }
      if (node.body.length === 0 || node.body.length > 1) {
        this.debugExit(`body.length=${node.body.length}, no inline`);
        return this.genericVisit(node);
      }
      const functionNode = node.body[0];
      if (!(functionNode instanceof FunctionCommandNode)) {
        this.debugExit("body[0] not FunctionCommandNode");
        return this.genericVisit(node);
      }
      const mcFunction = functionNode.args[0];
      if (typeof mcFunction === "string" || !mcFunction?.node) {
        this.debugExit("mcFunction not an instance");
        return this.genericVisit(node);
      }
      const mcFunctionNode = mcFunction.node;
      let command = getEffectiveSingleCommand(mcFunctionNode.body);
      if (!command) {
        if (mcFunctionNode.body.length === 1) {
          command = mcFunctionNode.body[0];
        } else {
          this.debugExit(`no effective single command in ${mcFunctionNode.resource?.name}`);
          return this.genericVisit(node);
        }
      }
      this.debug(`  effective command class=${command?.constructor?.name}`);
      if (command instanceof LoopArgument) {
        const loopExecute = command.loopIfNode?.resultingExecuteNode;
        const loopFunctionName = loopExecute?.createdMCFunction?.name;
        if (loopFunctionName) {
          node.body = [new FunctionCommandNode(this.pack, loopFunctionName)];
          if (mcFunction.creator === "sandstone") {
            this.core.resourceNodes.delete(mcFunctionNode);
          }
          this.debugExit(`loopArg -> call ${loopFunctionName}`);
          return this.genericVisit(node);
        }
        this.debugExit("loopArg without reference");
        return this.genericVisit(node);
      }
      if (!(command instanceof CommandNode)) {
        this.debugExit("effective command not a CommandNode");
        return this.genericVisit(node);
      }
      if (command instanceof ReturnRunCommandNode) {
        if (mcFunction.creator === "sandstone") {
          this.core.resourceNodes.delete(mcFunctionNode);
        }
        if (command.isFlowControl || !command.isFunctionBoundary) {
          node.body = [this.genericVisit(command)];
        } else {
          const returnCmd = this.visit(command);
          node.body = returnCmd.body;
          this.debugExit("returnRun auto-boundary, re-run");
          return this.visitExecuteCommandNode(node);
        }
        this.debugExit("returnRun preserved");
        return this.genericVisit(node);
      }
      if (command instanceof FunctionCommandNode) {
        const innerMCFunction = command.args[0];
        if (typeof innerMCFunction === "string") {
          this.debugExit("inner function call is string macro, skip");
          return this.genericVisit(node);
        }
        node.body = [command];
        if (mcFunction.creator === "sandstone") {
          this.core.resourceNodes.delete(mcFunctionNode);
        }
        this.debug(`  collapsed ${mcFunctionNode.resource?.name} -> inner function call`);
        const result = this.visitExecuteCommandNode(node);
        this.debugExit("FunctionCommandNode branch (collapsed F1)");
        return result;
      }
      if (command instanceof ExecuteCommandNode) {
        if (node.isFake || functionNode.args.length > 1 || command.givenCallbackName === "loop" || mcFunction.creator !== "sandstone") {
          this.debugExit("ExecuteCommandNode guard tripped");
          return this.genericVisit(node);
        }
        const innerArgs = command.args.map((a) => typeof a === "string" ? JSON.stringify(a) : "...");
        node.args.push(...command.args);
        node.body = command.body;
        node.isMacro = node.isMacro || command.isMacro;
        this.core.resourceNodes.delete(mcFunctionNode);
        node.createdMCFunction = null;
        this.debug(`  merged inner execute (args=[${innerArgs.join(",")}])`);
        const result = this.visitExecuteCommandNode(node);
        this.debugExit("ExecuteCommandNode merge (deleted F1)");
        return result;
      }
      node.body = [this.genericVisit(command)];
      if (mcFunction.creator === "sandstone") {
        this.core.resourceNodes.delete(mcFunctionNode);
      }
      this.debugExit(`inlined single command, deleted ${mcFunctionNode.resource?.name}`);
      return this.genericVisit(node);
    };
  };
SimplifyReturnRunFunctionVisitor = class SimplifyReturnRunFunctionVisitor extends GenericSandstoneVisitor {
    visitReturnRunCommandNode = (node) => {
      if (node.body.length === 0 || node.body.length > 1) {
        return this.genericVisit(node);
      }
      const childNode = node.body[0];
      if (!(childNode instanceof FunctionCommandNode)) {
        if (childNode instanceof ReturnRunCommandNode) {
          return this.visitReturnRunCommandNode(childNode);
        }
        if (childNode instanceof ReturnCommandNode) {
          return this.genericVisit(childNode);
        }
        return this.genericVisit(node);
      }
      const mcFunction = childNode.args[0];
      if (typeof mcFunction === "string" || isMacroArgument(this.core, mcFunction)) {
        return this.genericVisit(node);
      }
      const mcFunctionNode = mcFunction.node;
      let command = getEffectiveSingleCommand2(mcFunctionNode.body);
      if (!command) {
        if (mcFunctionNode.body.length === 1) {
          command = mcFunctionNode.body[0];
        } else {
          return this.genericVisit(node);
        }
      }
      if (!(command instanceof CommandNode)) {
        return this.genericVisit(node);
      }
      if (command instanceof FunctionCommandNode) {
        node.body = [command];
        if (mcFunction.creator === "sandstone") {
          this.core.resourceNodes.delete(mcFunctionNode);
        }
        return this.genericVisit(node);
      }
      if (command instanceof ReturnRunCommandNode) {
        node.body = command.body;
        node.isFlowControl = node.isFlowControl || command.isFlowControl;
        node.isFunctionBoundary = node.isFunctionBoundary || command.isFunctionBoundary;
        if (mcFunction.creator === "sandstone") {
          this.core.resourceNodes.delete(mcFunctionNode);
        }
        return this.visitReturnRunCommandNode(node);
      }
      if (command instanceof ReturnCommandNode) {
        if (mcFunction.creator === "sandstone") {
          this.core.resourceNodes.delete(mcFunctionNode);
        }
        return this.genericVisit(command);
      }
      node.body = [this.genericVisit(command)];
      if (mcFunction.creator === "sandstone") {
        this.core.resourceNodes.delete(mcFunctionNode);
      }
      return this.genericVisit(node);
    };
  };
SwitchTransformationVisitor = class SwitchTransformationVisitor extends GenericSandstoneVisitor {
    visitSwitchNode = (node) => {
      const { value, staticCases, conditionCases, defaultCase, parentMCFunction } = node;
      const { Data, initMCFunction, Macro: Macro2, commands: commands2 } = this.pack;
      const { functionCmd } = commands2;
      const parentName = parentMCFunction?.resource.name ?? "__sandstone:switch";
      const hasStaticCases = staticCases.length > 0;
      const switchMCFunction = new MCFunctionClass(this.core, `${parentName}/switch`, {
        addToSandstoneCore: true,
        creator: "sandstone",
        onConflict: "rename"
      }, hasStaticCases ? [value] : undefined);
      const storageKey = `__sandstone:${switchMCFunction.name.replace(/[:/]/g, "_")}`;
      const values = Data("storage", storageKey, "Values");
      if (hasStaticCases) {
        const isScoreSwitch = value instanceof Score;
        if (typeof value.local?.set === "function") {
          value.local.set(switchMCFunction.name, "env_0");
        }
        this.core.enterMCFunction(switchMCFunction);
        if (isScoreSwitch) {
          for (const caseNode of staticCases) {
            const caseMCFunction = new MCFunctionClass(this.core, `${switchMCFunction.name}/case_${caseNode.value}`, {
              addToSandstoneCore: true,
              creator: "sandstone",
              onConflict: "rename"
            });
            caseMCFunction.node.body = caseNode.body.flatMap((n) => this.visit(n));
          }
          const hasFallback = conditionCases.length > 0 || defaultCase !== undefined;
          if (hasFallback) {
            const tryCaseMCFunction = new MCFunctionClass(this.core, `${switchMCFunction.name}/try_case`, {
              addToSandstoneCore: true,
              creator: "sandstone",
              onConflict: "rename"
            });
            this.core.enterMCFunction(tryCaseMCFunction);
            Macro2.returnCmd.run.functionCmd(Macro2`${switchMCFunction.name}/case_${value}`);
            this.core.exitMCFunction();
            const successScore = this.pack.rootObjective("$switch_success");
            const resultScore = this.pack.rootObjective("$switch_result");
            commands2.execute.store.success(successScore).store.result(resultScore).run.functionCmd(tryCaseMCFunction.name, "with", switchMCFunction.macroPoint);
            commands2.execute.if.score(successScore, "matches", 1).run.returnCmd.run.scoreboard.players.get(resultScore);
            this.buildFallback(undefined, value, conditionCases, defaultCase, switchMCFunction);
          } else {
            const dispatchMCFunction = new MCFunctionClass(this.core, `${switchMCFunction.name}/dispatch`, {
              addToSandstoneCore: true,
              creator: "sandstone",
              onConflict: "rename"
            });
            this.core.enterMCFunction(dispatchMCFunction);
            Macro2.returnCmd.run.functionCmd(Macro2`${switchMCFunction.name}/case_${value}`);
            this.core.exitMCFunction();
            commands2.returnCmd.run.functionCmd(dispatchMCFunction.name, "with", switchMCFunction.macroPoint);
          }
          const macroPoint = switchMCFunction.macroPoint;
          const env0Point = macroPoint.select("env_0");
          commands2.execute.store.result.storage(env0Point.currentTarget, env0Point.path, "int").run.scoreboard.players.get(value);
          const copyNode = switchMCFunction.node.body.pop();
          switchMCFunction.node.body.unshift(copyNode);
          const canInline = parentMCFunction && node === parentMCFunction.body.at(-1);
          if (canInline) {
            this.core.exitMCFunction();
            this.core.resourceNodes.delete(switchMCFunction.node);
            return switchMCFunction.node.body;
          }
        } else {
          const index = switchMCFunction.macroPoint.select("Index");
          index.local.set(switchMCFunction.name, "Index");
          index.remove();
          Macro2.data.modify.storage(index.currentTarget, index.path).set.from.storage(values.currentTarget, Macro2`Values[{Value:${value}}].Index`);
          const caseData = [];
          for (let i = 0;i < staticCases.length; i++) {
            const caseNode = staticCases[i];
            const caseMCFunction = new MCFunctionClass(this.core, `${switchMCFunction.name}/case_${i}`, {
              addToSandstoneCore: true,
              creator: "sandstone",
              onConflict: "rename"
            });
            caseMCFunction.node.body = caseNode.body.flatMap((n) => this.visit(n));
            caseData.push({
              Value: caseNode.value,
              Index: NBT.int(i)
            });
          }
          initMCFunction.push(() => values.set(caseData));
          const innerMCFunction = new MCFunctionClass(this.core, `${switchMCFunction.name}/inner`, {
            addToSandstoneCore: true,
            creator: "sandstone",
            onConflict: "rename"
          });
          this.core.enterMCFunction(innerMCFunction);
          Macro2.returnCmd.run.functionCmd(Macro2`${switchMCFunction.name}/case_${index}`);
          this.core.exitMCFunction();
          const hasFallback = conditionCases.length > 0 || defaultCase !== undefined;
          if (hasFallback) {
            const ifNode = new IfNode(this.core, index._toMinecraftCondition(), undefined, switchMCFunction.node);
            switchMCFunction.node.enterContext(ifNode, false);
            functionCmd(innerMCFunction.name, "with", switchMCFunction.macroPoint);
            switchMCFunction.node.exitContext();
            switchMCFunction.node.body.push(ifNode);
            this.buildFallback(ifNode, value, conditionCases, defaultCase, switchMCFunction);
          } else {
            this.pack.commands.execute.if.data.storage(index.currentTarget, index.path).run.returnCmd.run.functionCmd(innerMCFunction.name, "with", switchMCFunction.macroPoint);
          }
        }
        this.core.exitMCFunction();
      } else {
        this.core.enterMCFunction(switchMCFunction);
        this.buildFallback(undefined, value, conditionCases, defaultCase, switchMCFunction);
        this.core.exitMCFunction();
        const canInline = parentMCFunction && node === parentMCFunction.body.at(-1);
        if (canInline) {
          this.core.resourceNodes.delete(switchMCFunction.node);
          for (const bodyNode of switchMCFunction.node.body) {
            if (bodyNode instanceof IfNode) {
              bodyNode.parentMCFunction = parentMCFunction;
              let lastIfNode = bodyNode;
              while (lastIfNode.nextFlowNode instanceof IfNode) {
                lastIfNode.nextFlowNode.parentMCFunction = parentMCFunction;
                lastIfNode = lastIfNode.nextFlowNode;
              }
              if (lastIfNode !== bodyNode) {
                switchMCFunction.node.body.push(lastIfNode);
              }
            }
          }
          return switchMCFunction.node.body;
        }
      }
      const isLastNode = parentMCFunction && node === parentMCFunction.body.at(-1);
      if (hasStaticCases && !(value instanceof Score)) {
        const macroPoint = switchMCFunction.macroPoint;
        const resolvedValue = value instanceof DataPointPickClass ? value._toDataPoint() : value;
        const env0Point = macroPoint.select("env_0");
        const copyNode = new DataCommandNode(this.pack);
        copyNode.args = [
          "modify",
          "storage",
          env0Point.currentTarget,
          env0Point.path,
          "set",
          "from",
          resolvedValue.type,
          resolvedValue.currentTarget,
          resolvedValue.path
        ];
        const funcNode2 = new FunctionCommandNode(this.pack, switchMCFunction.name);
        funcNode2.args.push("with", macroPoint.type, macroPoint.currentTarget, macroPoint.path);
        if (isLastNode) {
          const callNode = new ReturnRunCommandNode(this.pack, false, ["run"]);
          callNode.body = [funcNode2];
          return [copyNode, callNode].flatMap((n) => this.visit(n));
        }
        return [copyNode, funcNode2].flatMap((n) => this.visit(n));
      }
      const funcNode = new FunctionCommandNode(this.pack, switchMCFunction.name);
      if (isLastNode) {
        const callNode = new ReturnRunCommandNode(this.pack, false, ["run"]);
        callNode.body = [funcNode];
        return this.visit(callNode);
      }
      return this.visit(funcNode);
    };
    buildFallback(_if, value, conditionCases, defaultCase, switchMCFunction, targetBody) {
      if (conditionCases.length === 0 && !defaultCase)
        return;
      const body = targetBody ?? switchMCFunction.node.body;
      if (conditionCases.length > 0) {
        const firstCondition = conditionCases[0].condition(value);
        const firstConditionNode = conditionToNode(firstCondition);
        let currentIfNode;
        if (_if === undefined) {
          currentIfNode = new IfNode(this.core, firstConditionNode, undefined, switchMCFunction.node);
          currentIfNode.body = conditionCases[0].body.flatMap((n) => this.visit(n));
          body.push(currentIfNode);
        } else {
          currentIfNode = new IfNode(this.core, firstConditionNode, undefined, switchMCFunction.node);
          currentIfNode._isElseIf = true;
          _if.nextFlowNode = currentIfNode;
          currentIfNode.body = conditionCases[0].body.flatMap((n) => this.visit(n));
        }
        for (let i = 1;i < conditionCases.length; i++) {
          const condition2 = conditionCases[i].condition(value);
          const conditionNode = conditionToNode(condition2);
          const nextIfNode = new IfNode(this.core, conditionNode, undefined, switchMCFunction.node);
          nextIfNode._isElseIf = true;
          currentIfNode.nextFlowNode = nextIfNode;
          nextIfNode.body = conditionCases[i].body.flatMap((n) => this.visit(n));
          currentIfNode = nextIfNode;
        }
        if (defaultCase) {
          const elseNode = new ElseNode(this.core, () => {});
          elseNode._body = defaultCase.body.flatMap((n) => this.visit(n));
          currentIfNode.nextFlowNode = elseNode;
        }
      } else if (defaultCase) {
        if (_if === undefined) {
          const visitedNodes = defaultCase.body.flatMap((n) => this.visit(n));
          body.push(...visitedNodes);
        } else {
          const elseNode = new ElseNode(this.core, () => {});
          elseNode._body = defaultCase.body.flatMap((n) => this.visit(n));
          _if.nextFlowNode = elseNode;
        }
      }
    }
    visitStaticCaseNode = (_node) => {
      return [];
    };
    visitConditionCaseNode = (_node) => {
      return [];
    };
    visitDefaultCaseNode = (_node) => {
      return [];
    };
  };
ThrowInlineVisitor = class ThrowInlineVisitor extends GenericSandstoneVisitor {
    throwFunctions = new Set;
    throwScoreName = new WeakMap;
    throwIdCounter = 0;
    visitMCFunctionNode = (node) => {
      this.materializeThrowsIn(node);
      return this.genericVisit(node);
    };
    materializeThrowsIn(node) {
      const stack = [node];
      let foundThrow = false;
      while (stack.length) {
        const current = stack.pop();
        for (let i = 0;i < current.body.length; i++) {
          const child = current.body[i];
          if (child instanceof ThrowNode) {
            const replacement = this.materializeThrow(child);
            current.body.splice(i, 1, ...replacement);
            i += replacement.length - 1;
            foundThrow = true;
            continue;
          }
          if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
            stack.push(child);
          }
        }
      }
      if (foundThrow) {
        this.throwFunctions.add(node.resource.name);
      }
    }
    materializeThrow(throwNode) {
      const out = [];
      if (throwNode.broadcast !== false) {
        out.push(this.makeTellRaw(throwNode));
      }
      if (throwNode.dataPoint !== false) {
        out.push(this.makeDataSet(throwNode));
      }
      const scoreName = this.allocateScoreName();
      this.throwScoreName.set(throwNode, scoreName);
      out.push(this.makeThrowFlag(scoreName));
      out.push(this.makeReturn(1));
      return out;
    }
    makeTellRaw(throwNode) {
      const targets = throwNode.broadcast ?? "@a";
      const message = parseJSONText(this.core, throwNode.fullError);
      const node = new TellRawCommandNode(this.pack, targets, message);
      node.commited = false;
      return node;
    }
    makeDataSet(throwNode) {
      const point = throwNode.dataPoint;
      const target = point.currentTarget;
      const path4 = point.path;
      const serializable = parseJSONText(this.core, throwNode.fullError);
      const nbtString = serializable.toString();
      const node = new DataCommandNode(this.pack, "modify", "storage", target, path4, "set", "value", nbtString);
      node.commited = false;
      return node;
    }
    makeThrowFlag(scoreHolderName) {
      const node = new ScoreboardCommandNode(this.pack, "players", "set", `#${scoreHolderName}`, "__sandstone", 1);
      node.commited = false;
      return node;
    }
    makeReturn(value) {
      const node = new ReturnCommandNode(this.pack);
      node.args = [value];
      node.commited = false;
      return node;
    }
    allocateScoreName() {
      return `throw_${this.throwIdCounter++}`;
    }
  };
ThrowPropagationVisitor = class ThrowPropagationVisitor extends GenericSandstoneVisitor {
    throwFunctions = new Set;
    fallibleFunctions = new Set;
    reachableScores = new Map;
    usedScores = new Set;
    resetSites = new Set;
    roots = new Set;
    resetsEmitted = new Map;
    visitMCFunctionNode = (node) => {
      return this.genericVisit(node);
    };
    onEnd = () => {
      this.collectThrowScoresFromAST();
      this.computeReachableScores();
      this.computeRoots();
      this.pruneUnusedThrowScores();
      let changed = true;
      while (changed) {
        changed = false;
        const beforeFallible = this.fallibleFunctions.size;
        const beforeBody = new Map;
        for (const fn of this.pack.core.resourceNodes) {
          if (fn instanceof MCFunctionNode)
            beforeBody.set(fn.resource.name, fn.body.length);
        }
        for (const fn of this.pack.core.resourceNodes) {
          if (!(fn instanceof MCFunctionNode))
            continue;
          this.applyPatternA(fn);
          this.propagate(fn);
        }
        const grew = this.fallibleFunctions.size > beforeFallible || [...this.pack.core.resourceNodes].some((fn) => fn instanceof MCFunctionNode && fn.body.length > (beforeBody.get(fn.resource.name) ?? 0));
        if (grew)
          changed = true;
      }
    };
    collectThrowScoresFromAST() {
      for (const fn of this.pack.core.resourceNodes) {
        if (!(fn instanceof MCFunctionNode))
          continue;
        const scoreNames = new Set;
        const visit = (container) => {
          for (const child of container.body) {
            const cmd = child;
            if (cmd?.constructor?.name === "ScoreboardCommandNode" && Array.isArray(cmd.args)) {
              const args = cmd.args;
              if (args[0] === "players" && args[1] === "set" && typeof args[2] === "string" && args[2].startsWith("#throw_") && args[3] === "__sandstone" && args[4] === 1) {
                scoreNames.add(args[2].slice(1));
              }
            }
            if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
              visit(child);
            }
          }
        };
        visit(fn);
        if (scoreNames.size > 0) {
          this.throwFunctions.add(fn.resource.name);
          this.reachableScores.set(fn.resource.name, [...scoreNames]);
        }
      }
    }
    pruneUnusedThrowScores() {
      for (const fn of this.pack.core.resourceNodes) {
        if (!(fn instanceof MCFunctionNode))
          continue;
        if (!this.throwFunctions.has(fn.resource.name))
          continue;
        this.stripUnusedScores(fn, this.usedScores);
      }
    }
    stripUnusedScores(node, usedScores) {
      const visit = (container) => {
        for (let i = 0;i < container.body.length; i++) {
          const child = container.body[i];
          const cmd = child;
          if (cmd?.constructor?.name === "ScoreboardCommandNode" && Array.isArray(cmd.args)) {
            const args = cmd.args;
            if (args[0] === "players" && args[1] === "set" && typeof args[2] === "string" && args[2].startsWith("#throw_") && args[3] === "__sandstone" && args[4] === 1 && !usedScores.has(args[2].slice(1))) {
              container.body.splice(i, 1);
              i -= 1;
              continue;
            }
          }
          if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
            visit(child);
          }
        }
      };
      visit(node);
    }
    computeReachableScores() {
      let changed = true;
      while (changed) {
        changed = false;
        for (const fn of this.pack.core.resourceNodes) {
          if (!(fn instanceof MCFunctionNode))
            continue;
          const direct = this.collectDirectScores(fn);
          const current = new Set(this.reachableScores.get(fn.resource.name) ?? []);
          for (const s of direct) {
            if (!current.has(s)) {
              current.add(s);
              changed = true;
            }
          }
          this.reachableScores.set(fn.resource.name, [...current]);
        }
      }
    }
    collectDirectScores(node) {
      const out = new Set;
      const visit = (container) => {
        for (const child of container.body) {
          if (child instanceof ExecuteCommandNode && child.body.length === 1) {
            const inner = child.body[0];
            if (inner instanceof FunctionCommandNode) {
              const target = this.resolveFunctionName(inner);
              if (target) {
                const scores = this.reachableScores.get(target);
                if (scores)
                  for (const s of scores)
                    out.add(s);
              }
            }
          }
          if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
            visit(child);
          }
        }
      };
      visit(node);
      return [...out];
    }
    computeRoots() {
      const called = new Set;
      for (const fn of this.pack.core.resourceNodes) {
        if (!(fn instanceof MCFunctionNode))
          continue;
        const visit = (container) => {
          for (const child of container.body) {
            if (child instanceof ExecuteCommandNode && child.body.length === 1) {
              const inner = child.body[0];
              if (inner instanceof FunctionCommandNode) {
                const target = this.resolveFunctionName(inner);
                if (target)
                  called.add(target);
              }
            }
            if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
              visit(child);
            }
          }
        };
        visit(fn);
      }
      for (const fn of this.pack.core.resourceNodes) {
        if (fn instanceof MCFunctionNode && !called.has(fn.resource.name)) {
          this.roots.add(fn.resource.name);
        }
      }
    }
    applyPatternA(node) {
      let wrapped = false;
      const visit = (container) => {
        for (let i = 0;i < container.body.length; i++) {
          const child = container.body[i];
          if (child instanceof ExecuteCommandNode && child.body.length === 1) {
            if (child.__throwPatternA)
              continue;
            const inner = child.body[0];
            if (inner instanceof FunctionCommandNode) {
              const target = this.resolveFunctionName(inner);
              if (target && this.throwFunctions.has(target)) {
                child.args.push(["if", "function", target]);
                child.body = [this.makeReturn("fail")];
                child.__throwPatternA = true;
                child.isSingleExecute = false;
                wrapped = true;
                continue;
              }
            }
          }
          if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
            visit(child);
          }
        }
      };
      visit(node);
      if (wrapped) {
        this.fallibleFunctions.add(node.resource.name);
      }
    }
    propagate(node) {
      let wrapped = false;
      const visit = (container) => {
        for (let i = 0;i < container.body.length; i++) {
          const child = container.body[i];
          if (child instanceof ExecuteCommandNode && child.body.length === 1) {
            if (child.__throwPatternB)
              continue;
            const inner = child.body[0];
            if (inner instanceof FunctionCommandNode) {
              const target = this.resolveFunctionName(inner);
              if (target && target !== node.resource.name && (this.fallibleFunctions.has(target) || this.throwFunctions.has(target))) {
                const scores = this.reachableScores.get(target) ?? [];
                for (const scoreName of scores) {
                  const sibling = this.makeIfScoreFailExecute([], scoreName);
                  container.body.splice(i + 1, 0, sibling);
                  i += 1;
                  this.usedScores.add(scoreName);
                  this.resetSites.add(scoreName);
                }
                if (scores.length > 0) {
                  child.__throwPatternB = true;
                  wrapped = true;
                }
              }
            }
          }
          if (child instanceof ContainerNode || child instanceof ContainerCommandNode) {
            visit(child);
          }
        }
      };
      visit(node);
      if (wrapped && !this.fallibleFunctions.has(node.resource.name)) {
        this.fallibleFunctions.add(node.resource.name);
      }
      if (wrapped && this.roots.has(node.resource.name)) {
        this.prependScoreResets(node);
      }
    }
    prependScoreResets(node) {
      let emitted = this.resetsEmitted.get(node.resource.name);
      if (!emitted) {
        emitted = new Set;
        this.resetsEmitted.set(node.resource.name, emitted);
      }
      for (const scoreName of this.resetSites) {
        const reset = new ScoreResetNode(this.pack.core, scoreName);
        if (emitted.has(reset))
          continue;
        emitted.add(reset);
        node.body.unshift(reset);
      }
    }
    makeIfScoreFailExecute(args, scoreHolderName) {
      const clonedArgs = args.map((sub) => [...sub]);
      clonedArgs.push(["if", "score", `#${scoreHolderName}`, "__sandstone", "matches", 1]);
      const node = new ExecuteCommandNode(this.pack, false, clonedArgs, {
        isSingleExecute: true,
        body: []
      });
      node.body = [this.makeReturn("fail")];
      return node;
    }
    makeReturn(value) {
      const node = new ReturnCommandNode(this.pack);
      node.args = [value];
      node.commited = false;
      return node;
    }
    resolveFunctionName(node) {
      const arg = node.args[0];
      if (typeof arg === "function" && "node" in arg) {
        const fnClass = arg;
        return fnClass.name;
      }
      return;
    }
  };
ScoreResetNode = class ScoreResetNode extends Node {
    scoreName;
    constructor(sandstoneCore2, scoreName) {
      super(sandstoneCore2);
      this.scoreName = scoreName;
    }
    getValue() {
      return `scoreboard players reset #${this.scoreName} __sandstone`;
    }
  };
UnifyChainedExecutesVisitor = class UnifyChainedExecutesVisitor extends GenericSandstoneVisitor {
    visitExecuteCommandNode = (node) => {
      if (node.body.length === 0) {
        return this.genericVisit(node);
      }
      const chainedCommand = node.body[0];
      if (chainedCommand && chainedCommand instanceof ExecuteCommandNode) {
        node.body = chainedCommand.body;
        node.args.push(...chainedCommand.args);
      }
      const flattenedArgs = node.args.flat(1).filter((a) => a !== undefined && a !== null);
      if (flattenedArgs.length === 0 && node.body.length === 1) {
        return this.genericVisit(node.body[0]);
      }
      return this.genericVisit(node);
    };
  };
WithNodeVisitor = class WithNodeVisitor extends GenericSandstoneVisitor {
    visitMCFunctionNode = (node) => this.genericVisit(node);
    onEnd = () => {
      for (const withClass of this.pack.core.withNodes) {
        const fn = withClass.containingMCFunction;
        if (!fn)
          throw new Error(`[WithNodeVisitor] WithClass has no containingMCFunction — body assignment must have been skipped.`);
        const node = withClass;
        node.mcfunction.node.body.push(...node.body);
        if (node.mcfunction.node.body.length === 1 && node.mcfunction.node.body[0] instanceof ExecuteCommandNode && !node.mcfunction.node.body[0].isMacro) {
          this.hoistSingleExecutePrefix(node, fn);
          continue;
        }
        const myIndex = fn.body.indexOf(node);
        const prep = myIndex > 0 ? fn.body[myIndex - 1] : undefined;
        if (node.enclosingExecute && node.enclosingExecute.createdMCFunction?.node === fn && !node.enclosingExecute.isMacro && prep instanceof ResolveNBTNode && this.resolveNBTMatchesEnv(prep, node)) {
          this.hoistExtractedExecutePrefix(node, node.enclosingExecute, fn);
        }
      }
    };
    hoistSingleExecutePrefix(node, parentFn) {
      const innerExecute = node.mcfunction.node.body[0];
      const innerArgs = innerExecute.args.filter((arg) => arg[0] !== "run");
      node.mcfunction.node.body = [...innerExecute.body];
      const wrappedFnCall = this.makeFunctionCallNode(node);
      const wrapped = new ExecuteCommandNode(this.pack, false, innerArgs, {
        isSingleExecute: false
      });
      wrapped.body = [wrappedFnCall];
      wrapped.isMacro = wrappedFnCall.isMacro ?? false;
      const parentBody = parentFn.body;
      const myIndex = parentBody.indexOf(node);
      if (myIndex !== -1) {
        parentBody.splice(myIndex, 1, wrapped);
      }
      node.commited = true;
    }
    hoistExtractedExecutePrefix(node, outerExecute, wrapperFn) {
      const outerArgs = outerExecute.args.filter((arg) => arg[0] !== "run");
      const myIndex = wrapperFn.body.indexOf(node);
      const movable = wrapperFn.body.splice(0, myIndex + 1);
      const wrappedFnCall = this.makeFunctionCallNode(node);
      const wrapped = new ExecuteCommandNode(this.pack, false, outerArgs, {
        isSingleExecute: false
      });
      wrapped.body = [wrappedFnCall];
      wrapped.isMacro = wrappedFnCall.isMacro ?? false;
      const grandParentBody = node.hostFunction.body;
      const idx = grandParentBody.indexOf(outerExecute);
      if (idx !== -1) {
        grandParentBody.splice(idx, 1, ...movable.slice(0, -1), wrapped);
      }
      this.pack.core.resourceNodes.delete(wrapperFn);
      wrapperFn.body = [];
      node.commited = true;
    }
    resolveNBTMatchesEnv(node, withClass) {
      const { nbt } = node;
      if (!nbt || nbt.constructor?.name !== "Object")
        return false;
      const entries = Object.entries(nbt);
      if (entries.length !== withClass.env.size)
        return false;
      for (const [, value] of entries) {
        if (!(value instanceof ResolveNBTPartClass))
          return false;
        if (!withClass.env.has(value.value))
          return false;
      }
      return true;
    }
    makeFunctionCallNode(node) {
      return node;
    }
  };
DataPack = class DataPack extends PackType {
    packMcmeta;
    constructor(archiveOutput, options) {
      super("datapack", "saves/$worldName$/datapacks/$packName$", "world/datapacks/$packName$", "datapacks/$packName$", "server", archiveOutput, "data", true);
      this.packMcmeta = {
        pack: {
          min_format: options.minFormat ?? options.packFormat,
          max_format: options.maxFormat ?? options.packFormat,
          description: options.description
        }
      };
      if (options.features) {
        this.packMcmeta.features = { enabled: options.features };
      }
      if (options.filter) {
        this.packMcmeta.filter = { block: options.filter };
      }
    }
    handleOutput = async (type, readFile, writeFile) => {
      if (type === "output") {
        await writeFile("pack.mcmeta", JSON.stringify(this.packMcmeta, null, 2));
      }
    };
  };
ResourcePack = class ResourcePack extends PackType {
    packMcmeta;
    constructor(options) {
      super("resourcepack", "saves/$worldName$/resources", "resource_pack", "resourcepacks/$packName$", "client", true, "assets", true);
      this.packMcmeta = {
        pack: {
          min_format: options.minFormat ?? options.packFormat,
          max_format: options.maxFormat ?? options.packFormat,
          description: options.description
        }
      };
      if (options.filter) {
        this.packMcmeta.filter = { block: options.filter };
      }
    }
    handleOutput = async (type, readFile, writeFile) => {
      if (type === "output") {
        await writeFile("pack.mcmeta", JSON.stringify(this.packMcmeta, null, 2));
      }
    };
  };
ItemPredicateClass = class ItemPredicateClass {
    pack;
    itemType;
    testGroups = [];
    constructor(pack2, itemType) {
      this.pack = pack2;
      this.itemType = itemType;
    }
    has(component) {
      this.addTest({ negated: false, component, operator: "exists" });
      return this;
    }
    without(component) {
      this.addTest({ negated: true, component, operator: "exists" });
      return this;
    }
    exact(component, value) {
      this.addTest({ negated: false, component, operator: "=", value });
      return this;
    }
    notExact(component, value) {
      this.addTest({ negated: true, component, operator: "=", value });
      return this;
    }
    match(predicate3, value) {
      this.addTest({ negated: false, component: predicate3, operator: "~", value });
      return this;
    }
    notMatch(predicate3, value) {
      this.addTest({ negated: true, component: predicate3, operator: "~", value });
      return this;
    }
    count(range2) {
      this.addTest({ negated: false, component: "count", operator: "~", value: range2 });
      return this;
    }
    or(...builders) {
      const orGroup = [];
      for (const builderFn of builders) {
        const tempBuilder = new ItemPredicateClass(this.pack, this.itemType);
        builderFn(tempBuilder);
        for (const group of tempBuilder.testGroups) {
          orGroup.push(...group);
        }
      }
      if (orGroup.length > 0) {
        this.testGroups.push(orGroup);
      }
      return this;
    }
    model() {
      const { ItemModelBuilder: ItemModelBuilder2 } = (init_itemDefinition(), __toCommonJS(exports_itemDefinition));
      const builder = new ItemModelBuilder2(this.pack);
      for (const group of this.testGroups) {
        builder.testGroups.push([...group]);
      }
      return builder;
    }
    addTest(test2) {
      this.testGroups.push([test2]);
    }
    stringifyTest(test2) {
      const prefix = test2.negated ? "!" : "";
      if (test2.operator === "exists") {
        return `${prefix}${test2.component}`;
      }
      const valueStr = nbtResolver(test2.value).toString();
      return `${prefix}${test2.component}${test2.operator}${valueStr}`;
    }
    stringifyOrGroup(group) {
      return group.map((test2) => this.stringifyTest(test2)).join("|");
    }
    toString() {
      if (this.testGroups.length === 0) {
        return `${this.itemType}`;
      }
      const testsStr = this.testGroups.map((group) => this.stringifyOrGroup(group)).join(",");
      return `${this.itemType}[${testsStr}]`;
    }
    toJSON() {
      throw new Error;
    }
    [util11.inspect.custom]() {
      return formatDebugString(this.constructor.name, this.toString(), undefined, undefined);
    }
  };
ItemModelBuilder = class ItemModelBuilder extends ItemPredicateClass {
    onTrueModel;
    onFalseModel;
    explicitModel;
    _handAnimationOnSwap;
    _oversizedInGui;
    _swapAnimationScale;
    constructor(pack2) {
      super(pack2, "*");
    }
    onTrue(model2) {
      this.onTrueModel = normalizeModel(model2);
      return this;
    }
    onFalse(model2) {
      this.onFalseModel = normalizeModel(model2);
      return this;
    }
    composite(...models) {
      this.explicitModel = {
        type: "composite",
        models: models.map(normalizeModel)
      };
      return this;
    }
    select(property, config) {
      if ("cases" in config && config.cases !== undefined && config.cases !== null) {
        this.explicitModel = {
          type: "select",
          property,
          ...config
        };
        return this;
      }
      throw new Error(`[ItemModelBuilder#select] \`cases\` must be defined for \`${property}\``);
    }
    rangeDispatch(property, config) {
      this.explicitModel = {
        type: "range_dispatch",
        property,
        ...config
      };
      return this;
    }
    special(model2, base) {
      this.explicitModel = {
        type: "special",
        model: model2,
        base
      };
      return this;
    }
    empty() {
      this.explicitModel = { type: "empty" };
      return this;
    }
    handAnimationOnSwap(enabled) {
      this._handAnimationOnSwap = enabled;
      return this;
    }
    oversizedInGui(enabled) {
      this._oversizedInGui = enabled;
      return this;
    }
    swapAnimationScale(scale) {
      this._swapAnimationScale = scale;
      return this;
    }
    toItemModel() {
      if (this.explicitModel) {
        return this.explicitModel;
      }
      return this.buildFromPredicates();
    }
    toItemModelDefinition() {
      return {
        model: this.toItemModel(),
        ...this._handAnimationOnSwap !== undefined && { hand_animation_on_swap: this._handAnimationOnSwap },
        ...this._oversizedInGui !== undefined && { oversized_in_gui: this._oversizedInGui },
        ...this._swapAnimationScale !== undefined && { swap_animation_scale: this._swapAnimationScale }
      };
    }
    buildFromPredicates() {
      for (const group of this.testGroups) {
        if (group.length > 1) {
          throw new Error("ItemModelBuilder does not support OR groups in predicate-to-model conversion. " + "Use multiple chained calls instead of .or(), or use the select/rangeDispatch methods directly.");
        }
      }
      if (this.testGroups.length === 0) {
        if (this.explicitModel) {
          return this.explicitModel;
        }
        if (this.onTrueModel) {
          return this.onTrueModel;
        }
        throw new Error("ItemModelBuilder requires at least one predicate test or an explicit model type.");
      }
      const countTests = this.testGroups.filter((g) => g[0].component === "count");
      if (countTests.length > 0) {
        const countTest = countTests[0][0];
        const value = countTest.value;
        const entries = [];
        if (typeof value === "number") {
          entries.push({ threshold: value, model: this.onTrueModel || { type: "empty" } });
        } else if (value && typeof value === "object") {
          if (value.min !== undefined) {
            entries.push({ threshold: value.min, model: this.onTrueModel || { type: "empty" } });
          }
        }
        return {
          type: "range_dispatch",
          property: "count",
          entries,
          fallback: this.onFalseModel || { type: "empty" }
        };
      }
      const onTrue = this.onTrueModel || { type: "empty" };
      const onFalse = this.onFalseModel || { type: "empty" };
      return this.buildNestedConditions(0, onTrue, onFalse);
    }
    buildNestedConditions(index, onTrue, onFalse) {
      if (index >= this.testGroups.length) {
        return onTrue;
      }
      const test2 = this.testGroups[index][0];
      const nextCondition = this.buildNestedConditions(index + 1, onTrue, onFalse);
      return this.testToCondition(test2, nextCondition, onFalse);
    }
    testToCondition(test2, onTrue, onFalse) {
      const [trueModel, falseModel] = test2.negated ? [onFalse, onTrue] : [onTrue, onFalse];
      switch (test2.operator) {
        case "exists":
          return {
            type: "condition",
            property: "has_component",
            component: test2.component,
            on_true: trueModel,
            on_false: falseModel
          };
        case "=":
        case "~":
          return {
            type: "condition",
            property: "component",
            predicate: test2.component,
            value: test2.value,
            on_true: trueModel,
            on_false: falseModel
          };
        default:
          throw new Error(`Unknown predicate operator: ${test2.operator}`);
      }
    }
  };
ItemModelDefinitionNode = class ItemModelDefinitionNode extends ContainerNode {
    resource;
    constructor(sandstoneCore2, resource2) {
      super(sandstoneCore2);
      this.resource = resource2;
    }
    getValue = () => jsonStringify(this.resource.itemDefinitionJSON, this.resource._resourceType);
  };
ItemModelDefinitionClass = class ItemModelDefinitionClass extends ResourceClass {
    static resourceType = "item_definition";
    itemDefinitionJSON;
    constructor(core, name, args) {
      super(core, { packType: core.pack.resourcePack() }, ItemModelDefinitionNode, ItemModelDefinitionClass.resourceType, core.pack.resourceToPath(name, RESOURCE_PATHS[ItemModelDefinitionClass.resourceType].path), args);
      this.itemDefinitionJSON = this.resolveDefinitionInput(args.definition);
      this.handleConflicts();
    }
    resolveDefinitionInput(input) {
      if (typeof input === "function") {
        const builder = new ItemModelBuilder(this.core.pack);
        return input(builder).toItemModelDefinition();
      }
      if (input instanceof ItemModelBuilder) {
        return input.toItemModelDefinition();
      }
      if (input && "model" in input && input.model && typeof input.model === "object" && "type" in input.model) {
        return input;
      }
      return { model: input };
    }
    toString = () => `${this.path[0]}:${this.path.slice(2).join("/")}`;
  };
IterableDataClass = class IterableDataClass extends ConditionalDataPointPickClass {
    iteratorType;
    constructor(sandstoneCore2, iteratorType) {
      super(sandstoneCore2);
      this.iteratorType = iteratorType;
    }
    iterator(_callback, _direction = "normal") {
      throw new Error("Not implemented");
    }
    size() {
      throw new Error("Not implemented");
    }
    last() {
      throw new Error("Not implemented");
    }
    continue(direction = "normal") {
      throw new Error("Not implemented");
    }
  };
DataIndexMapClass = class DataIndexMapClass extends IterableDataClass {
    pack;
    entries = {};
    dataPoint;
    constructor(pack2, initialize, dataPoint2) {
      super(pack2.core, "map");
      this.pack = pack2;
      if (dataPoint2) {
        this.dataPoint = dataPoint2;
      } else {
        this.dataPoint = this.pack.DataVariable(undefined, "IndexMap");
      }
      if (pack2.core.currentMCFunction) {
        this.init(initialize);
      } else {
        pack2.initMCFunction.push(() => this.init(initialize));
      }
    }
    init(initialize) {
      for (const [i, [key, value]] of Object.entries(initialize).entries()) {
        this.dataPoint.select("Index").select(key).set(i);
        this.dataPoint.select("Entries").append([]);
        const entry = this.dataPoint.select(`Entries[${i}]`);
        entry.append(key);
        entry.append(value);
        this.entries[key] = i;
      }
    }
    __entryIterator;
    entryIterator(direction) {
      if (!this.__entryIterator) {
        this.__entryIterator = this.pack.DataVariable(this.dataPoint.select("Entries")).select(`[${direction === "normal" ? 0 : -1}]`);
      }
      return this.__entryIterator;
    }
    iterator(callback, direction = "normal") {
      this.__entryIterator = undefined;
      const entryIterator = this.entryIterator(direction);
      return () => {
        callback([entryIterator.select("[0]").slice(0), entryIterator.select("[1]")]);
        entryIterator.remove();
      };
    }
    continue(direction = "normal") {
      return this.entryIterator(direction)._toMinecraftCondition();
    }
    size = () => this.dataPoint.select("Entries");
    last = () => [this.dataPoint.select("Entries[-1][0]").slice(0), this.dataPoint.select("Entries[-1][1]")];
    set(key, value) {
      if (typeof key === "string") {
        if (this.entries[key]) {
          const index3 = this.entries[key];
          this.dataPoint.select(`Entries[${index3}]`).set(value);
          return index3;
        }
        this.dataPoint.select("Keys").append(key);
        this.dataPoint.select("Values").append(value);
        const index2 = this.pack.Variable(this.size());
        this.dataPoint.select("Index").select(key).set(index2);
        this.dataPoint.select("Entries").append([]);
        const entry2 = this.dataPoint.select("Entries[-1]");
        entry2.append(key);
        entry2.append(value);
        return index2;
      }
      const { Macro: Macro2, MCFunction, Variable, DataVariable } = this.pack;
      let _key;
      if (key instanceof DataPointClass) {
        _key = key;
      } else if (Object.hasOwn(key, "_toDataPoint")) {
        _key = key._toDataPoint();
      } else if (key instanceof Score) {
        _key = DataVariable().set(key);
      }
      const index = Variable(this.size());
      this.dataPoint.select("Keys").append(_key);
      this.dataPoint.select("Values").append(value);
      MCFunction("./__data_index_map/set", [_key], () => {
        const indexData = DataVariable().set(index);
        Macro2.data.modify.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}.Index[${_key}]`).set.from.storage(indexData.currentTarget, indexData.path);
      }, {
        creator: "sandstone",
        onConflict: "rename"
      })();
      this.dataPoint.select("Entries").append([]);
      const entry = this.dataPoint.select("Entries[-1]");
      entry.append(_key);
      entry.append(value);
      return index;
    }
    get(key) {
      const { MCFunction, Macro: Macro2, DataVariable } = this.pack;
      if (typeof key === "string") {
        if (this.entries[key]) {
          return this.dataPoint.select(`Entries[${this.entries[key]}]`);
        }
        const index = this.dataPoint.select("Index").select(key);
        const value = DataVariable();
        MCFunction("./__data_index_map/get", [index], () => {
          Macro2.data.modify.storage(value.currentTarget, value.path).set.from.storage(this.dataPoint.currentTarget, Macro2`Entries[${index}]`);
        }, {
          creator: "sandstone",
          onConflict: "rename"
        })();
        return value;
      }
      let _key;
      if (key instanceof DataPointClass) {
        _key = key;
      } else if (Object.hasOwn(key, "_toDataPoint")) {
        _key = key._toDataPoint();
      } else if (key instanceof Score) {
        _key = DataVariable().set(key);
      }
      const output = DataVariable();
      MCFunction("./__data_index_map/get", [_key], () => {
        const index = DataVariable();
        Macro2.data.modify.storage(index.currentTarget, index.path).set.from.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}.Index[${_key}]`);
        MCFunction("./__data_index_map/get/inner", [index], () => {
          Macro2.data.modify.storage(output.currentTarget, output.path).set.from.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}.Entries[${index}]`);
        }, {
          creator: "sandstone",
          onConflict: "rename"
        })();
      }, {
        creator: "sandstone",
        onConflict: "rename"
      })();
      return output;
    }
    remove(key) {
      const { MCFunction, Macro: Macro2, DataVariable } = this.pack;
      if (typeof key === "string") {
        const index2 = this.dataPoint.select("Index").select(key);
        MCFunction("./__data_index_map/remove", [index2], () => {
          Macro2.data.modify.storage(this.dataPoint.currentTarget, Macro2`Entries[${index2}]`).set.value(0);
          index2.remove();
        }, {
          creator: "sandstone",
          onConflict: "rename"
        })();
        return this;
      }
      let _key;
      if (key instanceof DataPointClass || key instanceof Score) {
        _key = key;
      } else {
        _key = key._toDataPoint();
      }
      const index = DataVariable();
      MCFunction("./__data_index_map/remove", [_key], () => {
        Macro2.data.modify.storage(index.currentTarget, index.path).set.from.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}.Index[${_key}]`);
        Macro2.data.remove.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}.Index[${_key}]`);
        MCFunction("./__data_index_map/remove/inner", [index], () => {
          Macro2.data.modify.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}.Entries[${index}]`).set.value(0);
        }, {
          creator: "sandstone",
          onConflict: "rename"
        })();
      }, {
        creator: "sandstone",
        onConflict: "rename"
      })();
      return this;
    }
    _toDataPoint = () => this.dataPoint;
    _toMinecraftCondition() {
      return this.dataPoint._toMinecraftCondition();
    }
  };
DataArrayClass = class DataArrayClass extends IterableDataClass {
    pack;
    dataPoint;
    constructor(pack2, initialize, dataPoint2) {
      super(pack2.core, "list");
      this.pack = pack2;
      if (dataPoint2) {
        this.dataPoint = dataPoint2;
      } else {
        this.dataPoint = this.pack.DataVariable([], "Array");
      }
      if (pack2.core.currentMCFunction) {
        this.init(initialize);
      } else {
        pack2.initMCFunction.push(() => this.init(initialize));
      }
    }
    init(initialize) {
      for (const entry of initialize) {
        this.dataPoint.append(entry);
      }
    }
    __entryIterator;
    entryIterator(direction) {
      if (!this.__entryIterator) {
        this.__entryIterator = this.pack.DataVariable(this.dataPoint).select(`[${direction === "normal" ? 0 : -1}]`);
      }
      return this.__entryIterator;
    }
    iterator(callback, direction = "normal") {
      this.__entryIterator = undefined;
      const entryIterator = this.entryIterator(direction);
      return () => {
        callback([entryIterator]);
        entryIterator.remove();
      };
    }
    continue(direction = "normal") {
      return this.entryIterator(direction)._toMinecraftCondition();
    }
    size = () => this.dataPoint;
    last = () => this.dataPoint.select("[-1]");
    set(index, value) {
      if (typeof index === "number") {
        this.dataPoint.select(`[${index}]`).set(value);
        return this;
      }
      const { Macro: Macro2, MCFunction } = this.pack;
      MCFunction("./__data_array/set", [index], () => {
        if (value instanceof StringDataPointClass) {
          const [start, end] = value.sliceBounds;
          Macro2.data.modify.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}[${index}]`).set.string.storage(value.currentTarget, value.path, start, end);
        } else if (value instanceof DataPointClass) {
          Macro2.data.modify.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}[${index}]`).set.from.storage(value.currentTarget, value.path);
        } else if (typeof value === "object" && Object.hasOwn(value, "_toDataPoint")) {
          const point = value._toDataPoint();
          Macro2.data.modify.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}[${index}]`).set.from.storage(point.currentTarget, point.path);
        } else {
          Macro2.data.modify.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}[${index}]`).set.value(value);
        }
      }, {
        creator: "sandstone",
        onConflict: "rename"
      })();
      return this;
    }
    push(value) {
      this.dataPoint.append(value);
      return this;
    }
    unshift(value) {
      this.dataPoint.prepend(value);
      return this;
    }
    get(index) {
      if (typeof index === "number") {
        return this.dataPoint.select(`[${index}]`);
      }
      const { Macro: Macro2, MCFunction, DataVariable } = this.pack;
      const output = DataVariable();
      MCFunction("./__data_array/get", [index], () => {
        Macro2.data.modify.storage(output.currentTarget, output.path).set.from.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}[${index}]`);
      }, {
        creator: "sandstone",
        onConflict: "rename"
      })();
      return output;
    }
    remove(index) {
      if (typeof index === "number") {
        this.dataPoint.select(`[${index}]`).remove();
        return this;
      }
      const { MCFunction, Macro: Macro2 } = this.pack;
      MCFunction("./__data_array/remove", [index], () => {
        Macro2.data.remove.storage(this.dataPoint.currentTarget, Macro2`${this.dataPoint.path}[${index}]`);
      }, {
        creator: "sandstone",
        onConflict: "rename"
      })();
      return this;
    }
    _toDataPoint = () => this.dataPoint;
    _toMinecraftCondition() {
      return this.dataPoint._toMinecraftCondition();
    }
  };
SelectorClass = class SelectorClass {
    sandstonePack;
    target;
    arguments;
    _hasMacro = false;
    constructor(sandstonePack2, target, selectorArguments) {
      this.sandstonePack = sandstonePack2;
      this.target = target;
      this.arguments = selectorArguments ?? {};
    }
    listScores = () => {
      this.sandstonePack.commands.scoreboard.players.list(this.toString());
    };
    toString() {
      if (!this.arguments || !Object.keys(this.arguments).length) {
        this._hasMacro = false;
        return this.target;
      }
      const result = [];
      const args = { ...this.arguments };
      const modifiers = {
        scores: (scores) => result.push(["scores", parseScore(this.sandstonePack.core, scores)]),
        nbt: (nbt2) => {
          const nbts = Array.isArray(nbt2) ? nbt2 : [nbt2];
          for (const nbt_ of nbts) {
            const resolved = nbtResolver(nbt_);
            if (resolved.containsMacro) {
              this._hasMacro = true;
            }
            result.push(["nbt", resolved]);
          }
        },
        advancements: (advancements) => result.push(["advancements", parseAdvancements(advancements)]),
        tag: (tag4) => {
          const tags = Array.isArray(tag4) ? tag4 : [tag4];
          result.push(...tags.map((tag_) => ["tag", tag_]));
        },
        gamemode: (gamemode2) => {
          const gamemodes = Array.isArray(gamemode2) ? gamemode2 : [gamemode2];
          result.push(...gamemodes.map((gamemode_) => ["gamemode", gamemode_]));
        },
        predicate: (predicate4) => {
          const predicates = Array.isArray(predicate4) ? predicate4 : [predicate4];
          result.push(...predicates.map((pred) => ["predicate", pred]));
        },
        team: (team2) => {
          let teamRepr;
          if (team2 === true) {
            teamRepr = "!";
          } else if (team2 === false) {
            teamRepr = "";
          } else {
            teamRepr = team2;
          }
          result.push(["team", teamRepr]);
        },
        distance: (range_) => result.push(["distance", rangeParser(this.sandstonePack.core, range_)])
      };
      Object.entries(args).forEach(([key_, value]) => {
        const key = key_;
        if (key in modifiers) {
          const modifierName = key;
          modifiers[modifierName](value);
        } else if (value !== undefined) {
          result.push([key, `${value}`]);
        }
      });
      const entityType = result.findIndex(([key]) => key === "type");
      if (entityType !== -1) {
        result.unshift(...result.splice(entityType, 1));
      }
      const predicate3 = result.findIndex(([key]) => key === "predicate");
      if (predicate3 !== -1) {
        result.push(...result.splice(predicate3, 1));
      }
      return `${this.target}[${result.map(([key, value]) => `${key}=${value}`).join(", ")}]`;
    }
    _toMinecraftCondition = () => new this.sandstonePack.conditions.Selector(this.sandstonePack.core, this.toString());
    _toChatComponent() {
      return {
        type: "selector",
        selector: this.toString()
      };
    }
    _toSelector() {
      return this;
    }
    toJSON() {
      return this.toString();
    }
    toNBT() {
      return `'${this.toString()}'`;
    }
    [util12.inspect.custom]() {
      return formatDebugString(this.constructor.name, this.toString(), undefined, undefined);
    }
  };
class _RawLabelClass {
  pack;
  name;
  fullName;
  description;
  constructor(pack2, name, description) {
    this.pack = pack2;
    if (name.includes(":")) {
      this.name = name.split(":")[1];
      this.fullName = name.replace(":", ".");
    } else {
      this.name = name;
      this.fullName = `${pack2.defaultNamespace}.${name}`;
    }
    if (description)
      this.description = description;
  }
  LabelHolder(entity, selectorArguments) {
    if (typeof entity === "string") {
      return new EntityLabel(this.pack, new SelectorClass(this.pack, entity, selectorArguments), this);
    }
    return new EntityLabel(this.pack, entity, this);
  }
  toString = () => `${this.fullName}${this.description ? `; ${this.description}` : ""}`;
  toNBT = () => `'${this.fullName}'`;
  __call__(entity, selectorArguments) {
    if (typeof entity === "string") {
      return new EntityLabel(this.pack, new SelectorClass(this.pack, entity, selectorArguments), this);
    }
    return new EntityLabel(this.pack, entity, this);
  }
}
LabelClass = makeClassCallable(_RawLabelClass);
LoopArgument = class LoopArgument extends Node {
    pack;
    loopIfNode = null;
    constructor(pack2) {
      super(pack2.core);
      this.pack = pack2;
      this.pack.appendNode(this);
    }
    getValue() {
      return this.toLoop();
    }
    toLoop() {
      const loopExecute = this.loopIfNode?.resultingExecuteNode;
      if (loopExecute?.createdMCFunction) {
        const funcNode = new FunctionCommandNode(this.pack, loopExecute.createdMCFunction.name);
        if (loopExecute.macroStorage) {
          funcNode.args.push("with", "storage", loopExecute.macroStorage.currentTarget, loopExecute.macroStorage.path);
        }
        return funcNode.getValue();
      }
      return new FunctionCommandNode(this.pack, this.pack.core.currentNode);
    }
  };
_RawObjectiveClass = class _RawObjectiveClass {
    sandstonePack;
    name;
    criteria;
    display;
    _displayRaw;
    creator;
    constructor(sandstonePack2, name, criteria = "dummy", display, opts) {
      this.sandstonePack = sandstonePack2;
      this.name = name;
      this.criteria = criteria;
      this.display = display === undefined ? undefined : new JSONTextComponentClass(display);
      this._displayRaw = display;
      this.creator = opts.creator;
    }
    reset = () => this.sandstonePack.commands.scoreboard.players.reset("*", this.name);
    ScoreHolder = (scoreHolder, display) => new Score(this.sandstonePack, targetParser(scoreHolder), display, this);
    toString() {
      return this.name;
    }
    [util13.inspect.custom](depth, options) {
      return formatDebugString(this.constructor.name, {
        name: this.name,
        criteria: this.criteria,
        creator: this.creator
      }, undefined, options.indent);
    }
    toJSON = this.toString;
    toNBT = () => `'${this.toString}'`;
    __call__ = this.ScoreHolder;
  };
ObjectiveClass = makeClassCallable(_RawObjectiveClass);

// src/variables/abstractClasses.ts

class ConditionClass {
  preNodes;
  _toMinecraftCondition() {
    throw new Error("Not implemented");
  }
}

class SelectorPickClass {
  _toSelector() {
    throw new Error("Not implemented");
  }
  toNBT() {
    throw new Error("Not implemented");
  }
  _toChatComponent() {
    throw new Error("Not implemented");
  }
}
var ConditionTextComponentClass;
var init_abstractClasses = __esm(() => {
  });

// src/variables/Coordinates.ts
var exports_Coordinates = {};
__export(exports_Coordinates, {
  relative: () => relative,
  local: () => local,
  absolute: () => absolute,
  VectorClass: () => VectorClass
});
import { inspect } from "util";
function absolute(...coordinates) {
  if (coordinates.length === 1) {
    return coordinates[0].toString();
  }
  return new VectorClass(coordinates.map((coord) => coord.toString()));
}
function relative(...coordinates) {
  if (coordinates.length === 0) {
    return new VectorClass(["~", "~", "~"]);
  }
  if (coordinates.length === 1) {
    return `~${coordinates[0]}`;
  }
  return new VectorClass(coordinates.map((coord) => `~${coord || ""}`));
}
function local(...coordinates) {
  if (coordinates.length === 0) {
    return new VectorClass(["^", "^", "^"]);
  }
  if (coordinates.length === 1) {
    return `^${coordinates[0]}`;
  }
  return new VectorClass(coordinates.map((coord) => `^${coord || ""}`));
}
var VectorClass;
var init_Coordinates = __esm(() => {
  });

// src/core/Macro.ts
function isMacroArgument(core, arg) {
  if (typeof arg === "object" && Object.hasOwn(arg, "toMacro")) {
    const local2 = arg.local;
    let currentMCFunctionName = "";
    try {
      currentMCFunctionName = core.getCurrentMCFunctionOrThrow().resource.name;
    } catch {}
    if (arg instanceof MacroLiteral || local2.has(currentMCFunctionName) || local2.has(core.currentNode))
      return arg;
  }
  return;
}
var MacroLiteral, DataPointPickClass, ConditionalDataPointPickClass;
var init_Macro = __esm(() => {
      });

// src/utils.ts
import fs from "fs-extra";
import * as util from "util";
function makeCallableProxy(func, object) {
  return new Proxy(func, {
    apply: (_t, _thisArg, args) => Reflect.apply(func, object, args),
    get: (_t, p, _r) => object[p],
    set: (_t, p, value, _r) => {
      object[p] = value;
      return value;
    },
    getPrototypeOf: (_t) => Object.getPrototypeOf(object),
    ownKeys: (_t) => {
      return Reflect.ownKeys(object);
    },
    getOwnPropertyDescriptor: (_t, prop) => {
      return Reflect.getOwnPropertyDescriptor(object, prop);
    },
    has: (_t, prop) => {
      return Reflect.has(object, prop);
    }
  });
}
function makeClassCallable(Class_) {
  return new Proxy(Class_, {
    construct: (_t, argArray, _nt) => {
      const obj = new Class_(...argArray);
      const result = makeCallableProxy(obj.__call__, obj);
      return result;
    }
  });
}
function makeCallable(object, func, useProxy = false) {
  if (useProxy) {
    return makeCallableProxy(func, object);
  }
  const { name, ...objectExceptName } = object;
  const result = Object.assign(func, objectExceptName);
  if (name !== undefined) {
    const descriptor = Object.getOwnPropertyDescriptor(func, "name");
    descriptor.value = name;
    Object.defineProperty(func, "name", descriptor);
  }
  return result;
}
function randomUUID() {
  crypto.getRandomValues(uuidBytes);
  uuidBytes[6] = uuidBytes[6] & 15 | 4 << 4;
  uuidBytes[8] = uuidBytes[8] & 63 | 128;
  const array = [];
  for (let i = 0;i < 4; i++) {
    array.push(uuid.getInt32(i * 4, false));
  }
  return array;
}
function add(obj) {
  const filtered = {};
  for (const key of Object.keys(obj)) {
    const value = obj[key];
    if (value !== undefined) {
      filtered[key] = value;
    }
  }
  return filtered;
}
async function safeWrite(...args) {
  if (typeof args[0] !== "string")
    throw new Error("unimplemented");
  await fs.ensureDir(args[0].replace(/(?:\/|\\)(?:.(?!(?:\/|\\)))+$/, ""));
  return fs.writeFile(...args);
}
function formatDebugString(className, args, body, currentIndent) {
  const FIXED_INDENT = "  ";
  const indent = currentIndent || "";
  const nextIndent = indent + FIXED_INDENT;
  const options = { indent: nextIndent };
  let argsString;
  if (typeof args === "string") {
    argsString = args;
  } else if (Array.isArray(args)) {
    argsString = args.map((arg) => util.inspect(arg, options)).join(", ");
    if (argsString.includes(`
`)) {
      argsString = `
${nextIndent}${args.map((arg) => util.inspect(arg, options).replaceAll(`
`, `
${nextIndent}`)).join(`,
${nextIndent}`)}`;
    }
  } else if (args && typeof args === "object") {
    argsString = Object.entries(args).map(([key, value]) => `${key}: ${util.inspect(value, options)}`).join(", ");
  } else {
    argsString = "";
  }
  const bodyString = typeof body === "undefined" ? "" : body.map((node) => {
    return util.inspect(node, options);
  }).join(`
${nextIndent}`);
  const rainbowBracketColors = [
    "yellow",
    "green",
    "cyan",
    "blue",
    "magenta",
    "redBright",
    "yellowBright",
    "greenBright",
    "cyanBright",
    "blueBright",
    "magentaBright"
  ];
  const bracketColor = rainbowBracketColors[indent.length / FIXED_INDENT.length % rainbowBracketColors.length];
  const realArgsString = argsString.length === 0 ? "" : `(${argsString})`;
  const realBodyString = bodyString.length === 0 ? "" : ` ${util.styleText(bracketColor, "{")}
${nextIndent}${bodyString}
${indent}${util.styleText(bracketColor, "}")}`;
  const classNameString = util.styleText("green", className);
  return `${classNameString}${realArgsString}${realBodyString}`;
}
var uuidBytes, uuid, capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1), Set2;
var init_utils = __esm(() => {
  uuidBytes = new Uint8Array(16);
  uuid = new DataView(uuidBytes.buffer);
  });

// src/variables/nbt/grammar.ts
function id(d) {
  return d[0];
}
var isCompoundSymbol, grammar, grammar_default;
var init_grammar = __esm(() => {
  isCompoundSymbol = Symbol("isCompound");
  grammar = {
    Lexer: undefined,
    ParserRules: [
      { name: "_$ebnf$1", symbols: [] },
      { name: "_$ebnf$1", symbols: ["_$ebnf$1", "wschar"], postprocess: (d) => d[0].concat([d[1]]) },
      {
        name: "_",
        symbols: ["_$ebnf$1"],
        postprocess(d) {
          return null;
        }
      },
      { name: "__$ebnf$1", symbols: ["wschar"] },
      { name: "__$ebnf$1", symbols: ["__$ebnf$1", "wschar"], postprocess: (d) => d[0].concat([d[1]]) },
      {
        name: "__",
        symbols: ["__$ebnf$1"],
        postprocess(d) {
          return null;
        }
      },
      { name: "wschar", symbols: [/[ \t\n\v\f]/], postprocess: id },
      { name: "unsigned_int$ebnf$1", symbols: [/[0-9]/] },
      { name: "unsigned_int$ebnf$1", symbols: ["unsigned_int$ebnf$1", /[0-9]/], postprocess: (d) => d[0].concat([d[1]]) },
      {
        name: "unsigned_int",
        symbols: ["unsigned_int$ebnf$1"],
        postprocess(d) {
          return Number.parseInt(d[0].join(""));
        }
      },
      { name: "int$ebnf$1$subexpression$1", symbols: [{ literal: "-" }] },
      { name: "int$ebnf$1$subexpression$1", symbols: [{ literal: "+" }] },
      { name: "int$ebnf$1", symbols: ["int$ebnf$1$subexpression$1"], postprocess: id },
      { name: "int$ebnf$1", symbols: [], postprocess: () => null },
      { name: "int$ebnf$2", symbols: [/[0-9]/] },
      { name: "int$ebnf$2", symbols: ["int$ebnf$2", /[0-9]/], postprocess: (d) => d[0].concat([d[1]]) },
      {
        name: "int",
        symbols: ["int$ebnf$1", "int$ebnf$2"],
        postprocess(d) {
          if (d[0]) {
            return Number.parseInt(d[0][0] + d[1].join(""));
          }
          return Number.parseInt(d[1].join(""));
        }
      },
      { name: "unsigned_decimal$ebnf$1", symbols: [/[0-9]/] },
      {
        name: "unsigned_decimal$ebnf$1",
        symbols: ["unsigned_decimal$ebnf$1", /[0-9]/],
        postprocess: (d) => d[0].concat([d[1]])
      },
      { name: "unsigned_decimal$ebnf$2$subexpression$1$ebnf$1", symbols: [/[0-9]/] },
      {
        name: "unsigned_decimal$ebnf$2$subexpression$1$ebnf$1",
        symbols: ["unsigned_decimal$ebnf$2$subexpression$1$ebnf$1", /[0-9]/],
        postprocess: (d) => d[0].concat([d[1]])
      },
      {
        name: "unsigned_decimal$ebnf$2$subexpression$1",
        symbols: [{ literal: "." }, "unsigned_decimal$ebnf$2$subexpression$1$ebnf$1"]
      },
      { name: "unsigned_decimal$ebnf$2", symbols: ["unsigned_decimal$ebnf$2$subexpression$1"], postprocess: id },
      { name: "unsigned_decimal$ebnf$2", symbols: [], postprocess: () => null },
      {
        name: "unsigned_decimal",
        symbols: ["unsigned_decimal$ebnf$1", "unsigned_decimal$ebnf$2"],
        postprocess(d) {
          return Number.parseFloat(d[0].join("") + (d[1] ? `.${d[1][1].join("")}` : ""));
        }
      },
      { name: "decimal$ebnf$1", symbols: [{ literal: "-" }], postprocess: id },
      { name: "decimal$ebnf$1", symbols: [], postprocess: () => null },
      { name: "decimal$ebnf$2", symbols: [/[0-9]/] },
      { name: "decimal$ebnf$2", symbols: ["decimal$ebnf$2", /[0-9]/], postprocess: (d) => d[0].concat([d[1]]) },
      { name: "decimal$ebnf$3$subexpression$1$ebnf$1", symbols: [/[0-9]/] },
      {
        name: "decimal$ebnf$3$subexpression$1$ebnf$1",
        symbols: ["decimal$ebnf$3$subexpression$1$ebnf$1", /[0-9]/],
        postprocess: (d) => d[0].concat([d[1]])
      },
      { name: "decimal$ebnf$3$subexpression$1", symbols: [{ literal: "." }, "decimal$ebnf$3$subexpression$1$ebnf$1"] },
      { name: "decimal$ebnf$3", symbols: ["decimal$ebnf$3$subexpression$1"], postprocess: id },
      { name: "decimal$ebnf$3", symbols: [], postprocess: () => null },
      {
        name: "decimal",
        symbols: ["decimal$ebnf$1", "decimal$ebnf$2", "decimal$ebnf$3"],
        postprocess(d) {
          return Number.parseFloat((d[0] || "") + d[1].join("") + (d[2] ? `.${d[2][1].join("")}` : ""));
        }
      },
      {
        name: "percentage",
        symbols: ["decimal", { literal: "%" }],
        postprocess(d) {
          return d[0] / 100;
        }
      },
      { name: "jsonfloat$ebnf$1", symbols: [{ literal: "-" }], postprocess: id },
      { name: "jsonfloat$ebnf$1", symbols: [], postprocess: () => null },
      { name: "jsonfloat$ebnf$2", symbols: [/[0-9]/] },
      { name: "jsonfloat$ebnf$2", symbols: ["jsonfloat$ebnf$2", /[0-9]/], postprocess: (d) => d[0].concat([d[1]]) },
      { name: "jsonfloat$ebnf$3$subexpression$1$ebnf$1", symbols: [/[0-9]/] },
      {
        name: "jsonfloat$ebnf$3$subexpression$1$ebnf$1",
        symbols: ["jsonfloat$ebnf$3$subexpression$1$ebnf$1", /[0-9]/],
        postprocess: (d) => d[0].concat([d[1]])
      },
      {
        name: "jsonfloat$ebnf$3$subexpression$1",
        symbols: [{ literal: "." }, "jsonfloat$ebnf$3$subexpression$1$ebnf$1"]
      },
      { name: "jsonfloat$ebnf$3", symbols: ["jsonfloat$ebnf$3$subexpression$1"], postprocess: id },
      { name: "jsonfloat$ebnf$3", symbols: [], postprocess: () => null },
      { name: "jsonfloat$ebnf$4$subexpression$1$ebnf$1", symbols: [/[+-]/], postprocess: id },
      { name: "jsonfloat$ebnf$4$subexpression$1$ebnf$1", symbols: [], postprocess: () => null },
      { name: "jsonfloat$ebnf$4$subexpression$1$ebnf$2", symbols: [/[0-9]/] },
      {
        name: "jsonfloat$ebnf$4$subexpression$1$ebnf$2",
        symbols: ["jsonfloat$ebnf$4$subexpression$1$ebnf$2", /[0-9]/],
        postprocess: (d) => d[0].concat([d[1]])
      },
      {
        name: "jsonfloat$ebnf$4$subexpression$1",
        symbols: [/[eE]/, "jsonfloat$ebnf$4$subexpression$1$ebnf$1", "jsonfloat$ebnf$4$subexpression$1$ebnf$2"]
      },
      { name: "jsonfloat$ebnf$4", symbols: ["jsonfloat$ebnf$4$subexpression$1"], postprocess: id },
      { name: "jsonfloat$ebnf$4", symbols: [], postprocess: () => null },
      {
        name: "jsonfloat",
        symbols: ["jsonfloat$ebnf$1", "jsonfloat$ebnf$2", "jsonfloat$ebnf$3", "jsonfloat$ebnf$4"],
        postprocess(d) {
          return Number.parseFloat((d[0] || "") + d[1].join("") + (d[2] ? `.${d[2][1].join("")}` : "") + (d[3] ? `e${d[3][1] || "+"}${d[3][2].join("")}` : ""));
        }
      },
      { name: "dqstring$ebnf$1", symbols: [] },
      { name: "dqstring$ebnf$1", symbols: ["dqstring$ebnf$1", "dstrchar"], postprocess: (d) => d[0].concat([d[1]]) },
      {
        name: "dqstring",
        symbols: [{ literal: '"' }, "dqstring$ebnf$1", { literal: '"' }],
        postprocess(d) {
          return d[1].join("");
        }
      },
      { name: "sqstring$ebnf$1", symbols: [] },
      { name: "sqstring$ebnf$1", symbols: ["sqstring$ebnf$1", "sstrchar"], postprocess: (d) => d[0].concat([d[1]]) },
      {
        name: "sqstring",
        symbols: [{ literal: "'" }, "sqstring$ebnf$1", { literal: "'" }],
        postprocess(d) {
          return d[1].join("");
        }
      },
      { name: "btstring$ebnf$1", symbols: [] },
      { name: "btstring$ebnf$1", symbols: ["btstring$ebnf$1", /[^`]/], postprocess: (d) => d[0].concat([d[1]]) },
      {
        name: "btstring",
        symbols: [{ literal: "`" }, "btstring$ebnf$1", { literal: "`" }],
        postprocess(d) {
          return d[1].join("");
        }
      },
      { name: "dstrchar", symbols: [/[^\\"\n]/], postprocess: id },
      {
        name: "dstrchar",
        symbols: [{ literal: "\\" }, "strescape"],
        postprocess(d) {
          return JSON.parse(`"${d.join("")}"`);
        }
      },
      { name: "sstrchar", symbols: [/[^\\'\n]/], postprocess: id },
      {
        name: "sstrchar",
        symbols: [{ literal: "\\" }, "strescape"],
        postprocess(d) {
          return JSON.parse(`"${d.join("")}"`);
        }
      },
      { name: "sstrchar$string$1", symbols: [{ literal: "\\" }, { literal: "'" }], postprocess: (d) => d.join("") },
      {
        name: "sstrchar",
        symbols: ["sstrchar$string$1"],
        postprocess(d) {
          return "'";
        }
      },
      { name: "strescape", symbols: [/["\\/bfnrt]/], postprocess: id },
      {
        name: "strescape",
        symbols: [{ literal: "u" }, /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/, /[a-fA-F0-9]/],
        postprocess(d) {
          return d.join("");
        }
      },
      { name: "expression$subexpression$1", symbols: ["string"] },
      { name: "expression$subexpression$1", symbols: ["typedNum"] },
      { name: "expression$subexpression$1", symbols: ["number"] },
      { name: "expression$subexpression$1", symbols: ["boolean"] },
      { name: "expression$subexpression$1", symbols: ["byteArray"] },
      { name: "expression$subexpression$1", symbols: ["intArray"] },
      { name: "expression$subexpression$1", symbols: ["longArray"] },
      { name: "expression$subexpression$1", symbols: ["array"] },
      { name: "expression$subexpression$1", symbols: ["object"] },
      {
        name: "expression",
        symbols: ["expression$subexpression$1"],
        postprocess: (data) => data[0][0]
      },
      {
        name: "object",
        symbols: [{ literal: "{" }, "objectInner", { literal: "}" }],
        postprocess: (data) => Object.fromEntries([
          ...data[1].map(({ key, value }) => [key, value]),
          [isCompoundSymbol, true]
        ])
      },
      { name: "objectInner", symbols: ["_"], postprocess: (data) => [] },
      { name: "objectInner$ebnf$1", symbols: [] },
      { name: "objectInner$ebnf$1$subexpression$1", symbols: ["objectKeyValue", "_", { literal: "," }, "_"] },
      {
        name: "objectInner$ebnf$1",
        symbols: ["objectInner$ebnf$1", "objectInner$ebnf$1$subexpression$1"],
        postprocess: (d) => d[0].concat([d[1]])
      },
      { name: "objectInner$ebnf$2$subexpression$1", symbols: ["_", { literal: "," }] },
      { name: "objectInner$ebnf$2", symbols: ["objectInner$ebnf$2$subexpression$1"], postprocess: id },
      { name: "objectInner$ebnf$2", symbols: [], postprocess: () => null },
      {
        name: "objectInner",
        symbols: ["_", "objectInner$ebnf$1", "objectKeyValue", "objectInner$ebnf$2", "_"],
        postprocess: (data) => {
          const firstKeyValues = data[1].map(([keyValue]) => keyValue);
          const keyValues = [...firstKeyValues, data[2]];
          return keyValues;
        }
      },
      { name: "objectKeyValue$ebnf$1", symbols: [/[a-zA-Z]/] },
      {
        name: "objectKeyValue$ebnf$1",
        symbols: ["objectKeyValue$ebnf$1", /[a-zA-Z]/],
        postprocess: (d) => d[0].concat([d[1]])
      },
      {
        name: "objectKeyValue",
        symbols: ["objectKeyValue$ebnf$1", "_", { literal: ":" }, "_", "expression"],
        postprocess: (data) => ({ key: data[0].join(""), value: data[4] })
      },
      {
        name: "objectKeyValue",
        symbols: ["string", "_", { literal: ":" }, "_", "expression"],
        postprocess: (data) => ({ key: data[0].value, value: data[4] })
      },
      { name: "array$macrocall$2", symbols: ["expression"] },
      { name: "array$macrocall$1", symbols: ["_"], postprocess: () => [] },
      { name: "array$macrocall$1$ebnf$1", symbols: [] },
      { name: "array$macrocall$1$ebnf$1$subexpression$1", symbols: ["array$macrocall$2", "_", { literal: "," }, "_"] },
      {
        name: "array$macrocall$1$ebnf$1",
        symbols: ["array$macrocall$1$ebnf$1", "array$macrocall$1$ebnf$1$subexpression$1"],
        postprocess: (d) => d[0].concat([d[1]])
      },
      { name: "array$macrocall$1$ebnf$2$subexpression$1", symbols: ["_", { literal: "," }] },
      { name: "array$macrocall$1$ebnf$2", symbols: ["array$macrocall$1$ebnf$2$subexpression$1"], postprocess: id },
      { name: "array$macrocall$1$ebnf$2", symbols: [], postprocess: () => null },
      {
        name: "array$macrocall$1",
        symbols: ["_", "array$macrocall$1$ebnf$1", "array$macrocall$2", "array$macrocall$1$ebnf$2", "_"],
        postprocess: (data) => {
          const firstArray = data[1].map(([expression]) => expression[0]);
          return [...firstArray, data[2][0]];
        }
      },
      {
        name: "array",
        symbols: [{ literal: "[" }, "array$macrocall$1", { literal: "]" }],
        postprocess: (data) => data[1]
      },
      { name: "byteArray$macrocall$2", symbols: ["typedByte"] },
      { name: "byteArray$macrocall$1", symbols: ["_"], postprocess: () => [] },
      { name: "byteArray$macrocall$1$ebnf$1", symbols: [] },
      {
        name: "byteArray$macrocall$1$ebnf$1$subexpression$1",
        symbols: ["byteArray$macrocall$2", "_", { literal: "," }, "_"]
      },
      {
        name: "byteArray$macrocall$1$ebnf$1",
        symbols: ["byteArray$macrocall$1$ebnf$1", "byteArray$macrocall$1$ebnf$1$subexpression$1"],
        postprocess: (d) => d[0].concat([d[1]])
      },
      { name: "byteArray$macrocall$1$ebnf$2$subexpression$1", symbols: ["_", { literal: "," }] },
      {
        name: "byteArray$macrocall$1$ebnf$2",
        symbols: ["byteArray$macrocall$1$ebnf$2$subexpression$1"],
        postprocess: id
      },
      { name: "byteArray$macrocall$1$ebnf$2", symbols: [], postprocess: () => null },
      {
        name: "byteArray$macrocall$1",
        symbols: ["_", "byteArray$macrocall$1$ebnf$1", "byteArray$macrocall$2", "byteArray$macrocall$1$ebnf$2", "_"],
        postprocess: (data) => {
          const firstArray = data[1].map(([expression]) => expression[0]);
          return [...firstArray, data[2][0]];
        }
      },
      {
        name: "byteArray",
        symbols: [
          { literal: "[" },
          "_",
          { literal: "B" },
          "_",
          { literal: ";" },
          "byteArray$macrocall$1",
          { literal: "]" }
        ],
        postprocess: (data) => ({ dataType: "byteArray", value: data[5] })
      },
      { name: "intArray$macrocall$2", symbols: ["number"] },
      { name: "intArray$macrocall$1", symbols: ["_"], postprocess: () => [] },
      { name: "intArray$macrocall$1$ebnf$1", symbols: [] },
      {
        name: "intArray$macrocall$1$ebnf$1$subexpression$1",
        symbols: ["intArray$macrocall$2", "_", { literal: "," }, "_"]
      },
      {
        name: "intArray$macrocall$1$ebnf$1",
        symbols: ["intArray$macrocall$1$ebnf$1", "intArray$macrocall$1$ebnf$1$subexpression$1"],
        postprocess: (d) => d[0].concat([d[1]])
      },
      { name: "intArray$macrocall$1$ebnf$2$subexpression$1", symbols: ["_", { literal: "," }] },
      { name: "intArray$macrocall$1$ebnf$2", symbols: ["intArray$macrocall$1$ebnf$2$subexpression$1"], postprocess: id },
      { name: "intArray$macrocall$1$ebnf$2", symbols: [], postprocess: () => null },
      {
        name: "intArray$macrocall$1",
        symbols: ["_", "intArray$macrocall$1$ebnf$1", "intArray$macrocall$2", "intArray$macrocall$1$ebnf$2", "_"],
        postprocess: (data) => {
          const firstArray = data[1].map(([expression]) => expression[0]);
          return [...firstArray, data[2][0]];
        }
      },
      {
        name: "intArray",
        symbols: [
          { literal: "[" },
          "_",
          { literal: "I" },
          "_",
          { literal: ";" },
          "intArray$macrocall$1",
          { literal: "]" }
        ],
        postprocess: (data) => ({ dataType: "intArray", value: data[5] })
      },
      { name: "longArray$macrocall$2", symbols: ["typedLong"] },
      { name: "longArray$macrocall$1", symbols: ["_"], postprocess: () => [] },
      { name: "longArray$macrocall$1$ebnf$1", symbols: [] },
      {
        name: "longArray$macrocall$1$ebnf$1$subexpression$1",
        symbols: ["longArray$macrocall$2", "_", { literal: "," }, "_"]
      },
      {
        name: "longArray$macrocall$1$ebnf$1",
        symbols: ["longArray$macrocall$1$ebnf$1", "longArray$macrocall$1$ebnf$1$subexpression$1"],
        postprocess: (d) => d[0].concat([d[1]])
      },
      { name: "longArray$macrocall$1$ebnf$2$subexpression$1", symbols: ["_", { literal: "," }] },
      {
        name: "longArray$macrocall$1$ebnf$2",
        symbols: ["longArray$macrocall$1$ebnf$2$subexpression$1"],
        postprocess: id
      },
      { name: "longArray$macrocall$1$ebnf$2", symbols: [], postprocess: () => null },
      {
        name: "longArray$macrocall$1",
        symbols: ["_", "longArray$macrocall$1$ebnf$1", "longArray$macrocall$2", "longArray$macrocall$1$ebnf$2", "_"],
        postprocess: (data) => {
          const firstArray = data[1].map(([expression]) => expression[0]);
          return [...firstArray, data[2][0]];
        }
      },
      {
        name: "longArray",
        symbols: [
          { literal: "[" },
          "_",
          { literal: "L" },
          "_",
          { literal: ";" },
          "longArray$macrocall$1",
          { literal: "]" }
        ],
        postprocess: (data) => ({ dataType: "longArray", value: data[5] })
      },
      { name: "string$subexpression$1", symbols: ["dqstring"] },
      { name: "string$subexpression$1", symbols: ["sqstring"] },
      {
        name: "string",
        symbols: ["string$subexpression$1"],
        postprocess: (data) => ({ dataType: "string", value: data[0][0] })
      },
      { name: "typedNum$subexpression$1", symbols: ["typedByte"] },
      { name: "typedNum$subexpression$1", symbols: ["typedShort"] },
      { name: "typedNum$subexpression$1", symbols: ["typedLong"] },
      { name: "typedNum$subexpression$1", symbols: ["typedFloat"] },
      { name: "typedNum", symbols: ["typedNum$subexpression$1"], postprocess: (data) => data[0][0] },
      {
        name: "typedByte$subexpression$1",
        symbols: [/[bB]/],
        postprocess(d) {
          return d.join("");
        }
      },
      {
        name: "typedByte",
        symbols: ["int", "typedByte$subexpression$1"],
        postprocess: (data) => ({ dataType: "byte", value: data[0] })
      },
      {
        name: "typedShort$subexpression$1",
        symbols: [/[sS]/],
        postprocess(d) {
          return d.join("");
        }
      },
      {
        name: "typedShort",
        symbols: ["int", "typedShort$subexpression$1"],
        postprocess: (data) => ({ dataType: "short", value: data[0] })
      },
      {
        name: "typedLong$subexpression$1",
        symbols: [/[lL]/],
        postprocess(d) {
          return d.join("");
        }
      },
      {
        name: "typedLong",
        symbols: ["int", "typedLong$subexpression$1"],
        postprocess: (data) => ({ dataType: "long", value: data[0] })
      },
      {
        name: "typedFloat$subexpression$1",
        symbols: [/[dD]/],
        postprocess(d) {
          return d.join("");
        }
      },
      {
        name: "typedFloat",
        symbols: ["decimal", "typedFloat$subexpression$1"],
        postprocess: (data) => ({ dataType: "double", value: data[0] })
      },
      {
        name: "typedFloat$subexpression$2",
        symbols: [/[fF]/],
        postprocess(d) {
          return d.join("");
        }
      },
      {
        name: "typedFloat",
        symbols: ["decimal", "typedFloat$subexpression$2"],
        postprocess: (data) => ({ dataType: "float", value: data[0] })
      },
      { name: "number$subexpression$1", symbols: ["decimal"] },
      {
        name: "number",
        symbols: ["number$subexpression$1"],
        postprocess: (data) => ({ dataType: "number", value: data[0][0] })
      },
      {
        name: "boolean$subexpression$1$string$1",
        symbols: [{ literal: "t" }, { literal: "r" }, { literal: "u" }, { literal: "e" }],
        postprocess: (d) => d.join("")
      },
      { name: "boolean$subexpression$1", symbols: ["boolean$subexpression$1$string$1"] },
      {
        name: "boolean$subexpression$1$string$2",
        symbols: [{ literal: "f" }, { literal: "a" }, { literal: "l" }, { literal: "s" }, { literal: "e" }],
        postprocess: (d) => d.join("")
      },
      { name: "boolean$subexpression$1", symbols: ["boolean$subexpression$1$string$2"] },
      {
        name: "boolean",
        symbols: ["boolean$subexpression$1"],
        postprocess: (data) => ({ dataType: "boolean", value: data[0].join("") === "true" })
      }
    ],
    ParserStart: "expression"
  };
  grammar_default = grammar;
});

// src/variables/nbt/parser.ts
import nearley from "nearley";
function isCompoundNbt(nbt) {
  return !!nbt[isCompoundSymbol];
}
function parseRaw(nbt) {
  const parser = new nearley.Parser(nearley.Grammar.fromCompiled(grammar_default));
  parser.feed(nbt);
  parser.finish();
  return parser.results[0];
}
function parseExpression(NBT, nbt) {
  if (Array.isArray(nbt)) {
    return nbt.map((x) => parseExpression(NBT, x));
  }
  if (typeof nbt === "object") {
    if (isCompoundNbt(nbt)) {
      return Object.keys(nbt).reduce((acc, key) => {
        acc[key] = parseExpression(NBT, nbt[key]);
        return acc;
      }, {});
    }
    switch (nbt.dataType) {
      case "byte":
        return NBT.byte(nbt.value);
      case "short":
        return NBT.short(nbt.value);
      case "long":
        return NBT.long(nbt.value);
      case "float":
        return NBT.float(nbt.value);
      case "double":
        return NBT.double(nbt.value);
      case "number":
        return nbt.value;
      case "string":
        return nbt.value;
      case "byteArray":
        return NBT.byteArray(nbt.value.map((x) => x.value));
      case "intArray":
        return NBT.intArray(nbt.value.map((x) => x.value));
      case "longArray":
        return NBT.longArray(nbt.value.map((x) => x.value));
    }
  }
  throw new Error(`Unrecognized data type: ${nbt.dataType}`);
}
function parseNBT(NBT, nbt) {
  const rawResult = parseRaw(nbt);
  return parseExpression(NBT, rawResult);
}
var init_parser = __esm(() => {
  init_grammar();
});

// src/variables/nbt/NBTs.ts
import * as util2 from "util";

function customNumber(num, _class) {
  if (Array.isArray(num)) {
    return num.map((n) => new _class(n));
  }
  return new _class(num);
}
function dynamicNBT(template, ...args) {
  const mixedArgs = template.flatMap((s, i) => [s, args[i]]).slice(0, -1);
  const result = mixedArgs.map((element) => element instanceof NBTClass ? nbtResolver(element).toString() : element.toString()).join("");
  return parseNBT(NBT, result);
}

class ResolvedNBT {
  value;
  containsMacro;
  constructor(value, containsMacro) {
    this.value = value;
    this.containsMacro = containsMacro;
  }
  toString() {
    return this.value;
  }
}
var NBTPrimitive, NBTLong, NBTByte, NBTShort, NBTFloat, NBTInt, NBTDouble, NBTTypedArray, NBTLongArray, NBTByteArray, NBTIntArray, NotNBT, NBTString, NBTAnyValue, NBT, resolve = (nbt) => {
  if (nbt === null || nbt === undefined) {
    throw new Error("Nullish nbt values are not allowed");
  }
  if (typeof nbt === "number") {
    return new ResolvedNBT(`${nbt}d`, false);
  }
  if (typeof nbt === "boolean") {
    return new ResolvedNBT(nbt.toString(), false);
  }
  if (typeof nbt === "string") {
    const inspectedStr = util2.inspect(nbt, {
      breakLength: Number.POSITIVE_INFINITY,
      compact: true,
      maxStringLength: Number.POSITIVE_INFINITY,
      depth: Number.POSITIVE_INFINITY
    });
    if (inspectedStr[0] === "`") {
      return new ResolvedNBT(JSON.stringify(nbt), false);
    }
    return new ResolvedNBT(inspectedStr, false);
  }
  if (Array.isArray(nbt)) {
    let containsMacro2 = false;
    const itemsStr = nbt.map((item) => {
      const resolved = resolve(item);
      if (resolved.containsMacro)
        containsMacro2 = true;
      return resolved.value;
    }).join(",");
    return new ResolvedNBT(`[${itemsStr}]`, containsMacro2);
  }
  if (nbt instanceof NBTClass) {
    return new ResolvedNBT(nbt[util2.inspect.custom](), false);
  }
  if (typeof nbt === "object" || typeof nbt === "function") {
    let failedMacro = false;
    if ("toMacro" in nbt) {
      const macro = nbt.toMacro();
      if (macro === "$()") {
        failedMacro = true;
      } else {
        return new ResolvedNBT(macro, true);
      }
    }
    if ("toNBT" in nbt) {
      const toNbtResult = nbt.toNBT();
      if (toNbtResult instanceof ResolvedNBT) {
        return toNbtResult;
      }
      return new ResolvedNBT(String(toNbtResult), false);
    } else if (failedMacro) {
      throw new Error("[nbtResolver] A macro variable NBT insertion was attempted in an mcfunction without macros defined.");
    }
    if (typeof nbt === "function") {
      throw new Error(`[nbtResolver] This should never happen. A function or callable instance (${nbt.constructor?.name}) without toNBT was passed in as an NBT value.`);
    }
    if (nbt.constructor.name !== "Object") {
      if ("toString" in nbt) {
        return new ResolvedNBT(`'${nbt}'`, false);
      } else {
        throw new Error(`[nbtResolver] A ${nbt.constructor?.name} was passed in as an NBT value. Hint: define toNBT or toString if this was intentional`);
      }
    }
  }
  let containsMacro = false;
  const objectStr = Object.entries(nbt).map(([key, value]) => {
    const resolved = resolve(value);
    if (resolved.containsMacro)
      containsMacro = true;
    return `${formatKey(key)}:${resolved.value}`;
  }).join(",");
  return new ResolvedNBT(`{${objectStr}}`, containsMacro);
}, SNBT_KEY_REQUIRED_QUOTE_CHARS, formatKey = (key) => {
  if (key.startsWith('"') && key.endsWith('"') || key.startsWith("'") && key.endsWith("'")) {
    return key;
  }
  if (!SNBT_KEY_REQUIRED_QUOTE_CHARS.test(key)) {
    return key;
  }
  if (key.includes("'")) {
    if (key.includes('"')) {
      return `'${key.replace(/'/g, "\\'")}'`;
    }
    return `"${key}"`;
  }
  return `'${key}'`;
}, nbtResolver = (nbt) => resolve(nbt);
var init_NBTs = __esm(() => {
  init_utils();
  init_parser();
                              NBT = makeCallable({
    int: (num) => customNumber(num, NBTInt),
    float: (num) => customNumber(num, NBTFloat),
    double: (num) => customNumber(num, NBTDouble),
    byte: (num) => customNumber(num, NBTByte),
    short: (num) => customNumber(num, NBTShort),
    long: (num) => customNumber(num, NBTLong),
    intArray: (numbers) => new NBTIntArray(numbers),
    longArray: (numbers) => new NBTLongArray(numbers),
    byteArray: (numbers) => new NBTByteArray(numbers),
    not: (nbt) => new NotNBT(nbt),
    stringify: (nbt) => nbtResolver(nbt).toString(),
    parse: (nbt) => parseNBT(NBT, nbt)
  }, dynamicNBT);
  SNBT_KEY_REQUIRED_QUOTE_CHARS = /[:,;.\[\]{}'"]/;
});

// src/variables/parsers.ts
function coordinatesParser(coordinates) {
  if (Array.isArray(coordinates)) {
    if (coordinates.length === 3 || coordinates.length === 2) {
      return new VectorClass(coordinates.map((coord) => {
        if (typeof coord === "string") {
          return coord;
        }
        if (typeof coord === "number") {
          return `${coord}`;
        }
        if ("toMacro" in coord) {
          return coord.toMacro();
        }
        throw new Error(`[coordinatesParser] Unsupported vector component ${coord}`);
      }));
    }
    throw new Error(`[coordinatesParser] Unsupported vector size ${coordinates.length}`);
  } else {
    return coordinates;
  }
}
function rotationParser(rotation) {
  if (Array.isArray(rotation)) {
    if (rotation.length === 2) {
      return new VectorClass(rotation.map((coord) => {
        if (typeof coord === "string") {
          return coord;
        }
        if (typeof coord === "number") {
          return `${coord}`;
        }
        if ("toMacro" in coord) {
          return coord.toMacro();
        }
        throw new Error(`[rotationParser] Unsupported vector component ${coord}`);
      }));
    }
    throw new Error(`[rotationParser] Unsupported vector size ${rotation.length}`);
  } else {
    return rotation;
  }
}
function targetParser(target) {
  if (target === undefined) {
    throw new Error("Target cannot be undefined.");
  }
  if (typeof target === "string") {
    return target;
  }
  if (target._toSelector) {
    return target._toSelector();
  }
  if (target.toMacro) {
    return target;
  }
  return target.toString();
}
var sanitizeValue = (core, value) => {
  if (value === undefined || value === null) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  if (isMacroArgument(core, value)) {
    return value.toMacro();
  }
  if (Number.isFinite(value)) {
    return value.toString();
  }
  return "";
}, rangeParser = (core, range) => {
  if (Array.isArray(range)) {
    return `${sanitizeValue(core, range[0])}..${sanitizeValue(core, range[1])}`;
  }
  return range.toString();
}, structureRotationParser = (rotation) => {
  if (!rotation) {
    return "none";
  }
  if (typeof rotation === "object") {
    return rotation;
  }
  const numToLiteral = (angle) => {
    switch (angle) {
      case 0:
        return "none";
      case 90:
        return "clockwise_90";
      case 180:
        return "180";
      case 270:
        return "counterclockwise_90";
      case -90:
        return "counterclockwise_90";
      case -180:
        return "180";
      case -270:
        return "clockwise_90";
      default: {
        if (!Number.isInteger(angle / 90)) {
          throw new Error("Structure rotation must be in increments of 90!");
        }
        angle %= 360;
        angle = (angle + 360) % 360;
        if (angle > 180)
          angle -= 360;
        return numToLiteral(angle);
      }
    }
  };
  if (typeof rotation === "number") {
    return numToLiteral(rotation);
  }
  if (rotation === "clockwise_90" || rotation === "counterclockwise_90") {
    return rotation;
  }
  return numToLiteral(Number(rotation));
}, structureMirrorParser = (mirror) => {
  if (typeof mirror === "object") {
    return mirror.toMacro();
  }
  if (typeof mirror === "string") {
    const lastCharacter = mirror.slice(0, -1);
    if (lastCharacter === "x") {
      return "left_right";
    }
    if (lastCharacter === "z") {
      return "front_back";
    }
    return mirror;
  }
  if (mirror) {
    return "left_right";
  }
  return "none";
};
var init_parsers = __esm(() => {
  init_Macro();
  init_Coordinates();
});

// src/variables/Score.ts
import * as util3 from "util";
function createVariable(pack, ...args) {
  const anonymousScore = pack.Variable();
  if (typeof args[0] === "number" || args[0] instanceof Score) {
    return anonymousScore.set(args[0]);
  }
  return anonymousScore.set(args[0], args[1]);
}
var matchers = 0, Score;
var init_Score = __esm(() => {
  init_variables2();
  init_Macro();
  init_utils();
  init_abstractClasses();
  init_parsers();
  });

// src/variables/Data.ts
function NBTpathToString(pack, paths) {
  const parsedPaths = [];
  const parsedMacros = [undefined];
  let hasMacro = false;
  for (const [i, path] of paths.entries()) {
    if (typeof path === "object") {
      if (isMacroArgument(pack.core, path)) {
        hasMacro = true;
        if (Object.hasOwn(path, "macros")) {
          const { strings, macros } = path;
          for (const [j, macro] of macros.entries()) {
            parsedPaths.push(strings[j]);
            if (typeof macro === "string" || typeof macro === "number") {
              parsedPaths.push(`${macro}`);
            } else {
              parsedMacros.push(macro);
            }
          }
          const last = strings[strings.length - 1];
          if (last !== "")
            parsedPaths.push(`${last}.`);
        } else {
          parsedMacros.push(path);
        }
      } else if (Array.isArray(path) && path.length === 1 && typeof path[0] === "number" && Number.isInteger(path[0])) {
        parsedPaths.push(`[${path[0]}]`);
      } else {
        parsedPaths.push(nbtResolver(path).toString());
      }
    } else if (path !== "") {
      parsedPaths.push(`${path}${i === paths.length - 1 ? "" : "."}`);
    }
  }
  if (hasMacro) {
    return new MacroLiteral(pack.core, parsedPaths, parsedMacros);
  }
  return parsedPaths.join("");
}

class TargetlessDataClass {
  sandstonePack;
  type;
  constructor(sandstonePack, type) {
    this.sandstonePack = sandstonePack;
    this.type = type;
  }
  target = (target) => {
    return new DataClass(this.sandstonePack, this.type, target);
  };
  select = (...path) => new TargetlessDataPointClass(this.sandstonePack, this.type, path);
}

class TargetlessDataPointClass {
  sandstonePack;
  type;
  path;
  constructor(sandstonePack, type, path) {
    this.sandstonePack = sandstonePack;
    this.type = type;
    this.path = NBTpathToString(sandstonePack, path);
  }
  target = (target) => {
    return new DataPointClass(this.sandstonePack, this.type, target, [this.path]);
  };
  select = (...path) => new TargetlessDataPointClass(this.sandstonePack, this.type, [this.path, ...path]);
}

class DataClass {
  sandstonePack;
  type;
  currentTarget;
  constructor(sandstonePack, type, target) {
    this.sandstonePack = sandstonePack;
    this.type = type;
    this.currentTarget = target;
  }
  merge = (value) => {
    this.sandstonePack.commands.data.merge[this.type](this.currentTarget, value);
  };
  target = (target) => new DataClass(this.sandstonePack, this.type, target);
  select = (...path) => new DataPointClass(this.sandstonePack, this.type, this.currentTarget, path);
  toString = () => this.currentTarget.toString();
  toJSON = this.toString;
}
var DataPointClass, StringDataPointClass;
var init_Data = __esm(() => {
  init_Macro();
  init_NBTs();
  init_Score();
    });
// src/arguments/basics.ts
class _ShowAlias {
  toNBT() {
    throw new Error("You're not supposed to use the _ShowAlias class directly");
  }
}
function getResourceTypeFromInstance(instance) {
  const entry = RESOURCE_CLASS_TYPES.find(([c]) => instance instanceof c);
  if (!entry) {
    throw new Error(`Unknown resource class: ${instance.constructor.name}`);
  }
  return entry[1];
}
var init_basics = __esm(() => {
  init_arguments();
});
// src/pack/packType.ts

// src/pack/dependencies.ts
var DataPackDependencies, ResourcePackDependencies;
var init_dependencies = __esm(() => {
    });

// src/core/nodes.ts
import * as util4 from "util";
var Node, ContainerNode, CommandNode, ContainerCommandNode, AwaitNode;
var init_nodes = __esm(() => {
  init_NBTs();
  init_utils();
  init_Macro();
          });

// src/commands/helpers.ts
class FinalCommandOutput {
  node;
  constructor(node) {
    this.node = node;
  }
}


// src/commands/implementations/_fake/comment.ts
var CommentCommandNode, CommentCommand;
var init_comment = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/_fake/raw.ts
var RawCommandNode, RawCommand;
var init_raw = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/block/clone.ts
var CloneCommandNode, CloneCommand, CloneFromDimensionCommand, CloneToDimensionCommand, CloneOptionsCommand, CloneStrictOptionsCommand, CloneModeCommand;
var init_clone = __esm(() => {
  init_nodes();
  init_parsers();
              });

// src/commands/implementations/block/setblock.ts
function blockStateStringifier(state) {
  let resultPairs = [];
  for (const [key, value] of Object.entries(state)) {
    resultPairs.push(`${key}=${value}`);
  }
  return `[${resultPairs.join(",")}]`;
}
var SetBlockCommandNode, SetBlockCommand;
var init_setblock = __esm(() => {
  init_nodes();
  init_variables2();
    });

// src/commands/implementations/block/fill.ts
var FillCommandNode, FillCommand, FillArgumentsCommand, FillReplaceFilterCommand;
var init_fill = __esm(() => {
  init_nodes();
  init_variables2();
  init_setblock();
        });

// src/commands/validators.ts
function validateIntegerRange(integer, name, minimum = 0, maximum = 2147483647) {
  if (typeof integer !== "number") {
    return integer;
  }
  if (integer && integer <= minimum) {
    throw new Error(`\`${name}\` must be greater than or equal to ${minimum.toLocaleString()}, got \`${integer.toLocaleString()}\`.`);
  }
  if (integer && integer >= maximum) {
    throw new Error(`\`${name}\` must be lower than or equal to ${maximum.toLocaleString()}, got \`${integer.toLocaleString()}\`.`);
  }
  return integer;
}

// src/commands/implementations/block/place.ts
var PlaceCommandNode, PlaceCommand;
var init_place = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/entity/attribute.ts
var AttributeCommandNode, AttributeCommand, AttributeOperationCommand;
var init_attribute = __esm(() => {
  init_nodes();
  init_parsers();
      });

// src/commands/implementations/player/clear.ts
var ClearCommandNode, ClearCommand;
var init_clear = __esm(() => {
  init_Macro();
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/entity/damage.ts
var DamageCommandNode, DamageCauseCommand, DamageSourceCommand, DamageCommand;
var init_damage = __esm(() => {
  init_nodes();
  init_parsers();
        });

// src/commands/implementations/entity/effect.ts
var EffectCommandNode, EffectCommand;
var init_effect = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/entity/enchant.ts
var EnchantCommandNode, EnchantCommand;
var init_enchant = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/context.ts
function setSandstoneContext(ctx) {
  _context = ctx;
}
function getSandstoneContext() {
  if (!_context) {
    throw new Error("Sandstone context not initialized. Make sure you are running through the Sandstone CLI (sand build/watch).");
  }
  return _context;
}
function hasContext() {
  return _context !== undefined;
}
function resetContext() {
  _context = undefined;
}
var _context;

// src/arguments/generated/resource-paths.ts
var RESOURCE_PATHS;
var init_resource_paths = __esm(() => {
  RESOURCE_PATHS = {
    advancement: { path: ["advancement"], pack: "data", ext: ".json" },
    function: { path: ["function"], pack: "data", ext: ".mcfunction" },
    item_modifier: { path: ["item_modifier"], pack: "data", ext: ".json" },
    loot_table: { path: ["loot_table"], pack: "data", ext: ".json" },
    predicate: { path: ["predicate"], pack: "data", ext: ".json" },
    recipe: { path: ["recipe"], pack: "data", ext: ".json" },
    structure: { path: ["structure"], pack: "data", ext: ".nbt" },
    banner_pattern: { path: ["banner_pattern"], pack: "data", ext: ".json" },
    cat_sound_variant: { path: ["cat_sound_variant"], pack: "data", ext: ".json" },
    cat_variant: { path: ["cat_variant"], pack: "data", ext: ".json" },
    chat_type: { path: ["chat_type"], pack: "data", ext: ".json" },
    chicken_sound_variant: { path: ["chicken_sound_variant"], pack: "data", ext: ".json" },
    chicken_variant: { path: ["chicken_variant"], pack: "data", ext: ".json" },
    cow_sound_variant: { path: ["cow_sound_variant"], pack: "data", ext: ".json" },
    cow_variant: { path: ["cow_variant"], pack: "data", ext: ".json" },
    decorated_pot_pattern: { path: ["decorated_pot_pattern"], pack: "data", ext: ".json" },
    damage_type: { path: ["damage_type"], pack: "data", ext: ".json" },
    dialog: { path: ["dialog"], pack: "data", ext: ".json" },
    enchantment: { path: ["enchantment"], pack: "data", ext: ".json" },
    enchantment_provider: { path: ["enchantment_provider"], pack: "data", ext: ".json" },
    frog_variant: { path: ["frog_variant"], pack: "data", ext: ".json" },
    instrument: { path: ["instrument"], pack: "data", ext: ".json" },
    jukebox_song: { path: ["jukebox_song"], pack: "data", ext: ".json" },
    number_provider: { path: ["number_provider"], pack: "data", ext: ".json" },
    painting_variant: { path: ["painting_variant"], pack: "data", ext: ".json" },
    pig_sound_variant: { path: ["pig_sound_variant"], pack: "data", ext: ".json" },
    pig_variant: { path: ["pig_variant"], pack: "data", ext: ".json" },
    slot_source: { path: ["slot_source"], pack: "data", ext: ".json" },
    sulfur_cube_archetype: { path: ["sulfur_cube_archetype"], pack: "data", ext: ".json" },
    test_instance: { path: ["test_instance"], pack: "data", ext: ".json" },
    test_environment: { path: ["test_environment"], pack: "data", ext: ".json" },
    timeline: { path: ["timeline"], pack: "data", ext: ".json" },
    trade_set: { path: ["trade_set"], pack: "data", ext: ".json" },
    trial_spawner: { path: ["trial_spawner"], pack: "data", ext: ".json" },
    trim_pattern: { path: ["trim_pattern"], pack: "data", ext: ".json" },
    trim_material: { path: ["trim_material"], pack: "data", ext: ".json" },
    villager_trade: { path: ["villager_trade"], pack: "data", ext: ".json" },
    wolf_sound_variant: { path: ["wolf_sound_variant"], pack: "data", ext: ".json" },
    wolf_variant: { path: ["wolf_variant"], pack: "data", ext: ".json" },
    world_clock: { path: ["world_clock"], pack: "data", ext: ".json" },
    zombie_nautilus_variant: { path: ["zombie_nautilus_variant"], pack: "data", ext: ".json" },
    dimension: { path: ["dimension"], pack: "data", ext: ".json" },
    dimension_type: { path: ["dimension_type"], pack: "data", ext: ".json" },
    atlas: { path: ["atlases"], pack: "assets", ext: ".json" },
    block_definition: { path: ["blockstates"], pack: "assets", ext: ".json" },
    equipment: { path: ["equipment"], pack: "assets", ext: ".json" },
    font: { path: ["font"], pack: "assets", ext: ".json" },
    "font/ttf": { path: ["font"], pack: "assets", ext: ".ttf" },
    "font/otf": { path: ["font"], pack: "assets", ext: ".otf" },
    "font/unihex": { path: ["font"], pack: "assets", ext: ".zip" },
    item_definition: { path: ["items"], pack: "assets", ext: ".json" },
    lang: { path: ["lang"], pack: "assets", ext: ".json" },
    "lang/deprecated": { path: ["lang"], pack: "assets", ext: ".json" },
    model: { path: ["models"], pack: "assets", ext: ".json" },
    particle: { path: ["particles"], pack: "assets", ext: ".json" },
    post_effect: { path: ["post_effect"], pack: "assets", ext: ".json" },
    shader: { path: ["shaders"], pack: "assets", ext: ".json" },
    "shader/fragment": { path: ["shaders"], pack: "assets", ext: ".fsh" },
    "shader/vertex": { path: ["shaders"], pack: "assets", ext: ".vsh" },
    sound: { path: ["sounds"], pack: "assets", ext: ".ogg" },
    texture: { path: ["textures"], pack: "assets", ext: ".png" },
    texture_meta: { path: ["textures"], pack: "assets", ext: ".png.mcmeta" },
    waypoint_style: { path: ["waypoint_style"], pack: "assets", ext: ".json" },
    sounds: { path: [], pack: "assets", ext: ".json" },
    regional_compliancies: { path: [], pack: "assets", ext: ".json" },
    gpu_warnlist: { path: [], pack: "assets", ext: ".json" },
    tag: { path: ["tags", true], pack: "data", ext: ".json" }
  };
});

// src/core/resources/resource.ts

class ListResource {
  push(..._args) {}
  unshift(..._args) {}
}
function jsonStringify(json, resourceType) {
  return JSON.stringify(json, function(key, value) {
    if ((typeof value === "object" || typeof value === "function") && value.constructor.name !== "Object" && "toResourceJSON" in value) {
      return value.toResourceJSON(key, this, resourceType, json);
    }
    return value;
  }, 2);
}
var CallableResourceClass, ResourceNodesMap;
var init_resource = __esm(() => {
  init_resource_paths();
    });

// src/core/resources/custom.ts
var CustomResourceNode, CustomResourceClass;
var init_custom = __esm(() => {
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/advancement.ts
var AdvancementNode, AdvancementClass;
var init_advancement = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/bannerPattern.ts
var BannerPatternNode, BannerPatternClass;
var init_bannerPattern = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/chatType.ts
var ChatTypeNode, ChatTypeClass;
var init_chatType = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/damageType.ts
var damageTypes, DamageTypeNode, DamageTypeClass;
var init_damageType = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
  damageTypes = new Map;
    });

// src/core/resources/datapack/decoratedPotPattern.ts
var DecoratedPotPatternNode, DecoratedPotPatternClass;
var init_decoratedPotPattern = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/dialog.ts
var DialogNode, DialogClass;
var init_dialog = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/enchantment.ts
var EnchantmentNode, EnchantmentClass, EnchantmentProviderNode, EnchantmentProviderClass;
var init_enchantment = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
        });

// src/core/resources/datapack/gametest.ts
var TestEnvironmentNode, TestEnvironmentClass, TestInstanceNode, TestInstanceClass;
var init_gametest = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
        });

// src/core/resources/datapack/instrument.ts
var InstrumentNode, InstrumentClass;
var init_instrument = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/itemModifier.ts
var ItemModifierNode, ItemModifierClass;
var init_itemModifier = __esm(() => {
  init_arguments();
  init_parsers();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/jukeboxSong.ts
var JukeboxSongNode, JukeboxSongClass;
var init_jukeboxSong = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/lootTable.ts
var LootTableNode, LootTableClass;
var init_lootTable = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/variables/nbt/index.ts
var init_nbt = __esm(() => {
  init_NBTs();
  init_parser();
});

// src/variables/ResolveNBT.ts
import * as util5 from "util";
function ResolveNBTPart(value, option1, option2) {
  if (Array.isArray(value)) {
    return new ResolveNBTPartClass(value, "scores", option2 || NBTIntArray, option1 || 1);
  }
  if (value instanceof Score) {
    return new ResolveNBTPartClass(value, "score", option2 || NBTInt, option1 || 1);
  }
  return new ResolveNBTPartClass(value, "data", option1 || NBTAnyValue);
}
var ResolveNBTNode, ResolveNBTClass, ResolveNBTPartClass;
var init_ResolveNBT = __esm(() => {
  init_Macro();
  init_nodes();
  init_utils();
  init_Data();
  init_nbt();
  init_Score();
      });

// src/core/resources/datapack/tag.ts
function isMCFunctionClass(v) {
  return typeof v === "function" && Object.hasOwn(v, "addToTag");
}
function isResource(v) {
  return v instanceof ResourceClass;
}
function isTagClass(v) {
  return v instanceof TagClass;
}
function objectToString(value) {
  if (isMCFunctionClass(value)) {
    if (value.env && value.callback.length < 2) {
      return value.node.sandstoneCore.pack.MCFunction(`${value.name}/_env`, () => value(), {
        creator: "sandstone",
        onConflict: "rename"
      }).name;
    }
    return value.name;
  }
  if (isTagClass(value)) {
    return value.toJSON();
  }
  if (isResource(value)) {
    return value.name;
  }
  if (typeof value === "object") {
    if (isMCFunctionClass(value.id)) {
      if (value.id.env && value.id.callback.length < 2) {
        return {
          id: value.id.node.sandstoneCore.pack.MCFunction(`${value.id.name}/_env`, () => value.id(), { creator: "sandstone", onConflict: "rename" }).name,
          required: value.required
        };
      }
      return {
        id: value.id.name,
        required: value.required
      };
    }
    if (isTagClass(value.id)) {
      return {
        id: value.id.toJSON(),
        required: value.required
      };
    }
    if (isResource(value.id)) {
      return value.id.name;
    }
  }
  return value;
}
var TagNode, TagClass;
var init_tag = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/mcfunction.ts
import * as util6 from "util";
var MCFunctionNode, _RawMCFunctionClass, MCFunctionClass;
var init_mcfunction = __esm(() => {
  init_utils();
  init_ResolveNBT();
  init_nodes();
  init_resource();
  init_tag();
      });

// src/core/resources/datapack/predicate.ts
var PredicateNode, PredicateClass;
var init_predicate = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/recipe.ts
var RecipeNode, RecipeClass;
var init_recipe = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/slotSource.ts
var SlotSourceNode, SlotSourceClass;
var init_slotSource = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/structure.ts
import lodash from "lodash";
import prismarine from "prismarine-nbt";
function encodeStructure(nbt) {
  const { comp, list, int, double, string, writeUncompressed } = prismarine;
  return writeUncompressed(comp({
    DataVersion: int(extractNumber(nbt.DataVersion)),
    size: list(comp(nbt.size.map((axis) => int(extractNumber(axis))))),
    blocks: list(comp(nbt.blocks.map((block) => ({
      state: int(extractNumber(block.state)),
      pos: list(comp(block.pos.map((axis) => int(extractNumber(axis)))))
    })))),
    entities: list(comp(nbt.entities.map((entity) => ({
      pos: list(comp(entity.pos.map((axis) => double(extractNumber(axis))))),
      blockPos: list(comp(entity.blockPos.map((axis) => int(extractNumber(axis)))))
    })))),
    ..."palette" in nbt ? {
      palette: list(comp(nbt.palette.map((block) => ({
        Name: string(typeof block === "string" ? block : block.id),
        Properties: list(comp(objectMap(typeof block === "string" ? {} : block.properties, (v, k) => [string(k), string(v)])))
      }))))
    } : {
      palettes: list(comp(nbt.palettes.map((palette) => palette.map((block) => ({
        Name: string(typeof block === "string" ? block : block.id),
        Properties: list(comp(objectMap(typeof block === "string" ? {} : block.properties, (v, k) => [string(k), string(v)])))
      })))))
    }
  }));
}
async function decodeStructure(buffer) {
  const nbt = await prismarine.parse(buffer);
  return prismarine.simplify(nbt.parsed);
}
var same, extractNumber = (double) => double instanceof NBTPrimitive ? double.value : double, diff = (num1, num2) => Math.sign(num1) === -1 ? (Math.abs(num1) - Math.abs(num2)) * -1 : num1 - num2, StructureNode, StructureClass, objectMap = (obj, fn) => Object.fromEntries(Object.entries(obj).map(([k, v], i) => fn(v, k, i)));
var init_structure = __esm(() => {
  init_arguments();
  init_utils();
  init_variables2();
  init_nodes();
  init_resource();
  same = lodash.isEqual;
    });

// src/core/resources/datapack/sulfurCubeArchetype.ts
var SulfurCubeArchetypeNode, SulfurCubeArchetypeClass;
var init_sulfurCubeArchetype = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/timeline.ts
var TimelineNode, TimelineClass, WorldClockNode, WorldClockClass;
var init_timeline = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
        });

// src/core/resources/datapack/trialSpawner.ts
var TrialSpawnerNode, TrialSpawnerClass;
var init_trialSpawner = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/trimMaterial.ts
var TrimMaterialNode, TrimMaterialClass;
var init_trimMaterial = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/trimPattern.ts
var TrimPatternNode, TrimPatternClass;
var init_trimPattern = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/variant.ts
var VariantNode, VariantClass;
var init_variant = __esm(() => {
  init_nodes();
  init_resource();
    });

// src/core/resources/datapack/villagerTrade.ts
var VillagerTradeNode, VillagerTradeClass, TradeSetNode, TradeSetClass;
var init_villagerTrade = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
        });

// src/core/resources/datapack/index.ts
var init_datapack = __esm(() => {
  init_advancement();
  init_bannerPattern();
  init_chatType();
  init_damageType();
  init_decoratedPotPattern();
  init_dialog();
  init_enchantment();
  init_gametest();
  init_instrument();
  init_itemModifier();
  init_jukeboxSong();
  init_lootTable();
  init_mcfunction();
  init_predicate();
  init_recipe();
  init_slotSource();
  init_structure();
  init_sulfurCubeArchetype();
  init_tag();
  init_timeline();
  init_trialSpawner();
  init_trimMaterial();
  init_trimPattern();
  init_variant();
  init_villagerTrade();
});

// src/core/resources/resourcepack/atlas.ts
var AtlasNode, AtlasClass;
var init_atlas = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/blockstate.ts
var BlockStateDefinitionNode, BlockStateDefinitionClass;
var init_blockstate = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/equipment.ts
var EquipmentNode, EquipmentClass;
var init_equipment = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/font.ts
var FontNode, FontClass;
var init_font = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/language.ts
var LanguageNode, LanguageClass;
var init_language = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/model.ts
var ModelNode, ModelClass;
var init_model = __esm(() => {
  init_nodes();
  init_resource();
  init_arguments();
    });

// src/core/resources/resourcepack/particle.ts
var ParticleNode, ParticleClass;
var init_particle = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/postEffect.ts
var PostEffectNode, PostEffectClass;
var init_postEffect = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/shader.ts
var ShaderNode, ShaderClass;
var init_shader = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/sound.ts
var SoundEventNode, SoundEventClass, SoundsIndexNode, SoundsIndexClass;
var init_sound = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
        });

// src/core/resources/resourcepack/text.ts
var PlainTextNode, PlainTextClass;
var init_text = __esm(() => {
  init_variables2();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/texture.ts
var TextureNode, TextureClass;
var init_texture = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/waypointStyle.ts
var WaypointStyleNode, WaypointStyleClass;
var init_waypointStyle = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
    });

// src/core/resources/resourcepack/index.ts
var init_resourcepack = __esm(() => {
  init_atlas();
  init_blockstate();
  init_equipment();
  init_font();
  init_itemDefinition();
  init_language();
  init_model();
  init_particle();
  init_postEffect();
  init_shader();
  init_sound();
  init_text();
  init_texture();
  init_waypointStyle();
});

// src/core/resources/index.ts
var init_resources = __esm(() => {
  init_custom();
  init_datapack();
  init_resource();
  init_resourcepack();
});

// src/core/mcmeta.ts
import path from "node:path";
import AdmZip from "adm-zip";
import fs2 from "fs-extra";
import lodash2 from "lodash";

class MCMetaCache {
  base = "/misode/mcmeta/";
  get path() {
    return path.join(getSandstoneContext().workingDir, "resources", "cache", "mcmeta");
  }
  get manifest() {
    return path.join(this.path, "..", "..", "mcmeta.json");
  }
  get lockFile() {
    return path.join(this.path, "..", "lock-mcmeta.json");
  }
  version = "latest";
  versionDate;
  branches = [];
  files = new Map;
  loaded = false;
  async load() {
    this.loaded = true;
    if (!await fs2.pathExists(this.manifest)) {
      return;
    }
    const manifest = JSON.parse(await fs2.readFile(this.manifest, "utf-8"));
    let uncached = false;
    this.version = manifest.version;
    const getZip = async (branch) => new AdmZip(Buffer.from(await (await fetch(`https://github.com${this.base}archive/refs/heads/${branch}.zip`)).arrayBuffer()));
    if (!await fs2.pathExists(this.lockFile)) {
      if (manifest.files.length > 10) {
        const archives = {};
        for await (const branch of manifest.branches) {
          archives[branch] = await getZip(branch);
        }
        for await (const [file, text2] of Object.entries(manifest.files)) {
          const _path = file.split("/");
          let contents = await new Promise((res, rej) => {
            archives[_path[0]].readFileAsync(_path.slice(1).join("/"), (data) => {
              if (data === null) {
                rej("[mcmeta] adm-zip got null");
              } else {
                res(data);
              }
            });
          });
          if (text2) {
            contents = contents.toString();
          }
          await safeWrite(path.join(this.path, file), contents);
          this.files.set(file, { contents, text: text2 });
        }
      } else {
        uncached = true;
        for await (const [file, text2] of Object.entries(manifest.files)) {
          const _path = file.split("/");
          await this.get(_path[0], _path.slice(1).join("/"), text2);
        }
      }
      await safeWrite(this.lockFile, JSON.stringify({
        files: manifest.files,
        version: manifest.version === "latest" ? await this.getVersion(false) : manifest.version,
        versionDate: this.versionDate
      }));
    } else {
      const lockFile = JSON.parse(await fs2.readFile(this.lockFile, "utf-8"));
      this.versionDate = lockFile.versionDate;
      const version = manifest.version === "latest" ? await this.getVersion(lockFile) : manifest.version;
      if (lockFile.version !== version) {
        if (manifest.files.length > 10) {
          const archives = {};
          for await (const branch of manifest.branches) {
            archives[branch] = await getZip(branch);
          }
          for await (const [file, text2] of Object.entries(manifest.files)) {
            const _path = file.split("/");
            let contents = await new Promise((res, rej) => {
              archives[_path[0]].readFileAsync(_path.slice(1).join("/"), (data) => {
                if (data === null) {
                  rej("[mcmeta] adm-zip got null");
                } else {
                  res(data);
                }
              });
            });
            if (text2) {
              contents = contents.toString();
            }
            await safeWrite(path.join(this.path, file), contents);
            this.files.set(file, { contents, text: text2 });
          }
        } else {
          uncached = true;
          for await (const [file, text2] of Object.entries(manifest.files)) {
            const _path = file.split("/");
            await this.get(_path[0], _path.slice(1).join("/"), text2);
          }
        }
      } else {
        const diff2 = lodash2.difference(Object.entries(manifest.files), Object.entries(lockFile.files));
        if (diff2.length !== 0) {
          if (diff2.length > 10) {
            const archives = {};
            for await (const [file, text2] of Object.entries(manifest.files)) {
              const _path = file.split("/");
              const branch = _path[0];
              if (!archives[branch]) {
                archives[branch] = await getZip(branch);
              }
              let contents = await new Promise((res, rej) => {
                archives[branch].readFileAsync(_path.slice(1).join("/"), (data) => {
                  if (data === null) {
                    rej("[mcmeta] adm-zip got null");
                  } else {
                    res(data);
                  }
                });
              });
              if (text2) {
                contents = contents.toString();
              }
              await safeWrite(path.join(this.path, file), contents);
              this.files.set(file, { contents, text: text2 });
            }
          } else {
            uncached = true;
            for await (const [file, text2] of diff2) {
              const _path = file.split("/");
              await this.get(_path[0], _path.slice(1).join("/"), text2);
            }
          }
        }
      }
      await safeWrite(this.lockFile, JSON.stringify({
        files: manifest.files,
        version: manifest.version === "latest" ? await this.getVersion(false) : manifest.version,
        versionDate: this.versionDate
      }));
    }
    this.branches = manifest.branches;
    if (!uncached) {
      for (const [file, text2] of Object.entries(manifest.files)) {
        this.files.set(file, { contents: false, text: text2 });
      }
    }
  }
  async save() {
    if (this.files.size !== 0) {
      const files = {};
      for (const [_path, { text: text2 }] of this.files.entries()) {
        files[_path] = text2;
      }
      await safeWrite(this.manifest, JSON.stringify({
        files,
        branches: this.branches,
        version: this.version
      }));
      await safeWrite(this.lockFile, JSON.stringify({
        files,
        version: this.version,
        versionDate: this.versionDate || Date.now()
      }));
    }
  }
  async get(branch, relativePath, text2 = true) {
    if (!this.loaded) {
      await this.load();
    }
    if (!this.branches.includes(branch)) {
      this.branches.push(branch);
    }
    const fullPath = path.join(branch, relativePath);
    const existing = this.files.get(fullPath);
    if (existing) {
      return existing.contents;
    }
    const req = await fetch(`https://raw.githubusercontent.com${this.base}${branch}/${relativePath}`);
    const file = text2 ? await req.text() : Buffer.from(await req.arrayBuffer());
    const finalPath = path.join(this.path, fullPath);
    await safeWrite(finalPath, file);
    return this.files.set(fullPath, { text: text2, contents: file }).get(fullPath)?.contents;
  }
  async getVersion(lockFile) {
    const fetchVersion = async () => (await (await fetch(`https://api.github.com/repos${this.base}commits?sha=summary`)).json()).sha;
    const currentDate = Date.now();
    if (lockFile) {
      if ((lockFile.versionDate - currentDate) / 3600000 > 6) {
        this.versionDate = currentDate;
        return fetchVersion();
      }
      this.versionDate = lockFile.versionDate;
      return lockFile.version;
    }
    this.versionDate = currentDate;
    return fetchVersion();
  }
}
var init_mcmeta = __esm(() => {
  init_utils();
});

// src/core/resources/dependency.ts
var DependencyNode, SmithedDependencyClass;
var init_dependency = __esm(() => {
  init_nodes();
  init_resource();
    });

// src/core/smithed.ts
import path2 from "node:path";
import AdmZip2 from "adm-zip";
import fs3 from "fs-extra";

class SmithedDependencyCache {
  core;
  constructor(core) {
    this.core = core;
  }
  baseURL = "https://api.smithed.dev/v2/";
  get path() {
    return path2.join(getSandstoneContext().workingDir, "resources", "cache", "smithed");
  }
  get manifest() {
    return path2.join(this.path, "..", "..", "smithed.json");
  }
  get lockFile() {
    return path2.join(this.path, "..", "lock-smithed.json");
  }
  dependencies = new Map;
  loaded = false;
  async load() {
    this.loaded = true;
    if (!await fs3.pathExists(this.manifest)) {
      return;
    }
    const manifest = JSON.parse(await fs3.readFile(this.manifest, "utf-8"));
    for (const [id2, version] of Object.entries(manifest)) {
      this.core.depend(id2, version);
    }
  }
  async save() {
    this.core.pack.packTypes.set("datapack-dependencies", new DataPackDependencies);
    let resourcePackDependencies = false;
    for (const [id2, dependency] of this.dependencies) {
      new SmithedDependencyClass(this.core, id2, dependency, "server");
      if (dependency.resourcepack !== false) {
        if (!resourcePackDependencies) {
          this.core.pack.packTypes.set("resourcepack-dependencies", new ResourcePackDependencies);
        }
        new SmithedDependencyClass(this.core, id2, dependency, "client");
      }
    }
  }
  async lock() {
    if (this.dependencies.size !== 0) {
      const dependencies = {};
      for (const [dependency, { version }] of this.dependencies.entries()) {
        dependencies[dependency] = version;
      }
      await safeWrite(this.manifest, JSON.stringify(dependencies));
      const lock = {};
      for (const [name, { version, date, resourcepack: resourcepack2 }] of this.dependencies.entries()) {
        lock[name] = {
          version,
          date,
          resourcepack: !!resourcepack2
        };
      }
      await safeWrite(this.lockFile, JSON.stringify(lock));
    }
  }
  async get(dependency, version) {
    const existing = this.dependencies.get(dependency);
    if (existing) {
      return existing;
    }
    let result;
    const lockFile = await (async () => {
      try {
        return JSON.parse(await fs3.readFile(this.lockFile, "utf-8"));
      } catch {
        return false;
      }
    })();
    let download = false;
    if (!lockFile || !lockFile[dependency] || lockFile[dependency].version !== version) {
      download = true;
    } else {
      const date = Date.now();
      if (version === "latest" && (lockFile[dependency].date - date) / 3600000 > 1) {
        lockFile[dependency].date = date;
        download = true;
      } else {
        result = this.dependencies.set(dependency, {
          version,
          date: lockFile[dependency].date,
          datapack: async () => await fs3.readFile(path2.join(this.path, dependency, "datapack.zip")),
          resourcepack: lockFile[dependency].resourcepack ? async () => await fs3.readFile(path2.join(this.path, dependency, "resourcepack.zip")) : false
        }).get(dependency);
      }
    }
    if (download) {
      let url = `${this.baseURL}download?pack=${dependency}`;
      let hasResourcePack = false;
      let pack = null;
      try {
        const response = await fetch(`${this.baseURL}packs/${dependency}`);
        if (!response.ok) {
          console.warn(`[SmithedDependencyCache#get] ${(await response.json()).message} (HTTP ${response.status}). The pack may not be published yet.`);
          return;
        }
        pack = JSON.parse(await response.text());
      } catch (error) {
        console.warn(`[SmithedDependencyCache#get] Failed to fetch metadata for "${dependency}":`, error);
        return;
      }
      if (!pack || !pack.versions || pack.versions.length === 0) {
        console.warn(`[SmithedDependencyCache#get] "${dependency}" has no versions available.`);
        return;
      }
      if (version === "latest") {
        const { versions } = pack;
        const ver = versions[versions.length - 1];
        if (ver.downloads.resourcepack) {
          hasResourcePack = true;
        }
      } else {
        const ver = pack.versions.find((_ver) => _ver.name === version);
        if (!ver) {
          console.warn(`[SmithedDependencyCache#get] "${dependency}" version "${version}" not found.`);
          return;
        }
        if (ver.downloads.resourcepack) {
          hasResourcePack = true;
        }
        url += `@${version}`;
      }
      let zip = new AdmZip2(Buffer.from(await (await fetch(url)).arrayBuffer()));
      let files = zip.getEntries();
      await safeWrite(path2.join(this.path, dependency, "datapack.zip"), await new Promise((res) => {
        files[0].getDataAsync((data) => res(data));
      }));
      if (hasResourcePack) {
        await safeWrite(path2.join(this.path, dependency, "resourcepack.zip"), await new Promise((res) => {
          files[1].getDataAsync((data) => res(data));
        }));
      }
      zip = undefined;
      files = undefined;
      result = this.dependencies.set(dependency, {
        version,
        date: version === "latest" ? Date.now() : 0,
        datapack: async () => await fs3.readFile(path2.join(this.path, dependency, "datapack.zip")),
        resourcepack: hasResourcePack ? async () => await fs3.readFile(path2.join(this.path, dependency, "resourcepack.zip")) : false
      }).get(dependency);
      await this.lock();
    }
    return result;
  }
  has(dependency) {
    const depend = this.dependencies.get(dependency);
    return depend !== undefined;
  }
}
var init_smithed = __esm(() => {
  init_utils();
  init_pack2();
  init_dependency();
});

// src/core/sandstoneCore.ts
import path3 from "node:path";
import fs4 from "fs-extra";
import crypto2 from "crypto";
import { isBinaryFileSync } from "isbinaryfile";
import binaryExtensions from "binary-extensions";

class SandstoneCore {
  pack;
  resourceNodes;
  mcfunctionStack;
  awaitNodes;
  withNodes;
  currentNode = "";
  _mcMetaCache = false;
  _smithed = false;
  dependencies = [];
  functionTags = new Map;
  sounds = new Map;
  checkTriggers = {};
  constructor(pack) {
    this.pack = pack;
    this.resourceNodes = new ResourceNodesMap;
    this.mcfunctionStack = [];
    this.awaitNodes = new Set;
    this.withNodes = new Set;
    this.functionTags = new Map;
    this.sounds = new Map;
    this.checkTriggers = {};
    for (const method of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (method !== "constructor" && typeof this[method] === "function" && typeof this[method].bind === "function") {
        this[method] = this[method].bind(this);
      }
    }
  }
  reset = () => {
    this.resourceNodes.clear();
    this.mcfunctionStack = [];
    this.awaitNodes.clear();
    this.withNodes.clear();
    this.currentNode = "";
    this._mcMetaCache = undefined;
    this._smithed = undefined;
    this.dependencies = [];
    this.functionTags.clear();
    this.sounds.clear();
    this.checkTriggers = {};
  };
  get currentMCFunction() {
    return this.mcfunctionStack[this.mcfunctionStack.length - 1];
  }
  getCurrentMCFunctionOrThrow = () => {
    const { currentMCFunction } = this;
    if (!currentMCFunction) {
      throw new Error("This operation is invalid when outside a MCFunction.");
    }
    return currentMCFunction;
  };
  insideContext = (...args) => this.getCurrentMCFunctionOrThrow().insideContext(...args);
  enterMCFunction = (mcfunction2) => {
    const node = mcfunction2.node;
    this.mcfunctionStack.push(node);
    return node;
  };
  exitMCFunction = () => this.mcfunctionStack.pop();
  get mcMetaCache() {
    if (this._mcMetaCache === false) {
      this._mcMetaCache = undefined;
      return;
    }
    this._mcMetaCache ??= new MCMetaCache;
    return this._mcMetaCache;
  }
  async getExistingResource(pathOrResource, encoding = "utf-8") {
    if (typeof pathOrResource === "string") {
      const fullPath2 = path3.isAbsolute(pathOrResource) ? pathOrResource : path3.join(getSandstoneContext().workingDir, "resources", pathOrResource);
      if (encoding === false) {
        return fs4.readFile(fullPath2);
      }
      return fs4.readFile(fullPath2, encoding);
    }
    const _path = pathOrResource.path;
    if (_path[0] === "minecraft") {
      const type = pathOrResource.packType.resourceSubFolder;
      return this.mcMetaCache.get(type, `${type}/${_path.join("/")}${pathOrResource.fileExtension ? `.${pathOrResource.fileExtension}` : ""}`, encoding === "utf-8");
    }
    const pathParts = [pathOrResource.packType.type];
    if (pathOrResource.packType.resourceSubFolder) {
      pathParts.push(pathOrResource.packType.resourceSubFolder);
    }
    pathParts.push(..._path);
    const fullPath = path3.join(getSandstoneContext().workingDir, `resources/${path3.join(...pathParts)}${pathOrResource.fileExtension ? `.${pathOrResource.fileExtension}` : ""}`);
    if (pathOrResource.fileEncoding === false) {
      return fs4.readFile(fullPath);
    }
    return fs4.readFile(fullPath, pathOrResource.fileEncoding);
  }
  async getVanillaResource(relativePath, text2 = true, type = "server") {
    return this.mcMetaCache.get(type === "server" ? "data" : "assets", relativePath, text2);
  }
  get smithed() {
    this._smithed ??= new SmithedDependencyCache(this);
    return this._smithed;
  }
  depend(dependency, version = "latest") {
    const i = this.dependencies.length;
    this.dependencies.push(async () => {
      if (!this.smithed.has(dependency)) {
        const depend = await this.smithed.get(dependency, version);
        if (depend === undefined) {
          this.dependencies[i] = false;
          this.pack.dependencies.set(dependency, false);
          return false;
        }
      }
      this.pack.dependencies.set(dependency, true);
      this.dependencies[i] = true;
      return true;
    });
    return i;
  }
  generateResources(opts) {
    const originalResources = new ResourceNodesMap(this.resourceNodes);
    for (const { resource: resource2 } of this.resourceNodes) {
      resource2.generate();
    }
    for (const visitor of opts.visitors) {
      visitor.onStart();
      for (const node of this.resourceNodes) {
        visitor.visit(node);
      }
      visitor.onEnd();
    }
    const finalResources = this.resourceNodes;
    this.resourceNodes = originalResources;
    return finalResources;
  }
  async save(cliOptions, opts) {
    await this.smithed.load();
    let dependenciesFailed = 0;
    for (const depend of this.dependencies) {
      const success = typeof depend === "boolean" ? depend : await depend();
      if (!success) {
        dependenciesFailed++;
      }
    }
    if (dependenciesFailed !== 0) {
      console.log(`[SandstoneCore#save] Failed to load ${dependenciesFailed} dependencies, continuing with compilation.`);
    }
    if (this.dependencies.length !== 0) {
      await this.smithed.save();
    }
    if (this._mcMetaCache) {
      if (!this.mcMetaCache.loaded) {
        await this.mcMetaCache.load();
      }
      await this.mcMetaCache.save();
    }
    const resources = this.generateResources(opts);
    const binaryExt = new Set(binaryExtensions);
    const encoder = new TextDecoder;
    for await (const node of resources) {
      const { packType, fileExtension } = node.resource;
      const _path = [packType.type, ...node.resource.path];
      if (packType.resourceSubFolder) {
        _path.splice(1, 0, packType.resourceSubFolder);
      }
      const resourcePath = path3.join(..._path);
      let value;
      try {
        value = await node.getValue();
      } catch (e) {
        console.log(`



`);
        console.log(node);
        throw e;
      }
      if (cliOptions.verbose) {
        console.log(`Path: ${resourcePath}.${fileExtension}

` + `${(() => {
          if (typeof value === "string") {
            return value;
          }
          if (!binaryExt.has(fileExtension) && !isBinaryFileSync(value)) {
            return encoder.decode(value);
          }
          return `<Buffer: ${crypto2.createHash("sha256").update(value).digest("hex")}>`;
        })()}`);
      }
      if (!cliOptions.dry) {
        await cliOptions.fileHandler(`${resourcePath}.${fileExtension}`, value);
      }
    }
  }
}
var init_sandstoneCore = __esm(() => {
  init_mcmeta();
  init_resource();
  init_smithed();
});

// src/core/index.ts
var init_core = __esm(() => {
  init_Macro();
  init_nodes();
  init_resources();
  init_sandstoneCore();
});

// src/commands/implementations/server/function.ts
var FunctionCommandNode, FunctionCommand;
var init_function = __esm(() => {
  init_Macro();
  init_nodes();
  init_NBTs();
    });

// src/commands/implementations/entity/execute.ts
function createDeferredMacroExecute(pack, executeChain, options) {
  const { childFunctionName, prependArgs } = options;
  const createProxy = (chain) => {
    const handler = {
      get(_target, prop) {
        if (prop === "run") {
          const node = chain.previousNode ?? chain.getNode?.();
          const accumulatedArgs = node?.args ?? [];
          const currentFunction = pack.core.getCurrentMCFunctionOrThrow();
          const envNames = "env" in options && options.env ? options.env.map((_, i) => `env_${i}`) : [];
          const macroNode = new ExecuteCommandNode(pack, true, [...prependArgs(envNames), ...accumulatedArgs], {
            isSingleExecute: true
          });
          macroNode.isMacro = true;
          let childFunctionNode;
          if ("env" in options && options.env) {
            const childFunction = pack.MCFunction(`${currentFunction.resource.name}/${childFunctionName}`, options.env, () => {}, { creator: "sandstone", onConflict: "rename" });
            childFunction();
            childFunctionNode = childFunction.node;
          } else {
            const childFunction = pack.MCFunction(`${currentFunction.resource.name}/${childFunctionName}`, () => {}, { creator: "sandstone", onConflict: "rename" });
            pack.commands.functionCmd(childFunction.name, "with", "storage", options.macroStorage.currentTarget, options.macroStorage.path);
            childFunctionNode = childFunction.node;
          }
          childFunctionNode.body.push(macroNode);
          pack.core.enterMCFunction(childFunctionNode.resource);
          childFunctionNode.enterContext(macroNode, false);
          let hasExited = false;
          const exitContexts = () => {
            if (hasExited)
              return;
            hasExited = true;
            if (pack.core.currentMCFunction === childFunctionNode) {
              if (childFunctionNode.contextStack.length > 1) {
                childFunctionNode.exitContext();
              }
              pack.core.exitMCFunction();
            }
          };
          const wrapCommands = (target) => {
            return new Proxy(target, {
              get(t, cmdProp) {
                const value = t[cmdProp];
                if (typeof value === "function") {
                  return (...args) => {
                    const result2 = value.apply(t, args);
                    if (result2 && typeof result2 === "object" && typeof result2.then !== "function") {
                      const proto = Object.getPrototypeOf(result2);
                      if (proto && proto.constructor?.name !== "FinalCommandOutput") {
                        return wrapCommands(result2);
                      }
                    }
                    exitContexts();
                    return result2;
                  };
                }
                if (value && typeof value === "object") {
                  return wrapCommands(value);
                }
                return value;
              }
            });
          };
          return wrapCommands(pack.commands);
        }
        const result = chain[prop];
        if (typeof result === "function") {
          return (...args) => {
            const nextChain = result.apply(chain, args);
            if (nextChain && typeof nextChain === "object") {
              return createProxy(nextChain);
            }
            return nextChain;
          };
        }
        if (result && typeof result === "object") {
          return createProxy(result);
        }
        return result;
      }
    };
    return new Proxy({}, handler);
  };
  return createProxy(executeChain);
}
var isObjective = (arg) => typeof arg === "object" && Object.hasOwn(arg, "reset"), isScore = (arg) => typeof arg === "object" && Object.hasOwn(arg, "setDisplay"), ExecuteCommandPart, ExecuteCommandNode, ExecuteStoreArgsCommand, ExecuteStoreCommand, ExecuteDataArgsCommand, ExecuteItemsCommand, ExecuteSlotsCommand, ExecuteIfUnlessCommand, ExecuteFacingEntityCommand, ExecutePositionedCommand, ExecuteRotatedAsCommand, ExecuteCommand;
var init_execute = __esm(() => {
  init_setblock();
  init_core();
  init_nodes();
  init_utils();
  init_parsers();
  init_variables2();
  init_function();
                        });

// src/commands/implementations/entity/kill.ts
var KillCommandNode, KillCommand;
var init_kill = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/entity/ride.ts
var RideCommandNode, RideArgumentsCommand, RideCommand;
var init_ride = __esm(() => {
  init_nodes();
  init_parsers();
      });

// src/commands/implementations/entity/rotate.ts
var RotateCommandNode, RotateCommand, RotateFacingArguments;
var init_rotate = __esm(() => {
  init_nodes();
  init_parsers();
      });

// src/variables/JSONTextComponentClass.ts
import * as util7 from "util";
function toComponent(c) {
  return c._toChatComponent?.() ?? c.toJSON?.() ?? c;
}
function parseJSONText(core, jsonText) {
  if (jsonText === undefined)
    return;
  if (isMacroArgument(core, jsonText)) {
    return jsonText;
  }
  return new JSONTextComponentClass(jsonText);
}
var JSONTextComponentClass;
var init_JSONTextComponentClass = __esm(() => {
  init_core();
  init_utils();
  });

// src/commands/implementations/entity/scoreboard.ts
function scoresParser(...args) {
  return args.map((_arg, _i) => {
    const arg = _arg;
    if (isScore2(arg)) {
      return [arg.target, arg.objective];
    }
    if (arg?._toSelector) {
      return [arg._toSelector()];
    }
    return [arg];
  }).flat(Number.POSITIVE_INFINITY);
}
var isScore2 = (arg) => typeof arg === "object" && Object.hasOwn(arg, "setDisplay"), ScoreboardCommandNode, ScoreboardObjectivesModifyCommand, ScoreboardPlayersDisplayCommand, ScoreboardCommand;
var init_scoreboard = __esm(() => {
  init_nodes();
  init_JSONTextComponentClass();
  init_parsers();
        });

// src/commands/implementations/entity/spreadplayers.ts
var SpreadPlayersNode, SpreadPlayersCommand;
var init_spreadplayers = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/entity/summon.ts
var SummonCommandNode, SummonCommand;
var init_summon = __esm(() => {
  init_nodes();
  init_NBTs();
  init_parsers();
    });

// src/commands/implementations/entity/swing.ts
var SwingCommandNode, SwingCommand;
var init_swing = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/entity/tag.ts
function checkTagName(tag2) {
  if (typeof tag2 !== "string") {
    return tag2;
  }
  if (!tag2.match(/[A-Za-z0-9\-_+.]/g)) {
    throw new Error(`Invalid tag name "${tag2}": Valid characters are uppercase and lowercase letters, numbers, hyphen, underscore, plus sign and period.`);
  }
  return tag2;
}
var TagCommandNode, TagArgumentsCommand, TagCommand;
var init_tag2 = __esm(() => {
  init_nodes();
  init_parsers();
      });

// src/commands/implementations/entity/team.ts
var TeamCommandNode, TeamCommand;
var init_team = __esm(() => {
  init_nodes();
  init_JSONTextComponentClass();
  init_parsers();
    });

// src/commands/implementations/entity/teleport.ts
var TeleportCommandNode, TeleportFacingCommand, TeleportCommand;
var init_teleport = __esm(() => {
  init_nodes();
  init_Coordinates();
  init_parsers();
      });

// src/commands/implementations/player/advancement.ts
var AdvancementCommandNode, AdvancementArgumentsCommand, AdvancementCommand;
var init_advancement2 = __esm(() => {
  init_nodes();
  init_parsers();
      });

// src/commands/implementations/player/bossbar.ts
var BossBarCommandNode, BossBarCommand, BossBarSetCommand;
var init_bossbar = __esm(() => {
  init_nodes();
  init_JSONTextComponentClass();
  init_parsers();
      });

// src/commands/implementations/player/dialog.ts
var DialogCommandNode, DialogCommand;
var init_dialog2 = __esm(() => {
  init_nodes();
  init_resource();
  init_variables2();
  init_parsers();
    });

// src/commands/implementations/player/experience.ts
var ExperienceCommandNode, ExperienceCommand;
var init_experience = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/gamemode.ts
var GameModeCommandNode, GameModeCommand;
var init_gamemode = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/give.ts
function componentPatchStringifier(components) {
  if (Object.hasOwn(components, "toMacro")) {
    return components.toMacro();
  }
  const resultPairs = [];
  for (const [key, value] of Object.entries(components)) {
    if (key.startsWith("!")) {
      if (typeof value === "object" && Object.keys(value).length === 0) {
        resultPairs.push(`!${key}={}`);
      } else {
        throw new Error(`Attempted to insert a negation component patch of ${key} with a value, use {} instead.`);
      }
    } else {
      resultPairs.push(`${key}=${nbtResolver(value).toString()}`);
    }
  }
  return `[${resultPairs.join(",")}]`;
}
var GiveCommandNode, GiveCommand;
var init_give = __esm(() => {
  init_core();
  init_variables2();
    });

// src/commands/implementations/player/particle.ts
function isCoordinates(value) {
  return typeof value === "string" || value instanceof VectorClass || Array.isArray(value);
}
var ParticleCommandNode, ParticleCommand;
var init_particle2 = __esm(() => {
  init_nodes();
  init_variables2();
    });

// src/commands/implementations/player/playsound.ts
var PlaySoundCommandNode, PlaySoundCommand;
var init_playsound = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/posteffect.ts
var PostEffectCommandNode, PostEffectCommand;
var init_posteffect = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/recipe.ts
var RecipeCommandNode, RecipeCommand;
var init_recipe2 = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/spawnpoint.ts
var SpawnPointCommandNode, SpawnPointCommand;
var init_spawnpoint = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/spectate.ts
var SpectateCommandNode, SpectateCommand;
var init_spectate = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/stopsound.ts
var StopSoundCommandNode, StopSoundCommand;
var init_stopsound = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/title.ts
var TitleCommandNode, TitleArgumentsCommand, TitleCommand;
var init_title = __esm(() => {
  init_nodes();
  init_JSONTextComponentClass();
  init_parsers();
      });

// src/commands/implementations/player/transfer.ts
var TransferCommandNode, TransferCommand;
var init_transfer = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/player/waypoint.ts
var WaypointCommandNode, WaypointCommand, WaypointModifyArguments;
var init_waypoint = __esm(() => {
  init_nodes();
  init_parsers();
      });

// src/commands/implementations/server/datapack.ts
var DataPackCommandNode, DataPackEnableCommand, DataPackCommand;
var init_datapack2 = __esm(() => {
  init_nodes();
      });

// src/commands/implementations/server/debug.ts
var DebugCommandNode, DebugCommand;
var init_debug = __esm(() => {
  init_nodes();
  init_Macro();
    });

// src/commands/implementations/server/defaultgamemode.ts
var DefaultGameModeCommandNode, DefaultGameModeCommand;
var init_defaultgamemode = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/difficulty.ts
var DifficultyCommandNode, DifficultyCommand;
var init_difficulty = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/gamerule.ts
var GameRuleCommandNode, GameRuleCommand;
var init_gamerule = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/help.ts
var HelpCommandNode, HelpCommand;
var init_help = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/list.ts
var ListCommandNode, ListCommand;
var init_list = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/me.ts
var MeCommandNode, MeCommand;
var init_me = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/server/performance.ts
var PerfCommandNode, PerfCommand, JFRCommandNode, JFRCommand;
var init_performance = __esm(() => {
  init_nodes();
        });

// src/commands/implementations/server/random.ts
var RandomCommandNode, RandomCommand;
var init_random = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/server/reload.ts
var ReloadCommandNode, ReloadCommand;
var init_reload = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/return.ts
var ReturnRunCommandNode, ReturnArgumentsCommand, ReturnCommandNode, ReturnCommand;
var init_return = __esm(() => {
  init_nodes();
  init_utils();
  init_function();
        });

// src/commands/implementations/server/say.ts
var SayCommandNode, SayCommand;
var init_say = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/schedule.ts
var ScheduleCommandNode, ScheduleCommand;
var init_schedule = __esm(() => {
  init_Macro();
  init_nodes();
    });

// src/commands/implementations/server/setidletimeout.ts
var SetIdleTimeoutCommandNode, SetIdleTimeoutCommand;
var init_setidletimeout = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/stopwatch.ts
var StopwatchCommandNode, StopwatchCommand;
var init_stopwatch = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/teammessage.ts
var TeamMessageCommandNode, TeamMessageCommand;
var init_teammessage = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/server/tell.ts
var TellCommandNode, TellCommand;
var init_tell = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/server/tellraw.ts
var TellRawCommandNode, TellRawCommand;
var init_tellraw = __esm(() => {
  init_nodes();
  init_JSONTextComponentClass();
  init_parsers();
    });

// src/commands/implementations/server/trigger.ts
var TriggerCommandNode, TriggerArgumentsCommand, TriggerCommand;
var init_trigger = __esm(() => {
  init_nodes();
      });

// src/commands/implementations/server/version.ts
var VersionCommandNode, VersionCommand;
var init_version = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/world/data.ts
var DataCommandNode, DataCommand, DataGetCommand, DataMergeCommand, DataModifyFromCommand, DataModifyValuesCommand, DataModifyTypeCommand, DataModifyCommand, DataRemoveCommand;
var init_data = __esm(() => {
  init_nodes();
  init_utils();
  init_NBTs();
  init_parsers();
                  });

// src/commands/implementations/world/fillbiome.ts
var FillBiomeCommandNode, FillBiomeCommand;
var init_fillbiome = __esm(() => {
  init_nodes();
  init_variables2();
    });

// src/commands/implementations/world/forceload.ts
function coordinatesToNumbers(coords) {
  if (typeof coords === "string") {
    return coords.replace(/[~^]/, "").split(" ").map((i) => Number(i));
  }
  const realCoords = Array.isArray(coords) ? coords : coords.values;
  return realCoords.map((coord) => Number.parseInt(coord.replace(/[\^~]/, "") || "0", 10));
}
function validateNumberOfChunks(from, to) {
  if (!to) {
    return;
  }
  if (typeof from === "object" || typeof to === "object") {
    return;
  }
  const coords = [...from, ...to].map(coordinatesParser);
  if (coords.every((c) => c[0] === "~") || coords.every((c) => c[0] === "^") || coords.every((c) => c[0].match(/0-9/))) {
    const [fromX, fromZ] = coordinatesToNumbers(from);
    const [toX, toZ] = coordinatesToNumbers(to);
    const chunksX = Math.ceil((Math.abs(fromX - toX) + 1) / 16);
    const chunksZ = Math.ceil((Math.abs(fromZ - toZ) + 1) / 16);
    const affectedChunks = chunksX * chunksZ;
    if (affectedChunks > 256) {
      throw new Error(`Impossible to forceload more than 256 chunks. From "${from}" to "${to}", at least ${affectedChunks} would be forceloaded.`);
    }
  }
}
var ForceLoadCommandNode, ForceLoadCommand;
var init_forceload = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/world/item.ts
var ItemCommandNode, ItemSourceCommand, ItemCommand;
var init_item = __esm(() => {
  init_nodes();
  init_parsers();
  init_give();
      });

// src/commands/implementations/world/locate.ts
var LocateCommandNode, LocateCommand;
var init_locate = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/world/loot.ts
var LootCommandNode, LootSourceCommand, LootCommand;
var init_loot = __esm(() => {
  init_nodes();
  init_parsers();
      });

// src/commands/implementations/world/seed.ts
var SeedCommandNode, SeedCommand;
var init_seed = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/world/setworldspawn.ts
var SetWorldSpawnCommandNode, SetWorldSpawnCommand;
var init_setworldspawn = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/world/test.ts
var TestCommandNode, TestCommand;
var init_test = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/world/time.ts
var TimeCommandNode, TimeArguments, TimeCommand;
var init_time = __esm(() => {
  init_nodes();
      });

// src/commands/implementations/world/weather.ts
var WeatherCommandNode, WeatherCommand;
var init_weather = __esm(() => {
  init_nodes();
    });

// src/commands/implementations/world/worldborder.ts
var WorldBorderNode, WorldBorderCommand;
var init_worldborder = __esm(() => {
  init_nodes();
  init_parsers();
    });

// src/commands/implementations/index.ts
var init_implementations = __esm(() => {
  init_comment();
  init_raw();
  init_clone();
  init_fill();
  init_place();
  init_setblock();
  init_attribute();
  init_clear();
  init_damage();
  init_effect();
  init_enchant();
  init_execute();
  init_kill();
  init_ride();
  init_rotate();
  init_scoreboard();
  init_spreadplayers();
  init_summon();
  init_swing();
  init_tag2();
  init_team();
  init_teleport();
  init_advancement2();
  init_bossbar();
  init_dialog2();
  init_experience();
  init_gamemode();
  init_give();
  init_particle2();
  init_playsound();
  init_posteffect();
  init_recipe2();
  init_spawnpoint();
  init_spectate();
  init_stopsound();
  init_title();
  init_transfer();
  init_waypoint();
  init_datapack2();
  init_debug();
  init_defaultgamemode();
  init_difficulty();
  init_function();
  init_gamerule();
  init_help();
  init_list();
  init_me();
  init_performance();
  init_random();
  init_reload();
  init_return();
  init_say();
  init_schedule();
  init_setidletimeout();
  init_stopwatch();
  init_teammessage();
  init_tell();
  init_tellraw();
  init_trigger();
  init_version();
  init_data();
  init_fillbiome();
  init_forceload();
  init_item();
  init_locate();
  init_loot();
  init_seed();
  init_setworldspawn();
  init_test();
  init_time();
  init_weather();
  init_worldborder();
});

// src/commands/commands.ts
function bind(pack, isMacro, _class, method) {
  const cmd = new _class(pack, isMacro);
  if (typeof cmd[method].bind === "function") {
    return cmd[method].bind(cmd);
  }
  throw Error("Commands binder screwed up");
}

class SandstoneCommands {
  sandstonePack;
  isMacro;
  constructor(sandstonePack, isMacro = false) {
    this.sandstonePack = sandstonePack;
    this.isMacro = isMacro;
  }
  get advancement() {
    return new AdvancementCommand(this.sandstonePack, this.isMacro);
  }
  get attribute() {
    return bind(this.sandstonePack, this.isMacro, AttributeCommand, "attribute");
  }
  get bossbar() {
    return new BossBarCommand(this.sandstonePack, this.isMacro);
  }
  get clear() {
    return bind(this.sandstonePack, this.isMacro, ClearCommand, "clear");
  }
  get clone() {
    return bind(this.sandstonePack, this.isMacro, CloneCommand, "clone");
  }
  get comment() {
    return bind(this.sandstonePack, this.isMacro, CommentCommand, "comment");
  }
  get damage() {
    return bind(this.sandstonePack, this.isMacro, DamageCommand, "damage");
  }
  get data() {
    return new DataCommand(this.sandstonePack, this.isMacro);
  }
  get datapack() {
    return new DataPackCommand(this.sandstonePack, this.isMacro);
  }
  get debug() {
    return new DebugCommand(this.sandstonePack, this.isMacro);
  }
  get dialog() {
    return new DialogCommand(this.sandstonePack, this.isMacro);
  }
  get defaultgamemode() {
    return bind(this.sandstonePack, this.isMacro, DefaultGameModeCommand, "defaultgamemode");
  }
  get difficulty() {
    return bind(this.sandstonePack, this.isMacro, DifficultyCommand, "difficulty");
  }
  get effect() {
    return new EffectCommand(this.sandstonePack, this.isMacro);
  }
  get enchant() {
    return bind(this.sandstonePack, this.isMacro, EnchantCommand, "enchant");
  }
  get execute() {
    return new ExecuteCommand(this.sandstonePack, this.isMacro);
  }
  get experience() {
    return new ExperienceCommand(this.sandstonePack, this.isMacro);
  }
  get fill() {
    return bind(this.sandstonePack, this.isMacro, FillCommand, "fill");
  }
  get fillbiome() {
    return bind(this.sandstonePack, this.isMacro, FillBiomeCommand, "fillbiome");
  }
  get functionCmd() {
    return bind(this.sandstonePack, this.isMacro, FunctionCommand, "function");
  }
  get forceload() {
    return new ForceLoadCommand(this.sandstonePack, this.isMacro);
  }
  get gamemode() {
    return bind(this.sandstonePack, this.isMacro, GameModeCommand, "gamemode");
  }
  get gamerule() {
    return bind(this.sandstonePack, this.isMacro, GameRuleCommand, "gamerule");
  }
  get give() {
    return bind(this.sandstonePack, this.isMacro, GiveCommand, "give");
  }
  get help() {
    return bind(this.sandstonePack, this.isMacro, HelpCommand, "help");
  }
  get item() {
    return new ItemCommand(this.sandstonePack, this.isMacro);
  }
  get jfr() {
    return new JFRCommand(this.sandstonePack, this.isMacro);
  }
  get kill() {
    return bind(this.sandstonePack, this.isMacro, KillCommand, "kill");
  }
  get list() {
    return bind(this.sandstonePack, this.isMacro, ListCommand, "list");
  }
  get locate() {
    return new LocateCommand(this.sandstonePack, this.isMacro);
  }
  get loot() {
    return new LootCommand(this.sandstonePack, this.isMacro);
  }
  get me() {
    return bind(this.sandstonePack, this.isMacro, MeCommand, "me");
  }
  get particle() {
    return bind(this.sandstonePack, this.isMacro, ParticleCommand, "particle");
  }
  get perf() {
    return new PerfCommand(this.sandstonePack, this.isMacro);
  }
  get place() {
    return new PlaceCommand(this.sandstonePack, this.isMacro);
  }
  get playsound() {
    return bind(this.sandstonePack, this.isMacro, PlaySoundCommand, "playsound");
  }
  get posteffect() {
    return new PostEffectCommand(this.sandstonePack, this.isMacro);
  }
  get random() {
    return new RandomCommand(this.sandstonePack, this.isMacro);
  }
  get raw() {
    return bind(this.sandstonePack, this.isMacro, RawCommand, "raw");
  }
  get recipe() {
    return new RecipeCommand(this.sandstonePack, this.isMacro);
  }
  get reload() {
    return bind(this.sandstonePack, this.isMacro, ReloadCommand, "reload");
  }
  get returnCmd() {
    return new ReturnCommand(this.sandstonePack, this.isMacro).return;
  }
  get ride() {
    return bind(this.sandstonePack, this.isMacro, RideCommand, "ride");
  }
  get rotate() {
    return bind(this.sandstonePack, this.isMacro, RotateCommand, "rotate");
  }
  get say() {
    return bind(this.sandstonePack, this.isMacro, SayCommand, "say");
  }
  get schedule() {
    return new ScheduleCommand(this.sandstonePack, this.isMacro);
  }
  get scoreboard() {
    return new ScoreboardCommand(this.sandstonePack, this.isMacro);
  }
  get seed() {
    return bind(this.sandstonePack, this.isMacro, SeedCommand, "seed");
  }
  get setblock() {
    return bind(this.sandstonePack, this.isMacro, SetBlockCommand, "setblock");
  }
  get setidletimeout() {
    return bind(this.sandstonePack, this.isMacro, SetIdleTimeoutCommand, "setidletimeout");
  }
  get setworldspawn() {
    return bind(this.sandstonePack, this.isMacro, SetWorldSpawnCommand, "setworldspawn");
  }
  get spawnpoint() {
    return bind(this.sandstonePack, this.isMacro, SpawnPointCommand, "spawnpoint");
  }
  get spectate() {
    return bind(this.sandstonePack, this.isMacro, SpectateCommand, "spectate");
  }
  get stopsound() {
    return bind(this.sandstonePack, this.isMacro, StopSoundCommand, "stopsound");
  }
  get stopwatch() {
    return new StopwatchCommand(this.sandstonePack, this.isMacro);
  }
  get spreadplayers() {
    return bind(this.sandstonePack, this.isMacro, SpreadPlayersCommand, "spreadplayers");
  }
  get summon() {
    return bind(this.sandstonePack, this.isMacro, SummonCommand, "summon");
  }
  get swing() {
    return bind(this.sandstonePack, this.isMacro, SwingCommand, "swing");
  }
  get tag() {
    return bind(this.sandstonePack, this.isMacro, TagCommand, "tag");
  }
  get team() {
    return new TeamCommand(this.sandstonePack, this.isMacro);
  }
  get teammsg() {
    return bind(this.sandstonePack, this.isMacro, TeamMessageCommand, "teammessage");
  }
  get teleport() {
    return bind(this.sandstonePack, this.isMacro, TeleportCommand, "tp");
  }
  get tell() {
    return bind(this.sandstonePack, this.isMacro, TellCommand, "tell");
  }
  get tellraw() {
    return bind(this.sandstonePack, this.isMacro, TellRawCommand, "tellraw");
  }
  get test() {
    return new TestCommand(this.sandstonePack, this.isMacro);
  }
  get time() {
    return new TimeCommand(this.sandstonePack, this.isMacro);
  }
  get title() {
    return bind(this.sandstonePack, this.isMacro, TitleCommand, "title");
  }
  get trigger() {
    return bind(this.sandstonePack, this.isMacro, TriggerCommand, "trigger");
  }
  get transfer() {
    return bind(this.sandstonePack, this.isMacro, TransferCommand, "transfer");
  }
  get version() {
    return bind(this.sandstonePack, this.isMacro, VersionCommand, "version");
  }
  get waypoint() {
    return new WaypointCommand(this.sandstonePack, this.isMacro);
  }
  get weather() {
    return new WeatherCommand(this.sandstonePack, this.isMacro);
  }
  get worldborder() {
    return new WorldBorderCommand(this.sandstonePack, this.isMacro);
  }
  get msg() {
    return this.tell;
  }
  get w() {
    return this.tell;
  }
  get tm() {
    return this.teammsg;
  }
  get xp() {
    return this.experience;
  }
  get tp() {
    return this.teleport;
  }
}
var init_commands = __esm(() => {
  init_implementations();
});

// src/commands/index.ts
var init_commands2 = __esm(() => {
  init_commands();
  init_implementations();
});

// src/flow/async/attach.ts
var ATTACH_CHILD_NAME = "__attach", AttachClass;
var init_attach = __esm(() => {
  init_nodes();
  });

// src/flow/async/sleep.ts
var SLEEP_CHILD_NAME = "__sleep", SleepClass;
var init_sleep = __esm(() => {
  init_nodes();
  init_variables2();
  });

// src/flow/async/until.ts
var UNTIL_CHILD_NAME = "__until", UntilClass;
var init_until = __esm(() => {
  init_commands2();
  init_nodes();
  init_sleep();
  });

// src/flow/async/index.ts
var init_async = __esm(() => {
  init_attach();
  init_sleep();
  init_until();
});

// src/flow/conditions/condition.ts
import * as util8 from "util";
var ConditionNode, SingleConditionNode, SingleExecuteNode;
var init_condition = __esm(() => {
  init_core();
  init_utils();
      });

// src/flow/conditions/and.ts
var AndNode;
var init_and = __esm(() => {
  init_condition();
  });

// src/flow/conditions/not.ts
var NotNode;
var init_not = __esm(() => {
  init_condition();
  });

// src/flow/conditions/or.ts
import * as util9 from "util";
var OrNode;
var init_or = __esm(() => {
  init_utils();
  init_condition();
  });

// src/flow/conditions/resources/advancement.ts
var AdvancementConditionNode;
var init_advancement3 = __esm(() => {
  init_condition();
  });

// src/flow/conditions/resources/predicate.ts
var PredicateConditionNode;
var init_predicate2 = __esm(() => {
  init_condition();
  });

// src/flow/conditions/resources/slotSource.ts
var SlotSourceConditionNode;
var init_slotSource2 = __esm(() => {
  init_condition();
  });

// src/flow/conditions/resources/tag.ts
var TagConditionNode;
var init_tag3 = __esm(() => {
  init_condition();
  });

// src/flow/conditions/resources/index.ts
var init_resources2 = __esm(() => {
  init_advancement3();
  init_predicate2();
  init_slotSource2();
  init_tag3();
});

// src/flow/conditions/variables/biome.ts
var BiomeConditionNode;
var init_biome = __esm(() => {
  init_variables2();
  init_condition();
  });

// src/flow/conditions/variables/block.ts
var BlockConditionNode;
var init_block = __esm(() => {
  init_variables2();
  init_condition();
  init_setblock();
  });

// src/flow/conditions/variables/blocks.ts
var BlocksConditionNode;
var init_blocks = __esm(() => {
  init_variables2();
  init_condition();
  });

// src/flow/conditions/variables/dataPoint.ts
var DataPointExistsConditionNode, DataPointEqualsConditionNode;
var init_dataPoint = __esm(() => {
  init_condition();
    });

// src/flow/conditions/variables/dimension.ts
var DimensionConditionNode;
var init_dimension = __esm(() => {
  init_condition();
  });

// src/flow/conditions/variables/function.ts
var FunctionConditionNode;
var init_function2 = __esm(() => {
  init_condition();
  });

// src/flow/conditions/variables/items.ts
var ItemsBlockConditionNode, ItemsEntityConditionNode, SlotsBlockConditionNode, SlotsEntityConditionNode;
var init_items = __esm(() => {
  init_variables2();
  init_condition();
        });

// src/flow/conditions/command.ts
var CommandConditionNode;
var init_command = __esm(() => {
  init_parsers();
  init_condition();
  });

// src/flow/conditions/variables/label.ts
var LabelConditionNode;
var init_label = __esm(() => {
  init_command();
  init_condition();
  });

// src/flow/conditions/variables/loaded.ts
var LoadedConditionNode;
var init_loaded = __esm(() => {
  init_variables2();
  init_condition();
  });

// src/flow/conditions/variables/score.ts
var ScoreConditionNode;
var init_score = __esm(() => {
  init_condition();
  });

// src/flow/conditions/variables/selector.ts
var SelectorConditionNode;
var init_selector = __esm(() => {
  init_condition();
  });

// src/flow/conditions/variables/uuid.ts
var UUIDConditionNode;
var init_uuid = __esm(() => {
  init_command();
  init_condition();
  });

// src/flow/conditions/variables/index.ts
var init_variables = __esm(() => {
  init_biome();
  init_block();
  init_blocks();
  init_dataPoint();
  init_dimension();
  init_function2();
  init_items();
  init_label();
  init_loaded();
  init_score();
  init_selector();
  init_uuid();
});

// src/flow/conditions/index.ts
var SandstoneConditions;
var init_conditions = __esm(() => {
  init_resources2();
  init_variables();
  init_and();
  init_condition();
  init_not();
  init_or();
  init_resources2();
  init_variables();
  SandstoneConditions = {
    Advancement: AdvancementConditionNode,
    Predicate: PredicateConditionNode,
    SlotSource: SlotSourceConditionNode,
    Tag: TagConditionNode,
    Biome: BiomeConditionNode,
    Block: BlockConditionNode,
    Blocks: BlocksConditionNode,
    Dimension: DimensionConditionNode,
    Function: FunctionConditionNode,
    ItemsBlock: ItemsBlockConditionNode,
    ItemsEntity: ItemsEntityConditionNode,
    SlotsBlock: SlotsBlockConditionNode,
    SlotsEntity: SlotsEntityConditionNode,
    Loaded: LoadedConditionNode,
    DataPointExists: DataPointExistsConditionNode,
    DataPointEquals: DataPointEqualsConditionNode,
    Label: LabelConditionNode,
    Score: ScoreConditionNode,
    Selector: SelectorConditionNode,
    UUID: UUIDConditionNode
  };
});

// src/flow/throw.ts
var ThrowNode;
var init_throw = __esm(() => {
  init_core();
  });

// src/flow/if_else.ts
import * as util10 from "util";

class IfStatement {
  sandstoneCore;
  condition;
  callback;
  node;
  constructor(sandstoneCore2, condition2, callback) {
    this.sandstoneCore = sandstoneCore2;
    this.condition = condition2;
    this.callback = callback;
    this.node = new IfNode(sandstoneCore2, condition2, callback);
  }
  get run() {
    return this._buildRun(this.node, this.node.parentMCFunction);
  }
  get else() {
    return this._buildElse();
  }
  elseIf(condition2, callback) {
    const cb = callback ?? (() => {});
    const statement = new IfStatement(this.sandstoneCore, conditionToNode(condition2), cb);
    this.node.nextFlowNode = statement.getNode();
    statement.node._isElseIf = true;
    return statement;
  }
  _buildRun(clauseNode, parentMCFunction) {
    const commandsSource = this.sandstoneCore.pack.commands;
    const commands2 = new Proxy(commandsSource, {
      get: (target, p, receiver) => {
        if (typeof p === "symbol" || !(p in target)) {
          return Reflect.get(target, p, receiver);
        }
        clauseNode.enterSingleCommand(parentMCFunction);
        return target[p];
      }
    });
    return commands2;
  }
  _buildElse() {
    const elseNode = new ElseNode(this.sandstoneCore, () => {});
    this.node.nextFlowNode = elseNode;
    const parentMCFunction = this.node.parentMCFunction;
    const commandsSource = this.sandstoneCore.pack.commands;
    const commands2 = new Proxy(commandsSource, {
      get: (target, p, receiver) => {
        if (p === "run")
          return commands2;
        if (typeof p === "symbol" || !(p in target)) {
          return Reflect.get(target, p, receiver);
        }
        elseNode.enterSingleCommand(parentMCFunction);
        return target[p];
      }
    });
    return makeCallable(commands2, (callback) => {
      const parentDepth = parentMCFunction.contextStack.length;
      parentMCFunction.enterContext(elseNode);
      callback();
      while (parentMCFunction.contextStack.length > parentDepth) {
        parentMCFunction.exitContext();
      }
      return new FinalCommandOutput(elseNode);
    }, true);
  }
  getNode = () => this.node;
}

class ElseStatement {
  sandstoneCore;
  callback;
  node;
  constructor(sandstoneCore2, callback) {
    this.sandstoneCore = sandstoneCore2;
    this.callback = callback;
    this.node = new ElseNode(sandstoneCore2, callback);
  }
  getNode = () => this.node;
}
var FlowClauseNode, IfNode, ElseNode;
var init_if_else = __esm(() => {
  init_core();
  init_commands2();
  init_utils();
  init_utils();
  init_Flow();
      });

// src/flow/loops/binary_for.ts
var init_binary_for = __esm(() => {
  init_variables2();
});

// src/flow/loop.ts
var LoopNode;
var init_loop = __esm(() => {
  init_core();
  });

// src/flow/loops/for_i.ts
class ForIStatement {
  sandstoneCore;
  initialValue;
  endCondition;
  iterate;
  callback;
  node;
  constructor(sandstoneCore2, initialValue, endCondition, iterate, callback) {
    this.sandstoneCore = sandstoneCore2;
    this.initialValue = initialValue;
    this.endCondition = endCondition;
    this.iterate = iterate;
    this.callback = callback;
    this.node = new ForINode(sandstoneCore2, initialValue, endCondition, iterate, callback);
  }
  getNode = () => this.node;
}
var ForINode;
var init_for_i = __esm(() => {
  init_variables2();
  init_flow();
  init_if_else();
  init_loop();
  });

// src/flow/loops/for_of.ts
function isMultipleVariable(iteratorType) {
  if (Array.isArray(iteratorType)) {
    return true;
  }
  return false;
}
function isMapIterator(iteratorType, iterable) {
  if (isMultipleVariable(iteratorType) && iteratorType[0] === "key") {
    if (iterable.iteratorType === "map") {
      return true;
    }
    throw new Error('Attempt to use "for key value" loop with a List iterable; this is not supported. (Hint: use "for entry" or "for i entry" instead)');
  }
  return false;
}

class ForOfStatement {
  sandstoneCore;
  iteratorType;
  direction;
  iterable;
  callback;
  node;
  constructor(sandstoneCore2, iteratorType, direction, iterable, callback) {
    this.sandstoneCore = sandstoneCore2;
    this.iteratorType = iteratorType;
    this.direction = direction;
    this.iterable = iterable;
    this.callback = callback;
    this.node = new ForOfNode(sandstoneCore2, iteratorType, direction, iterable, callback);
  }
  getNode = () => this.node;
}
var ForOfNode;
var init_for_of = __esm(() => {
  init_variables2();
  init_if_else();
  init_loop();
  });

// src/flow/loops/while.ts
class WhileStatement {
  sandstoneCore;
  condition;
  callback;
  node;
  constructor(sandstoneCore2, condition2, callback) {
    this.sandstoneCore = sandstoneCore2;
    this.condition = condition2;
    this.callback = callback;
    this.node = new WhileNode(sandstoneCore2, condition2, callback);
  }
}
var WhileNode;
var init_while = __esm(() => {
  init_variables2();
  init_if_else();
  init_flow();
  init_loop();
  });

// src/flow/loops/index.ts
var init_loops = __esm(() => {
  init_binary_for();
  init_for_i();
  init_for_of();
  init_while();
});

// src/flow/macro/with.ts
function withCommands(core, env) {
  const commandsSource = core.pack.macroCommands;
  return new Proxy(commandsSource, {
    get: (target, p, receiver) => {
      if (typeof p === "symbol" || !(p in target)) {
        return Reflect.get(target, p, receiver);
      }
      new WithClass(core, env).enterSingleCommand();
      return target[p];
    }
  });
}
var WITH_CHILD_NAME = "__with_macro", WithClass;
var init_with = __esm(() => {
  init_commands2();
  init_core();
  init_execute();
  });

// src/flow/macro/index.ts
var init_macro = __esm(() => {
  init_with();
});

// src/flow/switch_case.ts
class CaseStatement {
  entries;
  constructor(entries = []) {
    this.entries = entries;
  }
  getStaticCases() {
    return this.entries.filter((e) => e.type === "static");
  }
  getConditionCases() {
    return this.entries.filter((e) => e.type === "condition");
  }
  case(valueOrCondition, callback) {
    if (typeof valueOrCondition === "function") {
      return new CaseStatement([
        ...this.entries,
        { type: "condition", condition: valueOrCondition, callback }
      ]);
    }
    return new CaseStatement([
      ...this.entries,
      { type: "static", value: valueOrCondition, callback }
    ]);
  }
  default(callback) {
    return {
      entries: this.entries,
      default: callback
    };
  }
}
function isConditionCase(c) {
  return typeof c === "function";
}
function executeSwitch(sandstoneCore2, value, _cases) {
  let staticCaseEntries = [];
  let conditionCaseEntries = [];
  let _default;
  if (_cases instanceof CaseStatement) {
    staticCaseEntries = _cases.getStaticCases();
    conditionCaseEntries = _cases.getConditionCases();
  } else if (Array.isArray(_cases)) {
    for (const _case of _cases) {
      if (_case[0] === "default") {
        _default = _case;
        continue;
      }
      const [, condition2, callback] = _case;
      if (isConditionCase(condition2)) {
        conditionCaseEntries.push({ type: "condition", condition: condition2, callback });
      } else {
        staticCaseEntries.push({ type: "static", value: condition2, callback });
      }
    }
  } else {
    for (const _case of _cases.entries) {
      if (_case.type === "condition") {
        conditionCaseEntries.push(_case);
      } else {
        staticCaseEntries.push(_case);
      }
    }
    if (_cases.default) {
      _default = ["default", _cases.default];
    }
  }
  const staticCaseNodes = staticCaseEntries.map((c) => new StaticCaseNode(sandstoneCore2, c.value, c.callback));
  const conditionCaseNodes = conditionCaseEntries.map((c) => new ConditionCaseNode(sandstoneCore2, c.condition, c.callback));
  const defaultCaseNode = _default ? new DefaultCaseNode(sandstoneCore2, _default[1]) : undefined;
  new SwitchNode(sandstoneCore2, value, staticCaseNodes, conditionCaseNodes, defaultCaseNode);
}
var SwitchNode, StaticCaseNode, ConditionCaseNode, DefaultCaseNode;
var init_switch_case = __esm(() => {
  init_core();
        });

// src/flow/Flow.ts
function conditionToNode(condition2) {
  if (!(condition2 instanceof ConditionNode)) {
    return condition2._toMinecraftCondition();
  }
  return condition2;
}

class Flow {
  sandstoneCore;
  constructor(sandstoneCore2) {
    this.sandstoneCore = sandstoneCore2;
  }
  if(condition2, callback) {
    const cb = callback ?? (() => {});
    return new IfStatement(this.sandstoneCore, conditionToNode(condition2), cb);
  }
  and(...args) {
    const conditions = args[0] instanceof Array ? args[0] : args;
    return new AndNode(this.sandstoneCore, conditions.map((condition2) => conditionToNode(condition2)));
  }
  or(...args) {
    const conditions = args[0] instanceof Array ? args[0] : args;
    return new OrNode(this.sandstoneCore, conditions.map((condition2) => conditionToNode(condition2)));
  }
  not = (condition2) => new NotNode(this.sandstoneCore, conditionToNode(condition2));
  get return() {
    return this.sandstoneCore.pack.commands.returnCmd;
  }
  get await() {
    const methods = {
      sleep: (delay, logPath = false) => new SleepClass(this.sandstoneCore, delay, logPath),
      until: (condition2, pollRate, logPath = false) => new UntilClass(this.sandstoneCore, condition2, pollRate, logPath),
      attach: (entrypoint, func, branch, awaitNodeIdx, entity) => {
        return new AttachClass(this.sandstoneCore, { entrypoint, func, branch, awaitNodeIdx, entity }, false);
      },
      interrupt: (func, handle) => {}
    };
    const custom2 = (Ctor, ...args) => new Ctor(this.sandstoneCore, ...args);
    return makeCallable(methods, custom2, true);
  }
  throw(error, broadcast, dataPoint2) {
    const { pack, getCurrentMCFunctionOrThrow } = this.sandstoneCore;
    const { DataVariable } = pack;
    const node = getCurrentMCFunctionOrThrow();
    const fullError = [
      { text: `
Sandstone Pack Error:
`, color: "yellow" },
      typeof error === "string" ? { text: error } : error ?? { text: "[Function Threw]" },
      { text: `

` },
      { text: `@ Function ${node.resource.name}. Node ${node.body.length - 1}.
` }
    ];
    const errorSerializable = parseJSONText(this.sandstoneCore, fullError);
    if (dataPoint2 !== false) {
      const point = dataPoint2 ?? DataVariable();
      new ThrowNode(this.sandstoneCore, fullError, broadcast, point);
      return point;
    }
    new ThrowNode(this.sandstoneCore, fullError, broadcast, false);
    return errorSerializable;
  }
  while(condition2, callback) {
    return new WhileStatement(this.sandstoneCore, conditionToNode(condition2), callback);
  }
  doWhile(condition2, callback) {
    callback();
    return new WhileStatement(this.sandstoneCore, conditionToNode(condition2), callback);
  }
  for(arg1, arg2, arg3, arg4) {
    if (typeof arg1 === "number" || arg1 instanceof Score) {
      return new ForIStatement(this.sandstoneCore, arg1, arg2, arg3, arg4);
    }
    if (arg1 === "entry") {
      return new ForOfStatement(this.sandstoneCore, arg1, arg2 === "of-reverse" ? "reverse" : "normal", arg3, arg4);
    }
    if (arg1[0] === "key") {
      return new ForOfStatement(this.sandstoneCore, arg1, arg2 === "of-reverse" ? "reverse" : "normal", arg3, arg4);
    }
    if (typeof arg1[0] === "number" || arg1[0] instanceof Score) {
      if (arg2 === "iterate") {
        return new ForIStatement(this.sandstoneCore, arg1[0], (i) => i["<="](arg1[1]), (i) => i["++"], arg3);
      }
    }
    return new ForOfStatement(this.sandstoneCore, arg1, arg2 === "of-reverse" ? "reverse" : "normal", arg3, arg4);
  }
  switch(value, cases) {
    executeSwitch(this.sandstoneCore, value, cases);
  }
  case(value, callback) {
    if (typeof value === "function") {
      return new CaseStatement([
        { type: "condition", condition: value, callback }
      ]);
    }
    return new CaseStatement([
      {
        type: "static",
        value,
        callback
      }
    ]);
  }
  biome = (coordinates, biome2) => {
    return new SandstoneConditions.Biome(this.sandstoneCore, coordinates, biome2);
  };
  block(position, block2, state, nbt) {
    return new SandstoneConditions.Block(this.sandstoneCore, position, block2, state, nbt);
  }
  blocks = (start, end, destination, scan_mode = "all") => {
    return new SandstoneConditions.Blocks(this.sandstoneCore, start, end, destination, scan_mode);
  };
  data = (data2) => {
    return new SandstoneConditions.DataPointExists(this.sandstoneCore, data2);
  };
  dimension = (dimension2) => {
    return new SandstoneConditions.Dimension(this.sandstoneCore, dimension2);
  };
  mcfunction = (mcfunction2) => {
    if (typeof mcfunction2 === "string") {
      return new SandstoneConditions.Function(this.sandstoneCore, mcfunction2);
    }
    return new SandstoneConditions.Function(this.sandstoneCore, mcfunction2.name);
  };
  entity = (targets) => {
    return new SandstoneConditions.Selector(this.sandstoneCore, targets.toString());
  };
  get items() {
    return {
      block: (sourcePos, slotSource3, itemPredicate) => new SandstoneConditions.ItemsBlock(this.sandstoneCore, sourcePos, slotSource3, itemPredicate),
      entity: (source, slotSource3, itemPredicate) => new SandstoneConditions.ItemsEntity(this.sandstoneCore, source, slotSource3, itemPredicate)
    };
  }
  get slots() {
    return {
      block: (sourcePos, slotSource3) => new SandstoneConditions.SlotsBlock(this.sandstoneCore, sourcePos, slotSource3),
      entity: (source, slotSource3) => new SandstoneConditions.SlotsEntity(this.sandstoneCore, source, slotSource3)
    };
  }
  chunksLoaded = (position) => {
    return new SandstoneConditions.Loaded(this.sandstoneCore, position);
  };
  predicate = (predicate3) => {
    if (typeof predicate3 === "string") {
      return new SandstoneConditions.Predicate(this.sandstoneCore, predicate3);
    }
    return new SandstoneConditions.Predicate(this.sandstoneCore, predicate3.name);
  };
  with(env, callback) {
    if (callback) {
      return new WithClass(this.sandstoneCore, env, callback);
    }
    return withCommands(this.sandstoneCore, env);
  }
}
var init_Flow = __esm(() => {
  init_variables2();
  init_throw();
  init_utils();
  init_async();
  init_conditions();
  init_if_else();
  init_loops();
  init_macro();
  init_switch_case();
});

// src/flow/index.ts
var init_flow = __esm(() => {
  init_async();
  init_conditions();
  init_Flow();
  init_if_else();
  init_loop();
  init_macro();
  init_switch_case();
  init_throw();
});

// src/core/visitors.ts
function ancestors(prototype) {
  if (!prototype.name) {
    return [];
  }
  return [prototype.name, ...ancestors(Object.getPrototypeOf(prototype))];
}

var init_visitors = __esm(() => {
  init_core();
});

// src/pack/visitors/visitor.ts
var GenericSandstoneVisitor;
var init_visitor = __esm(() => {
  init_visitors();
  });

// src/pack/visitors/addAwaitBodyToMCFunctions.ts
var AwaitBodyVisitor;
var init_addAwaitBodyToMCFunctions = __esm(() => {
  init_core();
  init_flow();
  init_visitor();
  });

// src/pack/visitors/containerCommandsToMCFunction.ts
var ContainerCommandsToMCFunctionVisitor;
var init_containerCommandsToMCFunction = __esm(() => {
  init_commands2();
  init_core();
  init_macro();
  init_visitor();
  });

// src/pack/visitors/generateLazyMCFunctions.ts
var GenerateLazyMCFunction;
var init_generateLazyMCFunctions = __esm(() => {
  init_core();
  init_visitor();
  });

// src/pack/visitors/ifElseTransformationVisitor.ts
function* flattenIfNode(node) {
  yield node;
  const next = node.nextFlowNode;
  if (next instanceof IfNode) {
    yield* flattenIfNode(next);
  } else if (next) {
    yield next;
  }
}
function handleMultipleNodes(visitor, nodes2, macroStorage) {
  return nodes2.flatMap((node, i) => {
    const { body } = node;
    if (node instanceof IfNode) {
      const callbackName = i === 0 ? "if" : "elseif";
      let actualBody = body;
      if (body.length === 1) {
        const child = visitor.visit(body[0]);
        if (Array.isArray(child)) {
          actualBody = child;
        } else {
          return visitor.visit(new ExecuteCommandNode(visitor.pack, false, [[node.condition.getValue()]], {
            isSingleExecute: false,
            givenCallbackName: callbackName,
            body: [i === nodes2.length - 1 ? child : new ReturnRunCommandNode(visitor.pack, false, ["run"], {
              isSingleExecute: false,
              isFlowControl: true,
              body: [child]
            })],
            macroStorage
          }));
        }
      }
      return visitor.visit(new ExecuteCommandNode(visitor.pack, false, [[node.condition.getValue()]], {
        isSingleExecute: false,
        givenCallbackName: `${i}_${callbackName}`,
        body: [
          new ReturnRunCommandNode(visitor.pack, false, ["run"], {
            isSingleExecute: false,
            isFlowControl: true,
            body: actualBody
          })
        ],
        macroStorage
      }));
    }
    return body.flatMap((n) => visitor.visit(n));
  });
}
var IfElseTransformationVisitor;
var init_ifElseTransformationVisitor = __esm(() => {
  init_commands2();
  init_flow();
  init_visitor();
  });

// src/pack/visitors/initConstantsVisitor.ts
var InitConstantsVisitor;
var init_initConstantsVisitor = __esm(() => {
  init_commands2();
  init_visitor();
  });

// src/pack/visitors/initObjectivesVisitor.ts
var InitObjectivesVisitor;
var init_initObjectivesVisitor = __esm(() => {
  init_visitor();
  });

// src/pack/visitors/inlineFunctionCallVisitor.ts
var InlineFunctionCallVisitor;
var init_inlineFunctionCallVisitor = __esm(() => {
  init_commands2();
  init_core();
  init_visitor();
  });

// src/pack/visitors/loopTransformationVisitor.ts
var LoopTransformationVisitor;
var init_loopTransformationVisitor = __esm(() => {
  init_flow();
  init_visitor();
  });

// src/pack/visitors/orTransformationVisitor.ts
var FunctionReturnConditionNode, OrTransformationVisitor;
var init_orTransformationVisitor = __esm(() => {
  init_commands2();
  init_core();
  init_flow();
  init_visitor();
    });

// src/pack/visitors/optimizeMacroTemporaries.ts
var flattenArgs = (args) => args.flatMap((arg) => Array.isArray(arg) ? flattenArgs(arg) : [arg]), referencesStoragePoint = (node, point) => {
  let references = 0;
  if (node instanceof CommandNode) {
    const args = flattenArgs(node.args);
    for (let i = 0;i < args.length - 1; i++) {
      if (args[i] === point.target && args[i + 1] === point.path) {
        references++;
      }
    }
  }
  if (node instanceof ContainerNode || node instanceof ContainerCommandNode) {
    for (const child of node.body) {
      references += referencesStoragePoint(child, point);
    }
  }
  return references;
}, getMacroCopy = (node, macroPoint) => {
  if (!(node instanceof DataCommandNode)) {
    return;
  }
  const args = node.args;
  if (args[0] !== "modify" || args[1] !== "storage" || args[2] !== macroPoint.target || args[4] !== "set" || args[5] !== "from" || args[6] !== "storage" || typeof args[3] !== "string" || typeof args[7] !== "string" || typeof args[8] !== "string") {
    return;
  }
  const parameterPrefix = macroPoint.path ? `${macroPoint.path}.` : "";
  const destinationPath = args[3];
  const localPath = destinationPath.slice(parameterPrefix.length);
  if (!destinationPath.startsWith(parameterPrefix) || !localPath.startsWith("param_") && !localPath.startsWith("env_")) {
    return;
  }
  return {
    destination: { target: macroPoint.target, path: destinationPath },
    source: { target: args[7], path: args[8] }
  };
}, isMacroReset = (node, macroPoint) => {
  if (!(node instanceof DataCommandNode)) {
    return false;
  }
  const args = node.args;
  return args[0] === "modify" && args[1] === "storage" && args[2] === macroPoint.target && args[3] === macroPoint.path && args[4] === "set" && args[5] === "value" && `${args[6]}` === "{}";
}, getExecuteStore = (node, source) => {
  if (!(node instanceof ExecuteCommandNode)) {
    return;
  }
  const hasStoreResult = node.args.some((arg) => arg[0] === "store") && node.args.some((arg) => arg[0] === "result");
  if (!hasStoreResult) {
    return;
  }
  return node.args.find((arg) => arg[0] === "storage" && arg[1] === source.target && arg[2] === source.path);
}, OptimizeMacroTemporariesVisitor;
var init_optimizeMacroTemporaries = __esm(() => {
  init_commands2();
  init_core();
  init_ResolveNBT();
  init_visitor();
  });

// src/pack/visitors/simplifyExecuteFunction.ts
function getEffectiveSingleCommand(body) {
  const effectiveBody = body.filter((n) => !(n instanceof ElseNode));
  if (effectiveBody.length !== 1) {
    return null;
  }
  let command = effectiveBody[0];
  if (command instanceof ExecuteCommandNode && command.isFake && command.body.length === 1) {
    command = command.body[0];
  }
  return command;
}
var DEBUG_SIMPLIFY_EXEC = () => process.env.SANDSTONE_DEBUG_SIMPLIFY_EXEC === "1", SimplifyExecuteFunctionVisitor;
var init_simplifyExecuteFunction = __esm(() => {
  init_commands2();
  init_nodes();
  init_flow();
  init_variables2();
  init_visitor();
  });

// src/pack/visitors/simplifyReturnRunFunction.ts
function getEffectiveSingleCommand2(body) {
  const effectiveBody = body.filter((n) => !(n instanceof ElseNode));
  if (effectiveBody.length !== 1) {
    return null;
  }
  let command = effectiveBody[0];
  if (command instanceof ExecuteCommandNode && command.isFake && command.body.length === 1) {
    command = command.body[0];
  }
  return command;
}
var SimplifyReturnRunFunctionVisitor;
var init_simplifyReturnRunFunction = __esm(() => {
  init_commands2();
  init_nodes();
  init_flow();
  init_visitor();
  init_Macro();
  });

// src/pack/visitors/switchTransformationVisitor.ts
var SwitchTransformationVisitor;
var init_switchTransformationVisitor = __esm(() => {
  init_commands2();
  init_core();
  init_flow();
  init_variables2();
  init_visitor();
  });

// src/pack/visitors/throwInlineVisitor.ts
var ThrowInlineVisitor;
var init_throwInlineVisitor = __esm(() => {
  init_commands2();
  init_variables2();
  init_core();
  init_flow();
  init_visitor();
  });

// src/pack/visitors/throwPropagationVisitor.ts
var ThrowPropagationVisitor, ScoreResetNode;
var init_throwPropagationVisitor = __esm(() => {
  init_commands2();
  init_core();
  init_core();
  init_visitor();
    });

// src/pack/visitors/unifyChainedExecutes.ts
var UnifyChainedExecutesVisitor;
var init_unifyChainedExecutes = __esm(() => {
  init_commands2();
  init_visitor();
  });

// src/pack/visitors/withTransformationVisitor.ts
var WithNodeVisitor;
var init_withTransformationVisitor = __esm(() => {
  init_commands2();
  init_ResolveNBT();
  init_visitor();
  });

// src/pack/visitors/index.ts
var init_visitors2 = __esm(() => {
  init_containerCommandsToMCFunction();
  init_generateLazyMCFunctions();
  init_ifElseTransformationVisitor();
  init_initConstantsVisitor();
  init_initObjectivesVisitor();
  init_inlineFunctionCallVisitor();
  init_loopTransformationVisitor();
  init_orTransformationVisitor();
  init_optimizeMacroTemporaries();
  init_simplifyExecuteFunction();
  init_simplifyReturnRunFunction();
  init_switchTransformationVisitor();
  init_throwInlineVisitor();
  init_throwPropagationVisitor();
  init_unifyChainedExecutes();
  init_withTransformationVisitor();
});

// src/pack/pack.ts
class SandstonePack {
  defaultNamespace;
  packUid;
  core = new SandstoneCore(this);
  packTypes;
  get packOptions() {
    if (hasContext()) {
      return getSandstoneContext().packOptions;
    }
    return {
      datapack: {
        packFormat: 112,
        description: "A Sandstone datapack"
      },
      resourcepack: {
        packFormat: 93,
        description: "A Sandstone resource pack"
      }
    };
  }
  __initMCFunction;
  dependencies;
  flow;
  commands;
  macroCommands;
  Macro;
  conditions = SandstoneConditions;
  objectives;
  namedVariableIds;
  anonymousScoreId = 0;
  anonymousDataId = 0;
  constants;
  ticked;
  startAllTicked;
  tickedCommands;
  loadTags;
  __rootObjective;
  constructor(defaultNamespace, packUid) {
    this.defaultNamespace = defaultNamespace;
    this.packUid = packUid;
    this.packTypes = new Map;
    this.commands = new SandstoneCommands(this);
    this.macroCommands = new SandstoneCommands(this, true);
    this.Macro = makeCallable(this.macroCommands, (strings, ...macros) => new MacroLiteral(this.core, strings, macros), true);
    this.flow = new Flow(this.core);
    this.objectives = new Set;
    this.namedVariableIds = {};
    this.constants = new Set;
    this.ticked = {};
    this.tickedCommands = {};
    if (hasContext()) {
      this.defaultNamespace = getSandstoneContext().namespace;
    }
    this.loadTags = {
      preLoad: this.Tag("function", "load:pre_load", []),
      load: this.Tag("function", "load:load", []),
      postLoad: this.Tag("function", "load:post_load", [])
    };
    this.setupLantern();
    this.dependencies = new Map;
    for (const method of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (method !== "constructor" && typeof this[method] === "function" && typeof this[method].bind === "function") {
        this[method] = this[method].bind(this);
      }
    }
  }
  reset = () => {
    this.core.reset();
    this.packTypes.clear();
    this.__rootObjective = undefined;
    this.__initMCFunction = undefined;
    this.objectives.clear();
    this.anonymousDataId = 0;
    this.anonymousScoreId = 0;
    this.constants.clear();
    this.ticked = {};
    this.startAllTicked = undefined;
    this.tickedCommands = {};
    this.dependencies.clear();
    this.loadTags = {
      preLoad: this.Tag("function", "load:pre_load", []),
      load: this.Tag("function", "load:load", []),
      postLoad: this.Tag("function", "load:post_load", [])
    };
    this.setupLantern();
    if (hasContext()) {
      this.defaultNamespace = getSandstoneContext().namespace;
    }
    this.rootObjective;
    this.initMCFunction;
  };
  dataPack() {
    let pack = this.packTypes.get("datapack");
    if (!pack) {
      const options = this.packOptions.datapack ?? { packFormat: 112, description: "A Sandstone datapack" };
      pack = this.packTypes.set("datapack", new DataPack(false, options)).get("datapack");
    }
    return pack;
  }
  resourcePack() {
    let pack = this.packTypes.get("resourcepack");
    if (!pack) {
      const options = this.packOptions.resourcepack ?? { packFormat: 93, description: "A Sandstone resource pack" };
      pack = this.packTypes.set("resourcepack", new ResourcePack(options)).get("resourcepack");
    }
    return pack;
  }
  setupLantern = () => {
    const loadStatus = this.Objective.create("load.status", "dummy", undefined, { useDefaultNamespace: false, alreadyExists: true });
    const privateInit = this.Tag("function", "load:_private/init", [
      this.MCFunction("load:_private/init", () => {
        this.commands.comment("Reset scoreboards so packs can set values accurate for current load.");
        this.commands.scoreboard.objectives.add(loadStatus.name, "dummy");
        loadStatus.reset();
      })
    ]);
    const privateLoad = this.Tag("function", "load:_private/load", [
      privateInit,
      { id: this.loadTags.preLoad, required: false },
      { id: this.loadTags.load, required: false },
      { id: this.loadTags.postLoad, required: false }
    ]);
    this.Tag("function", "minecraft:load", [privateLoad]);
    const loadVersion = hasContext() ? getSandstoneContext().loadVersion ?? 1 : 1;
    this.initMCFunction.push(() => loadStatus(this.defaultNamespace).set(loadVersion));
  };
  resourceToPath = (name, resourceFolders) => {
    if (name === "") {
      throw new Error("A resource name must not be empty!");
    }
    let namespace = this.defaultNamespace;
    let fullName = name;
    if (name.includes(":")) {
      [namespace, fullName] = name.split(":");
    }
    const fullPath = fullName.split("/");
    if (!resourceFolders) {
      return fullPath;
    }
    return [namespace, ...resourceFolders, ...fullPath];
  };
  get _() {
    return this.flow;
  }
  registerNewObjective = (objective) => {
    for (const obj of this.objectives) {
      if (obj.name === objective.name) {
        return;
      }
    }
    this.objectives.add(objective);
  };
  registerNewConstant(amount) {
    this.constants.add(amount);
  }
  Objective = {
    create: (name, criteria = "dummy", display, options = {}) => {
      let { alreadyExists = false, useDefaultNamespace = true } = options;
      if (useDefaultNamespace) {
        name = `${this.defaultNamespace}.${name}`;
      }
      const objective = new ObjectiveClass(this, name, criteria, display, { creator: "user" });
      if (!alreadyExists) {
        this.registerNewObjective(objective);
      }
      return objective;
    },
    get: (name) => new ObjectiveClass(this, name, "dummy", undefined, { creator: "user" })
  };
  get rootObjective() {
    if (this.__rootObjective) {
      return this.__rootObjective;
    }
    this.__rootObjective = this.Objective.create("__sandstone", "dummy", [
      { text: "Sandstone", color: "gold" },
      " internals"
    ], { useDefaultNamespace: false });
    return this.__rootObjective;
  }
  variableName(name) {
    if (name === undefined) {
      return `anon_${this.packUid}_${this.anonymousScoreId++}`;
    } else {
      this.namedVariableIds[name] ??= 0;
      return `${name}_${this.namedVariableIds[name]++}_${this.packUid}`;
    }
  }
  Variable(...args) {
    const score2 = this.rootObjective;
    if (args[0] instanceof DataPointClass) {
      const [nbt, scale, name2] = args;
      return this.Variable(undefined, name2).set(nbt, scale);
    }
    const [initialValue, name] = args;
    const anonymousScore = score2(this.variableName(name));
    if (initialValue === undefined) {
      return anonymousScore;
    }
    if (this.core.currentMCFunction) {
      return anonymousScore.set(initialValue);
    }
    this.initMCFunction.push(() => anonymousScore.set(initialValue));
    return anonymousScore;
  }
  get flowVariable() {
    return this.rootObjective("if_result");
  }
  Trigger = (name, callback, pollingEvery = 1) => new TriggerClass(this.core, name, callback, pollingEvery);
  Label = (label2, description) => new LabelClass(this, label2, description);
  ItemPredicate = (itemType) => new ItemPredicateClass(this, itemType);
  Data(type, target, path4) {
    const dataPath = path4 ?? typeof path4 === "string" ? [path4] : path4;
    if (!path4 && !target) {
      return new TargetlessDataClass(this, type);
    }
    if (!target) {
      return new TargetlessDataPointClass(this, type, dataPath);
    }
    if (!path4) {
      return new DataClass(this, type, isMacroArgument(this.core, target) || (type === "block" ? coordinatesParser(target) : target));
    }
    return new DataPointClass(this, type, target instanceof VectorClass ? coordinatesParser(target) : target, dataPath);
  }
  __rootStorage;
  rootStorage() {
    if (!this.__rootStorage) {
      this.__rootStorage = new DataPointClass(this, "storage", "__sandstone:variable", []);
      return this.__rootStorage;
    }
    return this.__rootStorage;
  }
  DataVariable(...args) {
    const data2 = this.rootStorage();
    if (args[0] instanceof Score) {
      const [score2, storeType, scale, name2] = args;
      return this.DataVariable(undefined, name2).set(score2, storeType || "int", scale || 1);
    }
    const [initialValue, name] = args;
    const anonymousData = data2.select(`${name ?? "anon"}_${this.packUid}${name === undefined ? `_${this.anonymousDataId++}` : ""}`);
    if (initialValue === undefined) {
      return anonymousData;
    }
    if (this.core.currentMCFunction) {
      return anonymousData.set(initialValue);
    }
    this.initMCFunction.push(() => anonymousData.set(initialValue));
    return anonymousData;
  }
  DataIndexMap(initialize, dataPoint2) {
    return DataIndexMapInternal(this, initialize, dataPoint2);
  }
  DataArray(initialize, dataPoint2) {
    return DataArrayInternal(this, initialize, dataPoint2);
  }
  getTempStorage = (name) => {
    if (tempStorage) {
      return tempStorage.select(name);
    }
    tempStorage = this.Data("storage", "__sandstone:temp");
    return tempStorage.select(name);
  };
  ResolveNBT = (nbt, dataPoint2, skipReset) => new ResolveNBTClass(this, nbt, dataPoint2, skipReset);
  Selector(target, selectorArguments) {
    return new SelectorClass(this, target, selectorArguments);
  }
  UUID(source = randomUUID(), options) {
    return new UUIDClass(this.core, source, options);
  }
  MCFunction(...args) {
    return new MCFunctionClass(this.core, args[0], {
      callback: typeof args[1] === "function" ? args[1] : args[2],
      creator: "user",
      addToSandstoneCore: true,
      onConflict: conflictDefaults("function"),
      ...Array.isArray(args[1]) ? args[3] : args[2] || args[1]
    }, Array.isArray(args[1]) ? args[1] : undefined);
  }
  appendNode = (node) => this.core.getCurrentMCFunctionOrThrow().appendNode(node);
  get initMCFunction() {
    if (!this.__initMCFunction) {
      this.__initMCFunction = new MCFunctionClass(this.core, `${this.defaultNamespace}:__init__`, {
        addToSandstoneCore: true,
        creator: "sandstone"
      });
      this.loadTags.load.push(this.__initMCFunction);
      return this.__initMCFunction;
    }
    return this.__initMCFunction;
  }
  registerTicked(runEvery, func) {
    if (typeof runEvery === "number") {
      runEvery = `${runEvery}t`;
    }
    const tag4 = this.ticked[runEvery] ?? (() => {
      const name = `__sandstone:ticked/${runEvery}`;
      this.ticked[runEvery] = this.Tag("function", name, []);
      const looped = this.MCFunction(name, (self) => {
        this.commands.functionCmd(this.ticked[runEvery]);
        self.schedule.function(runEvery, "replace");
      });
      if (this.startAllTicked === undefined) {
        this.startAllTicked = this.MCFunction(`__sandstone:ticked/start/${this.packUid.toLowerCase()}`);
        this.loadTags.load.push(this.startAllTicked);
      }
      this.startAllTicked.push(() => looped());
      return this.ticked[runEvery];
    })();
    if (func.env === undefined) {
      tag4.push(func);
    } else {
      this.registerTickedCommands(runEvery, () => func());
    }
  }
  registerTickedCommands(runEvery, callback) {
    if (typeof runEvery === "number") {
      runEvery = `${runEvery}t`;
    }
    if (this.tickedCommands[runEvery] === undefined) {
      this.tickedCommands[runEvery] = this.MCFunction(`__sandstone:ticked/${runEvery}/${this.packUid.toLowerCase()}_commands`);
      this.registerTicked(runEvery, this.tickedCommands[runEvery]);
    }
    this.tickedCommands[runEvery].push(callback);
  }
  Loop = () => new LoopArgument(this);
  __customResourceTypes = [];
  registerCustomResource(type) {
    if (this.__customResourceTypes.includes(type)) {
      throw new Error(`A custom resource of the type '${type}' has already been created!`);
    }
    this.__customResourceTypes.push(type);
  }
  get makeCustomResource() {
    return [this.core, CustomResourceClass];
  }
  RawResource(...args) {
    const [core, CustomResource] = this.makeCustomResource;
    if (args[0] instanceof PackType) {
      const _path2 = args[1];
      const path5 = _path2.includes("/") ? _path2.split("/") : [_path2];
      const extension2 = path5[path5.length - 1].split(".")[1];
      path5[path5.length - 1] = path5[path5.length - 1].replace(`.${extension2}`, "");

      class RawResource2 extends CustomResource {
        constructor() {
          super(core, path5.join("/"), {
            type: `${Math.random()}`,
            packType: args[0],
            extension: extension2,
            addToSandstoneCore: true,
            creator: "user"
          });
        }
        getValue = () => args[2];
      }
      return new RawResource2;
    }
    const _path = args[0];
    const path4 = _path.includes("/") ? _path.split("/") : [_path];
    const extension = path4[path4.length - 1].split(".")[1];
    path4[path4.length - 1] = path4[path4.length - 1].replace(`.${extension}`, "");

    class RawResource extends CustomResource {
      constructor() {
        super(core, path4.join("/"), {
          type: `${Math.random()}`,
          extension,
          addToSandstoneCore: true,
          creator: "user"
        });
      }
      getValue = () => args[1];
    }
    return new RawResource;
  }
  Advancement(name, json, options) {
    return new AdvancementClass(this.core, name, {
      json,
      creator: "user",
      addToSandstoneCore: true,
      onConflict: conflictDefaults("advancement"),
      ...options
    });
  }
  DamageType = (name, damageType2, options) => new DamageTypeClass(this.core, name, {
    json: damageType2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("damage_type"),
    ...options
  });
  DecoratedPotPattern = (name, decoratedPotPattern2, options) => new DecoratedPotPatternClass(this.core, name, {
    json: decoratedPotPattern2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("decorated_pot_pattern"),
    ...options
  });
  ItemModifier = (name, itemModifier2, options) => new ItemModifierClass(this.core, name, {
    json: itemModifier2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("item_modifier"),
    ...options
  });
  LootTable = (name, lootTable2, options) => new LootTableClass(this.core, name, {
    json: lootTable2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("loot_table"),
    ...options
  });
  Predicate = (name, predicate3, options) => new PredicateClass(this.core, name, {
    json: predicate3,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("predicate"),
    ...options
  });
  Recipe = (name, recipe3, options) => new RecipeClass(this.core, name, {
    json: recipe3,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("recipe"),
    ...options
  });
  SlotSource = (name, slotSource3, options) => new SlotSourceClass(this.core, name, {
    json: slotSource3,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("slot_source"),
    ...options
  });
  SulfurCubeArchetype = (name, sulfurCubeArchetype2, options) => new SulfurCubeArchetypeClass(this.core, name, {
    json: sulfurCubeArchetype2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("sulfur_cube_archetype"),
    ...options
  });
  Tag = (type, name, values, options) => new TagClass(this.core, type, name, {
    values,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("tag"),
    ...options
  });
  TrimMaterial = (name, trimMaterial2, options) => new TrimMaterialClass(this.core, name, {
    json: trimMaterial2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("trim_material"),
    ...options
  });
  TrimPattern = (name, trimPattern2, options) => new TrimPatternClass(this.core, name, {
    json: trimPattern2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("trim_pattern"),
    ...options
  });
  BannerPattern = (name, bannerPattern2, options) => new BannerPatternClass(this.core, name, {
    json: bannerPattern2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("banner_pattern"),
    ...options
  });
  ChatType = (name, chatType2, options) => new ChatTypeClass(this.core, name, {
    json: chatType2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("chat_type"),
    ...options
  });
  Dialog = (name, dialog3, options) => new DialogClass(this.core, name, {
    json: dialog3,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("dialog"),
    ...options
  });
  Enchantment = (name, enchantment2, options) => new EnchantmentClass(this.core, name, {
    json: enchantment2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("enchantment"),
    ...options
  });
  EnchantmentProvider = (name, enchantmentProvider, options) => new EnchantmentProviderClass(this.core, name, {
    json: enchantmentProvider,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("enchantment_provider"),
    ...options
  });
  Instrument = (name, instrument2, options) => new InstrumentClass(this.core, name, {
    json: instrument2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("instrument"),
    ...options
  });
  JukeboxSong = (name, jukeboxSong2, options) => new JukeboxSongClass(this.core, name, {
    json: jukeboxSong2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("jukebox_song"),
    ...options
  });
  TestEnvironment = (name, testEnvironment, options) => new TestEnvironmentClass(this.core, name, {
    json: testEnvironment,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("test_environment"),
    ...options
  });
  TestInstance = (name, testInstance, options) => new TestInstanceClass(this.core, name, {
    json: testInstance,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("test_instance"),
    ...options
  });
  Timeline = (name, timeline2, options) => new TimelineClass(this.core, name, {
    json: timeline2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("timeline"),
    ...options
  });
  WorldClock = (name, worldClock, options) => new WorldClockClass(this.core, name, {
    json: worldClock,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("world_clock"),
    ...options
  });
  TradeSet = (name, tradeSet, options) => new TradeSetClass(this.core, name, {
    json: tradeSet,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("trade_set"),
    ...options
  });
  TrialSpawner = (name, trialSpawner2, options) => new TrialSpawnerClass(this.core, name, {
    json: trialSpawner2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("trial_spawner"),
    ...options
  });
  VillagerTrade = (name, villagerTrade2, options) => new VillagerTradeClass(this.core, name, {
    json: villagerTrade2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("villager_trade"),
    ...options
  });
  Variant = (type, name, variant2, options) => new VariantClass(this.core, type, name, {
    variant: variant2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults(`${type}_variant`),
    ...options
  });
  Atlas = (name, json, options) => new AtlasClass(this.core, name, {
    json,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("atlas"),
    ...options
  });
  BlockStateDefinition(name, json, options) {
    return new BlockStateDefinitionClass(this.core, name, {
      json,
      creator: "user",
      addToSandstoneCore: true,
      onConflict: conflictDefaults("blockstate"),
      ...options
    });
  }
  Font = (name, providers, options) => new FontClass(this.core, name, {
    providers,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("font"),
    ...options
  });
  Language = (name, language2, options) => new LanguageClass(this.core, name, {
    language: language2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("language"),
    ...options
  });
  Model(type, name, json, options) {
    return new ModelClass(this.core, type, name, {
      json,
      creator: "user",
      addToSandstoneCore: true,
      onConflict: conflictDefaults("model"),
      ...options
    });
  }
  ItemModelDefinition = (name, definition, options) => new ItemModelDefinitionClass(this.core, name, {
    definition,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("item_definition"),
    ...options
  });
  SoundEvent(type, name, sound2, options) {
    return new SoundEventClass(this.core, type, name, {
      sound: sound2,
      creator: "user",
      addToSandstoneCore: true,
      onConflict: conflictDefaults("sound_event"),
      ...options
    });
  }
  SoundsIndex = (definitions, namespace, options) => new SoundsIndexClass(this.core, namespace ?? this.defaultNamespace, {
    definitions,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("sounds"),
    ...options
  });
  PlainText = (name, text2, options) => new PlainTextClass(this.core, name, {
    text: text2,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("atlas"),
    ...options
  });
  Texture(type, name, texture2, options) {
    return new TextureClass(this.core, type, name, {
      texture: texture2,
      creator: "user",
      addToSandstoneCore: true,
      onConflict: conflictDefaults("sound_event"),
      ...options
    });
  }
  Equipment = (name, json, options) => new EquipmentClass(this.core, name, {
    json,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("equipment"),
    ...options
  });
  Particle = (name, json, options) => new ParticleClass(this.core, name, {
    json,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("particle"),
    ...options
  });
  PostEffect = (name, json, options) => new PostEffectClass(this.core, name, {
    json,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("post_effect"),
    ...options
  });
  Shader = (name, json, options) => new ShaderClass(this.core, name, {
    json,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("shader"),
    ...options
  });
  WaypointStyle = (name, json, options) => new WaypointStyleClass(this.core, name, {
    json,
    creator: "user",
    addToSandstoneCore: true,
    onConflict: conflictDefaults("waypoint_style"),
    ...options
  });
  async save(cliOptions) {
    await this.core.save(cliOptions, {
      visitors: defaultVisitors(this)
    });
    return this.packTypes;
  }
  compile(name, callback) {
    this.MCFunction(name, callback);
    const visitors = defaultVisitors(this);
    const resources3 = this.core.generateResources({ visitors });
    const out = new Map;
    for (const node of resources3) {
      const { packType, fileExtension } = node.resource;
      const _path = [packType.type, ...node.resource.path];
      if (packType.resourceSubFolder) {
        _path.splice(1, 0, packType.resourceSubFolder);
      }
      const resourcePath = `${_path.join("/")}.${fileExtension}`;
      const value = node.getValue();
      if (typeof value === "string") {
        out.set(resourcePath, value);
      }
    }
    return out;
  }
}
function defaultVisitors(pack) {
  return [
    new InitObjectivesVisitor(pack),
    new InitConstantsVisitor(pack),
    new GenerateLazyMCFunction(pack),
    new LoopTransformationVisitor(pack),
    new SwitchTransformationVisitor(pack),
    new OrTransformationVisitor(pack),
    new IfElseTransformationVisitor(pack),
    new ThrowInlineVisitor(pack),
    new ContainerCommandsToMCFunctionVisitor(pack),
    new AwaitBodyVisitor(pack),
    new ThrowPropagationVisitor(pack),
    new WithNodeVisitor(pack),
    new OptimizeMacroTemporariesVisitor(pack),
    new InlineFunctionCallVisitor(pack),
    new UnifyChainedExecutesVisitor(pack),
    new SimplifyExecuteFunctionVisitor(pack),
    new SimplifyReturnRunFunctionVisitor(pack)
  ];
}
var conflictDefaults = (resourceType) => {
  if (!hasContext())
    return;
  const strategies = getSandstoneContext().conflictStrategies;
  return strategies?.[resourceType] || strategies?.default;
}, tempStorage, DataPack, ResourcePack;
var init_pack = __esm(() => {
  init_commands2();
  init_core();
  init_custom();
  init_flow();
  init_utils();
  init_variables2();
  init_ResolveNBT();
  init_addAwaitBodyToMCFunctions();
  init_visitors2();
    });

// src/pack/index.ts
var init_pack2 = __esm(() => {
  init_dependencies();
  init_pack();
  init_visitors2();
});

// src/sandstone.ts
var _sandstonePack, sandstonePack, commandsProxy, packMethodsProxy, _, getVanillaResource, getExistingResource, depend, mcMetaCache;
var init_sandstone = __esm(() => {
  init_pack2();
  init_utils();
  init_Coordinates();
  init_ResolveNBT();
  init_NBTs();
  init_variables2();
  init_core();
  init_resources();
  sandstonePack = new Proxy({}, {
    get(_target, prop) {
      if (!_sandstonePack) {
        if (hasContext()) {
          const ctx = getSandstoneContext();
          _sandstonePack = new SandstonePack(ctx.namespace, ctx.packUid);
        } else {
          _sandstonePack = new SandstonePack("default", "0");
        }
      }
      return _sandstonePack[prop];
    }
  });
  commandsProxy = new Proxy({}, {
    get(_, prop) {
      const fn = (...args) => {
        const cmd = sandstonePack.commands[prop];
        if (typeof cmd === "function") {
          return cmd(...args);
        }
        throw new Error(`Command '${prop}' is not callable`);
      };
      return new Proxy(fn, {
        get(_target, subProp) {
          const cmd = sandstonePack.commands[prop];
          return cmd[subProp];
        },
        apply(_target, _thisArg, args) {
          const cmd = sandstonePack.commands[prop];
          if (typeof cmd === "function") {
            return cmd(...args);
          }
          throw new Error(`Command '${prop}' is not callable`);
        }
      });
    }
  });
  packMethodsProxy = new Proxy({}, {
    get(_, prop) {
      const fn = (...args) => {
        const method = sandstonePack[prop];
        if (typeof method === "function") {
          return method(...args);
        }
        throw new Error(`Pack method '${prop}' is not callable`);
      };
      return new Proxy(fn, {
        get(_target, subProp) {
          const method = sandstonePack[prop];
          const value = method[subProp];
          if (typeof value === "function" && typeof value.bind === "function") {
            return value.bind(method);
          }
          return value;
        },
        apply(_target, _thisArg, args) {
          const method = sandstonePack[prop];
          if (typeof method === "function") {
            return method(...args);
          }
          throw new Error(`Pack method '${prop}' is not callable`);
        }
      });
    }
  });
  _ = new Proxy({}, {
    get(_target, prop) {
      return sandstonePack._[prop];
    }
  });
  ({ getVanillaResource, getExistingResource, depend } = sandstonePack.core);
  mcMetaCache = new Proxy({}, {
    get: () => sandstonePack.core.mcMetaCache
  });
});

// src/arguments/generated/registry.ts
var REGISTRIES_SET;
var init_registry = __esm(() => {
  init_sandstone();
  REGISTRIES_SET = new Set2([
    "advancement",
    "banner_pattern",
    "cat_sound_variant",
    "cat_variant",
    "chat_type",
    "chicken_sound_variant",
    "chicken_variant",
    "cow_sound_variant",
    "cow_variant",
    "damage_type",
    "decorated_pot_pattern",
    "dialog",
    "dimension",
    "dimension_type",
    "enchantment",
    "enchantment_provider",
    "frog_variant",
    "function",
    "instrument",
    "item_modifier",
    "jukebox_song",
    "loot_table",
    "number_provider",
    "painting_variant",
    "pig_sound_variant",
    "pig_variant",
    "predicate",
    "recipe",
    "slot_source",
    "structure",
    "sulfur_cube_archetype",
    "test_environment",
    "test_instance",
    "timeline",
    "trade_set",
    "trial_spawner",
    "trim_material",
    "trim_pattern",
    "villager_trade",
    "wolf_sound_variant",
    "wolf_variant",
    "world_clock",
    "zombie_nautilus_variant",
    "activity",
    "armor_material",
    "attribute",
    "attribute_type",
    "block",
    "block_entity_type",
    "block_predicate_type",
    "block_type",
    "chunk_status",
    "command_argument_type",
    "consume_effect_type",
    "creative_mode_tab",
    "custom_stat",
    "data_component_predicate_type",
    "data_component_type",
    "debug_subscription",
    "decorated_pot_pattern",
    "decorated_pot_patterns",
    "dialog_action_type",
    "dialog_body_type",
    "dialog_type",
    "enchantment_effect_component_type",
    "enchantment_entity_effect_type",
    "enchantment_level_based_value_type",
    "enchantment_location_based_effect_type",
    "enchantment_provider_type",
    "enchantment_value_effect_type",
    "entity_sub_predicate_type",
    "entity_type",
    "environment_attribute",
    "float_provider_type",
    "fluid",
    "game_event",
    "game_rule",
    "height_provider_type",
    "incoming_rpc_methods",
    "input_control_type",
    "instrument",
    "int_provider_type",
    "item",
    "item_sub_predicate_type",
    "loot_condition_type",
    "loot_function_type",
    "loot_nbt_provider_type",
    "loot_number_provider_type",
    "loot_pool_entry_type",
    "loot_score_provider_type",
    "map_decoration_type",
    "memory_module_type",
    "menu",
    "mob_effect",
    "motive",
    "number_format_type",
    "outgoing_rpc_methods",
    "particle_type",
    "permission_check_type",
    "permission_type",
    "point_of_interest_type",
    "pos_rule_test",
    "position_source_type",
    "potion",
    "recipe_book_category",
    "recipe_display",
    "recipe_serializer",
    "recipe_type",
    "rule_block_entity_modifier",
    "rule_test",
    "schedule",
    "sensor_type",
    "slot_display",
    "slot_source_type",
    "sound_event",
    "spawn_condition_type",
    "stat_type",
    "test_environment_definition_type",
    "test_function",
    "test_instance_type",
    "trigger_type",
    "ticket_type",
    "villager_profession",
    "villager_type",
    "worldgen/biome_source",
    "worldgen/block_placer_type",
    "worldgen/block_state_provider_type",
    "worldgen/carver",
    "worldgen/carver_type",
    "worldgen/chunk_generator",
    "worldgen/decorator",
    "worldgen/density_function_type",
    "worldgen/feature",
    "worldgen/feature_size_type",
    "worldgen/feature_type",
    "worldgen/foliage_placer_type",
    "worldgen/material_condition",
    "worldgen/material_condition_type",
    "worldgen/material_rule",
    "worldgen/material_rule_type",
    "worldgen/placement_modifier_type",
    "worldgen/pool_alias_binding",
    "worldgen/root_placer_type",
    "worldgen/structure_feature",
    "worldgen/structure_piece",
    "worldgen/structure_placement",
    "worldgen/structure_pool_element",
    "worldgen/structure_processor",
    "worldgen/structure_type",
    "worldgen/surface_builder",
    "worldgen/tree_decorator_type",
    "worldgen/trunk_placer_type",
    "worldgen/biome",
    "worldgen/carver",
    "worldgen/configured_carver",
    "worldgen/configured_feature",
    "worldgen/configured_structure_feature",
    "worldgen/configured_surface_builder",
    "worldgen/density_function",
    "worldgen/feature",
    "worldgen/flat_level_generator_preset",
    "worldgen/material_condition",
    "worldgen/material_rule",
    "worldgen/multi_noise_biome_source_parameter_list",
    "worldgen/noise",
    "worldgen/noise_settings",
    "worldgen/placed_feature",
    "worldgen/processor_list",
    "worldgen/structure",
    "worldgen/structure_set",
    "worldgen/template_pool",
    "worldgen/world_preset"
  ]);
});

// src/arguments/generated/_registry/advancements.ts
var ADVANCEMENTS_SET;
var init_advancements = __esm(() => {
  init_sandstone();
  ADVANCEMENTS_SET = new Set2([
    "adventure/adventuring_time",
    "adventure/arbalistic",
    "adventure/avoid_vibration",
    "adventure/blowback",
    "adventure/brush_armadillo",
    "adventure/bullseye",
    "adventure/craft_decorated_pot_using_only_sherds",
    "adventure/crafters_crafting_crafters",
    "adventure/fall_from_world_height",
    "adventure/heart_transplanter",
    "adventure/hero_of_the_village",
    "adventure/honey_block_slide",
    "adventure/kill_a_mob",
    "adventure/kill_all_mobs",
    "adventure/kill_mob_near_sculk_catalyst",
    "adventure/lighten_up",
    "adventure/lightning_rod_with_villager_no_fire",
    "adventure/minecraft_trials_edition",
    "adventure/ol_betsy",
    "adventure/overoverkill",
    "adventure/play_jukebox_in_meadows",
    "adventure/read_power_of_chiseled_bookshelf",
    "adventure/revaulting",
    "adventure/root",
    "adventure/salvage_sherd",
    "adventure/shoot_arrow",
    "adventure/sleep_in_bed",
    "adventure/sniper_duel",
    "adventure/spear_many_mobs",
    "adventure/spyglass_at_dragon",
    "adventure/spyglass_at_ghast",
    "adventure/spyglass_at_parrot",
    "adventure/summon_iron_golem",
    "adventure/throw_trident",
    "adventure/totem_of_undying",
    "adventure/trade",
    "adventure/trade_at_world_height",
    "adventure/trim_with_all_exclusive_armor_patterns",
    "adventure/trim_with_any_armor_pattern",
    "adventure/two_birds_one_arrow",
    "adventure/under_lock_and_key",
    "adventure/use_lodestone",
    "adventure/very_very_frightening",
    "adventure/voluntary_exile",
    "adventure/walk_on_powder_snow_with_leather_boots",
    "adventure/who_needs_rockets",
    "adventure/whos_the_pillager_now",
    "end/dragon_breath",
    "end/dragon_egg",
    "end/elytra",
    "end/enter_end_gateway",
    "end/find_end_city",
    "end/kill_dragon",
    "end/levitate",
    "end/respawn_dragon",
    "end/root",
    "husbandry/allay_deliver_cake_to_note_block",
    "husbandry/allay_deliver_item_to_player",
    "husbandry/axolotl_in_a_bucket",
    "husbandry/balanced_diet",
    "husbandry/bred_all_animals",
    "husbandry/breed_an_animal",
    "husbandry/complete_catalogue",
    "husbandry/feed_snifflet",
    "husbandry/fishy_business",
    "husbandry/froglights",
    "husbandry/kill_axolotl_target",
    "husbandry/leash_all_frog_variants",
    "husbandry/make_a_sign_glow",
    "husbandry/obtain_netherite_hoe",
    "husbandry/obtain_sniffer_egg",
    "husbandry/place_dried_ghast_in_water",
    "husbandry/plant_any_sniffer_seed",
    "husbandry/plant_seed",
    "husbandry/remove_wolf_armor",
    "husbandry/repair_wolf_armor",
    "husbandry/ride_a_boat_with_a_goat",
    "husbandry/root",
    "husbandry/safely_harvest_honey",
    "husbandry/silk_touch_nest",
    "husbandry/tactical_fishing",
    "husbandry/tadpole_in_a_bucket",
    "husbandry/tame_an_animal",
    "husbandry/uh_oh",
    "husbandry/wax_off",
    "husbandry/wax_on",
    "husbandry/whole_pack",
    "nether/all_effects",
    "nether/all_potions",
    "nether/brew_potion",
    "nether/charge_respawn_anchor",
    "nether/create_beacon",
    "nether/create_full_beacon",
    "nether/distract_piglin",
    "nether/explore_nether",
    "nether/fast_travel",
    "nether/find_bastion",
    "nether/find_fortress",
    "nether/get_wither_skull",
    "nether/loot_bastion",
    "nether/netherite_armor",
    "nether/obtain_ancient_debris",
    "nether/obtain_blaze_rod",
    "nether/obtain_crying_obsidian",
    "nether/return_to_sender",
    "nether/ride_strider",
    "nether/ride_strider_in_overworld_lava",
    "nether/root",
    "nether/summon_wither",
    "nether/uneasy_alliance",
    "recipes/brewing/blaze_powder",
    "recipes/brewing/brewing_stand",
    "recipes/brewing/cauldron",
    "recipes/brewing/fermented_spider_eye",
    "recipes/brewing/glass_bottle",
    "recipes/brewing/glistering_melon_slice",
    "recipes/brewing/golden_carrot",
    "recipes/brewing/magma_cream",
    "recipes/building_blocks/acacia_planks",
    "recipes/building_blocks/acacia_slab",
    "recipes/building_blocks/acacia_stairs",
    "recipes/building_blocks/acacia_wood",
    "recipes/building_blocks/amethyst_block",
    "recipes/building_blocks/andesite",
    "recipes/building_blocks/andesite_slab",
    "recipes/building_blocks/andesite_slab_from_andesite_stonecutting",
    "recipes/building_blocks/andesite_stairs",
    "recipes/building_blocks/andesite_stairs_from_andesite_stonecutting",
    "recipes/building_blocks/bamboo_block",
    "recipes/building_blocks/bamboo_mosaic_slab",
    "recipes/building_blocks/bamboo_mosaic_stairs",
    "recipes/building_blocks/bamboo_planks",
    "recipes/building_blocks/bamboo_slab",
    "recipes/building_blocks/bamboo_stairs",
    "recipes/building_blocks/birch_planks",
    "recipes/building_blocks/birch_slab",
    "recipes/building_blocks/birch_stairs",
    "recipes/building_blocks/birch_wood",
    "recipes/building_blocks/black_concrete_powder",
    "recipes/building_blocks/black_concrete_slab",
    "recipes/building_blocks/black_concrete_stairs",
    "recipes/building_blocks/black_stained_glass",
    "recipes/building_blocks/black_terracotta",
    "recipes/building_blocks/black_wool_slab",
    "recipes/building_blocks/black_wool_stairs",
    "recipes/building_blocks/blackstone_slab",
    "recipes/building_blocks/blackstone_slab_from_blackstone_stonecutting",
    "recipes/building_blocks/blackstone_stairs",
    "recipes/building_blocks/blackstone_stairs_from_blackstone_stonecutting",
    "recipes/building_blocks/blue_concrete_powder",
    "recipes/building_blocks/blue_concrete_slab",
    "recipes/building_blocks/blue_concrete_stairs",
    "recipes/building_blocks/blue_ice",
    "recipes/building_blocks/blue_stained_glass",
    "recipes/building_blocks/blue_terracotta",
    "recipes/building_blocks/blue_wool_slab",
    "recipes/building_blocks/blue_wool_stairs",
    "recipes/building_blocks/bone_block",
    "recipes/building_blocks/bookshelf",
    "recipes/building_blocks/brick_slab",
    "recipes/building_blocks/brick_slab_from_bricks_stonecutting",
    "recipes/building_blocks/brick_stairs",
    "recipes/building_blocks/brick_stairs_from_bricks_stonecutting",
    "recipes/building_blocks/bricks",
    "recipes/building_blocks/brown_concrete_powder",
    "recipes/building_blocks/brown_concrete_slab",
    "recipes/building_blocks/brown_concrete_stairs",
    "recipes/building_blocks/brown_stained_glass",
    "recipes/building_blocks/brown_terracotta",
    "recipes/building_blocks/brown_wool_slab",
    "recipes/building_blocks/brown_wool_stairs",
    "recipes/building_blocks/cherry_planks",
    "recipes/building_blocks/cherry_slab",
    "recipes/building_blocks/cherry_stairs",
    "recipes/building_blocks/cherry_wood",
    "recipes/building_blocks/chiseled_bookshelf",
    "recipes/building_blocks/chiseled_cinnabar",
    "recipes/building_blocks/chiseled_cinnabar_from_cinnabar_stonecutting",
    "recipes/building_blocks/chiseled_copper",
    "recipes/building_blocks/chiseled_copper_from_copper_block_stonecutting",
    "recipes/building_blocks/chiseled_copper_from_cut_copper_stonecutting",
    "recipes/building_blocks/chiseled_deepslate",
    "recipes/building_blocks/chiseled_deepslate_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/chiseled_deepslate_from_deepslate_stonecutting",
    "recipes/building_blocks/chiseled_nether_bricks",
    "recipes/building_blocks/chiseled_nether_bricks_from_nether_bricks_stonecutting",
    "recipes/building_blocks/chiseled_polished_blackstone",
    "recipes/building_blocks/chiseled_polished_blackstone_from_blackstone_stonecutting",
    "recipes/building_blocks/chiseled_polished_blackstone_from_polished_blackstone_stonecutting",
    "recipes/building_blocks/chiseled_quartz_block",
    "recipes/building_blocks/chiseled_quartz_block_from_quartz_block_stonecutting",
    "recipes/building_blocks/chiseled_red_sandstone",
    "recipes/building_blocks/chiseled_red_sandstone_from_red_sandstone_stonecutting",
    "recipes/building_blocks/chiseled_resin_bricks",
    "recipes/building_blocks/chiseled_resin_bricks_from_resin_bricks_stonecutting",
    "recipes/building_blocks/chiseled_sandstone",
    "recipes/building_blocks/chiseled_sandstone_from_sandstone_stonecutting",
    "recipes/building_blocks/chiseled_stone_bricks",
    "recipes/building_blocks/chiseled_stone_bricks_from_stone_bricks_stonecutting",
    "recipes/building_blocks/chiseled_stone_bricks_from_stone_stonecutting",
    "recipes/building_blocks/chiseled_sulfur",
    "recipes/building_blocks/chiseled_sulfur_from_sulfur_stonecutting",
    "recipes/building_blocks/chiseled_tuff",
    "recipes/building_blocks/chiseled_tuff_bricks",
    "recipes/building_blocks/chiseled_tuff_bricks_from_polished_tuff_stonecutting",
    "recipes/building_blocks/chiseled_tuff_bricks_from_tuff_bricks_stonecutting",
    "recipes/building_blocks/chiseled_tuff_bricks_from_tuff_stonecutting",
    "recipes/building_blocks/chiseled_tuff_from_tuff_stonecutting",
    "recipes/building_blocks/cinnabar_brick_slab",
    "recipes/building_blocks/cinnabar_brick_slab_from_cinnabar_bricks_stonecutting",
    "recipes/building_blocks/cinnabar_brick_slab_from_cinnabar_stonecutting",
    "recipes/building_blocks/cinnabar_brick_slab_from_polished_cinnabar_stonecutting",
    "recipes/building_blocks/cinnabar_brick_stairs",
    "recipes/building_blocks/cinnabar_brick_stairs_from_cinnabar_bricks_stonecutting",
    "recipes/building_blocks/cinnabar_brick_stairs_from_cinnabar_stonecutting",
    "recipes/building_blocks/cinnabar_brick_stairs_from_polished_cinnabar_stonecutting",
    "recipes/building_blocks/cinnabar_bricks",
    "recipes/building_blocks/cinnabar_bricks_from_cinnabar_stonecutting",
    "recipes/building_blocks/cinnabar_bricks_from_polished_cinnabar_stonecutting",
    "recipes/building_blocks/cinnabar_slab",
    "recipes/building_blocks/cinnabar_slab_from_cinnabar_stonecutting",
    "recipes/building_blocks/cinnabar_stairs",
    "recipes/building_blocks/cinnabar_stairs_from_cinnabar_stonecutting",
    "recipes/building_blocks/clay",
    "recipes/building_blocks/coal_block",
    "recipes/building_blocks/coarse_dirt",
    "recipes/building_blocks/cobbled_deepslate_from_deepslate_stonecutting",
    "recipes/building_blocks/cobbled_deepslate_slab",
    "recipes/building_blocks/cobbled_deepslate_slab_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/cobbled_deepslate_slab_from_deepslate_stonecutting",
    "recipes/building_blocks/cobbled_deepslate_stairs",
    "recipes/building_blocks/cobbled_deepslate_stairs_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/cobbled_deepslate_stairs_from_deepslate_stonecutting",
    "recipes/building_blocks/cobblestone_from_stone_stonecutting",
    "recipes/building_blocks/cobblestone_slab",
    "recipes/building_blocks/cobblestone_slab_from_cobblestone_stonecutting",
    "recipes/building_blocks/cobblestone_slab_from_stone_stonecutting",
    "recipes/building_blocks/cobblestone_stairs",
    "recipes/building_blocks/cobblestone_stairs_from_cobblestone_stonecutting",
    "recipes/building_blocks/cobblestone_stairs_from_stone_stonecutting",
    "recipes/building_blocks/copper_block",
    "recipes/building_blocks/copper_grate",
    "recipes/building_blocks/copper_grate_from_copper_block_stonecutting",
    "recipes/building_blocks/cracked_deepslate_bricks",
    "recipes/building_blocks/cracked_deepslate_tiles",
    "recipes/building_blocks/cracked_nether_bricks",
    "recipes/building_blocks/cracked_polished_blackstone_bricks",
    "recipes/building_blocks/cracked_stone_bricks",
    "recipes/building_blocks/crimson_hyphae",
    "recipes/building_blocks/crimson_planks",
    "recipes/building_blocks/crimson_slab",
    "recipes/building_blocks/crimson_stairs",
    "recipes/building_blocks/cut_copper",
    "recipes/building_blocks/cut_copper_from_copper_block_stonecutting",
    "recipes/building_blocks/cut_copper_slab",
    "recipes/building_blocks/cut_copper_slab_from_copper_block_stonecutting",
    "recipes/building_blocks/cut_copper_slab_from_cut_copper_stonecutting",
    "recipes/building_blocks/cut_copper_stairs",
    "recipes/building_blocks/cut_copper_stairs_from_copper_block_stonecutting",
    "recipes/building_blocks/cut_copper_stairs_from_cut_copper_stonecutting",
    "recipes/building_blocks/cut_red_sandstone",
    "recipes/building_blocks/cut_red_sandstone_from_red_sandstone_stonecutting",
    "recipes/building_blocks/cut_red_sandstone_slab",
    "recipes/building_blocks/cut_red_sandstone_slab_from_cut_red_sandstone_stonecutting",
    "recipes/building_blocks/cut_red_sandstone_slab_from_red_sandstone_stonecutting",
    "recipes/building_blocks/cut_sandstone",
    "recipes/building_blocks/cut_sandstone_from_sandstone_stonecutting",
    "recipes/building_blocks/cut_sandstone_slab",
    "recipes/building_blocks/cut_sandstone_slab_from_cut_sandstone_stonecutting",
    "recipes/building_blocks/cut_sandstone_slab_from_sandstone_stonecutting",
    "recipes/building_blocks/cyan_concrete_powder",
    "recipes/building_blocks/cyan_concrete_slab",
    "recipes/building_blocks/cyan_concrete_stairs",
    "recipes/building_blocks/cyan_stained_glass",
    "recipes/building_blocks/cyan_terracotta",
    "recipes/building_blocks/cyan_wool_slab",
    "recipes/building_blocks/cyan_wool_stairs",
    "recipes/building_blocks/dark_oak_planks",
    "recipes/building_blocks/dark_oak_slab",
    "recipes/building_blocks/dark_oak_stairs",
    "recipes/building_blocks/dark_oak_wood",
    "recipes/building_blocks/dark_prismarine",
    "recipes/building_blocks/dark_prismarine_slab",
    "recipes/building_blocks/dark_prismarine_slab_from_dark_prismarine_stonecutting",
    "recipes/building_blocks/dark_prismarine_stairs",
    "recipes/building_blocks/dark_prismarine_stairs_from_dark_prismarine_stonecutting",
    "recipes/building_blocks/deepslate",
    "recipes/building_blocks/deepslate_brick_slab",
    "recipes/building_blocks/deepslate_brick_slab_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_brick_slab_from_deepslate_bricks_stonecutting",
    "recipes/building_blocks/deepslate_brick_slab_from_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_brick_slab_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_brick_stairs",
    "recipes/building_blocks/deepslate_brick_stairs_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_brick_stairs_from_deepslate_bricks_stonecutting",
    "recipes/building_blocks/deepslate_brick_stairs_from_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_brick_stairs_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_bricks",
    "recipes/building_blocks/deepslate_bricks_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_bricks_from_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_bricks_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tile_slab",
    "recipes/building_blocks/deepslate_tile_slab_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tile_slab_from_deepslate_bricks_stonecutting",
    "recipes/building_blocks/deepslate_tile_slab_from_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tile_slab_from_deepslate_tiles_stonecutting",
    "recipes/building_blocks/deepslate_tile_slab_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tile_stairs",
    "recipes/building_blocks/deepslate_tile_stairs_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tile_stairs_from_deepslate_bricks_stonecutting",
    "recipes/building_blocks/deepslate_tile_stairs_from_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tile_stairs_from_deepslate_tiles_stonecutting",
    "recipes/building_blocks/deepslate_tile_stairs_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tiles",
    "recipes/building_blocks/deepslate_tiles_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tiles_from_deepslate_bricks_stonecutting",
    "recipes/building_blocks/deepslate_tiles_from_deepslate_stonecutting",
    "recipes/building_blocks/deepslate_tiles_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/diamond_block",
    "recipes/building_blocks/diorite",
    "recipes/building_blocks/diorite_slab",
    "recipes/building_blocks/diorite_slab_from_diorite_stonecutting",
    "recipes/building_blocks/diorite_stairs",
    "recipes/building_blocks/diorite_stairs_from_diorite_stonecutting",
    "recipes/building_blocks/dried_ghast",
    "recipes/building_blocks/dried_kelp_block",
    "recipes/building_blocks/dripstone_block",
    "recipes/building_blocks/dye_black_wool",
    "recipes/building_blocks/dye_black_wool_slab",
    "recipes/building_blocks/dye_black_wool_stairs",
    "recipes/building_blocks/dye_blue_wool",
    "recipes/building_blocks/dye_blue_wool_slab",
    "recipes/building_blocks/dye_blue_wool_stairs",
    "recipes/building_blocks/dye_brown_wool",
    "recipes/building_blocks/dye_brown_wool_slab",
    "recipes/building_blocks/dye_brown_wool_stairs",
    "recipes/building_blocks/dye_cyan_wool",
    "recipes/building_blocks/dye_cyan_wool_slab",
    "recipes/building_blocks/dye_cyan_wool_stairs",
    "recipes/building_blocks/dye_gray_wool",
    "recipes/building_blocks/dye_gray_wool_slab",
    "recipes/building_blocks/dye_gray_wool_stairs",
    "recipes/building_blocks/dye_green_wool",
    "recipes/building_blocks/dye_green_wool_slab",
    "recipes/building_blocks/dye_green_wool_stairs",
    "recipes/building_blocks/dye_light_blue_wool",
    "recipes/building_blocks/dye_light_blue_wool_slab",
    "recipes/building_blocks/dye_light_blue_wool_stairs",
    "recipes/building_blocks/dye_light_gray_wool",
    "recipes/building_blocks/dye_light_gray_wool_slab",
    "recipes/building_blocks/dye_light_gray_wool_stairs",
    "recipes/building_blocks/dye_lime_wool",
    "recipes/building_blocks/dye_lime_wool_slab",
    "recipes/building_blocks/dye_lime_wool_stairs",
    "recipes/building_blocks/dye_magenta_wool",
    "recipes/building_blocks/dye_magenta_wool_slab",
    "recipes/building_blocks/dye_magenta_wool_stairs",
    "recipes/building_blocks/dye_orange_wool",
    "recipes/building_blocks/dye_orange_wool_slab",
    "recipes/building_blocks/dye_orange_wool_stairs",
    "recipes/building_blocks/dye_pink_wool",
    "recipes/building_blocks/dye_pink_wool_slab",
    "recipes/building_blocks/dye_pink_wool_stairs",
    "recipes/building_blocks/dye_purple_wool",
    "recipes/building_blocks/dye_purple_wool_slab",
    "recipes/building_blocks/dye_purple_wool_stairs",
    "recipes/building_blocks/dye_red_wool",
    "recipes/building_blocks/dye_red_wool_slab",
    "recipes/building_blocks/dye_red_wool_stairs",
    "recipes/building_blocks/dye_white_wool",
    "recipes/building_blocks/dye_white_wool_slab",
    "recipes/building_blocks/dye_white_wool_stairs",
    "recipes/building_blocks/dye_yellow_wool",
    "recipes/building_blocks/dye_yellow_wool_slab",
    "recipes/building_blocks/dye_yellow_wool_stairs",
    "recipes/building_blocks/emerald_block",
    "recipes/building_blocks/end_stone_brick_slab",
    "recipes/building_blocks/end_stone_brick_slab_from_end_stone_bricks_stonecutting",
    "recipes/building_blocks/end_stone_brick_slab_from_end_stone_stonecutting",
    "recipes/building_blocks/end_stone_brick_stairs",
    "recipes/building_blocks/end_stone_brick_stairs_from_end_stone_bricks_stonecutting",
    "recipes/building_blocks/end_stone_brick_stairs_from_end_stone_stonecutting",
    "recipes/building_blocks/end_stone_bricks",
    "recipes/building_blocks/end_stone_bricks_from_end_stone_stonecutting",
    "recipes/building_blocks/exposed_chiseled_copper",
    "recipes/building_blocks/exposed_chiseled_copper_from_exposed_copper_stonecutting",
    "recipes/building_blocks/exposed_chiseled_copper_from_exposed_cut_copper_stonecutting",
    "recipes/building_blocks/exposed_copper_grate",
    "recipes/building_blocks/exposed_copper_grate_from_exposed_copper_stonecutting",
    "recipes/building_blocks/exposed_cut_copper",
    "recipes/building_blocks/exposed_cut_copper_from_exposed_copper_stonecutting",
    "recipes/building_blocks/exposed_cut_copper_slab",
    "recipes/building_blocks/exposed_cut_copper_slab_from_exposed_copper_stonecutting",
    "recipes/building_blocks/exposed_cut_copper_slab_from_exposed_cut_copper_stonecutting",
    "recipes/building_blocks/exposed_cut_copper_stairs",
    "recipes/building_blocks/exposed_cut_copper_stairs_from_exposed_copper_stonecutting",
    "recipes/building_blocks/exposed_cut_copper_stairs_from_exposed_cut_copper_stonecutting",
    "recipes/building_blocks/glass",
    "recipes/building_blocks/glowstone",
    "recipes/building_blocks/gold_block",
    "recipes/building_blocks/granite",
    "recipes/building_blocks/granite_slab",
    "recipes/building_blocks/granite_slab_from_granite_stonecutting",
    "recipes/building_blocks/granite_stairs",
    "recipes/building_blocks/granite_stairs_from_granite_stonecutting",
    "recipes/building_blocks/gray_concrete_powder",
    "recipes/building_blocks/gray_concrete_slab",
    "recipes/building_blocks/gray_concrete_stairs",
    "recipes/building_blocks/gray_stained_glass",
    "recipes/building_blocks/gray_terracotta",
    "recipes/building_blocks/gray_wool_slab",
    "recipes/building_blocks/gray_wool_stairs",
    "recipes/building_blocks/green_concrete_powder",
    "recipes/building_blocks/green_concrete_slab",
    "recipes/building_blocks/green_concrete_stairs",
    "recipes/building_blocks/green_stained_glass",
    "recipes/building_blocks/green_terracotta",
    "recipes/building_blocks/green_wool_slab",
    "recipes/building_blocks/green_wool_stairs",
    "recipes/building_blocks/hay_block",
    "recipes/building_blocks/iron_block",
    "recipes/building_blocks/jack_o_lantern",
    "recipes/building_blocks/jungle_planks",
    "recipes/building_blocks/jungle_slab",
    "recipes/building_blocks/jungle_stairs",
    "recipes/building_blocks/jungle_wood",
    "recipes/building_blocks/lapis_block",
    "recipes/building_blocks/light_blue_concrete_powder",
    "recipes/building_blocks/light_blue_concrete_slab",
    "recipes/building_blocks/light_blue_concrete_stairs",
    "recipes/building_blocks/light_blue_stained_glass",
    "recipes/building_blocks/light_blue_terracotta",
    "recipes/building_blocks/light_blue_wool_slab",
    "recipes/building_blocks/light_blue_wool_stairs",
    "recipes/building_blocks/light_gray_concrete_powder",
    "recipes/building_blocks/light_gray_concrete_slab",
    "recipes/building_blocks/light_gray_concrete_stairs",
    "recipes/building_blocks/light_gray_stained_glass",
    "recipes/building_blocks/light_gray_terracotta",
    "recipes/building_blocks/light_gray_wool_slab",
    "recipes/building_blocks/light_gray_wool_stairs",
    "recipes/building_blocks/lime_concrete_powder",
    "recipes/building_blocks/lime_concrete_slab",
    "recipes/building_blocks/lime_concrete_stairs",
    "recipes/building_blocks/lime_stained_glass",
    "recipes/building_blocks/lime_terracotta",
    "recipes/building_blocks/lime_wool_slab",
    "recipes/building_blocks/lime_wool_stairs",
    "recipes/building_blocks/magenta_concrete_powder",
    "recipes/building_blocks/magenta_concrete_slab",
    "recipes/building_blocks/magenta_concrete_stairs",
    "recipes/building_blocks/magenta_stained_glass",
    "recipes/building_blocks/magenta_terracotta",
    "recipes/building_blocks/magenta_wool_slab",
    "recipes/building_blocks/magenta_wool_stairs",
    "recipes/building_blocks/magma_block",
    "recipes/building_blocks/mangrove_planks",
    "recipes/building_blocks/mangrove_slab",
    "recipes/building_blocks/mangrove_stairs",
    "recipes/building_blocks/mangrove_wood",
    "recipes/building_blocks/melon",
    "recipes/building_blocks/mossy_cobblestone_from_moss_block",
    "recipes/building_blocks/mossy_cobblestone_from_vine",
    "recipes/building_blocks/mossy_cobblestone_slab",
    "recipes/building_blocks/mossy_cobblestone_slab_from_mossy_cobblestone_stonecutting",
    "recipes/building_blocks/mossy_cobblestone_stairs",
    "recipes/building_blocks/mossy_cobblestone_stairs_from_mossy_cobblestone_stonecutting",
    "recipes/building_blocks/mossy_stone_brick_slab",
    "recipes/building_blocks/mossy_stone_brick_slab_from_mossy_stone_bricks_stonecutting",
    "recipes/building_blocks/mossy_stone_brick_stairs",
    "recipes/building_blocks/mossy_stone_brick_stairs_from_mossy_stone_bricks_stonecutting",
    "recipes/building_blocks/mossy_stone_bricks_from_moss_block",
    "recipes/building_blocks/mossy_stone_bricks_from_vine",
    "recipes/building_blocks/mud_brick_slab",
    "recipes/building_blocks/mud_brick_slab_from_mud_bricks_stonecutting",
    "recipes/building_blocks/mud_brick_stairs",
    "recipes/building_blocks/mud_brick_stairs_from_mud_bricks_stonecutting",
    "recipes/building_blocks/mud_bricks",
    "recipes/building_blocks/muddy_mangrove_roots",
    "recipes/building_blocks/nether_brick_slab",
    "recipes/building_blocks/nether_brick_slab_from_nether_bricks_stonecutting",
    "recipes/building_blocks/nether_brick_stairs",
    "recipes/building_blocks/nether_brick_stairs_from_nether_bricks_stonecutting",
    "recipes/building_blocks/nether_bricks",
    "recipes/building_blocks/nether_wart_block",
    "recipes/building_blocks/netherite_block",
    "recipes/building_blocks/oak_planks",
    "recipes/building_blocks/oak_slab",
    "recipes/building_blocks/oak_stairs",
    "recipes/building_blocks/oak_wood",
    "recipes/building_blocks/orange_concrete_powder",
    "recipes/building_blocks/orange_concrete_slab",
    "recipes/building_blocks/orange_concrete_stairs",
    "recipes/building_blocks/orange_stained_glass",
    "recipes/building_blocks/orange_terracotta",
    "recipes/building_blocks/orange_wool_slab",
    "recipes/building_blocks/orange_wool_stairs",
    "recipes/building_blocks/oxidized_chiseled_copper",
    "recipes/building_blocks/oxidized_chiseled_copper_from_oxidized_copper_stonecutting",
    "recipes/building_blocks/oxidized_chiseled_copper_from_oxidized_cut_copper_stonecutting",
    "recipes/building_blocks/oxidized_copper_grate",
    "recipes/building_blocks/oxidized_copper_grate_from_oxidized_copper_stonecutting",
    "recipes/building_blocks/oxidized_cut_copper",
    "recipes/building_blocks/oxidized_cut_copper_from_oxidized_copper_stonecutting",
    "recipes/building_blocks/oxidized_cut_copper_slab",
    "recipes/building_blocks/oxidized_cut_copper_slab_from_oxidized_copper_stonecutting",
    "recipes/building_blocks/oxidized_cut_copper_slab_from_oxidized_cut_copper_stonecutting",
    "recipes/building_blocks/oxidized_cut_copper_stairs",
    "recipes/building_blocks/oxidized_cut_copper_stairs_from_oxidized_copper_stonecutting",
    "recipes/building_blocks/oxidized_cut_copper_stairs_from_oxidized_cut_copper_stonecutting",
    "recipes/building_blocks/packed_ice",
    "recipes/building_blocks/packed_mud",
    "recipes/building_blocks/pale_oak_planks",
    "recipes/building_blocks/pale_oak_slab",
    "recipes/building_blocks/pale_oak_stairs",
    "recipes/building_blocks/pale_oak_wood",
    "recipes/building_blocks/pink_concrete_powder",
    "recipes/building_blocks/pink_concrete_slab",
    "recipes/building_blocks/pink_concrete_stairs",
    "recipes/building_blocks/pink_stained_glass",
    "recipes/building_blocks/pink_terracotta",
    "recipes/building_blocks/pink_wool_slab",
    "recipes/building_blocks/pink_wool_stairs",
    "recipes/building_blocks/polished_andesite",
    "recipes/building_blocks/polished_andesite_from_andesite_stonecutting",
    "recipes/building_blocks/polished_andesite_slab",
    "recipes/building_blocks/polished_andesite_slab_from_andesite_stonecutting",
    "recipes/building_blocks/polished_andesite_slab_from_polished_andesite_stonecutting",
    "recipes/building_blocks/polished_andesite_stairs",
    "recipes/building_blocks/polished_andesite_stairs_from_andesite_stonecutting",
    "recipes/building_blocks/polished_andesite_stairs_from_polished_andesite_stonecutting",
    "recipes/building_blocks/polished_basalt",
    "recipes/building_blocks/polished_basalt_from_basalt_stonecutting",
    "recipes/building_blocks/polished_blackstone",
    "recipes/building_blocks/polished_blackstone_brick_slab",
    "recipes/building_blocks/polished_blackstone_brick_slab_from_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_brick_slab_from_polished_blackstone_bricks_stonecutting",
    "recipes/building_blocks/polished_blackstone_brick_slab_from_polished_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_brick_stairs",
    "recipes/building_blocks/polished_blackstone_brick_stairs_from_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_brick_stairs_from_polished_blackstone_bricks_stonecutting",
    "recipes/building_blocks/polished_blackstone_brick_stairs_from_polished_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_bricks",
    "recipes/building_blocks/polished_blackstone_bricks_from_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_bricks_from_polished_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_from_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_slab",
    "recipes/building_blocks/polished_blackstone_slab_from_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_slab_from_polished_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_stairs",
    "recipes/building_blocks/polished_blackstone_stairs_from_blackstone_stonecutting",
    "recipes/building_blocks/polished_blackstone_stairs_from_polished_blackstone_stonecutting",
    "recipes/building_blocks/polished_cinnabar",
    "recipes/building_blocks/polished_cinnabar_from_cinnabar_stonecutting",
    "recipes/building_blocks/polished_cinnabar_slab",
    "recipes/building_blocks/polished_cinnabar_slab_from_cinnabar_stonecutting",
    "recipes/building_blocks/polished_cinnabar_slab_from_polished_cinnabar_stonecutting",
    "recipes/building_blocks/polished_cinnabar_stairs",
    "recipes/building_blocks/polished_cinnabar_stairs_from_cinnabar_stonecutting",
    "recipes/building_blocks/polished_cinnabar_stairs_from_polished_cinnabar_stonecutting",
    "recipes/building_blocks/polished_deepslate",
    "recipes/building_blocks/polished_deepslate_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/polished_deepslate_from_deepslate_stonecutting",
    "recipes/building_blocks/polished_deepslate_slab",
    "recipes/building_blocks/polished_deepslate_slab_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/polished_deepslate_slab_from_deepslate_stonecutting",
    "recipes/building_blocks/polished_deepslate_slab_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/polished_deepslate_stairs",
    "recipes/building_blocks/polished_deepslate_stairs_from_cobbled_deepslate_stonecutting",
    "recipes/building_blocks/polished_deepslate_stairs_from_deepslate_stonecutting",
    "recipes/building_blocks/polished_deepslate_stairs_from_polished_deepslate_stonecutting",
    "recipes/building_blocks/polished_diorite",
    "recipes/building_blocks/polished_diorite_from_diorite_stonecutting",
    "recipes/building_blocks/polished_diorite_slab",
    "recipes/building_blocks/polished_diorite_slab_from_diorite_stonecutting",
    "recipes/building_blocks/polished_diorite_slab_from_polished_diorite_stonecutting",
    "recipes/building_blocks/polished_diorite_stairs",
    "recipes/building_blocks/polished_diorite_stairs_from_diorite_stonecutting",
    "recipes/building_blocks/polished_diorite_stairs_from_polished_diorite_stonecutting",
    "recipes/building_blocks/polished_granite",
    "recipes/building_blocks/polished_granite_from_granite_stonecutting",
    "recipes/building_blocks/polished_granite_slab",
    "recipes/building_blocks/polished_granite_slab_from_granite_stonecutting",
    "recipes/building_blocks/polished_granite_slab_from_polished_granite_stonecutting",
    "recipes/building_blocks/polished_granite_stairs",
    "recipes/building_blocks/polished_granite_stairs_from_granite_stonecutting",
    "recipes/building_blocks/polished_granite_stairs_from_polished_granite_stonecutting",
    "recipes/building_blocks/polished_sulfur",
    "recipes/building_blocks/polished_sulfur_from_sulfur_stonecutting",
    "recipes/building_blocks/polished_sulfur_slab",
    "recipes/building_blocks/polished_sulfur_slab_from_polished_sulfur_stonecutting",
    "recipes/building_blocks/polished_sulfur_slab_from_sulfur_stonecutting",
    "recipes/building_blocks/polished_sulfur_stairs",
    "recipes/building_blocks/polished_sulfur_stairs_from_polished_sulfur_stonecutting",
    "recipes/building_blocks/polished_sulfur_stairs_from_sulfur_stonecutting",
    "recipes/building_blocks/polished_tuff",
    "recipes/building_blocks/polished_tuff_from_tuff_stonecutting",
    "recipes/building_blocks/polished_tuff_slab",
    "recipes/building_blocks/polished_tuff_slab_from_polished_tuff_stonecutting",
    "recipes/building_blocks/polished_tuff_slab_from_tuff_stonecutting",
    "recipes/building_blocks/polished_tuff_stairs",
    "recipes/building_blocks/polished_tuff_stairs_from_polished_tuff_stonecutting",
    "recipes/building_blocks/polished_tuff_stairs_from_tuff_stonecutting",
    "recipes/building_blocks/poplar_planks",
    "recipes/building_blocks/poplar_slab",
    "recipes/building_blocks/poplar_stairs",
    "recipes/building_blocks/poplar_wood",
    "recipes/building_blocks/potent_sulfur",
    "recipes/building_blocks/prismarine",
    "recipes/building_blocks/prismarine_brick_slab",
    "recipes/building_blocks/prismarine_brick_slab_from_prismarine_bricks_stonecutting",
    "recipes/building_blocks/prismarine_brick_stairs",
    "recipes/building_blocks/prismarine_brick_stairs_from_prismarine_bricks_stonecutting",
    "recipes/building_blocks/prismarine_bricks",
    "recipes/building_blocks/prismarine_slab",
    "recipes/building_blocks/prismarine_slab_from_prismarine_stonecutting",
    "recipes/building_blocks/prismarine_stairs",
    "recipes/building_blocks/prismarine_stairs_from_prismarine_stonecutting",
    "recipes/building_blocks/purple_concrete_powder",
    "recipes/building_blocks/purple_concrete_slab",
    "recipes/building_blocks/purple_concrete_stairs",
    "recipes/building_blocks/purple_stained_glass",
    "recipes/building_blocks/purple_terracotta",
    "recipes/building_blocks/purple_wool_slab",
    "recipes/building_blocks/purple_wool_stairs",
    "recipes/building_blocks/purpur_block",
    "recipes/building_blocks/purpur_pillar",
    "recipes/building_blocks/purpur_pillar_from_purpur_block_stonecutting",
    "recipes/building_blocks/purpur_slab",
    "recipes/building_blocks/purpur_slab_from_purpur_block_stonecutting",
    "recipes/building_blocks/purpur_stairs",
    "recipes/building_blocks/purpur_stairs_from_purpur_block_stonecutting",
    "recipes/building_blocks/quartz_block",
    "recipes/building_blocks/quartz_bricks",
    "recipes/building_blocks/quartz_bricks_from_quartz_block_stonecutting",
    "recipes/building_blocks/quartz_pillar",
    "recipes/building_blocks/quartz_pillar_from_quartz_block_stonecutting",
    "recipes/building_blocks/quartz_slab",
    "recipes/building_blocks/quartz_slab_from_quartz_block_stonecutting",
    "recipes/building_blocks/quartz_stairs",
    "recipes/building_blocks/quartz_stairs_from_quartz_block_stonecutting",
    "recipes/building_blocks/raw_copper_block",
    "recipes/building_blocks/raw_gold_block",
    "recipes/building_blocks/raw_iron_block",
    "recipes/building_blocks/red_concrete_powder",
    "recipes/building_blocks/red_concrete_slab",
    "recipes/building_blocks/red_concrete_stairs",
    "recipes/building_blocks/red_nether_brick_slab",
    "recipes/building_blocks/red_nether_brick_slab_from_red_nether_bricks_stonecutting",
    "recipes/building_blocks/red_nether_brick_stairs",
    "recipes/building_blocks/red_nether_brick_stairs_from_red_nether_bricks_stonecutting",
    "recipes/building_blocks/red_nether_bricks",
    "recipes/building_blocks/red_sandstone",
    "recipes/building_blocks/red_sandstone_slab",
    "recipes/building_blocks/red_sandstone_slab_from_red_sandstone_stonecutting",
    "recipes/building_blocks/red_sandstone_stairs",
    "recipes/building_blocks/red_sandstone_stairs_from_red_sandstone_stonecutting",
    "recipes/building_blocks/red_stained_glass",
    "recipes/building_blocks/red_terracotta",
    "recipes/building_blocks/red_wool_slab",
    "recipes/building_blocks/red_wool_stairs",
    "recipes/building_blocks/resin_block",
    "recipes/building_blocks/resin_brick_slab",
    "recipes/building_blocks/resin_brick_slab_from_resin_bricks_stonecutting",
    "recipes/building_blocks/resin_brick_stairs",
    "recipes/building_blocks/resin_brick_stairs_from_resin_bricks_stonecutting",
    "recipes/building_blocks/resin_bricks",
    "recipes/building_blocks/sandstone",
    "recipes/building_blocks/sandstone_slab",
    "recipes/building_blocks/sandstone_slab_from_sandstone_stonecutting",
    "recipes/building_blocks/sandstone_stairs",
    "recipes/building_blocks/sandstone_stairs_from_sandstone_stonecutting",
    "recipes/building_blocks/sea_lantern",
    "recipes/building_blocks/smooth_basalt",
    "recipes/building_blocks/smooth_quartz",
    "recipes/building_blocks/smooth_quartz_slab",
    "recipes/building_blocks/smooth_quartz_slab_from_smooth_quartz_stonecutting",
    "recipes/building_blocks/smooth_quartz_stairs",
    "recipes/building_blocks/smooth_quartz_stairs_from_smooth_quartz_stonecutting",
    "recipes/building_blocks/smooth_red_sandstone",
    "recipes/building_blocks/smooth_red_sandstone_slab",
    "recipes/building_blocks/smooth_red_sandstone_slab_from_smooth_red_sandstone_stonecutting",
    "recipes/building_blocks/smooth_red_sandstone_stairs",
    "recipes/building_blocks/smooth_red_sandstone_stairs_from_smooth_red_sandstone_stonecutting",
    "recipes/building_blocks/smooth_sandstone",
    "recipes/building_blocks/smooth_sandstone_slab",
    "recipes/building_blocks/smooth_sandstone_slab_from_smooth_sandstone_stonecutting",
    "recipes/building_blocks/smooth_sandstone_stairs",
    "recipes/building_blocks/smooth_sandstone_stairs_from_smooth_sandstone_stonecutting",
    "recipes/building_blocks/smooth_stone",
    "recipes/building_blocks/smooth_stone_slab",
    "recipes/building_blocks/smooth_stone_slab_from_smooth_stone_stonecutting",
    "recipes/building_blocks/snow_block",
    "recipes/building_blocks/sponge",
    "recipes/building_blocks/spruce_planks",
    "recipes/building_blocks/spruce_slab",
    "recipes/building_blocks/spruce_stairs",
    "recipes/building_blocks/spruce_wood",
    "recipes/building_blocks/stone",
    "recipes/building_blocks/stone_brick_slab",
    "recipes/building_blocks/stone_brick_slab_from_stone_bricks_stonecutting",
    "recipes/building_blocks/stone_brick_slab_from_stone_stonecutting",
    "recipes/building_blocks/stone_brick_stairs",
    "recipes/building_blocks/stone_brick_stairs_from_stone_bricks_stonecutting",
    "recipes/building_blocks/stone_brick_stairs_from_stone_stonecutting",
    "recipes/building_blocks/stone_bricks",
    "recipes/building_blocks/stone_bricks_from_stone_stonecutting",
    "recipes/building_blocks/stone_slab",
    "recipes/building_blocks/stone_slab_from_stone_stonecutting",
    "recipes/building_blocks/stone_stairs",
    "recipes/building_blocks/stone_stairs_from_stone_stonecutting",
    "recipes/building_blocks/stripped_acacia_wood",
    "recipes/building_blocks/stripped_birch_wood",
    "recipes/building_blocks/stripped_cherry_wood",
    "recipes/building_blocks/stripped_crimson_hyphae",
    "recipes/building_blocks/stripped_dark_oak_wood",
    "recipes/building_blocks/stripped_jungle_wood",
    "recipes/building_blocks/stripped_mangrove_wood",
    "recipes/building_blocks/stripped_oak_wood",
    "recipes/building_blocks/stripped_pale_oak_wood",
    "recipes/building_blocks/stripped_poplar_wood",
    "recipes/building_blocks/stripped_spruce_wood",
    "recipes/building_blocks/stripped_warped_hyphae",
    "recipes/building_blocks/sulfur_brick_slab",
    "recipes/building_blocks/sulfur_brick_slab_from_polished_sulfur_stonecutting",
    "recipes/building_blocks/sulfur_brick_slab_from_sulfur_bricks_stonecutting",
    "recipes/building_blocks/sulfur_brick_slab_from_sulfur_stonecutting",
    "recipes/building_blocks/sulfur_brick_stairs",
    "recipes/building_blocks/sulfur_brick_stairs_from_polished_sulfur_stonecutting",
    "recipes/building_blocks/sulfur_brick_stairs_from_sulfur_bricks_stonecutting",
    "recipes/building_blocks/sulfur_brick_stairs_from_sulfur_stonecutting",
    "recipes/building_blocks/sulfur_bricks",
    "recipes/building_blocks/sulfur_bricks_from_polished_sulfur_stonecutting",
    "recipes/building_blocks/sulfur_bricks_from_sulfur_stonecutting",
    "recipes/building_blocks/sulfur_from_sulfur_spikes",
    "recipes/building_blocks/sulfur_slab",
    "recipes/building_blocks/sulfur_slab_from_sulfur_stonecutting",
    "recipes/building_blocks/sulfur_stairs",
    "recipes/building_blocks/sulfur_stairs_from_sulfur_stonecutting",
    "recipes/building_blocks/terracotta",
    "recipes/building_blocks/tinted_glass",
    "recipes/building_blocks/tuff_brick_slab",
    "recipes/building_blocks/tuff_brick_slab_from_polished_tuff_stonecutting",
    "recipes/building_blocks/tuff_brick_slab_from_tuff_bricks_stonecutting",
    "recipes/building_blocks/tuff_brick_slab_from_tuff_stonecutting",
    "recipes/building_blocks/tuff_brick_stairs",
    "recipes/building_blocks/tuff_brick_stairs_from_polished_tuff_stonecutting",
    "recipes/building_blocks/tuff_brick_stairs_from_tuff_bricks_stonecutting",
    "recipes/building_blocks/tuff_brick_stairs_from_tuff_stonecutting",
    "recipes/building_blocks/tuff_bricks",
    "recipes/building_blocks/tuff_bricks_from_polished_tuff_stonecutting",
    "recipes/building_blocks/tuff_bricks_from_tuff_stonecutting",
    "recipes/building_blocks/tuff_slab",
    "recipes/building_blocks/tuff_slab_from_tuff_stonecutting",
    "recipes/building_blocks/tuff_stairs",
    "recipes/building_blocks/tuff_stairs_from_tuff_stonecutting",
    "recipes/building_blocks/warped_hyphae",
    "recipes/building_blocks/warped_planks",
    "recipes/building_blocks/warped_slab",
    "recipes/building_blocks/warped_stairs",
    "recipes/building_blocks/waxed_chiseled_copper",
    "recipes/building_blocks/waxed_chiseled_copper_from_honeycomb",
    "recipes/building_blocks/waxed_chiseled_copper_from_waxed_copper_block_stonecutting",
    "recipes/building_blocks/waxed_chiseled_copper_from_waxed_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_copper_bars_from_honeycomb",
    "recipes/building_blocks/waxed_copper_block_from_honeycomb",
    "recipes/building_blocks/waxed_copper_chain_from_honeycomb",
    "recipes/building_blocks/waxed_copper_chest_from_honeycomb",
    "recipes/building_blocks/waxed_copper_golem_statue_from_honeycomb",
    "recipes/building_blocks/waxed_copper_grate",
    "recipes/building_blocks/waxed_copper_grate_from_honeycomb",
    "recipes/building_blocks/waxed_copper_grate_from_waxed_copper_block_stonecutting",
    "recipes/building_blocks/waxed_copper_lantern_from_honeycomb",
    "recipes/building_blocks/waxed_cut_copper",
    "recipes/building_blocks/waxed_cut_copper_from_honeycomb",
    "recipes/building_blocks/waxed_cut_copper_from_waxed_copper_block_stonecutting",
    "recipes/building_blocks/waxed_cut_copper_slab",
    "recipes/building_blocks/waxed_cut_copper_slab_from_honeycomb",
    "recipes/building_blocks/waxed_cut_copper_slab_from_waxed_copper_block_stonecutting",
    "recipes/building_blocks/waxed_cut_copper_slab_from_waxed_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_cut_copper_stairs",
    "recipes/building_blocks/waxed_cut_copper_stairs_from_honeycomb",
    "recipes/building_blocks/waxed_cut_copper_stairs_from_waxed_copper_block_stonecutting",
    "recipes/building_blocks/waxed_cut_copper_stairs_from_waxed_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_chiseled_copper",
    "recipes/building_blocks/waxed_exposed_chiseled_copper_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_chiseled_copper_from_waxed_exposed_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_chiseled_copper_from_waxed_exposed_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_copper_bars_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_copper_chain_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_copper_chest_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_copper_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_copper_golem_statue_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_copper_grate",
    "recipes/building_blocks/waxed_exposed_copper_grate_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_copper_grate_from_waxed_exposed_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_copper_lantern_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_cut_copper",
    "recipes/building_blocks/waxed_exposed_cut_copper_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_cut_copper_from_waxed_exposed_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_cut_copper_slab",
    "recipes/building_blocks/waxed_exposed_cut_copper_slab_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_cut_copper_slab_from_waxed_exposed_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_cut_copper_slab_from_waxed_exposed_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_cut_copper_stairs",
    "recipes/building_blocks/waxed_exposed_cut_copper_stairs_from_honeycomb",
    "recipes/building_blocks/waxed_exposed_cut_copper_stairs_from_waxed_exposed_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_cut_copper_stairs_from_waxed_exposed_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_exposed_lightning_rod_from_honeycomb",
    "recipes/building_blocks/waxed_lightning_rod_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_chiseled_copper",
    "recipes/building_blocks/waxed_oxidized_chiseled_copper_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_chiseled_copper_from_waxed_oxidized_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_chiseled_copper_from_waxed_oxidized_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_copper_bars_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_copper_chain_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_copper_chest_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_copper_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_copper_golem_statue_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_copper_grate",
    "recipes/building_blocks/waxed_oxidized_copper_grate_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_copper_grate_from_waxed_oxidized_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_copper_lantern_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_cut_copper",
    "recipes/building_blocks/waxed_oxidized_cut_copper_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_cut_copper_from_waxed_oxidized_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_cut_copper_slab",
    "recipes/building_blocks/waxed_oxidized_cut_copper_slab_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_cut_copper_slab_from_waxed_oxidized_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_cut_copper_slab_from_waxed_oxidized_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_cut_copper_stairs",
    "recipes/building_blocks/waxed_oxidized_cut_copper_stairs_from_honeycomb",
    "recipes/building_blocks/waxed_oxidized_cut_copper_stairs_from_waxed_oxidized_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_cut_copper_stairs_from_waxed_oxidized_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_oxidized_lightning_rod_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_chiseled_copper",
    "recipes/building_blocks/waxed_weathered_chiseled_copper_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_chiseled_copper_from_waxed_weathered_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_chiseled_copper_from_waxed_weathered_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_copper_bars_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_copper_chain_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_copper_chest_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_copper_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_copper_golem_statue_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_copper_grate",
    "recipes/building_blocks/waxed_weathered_copper_grate_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_copper_grate_from_waxed_weathered_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_copper_lantern_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_cut_copper",
    "recipes/building_blocks/waxed_weathered_cut_copper_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_cut_copper_from_waxed_weathered_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_cut_copper_slab",
    "recipes/building_blocks/waxed_weathered_cut_copper_slab_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_cut_copper_slab_from_waxed_weathered_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_cut_copper_slab_from_waxed_weathered_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_cut_copper_stairs",
    "recipes/building_blocks/waxed_weathered_cut_copper_stairs_from_honeycomb",
    "recipes/building_blocks/waxed_weathered_cut_copper_stairs_from_waxed_weathered_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_cut_copper_stairs_from_waxed_weathered_cut_copper_stonecutting",
    "recipes/building_blocks/waxed_weathered_lightning_rod_from_honeycomb",
    "recipes/building_blocks/weathered_chiseled_copper",
    "recipes/building_blocks/weathered_chiseled_copper_from_weathered_copper_stonecutting",
    "recipes/building_blocks/weathered_chiseled_copper_from_weathered_cut_copper_stonecutting",
    "recipes/building_blocks/weathered_copper_grate",
    "recipes/building_blocks/weathered_copper_grate_from_weathered_copper_stonecutting",
    "recipes/building_blocks/weathered_cut_copper",
    "recipes/building_blocks/weathered_cut_copper_from_weathered_copper_stonecutting",
    "recipes/building_blocks/weathered_cut_copper_slab",
    "recipes/building_blocks/weathered_cut_copper_slab_from_weathered_copper_stonecutting",
    "recipes/building_blocks/weathered_cut_copper_slab_from_weathered_cut_copper_stonecutting",
    "recipes/building_blocks/weathered_cut_copper_stairs",
    "recipes/building_blocks/weathered_cut_copper_stairs_from_weathered_copper_stonecutting",
    "recipes/building_blocks/weathered_cut_copper_stairs_from_weathered_cut_copper_stonecutting",
    "recipes/building_blocks/white_concrete_powder",
    "recipes/building_blocks/white_concrete_slab",
    "recipes/building_blocks/white_concrete_stairs",
    "recipes/building_blocks/white_stained_glass",
    "recipes/building_blocks/white_terracotta",
    "recipes/building_blocks/white_wool_from_string",
    "recipes/building_blocks/white_wool_slab",
    "recipes/building_blocks/white_wool_stairs",
    "recipes/building_blocks/yellow_concrete_powder",
    "recipes/building_blocks/yellow_concrete_slab",
    "recipes/building_blocks/yellow_concrete_stairs",
    "recipes/building_blocks/yellow_stained_glass",
    "recipes/building_blocks/yellow_terracotta",
    "recipes/building_blocks/yellow_wool_slab",
    "recipes/building_blocks/yellow_wool_stairs",
    "recipes/combat/arrow",
    "recipes/combat/black_harness",
    "recipes/combat/blue_harness",
    "recipes/combat/bow",
    "recipes/combat/brown_harness",
    "recipes/combat/copper_boots",
    "recipes/combat/copper_chestplate",
    "recipes/combat/copper_helmet",
    "recipes/combat/copper_leggings",
    "recipes/combat/copper_spear",
    "recipes/combat/copper_sword",
    "recipes/combat/crossbow",
    "recipes/combat/cyan_harness",
    "recipes/combat/diamond_boots",
    "recipes/combat/diamond_chestplate",
    "recipes/combat/diamond_helmet",
    "recipes/combat/diamond_leggings",
    "recipes/combat/diamond_spear",
    "recipes/combat/diamond_sword",
    "recipes/combat/dye_black_harness",
    "recipes/combat/dye_blue_harness",
    "recipes/combat/dye_brown_harness",
    "recipes/combat/dye_cyan_harness",
    "recipes/combat/dye_gray_harness",
    "recipes/combat/dye_green_harness",
    "recipes/combat/dye_light_blue_harness",
    "recipes/combat/dye_light_gray_harness",
    "recipes/combat/dye_lime_harness",
    "recipes/combat/dye_magenta_harness",
    "recipes/combat/dye_orange_harness",
    "recipes/combat/dye_pink_harness",
    "recipes/combat/dye_purple_harness",
    "recipes/combat/dye_red_harness",
    "recipes/combat/dye_white_harness",
    "recipes/combat/dye_yellow_harness",
    "recipes/combat/golden_boots",
    "recipes/combat/golden_chestplate",
    "recipes/combat/golden_helmet",
    "recipes/combat/golden_leggings",
    "recipes/combat/golden_spear",
    "recipes/combat/golden_sword",
    "recipes/combat/gray_harness",
    "recipes/combat/green_harness",
    "recipes/combat/iron_boots",
    "recipes/combat/iron_chestplate",
    "recipes/combat/iron_helmet",
    "recipes/combat/iron_leggings",
    "recipes/combat/iron_spear",
    "recipes/combat/iron_sword",
    "recipes/combat/leather_boots",
    "recipes/combat/leather_chestplate",
    "recipes/combat/leather_helmet",
    "recipes/combat/leather_leggings",
    "recipes/combat/light_blue_harness",
    "recipes/combat/light_gray_harness",
    "recipes/combat/lime_harness",
    "recipes/combat/mace",
    "recipes/combat/magenta_harness",
    "recipes/combat/netherite_boots_smithing",
    "recipes/combat/netherite_chestplate_smithing",
    "recipes/combat/netherite_helmet_smithing",
    "recipes/combat/netherite_horse_armor_smithing",
    "recipes/combat/netherite_leggings_smithing",
    "recipes/combat/netherite_nautilus_armor_smithing",
    "recipes/combat/netherite_spear_smithing",
    "recipes/combat/netherite_sword_smithing",
    "recipes/combat/orange_harness",
    "recipes/combat/pink_harness",
    "recipes/combat/purple_harness",
    "recipes/combat/red_harness",
    "recipes/combat/saddle",
    "recipes/combat/shield",
    "recipes/combat/spectral_arrow",
    "recipes/combat/stone_spear",
    "recipes/combat/stone_sword",
    "recipes/combat/turtle_helmet",
    "recipes/combat/white_harness",
    "recipes/combat/wolf_armor",
    "recipes/combat/wooden_spear",
    "recipes/combat/wooden_sword",
    "recipes/combat/yellow_harness",
    "recipes/decorations/acacia_fence",
    "recipes/decorations/acacia_hanging_sign",
    "recipes/decorations/acacia_shelf",
    "recipes/decorations/acacia_sign",
    "recipes/decorations/andesite_wall",
    "recipes/decorations/andesite_wall_from_andesite_stonecutting",
    "recipes/decorations/anvil",
    "recipes/decorations/armor_stand",
    "recipes/decorations/bamboo_fence",
    "recipes/decorations/bamboo_hanging_sign",
    "recipes/decorations/bamboo_mosaic",
    "recipes/decorations/bamboo_shelf",
    "recipes/decorations/bamboo_sign",
    "recipes/decorations/barrel",
    "recipes/decorations/beehive",
    "recipes/decorations/birch_fence",
    "recipes/decorations/birch_hanging_sign",
    "recipes/decorations/birch_shelf",
    "recipes/decorations/birch_sign",
    "recipes/decorations/black_banner",
    "recipes/decorations/black_bed",
    "recipes/decorations/black_candle",
    "recipes/decorations/black_carpet",
    "recipes/decorations/black_cushion",
    "recipes/decorations/black_glazed_terracotta",
    "recipes/decorations/black_shulker_box",
    "recipes/decorations/black_stained_glass_pane",
    "recipes/decorations/black_stained_glass_pane_from_glass_pane",
    "recipes/decorations/blackstone_wall",
    "recipes/decorations/blackstone_wall_from_blackstone_stonecutting",
    "recipes/decorations/blast_furnace",
    "recipes/decorations/blue_banner",
    "recipes/decorations/blue_bed",
    "recipes/decorations/blue_candle",
    "recipes/decorations/blue_carpet",
    "recipes/decorations/blue_cushion",
    "recipes/decorations/blue_glazed_terracotta",
    "recipes/decorations/blue_shulker_box",
    "recipes/decorations/blue_stained_glass_pane",
    "recipes/decorations/blue_stained_glass_pane_from_glass_pane",
    "recipes/decorations/brick_wall",
    "recipes/decorations/brick_wall_from_bricks_stonecutting",
    "recipes/decorations/brown_banner",
    "recipes/decorations/brown_bed",
    "recipes/decorations/brown_candle",
    "recipes/decorations/brown_carpet",
    "recipes/decorations/brown_cushion",
    "recipes/decorations/brown_glazed_terracotta",
    "recipes/decorations/brown_shulker_box",
    "recipes/decorations/brown_stained_glass_pane",
    "recipes/decorations/brown_stained_glass_pane_from_glass_pane",
    "recipes/decorations/campfire",
    "recipes/decorations/candle",
    "recipes/decorations/cartography_table",
    "recipes/decorations/cherry_fence",
    "recipes/decorations/cherry_hanging_sign",
    "recipes/decorations/cherry_shelf",
    "recipes/decorations/cherry_sign",
    "recipes/decorations/chest",
    "recipes/decorations/cinnabar_brick_wall",
    "recipes/decorations/cinnabar_brick_wall_from_cinnabar_bricks_stonecutting",
    "recipes/decorations/cinnabar_brick_wall_from_cinnabar_stonecutting",
    "recipes/decorations/cinnabar_brick_wall_from_polished_cinnabar_stonecutting",
    "recipes/decorations/cinnabar_wall",
    "recipes/decorations/cinnabar_wall_from_cinnabar_stonecutting",
    "recipes/decorations/cobbled_deepslate_wall",
    "recipes/decorations/cobbled_deepslate_wall_from_cobbled_deepslate_stonecutting",
    "recipes/decorations/cobbled_deepslate_wall_from_deepslate_stonecutting",
    "recipes/decorations/cobblestone_wall",
    "recipes/decorations/cobblestone_wall_from_cobblestone_stonecutting",
    "recipes/decorations/cobblestone_wall_from_stone_stonecutting",
    "recipes/decorations/composter",
    "recipes/decorations/copper_bars",
    "recipes/decorations/copper_chain",
    "recipes/decorations/copper_chest",
    "recipes/decorations/copper_lantern",
    "recipes/decorations/copper_torch",
    "recipes/decorations/crafting_table",
    "recipes/decorations/crimson_fence",
    "recipes/decorations/crimson_hanging_sign",
    "recipes/decorations/crimson_shelf",
    "recipes/decorations/crimson_sign",
    "recipes/decorations/cyan_banner",
    "recipes/decorations/cyan_bed",
    "recipes/decorations/cyan_candle",
    "recipes/decorations/cyan_carpet",
    "recipes/decorations/cyan_cushion",
    "recipes/decorations/cyan_glazed_terracotta",
    "recipes/decorations/cyan_shulker_box",
    "recipes/decorations/cyan_stained_glass_pane",
    "recipes/decorations/cyan_stained_glass_pane_from_glass_pane",
    "recipes/decorations/dark_oak_fence",
    "recipes/decorations/dark_oak_hanging_sign",
    "recipes/decorations/dark_oak_shelf",
    "recipes/decorations/dark_oak_sign",
    "recipes/decorations/decorated_pot_simple",
    "recipes/decorations/deepslate_brick_wall",
    "recipes/decorations/deepslate_brick_wall_from_cobbled_deepslate_stonecutting",
    "recipes/decorations/deepslate_brick_wall_from_deepslate_bricks_stonecutting",
    "recipes/decorations/deepslate_brick_wall_from_deepslate_stonecutting",
    "recipes/decorations/deepslate_brick_wall_from_polished_deepslate_stonecutting",
    "recipes/decorations/deepslate_tile_wall",
    "recipes/decorations/deepslate_tile_wall_from_cobbled_deepslate_stonecutting",
    "recipes/decorations/deepslate_tile_wall_from_deepslate_bricks_stonecutting",
    "recipes/decorations/deepslate_tile_wall_from_deepslate_stonecutting",
    "recipes/decorations/deepslate_tile_wall_from_deepslate_tiles_stonecutting",
    "recipes/decorations/deepslate_tile_wall_from_polished_deepslate_stonecutting",
    "recipes/decorations/diorite_wall",
    "recipes/decorations/diorite_wall_from_diorite_stonecutting",
    "recipes/decorations/dye_black_bed",
    "recipes/decorations/dye_black_carpet",
    "recipes/decorations/dye_black_cushion",
    "recipes/decorations/dye_blue_bed",
    "recipes/decorations/dye_blue_carpet",
    "recipes/decorations/dye_blue_cushion",
    "recipes/decorations/dye_brown_bed",
    "recipes/decorations/dye_brown_carpet",
    "recipes/decorations/dye_brown_cushion",
    "recipes/decorations/dye_cyan_bed",
    "recipes/decorations/dye_cyan_carpet",
    "recipes/decorations/dye_cyan_cushion",
    "recipes/decorations/dye_gray_bed",
    "recipes/decorations/dye_gray_carpet",
    "recipes/decorations/dye_gray_cushion",
    "recipes/decorations/dye_green_bed",
    "recipes/decorations/dye_green_carpet",
    "recipes/decorations/dye_green_cushion",
    "recipes/decorations/dye_light_blue_bed",
    "recipes/decorations/dye_light_blue_carpet",
    "recipes/decorations/dye_light_blue_cushion",
    "recipes/decorations/dye_light_gray_bed",
    "recipes/decorations/dye_light_gray_carpet",
    "recipes/decorations/dye_light_gray_cushion",
    "recipes/decorations/dye_lime_bed",
    "recipes/decorations/dye_lime_carpet",
    "recipes/decorations/dye_lime_cushion",
    "recipes/decorations/dye_magenta_bed",
    "recipes/decorations/dye_magenta_carpet",
    "recipes/decorations/dye_magenta_cushion",
    "recipes/decorations/dye_orange_bed",
    "recipes/decorations/dye_orange_carpet",
    "recipes/decorations/dye_orange_cushion",
    "recipes/decorations/dye_pink_bed",
    "recipes/decorations/dye_pink_carpet",
    "recipes/decorations/dye_pink_cushion",
    "recipes/decorations/dye_purple_bed",
    "recipes/decorations/dye_purple_carpet",
    "recipes/decorations/dye_purple_cushion",
    "recipes/decorations/dye_red_bed",
    "recipes/decorations/dye_red_carpet",
    "recipes/decorations/dye_red_cushion",
    "recipes/decorations/dye_white_bed",
    "recipes/decorations/dye_white_carpet",
    "recipes/decorations/dye_white_cushion",
    "recipes/decorations/dye_yellow_bed",
    "recipes/decorations/dye_yellow_carpet",
    "recipes/decorations/dye_yellow_cushion",
    "recipes/decorations/enchanting_table",
    "recipes/decorations/end_crystal",
    "recipes/decorations/end_rod",
    "recipes/decorations/end_stone_brick_wall",
    "recipes/decorations/end_stone_brick_wall_from_end_stone_bricks_stonecutting",
    "recipes/decorations/end_stone_brick_wall_from_end_stone_stonecutting",
    "recipes/decorations/ender_chest",
    "recipes/decorations/fletching_table",
    "recipes/decorations/flower_pot",
    "recipes/decorations/furnace",
    "recipes/decorations/glass_pane",
    "recipes/decorations/glow_item_frame",
    "recipes/decorations/golden_dandelion",
    "recipes/decorations/granite_wall",
    "recipes/decorations/granite_wall_from_granite_stonecutting",
    "recipes/decorations/gray_banner",
    "recipes/decorations/gray_bed",
    "recipes/decorations/gray_candle",
    "recipes/decorations/gray_carpet",
    "recipes/decorations/gray_cushion",
    "recipes/decorations/gray_glazed_terracotta",
    "recipes/decorations/gray_shulker_box",
    "recipes/decorations/gray_stained_glass_pane",
    "recipes/decorations/gray_stained_glass_pane_from_glass_pane",
    "recipes/decorations/green_banner",
    "recipes/decorations/green_bed",
    "recipes/decorations/green_candle",
    "recipes/decorations/green_carpet",
    "recipes/decorations/green_cushion",
    "recipes/decorations/green_glazed_terracotta",
    "recipes/decorations/green_shulker_box",
    "recipes/decorations/green_stained_glass_pane",
    "recipes/decorations/green_stained_glass_pane_from_glass_pane",
    "recipes/decorations/grindstone",
    "recipes/decorations/honeycomb_block",
    "recipes/decorations/iron_bars",
    "recipes/decorations/iron_chain",
    "recipes/decorations/item_frame",
    "recipes/decorations/jukebox",
    "recipes/decorations/jungle_fence",
    "recipes/decorations/jungle_hanging_sign",
    "recipes/decorations/jungle_shelf",
    "recipes/decorations/jungle_sign",
    "recipes/decorations/ladder",
    "recipes/decorations/lantern",
    "recipes/decorations/light_blue_banner",
    "recipes/decorations/light_blue_bed",
    "recipes/decorations/light_blue_candle",
    "recipes/decorations/light_blue_carpet",
    "recipes/decorations/light_blue_cushion",
    "recipes/decorations/light_blue_glazed_terracotta",
    "recipes/decorations/light_blue_shulker_box",
    "recipes/decorations/light_blue_stained_glass_pane",
    "recipes/decorations/light_blue_stained_glass_pane_from_glass_pane",
    "recipes/decorations/light_gray_banner",
    "recipes/decorations/light_gray_bed",
    "recipes/decorations/light_gray_candle",
    "recipes/decorations/light_gray_carpet",
    "recipes/decorations/light_gray_cushion",
    "recipes/decorations/light_gray_glazed_terracotta",
    "recipes/decorations/light_gray_shulker_box",
    "recipes/decorations/light_gray_stained_glass_pane",
    "recipes/decorations/light_gray_stained_glass_pane_from_glass_pane",
    "recipes/decorations/lime_banner",
    "recipes/decorations/lime_bed",
    "recipes/decorations/lime_candle",
    "recipes/decorations/lime_carpet",
    "recipes/decorations/lime_cushion",
    "recipes/decorations/lime_glazed_terracotta",
    "recipes/decorations/lime_shulker_box",
    "recipes/decorations/lime_stained_glass_pane",
    "recipes/decorations/lime_stained_glass_pane_from_glass_pane",
    "recipes/decorations/lodestone",
    "recipes/decorations/loom",
    "recipes/decorations/magenta_banner",
    "recipes/decorations/magenta_bed",
    "recipes/decorations/magenta_candle",
    "recipes/decorations/magenta_carpet",
    "recipes/decorations/magenta_cushion",
    "recipes/decorations/magenta_glazed_terracotta",
    "recipes/decorations/magenta_shulker_box",
    "recipes/decorations/magenta_stained_glass_pane",
    "recipes/decorations/magenta_stained_glass_pane_from_glass_pane",
    "recipes/decorations/mangrove_fence",
    "recipes/decorations/mangrove_hanging_sign",
    "recipes/decorations/mangrove_shelf",
    "recipes/decorations/mangrove_sign",
    "recipes/decorations/moss_carpet",
    "recipes/decorations/mossy_cobblestone_wall",
    "recipes/decorations/mossy_cobblestone_wall_from_mossy_cobblestone_stonecutting",
    "recipes/decorations/mossy_stone_brick_wall",
    "recipes/decorations/mossy_stone_brick_wall_from_mossy_stone_bricks_stonecutting",
    "recipes/decorations/mud_brick_wall",
    "recipes/decorations/mud_brick_wall_from_mud_bricks_stonecutting",
    "recipes/decorations/nether_brick_fence",
    "recipes/decorations/nether_brick_wall",
    "recipes/decorations/nether_brick_wall_from_nether_bricks_stonecutting",
    "recipes/decorations/oak_fence",
    "recipes/decorations/oak_hanging_sign",
    "recipes/decorations/oak_shelf",
    "recipes/decorations/oak_sign",
    "recipes/decorations/orange_banner",
    "recipes/decorations/orange_bed",
    "recipes/decorations/orange_candle",
    "recipes/decorations/orange_carpet",
    "recipes/decorations/orange_cushion",
    "recipes/decorations/orange_glazed_terracotta",
    "recipes/decorations/orange_shulker_box",
    "recipes/decorations/orange_stained_glass_pane",
    "recipes/decorations/orange_stained_glass_pane_from_glass_pane",
    "recipes/decorations/painting",
    "recipes/decorations/pale_moss_carpet",
    "recipes/decorations/pale_oak_fence",
    "recipes/decorations/pale_oak_hanging_sign",
    "recipes/decorations/pale_oak_shelf",
    "recipes/decorations/pale_oak_sign",
    "recipes/decorations/pink_banner",
    "recipes/decorations/pink_bed",
    "recipes/decorations/pink_candle",
    "recipes/decorations/pink_carpet",
    "recipes/decorations/pink_cushion",
    "recipes/decorations/pink_glazed_terracotta",
    "recipes/decorations/pink_shulker_box",
    "recipes/decorations/pink_stained_glass_pane",
    "recipes/decorations/pink_stained_glass_pane_from_glass_pane",
    "recipes/decorations/polished_blackstone_brick_wall",
    "recipes/decorations/polished_blackstone_brick_wall_from_blackstone_stonecutting",
    "recipes/decorations/polished_blackstone_brick_wall_from_polished_blackstone_bricks_stonecutting",
    "recipes/decorations/polished_blackstone_brick_wall_from_polished_blackstone_stonecutting",
    "recipes/decorations/polished_blackstone_wall",
    "recipes/decorations/polished_blackstone_wall_from_blackstone_stonecutting",
    "recipes/decorations/polished_blackstone_wall_from_polished_blackstone_stonecutting",
    "recipes/decorations/polished_cinnabar_wall",
    "recipes/decorations/polished_cinnabar_wall_from_cinnabar_stonecutting",
    "recipes/decorations/polished_cinnabar_wall_from_polished_cinnabar_stonecutting",
    "recipes/decorations/polished_deepslate_wall",
    "recipes/decorations/polished_deepslate_wall_from_cobbled_deepslate_stonecutting",
    "recipes/decorations/polished_deepslate_wall_from_deepslate_stonecutting",
    "recipes/decorations/polished_deepslate_wall_from_polished_deepslate_stonecutting",
    "recipes/decorations/polished_sulfur_wall",
    "recipes/decorations/polished_sulfur_wall_from_polished_sulfur_stonecutting",
    "recipes/decorations/polished_sulfur_wall_from_sulfur_stonecutting",
    "recipes/decorations/polished_tuff_wall",
    "recipes/decorations/polished_tuff_wall_from_polished_tuff_stonecutting",
    "recipes/decorations/polished_tuff_wall_from_tuff_stonecutting",
    "recipes/decorations/poplar_fence",
    "recipes/decorations/poplar_hanging_sign",
    "recipes/decorations/poplar_shelf",
    "recipes/decorations/poplar_sign",
    "recipes/decorations/prismarine_wall",
    "recipes/decorations/prismarine_wall_from_prismarine_stonecutting",
    "recipes/decorations/purple_banner",
    "recipes/decorations/purple_bed",
    "recipes/decorations/purple_candle",
    "recipes/decorations/purple_carpet",
    "recipes/decorations/purple_cushion",
    "recipes/decorations/purple_glazed_terracotta",
    "recipes/decorations/purple_shulker_box",
    "recipes/decorations/purple_stained_glass_pane",
    "recipes/decorations/purple_stained_glass_pane_from_glass_pane",
    "recipes/decorations/red_banner",
    "recipes/decorations/red_bed",
    "recipes/decorations/red_candle",
    "recipes/decorations/red_carpet",
    "recipes/decorations/red_cushion",
    "recipes/decorations/red_glazed_terracotta",
    "recipes/decorations/red_nether_brick_wall",
    "recipes/decorations/red_nether_brick_wall_from_red_nether_bricks_stonecutting",
    "recipes/decorations/red_sandstone_wall",
    "recipes/decorations/red_sandstone_wall_from_red_sandstone_stonecutting",
    "recipes/decorations/red_shulker_box",
    "recipes/decorations/red_stained_glass_pane",
    "recipes/decorations/red_stained_glass_pane_from_glass_pane",
    "recipes/decorations/resin_brick_wall",
    "recipes/decorations/resin_brick_wall_from_resin_bricks_stonecutting",
    "recipes/decorations/respawn_anchor",
    "recipes/decorations/sandstone_wall",
    "recipes/decorations/sandstone_wall_from_sandstone_stonecutting",
    "recipes/decorations/scaffolding",
    "recipes/decorations/shulker_box",
    "recipes/decorations/smithing_table",
    "recipes/decorations/smoker",
    "recipes/decorations/snow",
    "recipes/decorations/soul_campfire",
    "recipes/decorations/soul_lantern",
    "recipes/decorations/soul_torch",
    "recipes/decorations/spruce_fence",
    "recipes/decorations/spruce_hanging_sign",
    "recipes/decorations/spruce_shelf",
    "recipes/decorations/spruce_sign",
    "recipes/decorations/stone_brick_wall",
    "recipes/decorations/stone_brick_wall_from_stone_bricks_stonecutting",
    "recipes/decorations/stone_brick_wall_from_stone_stonecutting",
    "recipes/decorations/stonecutter",
    "recipes/decorations/straw_bed",
    "recipes/decorations/sulfur_brick_wall",
    "recipes/decorations/sulfur_brick_wall_from_polished_sulfur_stonecutting",
    "recipes/decorations/sulfur_brick_wall_from_sulfur_bricks_stonecutting",
    "recipes/decorations/sulfur_brick_wall_from_sulfur_stonecutting",
    "recipes/decorations/sulfur_wall",
    "recipes/decorations/sulfur_wall_from_sulfur_stonecutting",
    "recipes/decorations/torch",
    "recipes/decorations/tuff_brick_wall",
    "recipes/decorations/tuff_brick_wall_from_polished_tuff_stonecutting",
    "recipes/decorations/tuff_brick_wall_from_tuff_bricks_stonecutting",
    "recipes/decorations/tuff_brick_wall_from_tuff_stonecutting",
    "recipes/decorations/tuff_wall",
    "recipes/decorations/tuff_wall_from_tuff_stonecutting",
    "recipes/decorations/warped_fence",
    "recipes/decorations/warped_hanging_sign",
    "recipes/decorations/warped_shelf",
    "recipes/decorations/warped_sign",
    "recipes/decorations/white_banner",
    "recipes/decorations/white_bed",
    "recipes/decorations/white_candle",
    "recipes/decorations/white_carpet",
    "recipes/decorations/white_cushion",
    "recipes/decorations/white_glazed_terracotta",
    "recipes/decorations/white_shulker_box",
    "recipes/decorations/white_stained_glass_pane",
    "recipes/decorations/white_stained_glass_pane_from_glass_pane",
    "recipes/decorations/yellow_banner",
    "recipes/decorations/yellow_bed",
    "recipes/decorations/yellow_candle",
    "recipes/decorations/yellow_carpet",
    "recipes/decorations/yellow_cushion",
    "recipes/decorations/yellow_glazed_terracotta",
    "recipes/decorations/yellow_shulker_box",
    "recipes/decorations/yellow_stained_glass_pane",
    "recipes/decorations/yellow_stained_glass_pane_from_glass_pane",
    "recipes/food/baked_potato",
    "recipes/food/baked_potato_from_campfire_cooking",
    "recipes/food/baked_potato_from_smoking",
    "recipes/food/beetroot_soup",
    "recipes/food/bread",
    "recipes/food/cake",
    "recipes/food/cooked_beef",
    "recipes/food/cooked_beef_from_campfire_cooking",
    "recipes/food/cooked_beef_from_smoking",
    "recipes/food/cooked_chicken",
    "recipes/food/cooked_chicken_from_campfire_cooking",
    "recipes/food/cooked_chicken_from_smoking",
    "recipes/food/cooked_cod",
    "recipes/food/cooked_cod_from_campfire_cooking",
    "recipes/food/cooked_cod_from_smoking",
    "recipes/food/cooked_mutton",
    "recipes/food/cooked_mutton_from_campfire_cooking",
    "recipes/food/cooked_mutton_from_smoking",
    "recipes/food/cooked_porkchop",
    "recipes/food/cooked_porkchop_from_campfire_cooking",
    "recipes/food/cooked_porkchop_from_smoking",
    "recipes/food/cooked_rabbit",
    "recipes/food/cooked_rabbit_from_campfire_cooking",
    "recipes/food/cooked_rabbit_from_smoking",
    "recipes/food/cooked_salmon",
    "recipes/food/cooked_salmon_from_campfire_cooking",
    "recipes/food/cooked_salmon_from_smoking",
    "recipes/food/cookie",
    "recipes/food/dried_kelp",
    "recipes/food/dried_kelp_from_campfire_cooking",
    "recipes/food/dried_kelp_from_smelting",
    "recipes/food/dried_kelp_from_smoking",
    "recipes/food/golden_apple",
    "recipes/food/honey_bottle",
    "recipes/food/mushroom_stew",
    "recipes/food/pumpkin_pie",
    "recipes/food/rabbit_stew_from_brown_mushroom",
    "recipes/food/rabbit_stew_from_red_mushroom",
    "recipes/food/rabbit_stew_from_shelf_mushroom",
    "recipes/food/suspicious_stew_from_allium",
    "recipes/food/suspicious_stew_from_azure_bluet",
    "recipes/food/suspicious_stew_from_blue_orchid",
    "recipes/food/suspicious_stew_from_closed_eyeblossom",
    "recipes/food/suspicious_stew_from_cornflower",
    "recipes/food/suspicious_stew_from_dandelion",
    "recipes/food/suspicious_stew_from_golden_dandelion",
    "recipes/food/suspicious_stew_from_lily_of_the_valley",
    "recipes/food/suspicious_stew_from_open_eyeblossom",
    "recipes/food/suspicious_stew_from_orange_tulip",
    "recipes/food/suspicious_stew_from_oxeye_daisy",
    "recipes/food/suspicious_stew_from_pink_tulip",
    "recipes/food/suspicious_stew_from_poppy",
    "recipes/food/suspicious_stew_from_red_tulip",
    "recipes/food/suspicious_stew_from_torchflower",
    "recipes/food/suspicious_stew_from_white_tulip",
    "recipes/food/suspicious_stew_from_wither_rose",
    "recipes/misc/beacon",
    "recipes/misc/black_dye",
    "recipes/misc/black_dye_from_wither_rose",
    "recipes/misc/blue_dye",
    "recipes/misc/blue_dye_from_cornflower",
    "recipes/misc/bolt_armor_trim_smithing_template",
    "recipes/misc/bolt_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/bone_meal",
    "recipes/misc/bone_meal_from_bone_block",
    "recipes/misc/book",
    "recipes/misc/bordure_indented_banner_pattern",
    "recipes/misc/bowl",
    "recipes/misc/brick",
    "recipes/misc/brown_dye",
    "recipes/misc/bucket",
    "recipes/misc/charcoal",
    "recipes/misc/coal",
    "recipes/misc/coal_from_blasting_coal_ore",
    "recipes/misc/coal_from_blasting_deepslate_coal_ore",
    "recipes/misc/coal_from_smelting_coal_ore",
    "recipes/misc/coal_from_smelting_deepslate_coal_ore",
    "recipes/misc/coast_armor_trim_smithing_template",
    "recipes/misc/coast_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/conduit",
    "recipes/misc/copper_ingot",
    "recipes/misc/copper_ingot_from_blasting_copper_ore",
    "recipes/misc/copper_ingot_from_blasting_deepslate_copper_ore",
    "recipes/misc/copper_ingot_from_blasting_raw_copper",
    "recipes/misc/copper_ingot_from_nuggets",
    "recipes/misc/copper_ingot_from_smelting_copper_ore",
    "recipes/misc/copper_ingot_from_smelting_deepslate_copper_ore",
    "recipes/misc/copper_ingot_from_smelting_raw_copper",
    "recipes/misc/copper_ingot_from_waxed_copper_block",
    "recipes/misc/copper_nugget",
    "recipes/misc/copper_nugget_from_blasting",
    "recipes/misc/copper_nugget_from_smelting",
    "recipes/misc/creaking_heart",
    "recipes/misc/creeper_banner_pattern",
    "recipes/misc/cyan_dye",
    "recipes/misc/cyan_dye_from_pitcher_plant",
    "recipes/misc/diamond",
    "recipes/misc/diamond_from_blasting_deepslate_diamond_ore",
    "recipes/misc/diamond_from_blasting_diamond_ore",
    "recipes/misc/diamond_from_smelting_deepslate_diamond_ore",
    "recipes/misc/diamond_from_smelting_diamond_ore",
    "recipes/misc/dune_armor_trim_smithing_template",
    "recipes/misc/dune_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/emerald",
    "recipes/misc/emerald_from_blasting_deepslate_emerald_ore",
    "recipes/misc/emerald_from_blasting_emerald_ore",
    "recipes/misc/emerald_from_smelting_deepslate_emerald_ore",
    "recipes/misc/emerald_from_smelting_emerald_ore",
    "recipes/misc/ender_eye",
    "recipes/misc/eye_armor_trim_smithing_template",
    "recipes/misc/eye_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/field_masoned_banner_pattern",
    "recipes/misc/fire_charge",
    "recipes/misc/firework_rocket_simple",
    "recipes/misc/flow_armor_trim_smithing_template",
    "recipes/misc/flow_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/flower_banner_pattern",
    "recipes/misc/gold_ingot_from_blasting_deepslate_gold_ore",
    "recipes/misc/gold_ingot_from_blasting_gold_ore",
    "recipes/misc/gold_ingot_from_blasting_nether_gold_ore",
    "recipes/misc/gold_ingot_from_blasting_raw_gold",
    "recipes/misc/gold_ingot_from_gold_block",
    "recipes/misc/gold_ingot_from_nuggets",
    "recipes/misc/gold_ingot_from_smelting_deepslate_gold_ore",
    "recipes/misc/gold_ingot_from_smelting_gold_ore",
    "recipes/misc/gold_ingot_from_smelting_nether_gold_ore",
    "recipes/misc/gold_ingot_from_smelting_raw_gold",
    "recipes/misc/gold_nugget",
    "recipes/misc/gold_nugget_from_blasting",
    "recipes/misc/gold_nugget_from_smelting",
    "recipes/misc/gray_dye",
    "recipes/misc/gray_dye_from_closed_eyeblossom",
    "recipes/misc/green_dye",
    "recipes/misc/host_armor_trim_smithing_template",
    "recipes/misc/host_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/iron_ingot_from_blasting_deepslate_iron_ore",
    "recipes/misc/iron_ingot_from_blasting_iron_ore",
    "recipes/misc/iron_ingot_from_blasting_raw_iron",
    "recipes/misc/iron_ingot_from_iron_block",
    "recipes/misc/iron_ingot_from_nuggets",
    "recipes/misc/iron_ingot_from_smelting_deepslate_iron_ore",
    "recipes/misc/iron_ingot_from_smelting_iron_ore",
    "recipes/misc/iron_ingot_from_smelting_raw_iron",
    "recipes/misc/iron_nugget",
    "recipes/misc/iron_nugget_from_blasting",
    "recipes/misc/iron_nugget_from_smelting",
    "recipes/misc/lapis_lazuli",
    "recipes/misc/lapis_lazuli_from_blasting_deepslate_lapis_ore",
    "recipes/misc/lapis_lazuli_from_blasting_lapis_ore",
    "recipes/misc/lapis_lazuli_from_smelting_deepslate_lapis_ore",
    "recipes/misc/lapis_lazuli_from_smelting_lapis_ore",
    "recipes/misc/leaf_litter",
    "recipes/misc/leather",
    "recipes/misc/leather_boots_dyed",
    "recipes/misc/leather_chestplate_dyed",
    "recipes/misc/leather_helmet_dyed",
    "recipes/misc/leather_horse_armor",
    "recipes/misc/leather_horse_armor_dyed",
    "recipes/misc/leather_leggings_dyed",
    "recipes/misc/light_blue_dye_from_blue_orchid",
    "recipes/misc/light_blue_dye_from_blue_white_dye",
    "recipes/misc/light_gray_dye_from_azure_bluet",
    "recipes/misc/light_gray_dye_from_black_white_dye",
    "recipes/misc/light_gray_dye_from_gray_white_dye",
    "recipes/misc/light_gray_dye_from_oxeye_daisy",
    "recipes/misc/light_gray_dye_from_white_tulip",
    "recipes/misc/lime_dye",
    "recipes/misc/lime_dye_from_smelting",
    "recipes/misc/magenta_dye_from_allium",
    "recipes/misc/magenta_dye_from_blue_red_pink",
    "recipes/misc/magenta_dye_from_blue_red_white_dye",
    "recipes/misc/magenta_dye_from_lilac",
    "recipes/misc/magenta_dye_from_purple_and_pink",
    "recipes/misc/map",
    "recipes/misc/map_cloning",
    "recipes/misc/melon_seeds",
    "recipes/misc/mojang_banner_pattern",
    "recipes/misc/music_disc_5",
    "recipes/misc/nether_brick",
    "recipes/misc/netherite_ingot",
    "recipes/misc/netherite_ingot_from_netherite_block",
    "recipes/misc/netherite_scrap",
    "recipes/misc/netherite_scrap_from_blasting",
    "recipes/misc/netherite_upgrade_smithing_template",
    "recipes/misc/orange_dye_from_open_eyeblossom",
    "recipes/misc/orange_dye_from_orange_tulip",
    "recipes/misc/orange_dye_from_red_yellow",
    "recipes/misc/orange_dye_from_torchflower",
    "recipes/misc/paper",
    "recipes/misc/pink_dye_from_cactus_flower",
    "recipes/misc/pink_dye_from_peony",
    "recipes/misc/pink_dye_from_pink_petals",
    "recipes/misc/pink_dye_from_pink_tulip",
    "recipes/misc/pink_dye_from_red_white_dye",
    "recipes/misc/popped_chorus_fruit",
    "recipes/misc/pumpkin_seeds",
    "recipes/misc/purple_dye",
    "recipes/misc/quartz",
    "recipes/misc/quartz_from_blasting",
    "recipes/misc/raiser_armor_trim_smithing_template",
    "recipes/misc/raiser_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/raw_copper",
    "recipes/misc/raw_gold",
    "recipes/misc/raw_iron",
    "recipes/misc/red_dye_from_beetroot",
    "recipes/misc/red_dye_from_poppy",
    "recipes/misc/red_dye_from_rose_bush",
    "recipes/misc/red_dye_from_tulip",
    "recipes/misc/resin_brick",
    "recipes/misc/resin_clump",
    "recipes/misc/rib_armor_trim_smithing_template",
    "recipes/misc/rib_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/sentry_armor_trim_smithing_template",
    "recipes/misc/sentry_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/shaper_armor_trim_smithing_template",
    "recipes/misc/shaper_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/silence_armor_trim_smithing_template",
    "recipes/misc/silence_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/skull_banner_pattern",
    "recipes/misc/slime_ball",
    "recipes/misc/snout_armor_trim_smithing_template",
    "recipes/misc/snout_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/spire_armor_trim_smithing_template",
    "recipes/misc/spire_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/stick",
    "recipes/misc/stick_from_bamboo_item",
    "recipes/misc/sugar_from_honey_bottle",
    "recipes/misc/sugar_from_sugar_cane",
    "recipes/misc/tide_armor_trim_smithing_template",
    "recipes/misc/tide_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/tipped_arrow",
    "recipes/misc/vex_armor_trim_smithing_template",
    "recipes/misc/vex_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/ward_armor_trim_smithing_template",
    "recipes/misc/ward_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/wayfinder_armor_trim_smithing_template",
    "recipes/misc/wayfinder_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/wheat",
    "recipes/misc/white_dye",
    "recipes/misc/white_dye_from_lily_of_the_valley",
    "recipes/misc/wild_armor_trim_smithing_template",
    "recipes/misc/wild_armor_trim_smithing_template_smithing_trim",
    "recipes/misc/wind_charge",
    "recipes/misc/wolf_armor_dyed",
    "recipes/misc/writable_book",
    "recipes/misc/yellow_dye_from_dandelion",
    "recipes/misc/yellow_dye_from_golden_dandelion",
    "recipes/misc/yellow_dye_from_sunflower",
    "recipes/misc/yellow_dye_from_wildflowers",
    "recipes/redstone/acacia_button",
    "recipes/redstone/acacia_door",
    "recipes/redstone/acacia_fence_gate",
    "recipes/redstone/acacia_pressure_plate",
    "recipes/redstone/acacia_trapdoor",
    "recipes/redstone/bamboo_button",
    "recipes/redstone/bamboo_door",
    "recipes/redstone/bamboo_fence_gate",
    "recipes/redstone/bamboo_pressure_plate",
    "recipes/redstone/bamboo_trapdoor",
    "recipes/redstone/birch_button",
    "recipes/redstone/birch_door",
    "recipes/redstone/birch_fence_gate",
    "recipes/redstone/birch_pressure_plate",
    "recipes/redstone/birch_trapdoor",
    "recipes/redstone/calibrated_sculk_sensor",
    "recipes/redstone/cherry_button",
    "recipes/redstone/cherry_door",
    "recipes/redstone/cherry_fence_gate",
    "recipes/redstone/cherry_pressure_plate",
    "recipes/redstone/cherry_trapdoor",
    "recipes/redstone/comparator",
    "recipes/redstone/copper_bulb",
    "recipes/redstone/copper_door",
    "recipes/redstone/copper_trapdoor",
    "recipes/redstone/crafter",
    "recipes/redstone/crimson_button",
    "recipes/redstone/crimson_door",
    "recipes/redstone/crimson_fence_gate",
    "recipes/redstone/crimson_pressure_plate",
    "recipes/redstone/crimson_trapdoor",
    "recipes/redstone/dark_oak_button",
    "recipes/redstone/dark_oak_door",
    "recipes/redstone/dark_oak_fence_gate",
    "recipes/redstone/dark_oak_pressure_plate",
    "recipes/redstone/dark_oak_trapdoor",
    "recipes/redstone/daylight_detector",
    "recipes/redstone/dispenser",
    "recipes/redstone/dropper",
    "recipes/redstone/exposed_copper_bulb",
    "recipes/redstone/heavy_weighted_pressure_plate",
    "recipes/redstone/honey_block",
    "recipes/redstone/hopper",
    "recipes/redstone/iron_door",
    "recipes/redstone/iron_trapdoor",
    "recipes/redstone/jungle_button",
    "recipes/redstone/jungle_door",
    "recipes/redstone/jungle_fence_gate",
    "recipes/redstone/jungle_pressure_plate",
    "recipes/redstone/jungle_trapdoor",
    "recipes/redstone/lectern",
    "recipes/redstone/lever",
    "recipes/redstone/light_weighted_pressure_plate",
    "recipes/redstone/lightning_rod",
    "recipes/redstone/mangrove_button",
    "recipes/redstone/mangrove_door",
    "recipes/redstone/mangrove_fence_gate",
    "recipes/redstone/mangrove_pressure_plate",
    "recipes/redstone/mangrove_trapdoor",
    "recipes/redstone/note_block",
    "recipes/redstone/oak_button",
    "recipes/redstone/oak_door",
    "recipes/redstone/oak_fence_gate",
    "recipes/redstone/oak_pressure_plate",
    "recipes/redstone/oak_trapdoor",
    "recipes/redstone/observer",
    "recipes/redstone/oxidized_copper_bulb",
    "recipes/redstone/pale_oak_button",
    "recipes/redstone/pale_oak_door",
    "recipes/redstone/pale_oak_fence_gate",
    "recipes/redstone/pale_oak_pressure_plate",
    "recipes/redstone/pale_oak_trapdoor",
    "recipes/redstone/piston",
    "recipes/redstone/polished_blackstone_button",
    "recipes/redstone/polished_blackstone_pressure_plate",
    "recipes/redstone/poplar_button",
    "recipes/redstone/poplar_door",
    "recipes/redstone/poplar_fence_gate",
    "recipes/redstone/poplar_pressure_plate",
    "recipes/redstone/poplar_trapdoor",
    "recipes/redstone/redstone",
    "recipes/redstone/redstone_block",
    "recipes/redstone/redstone_from_blasting_deepslate_redstone_ore",
    "recipes/redstone/redstone_from_blasting_redstone_ore",
    "recipes/redstone/redstone_from_smelting_deepslate_redstone_ore",
    "recipes/redstone/redstone_from_smelting_redstone_ore",
    "recipes/redstone/redstone_lamp",
    "recipes/redstone/redstone_torch",
    "recipes/redstone/repeater",
    "recipes/redstone/slime_block",
    "recipes/redstone/spruce_button",
    "recipes/redstone/spruce_door",
    "recipes/redstone/spruce_fence_gate",
    "recipes/redstone/spruce_pressure_plate",
    "recipes/redstone/spruce_trapdoor",
    "recipes/redstone/sticky_piston",
    "recipes/redstone/stone_button",
    "recipes/redstone/stone_pressure_plate",
    "recipes/redstone/target",
    "recipes/redstone/tnt",
    "recipes/redstone/trapped_chest",
    "recipes/redstone/tripwire_hook",
    "recipes/redstone/warped_button",
    "recipes/redstone/warped_door",
    "recipes/redstone/warped_fence_gate",
    "recipes/redstone/warped_pressure_plate",
    "recipes/redstone/warped_trapdoor",
    "recipes/redstone/waxed_copper_bulb",
    "recipes/redstone/waxed_copper_bulb_from_honeycomb",
    "recipes/redstone/waxed_copper_door_from_honeycomb",
    "recipes/redstone/waxed_copper_trapdoor_from_honeycomb",
    "recipes/redstone/waxed_exposed_copper_bulb",
    "recipes/redstone/waxed_exposed_copper_bulb_from_honeycomb",
    "recipes/redstone/waxed_exposed_copper_door_from_honeycomb",
    "recipes/redstone/waxed_exposed_copper_trapdoor_from_honeycomb",
    "recipes/redstone/waxed_oxidized_copper_bulb",
    "recipes/redstone/waxed_oxidized_copper_bulb_from_honeycomb",
    "recipes/redstone/waxed_oxidized_copper_door_from_honeycomb",
    "recipes/redstone/waxed_oxidized_copper_trapdoor_from_honeycomb",
    "recipes/redstone/waxed_weathered_copper_bulb",
    "recipes/redstone/waxed_weathered_copper_bulb_from_honeycomb",
    "recipes/redstone/waxed_weathered_copper_door_from_honeycomb",
    "recipes/redstone/waxed_weathered_copper_trapdoor_from_honeycomb",
    "recipes/redstone/weathered_copper_bulb",
    "recipes/root",
    "recipes/tools/black_bundle",
    "recipes/tools/blue_bundle",
    "recipes/tools/brown_bundle",
    "recipes/tools/brush",
    "recipes/tools/bundle",
    "recipes/tools/clock",
    "recipes/tools/compass",
    "recipes/tools/copper_axe",
    "recipes/tools/copper_hoe",
    "recipes/tools/copper_pickaxe",
    "recipes/tools/copper_shovel",
    "recipes/tools/cyan_bundle",
    "recipes/tools/diamond_axe",
    "recipes/tools/diamond_hoe",
    "recipes/tools/diamond_pickaxe",
    "recipes/tools/diamond_shovel",
    "recipes/tools/fishing_rod",
    "recipes/tools/flint_and_steel",
    "recipes/tools/golden_axe",
    "recipes/tools/golden_hoe",
    "recipes/tools/golden_pickaxe",
    "recipes/tools/golden_shovel",
    "recipes/tools/gray_bundle",
    "recipes/tools/green_bundle",
    "recipes/tools/iron_axe",
    "recipes/tools/iron_hoe",
    "recipes/tools/iron_pickaxe",
    "recipes/tools/iron_shovel",
    "recipes/tools/lead",
    "recipes/tools/light_blue_bundle",
    "recipes/tools/light_gray_bundle",
    "recipes/tools/lime_bundle",
    "recipes/tools/magenta_bundle",
    "recipes/tools/name_tag",
    "recipes/tools/netherite_axe_smithing",
    "recipes/tools/netherite_hoe_smithing",
    "recipes/tools/netherite_pickaxe_smithing",
    "recipes/tools/netherite_shovel_smithing",
    "recipes/tools/orange_bundle",
    "recipes/tools/pink_bundle",
    "recipes/tools/purple_bundle",
    "recipes/tools/recovery_compass",
    "recipes/tools/red_bundle",
    "recipes/tools/shears",
    "recipes/tools/spyglass",
    "recipes/tools/stone_axe",
    "recipes/tools/stone_hoe",
    "recipes/tools/stone_pickaxe",
    "recipes/tools/stone_shovel",
    "recipes/tools/white_bundle",
    "recipes/tools/wooden_axe",
    "recipes/tools/wooden_hoe",
    "recipes/tools/wooden_pickaxe",
    "recipes/tools/wooden_shovel",
    "recipes/tools/yellow_bundle",
    "recipes/transportation/acacia_boat",
    "recipes/transportation/acacia_chest_boat",
    "recipes/transportation/activator_rail",
    "recipes/transportation/bamboo_chest_raft",
    "recipes/transportation/bamboo_raft",
    "recipes/transportation/birch_boat",
    "recipes/transportation/birch_chest_boat",
    "recipes/transportation/carrot_on_a_stick",
    "recipes/transportation/cherry_boat",
    "recipes/transportation/cherry_chest_boat",
    "recipes/transportation/chest_minecart",
    "recipes/transportation/dark_oak_boat",
    "recipes/transportation/dark_oak_chest_boat",
    "recipes/transportation/detector_rail",
    "recipes/transportation/furnace_minecart",
    "recipes/transportation/hopper_minecart",
    "recipes/transportation/jungle_boat",
    "recipes/transportation/jungle_chest_boat",
    "recipes/transportation/mangrove_boat",
    "recipes/transportation/mangrove_chest_boat",
    "recipes/transportation/minecart",
    "recipes/transportation/oak_boat",
    "recipes/transportation/oak_chest_boat",
    "recipes/transportation/pale_oak_boat",
    "recipes/transportation/pale_oak_chest_boat",
    "recipes/transportation/poplar_boat",
    "recipes/transportation/poplar_chest_boat",
    "recipes/transportation/powered_rail",
    "recipes/transportation/rail",
    "recipes/transportation/spruce_boat",
    "recipes/transportation/spruce_chest_boat",
    "recipes/transportation/tnt_minecart",
    "recipes/transportation/warped_fungus_on_a_stick",
    "story/cure_zombie_villager",
    "story/deflect_arrow",
    "story/enchant_item",
    "story/enter_the_end",
    "story/enter_the_nether",
    "story/follow_ender_eye",
    "story/form_obsidian",
    "story/iron_tools",
    "story/lava_bucket",
    "story/mine_diamond",
    "story/mine_stone",
    "story/obtain_armor",
    "story/root",
    "story/shiny_gear",
    "story/smelt_iron",
    "story/upgrade_tools"
  ]);
});

// src/arguments/generated/_registry/banner_patterns.ts
var BANNER_PATTERNS_SET;
var init_banner_patterns = __esm(() => {
  init_sandstone();
  BANNER_PATTERNS_SET = new Set2([
    "base",
    "border",
    "bricks",
    "circle",
    "creeper",
    "cross",
    "curly_border",
    "diagonal_left",
    "diagonal_right",
    "diagonal_up_left",
    "diagonal_up_right",
    "flow",
    "flower",
    "globe",
    "gradient",
    "gradient_up",
    "guster",
    "half_horizontal",
    "half_horizontal_bottom",
    "half_vertical",
    "half_vertical_right",
    "mojang",
    "piglin",
    "rhombus",
    "skull",
    "small_stripes",
    "square_bottom_left",
    "square_bottom_right",
    "square_top_left",
    "square_top_right",
    "straight_cross",
    "stripe_bottom",
    "stripe_center",
    "stripe_downleft",
    "stripe_downright",
    "stripe_left",
    "stripe_middle",
    "stripe_right",
    "stripe_top",
    "triangle_bottom",
    "triangle_top",
    "triangles_bottom",
    "triangles_top"
  ]);
});

// src/arguments/generated/_registry/cat_sound_variants.ts
var CAT_SOUND_VARIANTS_SET;
var init_cat_sound_variants = __esm(() => {
  init_sandstone();
  CAT_SOUND_VARIANTS_SET = new Set2([
    "classic",
    "royal"
  ]);
});

// src/arguments/generated/_registry/cat_variants.ts
var CAT_VARIANTS_SET;
var init_cat_variants = __esm(() => {
  init_sandstone();
  CAT_VARIANTS_SET = new Set2([
    "all_black",
    "black",
    "british_shorthair",
    "calico",
    "jellie",
    "persian",
    "ragdoll",
    "red",
    "siamese",
    "tabby",
    "white"
  ]);
});

// src/arguments/generated/_registry/chat_types.ts
var CHAT_TYPES_SET;
var init_chat_types = __esm(() => {
  init_sandstone();
  CHAT_TYPES_SET = new Set2([
    "chat",
    "emote_command",
    "msg_command_incoming",
    "msg_command_outgoing",
    "say_command",
    "team_msg_command_incoming",
    "team_msg_command_outgoing"
  ]);
});

// src/arguments/generated/_registry/chicken_sound_variants.ts
var CHICKEN_SOUND_VARIANTS_SET;
var init_chicken_sound_variants = __esm(() => {
  init_sandstone();
  CHICKEN_SOUND_VARIANTS_SET = new Set2([
    "classic",
    "picky"
  ]);
});

// src/arguments/generated/_registry/chicken_variants.ts
var CHICKEN_VARIANTS_SET;
var init_chicken_variants = __esm(() => {
  init_sandstone();
  CHICKEN_VARIANTS_SET = new Set2([
    "cold",
    "temperate",
    "warm"
  ]);
});

// src/arguments/generated/_registry/cow_sound_variants.ts
var COW_SOUND_VARIANTS_SET;
var init_cow_sound_variants = __esm(() => {
  init_sandstone();
  COW_SOUND_VARIANTS_SET = new Set2([
    "classic",
    "moody"
  ]);
});

// src/arguments/generated/_registry/cow_variants.ts
var COW_VARIANTS_SET;
var init_cow_variants = __esm(() => {
  init_sandstone();
  COW_VARIANTS_SET = new Set2([
    "cold",
    "temperate",
    "warm"
  ]);
});

// src/arguments/generated/_registry/damage_types.ts
var DAMAGE_TYPES_SET;
var init_damage_types = __esm(() => {
  init_sandstone();
  DAMAGE_TYPES_SET = new Set2([
    "arrow",
    "bad_respawn_point",
    "cactus",
    "campfire",
    "cramming",
    "dragon_breath",
    "drown",
    "dry_out",
    "ender_pearl",
    "explosion",
    "fall",
    "falling_anvil",
    "falling_block",
    "falling_stalactite",
    "fireball",
    "fireworks",
    "fly_into_wall",
    "freeze",
    "generic",
    "generic_kill",
    "hot_floor",
    "in_fire",
    "in_wall",
    "indirect_magic",
    "lava",
    "lightning_bolt",
    "mace_smash",
    "magic",
    "mob_attack",
    "mob_attack_no_aggro",
    "mob_projectile",
    "on_fire",
    "out_of_world",
    "outside_border",
    "player_attack",
    "player_explosion",
    "sonic_boom",
    "spear",
    "spit",
    "stalagmite",
    "starve",
    "sting",
    "sulfur_cube_hot",
    "sweet_berry_bush",
    "thorns",
    "thrown",
    "trident",
    "unattributed_fireball",
    "wind_charge",
    "wither",
    "wither_skull"
  ]);
});

// src/arguments/generated/_registry/decorated_pot_patterns.ts
var DECORATED_POT_PATTERNS_SET;
var init_decorated_pot_patterns = __esm(() => {
  init_sandstone();
  DECORATED_POT_PATTERNS_SET = new Set2([
    "angler",
    "archer",
    "arms_up",
    "blade",
    "brewer",
    "burn",
    "danger",
    "explorer",
    "flow",
    "friend",
    "guster",
    "heart",
    "heartbreak",
    "howl",
    "miner",
    "mourner",
    "plenty",
    "prize",
    "scrape",
    "sheaf",
    "shelter",
    "skull",
    "snort"
  ]);
});

// src/arguments/generated/_registry/dialogs.ts
var DIALOGS_SET;
var init_dialogs = __esm(() => {
  init_sandstone();
  DIALOGS_SET = new Set2([
    "custom_options",
    "quick_actions",
    "server_links"
  ]);
});

// src/arguments/generated/_registry/dimensions.ts
var DIMENSIONS_SET;
var init_dimensions = __esm(() => {
  init_sandstone();
  DIMENSIONS_SET = new Set2([
    "overworld",
    "the_end",
    "the_nether"
  ]);
});

// src/arguments/generated/_registry/dimension_types.ts
var DIMENSION_TYPES_SET;
var init_dimension_types = __esm(() => {
  init_sandstone();
  DIMENSION_TYPES_SET = new Set2([
    "overworld",
    "overworld_caves",
    "the_end",
    "the_nether"
  ]);
});

// src/arguments/generated/_registry/enchantments.ts
var ENCHANTMENTS_SET;
var init_enchantments = __esm(() => {
  init_sandstone();
  ENCHANTMENTS_SET = new Set2([
    "aqua_affinity",
    "bane_of_arthropods",
    "binding_curse",
    "blast_protection",
    "breach",
    "channeling",
    "density",
    "depth_strider",
    "efficiency",
    "feather_falling",
    "fire_aspect",
    "fire_protection",
    "flame",
    "fortune",
    "frost_walker",
    "impaling",
    "infinity",
    "knockback",
    "looting",
    "loyalty",
    "luck_of_the_sea",
    "lunge",
    "lure",
    "mending",
    "multishot",
    "piercing",
    "power",
    "projectile_protection",
    "protection",
    "punch",
    "quick_charge",
    "respiration",
    "riptide",
    "sharpness",
    "silk_touch",
    "smite",
    "soul_speed",
    "sweeping_edge",
    "swift_sneak",
    "thorns",
    "unbreaking",
    "vanishing_curse",
    "wind_burst"
  ]);
});

// src/arguments/generated/_registry/enchantment_providers.ts
var ENCHANTMENT_PROVIDERS_SET;
var init_enchantment_providers = __esm(() => {
  init_sandstone();
  ENCHANTMENT_PROVIDERS_SET = new Set2([
    "enderman_loot_drop",
    "mob_spawn_equipment",
    "pillager_spawn_crossbow",
    "raid/pillager_post_wave_3",
    "raid/pillager_post_wave_5",
    "raid/vindicator",
    "raid/vindicator_post_wave_5"
  ]);
});

// src/arguments/generated/_registry/frog_variants.ts
var FROG_VARIANTS_SET;
var init_frog_variants = __esm(() => {
  init_sandstone();
  FROG_VARIANTS_SET = new Set2([
    "cold",
    "temperate",
    "warm"
  ]);
});

// src/arguments/generated/_registry/instruments.ts
var INSTRUMENTS_SET;
var init_instruments = __esm(() => {
  init_sandstone();
  INSTRUMENTS_SET = new Set2([
    "admire_goat_horn",
    "call_goat_horn",
    "dream_goat_horn",
    "feel_goat_horn",
    "ponder_goat_horn",
    "seek_goat_horn",
    "sing_goat_horn",
    "yearn_goat_horn"
  ]);
});

// src/arguments/generated/_registry/jukebox_songs.ts
var JUKEBOX_SONGS_SET;
var init_jukebox_songs = __esm(() => {
  init_sandstone();
  JUKEBOX_SONGS_SET = new Set2([
    "11",
    "13",
    "5",
    "blocks",
    "bounce",
    "cat",
    "chirp",
    "creator",
    "creator_music_box",
    "far",
    "lava_chicken",
    "mall",
    "mellohi",
    "otherside",
    "pigstep",
    "precipice",
    "relic",
    "stal",
    "strad",
    "tears",
    "wait",
    "ward"
  ]);
});

// src/arguments/generated/_registry/loot_tables.ts
var LOOT_TABLES_SET;
var init_loot_tables = __esm(() => {
  init_sandstone();
  LOOT_TABLES_SET = new Set2([
    "archaeology/desert_pyramid",
    "archaeology/desert_well",
    "archaeology/ocean_ruin_cold",
    "archaeology/ocean_ruin_warm",
    "archaeology/trail_ruins_common",
    "archaeology/trail_ruins_rare",
    "barrels/abandoned_camp_barrel",
    "blocks/acacia_button",
    "blocks/acacia_door",
    "blocks/acacia_fence",
    "blocks/acacia_fence_gate",
    "blocks/acacia_hanging_sign",
    "blocks/acacia_leaves",
    "blocks/acacia_log",
    "blocks/acacia_planks",
    "blocks/acacia_pressure_plate",
    "blocks/acacia_sapling",
    "blocks/acacia_shelf",
    "blocks/acacia_sign",
    "blocks/acacia_slab",
    "blocks/acacia_stairs",
    "blocks/acacia_trapdoor",
    "blocks/acacia_wood",
    "blocks/activator_rail",
    "blocks/allium",
    "blocks/amethyst_block",
    "blocks/amethyst_cluster",
    "blocks/ancient_debris",
    "blocks/andesite",
    "blocks/andesite_slab",
    "blocks/andesite_stairs",
    "blocks/andesite_wall",
    "blocks/anvil",
    "blocks/attached_melon_stem",
    "blocks/attached_pumpkin_stem",
    "blocks/azalea",
    "blocks/azalea_leaves",
    "blocks/azure_bluet",
    "blocks/bamboo",
    "blocks/bamboo_block",
    "blocks/bamboo_button",
    "blocks/bamboo_door",
    "blocks/bamboo_fence",
    "blocks/bamboo_fence_gate",
    "blocks/bamboo_hanging_sign",
    "blocks/bamboo_mosaic",
    "blocks/bamboo_mosaic_slab",
    "blocks/bamboo_mosaic_stairs",
    "blocks/bamboo_planks",
    "blocks/bamboo_pressure_plate",
    "blocks/bamboo_sapling",
    "blocks/bamboo_shelf",
    "blocks/bamboo_sign",
    "blocks/bamboo_slab",
    "blocks/bamboo_stairs",
    "blocks/bamboo_trapdoor",
    "blocks/barrel",
    "blocks/basalt",
    "blocks/beacon",
    "blocks/bee_nest",
    "blocks/beehive",
    "blocks/beetroots",
    "blocks/bell",
    "blocks/big_dripleaf",
    "blocks/big_dripleaf_stem",
    "blocks/birch_button",
    "blocks/birch_door",
    "blocks/birch_fence",
    "blocks/birch_fence_gate",
    "blocks/birch_hanging_sign",
    "blocks/birch_leaves",
    "blocks/birch_log",
    "blocks/birch_planks",
    "blocks/birch_pressure_plate",
    "blocks/birch_sapling",
    "blocks/birch_shelf",
    "blocks/birch_sign",
    "blocks/birch_slab",
    "blocks/birch_stairs",
    "blocks/birch_trapdoor",
    "blocks/birch_wood",
    "blocks/black_banner",
    "blocks/black_bed",
    "blocks/black_candle",
    "blocks/black_candle_cake",
    "blocks/black_carpet",
    "blocks/black_concrete",
    "blocks/black_concrete_powder",
    "blocks/black_concrete_slab",
    "blocks/black_concrete_stairs",
    "blocks/black_glazed_terracotta",
    "blocks/black_shulker_box",
    "blocks/black_stained_glass",
    "blocks/black_stained_glass_pane",
    "blocks/black_terracotta",
    "blocks/black_wool",
    "blocks/black_wool_slab",
    "blocks/black_wool_stairs",
    "blocks/blackstone",
    "blocks/blackstone_slab",
    "blocks/blackstone_stairs",
    "blocks/blackstone_wall",
    "blocks/blast_furnace",
    "blocks/blue_banner",
    "blocks/blue_bed",
    "blocks/blue_candle",
    "blocks/blue_candle_cake",
    "blocks/blue_carpet",
    "blocks/blue_concrete",
    "blocks/blue_concrete_powder",
    "blocks/blue_concrete_slab",
    "blocks/blue_concrete_stairs",
    "blocks/blue_glazed_terracotta",
    "blocks/blue_ice",
    "blocks/blue_orchid",
    "blocks/blue_shulker_box",
    "blocks/blue_stained_glass",
    "blocks/blue_stained_glass_pane",
    "blocks/blue_terracotta",
    "blocks/blue_wool",
    "blocks/blue_wool_slab",
    "blocks/blue_wool_stairs",
    "blocks/bone_block",
    "blocks/bookshelf",
    "blocks/brain_coral",
    "blocks/brain_coral_block",
    "blocks/brain_coral_fan",
    "blocks/brewing_stand",
    "blocks/brick_slab",
    "blocks/brick_stairs",
    "blocks/brick_wall",
    "blocks/bricks",
    "blocks/brown_banner",
    "blocks/brown_bed",
    "blocks/brown_candle",
    "blocks/brown_candle_cake",
    "blocks/brown_carpet",
    "blocks/brown_concrete",
    "blocks/brown_concrete_powder",
    "blocks/brown_concrete_slab",
    "blocks/brown_concrete_stairs",
    "blocks/brown_glazed_terracotta",
    "blocks/brown_mushroom",
    "blocks/brown_mushroom_block",
    "blocks/brown_shulker_box",
    "blocks/brown_stained_glass",
    "blocks/brown_stained_glass_pane",
    "blocks/brown_terracotta",
    "blocks/brown_wool",
    "blocks/brown_wool_slab",
    "blocks/brown_wool_stairs",
    "blocks/bubble_coral",
    "blocks/bubble_coral_block",
    "blocks/bubble_coral_fan",
    "blocks/budding_amethyst",
    "blocks/bush",
    "blocks/cactus",
    "blocks/cactus_flower",
    "blocks/cake",
    "blocks/calcite",
    "blocks/calibrated_sculk_sensor",
    "blocks/campfire",
    "blocks/candle",
    "blocks/candle_cake",
    "blocks/carrots",
    "blocks/cartography_table",
    "blocks/carved_pumpkin",
    "blocks/cauldron",
    "blocks/cave_vines",
    "blocks/cave_vines_plant",
    "blocks/cherry_button",
    "blocks/cherry_door",
    "blocks/cherry_fence",
    "blocks/cherry_fence_gate",
    "blocks/cherry_hanging_sign",
    "blocks/cherry_leaves",
    "blocks/cherry_log",
    "blocks/cherry_planks",
    "blocks/cherry_pressure_plate",
    "blocks/cherry_sapling",
    "blocks/cherry_shelf",
    "blocks/cherry_sign",
    "blocks/cherry_slab",
    "blocks/cherry_stairs",
    "blocks/cherry_trapdoor",
    "blocks/cherry_wood",
    "blocks/chest",
    "blocks/chipped_anvil",
    "blocks/chiseled_bookshelf",
    "blocks/chiseled_cinnabar",
    "blocks/chiseled_copper",
    "blocks/chiseled_deepslate",
    "blocks/chiseled_nether_bricks",
    "blocks/chiseled_polished_blackstone",
    "blocks/chiseled_quartz_block",
    "blocks/chiseled_red_sandstone",
    "blocks/chiseled_resin_bricks",
    "blocks/chiseled_sandstone",
    "blocks/chiseled_stone_bricks",
    "blocks/chiseled_sulfur",
    "blocks/chiseled_tuff",
    "blocks/chiseled_tuff_bricks",
    "blocks/chorus_flower",
    "blocks/chorus_plant",
    "blocks/cinnabar",
    "blocks/cinnabar_brick_slab",
    "blocks/cinnabar_brick_stairs",
    "blocks/cinnabar_brick_wall",
    "blocks/cinnabar_bricks",
    "blocks/cinnabar_slab",
    "blocks/cinnabar_stairs",
    "blocks/cinnabar_wall",
    "blocks/clay",
    "blocks/closed_eyeblossom",
    "blocks/coal_block",
    "blocks/coal_ore",
    "blocks/coarse_dirt",
    "blocks/cobbled_deepslate",
    "blocks/cobbled_deepslate_slab",
    "blocks/cobbled_deepslate_stairs",
    "blocks/cobbled_deepslate_wall",
    "blocks/cobblestone",
    "blocks/cobblestone_slab",
    "blocks/cobblestone_stairs",
    "blocks/cobblestone_wall",
    "blocks/cobweb",
    "blocks/cocoa",
    "blocks/comparator",
    "blocks/composter",
    "blocks/conduit",
    "blocks/copper_bars",
    "blocks/copper_block",
    "blocks/copper_bulb",
    "blocks/copper_chain",
    "blocks/copper_chest",
    "blocks/copper_door",
    "blocks/copper_golem_statue",
    "blocks/copper_grate",
    "blocks/copper_lantern",
    "blocks/copper_ore",
    "blocks/copper_torch",
    "blocks/copper_trapdoor",
    "blocks/cornflower",
    "blocks/cracked_deepslate_bricks",
    "blocks/cracked_deepslate_tiles",
    "blocks/cracked_nether_bricks",
    "blocks/cracked_polished_blackstone_bricks",
    "blocks/cracked_stone_bricks",
    "blocks/crafter",
    "blocks/crafting_table",
    "blocks/creaking_heart",
    "blocks/creeper_head",
    "blocks/crimson_button",
    "blocks/crimson_door",
    "blocks/crimson_fence",
    "blocks/crimson_fence_gate",
    "blocks/crimson_fungus",
    "blocks/crimson_hanging_sign",
    "blocks/crimson_hyphae",
    "blocks/crimson_nylium",
    "blocks/crimson_planks",
    "blocks/crimson_pressure_plate",
    "blocks/crimson_roots",
    "blocks/crimson_shelf",
    "blocks/crimson_sign",
    "blocks/crimson_slab",
    "blocks/crimson_stairs",
    "blocks/crimson_stem",
    "blocks/crimson_trapdoor",
    "blocks/crying_obsidian",
    "blocks/cut_copper",
    "blocks/cut_copper_slab",
    "blocks/cut_copper_stairs",
    "blocks/cut_red_sandstone",
    "blocks/cut_red_sandstone_slab",
    "blocks/cut_sandstone",
    "blocks/cut_sandstone_slab",
    "blocks/cyan_banner",
    "blocks/cyan_bed",
    "blocks/cyan_candle",
    "blocks/cyan_candle_cake",
    "blocks/cyan_carpet",
    "blocks/cyan_concrete",
    "blocks/cyan_concrete_powder",
    "blocks/cyan_concrete_slab",
    "blocks/cyan_concrete_stairs",
    "blocks/cyan_glazed_terracotta",
    "blocks/cyan_shulker_box",
    "blocks/cyan_stained_glass",
    "blocks/cyan_stained_glass_pane",
    "blocks/cyan_terracotta",
    "blocks/cyan_wool",
    "blocks/cyan_wool_slab",
    "blocks/cyan_wool_stairs",
    "blocks/damaged_anvil",
    "blocks/dandelion",
    "blocks/dark_oak_button",
    "blocks/dark_oak_door",
    "blocks/dark_oak_fence",
    "blocks/dark_oak_fence_gate",
    "blocks/dark_oak_hanging_sign",
    "blocks/dark_oak_leaves",
    "blocks/dark_oak_log",
    "blocks/dark_oak_planks",
    "blocks/dark_oak_pressure_plate",
    "blocks/dark_oak_sapling",
    "blocks/dark_oak_shelf",
    "blocks/dark_oak_sign",
    "blocks/dark_oak_slab",
    "blocks/dark_oak_stairs",
    "blocks/dark_oak_trapdoor",
    "blocks/dark_oak_wood",
    "blocks/dark_prismarine",
    "blocks/dark_prismarine_slab",
    "blocks/dark_prismarine_stairs",
    "blocks/daylight_detector",
    "blocks/dead_brain_coral",
    "blocks/dead_brain_coral_block",
    "blocks/dead_brain_coral_fan",
    "blocks/dead_bubble_coral",
    "blocks/dead_bubble_coral_block",
    "blocks/dead_bubble_coral_fan",
    "blocks/dead_bush",
    "blocks/dead_fire_coral",
    "blocks/dead_fire_coral_block",
    "blocks/dead_fire_coral_fan",
    "blocks/dead_horn_coral",
    "blocks/dead_horn_coral_block",
    "blocks/dead_horn_coral_fan",
    "blocks/dead_tube_coral",
    "blocks/dead_tube_coral_block",
    "blocks/dead_tube_coral_fan",
    "blocks/decorated_pot",
    "blocks/deepslate",
    "blocks/deepslate_brick_slab",
    "blocks/deepslate_brick_stairs",
    "blocks/deepslate_brick_wall",
    "blocks/deepslate_bricks",
    "blocks/deepslate_coal_ore",
    "blocks/deepslate_copper_ore",
    "blocks/deepslate_diamond_ore",
    "blocks/deepslate_emerald_ore",
    "blocks/deepslate_gold_ore",
    "blocks/deepslate_iron_ore",
    "blocks/deepslate_lapis_ore",
    "blocks/deepslate_redstone_ore",
    "blocks/deepslate_tile_slab",
    "blocks/deepslate_tile_stairs",
    "blocks/deepslate_tile_wall",
    "blocks/deepslate_tiles",
    "blocks/detector_rail",
    "blocks/diamond_block",
    "blocks/diamond_ore",
    "blocks/diorite",
    "blocks/diorite_slab",
    "blocks/diorite_stairs",
    "blocks/diorite_wall",
    "blocks/dirt",
    "blocks/dirt_path",
    "blocks/dispenser",
    "blocks/dragon_egg",
    "blocks/dragon_head",
    "blocks/dried_ghast",
    "blocks/dried_kelp_block",
    "blocks/dripstone_block",
    "blocks/dropper",
    "blocks/emerald_block",
    "blocks/emerald_ore",
    "blocks/enchanting_table",
    "blocks/end_rod",
    "blocks/end_stone",
    "blocks/end_stone_brick_slab",
    "blocks/end_stone_brick_stairs",
    "blocks/end_stone_brick_wall",
    "blocks/end_stone_bricks",
    "blocks/ender_chest",
    "blocks/exposed_chiseled_copper",
    "blocks/exposed_copper",
    "blocks/exposed_copper_bars",
    "blocks/exposed_copper_bulb",
    "blocks/exposed_copper_chain",
    "blocks/exposed_copper_chest",
    "blocks/exposed_copper_door",
    "blocks/exposed_copper_golem_statue",
    "blocks/exposed_copper_grate",
    "blocks/exposed_copper_lantern",
    "blocks/exposed_copper_trapdoor",
    "blocks/exposed_cut_copper",
    "blocks/exposed_cut_copper_slab",
    "blocks/exposed_cut_copper_stairs",
    "blocks/exposed_lightning_rod",
    "blocks/farmland",
    "blocks/fern",
    "blocks/fire",
    "blocks/fire_coral",
    "blocks/fire_coral_block",
    "blocks/fire_coral_fan",
    "blocks/firefly_bush",
    "blocks/fletching_table",
    "blocks/flower_pot",
    "blocks/flowering_azalea",
    "blocks/flowering_azalea_leaves",
    "blocks/frogspawn",
    "blocks/frosted_ice",
    "blocks/furnace",
    "blocks/gilded_blackstone",
    "blocks/glass",
    "blocks/glass_pane",
    "blocks/glow_lichen",
    "blocks/glowstone",
    "blocks/gold_block",
    "blocks/gold_ore",
    "blocks/golden_dandelion",
    "blocks/granite",
    "blocks/granite_slab",
    "blocks/granite_stairs",
    "blocks/granite_wall",
    "blocks/grass_block",
    "blocks/gravel",
    "blocks/gray_banner",
    "blocks/gray_bed",
    "blocks/gray_candle",
    "blocks/gray_candle_cake",
    "blocks/gray_carpet",
    "blocks/gray_concrete",
    "blocks/gray_concrete_powder",
    "blocks/gray_concrete_slab",
    "blocks/gray_concrete_stairs",
    "blocks/gray_glazed_terracotta",
    "blocks/gray_shulker_box",
    "blocks/gray_stained_glass",
    "blocks/gray_stained_glass_pane",
    "blocks/gray_terracotta",
    "blocks/gray_wool",
    "blocks/gray_wool_slab",
    "blocks/gray_wool_stairs",
    "blocks/green_banner",
    "blocks/green_bed",
    "blocks/green_candle",
    "blocks/green_candle_cake",
    "blocks/green_carpet",
    "blocks/green_concrete",
    "blocks/green_concrete_powder",
    "blocks/green_concrete_slab",
    "blocks/green_concrete_stairs",
    "blocks/green_glazed_terracotta",
    "blocks/green_shulker_box",
    "blocks/green_stained_glass",
    "blocks/green_stained_glass_pane",
    "blocks/green_terracotta",
    "blocks/green_wool",
    "blocks/green_wool_slab",
    "blocks/green_wool_stairs",
    "blocks/grindstone",
    "blocks/hanging_roots",
    "blocks/hay_block",
    "blocks/heavy_core",
    "blocks/heavy_weighted_pressure_plate",
    "blocks/honey_block",
    "blocks/honeycomb_block",
    "blocks/hopper",
    "blocks/horn_coral",
    "blocks/horn_coral_block",
    "blocks/horn_coral_fan",
    "blocks/ice",
    "blocks/infested_chiseled_stone_bricks",
    "blocks/infested_cobblestone",
    "blocks/infested_cracked_stone_bricks",
    "blocks/infested_deepslate",
    "blocks/infested_mossy_stone_bricks",
    "blocks/infested_stone",
    "blocks/infested_stone_bricks",
    "blocks/iron_bars",
    "blocks/iron_block",
    "blocks/iron_chain",
    "blocks/iron_door",
    "blocks/iron_ore",
    "blocks/iron_trapdoor",
    "blocks/jack_o_lantern",
    "blocks/jukebox",
    "blocks/jungle_button",
    "blocks/jungle_door",
    "blocks/jungle_fence",
    "blocks/jungle_fence_gate",
    "blocks/jungle_hanging_sign",
    "blocks/jungle_leaves",
    "blocks/jungle_log",
    "blocks/jungle_planks",
    "blocks/jungle_pressure_plate",
    "blocks/jungle_sapling",
    "blocks/jungle_shelf",
    "blocks/jungle_sign",
    "blocks/jungle_slab",
    "blocks/jungle_stairs",
    "blocks/jungle_trapdoor",
    "blocks/jungle_wood",
    "blocks/kelp",
    "blocks/kelp_plant",
    "blocks/ladder",
    "blocks/lantern",
    "blocks/lapis_block",
    "blocks/lapis_ore",
    "blocks/large_amethyst_bud",
    "blocks/large_fern",
    "blocks/lava_cauldron",
    "blocks/leaf_litter",
    "blocks/lectern",
    "blocks/lever",
    "blocks/light_blue_banner",
    "blocks/light_blue_bed",
    "blocks/light_blue_candle",
    "blocks/light_blue_candle_cake",
    "blocks/light_blue_carpet",
    "blocks/light_blue_concrete",
    "blocks/light_blue_concrete_powder",
    "blocks/light_blue_concrete_slab",
    "blocks/light_blue_concrete_stairs",
    "blocks/light_blue_glazed_terracotta",
    "blocks/light_blue_shulker_box",
    "blocks/light_blue_stained_glass",
    "blocks/light_blue_stained_glass_pane",
    "blocks/light_blue_terracotta",
    "blocks/light_blue_wool",
    "blocks/light_blue_wool_slab",
    "blocks/light_blue_wool_stairs",
    "blocks/light_gray_banner",
    "blocks/light_gray_bed",
    "blocks/light_gray_candle",
    "blocks/light_gray_candle_cake",
    "blocks/light_gray_carpet",
    "blocks/light_gray_concrete",
    "blocks/light_gray_concrete_powder",
    "blocks/light_gray_concrete_slab",
    "blocks/light_gray_concrete_stairs",
    "blocks/light_gray_glazed_terracotta",
    "blocks/light_gray_shulker_box",
    "blocks/light_gray_stained_glass",
    "blocks/light_gray_stained_glass_pane",
    "blocks/light_gray_terracotta",
    "blocks/light_gray_wool",
    "blocks/light_gray_wool_slab",
    "blocks/light_gray_wool_stairs",
    "blocks/light_weighted_pressure_plate",
    "blocks/lightning_rod",
    "blocks/lilac",
    "blocks/lily_of_the_valley",
    "blocks/lily_pad",
    "blocks/lime_banner",
    "blocks/lime_bed",
    "blocks/lime_candle",
    "blocks/lime_candle_cake",
    "blocks/lime_carpet",
    "blocks/lime_concrete",
    "blocks/lime_concrete_powder",
    "blocks/lime_concrete_slab",
    "blocks/lime_concrete_stairs",
    "blocks/lime_glazed_terracotta",
    "blocks/lime_shulker_box",
    "blocks/lime_stained_glass",
    "blocks/lime_stained_glass_pane",
    "blocks/lime_terracotta",
    "blocks/lime_wool",
    "blocks/lime_wool_slab",
    "blocks/lime_wool_stairs",
    "blocks/lodestone",
    "blocks/loom",
    "blocks/magenta_banner",
    "blocks/magenta_bed",
    "blocks/magenta_candle",
    "blocks/magenta_candle_cake",
    "blocks/magenta_carpet",
    "blocks/magenta_concrete",
    "blocks/magenta_concrete_powder",
    "blocks/magenta_concrete_slab",
    "blocks/magenta_concrete_stairs",
    "blocks/magenta_glazed_terracotta",
    "blocks/magenta_shulker_box",
    "blocks/magenta_stained_glass",
    "blocks/magenta_stained_glass_pane",
    "blocks/magenta_terracotta",
    "blocks/magenta_wool",
    "blocks/magenta_wool_slab",
    "blocks/magenta_wool_stairs",
    "blocks/magma_block",
    "blocks/mangrove_button",
    "blocks/mangrove_door",
    "blocks/mangrove_fence",
    "blocks/mangrove_fence_gate",
    "blocks/mangrove_hanging_sign",
    "blocks/mangrove_leaves",
    "blocks/mangrove_log",
    "blocks/mangrove_planks",
    "blocks/mangrove_pressure_plate",
    "blocks/mangrove_propagule",
    "blocks/mangrove_roots",
    "blocks/mangrove_shelf",
    "blocks/mangrove_sign",
    "blocks/mangrove_slab",
    "blocks/mangrove_stairs",
    "blocks/mangrove_trapdoor",
    "blocks/mangrove_wood",
    "blocks/medium_amethyst_bud",
    "blocks/melon",
    "blocks/melon_stem",
    "blocks/moss_block",
    "blocks/moss_carpet",
    "blocks/mossy_cobblestone",
    "blocks/mossy_cobblestone_slab",
    "blocks/mossy_cobblestone_stairs",
    "blocks/mossy_cobblestone_wall",
    "blocks/mossy_stone_brick_slab",
    "blocks/mossy_stone_brick_stairs",
    "blocks/mossy_stone_brick_wall",
    "blocks/mossy_stone_bricks",
    "blocks/mud",
    "blocks/mud_brick_slab",
    "blocks/mud_brick_stairs",
    "blocks/mud_brick_wall",
    "blocks/mud_bricks",
    "blocks/muddy_mangrove_roots",
    "blocks/mushroom_stem",
    "blocks/mycelium",
    "blocks/nether_brick_fence",
    "blocks/nether_brick_slab",
    "blocks/nether_brick_stairs",
    "blocks/nether_brick_wall",
    "blocks/nether_bricks",
    "blocks/nether_gold_ore",
    "blocks/nether_portal",
    "blocks/nether_quartz_ore",
    "blocks/nether_sprouts",
    "blocks/nether_wart",
    "blocks/nether_wart_block",
    "blocks/netherite_block",
    "blocks/netherrack",
    "blocks/note_block",
    "blocks/oak_button",
    "blocks/oak_door",
    "blocks/oak_fence",
    "blocks/oak_fence_gate",
    "blocks/oak_hanging_sign",
    "blocks/oak_leaves",
    "blocks/oak_log",
    "blocks/oak_planks",
    "blocks/oak_pressure_plate",
    "blocks/oak_sapling",
    "blocks/oak_shelf",
    "blocks/oak_sign",
    "blocks/oak_slab",
    "blocks/oak_stairs",
    "blocks/oak_trapdoor",
    "blocks/oak_wood",
    "blocks/observer",
    "blocks/obsidian",
    "blocks/ochre_froglight",
    "blocks/open_eyeblossom",
    "blocks/orange_banner",
    "blocks/orange_bed",
    "blocks/orange_candle",
    "blocks/orange_candle_cake",
    "blocks/orange_carpet",
    "blocks/orange_concrete",
    "blocks/orange_concrete_powder",
    "blocks/orange_concrete_slab",
    "blocks/orange_concrete_stairs",
    "blocks/orange_glazed_terracotta",
    "blocks/orange_poplar_leaves",
    "blocks/orange_shulker_box",
    "blocks/orange_stained_glass",
    "blocks/orange_stained_glass_pane",
    "blocks/orange_terracotta",
    "blocks/orange_tulip",
    "blocks/orange_wool",
    "blocks/orange_wool_slab",
    "blocks/orange_wool_stairs",
    "blocks/oxeye_daisy",
    "blocks/oxidized_chiseled_copper",
    "blocks/oxidized_copper",
    "blocks/oxidized_copper_bars",
    "blocks/oxidized_copper_bulb",
    "blocks/oxidized_copper_chain",
    "blocks/oxidized_copper_chest",
    "blocks/oxidized_copper_door",
    "blocks/oxidized_copper_golem_statue",
    "blocks/oxidized_copper_grate",
    "blocks/oxidized_copper_lantern",
    "blocks/oxidized_copper_trapdoor",
    "blocks/oxidized_cut_copper",
    "blocks/oxidized_cut_copper_slab",
    "blocks/oxidized_cut_copper_stairs",
    "blocks/oxidized_lightning_rod",
    "blocks/packed_ice",
    "blocks/packed_mud",
    "blocks/pale_hanging_moss",
    "blocks/pale_moss_block",
    "blocks/pale_moss_carpet",
    "blocks/pale_oak_button",
    "blocks/pale_oak_door",
    "blocks/pale_oak_fence",
    "blocks/pale_oak_fence_gate",
    "blocks/pale_oak_hanging_sign",
    "blocks/pale_oak_leaves",
    "blocks/pale_oak_log",
    "blocks/pale_oak_planks",
    "blocks/pale_oak_pressure_plate",
    "blocks/pale_oak_sapling",
    "blocks/pale_oak_shelf",
    "blocks/pale_oak_sign",
    "blocks/pale_oak_slab",
    "blocks/pale_oak_stairs",
    "blocks/pale_oak_trapdoor",
    "blocks/pale_oak_wood",
    "blocks/pearlescent_froglight",
    "blocks/peony",
    "blocks/petrified_oak_slab",
    "blocks/piglin_head",
    "blocks/pink_banner",
    "blocks/pink_bed",
    "blocks/pink_candle",
    "blocks/pink_candle_cake",
    "blocks/pink_carpet",
    "blocks/pink_concrete",
    "blocks/pink_concrete_powder",
    "blocks/pink_concrete_slab",
    "blocks/pink_concrete_stairs",
    "blocks/pink_glazed_terracotta",
    "blocks/pink_petals",
    "blocks/pink_shulker_box",
    "blocks/pink_stained_glass",
    "blocks/pink_stained_glass_pane",
    "blocks/pink_terracotta",
    "blocks/pink_tulip",
    "blocks/pink_wool",
    "blocks/pink_wool_slab",
    "blocks/pink_wool_stairs",
    "blocks/piston",
    "blocks/pitcher_crop",
    "blocks/pitcher_plant",
    "blocks/player_head",
    "blocks/podzol",
    "blocks/pointed_dripstone",
    "blocks/polished_andesite",
    "blocks/polished_andesite_slab",
    "blocks/polished_andesite_stairs",
    "blocks/polished_basalt",
    "blocks/polished_blackstone",
    "blocks/polished_blackstone_brick_slab",
    "blocks/polished_blackstone_brick_stairs",
    "blocks/polished_blackstone_brick_wall",
    "blocks/polished_blackstone_bricks",
    "blocks/polished_blackstone_button",
    "blocks/polished_blackstone_pressure_plate",
    "blocks/polished_blackstone_slab",
    "blocks/polished_blackstone_stairs",
    "blocks/polished_blackstone_wall",
    "blocks/polished_cinnabar",
    "blocks/polished_cinnabar_slab",
    "blocks/polished_cinnabar_stairs",
    "blocks/polished_cinnabar_wall",
    "blocks/polished_deepslate",
    "blocks/polished_deepslate_slab",
    "blocks/polished_deepslate_stairs",
    "blocks/polished_deepslate_wall",
    "blocks/polished_diorite",
    "blocks/polished_diorite_slab",
    "blocks/polished_diorite_stairs",
    "blocks/polished_granite",
    "blocks/polished_granite_slab",
    "blocks/polished_granite_stairs",
    "blocks/polished_sulfur",
    "blocks/polished_sulfur_slab",
    "blocks/polished_sulfur_stairs",
    "blocks/polished_sulfur_wall",
    "blocks/polished_tuff",
    "blocks/polished_tuff_slab",
    "blocks/polished_tuff_stairs",
    "blocks/polished_tuff_wall",
    "blocks/poplar_button",
    "blocks/poplar_door",
    "blocks/poplar_fence",
    "blocks/poplar_fence_gate",
    "blocks/poplar_hanging_sign",
    "blocks/poplar_log",
    "blocks/poplar_planks",
    "blocks/poplar_pressure_plate",
    "blocks/poplar_sapling",
    "blocks/poplar_shelf",
    "blocks/poplar_sign",
    "blocks/poplar_slab",
    "blocks/poplar_stairs",
    "blocks/poplar_trapdoor",
    "blocks/poplar_wood",
    "blocks/poppy",
    "blocks/potatoes",
    "blocks/potent_sulfur",
    "blocks/potted_acacia_sapling",
    "blocks/potted_allium",
    "blocks/potted_azalea_bush",
    "blocks/potted_azure_bluet",
    "blocks/potted_bamboo",
    "blocks/potted_birch_sapling",
    "blocks/potted_blue_orchid",
    "blocks/potted_brown_mushroom",
    "blocks/potted_cactus",
    "blocks/potted_cherry_sapling",
    "blocks/potted_closed_eyeblossom",
    "blocks/potted_cornflower",
    "blocks/potted_crimson_fungus",
    "blocks/potted_crimson_roots",
    "blocks/potted_dandelion",
    "blocks/potted_dark_oak_sapling",
    "blocks/potted_dead_bush",
    "blocks/potted_fern",
    "blocks/potted_flowering_azalea_bush",
    "blocks/potted_golden_dandelion",
    "blocks/potted_jungle_sapling",
    "blocks/potted_lily_of_the_valley",
    "blocks/potted_mangrove_propagule",
    "blocks/potted_oak_sapling",
    "blocks/potted_open_eyeblossom",
    "blocks/potted_orange_tulip",
    "blocks/potted_oxeye_daisy",
    "blocks/potted_pale_oak_sapling",
    "blocks/potted_pink_tulip",
    "blocks/potted_poplar_sapling",
    "blocks/potted_poppy",
    "blocks/potted_red_mushroom",
    "blocks/potted_red_tulip",
    "blocks/potted_spruce_sapling",
    "blocks/potted_torchflower",
    "blocks/potted_warped_fungus",
    "blocks/potted_warped_roots",
    "blocks/potted_white_tulip",
    "blocks/potted_wither_rose",
    "blocks/powder_snow",
    "blocks/powder_snow_cauldron",
    "blocks/powered_rail",
    "blocks/prismarine",
    "blocks/prismarine_brick_slab",
    "blocks/prismarine_brick_stairs",
    "blocks/prismarine_bricks",
    "blocks/prismarine_slab",
    "blocks/prismarine_stairs",
    "blocks/prismarine_wall",
    "blocks/pumpkin",
    "blocks/pumpkin_stem",
    "blocks/purple_banner",
    "blocks/purple_bed",
    "blocks/purple_candle",
    "blocks/purple_candle_cake",
    "blocks/purple_carpet",
    "blocks/purple_concrete",
    "blocks/purple_concrete_powder",
    "blocks/purple_concrete_slab",
    "blocks/purple_concrete_stairs",
    "blocks/purple_glazed_terracotta",
    "blocks/purple_shulker_box",
    "blocks/purple_stained_glass",
    "blocks/purple_stained_glass_pane",
    "blocks/purple_terracotta",
    "blocks/purple_wool",
    "blocks/purple_wool_slab",
    "blocks/purple_wool_stairs",
    "blocks/purpur_block",
    "blocks/purpur_pillar",
    "blocks/purpur_slab",
    "blocks/purpur_stairs",
    "blocks/quartz_block",
    "blocks/quartz_bricks",
    "blocks/quartz_pillar",
    "blocks/quartz_slab",
    "blocks/quartz_stairs",
    "blocks/rail",
    "blocks/raw_copper_block",
    "blocks/raw_gold_block",
    "blocks/raw_iron_block",
    "blocks/red_banner",
    "blocks/red_bed",
    "blocks/red_candle",
    "blocks/red_candle_cake",
    "blocks/red_carpet",
    "blocks/red_concrete",
    "blocks/red_concrete_powder",
    "blocks/red_concrete_slab",
    "blocks/red_concrete_stairs",
    "blocks/red_glazed_terracotta",
    "blocks/red_mushroom",
    "blocks/red_mushroom_block",
    "blocks/red_nether_brick_slab",
    "blocks/red_nether_brick_stairs",
    "blocks/red_nether_brick_wall",
    "blocks/red_nether_bricks",
    "blocks/red_poplar_leaves",
    "blocks/red_sand",
    "blocks/red_sandstone",
    "blocks/red_sandstone_slab",
    "blocks/red_sandstone_stairs",
    "blocks/red_sandstone_wall",
    "blocks/red_shrub",
    "blocks/red_shulker_box",
    "blocks/red_stained_glass",
    "blocks/red_stained_glass_pane",
    "blocks/red_terracotta",
    "blocks/red_tulip",
    "blocks/red_wool",
    "blocks/red_wool_slab",
    "blocks/red_wool_stairs",
    "blocks/redstone_block",
    "blocks/redstone_lamp",
    "blocks/redstone_ore",
    "blocks/redstone_torch",
    "blocks/redstone_wire",
    "blocks/reinforced_deepslate",
    "blocks/repeater",
    "blocks/resin_block",
    "blocks/resin_brick_slab",
    "blocks/resin_brick_stairs",
    "blocks/resin_brick_wall",
    "blocks/resin_bricks",
    "blocks/resin_clump",
    "blocks/respawn_anchor",
    "blocks/rooted_dirt",
    "blocks/rose_bush",
    "blocks/sand",
    "blocks/sandstone",
    "blocks/sandstone_slab",
    "blocks/sandstone_stairs",
    "blocks/sandstone_wall",
    "blocks/scaffolding",
    "blocks/sculk",
    "blocks/sculk_catalyst",
    "blocks/sculk_sensor",
    "blocks/sculk_shrieker",
    "blocks/sculk_vein",
    "blocks/sea_lantern",
    "blocks/sea_pickle",
    "blocks/seagrass",
    "blocks/shelf_mushroom",
    "blocks/short_dry_grass",
    "blocks/short_grass",
    "blocks/shroomlight",
    "blocks/shulker_box",
    "blocks/skeleton_skull",
    "blocks/slime_block",
    "blocks/small_amethyst_bud",
    "blocks/small_dripleaf",
    "blocks/smithing_table",
    "blocks/smoker",
    "blocks/smooth_basalt",
    "blocks/smooth_quartz",
    "blocks/smooth_quartz_slab",
    "blocks/smooth_quartz_stairs",
    "blocks/smooth_red_sandstone",
    "blocks/smooth_red_sandstone_slab",
    "blocks/smooth_red_sandstone_stairs",
    "blocks/smooth_sandstone",
    "blocks/smooth_sandstone_slab",
    "blocks/smooth_sandstone_stairs",
    "blocks/smooth_stone",
    "blocks/smooth_stone_slab",
    "blocks/sniffer_egg",
    "blocks/snow",
    "blocks/snow_block",
    "blocks/soul_campfire",
    "blocks/soul_fire",
    "blocks/soul_lantern",
    "blocks/soul_sand",
    "blocks/soul_soil",
    "blocks/soul_torch",
    "blocks/spawner",
    "blocks/sponge",
    "blocks/spore_blossom",
    "blocks/spruce_button",
    "blocks/spruce_door",
    "blocks/spruce_fence",
    "blocks/spruce_fence_gate",
    "blocks/spruce_hanging_sign",
    "blocks/spruce_leaves",
    "blocks/spruce_log",
    "blocks/spruce_planks",
    "blocks/spruce_pressure_plate",
    "blocks/spruce_sapling",
    "blocks/spruce_shelf",
    "blocks/spruce_sign",
    "blocks/spruce_slab",
    "blocks/spruce_stairs",
    "blocks/spruce_trapdoor",
    "blocks/spruce_wood",
    "blocks/sticky_piston",
    "blocks/stone",
    "blocks/stone_brick_slab",
    "blocks/stone_brick_stairs",
    "blocks/stone_brick_wall",
    "blocks/stone_bricks",
    "blocks/stone_button",
    "blocks/stone_pressure_plate",
    "blocks/stone_slab",
    "blocks/stone_stairs",
    "blocks/stonecutter",
    "blocks/straw_bed",
    "blocks/stripped_acacia_log",
    "blocks/stripped_acacia_wood",
    "blocks/stripped_bamboo_block",
    "blocks/stripped_birch_log",
    "blocks/stripped_birch_wood",
    "blocks/stripped_cherry_log",
    "blocks/stripped_cherry_wood",
    "blocks/stripped_crimson_hyphae",
    "blocks/stripped_crimson_stem",
    "blocks/stripped_dark_oak_log",
    "blocks/stripped_dark_oak_wood",
    "blocks/stripped_jungle_log",
    "blocks/stripped_jungle_wood",
    "blocks/stripped_mangrove_log",
    "blocks/stripped_mangrove_wood",
    "blocks/stripped_oak_log",
    "blocks/stripped_oak_wood",
    "blocks/stripped_pale_oak_log",
    "blocks/stripped_pale_oak_wood",
    "blocks/stripped_poplar_log",
    "blocks/stripped_poplar_wood",
    "blocks/stripped_spruce_log",
    "blocks/stripped_spruce_wood",
    "blocks/stripped_warped_hyphae",
    "blocks/stripped_warped_stem",
    "blocks/sugar_cane",
    "blocks/sulfur",
    "blocks/sulfur_brick_slab",
    "blocks/sulfur_brick_stairs",
    "blocks/sulfur_brick_wall",
    "blocks/sulfur_bricks",
    "blocks/sulfur_slab",
    "blocks/sulfur_spike",
    "blocks/sulfur_stairs",
    "blocks/sulfur_wall",
    "blocks/sunflower",
    "blocks/suspicious_gravel",
    "blocks/suspicious_sand",
    "blocks/sweet_berry_bush",
    "blocks/tall_dry_grass",
    "blocks/tall_grass",
    "blocks/tall_seagrass",
    "blocks/target",
    "blocks/terracotta",
    "blocks/tinted_glass",
    "blocks/tnt",
    "blocks/torch",
    "blocks/torchflower",
    "blocks/torchflower_crop",
    "blocks/trapped_chest",
    "blocks/trial_spawner",
    "blocks/tripwire",
    "blocks/tripwire_hook",
    "blocks/tube_coral",
    "blocks/tube_coral_block",
    "blocks/tube_coral_fan",
    "blocks/tuff",
    "blocks/tuff_brick_slab",
    "blocks/tuff_brick_stairs",
    "blocks/tuff_brick_wall",
    "blocks/tuff_bricks",
    "blocks/tuff_slab",
    "blocks/tuff_stairs",
    "blocks/tuff_wall",
    "blocks/turtle_egg",
    "blocks/twisting_vines",
    "blocks/twisting_vines_plant",
    "blocks/vault",
    "blocks/verdant_froglight",
    "blocks/vine",
    "blocks/warped_button",
    "blocks/warped_door",
    "blocks/warped_fence",
    "blocks/warped_fence_gate",
    "blocks/warped_fungus",
    "blocks/warped_hanging_sign",
    "blocks/warped_hyphae",
    "blocks/warped_nylium",
    "blocks/warped_planks",
    "blocks/warped_pressure_plate",
    "blocks/warped_roots",
    "blocks/warped_shelf",
    "blocks/warped_sign",
    "blocks/warped_slab",
    "blocks/warped_stairs",
    "blocks/warped_stem",
    "blocks/warped_trapdoor",
    "blocks/warped_wart_block",
    "blocks/water_cauldron",
    "blocks/waxed_chiseled_copper",
    "blocks/waxed_copper_bars",
    "blocks/waxed_copper_block",
    "blocks/waxed_copper_bulb",
    "blocks/waxed_copper_chain",
    "blocks/waxed_copper_chest",
    "blocks/waxed_copper_door",
    "blocks/waxed_copper_golem_statue",
    "blocks/waxed_copper_grate",
    "blocks/waxed_copper_lantern",
    "blocks/waxed_copper_trapdoor",
    "blocks/waxed_cut_copper",
    "blocks/waxed_cut_copper_slab",
    "blocks/waxed_cut_copper_stairs",
    "blocks/waxed_exposed_chiseled_copper",
    "blocks/waxed_exposed_copper",
    "blocks/waxed_exposed_copper_bars",
    "blocks/waxed_exposed_copper_bulb",
    "blocks/waxed_exposed_copper_chain",
    "blocks/waxed_exposed_copper_chest",
    "blocks/waxed_exposed_copper_door",
    "blocks/waxed_exposed_copper_golem_statue",
    "blocks/waxed_exposed_copper_grate",
    "blocks/waxed_exposed_copper_lantern",
    "blocks/waxed_exposed_copper_trapdoor",
    "blocks/waxed_exposed_cut_copper",
    "blocks/waxed_exposed_cut_copper_slab",
    "blocks/waxed_exposed_cut_copper_stairs",
    "blocks/waxed_exposed_lightning_rod",
    "blocks/waxed_lightning_rod",
    "blocks/waxed_oxidized_chiseled_copper",
    "blocks/waxed_oxidized_copper",
    "blocks/waxed_oxidized_copper_bars",
    "blocks/waxed_oxidized_copper_bulb",
    "blocks/waxed_oxidized_copper_chain",
    "blocks/waxed_oxidized_copper_chest",
    "blocks/waxed_oxidized_copper_door",
    "blocks/waxed_oxidized_copper_golem_statue",
    "blocks/waxed_oxidized_copper_grate",
    "blocks/waxed_oxidized_copper_lantern",
    "blocks/waxed_oxidized_copper_trapdoor",
    "blocks/waxed_oxidized_cut_copper",
    "blocks/waxed_oxidized_cut_copper_slab",
    "blocks/waxed_oxidized_cut_copper_stairs",
    "blocks/waxed_oxidized_lightning_rod",
    "blocks/waxed_weathered_chiseled_copper",
    "blocks/waxed_weathered_copper",
    "blocks/waxed_weathered_copper_bars",
    "blocks/waxed_weathered_copper_bulb",
    "blocks/waxed_weathered_copper_chain",
    "blocks/waxed_weathered_copper_chest",
    "blocks/waxed_weathered_copper_door",
    "blocks/waxed_weathered_copper_golem_statue",
    "blocks/waxed_weathered_copper_grate",
    "blocks/waxed_weathered_copper_lantern",
    "blocks/waxed_weathered_copper_trapdoor",
    "blocks/waxed_weathered_cut_copper",
    "blocks/waxed_weathered_cut_copper_slab",
    "blocks/waxed_weathered_cut_copper_stairs",
    "blocks/waxed_weathered_lightning_rod",
    "blocks/weathered_chiseled_copper",
    "blocks/weathered_copper",
    "blocks/weathered_copper_bars",
    "blocks/weathered_copper_bulb",
    "blocks/weathered_copper_chain",
    "blocks/weathered_copper_chest",
    "blocks/weathered_copper_door",
    "blocks/weathered_copper_golem_statue",
    "blocks/weathered_copper_grate",
    "blocks/weathered_copper_lantern",
    "blocks/weathered_copper_trapdoor",
    "blocks/weathered_cut_copper",
    "blocks/weathered_cut_copper_slab",
    "blocks/weathered_cut_copper_stairs",
    "blocks/weathered_lightning_rod",
    "blocks/weeping_vines",
    "blocks/weeping_vines_plant",
    "blocks/wet_sponge",
    "blocks/wheat",
    "blocks/white_banner",
    "blocks/white_bed",
    "blocks/white_candle",
    "blocks/white_candle_cake",
    "blocks/white_carpet",
    "blocks/white_concrete",
    "blocks/white_concrete_powder",
    "blocks/white_concrete_slab",
    "blocks/white_concrete_stairs",
    "blocks/white_glazed_terracotta",
    "blocks/white_shulker_box",
    "blocks/white_stained_glass",
    "blocks/white_stained_glass_pane",
    "blocks/white_terracotta",
    "blocks/white_tulip",
    "blocks/white_wool",
    "blocks/white_wool_slab",
    "blocks/white_wool_stairs",
    "blocks/wildflowers",
    "blocks/wither_rose",
    "blocks/wither_skeleton_skull",
    "blocks/yellow_banner",
    "blocks/yellow_bed",
    "blocks/yellow_candle",
    "blocks/yellow_candle_cake",
    "blocks/yellow_carpet",
    "blocks/yellow_concrete",
    "blocks/yellow_concrete_powder",
    "blocks/yellow_concrete_slab",
    "blocks/yellow_concrete_stairs",
    "blocks/yellow_glazed_terracotta",
    "blocks/yellow_poplar_leaves",
    "blocks/yellow_shulker_box",
    "blocks/yellow_stained_glass",
    "blocks/yellow_stained_glass_pane",
    "blocks/yellow_terracotta",
    "blocks/yellow_wool",
    "blocks/yellow_wool_slab",
    "blocks/yellow_wool_stairs",
    "blocks/zombie_head",
    "brush/armadillo",
    "carve/pumpkin",
    "charged_creeper/creeper",
    "charged_creeper/piglin",
    "charged_creeper/root",
    "charged_creeper/skeleton",
    "charged_creeper/wither_skeleton",
    "charged_creeper/zombie",
    "chests/abandoned_camp_common_chest",
    "chests/abandoned_camp_secret_chest",
    "chests/abandoned_mineshaft",
    "chests/ancient_city",
    "chests/ancient_city_ice_box",
    "chests/bastion_bridge",
    "chests/bastion_hoglin_stable",
    "chests/bastion_other",
    "chests/bastion_treasure",
    "chests/buried_treasure",
    "chests/desert_pyramid",
    "chests/end_city_treasure",
    "chests/igloo_chest",
    "chests/jungle_temple",
    "chests/jungle_temple_dispenser",
    "chests/nether_bridge",
    "chests/pillager_outpost",
    "chests/ruined_portal",
    "chests/shipwreck_map",
    "chests/shipwreck_supply",
    "chests/shipwreck_treasure",
    "chests/simple_dungeon",
    "chests/spawn_bonus_chest",
    "chests/stronghold_corridor",
    "chests/stronghold_crossing",
    "chests/stronghold_library",
    "chests/trial_chambers/corridor",
    "chests/trial_chambers/entrance",
    "chests/trial_chambers/intersection",
    "chests/trial_chambers/intersection_barrel",
    "chests/trial_chambers/reward",
    "chests/trial_chambers/reward_common",
    "chests/trial_chambers/reward_ominous",
    "chests/trial_chambers/reward_ominous_common",
    "chests/trial_chambers/reward_ominous_rare",
    "chests/trial_chambers/reward_ominous_unique",
    "chests/trial_chambers/reward_rare",
    "chests/trial_chambers/reward_unique",
    "chests/trial_chambers/supply",
    "chests/underwater_ruin_big",
    "chests/underwater_ruin_small",
    "chests/village/village_armorer",
    "chests/village/village_butcher",
    "chests/village/village_cartographer",
    "chests/village/village_desert_house",
    "chests/village/village_fisher",
    "chests/village/village_fletcher",
    "chests/village/village_mason",
    "chests/village/village_plains_house",
    "chests/village/village_savanna_house",
    "chests/village/village_shepherd",
    "chests/village/village_snowy_house",
    "chests/village/village_taiga_house",
    "chests/village/village_tannery",
    "chests/village/village_temple",
    "chests/village/village_toolsmith",
    "chests/village/village_weaponsmith",
    "chests/woodland_mansion",
    "dispensers/trial_chambers/chamber",
    "dispensers/trial_chambers/corridor",
    "dispensers/trial_chambers/water",
    "entities/allay",
    "entities/armadillo",
    "entities/armor_stand",
    "entities/axolotl",
    "entities/bat",
    "entities/bee",
    "entities/blaze",
    "entities/bogged",
    "entities/breeze",
    "entities/camel",
    "entities/camel_husk",
    "entities/cat",
    "entities/cave_spider",
    "entities/chicken",
    "entities/cod",
    "entities/copper_golem",
    "entities/cow",
    "entities/creaking",
    "entities/creeper",
    "entities/dolphin",
    "entities/donkey",
    "entities/drowned",
    "entities/elder_guardian",
    "entities/ender_dragon",
    "entities/enderman",
    "entities/endermite",
    "entities/evoker",
    "entities/fox",
    "entities/frog",
    "entities/ghast",
    "entities/giant",
    "entities/glow_squid",
    "entities/goat",
    "entities/guardian",
    "entities/happy_ghast",
    "entities/hoglin",
    "entities/horse",
    "entities/husk",
    "entities/illusioner",
    "entities/iron_golem",
    "entities/llama",
    "entities/magma_cube",
    "entities/mannequin",
    "entities/mooshroom",
    "entities/mule",
    "entities/nautilus",
    "entities/ocelot",
    "entities/panda",
    "entities/parched",
    "entities/parrot",
    "entities/phantom",
    "entities/pig",
    "entities/piglin",
    "entities/piglin_brute",
    "entities/pillager",
    "entities/player",
    "entities/polar_bear",
    "entities/pufferfish",
    "entities/rabbit",
    "entities/ravager",
    "entities/salmon",
    "entities/sheep",
    "entities/sheep/black",
    "entities/sheep/blue",
    "entities/sheep/brown",
    "entities/sheep/cyan",
    "entities/sheep/gray",
    "entities/sheep/green",
    "entities/sheep/light_blue",
    "entities/sheep/light_gray",
    "entities/sheep/lime",
    "entities/sheep/magenta",
    "entities/sheep/orange",
    "entities/sheep/pink",
    "entities/sheep/purple",
    "entities/sheep/red",
    "entities/sheep/white",
    "entities/sheep/yellow",
    "entities/shulker",
    "entities/silverfish",
    "entities/skeleton",
    "entities/skeleton_horse",
    "entities/slime",
    "entities/sniffer",
    "entities/snow_golem",
    "entities/spider",
    "entities/squid",
    "entities/stray",
    "entities/strider",
    "entities/sulfur_cube",
    "entities/tadpole",
    "entities/trader_llama",
    "entities/tropical_fish",
    "entities/turtle",
    "entities/vex",
    "entities/villager",
    "entities/vindicator",
    "entities/wandering_trader",
    "entities/warden",
    "entities/witch",
    "entities/wither",
    "entities/wither_skeleton",
    "entities/wolf",
    "entities/zoglin",
    "entities/zombie",
    "entities/zombie_horse",
    "entities/zombie_nautilus",
    "entities/zombie_villager",
    "entities/zombified_piglin",
    "equipment/trial_chamber",
    "equipment/trial_chamber_melee",
    "equipment/trial_chamber_ranged",
    "gameplay/armadillo_shed",
    "gameplay/cat_morning_gift",
    "gameplay/chicken_lay",
    "gameplay/fishing",
    "gameplay/fishing/fish",
    "gameplay/fishing/junk",
    "gameplay/fishing/treasure",
    "gameplay/hero_of_the_village/armorer_gift",
    "gameplay/hero_of_the_village/baby_gift",
    "gameplay/hero_of_the_village/butcher_gift",
    "gameplay/hero_of_the_village/cartographer_gift",
    "gameplay/hero_of_the_village/cleric_gift",
    "gameplay/hero_of_the_village/farmer_gift",
    "gameplay/hero_of_the_village/fisherman_gift",
    "gameplay/hero_of_the_village/fletcher_gift",
    "gameplay/hero_of_the_village/leatherworker_gift",
    "gameplay/hero_of_the_village/librarian_gift",
    "gameplay/hero_of_the_village/mason_gift",
    "gameplay/hero_of_the_village/shepherd_gift",
    "gameplay/hero_of_the_village/toolsmith_gift",
    "gameplay/hero_of_the_village/unemployed_gift",
    "gameplay/hero_of_the_village/weaponsmith_gift",
    "gameplay/panda_sneeze",
    "gameplay/piglin_bartering",
    "gameplay/sniffer_digging",
    "gameplay/turtle_grow",
    "harvest/beehive",
    "harvest/cave_vine",
    "harvest/sweet_berry_bush",
    "pots/trial_chambers/corridor",
    "shearing/bogged",
    "shearing/mooshroom",
    "shearing/mooshroom/brown",
    "shearing/mooshroom/red",
    "shearing/sheep",
    "shearing/sheep/black",
    "shearing/sheep/blue",
    "shearing/sheep/brown",
    "shearing/sheep/cyan",
    "shearing/sheep/gray",
    "shearing/sheep/green",
    "shearing/sheep/light_blue",
    "shearing/sheep/light_gray",
    "shearing/sheep/lime",
    "shearing/sheep/magenta",
    "shearing/sheep/orange",
    "shearing/sheep/pink",
    "shearing/sheep/purple",
    "shearing/sheep/red",
    "shearing/sheep/white",
    "shearing/sheep/yellow",
    "shearing/snow_golem",
    "spawners/ominous/trial_chamber/consumables",
    "spawners/ominous/trial_chamber/key",
    "spawners/trial_chamber/consumables",
    "spawners/trial_chamber/items_to_drop_when_ominous",
    "spawners/trial_chamber/key",
    "till/rooted_dirt"
  ]);
});

// src/arguments/generated/_registry/number_providers.ts
var NUMBER_PROVIDERS_SET;
var init_number_providers = __esm(() => {
  init_sandstone();
  NUMBER_PROVIDERS_SET = new Set2([
    "brewing/speed_default",
    "brewing/uses_default",
    "compostable/always_add_one",
    "compostable/low",
    "compostable/low_medium",
    "compostable/medium",
    "compostable/medium_high",
    "cooking/speed_default",
    "cooking/time_bamboo",
    "cooking/time_blaze_rod",
    "cooking/time_boats",
    "cooking/time_coal",
    "cooking/time_coal_block",
    "cooking/time_dried_kelp_block",
    "cooking/time_dry_plants",
    "cooking/time_hanging_signs",
    "cooking/time_lava_bucket",
    "cooking/time_roots",
    "cooking/time_wood_blocks",
    "cooking/time_wood_items_extra_small",
    "cooking/time_wood_items_large",
    "cooking/time_wood_items_small",
    "cooking/time_wood_slabs",
    "cooking/time_wool",
    "cooking/time_wool_carpets",
    "cooking/time_wool_slabs"
  ]);
});

// src/arguments/generated/_registry/painting_variants.ts
var PAINTING_VARIANTS_SET;
var init_painting_variants = __esm(() => {
  init_sandstone();
  PAINTING_VARIANTS_SET = new Set2([
    "alban",
    "aztec",
    "aztec2",
    "backyard",
    "baroque",
    "bomb",
    "bouquet",
    "burning_skull",
    "bust",
    "cavebird",
    "changing",
    "cotan",
    "courbet",
    "creebet",
    "dennis",
    "donkey_kong",
    "earth",
    "endboss",
    "fern",
    "fighters",
    "finding",
    "fire",
    "graham",
    "humble",
    "kebab",
    "lowmist",
    "match",
    "meditative",
    "orb",
    "owlemons",
    "passage",
    "pigscene",
    "plant",
    "pointer",
    "pond",
    "pool",
    "prairie_ride",
    "sea",
    "skeleton",
    "skull_and_roses",
    "stage",
    "sunflowers",
    "sunset",
    "tides",
    "unpacked",
    "void",
    "wanderer",
    "wasteland",
    "water",
    "wind",
    "wither"
  ]);
});

// src/arguments/generated/_registry/pig_sound_variants.ts
var PIG_SOUND_VARIANTS_SET;
var init_pig_sound_variants = __esm(() => {
  init_sandstone();
  PIG_SOUND_VARIANTS_SET = new Set2([
    "big",
    "classic",
    "mini"
  ]);
});

// src/arguments/generated/_registry/pig_variants.ts
var PIG_VARIANTS_SET;
var init_pig_variants = __esm(() => {
  init_sandstone();
  PIG_VARIANTS_SET = new Set2([
    "cold",
    "temperate",
    "warm"
  ]);
});

// src/arguments/generated/_registry/predicates.ts
var PREDICATES_SET;
var init_predicates = __esm(() => {
  init_sandstone();
  PREDICATES_SET = new Set2([
    "block/fast_cooking",
    "tool/can_shear",
    "tool/can_silk_touch"
  ]);
});

// src/arguments/generated/_registry/recipes.ts
var RECIPES_SET;
var init_recipes = __esm(() => {
  init_sandstone();
  RECIPES_SET = new Set2([
    "acacia_boat",
    "acacia_button",
    "acacia_chest_boat",
    "acacia_door",
    "acacia_fence",
    "acacia_fence_gate",
    "acacia_hanging_sign",
    "acacia_planks",
    "acacia_pressure_plate",
    "acacia_shelf",
    "acacia_sign",
    "acacia_slab",
    "acacia_stairs",
    "acacia_trapdoor",
    "acacia_wood",
    "activator_rail",
    "amethyst_block",
    "andesite",
    "andesite_slab",
    "andesite_slab_from_andesite_stonecutting",
    "andesite_stairs",
    "andesite_stairs_from_andesite_stonecutting",
    "andesite_wall",
    "andesite_wall_from_andesite_stonecutting",
    "anvil",
    "armor_stand",
    "arrow",
    "baked_potato",
    "baked_potato_from_campfire_cooking",
    "baked_potato_from_smoking",
    "bamboo_block",
    "bamboo_button",
    "bamboo_chest_raft",
    "bamboo_door",
    "bamboo_fence",
    "bamboo_fence_gate",
    "bamboo_hanging_sign",
    "bamboo_mosaic",
    "bamboo_mosaic_slab",
    "bamboo_mosaic_stairs",
    "bamboo_planks",
    "bamboo_pressure_plate",
    "bamboo_raft",
    "bamboo_shelf",
    "bamboo_sign",
    "bamboo_slab",
    "bamboo_stairs",
    "bamboo_trapdoor",
    "barrel",
    "beacon",
    "beehive",
    "beetroot_soup",
    "birch_boat",
    "birch_button",
    "birch_chest_boat",
    "birch_door",
    "birch_fence",
    "birch_fence_gate",
    "birch_hanging_sign",
    "birch_planks",
    "birch_pressure_plate",
    "birch_shelf",
    "birch_sign",
    "birch_slab",
    "birch_stairs",
    "birch_trapdoor",
    "birch_wood",
    "black_banner",
    "black_banner_duplicate",
    "black_bed",
    "black_bundle",
    "black_candle",
    "black_carpet",
    "black_concrete_powder",
    "black_concrete_slab",
    "black_concrete_stairs",
    "black_cushion",
    "black_dye",
    "black_dye_from_wither_rose",
    "black_glazed_terracotta",
    "black_harness",
    "black_shulker_box",
    "black_stained_glass",
    "black_stained_glass_pane",
    "black_stained_glass_pane_from_glass_pane",
    "black_terracotta",
    "black_wool_slab",
    "black_wool_stairs",
    "blackstone_slab",
    "blackstone_slab_from_blackstone_stonecutting",
    "blackstone_stairs",
    "blackstone_stairs_from_blackstone_stonecutting",
    "blackstone_wall",
    "blackstone_wall_from_blackstone_stonecutting",
    "blast_furnace",
    "blaze_powder",
    "blue_banner",
    "blue_banner_duplicate",
    "blue_bed",
    "blue_bundle",
    "blue_candle",
    "blue_carpet",
    "blue_concrete_powder",
    "blue_concrete_slab",
    "blue_concrete_stairs",
    "blue_cushion",
    "blue_dye",
    "blue_dye_from_cornflower",
    "blue_glazed_terracotta",
    "blue_harness",
    "blue_ice",
    "blue_shulker_box",
    "blue_stained_glass",
    "blue_stained_glass_pane",
    "blue_stained_glass_pane_from_glass_pane",
    "blue_terracotta",
    "blue_wool_slab",
    "blue_wool_stairs",
    "bolt_armor_trim_smithing_template",
    "bolt_armor_trim_smithing_template_smithing_trim",
    "bone_block",
    "bone_meal",
    "bone_meal_from_bone_block",
    "book",
    "book_cloning",
    "bookshelf",
    "bordure_indented_banner_pattern",
    "bow",
    "bowl",
    "bread",
    "brewing/lingering_potion_awkward_blaze_powder",
    "brewing/lingering_potion_awkward_breeze_rod",
    "brewing/lingering_potion_awkward_cobweb",
    "brewing/lingering_potion_awkward_ghast_tear",
    "brewing/lingering_potion_awkward_glistering_melon_slice",
    "brewing/lingering_potion_awkward_golden_carrot",
    "brewing/lingering_potion_awkward_magma_cream",
    "brewing/lingering_potion_awkward_phantom_membrane",
    "brewing/lingering_potion_awkward_pufferfish",
    "brewing/lingering_potion_awkward_rabbit_foot",
    "brewing/lingering_potion_awkward_slime_block",
    "brewing/lingering_potion_awkward_spider_eye",
    "brewing/lingering_potion_awkward_stone",
    "brewing/lingering_potion_awkward_sugar",
    "brewing/lingering_potion_awkward_turtle_helmet",
    "brewing/lingering_potion_fire_resistance_redstone",
    "brewing/lingering_potion_harming_glowstone_dust",
    "brewing/lingering_potion_healing_fermented_spider_eye",
    "brewing/lingering_potion_healing_glowstone_dust",
    "brewing/lingering_potion_invisibility_redstone",
    "brewing/lingering_potion_leaping_fermented_spider_eye",
    "brewing/lingering_potion_leaping_glowstone_dust",
    "brewing/lingering_potion_leaping_redstone",
    "brewing/lingering_potion_long_leaping_fermented_spider_eye",
    "brewing/lingering_potion_long_night_vision_fermented_spider_eye",
    "brewing/lingering_potion_long_poison_fermented_spider_eye",
    "brewing/lingering_potion_long_swiftness_fermented_spider_eye",
    "brewing/lingering_potion_night_vision_fermented_spider_eye",
    "brewing/lingering_potion_night_vision_redstone",
    "brewing/lingering_potion_poison_fermented_spider_eye",
    "brewing/lingering_potion_poison_glowstone_dust",
    "brewing/lingering_potion_poison_redstone",
    "brewing/lingering_potion_regeneration_glowstone_dust",
    "brewing/lingering_potion_regeneration_redstone",
    "brewing/lingering_potion_slow_falling_redstone",
    "brewing/lingering_potion_slowness_glowstone_dust",
    "brewing/lingering_potion_slowness_redstone",
    "brewing/lingering_potion_strength_glowstone_dust",
    "brewing/lingering_potion_strength_redstone",
    "brewing/lingering_potion_strong_healing_fermented_spider_eye",
    "brewing/lingering_potion_strong_poison_fermented_spider_eye",
    "brewing/lingering_potion_swiftness_fermented_spider_eye",
    "brewing/lingering_potion_swiftness_glowstone_dust",
    "brewing/lingering_potion_swiftness_redstone",
    "brewing/lingering_potion_turtle_master_glowstone_dust",
    "brewing/lingering_potion_turtle_master_redstone",
    "brewing/lingering_potion_water_blaze_powder",
    "brewing/lingering_potion_water_breathing_redstone",
    "brewing/lingering_potion_water_breeze_rod",
    "brewing/lingering_potion_water_cobweb",
    "brewing/lingering_potion_water_fermented_spider_eye",
    "brewing/lingering_potion_water_ghast_tear",
    "brewing/lingering_potion_water_glistering_melon_slice",
    "brewing/lingering_potion_water_glowstone_dust",
    "brewing/lingering_potion_water_magma_cream",
    "brewing/lingering_potion_water_nether_wart",
    "brewing/lingering_potion_water_rabbit_foot",
    "brewing/lingering_potion_water_redstone",
    "brewing/lingering_potion_water_slime_block",
    "brewing/lingering_potion_water_spider_eye",
    "brewing/lingering_potion_water_stone",
    "brewing/lingering_potion_water_sugar",
    "brewing/lingering_potion_weakness_redstone",
    "brewing/potion_awkward_blaze_powder",
    "brewing/potion_awkward_breeze_rod",
    "brewing/potion_awkward_cobweb",
    "brewing/potion_awkward_ghast_tear",
    "brewing/potion_awkward_glistering_melon_slice",
    "brewing/potion_awkward_golden_carrot",
    "brewing/potion_awkward_gunpowder",
    "brewing/potion_awkward_magma_cream",
    "brewing/potion_awkward_phantom_membrane",
    "brewing/potion_awkward_pufferfish",
    "brewing/potion_awkward_rabbit_foot",
    "brewing/potion_awkward_slime_block",
    "brewing/potion_awkward_spider_eye",
    "brewing/potion_awkward_stone",
    "brewing/potion_awkward_sugar",
    "brewing/potion_awkward_turtle_helmet",
    "brewing/potion_fire_resistance_gunpowder",
    "brewing/potion_fire_resistance_redstone",
    "brewing/potion_harming_glowstone_dust",
    "brewing/potion_harming_gunpowder",
    "brewing/potion_healing_fermented_spider_eye",
    "brewing/potion_healing_glowstone_dust",
    "brewing/potion_healing_gunpowder",
    "brewing/potion_infested_gunpowder",
    "brewing/potion_invisibility_gunpowder",
    "brewing/potion_invisibility_redstone",
    "brewing/potion_leaping_fermented_spider_eye",
    "brewing/potion_leaping_glowstone_dust",
    "brewing/potion_leaping_gunpowder",
    "brewing/potion_leaping_redstone",
    "brewing/potion_long_fire_resistance_gunpowder",
    "brewing/potion_long_invisibility_gunpowder",
    "brewing/potion_long_leaping_fermented_spider_eye",
    "brewing/potion_long_leaping_gunpowder",
    "brewing/potion_long_night_vision_fermented_spider_eye",
    "brewing/potion_long_night_vision_gunpowder",
    "brewing/potion_long_poison_fermented_spider_eye",
    "brewing/potion_long_poison_gunpowder",
    "brewing/potion_long_regeneration_gunpowder",
    "brewing/potion_long_slow_falling_gunpowder",
    "brewing/potion_long_slowness_gunpowder",
    "brewing/potion_long_strength_gunpowder",
    "brewing/potion_long_swiftness_fermented_spider_eye",
    "brewing/potion_long_swiftness_gunpowder",
    "brewing/potion_long_turtle_master_gunpowder",
    "brewing/potion_long_water_breathing_gunpowder",
    "brewing/potion_long_weakness_gunpowder",
    "brewing/potion_mundane_gunpowder",
    "brewing/potion_night_vision_fermented_spider_eye",
    "brewing/potion_night_vision_gunpowder",
    "brewing/potion_night_vision_redstone",
    "brewing/potion_oozing_gunpowder",
    "brewing/potion_poison_fermented_spider_eye",
    "brewing/potion_poison_glowstone_dust",
    "brewing/potion_poison_gunpowder",
    "brewing/potion_poison_redstone",
    "brewing/potion_regeneration_glowstone_dust",
    "brewing/potion_regeneration_gunpowder",
    "brewing/potion_regeneration_redstone",
    "brewing/potion_slow_falling_gunpowder",
    "brewing/potion_slow_falling_redstone",
    "brewing/potion_slowness_glowstone_dust",
    "brewing/potion_slowness_gunpowder",
    "brewing/potion_slowness_redstone",
    "brewing/potion_strength_glowstone_dust",
    "brewing/potion_strength_gunpowder",
    "brewing/potion_strength_redstone",
    "brewing/potion_strong_harming_gunpowder",
    "brewing/potion_strong_healing_fermented_spider_eye",
    "brewing/potion_strong_healing_gunpowder",
    "brewing/potion_strong_leaping_gunpowder",
    "brewing/potion_strong_poison_fermented_spider_eye",
    "brewing/potion_strong_poison_gunpowder",
    "brewing/potion_strong_regeneration_gunpowder",
    "brewing/potion_strong_slowness_gunpowder",
    "brewing/potion_strong_strength_gunpowder",
    "brewing/potion_strong_swiftness_gunpowder",
    "brewing/potion_strong_turtle_master_gunpowder",
    "brewing/potion_swiftness_fermented_spider_eye",
    "brewing/potion_swiftness_glowstone_dust",
    "brewing/potion_swiftness_gunpowder",
    "brewing/potion_swiftness_redstone",
    "brewing/potion_thick_gunpowder",
    "brewing/potion_turtle_master_glowstone_dust",
    "brewing/potion_turtle_master_gunpowder",
    "brewing/potion_turtle_master_redstone",
    "brewing/potion_water_blaze_powder",
    "brewing/potion_water_breathing_gunpowder",
    "brewing/potion_water_breathing_redstone",
    "brewing/potion_water_breeze_rod",
    "brewing/potion_water_cobweb",
    "brewing/potion_water_fermented_spider_eye",
    "brewing/potion_water_ghast_tear",
    "brewing/potion_water_glistering_melon_slice",
    "brewing/potion_water_glowstone_dust",
    "brewing/potion_water_gunpowder",
    "brewing/potion_water_magma_cream",
    "brewing/potion_water_nether_wart",
    "brewing/potion_water_rabbit_foot",
    "brewing/potion_water_redstone",
    "brewing/potion_water_slime_block",
    "brewing/potion_water_spider_eye",
    "brewing/potion_water_stone",
    "brewing/potion_water_sugar",
    "brewing/potion_weakness_gunpowder",
    "brewing/potion_weakness_redstone",
    "brewing/potion_weaving_gunpowder",
    "brewing/potion_wind_charged_gunpowder",
    "brewing/splash_potion_awkward_blaze_powder",
    "brewing/splash_potion_awkward_breeze_rod",
    "brewing/splash_potion_awkward_cobweb",
    "brewing/splash_potion_awkward_dragon_breath",
    "brewing/splash_potion_awkward_ghast_tear",
    "brewing/splash_potion_awkward_glistering_melon_slice",
    "brewing/splash_potion_awkward_golden_carrot",
    "brewing/splash_potion_awkward_magma_cream",
    "brewing/splash_potion_awkward_phantom_membrane",
    "brewing/splash_potion_awkward_pufferfish",
    "brewing/splash_potion_awkward_rabbit_foot",
    "brewing/splash_potion_awkward_slime_block",
    "brewing/splash_potion_awkward_spider_eye",
    "brewing/splash_potion_awkward_stone",
    "brewing/splash_potion_awkward_sugar",
    "brewing/splash_potion_awkward_turtle_helmet",
    "brewing/splash_potion_fire_resistance_dragon_breath",
    "brewing/splash_potion_fire_resistance_redstone",
    "brewing/splash_potion_harming_dragon_breath",
    "brewing/splash_potion_harming_glowstone_dust",
    "brewing/splash_potion_healing_dragon_breath",
    "brewing/splash_potion_healing_fermented_spider_eye",
    "brewing/splash_potion_healing_glowstone_dust",
    "brewing/splash_potion_infested_dragon_breath",
    "brewing/splash_potion_invisibility_dragon_breath",
    "brewing/splash_potion_invisibility_redstone",
    "brewing/splash_potion_leaping_dragon_breath",
    "brewing/splash_potion_leaping_fermented_spider_eye",
    "brewing/splash_potion_leaping_glowstone_dust",
    "brewing/splash_potion_leaping_redstone",
    "brewing/splash_potion_long_fire_resistance_dragon_breath",
    "brewing/splash_potion_long_invisibility_dragon_breath",
    "brewing/splash_potion_long_leaping_dragon_breath",
    "brewing/splash_potion_long_leaping_fermented_spider_eye",
    "brewing/splash_potion_long_night_vision_dragon_breath",
    "brewing/splash_potion_long_night_vision_fermented_spider_eye",
    "brewing/splash_potion_long_poison_dragon_breath",
    "brewing/splash_potion_long_poison_fermented_spider_eye",
    "brewing/splash_potion_long_regeneration_dragon_breath",
    "brewing/splash_potion_long_slow_falling_dragon_breath",
    "brewing/splash_potion_long_slowness_dragon_breath",
    "brewing/splash_potion_long_strength_dragon_breath",
    "brewing/splash_potion_long_swiftness_dragon_breath",
    "brewing/splash_potion_long_swiftness_fermented_spider_eye",
    "brewing/splash_potion_long_turtle_master_dragon_breath",
    "brewing/splash_potion_long_water_breathing_dragon_breath",
    "brewing/splash_potion_long_weakness_dragon_breath",
    "brewing/splash_potion_mundane_dragon_breath",
    "brewing/splash_potion_night_vision_dragon_breath",
    "brewing/splash_potion_night_vision_fermented_spider_eye",
    "brewing/splash_potion_night_vision_redstone",
    "brewing/splash_potion_oozing_dragon_breath",
    "brewing/splash_potion_poison_dragon_breath",
    "brewing/splash_potion_poison_fermented_spider_eye",
    "brewing/splash_potion_poison_glowstone_dust",
    "brewing/splash_potion_poison_redstone",
    "brewing/splash_potion_regeneration_dragon_breath",
    "brewing/splash_potion_regeneration_glowstone_dust",
    "brewing/splash_potion_regeneration_redstone",
    "brewing/splash_potion_slow_falling_dragon_breath",
    "brewing/splash_potion_slow_falling_redstone",
    "brewing/splash_potion_slowness_dragon_breath",
    "brewing/splash_potion_slowness_glowstone_dust",
    "brewing/splash_potion_slowness_redstone",
    "brewing/splash_potion_strength_dragon_breath",
    "brewing/splash_potion_strength_glowstone_dust",
    "brewing/splash_potion_strength_redstone",
    "brewing/splash_potion_strong_harming_dragon_breath",
    "brewing/splash_potion_strong_healing_dragon_breath",
    "brewing/splash_potion_strong_healing_fermented_spider_eye",
    "brewing/splash_potion_strong_leaping_dragon_breath",
    "brewing/splash_potion_strong_poison_dragon_breath",
    "brewing/splash_potion_strong_poison_fermented_spider_eye",
    "brewing/splash_potion_strong_regeneration_dragon_breath",
    "brewing/splash_potion_strong_slowness_dragon_breath",
    "brewing/splash_potion_strong_strength_dragon_breath",
    "brewing/splash_potion_strong_swiftness_dragon_breath",
    "brewing/splash_potion_strong_turtle_master_dragon_breath",
    "brewing/splash_potion_swiftness_dragon_breath",
    "brewing/splash_potion_swiftness_fermented_spider_eye",
    "brewing/splash_potion_swiftness_glowstone_dust",
    "brewing/splash_potion_swiftness_redstone",
    "brewing/splash_potion_thick_dragon_breath",
    "brewing/splash_potion_turtle_master_dragon_breath",
    "brewing/splash_potion_turtle_master_glowstone_dust",
    "brewing/splash_potion_turtle_master_redstone",
    "brewing/splash_potion_water_blaze_powder",
    "brewing/splash_potion_water_breathing_dragon_breath",
    "brewing/splash_potion_water_breathing_redstone",
    "brewing/splash_potion_water_breeze_rod",
    "brewing/splash_potion_water_cobweb",
    "brewing/splash_potion_water_dragon_breath",
    "brewing/splash_potion_water_fermented_spider_eye",
    "brewing/splash_potion_water_ghast_tear",
    "brewing/splash_potion_water_glistering_melon_slice",
    "brewing/splash_potion_water_glowstone_dust",
    "brewing/splash_potion_water_magma_cream",
    "brewing/splash_potion_water_nether_wart",
    "brewing/splash_potion_water_rabbit_foot",
    "brewing/splash_potion_water_redstone",
    "brewing/splash_potion_water_slime_block",
    "brewing/splash_potion_water_spider_eye",
    "brewing/splash_potion_water_stone",
    "brewing/splash_potion_water_sugar",
    "brewing/splash_potion_weakness_dragon_breath",
    "brewing/splash_potion_weakness_redstone",
    "brewing/splash_potion_weaving_dragon_breath",
    "brewing/splash_potion_wind_charged_dragon_breath",
    "brewing_stand",
    "brick",
    "brick_slab",
    "brick_slab_from_bricks_stonecutting",
    "brick_stairs",
    "brick_stairs_from_bricks_stonecutting",
    "brick_wall",
    "brick_wall_from_bricks_stonecutting",
    "bricks",
    "brown_banner",
    "brown_banner_duplicate",
    "brown_bed",
    "brown_bundle",
    "brown_candle",
    "brown_carpet",
    "brown_concrete_powder",
    "brown_concrete_slab",
    "brown_concrete_stairs",
    "brown_cushion",
    "brown_dye",
    "brown_glazed_terracotta",
    "brown_harness",
    "brown_shulker_box",
    "brown_stained_glass",
    "brown_stained_glass_pane",
    "brown_stained_glass_pane_from_glass_pane",
    "brown_terracotta",
    "brown_wool_slab",
    "brown_wool_stairs",
    "brush",
    "bucket",
    "bundle",
    "cake",
    "calibrated_sculk_sensor",
    "campfire",
    "candle",
    "carrot_on_a_stick",
    "cartography_table",
    "cauldron",
    "charcoal",
    "cherry_boat",
    "cherry_button",
    "cherry_chest_boat",
    "cherry_door",
    "cherry_fence",
    "cherry_fence_gate",
    "cherry_hanging_sign",
    "cherry_planks",
    "cherry_pressure_plate",
    "cherry_shelf",
    "cherry_sign",
    "cherry_slab",
    "cherry_stairs",
    "cherry_trapdoor",
    "cherry_wood",
    "chest",
    "chest_minecart",
    "chiseled_bookshelf",
    "chiseled_cinnabar",
    "chiseled_cinnabar_from_cinnabar_stonecutting",
    "chiseled_copper",
    "chiseled_copper_from_copper_block_stonecutting",
    "chiseled_copper_from_cut_copper_stonecutting",
    "chiseled_deepslate",
    "chiseled_deepslate_from_cobbled_deepslate_stonecutting",
    "chiseled_deepslate_from_deepslate_stonecutting",
    "chiseled_nether_bricks",
    "chiseled_nether_bricks_from_nether_bricks_stonecutting",
    "chiseled_polished_blackstone",
    "chiseled_polished_blackstone_from_blackstone_stonecutting",
    "chiseled_polished_blackstone_from_polished_blackstone_stonecutting",
    "chiseled_quartz_block",
    "chiseled_quartz_block_from_quartz_block_stonecutting",
    "chiseled_red_sandstone",
    "chiseled_red_sandstone_from_red_sandstone_stonecutting",
    "chiseled_resin_bricks",
    "chiseled_resin_bricks_from_resin_bricks_stonecutting",
    "chiseled_sandstone",
    "chiseled_sandstone_from_sandstone_stonecutting",
    "chiseled_stone_bricks",
    "chiseled_stone_bricks_from_stone_bricks_stonecutting",
    "chiseled_stone_bricks_from_stone_stonecutting",
    "chiseled_sulfur",
    "chiseled_sulfur_from_sulfur_stonecutting",
    "chiseled_tuff",
    "chiseled_tuff_bricks",
    "chiseled_tuff_bricks_from_polished_tuff_stonecutting",
    "chiseled_tuff_bricks_from_tuff_bricks_stonecutting",
    "chiseled_tuff_bricks_from_tuff_stonecutting",
    "chiseled_tuff_from_tuff_stonecutting",
    "cinnabar_brick_slab",
    "cinnabar_brick_slab_from_cinnabar_bricks_stonecutting",
    "cinnabar_brick_slab_from_cinnabar_stonecutting",
    "cinnabar_brick_slab_from_polished_cinnabar_stonecutting",
    "cinnabar_brick_stairs",
    "cinnabar_brick_stairs_from_cinnabar_bricks_stonecutting",
    "cinnabar_brick_stairs_from_cinnabar_stonecutting",
    "cinnabar_brick_stairs_from_polished_cinnabar_stonecutting",
    "cinnabar_brick_wall",
    "cinnabar_brick_wall_from_cinnabar_bricks_stonecutting",
    "cinnabar_brick_wall_from_cinnabar_stonecutting",
    "cinnabar_brick_wall_from_polished_cinnabar_stonecutting",
    "cinnabar_bricks",
    "cinnabar_bricks_from_cinnabar_stonecutting",
    "cinnabar_bricks_from_polished_cinnabar_stonecutting",
    "cinnabar_slab",
    "cinnabar_slab_from_cinnabar_stonecutting",
    "cinnabar_stairs",
    "cinnabar_stairs_from_cinnabar_stonecutting",
    "cinnabar_wall",
    "cinnabar_wall_from_cinnabar_stonecutting",
    "clay",
    "clock",
    "coal",
    "coal_block",
    "coal_from_blasting_coal_ore",
    "coal_from_blasting_deepslate_coal_ore",
    "coal_from_smelting_coal_ore",
    "coal_from_smelting_deepslate_coal_ore",
    "coarse_dirt",
    "coast_armor_trim_smithing_template",
    "coast_armor_trim_smithing_template_smithing_trim",
    "cobbled_deepslate_from_deepslate_stonecutting",
    "cobbled_deepslate_slab",
    "cobbled_deepslate_slab_from_cobbled_deepslate_stonecutting",
    "cobbled_deepslate_slab_from_deepslate_stonecutting",
    "cobbled_deepslate_stairs",
    "cobbled_deepslate_stairs_from_cobbled_deepslate_stonecutting",
    "cobbled_deepslate_stairs_from_deepslate_stonecutting",
    "cobbled_deepslate_wall",
    "cobbled_deepslate_wall_from_cobbled_deepslate_stonecutting",
    "cobbled_deepslate_wall_from_deepslate_stonecutting",
    "cobblestone_from_stone_stonecutting",
    "cobblestone_slab",
    "cobblestone_slab_from_cobblestone_stonecutting",
    "cobblestone_slab_from_stone_stonecutting",
    "cobblestone_stairs",
    "cobblestone_stairs_from_cobblestone_stonecutting",
    "cobblestone_stairs_from_stone_stonecutting",
    "cobblestone_wall",
    "cobblestone_wall_from_cobblestone_stonecutting",
    "cobblestone_wall_from_stone_stonecutting",
    "comparator",
    "compass",
    "composter",
    "conduit",
    "cooked_beef",
    "cooked_beef_from_campfire_cooking",
    "cooked_beef_from_smoking",
    "cooked_chicken",
    "cooked_chicken_from_campfire_cooking",
    "cooked_chicken_from_smoking",
    "cooked_cod",
    "cooked_cod_from_campfire_cooking",
    "cooked_cod_from_smoking",
    "cooked_mutton",
    "cooked_mutton_from_campfire_cooking",
    "cooked_mutton_from_smoking",
    "cooked_porkchop",
    "cooked_porkchop_from_campfire_cooking",
    "cooked_porkchop_from_smoking",
    "cooked_rabbit",
    "cooked_rabbit_from_campfire_cooking",
    "cooked_rabbit_from_smoking",
    "cooked_salmon",
    "cooked_salmon_from_campfire_cooking",
    "cooked_salmon_from_smoking",
    "cookie",
    "copper_axe",
    "copper_bars",
    "copper_block",
    "copper_boots",
    "copper_bulb",
    "copper_chain",
    "copper_chest",
    "copper_chestplate",
    "copper_door",
    "copper_grate",
    "copper_grate_from_copper_block_stonecutting",
    "copper_helmet",
    "copper_hoe",
    "copper_ingot",
    "copper_ingot_from_blasting_copper_ore",
    "copper_ingot_from_blasting_deepslate_copper_ore",
    "copper_ingot_from_blasting_raw_copper",
    "copper_ingot_from_nuggets",
    "copper_ingot_from_smelting_copper_ore",
    "copper_ingot_from_smelting_deepslate_copper_ore",
    "copper_ingot_from_smelting_raw_copper",
    "copper_ingot_from_waxed_copper_block",
    "copper_lantern",
    "copper_leggings",
    "copper_nugget",
    "copper_nugget_from_blasting",
    "copper_nugget_from_smelting",
    "copper_pickaxe",
    "copper_shovel",
    "copper_spear",
    "copper_sword",
    "copper_torch",
    "copper_trapdoor",
    "cracked_deepslate_bricks",
    "cracked_deepslate_tiles",
    "cracked_nether_bricks",
    "cracked_polished_blackstone_bricks",
    "cracked_stone_bricks",
    "crafter",
    "crafting_table",
    "creaking_heart",
    "creeper_banner_pattern",
    "crimson_button",
    "crimson_door",
    "crimson_fence",
    "crimson_fence_gate",
    "crimson_hanging_sign",
    "crimson_hyphae",
    "crimson_planks",
    "crimson_pressure_plate",
    "crimson_shelf",
    "crimson_sign",
    "crimson_slab",
    "crimson_stairs",
    "crimson_trapdoor",
    "crossbow",
    "cut_copper",
    "cut_copper_from_copper_block_stonecutting",
    "cut_copper_slab",
    "cut_copper_slab_from_copper_block_stonecutting",
    "cut_copper_slab_from_cut_copper_stonecutting",
    "cut_copper_stairs",
    "cut_copper_stairs_from_copper_block_stonecutting",
    "cut_copper_stairs_from_cut_copper_stonecutting",
    "cut_red_sandstone",
    "cut_red_sandstone_from_red_sandstone_stonecutting",
    "cut_red_sandstone_slab",
    "cut_red_sandstone_slab_from_cut_red_sandstone_stonecutting",
    "cut_red_sandstone_slab_from_red_sandstone_stonecutting",
    "cut_sandstone",
    "cut_sandstone_from_sandstone_stonecutting",
    "cut_sandstone_slab",
    "cut_sandstone_slab_from_cut_sandstone_stonecutting",
    "cut_sandstone_slab_from_sandstone_stonecutting",
    "cyan_banner",
    "cyan_banner_duplicate",
    "cyan_bed",
    "cyan_bundle",
    "cyan_candle",
    "cyan_carpet",
    "cyan_concrete_powder",
    "cyan_concrete_slab",
    "cyan_concrete_stairs",
    "cyan_cushion",
    "cyan_dye",
    "cyan_dye_from_pitcher_plant",
    "cyan_glazed_terracotta",
    "cyan_harness",
    "cyan_shulker_box",
    "cyan_stained_glass",
    "cyan_stained_glass_pane",
    "cyan_stained_glass_pane_from_glass_pane",
    "cyan_terracotta",
    "cyan_wool_slab",
    "cyan_wool_stairs",
    "dark_oak_boat",
    "dark_oak_button",
    "dark_oak_chest_boat",
    "dark_oak_door",
    "dark_oak_fence",
    "dark_oak_fence_gate",
    "dark_oak_hanging_sign",
    "dark_oak_planks",
    "dark_oak_pressure_plate",
    "dark_oak_shelf",
    "dark_oak_sign",
    "dark_oak_slab",
    "dark_oak_stairs",
    "dark_oak_trapdoor",
    "dark_oak_wood",
    "dark_prismarine",
    "dark_prismarine_slab",
    "dark_prismarine_slab_from_dark_prismarine_stonecutting",
    "dark_prismarine_stairs",
    "dark_prismarine_stairs_from_dark_prismarine_stonecutting",
    "daylight_detector",
    "decorated_pot",
    "decorated_pot_simple",
    "deepslate",
    "deepslate_brick_slab",
    "deepslate_brick_slab_from_cobbled_deepslate_stonecutting",
    "deepslate_brick_slab_from_deepslate_bricks_stonecutting",
    "deepslate_brick_slab_from_deepslate_stonecutting",
    "deepslate_brick_slab_from_polished_deepslate_stonecutting",
    "deepslate_brick_stairs",
    "deepslate_brick_stairs_from_cobbled_deepslate_stonecutting",
    "deepslate_brick_stairs_from_deepslate_bricks_stonecutting",
    "deepslate_brick_stairs_from_deepslate_stonecutting",
    "deepslate_brick_stairs_from_polished_deepslate_stonecutting",
    "deepslate_brick_wall",
    "deepslate_brick_wall_from_cobbled_deepslate_stonecutting",
    "deepslate_brick_wall_from_deepslate_bricks_stonecutting",
    "deepslate_brick_wall_from_deepslate_stonecutting",
    "deepslate_brick_wall_from_polished_deepslate_stonecutting",
    "deepslate_bricks",
    "deepslate_bricks_from_cobbled_deepslate_stonecutting",
    "deepslate_bricks_from_deepslate_stonecutting",
    "deepslate_bricks_from_polished_deepslate_stonecutting",
    "deepslate_tile_slab",
    "deepslate_tile_slab_from_cobbled_deepslate_stonecutting",
    "deepslate_tile_slab_from_deepslate_bricks_stonecutting",
    "deepslate_tile_slab_from_deepslate_stonecutting",
    "deepslate_tile_slab_from_deepslate_tiles_stonecutting",
    "deepslate_tile_slab_from_polished_deepslate_stonecutting",
    "deepslate_tile_stairs",
    "deepslate_tile_stairs_from_cobbled_deepslate_stonecutting",
    "deepslate_tile_stairs_from_deepslate_bricks_stonecutting",
    "deepslate_tile_stairs_from_deepslate_stonecutting",
    "deepslate_tile_stairs_from_deepslate_tiles_stonecutting",
    "deepslate_tile_stairs_from_polished_deepslate_stonecutting",
    "deepslate_tile_wall",
    "deepslate_tile_wall_from_cobbled_deepslate_stonecutting",
    "deepslate_tile_wall_from_deepslate_bricks_stonecutting",
    "deepslate_tile_wall_from_deepslate_stonecutting",
    "deepslate_tile_wall_from_deepslate_tiles_stonecutting",
    "deepslate_tile_wall_from_polished_deepslate_stonecutting",
    "deepslate_tiles",
    "deepslate_tiles_from_cobbled_deepslate_stonecutting",
    "deepslate_tiles_from_deepslate_bricks_stonecutting",
    "deepslate_tiles_from_deepslate_stonecutting",
    "deepslate_tiles_from_polished_deepslate_stonecutting",
    "detector_rail",
    "diamond",
    "diamond_axe",
    "diamond_block",
    "diamond_boots",
    "diamond_chestplate",
    "diamond_from_blasting_deepslate_diamond_ore",
    "diamond_from_blasting_diamond_ore",
    "diamond_from_smelting_deepslate_diamond_ore",
    "diamond_from_smelting_diamond_ore",
    "diamond_helmet",
    "diamond_hoe",
    "diamond_leggings",
    "diamond_pickaxe",
    "diamond_shovel",
    "diamond_spear",
    "diamond_sword",
    "diorite",
    "diorite_slab",
    "diorite_slab_from_diorite_stonecutting",
    "diorite_stairs",
    "diorite_stairs_from_diorite_stonecutting",
    "diorite_wall",
    "diorite_wall_from_diorite_stonecutting",
    "dispenser",
    "dried_ghast",
    "dried_kelp",
    "dried_kelp_block",
    "dried_kelp_from_campfire_cooking",
    "dried_kelp_from_smelting",
    "dried_kelp_from_smoking",
    "dripstone_block",
    "dropper",
    "dune_armor_trim_smithing_template",
    "dune_armor_trim_smithing_template_smithing_trim",
    "dye_black_bed",
    "dye_black_carpet",
    "dye_black_cushion",
    "dye_black_harness",
    "dye_black_wool",
    "dye_black_wool_slab",
    "dye_black_wool_stairs",
    "dye_blue_bed",
    "dye_blue_carpet",
    "dye_blue_cushion",
    "dye_blue_harness",
    "dye_blue_wool",
    "dye_blue_wool_slab",
    "dye_blue_wool_stairs",
    "dye_brown_bed",
    "dye_brown_carpet",
    "dye_brown_cushion",
    "dye_brown_harness",
    "dye_brown_wool",
    "dye_brown_wool_slab",
    "dye_brown_wool_stairs",
    "dye_cyan_bed",
    "dye_cyan_carpet",
    "dye_cyan_cushion",
    "dye_cyan_harness",
    "dye_cyan_wool",
    "dye_cyan_wool_slab",
    "dye_cyan_wool_stairs",
    "dye_gray_bed",
    "dye_gray_carpet",
    "dye_gray_cushion",
    "dye_gray_harness",
    "dye_gray_wool",
    "dye_gray_wool_slab",
    "dye_gray_wool_stairs",
    "dye_green_bed",
    "dye_green_carpet",
    "dye_green_cushion",
    "dye_green_harness",
    "dye_green_wool",
    "dye_green_wool_slab",
    "dye_green_wool_stairs",
    "dye_light_blue_bed",
    "dye_light_blue_carpet",
    "dye_light_blue_cushion",
    "dye_light_blue_harness",
    "dye_light_blue_wool",
    "dye_light_blue_wool_slab",
    "dye_light_blue_wool_stairs",
    "dye_light_gray_bed",
    "dye_light_gray_carpet",
    "dye_light_gray_cushion",
    "dye_light_gray_harness",
    "dye_light_gray_wool",
    "dye_light_gray_wool_slab",
    "dye_light_gray_wool_stairs",
    "dye_lime_bed",
    "dye_lime_carpet",
    "dye_lime_cushion",
    "dye_lime_harness",
    "dye_lime_wool",
    "dye_lime_wool_slab",
    "dye_lime_wool_stairs",
    "dye_magenta_bed",
    "dye_magenta_carpet",
    "dye_magenta_cushion",
    "dye_magenta_harness",
    "dye_magenta_wool",
    "dye_magenta_wool_slab",
    "dye_magenta_wool_stairs",
    "dye_orange_bed",
    "dye_orange_carpet",
    "dye_orange_cushion",
    "dye_orange_harness",
    "dye_orange_wool",
    "dye_orange_wool_slab",
    "dye_orange_wool_stairs",
    "dye_pink_bed",
    "dye_pink_carpet",
    "dye_pink_cushion",
    "dye_pink_harness",
    "dye_pink_wool",
    "dye_pink_wool_slab",
    "dye_pink_wool_stairs",
    "dye_purple_bed",
    "dye_purple_carpet",
    "dye_purple_cushion",
    "dye_purple_harness",
    "dye_purple_wool",
    "dye_purple_wool_slab",
    "dye_purple_wool_stairs",
    "dye_red_bed",
    "dye_red_carpet",
    "dye_red_cushion",
    "dye_red_harness",
    "dye_red_wool",
    "dye_red_wool_slab",
    "dye_red_wool_stairs",
    "dye_white_bed",
    "dye_white_carpet",
    "dye_white_cushion",
    "dye_white_harness",
    "dye_white_wool",
    "dye_white_wool_slab",
    "dye_white_wool_stairs",
    "dye_yellow_bed",
    "dye_yellow_carpet",
    "dye_yellow_cushion",
    "dye_yellow_harness",
    "dye_yellow_wool",
    "dye_yellow_wool_slab",
    "dye_yellow_wool_stairs",
    "emerald",
    "emerald_block",
    "emerald_from_blasting_deepslate_emerald_ore",
    "emerald_from_blasting_emerald_ore",
    "emerald_from_smelting_deepslate_emerald_ore",
    "emerald_from_smelting_emerald_ore",
    "enchanting_table",
    "end_crystal",
    "end_rod",
    "end_stone_brick_slab",
    "end_stone_brick_slab_from_end_stone_bricks_stonecutting",
    "end_stone_brick_slab_from_end_stone_stonecutting",
    "end_stone_brick_stairs",
    "end_stone_brick_stairs_from_end_stone_bricks_stonecutting",
    "end_stone_brick_stairs_from_end_stone_stonecutting",
    "end_stone_brick_wall",
    "end_stone_brick_wall_from_end_stone_bricks_stonecutting",
    "end_stone_brick_wall_from_end_stone_stonecutting",
    "end_stone_bricks",
    "end_stone_bricks_from_end_stone_stonecutting",
    "ender_chest",
    "ender_eye",
    "exposed_chiseled_copper",
    "exposed_chiseled_copper_from_exposed_copper_stonecutting",
    "exposed_chiseled_copper_from_exposed_cut_copper_stonecutting",
    "exposed_copper_bulb",
    "exposed_copper_grate",
    "exposed_copper_grate_from_exposed_copper_stonecutting",
    "exposed_cut_copper",
    "exposed_cut_copper_from_exposed_copper_stonecutting",
    "exposed_cut_copper_slab",
    "exposed_cut_copper_slab_from_exposed_copper_stonecutting",
    "exposed_cut_copper_slab_from_exposed_cut_copper_stonecutting",
    "exposed_cut_copper_stairs",
    "exposed_cut_copper_stairs_from_exposed_copper_stonecutting",
    "exposed_cut_copper_stairs_from_exposed_cut_copper_stonecutting",
    "eye_armor_trim_smithing_template",
    "eye_armor_trim_smithing_template_smithing_trim",
    "fermented_spider_eye",
    "field_masoned_banner_pattern",
    "fire_charge",
    "firework_rocket",
    "firework_rocket_simple",
    "firework_star",
    "firework_star_fade",
    "fishing_rod",
    "fletching_table",
    "flint_and_steel",
    "flow_armor_trim_smithing_template",
    "flow_armor_trim_smithing_template_smithing_trim",
    "flower_banner_pattern",
    "flower_pot",
    "furnace",
    "furnace_minecart",
    "glass",
    "glass_bottle",
    "glass_pane",
    "glistering_melon_slice",
    "glow_item_frame",
    "glowstone",
    "gold_block",
    "gold_ingot_from_blasting_deepslate_gold_ore",
    "gold_ingot_from_blasting_gold_ore",
    "gold_ingot_from_blasting_nether_gold_ore",
    "gold_ingot_from_blasting_raw_gold",
    "gold_ingot_from_gold_block",
    "gold_ingot_from_nuggets",
    "gold_ingot_from_smelting_deepslate_gold_ore",
    "gold_ingot_from_smelting_gold_ore",
    "gold_ingot_from_smelting_nether_gold_ore",
    "gold_ingot_from_smelting_raw_gold",
    "gold_nugget",
    "gold_nugget_from_blasting",
    "gold_nugget_from_smelting",
    "golden_apple",
    "golden_axe",
    "golden_boots",
    "golden_carrot",
    "golden_chestplate",
    "golden_dandelion",
    "golden_helmet",
    "golden_hoe",
    "golden_leggings",
    "golden_pickaxe",
    "golden_shovel",
    "golden_spear",
    "golden_sword",
    "granite",
    "granite_slab",
    "granite_slab_from_granite_stonecutting",
    "granite_stairs",
    "granite_stairs_from_granite_stonecutting",
    "granite_wall",
    "granite_wall_from_granite_stonecutting",
    "gray_banner",
    "gray_banner_duplicate",
    "gray_bed",
    "gray_bundle",
    "gray_candle",
    "gray_carpet",
    "gray_concrete_powder",
    "gray_concrete_slab",
    "gray_concrete_stairs",
    "gray_cushion",
    "gray_dye",
    "gray_dye_from_closed_eyeblossom",
    "gray_glazed_terracotta",
    "gray_harness",
    "gray_shulker_box",
    "gray_stained_glass",
    "gray_stained_glass_pane",
    "gray_stained_glass_pane_from_glass_pane",
    "gray_terracotta",
    "gray_wool_slab",
    "gray_wool_stairs",
    "green_banner",
    "green_banner_duplicate",
    "green_bed",
    "green_bundle",
    "green_candle",
    "green_carpet",
    "green_concrete_powder",
    "green_concrete_slab",
    "green_concrete_stairs",
    "green_cushion",
    "green_dye",
    "green_glazed_terracotta",
    "green_harness",
    "green_shulker_box",
    "green_stained_glass",
    "green_stained_glass_pane",
    "green_stained_glass_pane_from_glass_pane",
    "green_terracotta",
    "green_wool_slab",
    "green_wool_stairs",
    "grindstone",
    "hay_block",
    "heavy_weighted_pressure_plate",
    "honey_block",
    "honey_bottle",
    "honeycomb_block",
    "hopper",
    "hopper_minecart",
    "host_armor_trim_smithing_template",
    "host_armor_trim_smithing_template_smithing_trim",
    "iron_axe",
    "iron_bars",
    "iron_block",
    "iron_boots",
    "iron_chain",
    "iron_chestplate",
    "iron_door",
    "iron_helmet",
    "iron_hoe",
    "iron_ingot_from_blasting_deepslate_iron_ore",
    "iron_ingot_from_blasting_iron_ore",
    "iron_ingot_from_blasting_raw_iron",
    "iron_ingot_from_iron_block",
    "iron_ingot_from_nuggets",
    "iron_ingot_from_smelting_deepslate_iron_ore",
    "iron_ingot_from_smelting_iron_ore",
    "iron_ingot_from_smelting_raw_iron",
    "iron_leggings",
    "iron_nugget",
    "iron_nugget_from_blasting",
    "iron_nugget_from_smelting",
    "iron_pickaxe",
    "iron_shovel",
    "iron_spear",
    "iron_sword",
    "iron_trapdoor",
    "item_frame",
    "jack_o_lantern",
    "jukebox",
    "jungle_boat",
    "jungle_button",
    "jungle_chest_boat",
    "jungle_door",
    "jungle_fence",
    "jungle_fence_gate",
    "jungle_hanging_sign",
    "jungle_planks",
    "jungle_pressure_plate",
    "jungle_shelf",
    "jungle_sign",
    "jungle_slab",
    "jungle_stairs",
    "jungle_trapdoor",
    "jungle_wood",
    "ladder",
    "lantern",
    "lapis_block",
    "lapis_lazuli",
    "lapis_lazuli_from_blasting_deepslate_lapis_ore",
    "lapis_lazuli_from_blasting_lapis_ore",
    "lapis_lazuli_from_smelting_deepslate_lapis_ore",
    "lapis_lazuli_from_smelting_lapis_ore",
    "lead",
    "leaf_litter",
    "leather",
    "leather_boots",
    "leather_boots_dyed",
    "leather_chestplate",
    "leather_chestplate_dyed",
    "leather_helmet",
    "leather_helmet_dyed",
    "leather_horse_armor",
    "leather_horse_armor_dyed",
    "leather_leggings",
    "leather_leggings_dyed",
    "lectern",
    "lever",
    "light_blue_banner",
    "light_blue_banner_duplicate",
    "light_blue_bed",
    "light_blue_bundle",
    "light_blue_candle",
    "light_blue_carpet",
    "light_blue_concrete_powder",
    "light_blue_concrete_slab",
    "light_blue_concrete_stairs",
    "light_blue_cushion",
    "light_blue_dye_from_blue_orchid",
    "light_blue_dye_from_blue_white_dye",
    "light_blue_glazed_terracotta",
    "light_blue_harness",
    "light_blue_shulker_box",
    "light_blue_stained_glass",
    "light_blue_stained_glass_pane",
    "light_blue_stained_glass_pane_from_glass_pane",
    "light_blue_terracotta",
    "light_blue_wool_slab",
    "light_blue_wool_stairs",
    "light_gray_banner",
    "light_gray_banner_duplicate",
    "light_gray_bed",
    "light_gray_bundle",
    "light_gray_candle",
    "light_gray_carpet",
    "light_gray_concrete_powder",
    "light_gray_concrete_slab",
    "light_gray_concrete_stairs",
    "light_gray_cushion",
    "light_gray_dye_from_azure_bluet",
    "light_gray_dye_from_black_white_dye",
    "light_gray_dye_from_gray_white_dye",
    "light_gray_dye_from_oxeye_daisy",
    "light_gray_dye_from_white_tulip",
    "light_gray_glazed_terracotta",
    "light_gray_harness",
    "light_gray_shulker_box",
    "light_gray_stained_glass",
    "light_gray_stained_glass_pane",
    "light_gray_stained_glass_pane_from_glass_pane",
    "light_gray_terracotta",
    "light_gray_wool_slab",
    "light_gray_wool_stairs",
    "light_weighted_pressure_plate",
    "lightning_rod",
    "lime_banner",
    "lime_banner_duplicate",
    "lime_bed",
    "lime_bundle",
    "lime_candle",
    "lime_carpet",
    "lime_concrete_powder",
    "lime_concrete_slab",
    "lime_concrete_stairs",
    "lime_cushion",
    "lime_dye",
    "lime_dye_from_smelting",
    "lime_glazed_terracotta",
    "lime_harness",
    "lime_shulker_box",
    "lime_stained_glass",
    "lime_stained_glass_pane",
    "lime_stained_glass_pane_from_glass_pane",
    "lime_terracotta",
    "lime_wool_slab",
    "lime_wool_stairs",
    "lodestone",
    "loom",
    "mace",
    "magenta_banner",
    "magenta_banner_duplicate",
    "magenta_bed",
    "magenta_bundle",
    "magenta_candle",
    "magenta_carpet",
    "magenta_concrete_powder",
    "magenta_concrete_slab",
    "magenta_concrete_stairs",
    "magenta_cushion",
    "magenta_dye_from_allium",
    "magenta_dye_from_blue_red_pink",
    "magenta_dye_from_blue_red_white_dye",
    "magenta_dye_from_lilac",
    "magenta_dye_from_purple_and_pink",
    "magenta_glazed_terracotta",
    "magenta_harness",
    "magenta_shulker_box",
    "magenta_stained_glass",
    "magenta_stained_glass_pane",
    "magenta_stained_glass_pane_from_glass_pane",
    "magenta_terracotta",
    "magenta_wool_slab",
    "magenta_wool_stairs",
    "magma_block",
    "magma_cream",
    "mangrove_boat",
    "mangrove_button",
    "mangrove_chest_boat",
    "mangrove_door",
    "mangrove_fence",
    "mangrove_fence_gate",
    "mangrove_hanging_sign",
    "mangrove_planks",
    "mangrove_pressure_plate",
    "mangrove_shelf",
    "mangrove_sign",
    "mangrove_slab",
    "mangrove_stairs",
    "mangrove_trapdoor",
    "mangrove_wood",
    "map",
    "map_cloning",
    "map_extending",
    "melon",
    "melon_seeds",
    "minecart",
    "mojang_banner_pattern",
    "moss_carpet",
    "mossy_cobblestone_from_moss_block",
    "mossy_cobblestone_from_vine",
    "mossy_cobblestone_slab",
    "mossy_cobblestone_slab_from_mossy_cobblestone_stonecutting",
    "mossy_cobblestone_stairs",
    "mossy_cobblestone_stairs_from_mossy_cobblestone_stonecutting",
    "mossy_cobblestone_wall",
    "mossy_cobblestone_wall_from_mossy_cobblestone_stonecutting",
    "mossy_stone_brick_slab",
    "mossy_stone_brick_slab_from_mossy_stone_bricks_stonecutting",
    "mossy_stone_brick_stairs",
    "mossy_stone_brick_stairs_from_mossy_stone_bricks_stonecutting",
    "mossy_stone_brick_wall",
    "mossy_stone_brick_wall_from_mossy_stone_bricks_stonecutting",
    "mossy_stone_bricks_from_moss_block",
    "mossy_stone_bricks_from_vine",
    "mud_brick_slab",
    "mud_brick_slab_from_mud_bricks_stonecutting",
    "mud_brick_stairs",
    "mud_brick_stairs_from_mud_bricks_stonecutting",
    "mud_brick_wall",
    "mud_brick_wall_from_mud_bricks_stonecutting",
    "mud_bricks",
    "muddy_mangrove_roots",
    "mushroom_stew",
    "music_disc_5",
    "name_tag",
    "nether_brick",
    "nether_brick_fence",
    "nether_brick_slab",
    "nether_brick_slab_from_nether_bricks_stonecutting",
    "nether_brick_stairs",
    "nether_brick_stairs_from_nether_bricks_stonecutting",
    "nether_brick_wall",
    "nether_brick_wall_from_nether_bricks_stonecutting",
    "nether_bricks",
    "nether_wart_block",
    "netherite_axe_smithing",
    "netherite_block",
    "netherite_boots_smithing",
    "netherite_chestplate_smithing",
    "netherite_helmet_smithing",
    "netherite_hoe_smithing",
    "netherite_horse_armor_smithing",
    "netherite_ingot",
    "netherite_ingot_from_netherite_block",
    "netherite_leggings_smithing",
    "netherite_nautilus_armor_smithing",
    "netherite_pickaxe_smithing",
    "netherite_scrap",
    "netherite_scrap_from_blasting",
    "netherite_shovel_smithing",
    "netherite_spear_smithing",
    "netherite_sword_smithing",
    "netherite_upgrade_smithing_template",
    "note_block",
    "oak_boat",
    "oak_button",
    "oak_chest_boat",
    "oak_door",
    "oak_fence",
    "oak_fence_gate",
    "oak_hanging_sign",
    "oak_planks",
    "oak_pressure_plate",
    "oak_shelf",
    "oak_sign",
    "oak_slab",
    "oak_stairs",
    "oak_trapdoor",
    "oak_wood",
    "observer",
    "orange_banner",
    "orange_banner_duplicate",
    "orange_bed",
    "orange_bundle",
    "orange_candle",
    "orange_carpet",
    "orange_concrete_powder",
    "orange_concrete_slab",
    "orange_concrete_stairs",
    "orange_cushion",
    "orange_dye_from_open_eyeblossom",
    "orange_dye_from_orange_tulip",
    "orange_dye_from_red_yellow",
    "orange_dye_from_torchflower",
    "orange_glazed_terracotta",
    "orange_harness",
    "orange_shulker_box",
    "orange_stained_glass",
    "orange_stained_glass_pane",
    "orange_stained_glass_pane_from_glass_pane",
    "orange_terracotta",
    "orange_wool_slab",
    "orange_wool_stairs",
    "oxidized_chiseled_copper",
    "oxidized_chiseled_copper_from_oxidized_copper_stonecutting",
    "oxidized_chiseled_copper_from_oxidized_cut_copper_stonecutting",
    "oxidized_copper_bulb",
    "oxidized_copper_grate",
    "oxidized_copper_grate_from_oxidized_copper_stonecutting",
    "oxidized_cut_copper",
    "oxidized_cut_copper_from_oxidized_copper_stonecutting",
    "oxidized_cut_copper_slab",
    "oxidized_cut_copper_slab_from_oxidized_copper_stonecutting",
    "oxidized_cut_copper_slab_from_oxidized_cut_copper_stonecutting",
    "oxidized_cut_copper_stairs",
    "oxidized_cut_copper_stairs_from_oxidized_copper_stonecutting",
    "oxidized_cut_copper_stairs_from_oxidized_cut_copper_stonecutting",
    "packed_ice",
    "packed_mud",
    "painting",
    "pale_moss_carpet",
    "pale_oak_boat",
    "pale_oak_button",
    "pale_oak_chest_boat",
    "pale_oak_door",
    "pale_oak_fence",
    "pale_oak_fence_gate",
    "pale_oak_hanging_sign",
    "pale_oak_planks",
    "pale_oak_pressure_plate",
    "pale_oak_shelf",
    "pale_oak_sign",
    "pale_oak_slab",
    "pale_oak_stairs",
    "pale_oak_trapdoor",
    "pale_oak_wood",
    "paper",
    "pink_banner",
    "pink_banner_duplicate",
    "pink_bed",
    "pink_bundle",
    "pink_candle",
    "pink_carpet",
    "pink_concrete_powder",
    "pink_concrete_slab",
    "pink_concrete_stairs",
    "pink_cushion",
    "pink_dye_from_cactus_flower",
    "pink_dye_from_peony",
    "pink_dye_from_pink_petals",
    "pink_dye_from_pink_tulip",
    "pink_dye_from_red_white_dye",
    "pink_glazed_terracotta",
    "pink_harness",
    "pink_shulker_box",
    "pink_stained_glass",
    "pink_stained_glass_pane",
    "pink_stained_glass_pane_from_glass_pane",
    "pink_terracotta",
    "pink_wool_slab",
    "pink_wool_stairs",
    "piston",
    "polished_andesite",
    "polished_andesite_from_andesite_stonecutting",
    "polished_andesite_slab",
    "polished_andesite_slab_from_andesite_stonecutting",
    "polished_andesite_slab_from_polished_andesite_stonecutting",
    "polished_andesite_stairs",
    "polished_andesite_stairs_from_andesite_stonecutting",
    "polished_andesite_stairs_from_polished_andesite_stonecutting",
    "polished_basalt",
    "polished_basalt_from_basalt_stonecutting",
    "polished_blackstone",
    "polished_blackstone_brick_slab",
    "polished_blackstone_brick_slab_from_blackstone_stonecutting",
    "polished_blackstone_brick_slab_from_polished_blackstone_bricks_stonecutting",
    "polished_blackstone_brick_slab_from_polished_blackstone_stonecutting",
    "polished_blackstone_brick_stairs",
    "polished_blackstone_brick_stairs_from_blackstone_stonecutting",
    "polished_blackstone_brick_stairs_from_polished_blackstone_bricks_stonecutting",
    "polished_blackstone_brick_stairs_from_polished_blackstone_stonecutting",
    "polished_blackstone_brick_wall",
    "polished_blackstone_brick_wall_from_blackstone_stonecutting",
    "polished_blackstone_brick_wall_from_polished_blackstone_bricks_stonecutting",
    "polished_blackstone_brick_wall_from_polished_blackstone_stonecutting",
    "polished_blackstone_bricks",
    "polished_blackstone_bricks_from_blackstone_stonecutting",
    "polished_blackstone_bricks_from_polished_blackstone_stonecutting",
    "polished_blackstone_button",
    "polished_blackstone_from_blackstone_stonecutting",
    "polished_blackstone_pressure_plate",
    "polished_blackstone_slab",
    "polished_blackstone_slab_from_blackstone_stonecutting",
    "polished_blackstone_slab_from_polished_blackstone_stonecutting",
    "polished_blackstone_stairs",
    "polished_blackstone_stairs_from_blackstone_stonecutting",
    "polished_blackstone_stairs_from_polished_blackstone_stonecutting",
    "polished_blackstone_wall",
    "polished_blackstone_wall_from_blackstone_stonecutting",
    "polished_blackstone_wall_from_polished_blackstone_stonecutting",
    "polished_cinnabar",
    "polished_cinnabar_from_cinnabar_stonecutting",
    "polished_cinnabar_slab",
    "polished_cinnabar_slab_from_cinnabar_stonecutting",
    "polished_cinnabar_slab_from_polished_cinnabar_stonecutting",
    "polished_cinnabar_stairs",
    "polished_cinnabar_stairs_from_cinnabar_stonecutting",
    "polished_cinnabar_stairs_from_polished_cinnabar_stonecutting",
    "polished_cinnabar_wall",
    "polished_cinnabar_wall_from_cinnabar_stonecutting",
    "polished_cinnabar_wall_from_polished_cinnabar_stonecutting",
    "polished_deepslate",
    "polished_deepslate_from_cobbled_deepslate_stonecutting",
    "polished_deepslate_from_deepslate_stonecutting",
    "polished_deepslate_slab",
    "polished_deepslate_slab_from_cobbled_deepslate_stonecutting",
    "polished_deepslate_slab_from_deepslate_stonecutting",
    "polished_deepslate_slab_from_polished_deepslate_stonecutting",
    "polished_deepslate_stairs",
    "polished_deepslate_stairs_from_cobbled_deepslate_stonecutting",
    "polished_deepslate_stairs_from_deepslate_stonecutting",
    "polished_deepslate_stairs_from_polished_deepslate_stonecutting",
    "polished_deepslate_wall",
    "polished_deepslate_wall_from_cobbled_deepslate_stonecutting",
    "polished_deepslate_wall_from_deepslate_stonecutting",
    "polished_deepslate_wall_from_polished_deepslate_stonecutting",
    "polished_diorite",
    "polished_diorite_from_diorite_stonecutting",
    "polished_diorite_slab",
    "polished_diorite_slab_from_diorite_stonecutting",
    "polished_diorite_slab_from_polished_diorite_stonecutting",
    "polished_diorite_stairs",
    "polished_diorite_stairs_from_diorite_stonecutting",
    "polished_diorite_stairs_from_polished_diorite_stonecutting",
    "polished_granite",
    "polished_granite_from_granite_stonecutting",
    "polished_granite_slab",
    "polished_granite_slab_from_granite_stonecutting",
    "polished_granite_slab_from_polished_granite_stonecutting",
    "polished_granite_stairs",
    "polished_granite_stairs_from_granite_stonecutting",
    "polished_granite_stairs_from_polished_granite_stonecutting",
    "polished_sulfur",
    "polished_sulfur_from_sulfur_stonecutting",
    "polished_sulfur_slab",
    "polished_sulfur_slab_from_polished_sulfur_stonecutting",
    "polished_sulfur_slab_from_sulfur_stonecutting",
    "polished_sulfur_stairs",
    "polished_sulfur_stairs_from_polished_sulfur_stonecutting",
    "polished_sulfur_stairs_from_sulfur_stonecutting",
    "polished_sulfur_wall",
    "polished_sulfur_wall_from_polished_sulfur_stonecutting",
    "polished_sulfur_wall_from_sulfur_stonecutting",
    "polished_tuff",
    "polished_tuff_from_tuff_stonecutting",
    "polished_tuff_slab",
    "polished_tuff_slab_from_polished_tuff_stonecutting",
    "polished_tuff_slab_from_tuff_stonecutting",
    "polished_tuff_stairs",
    "polished_tuff_stairs_from_polished_tuff_stonecutting",
    "polished_tuff_stairs_from_tuff_stonecutting",
    "polished_tuff_wall",
    "polished_tuff_wall_from_polished_tuff_stonecutting",
    "polished_tuff_wall_from_tuff_stonecutting",
    "poplar_boat",
    "poplar_button",
    "poplar_chest_boat",
    "poplar_door",
    "poplar_fence",
    "poplar_fence_gate",
    "poplar_hanging_sign",
    "poplar_planks",
    "poplar_pressure_plate",
    "poplar_shelf",
    "poplar_sign",
    "poplar_slab",
    "poplar_stairs",
    "poplar_trapdoor",
    "poplar_wood",
    "popped_chorus_fruit",
    "potent_sulfur",
    "powered_rail",
    "prismarine",
    "prismarine_brick_slab",
    "prismarine_brick_slab_from_prismarine_bricks_stonecutting",
    "prismarine_brick_stairs",
    "prismarine_brick_stairs_from_prismarine_bricks_stonecutting",
    "prismarine_bricks",
    "prismarine_slab",
    "prismarine_slab_from_prismarine_stonecutting",
    "prismarine_stairs",
    "prismarine_stairs_from_prismarine_stonecutting",
    "prismarine_wall",
    "prismarine_wall_from_prismarine_stonecutting",
    "pumpkin_pie",
    "pumpkin_seeds",
    "purple_banner",
    "purple_banner_duplicate",
    "purple_bed",
    "purple_bundle",
    "purple_candle",
    "purple_carpet",
    "purple_concrete_powder",
    "purple_concrete_slab",
    "purple_concrete_stairs",
    "purple_cushion",
    "purple_dye",
    "purple_glazed_terracotta",
    "purple_harness",
    "purple_shulker_box",
    "purple_stained_glass",
    "purple_stained_glass_pane",
    "purple_stained_glass_pane_from_glass_pane",
    "purple_terracotta",
    "purple_wool_slab",
    "purple_wool_stairs",
    "purpur_block",
    "purpur_pillar",
    "purpur_pillar_from_purpur_block_stonecutting",
    "purpur_slab",
    "purpur_slab_from_purpur_block_stonecutting",
    "purpur_stairs",
    "purpur_stairs_from_purpur_block_stonecutting",
    "quartz",
    "quartz_block",
    "quartz_bricks",
    "quartz_bricks_from_quartz_block_stonecutting",
    "quartz_from_blasting",
    "quartz_pillar",
    "quartz_pillar_from_quartz_block_stonecutting",
    "quartz_slab",
    "quartz_slab_from_quartz_block_stonecutting",
    "quartz_stairs",
    "quartz_stairs_from_quartz_block_stonecutting",
    "rabbit_stew_from_brown_mushroom",
    "rabbit_stew_from_red_mushroom",
    "rabbit_stew_from_shelf_mushroom",
    "rail",
    "raiser_armor_trim_smithing_template",
    "raiser_armor_trim_smithing_template_smithing_trim",
    "raw_copper",
    "raw_copper_block",
    "raw_gold",
    "raw_gold_block",
    "raw_iron",
    "raw_iron_block",
    "recovery_compass",
    "red_banner",
    "red_banner_duplicate",
    "red_bed",
    "red_bundle",
    "red_candle",
    "red_carpet",
    "red_concrete_powder",
    "red_concrete_slab",
    "red_concrete_stairs",
    "red_cushion",
    "red_dye_from_beetroot",
    "red_dye_from_poppy",
    "red_dye_from_rose_bush",
    "red_dye_from_tulip",
    "red_glazed_terracotta",
    "red_harness",
    "red_nether_brick_slab",
    "red_nether_brick_slab_from_red_nether_bricks_stonecutting",
    "red_nether_brick_stairs",
    "red_nether_brick_stairs_from_red_nether_bricks_stonecutting",
    "red_nether_brick_wall",
    "red_nether_brick_wall_from_red_nether_bricks_stonecutting",
    "red_nether_bricks",
    "red_sandstone",
    "red_sandstone_slab",
    "red_sandstone_slab_from_red_sandstone_stonecutting",
    "red_sandstone_stairs",
    "red_sandstone_stairs_from_red_sandstone_stonecutting",
    "red_sandstone_wall",
    "red_sandstone_wall_from_red_sandstone_stonecutting",
    "red_shulker_box",
    "red_stained_glass",
    "red_stained_glass_pane",
    "red_stained_glass_pane_from_glass_pane",
    "red_terracotta",
    "red_wool_slab",
    "red_wool_stairs",
    "redstone",
    "redstone_block",
    "redstone_from_blasting_deepslate_redstone_ore",
    "redstone_from_blasting_redstone_ore",
    "redstone_from_smelting_deepslate_redstone_ore",
    "redstone_from_smelting_redstone_ore",
    "redstone_lamp",
    "redstone_torch",
    "repair_item",
    "repeater",
    "resin_block",
    "resin_brick",
    "resin_brick_slab",
    "resin_brick_slab_from_resin_bricks_stonecutting",
    "resin_brick_stairs",
    "resin_brick_stairs_from_resin_bricks_stonecutting",
    "resin_brick_wall",
    "resin_brick_wall_from_resin_bricks_stonecutting",
    "resin_bricks",
    "resin_clump",
    "respawn_anchor",
    "rib_armor_trim_smithing_template",
    "rib_armor_trim_smithing_template_smithing_trim",
    "saddle",
    "sandstone",
    "sandstone_slab",
    "sandstone_slab_from_sandstone_stonecutting",
    "sandstone_stairs",
    "sandstone_stairs_from_sandstone_stonecutting",
    "sandstone_wall",
    "sandstone_wall_from_sandstone_stonecutting",
    "scaffolding",
    "sea_lantern",
    "sentry_armor_trim_smithing_template",
    "sentry_armor_trim_smithing_template_smithing_trim",
    "shaper_armor_trim_smithing_template",
    "shaper_armor_trim_smithing_template_smithing_trim",
    "shears",
    "shield",
    "shield_decoration",
    "shulker_box",
    "silence_armor_trim_smithing_template",
    "silence_armor_trim_smithing_template_smithing_trim",
    "skull_banner_pattern",
    "slime_ball",
    "slime_block",
    "smithing_table",
    "smoker",
    "smooth_basalt",
    "smooth_quartz",
    "smooth_quartz_slab",
    "smooth_quartz_slab_from_smooth_quartz_stonecutting",
    "smooth_quartz_stairs",
    "smooth_quartz_stairs_from_smooth_quartz_stonecutting",
    "smooth_red_sandstone",
    "smooth_red_sandstone_slab",
    "smooth_red_sandstone_slab_from_smooth_red_sandstone_stonecutting",
    "smooth_red_sandstone_stairs",
    "smooth_red_sandstone_stairs_from_smooth_red_sandstone_stonecutting",
    "smooth_sandstone",
    "smooth_sandstone_slab",
    "smooth_sandstone_slab_from_smooth_sandstone_stonecutting",
    "smooth_sandstone_stairs",
    "smooth_sandstone_stairs_from_smooth_sandstone_stonecutting",
    "smooth_stone",
    "smooth_stone_slab",
    "smooth_stone_slab_from_smooth_stone_stonecutting",
    "snout_armor_trim_smithing_template",
    "snout_armor_trim_smithing_template_smithing_trim",
    "snow",
    "snow_block",
    "soul_campfire",
    "soul_lantern",
    "soul_torch",
    "spectral_arrow",
    "spire_armor_trim_smithing_template",
    "spire_armor_trim_smithing_template_smithing_trim",
    "sponge",
    "spruce_boat",
    "spruce_button",
    "spruce_chest_boat",
    "spruce_door",
    "spruce_fence",
    "spruce_fence_gate",
    "spruce_hanging_sign",
    "spruce_planks",
    "spruce_pressure_plate",
    "spruce_shelf",
    "spruce_sign",
    "spruce_slab",
    "spruce_stairs",
    "spruce_trapdoor",
    "spruce_wood",
    "spyglass",
    "stick",
    "stick_from_bamboo_item",
    "sticky_piston",
    "stone",
    "stone_axe",
    "stone_brick_slab",
    "stone_brick_slab_from_stone_bricks_stonecutting",
    "stone_brick_slab_from_stone_stonecutting",
    "stone_brick_stairs",
    "stone_brick_stairs_from_stone_bricks_stonecutting",
    "stone_brick_stairs_from_stone_stonecutting",
    "stone_brick_wall",
    "stone_brick_wall_from_stone_bricks_stonecutting",
    "stone_brick_wall_from_stone_stonecutting",
    "stone_bricks",
    "stone_bricks_from_stone_stonecutting",
    "stone_button",
    "stone_hoe",
    "stone_pickaxe",
    "stone_pressure_plate",
    "stone_shovel",
    "stone_slab",
    "stone_slab_from_stone_stonecutting",
    "stone_spear",
    "stone_stairs",
    "stone_stairs_from_stone_stonecutting",
    "stone_sword",
    "stonecutter",
    "straw_bed",
    "stripped_acacia_wood",
    "stripped_birch_wood",
    "stripped_cherry_wood",
    "stripped_crimson_hyphae",
    "stripped_dark_oak_wood",
    "stripped_jungle_wood",
    "stripped_mangrove_wood",
    "stripped_oak_wood",
    "stripped_pale_oak_wood",
    "stripped_poplar_wood",
    "stripped_spruce_wood",
    "stripped_warped_hyphae",
    "sugar_from_honey_bottle",
    "sugar_from_sugar_cane",
    "sulfur_brick_slab",
    "sulfur_brick_slab_from_polished_sulfur_stonecutting",
    "sulfur_brick_slab_from_sulfur_bricks_stonecutting",
    "sulfur_brick_slab_from_sulfur_stonecutting",
    "sulfur_brick_stairs",
    "sulfur_brick_stairs_from_polished_sulfur_stonecutting",
    "sulfur_brick_stairs_from_sulfur_bricks_stonecutting",
    "sulfur_brick_stairs_from_sulfur_stonecutting",
    "sulfur_brick_wall",
    "sulfur_brick_wall_from_polished_sulfur_stonecutting",
    "sulfur_brick_wall_from_sulfur_bricks_stonecutting",
    "sulfur_brick_wall_from_sulfur_stonecutting",
    "sulfur_bricks",
    "sulfur_bricks_from_polished_sulfur_stonecutting",
    "sulfur_bricks_from_sulfur_stonecutting",
    "sulfur_from_sulfur_spikes",
    "sulfur_slab",
    "sulfur_slab_from_sulfur_stonecutting",
    "sulfur_stairs",
    "sulfur_stairs_from_sulfur_stonecutting",
    "sulfur_wall",
    "sulfur_wall_from_sulfur_stonecutting",
    "suspicious_stew_from_allium",
    "suspicious_stew_from_azure_bluet",
    "suspicious_stew_from_blue_orchid",
    "suspicious_stew_from_closed_eyeblossom",
    "suspicious_stew_from_cornflower",
    "suspicious_stew_from_dandelion",
    "suspicious_stew_from_golden_dandelion",
    "suspicious_stew_from_lily_of_the_valley",
    "suspicious_stew_from_open_eyeblossom",
    "suspicious_stew_from_orange_tulip",
    "suspicious_stew_from_oxeye_daisy",
    "suspicious_stew_from_pink_tulip",
    "suspicious_stew_from_poppy",
    "suspicious_stew_from_red_tulip",
    "suspicious_stew_from_torchflower",
    "suspicious_stew_from_white_tulip",
    "suspicious_stew_from_wither_rose",
    "target",
    "terracotta",
    "tide_armor_trim_smithing_template",
    "tide_armor_trim_smithing_template_smithing_trim",
    "tinted_glass",
    "tipped_arrow",
    "tnt",
    "tnt_minecart",
    "torch",
    "trapped_chest",
    "tripwire_hook",
    "tuff_brick_slab",
    "tuff_brick_slab_from_polished_tuff_stonecutting",
    "tuff_brick_slab_from_tuff_bricks_stonecutting",
    "tuff_brick_slab_from_tuff_stonecutting",
    "tuff_brick_stairs",
    "tuff_brick_stairs_from_polished_tuff_stonecutting",
    "tuff_brick_stairs_from_tuff_bricks_stonecutting",
    "tuff_brick_stairs_from_tuff_stonecutting",
    "tuff_brick_wall",
    "tuff_brick_wall_from_polished_tuff_stonecutting",
    "tuff_brick_wall_from_tuff_bricks_stonecutting",
    "tuff_brick_wall_from_tuff_stonecutting",
    "tuff_bricks",
    "tuff_bricks_from_polished_tuff_stonecutting",
    "tuff_bricks_from_tuff_stonecutting",
    "tuff_slab",
    "tuff_slab_from_tuff_stonecutting",
    "tuff_stairs",
    "tuff_stairs_from_tuff_stonecutting",
    "tuff_wall",
    "tuff_wall_from_tuff_stonecutting",
    "turtle_helmet",
    "vex_armor_trim_smithing_template",
    "vex_armor_trim_smithing_template_smithing_trim",
    "ward_armor_trim_smithing_template",
    "ward_armor_trim_smithing_template_smithing_trim",
    "warped_button",
    "warped_door",
    "warped_fence",
    "warped_fence_gate",
    "warped_fungus_on_a_stick",
    "warped_hanging_sign",
    "warped_hyphae",
    "warped_planks",
    "warped_pressure_plate",
    "warped_shelf",
    "warped_sign",
    "warped_slab",
    "warped_stairs",
    "warped_trapdoor",
    "waxed_chiseled_copper",
    "waxed_chiseled_copper_from_honeycomb",
    "waxed_chiseled_copper_from_waxed_copper_block_stonecutting",
    "waxed_chiseled_copper_from_waxed_cut_copper_stonecutting",
    "waxed_copper_bars_from_honeycomb",
    "waxed_copper_block_from_honeycomb",
    "waxed_copper_bulb",
    "waxed_copper_bulb_from_honeycomb",
    "waxed_copper_chain_from_honeycomb",
    "waxed_copper_chest_from_honeycomb",
    "waxed_copper_door_from_honeycomb",
    "waxed_copper_golem_statue_from_honeycomb",
    "waxed_copper_grate",
    "waxed_copper_grate_from_honeycomb",
    "waxed_copper_grate_from_waxed_copper_block_stonecutting",
    "waxed_copper_lantern_from_honeycomb",
    "waxed_copper_trapdoor_from_honeycomb",
    "waxed_cut_copper",
    "waxed_cut_copper_from_honeycomb",
    "waxed_cut_copper_from_waxed_copper_block_stonecutting",
    "waxed_cut_copper_slab",
    "waxed_cut_copper_slab_from_honeycomb",
    "waxed_cut_copper_slab_from_waxed_copper_block_stonecutting",
    "waxed_cut_copper_slab_from_waxed_cut_copper_stonecutting",
    "waxed_cut_copper_stairs",
    "waxed_cut_copper_stairs_from_honeycomb",
    "waxed_cut_copper_stairs_from_waxed_copper_block_stonecutting",
    "waxed_cut_copper_stairs_from_waxed_cut_copper_stonecutting",
    "waxed_exposed_chiseled_copper",
    "waxed_exposed_chiseled_copper_from_honeycomb",
    "waxed_exposed_chiseled_copper_from_waxed_exposed_copper_stonecutting",
    "waxed_exposed_chiseled_copper_from_waxed_exposed_cut_copper_stonecutting",
    "waxed_exposed_copper_bars_from_honeycomb",
    "waxed_exposed_copper_bulb",
    "waxed_exposed_copper_bulb_from_honeycomb",
    "waxed_exposed_copper_chain_from_honeycomb",
    "waxed_exposed_copper_chest_from_honeycomb",
    "waxed_exposed_copper_door_from_honeycomb",
    "waxed_exposed_copper_from_honeycomb",
    "waxed_exposed_copper_golem_statue_from_honeycomb",
    "waxed_exposed_copper_grate",
    "waxed_exposed_copper_grate_from_honeycomb",
    "waxed_exposed_copper_grate_from_waxed_exposed_copper_stonecutting",
    "waxed_exposed_copper_lantern_from_honeycomb",
    "waxed_exposed_copper_trapdoor_from_honeycomb",
    "waxed_exposed_cut_copper",
    "waxed_exposed_cut_copper_from_honeycomb",
    "waxed_exposed_cut_copper_from_waxed_exposed_copper_stonecutting",
    "waxed_exposed_cut_copper_slab",
    "waxed_exposed_cut_copper_slab_from_honeycomb",
    "waxed_exposed_cut_copper_slab_from_waxed_exposed_copper_stonecutting",
    "waxed_exposed_cut_copper_slab_from_waxed_exposed_cut_copper_stonecutting",
    "waxed_exposed_cut_copper_stairs",
    "waxed_exposed_cut_copper_stairs_from_honeycomb",
    "waxed_exposed_cut_copper_stairs_from_waxed_exposed_copper_stonecutting",
    "waxed_exposed_cut_copper_stairs_from_waxed_exposed_cut_copper_stonecutting",
    "waxed_exposed_lightning_rod_from_honeycomb",
    "waxed_lightning_rod_from_honeycomb",
    "waxed_oxidized_chiseled_copper",
    "waxed_oxidized_chiseled_copper_from_honeycomb",
    "waxed_oxidized_chiseled_copper_from_waxed_oxidized_copper_stonecutting",
    "waxed_oxidized_chiseled_copper_from_waxed_oxidized_cut_copper_stonecutting",
    "waxed_oxidized_copper_bars_from_honeycomb",
    "waxed_oxidized_copper_bulb",
    "waxed_oxidized_copper_bulb_from_honeycomb",
    "waxed_oxidized_copper_chain_from_honeycomb",
    "waxed_oxidized_copper_chest_from_honeycomb",
    "waxed_oxidized_copper_door_from_honeycomb",
    "waxed_oxidized_copper_from_honeycomb",
    "waxed_oxidized_copper_golem_statue_from_honeycomb",
    "waxed_oxidized_copper_grate",
    "waxed_oxidized_copper_grate_from_honeycomb",
    "waxed_oxidized_copper_grate_from_waxed_oxidized_copper_stonecutting",
    "waxed_oxidized_copper_lantern_from_honeycomb",
    "waxed_oxidized_copper_trapdoor_from_honeycomb",
    "waxed_oxidized_cut_copper",
    "waxed_oxidized_cut_copper_from_honeycomb",
    "waxed_oxidized_cut_copper_from_waxed_oxidized_copper_stonecutting",
    "waxed_oxidized_cut_copper_slab",
    "waxed_oxidized_cut_copper_slab_from_honeycomb",
    "waxed_oxidized_cut_copper_slab_from_waxed_oxidized_copper_stonecutting",
    "waxed_oxidized_cut_copper_slab_from_waxed_oxidized_cut_copper_stonecutting",
    "waxed_oxidized_cut_copper_stairs",
    "waxed_oxidized_cut_copper_stairs_from_honeycomb",
    "waxed_oxidized_cut_copper_stairs_from_waxed_oxidized_copper_stonecutting",
    "waxed_oxidized_cut_copper_stairs_from_waxed_oxidized_cut_copper_stonecutting",
    "waxed_oxidized_lightning_rod_from_honeycomb",
    "waxed_weathered_chiseled_copper",
    "waxed_weathered_chiseled_copper_from_honeycomb",
    "waxed_weathered_chiseled_copper_from_waxed_weathered_copper_stonecutting",
    "waxed_weathered_chiseled_copper_from_waxed_weathered_cut_copper_stonecutting",
    "waxed_weathered_copper_bars_from_honeycomb",
    "waxed_weathered_copper_bulb",
    "waxed_weathered_copper_bulb_from_honeycomb",
    "waxed_weathered_copper_chain_from_honeycomb",
    "waxed_weathered_copper_chest_from_honeycomb",
    "waxed_weathered_copper_door_from_honeycomb",
    "waxed_weathered_copper_from_honeycomb",
    "waxed_weathered_copper_golem_statue_from_honeycomb",
    "waxed_weathered_copper_grate",
    "waxed_weathered_copper_grate_from_honeycomb",
    "waxed_weathered_copper_grate_from_waxed_weathered_copper_stonecutting",
    "waxed_weathered_copper_lantern_from_honeycomb",
    "waxed_weathered_copper_trapdoor_from_honeycomb",
    "waxed_weathered_cut_copper",
    "waxed_weathered_cut_copper_from_honeycomb",
    "waxed_weathered_cut_copper_from_waxed_weathered_copper_stonecutting",
    "waxed_weathered_cut_copper_slab",
    "waxed_weathered_cut_copper_slab_from_honeycomb",
    "waxed_weathered_cut_copper_slab_from_waxed_weathered_copper_stonecutting",
    "waxed_weathered_cut_copper_slab_from_waxed_weathered_cut_copper_stonecutting",
    "waxed_weathered_cut_copper_stairs",
    "waxed_weathered_cut_copper_stairs_from_honeycomb",
    "waxed_weathered_cut_copper_stairs_from_waxed_weathered_copper_stonecutting",
    "waxed_weathered_cut_copper_stairs_from_waxed_weathered_cut_copper_stonecutting",
    "waxed_weathered_lightning_rod_from_honeycomb",
    "wayfinder_armor_trim_smithing_template",
    "wayfinder_armor_trim_smithing_template_smithing_trim",
    "weathered_chiseled_copper",
    "weathered_chiseled_copper_from_weathered_copper_stonecutting",
    "weathered_chiseled_copper_from_weathered_cut_copper_stonecutting",
    "weathered_copper_bulb",
    "weathered_copper_grate",
    "weathered_copper_grate_from_weathered_copper_stonecutting",
    "weathered_cut_copper",
    "weathered_cut_copper_from_weathered_copper_stonecutting",
    "weathered_cut_copper_slab",
    "weathered_cut_copper_slab_from_weathered_copper_stonecutting",
    "weathered_cut_copper_slab_from_weathered_cut_copper_stonecutting",
    "weathered_cut_copper_stairs",
    "weathered_cut_copper_stairs_from_weathered_copper_stonecutting",
    "weathered_cut_copper_stairs_from_weathered_cut_copper_stonecutting",
    "wheat",
    "white_banner",
    "white_banner_duplicate",
    "white_bed",
    "white_bundle",
    "white_candle",
    "white_carpet",
    "white_concrete_powder",
    "white_concrete_slab",
    "white_concrete_stairs",
    "white_cushion",
    "white_dye",
    "white_dye_from_lily_of_the_valley",
    "white_glazed_terracotta",
    "white_harness",
    "white_shulker_box",
    "white_stained_glass",
    "white_stained_glass_pane",
    "white_stained_glass_pane_from_glass_pane",
    "white_terracotta",
    "white_wool_from_string",
    "white_wool_slab",
    "white_wool_stairs",
    "wild_armor_trim_smithing_template",
    "wild_armor_trim_smithing_template_smithing_trim",
    "wind_charge",
    "wolf_armor",
    "wolf_armor_dyed",
    "wooden_axe",
    "wooden_hoe",
    "wooden_pickaxe",
    "wooden_shovel",
    "wooden_spear",
    "wooden_sword",
    "writable_book",
    "yellow_banner",
    "yellow_banner_duplicate",
    "yellow_bed",
    "yellow_bundle",
    "yellow_candle",
    "yellow_carpet",
    "yellow_concrete_powder",
    "yellow_concrete_slab",
    "yellow_concrete_stairs",
    "yellow_cushion",
    "yellow_dye_from_dandelion",
    "yellow_dye_from_golden_dandelion",
    "yellow_dye_from_sunflower",
    "yellow_dye_from_wildflowers",
    "yellow_glazed_terracotta",
    "yellow_harness",
    "yellow_shulker_box",
    "yellow_stained_glass",
    "yellow_stained_glass_pane",
    "yellow_stained_glass_pane_from_glass_pane",
    "yellow_terracotta",
    "yellow_wool_slab",
    "yellow_wool_stairs"
  ]);
});

// src/arguments/generated/_registry/structures.ts
var STRUCTURES_SET;
var init_structures = __esm(() => {
  init_sandstone();
  STRUCTURES_SET = new Set2([
    "abandoned_camp/camp/bamboo_jungle/campsite_bamboo_jungle_1",
    "abandoned_camp/camp/bamboo_jungle/campsite_bamboo_jungle_2",
    "abandoned_camp/camp/bamboo_jungle/campsite_bamboo_jungle_3",
    "abandoned_camp/camp/bamboo_jungle/campsite_bamboo_jungle_4",
    "abandoned_camp/camp/birch_forest/campsite_birch_forest_1",
    "abandoned_camp/camp/birch_forest/campsite_birch_forest_2",
    "abandoned_camp/camp/birch_forest/campsite_birch_forest_3",
    "abandoned_camp/camp/birch_forest/campsite_birch_forest_4",
    "abandoned_camp/camp/cherry_grove/campsite_cherry_grove_1",
    "abandoned_camp/camp/cherry_grove/campsite_cherry_grove_2",
    "abandoned_camp/camp/cherry_grove/campsite_cherry_grove_3",
    "abandoned_camp/camp/cherry_grove/campsite_cherry_grove_4",
    "abandoned_camp/camp/dappled_forest/campsite_dappled_forest_1",
    "abandoned_camp/camp/dappled_forest/campsite_dappled_forest_2",
    "abandoned_camp/camp/dappled_forest/campsite_dappled_forest_3",
    "abandoned_camp/camp/dappled_forest/campsite_dappled_forest_4",
    "abandoned_camp/camp/default/campsite_default_barrel_1",
    "abandoned_camp/camp/default/campsite_default_barrel_10",
    "abandoned_camp/camp/default/campsite_default_barrel_11",
    "abandoned_camp/camp/default/campsite_default_barrel_12",
    "abandoned_camp/camp/default/campsite_default_barrel_13",
    "abandoned_camp/camp/default/campsite_default_barrel_14",
    "abandoned_camp/camp/default/campsite_default_barrel_15",
    "abandoned_camp/camp/default/campsite_default_barrel_2",
    "abandoned_camp/camp/default/campsite_default_barrel_3",
    "abandoned_camp/camp/default/campsite_default_barrel_4",
    "abandoned_camp/camp/default/campsite_default_barrel_5",
    "abandoned_camp/camp/default/campsite_default_barrel_6",
    "abandoned_camp/camp/default/campsite_default_barrel_7",
    "abandoned_camp/camp/default/campsite_default_barrel_8",
    "abandoned_camp/camp/default/campsite_default_barrel_9",
    "abandoned_camp/camp/default/campsite_default_chest_1",
    "abandoned_camp/camp/default/campsite_default_chest_10",
    "abandoned_camp/camp/default/campsite_default_chest_11",
    "abandoned_camp/camp/default/campsite_default_chest_12",
    "abandoned_camp/camp/default/campsite_default_chest_13",
    "abandoned_camp/camp/default/campsite_default_chest_14",
    "abandoned_camp/camp/default/campsite_default_chest_15",
    "abandoned_camp/camp/default/campsite_default_chest_2",
    "abandoned_camp/camp/default/campsite_default_chest_3",
    "abandoned_camp/camp/default/campsite_default_chest_4",
    "abandoned_camp/camp/default/campsite_default_chest_5",
    "abandoned_camp/camp/default/campsite_default_chest_6",
    "abandoned_camp/camp/default/campsite_default_chest_7",
    "abandoned_camp/camp/default/campsite_default_chest_8",
    "abandoned_camp/camp/default/campsite_default_chest_9",
    "abandoned_camp/camp/default/campsite_default_special_1",
    "abandoned_camp/camp/default/campsite_default_special_10",
    "abandoned_camp/camp/default/campsite_default_special_11",
    "abandoned_camp/camp/default/campsite_default_special_12",
    "abandoned_camp/camp/default/campsite_default_special_13",
    "abandoned_camp/camp/default/campsite_default_special_14",
    "abandoned_camp/camp/default/campsite_default_special_15",
    "abandoned_camp/camp/default/campsite_default_special_2",
    "abandoned_camp/camp/default/campsite_default_special_3",
    "abandoned_camp/camp/default/campsite_default_special_4",
    "abandoned_camp/camp/default/campsite_default_special_5",
    "abandoned_camp/camp/default/campsite_default_special_6",
    "abandoned_camp/camp/default/campsite_default_special_7",
    "abandoned_camp/camp/default/campsite_default_special_8",
    "abandoned_camp/camp/default/campsite_default_special_9",
    "abandoned_camp/camp/flower_forest/campsite_flower_forest_1",
    "abandoned_camp/camp/flower_forest/campsite_flower_forest_2",
    "abandoned_camp/camp/flower_forest/campsite_flower_forest_3",
    "abandoned_camp/camp/flower_forest/campsite_flower_forest_4",
    "abandoned_camp/camp/forest/campsite_forest_1",
    "abandoned_camp/camp/forest/campsite_forest_2",
    "abandoned_camp/camp/forest/campsite_forest_3",
    "abandoned_camp/camp/forest/campsite_forest_4",
    "abandoned_camp/camp/meadow/campsite_meadow_1",
    "abandoned_camp/camp/meadow/campsite_meadow_2",
    "abandoned_camp/camp/meadow/campsite_meadow_3",
    "abandoned_camp/camp/meadow/campsite_meadow_4",
    "abandoned_camp/camp/old_growth_birch_forest/campsite_old_growth_birch_forest_1",
    "abandoned_camp/camp/old_growth_birch_forest/campsite_old_growth_birch_forest_2",
    "abandoned_camp/camp/old_growth_birch_forest/campsite_old_growth_birch_forest_3",
    "abandoned_camp/camp/old_growth_birch_forest/campsite_old_growth_birch_forest_4",
    "abandoned_camp/camp/old_growth_pine_taiga/campsite_old_growth_pine_taiga_1",
    "abandoned_camp/camp/old_growth_pine_taiga/campsite_old_growth_pine_taiga_2",
    "abandoned_camp/camp/old_growth_pine_taiga/campsite_old_growth_pine_taiga_3",
    "abandoned_camp/camp/old_growth_pine_taiga/campsite_old_growth_pine_taiga_4",
    "abandoned_camp/camp/old_growth_spruce_taiga/campsite_old_growth_spruce_taiga_1",
    "abandoned_camp/camp/old_growth_spruce_taiga/campsite_old_growth_spruce_taiga_2",
    "abandoned_camp/camp/old_growth_spruce_taiga/campsite_old_growth_spruce_taiga_3",
    "abandoned_camp/camp/old_growth_spruce_taiga/campsite_old_growth_spruce_taiga_4",
    "abandoned_camp/camp/pale_garden/campsite_pale_garden_1",
    "abandoned_camp/camp/pale_garden/campsite_pale_garden_2",
    "abandoned_camp/camp/pale_garden/campsite_pale_garden_3",
    "abandoned_camp/camp/pale_garden/campsite_pale_garden_4",
    "abandoned_camp/camp/savanna/campsite_savanna_1",
    "abandoned_camp/camp/savanna/campsite_savanna_2",
    "abandoned_camp/camp/savanna/campsite_savanna_3",
    "abandoned_camp/camp/savanna/campsite_savanna_4",
    "abandoned_camp/camp/snowy_taiga/campsite_snowy_taiga_1",
    "abandoned_camp/camp/snowy_taiga/campsite_snowy_taiga_2",
    "abandoned_camp/camp/snowy_taiga/campsite_snowy_taiga_3",
    "abandoned_camp/camp/snowy_taiga/campsite_snowy_taiga_4",
    "abandoned_camp/camp/sparse_jungle/campsite_sparse_jungle_1",
    "abandoned_camp/camp/sparse_jungle/campsite_sparse_jungle_2",
    "abandoned_camp/camp/sparse_jungle/campsite_sparse_jungle_3",
    "abandoned_camp/camp/sparse_jungle/campsite_sparse_jungle_4",
    "abandoned_camp/camp/swamp/campsite_swamp_1",
    "abandoned_camp/camp/swamp/campsite_swamp_2",
    "abandoned_camp/camp/swamp/campsite_swamp_3",
    "abandoned_camp/camp/swamp/campsite_swamp_4",
    "abandoned_camp/camp/taiga/campsite_taiga_1",
    "abandoned_camp/camp/taiga/campsite_taiga_2",
    "abandoned_camp/camp/taiga/campsite_taiga_3",
    "abandoned_camp/camp/taiga/campsite_taiga_4",
    "abandoned_camp/camp/windswept_forest/campsite_windswept_forest_1",
    "abandoned_camp/camp/windswept_forest/campsite_windswept_forest_2",
    "abandoned_camp/camp/windswept_forest/campsite_windswept_forest_3",
    "abandoned_camp/camp/windswept_forest/campsite_windswept_forest_4",
    "abandoned_camp/camp/wooded_badlands/campsite_wooded_badlands_1",
    "abandoned_camp/camp/wooded_badlands/campsite_wooded_badlands_2",
    "abandoned_camp/camp/wooded_badlands/campsite_wooded_badlands_3",
    "abandoned_camp/camp/wooded_badlands/campsite_wooded_badlands_4",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_1",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_10",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_2",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_3",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_4",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_5",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_6",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_7",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_8",
    "abandoned_camp/tent/bamboo_jungle/tent_bamboo_jungle_9",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_1",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_10",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_2",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_3",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_4",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_5",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_6",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_7",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_8",
    "abandoned_camp/tent/birch_forest/tent_birch_forest_9",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_1",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_10",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_2",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_3",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_4",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_5",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_6",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_7",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_8",
    "abandoned_camp/tent/cherry_grove/tent_cherry_grove_9",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_1",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_10",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_2",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_3",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_4",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_5",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_6",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_7",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_8",
    "abandoned_camp/tent/dappled_forest/tent_dappled_forest_9",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_1",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_10",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_2",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_3",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_4",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_5",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_6",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_7",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_8",
    "abandoned_camp/tent/flower_forest/tent_flower_forest_9",
    "abandoned_camp/tent/forest/tent_forest_1",
    "abandoned_camp/tent/forest/tent_forest_10",
    "abandoned_camp/tent/forest/tent_forest_2",
    "abandoned_camp/tent/forest/tent_forest_3",
    "abandoned_camp/tent/forest/tent_forest_4",
    "abandoned_camp/tent/forest/tent_forest_5",
    "abandoned_camp/tent/forest/tent_forest_6",
    "abandoned_camp/tent/forest/tent_forest_7",
    "abandoned_camp/tent/forest/tent_forest_8",
    "abandoned_camp/tent/forest/tent_forest_9",
    "abandoned_camp/tent/meadow/tent_meadow_1",
    "abandoned_camp/tent/meadow/tent_meadow_10",
    "abandoned_camp/tent/meadow/tent_meadow_2",
    "abandoned_camp/tent/meadow/tent_meadow_3",
    "abandoned_camp/tent/meadow/tent_meadow_4",
    "abandoned_camp/tent/meadow/tent_meadow_5",
    "abandoned_camp/tent/meadow/tent_meadow_6",
    "abandoned_camp/tent/meadow/tent_meadow_7",
    "abandoned_camp/tent/meadow/tent_meadow_8",
    "abandoned_camp/tent/meadow/tent_meadow_9",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_1",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_10",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_2",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_3",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_4",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_5",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_6",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_7",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_8",
    "abandoned_camp/tent/old_growth_birch_forest/tent_old_growth_birch_forest_9",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_1",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_10",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_2",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_3",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_4",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_5",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_6",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_7",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_8",
    "abandoned_camp/tent/old_growth_pine_taiga/tent_old_growth_pine_taiga_9",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_1",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_10",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_2",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_3",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_4",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_5",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_6",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_7",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_8",
    "abandoned_camp/tent/old_growth_spruce_taiga/tent_old_growth_spruce_taiga_9",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_1",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_10",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_2",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_3",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_4",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_5",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_6",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_7",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_8",
    "abandoned_camp/tent/pale_garden/tent_pale_garden_9",
    "abandoned_camp/tent/savanna/tent_savanna_1",
    "abandoned_camp/tent/savanna/tent_savanna_10",
    "abandoned_camp/tent/savanna/tent_savanna_2",
    "abandoned_camp/tent/savanna/tent_savanna_3",
    "abandoned_camp/tent/savanna/tent_savanna_4",
    "abandoned_camp/tent/savanna/tent_savanna_5",
    "abandoned_camp/tent/savanna/tent_savanna_6",
    "abandoned_camp/tent/savanna/tent_savanna_7",
    "abandoned_camp/tent/savanna/tent_savanna_8",
    "abandoned_camp/tent/savanna/tent_savanna_9",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_1",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_10",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_2",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_3",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_4",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_5",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_6",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_7",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_8",
    "abandoned_camp/tent/snowy_taiga/tent_snowy_taiga_9",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_1",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_10",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_2",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_3",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_4",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_5",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_6",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_7",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_8",
    "abandoned_camp/tent/sparse_jungle/tent_sparse_jungle_9",
    "abandoned_camp/tent/swamp/tent_swamp_1",
    "abandoned_camp/tent/swamp/tent_swamp_10",
    "abandoned_camp/tent/swamp/tent_swamp_2",
    "abandoned_camp/tent/swamp/tent_swamp_3",
    "abandoned_camp/tent/swamp/tent_swamp_4",
    "abandoned_camp/tent/swamp/tent_swamp_5",
    "abandoned_camp/tent/swamp/tent_swamp_6",
    "abandoned_camp/tent/swamp/tent_swamp_7",
    "abandoned_camp/tent/swamp/tent_swamp_8",
    "abandoned_camp/tent/swamp/tent_swamp_9",
    "abandoned_camp/tent/taiga/tent_taiga_1",
    "abandoned_camp/tent/taiga/tent_taiga_10",
    "abandoned_camp/tent/taiga/tent_taiga_2",
    "abandoned_camp/tent/taiga/tent_taiga_3",
    "abandoned_camp/tent/taiga/tent_taiga_4",
    "abandoned_camp/tent/taiga/tent_taiga_5",
    "abandoned_camp/tent/taiga/tent_taiga_6",
    "abandoned_camp/tent/taiga/tent_taiga_7",
    "abandoned_camp/tent/taiga/tent_taiga_8",
    "abandoned_camp/tent/taiga/tent_taiga_9",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_1",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_10",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_2",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_3",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_4",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_5",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_6",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_7",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_8",
    "abandoned_camp/tent/windswept_forest/tent_windswept_forest_9",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_1",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_10",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_2",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_3",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_4",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_5",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_6",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_7",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_8",
    "abandoned_camp/tent/wooded_badlands/tent_wooded_badlands_9",
    "ancient_city/city/entrance/entrance_connector",
    "ancient_city/city/entrance/entrance_path_1",
    "ancient_city/city/entrance/entrance_path_2",
    "ancient_city/city/entrance/entrance_path_3",
    "ancient_city/city/entrance/entrance_path_4",
    "ancient_city/city/entrance/entrance_path_5",
    "ancient_city/city_center/city_center_1",
    "ancient_city/city_center/city_center_2",
    "ancient_city/city_center/city_center_3",
    "ancient_city/city_center/walls/bottom_1",
    "ancient_city/city_center/walls/bottom_2",
    "ancient_city/city_center/walls/bottom_left_corner",
    "ancient_city/city_center/walls/bottom_right_corner",
    "ancient_city/city_center/walls/bottom_right_corner_1",
    "ancient_city/city_center/walls/bottom_right_corner_2",
    "ancient_city/city_center/walls/left",
    "ancient_city/city_center/walls/right",
    "ancient_city/city_center/walls/top",
    "ancient_city/city_center/walls/top_left_corner",
    "ancient_city/city_center/walls/top_right_corner",
    "ancient_city/structures/barracks",
    "ancient_city/structures/camp_1",
    "ancient_city/structures/camp_2",
    "ancient_city/structures/camp_3",
    "ancient_city/structures/chamber_1",
    "ancient_city/structures/chamber_2",
    "ancient_city/structures/chamber_3",
    "ancient_city/structures/ice_box_1",
    "ancient_city/structures/large_pillar_1",
    "ancient_city/structures/large_ruin_1",
    "ancient_city/structures/medium_pillar_1",
    "ancient_city/structures/medium_ruin_1",
    "ancient_city/structures/medium_ruin_2",
    "ancient_city/structures/sauna_1",
    "ancient_city/structures/small_ruin_1",
    "ancient_city/structures/small_ruin_2",
    "ancient_city/structures/small_statue",
    "ancient_city/structures/tall_ruin_1",
    "ancient_city/structures/tall_ruin_2",
    "ancient_city/structures/tall_ruin_3",
    "ancient_city/structures/tall_ruin_4",
    "ancient_city/walls/intact_corner_wall_1",
    "ancient_city/walls/intact_horizontal_wall_1",
    "ancient_city/walls/intact_horizontal_wall_2",
    "ancient_city/walls/intact_horizontal_wall_bridge",
    "ancient_city/walls/intact_horizontal_wall_passage_1",
    "ancient_city/walls/intact_horizontal_wall_stairs_1",
    "ancient_city/walls/intact_horizontal_wall_stairs_2",
    "ancient_city/walls/intact_horizontal_wall_stairs_3",
    "ancient_city/walls/intact_horizontal_wall_stairs_4",
    "ancient_city/walls/intact_intersection_wall_1",
    "ancient_city/walls/intact_lshape_wall_1",
    "ancient_city/walls/ruined_corner_wall_1",
    "ancient_city/walls/ruined_corner_wall_2",
    "ancient_city/walls/ruined_horizontal_wall_stairs_1",
    "ancient_city/walls/ruined_horizontal_wall_stairs_2",
    "ancient_city/walls/ruined_horizontal_wall_stairs_3",
    "ancient_city/walls/ruined_horizontal_wall_stairs_4",
    "bastion/blocks/air",
    "bastion/blocks/gold",
    "bastion/bridge/bridge_pieces/bridge",
    "bastion/bridge/connectors/back_bridge_bottom",
    "bastion/bridge/connectors/back_bridge_top",
    "bastion/bridge/legs/leg_0",
    "bastion/bridge/legs/leg_1",
    "bastion/bridge/rampart_plates/plate_0",
    "bastion/bridge/ramparts/rampart_0",
    "bastion/bridge/ramparts/rampart_1",
    "bastion/bridge/starting_pieces/entrance",
    "bastion/bridge/starting_pieces/entrance_base",
    "bastion/bridge/starting_pieces/entrance_face",
    "bastion/bridge/walls/wall_base_0",
    "bastion/bridge/walls/wall_base_1",
    "bastion/hoglin_stable/air_base",
    "bastion/hoglin_stable/connectors/end_post_connector",
    "bastion/hoglin_stable/large_stables/inner_0",
    "bastion/hoglin_stable/large_stables/inner_1",
    "bastion/hoglin_stable/large_stables/inner_2",
    "bastion/hoglin_stable/large_stables/inner_3",
    "bastion/hoglin_stable/large_stables/inner_4",
    "bastion/hoglin_stable/large_stables/outer_0",
    "bastion/hoglin_stable/large_stables/outer_1",
    "bastion/hoglin_stable/large_stables/outer_2",
    "bastion/hoglin_stable/large_stables/outer_3",
    "bastion/hoglin_stable/large_stables/outer_4",
    "bastion/hoglin_stable/posts/end_post",
    "bastion/hoglin_stable/posts/stair_post",
    "bastion/hoglin_stable/rampart_plates/rampart_plate_1",
    "bastion/hoglin_stable/ramparts/ramparts_1",
    "bastion/hoglin_stable/ramparts/ramparts_2",
    "bastion/hoglin_stable/ramparts/ramparts_3",
    "bastion/hoglin_stable/small_stables/inner_0",
    "bastion/hoglin_stable/small_stables/inner_1",
    "bastion/hoglin_stable/small_stables/inner_2",
    "bastion/hoglin_stable/small_stables/inner_3",
    "bastion/hoglin_stable/small_stables/outer_0",
    "bastion/hoglin_stable/small_stables/outer_1",
    "bastion/hoglin_stable/small_stables/outer_2",
    "bastion/hoglin_stable/small_stables/outer_3",
    "bastion/hoglin_stable/stairs/stairs_1_0",
    "bastion/hoglin_stable/stairs/stairs_1_1",
    "bastion/hoglin_stable/stairs/stairs_1_2",
    "bastion/hoglin_stable/stairs/stairs_1_3",
    "bastion/hoglin_stable/stairs/stairs_1_4",
    "bastion/hoglin_stable/stairs/stairs_2_0",
    "bastion/hoglin_stable/stairs/stairs_2_1",
    "bastion/hoglin_stable/stairs/stairs_2_2",
    "bastion/hoglin_stable/stairs/stairs_2_3",
    "bastion/hoglin_stable/stairs/stairs_2_4",
    "bastion/hoglin_stable/stairs/stairs_3_0",
    "bastion/hoglin_stable/stairs/stairs_3_1",
    "bastion/hoglin_stable/stairs/stairs_3_2",
    "bastion/hoglin_stable/stairs/stairs_3_3",
    "bastion/hoglin_stable/stairs/stairs_3_4",
    "bastion/hoglin_stable/starting_pieces/stairs_0_mirrored",
    "bastion/hoglin_stable/starting_pieces/stairs_1_mirrored",
    "bastion/hoglin_stable/starting_pieces/stairs_2_mirrored",
    "bastion/hoglin_stable/starting_pieces/stairs_3_mirrored",
    "bastion/hoglin_stable/starting_pieces/stairs_4_mirrored",
    "bastion/hoglin_stable/starting_pieces/starting_stairs_0",
    "bastion/hoglin_stable/starting_pieces/starting_stairs_1",
    "bastion/hoglin_stable/starting_pieces/starting_stairs_2",
    "bastion/hoglin_stable/starting_pieces/starting_stairs_3",
    "bastion/hoglin_stable/starting_pieces/starting_stairs_4",
    "bastion/hoglin_stable/walls/side_wall_0",
    "bastion/hoglin_stable/walls/side_wall_1",
    "bastion/hoglin_stable/walls/wall_base",
    "bastion/mobs/crossbow_piglin",
    "bastion/mobs/empty",
    "bastion/mobs/hoglin",
    "bastion/mobs/melee_piglin",
    "bastion/mobs/melee_piglin_always",
    "bastion/mobs/sword_piglin",
    "bastion/treasure/bases/centers/center_0",
    "bastion/treasure/bases/centers/center_1",
    "bastion/treasure/bases/centers/center_2",
    "bastion/treasure/bases/centers/center_3",
    "bastion/treasure/bases/lava_basin",
    "bastion/treasure/big_air_full",
    "bastion/treasure/brains/center_brain",
    "bastion/treasure/connectors/center_to_wall_middle",
    "bastion/treasure/connectors/center_to_wall_top",
    "bastion/treasure/connectors/center_to_wall_top_entrance",
    "bastion/treasure/corners/bottom/corner_0",
    "bastion/treasure/corners/bottom/corner_1",
    "bastion/treasure/corners/edges/bottom",
    "bastion/treasure/corners/edges/middle",
    "bastion/treasure/corners/edges/top",
    "bastion/treasure/corners/middle/corner_0",
    "bastion/treasure/corners/middle/corner_1",
    "bastion/treasure/corners/top/corner_0",
    "bastion/treasure/corners/top/corner_1",
    "bastion/treasure/entrances/entrance_0",
    "bastion/treasure/extensions/empty",
    "bastion/treasure/extensions/fire_room",
    "bastion/treasure/extensions/house_0",
    "bastion/treasure/extensions/house_1",
    "bastion/treasure/extensions/large_bridge_0",
    "bastion/treasure/extensions/large_bridge_1",
    "bastion/treasure/extensions/large_bridge_2",
    "bastion/treasure/extensions/large_bridge_3",
    "bastion/treasure/extensions/roofed_bridge",
    "bastion/treasure/extensions/small_bridge_0",
    "bastion/treasure/extensions/small_bridge_1",
    "bastion/treasure/extensions/small_bridge_2",
    "bastion/treasure/extensions/small_bridge_3",
    "bastion/treasure/ramparts/bottom_wall_0",
    "bastion/treasure/ramparts/lava_basin_main",
    "bastion/treasure/ramparts/lava_basin_side",
    "bastion/treasure/ramparts/mid_wall_main",
    "bastion/treasure/ramparts/mid_wall_side",
    "bastion/treasure/ramparts/top_wall",
    "bastion/treasure/roofs/center_roof",
    "bastion/treasure/roofs/corner_roof",
    "bastion/treasure/roofs/wall_roof",
    "bastion/treasure/stairs/lower_stairs",
    "bastion/treasure/walls/bottom/wall_0",
    "bastion/treasure/walls/bottom/wall_1",
    "bastion/treasure/walls/bottom/wall_2",
    "bastion/treasure/walls/bottom/wall_3",
    "bastion/treasure/walls/entrance_wall",
    "bastion/treasure/walls/lava_wall",
    "bastion/treasure/walls/mid/wall_0",
    "bastion/treasure/walls/mid/wall_1",
    "bastion/treasure/walls/mid/wall_2",
    "bastion/treasure/walls/outer/bottom_corner",
    "bastion/treasure/walls/outer/medium_outer_wall",
    "bastion/treasure/walls/outer/mid_corner",
    "bastion/treasure/walls/outer/outer_wall",
    "bastion/treasure/walls/outer/tall_outer_wall",
    "bastion/treasure/walls/outer/top_corner",
    "bastion/treasure/walls/top/main_entrance",
    "bastion/treasure/walls/top/wall_0",
    "bastion/treasure/walls/top/wall_1",
    "bastion/units/air_base",
    "bastion/units/center_pieces/center_0",
    "bastion/units/center_pieces/center_1",
    "bastion/units/center_pieces/center_2",
    "bastion/units/edges/edge_0",
    "bastion/units/fillers/stage_0",
    "bastion/units/pathways/pathway_0",
    "bastion/units/pathways/pathway_wall_0",
    "bastion/units/rampart_plates/plate_0",
    "bastion/units/ramparts/ramparts_0",
    "bastion/units/ramparts/ramparts_1",
    "bastion/units/ramparts/ramparts_2",
    "bastion/units/stages/rot/stage_1_0",
    "bastion/units/stages/stage_0_0",
    "bastion/units/stages/stage_0_1",
    "bastion/units/stages/stage_0_2",
    "bastion/units/stages/stage_0_3",
    "bastion/units/stages/stage_1_0",
    "bastion/units/stages/stage_1_1",
    "bastion/units/stages/stage_1_2",
    "bastion/units/stages/stage_1_3",
    "bastion/units/stages/stage_2_0",
    "bastion/units/stages/stage_2_1",
    "bastion/units/stages/stage_3_0",
    "bastion/units/stages/stage_3_1",
    "bastion/units/stages/stage_3_2",
    "bastion/units/stages/stage_3_3",
    "bastion/units/wall_units/edge_0_large",
    "bastion/units/wall_units/unit_0",
    "bastion/units/walls/connected_wall",
    "bastion/units/walls/wall_base",
    "empty",
    "end_city/base_floor",
    "end_city/base_roof",
    "end_city/bridge_end",
    "end_city/bridge_gentle_stairs",
    "end_city/bridge_piece",
    "end_city/bridge_steep_stairs",
    "end_city/fat_tower_base",
    "end_city/fat_tower_middle",
    "end_city/fat_tower_top",
    "end_city/second_floor_1",
    "end_city/second_floor_2",
    "end_city/second_roof",
    "end_city/ship",
    "end_city/third_floor_1",
    "end_city/third_floor_2",
    "end_city/third_roof",
    "end_city/tower_base",
    "end_city/tower_floor",
    "end_city/tower_piece",
    "end_city/tower_top",
    "fossil/skull_1",
    "fossil/skull_1_coal",
    "fossil/skull_2",
    "fossil/skull_2_coal",
    "fossil/skull_3",
    "fossil/skull_3_coal",
    "fossil/skull_4",
    "fossil/skull_4_coal",
    "fossil/spine_1",
    "fossil/spine_1_coal",
    "fossil/spine_2",
    "fossil/spine_2_coal",
    "fossil/spine_3",
    "fossil/spine_3_coal",
    "fossil/spine_4",
    "fossil/spine_4_coal",
    "igloo/bottom",
    "igloo/middle",
    "igloo/top",
    "nether_fossils/fossil_1",
    "nether_fossils/fossil_10",
    "nether_fossils/fossil_11",
    "nether_fossils/fossil_12",
    "nether_fossils/fossil_13",
    "nether_fossils/fossil_14",
    "nether_fossils/fossil_2",
    "nether_fossils/fossil_3",
    "nether_fossils/fossil_4",
    "nether_fossils/fossil_5",
    "nether_fossils/fossil_6",
    "nether_fossils/fossil_7",
    "nether_fossils/fossil_8",
    "nether_fossils/fossil_9",
    "pillager_outpost/base_plate",
    "pillager_outpost/feature_cage1",
    "pillager_outpost/feature_cage2",
    "pillager_outpost/feature_cage_with_allays",
    "pillager_outpost/feature_logs",
    "pillager_outpost/feature_plate",
    "pillager_outpost/feature_targets",
    "pillager_outpost/feature_tent1",
    "pillager_outpost/feature_tent2",
    "pillager_outpost/watchtower",
    "pillager_outpost/watchtower_overgrown",
    "ruined_portal/giant_portal_1",
    "ruined_portal/giant_portal_2",
    "ruined_portal/giant_portal_3",
    "ruined_portal/portal_1",
    "ruined_portal/portal_10",
    "ruined_portal/portal_2",
    "ruined_portal/portal_3",
    "ruined_portal/portal_4",
    "ruined_portal/portal_5",
    "ruined_portal/portal_6",
    "ruined_portal/portal_7",
    "ruined_portal/portal_8",
    "ruined_portal/portal_9",
    "shipwreck/rightsideup_backhalf",
    "shipwreck/rightsideup_backhalf_degraded",
    "shipwreck/rightsideup_fronthalf",
    "shipwreck/rightsideup_fronthalf_degraded",
    "shipwreck/rightsideup_full",
    "shipwreck/rightsideup_full_degraded",
    "shipwreck/sideways_backhalf",
    "shipwreck/sideways_backhalf_degraded",
    "shipwreck/sideways_fronthalf",
    "shipwreck/sideways_fronthalf_degraded",
    "shipwreck/sideways_full",
    "shipwreck/sideways_full_degraded",
    "shipwreck/upsidedown_backhalf",
    "shipwreck/upsidedown_backhalf_degraded",
    "shipwreck/upsidedown_fronthalf",
    "shipwreck/upsidedown_fronthalf_degraded",
    "shipwreck/upsidedown_full",
    "shipwreck/upsidedown_full_degraded",
    "shipwreck/with_mast",
    "shipwreck/with_mast_degraded",
    "spring/sulfur_spring_extra_large_1",
    "spring/sulfur_spring_large_1",
    "spring/sulfur_spring_large_2",
    "spring/sulfur_spring_medium_1",
    "spring/sulfur_spring_medium_2",
    "spring/sulfur_spring_medium_3",
    "spring/sulfur_spring_small_1",
    "spring/sulfur_spring_small_2",
    "spring/sulfur_spring_small_3",
    "spring/sulfur_spring_small_4",
    "trail_ruins/buildings/group_full_1",
    "trail_ruins/buildings/group_full_2",
    "trail_ruins/buildings/group_full_3",
    "trail_ruins/buildings/group_full_4",
    "trail_ruins/buildings/group_full_5",
    "trail_ruins/buildings/group_hall_1",
    "trail_ruins/buildings/group_hall_2",
    "trail_ruins/buildings/group_hall_3",
    "trail_ruins/buildings/group_hall_4",
    "trail_ruins/buildings/group_hall_5",
    "trail_ruins/buildings/group_lower_1",
    "trail_ruins/buildings/group_lower_2",
    "trail_ruins/buildings/group_lower_3",
    "trail_ruins/buildings/group_lower_4",
    "trail_ruins/buildings/group_lower_5",
    "trail_ruins/buildings/group_room_1",
    "trail_ruins/buildings/group_room_2",
    "trail_ruins/buildings/group_room_3",
    "trail_ruins/buildings/group_room_4",
    "trail_ruins/buildings/group_room_5",
    "trail_ruins/buildings/group_upper_1",
    "trail_ruins/buildings/group_upper_2",
    "trail_ruins/buildings/group_upper_3",
    "trail_ruins/buildings/group_upper_4",
    "trail_ruins/buildings/group_upper_5",
    "trail_ruins/buildings/large_room_1",
    "trail_ruins/buildings/large_room_2",
    "trail_ruins/buildings/large_room_3",
    "trail_ruins/buildings/large_room_4",
    "trail_ruins/buildings/large_room_5",
    "trail_ruins/buildings/one_room_1",
    "trail_ruins/buildings/one_room_2",
    "trail_ruins/buildings/one_room_3",
    "trail_ruins/buildings/one_room_4",
    "trail_ruins/buildings/one_room_5",
    "trail_ruins/decor/decor_1",
    "trail_ruins/decor/decor_2",
    "trail_ruins/decor/decor_3",
    "trail_ruins/decor/decor_4",
    "trail_ruins/decor/decor_5",
    "trail_ruins/decor/decor_6",
    "trail_ruins/decor/decor_7",
    "trail_ruins/roads/long_road_end",
    "trail_ruins/roads/road_end_1",
    "trail_ruins/roads/road_section_1",
    "trail_ruins/roads/road_section_2",
    "trail_ruins/roads/road_section_3",
    "trail_ruins/roads/road_section_4",
    "trail_ruins/roads/road_spacer_1",
    "trail_ruins/tower/hall_1",
    "trail_ruins/tower/hall_2",
    "trail_ruins/tower/hall_3",
    "trail_ruins/tower/hall_4",
    "trail_ruins/tower/hall_5",
    "trail_ruins/tower/large_hall_1",
    "trail_ruins/tower/large_hall_2",
    "trail_ruins/tower/large_hall_3",
    "trail_ruins/tower/large_hall_4",
    "trail_ruins/tower/large_hall_5",
    "trail_ruins/tower/one_room_1",
    "trail_ruins/tower/one_room_2",
    "trail_ruins/tower/one_room_3",
    "trail_ruins/tower/one_room_4",
    "trail_ruins/tower/one_room_5",
    "trail_ruins/tower/platform_1",
    "trail_ruins/tower/platform_2",
    "trail_ruins/tower/platform_3",
    "trail_ruins/tower/platform_4",
    "trail_ruins/tower/platform_5",
    "trail_ruins/tower/stable_1",
    "trail_ruins/tower/stable_2",
    "trail_ruins/tower/stable_3",
    "trail_ruins/tower/stable_4",
    "trail_ruins/tower/stable_5",
    "trail_ruins/tower/tower_1",
    "trail_ruins/tower/tower_2",
    "trail_ruins/tower/tower_3",
    "trail_ruins/tower/tower_4",
    "trail_ruins/tower/tower_5",
    "trail_ruins/tower/tower_top_1",
    "trail_ruins/tower/tower_top_2",
    "trail_ruins/tower/tower_top_3",
    "trail_ruins/tower/tower_top_4",
    "trail_ruins/tower/tower_top_5",
    "trial_chambers/chamber/addon/c1_breeze",
    "trial_chambers/chamber/addon/full_corner_column",
    "trial_chambers/chamber/addon/full_stacked_walkway",
    "trial_chambers/chamber/addon/full_stacked_walkway_2",
    "trial_chambers/chamber/addon/grate_bridge",
    "trial_chambers/chamber/addon/hanging_platform",
    "trial_chambers/chamber/addon/lower_staircase_down",
    "trial_chambers/chamber/addon/short_grate_platform",
    "trial_chambers/chamber/addon/short_platform",
    "trial_chambers/chamber/addon/walkway_with_bridge_1",
    "trial_chambers/chamber/assembly",
    "trial_chambers/chamber/assembly/cover_1",
    "trial_chambers/chamber/assembly/cover_2",
    "trial_chambers/chamber/assembly/cover_3",
    "trial_chambers/chamber/assembly/cover_4",
    "trial_chambers/chamber/assembly/cover_5",
    "trial_chambers/chamber/assembly/cover_6",
    "trial_chambers/chamber/assembly/cover_7",
    "trial_chambers/chamber/assembly/full_column",
    "trial_chambers/chamber/assembly/hanging_1",
    "trial_chambers/chamber/assembly/hanging_2",
    "trial_chambers/chamber/assembly/hanging_3",
    "trial_chambers/chamber/assembly/hanging_4",
    "trial_chambers/chamber/assembly/hanging_5",
    "trial_chambers/chamber/assembly/left_staircase_1",
    "trial_chambers/chamber/assembly/left_staircase_2",
    "trial_chambers/chamber/assembly/left_staircase_3",
    "trial_chambers/chamber/assembly/platform_1",
    "trial_chambers/chamber/assembly/right_staircase_1",
    "trial_chambers/chamber/assembly/right_staircase_2",
    "trial_chambers/chamber/assembly/right_staircase_3",
    "trial_chambers/chamber/assembly/spawner_1",
    "trial_chambers/chamber/chamber_1",
    "trial_chambers/chamber/chamber_2",
    "trial_chambers/chamber/chamber_4",
    "trial_chambers/chamber/chamber_8",
    "trial_chambers/chamber/entrance_cap",
    "trial_chambers/chamber/eruption",
    "trial_chambers/chamber/eruption/breeze_slice_1",
    "trial_chambers/chamber/eruption/center_1",
    "trial_chambers/chamber/eruption/quadrant_1",
    "trial_chambers/chamber/eruption/quadrant_2",
    "trial_chambers/chamber/eruption/quadrant_3",
    "trial_chambers/chamber/eruption/quadrant_4",
    "trial_chambers/chamber/eruption/quadrant_5",
    "trial_chambers/chamber/eruption/slice_1",
    "trial_chambers/chamber/eruption/slice_2",
    "trial_chambers/chamber/eruption/slice_3",
    "trial_chambers/chamber/pedestal",
    "trial_chambers/chamber/pedestal/center_1",
    "trial_chambers/chamber/pedestal/ominous_slice_1",
    "trial_chambers/chamber/pedestal/quadrant_1",
    "trial_chambers/chamber/pedestal/quadrant_2",
    "trial_chambers/chamber/pedestal/quadrant_3",
    "trial_chambers/chamber/pedestal/slice_1",
    "trial_chambers/chamber/pedestal/slice_2",
    "trial_chambers/chamber/pedestal/slice_3",
    "trial_chambers/chamber/pedestal/slice_4",
    "trial_chambers/chamber/pedestal/slice_5",
    "trial_chambers/chamber/slanted",
    "trial_chambers/chamber/slanted/center",
    "trial_chambers/chamber/slanted/hallway_1",
    "trial_chambers/chamber/slanted/hallway_2",
    "trial_chambers/chamber/slanted/hallway_3",
    "trial_chambers/chamber/slanted/ominous_upper_arm_1",
    "trial_chambers/chamber/slanted/quadrant_1",
    "trial_chambers/chamber/slanted/quadrant_2",
    "trial_chambers/chamber/slanted/quadrant_3",
    "trial_chambers/chamber/slanted/quadrant_4",
    "trial_chambers/chamber/slanted/ramp_1",
    "trial_chambers/chamber/slanted/ramp_2",
    "trial_chambers/chamber/slanted/ramp_3",
    "trial_chambers/chamber/slanted/ramp_4",
    "trial_chambers/chests/connectors/supply",
    "trial_chambers/chests/supply",
    "trial_chambers/corridor/addon/arrow_dispenser",
    "trial_chambers/corridor/addon/bridge_lower",
    "trial_chambers/corridor/addon/chandelier_upper",
    "trial_chambers/corridor/addon/decoration_upper",
    "trial_chambers/corridor/addon/display_1",
    "trial_chambers/corridor/addon/display_2",
    "trial_chambers/corridor/addon/display_3",
    "trial_chambers/corridor/addon/head_upper",
    "trial_chambers/corridor/addon/ladder_to_middle",
    "trial_chambers/corridor/addon/open_walkway",
    "trial_chambers/corridor/addon/open_walkway_upper",
    "trial_chambers/corridor/addon/reward_upper",
    "trial_chambers/corridor/addon/staircase",
    "trial_chambers/corridor/addon/wall",
    "trial_chambers/corridor/addon/walled_walkway",
    "trial_chambers/corridor/atrium/bogged_relief",
    "trial_chambers/corridor/atrium/breeze_relief",
    "trial_chambers/corridor/atrium/grand_staircase_1",
    "trial_chambers/corridor/atrium/grand_staircase_2",
    "trial_chambers/corridor/atrium/grand_staircase_3",
    "trial_chambers/corridor/atrium/spider_relief",
    "trial_chambers/corridor/atrium/spiral_relief",
    "trial_chambers/corridor/atrium_1",
    "trial_chambers/corridor/end_1",
    "trial_chambers/corridor/end_2",
    "trial_chambers/corridor/entrance_1",
    "trial_chambers/corridor/entrance_2",
    "trial_chambers/corridor/entrance_3",
    "trial_chambers/corridor/first_plate",
    "trial_chambers/corridor/second_plate",
    "trial_chambers/corridor/straight_1",
    "trial_chambers/corridor/straight_2",
    "trial_chambers/corridor/straight_3",
    "trial_chambers/corridor/straight_4",
    "trial_chambers/corridor/straight_5",
    "trial_chambers/corridor/straight_6",
    "trial_chambers/corridor/straight_7",
    "trial_chambers/corridor/straight_8",
    "trial_chambers/decor/barrel",
    "trial_chambers/decor/black_bed",
    "trial_chambers/decor/blue_bed",
    "trial_chambers/decor/brown_bed",
    "trial_chambers/decor/candle_1",
    "trial_chambers/decor/candle_2",
    "trial_chambers/decor/candle_3",
    "trial_chambers/decor/candle_4",
    "trial_chambers/decor/cyan_bed",
    "trial_chambers/decor/dead_bush_pot",
    "trial_chambers/decor/disposal",
    "trial_chambers/decor/empty_pot",
    "trial_chambers/decor/flow_pot",
    "trial_chambers/decor/gray_bed",
    "trial_chambers/decor/green_bed",
    "trial_chambers/decor/guster_pot",
    "trial_chambers/decor/light_blue_bed",
    "trial_chambers/decor/light_gray_bed",
    "trial_chambers/decor/lime_bed",
    "trial_chambers/decor/magenta_bed",
    "trial_chambers/decor/orange_bed",
    "trial_chambers/decor/pink_bed",
    "trial_chambers/decor/purple_bed",
    "trial_chambers/decor/red_bed",
    "trial_chambers/decor/scrape_pot",
    "trial_chambers/decor/undecorated_pot",
    "trial_chambers/decor/white_bed",
    "trial_chambers/decor/yellow_bed",
    "trial_chambers/dispensers/chamber",
    "trial_chambers/dispensers/floor_dispenser",
    "trial_chambers/dispensers/wall_dispenser",
    "trial_chambers/hallway/cache_1",
    "trial_chambers/hallway/corner_staircase",
    "trial_chambers/hallway/corner_staircase_down",
    "trial_chambers/hallway/corridor_connector_1",
    "trial_chambers/hallway/encounter_1",
    "trial_chambers/hallway/encounter_2",
    "trial_chambers/hallway/encounter_3",
    "trial_chambers/hallway/encounter_4",
    "trial_chambers/hallway/encounter_5",
    "trial_chambers/hallway/left_corner",
    "trial_chambers/hallway/long_straight_staircase",
    "trial_chambers/hallway/long_straight_staircase_down",
    "trial_chambers/hallway/lower_hallway_connector",
    "trial_chambers/hallway/right_corner",
    "trial_chambers/hallway/rubble",
    "trial_chambers/hallway/rubble_chamber",
    "trial_chambers/hallway/rubble_chamber_thin",
    "trial_chambers/hallway/rubble_thin",
    "trial_chambers/hallway/straight",
    "trial_chambers/hallway/straight_staircase",
    "trial_chambers/hallway/straight_staircase_down",
    "trial_chambers/hallway/trapped_staircase",
    "trial_chambers/hallway/upper_hallway_connector",
    "trial_chambers/intersection/intersection_1",
    "trial_chambers/intersection/intersection_2",
    "trial_chambers/intersection/intersection_3",
    "trial_chambers/reward/ominous_vault",
    "trial_chambers/reward/vault",
    "trial_chambers/spawner/breeze/breeze",
    "trial_chambers/spawner/connectors/breeze",
    "trial_chambers/spawner/connectors/melee",
    "trial_chambers/spawner/connectors/ranged",
    "trial_chambers/spawner/connectors/slow_ranged",
    "trial_chambers/spawner/connectors/small_melee",
    "trial_chambers/spawner/melee/husk",
    "trial_chambers/spawner/melee/spider",
    "trial_chambers/spawner/melee/zombie",
    "trial_chambers/spawner/ranged/poison_skeleton",
    "trial_chambers/spawner/ranged/skeleton",
    "trial_chambers/spawner/ranged/stray",
    "trial_chambers/spawner/slow_ranged/poison_skeleton",
    "trial_chambers/spawner/slow_ranged/skeleton",
    "trial_chambers/spawner/slow_ranged/stray",
    "trial_chambers/spawner/small_melee/baby_zombie",
    "trial_chambers/spawner/small_melee/cave_spider",
    "trial_chambers/spawner/small_melee/silverfish",
    "trial_chambers/spawner/small_melee/slime",
    "underwater_ruin/big_brick_1",
    "underwater_ruin/big_brick_2",
    "underwater_ruin/big_brick_3",
    "underwater_ruin/big_brick_8",
    "underwater_ruin/big_cracked_1",
    "underwater_ruin/big_cracked_2",
    "underwater_ruin/big_cracked_3",
    "underwater_ruin/big_cracked_8",
    "underwater_ruin/big_mossy_1",
    "underwater_ruin/big_mossy_2",
    "underwater_ruin/big_mossy_3",
    "underwater_ruin/big_mossy_8",
    "underwater_ruin/big_warm_4",
    "underwater_ruin/big_warm_5",
    "underwater_ruin/big_warm_6",
    "underwater_ruin/big_warm_7",
    "underwater_ruin/brick_1",
    "underwater_ruin/brick_2",
    "underwater_ruin/brick_3",
    "underwater_ruin/brick_4",
    "underwater_ruin/brick_5",
    "underwater_ruin/brick_6",
    "underwater_ruin/brick_7",
    "underwater_ruin/brick_8",
    "underwater_ruin/cracked_1",
    "underwater_ruin/cracked_2",
    "underwater_ruin/cracked_3",
    "underwater_ruin/cracked_4",
    "underwater_ruin/cracked_5",
    "underwater_ruin/cracked_6",
    "underwater_ruin/cracked_7",
    "underwater_ruin/cracked_8",
    "underwater_ruin/mossy_1",
    "underwater_ruin/mossy_2",
    "underwater_ruin/mossy_3",
    "underwater_ruin/mossy_4",
    "underwater_ruin/mossy_5",
    "underwater_ruin/mossy_6",
    "underwater_ruin/mossy_7",
    "underwater_ruin/mossy_8",
    "underwater_ruin/warm_1",
    "underwater_ruin/warm_2",
    "underwater_ruin/warm_3",
    "underwater_ruin/warm_4",
    "underwater_ruin/warm_5",
    "underwater_ruin/warm_6",
    "underwater_ruin/warm_7",
    "underwater_ruin/warm_8",
    "village/common/animals/cat_black",
    "village/common/animals/cat_british",
    "village/common/animals/cat_calico",
    "village/common/animals/cat_jellie",
    "village/common/animals/cat_persian",
    "village/common/animals/cat_ragdoll",
    "village/common/animals/cat_red",
    "village/common/animals/cat_siamese",
    "village/common/animals/cat_tabby",
    "village/common/animals/cat_white",
    "village/common/animals/cows_1",
    "village/common/animals/horses_1",
    "village/common/animals/horses_2",
    "village/common/animals/horses_3",
    "village/common/animals/horses_4",
    "village/common/animals/horses_5",
    "village/common/animals/pigs_1",
    "village/common/animals/sheep_1",
    "village/common/animals/sheep_2",
    "village/common/iron_golem",
    "village/common/well_bottom",
    "village/decays/grass_11x13",
    "village/decays/grass_16x16",
    "village/decays/grass_9x9",
    "village/desert/camel_spawn",
    "village/desert/desert_lamp_1",
    "village/desert/houses/desert_animal_pen_1",
    "village/desert/houses/desert_animal_pen_2",
    "village/desert/houses/desert_armorer_1",
    "village/desert/houses/desert_butcher_shop_1",
    "village/desert/houses/desert_cartographer_house_1",
    "village/desert/houses/desert_farm_1",
    "village/desert/houses/desert_farm_2",
    "village/desert/houses/desert_fisher_1",
    "village/desert/houses/desert_fletcher_house_1",
    "village/desert/houses/desert_large_farm_1",
    "village/desert/houses/desert_library_1",
    "village/desert/houses/desert_mason_1",
    "village/desert/houses/desert_medium_house_1",
    "village/desert/houses/desert_medium_house_2",
    "village/desert/houses/desert_shepherd_house_1",
    "village/desert/houses/desert_small_house_1",
    "village/desert/houses/desert_small_house_2",
    "village/desert/houses/desert_small_house_3",
    "village/desert/houses/desert_small_house_4",
    "village/desert/houses/desert_small_house_5",
    "village/desert/houses/desert_small_house_6",
    "village/desert/houses/desert_small_house_7",
    "village/desert/houses/desert_small_house_8",
    "village/desert/houses/desert_tannery_1",
    "village/desert/houses/desert_temple_1",
    "village/desert/houses/desert_temple_2",
    "village/desert/houses/desert_tool_smith_1",
    "village/desert/houses/desert_weaponsmith_1",
    "village/desert/streets/corner_01",
    "village/desert/streets/corner_02",
    "village/desert/streets/crossroad_01",
    "village/desert/streets/crossroad_02",
    "village/desert/streets/crossroad_03",
    "village/desert/streets/square_01",
    "village/desert/streets/square_02",
    "village/desert/streets/straight_01",
    "village/desert/streets/straight_02",
    "village/desert/streets/straight_03",
    "village/desert/streets/turn_01",
    "village/desert/terminators/terminator_01",
    "village/desert/terminators/terminator_02",
    "village/desert/town_centers/desert_meeting_point_1",
    "village/desert/town_centers/desert_meeting_point_2",
    "village/desert/town_centers/desert_meeting_point_3",
    "village/desert/villagers/baby",
    "village/desert/villagers/nitwit",
    "village/desert/villagers/unemployed",
    "village/desert/zombie/houses/desert_medium_house_1",
    "village/desert/zombie/houses/desert_medium_house_2",
    "village/desert/zombie/houses/desert_small_house_1",
    "village/desert/zombie/houses/desert_small_house_2",
    "village/desert/zombie/houses/desert_small_house_3",
    "village/desert/zombie/houses/desert_small_house_4",
    "village/desert/zombie/houses/desert_small_house_5",
    "village/desert/zombie/houses/desert_small_house_6",
    "village/desert/zombie/houses/desert_small_house_7",
    "village/desert/zombie/houses/desert_small_house_8",
    "village/desert/zombie/streets/corner_01",
    "village/desert/zombie/streets/corner_02",
    "village/desert/zombie/streets/crossroad_01",
    "village/desert/zombie/streets/crossroad_02",
    "village/desert/zombie/streets/crossroad_03",
    "village/desert/zombie/streets/square_01",
    "village/desert/zombie/streets/square_02",
    "village/desert/zombie/streets/straight_01",
    "village/desert/zombie/streets/straight_02",
    "village/desert/zombie/streets/straight_03",
    "village/desert/zombie/streets/turn_01",
    "village/desert/zombie/terminators/terminator_02",
    "village/desert/zombie/town_centers/desert_meeting_point_1",
    "village/desert/zombie/town_centers/desert_meeting_point_2",
    "village/desert/zombie/town_centers/desert_meeting_point_3",
    "village/desert/zombie/villagers/nitwit",
    "village/desert/zombie/villagers/unemployed",
    "village/plains/houses/plains_accessory_1",
    "village/plains/houses/plains_animal_pen_1",
    "village/plains/houses/plains_animal_pen_2",
    "village/plains/houses/plains_animal_pen_3",
    "village/plains/houses/plains_armorer_house_1",
    "village/plains/houses/plains_big_house_1",
    "village/plains/houses/plains_butcher_shop_1",
    "village/plains/houses/plains_butcher_shop_2",
    "village/plains/houses/plains_cartographer_1",
    "village/plains/houses/plains_fisher_cottage_1",
    "village/plains/houses/plains_fletcher_house_1",
    "village/plains/houses/plains_large_farm_1",
    "village/plains/houses/plains_library_1",
    "village/plains/houses/plains_library_2",
    "village/plains/houses/plains_masons_house_1",
    "village/plains/houses/plains_medium_house_1",
    "village/plains/houses/plains_medium_house_2",
    "village/plains/houses/plains_meeting_point_4",
    "village/plains/houses/plains_meeting_point_5",
    "village/plains/houses/plains_shepherds_house_1",
    "village/plains/houses/plains_small_farm_1",
    "village/plains/houses/plains_small_house_1",
    "village/plains/houses/plains_small_house_2",
    "village/plains/houses/plains_small_house_3",
    "village/plains/houses/plains_small_house_4",
    "village/plains/houses/plains_small_house_5",
    "village/plains/houses/plains_small_house_6",
    "village/plains/houses/plains_small_house_7",
    "village/plains/houses/plains_small_house_8",
    "village/plains/houses/plains_stable_1",
    "village/plains/houses/plains_stable_2",
    "village/plains/houses/plains_tannery_1",
    "village/plains/houses/plains_temple_3",
    "village/plains/houses/plains_temple_4",
    "village/plains/houses/plains_tool_smith_1",
    "village/plains/houses/plains_weaponsmith_1",
    "village/plains/plains_lamp_1",
    "village/plains/streets/corner_01",
    "village/plains/streets/corner_02",
    "village/plains/streets/corner_03",
    "village/plains/streets/crossroad_01",
    "village/plains/streets/crossroad_02",
    "village/plains/streets/crossroad_03",
    "village/plains/streets/crossroad_04",
    "village/plains/streets/crossroad_05",
    "village/plains/streets/crossroad_06",
    "village/plains/streets/straight_01",
    "village/plains/streets/straight_02",
    "village/plains/streets/straight_03",
    "village/plains/streets/straight_04",
    "village/plains/streets/straight_05",
    "village/plains/streets/straight_06",
    "village/plains/streets/turn_01",
    "village/plains/terminators/terminator_01",
    "village/plains/terminators/terminator_02",
    "village/plains/terminators/terminator_03",
    "village/plains/terminators/terminator_04",
    "village/plains/town_centers/plains_fountain_01",
    "village/plains/town_centers/plains_meeting_point_1",
    "village/plains/town_centers/plains_meeting_point_2",
    "village/plains/town_centers/plains_meeting_point_3",
    "village/plains/villagers/baby",
    "village/plains/villagers/nitwit",
    "village/plains/villagers/unemployed",
    "village/plains/zombie/houses/plains_animal_pen_3",
    "village/plains/zombie/houses/plains_big_house_1",
    "village/plains/zombie/houses/plains_butcher_shop_2",
    "village/plains/zombie/houses/plains_fletcher_house_1",
    "village/plains/zombie/houses/plains_medium_house_1",
    "village/plains/zombie/houses/plains_medium_house_2",
    "village/plains/zombie/houses/plains_meeting_point_4",
    "village/plains/zombie/houses/plains_meeting_point_5",
    "village/plains/zombie/houses/plains_shepherds_house_1",
    "village/plains/zombie/houses/plains_small_house_1",
    "village/plains/zombie/houses/plains_small_house_2",
    "village/plains/zombie/houses/plains_small_house_3",
    "village/plains/zombie/houses/plains_small_house_4",
    "village/plains/zombie/houses/plains_small_house_5",
    "village/plains/zombie/houses/plains_small_house_6",
    "village/plains/zombie/houses/plains_small_house_7",
    "village/plains/zombie/houses/plains_small_house_8",
    "village/plains/zombie/houses/plains_stable_1",
    "village/plains/zombie/streets/corner_01",
    "village/plains/zombie/streets/corner_02",
    "village/plains/zombie/streets/corner_03",
    "village/plains/zombie/streets/crossroad_01",
    "village/plains/zombie/streets/crossroad_02",
    "village/plains/zombie/streets/crossroad_03",
    "village/plains/zombie/streets/crossroad_04",
    "village/plains/zombie/streets/crossroad_05",
    "village/plains/zombie/streets/crossroad_06",
    "village/plains/zombie/streets/straight_01",
    "village/plains/zombie/streets/straight_02",
    "village/plains/zombie/streets/straight_03",
    "village/plains/zombie/streets/straight_04",
    "village/plains/zombie/streets/straight_05",
    "village/plains/zombie/streets/straight_06",
    "village/plains/zombie/streets/turn_01",
    "village/plains/zombie/town_centers/plains_fountain_01",
    "village/plains/zombie/town_centers/plains_meeting_point_1",
    "village/plains/zombie/town_centers/plains_meeting_point_2",
    "village/plains/zombie/town_centers/plains_meeting_point_3",
    "village/plains/zombie/villagers/nitwit",
    "village/plains/zombie/villagers/unemployed",
    "village/savanna/houses/savanna_animal_pen_1",
    "village/savanna/houses/savanna_animal_pen_2",
    "village/savanna/houses/savanna_animal_pen_3",
    "village/savanna/houses/savanna_armorer_1",
    "village/savanna/houses/savanna_butchers_shop_1",
    "village/savanna/houses/savanna_butchers_shop_2",
    "village/savanna/houses/savanna_cartographer_1",
    "village/savanna/houses/savanna_fisher_cottage_1",
    "village/savanna/houses/savanna_fletcher_house_1",
    "village/savanna/houses/savanna_large_farm_1",
    "village/savanna/houses/savanna_large_farm_2",
    "village/savanna/houses/savanna_library_1",
    "village/savanna/houses/savanna_mason_1",
    "village/savanna/houses/savanna_medium_house_1",
    "village/savanna/houses/savanna_medium_house_2",
    "village/savanna/houses/savanna_shepherd_1",
    "village/savanna/houses/savanna_small_farm",
    "village/savanna/houses/savanna_small_house_1",
    "village/savanna/houses/savanna_small_house_2",
    "village/savanna/houses/savanna_small_house_3",
    "village/savanna/houses/savanna_small_house_4",
    "village/savanna/houses/savanna_small_house_5",
    "village/savanna/houses/savanna_small_house_6",
    "village/savanna/houses/savanna_small_house_7",
    "village/savanna/houses/savanna_small_house_8",
    "village/savanna/houses/savanna_tannery_1",
    "village/savanna/houses/savanna_temple_1",
    "village/savanna/houses/savanna_temple_2",
    "village/savanna/houses/savanna_tool_smith_1",
    "village/savanna/houses/savanna_weaponsmith_1",
    "village/savanna/houses/savanna_weaponsmith_2",
    "village/savanna/savanna_lamp_post_01",
    "village/savanna/streets/corner_01",
    "village/savanna/streets/corner_03",
    "village/savanna/streets/crossroad_02",
    "village/savanna/streets/crossroad_03",
    "village/savanna/streets/crossroad_04",
    "village/savanna/streets/crossroad_05",
    "village/savanna/streets/crossroad_06",
    "village/savanna/streets/crossroad_07",
    "village/savanna/streets/split_01",
    "village/savanna/streets/split_02",
    "village/savanna/streets/straight_02",
    "village/savanna/streets/straight_04",
    "village/savanna/streets/straight_05",
    "village/savanna/streets/straight_06",
    "village/savanna/streets/straight_08",
    "village/savanna/streets/straight_09",
    "village/savanna/streets/straight_10",
    "village/savanna/streets/straight_11",
    "village/savanna/streets/turn_01",
    "village/savanna/terminators/terminator_05",
    "village/savanna/town_centers/savanna_meeting_point_1",
    "village/savanna/town_centers/savanna_meeting_point_2",
    "village/savanna/town_centers/savanna_meeting_point_3",
    "village/savanna/town_centers/savanna_meeting_point_4",
    "village/savanna/villagers/baby",
    "village/savanna/villagers/nitwit",
    "village/savanna/villagers/unemployed",
    "village/savanna/zombie/houses/savanna_animal_pen_2",
    "village/savanna/zombie/houses/savanna_animal_pen_3",
    "village/savanna/zombie/houses/savanna_large_farm_2",
    "village/savanna/zombie/houses/savanna_medium_house_1",
    "village/savanna/zombie/houses/savanna_medium_house_2",
    "village/savanna/zombie/houses/savanna_small_house_1",
    "village/savanna/zombie/houses/savanna_small_house_2",
    "village/savanna/zombie/houses/savanna_small_house_3",
    "village/savanna/zombie/houses/savanna_small_house_4",
    "village/savanna/zombie/houses/savanna_small_house_5",
    "village/savanna/zombie/houses/savanna_small_house_6",
    "village/savanna/zombie/houses/savanna_small_house_7",
    "village/savanna/zombie/houses/savanna_small_house_8",
    "village/savanna/zombie/streets/corner_01",
    "village/savanna/zombie/streets/corner_03",
    "village/savanna/zombie/streets/crossroad_02",
    "village/savanna/zombie/streets/crossroad_03",
    "village/savanna/zombie/streets/crossroad_04",
    "village/savanna/zombie/streets/crossroad_05",
    "village/savanna/zombie/streets/crossroad_06",
    "village/savanna/zombie/streets/crossroad_07",
    "village/savanna/zombie/streets/split_01",
    "village/savanna/zombie/streets/split_02",
    "village/savanna/zombie/streets/straight_02",
    "village/savanna/zombie/streets/straight_04",
    "village/savanna/zombie/streets/straight_05",
    "village/savanna/zombie/streets/straight_06",
    "village/savanna/zombie/streets/straight_08",
    "village/savanna/zombie/streets/straight_09",
    "village/savanna/zombie/streets/straight_10",
    "village/savanna/zombie/streets/straight_11",
    "village/savanna/zombie/streets/turn_01",
    "village/savanna/zombie/terminators/terminator_05",
    "village/savanna/zombie/town_centers/savanna_meeting_point_1",
    "village/savanna/zombie/town_centers/savanna_meeting_point_2",
    "village/savanna/zombie/town_centers/savanna_meeting_point_3",
    "village/savanna/zombie/town_centers/savanna_meeting_point_4",
    "village/savanna/zombie/villagers/nitwit",
    "village/savanna/zombie/villagers/unemployed",
    "village/snowy/houses/snowy_animal_pen_1",
    "village/snowy/houses/snowy_animal_pen_2",
    "village/snowy/houses/snowy_armorer_house_1",
    "village/snowy/houses/snowy_armorer_house_2",
    "village/snowy/houses/snowy_butchers_shop_1",
    "village/snowy/houses/snowy_butchers_shop_2",
    "village/snowy/houses/snowy_cartographer_house_1",
    "village/snowy/houses/snowy_farm_1",
    "village/snowy/houses/snowy_farm_2",
    "village/snowy/houses/snowy_fisher_cottage",
    "village/snowy/houses/snowy_fletcher_house_1",
    "village/snowy/houses/snowy_library_1",
    "village/snowy/houses/snowy_masons_house_1",
    "village/snowy/houses/snowy_masons_house_2",
    "village/snowy/houses/snowy_medium_house_1",
    "village/snowy/houses/snowy_medium_house_2",
    "village/snowy/houses/snowy_medium_house_3",
    "village/snowy/houses/snowy_shepherds_house_1",
    "village/snowy/houses/snowy_small_house_1",
    "village/snowy/houses/snowy_small_house_2",
    "village/snowy/houses/snowy_small_house_3",
    "village/snowy/houses/snowy_small_house_4",
    "village/snowy/houses/snowy_small_house_5",
    "village/snowy/houses/snowy_small_house_6",
    "village/snowy/houses/snowy_small_house_7",
    "village/snowy/houses/snowy_small_house_8",
    "village/snowy/houses/snowy_tannery_1",
    "village/snowy/houses/snowy_temple_1",
    "village/snowy/houses/snowy_tool_smith_1",
    "village/snowy/houses/snowy_weapon_smith_1",
    "village/snowy/snowy_lamp_post_01",
    "village/snowy/snowy_lamp_post_02",
    "village/snowy/snowy_lamp_post_03",
    "village/snowy/streets/corner_01",
    "village/snowy/streets/corner_02",
    "village/snowy/streets/corner_03",
    "village/snowy/streets/crossroad_01",
    "village/snowy/streets/crossroad_02",
    "village/snowy/streets/crossroad_03",
    "village/snowy/streets/crossroad_04",
    "village/snowy/streets/crossroad_05",
    "village/snowy/streets/crossroad_06",
    "village/snowy/streets/square_01",
    "village/snowy/streets/straight_01",
    "village/snowy/streets/straight_02",
    "village/snowy/streets/straight_03",
    "village/snowy/streets/straight_04",
    "village/snowy/streets/straight_06",
    "village/snowy/streets/straight_08",
    "village/snowy/streets/turn_01",
    "village/snowy/town_centers/snowy_meeting_point_1",
    "village/snowy/town_centers/snowy_meeting_point_2",
    "village/snowy/town_centers/snowy_meeting_point_3",
    "village/snowy/villagers/baby",
    "village/snowy/villagers/nitwit",
    "village/snowy/villagers/unemployed",
    "village/snowy/zombie/houses/snowy_medium_house_1",
    "village/snowy/zombie/houses/snowy_medium_house_2",
    "village/snowy/zombie/houses/snowy_medium_house_3",
    "village/snowy/zombie/houses/snowy_small_house_1",
    "village/snowy/zombie/houses/snowy_small_house_2",
    "village/snowy/zombie/houses/snowy_small_house_3",
    "village/snowy/zombie/houses/snowy_small_house_4",
    "village/snowy/zombie/houses/snowy_small_house_5",
    "village/snowy/zombie/houses/snowy_small_house_6",
    "village/snowy/zombie/houses/snowy_small_house_7",
    "village/snowy/zombie/houses/snowy_small_house_8",
    "village/snowy/zombie/streets/corner_01",
    "village/snowy/zombie/streets/corner_02",
    "village/snowy/zombie/streets/corner_03",
    "village/snowy/zombie/streets/crossroad_01",
    "village/snowy/zombie/streets/crossroad_02",
    "village/snowy/zombie/streets/crossroad_03",
    "village/snowy/zombie/streets/crossroad_04",
    "village/snowy/zombie/streets/crossroad_05",
    "village/snowy/zombie/streets/crossroad_06",
    "village/snowy/zombie/streets/square_01",
    "village/snowy/zombie/streets/straight_01",
    "village/snowy/zombie/streets/straight_02",
    "village/snowy/zombie/streets/straight_03",
    "village/snowy/zombie/streets/straight_04",
    "village/snowy/zombie/streets/straight_06",
    "village/snowy/zombie/streets/straight_08",
    "village/snowy/zombie/streets/turn_01",
    "village/snowy/zombie/town_centers/snowy_meeting_point_1",
    "village/snowy/zombie/town_centers/snowy_meeting_point_2",
    "village/snowy/zombie/town_centers/snowy_meeting_point_3",
    "village/snowy/zombie/villagers/nitwit",
    "village/snowy/zombie/villagers/unemployed",
    "village/taiga/houses/taiga_animal_pen_1",
    "village/taiga/houses/taiga_armorer_2",
    "village/taiga/houses/taiga_armorer_house_1",
    "village/taiga/houses/taiga_butcher_shop_1",
    "village/taiga/houses/taiga_cartographer_house_1",
    "village/taiga/houses/taiga_fisher_cottage_1",
    "village/taiga/houses/taiga_fletcher_house_1",
    "village/taiga/houses/taiga_large_farm_1",
    "village/taiga/houses/taiga_large_farm_2",
    "village/taiga/houses/taiga_library_1",
    "village/taiga/houses/taiga_masons_house_1",
    "village/taiga/houses/taiga_medium_house_1",
    "village/taiga/houses/taiga_medium_house_2",
    "village/taiga/houses/taiga_medium_house_3",
    "village/taiga/houses/taiga_medium_house_4",
    "village/taiga/houses/taiga_shepherds_house_1",
    "village/taiga/houses/taiga_small_farm_1",
    "village/taiga/houses/taiga_small_house_1",
    "village/taiga/houses/taiga_small_house_2",
    "village/taiga/houses/taiga_small_house_3",
    "village/taiga/houses/taiga_small_house_4",
    "village/taiga/houses/taiga_small_house_5",
    "village/taiga/houses/taiga_tannery_1",
    "village/taiga/houses/taiga_temple_1",
    "village/taiga/houses/taiga_tool_smith_1",
    "village/taiga/houses/taiga_weaponsmith_1",
    "village/taiga/houses/taiga_weaponsmith_2",
    "village/taiga/streets/corner_01",
    "village/taiga/streets/corner_02",
    "village/taiga/streets/corner_03",
    "village/taiga/streets/crossroad_01",
    "village/taiga/streets/crossroad_02",
    "village/taiga/streets/crossroad_03",
    "village/taiga/streets/crossroad_04",
    "village/taiga/streets/crossroad_05",
    "village/taiga/streets/crossroad_06",
    "village/taiga/streets/straight_01",
    "village/taiga/streets/straight_02",
    "village/taiga/streets/straight_03",
    "village/taiga/streets/straight_04",
    "village/taiga/streets/straight_05",
    "village/taiga/streets/straight_06",
    "village/taiga/streets/turn_01",
    "village/taiga/taiga_decoration_1",
    "village/taiga/taiga_decoration_2",
    "village/taiga/taiga_decoration_3",
    "village/taiga/taiga_decoration_4",
    "village/taiga/taiga_decoration_5",
    "village/taiga/taiga_decoration_6",
    "village/taiga/taiga_lamp_post_1",
    "village/taiga/town_centers/taiga_meeting_point_1",
    "village/taiga/town_centers/taiga_meeting_point_2",
    "village/taiga/villagers/baby",
    "village/taiga/villagers/nitwit",
    "village/taiga/villagers/unemployed",
    "village/taiga/zombie/houses/taiga_cartographer_house_1",
    "village/taiga/zombie/houses/taiga_fisher_cottage_1",
    "village/taiga/zombie/houses/taiga_large_farm_2",
    "village/taiga/zombie/houses/taiga_library_1",
    "village/taiga/zombie/houses/taiga_medium_house_1",
    "village/taiga/zombie/houses/taiga_medium_house_2",
    "village/taiga/zombie/houses/taiga_medium_house_3",
    "village/taiga/zombie/houses/taiga_medium_house_4",
    "village/taiga/zombie/houses/taiga_shepherds_house_1",
    "village/taiga/zombie/houses/taiga_small_house_1",
    "village/taiga/zombie/houses/taiga_small_house_2",
    "village/taiga/zombie/houses/taiga_small_house_3",
    "village/taiga/zombie/houses/taiga_small_house_4",
    "village/taiga/zombie/houses/taiga_small_house_5",
    "village/taiga/zombie/houses/taiga_temple_1",
    "village/taiga/zombie/houses/taiga_tool_smith_1",
    "village/taiga/zombie/houses/taiga_weaponsmith_2",
    "village/taiga/zombie/streets/corner_01",
    "village/taiga/zombie/streets/corner_02",
    "village/taiga/zombie/streets/corner_03",
    "village/taiga/zombie/streets/crossroad_01",
    "village/taiga/zombie/streets/crossroad_02",
    "village/taiga/zombie/streets/crossroad_03",
    "village/taiga/zombie/streets/crossroad_04",
    "village/taiga/zombie/streets/crossroad_05",
    "village/taiga/zombie/streets/crossroad_06",
    "village/taiga/zombie/streets/straight_01",
    "village/taiga/zombie/streets/straight_02",
    "village/taiga/zombie/streets/straight_03",
    "village/taiga/zombie/streets/straight_04",
    "village/taiga/zombie/streets/straight_05",
    "village/taiga/zombie/streets/straight_06",
    "village/taiga/zombie/streets/turn_01",
    "village/taiga/zombie/town_centers/taiga_meeting_point_1",
    "village/taiga/zombie/town_centers/taiga_meeting_point_2",
    "village/taiga/zombie/villagers/nitwit",
    "village/taiga/zombie/villagers/unemployed",
    "woodland_mansion/1x1_a1",
    "woodland_mansion/1x1_a2",
    "woodland_mansion/1x1_a3",
    "woodland_mansion/1x1_a4",
    "woodland_mansion/1x1_a5",
    "woodland_mansion/1x1_as1",
    "woodland_mansion/1x1_as2",
    "woodland_mansion/1x1_as3",
    "woodland_mansion/1x1_as4",
    "woodland_mansion/1x1_b1",
    "woodland_mansion/1x1_b2",
    "woodland_mansion/1x1_b3",
    "woodland_mansion/1x1_b4",
    "woodland_mansion/1x1_b5",
    "woodland_mansion/1x2_a1",
    "woodland_mansion/1x2_a2",
    "woodland_mansion/1x2_a3",
    "woodland_mansion/1x2_a4",
    "woodland_mansion/1x2_a5",
    "woodland_mansion/1x2_a6",
    "woodland_mansion/1x2_a7",
    "woodland_mansion/1x2_a8",
    "woodland_mansion/1x2_a9",
    "woodland_mansion/1x2_b1",
    "woodland_mansion/1x2_b2",
    "woodland_mansion/1x2_b3",
    "woodland_mansion/1x2_b4",
    "woodland_mansion/1x2_b5",
    "woodland_mansion/1x2_c1",
    "woodland_mansion/1x2_c2",
    "woodland_mansion/1x2_c3",
    "woodland_mansion/1x2_c4",
    "woodland_mansion/1x2_c_stairs",
    "woodland_mansion/1x2_d1",
    "woodland_mansion/1x2_d2",
    "woodland_mansion/1x2_d3",
    "woodland_mansion/1x2_d4",
    "woodland_mansion/1x2_d5",
    "woodland_mansion/1x2_d_stairs",
    "woodland_mansion/1x2_s1",
    "woodland_mansion/1x2_s2",
    "woodland_mansion/1x2_se1",
    "woodland_mansion/2x2_a1",
    "woodland_mansion/2x2_a2",
    "woodland_mansion/2x2_a3",
    "woodland_mansion/2x2_a4",
    "woodland_mansion/2x2_b1",
    "woodland_mansion/2x2_b2",
    "woodland_mansion/2x2_b3",
    "woodland_mansion/2x2_b4",
    "woodland_mansion/2x2_b5",
    "woodland_mansion/2x2_s1",
    "woodland_mansion/carpet_east",
    "woodland_mansion/carpet_north",
    "woodland_mansion/carpet_south_1",
    "woodland_mansion/carpet_south_2",
    "woodland_mansion/carpet_west_1",
    "woodland_mansion/carpet_west_2",
    "woodland_mansion/corridor_floor",
    "woodland_mansion/entrance",
    "woodland_mansion/indoors_door_1",
    "woodland_mansion/indoors_door_2",
    "woodland_mansion/indoors_wall_1",
    "woodland_mansion/indoors_wall_2",
    "woodland_mansion/roof",
    "woodland_mansion/roof_corner",
    "woodland_mansion/roof_front",
    "woodland_mansion/roof_inner_corner",
    "woodland_mansion/small_wall",
    "woodland_mansion/small_wall_corner",
    "woodland_mansion/wall_corner",
    "woodland_mansion/wall_flat",
    "woodland_mansion/wall_window"
  ]);
});

// src/arguments/generated/_registry/sulfur_cube_archetypes.ts
var SULFUR_CUBE_ARCHETYPES_SET;
var init_sulfur_cube_archetypes = __esm(() => {
  init_sandstone();
  SULFUR_CUBE_ARCHETYPES_SET = new Set2([
    "bouncy",
    "explosive",
    "fast_flat",
    "fast_sliding",
    "high_resistance",
    "hot",
    "light",
    "regular",
    "slow_bouncy",
    "slow_flat",
    "slow_sliding",
    "sticky"
  ]);
});

// src/arguments/generated/_registry/test_environments.ts
var TEST_ENVIRONMENTS_SET;
var init_test_environments = __esm(() => {
  init_sandstone();
  TEST_ENVIRONMENTS_SET = new Set2([
    "default"
  ]);
});

// src/arguments/generated/_registry/test_instances.ts
var TEST_INSTANCES_SET;
var init_test_instances = __esm(() => {
  init_sandstone();
  TEST_INSTANCES_SET = new Set2([
    "always_pass"
  ]);
});

// src/arguments/generated/_registry/timelines.ts
var TIMELINES_SET;
var init_timelines = __esm(() => {
  init_sandstone();
  TIMELINES_SET = new Set2([
    "day",
    "early_game",
    "moon",
    "villager_schedule"
  ]);
});

// src/arguments/generated/_registry/trade_sets.ts
var TRADE_SETS_SET;
var init_trade_sets = __esm(() => {
  init_sandstone();
  TRADE_SETS_SET = new Set2([
    "armorer/level_1",
    "armorer/level_2",
    "armorer/level_3",
    "armorer/level_4",
    "armorer/level_5",
    "butcher/level_1",
    "butcher/level_2",
    "butcher/level_3",
    "butcher/level_4",
    "butcher/level_5",
    "cartographer/level_1",
    "cartographer/level_2",
    "cartographer/level_3",
    "cartographer/level_4",
    "cartographer/level_5",
    "cleric/level_1",
    "cleric/level_2",
    "cleric/level_3",
    "cleric/level_4",
    "cleric/level_5",
    "farmer/level_1",
    "farmer/level_2",
    "farmer/level_3",
    "farmer/level_4",
    "farmer/level_5",
    "fisherman/level_1",
    "fisherman/level_2",
    "fisherman/level_3",
    "fisherman/level_4",
    "fisherman/level_5",
    "fletcher/level_1",
    "fletcher/level_2",
    "fletcher/level_3",
    "fletcher/level_4",
    "fletcher/level_5",
    "leatherworker/level_1",
    "leatherworker/level_2",
    "leatherworker/level_3",
    "leatherworker/level_4",
    "leatherworker/level_5",
    "librarian/level_1",
    "librarian/level_2",
    "librarian/level_3",
    "librarian/level_4",
    "librarian/level_5",
    "mason/level_1",
    "mason/level_2",
    "mason/level_3",
    "mason/level_4",
    "mason/level_5",
    "shepherd/level_1",
    "shepherd/level_2",
    "shepherd/level_3",
    "shepherd/level_4",
    "shepherd/level_5",
    "toolsmith/level_1",
    "toolsmith/level_2",
    "toolsmith/level_3",
    "toolsmith/level_4",
    "toolsmith/level_5",
    "wandering_trader/buying",
    "wandering_trader/common",
    "wandering_trader/uncommon",
    "weaponsmith/level_1",
    "weaponsmith/level_2",
    "weaponsmith/level_3",
    "weaponsmith/level_4",
    "weaponsmith/level_5"
  ]);
});

// src/arguments/generated/_registry/trial_spawners.ts
var TRIAL_SPAWNERS_SET;
var init_trial_spawners = __esm(() => {
  init_sandstone();
  TRIAL_SPAWNERS_SET = new Set2([
    "trial_chamber/breeze/normal",
    "trial_chamber/breeze/ominous",
    "trial_chamber/melee/husk/normal",
    "trial_chamber/melee/husk/ominous",
    "trial_chamber/melee/spider/normal",
    "trial_chamber/melee/spider/ominous",
    "trial_chamber/melee/zombie/normal",
    "trial_chamber/melee/zombie/ominous",
    "trial_chamber/ranged/poison_skeleton/normal",
    "trial_chamber/ranged/poison_skeleton/ominous",
    "trial_chamber/ranged/skeleton/normal",
    "trial_chamber/ranged/skeleton/ominous",
    "trial_chamber/ranged/stray/normal",
    "trial_chamber/ranged/stray/ominous",
    "trial_chamber/slow_ranged/poison_skeleton/normal",
    "trial_chamber/slow_ranged/poison_skeleton/ominous",
    "trial_chamber/slow_ranged/skeleton/normal",
    "trial_chamber/slow_ranged/skeleton/ominous",
    "trial_chamber/slow_ranged/stray/normal",
    "trial_chamber/slow_ranged/stray/ominous",
    "trial_chamber/small_melee/baby_zombie/normal",
    "trial_chamber/small_melee/baby_zombie/ominous",
    "trial_chamber/small_melee/cave_spider/normal",
    "trial_chamber/small_melee/cave_spider/ominous",
    "trial_chamber/small_melee/silverfish/normal",
    "trial_chamber/small_melee/silverfish/ominous",
    "trial_chamber/small_melee/slime/normal",
    "trial_chamber/small_melee/slime/ominous"
  ]);
});

// src/arguments/generated/_registry/trim_materials.ts
var TRIM_MATERIALS_SET;
var init_trim_materials = __esm(() => {
  init_sandstone();
  TRIM_MATERIALS_SET = new Set2([
    "amethyst",
    "copper",
    "diamond",
    "emerald",
    "gold",
    "iron",
    "lapis",
    "netherite",
    "quartz",
    "redstone",
    "resin"
  ]);
});

// src/arguments/generated/_registry/trim_patterns.ts
var TRIM_PATTERNS_SET;
var init_trim_patterns = __esm(() => {
  init_sandstone();
  TRIM_PATTERNS_SET = new Set2([
    "bolt",
    "coast",
    "dune",
    "eye",
    "flow",
    "host",
    "raiser",
    "rib",
    "sentry",
    "shaper",
    "silence",
    "snout",
    "spire",
    "tide",
    "vex",
    "ward",
    "wayfinder",
    "wild"
  ]);
});

// src/arguments/generated/_registry/villager_trades.ts
var VILLAGER_TRADES_SET;
var init_villager_trades = __esm(() => {
  init_sandstone();
  VILLAGER_TRADES_SET = new Set2([
    "armorer/1/emerald_iron_boots",
    "armorer/1/emerald_iron_chestplate",
    "armorer/1/emerald_iron_helmet",
    "armorer/1/emerald_iron_leggings",
    "armorer/2/emerald_chainmail_boots",
    "armorer/2/emerald_chainmail_leggings",
    "armorer/3/diamond_emerald",
    "armorer/3/emerald_chainmail_chestplate",
    "armorer/3/emerald_chainmail_helmet",
    "armorer/3/emerald_shield",
    "armorer/3/lava_bucket_emerald",
    "armorer/4/emerald_enchanted_diamond_boots",
    "armorer/4/emerald_enchanted_diamond_leggings",
    "armorer/5/emerald_enchanted_diamond_chestplate",
    "armorer/5/emerald_enchanted_diamond_helmet",
    "butcher/1/chicken_emerald",
    "butcher/1/emerald_rabbit_stew",
    "butcher/1/porkchop_emerald",
    "butcher/1/rabbit_emerald",
    "butcher/2/coal_emerald",
    "butcher/2/emerald_cooked_chicken",
    "butcher/2/emerald_cooked_porkchop",
    "butcher/3/beef_emerald",
    "butcher/3/mutton_emerald",
    "butcher/4/dried_kelp_block_emerald",
    "butcher/5/sweet_berries_emerald",
    "cartographer/1/emerald_map",
    "cartographer/1/paper_emerald",
    "cartographer/2/emerald_and_compass_explorer_jungle_map",
    "cartographer/2/emerald_and_compass_explorer_swamp_map",
    "cartographer/2/emerald_and_compass_village_desert_map",
    "cartographer/2/emerald_and_compass_village_plains_map",
    "cartographer/2/emerald_and_compass_village_savanna_map",
    "cartographer/2/emerald_and_compass_village_snowy_map",
    "cartographer/2/emerald_and_compass_village_taiga_map",
    "cartographer/2/glass_pane_emerald",
    "cartographer/3/compass_emerald",
    "cartographer/3/emerald_and_compass_ocean_explorer_map",
    "cartographer/3/emerald_and_compass_trial_chamber_map",
    "cartographer/4/emerald_black_banner",
    "cartographer/4/emerald_blue_banner",
    "cartographer/4/emerald_brown_banner",
    "cartographer/4/emerald_cyan_banner",
    "cartographer/4/emerald_gray_banner",
    "cartographer/4/emerald_green_banner",
    "cartographer/4/emerald_item_frame",
    "cartographer/4/emerald_light_blue_banner",
    "cartographer/4/emerald_lime_banner",
    "cartographer/4/emerald_magenta_banner",
    "cartographer/4/emerald_orange_banner",
    "cartographer/4/emerald_pink_banner",
    "cartographer/4/emerald_purple_banner",
    "cartographer/4/emerald_red_banner",
    "cartographer/4/emerald_white_banner",
    "cartographer/4/emerald_yellow_banner",
    "cartographer/5/emerald_and_compass_woodland_mansion_map",
    "cartographer/5/emerald_globe_banner_pattern",
    "cleric/1/emerald_redstone",
    "cleric/1/rotten_flesh_emerald",
    "cleric/2/emerald_lapis_lazuli",
    "cleric/2/gold_ingot_emerald",
    "cleric/3/emerald_glowstone",
    "cleric/3/rabbit_foot_emerald",
    "cleric/4/emerald_ender_pearl",
    "cleric/4/glass_bottle_emerald",
    "cleric/4/turtle_scute_emerald",
    "cleric/5/emerald_experience_bottle",
    "cleric/5/nether_wart_emerald",
    "farmer/1/beetroot_emerald",
    "farmer/1/carrot_emerald",
    "farmer/1/emerald_bread",
    "farmer/1/potato_emerald",
    "farmer/1/wheat_emerald",
    "farmer/2/emerald_apple",
    "farmer/2/emerald_pumpkin_pie",
    "farmer/2/pumpkin_emerald",
    "farmer/3/emerald_cookie",
    "farmer/3/melon_emerald",
    "farmer/4/emerald_cake",
    "farmer/4/emerald_suspicious_stew",
    "farmer/5/emerald_glistening_melon_slice",
    "farmer/5/emerald_golden_carrot",
    "fisherman/1/coal_emerald",
    "fisherman/1/emerald_cod_bucket",
    "fisherman/1/raw_cod_and_emerald_cooked_cod",
    "fisherman/1/string_emerald",
    "fisherman/2/cod_emerald",
    "fisherman/2/emerald_campfire",
    "fisherman/2/salmon_and_emerald_cooked_salmon",
    "fisherman/3/emerald_enchanted_fishing_rod",
    "fisherman/3/salmon_emerald",
    "fisherman/4/tropical_fish_emerald",
    "fisherman/5/acacia_boat_emerald",
    "fisherman/5/dark_oak_boat_emerald",
    "fisherman/5/jungle_boat_emerald",
    "fisherman/5/oak_boat_emerald",
    "fisherman/5/pufferfish_emerald",
    "fisherman/5/spruce_boat_emerald",
    "fletcher/1/emerald_arrow",
    "fletcher/1/gravel_and_emerald_flint",
    "fletcher/1/stick_emerald",
    "fletcher/2/emerald_bow",
    "fletcher/2/flint_emerald",
    "fletcher/3/emerald_crossbow",
    "fletcher/3/string_emerald",
    "fletcher/4/emerald_enchanted_bow",
    "fletcher/4/feather_emerald",
    "fletcher/5/arrow_and_emerald_tipped_arrow",
    "fletcher/5/emerald_enchanted_crossbow",
    "fletcher/5/tripwire_hook_emerald",
    "leatherworker/1/emerald_dyed_leather_chestplate",
    "leatherworker/1/emerald_dyed_leather_leggings",
    "leatherworker/1/leather_emerald",
    "leatherworker/2/emerald_dyed_leather_boots",
    "leatherworker/2/emerald_dyed_leather_helmet",
    "leatherworker/2/flint_emerald",
    "leatherworker/3/emerald_dyed_leather_chestplate",
    "leatherworker/3/rabbit_hide_emerald",
    "leatherworker/4/emerald_dyed_leather_horse_armor",
    "leatherworker/4/turtle_scute_emerald",
    "leatherworker/5/emerald_dyed_leather_helmet",
    "leatherworker/5/emerald_saddle",
    "librarian/1/emerald_and_book_enchanted_book",
    "librarian/1/emerald_bookshelf",
    "librarian/1/paper_emerald",
    "librarian/2/book_emerald",
    "librarian/2/emerald_and_book_enchanted_book",
    "librarian/2/emerald_lantern",
    "librarian/3/emerald_and_book_enchanted_book",
    "librarian/3/emerald_glass",
    "librarian/3/ink_sac_emerald",
    "librarian/4/emerald_book_and_enchanted_book",
    "librarian/4/emerald_clock",
    "librarian/4/emerald_compass",
    "librarian/4/writable_book_emerald",
    "librarian/5/emerald_red_candle",
    "librarian/5/emerald_yellow_candle",
    "mason/1/clay_ball_emerald",
    "mason/1/emerald_brick",
    "mason/2/emerald_chiseled_stone_bricks",
    "mason/2/stone_emerald",
    "mason/3/andesite_emerald",
    "mason/3/diorite_emerald",
    "mason/3/emerald_dripstone_block",
    "mason/3/emerald_polished_andesite",
    "mason/3/emerald_polished_diorite",
    "mason/3/emerald_polished_granite",
    "mason/3/granite_emerald",
    "mason/4/emerald_black_glazed_terracotta",
    "mason/4/emerald_black_terracotta",
    "mason/4/emerald_blue_glazed_terracotta",
    "mason/4/emerald_blue_terracotta",
    "mason/4/emerald_brown_glazed_terracotta",
    "mason/4/emerald_brown_terracotta",
    "mason/4/emerald_cyan_glazed_terracotta",
    "mason/4/emerald_cyan_terracotta",
    "mason/4/emerald_gray_glazed_terracotta",
    "mason/4/emerald_gray_terracotta",
    "mason/4/emerald_green_glazed_terracotta",
    "mason/4/emerald_green_terracotta",
    "mason/4/emerald_light_blue_glazed_terracotta",
    "mason/4/emerald_light_blue_terracotta",
    "mason/4/emerald_light_gray_glazed_terracotta",
    "mason/4/emerald_light_gray_terracotta",
    "mason/4/emerald_lime_glazed_terracotta",
    "mason/4/emerald_lime_terracotta",
    "mason/4/emerald_magenta_glazed_terracotta",
    "mason/4/emerald_magenta_terracotta",
    "mason/4/emerald_orange_glazed_terracotta",
    "mason/4/emerald_orange_terracotta",
    "mason/4/emerald_pink_glazed_terracotta",
    "mason/4/emerald_pink_terracotta",
    "mason/4/emerald_purple_glazed_terracotta",
    "mason/4/emerald_purple_terracotta",
    "mason/4/emerald_red_glazed_terracotta",
    "mason/4/emerald_red_terracotta",
    "mason/4/emerald_white_glazed_terracotta",
    "mason/4/emerald_white_terracotta",
    "mason/4/emerald_yellow_glazed_terracotta",
    "mason/4/emerald_yellow_terracotta",
    "mason/4/quartz_emerald",
    "mason/5/emerald_quartz_block",
    "mason/5/emerald_quartz_pillar",
    "shepherd/1/black_wool_emerald",
    "shepherd/1/brown_wool_emerald",
    "shepherd/1/emerald_shears",
    "shepherd/1/gray_wool_emerald",
    "shepherd/1/white_wool_emerald",
    "shepherd/2/black_dye_emerald",
    "shepherd/2/emerald_black_carpet",
    "shepherd/2/emerald_black_wool",
    "shepherd/2/emerald_blue_carpet",
    "shepherd/2/emerald_blue_wool",
    "shepherd/2/emerald_brown_carpet",
    "shepherd/2/emerald_brown_wool",
    "shepherd/2/emerald_cyan_carpet",
    "shepherd/2/emerald_cyan_wool",
    "shepherd/2/emerald_gray_carpet",
    "shepherd/2/emerald_gray_wool",
    "shepherd/2/emerald_green_carpet",
    "shepherd/2/emerald_green_wool",
    "shepherd/2/emerald_light_blue_carpet",
    "shepherd/2/emerald_light_blue_wool",
    "shepherd/2/emerald_light_gray_carpet",
    "shepherd/2/emerald_light_gray_wool",
    "shepherd/2/emerald_lime_carpet",
    "shepherd/2/emerald_lime_wool",
    "shepherd/2/emerald_magenta_carpet",
    "shepherd/2/emerald_magenta_wool",
    "shepherd/2/emerald_orange_carpet",
    "shepherd/2/emerald_orange_wool",
    "shepherd/2/emerald_pink_carpet",
    "shepherd/2/emerald_pink_wool",
    "shepherd/2/emerald_purple_carpet",
    "shepherd/2/emerald_purple_wool",
    "shepherd/2/emerald_red_carpet",
    "shepherd/2/emerald_red_wool",
    "shepherd/2/emerald_white_carpet",
    "shepherd/2/emerald_white_wool",
    "shepherd/2/emerald_yellow_carpet",
    "shepherd/2/emerald_yellow_wool",
    "shepherd/2/gray_dye_emerald",
    "shepherd/2/light_blue_dye_emerald",
    "shepherd/2/lime_dye_emerald",
    "shepherd/2/white_dye_emerald",
    "shepherd/3/emerald_black_bed",
    "shepherd/3/emerald_blue_bed",
    "shepherd/3/emerald_brown_bed",
    "shepherd/3/emerald_cyan_bed",
    "shepherd/3/emerald_gray_bed",
    "shepherd/3/emerald_green_bed",
    "shepherd/3/emerald_light_blue_bed",
    "shepherd/3/emerald_light_gray_bed",
    "shepherd/3/emerald_lime_bed",
    "shepherd/3/emerald_magenta_bed",
    "shepherd/3/emerald_orange_bed",
    "shepherd/3/emerald_pink_bed",
    "shepherd/3/emerald_purple_bed",
    "shepherd/3/emerald_red_bed",
    "shepherd/3/emerald_white_bed",
    "shepherd/3/emerald_yellow_bed",
    "shepherd/3/light_gray_dye_emerald",
    "shepherd/3/orange_dye_emerald",
    "shepherd/3/pink_dye_emerald",
    "shepherd/3/red_dye_emerald",
    "shepherd/3/yellow_dye_emerald",
    "shepherd/4/blue_dye_emerald",
    "shepherd/4/brown_dye_emerald",
    "shepherd/4/cyan_dye_emerald",
    "shepherd/4/emerald_black_banner",
    "shepherd/4/emerald_blue_banner",
    "shepherd/4/emerald_brown_banner",
    "shepherd/4/emerald_cyan_banner",
    "shepherd/4/emerald_gray_banner",
    "shepherd/4/emerald_green_banner",
    "shepherd/4/emerald_light_blue_banner",
    "shepherd/4/emerald_light_gray_banner",
    "shepherd/4/emerald_lime_banner",
    "shepherd/4/emerald_magenta_banner",
    "shepherd/4/emerald_orange_banner",
    "shepherd/4/emerald_pink_banner",
    "shepherd/4/emerald_purple_banner",
    "shepherd/4/emerald_red_banner",
    "shepherd/4/emerald_white_banner",
    "shepherd/4/emerald_yellow_banner",
    "shepherd/4/green_dye_emerald",
    "shepherd/4/magenta_dye_emerald",
    "shepherd/4/purple_dye_emerald",
    "shepherd/5/emerald_painting",
    "smith/1/coal_emerald",
    "smith/2/emerald_bell",
    "smith/2/iron_ingot_emerald",
    "toolsmith/1/emerald_stone_axe",
    "toolsmith/1/emerald_stone_hoe",
    "toolsmith/1/emerald_stone_pickaxe",
    "toolsmith/1/emerald_stone_shovel",
    "toolsmith/3/emerald_diamond_hoe",
    "toolsmith/3/emerald_enchanted_iron_axe",
    "toolsmith/3/emerald_enchanted_iron_pickaxe",
    "toolsmith/3/emerald_enchanted_iron_shovel",
    "toolsmith/3/flint_emerald",
    "toolsmith/4/diamond_emerald",
    "toolsmith/4/emerald_enchanted_diamond_axe",
    "toolsmith/4/emerald_enchanted_diamond_shovel",
    "toolsmith/5/emerald_enchanted_diamond_pickaxe",
    "wandering_trader/baked_potato_emerald",
    "wandering_trader/emerald_acacia_log",
    "wandering_trader/emerald_acacia_sapling",
    "wandering_trader/emerald_allium",
    "wandering_trader/emerald_azure_bluet",
    "wandering_trader/emerald_beetroot_seeds",
    "wandering_trader/emerald_birch_log",
    "wandering_trader/emerald_birch_sapling",
    "wandering_trader/emerald_black_dye",
    "wandering_trader/emerald_blue_dye",
    "wandering_trader/emerald_blue_ice",
    "wandering_trader/emerald_blue_orchid",
    "wandering_trader/emerald_brain_coral_block",
    "wandering_trader/emerald_brown_dye",
    "wandering_trader/emerald_brown_mushroom",
    "wandering_trader/emerald_bubble_coral_block",
    "wandering_trader/emerald_cactus",
    "wandering_trader/emerald_cherry_log",
    "wandering_trader/emerald_cherry_sapling",
    "wandering_trader/emerald_cornflower",
    "wandering_trader/emerald_cyan_dye",
    "wandering_trader/emerald_dandelion",
    "wandering_trader/emerald_dark_oak_log",
    "wandering_trader/emerald_dark_oak_sapling",
    "wandering_trader/emerald_dry_tall_grass",
    "wandering_trader/emerald_enchanted_iron_pickaxe",
    "wandering_trader/emerald_fern",
    "wandering_trader/emerald_fire_coral_block",
    "wandering_trader/emerald_firefly_bush",
    "wandering_trader/emerald_fish_bucket",
    "wandering_trader/emerald_glowstone",
    "wandering_trader/emerald_golden_dandelion",
    "wandering_trader/emerald_gray_dye",
    "wandering_trader/emerald_green_dye",
    "wandering_trader/emerald_gunpowder",
    "wandering_trader/emerald_horn_coral_block",
    "wandering_trader/emerald_jungle_log",
    "wandering_trader/emerald_jungle_sapling",
    "wandering_trader/emerald_kelp",
    "wandering_trader/emerald_light_blue_dye",
    "wandering_trader/emerald_light_gray_dye",
    "wandering_trader/emerald_lily_of_the_valley",
    "wandering_trader/emerald_lily_pad",
    "wandering_trader/emerald_lime_dye",
    "wandering_trader/emerald_long_invisibility_potion",
    "wandering_trader/emerald_magenta_dye",
    "wandering_trader/emerald_mangrove_log",
    "wandering_trader/emerald_mangrove_propagule",
    "wandering_trader/emerald_melon_seeds",
    "wandering_trader/emerald_moss_block",
    "wandering_trader/emerald_name_tag",
    "wandering_trader/emerald_nautilus_shell",
    "wandering_trader/emerald_oak_log",
    "wandering_trader/emerald_oak_sapling",
    "wandering_trader/emerald_open_eyeblossom",
    "wandering_trader/emerald_orange_dye",
    "wandering_trader/emerald_orange_tulip",
    "wandering_trader/emerald_oxeye_daisy",
    "wandering_trader/emerald_packed_ice",
    "wandering_trader/emerald_pale_hanging_moss",
    "wandering_trader/emerald_pale_moss_block",
    "wandering_trader/emerald_pale_oak_log",
    "wandering_trader/emerald_pale_oak_sapling",
    "wandering_trader/emerald_pink_dye",
    "wandering_trader/emerald_pink_tulip",
    "wandering_trader/emerald_podzol",
    "wandering_trader/emerald_pointed_dripstone",
    "wandering_trader/emerald_poplar_log",
    "wandering_trader/emerald_poplar_sapling",
    "wandering_trader/emerald_poppy",
    "wandering_trader/emerald_pufferfish_bucket",
    "wandering_trader/emerald_pumpkin",
    "wandering_trader/emerald_pumpkin_seeds",
    "wandering_trader/emerald_purple_dye",
    "wandering_trader/emerald_red_dye",
    "wandering_trader/emerald_red_mushroom",
    "wandering_trader/emerald_red_sand",
    "wandering_trader/emerald_red_tulip",
    "wandering_trader/emerald_rooted_dirt",
    "wandering_trader/emerald_sand",
    "wandering_trader/emerald_sea_pickle",
    "wandering_trader/emerald_shelf_mushroom",
    "wandering_trader/emerald_slime_ball",
    "wandering_trader/emerald_small_dripleaf",
    "wandering_trader/emerald_spruce_log",
    "wandering_trader/emerald_spruce_sapling",
    "wandering_trader/emerald_sugar_cane",
    "wandering_trader/emerald_sulfur_spike",
    "wandering_trader/emerald_tube_coral_block",
    "wandering_trader/emerald_vine",
    "wandering_trader/emerald_wheat_seeds",
    "wandering_trader/emerald_white_dye",
    "wandering_trader/emerald_white_tulip",
    "wandering_trader/emerald_wildflowers",
    "wandering_trader/emerald_yellow_dye",
    "wandering_trader/fermented_spider_eye_emerald",
    "wandering_trader/hay_block_emerald",
    "wandering_trader/milk_bucket_emerald",
    "wandering_trader/water_bottle_emerald",
    "wandering_trader/water_bucket_emerald",
    "weaponsmith/1/emerald_enchanted_iron_sword",
    "weaponsmith/1/emerald_iron_axe",
    "weaponsmith/3/flint_emerald",
    "weaponsmith/4/diamond_emerald",
    "weaponsmith/4/emerald_enchanted_diamond_axe",
    "weaponsmith/5/emerald_enchanted_diamond_sword"
  ]);
});

// src/arguments/generated/_registry/wolf_sound_variants.ts
var WOLF_SOUND_VARIANTS_SET;
var init_wolf_sound_variants = __esm(() => {
  init_sandstone();
  WOLF_SOUND_VARIANTS_SET = new Set2([
    "angry",
    "big",
    "classic",
    "cute",
    "grumpy",
    "puglin",
    "sad"
  ]);
});

// src/arguments/generated/_registry/wolf_variants.ts
var WOLF_VARIANTS_SET;
var init_wolf_variants = __esm(() => {
  init_sandstone();
  WOLF_VARIANTS_SET = new Set2([
    "ashen",
    "black",
    "chestnut",
    "pale",
    "rusty",
    "snowy",
    "spotted",
    "striped",
    "woods"
  ]);
});

// src/arguments/generated/_registry/world_clocks.ts
var WORLD_CLOCKS_SET;
var init_world_clocks = __esm(() => {
  init_sandstone();
  WORLD_CLOCKS_SET = new Set2([
    "overworld",
    "the_end"
  ]);
});

// src/arguments/generated/_registry/zombie_nautilus_variants.ts
var ZOMBIE_NAUTILUS_VARIANTS_SET;
var init_zombie_nautilus_variants = __esm(() => {
  init_sandstone();
  ZOMBIE_NAUTILUS_VARIANTS_SET = new Set2([
    "temperate",
    "warm"
  ]);
});

// src/arguments/generated/_registry/tag_banner_patterns.ts
var TAG_BANNER_PATTERNS_SET;
var init_tag_banner_patterns = __esm(() => {
  init_sandstone();
  TAG_BANNER_PATTERNS_SET = new Set2([
    "no_item_required",
    "pattern_item/bordure_indented",
    "pattern_item/creeper",
    "pattern_item/field_masoned",
    "pattern_item/flow",
    "pattern_item/flower",
    "pattern_item/globe",
    "pattern_item/guster",
    "pattern_item/mojang",
    "pattern_item/piglin",
    "pattern_item/skull"
  ]);
});

// src/arguments/generated/_registry/tag_damage_types.ts
var TAG_DAMAGE_TYPES_SET;
var init_tag_damage_types = __esm(() => {
  init_sandstone();
  TAG_DAMAGE_TYPES_SET = new Set2([
    "always_hurts_ender_dragons",
    "always_kills_armor_stands",
    "always_most_significant_fall",
    "always_triggers_silverfish",
    "avoids_guardian_thorns",
    "burn_from_stepping",
    "burns_armor_stands",
    "bypasses_armor",
    "bypasses_effects",
    "bypasses_enchantments",
    "bypasses_invulnerability",
    "bypasses_resistance",
    "bypasses_shield",
    "bypasses_wolf_armor",
    "can_break_armor_stand",
    "damages_helmet",
    "ignites_armor_stands",
    "is_drowning",
    "is_explosion",
    "is_fall",
    "is_fire",
    "is_freezing",
    "is_lightning",
    "is_player_attack",
    "is_projectile",
    "mace_smash",
    "no_anger",
    "no_impact",
    "no_knockback",
    "no_wolf_retaliation",
    "panic_causes",
    "panic_environmental_causes",
    "sulfur_cube_with_block_immune_to",
    "witch_resistant_to",
    "wither_immune_to"
  ]);
});

// src/arguments/generated/_registry/tag_dialogs.ts
var TAG_DIALOGS_SET;
var init_tag_dialogs = __esm(() => {
  init_sandstone();
  TAG_DIALOGS_SET = new Set2([
    "pause_screen_additions",
    "quick_actions"
  ]);
});

// src/arguments/generated/_registry/tag_enchantments.ts
var TAG_ENCHANTMENTS_SET;
var init_tag_enchantments = __esm(() => {
  init_sandstone();
  TAG_ENCHANTMENTS_SET = new Set2([
    "curse",
    "double_trade_price",
    "exclusive_set/armor",
    "exclusive_set/boots",
    "exclusive_set/bow",
    "exclusive_set/crossbow",
    "exclusive_set/damage",
    "exclusive_set/mining",
    "exclusive_set/riptide",
    "in_enchanting_table",
    "non_treasure",
    "on_mob_spawn_equipment",
    "on_random_loot",
    "on_traded_equipment",
    "prevents_bee_spawns_when_mining",
    "prevents_decorated_pot_shattering",
    "prevents_ice_melting",
    "prevents_infested_spawns",
    "smelts_loot",
    "tooltip_order",
    "tradeable",
    "treasure"
  ]);
});

// src/arguments/generated/_registry/tag_instruments.ts
var TAG_INSTRUMENTS_SET;
var init_tag_instruments = __esm(() => {
  init_sandstone();
  TAG_INSTRUMENTS_SET = new Set2([
    "goat_horns",
    "regular_goat_horns",
    "screaming_goat_horns"
  ]);
});

// src/arguments/generated/_registry/tag_painting_variants.ts
var TAG_PAINTING_VARIANTS_SET;
var init_tag_painting_variants = __esm(() => {
  init_sandstone();
  TAG_PAINTING_VARIANTS_SET = new Set2([
    "placeable"
  ]);
});

// src/arguments/generated/_registry/tag_timelines.ts
var TAG_TIMELINES_SET;
var init_tag_timelines = __esm(() => {
  init_sandstone();
  TAG_TIMELINES_SET = new Set2([
    "in_end",
    "in_nether",
    "in_overworld",
    "universal"
  ]);
});

// src/arguments/generated/_registry/tag_villager_trades.ts
var TAG_VILLAGER_TRADES_SET;
var init_tag_villager_trades = __esm(() => {
  init_sandstone();
  TAG_VILLAGER_TRADES_SET = new Set2([
    "armorer/level_1",
    "armorer/level_2",
    "armorer/level_3",
    "armorer/level_4",
    "armorer/level_5",
    "butcher/level_1",
    "butcher/level_2",
    "butcher/level_3",
    "butcher/level_4",
    "butcher/level_5",
    "cartographer/level_1",
    "cartographer/level_2",
    "cartographer/level_3",
    "cartographer/level_4",
    "cartographer/level_5",
    "cleric/level_1",
    "cleric/level_2",
    "cleric/level_3",
    "cleric/level_4",
    "cleric/level_5",
    "common_smith/level_1",
    "common_smith/level_2",
    "common_smith/level_3",
    "common_smith/level_4",
    "common_smith/level_5",
    "farmer/level_1",
    "farmer/level_2",
    "farmer/level_3",
    "farmer/level_4",
    "farmer/level_5",
    "fisherman/level_1",
    "fisherman/level_2",
    "fisherman/level_3",
    "fisherman/level_4",
    "fisherman/level_5",
    "fletcher/level_1",
    "fletcher/level_2",
    "fletcher/level_3",
    "fletcher/level_4",
    "fletcher/level_5",
    "leatherworker/level_1",
    "leatherworker/level_2",
    "leatherworker/level_3",
    "leatherworker/level_4",
    "leatherworker/level_5",
    "librarian/level_1",
    "librarian/level_2",
    "librarian/level_3",
    "librarian/level_4",
    "librarian/level_5",
    "mason/level_1",
    "mason/level_2",
    "mason/level_3",
    "mason/level_4",
    "mason/level_5",
    "shepherd/level_1",
    "shepherd/level_2",
    "shepherd/level_3",
    "shepherd/level_4",
    "shepherd/level_5",
    "toolsmith/level_1",
    "toolsmith/level_2",
    "toolsmith/level_3",
    "toolsmith/level_4",
    "toolsmith/level_5",
    "wandering_trader/buying",
    "wandering_trader/common",
    "wandering_trader/uncommon",
    "weaponsmith/level_1",
    "weaponsmith/level_2",
    "weaponsmith/level_3",
    "weaponsmith/level_4",
    "weaponsmith/level_5"
  ]);
});

// src/arguments/generated/_registry/tag_blocks.ts
var TAG_BLOCKS_SET;
var init_tag_blocks = __esm(() => {
  init_sandstone();
  TAG_BLOCKS_SET = new Set2([
    "acacia_logs",
    "air",
    "all_hanging_signs",
    "all_signs",
    "ancient_city_replaceable",
    "animals_spawnable_on",
    "anvil",
    "armadillo_spawnable_on",
    "axolotls_spawnable_on",
    "azalea_grows_on",
    "azalea_root_replaceable",
    "badlands_terracotta",
    "bamboo_blocks",
    "banners",
    "bars",
    "base_stone_nether",
    "base_stone_overworld",
    "bats_spawnable_on",
    "beacon_base_blocks",
    "beds",
    "bee_attractive",
    "bee_growables",
    "beehives",
    "beneath_bamboo_podzol_replaceable",
    "beneath_tree_podzol_replaceable",
    "birch_logs",
    "blocks_dolphin_jump",
    "blocks_fluid_flow",
    "blocks_lava_fire_spread",
    "blocks_motion",
    "blocks_motion_in_heightmap",
    "blocks_motion_in_heightmap_no_leaves",
    "blocks_motion_no_leaves",
    "blocks_wind_charge_explosions",
    "buttons",
    "camel_sand_step_sound_blocks",
    "camels_spawnable_on",
    "campfires",
    "can_glide_through",
    "candle_cakes",
    "candles",
    "cannot_place_basalt_pillar_on",
    "cannot_replace_below_tree_trunk",
    "cannot_support_kelp",
    "cannot_support_seagrass",
    "cannot_support_snow_layer",
    "cats_can_lie_on",
    "cats_can_sit_on",
    "cauldrons",
    "causes_continuous_geyser_eruptions",
    "causes_periodic_geyser_eruptions",
    "causes_suffocation",
    "cave_vines",
    "ceiling_hanging_signs",
    "chains",
    "cherry_logs",
    "climbable",
    "coal_ores",
    "combination_step_sound_blocks",
    "completes_find_tree_tutorial",
    "concrete",
    "concrete_powders",
    "concrete_slabs",
    "concrete_stairs",
    "convertible_to_mud",
    "copper",
    "copper_chests",
    "copper_golem_statues",
    "copper_ores",
    "coral_blocks",
    "coral_plants",
    "corals",
    "crimson_stems",
    "crops",
    "crystal_sound_blocks",
    "cushion_uses_collision_shape",
    "dampens_vibrations",
    "dark_oak_logs",
    "deepslate_ore_replaceables",
    "default_immune_to",
    "diamond_ores",
    "dirt",
    "does_not_block_hoppers",
    "doors",
    "dragon_immune",
    "dragon_transparent",
    "dripstone_replaceable_blocks",
    "edible_for_sheep",
    "emerald_ores",
    "enables_bubble_column_drag_down",
    "enables_bubble_column_push_up",
    "enchantment_power_provider",
    "enchantment_power_transmitter",
    "enderman_holdable",
    "entities_can_teleport_to",
    "fall_damage_resetting",
    "features_cannot_replace",
    "fence_gates",
    "fences",
    "fire",
    "flower_pots",
    "flowers",
    "forest_rock_can_place_on",
    "fox_immune_to",
    "foxes_spawnable_on",
    "frog_prefer_jump_to",
    "frogs_spawnable_on",
    "geode_invalid_blocks",
    "glazed_terracotta",
    "goats_spawnable_on",
    "gold_ores",
    "grass_blocks",
    "grows_crops",
    "guarded_by_piglins",
    "happy_ghast_avoids",
    "height_specific_ore_replaceables",
    "hoglin_repellents",
    "huge_brown_mushroom_can_place_on",
    "huge_red_mushroom_can_place_on",
    "ice",
    "ice_melts_when_destroyed_above",
    "ice_spike_replaceable",
    "impermeable",
    "incorrect_for_copper_tool",
    "incorrect_for_diamond_tool",
    "incorrect_for_gold_tool",
    "incorrect_for_iron_tool",
    "incorrect_for_netherite_tool",
    "incorrect_for_stone_tool",
    "incorrect_for_wooden_tool",
    "infiniburn_end",
    "infiniburn_nether",
    "infiniburn_overworld",
    "inside_step_sound_blocks",
    "invalid_spawn_inside",
    "iron_ores",
    "jungle_logs",
    "lanterns",
    "lapis_ores",
    "lava_pool_stone_cannot_replace",
    "leaves",
    "lightning_rods",
    "logs",
    "logs_that_burn",
    "lush_ground_replaceable",
    "maintains_farmland",
    "mangrove_logs",
    "mangrove_logs_can_grow_through",
    "mangrove_roots_can_grow_through",
    "mineable/axe",
    "mineable/hoe",
    "mineable/pickaxe",
    "mineable/shovel",
    "mob_interactable_doors",
    "mooshrooms_spawnable_on",
    "moss_blocks",
    "moss_replaceable",
    "mud",
    "needs_diamond_tool",
    "needs_iron_tool",
    "needs_stone_tool",
    "nylium",
    "oak_logs",
    "occludes_vibration_signals",
    "ores",
    "overrides_mushroom_light_requirement",
    "overworld_natural_logs",
    "pale_oak_logs",
    "parrots_spawnable_on",
    "piglin_repellents",
    "planks",
    "polar_bear_immune_to",
    "polar_bears_spawnable_on_alternate",
    "poplar_logs",
    "portals",
    "pressure_plates",
    "prevent_mob_spawning_inside",
    "prevents_nearby_leaf_decay",
    "rabbits_spawnable_on",
    "rails",
    "redstone_ores",
    "replaceable",
    "replaceable_by_mushrooms",
    "replaceable_by_trees",
    "required_for_poplar_leaf_ambience",
    "sand",
    "saplings",
    "sculk_growth_inhibitors",
    "sculk_replaceable",
    "sculk_replaceable_world_gen",
    "shears_extreme_breaking_speed",
    "shears_major_breaking_speed",
    "shears_minor_breaking_speed",
    "shulker_boxes",
    "signs",
    "skulls",
    "slabs",
    "small_flowers",
    "smelts_to_glass",
    "snaps_goat_horn",
    "sniffer_diggable_block",
    "sniffer_egg_hatch_boost",
    "snow",
    "snow_golem_immune_to",
    "soul_fire_base_blocks",
    "soul_speed_blocks",
    "speeds_up_zombie_villager_curing",
    "speleothems",
    "spruce_logs",
    "stairs",
    "standing_signs",
    "stone_bricks",
    "stone_buttons",
    "stone_ore_replaceables",
    "stone_pressure_plates",
    "stray_immune_to",
    "strider_warm_blocks",
    "substrate_overworld",
    "sulfur_spike_replaceable_blocks",
    "support_override_cactus_flower",
    "support_override_snow_layer",
    "supports_azalea",
    "supports_bamboo",
    "supports_big_dripleaf",
    "supports_cactus",
    "supports_chorus_flower",
    "supports_chorus_plant",
    "supports_cocoa",
    "supports_crimson_fungus",
    "supports_crimson_roots",
    "supports_crops",
    "supports_dry_vegetation",
    "supports_frogspawn",
    "supports_hanging_mangrove_propagule",
    "supports_lily_pad",
    "supports_mangrove_propagule",
    "supports_melon_stem",
    "supports_melon_stem_fruit",
    "supports_nether_sprouts",
    "supports_nether_wart",
    "supports_pumpkin_stem",
    "supports_pumpkin_stem_fruit",
    "supports_small_dripleaf",
    "supports_stem_crops",
    "supports_stem_fruit",
    "supports_sugar_cane",
    "supports_sugar_cane_adjacently",
    "supports_vegetation",
    "supports_warped_fungus",
    "supports_warped_roots",
    "supports_wither_rose",
    "suppresses_bounce",
    "sword_efficient",
    "sword_instantly_mines",
    "terracotta",
    "trail_ruins_replaceable",
    "trapdoors",
    "triggers_ambient_desert_dry_vegetation_block_sounds",
    "triggers_ambient_desert_sand_block_sounds",
    "triggers_ambient_dried_ghast_block_sounds",
    "turns_into_dirt_path",
    "turns_into_farmland",
    "underwater_bonemeals",
    "unstable_bottom_center",
    "valid_spawn",
    "vibration_resonators",
    "villager_babies_can_jump_on_bed",
    "villagers_can_sleep_on_bed",
    "wall_corals",
    "wall_hanging_signs",
    "wall_post_override",
    "wall_signs",
    "walls",
    "warped_stems",
    "wart_blocks",
    "washed_away_by_fluids",
    "wither_immune",
    "wither_immune_to",
    "wither_skeleton_immune_to",
    "wither_summon_base_blocks",
    "wolves_spawnable_on",
    "wooden_buttons",
    "wooden_doors",
    "wooden_fences",
    "wooden_pressure_plates",
    "wooden_shelves",
    "wooden_slabs",
    "wooden_stairs",
    "wooden_trapdoors",
    "wool",
    "wool_carpets",
    "wool_slabs",
    "wool_stairs"
  ]);
});

// src/arguments/generated/_registry/tag_entity_types.ts
var TAG_ENTITY_TYPES_SET;
var init_tag_entity_types = __esm(() => {
  init_sandstone();
  TAG_ENTITY_TYPES_SET = new Set2([
    "accepts_iron_golem_gift",
    "aquatic",
    "arrows",
    "arthropod",
    "axolotl_always_hostiles",
    "axolotl_hunt_targets",
    "beehive_inhabitors",
    "boat",
    "burn_in_daylight",
    "can_breathe_under_water",
    "can_equip_harness",
    "can_equip_saddle",
    "can_float_while_ridden",
    "can_turn_in_boats",
    "can_wear_horse_armor",
    "can_wear_nautilus_armor",
    "candidate_for_iron_golem_gift",
    "cannot_be_age_locked",
    "cannot_be_dismounted_by_item_usage",
    "cannot_be_pushed_onto_boats",
    "deflects_projectiles",
    "dismounts_underwater",
    "fall_damage_immune",
    "followable_friendly_mobs",
    "freeze_hurts_extra_types",
    "freeze_immune_entity_types",
    "frog_food",
    "ignores_poison_and_regen",
    "illager",
    "illager_friends",
    "immune_to_infested",
    "immune_to_oozing",
    "impact_projectiles",
    "inverted_healing_and_harm",
    "nautilus_hostiles",
    "no_anger_from_wind_charge",
    "non_controlling_rider",
    "not_affected_by_geysers",
    "not_scary_for_pufferfish",
    "powder_snow_walkable_mobs",
    "raiders",
    "redirectable_projectile",
    "sensitive_to_bane_of_arthropods",
    "sensitive_to_impaling",
    "sensitive_to_smite",
    "skeletons",
    "undead",
    "wither_friends",
    "zombies"
  ]);
});

// src/arguments/generated/_registry/tag_fluids.ts
var TAG_FLUIDS_SET;
var init_tag_fluids = __esm(() => {
  init_sandstone();
  TAG_FLUIDS_SET = new Set2([
    "bubble_column_can_occupy",
    "lava",
    "supports_frogspawn",
    "supports_lily_pad",
    "supports_sugar_cane_adjacently",
    "water"
  ]);
});

// src/arguments/generated/_registry/tag_game_events.ts
var TAG_GAME_EVENTS_SET;
var init_tag_game_events = __esm(() => {
  init_sandstone();
  TAG_GAME_EVENTS_SET = new Set2([
    "allay_can_listen",
    "ignore_vibrations_sneaking",
    "shrieker_can_listen",
    "vibrations",
    "warden_can_listen"
  ]);
});

// src/arguments/generated/_registry/tag_items.ts
var TAG_ITEMS_SET;
var init_tag_items = __esm(() => {
  init_sandstone();
  TAG_ITEMS_SET = new Set2([
    "acacia_logs",
    "anvil",
    "armadillo_food",
    "arrows",
    "axes",
    "axolotl_food",
    "bamboo_blocks",
    "banners",
    "bars",
    "beacon_payment_items",
    "beds",
    "bee_food",
    "birch_logs",
    "boats",
    "book_cloning_target",
    "bookshelf_books",
    "breaks_decorated_pots",
    "bundles",
    "buttons",
    "camel_food",
    "camel_husk_food",
    "candles",
    "cat_collar_dyes",
    "cat_food",
    "cauldron_can_remove_dye",
    "chains",
    "cherry_logs",
    "chest_armor",
    "chest_boats",
    "chicken_food",
    "clonable_maps",
    "cluster_max_harvestables",
    "coal_ores",
    "coals",
    "compasses",
    "completes_find_tree_tutorial",
    "concrete",
    "concrete_powders",
    "concrete_slabs",
    "concrete_stairs",
    "copper",
    "copper_chests",
    "copper_golem_statues",
    "copper_ores",
    "copper_tool_materials",
    "cow_food",
    "creeper_drop_music_discs",
    "creeper_igniters",
    "crimson_stems",
    "cushions",
    "dampens_vibrations",
    "dark_oak_logs",
    "decorated_pot_ingredients",
    "decorated_pot_sherds",
    "diamond_ores",
    "diamond_tool_materials",
    "dirt",
    "doors",
    "douses_campfires",
    "drowned_preferred_weapons",
    "duplicates_allays",
    "dyes",
    "eggs",
    "emerald_ores",
    "enchantable/armor",
    "enchantable/bow",
    "enchantable/chest_armor",
    "enchantable/crossbow",
    "enchantable/durability",
    "enchantable/equippable",
    "enchantable/fire_aspect",
    "enchantable/fishing",
    "enchantable/foot_armor",
    "enchantable/head_armor",
    "enchantable/leg_armor",
    "enchantable/lunge",
    "enchantable/mace",
    "enchantable/melee_weapon",
    "enchantable/mining",
    "enchantable/mining_loot",
    "enchantable/sharp_weapon",
    "enchantable/sweeping",
    "enchantable/trident",
    "enchantable/vanishing",
    "enchantable/weapon",
    "extendable_maps",
    "fence_gates",
    "fences",
    "fishes",
    "flowers",
    "foot_armor",
    "fox_food",
    "freeze_immune_wearables",
    "frog_food",
    "furnace_minecart_fuel",
    "gaze_disguise_equipment",
    "glazed_terracotta",
    "goat_food",
    "gold_ores",
    "gold_tool_materials",
    "grass_blocks",
    "hanging_signs",
    "happy_ghast_food",
    "happy_ghast_tempt_items",
    "harnesses",
    "head_armor",
    "hoes",
    "hoglin_food",
    "horse_food",
    "horse_tempt_items",
    "ignored_by_piglin_babies",
    "iron_ores",
    "iron_tool_materials",
    "jungle_logs",
    "lanterns",
    "lapis_ores",
    "leaves",
    "lectern_books",
    "leg_armor",
    "lightning_rods",
    "llama_food",
    "llama_tempt_items",
    "logs",
    "logs_that_burn",
    "loom_dyes",
    "loom_patterns",
    "mangrove_logs",
    "map_invisibility_equipment",
    "meat",
    "metal_nuggets",
    "moss_blocks",
    "mud",
    "mushrooms",
    "nautilus_bucket_food",
    "nautilus_food",
    "nautilus_taming_items",
    "netherite_tool_materials",
    "non_flammable_wood",
    "noteblock_top_instruments",
    "oak_logs",
    "ocelot_food",
    "ores",
    "pale_oak_logs",
    "panda_eats_from_ground",
    "panda_food",
    "parrot_food",
    "parrot_poisonous_food",
    "pickaxes",
    "pig_food",
    "piglin_food",
    "piglin_loved",
    "piglin_preferred_weapons",
    "piglin_repellents",
    "piglin_safe_armor",
    "pillager_preferred_weapons",
    "planks",
    "poplar_logs",
    "rabbit_food",
    "rails",
    "redstone_ores",
    "repairs_chain_armor",
    "repairs_copper_armor",
    "repairs_diamond_armor",
    "repairs_gold_armor",
    "repairs_iron_armor",
    "repairs_leather_armor",
    "repairs_netherite_armor",
    "repairs_turtle_helmet",
    "repairs_wolf_armor",
    "sand",
    "saplings",
    "shearable_from_copper_golem",
    "sheep_food",
    "shovels",
    "shulker_boxes",
    "signs",
    "skeleton_preferred_weapons",
    "skulls",
    "slabs",
    "small_flowers",
    "smelts_to_glass",
    "sniffer_food",
    "soul_fire_base_blocks",
    "spears",
    "spruce_logs",
    "stairs",
    "stone_bricks",
    "stone_buttons",
    "stone_crafting_materials",
    "stone_tool_materials",
    "strider_food",
    "strider_tempt_items",
    "sulfur_cube_archetype/bouncy",
    "sulfur_cube_archetype/explosive",
    "sulfur_cube_archetype/fast_flat",
    "sulfur_cube_archetype/fast_sliding",
    "sulfur_cube_archetype/high_resistance",
    "sulfur_cube_archetype/hot",
    "sulfur_cube_archetype/light",
    "sulfur_cube_archetype/regular",
    "sulfur_cube_archetype/slow_bouncy",
    "sulfur_cube_archetype/slow_flat",
    "sulfur_cube_archetype/slow_sliding",
    "sulfur_cube_archetype/sticky",
    "sulfur_cube_food",
    "sulfur_cube_swallowable",
    "swords",
    "terracotta",
    "trapdoors",
    "trim_materials",
    "trimmable_armor",
    "turtle_food",
    "villager_picks_up",
    "villager_plantable_seeds",
    "walls",
    "warped_stems",
    "wart_blocks",
    "wither_skeleton_disliked_weapons",
    "wolf_collar_dyes",
    "wolf_food",
    "wooden_buttons",
    "wooden_doors",
    "wooden_fences",
    "wooden_pressure_plates",
    "wooden_shelves",
    "wooden_slabs",
    "wooden_stairs",
    "wooden_tool_materials",
    "wooden_trapdoors",
    "wool",
    "wool_carpets",
    "wool_slabs",
    "wool_stairs",
    "zombie_horse_food"
  ]);
});

// src/arguments/generated/_registry/tag_point_of_interest_types.ts
var TAG_POINT_OF_INTEREST_TYPES_SET;
var init_tag_point_of_interest_types = __esm(() => {
  init_sandstone();
  TAG_POINT_OF_INTEREST_TYPES_SET = new Set2([
    "acquirable_job_site",
    "bee_home",
    "village"
  ]);
});

// src/arguments/generated/_registry/tag_potions.ts
var TAG_POTIONS_SET;
var init_tag_potions = __esm(() => {
  init_sandstone();
  TAG_POTIONS_SET = new Set2([
    "tradeable"
  ]);
});

// src/arguments/generated/_registry/tag_worldgen_features.ts
var TAG_WORLDGEN_FEATURES_SET;
var init_tag_worldgen_features = __esm(() => {
  init_sandstone();
  TAG_WORLDGEN_FEATURES_SET = new Set2([
    "can_spawn_from_bone_meal"
  ]);
});

// src/arguments/generated/_registry/tag_worldgen_biomes.ts
var TAG_WORLDGEN_BIOMES_SET;
var init_tag_worldgen_biomes = __esm(() => {
  init_sandstone();
  TAG_WORLDGEN_BIOMES_SET = new Set2([
    "allows_surface_slime_spawns",
    "allows_tropical_fish_spawns_at_any_height",
    "has_structure/abandoned_camp_bamboo_jungle",
    "has_structure/abandoned_camp_birch_forest",
    "has_structure/abandoned_camp_cherry_grove",
    "has_structure/abandoned_camp_dappled_forest",
    "has_structure/abandoned_camp_flower_forest",
    "has_structure/abandoned_camp_forest",
    "has_structure/abandoned_camp_meadow",
    "has_structure/abandoned_camp_old_growth_birch_forest",
    "has_structure/abandoned_camp_old_growth_pine_taiga",
    "has_structure/abandoned_camp_old_growth_spruce_taiga",
    "has_structure/abandoned_camp_pale_garden",
    "has_structure/abandoned_camp_savanna",
    "has_structure/abandoned_camp_snowy_taiga",
    "has_structure/abandoned_camp_sparse_jungle",
    "has_structure/abandoned_camp_swamp",
    "has_structure/abandoned_camp_taiga",
    "has_structure/abandoned_camp_windswept_forest",
    "has_structure/abandoned_camp_wooded_badlands",
    "has_structure/ancient_city",
    "has_structure/bastion_remnant",
    "has_structure/buried_treasure",
    "has_structure/desert_pyramid",
    "has_structure/end_city",
    "has_structure/igloo",
    "has_structure/jungle_temple",
    "has_structure/mineshaft",
    "has_structure/mineshaft_mesa",
    "has_structure/nether_fortress",
    "has_structure/nether_fossil",
    "has_structure/ocean_monument",
    "has_structure/ocean_ruin_cold",
    "has_structure/ocean_ruin_warm",
    "has_structure/pillager_outpost",
    "has_structure/ruined_portal_desert",
    "has_structure/ruined_portal_jungle",
    "has_structure/ruined_portal_mountain",
    "has_structure/ruined_portal_nether",
    "has_structure/ruined_portal_ocean",
    "has_structure/ruined_portal_standard",
    "has_structure/ruined_portal_swamp",
    "has_structure/shipwreck",
    "has_structure/shipwreck_beached",
    "has_structure/stronghold",
    "has_structure/swamp_hut",
    "has_structure/trail_ruins",
    "has_structure/trial_chambers",
    "has_structure/village_desert",
    "has_structure/village_plains",
    "has_structure/village_savanna",
    "has_structure/village_snowy",
    "has_structure/village_taiga",
    "has_structure/woodland_mansion",
    "is_badlands",
    "is_beach",
    "is_deep_ocean",
    "is_end",
    "is_forest",
    "is_hill",
    "is_jungle",
    "is_mountain",
    "is_nether",
    "is_ocean",
    "is_overworld",
    "is_river",
    "is_savanna",
    "is_taiga",
    "mineshaft_blocking",
    "more_frequent_drowned_spawns",
    "polar_bears_spawn_on_alternate_blocks",
    "produces_corals_from_bonemeal",
    "reduce_water_ambient_spawns",
    "required_ocean_monument_surrounding",
    "spawns_cold_variant_farm_animals",
    "spawns_cold_variant_frogs",
    "spawns_coral_variant_zombie_nautilus",
    "spawns_gold_rabbits",
    "spawns_snow_foxes",
    "spawns_warm_variant_farm_animals",
    "spawns_warm_variant_frogs",
    "spawns_white_rabbits",
    "stronghold_biased_to",
    "water_on_map_outlines",
    "without_wandering_trader_spawns",
    "without_zombie_sieges"
  ]);
});

// src/arguments/generated/_registry/tag_worldgen_flat_level_generator_presets.ts
var TAG_WORLDGEN_FLAT_LEVEL_GENERATOR_PRESETS_SET;
var init_tag_worldgen_flat_level_generator_presets = __esm(() => {
  init_sandstone();
  TAG_WORLDGEN_FLAT_LEVEL_GENERATOR_PRESETS_SET = new Set2([
    "visible"
  ]);
});

// src/arguments/generated/_registry/tag_worldgen_structures.ts
var TAG_WORLDGEN_STRUCTURES_SET;
var init_tag_worldgen_structures = __esm(() => {
  init_sandstone();
  TAG_WORLDGEN_STRUCTURES_SET = new Set2([
    "abandoned_camp",
    "cats_spawn_as_black",
    "cats_spawn_in",
    "dolphin_located",
    "eye_of_ender_located",
    "mineshaft",
    "ocean_ruin",
    "on_abandoned_camp_bamboo_jungle",
    "on_abandoned_camp_birch_forest",
    "on_abandoned_camp_cherry_grove",
    "on_abandoned_camp_dappled_forest",
    "on_abandoned_camp_flower_forest",
    "on_abandoned_camp_pale_garden",
    "on_abandoned_camp_swamp",
    "on_abandoned_camp_windswept",
    "on_ancient_city_maps",
    "on_desert_pyramid_maps",
    "on_desert_village_maps",
    "on_jungle_explorer_maps",
    "on_mineshaft_maps",
    "on_ocean_explorer_maps",
    "on_ocean_ruin_warm_maps",
    "on_plains_village_maps",
    "on_savanna_village_maps",
    "on_snowy_village_maps",
    "on_swamp_explorer_maps",
    "on_taiga_village_maps",
    "on_treasure_maps",
    "on_trial_chambers_maps",
    "on_woodland_explorer_maps",
    "ruined_portal",
    "shipwreck",
    "village"
  ]);
});

// src/arguments/generated/_registry/tag_worldgen_world_presets.ts
var TAG_WORLDGEN_WORLD_PRESETS_SET;
var init_tag_worldgen_world_presets = __esm(() => {
  init_sandstone();
  TAG_WORLDGEN_WORLD_PRESETS_SET = new Set2([
    "extended",
    "normal"
  ]);
});

// src/arguments/generated/_registry/worldgen_biomes.ts
var WORLDGEN_BIOMES_SET;
var init_worldgen_biomes = __esm(() => {
  init_sandstone();
  WORLDGEN_BIOMES_SET = new Set2([
    "badlands",
    "bamboo_jungle",
    "basalt_deltas",
    "beach",
    "birch_forest",
    "cherry_grove",
    "cold_ocean",
    "crimson_forest",
    "dappled_forest",
    "dark_forest",
    "deep_cold_ocean",
    "deep_dark",
    "deep_frozen_ocean",
    "deep_lukewarm_ocean",
    "deep_ocean",
    "desert",
    "dripstone_caves",
    "end_barrens",
    "end_highlands",
    "end_midlands",
    "eroded_badlands",
    "flower_forest",
    "forest",
    "frozen_ocean",
    "frozen_peaks",
    "frozen_river",
    "grove",
    "ice_spikes",
    "jagged_peaks",
    "jungle",
    "lukewarm_ocean",
    "lush_caves",
    "mangrove_swamp",
    "meadow",
    "mushroom_fields",
    "nether_wastes",
    "ocean",
    "old_growth_birch_forest",
    "old_growth_pine_taiga",
    "old_growth_spruce_taiga",
    "pale_garden",
    "plains",
    "river",
    "savanna",
    "savanna_plateau",
    "small_end_islands",
    "snowy_beach",
    "snowy_plains",
    "snowy_slopes",
    "snowy_taiga",
    "soul_sand_valley",
    "sparse_jungle",
    "stony_peaks",
    "stony_shore",
    "sulfur_caves",
    "sunflower_plains",
    "swamp",
    "taiga",
    "the_end",
    "the_void",
    "warm_ocean",
    "warped_forest",
    "windswept_forest",
    "windswept_gravelly_hills",
    "windswept_hills",
    "windswept_savanna",
    "wooded_badlands"
  ]);
});

// src/arguments/generated/_registry/worldgen_carvers.ts
var WORLDGEN_CARVERS_SET;
var init_worldgen_carvers = __esm(() => {
  init_sandstone();
  WORLDGEN_CARVERS_SET = new Set2([
    "canyon",
    "cave",
    "cave_extra_underground",
    "nether_cave"
  ]);
});

// src/arguments/generated/_registry/worldgen_density_functions.ts
var WORLDGEN_DENSITY_FUNCTIONS_SET;
var init_worldgen_density_functions = __esm(() => {
  init_sandstone();
  WORLDGEN_DENSITY_FUNCTIONS_SET = new Set2([
    "end/base_3d_noise",
    "end/islands",
    "end/sloped_cheese",
    "nether/base_3d_noise",
    "overworld/base_3d_noise",
    "overworld/caves/entrances",
    "overworld/caves/noodle",
    "overworld/caves/pillars",
    "overworld/caves/spaghetti_2d",
    "overworld/caves/spaghetti_2d_thickness_modulator",
    "overworld/caves/spaghetti_roughness_function",
    "overworld/continents",
    "overworld/depth",
    "overworld/erosion",
    "overworld/factor",
    "overworld/final_density",
    "overworld/jaggedness",
    "overworld/offset",
    "overworld/ore_vein/copper_density",
    "overworld/ore_vein/gap",
    "overworld/ore_vein/iron_density",
    "overworld/ore_vein/mask",
    "overworld/ore_vein/richness",
    "overworld/ore_vein/toggle",
    "overworld/preliminary_surface_level",
    "overworld/ridges",
    "overworld/ridges_folded",
    "overworld/sloped_cheese",
    "overworld/temperature",
    "overworld/vegetation",
    "overworld_amplified/depth",
    "overworld_amplified/factor",
    "overworld_amplified/final_density",
    "overworld_amplified/jaggedness",
    "overworld_amplified/offset",
    "overworld_amplified/preliminary_surface_level",
    "overworld_amplified/sloped_cheese",
    "overworld_large_biomes/continents",
    "overworld_large_biomes/depth",
    "overworld_large_biomes/erosion",
    "overworld_large_biomes/factor",
    "overworld_large_biomes/final_density",
    "overworld_large_biomes/jaggedness",
    "overworld_large_biomes/offset",
    "overworld_large_biomes/preliminary_surface_level",
    "overworld_large_biomes/sloped_cheese",
    "overworld_large_biomes/temperature",
    "overworld_large_biomes/vegetation",
    "shift_x",
    "shift_z",
    "y",
    "zero"
  ]);
});

// src/arguments/generated/_registry/worldgen_features.ts
var WORLDGEN_FEATURES_SET;
var init_worldgen_features = __esm(() => {
  init_sandstone();
  WORLDGEN_FEATURES_SET = new Set2([
    "acacia",
    "amethyst_geode",
    "azalea_tree",
    "bamboo_no_podzol",
    "bamboo_some_podzol",
    "bamboo_vegetation",
    "basalt_blobs",
    "basalt_pillar",
    "berry_bush",
    "birch",
    "birch_bees_0002",
    "birch_bees_0002_leaf_litter",
    "birch_bees_002",
    "birch_bees_005",
    "birch_leaf_litter",
    "birch_tall",
    "blackstone_blobs",
    "blue_ice",
    "bonus_chest",
    "brown_mushroom",
    "bush",
    "cactus",
    "cave_vine",
    "cave_vine_in_moss",
    "cherry",
    "cherry_bees_005",
    "chorus_plant",
    "clay_pool_with_dripleaves",
    "clay_with_dripleaves",
    "coral/block_decoration",
    "coral/brain_block",
    "coral/bubble_block",
    "coral/fire_block",
    "coral/horn_block",
    "coral/tube_block",
    "crimson_forest_vegetation",
    "crimson_fungus",
    "crimson_fungus_planted",
    "crimson_roots",
    "dark_forest_vegetation",
    "dark_oak",
    "dark_oak_leaf_litter",
    "dead_bush",
    "delta",
    "desert_well",
    "disk_clay",
    "disk_grass",
    "disk_gravel",
    "disk_sand",
    "dripleaf",
    "dripstone_cluster",
    "dry_grass",
    "end_gateway_delayed",
    "end_gateway_return",
    "end_island",
    "end_platform",
    "end_podium_active",
    "end_podium_inactive",
    "end_spike",
    "fallen_birch_tree",
    "fallen_jungle_tree",
    "fallen_oak_tree",
    "fallen_poplar_tree",
    "fallen_spruce_tree",
    "fallen_super_birch_tree",
    "fancy_oak",
    "fancy_oak_bees",
    "fancy_oak_bees_0002_leaf_litter",
    "fancy_oak_bees_002",
    "fancy_oak_bees_005",
    "fancy_oak_leaf_litter",
    "firefly_bush",
    "flower_cherry",
    "flower_default",
    "flower_flower_forest",
    "flower_meadow",
    "flower_pale_garden",
    "flower_plain",
    "flower_swamp",
    "forest_flowers",
    "forest_rock",
    "fossil_coal",
    "fossil_diamonds",
    "freeze_top_layer",
    "glow_lichen",
    "glowstone_extra",
    "grass",
    "grass_jungle",
    "huge_brown_mushroom",
    "huge_red_mushroom",
    "ice_patch",
    "ice_spike",
    "iceberg_blue",
    "iceberg_packed",
    "jungle_bush",
    "jungle_tree",
    "jungle_tree_no_vine",
    "kelp",
    "lake_lava",
    "large_basalt_columns",
    "large_dripstone",
    "large_fern",
    "leaf_litter",
    "lush_caves_clay",
    "mangrove",
    "mangrove_vegetation",
    "meadow_trees",
    "mega_jungle_tree",
    "mega_pine",
    "mega_spruce",
    "melon",
    "monster_room",
    "moss_patch",
    "moss_patch_bonemeal",
    "moss_patch_ceiling",
    "moss_vegetation",
    "mushroom_island_vegetation",
    "nether_sprouts",
    "nylium_bonemeal",
    "oak",
    "oak_bees_0002_leaf_litter",
    "oak_bees_002",
    "oak_bees_005",
    "oak_leaf_litter",
    "orange_poplar",
    "orange_poplar_leaf_litter",
    "ore_ancient_debris_large",
    "ore_ancient_debris_small",
    "ore_andesite",
    "ore_blackstone",
    "ore_clay",
    "ore_coal",
    "ore_coal_buried",
    "ore_copper_large",
    "ore_copper_small",
    "ore_diamond_buried",
    "ore_diamond_large",
    "ore_diamond_medium",
    "ore_diamond_small",
    "ore_diorite",
    "ore_dirt",
    "ore_emerald",
    "ore_gold",
    "ore_gold_buried",
    "ore_granite",
    "ore_gravel",
    "ore_gravel_nether",
    "ore_infested",
    "ore_iron",
    "ore_iron_small",
    "ore_lapis",
    "ore_lapis_buried",
    "ore_magma",
    "ore_nether_gold",
    "ore_quartz",
    "ore_redstone",
    "ore_soul_sand",
    "ore_tuff",
    "pale_forest_flower",
    "pale_garden_vegetation",
    "pale_moss_patch",
    "pale_moss_patch_bonemeal",
    "pale_moss_vegetation",
    "pale_oak",
    "pale_oak_bonemeal",
    "pale_oak_creaking",
    "patch_fire",
    "patch_soul_fire",
    "pile_hay",
    "pile_ice",
    "pile_melon",
    "pile_pumpkin",
    "pile_snow",
    "pine",
    "pointed_dripstone",
    "pumpkin",
    "red_mushroom",
    "red_poplar",
    "red_poplar_leaf_litter",
    "red_shrub",
    "rooted_azalea_tree",
    "rooted_sulfur_spring",
    "sculk_patch_ancient_city",
    "sculk_patch_deep_dark",
    "sculk_vein",
    "sea_pickle",
    "seagrass_mid",
    "seagrass_short",
    "seagrass_slightly_less_short",
    "seagrass_tall",
    "small_basalt_columns",
    "spore_blossom",
    "spring_lava_frozen",
    "spring_lava_nether",
    "spring_lava_overworld",
    "spring_nether_closed",
    "spring_nether_open",
    "spring_water",
    "spruce",
    "sugar_cane",
    "sulfur_pool",
    "sulfur_spike",
    "sulfur_spike_cluster",
    "sulfur_spring",
    "sunflower",
    "super_birch_bees",
    "super_birch_bees_0002",
    "swamp_oak",
    "taiga_grass",
    "tall_grass",
    "tall_mangrove",
    "trees_badlands",
    "trees_birch",
    "trees_birch_and_oak_leaf_litter",
    "trees_dappled_forest",
    "trees_flower_forest",
    "trees_grove",
    "trees_jungle",
    "trees_old_growth_pine_taiga",
    "trees_old_growth_spruce_taiga",
    "trees_plains",
    "trees_savanna",
    "trees_snowy",
    "trees_sparse_jungle",
    "trees_taiga",
    "trees_water",
    "trees_windswept_hills",
    "twisting_vines",
    "underwater_magma",
    "vines",
    "void_start_platform",
    "warm_ocean_vegetation",
    "warped_forest_vegetation",
    "warped_fungus",
    "warped_fungus_planted",
    "waterlily",
    "weeping_vines",
    "wildflower",
    "yellow_poplar",
    "yellow_poplar_leaf_litter"
  ]);
});

// src/arguments/generated/_registry/worldgen_flat_level_generator_presets.ts
var WORLDGEN_FLAT_LEVEL_GENERATOR_PRESETS_SET;
var init_worldgen_flat_level_generator_presets = __esm(() => {
  init_sandstone();
  WORLDGEN_FLAT_LEVEL_GENERATOR_PRESETS_SET = new Set2([
    "bottomless_pit",
    "classic_flat",
    "desert",
    "overworld",
    "redstone_ready",
    "snowy_kingdom",
    "the_void",
    "tunnelers_dream",
    "water_world"
  ]);
});

// src/arguments/generated/_registry/worldgen_material_conditions.ts
var WORLDGEN_MATERIAL_CONDITIONS_SET;
var init_worldgen_material_conditions = __esm(() => {
  init_sandstone();
  WORLDGEN_MATERIAL_CONDITIONS_SET = new Set2([
    "deep_under_floor",
    "not_under_deep_water",
    "not_underwater",
    "on_ceiling",
    "on_floor",
    "under_ceiling",
    "under_floor",
    "very_deep_under_floor"
  ]);
});

// src/arguments/generated/_registry/worldgen_material_rules.ts
var WORLDGEN_MATERIAL_RULES_SET;
var init_worldgen_material_rules = __esm(() => {
  init_sandstone();
  WORLDGEN_MATERIAL_RULES_SET = new Set2([
    "bedrock_floor",
    "bedrock_roof",
    "end",
    "nether",
    "overworld",
    "overworld/biome_surface",
    "overworld/biome_surface/dappled_forest",
    "overworld/biome_surface/default",
    "overworld/biome_surface/dripstone_caves",
    "overworld/biome_surface/frozen_peaks",
    "overworld/biome_surface/grove",
    "overworld/biome_surface/ice_spikes",
    "overworld/biome_surface/jagged_peaks",
    "overworld/biome_surface/mangrove_swamp",
    "overworld/biome_surface/mushroom_fields",
    "overworld/biome_surface/old_growth_pine_taiga",
    "overworld/biome_surface/snowy_slopes",
    "overworld/biome_surface/stony_peaks",
    "overworld/biome_surface/stony_shore",
    "overworld/biome_surface/sulfur_caves",
    "overworld/biome_surface/windswept_gravelly_hills",
    "overworld/biome_surface/windswept_hills",
    "overworld/biome_surface/windswept_savanna",
    "overworld/gravel_or_stone_if_ceiling",
    "overworld/powder_snow_surface",
    "overworld/powder_snow_under_surface",
    "overworld/sand_or_sandstone_if_ceiling",
    "overworld/sulfur_cave_bands",
    "overworld/surface",
    "overworld/under_biome_surface",
    "overworld/under_biome_surface/default",
    "overworld/under_biome_surface/frozen_peaks",
    "overworld/under_biome_surface/grove",
    "overworld/under_biome_surface/jagged_peaks",
    "overworld/under_biome_surface/snowy_slopes",
    "overworld/under_biome_surface/windswept_gravelly_hills",
    "overworld/under_biome_surface/windswept_savanna",
    "overworld/underground",
    "overworld_caves",
    "overworld_floating_islands"
  ]);
});

// src/arguments/generated/_registry/worldgen_multi_noise_biome_source_parameter_lists.ts
var WORLDGEN_MULTI_NOISE_BIOME_SOURCE_PARAMETER_LISTS_SET;
var init_worldgen_multi_noise_biome_source_parameter_lists = __esm(() => {
  init_sandstone();
  WORLDGEN_MULTI_NOISE_BIOME_SOURCE_PARAMETER_LISTS_SET = new Set2([
    "nether",
    "overworld"
  ]);
});

// src/arguments/generated/_registry/worldgen_noises.ts
var WORLDGEN_NOISES_SET;
var init_worldgen_noises = __esm(() => {
  init_sandstone();
  WORLDGEN_NOISES_SET = new Set2([
    "aquifer_barrier",
    "aquifer_fluid_level_floodedness",
    "aquifer_fluid_level_spread",
    "aquifer_lava",
    "badlands_pillar",
    "badlands_pillar_roof",
    "badlands_surface",
    "calcite",
    "cave_cheese",
    "cave_entrance",
    "cave_layer",
    "clay_bands_offset",
    "continentalness",
    "continentalness_large",
    "erosion",
    "erosion_large",
    "gravel",
    "gravel_layer",
    "ice",
    "iceberg_pillar",
    "iceberg_pillar_roof",
    "iceberg_surface",
    "jagged",
    "nether/temperature",
    "nether/vegetation",
    "nether_state_selector",
    "nether_wart",
    "netherrack",
    "noodle",
    "noodle_ridge_a",
    "noodle_ridge_b",
    "noodle_thickness",
    "offset",
    "ore_gap",
    "ore_vein_a",
    "ore_vein_b",
    "ore_veininess",
    "packed_ice",
    "patch",
    "pillar",
    "pillar_rareness",
    "pillar_thickness",
    "powder_snow",
    "ridge",
    "small_patch",
    "soul_sand_layer",
    "spaghetti_2d",
    "spaghetti_2d_elevation",
    "spaghetti_2d_modulator",
    "spaghetti_2d_thickness",
    "spaghetti_3d_1",
    "spaghetti_3d_2",
    "spaghetti_3d_rarity",
    "spaghetti_3d_thickness",
    "spaghetti_roughness",
    "spaghetti_roughness_modulator",
    "sulfur_cave_gradient",
    "surface",
    "surface_secondary",
    "surface_swamp",
    "temperature",
    "temperature_large",
    "vegetation",
    "vegetation_large"
  ]);
});

// src/arguments/generated/_registry/worldgen_noise_settings.ts
var WORLDGEN_NOISE_SETTINGS_SET;
var init_worldgen_noise_settings = __esm(() => {
  init_sandstone();
  WORLDGEN_NOISE_SETTINGS_SET = new Set2([
    "amplified",
    "caves",
    "end",
    "floating_islands",
    "large_biomes",
    "nether",
    "overworld"
  ]);
});

// src/arguments/generated/_registry/worldgen_placed_features.ts
var WORLDGEN_PLACED_FEATURES_SET;
var init_worldgen_placed_features = __esm(() => {
  init_sandstone();
  WORLDGEN_PLACED_FEATURES_SET = new Set2([
    "acacia",
    "acacia_checked",
    "amethyst_geode",
    "bamboo",
    "bamboo_in_structure",
    "bamboo_light",
    "bamboo_vegetation",
    "basalt_blobs",
    "basalt_pillar",
    "birch_bees_0002",
    "birch_bees_0002_leaf_litter",
    "birch_bees_002",
    "birch_checked",
    "birch_leaf_litter",
    "birch_tall",
    "blackstone_blobs",
    "blue_ice",
    "brown_mushroom_dappled_forest",
    "brown_mushroom_nether",
    "brown_mushroom_normal",
    "brown_mushroom_old_growth",
    "brown_mushroom_swamp",
    "brown_mushroom_taiga",
    "cave_vines",
    "cherry_bees_005",
    "cherry_checked",
    "chorus_plant",
    "classic_vines_cave_feature",
    "crimson_forest_vegetation",
    "crimson_fungi",
    "dark_forest_vegetation",
    "dark_oak_checked",
    "dark_oak_leaf_litter",
    "delta",
    "desert_well",
    "disk_clay",
    "disk_grass",
    "disk_gravel",
    "disk_sand",
    "dripstone_cluster",
    "end_gateway_return",
    "end_island_decorated",
    "end_platform",
    "end_spike",
    "fallen_birch_tree",
    "fallen_jungle_tree",
    "fallen_oak_tree",
    "fallen_poplar_tree",
    "fallen_spruce_tree",
    "fallen_super_birch_tree",
    "fancy_oak_bees",
    "fancy_oak_bees_0002_leaf_litter",
    "fancy_oak_bees_002",
    "fancy_oak_checked",
    "fancy_oak_leaf_litter",
    "flower_cherry",
    "flower_default",
    "flower_flower_forest",
    "flower_forest_flowers",
    "flower_meadow",
    "flower_pale_garden",
    "flower_plain",
    "flower_plains",
    "flower_swamp",
    "flower_warm",
    "forest_flowers",
    "forest_rock",
    "fossil_lower",
    "fossil_upper",
    "freeze_top_layer",
    "glow_lichen",
    "glowstone",
    "glowstone_extra",
    "grass_bonemeal",
    "ice_patch",
    "ice_spike",
    "iceberg_blue",
    "iceberg_packed",
    "jungle_bush",
    "jungle_tree",
    "kelp_cold",
    "kelp_warm",
    "lake_lava_surface",
    "lake_lava_underground",
    "large_basalt_columns",
    "large_dripstone",
    "lush_caves_ceiling_vegetation",
    "lush_caves_clay",
    "lush_caves_vegetation",
    "mangrove_checked",
    "mega_jungle_tree_checked",
    "mega_pine_checked",
    "mega_spruce_checked",
    "monster_room",
    "monster_room_deep",
    "mushroom_island_vegetation",
    "nether_sprouts",
    "oak",
    "oak_bees_0002_leaf_litter",
    "oak_bees_002",
    "oak_checked",
    "oak_leaf_litter",
    "orange_poplar",
    "orange_poplar_leaf_litter",
    "ore_ancient_debris_large",
    "ore_andesite_lower",
    "ore_andesite_upper",
    "ore_blackstone",
    "ore_clay",
    "ore_coal_lower",
    "ore_coal_upper",
    "ore_copper",
    "ore_copper_large",
    "ore_debris_small",
    "ore_diamond",
    "ore_diamond_buried",
    "ore_diamond_large",
    "ore_diamond_medium",
    "ore_diorite_lower",
    "ore_diorite_upper",
    "ore_dirt",
    "ore_emerald",
    "ore_gold",
    "ore_gold_deltas",
    "ore_gold_extra",
    "ore_gold_lower",
    "ore_gold_nether",
    "ore_granite_lower",
    "ore_granite_upper",
    "ore_gravel",
    "ore_gravel_nether",
    "ore_infested",
    "ore_iron_middle",
    "ore_iron_small",
    "ore_iron_upper",
    "ore_lapis",
    "ore_lapis_buried",
    "ore_magma",
    "ore_quartz_deltas",
    "ore_quartz_nether",
    "ore_redstone",
    "ore_redstone_lower",
    "ore_soul_sand",
    "ore_tuff",
    "pale_garden_flowers",
    "pale_garden_vegetation",
    "pale_moss_patch",
    "pale_oak_checked",
    "pale_oak_creaking_checked",
    "patch_berry_bush",
    "patch_berry_common",
    "patch_berry_rare",
    "patch_bush",
    "patch_cactus",
    "patch_cactus_decorated",
    "patch_cactus_desert",
    "patch_crimson_roots",
    "patch_dead_bush",
    "patch_dead_bush_2",
    "patch_dead_bush_badlands",
    "patch_dry_grass_badlands",
    "patch_dry_grass_desert",
    "patch_fire",
    "patch_firefly_bush_near_water",
    "patch_firefly_bush_near_water_swamp",
    "patch_firefly_bush_swamp",
    "patch_grass_badlands",
    "patch_grass_forest",
    "patch_grass_jungle",
    "patch_grass_meadow",
    "patch_grass_normal",
    "patch_grass_plain",
    "patch_grass_savanna",
    "patch_grass_taiga",
    "patch_grass_taiga_2",
    "patch_large_fern",
    "patch_leaf_litter",
    "patch_melon",
    "patch_melon_sparse",
    "patch_pumpkin",
    "patch_red_shrub",
    "patch_soul_fire",
    "patch_sugar_cane",
    "patch_sugar_cane_badlands",
    "patch_sugar_cane_desert",
    "patch_sugar_cane_swamp",
    "patch_sunflower",
    "patch_taiga_grass",
    "patch_tall_grass",
    "patch_tall_grass_2",
    "patch_waterlily",
    "pile_hay",
    "pile_ice",
    "pile_melon",
    "pile_pumpkin",
    "pile_snow",
    "pine",
    "pine_checked",
    "pine_on_snow",
    "pointed_dripstone",
    "red_mushroom_nether",
    "red_mushroom_normal",
    "red_mushroom_old_growth",
    "red_mushroom_swamp",
    "red_mushroom_taiga",
    "red_poplar",
    "red_poplar_leaf_litter",
    "rooted_azalea_tree",
    "rooted_sulfur_spring",
    "sculk_patch_ancient_city",
    "sculk_patch_deep_dark",
    "sculk_vein",
    "sea_pickle",
    "seagrass_cold",
    "seagrass_deep",
    "seagrass_deep_cold",
    "seagrass_deep_warm",
    "seagrass_normal",
    "seagrass_river",
    "seagrass_swamp",
    "seagrass_warm",
    "small_basalt_columns",
    "spore_blossom",
    "spring_closed",
    "spring_closed_double",
    "spring_delta",
    "spring_lava",
    "spring_lava_frozen",
    "spring_open",
    "spring_water",
    "spruce",
    "spruce_checked",
    "spruce_on_snow",
    "sulfur_pool",
    "sulfur_spike",
    "sulfur_spike_cluster",
    "super_birch_bees",
    "super_birch_bees_0002",
    "tall_mangrove_checked",
    "trees_badlands",
    "trees_birch",
    "trees_birch_and_oak_leaf_litter",
    "trees_cherry",
    "trees_dappled_forest",
    "trees_flower_forest",
    "trees_grove",
    "trees_jungle",
    "trees_mangrove",
    "trees_meadow",
    "trees_old_growth_pine_taiga",
    "trees_old_growth_spruce_taiga",
    "trees_plains",
    "trees_savanna",
    "trees_snowy",
    "trees_sparse_jungle",
    "trees_swamp",
    "trees_taiga",
    "trees_water",
    "trees_windswept_forest",
    "trees_windswept_hills",
    "trees_windswept_savanna",
    "twisting_vines",
    "underwater_magma",
    "vines",
    "void_start_platform",
    "warm_ocean_vegetation",
    "warped_forest_vegetation",
    "warped_fungi",
    "weeping_vines",
    "wildflowers_birch_forest",
    "wildflowers_meadow",
    "yellow_poplar",
    "yellow_poplar_leaf_litter"
  ]);
});

// src/arguments/generated/_registry/worldgen_processor_lists.ts
var WORLDGEN_PROCESSOR_LISTS_SET;
var init_worldgen_processor_lists = __esm(() => {
  init_sandstone();
  WORLDGEN_PROCESSOR_LISTS_SET = new Set2([
    "ancient_city_generic_degradation",
    "ancient_city_start_degradation",
    "ancient_city_walls_degradation",
    "bastion_generic_degradation",
    "bottom_rampart",
    "bridge",
    "empty",
    "entrance_replacement",
    "farm_desert",
    "farm_plains",
    "farm_savanna",
    "farm_snowy",
    "farm_taiga",
    "fossil_coal",
    "fossil_diamonds",
    "fossil_rot",
    "high_rampart",
    "high_wall",
    "housing",
    "mossify_10_percent",
    "mossify_20_percent",
    "mossify_70_percent",
    "outpost_rot",
    "rampart_degradation",
    "roof",
    "side_wall_degradation",
    "stable_degradation",
    "street_plains",
    "street_savanna",
    "street_snowy_or_taiga",
    "trail_ruins_houses_archaeology",
    "trail_ruins_roads_archaeology",
    "trail_ruins_tower_top_archaeology",
    "treasure_rooms",
    "trial_chambers_copper_bulb_degradation",
    "zombie_desert",
    "zombie_plains",
    "zombie_savanna",
    "zombie_snowy",
    "zombie_taiga"
  ]);
});

// src/arguments/generated/_registry/worldgen_structures.ts
var WORLDGEN_STRUCTURES_SET;
var init_worldgen_structures = __esm(() => {
  init_sandstone();
  WORLDGEN_STRUCTURES_SET = new Set2([
    "abandoned_camp_bamboo_jungle",
    "abandoned_camp_birch_forest",
    "abandoned_camp_cherry_grove",
    "abandoned_camp_dappled_forest",
    "abandoned_camp_flower_forest",
    "abandoned_camp_forest",
    "abandoned_camp_meadow",
    "abandoned_camp_old_growth_birch_forest",
    "abandoned_camp_old_growth_pine_taiga",
    "abandoned_camp_old_growth_spruce_taiga",
    "abandoned_camp_pale_garden",
    "abandoned_camp_savanna",
    "abandoned_camp_snowy_taiga",
    "abandoned_camp_sparse_jungle",
    "abandoned_camp_swamp",
    "abandoned_camp_taiga",
    "abandoned_camp_windswept_forest",
    "abandoned_camp_wooded_badlands",
    "ancient_city",
    "bastion_remnant",
    "buried_treasure",
    "desert_pyramid",
    "end_city",
    "fortress",
    "igloo",
    "jungle_pyramid",
    "mansion",
    "mineshaft",
    "mineshaft_mesa",
    "monument",
    "nether_fossil",
    "ocean_ruin_cold",
    "ocean_ruin_warm",
    "pillager_outpost",
    "ruined_portal",
    "ruined_portal_desert",
    "ruined_portal_jungle",
    "ruined_portal_mountain",
    "ruined_portal_nether",
    "ruined_portal_ocean",
    "ruined_portal_swamp",
    "shipwreck",
    "shipwreck_beached",
    "stronghold",
    "swamp_hut",
    "trail_ruins",
    "trial_chambers",
    "village_desert",
    "village_plains",
    "village_savanna",
    "village_snowy",
    "village_taiga"
  ]);
});

// src/arguments/generated/_registry/worldgen_structure_sets.ts
var WORLDGEN_STRUCTURE_SETS_SET;
var init_worldgen_structure_sets = __esm(() => {
  init_sandstone();
  WORLDGEN_STRUCTURE_SETS_SET = new Set2([
    "abandoned_camp",
    "ancient_cities",
    "buried_treasures",
    "desert_pyramids",
    "end_cities",
    "igloos",
    "jungle_temples",
    "mineshafts",
    "nether_complexes",
    "nether_fossils",
    "ocean_monuments",
    "ocean_ruins",
    "pillager_outposts",
    "ruined_portals",
    "shipwrecks",
    "strongholds",
    "swamp_huts",
    "trail_ruins",
    "trial_chambers",
    "villages",
    "woodland_mansions"
  ]);
});

// src/arguments/generated/_registry/worldgen_template_pools.ts
var WORLDGEN_TEMPLATE_POOLS_SET;
var init_worldgen_template_pools = __esm(() => {
  init_sandstone();
  WORLDGEN_TEMPLATE_POOLS_SET = new Set2([
    "abandoned_camp/camp/bamboo_jungle",
    "abandoned_camp/camp/birch_forest",
    "abandoned_camp/camp/cherry_grove",
    "abandoned_camp/camp/dappled_forest",
    "abandoned_camp/camp/flower_forest",
    "abandoned_camp/camp/forest",
    "abandoned_camp/camp/meadow",
    "abandoned_camp/camp/old_growth_birch_forest",
    "abandoned_camp/camp/old_growth_pine_taiga",
    "abandoned_camp/camp/old_growth_spruce_taiga",
    "abandoned_camp/camp/pale_garden",
    "abandoned_camp/camp/savanna",
    "abandoned_camp/camp/snowy_taiga",
    "abandoned_camp/camp/sparse_jungle",
    "abandoned_camp/camp/swamp",
    "abandoned_camp/camp/taiga",
    "abandoned_camp/camp/windswept_forest",
    "abandoned_camp/camp/wooded_badlands",
    "abandoned_camp/tent/bamboo_jungle",
    "abandoned_camp/tent/birch_forest",
    "abandoned_camp/tent/cherry_grove",
    "abandoned_camp/tent/dappled_forest",
    "abandoned_camp/tent/flower_forest",
    "abandoned_camp/tent/forest",
    "abandoned_camp/tent/meadow",
    "abandoned_camp/tent/old_growth_birch_forest",
    "abandoned_camp/tent/old_growth_pine_taiga",
    "abandoned_camp/tent/old_growth_spruce_taiga",
    "abandoned_camp/tent/pale_garden",
    "abandoned_camp/tent/savanna",
    "abandoned_camp/tent/snowy_taiga",
    "abandoned_camp/tent/sparse_jungle",
    "abandoned_camp/tent/swamp",
    "abandoned_camp/tent/taiga",
    "abandoned_camp/tent/windswept_forest",
    "abandoned_camp/tent/wooded_badlands",
    "abandoned_camp/trees/acacia",
    "abandoned_camp/trees/bamboo",
    "abandoned_camp/trees/birch",
    "abandoned_camp/trees/birch_bees",
    "abandoned_camp/trees/cherry",
    "abandoned_camp/trees/cherry_bees",
    "abandoned_camp/trees/fancy_oak",
    "abandoned_camp/trees/fancy_oak_bees",
    "abandoned_camp/trees/jungle",
    "abandoned_camp/trees/mega_jungle",
    "abandoned_camp/trees/mega_pine",
    "abandoned_camp/trees/oak",
    "abandoned_camp/trees/orange_poplar",
    "abandoned_camp/trees/pale_oak",
    "abandoned_camp/trees/pine",
    "abandoned_camp/trees/red_poplar",
    "abandoned_camp/trees/spruce",
    "abandoned_camp/trees/spruce_on_snow",
    "abandoned_camp/trees/super_birch_bees",
    "abandoned_camp/trees/thick_spruce",
    "abandoned_camp/trees/yellow_poplar",
    "ancient_city/city/entrance",
    "ancient_city/city_center",
    "ancient_city/city_center/walls",
    "ancient_city/sculk",
    "ancient_city/structures",
    "ancient_city/walls",
    "ancient_city/walls/no_corners",
    "bastion/blocks/gold",
    "bastion/bridge/bridge_pieces",
    "bastion/bridge/connectors",
    "bastion/bridge/legs",
    "bastion/bridge/rampart_plates",
    "bastion/bridge/ramparts",
    "bastion/bridge/starting_pieces",
    "bastion/bridge/walls",
    "bastion/hoglin_stable/connectors",
    "bastion/hoglin_stable/large_stables/inner",
    "bastion/hoglin_stable/large_stables/outer",
    "bastion/hoglin_stable/mirrored_starting_pieces",
    "bastion/hoglin_stable/posts",
    "bastion/hoglin_stable/rampart_plates",
    "bastion/hoglin_stable/ramparts",
    "bastion/hoglin_stable/small_stables/inner",
    "bastion/hoglin_stable/small_stables/outer",
    "bastion/hoglin_stable/stairs",
    "bastion/hoglin_stable/starting_pieces",
    "bastion/hoglin_stable/wall_bases",
    "bastion/hoglin_stable/walls",
    "bastion/mobs/hoglin",
    "bastion/mobs/piglin",
    "bastion/mobs/piglin_melee",
    "bastion/starts",
    "bastion/treasure/bases",
    "bastion/treasure/bases/centers",
    "bastion/treasure/brains",
    "bastion/treasure/connectors",
    "bastion/treasure/corners/bottom",
    "bastion/treasure/corners/edges",
    "bastion/treasure/corners/middle",
    "bastion/treasure/corners/top",
    "bastion/treasure/entrances",
    "bastion/treasure/extensions/houses",
    "bastion/treasure/extensions/large_pool",
    "bastion/treasure/extensions/small_pool",
    "bastion/treasure/ramparts",
    "bastion/treasure/roofs",
    "bastion/treasure/stairs",
    "bastion/treasure/walls",
    "bastion/treasure/walls/bottom",
    "bastion/treasure/walls/mid",
    "bastion/treasure/walls/outer",
    "bastion/treasure/walls/top",
    "bastion/units/center_pieces",
    "bastion/units/edge_wall_units",
    "bastion/units/edges",
    "bastion/units/fillers/stage_0",
    "bastion/units/large_ramparts",
    "bastion/units/pathways",
    "bastion/units/rampart_plates",
    "bastion/units/ramparts",
    "bastion/units/stages/rot/stage_1",
    "bastion/units/stages/stage_0",
    "bastion/units/stages/stage_1",
    "bastion/units/stages/stage_2",
    "bastion/units/stages/stage_3",
    "bastion/units/wall_units",
    "bastion/units/walls/wall_bases",
    "empty",
    "pillager_outpost/base_plates",
    "pillager_outpost/feature_plates",
    "pillager_outpost/features",
    "pillager_outpost/towers",
    "trail_ruins/buildings",
    "trail_ruins/buildings/grouped",
    "trail_ruins/decor",
    "trail_ruins/roads",
    "trail_ruins/tower",
    "trail_ruins/tower/additions",
    "trail_ruins/tower/tower_top",
    "trial_chambers/atrium",
    "trial_chambers/chamber/addon",
    "trial_chambers/chamber/assembly",
    "trial_chambers/chamber/end",
    "trial_chambers/chamber/entrance_cap",
    "trial_chambers/chamber/eruption",
    "trial_chambers/chamber/pedestal",
    "trial_chambers/chamber/slanted",
    "trial_chambers/chambers/end",
    "trial_chambers/chests/contents/supply",
    "trial_chambers/chests/supply",
    "trial_chambers/corridor",
    "trial_chambers/corridor/slices",
    "trial_chambers/corridors/addon/lower",
    "trial_chambers/corridors/addon/middle",
    "trial_chambers/corridors/addon/middle_upper",
    "trial_chambers/decor",
    "trial_chambers/decor/bed",
    "trial_chambers/decor/chamber",
    "trial_chambers/decor/disposal",
    "trial_chambers/dispensers/chamber",
    "trial_chambers/entrance",
    "trial_chambers/hallway",
    "trial_chambers/hallway/fallback",
    "trial_chambers/reward/all",
    "trial_chambers/reward/contents/default",
    "trial_chambers/reward/ominous_vault",
    "trial_chambers/spawner/all",
    "trial_chambers/spawner/breeze",
    "trial_chambers/spawner/contents/breeze",
    "trial_chambers/spawner/melee",
    "trial_chambers/spawner/melee/husk",
    "trial_chambers/spawner/melee/spider",
    "trial_chambers/spawner/melee/zombie",
    "trial_chambers/spawner/ranged",
    "trial_chambers/spawner/ranged/poison_skeleton",
    "trial_chambers/spawner/ranged/skeleton",
    "trial_chambers/spawner/ranged/stray",
    "trial_chambers/spawner/slow_ranged",
    "trial_chambers/spawner/slow_ranged/poison_skeleton",
    "trial_chambers/spawner/slow_ranged/skeleton",
    "trial_chambers/spawner/slow_ranged/stray",
    "trial_chambers/spawner/small_melee",
    "trial_chambers/spawner/small_melee/baby_zombie",
    "trial_chambers/spawner/small_melee/cave_spider",
    "trial_chambers/spawner/small_melee/silverfish",
    "trial_chambers/spawner/small_melee/slime",
    "village/common/animals",
    "village/common/butcher_animals",
    "village/common/cats",
    "village/common/iron_golem",
    "village/common/sheep",
    "village/common/well_bottoms",
    "village/desert/camel",
    "village/desert/decor",
    "village/desert/houses",
    "village/desert/streets",
    "village/desert/terminators",
    "village/desert/town_centers",
    "village/desert/villagers",
    "village/desert/zombie/decor",
    "village/desert/zombie/houses",
    "village/desert/zombie/streets",
    "village/desert/zombie/terminators",
    "village/desert/zombie/villagers",
    "village/plains/decor",
    "village/plains/houses",
    "village/plains/streets",
    "village/plains/terminators",
    "village/plains/town_centers",
    "village/plains/trees",
    "village/plains/villagers",
    "village/plains/zombie/decor",
    "village/plains/zombie/houses",
    "village/plains/zombie/streets",
    "village/plains/zombie/villagers",
    "village/savanna/decor",
    "village/savanna/houses",
    "village/savanna/streets",
    "village/savanna/terminators",
    "village/savanna/town_centers",
    "village/savanna/trees",
    "village/savanna/villagers",
    "village/savanna/zombie/decor",
    "village/savanna/zombie/houses",
    "village/savanna/zombie/streets",
    "village/savanna/zombie/terminators",
    "village/savanna/zombie/villagers",
    "village/snowy/decor",
    "village/snowy/houses",
    "village/snowy/streets",
    "village/snowy/terminators",
    "village/snowy/town_centers",
    "village/snowy/trees",
    "village/snowy/villagers",
    "village/snowy/zombie/decor",
    "village/snowy/zombie/houses",
    "village/snowy/zombie/streets",
    "village/snowy/zombie/villagers",
    "village/taiga/decor",
    "village/taiga/houses",
    "village/taiga/streets",
    "village/taiga/terminators",
    "village/taiga/town_centers",
    "village/taiga/villagers",
    "village/taiga/zombie/decor",
    "village/taiga/zombie/houses",
    "village/taiga/zombie/streets",
    "village/taiga/zombie/villagers"
  ]);
});

// src/arguments/generated/_registry/worldgen_world_presets.ts
var WORLDGEN_WORLD_PRESETS_SET;
var init_worldgen_world_presets = __esm(() => {
  init_sandstone();
  WORLDGEN_WORLD_PRESETS_SET = new Set2([
    "amplified",
    "debug_all_block_states",
    "flat",
    "flat_all_dimensions",
    "large_biomes",
    "normal",
    "single_biome_surface"
  ]);
});

// src/arguments/generated/_registry/translation_keys.ts
var TRANSLATION_KEYS_SET;
var init_translation_keys = __esm(() => {
  init_sandstone();
  TRANSLATION_KEYS_SET = new Set2([
    "accessibility.onboarding.accessibility.button",
    "accessibility.onboarding.accessibility.button.narration",
    "accessibility.onboarding.screen.narrator",
    "accessibility.onboarding.screen.title",
    "addServer.add",
    "addServer.enterIp",
    "addServer.enterName",
    "addServer.resourcePack",
    "addServer.resourcePack.disabled",
    "addServer.resourcePack.enabled",
    "addServer.resourcePack.prompt",
    "addServer.title",
    "advancement.advancementNotFound",
    "advancements.adventure.adventuring_time.description",
    "advancements.adventure.adventuring_time.title",
    "advancements.adventure.arbalistic.description",
    "advancements.adventure.arbalistic.title",
    "advancements.adventure.avoid_vibration.description",
    "advancements.adventure.avoid_vibration.title",
    "advancements.adventure.blowback.description",
    "advancements.adventure.blowback.title",
    "advancements.adventure.brush_armadillo.description",
    "advancements.adventure.brush_armadillo.title",
    "advancements.adventure.bullseye.description",
    "advancements.adventure.bullseye.title",
    "advancements.adventure.craft_decorated_pot_using_only_sherds.description",
    "advancements.adventure.craft_decorated_pot_using_only_sherds.title",
    "advancements.adventure.crafters_crafting_crafters.description",
    "advancements.adventure.crafters_crafting_crafters.title",
    "advancements.adventure.fall_from_world_height.description",
    "advancements.adventure.fall_from_world_height.title",
    "advancements.adventure.heart_transplanter.description",
    "advancements.adventure.heart_transplanter.title",
    "advancements.adventure.hero_of_the_village.description",
    "advancements.adventure.hero_of_the_village.title",
    "advancements.adventure.honey_block_slide.description",
    "advancements.adventure.honey_block_slide.title",
    "advancements.adventure.kill_a_mob.description",
    "advancements.adventure.kill_a_mob.title",
    "advancements.adventure.kill_all_mobs.description",
    "advancements.adventure.kill_all_mobs.title",
    "advancements.adventure.kill_mob_near_sculk_catalyst.description",
    "advancements.adventure.kill_mob_near_sculk_catalyst.title",
    "advancements.adventure.lighten_up.description",
    "advancements.adventure.lighten_up.title",
    "advancements.adventure.lightning_rod_with_villager_no_fire.description",
    "advancements.adventure.lightning_rod_with_villager_no_fire.title",
    "advancements.adventure.minecraft_trials_edition.description",
    "advancements.adventure.minecraft_trials_edition.title",
    "advancements.adventure.ol_betsy.description",
    "advancements.adventure.ol_betsy.title",
    "advancements.adventure.overoverkill.description",
    "advancements.adventure.overoverkill.title",
    "advancements.adventure.play_jukebox_in_meadows.description",
    "advancements.adventure.play_jukebox_in_meadows.title",
    "advancements.adventure.read_power_from_chiseled_bookshelf.description",
    "advancements.adventure.read_power_from_chiseled_bookshelf.title",
    "advancements.adventure.revaulting.description",
    "advancements.adventure.revaulting.title",
    "advancements.adventure.root.description",
    "advancements.adventure.root.title",
    "advancements.adventure.salvage_sherd.description",
    "advancements.adventure.salvage_sherd.title",
    "advancements.adventure.shoot_arrow.description",
    "advancements.adventure.shoot_arrow.title",
    "advancements.adventure.sleep_in_bed.description",
    "advancements.adventure.sleep_in_bed.title",
    "advancements.adventure.sniper_duel.description",
    "advancements.adventure.sniper_duel.title",
    "advancements.adventure.spear_many_mobs.description",
    "advancements.adventure.spear_many_mobs.title",
    "advancements.adventure.spyglass_at_dragon.description",
    "advancements.adventure.spyglass_at_dragon.title",
    "advancements.adventure.spyglass_at_ghast.description",
    "advancements.adventure.spyglass_at_ghast.title",
    "advancements.adventure.spyglass_at_parrot.description",
    "advancements.adventure.spyglass_at_parrot.title",
    "advancements.adventure.summon_iron_golem.description",
    "advancements.adventure.summon_iron_golem.title",
    "advancements.adventure.throw_trident.description",
    "advancements.adventure.throw_trident.title",
    "advancements.adventure.totem_of_undying.description",
    "advancements.adventure.totem_of_undying.title",
    "advancements.adventure.trade_at_world_height.description",
    "advancements.adventure.trade_at_world_height.title",
    "advancements.adventure.trade.description",
    "advancements.adventure.trade.title",
    "advancements.adventure.trim_with_all_exclusive_armor_patterns.description",
    "advancements.adventure.trim_with_all_exclusive_armor_patterns.title",
    "advancements.adventure.trim_with_any_armor_pattern.description",
    "advancements.adventure.trim_with_any_armor_pattern.title",
    "advancements.adventure.two_birds_one_arrow.description",
    "advancements.adventure.two_birds_one_arrow.title",
    "advancements.adventure.under_lock_and_key.description",
    "advancements.adventure.under_lock_and_key.title",
    "advancements.adventure.use_lodestone.description",
    "advancements.adventure.use_lodestone.title",
    "advancements.adventure.very_very_frightening.description",
    "advancements.adventure.very_very_frightening.title",
    "advancements.adventure.voluntary_exile.description",
    "advancements.adventure.voluntary_exile.title",
    "advancements.adventure.walk_on_powder_snow_with_leather_boots.description",
    "advancements.adventure.walk_on_powder_snow_with_leather_boots.title",
    "advancements.adventure.who_needs_rockets.description",
    "advancements.adventure.who_needs_rockets.title",
    "advancements.adventure.whos_the_pillager_now.description",
    "advancements.adventure.whos_the_pillager_now.title",
    "advancements.empty",
    "advancements.end.dragon_breath.description",
    "advancements.end.dragon_breath.title",
    "advancements.end.dragon_egg.description",
    "advancements.end.dragon_egg.title",
    "advancements.end.elytra.description",
    "advancements.end.elytra.title",
    "advancements.end.enter_end_gateway.description",
    "advancements.end.enter_end_gateway.title",
    "advancements.end.find_end_city.description",
    "advancements.end.find_end_city.title",
    "advancements.end.kill_dragon.description",
    "advancements.end.kill_dragon.title",
    "advancements.end.levitate.description",
    "advancements.end.levitate.title",
    "advancements.end.respawn_dragon.description",
    "advancements.end.respawn_dragon.title",
    "advancements.end.root.description",
    "advancements.end.root.title",
    "advancements.husbandry.allay_deliver_cake_to_note_block.description",
    "advancements.husbandry.allay_deliver_cake_to_note_block.title",
    "advancements.husbandry.allay_deliver_item_to_player.description",
    "advancements.husbandry.allay_deliver_item_to_player.title",
    "advancements.husbandry.axolotl_in_a_bucket.description",
    "advancements.husbandry.axolotl_in_a_bucket.title",
    "advancements.husbandry.balanced_diet.description",
    "advancements.husbandry.balanced_diet.title",
    "advancements.husbandry.breed_all_animals.description",
    "advancements.husbandry.breed_all_animals.title",
    "advancements.husbandry.breed_an_animal.description",
    "advancements.husbandry.breed_an_animal.title",
    "advancements.husbandry.complete_catalogue.description",
    "advancements.husbandry.complete_catalogue.title",
    "advancements.husbandry.feed_snifflet.description",
    "advancements.husbandry.feed_snifflet.title",
    "advancements.husbandry.fishy_business.description",
    "advancements.husbandry.fishy_business.title",
    "advancements.husbandry.froglights.description",
    "advancements.husbandry.froglights.title",
    "advancements.husbandry.kill_axolotl_target.description",
    "advancements.husbandry.kill_axolotl_target.title",
    "advancements.husbandry.leash_all_frog_variants.description",
    "advancements.husbandry.leash_all_frog_variants.title",
    "advancements.husbandry.make_a_sign_glow.description",
    "advancements.husbandry.make_a_sign_glow.title",
    "advancements.husbandry.netherite_hoe.description",
    "advancements.husbandry.netherite_hoe.title",
    "advancements.husbandry.obtain_sniffer_egg.description",
    "advancements.husbandry.obtain_sniffer_egg.title",
    "advancements.husbandry.place_dried_ghast_in_water.description",
    "advancements.husbandry.place_dried_ghast_in_water.title",
    "advancements.husbandry.plant_any_sniffer_seed.description",
    "advancements.husbandry.plant_any_sniffer_seed.title",
    "advancements.husbandry.plant_seed.description",
    "advancements.husbandry.plant_seed.title",
    "advancements.husbandry.remove_wolf_armor.description",
    "advancements.husbandry.remove_wolf_armor.title",
    "advancements.husbandry.repair_wolf_armor.description",
    "advancements.husbandry.repair_wolf_armor.title",
    "advancements.husbandry.ride_a_boat_with_a_goat.description",
    "advancements.husbandry.ride_a_boat_with_a_goat.title",
    "advancements.husbandry.root.description",
    "advancements.husbandry.root.title",
    "advancements.husbandry.safely_harvest_honey.description",
    "advancements.husbandry.safely_harvest_honey.title",
    "advancements.husbandry.silk_touch_nest.description",
    "advancements.husbandry.silk_touch_nest.title",
    "advancements.husbandry.tactical_fishing.description",
    "advancements.husbandry.tactical_fishing.title",
    "advancements.husbandry.tadpole_in_a_bucket.description",
    "advancements.husbandry.tadpole_in_a_bucket.title",
    "advancements.husbandry.tame_an_animal.description",
    "advancements.husbandry.tame_an_animal.title",
    "advancements.husbandry.uh_oh.description",
    "advancements.husbandry.uh_oh.title",
    "advancements.husbandry.wax_off.description",
    "advancements.husbandry.wax_off.title",
    "advancements.husbandry.wax_on.description",
    "advancements.husbandry.wax_on.title",
    "advancements.husbandry.whole_pack.description",
    "advancements.husbandry.whole_pack.title",
    "advancements.nether.all_effects.description",
    "advancements.nether.all_effects.title",
    "advancements.nether.all_potions.description",
    "advancements.nether.all_potions.title",
    "advancements.nether.brew_potion.description",
    "advancements.nether.brew_potion.title",
    "advancements.nether.charge_respawn_anchor.description",
    "advancements.nether.charge_respawn_anchor.title",
    "advancements.nether.create_beacon.description",
    "advancements.nether.create_beacon.title",
    "advancements.nether.create_full_beacon.description",
    "advancements.nether.create_full_beacon.title",
    "advancements.nether.distract_piglin.description",
    "advancements.nether.distract_piglin.title",
    "advancements.nether.explore_nether.description",
    "advancements.nether.explore_nether.title",
    "advancements.nether.fast_travel.description",
    "advancements.nether.fast_travel.title",
    "advancements.nether.find_bastion.description",
    "advancements.nether.find_bastion.title",
    "advancements.nether.find_fortress.description",
    "advancements.nether.find_fortress.title",
    "advancements.nether.get_wither_skull.description",
    "advancements.nether.get_wither_skull.title",
    "advancements.nether.loot_bastion.description",
    "advancements.nether.loot_bastion.title",
    "advancements.nether.netherite_armor.description",
    "advancements.nether.netherite_armor.title",
    "advancements.nether.obtain_ancient_debris.description",
    "advancements.nether.obtain_ancient_debris.title",
    "advancements.nether.obtain_blaze_rod.description",
    "advancements.nether.obtain_blaze_rod.title",
    "advancements.nether.obtain_crying_obsidian.description",
    "advancements.nether.obtain_crying_obsidian.title",
    "advancements.nether.return_to_sender.description",
    "advancements.nether.return_to_sender.title",
    "advancements.nether.ride_strider_in_overworld_lava.description",
    "advancements.nether.ride_strider_in_overworld_lava.title",
    "advancements.nether.ride_strider.description",
    "advancements.nether.ride_strider.title",
    "advancements.nether.root.description",
    "advancements.nether.root.title",
    "advancements.nether.summon_wither.description",
    "advancements.nether.summon_wither.title",
    "advancements.nether.uneasy_alliance.description",
    "advancements.nether.uneasy_alliance.title",
    "advancements.nether.use_lodestone.description",
    "advancements.nether.use_lodestone.title",
    "advancements.progress",
    "advancements.sad_label",
    "advancements.story.cure_zombie_villager.description",
    "advancements.story.cure_zombie_villager.title",
    "advancements.story.deflect_arrow.description",
    "advancements.story.deflect_arrow.title",
    "advancements.story.enchant_item.description",
    "advancements.story.enchant_item.title",
    "advancements.story.enter_the_end.description",
    "advancements.story.enter_the_end.title",
    "advancements.story.enter_the_nether.description",
    "advancements.story.enter_the_nether.title",
    "advancements.story.follow_ender_eye.description",
    "advancements.story.follow_ender_eye.title",
    "advancements.story.form_obsidian.description",
    "advancements.story.form_obsidian.title",
    "advancements.story.iron_tools.description",
    "advancements.story.iron_tools.title",
    "advancements.story.lava_bucket.description",
    "advancements.story.lava_bucket.title",
    "advancements.story.mine_diamond.description",
    "advancements.story.mine_diamond.title",
    "advancements.story.mine_stone.description",
    "advancements.story.mine_stone.title",
    "advancements.story.obtain_armor.description",
    "advancements.story.obtain_armor.title",
    "advancements.story.root.description",
    "advancements.story.root.title",
    "advancements.story.shiny_gear.description",
    "advancements.story.shiny_gear.title",
    "advancements.story.smelt_iron.description",
    "advancements.story.smelt_iron.title",
    "advancements.story.upgrade_tools.description",
    "advancements.story.upgrade_tools.title",
    "advancements.toast.challenge",
    "advancements.toast.goal",
    "advancements.toast.task",
    "advMode.command",
    "advMode.mode",
    "advMode.mode.auto",
    "advMode.mode.autoexec.bat",
    "advMode.mode.conditional",
    "advMode.mode.redstone",
    "advMode.mode.redstoneTriggered",
    "advMode.mode.sequence",
    "advMode.mode.unconditional",
    "advMode.notAllowed",
    "advMode.notEnabled",
    "advMode.notEnabled.spawner",
    "advMode.previousOutput",
    "advMode.setCommand",
    "advMode.setCommand.disabled",
    "advMode.setCommand.success",
    "advMode.trackOutput",
    "advMode.triggering",
    "advMode.type",
    "argument.anchor.invalid",
    "argument.angle.incomplete",
    "argument.angle.invalid",
    "argument.block.id.invalid",
    "argument.block.property.duplicate",
    "argument.block.property.invalid",
    "argument.block.property.novalue",
    "argument.block.property.unclosed",
    "argument.block.property.unknown",
    "argument.block.tag.disallowed",
    "argument.color.invalid",
    "argument.component.invalid",
    "argument.criteria.invalid",
    "argument.dimension.invalid",
    "argument.double.big",
    "argument.double.low",
    "argument.entity.invalid",
    "argument.entity.notfound.entity",
    "argument.entity.notfound.player",
    "argument.entity.options.advancements.description",
    "argument.entity.options.distance.description",
    "argument.entity.options.distance.negative",
    "argument.entity.options.dx.description",
    "argument.entity.options.dy.description",
    "argument.entity.options.dz.description",
    "argument.entity.options.gamemode.description",
    "argument.entity.options.inapplicable",
    "argument.entity.options.level.description",
    "argument.entity.options.level.negative",
    "argument.entity.options.limit.description",
    "argument.entity.options.limit.toosmall",
    "argument.entity.options.mode.invalid",
    "argument.entity.options.name.description",
    "argument.entity.options.nbt.description",
    "argument.entity.options.predicate.description",
    "argument.entity.options.scores.description",
    "argument.entity.options.sort.description",
    "argument.entity.options.sort.irreversible",
    "argument.entity.options.tag.description",
    "argument.entity.options.team.description",
    "argument.entity.options.type.description",
    "argument.entity.options.type.invalid",
    "argument.entity.options.unknown",
    "argument.entity.options.unterminated",
    "argument.entity.options.valueless",
    "argument.entity.options.x_rotation.description",
    "argument.entity.options.x.description",
    "argument.entity.options.y_rotation.description",
    "argument.entity.options.y.description",
    "argument.entity.options.z.description",
    "argument.entity.selector.allEntities",
    "argument.entity.selector.allPlayers",
    "argument.entity.selector.missing",
    "argument.entity.selector.nearestEntity",
    "argument.entity.selector.nearestPlayer",
    "argument.entity.selector.not_allowed",
    "argument.entity.selector.randomPlayer",
    "argument.entity.selector.self",
    "argument.entity.selector.unknown",
    "argument.entity.toomany",
    "argument.enum.invalid",
    "argument.float.big",
    "argument.float.low",
    "argument.gamemode.invalid",
    "argument.hexcolor.invalid",
    "argument.id.invalid",
    "argument.id.unknown",
    "argument.integer.big",
    "argument.integer.low",
    "argument.item.id.invalid",
    "argument.item.tag.disallowed",
    "argument.literal.incorrect",
    "argument.long.big",
    "argument.long.low",
    "argument.message.too_long",
    "argument.nbt.array.invalid",
    "argument.nbt.array.mixed",
    "argument.nbt.expected.compound",
    "argument.nbt.expected.key",
    "argument.nbt.expected.value",
    "argument.nbt.list.mixed",
    "argument.nbt.trailing",
    "argument.player.entities",
    "argument.player.toomany",
    "argument.player.unknown",
    "argument.pos.missing.double",
    "argument.pos.missing.int",
    "argument.pos.mixed",
    "argument.pos.outofbounds",
    "argument.pos.outofworld",
    "argument.pos.unloaded",
    "argument.pos2d.incomplete",
    "argument.pos3d.incomplete",
    "argument.range.empty",
    "argument.range.ints",
    "argument.range.swapped",
    "argument.resource_or_id.failed_to_parse",
    "argument.resource_or_id.invalid",
    "argument.resource_or_id.no_such_element",
    "argument.resource_selector.not_found",
    "argument.resource_tag.invalid_type",
    "argument.resource_tag.not_found",
    "argument.resource.invalid_type",
    "argument.resource.not_found",
    "argument.rotation.incomplete",
    "argument.scoreboardDisplaySlot.invalid",
    "argument.scoreHolder.empty",
    "argument.style.invalid",
    "argument.swing_animation.invalid",
    "argument.time.invalid_tick_count",
    "argument.time.invalid_unit",
    "argument.time.tick_count_too_low",
    "argument.uuid.invalid",
    "argument.waypoint.invalid",
    "arguments.block.tag.unknown",
    "arguments.function.tag.unknown",
    "arguments.function.unknown",
    "arguments.item.component.expected",
    "arguments.item.component.malformed",
    "arguments.item.component.repeated",
    "arguments.item.component.unknown",
    "arguments.item.malformed",
    "arguments.item.overstacked",
    "arguments.item.predicate.malformed",
    "arguments.item.predicate.unknown",
    "arguments.item.tag.unknown",
    "arguments.nbtpath.node.invalid",
    "arguments.nbtpath.nothing_found",
    "arguments.nbtpath.too_deep",
    "arguments.nbtpath.too_large",
    "arguments.objective.notFound",
    "arguments.objective.readonly",
    "arguments.operation.div0",
    "arguments.operation.invalid",
    "arguments.swizzle.invalid",
    "attribute.modifier.equals.0",
    "attribute.modifier.equals.1",
    "attribute.modifier.equals.2",
    "attribute.modifier.plus.0",
    "attribute.modifier.plus.1",
    "attribute.modifier.plus.2",
    "attribute.modifier.take.0",
    "attribute.modifier.take.1",
    "attribute.modifier.take.2",
    "attribute.name.air_drag_modifier",
    "attribute.name.armor",
    "attribute.name.armor_toughness",
    "attribute.name.attack_damage",
    "attribute.name.attack_knockback",
    "attribute.name.attack_speed",
    "attribute.name.below_name_distance",
    "attribute.name.block_break_speed",
    "attribute.name.block_interaction_range",
    "attribute.name.bounciness",
    "attribute.name.burning_time",
    "attribute.name.camera_distance",
    "attribute.name.entity_interaction_range",
    "attribute.name.explosion_knockback_resistance",
    "attribute.name.fall_damage_multiplier",
    "attribute.name.flying_speed",
    "attribute.name.follow_range",
    "attribute.name.friction_modifier",
    "attribute.name.generic.armor",
    "attribute.name.generic.armor_toughness",
    "attribute.name.generic.attack_damage",
    "attribute.name.generic.attack_knockback",
    "attribute.name.generic.attack_speed",
    "attribute.name.generic.block_interaction_range",
    "attribute.name.generic.burning_time",
    "attribute.name.generic.entity_interaction_range",
    "attribute.name.generic.explosion_knockback_resistance",
    "attribute.name.generic.fall_damage_multiplier",
    "attribute.name.generic.flying_speed",
    "attribute.name.generic.follow_range",
    "attribute.name.generic.gravity",
    "attribute.name.generic.jump_strength",
    "attribute.name.generic.knockback_resistance",
    "attribute.name.generic.luck",
    "attribute.name.generic.max_absorption",
    "attribute.name.generic.max_health",
    "attribute.name.generic.movement_efficiency",
    "attribute.name.generic.movement_speed",
    "attribute.name.generic.oxygen_bonus",
    "attribute.name.generic.safe_fall_distance",
    "attribute.name.generic.scale",
    "attribute.name.generic.step_height",
    "attribute.name.generic.water_movement_efficiency",
    "attribute.name.gravity",
    "attribute.name.horse.jump_strength",
    "attribute.name.jump_strength",
    "attribute.name.knockback_resistance",
    "attribute.name.luck",
    "attribute.name.max_absorption",
    "attribute.name.max_health",
    "attribute.name.mining_efficiency",
    "attribute.name.movement_efficiency",
    "attribute.name.movement_speed",
    "attribute.name.nameplate_distance",
    "attribute.name.oxygen_bonus",
    "attribute.name.player.block_break_speed",
    "attribute.name.player.block_interaction_range",
    "attribute.name.player.entity_interaction_range",
    "attribute.name.player.mining_efficiency",
    "attribute.name.player.sneaking_speed",
    "attribute.name.player.submerged_mining_speed",
    "attribute.name.player.sweeping_damage_ratio",
    "attribute.name.safe_fall_distance",
    "attribute.name.scale",
    "attribute.name.sneaking_speed",
    "attribute.name.spawn_reinforcements",
    "attribute.name.step_height",
    "attribute.name.submerged_mining_speed",
    "attribute.name.sweeping_damage_ratio",
    "attribute.name.tempt_range",
    "attribute.name.water_movement_efficiency",
    "attribute.name.waypoint_receive_range",
    "attribute.name.waypoint_transmit_range",
    "attribute.name.zombie.spawn_reinforcements",
    "biome.minecraft.badlands",
    "biome.minecraft.bamboo_jungle",
    "biome.minecraft.basalt_deltas",
    "biome.minecraft.beach",
    "biome.minecraft.birch_forest",
    "biome.minecraft.cherry_grove",
    "biome.minecraft.cold_ocean",
    "biome.minecraft.crimson_forest",
    "biome.minecraft.dappled_forest",
    "biome.minecraft.dark_forest",
    "biome.minecraft.deep_cold_ocean",
    "biome.minecraft.deep_dark",
    "biome.minecraft.deep_frozen_ocean",
    "biome.minecraft.deep_lukewarm_ocean",
    "biome.minecraft.deep_ocean",
    "biome.minecraft.desert",
    "biome.minecraft.dripstone_caves",
    "biome.minecraft.end_barrens",
    "biome.minecraft.end_highlands",
    "biome.minecraft.end_midlands",
    "biome.minecraft.eroded_badlands",
    "biome.minecraft.flower_forest",
    "biome.minecraft.forest",
    "biome.minecraft.frozen_ocean",
    "biome.minecraft.frozen_peaks",
    "biome.minecraft.frozen_river",
    "biome.minecraft.grove",
    "biome.minecraft.ice_spikes",
    "biome.minecraft.jagged_peaks",
    "biome.minecraft.jungle",
    "biome.minecraft.lukewarm_ocean",
    "biome.minecraft.lush_caves",
    "biome.minecraft.mangrove_swamp",
    "biome.minecraft.meadow",
    "biome.minecraft.mushroom_fields",
    "biome.minecraft.nether_wastes",
    "biome.minecraft.ocean",
    "biome.minecraft.old_growth_birch_forest",
    "biome.minecraft.old_growth_pine_taiga",
    "biome.minecraft.old_growth_spruce_taiga",
    "biome.minecraft.pale_garden",
    "biome.minecraft.plains",
    "biome.minecraft.river",
    "biome.minecraft.savanna",
    "biome.minecraft.savanna_plateau",
    "biome.minecraft.small_end_islands",
    "biome.minecraft.snowy_beach",
    "biome.minecraft.snowy_plains",
    "biome.minecraft.snowy_slopes",
    "biome.minecraft.snowy_taiga",
    "biome.minecraft.soul_sand_valley",
    "biome.minecraft.sparse_jungle",
    "biome.minecraft.stony_peaks",
    "biome.minecraft.stony_shore",
    "biome.minecraft.sulfur_caves",
    "biome.minecraft.sunflower_plains",
    "biome.minecraft.swamp",
    "biome.minecraft.taiga",
    "biome.minecraft.the_end",
    "biome.minecraft.the_void",
    "biome.minecraft.warm_ocean",
    "biome.minecraft.warped_forest",
    "biome.minecraft.windswept_forest",
    "biome.minecraft.windswept_gravelly_hills",
    "biome.minecraft.windswept_hills",
    "biome.minecraft.windswept_savanna",
    "biome.minecraft.wooded_badlands",
    "block.minecraft.acacia_button",
    "block.minecraft.acacia_door",
    "block.minecraft.acacia_fence",
    "block.minecraft.acacia_fence_gate",
    "block.minecraft.acacia_hanging_sign",
    "block.minecraft.acacia_leaves",
    "block.minecraft.acacia_log",
    "block.minecraft.acacia_planks",
    "block.minecraft.acacia_pressure_plate",
    "block.minecraft.acacia_sapling",
    "block.minecraft.acacia_shelf",
    "block.minecraft.acacia_sign",
    "block.minecraft.acacia_slab",
    "block.minecraft.acacia_stairs",
    "block.minecraft.acacia_trapdoor",
    "block.minecraft.acacia_wall_hanging_sign",
    "block.minecraft.acacia_wall_sign",
    "block.minecraft.acacia_wood",
    "block.minecraft.activator_rail",
    "block.minecraft.air",
    "block.minecraft.allium",
    "block.minecraft.amethyst_block",
    "block.minecraft.amethyst_cluster",
    "block.minecraft.ancient_debris",
    "block.minecraft.andesite",
    "block.minecraft.andesite_slab",
    "block.minecraft.andesite_stairs",
    "block.minecraft.andesite_wall",
    "block.minecraft.anvil",
    "block.minecraft.attached_melon_stem",
    "block.minecraft.attached_pumpkin_stem",
    "block.minecraft.azalea",
    "block.minecraft.azalea_leaves",
    "block.minecraft.azure_bluet",
    "block.minecraft.bamboo",
    "block.minecraft.bamboo_block",
    "block.minecraft.bamboo_button",
    "block.minecraft.bamboo_door",
    "block.minecraft.bamboo_fence",
    "block.minecraft.bamboo_fence_gate",
    "block.minecraft.bamboo_hanging_sign",
    "block.minecraft.bamboo_mosaic",
    "block.minecraft.bamboo_mosaic_slab",
    "block.minecraft.bamboo_mosaic_stairs",
    "block.minecraft.bamboo_planks",
    "block.minecraft.bamboo_pressure_plate",
    "block.minecraft.bamboo_sapling",
    "block.minecraft.bamboo_shelf",
    "block.minecraft.bamboo_sign",
    "block.minecraft.bamboo_slab",
    "block.minecraft.bamboo_stairs",
    "block.minecraft.bamboo_trapdoor",
    "block.minecraft.bamboo_wall_hanging_sign",
    "block.minecraft.bamboo_wall_sign",
    "block.minecraft.banner.base.black",
    "block.minecraft.banner.base.blue",
    "block.minecraft.banner.base.brown",
    "block.minecraft.banner.base.cyan",
    "block.minecraft.banner.base.gray",
    "block.minecraft.banner.base.green",
    "block.minecraft.banner.base.light_blue",
    "block.minecraft.banner.base.light_gray",
    "block.minecraft.banner.base.lime",
    "block.minecraft.banner.base.magenta",
    "block.minecraft.banner.base.orange",
    "block.minecraft.banner.base.pink",
    "block.minecraft.banner.base.purple",
    "block.minecraft.banner.base.red",
    "block.minecraft.banner.base.white",
    "block.minecraft.banner.base.yellow",
    "block.minecraft.banner.border.black",
    "block.minecraft.banner.border.blue",
    "block.minecraft.banner.border.brown",
    "block.minecraft.banner.border.cyan",
    "block.minecraft.banner.border.gray",
    "block.minecraft.banner.border.green",
    "block.minecraft.banner.border.light_blue",
    "block.minecraft.banner.border.light_gray",
    "block.minecraft.banner.border.lime",
    "block.minecraft.banner.border.magenta",
    "block.minecraft.banner.border.orange",
    "block.minecraft.banner.border.pink",
    "block.minecraft.banner.border.purple",
    "block.minecraft.banner.border.red",
    "block.minecraft.banner.border.white",
    "block.minecraft.banner.border.yellow",
    "block.minecraft.banner.bricks.black",
    "block.minecraft.banner.bricks.blue",
    "block.minecraft.banner.bricks.brown",
    "block.minecraft.banner.bricks.cyan",
    "block.minecraft.banner.bricks.gray",
    "block.minecraft.banner.bricks.green",
    "block.minecraft.banner.bricks.light_blue",
    "block.minecraft.banner.bricks.light_gray",
    "block.minecraft.banner.bricks.lime",
    "block.minecraft.banner.bricks.magenta",
    "block.minecraft.banner.bricks.orange",
    "block.minecraft.banner.bricks.pink",
    "block.minecraft.banner.bricks.purple",
    "block.minecraft.banner.bricks.red",
    "block.minecraft.banner.bricks.white",
    "block.minecraft.banner.bricks.yellow",
    "block.minecraft.banner.circle.black",
    "block.minecraft.banner.circle.blue",
    "block.minecraft.banner.circle.brown",
    "block.minecraft.banner.circle.cyan",
    "block.minecraft.banner.circle.gray",
    "block.minecraft.banner.circle.green",
    "block.minecraft.banner.circle.light_blue",
    "block.minecraft.banner.circle.light_gray",
    "block.minecraft.banner.circle.lime",
    "block.minecraft.banner.circle.magenta",
    "block.minecraft.banner.circle.orange",
    "block.minecraft.banner.circle.pink",
    "block.minecraft.banner.circle.purple",
    "block.minecraft.banner.circle.red",
    "block.minecraft.banner.circle.white",
    "block.minecraft.banner.circle.yellow",
    "block.minecraft.banner.creeper.black",
    "block.minecraft.banner.creeper.blue",
    "block.minecraft.banner.creeper.brown",
    "block.minecraft.banner.creeper.cyan",
    "block.minecraft.banner.creeper.gray",
    "block.minecraft.banner.creeper.green",
    "block.minecraft.banner.creeper.light_blue",
    "block.minecraft.banner.creeper.light_gray",
    "block.minecraft.banner.creeper.lime",
    "block.minecraft.banner.creeper.magenta",
    "block.minecraft.banner.creeper.orange",
    "block.minecraft.banner.creeper.pink",
    "block.minecraft.banner.creeper.purple",
    "block.minecraft.banner.creeper.red",
    "block.minecraft.banner.creeper.white",
    "block.minecraft.banner.creeper.yellow",
    "block.minecraft.banner.cross.black",
    "block.minecraft.banner.cross.blue",
    "block.minecraft.banner.cross.brown",
    "block.minecraft.banner.cross.cyan",
    "block.minecraft.banner.cross.gray",
    "block.minecraft.banner.cross.green",
    "block.minecraft.banner.cross.light_blue",
    "block.minecraft.banner.cross.light_gray",
    "block.minecraft.banner.cross.lime",
    "block.minecraft.banner.cross.magenta",
    "block.minecraft.banner.cross.orange",
    "block.minecraft.banner.cross.pink",
    "block.minecraft.banner.cross.purple",
    "block.minecraft.banner.cross.red",
    "block.minecraft.banner.cross.white",
    "block.minecraft.banner.cross.yellow",
    "block.minecraft.banner.curly_border.black",
    "block.minecraft.banner.curly_border.blue",
    "block.minecraft.banner.curly_border.brown",
    "block.minecraft.banner.curly_border.cyan",
    "block.minecraft.banner.curly_border.gray",
    "block.minecraft.banner.curly_border.green",
    "block.minecraft.banner.curly_border.light_blue",
    "block.minecraft.banner.curly_border.light_gray",
    "block.minecraft.banner.curly_border.lime",
    "block.minecraft.banner.curly_border.magenta",
    "block.minecraft.banner.curly_border.orange",
    "block.minecraft.banner.curly_border.pink",
    "block.minecraft.banner.curly_border.purple",
    "block.minecraft.banner.curly_border.red",
    "block.minecraft.banner.curly_border.white",
    "block.minecraft.banner.curly_border.yellow",
    "block.minecraft.banner.diagonal_left.black",
    "block.minecraft.banner.diagonal_left.blue",
    "block.minecraft.banner.diagonal_left.brown",
    "block.minecraft.banner.diagonal_left.cyan",
    "block.minecraft.banner.diagonal_left.gray",
    "block.minecraft.banner.diagonal_left.green",
    "block.minecraft.banner.diagonal_left.light_blue",
    "block.minecraft.banner.diagonal_left.light_gray",
    "block.minecraft.banner.diagonal_left.lime",
    "block.minecraft.banner.diagonal_left.magenta",
    "block.minecraft.banner.diagonal_left.orange",
    "block.minecraft.banner.diagonal_left.pink",
    "block.minecraft.banner.diagonal_left.purple",
    "block.minecraft.banner.diagonal_left.red",
    "block.minecraft.banner.diagonal_left.white",
    "block.minecraft.banner.diagonal_left.yellow",
    "block.minecraft.banner.diagonal_right.black",
    "block.minecraft.banner.diagonal_right.blue",
    "block.minecraft.banner.diagonal_right.brown",
    "block.minecraft.banner.diagonal_right.cyan",
    "block.minecraft.banner.diagonal_right.gray",
    "block.minecraft.banner.diagonal_right.green",
    "block.minecraft.banner.diagonal_right.light_blue",
    "block.minecraft.banner.diagonal_right.light_gray",
    "block.minecraft.banner.diagonal_right.lime",
    "block.minecraft.banner.diagonal_right.magenta",
    "block.minecraft.banner.diagonal_right.orange",
    "block.minecraft.banner.diagonal_right.pink",
    "block.minecraft.banner.diagonal_right.purple",
    "block.minecraft.banner.diagonal_right.red",
    "block.minecraft.banner.diagonal_right.white",
    "block.minecraft.banner.diagonal_right.yellow",
    "block.minecraft.banner.diagonal_up_left.black",
    "block.minecraft.banner.diagonal_up_left.blue",
    "block.minecraft.banner.diagonal_up_left.brown",
    "block.minecraft.banner.diagonal_up_left.cyan",
    "block.minecraft.banner.diagonal_up_left.gray",
    "block.minecraft.banner.diagonal_up_left.green",
    "block.minecraft.banner.diagonal_up_left.light_blue",
    "block.minecraft.banner.diagonal_up_left.light_gray",
    "block.minecraft.banner.diagonal_up_left.lime",
    "block.minecraft.banner.diagonal_up_left.magenta",
    "block.minecraft.banner.diagonal_up_left.orange",
    "block.minecraft.banner.diagonal_up_left.pink",
    "block.minecraft.banner.diagonal_up_left.purple",
    "block.minecraft.banner.diagonal_up_left.red",
    "block.minecraft.banner.diagonal_up_left.white",
    "block.minecraft.banner.diagonal_up_left.yellow",
    "block.minecraft.banner.diagonal_up_right.black",
    "block.minecraft.banner.diagonal_up_right.blue",
    "block.minecraft.banner.diagonal_up_right.brown",
    "block.minecraft.banner.diagonal_up_right.cyan",
    "block.minecraft.banner.diagonal_up_right.gray",
    "block.minecraft.banner.diagonal_up_right.green",
    "block.minecraft.banner.diagonal_up_right.light_blue",
    "block.minecraft.banner.diagonal_up_right.light_gray",
    "block.minecraft.banner.diagonal_up_right.lime",
    "block.minecraft.banner.diagonal_up_right.magenta",
    "block.minecraft.banner.diagonal_up_right.orange",
    "block.minecraft.banner.diagonal_up_right.pink",
    "block.minecraft.banner.diagonal_up_right.purple",
    "block.minecraft.banner.diagonal_up_right.red",
    "block.minecraft.banner.diagonal_up_right.white",
    "block.minecraft.banner.diagonal_up_right.yellow",
    "block.minecraft.banner.flow.black",
    "block.minecraft.banner.flow.blue",
    "block.minecraft.banner.flow.brown",
    "block.minecraft.banner.flow.cyan",
    "block.minecraft.banner.flow.gray",
    "block.minecraft.banner.flow.green",
    "block.minecraft.banner.flow.light_blue",
    "block.minecraft.banner.flow.light_gray",
    "block.minecraft.banner.flow.lime",
    "block.minecraft.banner.flow.magenta",
    "block.minecraft.banner.flow.orange",
    "block.minecraft.banner.flow.pink",
    "block.minecraft.banner.flow.purple",
    "block.minecraft.banner.flow.red",
    "block.minecraft.banner.flow.white",
    "block.minecraft.banner.flow.yellow",
    "block.minecraft.banner.flower.black",
    "block.minecraft.banner.flower.blue",
    "block.minecraft.banner.flower.brown",
    "block.minecraft.banner.flower.cyan",
    "block.minecraft.banner.flower.gray",
    "block.minecraft.banner.flower.green",
    "block.minecraft.banner.flower.light_blue",
    "block.minecraft.banner.flower.light_gray",
    "block.minecraft.banner.flower.lime",
    "block.minecraft.banner.flower.magenta",
    "block.minecraft.banner.flower.orange",
    "block.minecraft.banner.flower.pink",
    "block.minecraft.banner.flower.purple",
    "block.minecraft.banner.flower.red",
    "block.minecraft.banner.flower.white",
    "block.minecraft.banner.flower.yellow",
    "block.minecraft.banner.globe.black",
    "block.minecraft.banner.globe.blue",
    "block.minecraft.banner.globe.brown",
    "block.minecraft.banner.globe.cyan",
    "block.minecraft.banner.globe.gray",
    "block.minecraft.banner.globe.green",
    "block.minecraft.banner.globe.light_blue",
    "block.minecraft.banner.globe.light_gray",
    "block.minecraft.banner.globe.lime",
    "block.minecraft.banner.globe.magenta",
    "block.minecraft.banner.globe.orange",
    "block.minecraft.banner.globe.pink",
    "block.minecraft.banner.globe.purple",
    "block.minecraft.banner.globe.red",
    "block.minecraft.banner.globe.white",
    "block.minecraft.banner.globe.yellow",
    "block.minecraft.banner.gradient_up.black",
    "block.minecraft.banner.gradient_up.blue",
    "block.minecraft.banner.gradient_up.brown",
    "block.minecraft.banner.gradient_up.cyan",
    "block.minecraft.banner.gradient_up.gray",
    "block.minecraft.banner.gradient_up.green",
    "block.minecraft.banner.gradient_up.light_blue",
    "block.minecraft.banner.gradient_up.light_gray",
    "block.minecraft.banner.gradient_up.lime",
    "block.minecraft.banner.gradient_up.magenta",
    "block.minecraft.banner.gradient_up.orange",
    "block.minecraft.banner.gradient_up.pink",
    "block.minecraft.banner.gradient_up.purple",
    "block.minecraft.banner.gradient_up.red",
    "block.minecraft.banner.gradient_up.white",
    "block.minecraft.banner.gradient_up.yellow",
    "block.minecraft.banner.gradient.black",
    "block.minecraft.banner.gradient.blue",
    "block.minecraft.banner.gradient.brown",
    "block.minecraft.banner.gradient.cyan",
    "block.minecraft.banner.gradient.gray",
    "block.minecraft.banner.gradient.green",
    "block.minecraft.banner.gradient.light_blue",
    "block.minecraft.banner.gradient.light_gray",
    "block.minecraft.banner.gradient.lime",
    "block.minecraft.banner.gradient.magenta",
    "block.minecraft.banner.gradient.orange",
    "block.minecraft.banner.gradient.pink",
    "block.minecraft.banner.gradient.purple",
    "block.minecraft.banner.gradient.red",
    "block.minecraft.banner.gradient.white",
    "block.minecraft.banner.gradient.yellow",
    "block.minecraft.banner.guster.black",
    "block.minecraft.banner.guster.blue",
    "block.minecraft.banner.guster.brown",
    "block.minecraft.banner.guster.cyan",
    "block.minecraft.banner.guster.gray",
    "block.minecraft.banner.guster.green",
    "block.minecraft.banner.guster.light_blue",
    "block.minecraft.banner.guster.light_gray",
    "block.minecraft.banner.guster.lime",
    "block.minecraft.banner.guster.magenta",
    "block.minecraft.banner.guster.orange",
    "block.minecraft.banner.guster.pink",
    "block.minecraft.banner.guster.purple",
    "block.minecraft.banner.guster.red",
    "block.minecraft.banner.guster.white",
    "block.minecraft.banner.guster.yellow",
    "block.minecraft.banner.half_horizontal_bottom.black",
    "block.minecraft.banner.half_horizontal_bottom.blue",
    "block.minecraft.banner.half_horizontal_bottom.brown",
    "block.minecraft.banner.half_horizontal_bottom.cyan",
    "block.minecraft.banner.half_horizontal_bottom.gray",
    "block.minecraft.banner.half_horizontal_bottom.green",
    "block.minecraft.banner.half_horizontal_bottom.light_blue",
    "block.minecraft.banner.half_horizontal_bottom.light_gray",
    "block.minecraft.banner.half_horizontal_bottom.lime",
    "block.minecraft.banner.half_horizontal_bottom.magenta",
    "block.minecraft.banner.half_horizontal_bottom.orange",
    "block.minecraft.banner.half_horizontal_bottom.pink",
    "block.minecraft.banner.half_horizontal_bottom.purple",
    "block.minecraft.banner.half_horizontal_bottom.red",
    "block.minecraft.banner.half_horizontal_bottom.white",
    "block.minecraft.banner.half_horizontal_bottom.yellow",
    "block.minecraft.banner.half_horizontal.black",
    "block.minecraft.banner.half_horizontal.blue",
    "block.minecraft.banner.half_horizontal.brown",
    "block.minecraft.banner.half_horizontal.cyan",
    "block.minecraft.banner.half_horizontal.gray",
    "block.minecraft.banner.half_horizontal.green",
    "block.minecraft.banner.half_horizontal.light_blue",
    "block.minecraft.banner.half_horizontal.light_gray",
    "block.minecraft.banner.half_horizontal.lime",
    "block.minecraft.banner.half_horizontal.magenta",
    "block.minecraft.banner.half_horizontal.orange",
    "block.minecraft.banner.half_horizontal.pink",
    "block.minecraft.banner.half_horizontal.purple",
    "block.minecraft.banner.half_horizontal.red",
    "block.minecraft.banner.half_horizontal.white",
    "block.minecraft.banner.half_horizontal.yellow",
    "block.minecraft.banner.half_vertical_right.black",
    "block.minecraft.banner.half_vertical_right.blue",
    "block.minecraft.banner.half_vertical_right.brown",
    "block.minecraft.banner.half_vertical_right.cyan",
    "block.minecraft.banner.half_vertical_right.gray",
    "block.minecraft.banner.half_vertical_right.green",
    "block.minecraft.banner.half_vertical_right.light_blue",
    "block.minecraft.banner.half_vertical_right.light_gray",
    "block.minecraft.banner.half_vertical_right.lime",
    "block.minecraft.banner.half_vertical_right.magenta",
    "block.minecraft.banner.half_vertical_right.orange",
    "block.minecraft.banner.half_vertical_right.pink",
    "block.minecraft.banner.half_vertical_right.purple",
    "block.minecraft.banner.half_vertical_right.red",
    "block.minecraft.banner.half_vertical_right.white",
    "block.minecraft.banner.half_vertical_right.yellow",
    "block.minecraft.banner.half_vertical.black",
    "block.minecraft.banner.half_vertical.blue",
    "block.minecraft.banner.half_vertical.brown",
    "block.minecraft.banner.half_vertical.cyan",
    "block.minecraft.banner.half_vertical.gray",
    "block.minecraft.banner.half_vertical.green",
    "block.minecraft.banner.half_vertical.light_blue",
    "block.minecraft.banner.half_vertical.light_gray",
    "block.minecraft.banner.half_vertical.lime",
    "block.minecraft.banner.half_vertical.magenta",
    "block.minecraft.banner.half_vertical.orange",
    "block.minecraft.banner.half_vertical.pink",
    "block.minecraft.banner.half_vertical.purple",
    "block.minecraft.banner.half_vertical.red",
    "block.minecraft.banner.half_vertical.white",
    "block.minecraft.banner.half_vertical.yellow",
    "block.minecraft.banner.mojang.black",
    "block.minecraft.banner.mojang.blue",
    "block.minecraft.banner.mojang.brown",
    "block.minecraft.banner.mojang.cyan",
    "block.minecraft.banner.mojang.gray",
    "block.minecraft.banner.mojang.green",
    "block.minecraft.banner.mojang.light_blue",
    "block.minecraft.banner.mojang.light_gray",
    "block.minecraft.banner.mojang.lime",
    "block.minecraft.banner.mojang.magenta",
    "block.minecraft.banner.mojang.orange",
    "block.minecraft.banner.mojang.pink",
    "block.minecraft.banner.mojang.purple",
    "block.minecraft.banner.mojang.red",
    "block.minecraft.banner.mojang.white",
    "block.minecraft.banner.mojang.yellow",
    "block.minecraft.banner.piglin.black",
    "block.minecraft.banner.piglin.blue",
    "block.minecraft.banner.piglin.brown",
    "block.minecraft.banner.piglin.cyan",
    "block.minecraft.banner.piglin.gray",
    "block.minecraft.banner.piglin.green",
    "block.minecraft.banner.piglin.light_blue",
    "block.minecraft.banner.piglin.light_gray",
    "block.minecraft.banner.piglin.lime",
    "block.minecraft.banner.piglin.magenta",
    "block.minecraft.banner.piglin.orange",
    "block.minecraft.banner.piglin.pink",
    "block.minecraft.banner.piglin.purple",
    "block.minecraft.banner.piglin.red",
    "block.minecraft.banner.piglin.white",
    "block.minecraft.banner.piglin.yellow",
    "block.minecraft.banner.rhombus.black",
    "block.minecraft.banner.rhombus.blue",
    "block.minecraft.banner.rhombus.brown",
    "block.minecraft.banner.rhombus.cyan",
    "block.minecraft.banner.rhombus.gray",
    "block.minecraft.banner.rhombus.green",
    "block.minecraft.banner.rhombus.light_blue",
    "block.minecraft.banner.rhombus.light_gray",
    "block.minecraft.banner.rhombus.lime",
    "block.minecraft.banner.rhombus.magenta",
    "block.minecraft.banner.rhombus.orange",
    "block.minecraft.banner.rhombus.pink",
    "block.minecraft.banner.rhombus.purple",
    "block.minecraft.banner.rhombus.red",
    "block.minecraft.banner.rhombus.white",
    "block.minecraft.banner.rhombus.yellow",
    "block.minecraft.banner.skull.black",
    "block.minecraft.banner.skull.blue",
    "block.minecraft.banner.skull.brown",
    "block.minecraft.banner.skull.cyan",
    "block.minecraft.banner.skull.gray",
    "block.minecraft.banner.skull.green",
    "block.minecraft.banner.skull.light_blue",
    "block.minecraft.banner.skull.light_gray",
    "block.minecraft.banner.skull.lime",
    "block.minecraft.banner.skull.magenta",
    "block.minecraft.banner.skull.orange",
    "block.minecraft.banner.skull.pink",
    "block.minecraft.banner.skull.purple",
    "block.minecraft.banner.skull.red",
    "block.minecraft.banner.skull.white",
    "block.minecraft.banner.skull.yellow",
    "block.minecraft.banner.small_stripes.black",
    "block.minecraft.banner.small_stripes.blue",
    "block.minecraft.banner.small_stripes.brown",
    "block.minecraft.banner.small_stripes.cyan",
    "block.minecraft.banner.small_stripes.gray",
    "block.minecraft.banner.small_stripes.green",
    "block.minecraft.banner.small_stripes.light_blue",
    "block.minecraft.banner.small_stripes.light_gray",
    "block.minecraft.banner.small_stripes.lime",
    "block.minecraft.banner.small_stripes.magenta",
    "block.minecraft.banner.small_stripes.orange",
    "block.minecraft.banner.small_stripes.pink",
    "block.minecraft.banner.small_stripes.purple",
    "block.minecraft.banner.small_stripes.red",
    "block.minecraft.banner.small_stripes.white",
    "block.minecraft.banner.small_stripes.yellow",
    "block.minecraft.banner.square_bottom_left.black",
    "block.minecraft.banner.square_bottom_left.blue",
    "block.minecraft.banner.square_bottom_left.brown",
    "block.minecraft.banner.square_bottom_left.cyan",
    "block.minecraft.banner.square_bottom_left.gray",
    "block.minecraft.banner.square_bottom_left.green",
    "block.minecraft.banner.square_bottom_left.light_blue",
    "block.minecraft.banner.square_bottom_left.light_gray",
    "block.minecraft.banner.square_bottom_left.lime",
    "block.minecraft.banner.square_bottom_left.magenta",
    "block.minecraft.banner.square_bottom_left.orange",
    "block.minecraft.banner.square_bottom_left.pink",
    "block.minecraft.banner.square_bottom_left.purple",
    "block.minecraft.banner.square_bottom_left.red",
    "block.minecraft.banner.square_bottom_left.white",
    "block.minecraft.banner.square_bottom_left.yellow",
    "block.minecraft.banner.square_bottom_right.black",
    "block.minecraft.banner.square_bottom_right.blue",
    "block.minecraft.banner.square_bottom_right.brown",
    "block.minecraft.banner.square_bottom_right.cyan",
    "block.minecraft.banner.square_bottom_right.gray",
    "block.minecraft.banner.square_bottom_right.green",
    "block.minecraft.banner.square_bottom_right.light_blue",
    "block.minecraft.banner.square_bottom_right.light_gray",
    "block.minecraft.banner.square_bottom_right.lime",
    "block.minecraft.banner.square_bottom_right.magenta",
    "block.minecraft.banner.square_bottom_right.orange",
    "block.minecraft.banner.square_bottom_right.pink",
    "block.minecraft.banner.square_bottom_right.purple",
    "block.minecraft.banner.square_bottom_right.red",
    "block.minecraft.banner.square_bottom_right.white",
    "block.minecraft.banner.square_bottom_right.yellow",
    "block.minecraft.banner.square_top_left.black",
    "block.minecraft.banner.square_top_left.blue",
    "block.minecraft.banner.square_top_left.brown",
    "block.minecraft.banner.square_top_left.cyan",
    "block.minecraft.banner.square_top_left.gray",
    "block.minecraft.banner.square_top_left.green",
    "block.minecraft.banner.square_top_left.light_blue",
    "block.minecraft.banner.square_top_left.light_gray",
    "block.minecraft.banner.square_top_left.lime",
    "block.minecraft.banner.square_top_left.magenta",
    "block.minecraft.banner.square_top_left.orange",
    "block.minecraft.banner.square_top_left.pink",
    "block.minecraft.banner.square_top_left.purple",
    "block.minecraft.banner.square_top_left.red",
    "block.minecraft.banner.square_top_left.white",
    "block.minecraft.banner.square_top_left.yellow",
    "block.minecraft.banner.square_top_right.black",
    "block.minecraft.banner.square_top_right.blue",
    "block.minecraft.banner.square_top_right.brown",
    "block.minecraft.banner.square_top_right.cyan",
    "block.minecraft.banner.square_top_right.gray",
    "block.minecraft.banner.square_top_right.green",
    "block.minecraft.banner.square_top_right.light_blue",
    "block.minecraft.banner.square_top_right.light_gray",
    "block.minecraft.banner.square_top_right.lime",
    "block.minecraft.banner.square_top_right.magenta",
    "block.minecraft.banner.square_top_right.orange",
    "block.minecraft.banner.square_top_right.pink",
    "block.minecraft.banner.square_top_right.purple",
    "block.minecraft.banner.square_top_right.red",
    "block.minecraft.banner.square_top_right.white",
    "block.minecraft.banner.square_top_right.yellow",
    "block.minecraft.banner.straight_cross.black",
    "block.minecraft.banner.straight_cross.blue",
    "block.minecraft.banner.straight_cross.brown",
    "block.minecraft.banner.straight_cross.cyan",
    "block.minecraft.banner.straight_cross.gray",
    "block.minecraft.banner.straight_cross.green",
    "block.minecraft.banner.straight_cross.light_blue",
    "block.minecraft.banner.straight_cross.light_gray",
    "block.minecraft.banner.straight_cross.lime",
    "block.minecraft.banner.straight_cross.magenta",
    "block.minecraft.banner.straight_cross.orange",
    "block.minecraft.banner.straight_cross.pink",
    "block.minecraft.banner.straight_cross.purple",
    "block.minecraft.banner.straight_cross.red",
    "block.minecraft.banner.straight_cross.white",
    "block.minecraft.banner.straight_cross.yellow",
    "block.minecraft.banner.stripe_bottom.black",
    "block.minecraft.banner.stripe_bottom.blue",
    "block.minecraft.banner.stripe_bottom.brown",
    "block.minecraft.banner.stripe_bottom.cyan",
    "block.minecraft.banner.stripe_bottom.gray",
    "block.minecraft.banner.stripe_bottom.green",
    "block.minecraft.banner.stripe_bottom.light_blue",
    "block.minecraft.banner.stripe_bottom.light_gray",
    "block.minecraft.banner.stripe_bottom.lime",
    "block.minecraft.banner.stripe_bottom.magenta",
    "block.minecraft.banner.stripe_bottom.orange",
    "block.minecraft.banner.stripe_bottom.pink",
    "block.minecraft.banner.stripe_bottom.purple",
    "block.minecraft.banner.stripe_bottom.red",
    "block.minecraft.banner.stripe_bottom.white",
    "block.minecraft.banner.stripe_bottom.yellow",
    "block.minecraft.banner.stripe_center.black",
    "block.minecraft.banner.stripe_center.blue",
    "block.minecraft.banner.stripe_center.brown",
    "block.minecraft.banner.stripe_center.cyan",
    "block.minecraft.banner.stripe_center.gray",
    "block.minecraft.banner.stripe_center.green",
    "block.minecraft.banner.stripe_center.light_blue",
    "block.minecraft.banner.stripe_center.light_gray",
    "block.minecraft.banner.stripe_center.lime",
    "block.minecraft.banner.stripe_center.magenta",
    "block.minecraft.banner.stripe_center.orange",
    "block.minecraft.banner.stripe_center.pink",
    "block.minecraft.banner.stripe_center.purple",
    "block.minecraft.banner.stripe_center.red",
    "block.minecraft.banner.stripe_center.white",
    "block.minecraft.banner.stripe_center.yellow",
    "block.minecraft.banner.stripe_downleft.black",
    "block.minecraft.banner.stripe_downleft.blue",
    "block.minecraft.banner.stripe_downleft.brown",
    "block.minecraft.banner.stripe_downleft.cyan",
    "block.minecraft.banner.stripe_downleft.gray",
    "block.minecraft.banner.stripe_downleft.green",
    "block.minecraft.banner.stripe_downleft.light_blue",
    "block.minecraft.banner.stripe_downleft.light_gray",
    "block.minecraft.banner.stripe_downleft.lime",
    "block.minecraft.banner.stripe_downleft.magenta",
    "block.minecraft.banner.stripe_downleft.orange",
    "block.minecraft.banner.stripe_downleft.pink",
    "block.minecraft.banner.stripe_downleft.purple",
    "block.minecraft.banner.stripe_downleft.red",
    "block.minecraft.banner.stripe_downleft.white",
    "block.minecraft.banner.stripe_downleft.yellow",
    "block.minecraft.banner.stripe_downright.black",
    "block.minecraft.banner.stripe_downright.blue",
    "block.minecraft.banner.stripe_downright.brown",
    "block.minecraft.banner.stripe_downright.cyan",
    "block.minecraft.banner.stripe_downright.gray",
    "block.minecraft.banner.stripe_downright.green",
    "block.minecraft.banner.stripe_downright.light_blue",
    "block.minecraft.banner.stripe_downright.light_gray",
    "block.minecraft.banner.stripe_downright.lime",
    "block.minecraft.banner.stripe_downright.magenta",
    "block.minecraft.banner.stripe_downright.orange",
    "block.minecraft.banner.stripe_downright.pink",
    "block.minecraft.banner.stripe_downright.purple",
    "block.minecraft.banner.stripe_downright.red",
    "block.minecraft.banner.stripe_downright.white",
    "block.minecraft.banner.stripe_downright.yellow",
    "block.minecraft.banner.stripe_left.black",
    "block.minecraft.banner.stripe_left.blue",
    "block.minecraft.banner.stripe_left.brown",
    "block.minecraft.banner.stripe_left.cyan",
    "block.minecraft.banner.stripe_left.gray",
    "block.minecraft.banner.stripe_left.green",
    "block.minecraft.banner.stripe_left.light_blue",
    "block.minecraft.banner.stripe_left.light_gray",
    "block.minecraft.banner.stripe_left.lime",
    "block.minecraft.banner.stripe_left.magenta",
    "block.minecraft.banner.stripe_left.orange",
    "block.minecraft.banner.stripe_left.pink",
    "block.minecraft.banner.stripe_left.purple",
    "block.minecraft.banner.stripe_left.red",
    "block.minecraft.banner.stripe_left.white",
    "block.minecraft.banner.stripe_left.yellow",
    "block.minecraft.banner.stripe_middle.black",
    "block.minecraft.banner.stripe_middle.blue",
    "block.minecraft.banner.stripe_middle.brown",
    "block.minecraft.banner.stripe_middle.cyan",
    "block.minecraft.banner.stripe_middle.gray",
    "block.minecraft.banner.stripe_middle.green",
    "block.minecraft.banner.stripe_middle.light_blue",
    "block.minecraft.banner.stripe_middle.light_gray",
    "block.minecraft.banner.stripe_middle.lime",
    "block.minecraft.banner.stripe_middle.magenta",
    "block.minecraft.banner.stripe_middle.orange",
    "block.minecraft.banner.stripe_middle.pink",
    "block.minecraft.banner.stripe_middle.purple",
    "block.minecraft.banner.stripe_middle.red",
    "block.minecraft.banner.stripe_middle.white",
    "block.minecraft.banner.stripe_middle.yellow",
    "block.minecraft.banner.stripe_right.black",
    "block.minecraft.banner.stripe_right.blue",
    "block.minecraft.banner.stripe_right.brown",
    "block.minecraft.banner.stripe_right.cyan",
    "block.minecraft.banner.stripe_right.gray",
    "block.minecraft.banner.stripe_right.green",
    "block.minecraft.banner.stripe_right.light_blue",
    "block.minecraft.banner.stripe_right.light_gray",
    "block.minecraft.banner.stripe_right.lime",
    "block.minecraft.banner.stripe_right.magenta",
    "block.minecraft.banner.stripe_right.orange",
    "block.minecraft.banner.stripe_right.pink",
    "block.minecraft.banner.stripe_right.purple",
    "block.minecraft.banner.stripe_right.red",
    "block.minecraft.banner.stripe_right.white",
    "block.minecraft.banner.stripe_right.yellow",
    "block.minecraft.banner.stripe_top.black",
    "block.minecraft.banner.stripe_top.blue",
    "block.minecraft.banner.stripe_top.brown",
    "block.minecraft.banner.stripe_top.cyan",
    "block.minecraft.banner.stripe_top.gray",
    "block.minecraft.banner.stripe_top.green",
    "block.minecraft.banner.stripe_top.light_blue",
    "block.minecraft.banner.stripe_top.light_gray",
    "block.minecraft.banner.stripe_top.lime",
    "block.minecraft.banner.stripe_top.magenta",
    "block.minecraft.banner.stripe_top.orange",
    "block.minecraft.banner.stripe_top.pink",
    "block.minecraft.banner.stripe_top.purple",
    "block.minecraft.banner.stripe_top.red",
    "block.minecraft.banner.stripe_top.white",
    "block.minecraft.banner.stripe_top.yellow",
    "block.minecraft.banner.triangle_bottom.black",
    "block.minecraft.banner.triangle_bottom.blue",
    "block.minecraft.banner.triangle_bottom.brown",
    "block.minecraft.banner.triangle_bottom.cyan",
    "block.minecraft.banner.triangle_bottom.gray",
    "block.minecraft.banner.triangle_bottom.green",
    "block.minecraft.banner.triangle_bottom.light_blue",
    "block.minecraft.banner.triangle_bottom.light_gray",
    "block.minecraft.banner.triangle_bottom.lime",
    "block.minecraft.banner.triangle_bottom.magenta",
    "block.minecraft.banner.triangle_bottom.orange",
    "block.minecraft.banner.triangle_bottom.pink",
    "block.minecraft.banner.triangle_bottom.purple",
    "block.minecraft.banner.triangle_bottom.red",
    "block.minecraft.banner.triangle_bottom.white",
    "block.minecraft.banner.triangle_bottom.yellow",
    "block.minecraft.banner.triangle_top.black",
    "block.minecraft.banner.triangle_top.blue",
    "block.minecraft.banner.triangle_top.brown",
    "block.minecraft.banner.triangle_top.cyan",
    "block.minecraft.banner.triangle_top.gray",
    "block.minecraft.banner.triangle_top.green",
    "block.minecraft.banner.triangle_top.light_blue",
    "block.minecraft.banner.triangle_top.light_gray",
    "block.minecraft.banner.triangle_top.lime",
    "block.minecraft.banner.triangle_top.magenta",
    "block.minecraft.banner.triangle_top.orange",
    "block.minecraft.banner.triangle_top.pink",
    "block.minecraft.banner.triangle_top.purple",
    "block.minecraft.banner.triangle_top.red",
    "block.minecraft.banner.triangle_top.white",
    "block.minecraft.banner.triangle_top.yellow",
    "block.minecraft.banner.triangles_bottom.black",
    "block.minecraft.banner.triangles_bottom.blue",
    "block.minecraft.banner.triangles_bottom.brown",
    "block.minecraft.banner.triangles_bottom.cyan",
    "block.minecraft.banner.triangles_bottom.gray",
    "block.minecraft.banner.triangles_bottom.green",
    "block.minecraft.banner.triangles_bottom.light_blue",
    "block.minecraft.banner.triangles_bottom.light_gray",
    "block.minecraft.banner.triangles_bottom.lime",
    "block.minecraft.banner.triangles_bottom.magenta",
    "block.minecraft.banner.triangles_bottom.orange",
    "block.minecraft.banner.triangles_bottom.pink",
    "block.minecraft.banner.triangles_bottom.purple",
    "block.minecraft.banner.triangles_bottom.red",
    "block.minecraft.banner.triangles_bottom.white",
    "block.minecraft.banner.triangles_bottom.yellow",
    "block.minecraft.banner.triangles_top.black",
    "block.minecraft.banner.triangles_top.blue",
    "block.minecraft.banner.triangles_top.brown",
    "block.minecraft.banner.triangles_top.cyan",
    "block.minecraft.banner.triangles_top.gray",
    "block.minecraft.banner.triangles_top.green",
    "block.minecraft.banner.triangles_top.light_blue",
    "block.minecraft.banner.triangles_top.light_gray",
    "block.minecraft.banner.triangles_top.lime",
    "block.minecraft.banner.triangles_top.magenta",
    "block.minecraft.banner.triangles_top.orange",
    "block.minecraft.banner.triangles_top.pink",
    "block.minecraft.banner.triangles_top.purple",
    "block.minecraft.banner.triangles_top.red",
    "block.minecraft.banner.triangles_top.white",
    "block.minecraft.banner.triangles_top.yellow",
    "block.minecraft.barrel",
    "block.minecraft.barrier",
    "block.minecraft.basalt",
    "block.minecraft.beacon",
    "block.minecraft.beacon.primary",
    "block.minecraft.beacon.secondary",
    "block.minecraft.bed.no_sleep",
    "block.minecraft.bed.not_safe",
    "block.minecraft.bed.obstructed",
    "block.minecraft.bed.occupied",
    "block.minecraft.bed.too_far_away",
    "block.minecraft.bedrock",
    "block.minecraft.bee_nest",
    "block.minecraft.beehive",
    "block.minecraft.beetroots",
    "block.minecraft.bell",
    "block.minecraft.big_dripleaf",
    "block.minecraft.big_dripleaf_stem",
    "block.minecraft.birch_button",
    "block.minecraft.birch_door",
    "block.minecraft.birch_fence",
    "block.minecraft.birch_fence_gate",
    "block.minecraft.birch_hanging_sign",
    "block.minecraft.birch_leaves",
    "block.minecraft.birch_log",
    "block.minecraft.birch_planks",
    "block.minecraft.birch_pressure_plate",
    "block.minecraft.birch_sapling",
    "block.minecraft.birch_shelf",
    "block.minecraft.birch_sign",
    "block.minecraft.birch_slab",
    "block.minecraft.birch_stairs",
    "block.minecraft.birch_trapdoor",
    "block.minecraft.birch_wall_hanging_sign",
    "block.minecraft.birch_wall_sign",
    "block.minecraft.birch_wood",
    "block.minecraft.black_banner",
    "block.minecraft.black_bed",
    "block.minecraft.black_candle",
    "block.minecraft.black_candle_cake",
    "block.minecraft.black_carpet",
    "block.minecraft.black_concrete",
    "block.minecraft.black_concrete_powder",
    "block.minecraft.black_concrete_slab",
    "block.minecraft.black_concrete_stairs",
    "block.minecraft.black_glazed_terracotta",
    "block.minecraft.black_shulker_box",
    "block.minecraft.black_stained_glass",
    "block.minecraft.black_stained_glass_pane",
    "block.minecraft.black_terracotta",
    "block.minecraft.black_wool",
    "block.minecraft.black_wool_slab",
    "block.minecraft.black_wool_stairs",
    "block.minecraft.blackstone",
    "block.minecraft.blackstone_slab",
    "block.minecraft.blackstone_stairs",
    "block.minecraft.blackstone_wall",
    "block.minecraft.blast_furnace",
    "block.minecraft.blue_banner",
    "block.minecraft.blue_bed",
    "block.minecraft.blue_candle",
    "block.minecraft.blue_candle_cake",
    "block.minecraft.blue_carpet",
    "block.minecraft.blue_concrete",
    "block.minecraft.blue_concrete_powder",
    "block.minecraft.blue_concrete_slab",
    "block.minecraft.blue_concrete_stairs",
    "block.minecraft.blue_glazed_terracotta",
    "block.minecraft.blue_ice",
    "block.minecraft.blue_orchid",
    "block.minecraft.blue_shulker_box",
    "block.minecraft.blue_stained_glass",
    "block.minecraft.blue_stained_glass_pane",
    "block.minecraft.blue_terracotta",
    "block.minecraft.blue_wool",
    "block.minecraft.blue_wool_slab",
    "block.minecraft.blue_wool_stairs",
    "block.minecraft.bone_block",
    "block.minecraft.bookshelf",
    "block.minecraft.brain_coral",
    "block.minecraft.brain_coral_block",
    "block.minecraft.brain_coral_fan",
    "block.minecraft.brain_coral_wall_fan",
    "block.minecraft.brewing_stand",
    "block.minecraft.brick_slab",
    "block.minecraft.brick_stairs",
    "block.minecraft.brick_wall",
    "block.minecraft.bricks",
    "block.minecraft.brown_banner",
    "block.minecraft.brown_bed",
    "block.minecraft.brown_candle",
    "block.minecraft.brown_candle_cake",
    "block.minecraft.brown_carpet",
    "block.minecraft.brown_concrete",
    "block.minecraft.brown_concrete_powder",
    "block.minecraft.brown_concrete_slab",
    "block.minecraft.brown_concrete_stairs",
    "block.minecraft.brown_glazed_terracotta",
    "block.minecraft.brown_mushroom",
    "block.minecraft.brown_mushroom_block",
    "block.minecraft.brown_shulker_box",
    "block.minecraft.brown_stained_glass",
    "block.minecraft.brown_stained_glass_pane",
    "block.minecraft.brown_terracotta",
    "block.minecraft.brown_wool",
    "block.minecraft.brown_wool_slab",
    "block.minecraft.brown_wool_stairs",
    "block.minecraft.bubble_column",
    "block.minecraft.bubble_coral",
    "block.minecraft.bubble_coral_block",
    "block.minecraft.bubble_coral_fan",
    "block.minecraft.bubble_coral_wall_fan",
    "block.minecraft.budding_amethyst",
    "block.minecraft.bush",
    "block.minecraft.cactus",
    "block.minecraft.cactus_flower",
    "block.minecraft.cake",
    "block.minecraft.calcite",
    "block.minecraft.calibrated_sculk_sensor",
    "block.minecraft.campfire",
    "block.minecraft.candle",
    "block.minecraft.candle_cake",
    "block.minecraft.carrots",
    "block.minecraft.cartography_table",
    "block.minecraft.carved_pumpkin",
    "block.minecraft.cauldron",
    "block.minecraft.cave_air",
    "block.minecraft.cave_vines",
    "block.minecraft.cave_vines_plant",
    "block.minecraft.chain",
    "block.minecraft.chain_command_block",
    "block.minecraft.cherry_button",
    "block.minecraft.cherry_door",
    "block.minecraft.cherry_fence",
    "block.minecraft.cherry_fence_gate",
    "block.minecraft.cherry_hanging_sign",
    "block.minecraft.cherry_leaves",
    "block.minecraft.cherry_log",
    "block.minecraft.cherry_planks",
    "block.minecraft.cherry_pressure_plate",
    "block.minecraft.cherry_sapling",
    "block.minecraft.cherry_shelf",
    "block.minecraft.cherry_sign",
    "block.minecraft.cherry_slab",
    "block.minecraft.cherry_stairs",
    "block.minecraft.cherry_trapdoor",
    "block.minecraft.cherry_wall_hanging_sign",
    "block.minecraft.cherry_wall_sign",
    "block.minecraft.cherry_wood",
    "block.minecraft.chest",
    "block.minecraft.chipped_anvil",
    "block.minecraft.chiseled_bookshelf",
    "block.minecraft.chiseled_cinnabar",
    "block.minecraft.chiseled_copper",
    "block.minecraft.chiseled_deepslate",
    "block.minecraft.chiseled_nether_bricks",
    "block.minecraft.chiseled_polished_blackstone",
    "block.minecraft.chiseled_quartz_block",
    "block.minecraft.chiseled_red_sandstone",
    "block.minecraft.chiseled_resin_bricks",
    "block.minecraft.chiseled_sandstone",
    "block.minecraft.chiseled_stone_bricks",
    "block.minecraft.chiseled_sulfur",
    "block.minecraft.chiseled_tuff",
    "block.minecraft.chiseled_tuff_bricks",
    "block.minecraft.chorus_flower",
    "block.minecraft.chorus_plant",
    "block.minecraft.cinnabar",
    "block.minecraft.cinnabar_brick_slab",
    "block.minecraft.cinnabar_brick_stairs",
    "block.minecraft.cinnabar_brick_wall",
    "block.minecraft.cinnabar_bricks",
    "block.minecraft.cinnabar_slab",
    "block.minecraft.cinnabar_stairs",
    "block.minecraft.cinnabar_wall",
    "block.minecraft.clay",
    "block.minecraft.closed_eyeblossom",
    "block.minecraft.coal_block",
    "block.minecraft.coal_ore",
    "block.minecraft.coarse_dirt",
    "block.minecraft.cobbled_deepslate",
    "block.minecraft.cobbled_deepslate_slab",
    "block.minecraft.cobbled_deepslate_stairs",
    "block.minecraft.cobbled_deepslate_wall",
    "block.minecraft.cobblestone",
    "block.minecraft.cobblestone_slab",
    "block.minecraft.cobblestone_stairs",
    "block.minecraft.cobblestone_wall",
    "block.minecraft.cobweb",
    "block.minecraft.cocoa",
    "block.minecraft.command_block",
    "block.minecraft.comparator",
    "block.minecraft.composter",
    "block.minecraft.conduit",
    "block.minecraft.copper_bars",
    "block.minecraft.copper_block",
    "block.minecraft.copper_bulb",
    "block.minecraft.copper_chain",
    "block.minecraft.copper_chest",
    "block.minecraft.copper_door",
    "block.minecraft.copper_golem_statue",
    "block.minecraft.copper_grate",
    "block.minecraft.copper_lantern",
    "block.minecraft.copper_ore",
    "block.minecraft.copper_torch",
    "block.minecraft.copper_trapdoor",
    "block.minecraft.copper_wall_torch",
    "block.minecraft.cornflower",
    "block.minecraft.cracked_deepslate_bricks",
    "block.minecraft.cracked_deepslate_tiles",
    "block.minecraft.cracked_nether_bricks",
    "block.minecraft.cracked_polished_blackstone_bricks",
    "block.minecraft.cracked_stone_bricks",
    "block.minecraft.crafter",
    "block.minecraft.crafting_table",
    "block.minecraft.creaking_heart",
    "block.minecraft.creeper_head",
    "block.minecraft.creeper_wall_head",
    "block.minecraft.crimson_button",
    "block.minecraft.crimson_door",
    "block.minecraft.crimson_fence",
    "block.minecraft.crimson_fence_gate",
    "block.minecraft.crimson_fungus",
    "block.minecraft.crimson_hanging_sign",
    "block.minecraft.crimson_hyphae",
    "block.minecraft.crimson_nylium",
    "block.minecraft.crimson_planks",
    "block.minecraft.crimson_pressure_plate",
    "block.minecraft.crimson_roots",
    "block.minecraft.crimson_shelf",
    "block.minecraft.crimson_sign",
    "block.minecraft.crimson_slab",
    "block.minecraft.crimson_stairs",
    "block.minecraft.crimson_stem",
    "block.minecraft.crimson_trapdoor",
    "block.minecraft.crimson_wall_hanging_sign",
    "block.minecraft.crimson_wall_sign",
    "block.minecraft.crying_obsidian",
    "block.minecraft.cut_copper",
    "block.minecraft.cut_copper_slab",
    "block.minecraft.cut_copper_stairs",
    "block.minecraft.cut_red_sandstone",
    "block.minecraft.cut_red_sandstone_slab",
    "block.minecraft.cut_sandstone",
    "block.minecraft.cut_sandstone_slab",
    "block.minecraft.cyan_banner",
    "block.minecraft.cyan_bed",
    "block.minecraft.cyan_candle",
    "block.minecraft.cyan_candle_cake",
    "block.minecraft.cyan_carpet",
    "block.minecraft.cyan_concrete",
    "block.minecraft.cyan_concrete_powder",
    "block.minecraft.cyan_concrete_slab",
    "block.minecraft.cyan_concrete_stairs",
    "block.minecraft.cyan_glazed_terracotta",
    "block.minecraft.cyan_shulker_box",
    "block.minecraft.cyan_stained_glass",
    "block.minecraft.cyan_stained_glass_pane",
    "block.minecraft.cyan_terracotta",
    "block.minecraft.cyan_wool",
    "block.minecraft.cyan_wool_slab",
    "block.minecraft.cyan_wool_stairs",
    "block.minecraft.damaged_anvil",
    "block.minecraft.dandelion",
    "block.minecraft.dark_oak_button",
    "block.minecraft.dark_oak_door",
    "block.minecraft.dark_oak_fence",
    "block.minecraft.dark_oak_fence_gate",
    "block.minecraft.dark_oak_hanging_sign",
    "block.minecraft.dark_oak_leaves",
    "block.minecraft.dark_oak_log",
    "block.minecraft.dark_oak_planks",
    "block.minecraft.dark_oak_pressure_plate",
    "block.minecraft.dark_oak_sapling",
    "block.minecraft.dark_oak_shelf",
    "block.minecraft.dark_oak_sign",
    "block.minecraft.dark_oak_slab",
    "block.minecraft.dark_oak_stairs",
    "block.minecraft.dark_oak_trapdoor",
    "block.minecraft.dark_oak_wall_hanging_sign",
    "block.minecraft.dark_oak_wall_sign",
    "block.minecraft.dark_oak_wood",
    "block.minecraft.dark_prismarine",
    "block.minecraft.dark_prismarine_slab",
    "block.minecraft.dark_prismarine_stairs",
    "block.minecraft.daylight_detector",
    "block.minecraft.dead_brain_coral",
    "block.minecraft.dead_brain_coral_block",
    "block.minecraft.dead_brain_coral_fan",
    "block.minecraft.dead_brain_coral_wall_fan",
    "block.minecraft.dead_bubble_coral",
    "block.minecraft.dead_bubble_coral_block",
    "block.minecraft.dead_bubble_coral_fan",
    "block.minecraft.dead_bubble_coral_wall_fan",
    "block.minecraft.dead_bush",
    "block.minecraft.dead_fire_coral",
    "block.minecraft.dead_fire_coral_block",
    "block.minecraft.dead_fire_coral_fan",
    "block.minecraft.dead_fire_coral_wall_fan",
    "block.minecraft.dead_horn_coral",
    "block.minecraft.dead_horn_coral_block",
    "block.minecraft.dead_horn_coral_fan",
    "block.minecraft.dead_horn_coral_wall_fan",
    "block.minecraft.dead_tube_coral",
    "block.minecraft.dead_tube_coral_block",
    "block.minecraft.dead_tube_coral_fan",
    "block.minecraft.dead_tube_coral_wall_fan",
    "block.minecraft.decorated_pot",
    "block.minecraft.deepslate",
    "block.minecraft.deepslate_brick_slab",
    "block.minecraft.deepslate_brick_stairs",
    "block.minecraft.deepslate_brick_wall",
    "block.minecraft.deepslate_bricks",
    "block.minecraft.deepslate_coal_ore",
    "block.minecraft.deepslate_copper_ore",
    "block.minecraft.deepslate_diamond_ore",
    "block.minecraft.deepslate_emerald_ore",
    "block.minecraft.deepslate_gold_ore",
    "block.minecraft.deepslate_iron_ore",
    "block.minecraft.deepslate_lapis_ore",
    "block.minecraft.deepslate_redstone_ore",
    "block.minecraft.deepslate_tile_slab",
    "block.minecraft.deepslate_tile_stairs",
    "block.minecraft.deepslate_tile_wall",
    "block.minecraft.deepslate_tiles",
    "block.minecraft.detector_rail",
    "block.minecraft.diamond_block",
    "block.minecraft.diamond_ore",
    "block.minecraft.diorite",
    "block.minecraft.diorite_slab",
    "block.minecraft.diorite_stairs",
    "block.minecraft.diorite_wall",
    "block.minecraft.dirt",
    "block.minecraft.dirt_path",
    "block.minecraft.dispenser",
    "block.minecraft.dragon_egg",
    "block.minecraft.dragon_head",
    "block.minecraft.dragon_wall_head",
    "block.minecraft.dried_ghast",
    "block.minecraft.dried_kelp_block",
    "block.minecraft.dripstone_block",
    "block.minecraft.dropper",
    "block.minecraft.emerald_block",
    "block.minecraft.emerald_ore",
    "block.minecraft.enchanting_table",
    "block.minecraft.end_gateway",
    "block.minecraft.end_portal",
    "block.minecraft.end_portal_frame",
    "block.minecraft.end_rod",
    "block.minecraft.end_stone",
    "block.minecraft.end_stone_brick_slab",
    "block.minecraft.end_stone_brick_stairs",
    "block.minecraft.end_stone_brick_wall",
    "block.minecraft.end_stone_bricks",
    "block.minecraft.ender_chest",
    "block.minecraft.exposed_chiseled_copper",
    "block.minecraft.exposed_copper",
    "block.minecraft.exposed_copper_bars",
    "block.minecraft.exposed_copper_bulb",
    "block.minecraft.exposed_copper_chain",
    "block.minecraft.exposed_copper_chest",
    "block.minecraft.exposed_copper_door",
    "block.minecraft.exposed_copper_golem_statue",
    "block.minecraft.exposed_copper_grate",
    "block.minecraft.exposed_copper_lantern",
    "block.minecraft.exposed_copper_trapdoor",
    "block.minecraft.exposed_cut_copper",
    "block.minecraft.exposed_cut_copper_slab",
    "block.minecraft.exposed_cut_copper_stairs",
    "block.minecraft.exposed_lightning_rod",
    "block.minecraft.farmland",
    "block.minecraft.fern",
    "block.minecraft.fire",
    "block.minecraft.fire_coral",
    "block.minecraft.fire_coral_block",
    "block.minecraft.fire_coral_fan",
    "block.minecraft.fire_coral_wall_fan",
    "block.minecraft.firefly_bush",
    "block.minecraft.fletching_table",
    "block.minecraft.flower_pot",
    "block.minecraft.flowering_azalea",
    "block.minecraft.flowering_azalea_leaves",
    "block.minecraft.frogspawn",
    "block.minecraft.frosted_ice",
    "block.minecraft.furnace",
    "block.minecraft.gilded_blackstone",
    "block.minecraft.glass",
    "block.minecraft.glass_pane",
    "block.minecraft.glow_lichen",
    "block.minecraft.glowstone",
    "block.minecraft.gold_block",
    "block.minecraft.gold_ore",
    "block.minecraft.golden_dandelion",
    "block.minecraft.granite",
    "block.minecraft.granite_slab",
    "block.minecraft.granite_stairs",
    "block.minecraft.granite_wall",
    "block.minecraft.grass",
    "block.minecraft.grass_block",
    "block.minecraft.gravel",
    "block.minecraft.gray_banner",
    "block.minecraft.gray_bed",
    "block.minecraft.gray_candle",
    "block.minecraft.gray_candle_cake",
    "block.minecraft.gray_carpet",
    "block.minecraft.gray_concrete",
    "block.minecraft.gray_concrete_powder",
    "block.minecraft.gray_concrete_slab",
    "block.minecraft.gray_concrete_stairs",
    "block.minecraft.gray_glazed_terracotta",
    "block.minecraft.gray_shulker_box",
    "block.minecraft.gray_stained_glass",
    "block.minecraft.gray_stained_glass_pane",
    "block.minecraft.gray_terracotta",
    "block.minecraft.gray_wool",
    "block.minecraft.gray_wool_slab",
    "block.minecraft.gray_wool_stairs",
    "block.minecraft.green_banner",
    "block.minecraft.green_bed",
    "block.minecraft.green_candle",
    "block.minecraft.green_candle_cake",
    "block.minecraft.green_carpet",
    "block.minecraft.green_concrete",
    "block.minecraft.green_concrete_powder",
    "block.minecraft.green_concrete_slab",
    "block.minecraft.green_concrete_stairs",
    "block.minecraft.green_glazed_terracotta",
    "block.minecraft.green_shulker_box",
    "block.minecraft.green_stained_glass",
    "block.minecraft.green_stained_glass_pane",
    "block.minecraft.green_terracotta",
    "block.minecraft.green_wool",
    "block.minecraft.green_wool_slab",
    "block.minecraft.green_wool_stairs",
    "block.minecraft.grindstone",
    "block.minecraft.hanging_roots",
    "block.minecraft.hay_block",
    "block.minecraft.heavy_core",
    "block.minecraft.heavy_weighted_pressure_plate",
    "block.minecraft.honey_block",
    "block.minecraft.honeycomb_block",
    "block.minecraft.hopper",
    "block.minecraft.horn_coral",
    "block.minecraft.horn_coral_block",
    "block.minecraft.horn_coral_fan",
    "block.minecraft.horn_coral_wall_fan",
    "block.minecraft.ice",
    "block.minecraft.infested_chiseled_stone_bricks",
    "block.minecraft.infested_cobblestone",
    "block.minecraft.infested_cracked_stone_bricks",
    "block.minecraft.infested_deepslate",
    "block.minecraft.infested_mossy_stone_bricks",
    "block.minecraft.infested_stone",
    "block.minecraft.infested_stone_bricks",
    "block.minecraft.iron_bars",
    "block.minecraft.iron_block",
    "block.minecraft.iron_chain",
    "block.minecraft.iron_door",
    "block.minecraft.iron_ore",
    "block.minecraft.iron_trapdoor",
    "block.minecraft.jack_o_lantern",
    "block.minecraft.jigsaw",
    "block.minecraft.jukebox",
    "block.minecraft.jungle_button",
    "block.minecraft.jungle_door",
    "block.minecraft.jungle_fence",
    "block.minecraft.jungle_fence_gate",
    "block.minecraft.jungle_hanging_sign",
    "block.minecraft.jungle_leaves",
    "block.minecraft.jungle_log",
    "block.minecraft.jungle_planks",
    "block.minecraft.jungle_pressure_plate",
    "block.minecraft.jungle_sapling",
    "block.minecraft.jungle_shelf",
    "block.minecraft.jungle_sign",
    "block.minecraft.jungle_slab",
    "block.minecraft.jungle_stairs",
    "block.minecraft.jungle_trapdoor",
    "block.minecraft.jungle_wall_hanging_sign",
    "block.minecraft.jungle_wall_sign",
    "block.minecraft.jungle_wood",
    "block.minecraft.kelp",
    "block.minecraft.kelp_plant",
    "block.minecraft.ladder",
    "block.minecraft.lantern",
    "block.minecraft.lapis_block",
    "block.minecraft.lapis_ore",
    "block.minecraft.large_amethyst_bud",
    "block.minecraft.large_fern",
    "block.minecraft.lava",
    "block.minecraft.lava_cauldron",
    "block.minecraft.leaf_litter",
    "block.minecraft.lectern",
    "block.minecraft.lever",
    "block.minecraft.light",
    "block.minecraft.light_blue_banner",
    "block.minecraft.light_blue_bed",
    "block.minecraft.light_blue_candle",
    "block.minecraft.light_blue_candle_cake",
    "block.minecraft.light_blue_carpet",
    "block.minecraft.light_blue_concrete",
    "block.minecraft.light_blue_concrete_powder",
    "block.minecraft.light_blue_concrete_slab",
    "block.minecraft.light_blue_concrete_stairs",
    "block.minecraft.light_blue_glazed_terracotta",
    "block.minecraft.light_blue_shulker_box",
    "block.minecraft.light_blue_stained_glass",
    "block.minecraft.light_blue_stained_glass_pane",
    "block.minecraft.light_blue_terracotta",
    "block.minecraft.light_blue_wool",
    "block.minecraft.light_blue_wool_slab",
    "block.minecraft.light_blue_wool_stairs",
    "block.minecraft.light_gray_banner",
    "block.minecraft.light_gray_bed",
    "block.minecraft.light_gray_candle",
    "block.minecraft.light_gray_candle_cake",
    "block.minecraft.light_gray_carpet",
    "block.minecraft.light_gray_concrete",
    "block.minecraft.light_gray_concrete_powder",
    "block.minecraft.light_gray_concrete_slab",
    "block.minecraft.light_gray_concrete_stairs",
    "block.minecraft.light_gray_glazed_terracotta",
    "block.minecraft.light_gray_shulker_box",
    "block.minecraft.light_gray_stained_glass",
    "block.minecraft.light_gray_stained_glass_pane",
    "block.minecraft.light_gray_terracotta",
    "block.minecraft.light_gray_wool",
    "block.minecraft.light_gray_wool_slab",
    "block.minecraft.light_gray_wool_stairs",
    "block.minecraft.light_weighted_pressure_plate",
    "block.minecraft.lightning_rod",
    "block.minecraft.lilac",
    "block.minecraft.lily_of_the_valley",
    "block.minecraft.lily_pad",
    "block.minecraft.lime_banner",
    "block.minecraft.lime_bed",
    "block.minecraft.lime_candle",
    "block.minecraft.lime_candle_cake",
    "block.minecraft.lime_carpet",
    "block.minecraft.lime_concrete",
    "block.minecraft.lime_concrete_powder",
    "block.minecraft.lime_concrete_slab",
    "block.minecraft.lime_concrete_stairs",
    "block.minecraft.lime_glazed_terracotta",
    "block.minecraft.lime_shulker_box",
    "block.minecraft.lime_stained_glass",
    "block.minecraft.lime_stained_glass_pane",
    "block.minecraft.lime_terracotta",
    "block.minecraft.lime_wool",
    "block.minecraft.lime_wool_slab",
    "block.minecraft.lime_wool_stairs",
    "block.minecraft.lodestone",
    "block.minecraft.loom",
    "block.minecraft.magenta_banner",
    "block.minecraft.magenta_bed",
    "block.minecraft.magenta_candle",
    "block.minecraft.magenta_candle_cake",
    "block.minecraft.magenta_carpet",
    "block.minecraft.magenta_concrete",
    "block.minecraft.magenta_concrete_powder",
    "block.minecraft.magenta_concrete_slab",
    "block.minecraft.magenta_concrete_stairs",
    "block.minecraft.magenta_glazed_terracotta",
    "block.minecraft.magenta_shulker_box",
    "block.minecraft.magenta_stained_glass",
    "block.minecraft.magenta_stained_glass_pane",
    "block.minecraft.magenta_terracotta",
    "block.minecraft.magenta_wool",
    "block.minecraft.magenta_wool_slab",
    "block.minecraft.magenta_wool_stairs",
    "block.minecraft.magma_block",
    "block.minecraft.mangrove_button",
    "block.minecraft.mangrove_door",
    "block.minecraft.mangrove_fence",
    "block.minecraft.mangrove_fence_gate",
    "block.minecraft.mangrove_hanging_sign",
    "block.minecraft.mangrove_leaves",
    "block.minecraft.mangrove_log",
    "block.minecraft.mangrove_planks",
    "block.minecraft.mangrove_pressure_plate",
    "block.minecraft.mangrove_propagule",
    "block.minecraft.mangrove_roots",
    "block.minecraft.mangrove_shelf",
    "block.minecraft.mangrove_sign",
    "block.minecraft.mangrove_slab",
    "block.minecraft.mangrove_stairs",
    "block.minecraft.mangrove_trapdoor",
    "block.minecraft.mangrove_wall_hanging_sign",
    "block.minecraft.mangrove_wall_sign",
    "block.minecraft.mangrove_wood",
    "block.minecraft.medium_amethyst_bud",
    "block.minecraft.melon",
    "block.minecraft.melon_stem",
    "block.minecraft.moss_block",
    "block.minecraft.moss_carpet",
    "block.minecraft.mossy_cobblestone",
    "block.minecraft.mossy_cobblestone_slab",
    "block.minecraft.mossy_cobblestone_stairs",
    "block.minecraft.mossy_cobblestone_wall",
    "block.minecraft.mossy_stone_brick_slab",
    "block.minecraft.mossy_stone_brick_stairs",
    "block.minecraft.mossy_stone_brick_wall",
    "block.minecraft.mossy_stone_bricks",
    "block.minecraft.moving_piston",
    "block.minecraft.mud",
    "block.minecraft.mud_brick_slab",
    "block.minecraft.mud_brick_stairs",
    "block.minecraft.mud_brick_wall",
    "block.minecraft.mud_bricks",
    "block.minecraft.muddy_mangrove_roots",
    "block.minecraft.mushroom_stem",
    "block.minecraft.mycelium",
    "block.minecraft.nether_brick_fence",
    "block.minecraft.nether_brick_slab",
    "block.minecraft.nether_brick_stairs",
    "block.minecraft.nether_brick_wall",
    "block.minecraft.nether_bricks",
    "block.minecraft.nether_gold_ore",
    "block.minecraft.nether_portal",
    "block.minecraft.nether_quartz_ore",
    "block.minecraft.nether_sprouts",
    "block.minecraft.nether_wart",
    "block.minecraft.nether_wart_block",
    "block.minecraft.netherite_block",
    "block.minecraft.netherrack",
    "block.minecraft.note_block",
    "block.minecraft.oak_button",
    "block.minecraft.oak_door",
    "block.minecraft.oak_fence",
    "block.minecraft.oak_fence_gate",
    "block.minecraft.oak_hanging_sign",
    "block.minecraft.oak_leaves",
    "block.minecraft.oak_log",
    "block.minecraft.oak_planks",
    "block.minecraft.oak_pressure_plate",
    "block.minecraft.oak_sapling",
    "block.minecraft.oak_shelf",
    "block.minecraft.oak_sign",
    "block.minecraft.oak_slab",
    "block.minecraft.oak_stairs",
    "block.minecraft.oak_trapdoor",
    "block.minecraft.oak_wall_hanging_sign",
    "block.minecraft.oak_wall_sign",
    "block.minecraft.oak_wood",
    "block.minecraft.observer",
    "block.minecraft.obsidian",
    "block.minecraft.ochre_froglight",
    "block.minecraft.ominous_banner",
    "block.minecraft.open_eyeblossom",
    "block.minecraft.orange_banner",
    "block.minecraft.orange_bed",
    "block.minecraft.orange_candle",
    "block.minecraft.orange_candle_cake",
    "block.minecraft.orange_carpet",
    "block.minecraft.orange_concrete",
    "block.minecraft.orange_concrete_powder",
    "block.minecraft.orange_concrete_slab",
    "block.minecraft.orange_concrete_stairs",
    "block.minecraft.orange_glazed_terracotta",
    "block.minecraft.orange_poplar_leaves",
    "block.minecraft.orange_shulker_box",
    "block.minecraft.orange_stained_glass",
    "block.minecraft.orange_stained_glass_pane",
    "block.minecraft.orange_terracotta",
    "block.minecraft.orange_tulip",
    "block.minecraft.orange_wool",
    "block.minecraft.orange_wool_slab",
    "block.minecraft.orange_wool_stairs",
    "block.minecraft.oxeye_daisy",
    "block.minecraft.oxidized_chiseled_copper",
    "block.minecraft.oxidized_copper",
    "block.minecraft.oxidized_copper_bars",
    "block.minecraft.oxidized_copper_bulb",
    "block.minecraft.oxidized_copper_chain",
    "block.minecraft.oxidized_copper_chest",
    "block.minecraft.oxidized_copper_door",
    "block.minecraft.oxidized_copper_golem_statue",
    "block.minecraft.oxidized_copper_grate",
    "block.minecraft.oxidized_copper_lantern",
    "block.minecraft.oxidized_copper_trapdoor",
    "block.minecraft.oxidized_cut_copper",
    "block.minecraft.oxidized_cut_copper_slab",
    "block.minecraft.oxidized_cut_copper_stairs",
    "block.minecraft.oxidized_lightning_rod",
    "block.minecraft.packed_ice",
    "block.minecraft.packed_mud",
    "block.minecraft.pale_hanging_moss",
    "block.minecraft.pale_moss_block",
    "block.minecraft.pale_moss_carpet",
    "block.minecraft.pale_oak_button",
    "block.minecraft.pale_oak_door",
    "block.minecraft.pale_oak_fence",
    "block.minecraft.pale_oak_fence_gate",
    "block.minecraft.pale_oak_hanging_sign",
    "block.minecraft.pale_oak_leaves",
    "block.minecraft.pale_oak_log",
    "block.minecraft.pale_oak_planks",
    "block.minecraft.pale_oak_pressure_plate",
    "block.minecraft.pale_oak_sapling",
    "block.minecraft.pale_oak_shelf",
    "block.minecraft.pale_oak_sign",
    "block.minecraft.pale_oak_slab",
    "block.minecraft.pale_oak_stairs",
    "block.minecraft.pale_oak_trapdoor",
    "block.minecraft.pale_oak_wall_hanging_sign",
    "block.minecraft.pale_oak_wall_sign",
    "block.minecraft.pale_oak_wood",
    "block.minecraft.pearlescent_froglight",
    "block.minecraft.peony",
    "block.minecraft.petrified_oak_slab",
    "block.minecraft.piglin_head",
    "block.minecraft.piglin_wall_head",
    "block.minecraft.pink_banner",
    "block.minecraft.pink_bed",
    "block.minecraft.pink_candle",
    "block.minecraft.pink_candle_cake",
    "block.minecraft.pink_carpet",
    "block.minecraft.pink_concrete",
    "block.minecraft.pink_concrete_powder",
    "block.minecraft.pink_concrete_slab",
    "block.minecraft.pink_concrete_stairs",
    "block.minecraft.pink_glazed_terracotta",
    "block.minecraft.pink_petals",
    "block.minecraft.pink_shulker_box",
    "block.minecraft.pink_stained_glass",
    "block.minecraft.pink_stained_glass_pane",
    "block.minecraft.pink_terracotta",
    "block.minecraft.pink_tulip",
    "block.minecraft.pink_wool",
    "block.minecraft.pink_wool_slab",
    "block.minecraft.pink_wool_stairs",
    "block.minecraft.piston",
    "block.minecraft.piston_head",
    "block.minecraft.pitcher_crop",
    "block.minecraft.pitcher_plant",
    "block.minecraft.player_head",
    "block.minecraft.player_head.named",
    "block.minecraft.player_wall_head",
    "block.minecraft.podzol",
    "block.minecraft.pointed_dripstone",
    "block.minecraft.polished_andesite",
    "block.minecraft.polished_andesite_slab",
    "block.minecraft.polished_andesite_stairs",
    "block.minecraft.polished_basalt",
    "block.minecraft.polished_blackstone",
    "block.minecraft.polished_blackstone_brick_slab",
    "block.minecraft.polished_blackstone_brick_stairs",
    "block.minecraft.polished_blackstone_brick_wall",
    "block.minecraft.polished_blackstone_bricks",
    "block.minecraft.polished_blackstone_button",
    "block.minecraft.polished_blackstone_pressure_plate",
    "block.minecraft.polished_blackstone_slab",
    "block.minecraft.polished_blackstone_stairs",
    "block.minecraft.polished_blackstone_wall",
    "block.minecraft.polished_cinnabar",
    "block.minecraft.polished_cinnabar_slab",
    "block.minecraft.polished_cinnabar_stairs",
    "block.minecraft.polished_cinnabar_wall",
    "block.minecraft.polished_deepslate",
    "block.minecraft.polished_deepslate_slab",
    "block.minecraft.polished_deepslate_stairs",
    "block.minecraft.polished_deepslate_wall",
    "block.minecraft.polished_diorite",
    "block.minecraft.polished_diorite_slab",
    "block.minecraft.polished_diorite_stairs",
    "block.minecraft.polished_granite",
    "block.minecraft.polished_granite_slab",
    "block.minecraft.polished_granite_stairs",
    "block.minecraft.polished_sulfur",
    "block.minecraft.polished_sulfur_slab",
    "block.minecraft.polished_sulfur_stairs",
    "block.minecraft.polished_sulfur_wall",
    "block.minecraft.polished_tuff",
    "block.minecraft.polished_tuff_slab",
    "block.minecraft.polished_tuff_stairs",
    "block.minecraft.polished_tuff_wall",
    "block.minecraft.poplar_button",
    "block.minecraft.poplar_door",
    "block.minecraft.poplar_fence",
    "block.minecraft.poplar_fence_gate",
    "block.minecraft.poplar_hanging_sign",
    "block.minecraft.poplar_leaves",
    "block.minecraft.poplar_log",
    "block.minecraft.poplar_planks",
    "block.minecraft.poplar_pressure_plate",
    "block.minecraft.poplar_sapling",
    "block.minecraft.poplar_shelf",
    "block.minecraft.poplar_sign",
    "block.minecraft.poplar_slab",
    "block.minecraft.poplar_stairs",
    "block.minecraft.poplar_trapdoor",
    "block.minecraft.poplar_wall_hanging_sign",
    "block.minecraft.poplar_wall_sign",
    "block.minecraft.poplar_wood",
    "block.minecraft.poppy",
    "block.minecraft.potatoes",
    "block.minecraft.potent_sulfur",
    "block.minecraft.potted_acacia_sapling",
    "block.minecraft.potted_allium",
    "block.minecraft.potted_azalea_bush",
    "block.minecraft.potted_azure_bluet",
    "block.minecraft.potted_bamboo",
    "block.minecraft.potted_birch_sapling",
    "block.minecraft.potted_blue_orchid",
    "block.minecraft.potted_brown_mushroom",
    "block.minecraft.potted_cactus",
    "block.minecraft.potted_cherry_sapling",
    "block.minecraft.potted_closed_eyeblossom",
    "block.minecraft.potted_cornflower",
    "block.minecraft.potted_crimson_fungus",
    "block.minecraft.potted_crimson_roots",
    "block.minecraft.potted_dandelion",
    "block.minecraft.potted_dark_oak_sapling",
    "block.minecraft.potted_dead_bush",
    "block.minecraft.potted_fern",
    "block.minecraft.potted_flowering_azalea_bush",
    "block.minecraft.potted_golden_dandelion",
    "block.minecraft.potted_jungle_sapling",
    "block.minecraft.potted_lily_of_the_valley",
    "block.minecraft.potted_mangrove_propagule",
    "block.minecraft.potted_oak_sapling",
    "block.minecraft.potted_open_eyeblossom",
    "block.minecraft.potted_orange_tulip",
    "block.minecraft.potted_oxeye_daisy",
    "block.minecraft.potted_pale_oak_sapling",
    "block.minecraft.potted_pink_tulip",
    "block.minecraft.potted_poplar_sapling",
    "block.minecraft.potted_poppy",
    "block.minecraft.potted_red_mushroom",
    "block.minecraft.potted_red_tulip",
    "block.minecraft.potted_spruce_sapling",
    "block.minecraft.potted_torchflower",
    "block.minecraft.potted_warped_fungus",
    "block.minecraft.potted_warped_roots",
    "block.minecraft.potted_white_tulip",
    "block.minecraft.potted_wither_rose",
    "block.minecraft.powder_snow",
    "block.minecraft.powder_snow_cauldron",
    "block.minecraft.powered_rail",
    "block.minecraft.prismarine",
    "block.minecraft.prismarine_brick_slab",
    "block.minecraft.prismarine_brick_stairs",
    "block.minecraft.prismarine_bricks",
    "block.minecraft.prismarine_slab",
    "block.minecraft.prismarine_stairs",
    "block.minecraft.prismarine_wall",
    "block.minecraft.pumpkin",
    "block.minecraft.pumpkin_stem",
    "block.minecraft.purple_banner",
    "block.minecraft.purple_bed",
    "block.minecraft.purple_candle",
    "block.minecraft.purple_candle_cake",
    "block.minecraft.purple_carpet",
    "block.minecraft.purple_concrete",
    "block.minecraft.purple_concrete_powder",
    "block.minecraft.purple_concrete_slab",
    "block.minecraft.purple_concrete_stairs",
    "block.minecraft.purple_glazed_terracotta",
    "block.minecraft.purple_shulker_box",
    "block.minecraft.purple_stained_glass",
    "block.minecraft.purple_stained_glass_pane",
    "block.minecraft.purple_terracotta",
    "block.minecraft.purple_wool",
    "block.minecraft.purple_wool_slab",
    "block.minecraft.purple_wool_stairs",
    "block.minecraft.purpur_block",
    "block.minecraft.purpur_pillar",
    "block.minecraft.purpur_slab",
    "block.minecraft.purpur_stairs",
    "block.minecraft.quartz_block",
    "block.minecraft.quartz_bricks",
    "block.minecraft.quartz_pillar",
    "block.minecraft.quartz_slab",
    "block.minecraft.quartz_stairs",
    "block.minecraft.rail",
    "block.minecraft.raw_copper_block",
    "block.minecraft.raw_gold_block",
    "block.minecraft.raw_iron_block",
    "block.minecraft.red_banner",
    "block.minecraft.red_bed",
    "block.minecraft.red_candle",
    "block.minecraft.red_candle_cake",
    "block.minecraft.red_carpet",
    "block.minecraft.red_concrete",
    "block.minecraft.red_concrete_powder",
    "block.minecraft.red_concrete_slab",
    "block.minecraft.red_concrete_stairs",
    "block.minecraft.red_glazed_terracotta",
    "block.minecraft.red_mushroom",
    "block.minecraft.red_mushroom_block",
    "block.minecraft.red_nether_brick_slab",
    "block.minecraft.red_nether_brick_stairs",
    "block.minecraft.red_nether_brick_wall",
    "block.minecraft.red_nether_bricks",
    "block.minecraft.red_poplar_leaves",
    "block.minecraft.red_sand",
    "block.minecraft.red_sandstone",
    "block.minecraft.red_sandstone_slab",
    "block.minecraft.red_sandstone_stairs",
    "block.minecraft.red_sandstone_wall",
    "block.minecraft.red_shrub",
    "block.minecraft.red_shulker_box",
    "block.minecraft.red_stained_glass",
    "block.minecraft.red_stained_glass_pane",
    "block.minecraft.red_terracotta",
    "block.minecraft.red_tulip",
    "block.minecraft.red_wool",
    "block.minecraft.red_wool_slab",
    "block.minecraft.red_wool_stairs",
    "block.minecraft.redstone_block",
    "block.minecraft.redstone_lamp",
    "block.minecraft.redstone_ore",
    "block.minecraft.redstone_torch",
    "block.minecraft.redstone_wall_torch",
    "block.minecraft.redstone_wire",
    "block.minecraft.reinforced_deepslate",
    "block.minecraft.repeater",
    "block.minecraft.repeating_command_block",
    "block.minecraft.resin_block",
    "block.minecraft.resin_brick_slab",
    "block.minecraft.resin_brick_stairs",
    "block.minecraft.resin_brick_wall",
    "block.minecraft.resin_bricks",
    "block.minecraft.resin_clump",
    "block.minecraft.respawn_anchor",
    "block.minecraft.rooted_dirt",
    "block.minecraft.rose_bush",
    "block.minecraft.sand",
    "block.minecraft.sandstone",
    "block.minecraft.sandstone_slab",
    "block.minecraft.sandstone_stairs",
    "block.minecraft.sandstone_wall",
    "block.minecraft.scaffolding",
    "block.minecraft.sculk",
    "block.minecraft.sculk_catalyst",
    "block.minecraft.sculk_sensor",
    "block.minecraft.sculk_shrieker",
    "block.minecraft.sculk_vein",
    "block.minecraft.sea_lantern",
    "block.minecraft.sea_pickle",
    "block.minecraft.seagrass",
    "block.minecraft.set_spawn",
    "block.minecraft.shelf_mushroom",
    "block.minecraft.short_dry_grass",
    "block.minecraft.short_grass",
    "block.minecraft.shroomlight",
    "block.minecraft.shulker_box",
    "block.minecraft.skeleton_skull",
    "block.minecraft.skeleton_wall_skull",
    "block.minecraft.slime_block",
    "block.minecraft.small_amethyst_bud",
    "block.minecraft.small_dripleaf",
    "block.minecraft.smithing_table",
    "block.minecraft.smoker",
    "block.minecraft.smooth_basalt",
    "block.minecraft.smooth_quartz",
    "block.minecraft.smooth_quartz_slab",
    "block.minecraft.smooth_quartz_stairs",
    "block.minecraft.smooth_red_sandstone",
    "block.minecraft.smooth_red_sandstone_slab",
    "block.minecraft.smooth_red_sandstone_stairs",
    "block.minecraft.smooth_sandstone",
    "block.minecraft.smooth_sandstone_slab",
    "block.minecraft.smooth_sandstone_stairs",
    "block.minecraft.smooth_stone",
    "block.minecraft.smooth_stone_slab",
    "block.minecraft.sniffer_egg",
    "block.minecraft.snow",
    "block.minecraft.snow_block",
    "block.minecraft.soul_campfire",
    "block.minecraft.soul_fire",
    "block.minecraft.soul_lantern",
    "block.minecraft.soul_sand",
    "block.minecraft.soul_soil",
    "block.minecraft.soul_torch",
    "block.minecraft.soul_wall_torch",
    "block.minecraft.spawn.not_valid",
    "block.minecraft.spawner",
    "block.minecraft.spawner.desc1",
    "block.minecraft.spawner.desc2",
    "block.minecraft.sponge",
    "block.minecraft.spore_blossom",
    "block.minecraft.spruce_button",
    "block.minecraft.spruce_door",
    "block.minecraft.spruce_fence",
    "block.minecraft.spruce_fence_gate",
    "block.minecraft.spruce_hanging_sign",
    "block.minecraft.spruce_leaves",
    "block.minecraft.spruce_log",
    "block.minecraft.spruce_planks",
    "block.minecraft.spruce_pressure_plate",
    "block.minecraft.spruce_sapling",
    "block.minecraft.spruce_shelf",
    "block.minecraft.spruce_sign",
    "block.minecraft.spruce_slab",
    "block.minecraft.spruce_stairs",
    "block.minecraft.spruce_trapdoor",
    "block.minecraft.spruce_wall_hanging_sign",
    "block.minecraft.spruce_wall_sign",
    "block.minecraft.spruce_wood",
    "block.minecraft.sticky_piston",
    "block.minecraft.stone",
    "block.minecraft.stone_brick_slab",
    "block.minecraft.stone_brick_stairs",
    "block.minecraft.stone_brick_wall",
    "block.minecraft.stone_bricks",
    "block.minecraft.stone_button",
    "block.minecraft.stone_pressure_plate",
    "block.minecraft.stone_slab",
    "block.minecraft.stone_stairs",
    "block.minecraft.stonecutter",
    "block.minecraft.straw_bed",
    "block.minecraft.stripped_acacia_log",
    "block.minecraft.stripped_acacia_wood",
    "block.minecraft.stripped_bamboo_block",
    "block.minecraft.stripped_birch_log",
    "block.minecraft.stripped_birch_wood",
    "block.minecraft.stripped_cherry_log",
    "block.minecraft.stripped_cherry_wood",
    "block.minecraft.stripped_crimson_hyphae",
    "block.minecraft.stripped_crimson_stem",
    "block.minecraft.stripped_dark_oak_log",
    "block.minecraft.stripped_dark_oak_wood",
    "block.minecraft.stripped_jungle_log",
    "block.minecraft.stripped_jungle_wood",
    "block.minecraft.stripped_mangrove_log",
    "block.minecraft.stripped_mangrove_wood",
    "block.minecraft.stripped_oak_log",
    "block.minecraft.stripped_oak_wood",
    "block.minecraft.stripped_pale_oak_log",
    "block.minecraft.stripped_pale_oak_wood",
    "block.minecraft.stripped_poplar_log",
    "block.minecraft.stripped_poplar_wood",
    "block.minecraft.stripped_spruce_log",
    "block.minecraft.stripped_spruce_wood",
    "block.minecraft.stripped_warped_hyphae",
    "block.minecraft.stripped_warped_stem",
    "block.minecraft.structure_block",
    "block.minecraft.structure_void",
    "block.minecraft.sugar_cane",
    "block.minecraft.sulfur",
    "block.minecraft.sulfur_brick_slab",
    "block.minecraft.sulfur_brick_stairs",
    "block.minecraft.sulfur_brick_wall",
    "block.minecraft.sulfur_bricks",
    "block.minecraft.sulfur_slab",
    "block.minecraft.sulfur_spike",
    "block.minecraft.sulfur_stairs",
    "block.minecraft.sulfur_wall",
    "block.minecraft.sunflower",
    "block.minecraft.suspicious_gravel",
    "block.minecraft.suspicious_sand",
    "block.minecraft.sweet_berry_bush",
    "block.minecraft.tall_dry_grass",
    "block.minecraft.tall_grass",
    "block.minecraft.tall_seagrass",
    "block.minecraft.target",
    "block.minecraft.terracotta",
    "block.minecraft.test_block",
    "block.minecraft.test_instance_block",
    "block.minecraft.tinted_glass",
    "block.minecraft.tnt",
    "block.minecraft.tnt.disabled",
    "block.minecraft.torch",
    "block.minecraft.torchflower",
    "block.minecraft.torchflower_crop",
    "block.minecraft.trapped_chest",
    "block.minecraft.trial_spawner",
    "block.minecraft.tripwire",
    "block.minecraft.tripwire_hook",
    "block.minecraft.tube_coral",
    "block.minecraft.tube_coral_block",
    "block.minecraft.tube_coral_fan",
    "block.minecraft.tube_coral_wall_fan",
    "block.minecraft.tuff",
    "block.minecraft.tuff_brick_slab",
    "block.minecraft.tuff_brick_stairs",
    "block.minecraft.tuff_brick_wall",
    "block.minecraft.tuff_bricks",
    "block.minecraft.tuff_slab",
    "block.minecraft.tuff_stairs",
    "block.minecraft.tuff_wall",
    "block.minecraft.turtle_egg",
    "block.minecraft.twisting_vines",
    "block.minecraft.twisting_vines_plant",
    "block.minecraft.vault",
    "block.minecraft.verdant_froglight",
    "block.minecraft.vine",
    "block.minecraft.void_air",
    "block.minecraft.wall_torch",
    "block.minecraft.warped_button",
    "block.minecraft.warped_door",
    "block.minecraft.warped_fence",
    "block.minecraft.warped_fence_gate",
    "block.minecraft.warped_fungus",
    "block.minecraft.warped_hanging_sign",
    "block.minecraft.warped_hyphae",
    "block.minecraft.warped_nylium",
    "block.minecraft.warped_planks",
    "block.minecraft.warped_pressure_plate",
    "block.minecraft.warped_roots",
    "block.minecraft.warped_shelf",
    "block.minecraft.warped_sign",
    "block.minecraft.warped_slab",
    "block.minecraft.warped_stairs",
    "block.minecraft.warped_stem",
    "block.minecraft.warped_trapdoor",
    "block.minecraft.warped_wall_hanging_sign",
    "block.minecraft.warped_wall_sign",
    "block.minecraft.warped_wart_block",
    "block.minecraft.water",
    "block.minecraft.water_cauldron",
    "block.minecraft.waxed_chiseled_copper",
    "block.minecraft.waxed_copper_bars",
    "block.minecraft.waxed_copper_block",
    "block.minecraft.waxed_copper_bulb",
    "block.minecraft.waxed_copper_chain",
    "block.minecraft.waxed_copper_chest",
    "block.minecraft.waxed_copper_door",
    "block.minecraft.waxed_copper_golem_statue",
    "block.minecraft.waxed_copper_grate",
    "block.minecraft.waxed_copper_lantern",
    "block.minecraft.waxed_copper_trapdoor",
    "block.minecraft.waxed_cut_copper",
    "block.minecraft.waxed_cut_copper_slab",
    "block.minecraft.waxed_cut_copper_stairs",
    "block.minecraft.waxed_exposed_chiseled_copper",
    "block.minecraft.waxed_exposed_copper",
    "block.minecraft.waxed_exposed_copper_bars",
    "block.minecraft.waxed_exposed_copper_bulb",
    "block.minecraft.waxed_exposed_copper_chain",
    "block.minecraft.waxed_exposed_copper_chest",
    "block.minecraft.waxed_exposed_copper_door",
    "block.minecraft.waxed_exposed_copper_golem_statue",
    "block.minecraft.waxed_exposed_copper_grate",
    "block.minecraft.waxed_exposed_copper_lantern",
    "block.minecraft.waxed_exposed_copper_trapdoor",
    "block.minecraft.waxed_exposed_cut_copper",
    "block.minecraft.waxed_exposed_cut_copper_slab",
    "block.minecraft.waxed_exposed_cut_copper_stairs",
    "block.minecraft.waxed_exposed_lightning_rod",
    "block.minecraft.waxed_lightning_rod",
    "block.minecraft.waxed_oxidized_chiseled_copper",
    "block.minecraft.waxed_oxidized_copper",
    "block.minecraft.waxed_oxidized_copper_bars",
    "block.minecraft.waxed_oxidized_copper_bulb",
    "block.minecraft.waxed_oxidized_copper_chain",
    "block.minecraft.waxed_oxidized_copper_chest",
    "block.minecraft.waxed_oxidized_copper_door",
    "block.minecraft.waxed_oxidized_copper_golem_statue",
    "block.minecraft.waxed_oxidized_copper_grate",
    "block.minecraft.waxed_oxidized_copper_lantern",
    "block.minecraft.waxed_oxidized_copper_trapdoor",
    "block.minecraft.waxed_oxidized_cut_copper",
    "block.minecraft.waxed_oxidized_cut_copper_slab",
    "block.minecraft.waxed_oxidized_cut_copper_stairs",
    "block.minecraft.waxed_oxidized_lightning_rod",
    "block.minecraft.waxed_weathered_chiseled_copper",
    "block.minecraft.waxed_weathered_copper",
    "block.minecraft.waxed_weathered_copper_bars",
    "block.minecraft.waxed_weathered_copper_bulb",
    "block.minecraft.waxed_weathered_copper_chain",
    "block.minecraft.waxed_weathered_copper_chest",
    "block.minecraft.waxed_weathered_copper_door",
    "block.minecraft.waxed_weathered_copper_golem_statue",
    "block.minecraft.waxed_weathered_copper_grate",
    "block.minecraft.waxed_weathered_copper_lantern",
    "block.minecraft.waxed_weathered_copper_trapdoor",
    "block.minecraft.waxed_weathered_cut_copper",
    "block.minecraft.waxed_weathered_cut_copper_slab",
    "block.minecraft.waxed_weathered_cut_copper_stairs",
    "block.minecraft.waxed_weathered_lightning_rod",
    "block.minecraft.weathered_chiseled_copper",
    "block.minecraft.weathered_copper",
    "block.minecraft.weathered_copper_bars",
    "block.minecraft.weathered_copper_bulb",
    "block.minecraft.weathered_copper_chain",
    "block.minecraft.weathered_copper_chest",
    "block.minecraft.weathered_copper_door",
    "block.minecraft.weathered_copper_golem_statue",
    "block.minecraft.weathered_copper_grate",
    "block.minecraft.weathered_copper_lantern",
    "block.minecraft.weathered_copper_trapdoor",
    "block.minecraft.weathered_cut_copper",
    "block.minecraft.weathered_cut_copper_slab",
    "block.minecraft.weathered_cut_copper_stairs",
    "block.minecraft.weathered_lightning_rod",
    "block.minecraft.weeping_vines",
    "block.minecraft.weeping_vines_plant",
    "block.minecraft.wet_sponge",
    "block.minecraft.wheat",
    "block.minecraft.white_banner",
    "block.minecraft.white_bed",
    "block.minecraft.white_candle",
    "block.minecraft.white_candle_cake",
    "block.minecraft.white_carpet",
    "block.minecraft.white_concrete",
    "block.minecraft.white_concrete_powder",
    "block.minecraft.white_concrete_slab",
    "block.minecraft.white_concrete_stairs",
    "block.minecraft.white_glazed_terracotta",
    "block.minecraft.white_shulker_box",
    "block.minecraft.white_stained_glass",
    "block.minecraft.white_stained_glass_pane",
    "block.minecraft.white_terracotta",
    "block.minecraft.white_tulip",
    "block.minecraft.white_wool",
    "block.minecraft.white_wool_slab",
    "block.minecraft.white_wool_stairs",
    "block.minecraft.wildflowers",
    "block.minecraft.wither_rose",
    "block.minecraft.wither_skeleton_skull",
    "block.minecraft.wither_skeleton_wall_skull",
    "block.minecraft.yellow_banner",
    "block.minecraft.yellow_bed",
    "block.minecraft.yellow_candle",
    "block.minecraft.yellow_candle_cake",
    "block.minecraft.yellow_carpet",
    "block.minecraft.yellow_concrete",
    "block.minecraft.yellow_concrete_powder",
    "block.minecraft.yellow_concrete_slab",
    "block.minecraft.yellow_concrete_stairs",
    "block.minecraft.yellow_glazed_terracotta",
    "block.minecraft.yellow_poplar_leaves",
    "block.minecraft.yellow_shulker_box",
    "block.minecraft.yellow_stained_glass",
    "block.minecraft.yellow_stained_glass_pane",
    "block.minecraft.yellow_terracotta",
    "block.minecraft.yellow_wool",
    "block.minecraft.yellow_wool_slab",
    "block.minecraft.yellow_wool_stairs",
    "block.minecraft.zombie_head",
    "block.minecraft.zombie_wall_head",
    "book.byAuthor",
    "book.edit.title",
    "book.editTitle",
    "book.finalizeButton",
    "book.finalizeWarning",
    "book.generation.0",
    "book.generation.1",
    "book.generation.2",
    "book.generation.3",
    "book.invalid.tag",
    "book.page_button.next",
    "book.page_button.previous",
    "book.pageIndicator",
    "book.sign.title",
    "book.sign.titlebox",
    "book.signButton",
    "book.view.title",
    "build.spawn_protection",
    "build.tooHigh",
    "build.tooLow",
    "chat_restriction.chat_and_commands_disabled_by_options",
    "chat_restriction.chat_disabled_by_options",
    "chat_restriction.chat_disabled_by_options.action",
    "chat_restriction.disabled_by_launcher",
    "chat_restriction.disabled_by_profile",
    "chat_restriction.disabled_by_profile.action",
    "chat_screen.commands_not_allowed",
    "chat_screen.message",
    "chat_screen.messages_not_allowed",
    "chat_screen.restricted",
    "chat_screen.restricted.narration",
    "chat_screen.title",
    "chat_screen.usage",
    "chat.cannotSend",
    "chat.coordinates",
    "chat.coordinates.tooltip",
    "chat.copy",
    "chat.copy.click",
    "chat.deleted_marker",
    "chat.disabled.chain_broken",
    "chat.disabled.expiredProfileKey",
    "chat.disabled.invalid_command_signature",
    "chat.disabled.invalid_signature",
    "chat.disabled.launcher",
    "chat.disabled.missingProfileKey",
    "chat.disabled.options",
    "chat.disabled.out_of_order_chat",
    "chat.disabled.profile",
    "chat.disabled.profile.moreInfo",
    "chat.editBox",
    "chat.filtered",
    "chat.filtered_full",
    "chat.link.confirm",
    "chat.link.confirmTrusted",
    "chat.link.open",
    "chat.link.warning",
    "chat.queue",
    "chat.queue.tooltip",
    "chat.square_brackets",
    "chat.tag.error",
    "chat.tag.modified",
    "chat.tag.not_secure",
    "chat.tag.system",
    "chat.tag.system_single_player",
    "chat.type.admin",
    "chat.type.advancement.challenge",
    "chat.type.advancement.goal",
    "chat.type.advancement.task",
    "chat.type.announcement",
    "chat.type.emote",
    "chat.type.team.hover",
    "chat.type.team.sent",
    "chat.type.team.text",
    "chat.type.text",
    "chat.type.text.narrate",
    "chat.validation_error",
    "chunk.toast.checkLog",
    "chunk.toast.loadFailure",
    "chunk.toast.lowDiskSpace",
    "chunk.toast.lowDiskSpace.description",
    "chunk.toast.saveFailure",
    "clear.failed.multiple",
    "clear.failed.single",
    "color.minecraft.black",
    "color.minecraft.blue",
    "color.minecraft.brown",
    "color.minecraft.cyan",
    "color.minecraft.gray",
    "color.minecraft.green",
    "color.minecraft.light_blue",
    "color.minecraft.light_gray",
    "color.minecraft.lime",
    "color.minecraft.magenta",
    "color.minecraft.orange",
    "color.minecraft.pink",
    "color.minecraft.purple",
    "color.minecraft.red",
    "color.minecraft.white",
    "color.minecraft.yellow",
    "command.context.here",
    "command.context.parse_error",
    "command.exception",
    "command.expected.separator",
    "command.failed",
    "command.forkLimit",
    "command.trailing_data",
    "command.unknown.argument",
    "command.unknown.command",
    "commands.advancement.criterionNotFound",
    "commands.advancement.grant.criterion.to.many.failure",
    "commands.advancement.grant.criterion.to.many.success",
    "commands.advancement.grant.criterion.to.one.failure",
    "commands.advancement.grant.criterion.to.one.success",
    "commands.advancement.grant.many.to.many.failure",
    "commands.advancement.grant.many.to.many.success",
    "commands.advancement.grant.many.to.one.failure",
    "commands.advancement.grant.many.to.one.success",
    "commands.advancement.grant.one.to.many.failure",
    "commands.advancement.grant.one.to.many.success",
    "commands.advancement.grant.one.to.one.failure",
    "commands.advancement.grant.one.to.one.success",
    "commands.advancement.revoke.criterion.to.many.failure",
    "commands.advancement.revoke.criterion.to.many.success",
    "commands.advancement.revoke.criterion.to.one.failure",
    "commands.advancement.revoke.criterion.to.one.success",
    "commands.advancement.revoke.many.to.many.failure",
    "commands.advancement.revoke.many.to.many.success",
    "commands.advancement.revoke.many.to.one.failure",
    "commands.advancement.revoke.many.to.one.success",
    "commands.advancement.revoke.one.to.many.failure",
    "commands.advancement.revoke.one.to.many.success",
    "commands.advancement.revoke.one.to.one.failure",
    "commands.advancement.revoke.one.to.one.success",
    "commands.attribute.base_value.get.success",
    "commands.attribute.base_value.reset.success",
    "commands.attribute.base_value.set.success",
    "commands.attribute.failed.entity",
    "commands.attribute.failed.modifier_already_present",
    "commands.attribute.failed.no_attribute",
    "commands.attribute.failed.no_modifier",
    "commands.attribute.modifier.add.success",
    "commands.attribute.modifier.remove.success",
    "commands.attribute.modifier.value.get.success",
    "commands.attribute.value.get.success",
    "commands.ban.failed",
    "commands.ban.success",
    "commands.banip.failed",
    "commands.banip.info",
    "commands.banip.invalid",
    "commands.banip.success",
    "commands.banlist.entry",
    "commands.banlist.entry.unknown",
    "commands.banlist.list",
    "commands.banlist.none",
    "commands.bossbar.create.failed",
    "commands.bossbar.create.success",
    "commands.bossbar.get.max",
    "commands.bossbar.get.players.none",
    "commands.bossbar.get.players.some",
    "commands.bossbar.get.value",
    "commands.bossbar.get.visible.hidden",
    "commands.bossbar.get.visible.visible",
    "commands.bossbar.list.bars.none",
    "commands.bossbar.list.bars.some",
    "commands.bossbar.remove.success",
    "commands.bossbar.set.color.success",
    "commands.bossbar.set.color.unchanged",
    "commands.bossbar.set.max.success",
    "commands.bossbar.set.max.unchanged",
    "commands.bossbar.set.name.success",
    "commands.bossbar.set.name.unchanged",
    "commands.bossbar.set.players.success.none",
    "commands.bossbar.set.players.success.some",
    "commands.bossbar.set.players.unchanged",
    "commands.bossbar.set.style.success",
    "commands.bossbar.set.style.unchanged",
    "commands.bossbar.set.value.success",
    "commands.bossbar.set.value.unchanged",
    "commands.bossbar.set.visibility.unchanged.hidden",
    "commands.bossbar.set.visibility.unchanged.visible",
    "commands.bossbar.set.visible.success.hidden",
    "commands.bossbar.set.visible.success.visible",
    "commands.bossbar.unknown",
    "commands.clear.success.multiple",
    "commands.clear.success.single",
    "commands.clear.test.multiple",
    "commands.clear.test.single",
    "commands.clone.failed",
    "commands.clone.overlap",
    "commands.clone.success",
    "commands.clone.toobig",
    "commands.damage.invulnerable",
    "commands.damage.success",
    "commands.data.block.get",
    "commands.data.block.invalid",
    "commands.data.block.modified",
    "commands.data.block.query",
    "commands.data.entity.get",
    "commands.data.entity.invalid",
    "commands.data.entity.modified",
    "commands.data.entity.query",
    "commands.data.get.invalid",
    "commands.data.get.multiple",
    "commands.data.get.unknown",
    "commands.data.merge.failed",
    "commands.data.modify.expected_list",
    "commands.data.modify.expected_object",
    "commands.data.modify.expected_value",
    "commands.data.modify.invalid_index",
    "commands.data.modify.invalid_substring",
    "commands.data.storage.get",
    "commands.data.storage.modified",
    "commands.data.storage.query",
    "commands.datapack.create.already_exists",
    "commands.datapack.create.invalid_full_name",
    "commands.datapack.create.invalid_name",
    "commands.datapack.create.io_failure",
    "commands.datapack.create.metadata_encode_failure",
    "commands.datapack.create.success",
    "commands.datapack.disable.failed",
    "commands.datapack.disable.failed.feature",
    "commands.datapack.enable.failed",
    "commands.datapack.enable.failed.no_flags",
    "commands.datapack.list.available.none",
    "commands.datapack.list.available.success",
    "commands.datapack.list.enabled.none",
    "commands.datapack.list.enabled.success",
    "commands.datapack.modify.disable",
    "commands.datapack.modify.enable",
    "commands.datapack.unknown",
    "commands.debug.alreadyRunning",
    "commands.debug.function.noRecursion",
    "commands.debug.function.noReturnRun",
    "commands.debug.function.success.multiple",
    "commands.debug.function.success.single",
    "commands.debug.function.traceFailed",
    "commands.debug.notRunning",
    "commands.debug.started",
    "commands.debug.stopped",
    "commands.defaultgamemode.success",
    "commands.deop.failed",
    "commands.deop.success",
    "commands.dialog.clear.multiple",
    "commands.dialog.clear.single",
    "commands.dialog.show.multiple",
    "commands.dialog.show.single",
    "commands.difficulty.failure",
    "commands.difficulty.query",
    "commands.difficulty.success",
    "commands.drop.no_held_items",
    "commands.drop.no_loot_table",
    "commands.drop.no_loot_table.block",
    "commands.drop.success.multiple",
    "commands.drop.success.multiple_with_table",
    "commands.drop.success.single",
    "commands.drop.success.single_with_table",
    "commands.effect.clear.everything.failed",
    "commands.effect.clear.everything.success.multiple",
    "commands.effect.clear.everything.success.single",
    "commands.effect.clear.specific.failed",
    "commands.effect.clear.specific.success.multiple",
    "commands.effect.clear.specific.success.single",
    "commands.effect.give.failed",
    "commands.effect.give.success.multiple",
    "commands.effect.give.success.single",
    "commands.enchant.failed",
    "commands.enchant.failed.entity",
    "commands.enchant.failed.incompatible",
    "commands.enchant.failed.itemless",
    "commands.enchant.failed.level",
    "commands.enchant.success.multiple",
    "commands.enchant.success.single",
    "commands.execute.blocks.toobig",
    "commands.execute.conditional.fail",
    "commands.execute.conditional.fail_count",
    "commands.execute.conditional.pass",
    "commands.execute.conditional.pass_count",
    "commands.execute.function.instantiationFailure",
    "commands.experience.add.levels.success.multiple",
    "commands.experience.add.levels.success.single",
    "commands.experience.add.points.success.multiple",
    "commands.experience.add.points.success.single",
    "commands.experience.query.levels",
    "commands.experience.query.points",
    "commands.experience.set.levels.success.multiple",
    "commands.experience.set.levels.success.single",
    "commands.experience.set.points.invalid",
    "commands.experience.set.points.success.multiple",
    "commands.experience.set.points.success.single",
    "commands.fetchprofile.copy_component",
    "commands.fetchprofile.copy_text",
    "commands.fetchprofile.entity.success",
    "commands.fetchprofile.failed_to_serialize",
    "commands.fetchprofile.give_item",
    "commands.fetchprofile.id.failure",
    "commands.fetchprofile.id.success",
    "commands.fetchprofile.name.failure",
    "commands.fetchprofile.name.success",
    "commands.fetchprofile.no_profile",
    "commands.fetchprofile.summon_mannequin",
    "commands.fill.failed",
    "commands.fill.success",
    "commands.fill.toobig",
    "commands.fillbiome.no_changes",
    "commands.fillbiome.success",
    "commands.fillbiome.success.count",
    "commands.fillbiome.toobig",
    "commands.forceload.added.failure",
    "commands.forceload.added.multiple",
    "commands.forceload.added.none",
    "commands.forceload.added.single",
    "commands.forceload.list.multiple",
    "commands.forceload.list.single",
    "commands.forceload.query.failure",
    "commands.forceload.query.success",
    "commands.forceload.removed.all",
    "commands.forceload.removed.failure",
    "commands.forceload.removed.multiple",
    "commands.forceload.removed.single",
    "commands.forceload.toobig",
    "commands.function.error.argument_not_compound",
    "commands.function.error.missing_argument",
    "commands.function.error.missing_arguments",
    "commands.function.error.parse",
    "commands.function.instantiationFailure",
    "commands.function.result",
    "commands.function.scheduled.multiple",
    "commands.function.scheduled.no_functions",
    "commands.function.scheduled.single",
    "commands.function.success.multiple",
    "commands.function.success.multiple.result",
    "commands.function.success.single",
    "commands.function.success.single.result",
    "commands.gamemode.success.other",
    "commands.gamemode.success.self",
    "commands.gamerule.not_set",
    "commands.gamerule.query",
    "commands.gamerule.set",
    "commands.give.failed.toomanyitems",
    "commands.give.success.multiple",
    "commands.give.success.single",
    "commands.help.failed",
    "commands.item.block.modify.success",
    "commands.item.block.replace.success",
    "commands.item.block.replace.success.known_item",
    "commands.item.block.set.success",
    "commands.item.entity.modify.success.multiple",
    "commands.item.entity.modify.success.single",
    "commands.item.entity.replace.success.multiple",
    "commands.item.entity.replace.success.multiple.known_item",
    "commands.item.entity.replace.success.single",
    "commands.item.entity.replace.success.single.known_item",
    "commands.item.entity.set.success.multiple",
    "commands.item.entity.set.success.single",
    "commands.item.source.no_such_slot",
    "commands.item.source.no_such_slot.unnamed",
    "commands.item.source.not_a_container",
    "commands.item.target.failed",
    "commands.item.target.failed.known_item",
    "commands.item.target.no_changed.known_item",
    "commands.item.target.no_changes",
    "commands.item.target.no_such_slot",
    "commands.item.target.no_such_slot.unnamed",
    "commands.item.target.not_a_container",
    "commands.jfr.dump.failed",
    "commands.jfr.start.failed",
    "commands.jfr.started",
    "commands.jfr.stopped",
    "commands.kick.owner.failed",
    "commands.kick.singleplayer.failed",
    "commands.kick.success",
    "commands.kill.success.multiple",
    "commands.kill.success.single",
    "commands.list.nameAndId",
    "commands.list.players",
    "commands.locate.biome.not_found",
    "commands.locate.biome.success",
    "commands.locate.poi.not_found",
    "commands.locate.poi.success",
    "commands.locate.structure.invalid",
    "commands.locate.structure.not_found",
    "commands.locate.structure.success",
    "commands.message.display.incoming",
    "commands.message.display.outgoing",
    "commands.op.failed",
    "commands.op.success",
    "commands.pardon.failed",
    "commands.pardon.success",
    "commands.pardonip.failed",
    "commands.pardonip.invalid",
    "commands.pardonip.success",
    "commands.particle.failed",
    "commands.particle.success",
    "commands.perf.alreadyRunning",
    "commands.perf.notRunning",
    "commands.perf.reportFailed",
    "commands.perf.reportSaved",
    "commands.perf.started",
    "commands.perf.stopped",
    "commands.place.feature.failed",
    "commands.place.feature.invalid",
    "commands.place.feature.success",
    "commands.place.feature.success.inline",
    "commands.place.jigsaw.failed",
    "commands.place.jigsaw.invalid",
    "commands.place.jigsaw.success",
    "commands.place.structure.failed",
    "commands.place.structure.invalid",
    "commands.place.structure.success",
    "commands.place.template.failed",
    "commands.place.template.invalid",
    "commands.place.template.success",
    "commands.playsound.failed",
    "commands.playsound.success.multiple",
    "commands.playsound.success.single",
    "commands.posteffect.add.failed",
    "commands.posteffect.add.success.multiple",
    "commands.posteffect.add.success.single",
    "commands.posteffect.clear.failed",
    "commands.posteffect.clear.success.multiple",
    "commands.posteffect.clear.success.single",
    "commands.posteffect.list.empty",
    "commands.posteffect.list.success",
    "commands.posteffect.remove.failed",
    "commands.posteffect.remove.success.multiple",
    "commands.posteffect.remove.success.single",
    "commands.profile_fetch.copy_component",
    "commands.profile_fetch.failed_to_serialize",
    "commands.profile_fetch.give_item",
    "commands.profile_fetch.id.failure",
    "commands.profile_fetch.id.success",
    "commands.profile_fetch.name.failure",
    "commands.profile_fetch.name.success",
    "commands.publish.alreadyPublished",
    "commands.publish.alreadyPublished.lan",
    "commands.publish.alreadyPublished.online",
    "commands.publish.failed",
    "commands.publish.started",
    "commands.publish.started.lan",
    "commands.publish.started.online",
    "commands.publish.success",
    "commands.random.error.range_too_large",
    "commands.random.error.range_too_small",
    "commands.random.reset.all.success",
    "commands.random.reset.success",
    "commands.random.roll",
    "commands.random.sample.success",
    "commands.recipe.give.failed",
    "commands.recipe.give.success.multiple",
    "commands.recipe.give.success.single",
    "commands.recipe.take.failed",
    "commands.recipe.take.success.multiple",
    "commands.recipe.take.success.single",
    "commands.reload.failure",
    "commands.reload.success",
    "commands.ride.already_riding",
    "commands.ride.dismount.success",
    "commands.ride.mount.failure.cant_ride_players",
    "commands.ride.mount.failure.generic",
    "commands.ride.mount.failure.loop",
    "commands.ride.mount.failure.wrong_dimension",
    "commands.ride.mount.success",
    "commands.ride.not_riding",
    "commands.rotate.success",
    "commands.save.alreadyOff",
    "commands.save.alreadyOn",
    "commands.save.disabled",
    "commands.save.enabled",
    "commands.save.failed",
    "commands.save.saving",
    "commands.save.success",
    "commands.schedule.cleared.failure",
    "commands.schedule.cleared.success",
    "commands.schedule.created.function",
    "commands.schedule.created.tag",
    "commands.schedule.macro",
    "commands.schedule.same_tick",
    "commands.scoreboard.objectives.add.duplicate",
    "commands.scoreboard.objectives.add.success",
    "commands.scoreboard.objectives.display.alreadyEmpty",
    "commands.scoreboard.objectives.display.alreadySet",
    "commands.scoreboard.objectives.display.cleared",
    "commands.scoreboard.objectives.display.set",
    "commands.scoreboard.objectives.list.empty",
    "commands.scoreboard.objectives.list.success",
    "commands.scoreboard.objectives.modify.displayAutoUpdate.disable",
    "commands.scoreboard.objectives.modify.displayAutoUpdate.enable",
    "commands.scoreboard.objectives.modify.displayname",
    "commands.scoreboard.objectives.modify.objectiveFormat.clear",
    "commands.scoreboard.objectives.modify.objectiveFormat.set",
    "commands.scoreboard.objectives.modify.rendertype",
    "commands.scoreboard.objectives.remove.success",
    "commands.scoreboard.players.add.success.multiple",
    "commands.scoreboard.players.add.success.single",
    "commands.scoreboard.players.display.name.clear.success.multiple",
    "commands.scoreboard.players.display.name.clear.success.single",
    "commands.scoreboard.players.display.name.set.success.multiple",
    "commands.scoreboard.players.display.name.set.success.single",
    "commands.scoreboard.players.display.numberFormat.clear.success.multiple",
    "commands.scoreboard.players.display.numberFormat.clear.success.single",
    "commands.scoreboard.players.display.numberFormat.set.success.multiple",
    "commands.scoreboard.players.display.numberFormat.set.success.single",
    "commands.scoreboard.players.enable.failed",
    "commands.scoreboard.players.enable.invalid",
    "commands.scoreboard.players.enable.success.multiple",
    "commands.scoreboard.players.enable.success.single",
    "commands.scoreboard.players.get.null",
    "commands.scoreboard.players.get.success",
    "commands.scoreboard.players.list.empty",
    "commands.scoreboard.players.list.entity.empty",
    "commands.scoreboard.players.list.entity.entry",
    "commands.scoreboard.players.list.entity.success",
    "commands.scoreboard.players.list.success",
    "commands.scoreboard.players.operation.success.multiple",
    "commands.scoreboard.players.operation.success.single",
    "commands.scoreboard.players.remove.success.multiple",
    "commands.scoreboard.players.remove.success.single",
    "commands.scoreboard.players.reset.all.multiple",
    "commands.scoreboard.players.reset.all.single",
    "commands.scoreboard.players.reset.specific.multiple",
    "commands.scoreboard.players.reset.specific.single",
    "commands.scoreboard.players.set.success.multiple",
    "commands.scoreboard.players.set.success.single",
    "commands.seed.success",
    "commands.setblock.failed",
    "commands.setblock.success",
    "commands.setidletimeout.success",
    "commands.setidletimeout.success.disabled",
    "commands.setworldspawn.failure.not_overworld",
    "commands.setworldspawn.success",
    "commands.setworldspawn.success.new",
    "commands.spawnpoint.success.multiple",
    "commands.spawnpoint.success.multiple.new",
    "commands.spawnpoint.success.single",
    "commands.spawnpoint.success.single.new",
    "commands.spectate.cannot_spectate",
    "commands.spectate.not_spectator",
    "commands.spectate.self",
    "commands.spectate.success.started",
    "commands.spectate.success.stopped",
    "commands.spreadplayers.failed.entities",
    "commands.spreadplayers.failed.invalid.height",
    "commands.spreadplayers.failed.teams",
    "commands.spreadplayers.success.entities",
    "commands.spreadplayers.success.teams",
    "commands.stop.stopping",
    "commands.stopsound.success.source.any",
    "commands.stopsound.success.source.sound",
    "commands.stopsound.success.sourceless.any",
    "commands.stopsound.success.sourceless.sound",
    "commands.stopwatch.already_exists",
    "commands.stopwatch.create.success",
    "commands.stopwatch.does_not_exist",
    "commands.stopwatch.query",
    "commands.stopwatch.remove.success",
    "commands.stopwatch.restart.success",
    "commands.summon.failed",
    "commands.summon.failed.peaceful",
    "commands.summon.failed.uuid",
    "commands.summon.invalidPosition",
    "commands.summon.success",
    "commands.swing.failed.notliving",
    "commands.swing.success.multiple",
    "commands.swing.success.single",
    "commands.tag.add.failed",
    "commands.tag.add.success.multiple",
    "commands.tag.add.success.single",
    "commands.tag.list.multiple.empty",
    "commands.tag.list.multiple.success",
    "commands.tag.list.single.empty",
    "commands.tag.list.single.success",
    "commands.tag.remove.failed",
    "commands.tag.remove.success.multiple",
    "commands.tag.remove.success.single",
    "commands.team.add.duplicate",
    "commands.team.add.success",
    "commands.team.empty.success",
    "commands.team.empty.unchanged",
    "commands.team.join.success.multiple",
    "commands.team.join.success.single",
    "commands.team.leave.success.multiple",
    "commands.team.leave.success.single",
    "commands.team.list.members.empty",
    "commands.team.list.members.success",
    "commands.team.list.teams.empty",
    "commands.team.list.teams.success",
    "commands.team.option.collisionRule.success",
    "commands.team.option.collisionRule.unchanged",
    "commands.team.option.color.clear.success",
    "commands.team.option.color.success",
    "commands.team.option.color.unchanged",
    "commands.team.option.deathMessageVisibility.success",
    "commands.team.option.deathMessageVisibility.unchanged",
    "commands.team.option.friendlyfire.alreadyDisabled",
    "commands.team.option.friendlyfire.alreadyEnabled",
    "commands.team.option.friendlyfire.disabled",
    "commands.team.option.friendlyfire.enabled",
    "commands.team.option.name.success",
    "commands.team.option.name.unchanged",
    "commands.team.option.nametagVisibility.success",
    "commands.team.option.nametagVisibility.unchanged",
    "commands.team.option.prefix.success",
    "commands.team.option.seeFriendlyInvisibles.alreadyDisabled",
    "commands.team.option.seeFriendlyInvisibles.alreadyEnabled",
    "commands.team.option.seeFriendlyInvisibles.disabled",
    "commands.team.option.seeFriendlyInvisibles.enabled",
    "commands.team.option.suffix.success",
    "commands.team.remove.success",
    "commands.teammsg.failed.noteam",
    "commands.teleport.invalidPosition",
    "commands.teleport.success.entity.multiple",
    "commands.teleport.success.entity.single",
    "commands.teleport.success.location.multiple",
    "commands.teleport.success.location.single",
    "commands.test.batch.starting",
    "commands.test.clear.error.no_tests",
    "commands.test.clear.success",
    "commands.test.coordinates",
    "commands.test.coordinates.copy",
    "commands.test.create.success",
    "commands.test.error.no_test_containing_pos",
    "commands.test.error.no_test_instances",
    "commands.test.error.non_existant_test",
    "commands.test.error.structure_not_found",
    "commands.test.error.test_instance_not_found",
    "commands.test.error.test_instance_not_found.position",
    "commands.test.error.too_large",
    "commands.test.locate.done",
    "commands.test.locate.found",
    "commands.test.locate.started",
    "commands.test.no_tests",
    "commands.test.relative_position",
    "commands.test.reset.error.no_tests",
    "commands.test.reset.success",
    "commands.test.run.no_tests",
    "commands.test.run.running",
    "commands.test.summary",
    "commands.test.summary.all_required_passed",
    "commands.test.summary.failed",
    "commands.test.summary.optional_failed",
    "commands.tick.query.percentiles",
    "commands.tick.query.rate.running",
    "commands.tick.query.rate.sprinting",
    "commands.tick.rate.success",
    "commands.tick.sprint.report",
    "commands.tick.sprint.stop.fail",
    "commands.tick.sprint.stop.success",
    "commands.tick.status.frozen",
    "commands.tick.status.lagging",
    "commands.tick.status.running",
    "commands.tick.status.sprinting",
    "commands.tick.step.fail",
    "commands.tick.step.stop.fail",
    "commands.tick.step.stop.success",
    "commands.tick.step.success",
    "commands.time.no_default_clock",
    "commands.time.no_time_marker_found",
    "commands.time.pause",
    "commands.time.pause.already_paused",
    "commands.time.pause.already_running",
    "commands.time.query",
    "commands.time.query.absolute",
    "commands.time.query.gametime",
    "commands.time.query.timeline",
    "commands.time.query.timeline.repetitions",
    "commands.time.rate",
    "commands.time.rate.already_same",
    "commands.time.resume",
    "commands.time.set",
    "commands.time.set.absolute",
    "commands.time.set.already_at_time",
    "commands.time.set.already_at_time_marker",
    "commands.time.set.time_marker",
    "commands.time.wrong_timeline_for_clock",
    "commands.title.cleared.multiple",
    "commands.title.cleared.single",
    "commands.title.reset.multiple",
    "commands.title.reset.single",
    "commands.title.show.actionbar.multiple",
    "commands.title.show.actionbar.single",
    "commands.title.show.subtitle.multiple",
    "commands.title.show.subtitle.single",
    "commands.title.show.title.multiple",
    "commands.title.show.title.single",
    "commands.title.times.multiple",
    "commands.title.times.single",
    "commands.transfer.error.no_players",
    "commands.transfer.success.multiple",
    "commands.transfer.success.single",
    "commands.trigger.add.success",
    "commands.trigger.failed.invalid",
    "commands.trigger.failed.unprimed",
    "commands.trigger.set.success",
    "commands.trigger.simple.success",
    "commands.unpublish.notPublished",
    "commands.unpublish.success",
    "commands.version.build_time",
    "commands.version.data",
    "commands.version.header",
    "commands.version.id",
    "commands.version.name",
    "commands.version.pack.data",
    "commands.version.pack.resource",
    "commands.version.protocol",
    "commands.version.series",
    "commands.version.stable.no",
    "commands.version.stable.yes",
    "commands.waypoint.list.empty",
    "commands.waypoint.list.success",
    "commands.waypoint.modify.color",
    "commands.waypoint.modify.color.reset",
    "commands.waypoint.modify.style",
    "commands.weather.set.clear",
    "commands.weather.set.rain",
    "commands.weather.set.thunder",
    "commands.whitelist.add.failed",
    "commands.whitelist.add.success",
    "commands.whitelist.alreadyOff",
    "commands.whitelist.alreadyOn",
    "commands.whitelist.disabled",
    "commands.whitelist.enabled",
    "commands.whitelist.list",
    "commands.whitelist.none",
    "commands.whitelist.reloaded",
    "commands.whitelist.remove.failed",
    "commands.whitelist.remove.success",
    "commands.worldborder.center.failed",
    "commands.worldborder.center.success",
    "commands.worldborder.damage.amount.failed",
    "commands.worldborder.damage.amount.success",
    "commands.worldborder.damage.buffer.failed",
    "commands.worldborder.damage.buffer.success",
    "commands.worldborder.get",
    "commands.worldborder.set.failed.big",
    "commands.worldborder.set.failed.far",
    "commands.worldborder.set.failed.nochange",
    "commands.worldborder.set.failed.small",
    "commands.worldborder.set.grow",
    "commands.worldborder.set.immediate",
    "commands.worldborder.set.shrink",
    "commands.worldborder.warning.distance.failed",
    "commands.worldborder.warning.distance.success",
    "commands.worldborder.warning.time.failed",
    "commands.worldborder.warning.time.success",
    "compliance.playtime.greaterThan24Hours",
    "compliance.playtime.hours",
    "compliance.playtime.message",
    "component.profile.dynamic",
    "connect.aborted",
    "connect.authorizing",
    "connect.connecting",
    "connect.encrypting",
    "connect.failed",
    "connect.failed.transfer",
    "connect.joining",
    "connect.negotiating",
    "connect.p2p.establishing",
    "connect.p2p.failed.generic",
    "connect.p2p.failed.signaling",
    "connect.p2p.failed.timeout",
    "connect.p2p.failed.unreachable",
    "connect.reconfiging",
    "connect.reconfiguring",
    "connect.transferring",
    "container.barrel",
    "container.beacon",
    "container.beehive.bees",
    "container.beehive.honey",
    "container.blast_furnace",
    "container.brewing",
    "container.cartography_table",
    "container.chest",
    "container.chestDouble",
    "container.crafter",
    "container.crafting",
    "container.creative",
    "container.dispenser",
    "container.dropper",
    "container.enchant",
    "container.enchant.clue",
    "container.enchant.lapis.many",
    "container.enchant.lapis.one",
    "container.enchant.level.many",
    "container.enchant.level.one",
    "container.enchant.level.requirement",
    "container.enderchest",
    "container.furnace",
    "container.grindstone_title",
    "container.hopper",
    "container.inventory",
    "container.isLocked",
    "container.lectern",
    "container.loom",
    "container.repair",
    "container.repair.cost",
    "container.repair.expensive",
    "container.shulkerBox",
    "container.shulkerBox.itemCount",
    "container.shulkerBox.more",
    "container.shulkerBox.unknownContents",
    "container.smoker",
    "container.spectatorCantOpen",
    "container.stonecutter",
    "container.upgrade",
    "container.upgrade.error_tooltip",
    "container.upgrade.missing_template_tooltip",
    "controls.keybinds",
    "controls.keybinds.duplicateKeybinds",
    "controls.keybinds.title",
    "controls.reset",
    "controls.resetAll",
    "controls.title",
    "createWorld.customize.buffet.biome",
    "createWorld.customize.buffet.search",
    "createWorld.customize.buffet.title",
    "createWorld.customize.flat.height",
    "createWorld.customize.flat.layer",
    "createWorld.customize.flat.layer.bottom",
    "createWorld.customize.flat.layer.top",
    "createWorld.customize.flat.removeLayer",
    "createWorld.customize.flat.tile",
    "createWorld.customize.flat.title",
    "createWorld.customize.presets",
    "createWorld.customize.presets.list",
    "createWorld.customize.presets.select",
    "createWorld.customize.presets.share",
    "createWorld.customize.presets.title",
    "createWorld.preparing",
    "createWorld.tab.game.title",
    "createWorld.tab.more.title",
    "createWorld.tab.world.title",
    "credits_and_attribution.button.attribution",
    "credits_and_attribution.button.credits",
    "credits_and_attribution.button.licenses",
    "credits_and_attribution.screen.title",
    "dataPack.bundle.description",
    "dataPack.bundle.name",
    "dataPack.locator_bar.description",
    "dataPack.locator_bar.name",
    "dataPack.minecart_improvements.description",
    "dataPack.minecart_improvements.name",
    "dataPack.redstone_experiments.description",
    "dataPack.redstone_experiments.name",
    "dataPack.title",
    "dataPack.trade_rebalance.description",
    "dataPack.trade_rebalance.name",
    "dataPack.update_1_20.description",
    "dataPack.update_1_20.name",
    "dataPack.update_1_21.description",
    "dataPack.update_1_21.name",
    "dataPack.validation.back",
    "dataPack.validation.failed",
    "dataPack.validation.reset",
    "dataPack.validation.working",
    "dataPack.vanilla.description",
    "dataPack.vanilla.name",
    "dataPack.winter_drop.description",
    "dataPack.winter_drop.name",
    "datapackFailure.safeMode",
    "datapackFailure.safeMode.failed.description",
    "datapackFailure.safeMode.failed.title",
    "datapackFailure.title",
    "death.attack.anvil",
    "death.attack.anvil.player",
    "death.attack.arrow",
    "death.attack.arrow.item",
    "death.attack.badRespawnPoint.link",
    "death.attack.badRespawnPoint.message",
    "death.attack.cactus",
    "death.attack.cactus.player",
    "death.attack.cramming",
    "death.attack.cramming.player",
    "death.attack.dragonBreath",
    "death.attack.dragonBreath.player",
    "death.attack.drown",
    "death.attack.drown.player",
    "death.attack.dryout",
    "death.attack.dryout.player",
    "death.attack.even_more_magic",
    "death.attack.explosion",
    "death.attack.explosion.player",
    "death.attack.explosion.player.item",
    "death.attack.fall",
    "death.attack.fall.player",
    "death.attack.fallingBlock",
    "death.attack.fallingBlock.player",
    "death.attack.fallingStalactite",
    "death.attack.fallingStalactite.player",
    "death.attack.fireball",
    "death.attack.fireball.item",
    "death.attack.fireworks",
    "death.attack.fireworks.item",
    "death.attack.fireworks.player",
    "death.attack.flyIntoWall",
    "death.attack.flyIntoWall.player",
    "death.attack.freeze",
    "death.attack.freeze.player",
    "death.attack.generic",
    "death.attack.generic.player",
    "death.attack.genericKill",
    "death.attack.genericKill.player",
    "death.attack.hotFloor",
    "death.attack.hotFloor.player",
    "death.attack.indirectMagic",
    "death.attack.indirectMagic.item",
    "death.attack.inFire",
    "death.attack.inFire.player",
    "death.attack.inWall",
    "death.attack.inWall.player",
    "death.attack.lava",
    "death.attack.lava.player",
    "death.attack.lightningBolt",
    "death.attack.lightningBolt.player",
    "death.attack.mace_smash",
    "death.attack.mace_smash.item",
    "death.attack.magic",
    "death.attack.magic.player",
    "death.attack.message_too_long",
    "death.attack.mob",
    "death.attack.mob.item",
    "death.attack.onFire",
    "death.attack.onFire.item",
    "death.attack.onFire.player",
    "death.attack.outOfWorld",
    "death.attack.outOfWorld.player",
    "death.attack.outsideBorder",
    "death.attack.outsideBorder.player",
    "death.attack.player",
    "death.attack.player.item",
    "death.attack.sonic_boom",
    "death.attack.sonic_boom.item",
    "death.attack.sonic_boom.player",
    "death.attack.spear",
    "death.attack.spear.item",
    "death.attack.stalagmite",
    "death.attack.stalagmite.player",
    "death.attack.starve",
    "death.attack.starve.player",
    "death.attack.sting",
    "death.attack.sting.item",
    "death.attack.sting.player",
    "death.attack.sulfurCubeHot",
    "death.attack.sulfurCubeHot.item",
    "death.attack.sulfurCubeHot.player",
    "death.attack.sweetBerryBush",
    "death.attack.sweetBerryBush.player",
    "death.attack.thorns",
    "death.attack.thorns.item",
    "death.attack.thrown",
    "death.attack.thrown.item",
    "death.attack.trident",
    "death.attack.trident.item",
    "death.attack.wither",
    "death.attack.wither.player",
    "death.attack.witherSkull",
    "death.attack.witherSkull.item",
    "death.fell.accident.generic",
    "death.fell.accident.ladder",
    "death.fell.accident.other_climbable",
    "death.fell.accident.scaffolding",
    "death.fell.accident.twisting_vines",
    "death.fell.accident.vines",
    "death.fell.accident.weeping_vines",
    "death.fell.assist",
    "death.fell.assist.item",
    "death.fell.finish",
    "death.fell.finish.item",
    "death.fell.killer",
    "deathScreen.quit.confirm",
    "deathScreen.respawn",
    "deathScreen.score",
    "deathScreen.score.value",
    "deathScreen.spectate",
    "deathScreen.title",
    "deathScreen.title.hardcore",
    "deathScreen.titleScreen",
    "debug.advanced_tooltips.help",
    "debug.advanced_tooltips.off",
    "debug.advanced_tooltips.on",
    "debug.chunk_boundaries.help",
    "debug.chunk_boundaries.off",
    "debug.chunk_boundaries.on",
    "debug.clear_chat.help",
    "debug.copy_location.help",
    "debug.copy_location.message",
    "debug.crash.message",
    "debug.crash.message.rebindable",
    "debug.crash.warning",
    "debug.creative_spectator.error",
    "debug.creative_spectator.help",
    "debug.dump_dynamic_textures",
    "debug.dump_dynamic_textures.help",
    "debug.entry.always",
    "debug.entry.currently.alwaysOn",
    "debug.entry.currently.inF3",
    "debug.entry.currently.inOverlay",
    "debug.entry.currently.never",
    "debug.entry.f3",
    "debug.entry.overlay",
    "debug.gamemodes.error",
    "debug.gamemodes.help",
    "debug.gamemodes.press_f4",
    "debug.gamemodes.select_next",
    "debug.help.help",
    "debug.help.message",
    "debug.improvedTransparency.off",
    "debug.improvedTransparency.on",
    "debug.inspect.client.block",
    "debug.inspect.client.entity",
    "debug.inspect.help",
    "debug.inspect.server.block",
    "debug.inspect.server.entity",
    "debug.options.category.renderer",
    "debug.options.category.text",
    "debug.options.help",
    "debug.options.notAllowed.tooltip",
    "debug.options.profile.default",
    "debug.options.profile.performance",
    "debug.options.search",
    "debug.options.title",
    "debug.options.warning",
    "debug.pause_focus.help",
    "debug.pause_focus.off",
    "debug.pause_focus.on",
    "debug.pause.help",
    "debug.prefix",
    "debug.profiling.help",
    "debug.profiling.start",
    "debug.profiling.start.rebindable",
    "debug.profiling.stop",
    "debug.reload_chunks.help",
    "debug.reload_chunks.message",
    "debug.reload_resourcepacks.help",
    "debug.reload_resourcepacks.message",
    "debug.show_hitboxes.help",
    "debug.show_hitboxes.off",
    "debug.show_hitboxes.on",
    "debug.version.header",
    "debug.version.help",
    "demo.day.1",
    "demo.day.2",
    "demo.day.3",
    "demo.day.4",
    "demo.day.5",
    "demo.day.6",
    "demo.day.warning",
    "demo.demoExpired",
    "demo.help.buy",
    "demo.help.fullWrapped",
    "demo.help.inventory",
    "demo.help.jump",
    "demo.help.later",
    "demo.help.movement",
    "demo.help.movementMouse",
    "demo.help.movementShort",
    "demo.help.title",
    "demo.remainingTime",
    "demo.reminder",
    "difficulty.lock.question",
    "difficulty.lock.title",
    "disconnect.endOfStream",
    "disconnect.exceeded_packet_rate",
    "disconnect.genericReason",
    "disconnect.ignoring_status_request",
    "disconnect.loginFailedInfo",
    "disconnect.loginFailedInfo.insufficientPrivileges",
    "disconnect.loginFailedInfo.invalidSession",
    "disconnect.loginFailedInfo.serversUnavailable",
    "disconnect.loginFailedInfo.userBanned",
    "disconnect.lost",
    "disconnect.packetError",
    "disconnect.spam",
    "disconnect.timeout",
    "disconnect.transfer",
    "disconnect.unknownHost",
    "download.pack.failed",
    "download.pack.progress.bytes",
    "download.pack.progress.percent",
    "download.pack.title",
    "editGamerule.default",
    "editGamerule.inGame.button",
    "editGamerule.inGame.disabled.hardcore.tooltip",
    "editGamerule.inGame.disabled.tooltip",
    "editGamerule.inGame.discardChanges.message",
    "editGamerule.inGame.discardChanges.title",
    "editGamerule.inGame.downloadingGamerules",
    "editGamerule.title",
    "effect.duration.infinite",
    "effect.minecraft.absorption",
    "effect.minecraft.bad_omen",
    "effect.minecraft.blindness",
    "effect.minecraft.breath_of_the_nautilus",
    "effect.minecraft.conduit_power",
    "effect.minecraft.darkness",
    "effect.minecraft.dolphins_grace",
    "effect.minecraft.fire_resistance",
    "effect.minecraft.glowing",
    "effect.minecraft.haste",
    "effect.minecraft.health_boost",
    "effect.minecraft.hero_of_the_village",
    "effect.minecraft.hunger",
    "effect.minecraft.infested",
    "effect.minecraft.instant_damage",
    "effect.minecraft.instant_health",
    "effect.minecraft.invisibility",
    "effect.minecraft.jump_boost",
    "effect.minecraft.levitation",
    "effect.minecraft.luck",
    "effect.minecraft.mining_fatigue",
    "effect.minecraft.nausea",
    "effect.minecraft.night_vision",
    "effect.minecraft.oozing",
    "effect.minecraft.poison",
    "effect.minecraft.raid_omen",
    "effect.minecraft.regeneration",
    "effect.minecraft.resistance",
    "effect.minecraft.saturation",
    "effect.minecraft.slow_falling",
    "effect.minecraft.slowness",
    "effect.minecraft.speed",
    "effect.minecraft.strength",
    "effect.minecraft.trial_omen",
    "effect.minecraft.unluck",
    "effect.minecraft.water_breathing",
    "effect.minecraft.weakness",
    "effect.minecraft.weaving",
    "effect.minecraft.wind_charged",
    "effect.minecraft.wither",
    "effect.none",
    "enchantment.level.1",
    "enchantment.level.2",
    "enchantment.level.3",
    "enchantment.level.4",
    "enchantment.level.5",
    "enchantment.level.6",
    "enchantment.level.7",
    "enchantment.level.8",
    "enchantment.level.9",
    "enchantment.level.10",
    "enchantment.minecraft.aqua_affinity",
    "enchantment.minecraft.bane_of_arthropods",
    "enchantment.minecraft.binding_curse",
    "enchantment.minecraft.blast_protection",
    "enchantment.minecraft.breach",
    "enchantment.minecraft.channeling",
    "enchantment.minecraft.density",
    "enchantment.minecraft.depth_strider",
    "enchantment.minecraft.efficiency",
    "enchantment.minecraft.feather_falling",
    "enchantment.minecraft.fire_aspect",
    "enchantment.minecraft.fire_protection",
    "enchantment.minecraft.flame",
    "enchantment.minecraft.fortune",
    "enchantment.minecraft.frost_walker",
    "enchantment.minecraft.impaling",
    "enchantment.minecraft.infinity",
    "enchantment.minecraft.knockback",
    "enchantment.minecraft.looting",
    "enchantment.minecraft.loyalty",
    "enchantment.minecraft.luck_of_the_sea",
    "enchantment.minecraft.lunge",
    "enchantment.minecraft.lure",
    "enchantment.minecraft.mending",
    "enchantment.minecraft.multishot",
    "enchantment.minecraft.piercing",
    "enchantment.minecraft.power",
    "enchantment.minecraft.projectile_protection",
    "enchantment.minecraft.protection",
    "enchantment.minecraft.punch",
    "enchantment.minecraft.quick_charge",
    "enchantment.minecraft.respiration",
    "enchantment.minecraft.riptide",
    "enchantment.minecraft.sharpness",
    "enchantment.minecraft.silk_touch",
    "enchantment.minecraft.smite",
    "enchantment.minecraft.soul_speed",
    "enchantment.minecraft.sweeping",
    "enchantment.minecraft.sweeping_edge",
    "enchantment.minecraft.swift_sneak",
    "enchantment.minecraft.thorns",
    "enchantment.minecraft.unbreaking",
    "enchantment.minecraft.vanishing_curse",
    "enchantment.minecraft.wind_burst",
    "entity.minecraft.acacia_boat",
    "entity.minecraft.acacia_chest_boat",
    "entity.minecraft.allay",
    "entity.minecraft.area_effect_cloud",
    "entity.minecraft.armadillo",
    "entity.minecraft.armor_stand",
    "entity.minecraft.arrow",
    "entity.minecraft.axolotl",
    "entity.minecraft.bamboo_chest_raft",
    "entity.minecraft.bamboo_raft",
    "entity.minecraft.bat",
    "entity.minecraft.bee",
    "entity.minecraft.birch_boat",
    "entity.minecraft.birch_chest_boat",
    "entity.minecraft.blaze",
    "entity.minecraft.block_display",
    "entity.minecraft.boat",
    "entity.minecraft.bogged",
    "entity.minecraft.breeze",
    "entity.minecraft.breeze_wind_charge",
    "entity.minecraft.camel",
    "entity.minecraft.camel_husk",
    "entity.minecraft.cat",
    "entity.minecraft.cave_spider",
    "entity.minecraft.cherry_boat",
    "entity.minecraft.cherry_chest_boat",
    "entity.minecraft.chest_boat",
    "entity.minecraft.chest_minecart",
    "entity.minecraft.chicken",
    "entity.minecraft.cod",
    "entity.minecraft.command_block_minecart",
    "entity.minecraft.copper_golem",
    "entity.minecraft.cow",
    "entity.minecraft.creaking",
    "entity.minecraft.creaking_transient",
    "entity.minecraft.creeper",
    "entity.minecraft.cushion",
    "entity.minecraft.dark_oak_boat",
    "entity.minecraft.dark_oak_chest_boat",
    "entity.minecraft.dolphin",
    "entity.minecraft.donkey",
    "entity.minecraft.dragon_fireball",
    "entity.minecraft.drowned",
    "entity.minecraft.egg",
    "entity.minecraft.elder_guardian",
    "entity.minecraft.end_crystal",
    "entity.minecraft.ender_dragon",
    "entity.minecraft.ender_pearl",
    "entity.minecraft.enderman",
    "entity.minecraft.endermite",
    "entity.minecraft.evoker",
    "entity.minecraft.evoker_fangs",
    "entity.minecraft.experience_bottle",
    "entity.minecraft.experience_orb",
    "entity.minecraft.eye_of_ender",
    "entity.minecraft.falling_block",
    "entity.minecraft.falling_block_type",
    "entity.minecraft.fireball",
    "entity.minecraft.firework_rocket",
    "entity.minecraft.fishing_bobber",
    "entity.minecraft.fox",
    "entity.minecraft.frog",
    "entity.minecraft.furnace_minecart",
    "entity.minecraft.ghast",
    "entity.minecraft.giant",
    "entity.minecraft.glow_item_frame",
    "entity.minecraft.glow_squid",
    "entity.minecraft.goat",
    "entity.minecraft.guardian",
    "entity.minecraft.happy_ghast",
    "entity.minecraft.hoglin",
    "entity.minecraft.hopper_minecart",
    "entity.minecraft.horse",
    "entity.minecraft.husk",
    "entity.minecraft.illusioner",
    "entity.minecraft.interaction",
    "entity.minecraft.iron_golem",
    "entity.minecraft.item",
    "entity.minecraft.item_display",
    "entity.minecraft.item_frame",
    "entity.minecraft.jungle_boat",
    "entity.minecraft.jungle_chest_boat",
    "entity.minecraft.killer_bunny",
    "entity.minecraft.leash_knot",
    "entity.minecraft.lightning_bolt",
    "entity.minecraft.lingering_potion",
    "entity.minecraft.llama",
    "entity.minecraft.llama_spit",
    "entity.minecraft.magma_cube",
    "entity.minecraft.mangrove_boat",
    "entity.minecraft.mangrove_chest_boat",
    "entity.minecraft.mannequin",
    "entity.minecraft.mannequin.label",
    "entity.minecraft.marker",
    "entity.minecraft.minecart",
    "entity.minecraft.mooshroom",
    "entity.minecraft.mule",
    "entity.minecraft.nautilus",
    "entity.minecraft.oak_boat",
    "entity.minecraft.oak_chest_boat",
    "entity.minecraft.ocelot",
    "entity.minecraft.ominous_item_spawner",
    "entity.minecraft.painting",
    "entity.minecraft.pale_oak_boat",
    "entity.minecraft.pale_oak_chest_boat",
    "entity.minecraft.panda",
    "entity.minecraft.parched",
    "entity.minecraft.parrot",
    "entity.minecraft.phantom",
    "entity.minecraft.pig",
    "entity.minecraft.piglin",
    "entity.minecraft.piglin_brute",
    "entity.minecraft.pillager",
    "entity.minecraft.player",
    "entity.minecraft.polar_bear",
    "entity.minecraft.poplar_boat",
    "entity.minecraft.poplar_chest_boat",
    "entity.minecraft.potion",
    "entity.minecraft.pufferfish",
    "entity.minecraft.rabbit",
    "entity.minecraft.ravager",
    "entity.minecraft.salmon",
    "entity.minecraft.sheep",
    "entity.minecraft.shulker",
    "entity.minecraft.shulker_bullet",
    "entity.minecraft.silverfish",
    "entity.minecraft.skeleton",
    "entity.minecraft.skeleton_horse",
    "entity.minecraft.slime",
    "entity.minecraft.small_fireball",
    "entity.minecraft.sniffer",
    "entity.minecraft.snow_golem",
    "entity.minecraft.snowball",
    "entity.minecraft.spawner_minecart",
    "entity.minecraft.spectral_arrow",
    "entity.minecraft.spider",
    "entity.minecraft.splash_potion",
    "entity.minecraft.spruce_boat",
    "entity.minecraft.spruce_chest_boat",
    "entity.minecraft.squid",
    "entity.minecraft.stray",
    "entity.minecraft.strider",
    "entity.minecraft.sulfur_cube",
    "entity.minecraft.sulfur_cube.content",
    "entity.minecraft.tadpole",
    "entity.minecraft.text_display",
    "entity.minecraft.tnt",
    "entity.minecraft.tnt_minecart",
    "entity.minecraft.trader_llama",
    "entity.minecraft.trident",
    "entity.minecraft.tropical_fish",
    "entity.minecraft.tropical_fish.predefined.0",
    "entity.minecraft.tropical_fish.predefined.1",
    "entity.minecraft.tropical_fish.predefined.2",
    "entity.minecraft.tropical_fish.predefined.3",
    "entity.minecraft.tropical_fish.predefined.4",
    "entity.minecraft.tropical_fish.predefined.5",
    "entity.minecraft.tropical_fish.predefined.6",
    "entity.minecraft.tropical_fish.predefined.7",
    "entity.minecraft.tropical_fish.predefined.8",
    "entity.minecraft.tropical_fish.predefined.9",
    "entity.minecraft.tropical_fish.predefined.10",
    "entity.minecraft.tropical_fish.predefined.11",
    "entity.minecraft.tropical_fish.predefined.12",
    "entity.minecraft.tropical_fish.predefined.13",
    "entity.minecraft.tropical_fish.predefined.14",
    "entity.minecraft.tropical_fish.predefined.15",
    "entity.minecraft.tropical_fish.predefined.16",
    "entity.minecraft.tropical_fish.predefined.17",
    "entity.minecraft.tropical_fish.predefined.18",
    "entity.minecraft.tropical_fish.predefined.19",
    "entity.minecraft.tropical_fish.predefined.20",
    "entity.minecraft.tropical_fish.predefined.21",
    "entity.minecraft.tropical_fish.type.betty",
    "entity.minecraft.tropical_fish.type.blockfish",
    "entity.minecraft.tropical_fish.type.brinely",
    "entity.minecraft.tropical_fish.type.clayfish",
    "entity.minecraft.tropical_fish.type.dasher",
    "entity.minecraft.tropical_fish.type.flopper",
    "entity.minecraft.tropical_fish.type.glitter",
    "entity.minecraft.tropical_fish.type.kob",
    "entity.minecraft.tropical_fish.type.snooper",
    "entity.minecraft.tropical_fish.type.spotty",
    "entity.minecraft.tropical_fish.type.stripey",
    "entity.minecraft.tropical_fish.type.sunstreak",
    "entity.minecraft.turtle",
    "entity.minecraft.vex",
    "entity.minecraft.villager",
    "entity.minecraft.villager.armorer",
    "entity.minecraft.villager.butcher",
    "entity.minecraft.villager.cartographer",
    "entity.minecraft.villager.cleric",
    "entity.minecraft.villager.farmer",
    "entity.minecraft.villager.fisherman",
    "entity.minecraft.villager.fletcher",
    "entity.minecraft.villager.leatherworker",
    "entity.minecraft.villager.librarian",
    "entity.minecraft.villager.mason",
    "entity.minecraft.villager.nitwit",
    "entity.minecraft.villager.none",
    "entity.minecraft.villager.shepherd",
    "entity.minecraft.villager.toolsmith",
    "entity.minecraft.villager.weaponsmith",
    "entity.minecraft.vindicator",
    "entity.minecraft.wandering_trader",
    "entity.minecraft.warden",
    "entity.minecraft.wind_charge",
    "entity.minecraft.witch",
    "entity.minecraft.wither",
    "entity.minecraft.wither_skeleton",
    "entity.minecraft.wither_skull",
    "entity.minecraft.wolf",
    "entity.minecraft.zoglin",
    "entity.minecraft.zombie",
    "entity.minecraft.zombie_horse",
    "entity.minecraft.zombie_nautilus",
    "entity.minecraft.zombie_villager",
    "entity.minecraft.zombified_piglin",
    "entity.not_summonable",
    "event.minecraft.raid",
    "event.minecraft.raid.defeat",
    "event.minecraft.raid.defeat.full",
    "event.minecraft.raid.raiders_remaining",
    "event.minecraft.raid.victory",
    "event.minecraft.raid.victory.full",
    "filled_map.bamboo_jungle_abandoned_camp",
    "filled_map.birch_forest_abandoned_camp",
    "filled_map.buried_treasure",
    "filled_map.cherry_grove_abandoned_camp",
    "filled_map.dappled_forest_abandoned_camp",
    "filled_map.explorer_jungle",
    "filled_map.explorer_swamp",
    "filled_map.flower_forest_abandoned_camp",
    "filled_map.id",
    "filled_map.jungle_temple",
    "filled_map.level",
    "filled_map.locked",
    "filled_map.mansion",
    "filled_map.monument",
    "filled_map.pale_garden_abandoned_camp",
    "filled_map.scale",
    "filled_map.swamp_abandoned_camp",
    "filled_map.trial_chambers",
    "filled_map.unknown",
    "filled_map.village_desert",
    "filled_map.village_plains",
    "filled_map.village_savanna",
    "filled_map.village_snowy",
    "filled_map.village_taiga",
    "filled_map.windswept_forest_abandoned_camp",
    "flat_world_preset.minecraft.bottomless_pit",
    "flat_world_preset.minecraft.classic_flat",
    "flat_world_preset.minecraft.desert",
    "flat_world_preset.minecraft.overworld",
    "flat_world_preset.minecraft.redstone_ready",
    "flat_world_preset.minecraft.snowy_kingdom",
    "flat_world_preset.minecraft.the_void",
    "flat_world_preset.minecraft.tunnelers_dream",
    "flat_world_preset.minecraft.water_world",
    "flat_world_preset.unknown",
    "gameMode.adventure",
    "gameMode.changed",
    "gameMode.creative",
    "gameMode.hardcore",
    "gameMode.spectator",
    "gameMode.survival",
    "gamerule.allowEnteringNetherUsingPortals",
    "gamerule.allowEnteringNetherUsingPortals.description",
    "gamerule.allowFireTicksAwayFromPlayer",
    "gamerule.allowFireTicksAwayFromPlayer.description",
    "gamerule.announceAdvancements",
    "gamerule.blockExplosionDropDecay",
    "gamerule.blockExplosionDropDecay.description",
    "gamerule.category.chat",
    "gamerule.category.drops",
    "gamerule.category.misc",
    "gamerule.category.mobs",
    "gamerule.category.player",
    "gamerule.category.spawning",
    "gamerule.category.updates",
    "gamerule.commandBlockOutput",
    "gamerule.commandBlocksEnabled",
    "gamerule.commandModificationBlockLimit",
    "gamerule.commandModificationBlockLimit.description",
    "gamerule.disableElytraMovementCheck",
    "gamerule.disablePlayerMovementCheck",
    "gamerule.disableRaids",
    "gamerule.doDaylightCycle",
    "gamerule.doEntityDrops",
    "gamerule.doEntityDrops.description",
    "gamerule.doFireTick",
    "gamerule.doImmediateRespawn",
    "gamerule.doInsomnia",
    "gamerule.doLimitedCrafting",
    "gamerule.doLimitedCrafting.description",
    "gamerule.doMobLoot",
    "gamerule.doMobLoot.description",
    "gamerule.doMobSpawning",
    "gamerule.doMobSpawning.description",
    "gamerule.doPatrolSpawning",
    "gamerule.doTileDrops",
    "gamerule.doTileDrops.description",
    "gamerule.doTraderSpawning",
    "gamerule.doVinesSpread",
    "gamerule.doVinesSpread.description",
    "gamerule.doWardenSpawning",
    "gamerule.doWeatherCycle",
    "gamerule.drowningDamage",
    "gamerule.enableCommandBlocks",
    "gamerule.enderPearlsVanishOnDeath",
    "gamerule.enderPearlsVanishOnDeath.description",
    "gamerule.entitiesWithPassengersCanUsePortals",
    "gamerule.entitiesWithPassengersCanUsePortals.description",
    "gamerule.fallDamage",
    "gamerule.fireDamage",
    "gamerule.forgiveDeadPlayers",
    "gamerule.forgiveDeadPlayers.description",
    "gamerule.freezeDamage",
    "gamerule.globalSoundEvents",
    "gamerule.globalSoundEvents.description",
    "gamerule.keepInventory",
    "gamerule.lavaSourceConversion",
    "gamerule.lavaSourceConversion.description",
    "gamerule.locatorBar",
    "gamerule.locatorBar.description",
    "gamerule.logAdminCommands",
    "gamerule.maxCommandChainLength",
    "gamerule.maxCommandChainLength.description",
    "gamerule.maxCommandForkCount",
    "gamerule.maxCommandForkCount.description",
    "gamerule.maxEntityCramming",
    "gamerule.minecartMaxSpeed",
    "gamerule.minecartMaxSpeed.description",
    "gamerule.minecraft.elytra_movement_check",
    "gamerule.minecraft.fire_spread_radius_around_player",
    "gamerule.minecraft.fire_spread_radius_around_player.description",
    "gamerule.minecraft.player_movement_check",
    "gamerule.minecraft.raids",
    "gamerule.minecraft.universal_anger.description",
    "gamerule.mobExplosionDropDecay",
    "gamerule.mobExplosionDropDecay.description",
    "gamerule.mobGriefing",
    "gamerule.naturalRegeneration",
    "gamerule.playersNetherPortalCreativeDelay",
    "gamerule.playersNetherPortalCreativeDelay.description",
    "gamerule.playersNetherPortalDefaultDelay",
    "gamerule.playersNetherPortalDefaultDelay.description",
    "gamerule.playersSleepingPercentage",
    "gamerule.playersSleepingPercentage.description",
    "gamerule.projectilesCanBreakBlocks",
    "gamerule.projectilesCanBreakBlocks.description",
    "gamerule.pvp",
    "gamerule.pvp.description",
    "gamerule.randomTickSpeed",
    "gamerule.reducedDebugInfo",
    "gamerule.reducedDebugInfo.description",
    "gamerule.sendCommandFeedback",
    "gamerule.showDeathMessages",
    "gamerule.snowAccumulationHeight",
    "gamerule.snowAccumulationHeight.description",
    "gamerule.spawnChunkRadius",
    "gamerule.spawnChunkRadius.description",
    "gamerule.spawnerBlocksEnabled",
    "gamerule.spawnMonsters",
    "gamerule.spawnMonsters.description",
    "gamerule.spawnRadius",
    "gamerule.spawnRadius.description",
    "gamerule.spectatorsGenerateChunks",
    "gamerule.tntExplodes",
    "gamerule.tntExplosionDropDecay",
    "gamerule.tntExplosionDropDecay.description",
    "gamerule.universalAnger",
    "gamerule.universalAnger.description",
    "gamerule.waterSourceConversion",
    "gamerule.waterSourceConversion.description",
    "generator.custom",
    "generator.customized",
    "generator.minecraft.amplified",
    "generator.minecraft.amplified.info",
    "generator.minecraft.debug_all_block_states",
    "generator.minecraft.flat",
    "generator.minecraft.flat_all_dimensions",
    "generator.minecraft.large_biomes",
    "generator.minecraft.normal",
    "generator.minecraft.single_biome_surface",
    "generator.single_biome_caves",
    "generator.single_biome_floating_islands",
    "gui.abuseReport.attestation",
    "gui.abuseReport.comments",
    "gui.abuseReport.describe",
    "gui.abuseReport.discard.content",
    "gui.abuseReport.discard.discard",
    "gui.abuseReport.discard.draft",
    "gui.abuseReport.discard.return",
    "gui.abuseReport.discard.title",
    "gui.abuseReport.draft.content",
    "gui.abuseReport.draft.discard",
    "gui.abuseReport.draft.edit",
    "gui.abuseReport.draft.quittotitle.content",
    "gui.abuseReport.draft.quittotitle.title",
    "gui.abuseReport.draft.title",
    "gui.abuseReport.error.title",
    "gui.abuseReport.message",
    "gui.abuseReport.more_comments",
    "gui.abuseReport.name.comment_box_label",
    "gui.abuseReport.name.reporting",
    "gui.abuseReport.name.title",
    "gui.abuseReport.observed_what",
    "gui.abuseReport.read_info",
    "gui.abuseReport.reason.alcohol_tobacco_drugs",
    "gui.abuseReport.reason.alcohol_tobacco_drugs.description",
    "gui.abuseReport.reason.child_sexual_exploitation_or_abuse",
    "gui.abuseReport.reason.child_sexual_exploitation_or_abuse.description",
    "gui.abuseReport.reason.defamation_impersonation_false_information",
    "gui.abuseReport.reason.defamation_impersonation_false_information.description",
    "gui.abuseReport.reason.description",
    "gui.abuseReport.reason.false_reporting",
    "gui.abuseReport.reason.generic",
    "gui.abuseReport.reason.generic.description",
    "gui.abuseReport.reason.harassment_or_bullying",
    "gui.abuseReport.reason.harassment_or_bullying.description",
    "gui.abuseReport.reason.hate_speech",
    "gui.abuseReport.reason.hate_speech.description",
    "gui.abuseReport.reason.imminent_harm",
    "gui.abuseReport.reason.imminent_harm.description",
    "gui.abuseReport.reason.narration",
    "gui.abuseReport.reason.non_consensual_intimate_imagery",
    "gui.abuseReport.reason.non_consensual_intimate_imagery.description",
    "gui.abuseReport.reason.self_harm_or_suicide",
    "gui.abuseReport.reason.self_harm_or_suicide.description",
    "gui.abuseReport.reason.sexually_inappropriate",
    "gui.abuseReport.reason.sexually_inappropriate.description",
    "gui.abuseReport.reason.terrorism_or_violent_extremism",
    "gui.abuseReport.reason.terrorism_or_violent_extremism.description",
    "gui.abuseReport.reason.title",
    "gui.abuseReport.report_sent_msg",
    "gui.abuseReport.select_reason",
    "gui.abuseReport.send",
    "gui.abuseReport.send.comment_too_long",
    "gui.abuseReport.send.error_message",
    "gui.abuseReport.send.generic_error",
    "gui.abuseReport.send.http_error",
    "gui.abuseReport.send.json_error",
    "gui.abuseReport.send.no_reason",
    "gui.abuseReport.send.not_attested",
    "gui.abuseReport.send.service_unavailable",
    "gui.abuseReport.sending.title",
    "gui.abuseReport.sent.title",
    "gui.abuseReport.skin.title",
    "gui.abuseReport.title",
    "gui.abuseReport.type.chat",
    "gui.abuseReport.type.name",
    "gui.abuseReport.type.skin",
    "gui.acknowledge",
    "gui.advancements",
    "gui.all",
    "gui.back",
    "gui.banned.description",
    "gui.banned.description.permanent",
    "gui.banned.description.reason",
    "gui.banned.description.reason_id",
    "gui.banned.description.reason_id_message",
    "gui.banned.description.temporary",
    "gui.banned.description.temporary.duration",
    "gui.banned.description.unknownreason",
    "gui.banned.name.description",
    "gui.banned.name.title",
    "gui.banned.reason.defamation_impersonation_false_information",
    "gui.banned.reason.drugs",
    "gui.banned.reason.extreme_violence_or_gore",
    "gui.banned.reason.false_reporting",
    "gui.banned.reason.fraud",
    "gui.banned.reason.generic_violation",
    "gui.banned.reason.harassment_or_bullying",
    "gui.banned.reason.hate_speech",
    "gui.banned.reason.hate_terrorism_notorious_figure",
    "gui.banned.reason.imminent_harm_to_person_or_property",
    "gui.banned.reason.nudity_or_pornography",
    "gui.banned.reason.sexually_inappropriate",
    "gui.banned.reason.spam_or_advertising",
    "gui.banned.skin.description",
    "gui.banned.skin.title",
    "gui.banned.title.permanent",
    "gui.banned.title.temporary",
    "gui.cancel",
    "gui.chatReport.comments",
    "gui.chatReport.describe",
    "gui.chatReport.discard.content",
    "gui.chatReport.discard.discard",
    "gui.chatReport.discard.draft",
    "gui.chatReport.discard.return",
    "gui.chatReport.discard.title",
    "gui.chatReport.draft.content",
    "gui.chatReport.draft.discard",
    "gui.chatReport.draft.edit",
    "gui.chatReport.draft.quittotitle.content",
    "gui.chatReport.draft.quittotitle.title",
    "gui.chatReport.draft.title",
    "gui.chatReport.more_comments",
    "gui.chatReport.observed_what",
    "gui.chatReport.read_info",
    "gui.chatReport.report_sent_msg",
    "gui.chatReport.select_chat",
    "gui.chatReport.select_reason",
    "gui.chatReport.selected_chat",
    "gui.chatReport.send",
    "gui.chatReport.send.comments_too_long",
    "gui.chatReport.send.no_reason",
    "gui.chatReport.send.no_reported_messages",
    "gui.chatReport.send.too_many_messages",
    "gui.chatReport.title",
    "gui.chatSelection.context",
    "gui.chatSelection.fold",
    "gui.chatSelection.heading",
    "gui.chatSelection.join",
    "gui.chatSelection.message.narrate",
    "gui.chatSelection.selected",
    "gui.chatSelection.title",
    "gui.continue",
    "gui.copy_link_to_clipboard",
    "gui.days",
    "gui.done",
    "gui.down",
    "gui.entity_tooltip.type",
    "gui.experience.level",
    "gui.fileDropFailure.detail",
    "gui.fileDropFailure.title",
    "gui.friends.accept",
    "gui.friends.button.loading",
    "gui.friends.button.loading.invite_request_pending",
    "gui.friends.button.loading.join_request_pending",
    "gui.friends.cancel_request",
    "gui.friends.confirm_title",
    "gui.friends.confirm_unfriend",
    "gui.friends.copy_to_clipboard",
    "gui.friends.decline",
    "gui.friends.empty_nickname",
    "gui.friends.empty_state",
    "gui.friends.empty_state.link",
    "gui.friends.enter_nickname",
    "gui.friends.error.connection_issue",
    "gui.friends.error.failed.message",
    "gui.friends.error.forbidden.message",
    "gui.friends.error.generic",
    "gui.friends.error.rateLimited.message",
    "gui.friends.error.temporary_unavailable",
    "gui.friends.error.unauthorized",
    "gui.friends.error.unavailable.message",
    "gui.friends.error.upgrade_needed",
    "gui.friends.error.user_may_lack_active_profile",
    "gui.friends.join",
    "gui.friends.loading_friends",
    "gui.friends.loading_requests",
    "gui.friends.manage_account_footer",
    "gui.friends.multiplayer.invite",
    "gui.friends.multiplayer.invite_accept",
    "gui.friends.multiplayer.invite_reject",
    "gui.friends.multiplayer.join_request",
    "gui.friends.multiplayer.join_request_accept",
    "gui.friends.multiplayer.join_request_reject",
    "gui.friends.my_profile_name",
    "gui.friends.my_profile_name.narration",
    "gui.friends.narration.button.accept",
    "gui.friends.narration.button.cancel_request",
    "gui.friends.narration.button.decline",
    "gui.friends.narration.button.unfriend",
    "gui.friends.narration.entry.friend",
    "gui.friends.narration.entry.incoming",
    "gui.friends.narration.entry.outgoing",
    "gui.friends.open",
    "gui.friends.open.narration",
    "gui.friends.open.tooltip",
    "gui.friends.pending.empty",
    "gui.friends.pending.received",
    "gui.friends.pending.sent",
    "gui.friends.presence.status.offline",
    "gui.friends.presence.status.online",
    "gui.friends.presence.status.playing_hosted_server",
    "gui.friends.presence.status.playing_offline",
    "gui.friends.presence.status.playing_realms",
    "gui.friends.presence.status.playing_server",
    "gui.friends.requests_count",
    "gui.friends.send_request",
    "gui.friends.tab_friends",
    "gui.friends.toast.friend_added.message",
    "gui.friends.toast.friend_invited.message",
    "gui.friends.toast.friend_removed.message",
    "gui.friends.toast.generic_error",
    "gui.friends.toast.host_invite_expired.message",
    "gui.friends.toast.invite_from_friend.message",
    "gui.friends.toast.join_invite_expired.message",
    "gui.friends.toast.join_request.message",
    "gui.friends.toast.request_accepted.message",
    "gui.friends.toast.request_received.message",
    "gui.friends.toast.request_sent.message",
    "gui.friends.toast.request_to_join_friend.message",
    "gui.friends.toast.requests_accepted_multiple.message",
    "gui.friends.toast.requests_received_multiple.message",
    "gui.friends.unfriend",
    "gui.friends.validation.already_friend",
    "gui.friends.validation.already_incoming",
    "gui.friends.validation.already_outgoing",
    "gui.friends.validation.cannot_add_self",
    "gui.game_rule.search",
    "gui.hours",
    "gui.language.search",
    "gui.loadingMinecraft",
    "gui.minutes",
    "gui.multiLineEditBox.character_limit",
    "gui.narrate.button",
    "gui.narrate.editBox",
    "gui.narrate.slider",
    "gui.narrate.tab",
    "gui.no",
    "gui.none",
    "gui.ok",
    "gui.open_report_dir",
    "gui.packSelection.search",
    "gui.privacy_link.message",
    "gui.privacy_link.title",
    "gui.proceed",
    "gui.recipebook.moreRecipes",
    "gui.recipebook.next_page",
    "gui.recipebook.page",
    "gui.recipebook.previous_page",
    "gui.recipebook.search_hint",
    "gui.recipebook.toggleRecipes.all",
    "gui.recipebook.toggleRecipes.blastable",
    "gui.recipebook.toggleRecipes.craftable",
    "gui.recipebook.toggleRecipes.smeltable",
    "gui.recipebook.toggleRecipes.smokable",
    "gui.remove",
    "gui.report_to_server",
    "gui.selectWorld.search",
    "gui.socialInteractions.blocking_hint",
    "gui.socialInteractions.empty_blocked",
    "gui.socialInteractions.empty_hidden",
    "gui.socialInteractions.hidden_in_chat",
    "gui.socialInteractions.hide",
    "gui.socialInteractions.narration.hide",
    "gui.socialInteractions.narration.report",
    "gui.socialInteractions.narration.show",
    "gui.socialInteractions.report",
    "gui.socialInteractions.search_empty",
    "gui.socialInteractions.search_hint",
    "gui.socialInteractions.server_label.multiple",
    "gui.socialInteractions.server_label.single",
    "gui.socialInteractions.show",
    "gui.socialInteractions.shown_in_chat",
    "gui.socialInteractions.status_blocked",
    "gui.socialInteractions.status_blocked_offline",
    "gui.socialInteractions.status_hidden",
    "gui.socialInteractions.status_hidden_offline",
    "gui.socialInteractions.status_offline",
    "gui.socialInteractions.tab_all",
    "gui.socialInteractions.tab_blocked",
    "gui.socialInteractions.tab_hidden",
    "gui.socialInteractions.title",
    "gui.socialInteractions.tooltip.hide",
    "gui.socialInteractions.tooltip.report",
    "gui.socialInteractions.tooltip.report.chat_disabled_or_blocked",
    "gui.socialInteractions.tooltip.report.disabled",
    "gui.socialInteractions.tooltip.report.no_messages",
    "gui.socialInteractions.tooltip.report.not_reportable",
    "gui.socialInteractions.tooltip.show",
    "gui.stats",
    "gui.stats.none_found",
    "gui.togglable_slot",
    "gui.toMenu",
    "gui.toRealms",
    "gui.toTitle",
    "gui.toWorld",
    "gui.up",
    "gui.waitingForResponse.button.inactive",
    "gui.waitingForResponse.title",
    "gui.yes",
    "hanging_sign.edit",
    "instrument.minecraft.admire_goat_horn",
    "instrument.minecraft.call_goat_horn",
    "instrument.minecraft.dream_goat_horn",
    "instrument.minecraft.feel_goat_horn",
    "instrument.minecraft.ponder_goat_horn",
    "instrument.minecraft.seek_goat_horn",
    "instrument.minecraft.sing_goat_horn",
    "instrument.minecraft.yearn_goat_horn",
    "inventory.binSlot",
    "inventory.hotbarInfo",
    "inventory.hotbarSaved",
    "item_modifier.unknown",
    "item.canBreak",
    "item.canPlace",
    "item.canUse.unknown",
    "item.color",
    "item.components",
    "item.disabled",
    "item.durability",
    "item.dyed",
    "item.intangible",
    "item.minecraft.abandoned_campsite_map",
    "item.minecraft.acacia_boat",
    "item.minecraft.acacia_chest_boat",
    "item.minecraft.allay_spawn_egg",
    "item.minecraft.amethyst_shard",
    "item.minecraft.ancient_city_map",
    "item.minecraft.angler_pottery_shard",
    "item.minecraft.angler_pottery_sherd",
    "item.minecraft.apple",
    "item.minecraft.archer_pottery_shard",
    "item.minecraft.archer_pottery_sherd",
    "item.minecraft.armadillo_scute",
    "item.minecraft.armadillo_spawn_egg",
    "item.minecraft.armor_stand",
    "item.minecraft.arms_up_pottery_shard",
    "item.minecraft.arms_up_pottery_sherd",
    "item.minecraft.arrow",
    "item.minecraft.axolotl_bucket",
    "item.minecraft.axolotl_spawn_egg",
    "item.minecraft.baked_potato",
    "item.minecraft.bamboo_chest_raft",
    "item.minecraft.bamboo_raft",
    "item.minecraft.bat_spawn_egg",
    "item.minecraft.bee_spawn_egg",
    "item.minecraft.beef",
    "item.minecraft.beetroot",
    "item.minecraft.beetroot_seeds",
    "item.minecraft.beetroot_soup",
    "item.minecraft.birch_boat",
    "item.minecraft.birch_chest_boat",
    "item.minecraft.black_bundle",
    "item.minecraft.black_cushion",
    "item.minecraft.black_dye",
    "item.minecraft.black_harness",
    "item.minecraft.blade_pottery_shard",
    "item.minecraft.blade_pottery_sherd",
    "item.minecraft.blaze_powder",
    "item.minecraft.blaze_rod",
    "item.minecraft.blaze_spawn_egg",
    "item.minecraft.blue_bundle",
    "item.minecraft.blue_cushion",
    "item.minecraft.blue_dye",
    "item.minecraft.blue_egg",
    "item.minecraft.blue_harness",
    "item.minecraft.bogged_spawn_egg",
    "item.minecraft.bolt_armor_trim_smithing_template",
    "item.minecraft.bolt_armor_trim_smithing_template.new",
    "item.minecraft.bone",
    "item.minecraft.bone_meal",
    "item.minecraft.book",
    "item.minecraft.bordure_indented_banner_pattern",
    "item.minecraft.bow",
    "item.minecraft.bowl",
    "item.minecraft.bread",
    "item.minecraft.breeze_rod",
    "item.minecraft.breeze_spawn_egg",
    "item.minecraft.brewer_pottery_shard",
    "item.minecraft.brewer_pottery_sherd",
    "item.minecraft.brewing_stand",
    "item.minecraft.brick",
    "item.minecraft.brown_bundle",
    "item.minecraft.brown_cushion",
    "item.minecraft.brown_dye",
    "item.minecraft.brown_egg",
    "item.minecraft.brown_harness",
    "item.minecraft.brush",
    "item.minecraft.bucket",
    "item.minecraft.bundle",
    "item.minecraft.bundle.empty",
    "item.minecraft.bundle.empty.description",
    "item.minecraft.bundle.full",
    "item.minecraft.bundle.fullness",
    "item.minecraft.buried_treasure_map",
    "item.minecraft.burn_pottery_shard",
    "item.minecraft.burn_pottery_sherd",
    "item.minecraft.camel_husk_spawn_egg",
    "item.minecraft.camel_spawn_egg",
    "item.minecraft.carrot",
    "item.minecraft.carrot_on_a_stick",
    "item.minecraft.cat_spawn_egg",
    "item.minecraft.cauldron",
    "item.minecraft.cave_spider_spawn_egg",
    "item.minecraft.chainmail_boots",
    "item.minecraft.chainmail_chestplate",
    "item.minecraft.chainmail_helmet",
    "item.minecraft.chainmail_leggings",
    "item.minecraft.charcoal",
    "item.minecraft.cherry_boat",
    "item.minecraft.cherry_chest_boat",
    "item.minecraft.chest_minecart",
    "item.minecraft.chicken",
    "item.minecraft.chicken_spawn_egg",
    "item.minecraft.chorus_fruit",
    "item.minecraft.clay_ball",
    "item.minecraft.clock",
    "item.minecraft.coal",
    "item.minecraft.coast_armor_trim_smithing_template",
    "item.minecraft.coast_armor_trim_smithing_template.new",
    "item.minecraft.cocoa_beans",
    "item.minecraft.cod",
    "item.minecraft.cod_bucket",
    "item.minecraft.cod_spawn_egg",
    "item.minecraft.command_block_minecart",
    "item.minecraft.compass",
    "item.minecraft.cooked_beef",
    "item.minecraft.cooked_chicken",
    "item.minecraft.cooked_cod",
    "item.minecraft.cooked_mutton",
    "item.minecraft.cooked_porkchop",
    "item.minecraft.cooked_rabbit",
    "item.minecraft.cooked_salmon",
    "item.minecraft.cookie",
    "item.minecraft.copper_axe",
    "item.minecraft.copper_boots",
    "item.minecraft.copper_chestplate",
    "item.minecraft.copper_golem_spawn_egg",
    "item.minecraft.copper_helmet",
    "item.minecraft.copper_hoe",
    "item.minecraft.copper_horse_armor",
    "item.minecraft.copper_ingot",
    "item.minecraft.copper_leggings",
    "item.minecraft.copper_nautilus_armor",
    "item.minecraft.copper_nugget",
    "item.minecraft.copper_pickaxe",
    "item.minecraft.copper_shovel",
    "item.minecraft.copper_spear",
    "item.minecraft.copper_sword",
    "item.minecraft.cow_spawn_egg",
    "item.minecraft.creaking_spawn_egg",
    "item.minecraft.creeper_banner_pattern",
    "item.minecraft.creeper_banner_pattern.desc",
    "item.minecraft.creeper_banner_pattern.new",
    "item.minecraft.creeper_spawn_egg",
    "item.minecraft.crossbow",
    "item.minecraft.crossbow.projectile",
    "item.minecraft.crossbow.projectile.multiple",
    "item.minecraft.crossbow.projectile.single",
    "item.minecraft.cyan_bundle",
    "item.minecraft.cyan_cushion",
    "item.minecraft.cyan_dye",
    "item.minecraft.cyan_harness",
    "item.minecraft.danger_pottery_shard",
    "item.minecraft.danger_pottery_sherd",
    "item.minecraft.dark_oak_boat",
    "item.minecraft.dark_oak_chest_boat",
    "item.minecraft.debug_stick",
    "item.minecraft.debug_stick.empty",
    "item.minecraft.debug_stick.select",
    "item.minecraft.debug_stick.update",
    "item.minecraft.desert_pyramid_map",
    "item.minecraft.desert_village_map",
    "item.minecraft.diamond",
    "item.minecraft.diamond_axe",
    "item.minecraft.diamond_boots",
    "item.minecraft.diamond_chestplate",
    "item.minecraft.diamond_helmet",
    "item.minecraft.diamond_hoe",
    "item.minecraft.diamond_horse_armor",
    "item.minecraft.diamond_leggings",
    "item.minecraft.diamond_nautilus_armor",
    "item.minecraft.diamond_pickaxe",
    "item.minecraft.diamond_shovel",
    "item.minecraft.diamond_spear",
    "item.minecraft.diamond_sword",
    "item.minecraft.disc_fragment_5",
    "item.minecraft.disc_fragment_5.desc",
    "item.minecraft.dolphin_spawn_egg",
    "item.minecraft.donkey_spawn_egg",
    "item.minecraft.dragon_breath",
    "item.minecraft.dried_kelp",
    "item.minecraft.drowned_spawn_egg",
    "item.minecraft.dune_armor_trim_smithing_template",
    "item.minecraft.dune_armor_trim_smithing_template.new",
    "item.minecraft.echo_shard",
    "item.minecraft.egg",
    "item.minecraft.elder_guardian_spawn_egg",
    "item.minecraft.elytra",
    "item.minecraft.emerald",
    "item.minecraft.enchanted_book",
    "item.minecraft.enchanted_golden_apple",
    "item.minecraft.end_crystal",
    "item.minecraft.ender_dragon_spawn_egg",
    "item.minecraft.ender_eye",
    "item.minecraft.ender_pearl",
    "item.minecraft.enderman_spawn_egg",
    "item.minecraft.endermite_spawn_egg",
    "item.minecraft.evoker_spawn_egg",
    "item.minecraft.experience_bottle",
    "item.minecraft.explorer_pottery_shard",
    "item.minecraft.explorer_pottery_sherd",
    "item.minecraft.eye_armor_trim_smithing_template",
    "item.minecraft.eye_armor_trim_smithing_template.new",
    "item.minecraft.feather",
    "item.minecraft.fermented_spider_eye",
    "item.minecraft.field_masoned_banner_pattern",
    "item.minecraft.filled_map",
    "item.minecraft.fire_charge",
    "item.minecraft.firework_rocket",
    "item.minecraft.firework_rocket.flight",
    "item.minecraft.firework_rocket.flight_duration",
    "item.minecraft.firework_rocket.multiple_stars",
    "item.minecraft.firework_rocket.single_star",
    "item.minecraft.firework_star",
    "item.minecraft.firework_star.black",
    "item.minecraft.firework_star.blue",
    "item.minecraft.firework_star.brown",
    "item.minecraft.firework_star.custom_color",
    "item.minecraft.firework_star.cyan",
    "item.minecraft.firework_star.fade_to",
    "item.minecraft.firework_star.flicker",
    "item.minecraft.firework_star.gray",
    "item.minecraft.firework_star.green",
    "item.minecraft.firework_star.light_blue",
    "item.minecraft.firework_star.light_gray",
    "item.minecraft.firework_star.lime",
    "item.minecraft.firework_star.magenta",
    "item.minecraft.firework_star.orange",
    "item.minecraft.firework_star.pink",
    "item.minecraft.firework_star.purple",
    "item.minecraft.firework_star.red",
    "item.minecraft.firework_star.shape",
    "item.minecraft.firework_star.shape.burst",
    "item.minecraft.firework_star.shape.creeper",
    "item.minecraft.firework_star.shape.large_ball",
    "item.minecraft.firework_star.shape.small_ball",
    "item.minecraft.firework_star.shape.star",
    "item.minecraft.firework_star.trail",
    "item.minecraft.firework_star.white",
    "item.minecraft.firework_star.yellow",
    "item.minecraft.fishing_rod",
    "item.minecraft.flint",
    "item.minecraft.flint_and_steel",
    "item.minecraft.flow_armor_trim_smithing_template",
    "item.minecraft.flow_armor_trim_smithing_template.new",
    "item.minecraft.flow_banner_pattern",
    "item.minecraft.flow_banner_pattern.desc",
    "item.minecraft.flow_banner_pattern.new",
    "item.minecraft.flow_pottery_sherd",
    "item.minecraft.flower_banner_pattern",
    "item.minecraft.flower_banner_pattern.desc",
    "item.minecraft.flower_banner_pattern.new",
    "item.minecraft.flower_pot",
    "item.minecraft.fox_spawn_egg",
    "item.minecraft.friend_pottery_shard",
    "item.minecraft.friend_pottery_sherd",
    "item.minecraft.frog_spawn_egg",
    "item.minecraft.furnace_minecart",
    "item.minecraft.ghast_spawn_egg",
    "item.minecraft.ghast_tear",
    "item.minecraft.glass_bottle",
    "item.minecraft.glistering_melon_slice",
    "item.minecraft.globe_banner_pattern",
    "item.minecraft.globe_banner_pattern.desc",
    "item.minecraft.globe_banner_pattern.new",
    "item.minecraft.glow_berries",
    "item.minecraft.glow_ink_sac",
    "item.minecraft.glow_item_frame",
    "item.minecraft.glow_squid_spawn_egg",
    "item.minecraft.glowstone_dust",
    "item.minecraft.goat_horn",
    "item.minecraft.goat_spawn_egg",
    "item.minecraft.gold_ingot",
    "item.minecraft.gold_nugget",
    "item.minecraft.golden_apple",
    "item.minecraft.golden_axe",
    "item.minecraft.golden_boots",
    "item.minecraft.golden_carrot",
    "item.minecraft.golden_chestplate",
    "item.minecraft.golden_helmet",
    "item.minecraft.golden_hoe",
    "item.minecraft.golden_horse_armor",
    "item.minecraft.golden_leggings",
    "item.minecraft.golden_nautilus_armor",
    "item.minecraft.golden_pickaxe",
    "item.minecraft.golden_shovel",
    "item.minecraft.golden_spear",
    "item.minecraft.golden_sword",
    "item.minecraft.gray_bundle",
    "item.minecraft.gray_cushion",
    "item.minecraft.gray_dye",
    "item.minecraft.gray_harness",
    "item.minecraft.green_bundle",
    "item.minecraft.green_cushion",
    "item.minecraft.green_dye",
    "item.minecraft.green_harness",
    "item.minecraft.guardian_spawn_egg",
    "item.minecraft.gunpowder",
    "item.minecraft.guster_banner_pattern",
    "item.minecraft.guster_banner_pattern.desc",
    "item.minecraft.guster_banner_pattern.new",
    "item.minecraft.guster_pottery_sherd",
    "item.minecraft.happy_ghast_spawn_egg",
    "item.minecraft.harness",
    "item.minecraft.heart_of_the_sea",
    "item.minecraft.heart_pottery_shard",
    "item.minecraft.heart_pottery_sherd",
    "item.minecraft.heartbreak_pottery_shard",
    "item.minecraft.heartbreak_pottery_sherd",
    "item.minecraft.hoglin_spawn_egg",
    "item.minecraft.honey_bottle",
    "item.minecraft.honeycomb",
    "item.minecraft.hopper_minecart",
    "item.minecraft.horse_spawn_egg",
    "item.minecraft.host_armor_trim_smithing_template",
    "item.minecraft.host_armor_trim_smithing_template.new",
    "item.minecraft.howl_pottery_shard",
    "item.minecraft.howl_pottery_sherd",
    "item.minecraft.husk_spawn_egg",
    "item.minecraft.ink_sac",
    "item.minecraft.iron_axe",
    "item.minecraft.iron_boots",
    "item.minecraft.iron_chestplate",
    "item.minecraft.iron_golem_spawn_egg",
    "item.minecraft.iron_helmet",
    "item.minecraft.iron_hoe",
    "item.minecraft.iron_horse_armor",
    "item.minecraft.iron_ingot",
    "item.minecraft.iron_leggings",
    "item.minecraft.iron_nautilus_armor",
    "item.minecraft.iron_nugget",
    "item.minecraft.iron_pickaxe",
    "item.minecraft.iron_shovel",
    "item.minecraft.iron_spear",
    "item.minecraft.iron_sword",
    "item.minecraft.item_frame",
    "item.minecraft.jungle_boat",
    "item.minecraft.jungle_chest_boat",
    "item.minecraft.jungle_explorer_map",
    "item.minecraft.knowledge_book",
    "item.minecraft.lapis_lazuli",
    "item.minecraft.lava_bucket",
    "item.minecraft.lead",
    "item.minecraft.leather",
    "item.minecraft.leather_boots",
    "item.minecraft.leather_chestplate",
    "item.minecraft.leather_helmet",
    "item.minecraft.leather_horse_armor",
    "item.minecraft.leather_leggings",
    "item.minecraft.light_blue_bundle",
    "item.minecraft.light_blue_cushion",
    "item.minecraft.light_blue_dye",
    "item.minecraft.light_blue_harness",
    "item.minecraft.light_gray_bundle",
    "item.minecraft.light_gray_cushion",
    "item.minecraft.light_gray_dye",
    "item.minecraft.light_gray_harness",
    "item.minecraft.lime_bundle",
    "item.minecraft.lime_cushion",
    "item.minecraft.lime_dye",
    "item.minecraft.lime_harness",
    "item.minecraft.lingering_potion",
    "item.minecraft.lingering_potion.effect.awkward",
    "item.minecraft.lingering_potion.effect.empty",
    "item.minecraft.lingering_potion.effect.fire_resistance",
    "item.minecraft.lingering_potion.effect.harming",
    "item.minecraft.lingering_potion.effect.healing",
    "item.minecraft.lingering_potion.effect.infested",
    "item.minecraft.lingering_potion.effect.invisibility",
    "item.minecraft.lingering_potion.effect.leaping",
    "item.minecraft.lingering_potion.effect.levitation",
    "item.minecraft.lingering_potion.effect.luck",
    "item.minecraft.lingering_potion.effect.mundane",
    "item.minecraft.lingering_potion.effect.night_vision",
    "item.minecraft.lingering_potion.effect.oozing",
    "item.minecraft.lingering_potion.effect.poison",
    "item.minecraft.lingering_potion.effect.regeneration",
    "item.minecraft.lingering_potion.effect.slow_falling",
    "item.minecraft.lingering_potion.effect.slowness",
    "item.minecraft.lingering_potion.effect.strength",
    "item.minecraft.lingering_potion.effect.swiftness",
    "item.minecraft.lingering_potion.effect.thick",
    "item.minecraft.lingering_potion.effect.turtle_master",
    "item.minecraft.lingering_potion.effect.water",
    "item.minecraft.lingering_potion.effect.water_breathing",
    "item.minecraft.lingering_potion.effect.weakness",
    "item.minecraft.lingering_potion.effect.weaving",
    "item.minecraft.lingering_potion.effect.wind_charged",
    "item.minecraft.llama_spawn_egg",
    "item.minecraft.lodestone_compass",
    "item.minecraft.mace",
    "item.minecraft.magenta_bundle",
    "item.minecraft.magenta_cushion",
    "item.minecraft.magenta_dye",
    "item.minecraft.magenta_harness",
    "item.minecraft.magma_cream",
    "item.minecraft.magma_cube_spawn_egg",
    "item.minecraft.mangrove_boat",
    "item.minecraft.mangrove_chest_boat",
    "item.minecraft.map",
    "item.minecraft.melon_seeds",
    "item.minecraft.melon_slice",
    "item.minecraft.milk_bucket",
    "item.minecraft.minecart",
    "item.minecraft.miner_pottery_shard",
    "item.minecraft.miner_pottery_sherd",
    "item.minecraft.mineshaft_map",
    "item.minecraft.mojang_banner_pattern",
    "item.minecraft.mojang_banner_pattern.desc",
    "item.minecraft.mojang_banner_pattern.new",
    "item.minecraft.mooshroom_spawn_egg",
    "item.minecraft.mourner_pottery_shard",
    "item.minecraft.mourner_pottery_sherd",
    "item.minecraft.mule_spawn_egg",
    "item.minecraft.mushroom_stew",
    "item.minecraft.music_disc_5",
    "item.minecraft.music_disc_5.desc",
    "item.minecraft.music_disc_11",
    "item.minecraft.music_disc_11.desc",
    "item.minecraft.music_disc_13",
    "item.minecraft.music_disc_13.desc",
    "item.minecraft.music_disc_blocks",
    "item.minecraft.music_disc_blocks.desc",
    "item.minecraft.music_disc_bounce",
    "item.minecraft.music_disc_bounce.desc",
    "item.minecraft.music_disc_cat",
    "item.minecraft.music_disc_cat.desc",
    "item.minecraft.music_disc_chirp",
    "item.minecraft.music_disc_chirp.desc",
    "item.minecraft.music_disc_creator",
    "item.minecraft.music_disc_creator_music_box",
    "item.minecraft.music_disc_creator_music_box.desc",
    "item.minecraft.music_disc_creator.desc",
    "item.minecraft.music_disc_far",
    "item.minecraft.music_disc_far.desc",
    "item.minecraft.music_disc_lava_chicken",
    "item.minecraft.music_disc_lava_chicken.desc",
    "item.minecraft.music_disc_mall",
    "item.minecraft.music_disc_mall.desc",
    "item.minecraft.music_disc_mellohi",
    "item.minecraft.music_disc_mellohi.desc",
    "item.minecraft.music_disc_otherside",
    "item.minecraft.music_disc_otherside.desc",
    "item.minecraft.music_disc_pigstep",
    "item.minecraft.music_disc_pigstep.desc",
    "item.minecraft.music_disc_precipice",
    "item.minecraft.music_disc_precipice.desc",
    "item.minecraft.music_disc_relic",
    "item.minecraft.music_disc_relic.desc",
    "item.minecraft.music_disc_stal",
    "item.minecraft.music_disc_stal.desc",
    "item.minecraft.music_disc_strad",
    "item.minecraft.music_disc_strad.desc",
    "item.minecraft.music_disc_tears",
    "item.minecraft.music_disc_tears.desc",
    "item.minecraft.music_disc_wait",
    "item.minecraft.music_disc_wait.desc",
    "item.minecraft.music_disc_ward",
    "item.minecraft.music_disc_ward.desc",
    "item.minecraft.mutton",
    "item.minecraft.name_tag",
    "item.minecraft.nautilus_shell",
    "item.minecraft.nautilus_spawn_egg",
    "item.minecraft.nether_brick",
    "item.minecraft.nether_star",
    "item.minecraft.nether_wart",
    "item.minecraft.netherite_axe",
    "item.minecraft.netherite_boots",
    "item.minecraft.netherite_chestplate",
    "item.minecraft.netherite_helmet",
    "item.minecraft.netherite_hoe",
    "item.minecraft.netherite_horse_armor",
    "item.minecraft.netherite_ingot",
    "item.minecraft.netherite_leggings",
    "item.minecraft.netherite_nautilus_armor",
    "item.minecraft.netherite_pickaxe",
    "item.minecraft.netherite_scrap",
    "item.minecraft.netherite_shovel",
    "item.minecraft.netherite_spear",
    "item.minecraft.netherite_sword",
    "item.minecraft.netherite_upgrade_smithing_template",
    "item.minecraft.netherite_upgrade_smithing_template.new",
    "item.minecraft.oak_boat",
    "item.minecraft.oak_chest_boat",
    "item.minecraft.ocean_explorer_map",
    "item.minecraft.ocelot_spawn_egg",
    "item.minecraft.ominous_bottle",
    "item.minecraft.ominous_trial_key",
    "item.minecraft.orange_bundle",
    "item.minecraft.orange_cushion",
    "item.minecraft.orange_dye",
    "item.minecraft.orange_harness",
    "item.minecraft.painting",
    "item.minecraft.pale_oak_boat",
    "item.minecraft.pale_oak_chest_boat",
    "item.minecraft.panda_spawn_egg",
    "item.minecraft.paper",
    "item.minecraft.parched_spawn_egg",
    "item.minecraft.parrot_spawn_egg",
    "item.minecraft.phantom_membrane",
    "item.minecraft.phantom_spawn_egg",
    "item.minecraft.pig_spawn_egg",
    "item.minecraft.piglin_banner_pattern",
    "item.minecraft.piglin_banner_pattern.desc",
    "item.minecraft.piglin_banner_pattern.new",
    "item.minecraft.piglin_brute_spawn_egg",
    "item.minecraft.piglin_spawn_egg",
    "item.minecraft.pillager_spawn_egg",
    "item.minecraft.pink_bundle",
    "item.minecraft.pink_cushion",
    "item.minecraft.pink_dye",
    "item.minecraft.pink_harness",
    "item.minecraft.pitcher_plant",
    "item.minecraft.pitcher_pod",
    "item.minecraft.plains_village_map",
    "item.minecraft.plenty_pottery_shard",
    "item.minecraft.plenty_pottery_sherd",
    "item.minecraft.poisonous_potato",
    "item.minecraft.polar_bear_spawn_egg",
    "item.minecraft.poplar_boat",
    "item.minecraft.poplar_chest_boat",
    "item.minecraft.popped_chorus_fruit",
    "item.minecraft.porkchop",
    "item.minecraft.potato",
    "item.minecraft.potion",
    "item.minecraft.potion.effect.awkward",
    "item.minecraft.potion.effect.empty",
    "item.minecraft.potion.effect.fire_resistance",
    "item.minecraft.potion.effect.harming",
    "item.minecraft.potion.effect.healing",
    "item.minecraft.potion.effect.infested",
    "item.minecraft.potion.effect.invisibility",
    "item.minecraft.potion.effect.leaping",
    "item.minecraft.potion.effect.levitation",
    "item.minecraft.potion.effect.luck",
    "item.minecraft.potion.effect.mundane",
    "item.minecraft.potion.effect.night_vision",
    "item.minecraft.potion.effect.oozing",
    "item.minecraft.potion.effect.poison",
    "item.minecraft.potion.effect.regeneration",
    "item.minecraft.potion.effect.slow_falling",
    "item.minecraft.potion.effect.slowness",
    "item.minecraft.potion.effect.strength",
    "item.minecraft.potion.effect.swiftness",
    "item.minecraft.potion.effect.thick",
    "item.minecraft.potion.effect.turtle_master",
    "item.minecraft.potion.effect.water",
    "item.minecraft.potion.effect.water_breathing",
    "item.minecraft.potion.effect.weakness",
    "item.minecraft.potion.effect.weaving",
    "item.minecraft.potion.effect.wind_charged",
    "item.minecraft.pottery_shard_archer",
    "item.minecraft.pottery_shard_arms_up",
    "item.minecraft.pottery_shard_prize",
    "item.minecraft.pottery_shard_skull",
    "item.minecraft.powder_snow_bucket",
    "item.minecraft.prismarine_crystals",
    "item.minecraft.prismarine_shard",
    "item.minecraft.prize_pottery_shard",
    "item.minecraft.prize_pottery_sherd",
    "item.minecraft.pufferfish",
    "item.minecraft.pufferfish_bucket",
    "item.minecraft.pufferfish_spawn_egg",
    "item.minecraft.pumpkin_pie",
    "item.minecraft.pumpkin_seeds",
    "item.minecraft.purple_bundle",
    "item.minecraft.purple_cushion",
    "item.minecraft.purple_dye",
    "item.minecraft.purple_harness",
    "item.minecraft.quartz",
    "item.minecraft.rabbit",
    "item.minecraft.rabbit_foot",
    "item.minecraft.rabbit_hide",
    "item.minecraft.rabbit_spawn_egg",
    "item.minecraft.rabbit_stew",
    "item.minecraft.raiser_armor_trim_smithing_template",
    "item.minecraft.raiser_armor_trim_smithing_template.new",
    "item.minecraft.ravager_spawn_egg",
    "item.minecraft.raw_copper",
    "item.minecraft.raw_gold",
    "item.minecraft.raw_iron",
    "item.minecraft.recovery_compass",
    "item.minecraft.red_bundle",
    "item.minecraft.red_cushion",
    "item.minecraft.red_dye",
    "item.minecraft.red_harness",
    "item.minecraft.redstone",
    "item.minecraft.resin_brick",
    "item.minecraft.resin_clump",
    "item.minecraft.rib_armor_trim_smithing_template",
    "item.minecraft.rib_armor_trim_smithing_template.new",
    "item.minecraft.rotten_flesh",
    "item.minecraft.saddle",
    "item.minecraft.salmon",
    "item.minecraft.salmon_bucket",
    "item.minecraft.salmon_spawn_egg",
    "item.minecraft.savanna_village_map",
    "item.minecraft.scrape_pottery_sherd",
    "item.minecraft.scute",
    "item.minecraft.sentry_armor_trim_smithing_template",
    "item.minecraft.sentry_armor_trim_smithing_template.new",
    "item.minecraft.shaper_armor_trim_smithing_template",
    "item.minecraft.shaper_armor_trim_smithing_template.new",
    "item.minecraft.sheaf_pottery_shard",
    "item.minecraft.sheaf_pottery_sherd",
    "item.minecraft.shears",
    "item.minecraft.sheep_spawn_egg",
    "item.minecraft.shelter_pottery_shard",
    "item.minecraft.shelter_pottery_sherd",
    "item.minecraft.shield",
    "item.minecraft.shield.black",
    "item.minecraft.shield.blue",
    "item.minecraft.shield.brown",
    "item.minecraft.shield.cyan",
    "item.minecraft.shield.gray",
    "item.minecraft.shield.green",
    "item.minecraft.shield.light_blue",
    "item.minecraft.shield.light_gray",
    "item.minecraft.shield.lime",
    "item.minecraft.shield.magenta",
    "item.minecraft.shield.orange",
    "item.minecraft.shield.pink",
    "item.minecraft.shield.purple",
    "item.minecraft.shield.red",
    "item.minecraft.shield.white",
    "item.minecraft.shield.yellow",
    "item.minecraft.shulker_shell",
    "item.minecraft.shulker_spawn_egg",
    "item.minecraft.sign",
    "item.minecraft.silence_armor_trim_smithing_template",
    "item.minecraft.silence_armor_trim_smithing_template.new",
    "item.minecraft.silverfish_spawn_egg",
    "item.minecraft.skeleton_horse_spawn_egg",
    "item.minecraft.skeleton_spawn_egg",
    "item.minecraft.skull_banner_pattern",
    "item.minecraft.skull_banner_pattern.desc",
    "item.minecraft.skull_banner_pattern.new",
    "item.minecraft.skull_pottery_shard",
    "item.minecraft.skull_pottery_sherd",
    "item.minecraft.slime_ball",
    "item.minecraft.slime_spawn_egg",
    "item.minecraft.smithing_template",
    "item.minecraft.smithing_template.applies_to",
    "item.minecraft.smithing_template.armor_trim.additions_slot_description",
    "item.minecraft.smithing_template.armor_trim.applies_to",
    "item.minecraft.smithing_template.armor_trim.base_slot_description",
    "item.minecraft.smithing_template.armor_trim.ingredients",
    "item.minecraft.smithing_template.ingredients",
    "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description",
    "item.minecraft.smithing_template.netherite_upgrade.applies_to",
    "item.minecraft.smithing_template.netherite_upgrade.base_slot_description",
    "item.minecraft.smithing_template.netherite_upgrade.ingredients",
    "item.minecraft.smithing_template.upgrade",
    "item.minecraft.sniffer_spawn_egg",
    "item.minecraft.snort_pottery_shard",
    "item.minecraft.snort_pottery_sherd",
    "item.minecraft.snout_armor_trim_smithing_template",
    "item.minecraft.snout_armor_trim_smithing_template.new",
    "item.minecraft.snow_golem_spawn_egg",
    "item.minecraft.snowball",
    "item.minecraft.snowy_village_map",
    "item.minecraft.spectral_arrow",
    "item.minecraft.spider_eye",
    "item.minecraft.spider_spawn_egg",
    "item.minecraft.spire_armor_trim_smithing_template",
    "item.minecraft.spire_armor_trim_smithing_template.new",
    "item.minecraft.splash_potion",
    "item.minecraft.splash_potion.effect.awkward",
    "item.minecraft.splash_potion.effect.empty",
    "item.minecraft.splash_potion.effect.fire_resistance",
    "item.minecraft.splash_potion.effect.harming",
    "item.minecraft.splash_potion.effect.healing",
    "item.minecraft.splash_potion.effect.infested",
    "item.minecraft.splash_potion.effect.invisibility",
    "item.minecraft.splash_potion.effect.leaping",
    "item.minecraft.splash_potion.effect.levitation",
    "item.minecraft.splash_potion.effect.luck",
    "item.minecraft.splash_potion.effect.mundane",
    "item.minecraft.splash_potion.effect.night_vision",
    "item.minecraft.splash_potion.effect.oozing",
    "item.minecraft.splash_potion.effect.poison",
    "item.minecraft.splash_potion.effect.regeneration",
    "item.minecraft.splash_potion.effect.slow_falling",
    "item.minecraft.splash_potion.effect.slowness",
    "item.minecraft.splash_potion.effect.strength",
    "item.minecraft.splash_potion.effect.swiftness",
    "item.minecraft.splash_potion.effect.thick",
    "item.minecraft.splash_potion.effect.turtle_master",
    "item.minecraft.splash_potion.effect.water",
    "item.minecraft.splash_potion.effect.water_breathing",
    "item.minecraft.splash_potion.effect.weakness",
    "item.minecraft.splash_potion.effect.weaving",
    "item.minecraft.splash_potion.effect.wind_charged",
    "item.minecraft.spruce_boat",
    "item.minecraft.spruce_chest_boat",
    "item.minecraft.spyglass",
    "item.minecraft.squid_spawn_egg",
    "item.minecraft.stick",
    "item.minecraft.stone_axe",
    "item.minecraft.stone_hoe",
    "item.minecraft.stone_pickaxe",
    "item.minecraft.stone_shovel",
    "item.minecraft.stone_spear",
    "item.minecraft.stone_sword",
    "item.minecraft.straw_bed",
    "item.minecraft.stray_spawn_egg",
    "item.minecraft.strider_spawn_egg",
    "item.minecraft.string",
    "item.minecraft.sugar",
    "item.minecraft.sulfur_cube_bucket",
    "item.minecraft.sulfur_cube_spawn_egg",
    "item.minecraft.suspicious_stew",
    "item.minecraft.swamp_explorer_map",
    "item.minecraft.sweet_berries",
    "item.minecraft.tadpole_bucket",
    "item.minecraft.tadpole_spawn_egg",
    "item.minecraft.taiga_village_map",
    "item.minecraft.tide_armor_trim_smithing_template",
    "item.minecraft.tide_armor_trim_smithing_template.new",
    "item.minecraft.tipped_arrow",
    "item.minecraft.tipped_arrow.effect.awkward",
    "item.minecraft.tipped_arrow.effect.empty",
    "item.minecraft.tipped_arrow.effect.fire_resistance",
    "item.minecraft.tipped_arrow.effect.harming",
    "item.minecraft.tipped_arrow.effect.healing",
    "item.minecraft.tipped_arrow.effect.infested",
    "item.minecraft.tipped_arrow.effect.invisibility",
    "item.minecraft.tipped_arrow.effect.leaping",
    "item.minecraft.tipped_arrow.effect.levitation",
    "item.minecraft.tipped_arrow.effect.luck",
    "item.minecraft.tipped_arrow.effect.mundane",
    "item.minecraft.tipped_arrow.effect.night_vision",
    "item.minecraft.tipped_arrow.effect.oozing",
    "item.minecraft.tipped_arrow.effect.poison",
    "item.minecraft.tipped_arrow.effect.regeneration",
    "item.minecraft.tipped_arrow.effect.slow_falling",
    "item.minecraft.tipped_arrow.effect.slowness",
    "item.minecraft.tipped_arrow.effect.strength",
    "item.minecraft.tipped_arrow.effect.swiftness",
    "item.minecraft.tipped_arrow.effect.thick",
    "item.minecraft.tipped_arrow.effect.turtle_master",
    "item.minecraft.tipped_arrow.effect.water",
    "item.minecraft.tipped_arrow.effect.water_breathing",
    "item.minecraft.tipped_arrow.effect.weakness",
    "item.minecraft.tipped_arrow.effect.weaving",
    "item.minecraft.tipped_arrow.effect.wind_charged",
    "item.minecraft.tnt_minecart",
    "item.minecraft.torchflower_seeds",
    "item.minecraft.totem_of_undying",
    "item.minecraft.trader_llama_spawn_egg",
    "item.minecraft.trial_explorer_map",
    "item.minecraft.trial_key",
    "item.minecraft.trident",
    "item.minecraft.tropical_fish",
    "item.minecraft.tropical_fish_bucket",
    "item.minecraft.tropical_fish_spawn_egg",
    "item.minecraft.turtle_helmet",
    "item.minecraft.turtle_scute",
    "item.minecraft.turtle_spawn_egg",
    "item.minecraft.vex_armor_trim_smithing_template",
    "item.minecraft.vex_armor_trim_smithing_template.new",
    "item.minecraft.vex_spawn_egg",
    "item.minecraft.villager_spawn_egg",
    "item.minecraft.vindicator_spawn_egg",
    "item.minecraft.wandering_trader_spawn_egg",
    "item.minecraft.ward_armor_trim_smithing_template",
    "item.minecraft.ward_armor_trim_smithing_template.new",
    "item.minecraft.warden_spawn_egg",
    "item.minecraft.warm_ocean_ruins_map",
    "item.minecraft.warped_fungus_on_a_stick",
    "item.minecraft.water_bucket",
    "item.minecraft.wayfinder_armor_trim_smithing_template",
    "item.minecraft.wayfinder_armor_trim_smithing_template.new",
    "item.minecraft.wheat",
    "item.minecraft.wheat_seeds",
    "item.minecraft.white_bundle",
    "item.minecraft.white_cushion",
    "item.minecraft.white_dye",
    "item.minecraft.white_harness",
    "item.minecraft.wild_armor_trim_smithing_template",
    "item.minecraft.wild_armor_trim_smithing_template.new",
    "item.minecraft.wind_charge",
    "item.minecraft.witch_spawn_egg",
    "item.minecraft.wither_skeleton_spawn_egg",
    "item.minecraft.wither_spawn_egg",
    "item.minecraft.wolf_armor",
    "item.minecraft.wolf_spawn_egg",
    "item.minecraft.wooden_axe",
    "item.minecraft.wooden_hoe",
    "item.minecraft.wooden_pickaxe",
    "item.minecraft.wooden_shovel",
    "item.minecraft.wooden_spear",
    "item.minecraft.wooden_sword",
    "item.minecraft.woodland_explorer_map",
    "item.minecraft.writable_book",
    "item.minecraft.written_book",
    "item.minecraft.yellow_bundle",
    "item.minecraft.yellow_cushion",
    "item.minecraft.yellow_dye",
    "item.minecraft.yellow_harness",
    "item.minecraft.zoglin_spawn_egg",
    "item.minecraft.zombie_horse_spawn_egg",
    "item.minecraft.zombie_nautilus_spawn_egg",
    "item.minecraft.zombie_spawn_egg",
    "item.minecraft.zombie_villager_spawn_egg",
    "item.minecraft.zombified_piglin_spawn_egg",
    "item.modifiers.any",
    "item.modifiers.armor",
    "item.modifiers.body",
    "item.modifiers.chest",
    "item.modifiers.feet",
    "item.modifiers.hand",
    "item.modifiers.head",
    "item.modifiers.legs",
    "item.modifiers.mainhand",
    "item.modifiers.offhand",
    "item.modifiers.saddle",
    "item.nbt_tags",
    "item.op_block_warning.line1",
    "item.op_block_warning.line2",
    "item.op_block_warning.line3",
    "item.spawn_egg.peaceful",
    "item.unbreakable",
    "itemGroup.buildingBlocks",
    "itemGroup.coloredBlocks",
    "itemGroup.combat",
    "itemGroup.consumables",
    "itemGroup.crafting",
    "itemGroup.foodAndDrink",
    "itemGroup.functional",
    "itemGroup.hotbar",
    "itemGroup.ingredients",
    "itemGroup.inventory",
    "itemGroup.natural",
    "itemGroup.op",
    "itemGroup.redstone",
    "itemGroup.search",
    "itemGroup.spawnEggs",
    "itemGroup.tools",
    "jigsaw_block.final_state",
    "jigsaw_block.generate",
    "jigsaw_block.joint_label",
    "jigsaw_block.joint.aligned",
    "jigsaw_block.joint.rollable",
    "jigsaw_block.keep_jigsaws",
    "jigsaw_block.levels",
    "jigsaw_block.name",
    "jigsaw_block.placement_priority",
    "jigsaw_block.placement_priority.tooltip",
    "jigsaw_block.pool",
    "jigsaw_block.selection_priority",
    "jigsaw_block.selection_priority.tooltip",
    "jigsaw_block.target",
    "jukebox_song.minecraft.5",
    "jukebox_song.minecraft.11",
    "jukebox_song.minecraft.13",
    "jukebox_song.minecraft.blocks",
    "jukebox_song.minecraft.bounce",
    "jukebox_song.minecraft.cat",
    "jukebox_song.minecraft.chirp",
    "jukebox_song.minecraft.creator",
    "jukebox_song.minecraft.creator_music_box",
    "jukebox_song.minecraft.far",
    "jukebox_song.minecraft.lava_chicken",
    "jukebox_song.minecraft.mall",
    "jukebox_song.minecraft.mellohi",
    "jukebox_song.minecraft.otherside",
    "jukebox_song.minecraft.pigstep",
    "jukebox_song.minecraft.precipice",
    "jukebox_song.minecraft.relic",
    "jukebox_song.minecraft.stal",
    "jukebox_song.minecraft.strad",
    "jukebox_song.minecraft.tears",
    "jukebox_song.minecraft.wait",
    "jukebox_song.minecraft.ward",
    "key.advancements",
    "key.attack",
    "key.back",
    "key.categories.creative",
    "key.categories.gameplay",
    "key.categories.inventory",
    "key.categories.misc",
    "key.categories.movement",
    "key.categories.multiplayer",
    "key.categories.spectator",
    "key.categories.ui",
    "key.category.minecraft.creative",
    "key.category.minecraft.debug",
    "key.category.minecraft.gameplay",
    "key.category.minecraft.inventory",
    "key.category.minecraft.misc",
    "key.category.minecraft.movement",
    "key.category.minecraft.multiplayer",
    "key.category.minecraft.spectator",
    "key.chat",
    "key.command",
    "key.debug.clearChat",
    "key.debug.copyLocation",
    "key.debug.copyRecreateCommand",
    "key.debug.crash",
    "key.debug.debugOptions",
    "key.debug.dumpDynamicTextures",
    "key.debug.dumpVersion",
    "key.debug.focusPause",
    "key.debug.fpsCharts",
    "key.debug.improvedTransparency",
    "key.debug.lightmapTexture",
    "key.debug.modifier",
    "key.debug.networkCharts",
    "key.debug.overlay",
    "key.debug.profiling",
    "key.debug.profilingChart",
    "key.debug.reloadChunk",
    "key.debug.reloadResourcePacks",
    "key.debug.showAdvancedTooltips",
    "key.debug.showChunkBorders",
    "key.debug.showHitboxes",
    "key.debug.spectate",
    "key.debug.switchGameMode",
    "key.drop",
    "key.forward",
    "key.friends",
    "key.fullscreen",
    "key.hotbar.1",
    "key.hotbar.2",
    "key.hotbar.3",
    "key.hotbar.4",
    "key.hotbar.5",
    "key.hotbar.6",
    "key.hotbar.7",
    "key.hotbar.8",
    "key.hotbar.9",
    "key.inventory",
    "key.jump",
    "key.keyboard.again",
    "key.keyboard.apostrophe",
    "key.keyboard.application",
    "key.keyboard.backslash",
    "key.keyboard.backspace",
    "key.keyboard.caps.lock",
    "key.keyboard.comma",
    "key.keyboard.copy",
    "key.keyboard.cut",
    "key.keyboard.delete",
    "key.keyboard.down",
    "key.keyboard.end",
    "key.keyboard.enter",
    "key.keyboard.equal",
    "key.keyboard.escape",
    "key.keyboard.f1",
    "key.keyboard.f2",
    "key.keyboard.f3",
    "key.keyboard.f4",
    "key.keyboard.f5",
    "key.keyboard.f6",
    "key.keyboard.f7",
    "key.keyboard.f8",
    "key.keyboard.f9",
    "key.keyboard.f10",
    "key.keyboard.f11",
    "key.keyboard.f12",
    "key.keyboard.f13",
    "key.keyboard.f14",
    "key.keyboard.f15",
    "key.keyboard.f16",
    "key.keyboard.f17",
    "key.keyboard.f18",
    "key.keyboard.f19",
    "key.keyboard.f20",
    "key.keyboard.f21",
    "key.keyboard.f22",
    "key.keyboard.f23",
    "key.keyboard.f24",
    "key.keyboard.f25",
    "key.keyboard.find",
    "key.keyboard.grave.accent",
    "key.keyboard.help",
    "key.keyboard.home",
    "key.keyboard.insert",
    "key.keyboard.keypad.0",
    "key.keyboard.keypad.1",
    "key.keyboard.keypad.2",
    "key.keyboard.keypad.3",
    "key.keyboard.keypad.4",
    "key.keyboard.keypad.5",
    "key.keyboard.keypad.6",
    "key.keyboard.keypad.7",
    "key.keyboard.keypad.8",
    "key.keyboard.keypad.9",
    "key.keyboard.keypad.add",
    "key.keyboard.keypad.comma",
    "key.keyboard.keypad.decimal",
    "key.keyboard.keypad.divide",
    "key.keyboard.keypad.enter",
    "key.keyboard.keypad.equal",
    "key.keyboard.keypad.left.parenthesis",
    "key.keyboard.keypad.multiply",
    "key.keyboard.keypad.period",
    "key.keyboard.keypad.plus.minus",
    "key.keyboard.keypad.right.parenthesis",
    "key.keyboard.keypad.subtract",
    "key.keyboard.left",
    "key.keyboard.left.alt",
    "key.keyboard.left.bracket",
    "key.keyboard.left.command",
    "key.keyboard.left.control",
    "key.keyboard.left.option",
    "key.keyboard.left.shift",
    "key.keyboard.left.win",
    "key.keyboard.left.windows",
    "key.keyboard.media.play.pause",
    "key.keyboard.menu",
    "key.keyboard.minus",
    "key.keyboard.mute",
    "key.keyboard.new",
    "key.keyboard.num.lock",
    "key.keyboard.page.down",
    "key.keyboard.page.up",
    "key.keyboard.paste",
    "key.keyboard.pause",
    "key.keyboard.period",
    "key.keyboard.print.screen",
    "key.keyboard.right",
    "key.keyboard.right.alt",
    "key.keyboard.right.bracket",
    "key.keyboard.right.command",
    "key.keyboard.right.control",
    "key.keyboard.right.option",
    "key.keyboard.right.shift",
    "key.keyboard.right.win",
    "key.keyboard.right.windows",
    "key.keyboard.save",
    "key.keyboard.scroll.lock",
    "key.keyboard.semicolon",
    "key.keyboard.slash",
    "key.keyboard.space",
    "key.keyboard.stop",
    "key.keyboard.tab",
    "key.keyboard.undo",
    "key.keyboard.unknown",
    "key.keyboard.up",
    "key.keyboard.volume.down",
    "key.keyboard.volume.up",
    "key.keyboard.world.1",
    "key.keyboard.world.2",
    "key.left",
    "key.loadToolbarActivator",
    "key.mouse",
    "key.mouse.left",
    "key.mouse.middle",
    "key.mouse.right",
    "key.pickItem",
    "key.playerlist",
    "key.quickActions",
    "key.right",
    "key.saveToolbarActivator",
    "key.screenshot",
    "key.smoothCamera",
    "key.sneak",
    "key.socialInteractions",
    "key.spectatorHotbar",
    "key.spectatorOutlines",
    "key.sprint",
    "key.swapOffhand",
    "key.toggleGui",
    "key.togglePerspective",
    "key.toggleSpectatorShaderEffects",
    "key.use",
    "known_server_link.announcements",
    "known_server_link.community",
    "known_server_link.community_guidelines",
    "known_server_link.feedback",
    "known_server_link.forums",
    "known_server_link.news",
    "known_server_link.report_bug",
    "known_server_link.status",
    "known_server_link.support",
    "known_server_link.website",
    "language.code",
    "language.name",
    "language.region",
    "lanServer.otherPlayers",
    "lanServer.port",
    "lanServer.port.invalid",
    "lanServer.port.invalid.new",
    "lanServer.port.unavailable",
    "lanServer.port.unavailable.new",
    "lanServer.scanning",
    "lanServer.start",
    "lanServer.title",
    "lectern.take_book",
    "loading.progress",
    "manageServer.add.title",
    "manageServer.edit.title",
    "manageServer.enterIp",
    "manageServer.enterName",
    "manageServer.resourcePack",
    "manageServer.resourcePack.disabled",
    "manageServer.resourcePack.enabled",
    "manageServer.resourcePack.prompt",
    "mco.account.privacy.info",
    "mco.account.privacy.info.button",
    "mco.account.privacy.information",
    "mco.account.privacyinfo",
    "mco.account.update",
    "mco.activity.noactivity",
    "mco.activity.title",
    "mco.backup.button.download",
    "mco.backup.button.reset",
    "mco.backup.button.restore",
    "mco.backup.button.upload",
    "mco.backup.changes.tooltip",
    "mco.backup.entry",
    "mco.backup.entry.description",
    "mco.backup.entry.enabledPack",
    "mco.backup.entry.gameDifficulty",
    "mco.backup.entry.gameMode",
    "mco.backup.entry.gameServerVersion",
    "mco.backup.entry.name",
    "mco.backup.entry.seed",
    "mco.backup.entry.templateName",
    "mco.backup.entry.undefined",
    "mco.backup.entry.uploaded",
    "mco.backup.entry.worldType",
    "mco.backup.entry.worldType.adventureMap",
    "mco.backup.entry.worldType.experience",
    "mco.backup.entry.worldType.inspiration",
    "mco.backup.entry.worldType.minigame",
    "mco.backup.entry.worldType.normal",
    "mco.backup.entry.worldType.unknown",
    "mco.backup.generate.world",
    "mco.backup.info.title",
    "mco.backup.narration",
    "mco.backup.nobackups",
    "mco.backup.restoring",
    "mco.backup.unknown",
    "mco.brokenworld.download",
    "mco.brokenworld.downloaded",
    "mco.brokenworld.message.line1",
    "mco.brokenworld.message.line2",
    "mco.brokenworld.minigame.title",
    "mco.brokenworld.nonowner.error",
    "mco.brokenworld.nonowner.title",
    "mco.brokenworld.play",
    "mco.brokenworld.reset",
    "mco.brokenworld.title",
    "mco.client.incompatible.msg.line1",
    "mco.client.incompatible.msg.line2",
    "mco.client.incompatible.msg.line3",
    "mco.client.incompatible.title",
    "mco.client.outdated.stable.version",
    "mco.client.unsupported.snapshot.version",
    "mco.compatibility.downgrade",
    "mco.compatibility.downgrade.description",
    "mco.compatibility.incompatible.popup.title",
    "mco.compatibility.incompatible.releaseType.popup.message",
    "mco.compatibility.incompatible.series.popup.message",
    "mco.compatibility.unverifiable.message",
    "mco.compatibility.unverifiable.title",
    "mco.compatibility.upgrade",
    "mco.compatibility.upgrade.description",
    "mco.compatibility.upgrade.friend.description",
    "mco.compatibility.upgrade.title",
    "mco.configure.current.minigame",
    "mco.configure.world.activityfeed.disabled",
    "mco.configure.world.backup",
    "mco.configure.world.buttons.activity",
    "mco.configure.world.buttons.close",
    "mco.configure.world.buttons.delete",
    "mco.configure.world.buttons.done",
    "mco.configure.world.buttons.edit",
    "mco.configure.world.buttons.invite",
    "mco.configure.world.buttons.moreoptions",
    "mco.configure.world.buttons.newworld",
    "mco.configure.world.buttons.open",
    "mco.configure.world.buttons.options",
    "mco.configure.world.buttons.players",
    "mco.configure.world.buttons.region_preference",
    "mco.configure.world.buttons.resetworld",
    "mco.configure.world.buttons.save",
    "mco.configure.world.buttons.settings",
    "mco.configure.world.buttons.subscription",
    "mco.configure.world.buttons.switchminigame",
    "mco.configure.world.close.question.line1",
    "mco.configure.world.close.question.line2",
    "mco.configure.world.close.question.title",
    "mco.configure.world.closing",
    "mco.configure.world.commandBlocks",
    "mco.configure.world.delete.button",
    "mco.configure.world.delete.question.line1",
    "mco.configure.world.delete.question.line2",
    "mco.configure.world.description",
    "mco.configure.world.edit.slot.name",
    "mco.configure.world.edit.subscreen.adventuremap",
    "mco.configure.world.edit.subscreen.experience",
    "mco.configure.world.edit.subscreen.inspiration",
    "mco.configure.world.forceGameMode",
    "mco.configure.world.invite.narration",
    "mco.configure.world.invite.profile.name",
    "mco.configure.world.invited",
    "mco.configure.world.invited.number",
    "mco.configure.world.invites.normal.tooltip",
    "mco.configure.world.invites.ops.tooltip",
    "mco.configure.world.invites.remove.tooltip",
    "mco.configure.world.leave.question.line1",
    "mco.configure.world.leave.question.line2",
    "mco.configure.world.loading",
    "mco.configure.world.location",
    "mco.configure.world.minigame",
    "mco.configure.world.name",
    "mco.configure.world.name.validation.whitespace",
    "mco.configure.world.opening",
    "mco.configure.world.players.error",
    "mco.configure.world.players.invite.duplicate",
    "mco.configure.world.players.inviting",
    "mco.configure.world.players.title",
    "mco.configure.world.pvp",
    "mco.configure.world.region_preference",
    "mco.configure.world.region_preference.title",
    "mco.configure.world.reset.question.line1",
    "mco.configure.world.reset.question.line2",
    "mco.configure.world.resourcepack.question",
    "mco.configure.world.resourcepack.question.line1",
    "mco.configure.world.resourcepack.question.line2",
    "mco.configure.world.restore.download.question.line1",
    "mco.configure.world.restore.download.question.line2",
    "mco.configure.world.restore.question.line1",
    "mco.configure.world.restore.question.line2",
    "mco.configure.world.settings.expired",
    "mco.configure.world.settings.title",
    "mco.configure.world.slot",
    "mco.configure.world.slot.empty",
    "mco.configure.world.slot.switch.question.line1",
    "mco.configure.world.slot.switch.question.line2",
    "mco.configure.world.slot.tooltip",
    "mco.configure.world.slot.tooltip.active",
    "mco.configure.world.slot.tooltip.minigame",
    "mco.configure.world.spawn_toggle.message",
    "mco.configure.world.spawn_toggle.message.npc",
    "mco.configure.world.spawn_toggle.title",
    "mco.configure.world.spawnAnimals",
    "mco.configure.world.spawnMonsters",
    "mco.configure.world.spawnNPCs",
    "mco.configure.world.spawnProtection",
    "mco.configure.world.status",
    "mco.configure.world.subscription.day",
    "mco.configure.world.subscription.days",
    "mco.configure.world.subscription.expired",
    "mco.configure.world.subscription.extend",
    "mco.configure.world.subscription.less_than_a_day",
    "mco.configure.world.subscription.month",
    "mco.configure.world.subscription.months",
    "mco.configure.world.subscription.recurring.daysleft",
    "mco.configure.world.subscription.recurring.info",
    "mco.configure.world.subscription.remaining.days",
    "mco.configure.world.subscription.remaining.months",
    "mco.configure.world.subscription.remaining.months.days",
    "mco.configure.world.subscription.start",
    "mco.configure.world.subscription.tab",
    "mco.configure.world.subscription.timeleft",
    "mco.configure.world.subscription.title",
    "mco.configure.world.subscription.unknown",
    "mco.configure.world.switch.slot",
    "mco.configure.world.switch.slot.subtitle",
    "mco.configure.world.title",
    "mco.configure.world.uninvite.player",
    "mco.configure.world.uninvite.question",
    "mco.configure.worlds.title",
    "mco.connect.authorizing",
    "mco.connect.connecting",
    "mco.connect.failed",
    "mco.connect.region",
    "mco.connect.success",
    "mco.create.world",
    "mco.create.world.error",
    "mco.create.world.failed",
    "mco.create.world.reset.title",
    "mco.create.world.skip",
    "mco.create.world.subtitle",
    "mco.create.world.wait",
    "mco.download.cancelled",
    "mco.download.confirmation.line1",
    "mco.download.confirmation.line2",
    "mco.download.confirmation.oversized",
    "mco.download.done",
    "mco.download.downloading",
    "mco.download.extracting",
    "mco.download.failed",
    "mco.download.percent",
    "mco.download.preparing",
    "mco.download.resourcePack.fail",
    "mco.download.speed",
    "mco.download.speed.narration",
    "mco.download.title",
    "mco.error.invalid.session.message",
    "mco.error.invalid.session.title",
    "mco.errorMessage.6001",
    "mco.errorMessage.6002",
    "mco.errorMessage.6003",
    "mco.errorMessage.6004",
    "mco.errorMessage.6005",
    "mco.errorMessage.6006",
    "mco.errorMessage.6007",
    "mco.errorMessage.6008",
    "mco.errorMessage.6009",
    "mco.errorMessage.connectionFailure",
    "mco.errorMessage.generic",
    "mco.errorMessage.initialize.failed",
    "mco.errorMessage.noDetails",
    "mco.errorMessage.realmsService",
    "mco.errorMessage.realmsService.configurationError",
    "mco.errorMessage.realmsService.connectivity",
    "mco.errorMessage.realmsService.realmsError",
    "mco.errorMessage.realmsService.unknownCompatibility",
    "mco.errorMessage.retry",
    "mco.errorMessage.serviceBusy",
    "mco.gui.button",
    "mco.gui.ok",
    "mco.info",
    "mco.invited.player.narration",
    "mco.invites.button.accept",
    "mco.invites.button.reject",
    "mco.invites.nopending",
    "mco.invites.pending",
    "mco.invites.title",
    "mco.minigame.world.changeButton",
    "mco.minigame.world.info.line1",
    "mco.minigame.world.info.line2",
    "mco.minigame.world.noSelection",
    "mco.minigame.world.restore",
    "mco.minigame.world.restore.question.line1",
    "mco.minigame.world.restore.question.line2",
    "mco.minigame.world.selected",
    "mco.minigame.world.slot.screen.title",
    "mco.minigame.world.startButton",
    "mco.minigame.world.starting.screen.title",
    "mco.minigame.world.stopButton",
    "mco.minigame.world.switch.new",
    "mco.minigame.world.switch.title",
    "mco.minigame.world.title",
    "mco.news",
    "mco.notification.dismiss",
    "mco.notification.transferSubscription.buttonText",
    "mco.notification.transferSubscription.message",
    "mco.notification.visitUrl.buttonText.default",
    "mco.notification.visitUrl.message.default",
    "mco.onlinePlayers",
    "mco.play.button.realm.closed",
    "mco.question",
    "mco.reset.world.adventure",
    "mco.reset.world.experience",
    "mco.reset.world.generate",
    "mco.reset.world.inspiration",
    "mco.reset.world.resetting.screen.title",
    "mco.reset.world.seed",
    "mco.reset.world.template",
    "mco.reset.world.title",
    "mco.reset.world.upload",
    "mco.reset.world.warning",
    "mco.selectServer.buy",
    "mco.selectServer.close",
    "mco.selectServer.closed",
    "mco.selectServer.closeserver",
    "mco.selectServer.configure",
    "mco.selectServer.configureRealm",
    "mco.selectServer.create",
    "mco.selectServer.create.subtitle",
    "mco.selectServer.expired",
    "mco.selectServer.expiredList",
    "mco.selectServer.expiredRenew",
    "mco.selectServer.expiredSubscribe",
    "mco.selectServer.expiredTrial",
    "mco.selectServer.expires.day",
    "mco.selectServer.expires.days",
    "mco.selectServer.expires.soon",
    "mco.selectServer.leave",
    "mco.selectServer.loading",
    "mco.selectServer.mapOnlySupportedForVersion",
    "mco.selectServer.minigame",
    "mco.selectServer.minigameName",
    "mco.selectServer.minigameNotSupportedInVersion",
    "mco.selectServer.noRealms",
    "mco.selectServer.note",
    "mco.selectServer.open",
    "mco.selectServer.openserver",
    "mco.selectServer.play",
    "mco.selectServer.popup",
    "mco.selectServer.purchase",
    "mco.selectServer.trial",
    "mco.selectServer.uninitialized",
    "mco.snapshot.createSnapshotPopup.text",
    "mco.snapshot.createSnapshotPopup.title",
    "mco.snapshot.creating",
    "mco.snapshot.description",
    "mco.snapshot.friendsRealm.downgrade",
    "mco.snapshot.friendsRealm.upgrade",
    "mco.snapshot.paired",
    "mco.snapshot.parent.tooltip",
    "mco.snapshot.start",
    "mco.snapshot.subscription.info",
    "mco.snapshot.tooltip",
    "mco.snapshotRealmsPopup.message",
    "mco.snapshotRealmsPopup.title",
    "mco.snapshotRealmsPopup.urlText",
    "mco.template.button.publisher",
    "mco.template.button.select",
    "mco.template.button.trailer",
    "mco.template.default.name",
    "mco.template.info.tooltip",
    "mco.template.name",
    "mco.template.select.failure",
    "mco.template.select.narrate.authors",
    "mco.template.select.narrate.version",
    "mco.template.select.none",
    "mco.template.select.none.linkTitle",
    "mco.template.title",
    "mco.template.title.minigame",
    "mco.template.trailer.tooltip",
    "mco.terms.buttons.agree",
    "mco.terms.buttons.disagree",
    "mco.terms.sentence.1",
    "mco.terms.sentence.2",
    "mco.terms.title",
    "mco.time.daysAgo",
    "mco.time.hoursAgo",
    "mco.time.minutesAgo",
    "mco.time.now",
    "mco.time.secondsAgo",
    "mco.trial.message.line1",
    "mco.trial.message.line2",
    "mco.upload.button.name",
    "mco.upload.cancelled",
    "mco.upload.close.failure",
    "mco.upload.done",
    "mco.upload.entry.cheats",
    "mco.upload.entry.commands",
    "mco.upload.entry.id",
    "mco.upload.failed",
    "mco.upload.failed.too_big.description",
    "mco.upload.failed.too_big.title",
    "mco.upload.hardcore",
    "mco.upload.percent",
    "mco.upload.preparing",
    "mco.upload.select.world.none",
    "mco.upload.select.world.subtitle",
    "mco.upload.select.world.title",
    "mco.upload.size.failure.line1",
    "mco.upload.size.failure.line2",
    "mco.upload.uploading",
    "mco.upload.verifying",
    "mco.version",
    "mco.warning",
    "mco.worldSlot.minigame",
    "menu.custom_options",
    "menu.custom_options.title",
    "menu.custom_options.tooltip",
    "menu.custom_screen_info.button_narration",
    "menu.custom_screen_info.contents",
    "menu.custom_screen_info.disconnect",
    "menu.custom_screen_info.title",
    "menu.custom_screen_info.tooltip",
    "menu.disconnect",
    "menu.feedback",
    "menu.feedback.title",
    "menu.game",
    "menu.modded",
    "menu.multiplayer",
    "menu.multiplayerOptions.applyChanges",
    "menu.multiplayerOptions.button",
    "menu.multiplayerOptions.lan",
    "menu.multiplayerOptions.network",
    "menu.multiplayerOptions.network.header",
    "menu.multiplayerOptions.network.lan",
    "menu.multiplayerOptions.network.lan.tooltip",
    "menu.multiplayerOptions.network.off",
    "menu.multiplayerOptions.network.off.tooltip",
    "menu.multiplayerOptions.network.online",
    "menu.multiplayerOptions.network.online.tooltip",
    "menu.multiplayerOptions.otherPlayers.header",
    "menu.multiplayerOptions.publish.started.lan",
    "menu.multiplayerOptions.publish.started.online",
    "menu.multiplayerOptions.publish.stopped",
    "menu.multiplayerOptions.title",
    "menu.online",
    "menu.options",
    "menu.paused",
    "menu.playdemo",
    "menu.playerReporting",
    "menu.playerReporting.no_players",
    "menu.preparingSpawn",
    "menu.quick_actions",
    "menu.quick_actions.title",
    "menu.quit",
    "menu.reportBugs",
    "menu.resetdemo",
    "menu.returnToGame",
    "menu.returnToMenu",
    "menu.savingChunks",
    "menu.savingLevel",
    "menu.sendFeedback",
    "menu.server_links",
    "menu.server_links.title",
    "menu.shareToLan",
    "menu.singleplayer",
    "menu.working",
    "merchant.deprecated",
    "merchant.level.1",
    "merchant.level.2",
    "merchant.level.3",
    "merchant.level.4",
    "merchant.level.5",
    "merchant.title",
    "merchant.trades",
    "mirror.front_back",
    "mirror.left_right",
    "mirror.none",
    "mount.onboard",
    "mount.sit",
    "multiplayer.applyingPack",
    "multiplayer.codeOfConduct.check",
    "multiplayer.codeOfConduct.title",
    "multiplayer.confirm_command.parse_errors",
    "multiplayer.confirm_command.permissions_required",
    "multiplayer.confirm_command.run_command",
    "multiplayer.confirm_command.signature_required",
    "multiplayer.confirm_command.suggest_command",
    "multiplayer.confirm_command.title",
    "multiplayer.disconnect.authservers_down",
    "multiplayer.disconnect.bad_chat_index",
    "multiplayer.disconnect.banned",
    "multiplayer.disconnect.banned_ip.expiration",
    "multiplayer.disconnect.banned_ip.reason",
    "multiplayer.disconnect.banned.expiration",
    "multiplayer.disconnect.banned.reason",
    "multiplayer.disconnect.banned.reason.default",
    "multiplayer.disconnect.chat_validation_failed",
    "multiplayer.disconnect.code_of_conduct",
    "multiplayer.disconnect.configuration_error",
    "multiplayer.disconnect.duplicate_login",
    "multiplayer.disconnect.expired_public_key",
    "multiplayer.disconnect.flying",
    "multiplayer.disconnect.generic",
    "multiplayer.disconnect.idling",
    "multiplayer.disconnect.illegal_characters",
    "multiplayer.disconnect.incompatible",
    "multiplayer.disconnect.invalid_entity_attacked",
    "multiplayer.disconnect.invalid_packet",
    "multiplayer.disconnect.invalid_player_data",
    "multiplayer.disconnect.invalid_player_movement",
    "multiplayer.disconnect.invalid_public_key_signature",
    "multiplayer.disconnect.invalid_public_key_signature.new",
    "multiplayer.disconnect.invalid_vehicle_movement",
    "multiplayer.disconnect.ip_banned",
    "multiplayer.disconnect.kicked",
    "multiplayer.disconnect.missing_tags",
    "multiplayer.disconnect.name_taken",
    "multiplayer.disconnect.not_whitelisted",
    "multiplayer.disconnect.out_of_order_chat",
    "multiplayer.disconnect.outdated_client",
    "multiplayer.disconnect.outdated_server",
    "multiplayer.disconnect.server_full",
    "multiplayer.disconnect.server_shutdown",
    "multiplayer.disconnect.slow_login",
    "multiplayer.disconnect.too_many_pending_chats",
    "multiplayer.disconnect.transfers_disabled",
    "multiplayer.disconnect.unexpected_query_response",
    "multiplayer.disconnect.unsigned_chat",
    "multiplayer.disconnect.unverified_username",
    "multiplayer.downloadingStats",
    "multiplayer.downloadingTerrain",
    "multiplayer.lan.server_found",
    "multiplayer.message_not_delivered",
    "multiplayer.player.joined",
    "multiplayer.player.joined.renamed",
    "multiplayer.player.left",
    "multiplayer.player.list.hp",
    "multiplayer.player.list.narration",
    "multiplayer.requiredTexturePrompt.disconnect",
    "multiplayer.requiredTexturePrompt.line1",
    "multiplayer.requiredTexturePrompt.line2",
    "multiplayer.socialInteractions.not_available",
    "multiplayer.status.and_more",
    "multiplayer.status.anonymous_player",
    "multiplayer.status.cancelled",
    "multiplayer.status.cannot_connect",
    "multiplayer.status.cannot_resolve",
    "multiplayer.status.finished",
    "multiplayer.status.incompatible",
    "multiplayer.status.motd.narration",
    "multiplayer.status.no_connection",
    "multiplayer.status.old",
    "multiplayer.status.online",
    "multiplayer.status.ping",
    "multiplayer.status.ping.narration",
    "multiplayer.status.pinging",
    "multiplayer.status.player_count",
    "multiplayer.status.player_count.narration",
    "multiplayer.status.quitting",
    "multiplayer.status.request_handled",
    "multiplayer.status.unknown",
    "multiplayer.status.unrequested",
    "multiplayer.status.version.narration",
    "multiplayer.stopSleeping",
    "multiplayer.texturePrompt.failure.line1",
    "multiplayer.texturePrompt.failure.line2",
    "multiplayer.texturePrompt.line1",
    "multiplayer.texturePrompt.line2",
    "multiplayer.texturePrompt.serverPrompt",
    "multiplayer.title",
    "multiplayer.unsecureserver.toast",
    "multiplayer.unsecureserver.toast.title",
    "multiplayerWarning.check",
    "multiplayerWarning.header",
    "multiplayerWarning.message",
    "music.game.a_familiar_room",
    "music.game.an_ordinary_day",
    "music.game.ancestry",
    "music.game.below_and_above",
    "music.game.broken_clocks",
    "music.game.bromeliad",
    "music.game.clark",
    "music.game.comforting_memories",
    "music.game.creative.aria_math",
    "music.game.creative.biome_fest",
    "music.game.creative.blind_spots",
    "music.game.creative.dreiton",
    "music.game.creative.haunt_muskie",
    "music.game.creative.taswell",
    "music.game.crescent_dunes",
    "music.game.danny",
    "music.game.deeper",
    "music.game.dry_hands",
    "music.game.ebb",
    "music.game.echo_in_the_wind",
    "music.game.eld_unknown",
    "music.game.end.alpha",
    "music.game.end.boss",
    "music.game.end.the_end",
    "music.game.endless",
    "music.game.featherfall",
    "music.game.fireflies",
    "music.game.floating_dream",
    "music.game.haggstrom",
    "music.game.home",
    "music.game.infinite_amethyst",
    "music.game.key",
    "music.game.komorebi",
    "music.game.left_to_bloom",
    "music.game.lilypad",
    "music.game.living_mice",
    "music.game.memories",
    "music.game.mice_on_venus",
    "music.game.minecraft",
    "music.game.nether.ballad_of_the_cats",
    "music.game.nether.concrete_halls",
    "music.game.nether.crimson_forest.chrysopoeia",
    "music.game.nether.dead_voxel",
    "music.game.nether.nether_wastes.rubedo",
    "music.game.nether.soulsand_valley.so_below",
    "music.game.nether.warmth",
    "music.game.nightly",
    "music.game.one_more_day",
    "music.game.os_piano",
    "music.game.oxygene",
    "music.game.pokopoko",
    "music.game.puzzlebox",
    "music.game.shores",
    "music.game.stand_tall",
    "music.game.subwoofer_lullaby",
    "music.game.swamp.aerie",
    "music.game.swamp.firebugs",
    "music.game.swamp.labyrinthine",
    "music.game.sweden",
    "music.game.watcher",
    "music.game.water.axolotl",
    "music.game.water.dragon_fish",
    "music.game.water.shuniji",
    "music.game.wending",
    "music.game.wet_hands",
    "music.game.yakusoku",
    "music.menu.beginning_2",
    "music.menu.floating_trees",
    "music.menu.moog_city_2",
    "music.menu.mutation",
    "narration.button",
    "narration.button.usage.focused",
    "narration.button.usage.hovered",
    "narration.checkbox",
    "narration.checkbox.usage.focused",
    "narration.checkbox.usage.focused.check",
    "narration.checkbox.usage.focused.uncheck",
    "narration.checkbox.usage.hovered",
    "narration.checkbox.usage.hovered.check",
    "narration.checkbox.usage.hovered.uncheck",
    "narration.component_list.usage",
    "narration.cycle_button.usage.focused",
    "narration.cycle_button.usage.hovered",
    "narration.edit_box",
    "narration.item",
    "narration.link.usage.focused",
    "narration.link.usage.hovered",
    "narration.recipe",
    "narration.recipe.usage",
    "narration.recipe.usage.more",
    "narration.selection.usage",
    "narration.slider.usage.focused",
    "narration.slider.usage.focused.keyboard_cannot_change_value",
    "narration.slider.usage.hovered",
    "narration.suggestion",
    "narration.suggestion.tooltip",
    "narration.suggestion.usage.cycle.fixed",
    "narration.suggestion.usage.cycle.hidable",
    "narration.suggestion.usage.fill.fixed",
    "narration.suggestion.usage.fill.hidable",
    "narration.tab_navigation.usage",
    "narrator.button.accessibility",
    "narrator.button.difficulty_lock",
    "narrator.button.difficulty_lock.locked",
    "narrator.button.difficulty_lock.unlocked",
    "narrator.button.language",
    "narrator.controls.bound",
    "narrator.controls.reset",
    "narrator.controls.unbound",
    "narrator.joining",
    "narrator.loading",
    "narrator.loading.done",
    "narrator.position.list",
    "narrator.position.object_list",
    "narrator.position.screen",
    "narrator.position.tab",
    "narrator.ready_to_play",
    "narrator.screen.title",
    "narrator.screen.usage",
    "narrator.select",
    "narrator.select.world",
    "narrator.select.world_info",
    "narrator.toast.disabled",
    "narrator.toast.enabled",
    "optimizeWorld.confirm.description",
    "optimizeWorld.confirm.proceed",
    "optimizeWorld.confirm.title",
    "optimizeWorld.info.converted",
    "optimizeWorld.info.skipped",
    "optimizeWorld.info.total",
    "optimizeWorld.progress.counter",
    "optimizeWorld.progress.percentage",
    "optimizeWorld.stage.counting",
    "optimizeWorld.stage.failed",
    "optimizeWorld.stage.finished",
    "optimizeWorld.stage.finished.chunks",
    "optimizeWorld.stage.finished.entities",
    "optimizeWorld.stage.finished.poi",
    "optimizeWorld.stage.upgrading",
    "optimizeWorld.stage.upgrading.chunks",
    "optimizeWorld.stage.upgrading.entities",
    "optimizeWorld.stage.upgrading.poi",
    "optimizeWorld.title",
    "options.accessibility",
    "options.accessibility.high_contrast",
    "options.accessibility.high_contrast_block_outline",
    "options.accessibility.high_contrast_block_outline.tooltip",
    "options.accessibility.high_contrast.error.tooltip",
    "options.accessibility.high_contrast.tooltip",
    "options.accessibility.link",
    "options.accessibility.menu_background_blurriness",
    "options.accessibility.menu_background_blurriness.tooltip",
    "options.accessibility.narrator_hotkey",
    "options.accessibility.narrator_hotkey.mac.tooltip",
    "options.accessibility.narrator_hotkey.tooltip",
    "options.accessibility.panorama_speed",
    "options.accessibility.text_background",
    "options.accessibility.text_background_opacity",
    "options.accessibility.text_background.chat",
    "options.accessibility.text_background.everywhere",
    "options.accessibility.title",
    "options.accessibility.tooltip",
    "options.allowCursorChanges",
    "options.allowCursorChanges.tooltip",
    "options.allowFriendRequests",
    "options.allowFriendRequests.tooltip",
    "options.allowServerListing",
    "options.allowServerListing.tooltip",
    "options.ao",
    "options.ao.max",
    "options.ao.min",
    "options.ao.off",
    "options.attack.crosshair",
    "options.attack.hotbar",
    "options.attackIndicator",
    "options.audioDevice",
    "options.audioDevice.default",
    "options.autoJump",
    "options.autosaveIndicator",
    "options.autoSuggestCommands",
    "options.biomeBlendRadius",
    "options.biomeBlendRadius.1",
    "options.biomeBlendRadius.3",
    "options.biomeBlendRadius.5",
    "options.biomeBlendRadius.7",
    "options.biomeBlendRadius.9",
    "options.biomeBlendRadius.11",
    "options.biomeBlendRadius.13",
    "options.biomeBlendRadius.15",
    "options.blocks",
    "options.chat",
    "options.chat.color",
    "options.chat.delay",
    "options.chat.delay_none",
    "options.chat.drafts",
    "options.chat.drafts.tooltip",
    "options.chat.height.focused",
    "options.chat.height.unfocused",
    "options.chat.line_spacing",
    "options.chat.links",
    "options.chat.links.prompt",
    "options.chat.opacity",
    "options.chat.scale",
    "options.chat.title",
    "options.chat.visibility",
    "options.chat.visibility.full",
    "options.chat.visibility.hidden",
    "options.chat.visibility.system",
    "options.chat.width",
    "options.chunkFade",
    "options.chunkFade.none",
    "options.chunkFade.seconds",
    "options.chunkFade.tooltip",
    "options.chunks",
    "options.clouds.fancy",
    "options.clouds.fast",
    "options.controls",
    "options.credits_and_attribution",
    "options.cutoutLeaves",
    "options.cutoutLeaves.tooltip",
    "options.damageTiltStrength",
    "options.damageTiltStrength.tooltip",
    "options.darkMojangStudiosBackgroundColor",
    "options.darkMojangStudiosBackgroundColor.tooltip",
    "options.darknessEffectScale",
    "options.darknessEffectScale.tooltip",
    "options.debugGuiScale.tooltip",
    "options.debugGuiScale.unchanged",
    "options.difficulty",
    "options.difficulty.easy",
    "options.difficulty.easy.info",
    "options.difficulty.hard",
    "options.difficulty.hard.info",
    "options.difficulty.hardcore",
    "options.difficulty.normal",
    "options.difficulty.normal.info",
    "options.difficulty.online",
    "options.difficulty.peaceful",
    "options.difficulty.peaceful.info",
    "options.directionalAudio",
    "options.directionalAudio.off.tooltip",
    "options.directionalAudio.on.tooltip",
    "options.discrete_mouse_scroll",
    "options.entityDistanceScaling",
    "options.entityShadows",
    "options.exclusiveFullscreen",
    "options.exclusiveFullscreen.off.tooltip",
    "options.exclusiveFullscreen.on.tooltip",
    "options.exclusiveFullscreen.warningTooltip",
    "options.font",
    "options.font.title",
    "options.forceUnicodeFont",
    "options.fov",
    "options.fov.max",
    "options.fov.min",
    "options.fovEffectScale",
    "options.fovEffectScale.tooltip",
    "options.framerate",
    "options.framerateLimit",
    "options.framerateLimit.max",
    "options.friendsList",
    "options.friendsList.confirm.message",
    "options.friendsList.confirm.message.link",
    "options.friendsList.confirm.title",
    "options.friendsList.confirm.turnOff",
    "options.friendsList.confirm.turnOn",
    "options.fullscreen",
    "options.fullscreen.current",
    "options.fullscreen.entry",
    "options.fullscreen.exclusive.mode",
    "options.fullscreen.resolution",
    "options.fullscreen.unavailable",
    "options.gamma",
    "options.gamma.default",
    "options.gamma.max",
    "options.gamma.min",
    "options.generic_value",
    "options.glintSpeed",
    "options.glintSpeed.tooltip",
    "options.glintStrength",
    "options.glintStrength.tooltip",
    "options.graphics",
    "options.graphics.custom",
    "options.graphics.fabulous",
    "options.graphics.fabulous.tooltip",
    "options.graphics.fancy",
    "options.graphics.fancy.tooltip",
    "options.graphics.fast",
    "options.graphics.fast.tooltip",
    "options.graphics.preset",
    "options.graphics.preset.tooltip",
    "options.graphics.warning.accept",
    "options.graphics.warning.cancel",
    "options.graphics.warning.message",
    "options.graphics.warning.renderer",
    "options.graphics.warning.title",
    "options.graphics.warning.vendor",
    "options.graphics.warning.version",
    "options.graphicsApi",
    "options.graphicsApi.default",
    "options.graphicsApi.opengl",
    "options.graphicsApi.restart",
    "options.graphicsApi.tooltip",
    "options.graphicsApi.tooltip.vulkan",
    "options.graphicsApi.vulkan",
    "options.guiScale",
    "options.guiScale.auto",
    "options.hidden",
    "options.hideLightningFlashes",
    "options.hideLightningFlashes.tooltip",
    "options.hideMatchedNames",
    "options.hideMatchedNames.tooltip",
    "options.hideSplashTexts",
    "options.hideSplashTexts.tooltip",
    "options.improvedTransparency",
    "options.improvedTransparency.oit.tooltip",
    "options.improvedTransparency.tooltip",
    "options.inactivityFpsLimit",
    "options.inactivityFpsLimit.afk",
    "options.inactivityFpsLimit.afk.tooltip",
    "options.inactivityFpsLimit.minimized",
    "options.inactivityFpsLimit.minimized.tooltip",
    "options.inGameNotification",
    "options.inGameNotification.tooltip",
    "options.invertMouse",
    "options.invertMouseX",
    "options.invertMouseY",
    "options.japaneseGlyphVariants",
    "options.japaneseGlyphVariants.tooltip",
    "options.key.hold",
    "options.key.toggle",
    "options.language",
    "options.language.empty_or_missing_translation",
    "options.language.load_translations_failed",
    "options.language.narration",
    "options.language.title",
    "options.language.tooltip",
    "options.languageAccuracyWarning",
    "options.languageWarning",
    "options.mainHand",
    "options.mainHand.left",
    "options.mainHand.right",
    "options.maxAnisotropy",
    "options.maxAnisotropy.tooltip",
    "options.mipmapLevels",
    "options.modelPart.cape",
    "options.modelPart.hat",
    "options.modelPart.jacket",
    "options.modelPart.left_pants_leg",
    "options.modelPart.left_sleeve",
    "options.modelPart.right_pants_leg",
    "options.modelPart.right_sleeve",
    "options.mouse_settings",
    "options.mouse_settings.title",
    "options.mouseWheelSensitivity",
    "options.multiplayer.title",
    "options.multiplier",
    "options.music_frequency",
    "options.music_frequency.constant",
    "options.music_frequency.default",
    "options.music_frequency.frequent",
    "options.music_frequency.tooltip",
    "options.musicToast",
    "options.musicToast.never",
    "options.musicToast.never.tooltip",
    "options.musicToast.pauseMenu",
    "options.musicToast.pauseMenu.tooltip",
    "options.musicToast.pauseMenuAndToast",
    "options.musicToast.pauseMenuAndToast.tooltip",
    "options.narrator",
    "options.narrator.all",
    "options.narrator.chat",
    "options.narrator.notavailable",
    "options.narrator.off",
    "options.narrator.system",
    "options.needsRestart",
    "options.notifications.display_time",
    "options.notifications.display_time.tooltip",
    "options.off",
    "options.off.composed",
    "options.on",
    "options.on.composed",
    "options.online",
    "options.online.friends.header",
    "options.online.realms.header",
    "options.online.servers.header",
    "options.online.title",
    "options.online.xboxSettings",
    "options.onlyShowSecureChat",
    "options.onlyShowSecureChat.tooltip",
    "options.operatorItemsTab",
    "options.particles",
    "options.particles.all",
    "options.particles.decreased",
    "options.particles.minimal",
    "options.percent_add_value",
    "options.percent_value",
    "options.pixel_value",
    "options.prioritizeChunkUpdates",
    "options.prioritizeChunkUpdates.byPlayer",
    "options.prioritizeChunkUpdates.byPlayer.tooltip",
    "options.prioritizeChunkUpdates.nearby",
    "options.prioritizeChunkUpdates.nearby.tooltip",
    "options.prioritizeChunkUpdates.none",
    "options.prioritizeChunkUpdates.none.tooltip",
    "options.quitShortcuts",
    "options.quitShortcuts.tooltip",
    "options.rawMouseInput",
    "options.realmsNotifications",
    "options.realmsNotifications.button",
    "options.realmsNotifications.tooltip",
    "options.reducedDebugInfo",
    "options.renderClouds",
    "options.renderCloudsDistance",
    "options.renderDistance",
    "options.resourcepack",
    "options.restartRequired",
    "options.rotateWithMinecart",
    "options.rotateWithMinecart.tooltip",
    "options.screenEffectScale",
    "options.screenEffectScale.tooltip",
    "options.sensitivity",
    "options.sensitivity.max",
    "options.sensitivity.min",
    "options.sharePresence",
    "options.sharePresence.all",
    "options.sharePresence.all.tooltip",
    "options.sharePresence.limited",
    "options.sharePresence.limited.tooltip",
    "options.sharePresence.none",
    "options.sharePresence.none.tooltip",
    "options.showNowPlayingToast",
    "options.showNowPlayingToast.tooltip",
    "options.showSubtitles",
    "options.showSubtitles.tooltip",
    "options.simulationDistance",
    "options.skinCustomisation",
    "options.skinCustomisation.title",
    "options.sounds",
    "options.sounds.title",
    "options.sprintWindow",
    "options.sprintWindow.tooltip",
    "options.telemetry",
    "options.telemetry.button",
    "options.telemetry.button.tooltip",
    "options.telemetry.disabled",
    "options.telemetry.state.all",
    "options.telemetry.state.minimal",
    "options.telemetry.state.none",
    "options.textureFiltering",
    "options.textureFiltering.anisotropic",
    "options.textureFiltering.anisotropic.tooltip",
    "options.textureFiltering.none",
    "options.textureFiltering.none.tooltip",
    "options.textureFiltering.rgss",
    "options.textureFiltering.rgss.tooltip",
    "options.title",
    "options.touchscreen",
    "options.value",
    "options.video",
    "options.video.display.header",
    "options.video.interface.header",
    "options.video.preferences.header",
    "options.video.quality.header",
    "options.videoTitle",
    "options.viewBobbing",
    "options.vignette",
    "options.vignette.tooltip",
    "options.visible",
    "options.vsync",
    "options.weatherRadius",
    "options.weatherRadius.tooltip",
    "options.worldOptions.allow_commands.disabled.demo.tooltip",
    "options.worldOptions.allow_commands.disabled.tooltip",
    "options.worldOptions.button",
    "options.worldOptions.difficulty.disabled.hardcore.tooltip",
    "options.worldOptions.difficulty.disabled.locked.tooltip",
    "options.worldOptions.difficulty.disabled.operator.tooltip",
    "options.worldOptions.game_mode.disabled.operator.tooltip",
    "options.worldOptions.game_mode.disabled.tooltip",
    "options.worldOptions.general.title",
    "options.worldOptions.guest.command_access",
    "options.worldOptions.guest.command_access.disabled.commands.tooltip",
    "options.worldOptions.guest.command_access.disabled.scope.tooltip",
    "options.worldOptions.guest.command_access.tooltip",
    "options.worldOptions.multiplayer.title",
    "options.worldOptions.title",
    "outOfMemory.message",
    "outOfMemory.title",
    "pack.available.title",
    "pack.copyFailure",
    "pack.dropConfirm",
    "pack.dropInfo",
    "pack.dropRejected.message",
    "pack.dropRejected.title",
    "pack.folderInfo",
    "pack.incompatible",
    "pack.incompatible.confirm.new",
    "pack.incompatible.confirm.old",
    "pack.incompatible.confirm.title",
    "pack.incompatible.confirm.unknown",
    "pack.incompatible.new",
    "pack.incompatible.old",
    "pack.incompatible.unknown",
    "pack.nameAndSource",
    "pack.openFolder",
    "pack.selected.title",
    "pack.source.builtin",
    "pack.source.feature",
    "pack.source.local",
    "pack.source.server",
    "pack.source.world",
    "painting.dimensions",
    "painting.minecraft.alban.author",
    "painting.minecraft.alban.title",
    "painting.minecraft.aztec.author",
    "painting.minecraft.aztec.title",
    "painting.minecraft.aztec2.author",
    "painting.minecraft.aztec2.title",
    "painting.minecraft.backyard.author",
    "painting.minecraft.backyard.title",
    "painting.minecraft.baroque.author",
    "painting.minecraft.baroque.title",
    "painting.minecraft.bomb.author",
    "painting.minecraft.bomb.title",
    "painting.minecraft.bouquet.author",
    "painting.minecraft.bouquet.title",
    "painting.minecraft.burning_skull.author",
    "painting.minecraft.burning_skull.title",
    "painting.minecraft.bust.author",
    "painting.minecraft.bust.title",
    "painting.minecraft.cavebird.author",
    "painting.minecraft.cavebird.title",
    "painting.minecraft.changing.author",
    "painting.minecraft.changing.title",
    "painting.minecraft.cotan.author",
    "painting.minecraft.cotan.title",
    "painting.minecraft.courbet.author",
    "painting.minecraft.courbet.title",
    "painting.minecraft.creebet.author",
    "painting.minecraft.creebet.title",
    "painting.minecraft.dennis.author",
    "painting.minecraft.dennis.title",
    "painting.minecraft.donkey_kong.author",
    "painting.minecraft.donkey_kong.title",
    "painting.minecraft.earth.author",
    "painting.minecraft.earth.title",
    "painting.minecraft.endboss.author",
    "painting.minecraft.endboss.title",
    "painting.minecraft.fern.author",
    "painting.minecraft.fern.title",
    "painting.minecraft.fighters.author",
    "painting.minecraft.fighters.title",
    "painting.minecraft.finding.author",
    "painting.minecraft.finding.title",
    "painting.minecraft.fire.author",
    "painting.minecraft.fire.title",
    "painting.minecraft.graham.author",
    "painting.minecraft.graham.title",
    "painting.minecraft.humble.author",
    "painting.minecraft.humble.title",
    "painting.minecraft.kebab.author",
    "painting.minecraft.kebab.title",
    "painting.minecraft.lowmist.author",
    "painting.minecraft.lowmist.title",
    "painting.minecraft.match.author",
    "painting.minecraft.match.title",
    "painting.minecraft.meditative.author",
    "painting.minecraft.meditative.title",
    "painting.minecraft.orb.author",
    "painting.minecraft.orb.title",
    "painting.minecraft.owlemons.author",
    "painting.minecraft.owlemons.title",
    "painting.minecraft.passage.author",
    "painting.minecraft.passage.title",
    "painting.minecraft.pigscene.author",
    "painting.minecraft.pigscene.title",
    "painting.minecraft.plant.author",
    "painting.minecraft.plant.title",
    "painting.minecraft.pointer.author",
    "painting.minecraft.pointer.title",
    "painting.minecraft.pond.author",
    "painting.minecraft.pond.title",
    "painting.minecraft.pool.author",
    "painting.minecraft.pool.title",
    "painting.minecraft.prairie_ride.author",
    "painting.minecraft.prairie_ride.title",
    "painting.minecraft.sea.author",
    "painting.minecraft.sea.title",
    "painting.minecraft.skeleton.author",
    "painting.minecraft.skeleton.title",
    "painting.minecraft.skull_and_roses.author",
    "painting.minecraft.skull_and_roses.title",
    "painting.minecraft.stage.author",
    "painting.minecraft.stage.title",
    "painting.minecraft.sunflowers.author",
    "painting.minecraft.sunflowers.title",
    "painting.minecraft.sunset.author",
    "painting.minecraft.sunset.title",
    "painting.minecraft.tides.author",
    "painting.minecraft.tides.title",
    "painting.minecraft.unpacked.author",
    "painting.minecraft.unpacked.title",
    "painting.minecraft.void.author",
    "painting.minecraft.void.title",
    "painting.minecraft.wanderer.author",
    "painting.minecraft.wanderer.title",
    "painting.minecraft.wasteland.author",
    "painting.minecraft.wasteland.title",
    "painting.minecraft.water.author",
    "painting.minecraft.water.title",
    "painting.minecraft.wind.author",
    "painting.minecraft.wind.title",
    "painting.minecraft.wither.author",
    "painting.minecraft.wither.title",
    "painting.random",
    "parsing.bool.expected",
    "parsing.bool.invalid",
    "parsing.double.expected",
    "parsing.double.invalid",
    "parsing.expected",
    "parsing.float.expected",
    "parsing.float.invalid",
    "parsing.int.expected",
    "parsing.int.invalid",
    "parsing.long.expected",
    "parsing.long.invalid",
    "parsing.quote.escape",
    "parsing.quote.expected.end",
    "parsing.quote.expected.start",
    "particle.invalidOptions",
    "particle.notFound",
    "permissions.requires.entity",
    "permissions.requires.player",
    "potion.potency.0",
    "potion.potency.1",
    "potion.potency.2",
    "potion.potency.3",
    "potion.potency.4",
    "potion.potency.5",
    "potion.whenDrank",
    "potion.withAmplifier",
    "potion.withDuration",
    "predicate.unknown",
    "quickplay.error.invalid_identifier",
    "quickplay.error.realm_connect",
    "quickplay.error.realm_permission",
    "quickplay.error.title",
    "realms.configuration.region_preference.automatic_owner",
    "realms.configuration.region_preference.automatic_player",
    "realms.configuration.region.australia_east",
    "realms.configuration.region.australia_southeast",
    "realms.configuration.region.brazil_south",
    "realms.configuration.region.canada_central",
    "realms.configuration.region.central_india",
    "realms.configuration.region.central_us",
    "realms.configuration.region.east_asia",
    "realms.configuration.region.east_us",
    "realms.configuration.region.east_us_2",
    "realms.configuration.region.france_central",
    "realms.configuration.region.japan_east",
    "realms.configuration.region.japan_west",
    "realms.configuration.region.korea_central",
    "realms.configuration.region.mexico_central",
    "realms.configuration.region.north_central_us",
    "realms.configuration.region.north_europe",
    "realms.configuration.region.south_africa_north",
    "realms.configuration.region.south_central_us",
    "realms.configuration.region.southeast_asia",
    "realms.configuration.region.sweden_central",
    "realms.configuration.region.uae_north",
    "realms.configuration.region.uk_south",
    "realms.configuration.region.west_central_us",
    "realms.configuration.region.west_europe",
    "realms.configuration.region.west_us",
    "realms.configuration.region.west_us_2",
    "realms.configuration.region.west_us_3",
    "realms.missing.snapshot.error.text",
    "recipe.notFound",
    "recipe.toast.description",
    "recipe.toast.title",
    "record.nowPlaying",
    "recover_world.bug_tracker",
    "recover_world.button",
    "recover_world.done.failed",
    "recover_world.done.success",
    "recover_world.done.title",
    "recover_world.issue.missing_file",
    "recover_world.issue.none",
    "recover_world.message",
    "recover_world.no_fallback",
    "recover_world.restore",
    "recover_world.restoring",
    "recover_world.state_entry",
    "recover_world.state_entry.unknown",
    "recover_world.title",
    "recover_world.warning",
    "resourcePack.broken_assets",
    "resourcepack.downloading",
    "resourcePack.high_contrast.name",
    "resourcePack.load_fail",
    "resourcePack.programmer_art.name",
    "resourcepack.progress",
    "resourcepack.requesting",
    "resourcePack.runtime_failure",
    "resourcePack.server.name",
    "resourcePack.title",
    "resourcePack.vanilla.description",
    "resourcePack.vanilla.name",
    "restrictions_screen.button",
    "restrictions_screen.permission.receive_player_messages.allowed",
    "restrictions_screen.permission.receive_player_messages.denied",
    "restrictions_screen.permission.receive_system_messages.allowed",
    "restrictions_screen.permission.receive_system_messages.denied",
    "restrictions_screen.permission.send_commands.allowed",
    "restrictions_screen.permission.send_commands.denied",
    "restrictions_screen.permission.send_messages.allowed",
    "restrictions_screen.permission.send_messages.denied",
    "restrictions_screen.title",
    "screenshot.failure",
    "screenshot.success",
    "selecteWorld.backupRequiredTooltip",
    "selectServer.add",
    "selectServer.defaultName",
    "selectServer.delete",
    "selectServer.deleteButton",
    "selectServer.deleteQuestion",
    "selectServer.deleteWarning",
    "selectServer.direct",
    "selectServer.edit",
    "selectServer.hiddenAddress",
    "selectServer.refresh",
    "selectServer.select",
    "selectWorld.access_failure",
    "selectWorld.allowCommands",
    "selectWorld.allowCommands.info",
    "selectWorld.allowCommands.new",
    "selectWorld.backupEraseCache",
    "selectWorld.backupJoinConfirmButton",
    "selectWorld.backupJoinSkipButton",
    "selectWorld.backupQuestion.customized",
    "selectWorld.backupQuestion.downgrade",
    "selectWorld.backupQuestion.experimental",
    "selectWorld.backupQuestion.file_fixing_required",
    "selectWorld.backupQuestion.snapshot",
    "selectWorld.backupWarning.customized",
    "selectWorld.backupWarning.downgrade",
    "selectWorld.backupWarning.experimental",
    "selectWorld.backupWarning.file_fixing_required",
    "selectWorld.backupWarning.snapshot",
    "selectWorld.bonusItems",
    "selectWorld.cheats",
    "selectWorld.commands",
    "selectWorld.conversion",
    "selectWorld.conversion.tooltip",
    "selectWorld.create",
    "selectWorld.customizeType",
    "selectWorld.data_read",
    "selectWorld.dataPacks",
    "selectWorld.delete",
    "selectWorld.delete_failure",
    "selectWorld.deleteButton",
    "selectWorld.deleteQuestion",
    "selectWorld.deleteWarning",
    "selectWorld.edit",
    "selectWorld.edit.backup",
    "selectWorld.edit.backupCreated",
    "selectWorld.edit.backupFailed",
    "selectWorld.edit.backupFolder",
    "selectWorld.edit.backupSize",
    "selectWorld.edit.export_worldgen_settings",
    "selectWorld.edit.export_worldgen_settings.failure",
    "selectWorld.edit.export_worldgen_settings.success",
    "selectWorld.edit.openFolder",
    "selectWorld.edit.optimize",
    "selectWorld.edit.resetIcon",
    "selectWorld.edit.save",
    "selectWorld.edit.title",
    "selectWorld.enterName",
    "selectWorld.enterSeed",
    "selectWorld.experimental",
    "selectWorld.experimental.details",
    "selectWorld.experimental.details.entry",
    "selectWorld.experimental.details.title",
    "selectWorld.experimental.message",
    "selectWorld.experimental.title",
    "selectWorld.experiments",
    "selectWorld.experiments.info",
    "selectWorld.futureworld.error.text",
    "selectWorld.futureworld.error.title",
    "selectWorld.gameMode",
    "selectWorld.gameMode.adventure",
    "selectWorld.gameMode.adventure.info",
    "selectWorld.gameMode.adventure.line1",
    "selectWorld.gameMode.adventure.line2",
    "selectWorld.gameMode.creative",
    "selectWorld.gameMode.creative.info",
    "selectWorld.gameMode.creative.line1",
    "selectWorld.gameMode.creative.line2",
    "selectWorld.gameMode.hardcore",
    "selectWorld.gameMode.hardcore.info",
    "selectWorld.gameMode.hardcore.line1",
    "selectWorld.gameMode.hardcore.line2",
    "selectWorld.gameMode.spectator",
    "selectWorld.gameMode.spectator.info",
    "selectWorld.gameMode.spectator.line1",
    "selectWorld.gameMode.spectator.line2",
    "selectWorld.gameMode.survival",
    "selectWorld.gameMode.survival.info",
    "selectWorld.gameMode.survival.line1",
    "selectWorld.gameMode.survival.line2",
    "selectWorld.gameRules",
    "selectWorld.import_worldgen_settings",
    "selectWorld.import_worldgen_settings.failure",
    "selectWorld.import_worldgen_settings.select_file",
    "selectWorld.incompatible_series",
    "selectWorld.incompatible.description",
    "selectWorld.incompatible.info",
    "selectWorld.incompatible.title",
    "selectWorld.incompatible.tooltip",
    "selectWorld.load_folder_access",
    "selectWorld.loading_list",
    "selectWorld.locked",
    "selectWorld.mapFeatures",
    "selectWorld.mapFeatures.info",
    "selectWorld.mapType",
    "selectWorld.mapType.normal",
    "selectWorld.moreWorldOptions",
    "selectWorld.newWorld",
    "selectWorld.recreate",
    "selectWorld.recreate.customized.text",
    "selectWorld.recreate.customized.title",
    "selectWorld.recreate.error.text",
    "selectWorld.recreate.error.title",
    "selectWorld.requiresFileFixingTooltip.edit",
    "selectWorld.requiresFileFixingTooltip.play",
    "selectWorld.requiresFileFixingTooltip.recreate",
    "selectWorld.resource_load",
    "selectWorld.resultFolder",
    "selectWorld.search",
    "selectWorld.seedInfo",
    "selectWorld.select",
    "selectWorld.targetFolder",
    "selectWorld.title",
    "selectWorld.tooltip.fromNewerVersion1",
    "selectWorld.tooltip.fromNewerVersion2",
    "selectWorld.tooltip.snapshot1",
    "selectWorld.tooltip.snapshot2",
    "selectWorld.unable_to_load",
    "selectWorld.upgrade_and_play",
    "selectWorld.version",
    "selectWorld.versionJoinButton",
    "selectWorld.versionQuestion",
    "selectWorld.versionUnknown",
    "selectWorld.versionWarning",
    "selectWorld.waitingForBackup.message",
    "selectWorld.waitingForBackup.title",
    "selectWorld.warning.deprecated.question",
    "selectWorld.warning.deprecated.title",
    "selectWorld.warning.experimental.question",
    "selectWorld.warning.experimental.title",
    "selectWorld.warning.lowDiskSpace.description",
    "selectWorld.warning.lowDiskSpace.title",
    "selectWorld.world",
    "selectWorld.world_gen_settings_access",
    "sign.back_text",
    "sign.click_actions_disabled",
    "sign.edit",
    "sign.front_text",
    "sleep.not_possible",
    "sleep.players_sleeping",
    "sleep.skipping_night",
    "slot.only_single_allowed",
    "slot.unknown",
    "snbt.parser.empty_key",
    "snbt.parser.expected_binary_numeral",
    "snbt.parser.expected_decimal_numeral",
    "snbt.parser.expected_float_type",
    "snbt.parser.expected_hex_escape",
    "snbt.parser.expected_hex_numeral",
    "snbt.parser.expected_integer_type",
    "snbt.parser.expected_non_negative_number",
    "snbt.parser.expected_number_or_boolean",
    "snbt.parser.expected_string_uuid",
    "snbt.parser.expected_unquoted_string",
    "snbt.parser.infinity_not_allowed",
    "snbt.parser.invalid_array_element_type",
    "snbt.parser.invalid_character_name",
    "snbt.parser.invalid_codepoint",
    "snbt.parser.invalid_string_contents",
    "snbt.parser.invalid_unquoted_start",
    "snbt.parser.leading_zero_not_allowed",
    "snbt.parser.no_such_operation",
    "snbt.parser.number_parse_failure",
    "snbt.parser.undescore_not_allowed",
    "soundCategory.ambient",
    "soundCategory.block",
    "soundCategory.hostile",
    "soundCategory.master",
    "soundCategory.music",
    "soundCategory.neutral",
    "soundCategory.player",
    "soundCategory.record",
    "soundCategory.ui",
    "soundCategory.voice",
    "soundCategory.weather",
    "spectator.cannot_teleport",
    "spectatorMenu.close",
    "spectatorMenu.next_page",
    "spectatorMenu.previous_page",
    "spectatorMenu.root.prompt",
    "spectatorMenu.team_teleport",
    "spectatorMenu.team_teleport.prompt",
    "spectatorMenu.teleport",
    "spectatorMenu.teleport.prompt",
    "stat_type.minecraft.broken",
    "stat_type.minecraft.crafted",
    "stat_type.minecraft.dropped",
    "stat_type.minecraft.killed",
    "stat_type.minecraft.killed_by",
    "stat_type.minecraft.killed_by.none",
    "stat_type.minecraft.killed.none",
    "stat_type.minecraft.mined",
    "stat_type.minecraft.picked_up",
    "stat_type.minecraft.used",
    "stat.generalButton",
    "stat.itemsButton",
    "stat.minecraft.animals_bred",
    "stat.minecraft.aviate_one_cm",
    "stat.minecraft.bell_ring",
    "stat.minecraft.boat_one_cm",
    "stat.minecraft.clean_armor",
    "stat.minecraft.clean_banner",
    "stat.minecraft.clean_shulker_box",
    "stat.minecraft.climb_one_cm",
    "stat.minecraft.crouch_one_cm",
    "stat.minecraft.damage_absorbed",
    "stat.minecraft.damage_blocked_by_shield",
    "stat.minecraft.damage_dealt",
    "stat.minecraft.damage_dealt_absorbed",
    "stat.minecraft.damage_dealt_resisted",
    "stat.minecraft.damage_resisted",
    "stat.minecraft.damage_taken",
    "stat.minecraft.deaths",
    "stat.minecraft.drop",
    "stat.minecraft.eat_cake_slice",
    "stat.minecraft.enchant_item",
    "stat.minecraft.fall_one_cm",
    "stat.minecraft.fill_cauldron",
    "stat.minecraft.fish_caught",
    "stat.minecraft.fly_one_cm",
    "stat.minecraft.happy_ghast_one_cm",
    "stat.minecraft.horse_one_cm",
    "stat.minecraft.inspect_dispenser",
    "stat.minecraft.inspect_dropper",
    "stat.minecraft.inspect_hopper",
    "stat.minecraft.interact_with_anvil",
    "stat.minecraft.interact_with_beacon",
    "stat.minecraft.interact_with_blast_furnace",
    "stat.minecraft.interact_with_brewingstand",
    "stat.minecraft.interact_with_campfire",
    "stat.minecraft.interact_with_cartography_table",
    "stat.minecraft.interact_with_crafting_table",
    "stat.minecraft.interact_with_furnace",
    "stat.minecraft.interact_with_grindstone",
    "stat.minecraft.interact_with_lectern",
    "stat.minecraft.interact_with_loom",
    "stat.minecraft.interact_with_smithing_table",
    "stat.minecraft.interact_with_smoker",
    "stat.minecraft.interact_with_stonecutter",
    "stat.minecraft.jump",
    "stat.minecraft.leave_game",
    "stat.minecraft.minecart_one_cm",
    "stat.minecraft.mob_kills",
    "stat.minecraft.nautilus_one_cm",
    "stat.minecraft.open_barrel",
    "stat.minecraft.open_chest",
    "stat.minecraft.open_enderchest",
    "stat.minecraft.open_shulker_box",
    "stat.minecraft.pig_one_cm",
    "stat.minecraft.play_noteblock",
    "stat.minecraft.play_record",
    "stat.minecraft.play_time",
    "stat.minecraft.player_kills",
    "stat.minecraft.pot_flower",
    "stat.minecraft.raid_trigger",
    "stat.minecraft.raid_win",
    "stat.minecraft.sleep_in_bed",
    "stat.minecraft.sleep_in_straw_bed",
    "stat.minecraft.sneak_time",
    "stat.minecraft.sprint_one_cm",
    "stat.minecraft.strider_one_cm",
    "stat.minecraft.swim_one_cm",
    "stat.minecraft.talked_to_villager",
    "stat.minecraft.target_hit",
    "stat.minecraft.time_since_death",
    "stat.minecraft.time_since_rest",
    "stat.minecraft.total_world_time",
    "stat.minecraft.traded_with_villager",
    "stat.minecraft.trigger_trapped_chest",
    "stat.minecraft.tune_noteblock",
    "stat.minecraft.use_cauldron",
    "stat.minecraft.walk_on_water_one_cm",
    "stat.minecraft.walk_one_cm",
    "stat.minecraft.walk_under_water_one_cm",
    "stat.mobsButton",
    "stats.none",
    "structure_block.button.detect_size",
    "structure_block.button.load",
    "structure_block.button.save",
    "structure_block.custom_data",
    "structure_block.detect_size",
    "structure_block.hover.corner",
    "structure_block.hover.data",
    "structure_block.hover.load",
    "structure_block.hover.save",
    "structure_block.include_entities",
    "structure_block.integrity",
    "structure_block.integrity.integrity",
    "structure_block.integrity.seed",
    "structure_block.invalid_structure_name",
    "structure_block.load_not_found",
    "structure_block.load_prepare",
    "structure_block.load_success",
    "structure_block.mode_info.corner",
    "structure_block.mode_info.data",
    "structure_block.mode_info.load",
    "structure_block.mode_info.save",
    "structure_block.mode.corner",
    "structure_block.mode.data",
    "structure_block.mode.load",
    "structure_block.mode.save",
    "structure_block.position",
    "structure_block.position.x",
    "structure_block.position.y",
    "structure_block.position.z",
    "structure_block.save_failure",
    "structure_block.save_success",
    "structure_block.show_air",
    "structure_block.show_boundingbox",
    "structure_block.size",
    "structure_block.size_failure",
    "structure_block.size_success",
    "structure_block.size.x",
    "structure_block.size.y",
    "structure_block.size.z",
    "structure_block.strict",
    "structure_block.structure_name",
    "subtitles.ambient.cave",
    "subtitles.ambient.sound",
    "subtitles.block.amethyst_block.chime",
    "subtitles.block.amethyst_block.resonate",
    "subtitles.block.anvil.destroy",
    "subtitles.block.anvil.land",
    "subtitles.block.anvil.use",
    "subtitles.block.barrel.close",
    "subtitles.block.barrel.open",
    "subtitles.block.beacon.activate",
    "subtitles.block.beacon.ambient",
    "subtitles.block.beacon.deactivate",
    "subtitles.block.beacon.power_select",
    "subtitles.block.beehive.drip",
    "subtitles.block.beehive.enter",
    "subtitles.block.beehive.exit",
    "subtitles.block.beehive.shear",
    "subtitles.block.beehive.work",
    "subtitles.block.bell.resonate",
    "subtitles.block.bell.use",
    "subtitles.block.big_dripleaf.tilt_down",
    "subtitles.block.big_dripleaf.tilt_up",
    "subtitles.block.blastfurnace.fire_crackle",
    "subtitles.block.brewing_stand.brew",
    "subtitles.block.bubble_column.bubble_pop",
    "subtitles.block.bubble_column.upwards_ambient",
    "subtitles.block.bubble_column.upwards_inside",
    "subtitles.block.bubble_column.whirlpool_ambient",
    "subtitles.block.bubble_column.whirlpool_inside",
    "subtitles.block.button.click",
    "subtitles.block.cake.add_candle",
    "subtitles.block.campfire.crackle",
    "subtitles.block.candle.crackle",
    "subtitles.block.candle.extinguish",
    "subtitles.block.chest.close",
    "subtitles.block.chest.locked",
    "subtitles.block.chest.open",
    "subtitles.block.chorus_flower.death",
    "subtitles.block.chorus_flower.grow",
    "subtitles.block.comparator.click",
    "subtitles.block.composter.empty",
    "subtitles.block.composter.fill",
    "subtitles.block.composter.ready",
    "subtitles.block.conduit.activate",
    "subtitles.block.conduit.ambient",
    "subtitles.block.conduit.attack.target",
    "subtitles.block.conduit.deactivate",
    "subtitles.block.copper_bulb.turn_off",
    "subtitles.block.copper_bulb.turn_on",
    "subtitles.block.copper_chest.close",
    "subtitles.block.copper_chest.open",
    "subtitles.block.copper_trapdoor.close",
    "subtitles.block.copper_trapdoor.open",
    "subtitles.block.crafter.craft",
    "subtitles.block.crafter.fail",
    "subtitles.block.creaking_heart.hurt",
    "subtitles.block.creaking_heart.idle",
    "subtitles.block.creaking_heart.spawn",
    "subtitles.block.deadbush.idle",
    "subtitles.block.decorated_pot.insert",
    "subtitles.block.decorated_pot.insert_fail",
    "subtitles.block.decorated_pot.shatter",
    "subtitles.block.dispenser.dispense",
    "subtitles.block.dispenser.fail",
    "subtitles.block.door.toggle",
    "subtitles.block.dried_ghast.ambient",
    "subtitles.block.dried_ghast.ambient_water",
    "subtitles.block.dried_ghast.place_in_water",
    "subtitles.block.dried_ghast.transition",
    "subtitles.block.dry_grass.ambient",
    "subtitles.block.enchantment_table.use",
    "subtitles.block.end_portal_frame.fill",
    "subtitles.block.end_portal.spawn",
    "subtitles.block.eyeblossom.close",
    "subtitles.block.eyeblossom.idle",
    "subtitles.block.eyeblossom.open",
    "subtitles.block.fence_gate.toggle",
    "subtitles.block.fire.ambient",
    "subtitles.block.fire.extinguish",
    "subtitles.block.firefly_bush.idle",
    "subtitles.block.frogspawn.hatch",
    "subtitles.block.furnace.fire_crackle",
    "subtitles.block.generic.break",
    "subtitles.block.generic.fall",
    "subtitles.block.generic.footsteps",
    "subtitles.block.generic.hit",
    "subtitles.block.generic.place",
    "subtitles.block.grindstone.use",
    "subtitles.block.growing_plant.crop",
    "subtitles.block.hanging_sign.waxed_interact_fail",
    "subtitles.block.honey_block.slide",
    "subtitles.block.iron_trapdoor.close",
    "subtitles.block.iron_trapdoor.open",
    "subtitles.block.lava.ambient",
    "subtitles.block.lava.extinguish",
    "subtitles.block.lever.click",
    "subtitles.block.note_block.note",
    "subtitles.block.pale_hanging_moss.idle",
    "subtitles.block.piston.move",
    "subtitles.block.pointed_dripstone.drip_lava",
    "subtitles.block.pointed_dripstone.drip_lava_into_cauldron",
    "subtitles.block.pointed_dripstone.drip_water",
    "subtitles.block.pointed_dripstone.drip_water_into_cauldron",
    "subtitles.block.pointed_dripstone.land",
    "subtitles.block.poplar_leaves.ambient",
    "subtitles.block.portal.ambient",
    "subtitles.block.portal.travel",
    "subtitles.block.portal.trigger",
    "subtitles.block.potent_sulfur.geyser_eruption",
    "subtitles.block.potent_sulfur.noxious_gas",
    "subtitles.block.pressure_plate.click",
    "subtitles.block.pumpkin.carve",
    "subtitles.block.redstone_torch.burnout",
    "subtitles.block.respawn_anchor.ambient",
    "subtitles.block.respawn_anchor.charge",
    "subtitles.block.respawn_anchor.deplete",
    "subtitles.block.respawn_anchor.set_spawn",
    "subtitles.block.sand.idle",
    "subtitles.block.sand.wind",
    "subtitles.block.sculk_catalyst.bloom",
    "subtitles.block.sculk_sensor.clicking",
    "subtitles.block.sculk_sensor.clicking_stop",
    "subtitles.block.sculk_shrieker.shriek",
    "subtitles.block.sculk.charge",
    "subtitles.block.sculk.spread",
    "subtitles.block.shelf_mushroom.bounce",
    "subtitles.block.shelf.activate",
    "subtitles.block.shelf.deactivate",
    "subtitles.block.shelf.multi_swap",
    "subtitles.block.shelf.place_item",
    "subtitles.block.shelf.single_swap",
    "subtitles.block.shelf.take_item",
    "subtitles.block.shulker_box.close",
    "subtitles.block.shulker_box.open",
    "subtitles.block.sign.waxed_interact_fail",
    "subtitles.block.smithing_table.use",
    "subtitles.block.smoker.smoke",
    "subtitles.block.sniffer_egg.crack",
    "subtitles.block.sniffer_egg.hatch",
    "subtitles.block.sniffer_egg.plop",
    "subtitles.block.sponge.absorb",
    "subtitles.block.straw_bed.break_leave",
    "subtitles.block.sweet_berry_bush.pick_berries",
    "subtitles.block.trapdoor.close",
    "subtitles.block.trapdoor.open",
    "subtitles.block.trapdoor.toggle",
    "subtitles.block.trial_spawner.about_to_spawn_item",
    "subtitles.block.trial_spawner.ambient",
    "subtitles.block.trial_spawner.ambient_charged",
    "subtitles.block.trial_spawner.ambient_ominous",
    "subtitles.block.trial_spawner.charge_activate",
    "subtitles.block.trial_spawner.close_shutter",
    "subtitles.block.trial_spawner.detect_player",
    "subtitles.block.trial_spawner.eject_item",
    "subtitles.block.trial_spawner.ominous_activate",
    "subtitles.block.trial_spawner.open_shutter",
    "subtitles.block.trial_spawner.spawn_item",
    "subtitles.block.trial_spawner.spawn_item_begin",
    "subtitles.block.trial_spawner.spawn_mob",
    "subtitles.block.tripwire.attach",
    "subtitles.block.tripwire.click",
    "subtitles.block.tripwire.detach",
    "subtitles.block.vault.activate",
    "subtitles.block.vault.ambient",
    "subtitles.block.vault.close_shutter",
    "subtitles.block.vault.deactivate",
    "subtitles.block.vault.eject_item",
    "subtitles.block.vault.insert_item",
    "subtitles.block.vault.insert_item_fail",
    "subtitles.block.vault.open_shutter",
    "subtitles.block.vault.reject_rewarded_player",
    "subtitles.block.water.ambient",
    "subtitles.block.wet_sponge.dries",
    "subtitles.chiseled_bookshelf.insert",
    "subtitles.chiseled_bookshelf.insert_enchanted",
    "subtitles.chiseled_bookshelf.take",
    "subtitles.chiseled_bookshelf.take_enchanted",
    "subtitles.enchant.thorns.hit",
    "subtitles.entity.allay.ambient_with_item",
    "subtitles.entity.allay.ambient_without_item",
    "subtitles.entity.allay.death",
    "subtitles.entity.allay.hurt",
    "subtitles.entity.allay.item_given",
    "subtitles.entity.allay.item_taken",
    "subtitles.entity.allay.item_thrown",
    "subtitles.entity.armadillo.ambient",
    "subtitles.entity.armadillo.brush",
    "subtitles.entity.armadillo.death",
    "subtitles.entity.armadillo.eat",
    "subtitles.entity.armadillo.hurt",
    "subtitles.entity.armadillo.hurt_reduced",
    "subtitles.entity.armadillo.land",
    "subtitles.entity.armadillo.peek",
    "subtitles.entity.armadillo.roll",
    "subtitles.entity.armadillo.scute_drop",
    "subtitles.entity.armadillo.unroll_finish",
    "subtitles.entity.armadillo.unroll_start",
    "subtitles.entity.armor_stand.fall",
    "subtitles.entity.arrow.hit",
    "subtitles.entity.arrow.hit_player",
    "subtitles.entity.arrow.shoot",
    "subtitles.entity.axolotl.attack",
    "subtitles.entity.axolotl.death",
    "subtitles.entity.axolotl.hurt",
    "subtitles.entity.axolotl.idle_air",
    "subtitles.entity.axolotl.idle_water",
    "subtitles.entity.axolotl.splash",
    "subtitles.entity.axolotl.swim",
    "subtitles.entity.baby_cat.ambient",
    "subtitles.entity.baby_cat.beg_for_food",
    "subtitles.entity.baby_cat.death",
    "subtitles.entity.baby_cat.eat",
    "subtitles.entity.baby_cat.hiss",
    "subtitles.entity.baby_cat.hurt",
    "subtitles.entity.baby_cat.purr",
    "subtitles.entity.baby_chicken.ambient",
    "subtitles.entity.baby_chicken.death",
    "subtitles.entity.baby_chicken.hurts",
    "subtitles.entity.baby_horse.ambient",
    "subtitles.entity.baby_horse.angry",
    "subtitles.entity.baby_horse.breathe",
    "subtitles.entity.baby_horse.death",
    "subtitles.entity.baby_horse.eat",
    "subtitles.entity.baby_horse.hurt",
    "subtitles.entity.baby_horse.land",
    "subtitles.entity.baby_nautilus.ambient",
    "subtitles.entity.baby_nautilus.ambient_land",
    "subtitles.entity.baby_nautilus.death",
    "subtitles.entity.baby_nautilus.death_land",
    "subtitles.entity.baby_nautilus.eat",
    "subtitles.entity.baby_nautilus.hurt",
    "subtitles.entity.baby_nautilus.hurt_land",
    "subtitles.entity.baby_nautilus.swim",
    "subtitles.entity.baby_pig.ambient",
    "subtitles.entity.baby_pig.death",
    "subtitles.entity.baby_pig.eat",
    "subtitles.entity.baby_pig.hurt",
    "subtitles.entity.baby_wolf.ambient",
    "subtitles.entity.baby_wolf.death",
    "subtitles.entity.baby_wolf.growl",
    "subtitles.entity.baby_wolf.hurt",
    "subtitles.entity.baby_wolf.pant",
    "subtitles.entity.baby_wolf.whine",
    "subtitles.entity.bat.ambient",
    "subtitles.entity.bat.death",
    "subtitles.entity.bat.hurt",
    "subtitles.entity.bat.takeoff",
    "subtitles.entity.bee.ambient",
    "subtitles.entity.bee.death",
    "subtitles.entity.bee.hurt",
    "subtitles.entity.bee.loop",
    "subtitles.entity.bee.loop_aggressive",
    "subtitles.entity.bee.pollinate",
    "subtitles.entity.bee.sting",
    "subtitles.entity.blaze.ambient",
    "subtitles.entity.blaze.burn",
    "subtitles.entity.blaze.death",
    "subtitles.entity.blaze.hurt",
    "subtitles.entity.blaze.shoot",
    "subtitles.entity.boat.paddle_land",
    "subtitles.entity.boat.paddle_water",
    "subtitles.entity.bogged.ambient",
    "subtitles.entity.bogged.death",
    "subtitles.entity.bogged.hurt",
    "subtitles.entity.breeze.charge",
    "subtitles.entity.breeze.death",
    "subtitles.entity.breeze.deflect",
    "subtitles.entity.breeze.hurt",
    "subtitles.entity.breeze.idle_air",
    "subtitles.entity.breeze.idle_ground",
    "subtitles.entity.breeze.inhale",
    "subtitles.entity.breeze.jump",
    "subtitles.entity.breeze.land",
    "subtitles.entity.breeze.shoot",
    "subtitles.entity.breeze.slide",
    "subtitles.entity.breeze.whirl",
    "subtitles.entity.breeze.wind_burst",
    "subtitles.entity.camel_husk.ambient",
    "subtitles.entity.camel_husk.dash",
    "subtitles.entity.camel_husk.dash_ready",
    "subtitles.entity.camel_husk.death",
    "subtitles.entity.camel_husk.eat",
    "subtitles.entity.camel_husk.hurt",
    "subtitles.entity.camel_husk.saddle",
    "subtitles.entity.camel_husk.sit",
    "subtitles.entity.camel_husk.stand",
    "subtitles.entity.camel.ambient",
    "subtitles.entity.camel.dash",
    "subtitles.entity.camel.dash_ready",
    "subtitles.entity.camel.death",
    "subtitles.entity.camel.eat",
    "subtitles.entity.camel.hurt",
    "subtitles.entity.camel.saddle",
    "subtitles.entity.camel.sit",
    "subtitles.entity.camel.stand",
    "subtitles.entity.camel.step",
    "subtitles.entity.camel.step_sand",
    "subtitles.entity.cat.ambient",
    "subtitles.entity.cat.beg_for_food",
    "subtitles.entity.cat.death",
    "subtitles.entity.cat.eat",
    "subtitles.entity.cat.hiss",
    "subtitles.entity.cat.hurt",
    "subtitles.entity.cat.purr",
    "subtitles.entity.chicken.ambient",
    "subtitles.entity.chicken.death",
    "subtitles.entity.chicken.egg",
    "subtitles.entity.chicken.hurt",
    "subtitles.entity.cod.death",
    "subtitles.entity.cod.flop",
    "subtitles.entity.cod.hurt",
    "subtitles.entity.copper_golem_become_statue",
    "subtitles.entity.copper_golem_oxidized.death",
    "subtitles.entity.copper_golem_oxidized.hurt",
    "subtitles.entity.copper_golem_oxidized.spin",
    "subtitles.entity.copper_golem_weathered.death",
    "subtitles.entity.copper_golem_weathered.hurt",
    "subtitles.entity.copper_golem_weathered.spin",
    "subtitles.entity.copper_golem.death",
    "subtitles.entity.copper_golem.hurt",
    "subtitles.entity.copper_golem.item_drop",
    "subtitles.entity.copper_golem.item_no_drop",
    "subtitles.entity.copper_golem.no_item_get",
    "subtitles.entity.copper_golem.no_item_no_get",
    "subtitles.entity.copper_golem.spawn",
    "subtitles.entity.copper_golem.spin",
    "subtitles.entity.cow.ambient",
    "subtitles.entity.cow.death",
    "subtitles.entity.cow.hurt",
    "subtitles.entity.cow.milk",
    "subtitles.entity.creaking.activate",
    "subtitles.entity.creaking.ambient",
    "subtitles.entity.creaking.attack",
    "subtitles.entity.creaking.deactivate",
    "subtitles.entity.creaking.death",
    "subtitles.entity.creaking.freeze",
    "subtitles.entity.creaking.spawn",
    "subtitles.entity.creaking.sway",
    "subtitles.entity.creaking.twitch",
    "subtitles.entity.creaking.unfreeze",
    "subtitles.entity.creeper.death",
    "subtitles.entity.creeper.hurt",
    "subtitles.entity.creeper.primed",
    "subtitles.entity.cushion.break",
    "subtitles.entity.cushion.get_up",
    "subtitles.entity.cushion.place",
    "subtitles.entity.cushion.sit",
    "subtitles.entity.dolphin.ambient",
    "subtitles.entity.dolphin.ambient_water",
    "subtitles.entity.dolphin.attack",
    "subtitles.entity.dolphin.death",
    "subtitles.entity.dolphin.eat",
    "subtitles.entity.dolphin.hurt",
    "subtitles.entity.dolphin.jump",
    "subtitles.entity.dolphin.play",
    "subtitles.entity.dolphin.splash",
    "subtitles.entity.dolphin.swim",
    "subtitles.entity.donkey.ambient",
    "subtitles.entity.donkey.angry",
    "subtitles.entity.donkey.chest",
    "subtitles.entity.donkey.death",
    "subtitles.entity.donkey.eat",
    "subtitles.entity.donkey.hurt",
    "subtitles.entity.donkey.jump",
    "subtitles.entity.drowned.ambient",
    "subtitles.entity.drowned.ambient_water",
    "subtitles.entity.drowned.death",
    "subtitles.entity.drowned.hurt",
    "subtitles.entity.drowned.shoot",
    "subtitles.entity.drowned.step",
    "subtitles.entity.drowned.swim",
    "subtitles.entity.egg.throw",
    "subtitles.entity.elder_guardian.ambient",
    "subtitles.entity.elder_guardian.ambient_land",
    "subtitles.entity.elder_guardian.curse",
    "subtitles.entity.elder_guardian.death",
    "subtitles.entity.elder_guardian.flop",
    "subtitles.entity.elder_guardian.hurt",
    "subtitles.entity.ender_dragon.ambient",
    "subtitles.entity.ender_dragon.death",
    "subtitles.entity.ender_dragon.flap",
    "subtitles.entity.ender_dragon.growl",
    "subtitles.entity.ender_dragon.hurt",
    "subtitles.entity.ender_dragon.shoot",
    "subtitles.entity.ender_eye.death",
    "subtitles.entity.ender_eye.launch",
    "subtitles.entity.ender_pearl.throw",
    "subtitles.entity.enderman.ambient",
    "subtitles.entity.enderman.death",
    "subtitles.entity.enderman.hurt",
    "subtitles.entity.enderman.scream",
    "subtitles.entity.enderman.stare",
    "subtitles.entity.enderman.teleport",
    "subtitles.entity.endermite.ambient",
    "subtitles.entity.endermite.death",
    "subtitles.entity.endermite.hurt",
    "subtitles.entity.evoker_fangs.attack",
    "subtitles.entity.evoker.ambient",
    "subtitles.entity.evoker.cast_spell",
    "subtitles.entity.evoker.celebrate",
    "subtitles.entity.evoker.death",
    "subtitles.entity.evoker.hurt",
    "subtitles.entity.evoker.prepare_attack",
    "subtitles.entity.evoker.prepare_summon",
    "subtitles.entity.evoker.prepare_wololo",
    "subtitles.entity.experience_orb.pickup",
    "subtitles.entity.firework_rocket.blast",
    "subtitles.entity.firework_rocket.launch",
    "subtitles.entity.firework_rocket.twinkle",
    "subtitles.entity.fish.swim",
    "subtitles.entity.fishing_bobber.retrieve",
    "subtitles.entity.fishing_bobber.splash",
    "subtitles.entity.fishing_bobber.throw",
    "subtitles.entity.fox.aggro",
    "subtitles.entity.fox.ambient",
    "subtitles.entity.fox.bite",
    "subtitles.entity.fox.death",
    "subtitles.entity.fox.eat",
    "subtitles.entity.fox.hurt",
    "subtitles.entity.fox.screech",
    "subtitles.entity.fox.sleep",
    "subtitles.entity.fox.sniff",
    "subtitles.entity.fox.spit",
    "subtitles.entity.fox.teleport",
    "subtitles.entity.frog.ambient",
    "subtitles.entity.frog.death",
    "subtitles.entity.frog.eat",
    "subtitles.entity.frog.hurt",
    "subtitles.entity.frog.lay_spawn",
    "subtitles.entity.frog.long_jump",
    "subtitles.entity.generic.big_fall",
    "subtitles.entity.generic.burn",
    "subtitles.entity.generic.death",
    "subtitles.entity.generic.drink",
    "subtitles.entity.generic.eat",
    "subtitles.entity.generic.explode",
    "subtitles.entity.generic.extinguish_fire",
    "subtitles.entity.generic.hurt",
    "subtitles.entity.generic.small_fall",
    "subtitles.entity.generic.splash",
    "subtitles.entity.generic.swim",
    "subtitles.entity.generic.wind_burst",
    "subtitles.entity.ghast.ambient",
    "subtitles.entity.ghast.death",
    "subtitles.entity.ghast.hurt",
    "subtitles.entity.ghast.shoot",
    "subtitles.entity.ghastling.ambient",
    "subtitles.entity.ghastling.death",
    "subtitles.entity.ghastling.hurt",
    "subtitles.entity.ghastling.spawn",
    "subtitles.entity.glow_item_frame.add_item",
    "subtitles.entity.glow_item_frame.break",
    "subtitles.entity.glow_item_frame.place",
    "subtitles.entity.glow_item_frame.remove_item",
    "subtitles.entity.glow_item_frame.rotate_item",
    "subtitles.entity.glow_squid.ambient",
    "subtitles.entity.glow_squid.death",
    "subtitles.entity.glow_squid.hurt",
    "subtitles.entity.glow_squid.squirt",
    "subtitles.entity.goat.ambient",
    "subtitles.entity.goat.death",
    "subtitles.entity.goat.eat",
    "subtitles.entity.goat.horn_break",
    "subtitles.entity.goat.hurt",
    "subtitles.entity.goat.long_jump",
    "subtitles.entity.goat.milk",
    "subtitles.entity.goat.prepare_ram",
    "subtitles.entity.goat.ram_impact",
    "subtitles.entity.goat.screaming.ambient",
    "subtitles.entity.goat.step",
    "subtitles.entity.guardian.ambient",
    "subtitles.entity.guardian.ambient_land",
    "subtitles.entity.guardian.attack",
    "subtitles.entity.guardian.death",
    "subtitles.entity.guardian.flop",
    "subtitles.entity.guardian.hurt",
    "subtitles.entity.happy_ghast.ambient",
    "subtitles.entity.happy_ghast.death",
    "subtitles.entity.happy_ghast.equip",
    "subtitles.entity.happy_ghast.harness_goggles_down",
    "subtitles.entity.happy_ghast.harness_goggles_up",
    "subtitles.entity.happy_ghast.hurt",
    "subtitles.entity.happy_ghast.unequip",
    "subtitles.entity.hoglin.ambient",
    "subtitles.entity.hoglin.angry",
    "subtitles.entity.hoglin.attack",
    "subtitles.entity.hoglin.converted_to_zombified",
    "subtitles.entity.hoglin.death",
    "subtitles.entity.hoglin.hurt",
    "subtitles.entity.hoglin.retreat",
    "subtitles.entity.hoglin.step",
    "subtitles.entity.horse.ambient",
    "subtitles.entity.horse.angry",
    "subtitles.entity.horse.armor",
    "subtitles.entity.horse.breathe",
    "subtitles.entity.horse.death",
    "subtitles.entity.horse.eat",
    "subtitles.entity.horse.gallop",
    "subtitles.entity.horse.hurt",
    "subtitles.entity.horse.jump",
    "subtitles.entity.horse.saddle",
    "subtitles.entity.husk.ambient",
    "subtitles.entity.husk.converted_to_zombie",
    "subtitles.entity.husk.death",
    "subtitles.entity.husk.hurt",
    "subtitles.entity.illusioner.ambient",
    "subtitles.entity.illusioner.cast_spell",
    "subtitles.entity.illusioner.death",
    "subtitles.entity.illusioner.hurt",
    "subtitles.entity.illusioner.mirror_move",
    "subtitles.entity.illusioner.prepare_blindness",
    "subtitles.entity.illusioner.prepare_mirror",
    "subtitles.entity.iron_golem.attack",
    "subtitles.entity.iron_golem.damage",
    "subtitles.entity.iron_golem.death",
    "subtitles.entity.iron_golem.hurt",
    "subtitles.entity.iron_golem.repair",
    "subtitles.entity.item_frame.add_item",
    "subtitles.entity.item_frame.break",
    "subtitles.entity.item_frame.place",
    "subtitles.entity.item_frame.remove_item",
    "subtitles.entity.item_frame.rotate_item",
    "subtitles.entity.item.break",
    "subtitles.entity.item.pickup",
    "subtitles.entity.leash_knot.break",
    "subtitles.entity.leash_knot.place",
    "subtitles.entity.lightning_bolt.impact",
    "subtitles.entity.lightning_bolt.thunder",
    "subtitles.entity.llama.ambient",
    "subtitles.entity.llama.angry",
    "subtitles.entity.llama.chest",
    "subtitles.entity.llama.death",
    "subtitles.entity.llama.eat",
    "subtitles.entity.llama.hurt",
    "subtitles.entity.llama.spit",
    "subtitles.entity.llama.step",
    "subtitles.entity.llama.swag",
    "subtitles.entity.magma_cube.death",
    "subtitles.entity.magma_cube.hurt",
    "subtitles.entity.magma_cube.squish",
    "subtitles.entity.minecart.inside",
    "subtitles.entity.minecart.inside_underwater",
    "subtitles.entity.minecart.riding",
    "subtitles.entity.mooshroom.convert",
    "subtitles.entity.mooshroom.eat",
    "subtitles.entity.mooshroom.milk",
    "subtitles.entity.mooshroom.suspicious_milk",
    "subtitles.entity.mule.ambient",
    "subtitles.entity.mule.angry",
    "subtitles.entity.mule.chest",
    "subtitles.entity.mule.death",
    "subtitles.entity.mule.eat",
    "subtitles.entity.mule.hurt",
    "subtitles.entity.mule.jump",
    "subtitles.entity.nautilus.ambient",
    "subtitles.entity.nautilus.ambient_land",
    "subtitles.entity.nautilus.dash",
    "subtitles.entity.nautilus.dash_land",
    "subtitles.entity.nautilus.dash_ready",
    "subtitles.entity.nautilus.dash_ready_land",
    "subtitles.entity.nautilus.death",
    "subtitles.entity.nautilus.death_land",
    "subtitles.entity.nautilus.eat",
    "subtitles.entity.nautilus.hurt",
    "subtitles.entity.nautilus.hurt_land",
    "subtitles.entity.nautilus.swim",
    "subtitles.entity.painting.break",
    "subtitles.entity.painting.place",
    "subtitles.entity.panda.aggressive_ambient",
    "subtitles.entity.panda.ambient",
    "subtitles.entity.panda.bite",
    "subtitles.entity.panda.cant_breed",
    "subtitles.entity.panda.death",
    "subtitles.entity.panda.eat",
    "subtitles.entity.panda.hurt",
    "subtitles.entity.panda.pre_sneeze",
    "subtitles.entity.panda.sneeze",
    "subtitles.entity.panda.step",
    "subtitles.entity.panda.worried_ambient",
    "subtitles.entity.parched.ambient",
    "subtitles.entity.parched.death",
    "subtitles.entity.parched.hurt",
    "subtitles.entity.parrot.ambient",
    "subtitles.entity.parrot.death",
    "subtitles.entity.parrot.eats",
    "subtitles.entity.parrot.fly",
    "subtitles.entity.parrot.hurts",
    "subtitles.entity.parrot.imitate.blaze",
    "subtitles.entity.parrot.imitate.bogged",
    "subtitles.entity.parrot.imitate.breeze",
    "subtitles.entity.parrot.imitate.camel_husk",
    "subtitles.entity.parrot.imitate.creaking",
    "subtitles.entity.parrot.imitate.creeper",
    "subtitles.entity.parrot.imitate.drowned",
    "subtitles.entity.parrot.imitate.elder_guardian",
    "subtitles.entity.parrot.imitate.ender_dragon",
    "subtitles.entity.parrot.imitate.endermite",
    "subtitles.entity.parrot.imitate.evoker",
    "subtitles.entity.parrot.imitate.ghast",
    "subtitles.entity.parrot.imitate.guardian",
    "subtitles.entity.parrot.imitate.hoglin",
    "subtitles.entity.parrot.imitate.husk",
    "subtitles.entity.parrot.imitate.illusioner",
    "subtitles.entity.parrot.imitate.magma_cube",
    "subtitles.entity.parrot.imitate.parched",
    "subtitles.entity.parrot.imitate.phantom",
    "subtitles.entity.parrot.imitate.piglin",
    "subtitles.entity.parrot.imitate.piglin_brute",
    "subtitles.entity.parrot.imitate.pillager",
    "subtitles.entity.parrot.imitate.ravager",
    "subtitles.entity.parrot.imitate.shulker",
    "subtitles.entity.parrot.imitate.silverfish",
    "subtitles.entity.parrot.imitate.skeleton",
    "subtitles.entity.parrot.imitate.slime",
    "subtitles.entity.parrot.imitate.spider",
    "subtitles.entity.parrot.imitate.stray",
    "subtitles.entity.parrot.imitate.vex",
    "subtitles.entity.parrot.imitate.vindicator",
    "subtitles.entity.parrot.imitate.warden",
    "subtitles.entity.parrot.imitate.witch",
    "subtitles.entity.parrot.imitate.wither",
    "subtitles.entity.parrot.imitate.wither_skeleton",
    "subtitles.entity.parrot.imitate.zoglin",
    "subtitles.entity.parrot.imitate.zombie",
    "subtitles.entity.parrot.imitate.zombie_horse",
    "subtitles.entity.parrot.imitate.zombie_nautilus",
    "subtitles.entity.parrot.imitate.zombie_villager",
    "subtitles.entity.phantom.ambient",
    "subtitles.entity.phantom.bite",
    "subtitles.entity.phantom.death",
    "subtitles.entity.phantom.flap",
    "subtitles.entity.phantom.hurt",
    "subtitles.entity.phantom.swoop",
    "subtitles.entity.pig.ambient",
    "subtitles.entity.pig.death",
    "subtitles.entity.pig.eat",
    "subtitles.entity.pig.hurt",
    "subtitles.entity.pig.saddle",
    "subtitles.entity.piglin_brute.ambient",
    "subtitles.entity.piglin_brute.angry",
    "subtitles.entity.piglin_brute.converted_to_zombified",
    "subtitles.entity.piglin_brute.death",
    "subtitles.entity.piglin_brute.hurt",
    "subtitles.entity.piglin_brute.step",
    "subtitles.entity.piglin.admiring_item",
    "subtitles.entity.piglin.ambient",
    "subtitles.entity.piglin.angry",
    "subtitles.entity.piglin.celebrate",
    "subtitles.entity.piglin.converted_to_zombified",
    "subtitles.entity.piglin.death",
    "subtitles.entity.piglin.hurt",
    "subtitles.entity.piglin.jealous",
    "subtitles.entity.piglin.retreat",
    "subtitles.entity.piglin.step",
    "subtitles.entity.pillager.ambient",
    "subtitles.entity.pillager.celebrate",
    "subtitles.entity.pillager.death",
    "subtitles.entity.pillager.hurt",
    "subtitles.entity.player.attack.crit",
    "subtitles.entity.player.attack.knockback",
    "subtitles.entity.player.attack.strong",
    "subtitles.entity.player.attack.sweep",
    "subtitles.entity.player.attack.weak",
    "subtitles.entity.player.burp",
    "subtitles.entity.player.death",
    "subtitles.entity.player.freeze_hurt",
    "subtitles.entity.player.hurt",
    "subtitles.entity.player.hurt_drown",
    "subtitles.entity.player.hurt_on_fire",
    "subtitles.entity.player.levelup",
    "subtitles.entity.player.teleport",
    "subtitles.entity.polar_bear.ambient",
    "subtitles.entity.polar_bear.ambient_baby",
    "subtitles.entity.polar_bear.death",
    "subtitles.entity.polar_bear.hurt",
    "subtitles.entity.polar_bear.warning",
    "subtitles.entity.potion.splash",
    "subtitles.entity.potion.throw",
    "subtitles.entity.puffer_fish.blow_out",
    "subtitles.entity.puffer_fish.blow_up",
    "subtitles.entity.puffer_fish.death",
    "subtitles.entity.puffer_fish.flop",
    "subtitles.entity.puffer_fish.hurt",
    "subtitles.entity.puffer_fish.sting",
    "subtitles.entity.rabbit.ambient",
    "subtitles.entity.rabbit.attack",
    "subtitles.entity.rabbit.death",
    "subtitles.entity.rabbit.hurt",
    "subtitles.entity.rabbit.jump",
    "subtitles.entity.ravager.ambient",
    "subtitles.entity.ravager.attack",
    "subtitles.entity.ravager.celebrate",
    "subtitles.entity.ravager.death",
    "subtitles.entity.ravager.hurt",
    "subtitles.entity.ravager.roar",
    "subtitles.entity.ravager.step",
    "subtitles.entity.ravager.stunned",
    "subtitles.entity.salmon.death",
    "subtitles.entity.salmon.flop",
    "subtitles.entity.salmon.hurt",
    "subtitles.entity.sheep.ambient",
    "subtitles.entity.sheep.death",
    "subtitles.entity.sheep.hurt",
    "subtitles.entity.shulker_bullet.hit",
    "subtitles.entity.shulker_bullet.hurt",
    "subtitles.entity.shulker.ambient",
    "subtitles.entity.shulker.close",
    "subtitles.entity.shulker.death",
    "subtitles.entity.shulker.hurt",
    "subtitles.entity.shulker.open",
    "subtitles.entity.shulker.shoot",
    "subtitles.entity.shulker.teleport",
    "subtitles.entity.silverfish.ambient",
    "subtitles.entity.silverfish.death",
    "subtitles.entity.silverfish.hurt",
    "subtitles.entity.skeleton_horse.ambient",
    "subtitles.entity.skeleton_horse.death",
    "subtitles.entity.skeleton_horse.hurt",
    "subtitles.entity.skeleton_horse.jump_water",
    "subtitles.entity.skeleton_horse.swim",
    "subtitles.entity.skeleton.ambient",
    "subtitles.entity.skeleton.converted_to_stray",
    "subtitles.entity.skeleton.death",
    "subtitles.entity.skeleton.hurt",
    "subtitles.entity.skeleton.shoot",
    "subtitles.entity.slime.attack",
    "subtitles.entity.slime.death",
    "subtitles.entity.slime.hurt",
    "subtitles.entity.slime.squish",
    "subtitles.entity.small_sulfur_cube.death",
    "subtitles.entity.small_sulfur_cube.eat",
    "subtitles.entity.small_sulfur_cube.hurt",
    "subtitles.entity.small_sulfur_cube.jump",
    "subtitles.entity.sniffer.death",
    "subtitles.entity.sniffer.digging",
    "subtitles.entity.sniffer.digging_stop",
    "subtitles.entity.sniffer.drop_seed",
    "subtitles.entity.sniffer.eat",
    "subtitles.entity.sniffer.egg_crack",
    "subtitles.entity.sniffer.egg_hatch",
    "subtitles.entity.sniffer.happy",
    "subtitles.entity.sniffer.hurt",
    "subtitles.entity.sniffer.idle",
    "subtitles.entity.sniffer.scenting",
    "subtitles.entity.sniffer.searching",
    "subtitles.entity.sniffer.sniffing",
    "subtitles.entity.sniffer.step",
    "subtitles.entity.snow_golem.death",
    "subtitles.entity.snow_golem.hurt",
    "subtitles.entity.snowball.throw",
    "subtitles.entity.spider.ambient",
    "subtitles.entity.spider.death",
    "subtitles.entity.spider.hurt",
    "subtitles.entity.squid.ambient",
    "subtitles.entity.squid.death",
    "subtitles.entity.squid.hurt",
    "subtitles.entity.squid.squirt",
    "subtitles.entity.stray.ambient",
    "subtitles.entity.stray.death",
    "subtitles.entity.stray.hurt",
    "subtitles.entity.strider.death",
    "subtitles.entity.strider.eat",
    "subtitles.entity.strider.happy",
    "subtitles.entity.strider.hurt",
    "subtitles.entity.strider.idle",
    "subtitles.entity.strider.retreat",
    "subtitles.entity.sulfur_cube.absorb",
    "subtitles.entity.sulfur_cube.bounce",
    "subtitles.entity.sulfur_cube.death",
    "subtitles.entity.sulfur_cube.eject",
    "subtitles.entity.sulfur_cube.hit",
    "subtitles.entity.sulfur_cube.hurt",
    "subtitles.entity.sulfur_cube.jump",
    "subtitles.entity.sulfur_cube.push",
    "subtitles.entity.sulfur_cube.squish",
    "subtitles.entity.tadpole.death",
    "subtitles.entity.tadpole.flop",
    "subtitles.entity.tadpole.grow_up",
    "subtitles.entity.tadpole.hurt",
    "subtitles.entity.tnt.primed",
    "subtitles.entity.tropical_fish.death",
    "subtitles.entity.tropical_fish.flop",
    "subtitles.entity.tropical_fish.hurt",
    "subtitles.entity.turtle.ambient_land",
    "subtitles.entity.turtle.death",
    "subtitles.entity.turtle.death_baby",
    "subtitles.entity.turtle.egg_break",
    "subtitles.entity.turtle.egg_crack",
    "subtitles.entity.turtle.egg_hatch",
    "subtitles.entity.turtle.hurt",
    "subtitles.entity.turtle.hurt_baby",
    "subtitles.entity.turtle.lay_egg",
    "subtitles.entity.turtle.shamble",
    "subtitles.entity.turtle.shamble_baby",
    "subtitles.entity.turtle.swim",
    "subtitles.entity.vex.ambient",
    "subtitles.entity.vex.charge",
    "subtitles.entity.vex.death",
    "subtitles.entity.vex.hurt",
    "subtitles.entity.villager.ambient",
    "subtitles.entity.villager.celebrate",
    "subtitles.entity.villager.death",
    "subtitles.entity.villager.hurt",
    "subtitles.entity.villager.no",
    "subtitles.entity.villager.trade",
    "subtitles.entity.villager.work_armorer",
    "subtitles.entity.villager.work_butcher",
    "subtitles.entity.villager.work_cartographer",
    "subtitles.entity.villager.work_cleric",
    "subtitles.entity.villager.work_farmer",
    "subtitles.entity.villager.work_fisherman",
    "subtitles.entity.villager.work_fletcher",
    "subtitles.entity.villager.work_leatherworker",
    "subtitles.entity.villager.work_librarian",
    "subtitles.entity.villager.work_mason",
    "subtitles.entity.villager.work_shepherd",
    "subtitles.entity.villager.work_toolsmith",
    "subtitles.entity.villager.work_weaponsmith",
    "subtitles.entity.villager.yes",
    "subtitles.entity.vindicator.ambient",
    "subtitles.entity.vindicator.celebrate",
    "subtitles.entity.vindicator.death",
    "subtitles.entity.vindicator.hurt",
    "subtitles.entity.wandering_trader.ambient",
    "subtitles.entity.wandering_trader.death",
    "subtitles.entity.wandering_trader.disappeared",
    "subtitles.entity.wandering_trader.drink_milk",
    "subtitles.entity.wandering_trader.drink_potion",
    "subtitles.entity.wandering_trader.hurt",
    "subtitles.entity.wandering_trader.no",
    "subtitles.entity.wandering_trader.reappeared",
    "subtitles.entity.wandering_trader.trade",
    "subtitles.entity.wandering_trader.yes",
    "subtitles.entity.warden.agitated",
    "subtitles.entity.warden.ambient",
    "subtitles.entity.warden.angry",
    "subtitles.entity.warden.attack_impact",
    "subtitles.entity.warden.death",
    "subtitles.entity.warden.dig",
    "subtitles.entity.warden.emerge",
    "subtitles.entity.warden.heartbeat",
    "subtitles.entity.warden.hurt",
    "subtitles.entity.warden.listening",
    "subtitles.entity.warden.listening_angry",
    "subtitles.entity.warden.nearby_close",
    "subtitles.entity.warden.nearby_closer",
    "subtitles.entity.warden.nearby_closest",
    "subtitles.entity.warden.roar",
    "subtitles.entity.warden.sniff",
    "subtitles.entity.warden.sonic_boom",
    "subtitles.entity.warden.sonic_charge",
    "subtitles.entity.warden.step",
    "subtitles.entity.warden.tendril_clicks",
    "subtitles.entity.wind_charge.throw",
    "subtitles.entity.wind_charge.wind_burst",
    "subtitles.entity.witch.ambient",
    "subtitles.entity.witch.celebrate",
    "subtitles.entity.witch.death",
    "subtitles.entity.witch.drink",
    "subtitles.entity.witch.hurt",
    "subtitles.entity.witch.throw",
    "subtitles.entity.wither_skeleton.ambient",
    "subtitles.entity.wither_skeleton.death",
    "subtitles.entity.wither_skeleton.hurt",
    "subtitles.entity.wither.ambient",
    "subtitles.entity.wither.death",
    "subtitles.entity.wither.hurt",
    "subtitles.entity.wither.shoot",
    "subtitles.entity.wither.spawn",
    "subtitles.entity.wolf.ambient",
    "subtitles.entity.wolf.bark",
    "subtitles.entity.wolf.death",
    "subtitles.entity.wolf.growl",
    "subtitles.entity.wolf.hurt",
    "subtitles.entity.wolf.pant",
    "subtitles.entity.wolf.shake",
    "subtitles.entity.wolf.whine",
    "subtitles.entity.zoglin.ambient",
    "subtitles.entity.zoglin.angry",
    "subtitles.entity.zoglin.attack",
    "subtitles.entity.zoglin.death",
    "subtitles.entity.zoglin.hurt",
    "subtitles.entity.zoglin.step",
    "subtitles.entity.zombie_horse.ambient",
    "subtitles.entity.zombie_horse.angry",
    "subtitles.entity.zombie_horse.death",
    "subtitles.entity.zombie_horse.eat",
    "subtitles.entity.zombie_horse.hurt",
    "subtitles.entity.zombie_nautilus.ambient",
    "subtitles.entity.zombie_nautilus.ambient_land",
    "subtitles.entity.zombie_nautilus.dash",
    "subtitles.entity.zombie_nautilus.dash_land",
    "subtitles.entity.zombie_nautilus.dash_ready",
    "subtitles.entity.zombie_nautilus.dash_ready_land",
    "subtitles.entity.zombie_nautilus.death",
    "subtitles.entity.zombie_nautilus.death_land",
    "subtitles.entity.zombie_nautilus.eat",
    "subtitles.entity.zombie_nautilus.hurt",
    "subtitles.entity.zombie_nautilus.hurt_land",
    "subtitles.entity.zombie_nautilus.swim",
    "subtitles.entity.zombie_villager.ambient",
    "subtitles.entity.zombie_villager.converted",
    "subtitles.entity.zombie_villager.cure",
    "subtitles.entity.zombie_villager.death",
    "subtitles.entity.zombie_villager.hurt",
    "subtitles.entity.zombie.ambient",
    "subtitles.entity.zombie.attack_wooden_door",
    "subtitles.entity.zombie.break_wooden_door",
    "subtitles.entity.zombie.converted_to_drowned",
    "subtitles.entity.zombie.death",
    "subtitles.entity.zombie.destroy_egg",
    "subtitles.entity.zombie.hurt",
    "subtitles.entity.zombie.infect",
    "subtitles.entity.zombified_piglin.ambient",
    "subtitles.entity.zombified_piglin.angry",
    "subtitles.entity.zombified_piglin.death",
    "subtitles.entity.zombified_piglin.hurt",
    "subtitles.event.mob_effect.bad_omen",
    "subtitles.event.mob_effect.raid_omen",
    "subtitles.event.mob_effect.trial_omen",
    "subtitles.event.raid.horn",
    "subtitles.item.armor.equip",
    "subtitles.item.armor.equip_chain",
    "subtitles.item.armor.equip_copper",
    "subtitles.item.armor.equip_diamond",
    "subtitles.item.armor.equip_elytra",
    "subtitles.item.armor.equip_gold",
    "subtitles.item.armor.equip_iron",
    "subtitles.item.armor.equip_leather",
    "subtitles.item.armor.equip_nautilus",
    "subtitles.item.armor.equip_netherite",
    "subtitles.item.armor.equip_turtle",
    "subtitles.item.armor.equip_wolf",
    "subtitles.item.armor.unequip_nautilus",
    "subtitles.item.armor.unequip_wolf",
    "subtitles.item.axe.scrape",
    "subtitles.item.axe.strip",
    "subtitles.item.axe.wax_off",
    "subtitles.item.bone_meal.use",
    "subtitles.item.book.page_turn",
    "subtitles.item.book.put",
    "subtitles.item.bottle.empty",
    "subtitles.item.bottle.fill",
    "subtitles.item.brush.brushing.generic",
    "subtitles.item.brush.brushing.gravel",
    "subtitles.item.brush.brushing.gravel.complete",
    "subtitles.item.brush.brushing.sand",
    "subtitles.item.brush.brushing.sand.complete",
    "subtitles.item.bucket.empty",
    "subtitles.item.bucket.fill",
    "subtitles.item.bucket.fill_axolotl",
    "subtitles.item.bucket.fill_fish",
    "subtitles.item.bucket.fill_sulfur_cube",
    "subtitles.item.bucket.fill_tadpole",
    "subtitles.item.bundle.drop_contents",
    "subtitles.item.bundle.insert",
    "subtitles.item.bundle.insert_fail",
    "subtitles.item.bundle.remove_one",
    "subtitles.item.chorus_fruit.teleport",
    "subtitles.item.crop.plant",
    "subtitles.item.crossbow.charge",
    "subtitles.item.crossbow.hit",
    "subtitles.item.crossbow.load",
    "subtitles.item.crossbow.shoot",
    "subtitles.item.dye.use",
    "subtitles.item.elytra.flying",
    "subtitles.item.firecharge.use",
    "subtitles.item.flintandsteel.use",
    "subtitles.item.glow_ink_sac.use",
    "subtitles.item.goat_horn.play",
    "subtitles.item.golden_dandelion.unuse",
    "subtitles.item.golden_dandelion.use",
    "subtitles.item.hoe.till",
    "subtitles.item.honey_bottle.drink",
    "subtitles.item.honeycomb.wax_on",
    "subtitles.item.horse_armor.unequip",
    "subtitles.item.ink_sac.use",
    "subtitles.item.lead.break",
    "subtitles.item.lead.tied",
    "subtitles.item.lead.untied",
    "subtitles.item.llama_carpet.unequip",
    "subtitles.item.lodestone_compass.lock",
    "subtitles.item.mace.smash_air",
    "subtitles.item.mace.smash_ground",
    "subtitles.item.nautilus_saddle_equip",
    "subtitles.item.nautilus_saddle_underwater_equip",
    "subtitles.item.nether_wart.plant",
    "subtitles.item.ominous_bottle.dispose",
    "subtitles.item.saddle.unequip",
    "subtitles.item.shears.shear",
    "subtitles.item.shears.snip",
    "subtitles.item.shield.block",
    "subtitles.item.shovel.flatten",
    "subtitles.item.spear_wood.attack",
    "subtitles.item.spear_wood.hit",
    "subtitles.item.spear_wood.use",
    "subtitles.item.spear.attack",
    "subtitles.item.spear.hit",
    "subtitles.item.spear.lunge",
    "subtitles.item.spear.use",
    "subtitles.item.spyglass.stop_using",
    "subtitles.item.spyglass.use",
    "subtitles.item.totem.use",
    "subtitles.item.trident.hit",
    "subtitles.item.trident.hit_ground",
    "subtitles.item.trident.return",
    "subtitles.item.trident.riptide",
    "subtitles.item.trident.throw",
    "subtitles.item.trident.thunder",
    "subtitles.item.underwater_saddle.equip",
    "subtitles.item.wolf_armor.break",
    "subtitles.item.wolf_armor.crack",
    "subtitles.item.wolf_armor.damage",
    "subtitles.item.wolf_armor.repair",
    "subtitles.particle.soul_escape",
    "subtitles.ui.cartography_table.take_result",
    "subtitles.ui.hud.bubble_pop",
    "subtitles.ui.loom.take_result",
    "subtitles.ui.stonecutter.take_result",
    "subtitles.weather.end_flash",
    "subtitles.weather.rain",
    "symlink_warning.message",
    "symlink_warning.message.pack",
    "symlink_warning.message.world",
    "symlink_warning.more_info",
    "symlink_warning.title",
    "symlink_warning.title.pack",
    "symlink_warning.title.world",
    "team.collision.always",
    "team.collision.never",
    "team.collision.pushOtherTeams",
    "team.collision.pushOwnTeam",
    "team.notFound",
    "team.visibility.always",
    "team.visibility.hideForOtherTeams",
    "team.visibility.hideForOwnTeam",
    "team.visibility.never",
    "telemetry_info.button.give_feedback",
    "telemetry_info.button.privacy_statement",
    "telemetry_info.button.show_data",
    "telemetry_info.opt_in.description",
    "telemetry_info.property_title",
    "telemetry_info.screen.description",
    "telemetry_info.screen.title",
    "telemetry.event.advancement_made.description",
    "telemetry.event.advancement_made.title",
    "telemetry.event.game_load_times.description",
    "telemetry.event.game_load_times.title",
    "telemetry.event.graphics_capabilities.description",
    "telemetry.event.graphics_capabilities.title",
    "telemetry.event.optional",
    "telemetry.event.optional.disabled",
    "telemetry.event.p2p_connection.description",
    "telemetry.event.p2p_connection.title",
    "telemetry.event.performance_metrics.description",
    "telemetry.event.performance_metrics.title",
    "telemetry.event.required",
    "telemetry.event.world_load_times.description",
    "telemetry.event.world_load_times.title",
    "telemetry.event.world_loaded.description",
    "telemetry.event.world_loaded.title",
    "telemetry.event.world_unloaded.description",
    "telemetry.event.world_unloaded.title",
    "telemetry.property.advancement_game_time.title",
    "telemetry.property.advancement_id.title",
    "telemetry.property.backend_failure_message.title",
    "telemetry.property.backend_failure_missing_capabilities.title",
    "telemetry.property.backend_failure_reason.title",
    "telemetry.property.backend_name.title",
    "telemetry.property.client_id.title",
    "telemetry.property.client_modded.title",
    "telemetry.property.dedicated_memory_kb.title",
    "telemetry.property.event_timestamp_utc.title",
    "telemetry.property.frame_rate_samples.title",
    "telemetry.property.game_mode.title",
    "telemetry.property.game_version.title",
    "telemetry.property.launcher_name.title",
    "telemetry.property.load_time_bootstrap_ms.title",
    "telemetry.property.load_time_loading_overlay_ms.title",
    "telemetry.property.load_time_pre_window_ms.title",
    "telemetry.property.load_time_total_time_ms.title",
    "telemetry.property.minecraft_session_id.title",
    "telemetry.property.new_world.title",
    "telemetry.property.number_of_samples.title",
    "telemetry.property.operating_system.title",
    "telemetry.property.opt_in.title",
    "telemetry.property.p2p_connection_failure_stage.title",
    "telemetry.property.p2p_connection_ice_connect_time_ms.title",
    "telemetry.property.p2p_connection_ice_path.title",
    "telemetry.property.p2p_connection_local_candidate_type.title",
    "telemetry.property.p2p_connection_remote_candidate_type.title",
    "telemetry.property.p2p_connection_signaling_time_ms.title",
    "telemetry.property.p2p_connection_successful.title",
    "telemetry.property.p2p_connection_total_time_ms.title",
    "telemetry.property.platform.title",
    "telemetry.property.realms_map_content.title",
    "telemetry.property.render_distance.title",
    "telemetry.property.render_time_samples.title",
    "telemetry.property.seconds_since_load.title",
    "telemetry.property.server_modded.title",
    "telemetry.property.server_session_id.title",
    "telemetry.property.server_type.title",
    "telemetry.property.ticks_since_load.title",
    "telemetry.property.used_memory_samples.title",
    "telemetry.property.user_id.title",
    "telemetry.property.world_load_time_ms.title",
    "telemetry.property.world_session_id.title",
    "test_block.error.missing",
    "test_block.error.too_many",
    "test_block.invalid_timeout",
    "test_block.message",
    "test_block.mode_info.accept",
    "test_block.mode_info.fail",
    "test_block.mode_info.log",
    "test_block.mode_info.start",
    "test_block.mode.accept",
    "test_block.mode.fail",
    "test_block.mode.log",
    "test_block.mode.start",
    "test_instance_block.entities",
    "test_instance_block.error.no_test",
    "test_instance_block.error.no_test_structure",
    "test_instance_block.error.unable_to_save",
    "test_instance_block.invalid",
    "test_instance_block.reset_success",
    "test_instance_block.rotation",
    "test_instance_block.size",
    "test_instance_block.starting",
    "test_instance_block.test_id",
    "test_instance.action.reset",
    "test_instance.action.run",
    "test_instance.action.save",
    "test_instance.description.batch",
    "test_instance.description.failed",
    "test_instance.description.function",
    "test_instance.description.invalid_id",
    "test_instance.description.no_test",
    "test_instance.description.structure",
    "test_instance.description.type",
    "test_instance.type.block_based",
    "test_instance.type.function",
    "test.error.block_property_mismatch",
    "test.error.block_property_missing",
    "test.error.entity_property",
    "test.error.entity_property_details",
    "test.error.expected_block",
    "test.error.expected_block_present",
    "test.error.expected_block_tag",
    "test.error.expected_container_contents",
    "test.error.expected_container_contents_single",
    "test.error.expected_empty_container",
    "test.error.expected_entity",
    "test.error.expected_entity_around",
    "test.error.expected_entity_count",
    "test.error.expected_entity_data",
    "test.error.expected_entity_data_predicate",
    "test.error.expected_entity_effect",
    "test.error.expected_entity_having",
    "test.error.expected_entity_holding",
    "test.error.expected_entity_in_test",
    "test.error.expected_entity_not_touching",
    "test.error.expected_entity_touching",
    "test.error.expected_item",
    "test.error.expected_items_count",
    "test.error.fail",
    "test.error.invalid_block_type",
    "test.error.missing_block_entity",
    "test.error.not_a_block_item",
    "test.error.position",
    "test.error.sequence.condition_already_triggered",
    "test.error.sequence.condition_not_triggered",
    "test.error.sequence.invalid_tick",
    "test.error.sequence.minimum_tick",
    "test.error.sequence.not_completed",
    "test.error.set_biome",
    "test.error.spawn_failure",
    "test.error.state_not_equal",
    "test.error.structure.failure",
    "test.error.tick",
    "test.error.ticking_without_structure",
    "test.error.timeout.no_result",
    "test.error.timeout.no_sequences_finished",
    "test.error.too_many_entities",
    "test.error.unexpected_block",
    "test.error.unexpected_entity",
    "test.error.unexpected_item",
    "test.error.unknown",
    "test.error.value_not_equal",
    "test.error.value_not_in_between",
    "test.error.wrong_block_entity",
    "test.player.coordinates",
    "test.run.coordinates",
    "title.32bit.deprecation",
    "title.32bit.deprecation.realms",
    "title.32bit.deprecation.realms.check",
    "title.32bit.deprecation.realms.header",
    "title.credits",
    "title.multiplayer.disabled",
    "title.multiplayer.disabled.banned.name",
    "title.multiplayer.disabled.banned.permanent",
    "title.multiplayer.disabled.banned.temporary",
    "title.multiplayer.lan",
    "title.multiplayer.online",
    "title.multiplayer.other",
    "title.multiplayer.realms",
    "title.singleplayer",
    "translation.test.args",
    "translation.test.complex",
    "translation.test.escape",
    "translation.test.invalid",
    "translation.test.invalid2",
    "translation.test.none",
    "translation.test.world",
    "trim_material.minecraft.amethyst",
    "trim_material.minecraft.copper",
    "trim_material.minecraft.diamond",
    "trim_material.minecraft.emerald",
    "trim_material.minecraft.gold",
    "trim_material.minecraft.iron",
    "trim_material.minecraft.lapis",
    "trim_material.minecraft.netherite",
    "trim_material.minecraft.quartz",
    "trim_material.minecraft.redstone",
    "trim_material.minecraft.resin",
    "trim_pattern.minecraft.bolt",
    "trim_pattern.minecraft.coast",
    "trim_pattern.minecraft.dune",
    "trim_pattern.minecraft.eye",
    "trim_pattern.minecraft.flow",
    "trim_pattern.minecraft.host",
    "trim_pattern.minecraft.raiser",
    "trim_pattern.minecraft.rib",
    "trim_pattern.minecraft.sentry",
    "trim_pattern.minecraft.shaper",
    "trim_pattern.minecraft.silence",
    "trim_pattern.minecraft.snout",
    "trim_pattern.minecraft.spire",
    "trim_pattern.minecraft.tide",
    "trim_pattern.minecraft.vex",
    "trim_pattern.minecraft.ward",
    "trim_pattern.minecraft.wayfinder",
    "trim_pattern.minecraft.wild",
    "tutorial.bundleInsert.description",
    "tutorial.bundleInsert.title",
    "tutorial.craft_planks.description",
    "tutorial.craft_planks.title",
    "tutorial.find_tree.description",
    "tutorial.find_tree.title",
    "tutorial.look.description",
    "tutorial.look.title",
    "tutorial.move.description",
    "tutorial.move.title",
    "tutorial.open_inventory.description",
    "tutorial.open_inventory.title",
    "tutorial.punch_tree.description",
    "tutorial.punch_tree.title",
    "tutorial.socialInteractions.description",
    "tutorial.socialInteractions.title",
    "upgrade.minecraft.netherite_upgrade",
    "upgradeWorld.aborted.message",
    "upgradeWorld.aborted.reportBug",
    "upgradeWorld.aborted.title",
    "upgradeWorld.canceled.message",
    "upgradeWorld.canceled.title",
    "upgradeWorld.done",
    "upgradeWorld.failed_cleanup.message",
    "upgradeWorld.failed_cleanup.title",
    "upgradeWorld.info.converted",
    "upgradeWorld.info.file_fix_stage",
    "upgradeWorld.info.scanning",
    "upgradeWorld.info.total",
    "upgradeWorld.joinNow",
    "upgradeWorld.progress.percentage",
    "upgradeWorld.progress.type.files",
    "upgradeWorld.progress.type.legacy_structures",
    "upgradeWorld.progress.type.region",
    "upgradeWorld.symlink.message",
    "upgradeWorld.symlink.title",
    "upgradeWorld.title"
  ]);
});

// src/arguments/generated/_registry/atlases.ts
var ATLASES_SET;
var init_atlases = __esm(() => {
  init_sandstone();
  ATLASES_SET = new Set2([
    "banner_patterns",
    "blocks",
    "celestials",
    "chests",
    "decorated_pot",
    "gui",
    "items",
    "map_decorations",
    "paintings",
    "particles",
    "shield_patterns",
    "shulker_boxes"
  ]);
});

// src/arguments/generated/_registry/block_definitions.ts
var BLOCK_DEFINITIONS_SET;
var init_block_definitions = __esm(() => {
  init_sandstone();
  BLOCK_DEFINITIONS_SET = new Set2([
    "acacia_button",
    "acacia_door",
    "acacia_fence",
    "acacia_fence_gate",
    "acacia_hanging_sign",
    "acacia_leaves",
    "acacia_log",
    "acacia_planks",
    "acacia_pressure_plate",
    "acacia_sapling",
    "acacia_shelf",
    "acacia_sign",
    "acacia_slab",
    "acacia_stairs",
    "acacia_trapdoor",
    "acacia_wall_hanging_sign",
    "acacia_wall_sign",
    "acacia_wood",
    "activator_rail",
    "air",
    "allium",
    "amethyst_block",
    "amethyst_cluster",
    "ancient_debris",
    "andesite",
    "andesite_slab",
    "andesite_stairs",
    "andesite_wall",
    "anvil",
    "attached_melon_stem",
    "attached_pumpkin_stem",
    "azalea",
    "azalea_leaves",
    "azure_bluet",
    "bamboo",
    "bamboo_block",
    "bamboo_button",
    "bamboo_door",
    "bamboo_fence",
    "bamboo_fence_gate",
    "bamboo_hanging_sign",
    "bamboo_mosaic",
    "bamboo_mosaic_slab",
    "bamboo_mosaic_stairs",
    "bamboo_planks",
    "bamboo_pressure_plate",
    "bamboo_sapling",
    "bamboo_shelf",
    "bamboo_sign",
    "bamboo_slab",
    "bamboo_stairs",
    "bamboo_trapdoor",
    "bamboo_wall_hanging_sign",
    "bamboo_wall_sign",
    "barrel",
    "barrier",
    "basalt",
    "beacon",
    "bedrock",
    "bee_nest",
    "beehive",
    "beetroots",
    "bell",
    "big_dripleaf",
    "big_dripleaf_stem",
    "birch_button",
    "birch_door",
    "birch_fence",
    "birch_fence_gate",
    "birch_hanging_sign",
    "birch_leaves",
    "birch_log",
    "birch_planks",
    "birch_pressure_plate",
    "birch_sapling",
    "birch_shelf",
    "birch_sign",
    "birch_slab",
    "birch_stairs",
    "birch_trapdoor",
    "birch_wall_hanging_sign",
    "birch_wall_sign",
    "birch_wood",
    "black_banner",
    "black_bed",
    "black_candle",
    "black_candle_cake",
    "black_carpet",
    "black_concrete",
    "black_concrete_powder",
    "black_concrete_slab",
    "black_concrete_stairs",
    "black_glazed_terracotta",
    "black_shulker_box",
    "black_stained_glass",
    "black_stained_glass_pane",
    "black_terracotta",
    "black_wall_banner",
    "black_wool",
    "black_wool_slab",
    "black_wool_stairs",
    "blackstone",
    "blackstone_slab",
    "blackstone_stairs",
    "blackstone_wall",
    "blast_furnace",
    "blue_banner",
    "blue_bed",
    "blue_candle",
    "blue_candle_cake",
    "blue_carpet",
    "blue_concrete",
    "blue_concrete_powder",
    "blue_concrete_slab",
    "blue_concrete_stairs",
    "blue_glazed_terracotta",
    "blue_ice",
    "blue_orchid",
    "blue_shulker_box",
    "blue_stained_glass",
    "blue_stained_glass_pane",
    "blue_terracotta",
    "blue_wall_banner",
    "blue_wool",
    "blue_wool_slab",
    "blue_wool_stairs",
    "bone_block",
    "bookshelf",
    "brain_coral",
    "brain_coral_block",
    "brain_coral_fan",
    "brain_coral_wall_fan",
    "brewing_stand",
    "brick_slab",
    "brick_stairs",
    "brick_wall",
    "bricks",
    "brown_banner",
    "brown_bed",
    "brown_candle",
    "brown_candle_cake",
    "brown_carpet",
    "brown_concrete",
    "brown_concrete_powder",
    "brown_concrete_slab",
    "brown_concrete_stairs",
    "brown_glazed_terracotta",
    "brown_mushroom",
    "brown_mushroom_block",
    "brown_shulker_box",
    "brown_stained_glass",
    "brown_stained_glass_pane",
    "brown_terracotta",
    "brown_wall_banner",
    "brown_wool",
    "brown_wool_slab",
    "brown_wool_stairs",
    "bubble_column",
    "bubble_coral",
    "bubble_coral_block",
    "bubble_coral_fan",
    "bubble_coral_wall_fan",
    "budding_amethyst",
    "bush",
    "cactus",
    "cactus_flower",
    "cake",
    "calcite",
    "calibrated_sculk_sensor",
    "campfire",
    "candle",
    "candle_cake",
    "carrots",
    "cartography_table",
    "carved_pumpkin",
    "cauldron",
    "cave_air",
    "cave_vines",
    "cave_vines_plant",
    "chain_command_block",
    "cherry_button",
    "cherry_door",
    "cherry_fence",
    "cherry_fence_gate",
    "cherry_hanging_sign",
    "cherry_leaves",
    "cherry_log",
    "cherry_planks",
    "cherry_pressure_plate",
    "cherry_sapling",
    "cherry_shelf",
    "cherry_sign",
    "cherry_slab",
    "cherry_stairs",
    "cherry_trapdoor",
    "cherry_wall_hanging_sign",
    "cherry_wall_sign",
    "cherry_wood",
    "chest",
    "chipped_anvil",
    "chiseled_bookshelf",
    "chiseled_cinnabar",
    "chiseled_copper",
    "chiseled_deepslate",
    "chiseled_nether_bricks",
    "chiseled_polished_blackstone",
    "chiseled_quartz_block",
    "chiseled_red_sandstone",
    "chiseled_resin_bricks",
    "chiseled_sandstone",
    "chiseled_stone_bricks",
    "chiseled_sulfur",
    "chiseled_tuff",
    "chiseled_tuff_bricks",
    "chorus_flower",
    "chorus_plant",
    "cinnabar",
    "cinnabar_brick_slab",
    "cinnabar_brick_stairs",
    "cinnabar_brick_wall",
    "cinnabar_bricks",
    "cinnabar_slab",
    "cinnabar_stairs",
    "cinnabar_wall",
    "clay",
    "closed_eyeblossom",
    "coal_block",
    "coal_ore",
    "coarse_dirt",
    "cobbled_deepslate",
    "cobbled_deepslate_slab",
    "cobbled_deepslate_stairs",
    "cobbled_deepslate_wall",
    "cobblestone",
    "cobblestone_slab",
    "cobblestone_stairs",
    "cobblestone_wall",
    "cobweb",
    "cocoa",
    "command_block",
    "comparator",
    "composter",
    "conduit",
    "copper_bars",
    "copper_block",
    "copper_bulb",
    "copper_chain",
    "copper_chest",
    "copper_door",
    "copper_golem_statue",
    "copper_grate",
    "copper_lantern",
    "copper_ore",
    "copper_torch",
    "copper_trapdoor",
    "copper_wall_torch",
    "cornflower",
    "cracked_deepslate_bricks",
    "cracked_deepslate_tiles",
    "cracked_nether_bricks",
    "cracked_polished_blackstone_bricks",
    "cracked_stone_bricks",
    "crafter",
    "crafting_table",
    "creaking_heart",
    "creeper_head",
    "creeper_wall_head",
    "crimson_button",
    "crimson_door",
    "crimson_fence",
    "crimson_fence_gate",
    "crimson_fungus",
    "crimson_hanging_sign",
    "crimson_hyphae",
    "crimson_nylium",
    "crimson_planks",
    "crimson_pressure_plate",
    "crimson_roots",
    "crimson_shelf",
    "crimson_sign",
    "crimson_slab",
    "crimson_stairs",
    "crimson_stem",
    "crimson_trapdoor",
    "crimson_wall_hanging_sign",
    "crimson_wall_sign",
    "crying_obsidian",
    "cut_copper",
    "cut_copper_slab",
    "cut_copper_stairs",
    "cut_red_sandstone",
    "cut_red_sandstone_slab",
    "cut_sandstone",
    "cut_sandstone_slab",
    "cyan_banner",
    "cyan_bed",
    "cyan_candle",
    "cyan_candle_cake",
    "cyan_carpet",
    "cyan_concrete",
    "cyan_concrete_powder",
    "cyan_concrete_slab",
    "cyan_concrete_stairs",
    "cyan_glazed_terracotta",
    "cyan_shulker_box",
    "cyan_stained_glass",
    "cyan_stained_glass_pane",
    "cyan_terracotta",
    "cyan_wall_banner",
    "cyan_wool",
    "cyan_wool_slab",
    "cyan_wool_stairs",
    "damaged_anvil",
    "dandelion",
    "dark_oak_button",
    "dark_oak_door",
    "dark_oak_fence",
    "dark_oak_fence_gate",
    "dark_oak_hanging_sign",
    "dark_oak_leaves",
    "dark_oak_log",
    "dark_oak_planks",
    "dark_oak_pressure_plate",
    "dark_oak_sapling",
    "dark_oak_shelf",
    "dark_oak_sign",
    "dark_oak_slab",
    "dark_oak_stairs",
    "dark_oak_trapdoor",
    "dark_oak_wall_hanging_sign",
    "dark_oak_wall_sign",
    "dark_oak_wood",
    "dark_prismarine",
    "dark_prismarine_slab",
    "dark_prismarine_stairs",
    "daylight_detector",
    "dead_brain_coral",
    "dead_brain_coral_block",
    "dead_brain_coral_fan",
    "dead_brain_coral_wall_fan",
    "dead_bubble_coral",
    "dead_bubble_coral_block",
    "dead_bubble_coral_fan",
    "dead_bubble_coral_wall_fan",
    "dead_bush",
    "dead_fire_coral",
    "dead_fire_coral_block",
    "dead_fire_coral_fan",
    "dead_fire_coral_wall_fan",
    "dead_horn_coral",
    "dead_horn_coral_block",
    "dead_horn_coral_fan",
    "dead_horn_coral_wall_fan",
    "dead_tube_coral",
    "dead_tube_coral_block",
    "dead_tube_coral_fan",
    "dead_tube_coral_wall_fan",
    "decorated_pot",
    "deepslate",
    "deepslate_brick_slab",
    "deepslate_brick_stairs",
    "deepslate_brick_wall",
    "deepslate_bricks",
    "deepslate_coal_ore",
    "deepslate_copper_ore",
    "deepslate_diamond_ore",
    "deepslate_emerald_ore",
    "deepslate_gold_ore",
    "deepslate_iron_ore",
    "deepslate_lapis_ore",
    "deepslate_redstone_ore",
    "deepslate_tile_slab",
    "deepslate_tile_stairs",
    "deepslate_tile_wall",
    "deepslate_tiles",
    "detector_rail",
    "diamond_block",
    "diamond_ore",
    "diorite",
    "diorite_slab",
    "diorite_stairs",
    "diorite_wall",
    "dirt",
    "dirt_path",
    "dispenser",
    "dragon_egg",
    "dragon_head",
    "dragon_wall_head",
    "dried_ghast",
    "dried_kelp_block",
    "dripstone_block",
    "dropper",
    "emerald_block",
    "emerald_ore",
    "enchanting_table",
    "end_gateway",
    "end_portal",
    "end_portal_frame",
    "end_rod",
    "end_stone",
    "end_stone_brick_slab",
    "end_stone_brick_stairs",
    "end_stone_brick_wall",
    "end_stone_bricks",
    "ender_chest",
    "exposed_chiseled_copper",
    "exposed_copper",
    "exposed_copper_bars",
    "exposed_copper_bulb",
    "exposed_copper_chain",
    "exposed_copper_chest",
    "exposed_copper_door",
    "exposed_copper_golem_statue",
    "exposed_copper_grate",
    "exposed_copper_lantern",
    "exposed_copper_trapdoor",
    "exposed_cut_copper",
    "exposed_cut_copper_slab",
    "exposed_cut_copper_stairs",
    "exposed_lightning_rod",
    "farmland",
    "fern",
    "fire",
    "fire_coral",
    "fire_coral_block",
    "fire_coral_fan",
    "fire_coral_wall_fan",
    "firefly_bush",
    "fletching_table",
    "flower_pot",
    "flowering_azalea",
    "flowering_azalea_leaves",
    "frogspawn",
    "frosted_ice",
    "furnace",
    "gilded_blackstone",
    "glass",
    "glass_pane",
    "glow_item_frame",
    "glow_lichen",
    "glowstone",
    "gold_block",
    "gold_ore",
    "golden_dandelion",
    "granite",
    "granite_slab",
    "granite_stairs",
    "granite_wall",
    "grass_block",
    "gravel",
    "gray_banner",
    "gray_bed",
    "gray_candle",
    "gray_candle_cake",
    "gray_carpet",
    "gray_concrete",
    "gray_concrete_powder",
    "gray_concrete_slab",
    "gray_concrete_stairs",
    "gray_glazed_terracotta",
    "gray_shulker_box",
    "gray_stained_glass",
    "gray_stained_glass_pane",
    "gray_terracotta",
    "gray_wall_banner",
    "gray_wool",
    "gray_wool_slab",
    "gray_wool_stairs",
    "green_banner",
    "green_bed",
    "green_candle",
    "green_candle_cake",
    "green_carpet",
    "green_concrete",
    "green_concrete_powder",
    "green_concrete_slab",
    "green_concrete_stairs",
    "green_glazed_terracotta",
    "green_shulker_box",
    "green_stained_glass",
    "green_stained_glass_pane",
    "green_terracotta",
    "green_wall_banner",
    "green_wool",
    "green_wool_slab",
    "green_wool_stairs",
    "grindstone",
    "hanging_roots",
    "hay_block",
    "heavy_core",
    "heavy_weighted_pressure_plate",
    "honey_block",
    "honeycomb_block",
    "hopper",
    "horn_coral",
    "horn_coral_block",
    "horn_coral_fan",
    "horn_coral_wall_fan",
    "ice",
    "infested_chiseled_stone_bricks",
    "infested_cobblestone",
    "infested_cracked_stone_bricks",
    "infested_deepslate",
    "infested_mossy_stone_bricks",
    "infested_stone",
    "infested_stone_bricks",
    "iron_bars",
    "iron_block",
    "iron_chain",
    "iron_door",
    "iron_ore",
    "iron_trapdoor",
    "item_frame",
    "jack_o_lantern",
    "jigsaw",
    "jukebox",
    "jungle_button",
    "jungle_door",
    "jungle_fence",
    "jungle_fence_gate",
    "jungle_hanging_sign",
    "jungle_leaves",
    "jungle_log",
    "jungle_planks",
    "jungle_pressure_plate",
    "jungle_sapling",
    "jungle_shelf",
    "jungle_sign",
    "jungle_slab",
    "jungle_stairs",
    "jungle_trapdoor",
    "jungle_wall_hanging_sign",
    "jungle_wall_sign",
    "jungle_wood",
    "kelp",
    "kelp_plant",
    "ladder",
    "lantern",
    "lapis_block",
    "lapis_ore",
    "large_amethyst_bud",
    "large_fern",
    "lava",
    "lava_cauldron",
    "leaf_litter",
    "lectern",
    "lever",
    "light",
    "light_blue_banner",
    "light_blue_bed",
    "light_blue_candle",
    "light_blue_candle_cake",
    "light_blue_carpet",
    "light_blue_concrete",
    "light_blue_concrete_powder",
    "light_blue_concrete_slab",
    "light_blue_concrete_stairs",
    "light_blue_glazed_terracotta",
    "light_blue_shulker_box",
    "light_blue_stained_glass",
    "light_blue_stained_glass_pane",
    "light_blue_terracotta",
    "light_blue_wall_banner",
    "light_blue_wool",
    "light_blue_wool_slab",
    "light_blue_wool_stairs",
    "light_gray_banner",
    "light_gray_bed",
    "light_gray_candle",
    "light_gray_candle_cake",
    "light_gray_carpet",
    "light_gray_concrete",
    "light_gray_concrete_powder",
    "light_gray_concrete_slab",
    "light_gray_concrete_stairs",
    "light_gray_glazed_terracotta",
    "light_gray_shulker_box",
    "light_gray_stained_glass",
    "light_gray_stained_glass_pane",
    "light_gray_terracotta",
    "light_gray_wall_banner",
    "light_gray_wool",
    "light_gray_wool_slab",
    "light_gray_wool_stairs",
    "light_weighted_pressure_plate",
    "lightning_rod",
    "lilac",
    "lily_of_the_valley",
    "lily_pad",
    "lime_banner",
    "lime_bed",
    "lime_candle",
    "lime_candle_cake",
    "lime_carpet",
    "lime_concrete",
    "lime_concrete_powder",
    "lime_concrete_slab",
    "lime_concrete_stairs",
    "lime_glazed_terracotta",
    "lime_shulker_box",
    "lime_stained_glass",
    "lime_stained_glass_pane",
    "lime_terracotta",
    "lime_wall_banner",
    "lime_wool",
    "lime_wool_slab",
    "lime_wool_stairs",
    "lodestone",
    "loom",
    "magenta_banner",
    "magenta_bed",
    "magenta_candle",
    "magenta_candle_cake",
    "magenta_carpet",
    "magenta_concrete",
    "magenta_concrete_powder",
    "magenta_concrete_slab",
    "magenta_concrete_stairs",
    "magenta_glazed_terracotta",
    "magenta_shulker_box",
    "magenta_stained_glass",
    "magenta_stained_glass_pane",
    "magenta_terracotta",
    "magenta_wall_banner",
    "magenta_wool",
    "magenta_wool_slab",
    "magenta_wool_stairs",
    "magma_block",
    "mangrove_button",
    "mangrove_door",
    "mangrove_fence",
    "mangrove_fence_gate",
    "mangrove_hanging_sign",
    "mangrove_leaves",
    "mangrove_log",
    "mangrove_planks",
    "mangrove_pressure_plate",
    "mangrove_propagule",
    "mangrove_roots",
    "mangrove_shelf",
    "mangrove_sign",
    "mangrove_slab",
    "mangrove_stairs",
    "mangrove_trapdoor",
    "mangrove_wall_hanging_sign",
    "mangrove_wall_sign",
    "mangrove_wood",
    "medium_amethyst_bud",
    "melon",
    "melon_stem",
    "moss_block",
    "moss_carpet",
    "mossy_cobblestone",
    "mossy_cobblestone_slab",
    "mossy_cobblestone_stairs",
    "mossy_cobblestone_wall",
    "mossy_stone_brick_slab",
    "mossy_stone_brick_stairs",
    "mossy_stone_brick_wall",
    "mossy_stone_bricks",
    "moving_piston",
    "mud",
    "mud_brick_slab",
    "mud_brick_stairs",
    "mud_brick_wall",
    "mud_bricks",
    "muddy_mangrove_roots",
    "mushroom_stem",
    "mycelium",
    "nether_brick_fence",
    "nether_brick_slab",
    "nether_brick_stairs",
    "nether_brick_wall",
    "nether_bricks",
    "nether_gold_ore",
    "nether_portal",
    "nether_quartz_ore",
    "nether_sprouts",
    "nether_wart",
    "nether_wart_block",
    "netherite_block",
    "netherrack",
    "note_block",
    "oak_button",
    "oak_door",
    "oak_fence",
    "oak_fence_gate",
    "oak_hanging_sign",
    "oak_leaves",
    "oak_log",
    "oak_planks",
    "oak_pressure_plate",
    "oak_sapling",
    "oak_shelf",
    "oak_sign",
    "oak_slab",
    "oak_stairs",
    "oak_trapdoor",
    "oak_wall_hanging_sign",
    "oak_wall_sign",
    "oak_wood",
    "observer",
    "obsidian",
    "ochre_froglight",
    "open_eyeblossom",
    "orange_banner",
    "orange_bed",
    "orange_candle",
    "orange_candle_cake",
    "orange_carpet",
    "orange_concrete",
    "orange_concrete_powder",
    "orange_concrete_slab",
    "orange_concrete_stairs",
    "orange_glazed_terracotta",
    "orange_poplar_leaves",
    "orange_shulker_box",
    "orange_stained_glass",
    "orange_stained_glass_pane",
    "orange_terracotta",
    "orange_tulip",
    "orange_wall_banner",
    "orange_wool",
    "orange_wool_slab",
    "orange_wool_stairs",
    "oxeye_daisy",
    "oxidized_chiseled_copper",
    "oxidized_copper",
    "oxidized_copper_bars",
    "oxidized_copper_bulb",
    "oxidized_copper_chain",
    "oxidized_copper_chest",
    "oxidized_copper_door",
    "oxidized_copper_golem_statue",
    "oxidized_copper_grate",
    "oxidized_copper_lantern",
    "oxidized_copper_trapdoor",
    "oxidized_cut_copper",
    "oxidized_cut_copper_slab",
    "oxidized_cut_copper_stairs",
    "oxidized_lightning_rod",
    "packed_ice",
    "packed_mud",
    "pale_hanging_moss",
    "pale_moss_block",
    "pale_moss_carpet",
    "pale_oak_button",
    "pale_oak_door",
    "pale_oak_fence",
    "pale_oak_fence_gate",
    "pale_oak_hanging_sign",
    "pale_oak_leaves",
    "pale_oak_log",
    "pale_oak_planks",
    "pale_oak_pressure_plate",
    "pale_oak_sapling",
    "pale_oak_shelf",
    "pale_oak_sign",
    "pale_oak_slab",
    "pale_oak_stairs",
    "pale_oak_trapdoor",
    "pale_oak_wall_hanging_sign",
    "pale_oak_wall_sign",
    "pale_oak_wood",
    "pearlescent_froglight",
    "peony",
    "petrified_oak_slab",
    "piglin_head",
    "piglin_wall_head",
    "pink_banner",
    "pink_bed",
    "pink_candle",
    "pink_candle_cake",
    "pink_carpet",
    "pink_concrete",
    "pink_concrete_powder",
    "pink_concrete_slab",
    "pink_concrete_stairs",
    "pink_glazed_terracotta",
    "pink_petals",
    "pink_shulker_box",
    "pink_stained_glass",
    "pink_stained_glass_pane",
    "pink_terracotta",
    "pink_tulip",
    "pink_wall_banner",
    "pink_wool",
    "pink_wool_slab",
    "pink_wool_stairs",
    "piston",
    "piston_head",
    "pitcher_crop",
    "pitcher_plant",
    "player_head",
    "player_wall_head",
    "podzol",
    "pointed_dripstone",
    "polished_andesite",
    "polished_andesite_slab",
    "polished_andesite_stairs",
    "polished_basalt",
    "polished_blackstone",
    "polished_blackstone_brick_slab",
    "polished_blackstone_brick_stairs",
    "polished_blackstone_brick_wall",
    "polished_blackstone_bricks",
    "polished_blackstone_button",
    "polished_blackstone_pressure_plate",
    "polished_blackstone_slab",
    "polished_blackstone_stairs",
    "polished_blackstone_wall",
    "polished_cinnabar",
    "polished_cinnabar_slab",
    "polished_cinnabar_stairs",
    "polished_cinnabar_wall",
    "polished_deepslate",
    "polished_deepslate_slab",
    "polished_deepslate_stairs",
    "polished_deepslate_wall",
    "polished_diorite",
    "polished_diorite_slab",
    "polished_diorite_stairs",
    "polished_granite",
    "polished_granite_slab",
    "polished_granite_stairs",
    "polished_sulfur",
    "polished_sulfur_slab",
    "polished_sulfur_stairs",
    "polished_sulfur_wall",
    "polished_tuff",
    "polished_tuff_slab",
    "polished_tuff_stairs",
    "polished_tuff_wall",
    "poplar_button",
    "poplar_door",
    "poplar_fence",
    "poplar_fence_gate",
    "poplar_hanging_sign",
    "poplar_log",
    "poplar_planks",
    "poplar_pressure_plate",
    "poplar_sapling",
    "poplar_shelf",
    "poplar_sign",
    "poplar_slab",
    "poplar_stairs",
    "poplar_trapdoor",
    "poplar_wall_hanging_sign",
    "poplar_wall_sign",
    "poplar_wood",
    "poppy",
    "potatoes",
    "potent_sulfur",
    "potted_acacia_sapling",
    "potted_allium",
    "potted_azalea_bush",
    "potted_azure_bluet",
    "potted_bamboo",
    "potted_birch_sapling",
    "potted_blue_orchid",
    "potted_brown_mushroom",
    "potted_cactus",
    "potted_cherry_sapling",
    "potted_closed_eyeblossom",
    "potted_cornflower",
    "potted_crimson_fungus",
    "potted_crimson_roots",
    "potted_dandelion",
    "potted_dark_oak_sapling",
    "potted_dead_bush",
    "potted_fern",
    "potted_flowering_azalea_bush",
    "potted_golden_dandelion",
    "potted_jungle_sapling",
    "potted_lily_of_the_valley",
    "potted_mangrove_propagule",
    "potted_oak_sapling",
    "potted_open_eyeblossom",
    "potted_orange_tulip",
    "potted_oxeye_daisy",
    "potted_pale_oak_sapling",
    "potted_pink_tulip",
    "potted_poplar_sapling",
    "potted_poppy",
    "potted_red_mushroom",
    "potted_red_tulip",
    "potted_spruce_sapling",
    "potted_torchflower",
    "potted_warped_fungus",
    "potted_warped_roots",
    "potted_white_tulip",
    "potted_wither_rose",
    "powder_snow",
    "powder_snow_cauldron",
    "powered_rail",
    "prismarine",
    "prismarine_brick_slab",
    "prismarine_brick_stairs",
    "prismarine_bricks",
    "prismarine_slab",
    "prismarine_stairs",
    "prismarine_wall",
    "pumpkin",
    "pumpkin_stem",
    "purple_banner",
    "purple_bed",
    "purple_candle",
    "purple_candle_cake",
    "purple_carpet",
    "purple_concrete",
    "purple_concrete_powder",
    "purple_concrete_slab",
    "purple_concrete_stairs",
    "purple_glazed_terracotta",
    "purple_shulker_box",
    "purple_stained_glass",
    "purple_stained_glass_pane",
    "purple_terracotta",
    "purple_wall_banner",
    "purple_wool",
    "purple_wool_slab",
    "purple_wool_stairs",
    "purpur_block",
    "purpur_pillar",
    "purpur_slab",
    "purpur_stairs",
    "quartz_block",
    "quartz_bricks",
    "quartz_pillar",
    "quartz_slab",
    "quartz_stairs",
    "rail",
    "raw_copper_block",
    "raw_gold_block",
    "raw_iron_block",
    "red_banner",
    "red_bed",
    "red_candle",
    "red_candle_cake",
    "red_carpet",
    "red_concrete",
    "red_concrete_powder",
    "red_concrete_slab",
    "red_concrete_stairs",
    "red_glazed_terracotta",
    "red_mushroom",
    "red_mushroom_block",
    "red_nether_brick_slab",
    "red_nether_brick_stairs",
    "red_nether_brick_wall",
    "red_nether_bricks",
    "red_poplar_leaves",
    "red_sand",
    "red_sandstone",
    "red_sandstone_slab",
    "red_sandstone_stairs",
    "red_sandstone_wall",
    "red_shrub",
    "red_shulker_box",
    "red_stained_glass",
    "red_stained_glass_pane",
    "red_terracotta",
    "red_tulip",
    "red_wall_banner",
    "red_wool",
    "red_wool_slab",
    "red_wool_stairs",
    "redstone_block",
    "redstone_lamp",
    "redstone_ore",
    "redstone_torch",
    "redstone_wall_torch",
    "redstone_wire",
    "reinforced_deepslate",
    "repeater",
    "repeating_command_block",
    "resin_block",
    "resin_brick_slab",
    "resin_brick_stairs",
    "resin_brick_wall",
    "resin_bricks",
    "resin_clump",
    "respawn_anchor",
    "rooted_dirt",
    "rose_bush",
    "sand",
    "sandstone",
    "sandstone_slab",
    "sandstone_stairs",
    "sandstone_wall",
    "scaffolding",
    "sculk",
    "sculk_catalyst",
    "sculk_sensor",
    "sculk_shrieker",
    "sculk_vein",
    "sea_lantern",
    "sea_pickle",
    "seagrass",
    "shelf_mushroom",
    "short_dry_grass",
    "short_grass",
    "shroomlight",
    "shulker_box",
    "skeleton_skull",
    "skeleton_wall_skull",
    "slime_block",
    "small_amethyst_bud",
    "small_dripleaf",
    "smithing_table",
    "smoker",
    "smooth_basalt",
    "smooth_quartz",
    "smooth_quartz_slab",
    "smooth_quartz_stairs",
    "smooth_red_sandstone",
    "smooth_red_sandstone_slab",
    "smooth_red_sandstone_stairs",
    "smooth_sandstone",
    "smooth_sandstone_slab",
    "smooth_sandstone_stairs",
    "smooth_stone",
    "smooth_stone_slab",
    "sniffer_egg",
    "snow",
    "snow_block",
    "soul_campfire",
    "soul_fire",
    "soul_lantern",
    "soul_sand",
    "soul_soil",
    "soul_torch",
    "soul_wall_torch",
    "spawner",
    "sponge",
    "spore_blossom",
    "spruce_button",
    "spruce_door",
    "spruce_fence",
    "spruce_fence_gate",
    "spruce_hanging_sign",
    "spruce_leaves",
    "spruce_log",
    "spruce_planks",
    "spruce_pressure_plate",
    "spruce_sapling",
    "spruce_shelf",
    "spruce_sign",
    "spruce_slab",
    "spruce_stairs",
    "spruce_trapdoor",
    "spruce_wall_hanging_sign",
    "spruce_wall_sign",
    "spruce_wood",
    "sticky_piston",
    "stone",
    "stone_brick_slab",
    "stone_brick_stairs",
    "stone_brick_wall",
    "stone_bricks",
    "stone_button",
    "stone_pressure_plate",
    "stone_slab",
    "stone_stairs",
    "stonecutter",
    "straw_bed",
    "stripped_acacia_log",
    "stripped_acacia_wood",
    "stripped_bamboo_block",
    "stripped_birch_log",
    "stripped_birch_wood",
    "stripped_cherry_log",
    "stripped_cherry_wood",
    "stripped_crimson_hyphae",
    "stripped_crimson_stem",
    "stripped_dark_oak_log",
    "stripped_dark_oak_wood",
    "stripped_jungle_log",
    "stripped_jungle_wood",
    "stripped_mangrove_log",
    "stripped_mangrove_wood",
    "stripped_oak_log",
    "stripped_oak_wood",
    "stripped_pale_oak_log",
    "stripped_pale_oak_wood",
    "stripped_poplar_log",
    "stripped_poplar_wood",
    "stripped_spruce_log",
    "stripped_spruce_wood",
    "stripped_warped_hyphae",
    "stripped_warped_stem",
    "structure_block",
    "structure_void",
    "sugar_cane",
    "sulfur",
    "sulfur_brick_slab",
    "sulfur_brick_stairs",
    "sulfur_brick_wall",
    "sulfur_bricks",
    "sulfur_slab",
    "sulfur_spike",
    "sulfur_stairs",
    "sulfur_wall",
    "sunflower",
    "suspicious_gravel",
    "suspicious_sand",
    "sweet_berry_bush",
    "tall_dry_grass",
    "tall_grass",
    "tall_seagrass",
    "target",
    "terracotta",
    "test_block",
    "test_instance_block",
    "tinted_glass",
    "tnt",
    "torch",
    "torchflower",
    "torchflower_crop",
    "trapped_chest",
    "trial_spawner",
    "tripwire",
    "tripwire_hook",
    "tube_coral",
    "tube_coral_block",
    "tube_coral_fan",
    "tube_coral_wall_fan",
    "tuff",
    "tuff_brick_slab",
    "tuff_brick_stairs",
    "tuff_brick_wall",
    "tuff_bricks",
    "tuff_slab",
    "tuff_stairs",
    "tuff_wall",
    "turtle_egg",
    "twisting_vines",
    "twisting_vines_plant",
    "vault",
    "verdant_froglight",
    "vine",
    "void_air",
    "wall_torch",
    "warped_button",
    "warped_door",
    "warped_fence",
    "warped_fence_gate",
    "warped_fungus",
    "warped_hanging_sign",
    "warped_hyphae",
    "warped_nylium",
    "warped_planks",
    "warped_pressure_plate",
    "warped_roots",
    "warped_shelf",
    "warped_sign",
    "warped_slab",
    "warped_stairs",
    "warped_stem",
    "warped_trapdoor",
    "warped_wall_hanging_sign",
    "warped_wall_sign",
    "warped_wart_block",
    "water",
    "water_cauldron",
    "waxed_chiseled_copper",
    "waxed_copper_bars",
    "waxed_copper_block",
    "waxed_copper_bulb",
    "waxed_copper_chain",
    "waxed_copper_chest",
    "waxed_copper_door",
    "waxed_copper_golem_statue",
    "waxed_copper_grate",
    "waxed_copper_lantern",
    "waxed_copper_trapdoor",
    "waxed_cut_copper",
    "waxed_cut_copper_slab",
    "waxed_cut_copper_stairs",
    "waxed_exposed_chiseled_copper",
    "waxed_exposed_copper",
    "waxed_exposed_copper_bars",
    "waxed_exposed_copper_bulb",
    "waxed_exposed_copper_chain",
    "waxed_exposed_copper_chest",
    "waxed_exposed_copper_door",
    "waxed_exposed_copper_golem_statue",
    "waxed_exposed_copper_grate",
    "waxed_exposed_copper_lantern",
    "waxed_exposed_copper_trapdoor",
    "waxed_exposed_cut_copper",
    "waxed_exposed_cut_copper_slab",
    "waxed_exposed_cut_copper_stairs",
    "waxed_exposed_lightning_rod",
    "waxed_lightning_rod",
    "waxed_oxidized_chiseled_copper",
    "waxed_oxidized_copper",
    "waxed_oxidized_copper_bars",
    "waxed_oxidized_copper_bulb",
    "waxed_oxidized_copper_chain",
    "waxed_oxidized_copper_chest",
    "waxed_oxidized_copper_door",
    "waxed_oxidized_copper_golem_statue",
    "waxed_oxidized_copper_grate",
    "waxed_oxidized_copper_lantern",
    "waxed_oxidized_copper_trapdoor",
    "waxed_oxidized_cut_copper",
    "waxed_oxidized_cut_copper_slab",
    "waxed_oxidized_cut_copper_stairs",
    "waxed_oxidized_lightning_rod",
    "waxed_weathered_chiseled_copper",
    "waxed_weathered_copper",
    "waxed_weathered_copper_bars",
    "waxed_weathered_copper_bulb",
    "waxed_weathered_copper_chain",
    "waxed_weathered_copper_chest",
    "waxed_weathered_copper_door",
    "waxed_weathered_copper_golem_statue",
    "waxed_weathered_copper_grate",
    "waxed_weathered_copper_lantern",
    "waxed_weathered_copper_trapdoor",
    "waxed_weathered_cut_copper",
    "waxed_weathered_cut_copper_slab",
    "waxed_weathered_cut_copper_stairs",
    "waxed_weathered_lightning_rod",
    "weathered_chiseled_copper",
    "weathered_copper",
    "weathered_copper_bars",
    "weathered_copper_bulb",
    "weathered_copper_chain",
    "weathered_copper_chest",
    "weathered_copper_door",
    "weathered_copper_golem_statue",
    "weathered_copper_grate",
    "weathered_copper_lantern",
    "weathered_copper_trapdoor",
    "weathered_cut_copper",
    "weathered_cut_copper_slab",
    "weathered_cut_copper_stairs",
    "weathered_lightning_rod",
    "weeping_vines",
    "weeping_vines_plant",
    "wet_sponge",
    "wheat",
    "white_banner",
    "white_bed",
    "white_candle",
    "white_candle_cake",
    "white_carpet",
    "white_concrete",
    "white_concrete_powder",
    "white_concrete_slab",
    "white_concrete_stairs",
    "white_glazed_terracotta",
    "white_shulker_box",
    "white_stained_glass",
    "white_stained_glass_pane",
    "white_terracotta",
    "white_tulip",
    "white_wall_banner",
    "white_wool",
    "white_wool_slab",
    "white_wool_stairs",
    "wildflowers",
    "wither_rose",
    "wither_skeleton_skull",
    "wither_skeleton_wall_skull",
    "yellow_banner",
    "yellow_bed",
    "yellow_candle",
    "yellow_candle_cake",
    "yellow_carpet",
    "yellow_concrete",
    "yellow_concrete_powder",
    "yellow_concrete_slab",
    "yellow_concrete_stairs",
    "yellow_glazed_terracotta",
    "yellow_poplar_leaves",
    "yellow_shulker_box",
    "yellow_stained_glass",
    "yellow_stained_glass_pane",
    "yellow_terracotta",
    "yellow_wall_banner",
    "yellow_wool",
    "yellow_wool_slab",
    "yellow_wool_stairs",
    "zombie_head",
    "zombie_wall_head"
  ]);
});

// src/arguments/generated/_registry/equipments.ts
var EQUIPMENTS_SET;
var init_equipments = __esm(() => {
  init_sandstone();
  EQUIPMENTS_SET = new Set2([
    "armadillo_scute",
    "black_carpet",
    "black_harness",
    "blue_carpet",
    "blue_harness",
    "brown_carpet",
    "brown_harness",
    "chainmail",
    "copper",
    "cyan_carpet",
    "cyan_harness",
    "diamond",
    "elytra",
    "gold",
    "gray_carpet",
    "gray_harness",
    "green_carpet",
    "green_harness",
    "iron",
    "leather",
    "light_blue_carpet",
    "light_blue_harness",
    "light_gray_carpet",
    "light_gray_harness",
    "lime_carpet",
    "lime_harness",
    "magenta_carpet",
    "magenta_harness",
    "netherite",
    "orange_carpet",
    "orange_harness",
    "pink_carpet",
    "pink_harness",
    "purple_carpet",
    "purple_harness",
    "red_carpet",
    "red_harness",
    "saddle",
    "trader_llama",
    "trader_llama_baby",
    "turtle_scute",
    "white_carpet",
    "white_harness",
    "yellow_carpet",
    "yellow_harness"
  ]);
});

// src/arguments/generated/_registry/fonts.ts
var FONTS_SET;
var init_fonts = __esm(() => {
  init_sandstone();
  FONTS_SET = new Set2([
    "alt",
    "default",
    "illageralt",
    "include/default",
    "include/space",
    "include/unifont",
    "include/unifont_pua",
    "uniform"
  ]);
});

// src/arguments/generated/_registry/item_definitions.ts
var ITEM_DEFINITIONS_SET;
var init_item_definitions = __esm(() => {
  init_sandstone();
  ITEM_DEFINITIONS_SET = new Set2([
    "abandoned_campsite_map",
    "acacia_boat",
    "acacia_button",
    "acacia_chest_boat",
    "acacia_door",
    "acacia_fence",
    "acacia_fence_gate",
    "acacia_hanging_sign",
    "acacia_leaves",
    "acacia_log",
    "acacia_planks",
    "acacia_pressure_plate",
    "acacia_sapling",
    "acacia_shelf",
    "acacia_sign",
    "acacia_slab",
    "acacia_stairs",
    "acacia_trapdoor",
    "acacia_wood",
    "activator_rail",
    "air",
    "allay_spawn_egg",
    "allium",
    "amethyst_block",
    "amethyst_cluster",
    "amethyst_shard",
    "ancient_city_map",
    "ancient_debris",
    "andesite",
    "andesite_slab",
    "andesite_stairs",
    "andesite_wall",
    "angler_pottery_sherd",
    "anvil",
    "apple",
    "archer_pottery_sherd",
    "armadillo_scute",
    "armadillo_spawn_egg",
    "armor_stand",
    "arms_up_pottery_sherd",
    "arrow",
    "axolotl_bucket",
    "axolotl_spawn_egg",
    "azalea",
    "azalea_leaves",
    "azure_bluet",
    "baked_potato",
    "bamboo",
    "bamboo_block",
    "bamboo_button",
    "bamboo_chest_raft",
    "bamboo_door",
    "bamboo_fence",
    "bamboo_fence_gate",
    "bamboo_hanging_sign",
    "bamboo_mosaic",
    "bamboo_mosaic_slab",
    "bamboo_mosaic_stairs",
    "bamboo_planks",
    "bamboo_pressure_plate",
    "bamboo_raft",
    "bamboo_shelf",
    "bamboo_sign",
    "bamboo_slab",
    "bamboo_stairs",
    "bamboo_trapdoor",
    "barrel",
    "barrier",
    "basalt",
    "bat_spawn_egg",
    "beacon",
    "bedrock",
    "bee_nest",
    "bee_spawn_egg",
    "beef",
    "beehive",
    "beetroot",
    "beetroot_seeds",
    "beetroot_soup",
    "bell",
    "big_dripleaf",
    "birch_boat",
    "birch_button",
    "birch_chest_boat",
    "birch_door",
    "birch_fence",
    "birch_fence_gate",
    "birch_hanging_sign",
    "birch_leaves",
    "birch_log",
    "birch_planks",
    "birch_pressure_plate",
    "birch_sapling",
    "birch_shelf",
    "birch_sign",
    "birch_slab",
    "birch_stairs",
    "birch_trapdoor",
    "birch_wood",
    "black_banner",
    "black_bed",
    "black_bundle",
    "black_candle",
    "black_carpet",
    "black_concrete",
    "black_concrete_powder",
    "black_concrete_slab",
    "black_concrete_stairs",
    "black_cushion",
    "black_dye",
    "black_glazed_terracotta",
    "black_harness",
    "black_shulker_box",
    "black_stained_glass",
    "black_stained_glass_pane",
    "black_terracotta",
    "black_wool",
    "black_wool_slab",
    "black_wool_stairs",
    "blackstone",
    "blackstone_slab",
    "blackstone_stairs",
    "blackstone_wall",
    "blade_pottery_sherd",
    "blast_furnace",
    "blaze_powder",
    "blaze_rod",
    "blaze_spawn_egg",
    "blue_banner",
    "blue_bed",
    "blue_bundle",
    "blue_candle",
    "blue_carpet",
    "blue_concrete",
    "blue_concrete_powder",
    "blue_concrete_slab",
    "blue_concrete_stairs",
    "blue_cushion",
    "blue_dye",
    "blue_egg",
    "blue_glazed_terracotta",
    "blue_harness",
    "blue_ice",
    "blue_orchid",
    "blue_shulker_box",
    "blue_stained_glass",
    "blue_stained_glass_pane",
    "blue_terracotta",
    "blue_wool",
    "blue_wool_slab",
    "blue_wool_stairs",
    "bogged_spawn_egg",
    "bolt_armor_trim_smithing_template",
    "bone",
    "bone_block",
    "bone_meal",
    "book",
    "bookshelf",
    "bordure_indented_banner_pattern",
    "bow",
    "bowl",
    "brain_coral",
    "brain_coral_block",
    "brain_coral_fan",
    "bread",
    "breeze_rod",
    "breeze_spawn_egg",
    "brewer_pottery_sherd",
    "brewing_stand",
    "brick",
    "brick_slab",
    "brick_stairs",
    "brick_wall",
    "bricks",
    "brown_banner",
    "brown_bed",
    "brown_bundle",
    "brown_candle",
    "brown_carpet",
    "brown_concrete",
    "brown_concrete_powder",
    "brown_concrete_slab",
    "brown_concrete_stairs",
    "brown_cushion",
    "brown_dye",
    "brown_egg",
    "brown_glazed_terracotta",
    "brown_harness",
    "brown_mushroom",
    "brown_mushroom_block",
    "brown_shulker_box",
    "brown_stained_glass",
    "brown_stained_glass_pane",
    "brown_terracotta",
    "brown_wool",
    "brown_wool_slab",
    "brown_wool_stairs",
    "brush",
    "bubble_coral",
    "bubble_coral_block",
    "bubble_coral_fan",
    "bucket",
    "budding_amethyst",
    "bundle",
    "buried_treasure_map",
    "burn_pottery_sherd",
    "bush",
    "cactus",
    "cactus_flower",
    "cake",
    "calcite",
    "calibrated_sculk_sensor",
    "camel_husk_spawn_egg",
    "camel_spawn_egg",
    "campfire",
    "candle",
    "carrot",
    "carrot_on_a_stick",
    "cartography_table",
    "carved_pumpkin",
    "cat_spawn_egg",
    "cauldron",
    "cave_spider_spawn_egg",
    "chain_command_block",
    "chainmail_boots",
    "chainmail_chestplate",
    "chainmail_helmet",
    "chainmail_leggings",
    "charcoal",
    "cherry_boat",
    "cherry_button",
    "cherry_chest_boat",
    "cherry_door",
    "cherry_fence",
    "cherry_fence_gate",
    "cherry_hanging_sign",
    "cherry_leaves",
    "cherry_log",
    "cherry_planks",
    "cherry_pressure_plate",
    "cherry_sapling",
    "cherry_shelf",
    "cherry_sign",
    "cherry_slab",
    "cherry_stairs",
    "cherry_trapdoor",
    "cherry_wood",
    "chest",
    "chest_minecart",
    "chicken",
    "chicken_spawn_egg",
    "chipped_anvil",
    "chiseled_bookshelf",
    "chiseled_cinnabar",
    "chiseled_copper",
    "chiseled_deepslate",
    "chiseled_nether_bricks",
    "chiseled_polished_blackstone",
    "chiseled_quartz_block",
    "chiseled_red_sandstone",
    "chiseled_resin_bricks",
    "chiseled_sandstone",
    "chiseled_stone_bricks",
    "chiseled_sulfur",
    "chiseled_tuff",
    "chiseled_tuff_bricks",
    "chorus_flower",
    "chorus_fruit",
    "chorus_plant",
    "cinnabar",
    "cinnabar_brick_slab",
    "cinnabar_brick_stairs",
    "cinnabar_brick_wall",
    "cinnabar_bricks",
    "cinnabar_slab",
    "cinnabar_stairs",
    "cinnabar_wall",
    "clay",
    "clay_ball",
    "clock",
    "closed_eyeblossom",
    "coal",
    "coal_block",
    "coal_ore",
    "coarse_dirt",
    "coast_armor_trim_smithing_template",
    "cobbled_deepslate",
    "cobbled_deepslate_slab",
    "cobbled_deepslate_stairs",
    "cobbled_deepslate_wall",
    "cobblestone",
    "cobblestone_slab",
    "cobblestone_stairs",
    "cobblestone_wall",
    "cobweb",
    "cocoa_beans",
    "cod",
    "cod_bucket",
    "cod_spawn_egg",
    "command_block",
    "command_block_minecart",
    "comparator",
    "compass",
    "composter",
    "conduit",
    "cooked_beef",
    "cooked_chicken",
    "cooked_cod",
    "cooked_mutton",
    "cooked_porkchop",
    "cooked_rabbit",
    "cooked_salmon",
    "cookie",
    "copper_axe",
    "copper_bars",
    "copper_block",
    "copper_boots",
    "copper_bulb",
    "copper_chain",
    "copper_chest",
    "copper_chestplate",
    "copper_door",
    "copper_golem_spawn_egg",
    "copper_golem_statue",
    "copper_grate",
    "copper_helmet",
    "copper_hoe",
    "copper_horse_armor",
    "copper_ingot",
    "copper_lantern",
    "copper_leggings",
    "copper_nautilus_armor",
    "copper_nugget",
    "copper_ore",
    "copper_pickaxe",
    "copper_shovel",
    "copper_spear",
    "copper_sword",
    "copper_torch",
    "copper_trapdoor",
    "cornflower",
    "cow_spawn_egg",
    "cracked_deepslate_bricks",
    "cracked_deepslate_tiles",
    "cracked_nether_bricks",
    "cracked_polished_blackstone_bricks",
    "cracked_stone_bricks",
    "crafter",
    "crafting_table",
    "creaking_heart",
    "creaking_spawn_egg",
    "creeper_banner_pattern",
    "creeper_head",
    "creeper_spawn_egg",
    "crimson_button",
    "crimson_door",
    "crimson_fence",
    "crimson_fence_gate",
    "crimson_fungus",
    "crimson_hanging_sign",
    "crimson_hyphae",
    "crimson_nylium",
    "crimson_planks",
    "crimson_pressure_plate",
    "crimson_roots",
    "crimson_shelf",
    "crimson_sign",
    "crimson_slab",
    "crimson_stairs",
    "crimson_stem",
    "crimson_trapdoor",
    "crossbow",
    "crying_obsidian",
    "cut_copper",
    "cut_copper_slab",
    "cut_copper_stairs",
    "cut_red_sandstone",
    "cut_red_sandstone_slab",
    "cut_sandstone",
    "cut_sandstone_slab",
    "cyan_banner",
    "cyan_bed",
    "cyan_bundle",
    "cyan_candle",
    "cyan_carpet",
    "cyan_concrete",
    "cyan_concrete_powder",
    "cyan_concrete_slab",
    "cyan_concrete_stairs",
    "cyan_cushion",
    "cyan_dye",
    "cyan_glazed_terracotta",
    "cyan_harness",
    "cyan_shulker_box",
    "cyan_stained_glass",
    "cyan_stained_glass_pane",
    "cyan_terracotta",
    "cyan_wool",
    "cyan_wool_slab",
    "cyan_wool_stairs",
    "damaged_anvil",
    "dandelion",
    "danger_pottery_sherd",
    "dark_oak_boat",
    "dark_oak_button",
    "dark_oak_chest_boat",
    "dark_oak_door",
    "dark_oak_fence",
    "dark_oak_fence_gate",
    "dark_oak_hanging_sign",
    "dark_oak_leaves",
    "dark_oak_log",
    "dark_oak_planks",
    "dark_oak_pressure_plate",
    "dark_oak_sapling",
    "dark_oak_shelf",
    "dark_oak_sign",
    "dark_oak_slab",
    "dark_oak_stairs",
    "dark_oak_trapdoor",
    "dark_oak_wood",
    "dark_prismarine",
    "dark_prismarine_slab",
    "dark_prismarine_stairs",
    "daylight_detector",
    "dead_brain_coral",
    "dead_brain_coral_block",
    "dead_brain_coral_fan",
    "dead_bubble_coral",
    "dead_bubble_coral_block",
    "dead_bubble_coral_fan",
    "dead_bush",
    "dead_fire_coral",
    "dead_fire_coral_block",
    "dead_fire_coral_fan",
    "dead_horn_coral",
    "dead_horn_coral_block",
    "dead_horn_coral_fan",
    "dead_tube_coral",
    "dead_tube_coral_block",
    "dead_tube_coral_fan",
    "debug_stick",
    "decorated_pot",
    "deepslate",
    "deepslate_brick_slab",
    "deepslate_brick_stairs",
    "deepslate_brick_wall",
    "deepslate_bricks",
    "deepslate_coal_ore",
    "deepslate_copper_ore",
    "deepslate_diamond_ore",
    "deepslate_emerald_ore",
    "deepslate_gold_ore",
    "deepslate_iron_ore",
    "deepslate_lapis_ore",
    "deepslate_redstone_ore",
    "deepslate_tile_slab",
    "deepslate_tile_stairs",
    "deepslate_tile_wall",
    "deepslate_tiles",
    "desert_pyramid_map",
    "desert_village_map",
    "detector_rail",
    "diamond",
    "diamond_axe",
    "diamond_block",
    "diamond_boots",
    "diamond_chestplate",
    "diamond_helmet",
    "diamond_hoe",
    "diamond_horse_armor",
    "diamond_leggings",
    "diamond_nautilus_armor",
    "diamond_ore",
    "diamond_pickaxe",
    "diamond_shovel",
    "diamond_spear",
    "diamond_sword",
    "diorite",
    "diorite_slab",
    "diorite_stairs",
    "diorite_wall",
    "dirt",
    "dirt_path",
    "disc_fragment_5",
    "dispenser",
    "dolphin_spawn_egg",
    "donkey_spawn_egg",
    "dragon_breath",
    "dragon_egg",
    "dragon_head",
    "dried_ghast",
    "dried_kelp",
    "dried_kelp_block",
    "dripstone_block",
    "dropper",
    "drowned_spawn_egg",
    "dune_armor_trim_smithing_template",
    "echo_shard",
    "egg",
    "elder_guardian_spawn_egg",
    "elytra",
    "emerald",
    "emerald_block",
    "emerald_ore",
    "enchanted_book",
    "enchanted_golden_apple",
    "enchanting_table",
    "end_crystal",
    "end_portal_frame",
    "end_rod",
    "end_stone",
    "end_stone_brick_slab",
    "end_stone_brick_stairs",
    "end_stone_brick_wall",
    "end_stone_bricks",
    "ender_chest",
    "ender_dragon_spawn_egg",
    "ender_eye",
    "ender_pearl",
    "enderman_spawn_egg",
    "endermite_spawn_egg",
    "evoker_spawn_egg",
    "experience_bottle",
    "explorer_pottery_sherd",
    "exposed_chiseled_copper",
    "exposed_copper",
    "exposed_copper_bars",
    "exposed_copper_bulb",
    "exposed_copper_chain",
    "exposed_copper_chest",
    "exposed_copper_door",
    "exposed_copper_golem_statue",
    "exposed_copper_grate",
    "exposed_copper_lantern",
    "exposed_copper_trapdoor",
    "exposed_cut_copper",
    "exposed_cut_copper_slab",
    "exposed_cut_copper_stairs",
    "exposed_lightning_rod",
    "eye_armor_trim_smithing_template",
    "farmland",
    "feather",
    "fermented_spider_eye",
    "fern",
    "field_masoned_banner_pattern",
    "filled_map",
    "fire_charge",
    "fire_coral",
    "fire_coral_block",
    "fire_coral_fan",
    "firefly_bush",
    "firework_rocket",
    "firework_star",
    "fishing_rod",
    "fletching_table",
    "flint",
    "flint_and_steel",
    "flow_armor_trim_smithing_template",
    "flow_banner_pattern",
    "flow_pottery_sherd",
    "flower_banner_pattern",
    "flower_pot",
    "flowering_azalea",
    "flowering_azalea_leaves",
    "fox_spawn_egg",
    "friend_pottery_sherd",
    "frog_spawn_egg",
    "frogspawn",
    "furnace",
    "furnace_minecart",
    "ghast_spawn_egg",
    "ghast_tear",
    "gilded_blackstone",
    "glass",
    "glass_bottle",
    "glass_pane",
    "glistering_melon_slice",
    "globe_banner_pattern",
    "glow_berries",
    "glow_ink_sac",
    "glow_item_frame",
    "glow_lichen",
    "glow_squid_spawn_egg",
    "glowstone",
    "glowstone_dust",
    "goat_horn",
    "goat_spawn_egg",
    "gold_block",
    "gold_ingot",
    "gold_nugget",
    "gold_ore",
    "golden_apple",
    "golden_axe",
    "golden_boots",
    "golden_carrot",
    "golden_chestplate",
    "golden_dandelion",
    "golden_helmet",
    "golden_hoe",
    "golden_horse_armor",
    "golden_leggings",
    "golden_nautilus_armor",
    "golden_pickaxe",
    "golden_shovel",
    "golden_spear",
    "golden_sword",
    "granite",
    "granite_slab",
    "granite_stairs",
    "granite_wall",
    "grass_block",
    "gravel",
    "gray_banner",
    "gray_bed",
    "gray_bundle",
    "gray_candle",
    "gray_carpet",
    "gray_concrete",
    "gray_concrete_powder",
    "gray_concrete_slab",
    "gray_concrete_stairs",
    "gray_cushion",
    "gray_dye",
    "gray_glazed_terracotta",
    "gray_harness",
    "gray_shulker_box",
    "gray_stained_glass",
    "gray_stained_glass_pane",
    "gray_terracotta",
    "gray_wool",
    "gray_wool_slab",
    "gray_wool_stairs",
    "green_banner",
    "green_bed",
    "green_bundle",
    "green_candle",
    "green_carpet",
    "green_concrete",
    "green_concrete_powder",
    "green_concrete_slab",
    "green_concrete_stairs",
    "green_cushion",
    "green_dye",
    "green_glazed_terracotta",
    "green_harness",
    "green_shulker_box",
    "green_stained_glass",
    "green_stained_glass_pane",
    "green_terracotta",
    "green_wool",
    "green_wool_slab",
    "green_wool_stairs",
    "grindstone",
    "guardian_spawn_egg",
    "gunpowder",
    "guster_banner_pattern",
    "guster_pottery_sherd",
    "hanging_roots",
    "happy_ghast_spawn_egg",
    "hay_block",
    "heart_of_the_sea",
    "heart_pottery_sherd",
    "heartbreak_pottery_sherd",
    "heavy_core",
    "heavy_weighted_pressure_plate",
    "hoglin_spawn_egg",
    "honey_block",
    "honey_bottle",
    "honeycomb",
    "honeycomb_block",
    "hopper",
    "hopper_minecart",
    "horn_coral",
    "horn_coral_block",
    "horn_coral_fan",
    "horse_spawn_egg",
    "host_armor_trim_smithing_template",
    "howl_pottery_sherd",
    "husk_spawn_egg",
    "ice",
    "infested_chiseled_stone_bricks",
    "infested_cobblestone",
    "infested_cracked_stone_bricks",
    "infested_deepslate",
    "infested_mossy_stone_bricks",
    "infested_stone",
    "infested_stone_bricks",
    "ink_sac",
    "iron_axe",
    "iron_bars",
    "iron_block",
    "iron_boots",
    "iron_chain",
    "iron_chestplate",
    "iron_door",
    "iron_golem_spawn_egg",
    "iron_helmet",
    "iron_hoe",
    "iron_horse_armor",
    "iron_ingot",
    "iron_leggings",
    "iron_nautilus_armor",
    "iron_nugget",
    "iron_ore",
    "iron_pickaxe",
    "iron_shovel",
    "iron_spear",
    "iron_sword",
    "iron_trapdoor",
    "item_frame",
    "jack_o_lantern",
    "jigsaw",
    "jukebox",
    "jungle_boat",
    "jungle_button",
    "jungle_chest_boat",
    "jungle_door",
    "jungle_explorer_map",
    "jungle_fence",
    "jungle_fence_gate",
    "jungle_hanging_sign",
    "jungle_leaves",
    "jungle_log",
    "jungle_planks",
    "jungle_pressure_plate",
    "jungle_sapling",
    "jungle_shelf",
    "jungle_sign",
    "jungle_slab",
    "jungle_stairs",
    "jungle_trapdoor",
    "jungle_wood",
    "kelp",
    "knowledge_book",
    "ladder",
    "lantern",
    "lapis_block",
    "lapis_lazuli",
    "lapis_ore",
    "large_amethyst_bud",
    "large_fern",
    "lava_bucket",
    "lead",
    "leaf_litter",
    "leather",
    "leather_boots",
    "leather_chestplate",
    "leather_helmet",
    "leather_horse_armor",
    "leather_leggings",
    "lectern",
    "lever",
    "light",
    "light_blue_banner",
    "light_blue_bed",
    "light_blue_bundle",
    "light_blue_candle",
    "light_blue_carpet",
    "light_blue_concrete",
    "light_blue_concrete_powder",
    "light_blue_concrete_slab",
    "light_blue_concrete_stairs",
    "light_blue_cushion",
    "light_blue_dye",
    "light_blue_glazed_terracotta",
    "light_blue_harness",
    "light_blue_shulker_box",
    "light_blue_stained_glass",
    "light_blue_stained_glass_pane",
    "light_blue_terracotta",
    "light_blue_wool",
    "light_blue_wool_slab",
    "light_blue_wool_stairs",
    "light_gray_banner",
    "light_gray_bed",
    "light_gray_bundle",
    "light_gray_candle",
    "light_gray_carpet",
    "light_gray_concrete",
    "light_gray_concrete_powder",
    "light_gray_concrete_slab",
    "light_gray_concrete_stairs",
    "light_gray_cushion",
    "light_gray_dye",
    "light_gray_glazed_terracotta",
    "light_gray_harness",
    "light_gray_shulker_box",
    "light_gray_stained_glass",
    "light_gray_stained_glass_pane",
    "light_gray_terracotta",
    "light_gray_wool",
    "light_gray_wool_slab",
    "light_gray_wool_stairs",
    "light_weighted_pressure_plate",
    "lightning_rod",
    "lilac",
    "lily_of_the_valley",
    "lily_pad",
    "lime_banner",
    "lime_bed",
    "lime_bundle",
    "lime_candle",
    "lime_carpet",
    "lime_concrete",
    "lime_concrete_powder",
    "lime_concrete_slab",
    "lime_concrete_stairs",
    "lime_cushion",
    "lime_dye",
    "lime_glazed_terracotta",
    "lime_harness",
    "lime_shulker_box",
    "lime_stained_glass",
    "lime_stained_glass_pane",
    "lime_terracotta",
    "lime_wool",
    "lime_wool_slab",
    "lime_wool_stairs",
    "lingering_potion",
    "llama_spawn_egg",
    "lodestone",
    "loom",
    "mace",
    "magenta_banner",
    "magenta_bed",
    "magenta_bundle",
    "magenta_candle",
    "magenta_carpet",
    "magenta_concrete",
    "magenta_concrete_powder",
    "magenta_concrete_slab",
    "magenta_concrete_stairs",
    "magenta_cushion",
    "magenta_dye",
    "magenta_glazed_terracotta",
    "magenta_harness",
    "magenta_shulker_box",
    "magenta_stained_glass",
    "magenta_stained_glass_pane",
    "magenta_terracotta",
    "magenta_wool",
    "magenta_wool_slab",
    "magenta_wool_stairs",
    "magma_block",
    "magma_cream",
    "magma_cube_spawn_egg",
    "mangrove_boat",
    "mangrove_button",
    "mangrove_chest_boat",
    "mangrove_door",
    "mangrove_fence",
    "mangrove_fence_gate",
    "mangrove_hanging_sign",
    "mangrove_leaves",
    "mangrove_log",
    "mangrove_planks",
    "mangrove_pressure_plate",
    "mangrove_propagule",
    "mangrove_roots",
    "mangrove_shelf",
    "mangrove_sign",
    "mangrove_slab",
    "mangrove_stairs",
    "mangrove_trapdoor",
    "mangrove_wood",
    "map",
    "medium_amethyst_bud",
    "melon",
    "melon_seeds",
    "melon_slice",
    "milk_bucket",
    "minecart",
    "miner_pottery_sherd",
    "mineshaft_map",
    "mojang_banner_pattern",
    "mooshroom_spawn_egg",
    "moss_block",
    "moss_carpet",
    "mossy_cobblestone",
    "mossy_cobblestone_slab",
    "mossy_cobblestone_stairs",
    "mossy_cobblestone_wall",
    "mossy_stone_brick_slab",
    "mossy_stone_brick_stairs",
    "mossy_stone_brick_wall",
    "mossy_stone_bricks",
    "mourner_pottery_sherd",
    "mud",
    "mud_brick_slab",
    "mud_brick_stairs",
    "mud_brick_wall",
    "mud_bricks",
    "muddy_mangrove_roots",
    "mule_spawn_egg",
    "mushroom_stem",
    "mushroom_stew",
    "music_disc_11",
    "music_disc_13",
    "music_disc_5",
    "music_disc_blocks",
    "music_disc_bounce",
    "music_disc_cat",
    "music_disc_chirp",
    "music_disc_creator",
    "music_disc_creator_music_box",
    "music_disc_far",
    "music_disc_lava_chicken",
    "music_disc_mall",
    "music_disc_mellohi",
    "music_disc_otherside",
    "music_disc_pigstep",
    "music_disc_precipice",
    "music_disc_relic",
    "music_disc_stal",
    "music_disc_strad",
    "music_disc_tears",
    "music_disc_wait",
    "music_disc_ward",
    "mutton",
    "mycelium",
    "name_tag",
    "nautilus_shell",
    "nautilus_spawn_egg",
    "nether_brick",
    "nether_brick_fence",
    "nether_brick_slab",
    "nether_brick_stairs",
    "nether_brick_wall",
    "nether_bricks",
    "nether_gold_ore",
    "nether_quartz_ore",
    "nether_sprouts",
    "nether_star",
    "nether_wart",
    "nether_wart_block",
    "netherite_axe",
    "netherite_block",
    "netherite_boots",
    "netherite_chestplate",
    "netherite_helmet",
    "netherite_hoe",
    "netherite_horse_armor",
    "netherite_ingot",
    "netherite_leggings",
    "netherite_nautilus_armor",
    "netherite_pickaxe",
    "netherite_scrap",
    "netherite_shovel",
    "netherite_spear",
    "netherite_sword",
    "netherite_upgrade_smithing_template",
    "netherrack",
    "note_block",
    "oak_boat",
    "oak_button",
    "oak_chest_boat",
    "oak_door",
    "oak_fence",
    "oak_fence_gate",
    "oak_hanging_sign",
    "oak_leaves",
    "oak_log",
    "oak_planks",
    "oak_pressure_plate",
    "oak_sapling",
    "oak_shelf",
    "oak_sign",
    "oak_slab",
    "oak_stairs",
    "oak_trapdoor",
    "oak_wood",
    "observer",
    "obsidian",
    "ocean_explorer_map",
    "ocelot_spawn_egg",
    "ochre_froglight",
    "ominous_bottle",
    "ominous_trial_key",
    "open_eyeblossom",
    "orange_banner",
    "orange_bed",
    "orange_bundle",
    "orange_candle",
    "orange_carpet",
    "orange_concrete",
    "orange_concrete_powder",
    "orange_concrete_slab",
    "orange_concrete_stairs",
    "orange_cushion",
    "orange_dye",
    "orange_glazed_terracotta",
    "orange_harness",
    "orange_poplar_leaves",
    "orange_shulker_box",
    "orange_stained_glass",
    "orange_stained_glass_pane",
    "orange_terracotta",
    "orange_tulip",
    "orange_wool",
    "orange_wool_slab",
    "orange_wool_stairs",
    "oxeye_daisy",
    "oxidized_chiseled_copper",
    "oxidized_copper",
    "oxidized_copper_bars",
    "oxidized_copper_bulb",
    "oxidized_copper_chain",
    "oxidized_copper_chest",
    "oxidized_copper_door",
    "oxidized_copper_golem_statue",
    "oxidized_copper_grate",
    "oxidized_copper_lantern",
    "oxidized_copper_trapdoor",
    "oxidized_cut_copper",
    "oxidized_cut_copper_slab",
    "oxidized_cut_copper_stairs",
    "oxidized_lightning_rod",
    "packed_ice",
    "packed_mud",
    "painting",
    "pale_hanging_moss",
    "pale_moss_block",
    "pale_moss_carpet",
    "pale_oak_boat",
    "pale_oak_button",
    "pale_oak_chest_boat",
    "pale_oak_door",
    "pale_oak_fence",
    "pale_oak_fence_gate",
    "pale_oak_hanging_sign",
    "pale_oak_leaves",
    "pale_oak_log",
    "pale_oak_planks",
    "pale_oak_pressure_plate",
    "pale_oak_sapling",
    "pale_oak_shelf",
    "pale_oak_sign",
    "pale_oak_slab",
    "pale_oak_stairs",
    "pale_oak_trapdoor",
    "pale_oak_wood",
    "panda_spawn_egg",
    "paper",
    "parched_spawn_egg",
    "parrot_spawn_egg",
    "pearlescent_froglight",
    "peony",
    "petrified_oak_slab",
    "phantom_membrane",
    "phantom_spawn_egg",
    "pig_spawn_egg",
    "piglin_banner_pattern",
    "piglin_brute_spawn_egg",
    "piglin_head",
    "piglin_spawn_egg",
    "pillager_spawn_egg",
    "pink_banner",
    "pink_bed",
    "pink_bundle",
    "pink_candle",
    "pink_carpet",
    "pink_concrete",
    "pink_concrete_powder",
    "pink_concrete_slab",
    "pink_concrete_stairs",
    "pink_cushion",
    "pink_dye",
    "pink_glazed_terracotta",
    "pink_harness",
    "pink_petals",
    "pink_shulker_box",
    "pink_stained_glass",
    "pink_stained_glass_pane",
    "pink_terracotta",
    "pink_tulip",
    "pink_wool",
    "pink_wool_slab",
    "pink_wool_stairs",
    "piston",
    "pitcher_plant",
    "pitcher_pod",
    "plains_village_map",
    "player_head",
    "plenty_pottery_sherd",
    "podzol",
    "pointed_dripstone",
    "poisonous_potato",
    "polar_bear_spawn_egg",
    "polished_andesite",
    "polished_andesite_slab",
    "polished_andesite_stairs",
    "polished_basalt",
    "polished_blackstone",
    "polished_blackstone_brick_slab",
    "polished_blackstone_brick_stairs",
    "polished_blackstone_brick_wall",
    "polished_blackstone_bricks",
    "polished_blackstone_button",
    "polished_blackstone_pressure_plate",
    "polished_blackstone_slab",
    "polished_blackstone_stairs",
    "polished_blackstone_wall",
    "polished_cinnabar",
    "polished_cinnabar_slab",
    "polished_cinnabar_stairs",
    "polished_cinnabar_wall",
    "polished_deepslate",
    "polished_deepslate_slab",
    "polished_deepslate_stairs",
    "polished_deepslate_wall",
    "polished_diorite",
    "polished_diorite_slab",
    "polished_diorite_stairs",
    "polished_granite",
    "polished_granite_slab",
    "polished_granite_stairs",
    "polished_sulfur",
    "polished_sulfur_slab",
    "polished_sulfur_stairs",
    "polished_sulfur_wall",
    "polished_tuff",
    "polished_tuff_slab",
    "polished_tuff_stairs",
    "polished_tuff_wall",
    "poplar_boat",
    "poplar_button",
    "poplar_chest_boat",
    "poplar_door",
    "poplar_fence",
    "poplar_fence_gate",
    "poplar_hanging_sign",
    "poplar_log",
    "poplar_planks",
    "poplar_pressure_plate",
    "poplar_sapling",
    "poplar_shelf",
    "poplar_sign",
    "poplar_slab",
    "poplar_stairs",
    "poplar_trapdoor",
    "poplar_wood",
    "popped_chorus_fruit",
    "poppy",
    "porkchop",
    "potato",
    "potent_sulfur",
    "potion",
    "powder_snow_bucket",
    "powered_rail",
    "prismarine",
    "prismarine_brick_slab",
    "prismarine_brick_stairs",
    "prismarine_bricks",
    "prismarine_crystals",
    "prismarine_shard",
    "prismarine_slab",
    "prismarine_stairs",
    "prismarine_wall",
    "prize_pottery_sherd",
    "pufferfish",
    "pufferfish_bucket",
    "pufferfish_spawn_egg",
    "pumpkin",
    "pumpkin_pie",
    "pumpkin_seeds",
    "purple_banner",
    "purple_bed",
    "purple_bundle",
    "purple_candle",
    "purple_carpet",
    "purple_concrete",
    "purple_concrete_powder",
    "purple_concrete_slab",
    "purple_concrete_stairs",
    "purple_cushion",
    "purple_dye",
    "purple_glazed_terracotta",
    "purple_harness",
    "purple_shulker_box",
    "purple_stained_glass",
    "purple_stained_glass_pane",
    "purple_terracotta",
    "purple_wool",
    "purple_wool_slab",
    "purple_wool_stairs",
    "purpur_block",
    "purpur_pillar",
    "purpur_slab",
    "purpur_stairs",
    "quartz",
    "quartz_block",
    "quartz_bricks",
    "quartz_pillar",
    "quartz_slab",
    "quartz_stairs",
    "rabbit",
    "rabbit_foot",
    "rabbit_hide",
    "rabbit_spawn_egg",
    "rabbit_stew",
    "rail",
    "raiser_armor_trim_smithing_template",
    "ravager_spawn_egg",
    "raw_copper",
    "raw_copper_block",
    "raw_gold",
    "raw_gold_block",
    "raw_iron",
    "raw_iron_block",
    "recovery_compass",
    "red_banner",
    "red_bed",
    "red_bundle",
    "red_candle",
    "red_carpet",
    "red_concrete",
    "red_concrete_powder",
    "red_concrete_slab",
    "red_concrete_stairs",
    "red_cushion",
    "red_dye",
    "red_glazed_terracotta",
    "red_harness",
    "red_mushroom",
    "red_mushroom_block",
    "red_nether_brick_slab",
    "red_nether_brick_stairs",
    "red_nether_brick_wall",
    "red_nether_bricks",
    "red_poplar_leaves",
    "red_sand",
    "red_sandstone",
    "red_sandstone_slab",
    "red_sandstone_stairs",
    "red_sandstone_wall",
    "red_shrub",
    "red_shulker_box",
    "red_stained_glass",
    "red_stained_glass_pane",
    "red_terracotta",
    "red_tulip",
    "red_wool",
    "red_wool_slab",
    "red_wool_stairs",
    "redstone",
    "redstone_block",
    "redstone_lamp",
    "redstone_ore",
    "redstone_torch",
    "reinforced_deepslate",
    "repeater",
    "repeating_command_block",
    "resin_block",
    "resin_brick",
    "resin_brick_slab",
    "resin_brick_stairs",
    "resin_brick_wall",
    "resin_bricks",
    "resin_clump",
    "respawn_anchor",
    "rib_armor_trim_smithing_template",
    "rooted_dirt",
    "rose_bush",
    "rotten_flesh",
    "saddle",
    "salmon",
    "salmon_bucket",
    "salmon_spawn_egg",
    "sand",
    "sandstone",
    "sandstone_slab",
    "sandstone_stairs",
    "sandstone_wall",
    "savanna_village_map",
    "scaffolding",
    "scrape_pottery_sherd",
    "sculk",
    "sculk_catalyst",
    "sculk_sensor",
    "sculk_shrieker",
    "sculk_vein",
    "sea_lantern",
    "sea_pickle",
    "seagrass",
    "sentry_armor_trim_smithing_template",
    "shaper_armor_trim_smithing_template",
    "sheaf_pottery_sherd",
    "shears",
    "sheep_spawn_egg",
    "shelf_mushroom",
    "shelter_pottery_sherd",
    "shield",
    "short_dry_grass",
    "short_grass",
    "shroomlight",
    "shulker_box",
    "shulker_shell",
    "shulker_spawn_egg",
    "silence_armor_trim_smithing_template",
    "silverfish_spawn_egg",
    "skeleton_horse_spawn_egg",
    "skeleton_skull",
    "skeleton_spawn_egg",
    "skull_banner_pattern",
    "skull_pottery_sherd",
    "slime_ball",
    "slime_block",
    "slime_spawn_egg",
    "small_amethyst_bud",
    "small_dripleaf",
    "smithing_table",
    "smoker",
    "smooth_basalt",
    "smooth_quartz",
    "smooth_quartz_slab",
    "smooth_quartz_stairs",
    "smooth_red_sandstone",
    "smooth_red_sandstone_slab",
    "smooth_red_sandstone_stairs",
    "smooth_sandstone",
    "smooth_sandstone_slab",
    "smooth_sandstone_stairs",
    "smooth_stone",
    "smooth_stone_slab",
    "sniffer_egg",
    "sniffer_spawn_egg",
    "snort_pottery_sherd",
    "snout_armor_trim_smithing_template",
    "snow",
    "snow_block",
    "snow_golem_spawn_egg",
    "snowball",
    "snowy_village_map",
    "soul_campfire",
    "soul_lantern",
    "soul_sand",
    "soul_soil",
    "soul_torch",
    "spawner",
    "spectral_arrow",
    "spider_eye",
    "spider_spawn_egg",
    "spire_armor_trim_smithing_template",
    "splash_potion",
    "sponge",
    "spore_blossom",
    "spruce_boat",
    "spruce_button",
    "spruce_chest_boat",
    "spruce_door",
    "spruce_fence",
    "spruce_fence_gate",
    "spruce_hanging_sign",
    "spruce_leaves",
    "spruce_log",
    "spruce_planks",
    "spruce_pressure_plate",
    "spruce_sapling",
    "spruce_shelf",
    "spruce_sign",
    "spruce_slab",
    "spruce_stairs",
    "spruce_trapdoor",
    "spruce_wood",
    "spyglass",
    "squid_spawn_egg",
    "stick",
    "sticky_piston",
    "stone",
    "stone_axe",
    "stone_brick_slab",
    "stone_brick_stairs",
    "stone_brick_wall",
    "stone_bricks",
    "stone_button",
    "stone_hoe",
    "stone_pickaxe",
    "stone_pressure_plate",
    "stone_shovel",
    "stone_slab",
    "stone_spear",
    "stone_stairs",
    "stone_sword",
    "stonecutter",
    "straw_bed",
    "stray_spawn_egg",
    "strider_spawn_egg",
    "string",
    "stripped_acacia_log",
    "stripped_acacia_wood",
    "stripped_bamboo_block",
    "stripped_birch_log",
    "stripped_birch_wood",
    "stripped_cherry_log",
    "stripped_cherry_wood",
    "stripped_crimson_hyphae",
    "stripped_crimson_stem",
    "stripped_dark_oak_log",
    "stripped_dark_oak_wood",
    "stripped_jungle_log",
    "stripped_jungle_wood",
    "stripped_mangrove_log",
    "stripped_mangrove_wood",
    "stripped_oak_log",
    "stripped_oak_wood",
    "stripped_pale_oak_log",
    "stripped_pale_oak_wood",
    "stripped_poplar_log",
    "stripped_poplar_wood",
    "stripped_spruce_log",
    "stripped_spruce_wood",
    "stripped_warped_hyphae",
    "stripped_warped_stem",
    "structure_block",
    "structure_void",
    "sugar",
    "sugar_cane",
    "sulfur",
    "sulfur_brick_slab",
    "sulfur_brick_stairs",
    "sulfur_brick_wall",
    "sulfur_bricks",
    "sulfur_cube_bucket",
    "sulfur_cube_spawn_egg",
    "sulfur_slab",
    "sulfur_spike",
    "sulfur_stairs",
    "sulfur_wall",
    "sunflower",
    "suspicious_gravel",
    "suspicious_sand",
    "suspicious_stew",
    "swamp_explorer_map",
    "sweet_berries",
    "tadpole_bucket",
    "tadpole_spawn_egg",
    "taiga_village_map",
    "tall_dry_grass",
    "tall_grass",
    "target",
    "terracotta",
    "test_block",
    "test_instance_block",
    "tide_armor_trim_smithing_template",
    "tinted_glass",
    "tipped_arrow",
    "tnt",
    "tnt_minecart",
    "torch",
    "torchflower",
    "torchflower_seeds",
    "totem_of_undying",
    "trader_llama_spawn_egg",
    "trapped_chest",
    "trial_explorer_map",
    "trial_key",
    "trial_spawner",
    "trident",
    "tripwire_hook",
    "tropical_fish",
    "tropical_fish_bucket",
    "tropical_fish_spawn_egg",
    "tube_coral",
    "tube_coral_block",
    "tube_coral_fan",
    "tuff",
    "tuff_brick_slab",
    "tuff_brick_stairs",
    "tuff_brick_wall",
    "tuff_bricks",
    "tuff_slab",
    "tuff_stairs",
    "tuff_wall",
    "turtle_egg",
    "turtle_helmet",
    "turtle_scute",
    "turtle_spawn_egg",
    "twisting_vines",
    "vault",
    "verdant_froglight",
    "vex_armor_trim_smithing_template",
    "vex_spawn_egg",
    "villager_spawn_egg",
    "vindicator_spawn_egg",
    "vine",
    "wandering_trader_spawn_egg",
    "ward_armor_trim_smithing_template",
    "warden_spawn_egg",
    "warm_ocean_ruins_map",
    "warped_button",
    "warped_door",
    "warped_fence",
    "warped_fence_gate",
    "warped_fungus",
    "warped_fungus_on_a_stick",
    "warped_hanging_sign",
    "warped_hyphae",
    "warped_nylium",
    "warped_planks",
    "warped_pressure_plate",
    "warped_roots",
    "warped_shelf",
    "warped_sign",
    "warped_slab",
    "warped_stairs",
    "warped_stem",
    "warped_trapdoor",
    "warped_wart_block",
    "water_bucket",
    "waxed_chiseled_copper",
    "waxed_copper_bars",
    "waxed_copper_block",
    "waxed_copper_bulb",
    "waxed_copper_chain",
    "waxed_copper_chest",
    "waxed_copper_door",
    "waxed_copper_golem_statue",
    "waxed_copper_grate",
    "waxed_copper_lantern",
    "waxed_copper_trapdoor",
    "waxed_cut_copper",
    "waxed_cut_copper_slab",
    "waxed_cut_copper_stairs",
    "waxed_exposed_chiseled_copper",
    "waxed_exposed_copper",
    "waxed_exposed_copper_bars",
    "waxed_exposed_copper_bulb",
    "waxed_exposed_copper_chain",
    "waxed_exposed_copper_chest",
    "waxed_exposed_copper_door",
    "waxed_exposed_copper_golem_statue",
    "waxed_exposed_copper_grate",
    "waxed_exposed_copper_lantern",
    "waxed_exposed_copper_trapdoor",
    "waxed_exposed_cut_copper",
    "waxed_exposed_cut_copper_slab",
    "waxed_exposed_cut_copper_stairs",
    "waxed_exposed_lightning_rod",
    "waxed_lightning_rod",
    "waxed_oxidized_chiseled_copper",
    "waxed_oxidized_copper",
    "waxed_oxidized_copper_bars",
    "waxed_oxidized_copper_bulb",
    "waxed_oxidized_copper_chain",
    "waxed_oxidized_copper_chest",
    "waxed_oxidized_copper_door",
    "waxed_oxidized_copper_golem_statue",
    "waxed_oxidized_copper_grate",
    "waxed_oxidized_copper_lantern",
    "waxed_oxidized_copper_trapdoor",
    "waxed_oxidized_cut_copper",
    "waxed_oxidized_cut_copper_slab",
    "waxed_oxidized_cut_copper_stairs",
    "waxed_oxidized_lightning_rod",
    "waxed_weathered_chiseled_copper",
    "waxed_weathered_copper",
    "waxed_weathered_copper_bars",
    "waxed_weathered_copper_bulb",
    "waxed_weathered_copper_chain",
    "waxed_weathered_copper_chest",
    "waxed_weathered_copper_door",
    "waxed_weathered_copper_golem_statue",
    "waxed_weathered_copper_grate",
    "waxed_weathered_copper_lantern",
    "waxed_weathered_copper_trapdoor",
    "waxed_weathered_cut_copper",
    "waxed_weathered_cut_copper_slab",
    "waxed_weathered_cut_copper_stairs",
    "waxed_weathered_lightning_rod",
    "wayfinder_armor_trim_smithing_template",
    "weathered_chiseled_copper",
    "weathered_copper",
    "weathered_copper_bars",
    "weathered_copper_bulb",
    "weathered_copper_chain",
    "weathered_copper_chest",
    "weathered_copper_door",
    "weathered_copper_golem_statue",
    "weathered_copper_grate",
    "weathered_copper_lantern",
    "weathered_copper_trapdoor",
    "weathered_cut_copper",
    "weathered_cut_copper_slab",
    "weathered_cut_copper_stairs",
    "weathered_lightning_rod",
    "weeping_vines",
    "wet_sponge",
    "wheat",
    "wheat_seeds",
    "white_banner",
    "white_bed",
    "white_bundle",
    "white_candle",
    "white_carpet",
    "white_concrete",
    "white_concrete_powder",
    "white_concrete_slab",
    "white_concrete_stairs",
    "white_cushion",
    "white_dye",
    "white_glazed_terracotta",
    "white_harness",
    "white_shulker_box",
    "white_stained_glass",
    "white_stained_glass_pane",
    "white_terracotta",
    "white_tulip",
    "white_wool",
    "white_wool_slab",
    "white_wool_stairs",
    "wild_armor_trim_smithing_template",
    "wildflowers",
    "wind_charge",
    "witch_spawn_egg",
    "wither_rose",
    "wither_skeleton_skull",
    "wither_skeleton_spawn_egg",
    "wither_spawn_egg",
    "wolf_armor",
    "wolf_spawn_egg",
    "wooden_axe",
    "wooden_hoe",
    "wooden_pickaxe",
    "wooden_shovel",
    "wooden_spear",
    "wooden_sword",
    "woodland_explorer_map",
    "writable_book",
    "written_book",
    "yellow_banner",
    "yellow_bed",
    "yellow_bundle",
    "yellow_candle",
    "yellow_carpet",
    "yellow_concrete",
    "yellow_concrete_powder",
    "yellow_concrete_slab",
    "yellow_concrete_stairs",
    "yellow_cushion",
    "yellow_dye",
    "yellow_glazed_terracotta",
    "yellow_harness",
    "yellow_poplar_leaves",
    "yellow_shulker_box",
    "yellow_stained_glass",
    "yellow_stained_glass_pane",
    "yellow_terracotta",
    "yellow_wool",
    "yellow_wool_slab",
    "yellow_wool_stairs",
    "zoglin_spawn_egg",
    "zombie_head",
    "zombie_horse_spawn_egg",
    "zombie_nautilus_spawn_egg",
    "zombie_spawn_egg",
    "zombie_villager_spawn_egg",
    "zombified_piglin_spawn_egg"
  ]);
});

// src/arguments/generated/_registry/langs.ts
var LANGS_SET;
var init_langs = __esm(() => {
  init_sandstone();
  LANGS_SET = new Set2([
    "af_za",
    "ar_sa",
    "ast_es",
    "az_az",
    "ba_ru",
    "bar",
    "be_by",
    "be_latn",
    "bg_bg",
    "br_fr",
    "brb",
    "bs_ba",
    "ca_es",
    "cs_cz",
    "cv_cu",
    "cy_gb",
    "da_dk",
    "de_at",
    "de_ch",
    "de_de",
    "el_gr",
    "en_au",
    "en_ca",
    "en_gb",
    "en_nz",
    "en_pt",
    "en_ud",
    "en_us",
    "enp",
    "enws",
    "eo_uy",
    "es_ar",
    "es_cl",
    "es_ec",
    "es_es",
    "es_mx",
    "es_uy",
    "es_ve",
    "esan",
    "et_ee",
    "eu_es",
    "fa_ir",
    "fi_fi",
    "fil_ph",
    "fo_fo",
    "fr_ca",
    "fr_ch",
    "fr_fr",
    "fra_de",
    "fur_it",
    "fy_nl",
    "ga_ie",
    "gd_gb",
    "gl_es",
    "go_fr",
    "got_de",
    "hal_ua",
    "haw_us",
    "he_il",
    "hi_in",
    "hn_no",
    "hr_hr",
    "hu_hu",
    "hy_am",
    "id_id",
    "ig_ng",
    "io_en",
    "is_is",
    "isv",
    "it_it",
    "ja_jp",
    "jbo_en",
    "ka_ge",
    "kk_kz",
    "kn_in",
    "ko_kr",
    "ksh",
    "kw_gb",
    "ky_kg",
    "la_la",
    "lb_lu",
    "li_li",
    "lmo",
    "lo_la",
    "lol_us",
    "lt_lt",
    "lv_lv",
    "lzh",
    "mk_mk",
    "mn_mn",
    "ms_my",
    "mt_mt",
    "nah",
    "nds_de",
    "nl_be",
    "nl_nl",
    "nn_no",
    "no_no",
    "oc_fr",
    "ovd",
    "pl_pl",
    "pls",
    "pt_br",
    "pt_pt",
    "qcb_es",
    "qid",
    "qya_aa",
    "ro_ro",
    "rpr",
    "ru_ru",
    "ry_ua",
    "sah_sah",
    "se_no",
    "sk_sk",
    "sl_si",
    "so_so",
    "sq_al",
    "sr_cs",
    "sr_sp",
    "sv_se",
    "sxu",
    "szl",
    "ta_in",
    "th_th",
    "tl_ph",
    "tlh_aa",
    "tok",
    "tr_tr",
    "tt_ru",
    "tzo_mx",
    "uk_ua",
    "uz_uz",
    "val_es",
    "vec_it",
    "vi_vn",
    "vp_vl",
    "vro",
    "yi_de",
    "yo_ng",
    "zh_cn",
    "zh_hk",
    "zh_tw",
    "zlm_arab"
  ]);
});

// src/arguments/generated/_registry/models.ts
var MODELS_SET;
var init_models = __esm(() => {
  init_sandstone();
  MODELS_SET = new Set2([
    "block/acacia_button",
    "block/acacia_button_inventory",
    "block/acacia_button_pressed",
    "block/acacia_door_bottom_left",
    "block/acacia_door_bottom_left_open",
    "block/acacia_door_bottom_right",
    "block/acacia_door_bottom_right_open",
    "block/acacia_door_top_left",
    "block/acacia_door_top_left_open",
    "block/acacia_door_top_right",
    "block/acacia_door_top_right_open",
    "block/acacia_fence_gate",
    "block/acacia_fence_gate_open",
    "block/acacia_fence_gate_wall",
    "block/acacia_fence_gate_wall_open",
    "block/acacia_fence_inventory",
    "block/acacia_fence_post",
    "block/acacia_fence_side",
    "block/acacia_hanging_sign_attached_rot_0",
    "block/acacia_hanging_sign_attached_rot_1",
    "block/acacia_hanging_sign_attached_rot_2",
    "block/acacia_hanging_sign_attached_rot_3",
    "block/acacia_hanging_sign_rot_0",
    "block/acacia_hanging_sign_rot_1",
    "block/acacia_hanging_sign_rot_2",
    "block/acacia_hanging_sign_rot_3",
    "block/acacia_leaves",
    "block/acacia_log",
    "block/acacia_log_horizontal",
    "block/acacia_planks",
    "block/acacia_pressure_plate",
    "block/acacia_pressure_plate_down",
    "block/acacia_sapling",
    "block/acacia_shelf",
    "block/acacia_shelf_center",
    "block/acacia_shelf_inventory",
    "block/acacia_shelf_left",
    "block/acacia_shelf_right",
    "block/acacia_shelf_unconnected",
    "block/acacia_shelf_unpowered",
    "block/acacia_sign_rot_0",
    "block/acacia_sign_rot_1",
    "block/acacia_sign_rot_2",
    "block/acacia_sign_rot_3",
    "block/acacia_slab",
    "block/acacia_slab_top",
    "block/acacia_stairs",
    "block/acacia_stairs_inner",
    "block/acacia_stairs_outer",
    "block/acacia_trapdoor_bottom",
    "block/acacia_trapdoor_open",
    "block/acacia_trapdoor_top",
    "block/acacia_wall_hanging_sign",
    "block/acacia_wall_sign",
    "block/acacia_wood",
    "block/activator_rail",
    "block/activator_rail_on",
    "block/activator_rail_on_raised_ne",
    "block/activator_rail_on_raised_sw",
    "block/activator_rail_raised_ne",
    "block/activator_rail_raised_sw",
    "block/air",
    "block/allium",
    "block/amethyst_block",
    "block/amethyst_cluster",
    "block/ancient_debris",
    "block/andesite",
    "block/andesite_slab",
    "block/andesite_slab_top",
    "block/andesite_stairs",
    "block/andesite_stairs_inner",
    "block/andesite_stairs_outer",
    "block/andesite_wall_inventory",
    "block/andesite_wall_post",
    "block/andesite_wall_side",
    "block/andesite_wall_side_tall",
    "block/anvil",
    "block/attached_melon_stem",
    "block/attached_pumpkin_stem",
    "block/azalea",
    "block/azalea_leaves",
    "block/azure_bluet",
    "block/bamboo1_age0",
    "block/bamboo1_age1",
    "block/bamboo2_age0",
    "block/bamboo2_age1",
    "block/bamboo3_age0",
    "block/bamboo3_age1",
    "block/bamboo4_age0",
    "block/bamboo4_age1",
    "block/bamboo_block",
    "block/bamboo_block_x",
    "block/bamboo_block_y",
    "block/bamboo_block_z",
    "block/bamboo_button",
    "block/bamboo_button_inventory",
    "block/bamboo_button_pressed",
    "block/bamboo_door_bottom_left",
    "block/bamboo_door_bottom_left_open",
    "block/bamboo_door_bottom_right",
    "block/bamboo_door_bottom_right_open",
    "block/bamboo_door_top_left",
    "block/bamboo_door_top_left_open",
    "block/bamboo_door_top_right",
    "block/bamboo_door_top_right_open",
    "block/bamboo_fence_gate",
    "block/bamboo_fence_gate_open",
    "block/bamboo_fence_gate_wall",
    "block/bamboo_fence_gate_wall_open",
    "block/bamboo_fence_inventory",
    "block/bamboo_fence_post",
    "block/bamboo_fence_side_east",
    "block/bamboo_fence_side_north",
    "block/bamboo_fence_side_south",
    "block/bamboo_fence_side_west",
    "block/bamboo_hanging_sign_attached_rot_0",
    "block/bamboo_hanging_sign_attached_rot_1",
    "block/bamboo_hanging_sign_attached_rot_2",
    "block/bamboo_hanging_sign_attached_rot_3",
    "block/bamboo_hanging_sign_rot_0",
    "block/bamboo_hanging_sign_rot_1",
    "block/bamboo_hanging_sign_rot_2",
    "block/bamboo_hanging_sign_rot_3",
    "block/bamboo_large_leaves",
    "block/bamboo_mosaic",
    "block/bamboo_mosaic_slab",
    "block/bamboo_mosaic_slab_top",
    "block/bamboo_mosaic_stairs",
    "block/bamboo_mosaic_stairs_inner",
    "block/bamboo_mosaic_stairs_outer",
    "block/bamboo_planks",
    "block/bamboo_pressure_plate",
    "block/bamboo_pressure_plate_down",
    "block/bamboo_sapling",
    "block/bamboo_shelf",
    "block/bamboo_shelf_center",
    "block/bamboo_shelf_inventory",
    "block/bamboo_shelf_left",
    "block/bamboo_shelf_right",
    "block/bamboo_shelf_unconnected",
    "block/bamboo_shelf_unpowered",
    "block/bamboo_sign_rot_0",
    "block/bamboo_sign_rot_1",
    "block/bamboo_sign_rot_2",
    "block/bamboo_sign_rot_3",
    "block/bamboo_slab",
    "block/bamboo_slab_top",
    "block/bamboo_small_leaves",
    "block/bamboo_stairs",
    "block/bamboo_stairs_inner",
    "block/bamboo_stairs_outer",
    "block/bamboo_trapdoor_bottom",
    "block/bamboo_trapdoor_open",
    "block/bamboo_trapdoor_top",
    "block/bamboo_wall_hanging_sign",
    "block/bamboo_wall_sign",
    "block/banner",
    "block/barrel",
    "block/barrel_open",
    "block/barrier",
    "block/basalt",
    "block/beacon",
    "block/bedrock",
    "block/bedrock_mirrored",
    "block/bee_nest_empty",
    "block/bee_nest_honey",
    "block/beehive_empty",
    "block/beehive_honey",
    "block/beetroots_stage0",
    "block/beetroots_stage1",
    "block/beetroots_stage2",
    "block/beetroots_stage3",
    "block/bell_between_walls",
    "block/bell_ceiling",
    "block/bell_floor",
    "block/bell_wall",
    "block/big_dripleaf",
    "block/big_dripleaf_full_tilt",
    "block/big_dripleaf_partial_tilt",
    "block/big_dripleaf_stem",
    "block/birch_button",
    "block/birch_button_inventory",
    "block/birch_button_pressed",
    "block/birch_door_bottom_left",
    "block/birch_door_bottom_left_open",
    "block/birch_door_bottom_right",
    "block/birch_door_bottom_right_open",
    "block/birch_door_top_left",
    "block/birch_door_top_left_open",
    "block/birch_door_top_right",
    "block/birch_door_top_right_open",
    "block/birch_fence_gate",
    "block/birch_fence_gate_open",
    "block/birch_fence_gate_wall",
    "block/birch_fence_gate_wall_open",
    "block/birch_fence_inventory",
    "block/birch_fence_post",
    "block/birch_fence_side",
    "block/birch_hanging_sign_attached_rot_0",
    "block/birch_hanging_sign_attached_rot_1",
    "block/birch_hanging_sign_attached_rot_2",
    "block/birch_hanging_sign_attached_rot_3",
    "block/birch_hanging_sign_rot_0",
    "block/birch_hanging_sign_rot_1",
    "block/birch_hanging_sign_rot_2",
    "block/birch_hanging_sign_rot_3",
    "block/birch_leaves",
    "block/birch_log",
    "block/birch_log_horizontal",
    "block/birch_planks",
    "block/birch_pressure_plate",
    "block/birch_pressure_plate_down",
    "block/birch_sapling",
    "block/birch_shelf",
    "block/birch_shelf_center",
    "block/birch_shelf_inventory",
    "block/birch_shelf_left",
    "block/birch_shelf_right",
    "block/birch_shelf_unconnected",
    "block/birch_shelf_unpowered",
    "block/birch_sign_rot_0",
    "block/birch_sign_rot_1",
    "block/birch_sign_rot_2",
    "block/birch_sign_rot_3",
    "block/birch_slab",
    "block/birch_slab_top",
    "block/birch_stairs",
    "block/birch_stairs_inner",
    "block/birch_stairs_outer",
    "block/birch_trapdoor_bottom",
    "block/birch_trapdoor_open",
    "block/birch_trapdoor_top",
    "block/birch_wall_hanging_sign",
    "block/birch_wall_sign",
    "block/birch_wood",
    "block/black_bed_foot",
    "block/black_bed_head",
    "block/black_candle_cake",
    "block/black_candle_cake_lit",
    "block/black_candle_four_candles",
    "block/black_candle_four_candles_lit",
    "block/black_candle_one_candle",
    "block/black_candle_one_candle_lit",
    "block/black_candle_three_candles",
    "block/black_candle_three_candles_lit",
    "block/black_candle_two_candles",
    "block/black_candle_two_candles_lit",
    "block/black_carpet",
    "block/black_concrete",
    "block/black_concrete_powder",
    "block/black_concrete_slab",
    "block/black_concrete_slab_top",
    "block/black_concrete_stairs",
    "block/black_concrete_stairs_inner",
    "block/black_concrete_stairs_outer",
    "block/black_glazed_terracotta",
    "block/black_shulker_box",
    "block/black_stained_glass",
    "block/black_stained_glass_pane_noside",
    "block/black_stained_glass_pane_noside_alt",
    "block/black_stained_glass_pane_post",
    "block/black_stained_glass_pane_side",
    "block/black_stained_glass_pane_side_alt",
    "block/black_terracotta",
    "block/black_wool",
    "block/black_wool_slab",
    "block/black_wool_slab_top",
    "block/black_wool_stairs",
    "block/black_wool_stairs_inner",
    "block/black_wool_stairs_outer",
    "block/blackstone",
    "block/blackstone_slab",
    "block/blackstone_slab_top",
    "block/blackstone_stairs",
    "block/blackstone_stairs_inner",
    "block/blackstone_stairs_outer",
    "block/blackstone_wall_inventory",
    "block/blackstone_wall_post",
    "block/blackstone_wall_side",
    "block/blackstone_wall_side_tall",
    "block/blast_furnace",
    "block/blast_furnace_on",
    "block/block",
    "block/blue_bed_foot",
    "block/blue_bed_head",
    "block/blue_candle_cake",
    "block/blue_candle_cake_lit",
    "block/blue_candle_four_candles",
    "block/blue_candle_four_candles_lit",
    "block/blue_candle_one_candle",
    "block/blue_candle_one_candle_lit",
    "block/blue_candle_three_candles",
    "block/blue_candle_three_candles_lit",
    "block/blue_candle_two_candles",
    "block/blue_candle_two_candles_lit",
    "block/blue_carpet",
    "block/blue_concrete",
    "block/blue_concrete_powder",
    "block/blue_concrete_slab",
    "block/blue_concrete_slab_top",
    "block/blue_concrete_stairs",
    "block/blue_concrete_stairs_inner",
    "block/blue_concrete_stairs_outer",
    "block/blue_glazed_terracotta",
    "block/blue_ice",
    "block/blue_orchid",
    "block/blue_shulker_box",
    "block/blue_stained_glass",
    "block/blue_stained_glass_pane_noside",
    "block/blue_stained_glass_pane_noside_alt",
    "block/blue_stained_glass_pane_post",
    "block/blue_stained_glass_pane_side",
    "block/blue_stained_glass_pane_side_alt",
    "block/blue_terracotta",
    "block/blue_wool",
    "block/blue_wool_slab",
    "block/blue_wool_slab_top",
    "block/blue_wool_stairs",
    "block/blue_wool_stairs_inner",
    "block/blue_wool_stairs_outer",
    "block/bone_block",
    "block/bookshelf",
    "block/brain_coral",
    "block/brain_coral_block",
    "block/brain_coral_fan",
    "block/brain_coral_wall_fan",
    "block/brewing_stand",
    "block/brewing_stand_bottle0",
    "block/brewing_stand_bottle1",
    "block/brewing_stand_bottle2",
    "block/brewing_stand_empty0",
    "block/brewing_stand_empty1",
    "block/brewing_stand_empty2",
    "block/brick_slab",
    "block/brick_slab_top",
    "block/brick_stairs",
    "block/brick_stairs_inner",
    "block/brick_stairs_outer",
    "block/brick_wall_inventory",
    "block/brick_wall_post",
    "block/brick_wall_side",
    "block/brick_wall_side_tall",
    "block/bricks",
    "block/brown_bed_foot",
    "block/brown_bed_head",
    "block/brown_candle_cake",
    "block/brown_candle_cake_lit",
    "block/brown_candle_four_candles",
    "block/brown_candle_four_candles_lit",
    "block/brown_candle_one_candle",
    "block/brown_candle_one_candle_lit",
    "block/brown_candle_three_candles",
    "block/brown_candle_three_candles_lit",
    "block/brown_candle_two_candles",
    "block/brown_candle_two_candles_lit",
    "block/brown_carpet",
    "block/brown_concrete",
    "block/brown_concrete_powder",
    "block/brown_concrete_slab",
    "block/brown_concrete_slab_top",
    "block/brown_concrete_stairs",
    "block/brown_concrete_stairs_inner",
    "block/brown_concrete_stairs_outer",
    "block/brown_glazed_terracotta",
    "block/brown_mushroom",
    "block/brown_mushroom_block",
    "block/brown_mushroom_block_inventory",
    "block/brown_shulker_box",
    "block/brown_stained_glass",
    "block/brown_stained_glass_pane_noside",
    "block/brown_stained_glass_pane_noside_alt",
    "block/brown_stained_glass_pane_post",
    "block/brown_stained_glass_pane_side",
    "block/brown_stained_glass_pane_side_alt",
    "block/brown_terracotta",
    "block/brown_wool",
    "block/brown_wool_slab",
    "block/brown_wool_slab_top",
    "block/brown_wool_stairs",
    "block/brown_wool_stairs_inner",
    "block/brown_wool_stairs_outer",
    "block/bubble_coral",
    "block/bubble_coral_block",
    "block/bubble_coral_fan",
    "block/bubble_coral_wall_fan",
    "block/budding_amethyst",
    "block/bush",
    "block/button",
    "block/button_inventory",
    "block/button_pressed",
    "block/cactus",
    "block/cactus_flower",
    "block/cake",
    "block/cake_slice1",
    "block/cake_slice2",
    "block/cake_slice3",
    "block/cake_slice4",
    "block/cake_slice5",
    "block/cake_slice6",
    "block/calcite",
    "block/calibrated_sculk_sensor",
    "block/calibrated_sculk_sensor_active",
    "block/calibrated_sculk_sensor_inactive",
    "block/campfire",
    "block/campfire_off",
    "block/candle_cake",
    "block/candle_cake_lit",
    "block/candle_four_candles",
    "block/candle_four_candles_lit",
    "block/candle_one_candle",
    "block/candle_one_candle_lit",
    "block/candle_three_candles",
    "block/candle_three_candles_lit",
    "block/candle_two_candles",
    "block/candle_two_candles_lit",
    "block/carpet",
    "block/carrots_stage0",
    "block/carrots_stage1",
    "block/carrots_stage2",
    "block/carrots_stage3",
    "block/cartography_table",
    "block/carved_pumpkin",
    "block/cauldron",
    "block/cave_vines",
    "block/cave_vines_lit",
    "block/cave_vines_plant",
    "block/cave_vines_plant_lit",
    "block/chain_command_block",
    "block/chain_command_block_conditional",
    "block/cherry_button",
    "block/cherry_button_inventory",
    "block/cherry_button_pressed",
    "block/cherry_door_bottom_left",
    "block/cherry_door_bottom_left_open",
    "block/cherry_door_bottom_right",
    "block/cherry_door_bottom_right_open",
    "block/cherry_door_top_left",
    "block/cherry_door_top_left_open",
    "block/cherry_door_top_right",
    "block/cherry_door_top_right_open",
    "block/cherry_fence_gate",
    "block/cherry_fence_gate_open",
    "block/cherry_fence_gate_wall",
    "block/cherry_fence_gate_wall_open",
    "block/cherry_fence_inventory",
    "block/cherry_fence_post",
    "block/cherry_fence_side",
    "block/cherry_hanging_sign_attached_rot_0",
    "block/cherry_hanging_sign_attached_rot_1",
    "block/cherry_hanging_sign_attached_rot_2",
    "block/cherry_hanging_sign_attached_rot_3",
    "block/cherry_hanging_sign_rot_0",
    "block/cherry_hanging_sign_rot_1",
    "block/cherry_hanging_sign_rot_2",
    "block/cherry_hanging_sign_rot_3",
    "block/cherry_leaves",
    "block/cherry_log",
    "block/cherry_log_x",
    "block/cherry_log_y",
    "block/cherry_log_z",
    "block/cherry_planks",
    "block/cherry_pressure_plate",
    "block/cherry_pressure_plate_down",
    "block/cherry_sapling",
    "block/cherry_shelf",
    "block/cherry_shelf_center",
    "block/cherry_shelf_inventory",
    "block/cherry_shelf_left",
    "block/cherry_shelf_right",
    "block/cherry_shelf_unconnected",
    "block/cherry_shelf_unpowered",
    "block/cherry_sign_rot_0",
    "block/cherry_sign_rot_1",
    "block/cherry_sign_rot_2",
    "block/cherry_sign_rot_3",
    "block/cherry_slab",
    "block/cherry_slab_top",
    "block/cherry_stairs",
    "block/cherry_stairs_inner",
    "block/cherry_stairs_outer",
    "block/cherry_trapdoor_bottom",
    "block/cherry_trapdoor_open",
    "block/cherry_trapdoor_top",
    "block/cherry_wall_hanging_sign",
    "block/cherry_wall_sign",
    "block/cherry_wood",
    "block/chest",
    "block/chipped_anvil",
    "block/chiseled_bookshelf",
    "block/chiseled_bookshelf_empty_slot_bottom_left",
    "block/chiseled_bookshelf_empty_slot_bottom_mid",
    "block/chiseled_bookshelf_empty_slot_bottom_right",
    "block/chiseled_bookshelf_empty_slot_top_left",
    "block/chiseled_bookshelf_empty_slot_top_mid",
    "block/chiseled_bookshelf_empty_slot_top_right",
    "block/chiseled_bookshelf_inventory",
    "block/chiseled_bookshelf_occupied_slot_bottom_left",
    "block/chiseled_bookshelf_occupied_slot_bottom_mid",
    "block/chiseled_bookshelf_occupied_slot_bottom_right",
    "block/chiseled_bookshelf_occupied_slot_top_left",
    "block/chiseled_bookshelf_occupied_slot_top_mid",
    "block/chiseled_bookshelf_occupied_slot_top_right",
    "block/chiseled_cinnabar",
    "block/chiseled_copper",
    "block/chiseled_deepslate",
    "block/chiseled_nether_bricks",
    "block/chiseled_polished_blackstone",
    "block/chiseled_quartz_block",
    "block/chiseled_red_sandstone",
    "block/chiseled_resin_bricks",
    "block/chiseled_sandstone",
    "block/chiseled_stone_bricks",
    "block/chiseled_sulfur",
    "block/chiseled_tuff",
    "block/chiseled_tuff_bricks",
    "block/chorus_flower",
    "block/chorus_flower_dead",
    "block/chorus_plant",
    "block/chorus_plant_noside",
    "block/chorus_plant_noside1",
    "block/chorus_plant_noside2",
    "block/chorus_plant_noside3",
    "block/chorus_plant_side",
    "block/cinnabar",
    "block/cinnabar_brick_slab",
    "block/cinnabar_brick_slab_top",
    "block/cinnabar_brick_stairs",
    "block/cinnabar_brick_stairs_inner",
    "block/cinnabar_brick_stairs_outer",
    "block/cinnabar_brick_wall_inventory",
    "block/cinnabar_brick_wall_post",
    "block/cinnabar_brick_wall_side",
    "block/cinnabar_brick_wall_side_tall",
    "block/cinnabar_bricks",
    "block/cinnabar_slab",
    "block/cinnabar_slab_top",
    "block/cinnabar_stairs",
    "block/cinnabar_stairs_inner",
    "block/cinnabar_stairs_outer",
    "block/cinnabar_wall_inventory",
    "block/cinnabar_wall_post",
    "block/cinnabar_wall_side",
    "block/cinnabar_wall_side_tall",
    "block/clay",
    "block/closed_eyeblossom",
    "block/coal_block",
    "block/coal_ore",
    "block/coarse_dirt",
    "block/cobbled_deepslate",
    "block/cobbled_deepslate_slab",
    "block/cobbled_deepslate_slab_top",
    "block/cobbled_deepslate_stairs",
    "block/cobbled_deepslate_stairs_inner",
    "block/cobbled_deepslate_stairs_outer",
    "block/cobbled_deepslate_wall_inventory",
    "block/cobbled_deepslate_wall_post",
    "block/cobbled_deepslate_wall_side",
    "block/cobbled_deepslate_wall_side_tall",
    "block/cobblestone",
    "block/cobblestone_slab",
    "block/cobblestone_slab_top",
    "block/cobblestone_stairs",
    "block/cobblestone_stairs_inner",
    "block/cobblestone_stairs_outer",
    "block/cobblestone_wall_inventory",
    "block/cobblestone_wall_post",
    "block/cobblestone_wall_side",
    "block/cobblestone_wall_side_tall",
    "block/cobweb",
    "block/cocoa_stage0",
    "block/cocoa_stage1",
    "block/cocoa_stage2",
    "block/command_block",
    "block/command_block_conditional",
    "block/comparator",
    "block/comparator_on",
    "block/comparator_on_subtract",
    "block/comparator_subtract",
    "block/composter",
    "block/composter_contents1",
    "block/composter_contents2",
    "block/composter_contents3",
    "block/composter_contents4",
    "block/composter_contents5",
    "block/composter_contents6",
    "block/composter_contents7",
    "block/composter_contents_ready",
    "block/conduit",
    "block/copper_bars_cap",
    "block/copper_bars_cap_alt",
    "block/copper_bars_post",
    "block/copper_bars_post_ends",
    "block/copper_bars_side",
    "block/copper_bars_side_alt",
    "block/copper_block",
    "block/copper_bulb",
    "block/copper_bulb_lit",
    "block/copper_bulb_lit_powered",
    "block/copper_bulb_powered",
    "block/copper_chain",
    "block/copper_chest",
    "block/copper_door_bottom_left",
    "block/copper_door_bottom_left_open",
    "block/copper_door_bottom_right",
    "block/copper_door_bottom_right_open",
    "block/copper_door_top_left",
    "block/copper_door_top_left_open",
    "block/copper_door_top_right",
    "block/copper_door_top_right_open",
    "block/copper_golem_statue",
    "block/copper_grate",
    "block/copper_lantern",
    "block/copper_lantern_hanging",
    "block/copper_ore",
    "block/copper_torch",
    "block/copper_trapdoor_bottom",
    "block/copper_trapdoor_open",
    "block/copper_trapdoor_top",
    "block/copper_wall_torch",
    "block/coral_fan",
    "block/coral_wall_fan",
    "block/cornflower",
    "block/cracked_deepslate_bricks",
    "block/cracked_deepslate_tiles",
    "block/cracked_nether_bricks",
    "block/cracked_polished_blackstone_bricks",
    "block/cracked_stone_bricks",
    "block/crafter",
    "block/crafter_crafting",
    "block/crafter_crafting_triggered",
    "block/crafter_triggered",
    "block/crafting_table",
    "block/creaking_heart",
    "block/creaking_heart_awake",
    "block/creaking_heart_awake_horizontal",
    "block/creaking_heart_dormant",
    "block/creaking_heart_dormant_horizontal",
    "block/creaking_heart_horizontal",
    "block/crimson_button",
    "block/crimson_button_inventory",
    "block/crimson_button_pressed",
    "block/crimson_door_bottom_left",
    "block/crimson_door_bottom_left_open",
    "block/crimson_door_bottom_right",
    "block/crimson_door_bottom_right_open",
    "block/crimson_door_top_left",
    "block/crimson_door_top_left_open",
    "block/crimson_door_top_right",
    "block/crimson_door_top_right_open",
    "block/crimson_fence_gate",
    "block/crimson_fence_gate_open",
    "block/crimson_fence_gate_wall",
    "block/crimson_fence_gate_wall_open",
    "block/crimson_fence_inventory",
    "block/crimson_fence_post",
    "block/crimson_fence_side",
    "block/crimson_fungus",
    "block/crimson_hanging_sign_attached_rot_0",
    "block/crimson_hanging_sign_attached_rot_1",
    "block/crimson_hanging_sign_attached_rot_2",
    "block/crimson_hanging_sign_attached_rot_3",
    "block/crimson_hanging_sign_rot_0",
    "block/crimson_hanging_sign_rot_1",
    "block/crimson_hanging_sign_rot_2",
    "block/crimson_hanging_sign_rot_3",
    "block/crimson_hyphae",
    "block/crimson_nylium",
    "block/crimson_planks",
    "block/crimson_pressure_plate",
    "block/crimson_pressure_plate_down",
    "block/crimson_roots",
    "block/crimson_shelf",
    "block/crimson_shelf_center",
    "block/crimson_shelf_inventory",
    "block/crimson_shelf_left",
    "block/crimson_shelf_right",
    "block/crimson_shelf_unconnected",
    "block/crimson_shelf_unpowered",
    "block/crimson_sign_rot_0",
    "block/crimson_sign_rot_1",
    "block/crimson_sign_rot_2",
    "block/crimson_sign_rot_3",
    "block/crimson_slab",
    "block/crimson_slab_top",
    "block/crimson_stairs",
    "block/crimson_stairs_inner",
    "block/crimson_stairs_outer",
    "block/crimson_stem",
    "block/crimson_trapdoor_bottom",
    "block/crimson_trapdoor_open",
    "block/crimson_trapdoor_top",
    "block/crimson_wall_hanging_sign",
    "block/crimson_wall_sign",
    "block/crop",
    "block/cross",
    "block/cross_emissive",
    "block/crying_obsidian",
    "block/cube",
    "block/cube_all",
    "block/cube_all_inner_faces",
    "block/cube_bottom_top",
    "block/cube_bottom_top_inner_faces",
    "block/cube_column",
    "block/cube_column_horizontal",
    "block/cube_column_mirrored",
    "block/cube_column_uv_locked_x",
    "block/cube_column_uv_locked_y",
    "block/cube_column_uv_locked_z",
    "block/cube_directional",
    "block/cube_mirrored",
    "block/cube_mirrored_all",
    "block/cube_north_west_mirrored",
    "block/cube_north_west_mirrored_all",
    "block/cube_top",
    "block/custom_fence_inventory",
    "block/custom_fence_post",
    "block/custom_fence_side_east",
    "block/custom_fence_side_north",
    "block/custom_fence_side_south",
    "block/custom_fence_side_west",
    "block/cut_copper",
    "block/cut_copper_slab",
    "block/cut_copper_slab_top",
    "block/cut_copper_stairs",
    "block/cut_copper_stairs_inner",
    "block/cut_copper_stairs_outer",
    "block/cut_red_sandstone",
    "block/cut_red_sandstone_slab",
    "block/cut_red_sandstone_slab_top",
    "block/cut_sandstone",
    "block/cut_sandstone_slab",
    "block/cut_sandstone_slab_top",
    "block/cyan_bed_foot",
    "block/cyan_bed_head",
    "block/cyan_candle_cake",
    "block/cyan_candle_cake_lit",
    "block/cyan_candle_four_candles",
    "block/cyan_candle_four_candles_lit",
    "block/cyan_candle_one_candle",
    "block/cyan_candle_one_candle_lit",
    "block/cyan_candle_three_candles",
    "block/cyan_candle_three_candles_lit",
    "block/cyan_candle_two_candles",
    "block/cyan_candle_two_candles_lit",
    "block/cyan_carpet",
    "block/cyan_concrete",
    "block/cyan_concrete_powder",
    "block/cyan_concrete_slab",
    "block/cyan_concrete_slab_top",
    "block/cyan_concrete_stairs",
    "block/cyan_concrete_stairs_inner",
    "block/cyan_concrete_stairs_outer",
    "block/cyan_glazed_terracotta",
    "block/cyan_shulker_box",
    "block/cyan_stained_glass",
    "block/cyan_stained_glass_pane_noside",
    "block/cyan_stained_glass_pane_noside_alt",
    "block/cyan_stained_glass_pane_post",
    "block/cyan_stained_glass_pane_side",
    "block/cyan_stained_glass_pane_side_alt",
    "block/cyan_terracotta",
    "block/cyan_wool",
    "block/cyan_wool_slab",
    "block/cyan_wool_slab_top",
    "block/cyan_wool_stairs",
    "block/cyan_wool_stairs_inner",
    "block/cyan_wool_stairs_outer",
    "block/damaged_anvil",
    "block/dandelion",
    "block/dark_oak_button",
    "block/dark_oak_button_inventory",
    "block/dark_oak_button_pressed",
    "block/dark_oak_door_bottom_left",
    "block/dark_oak_door_bottom_left_open",
    "block/dark_oak_door_bottom_right",
    "block/dark_oak_door_bottom_right_open",
    "block/dark_oak_door_top_left",
    "block/dark_oak_door_top_left_open",
    "block/dark_oak_door_top_right",
    "block/dark_oak_door_top_right_open",
    "block/dark_oak_fence_gate",
    "block/dark_oak_fence_gate_open",
    "block/dark_oak_fence_gate_wall",
    "block/dark_oak_fence_gate_wall_open",
    "block/dark_oak_fence_inventory",
    "block/dark_oak_fence_post",
    "block/dark_oak_fence_side",
    "block/dark_oak_hanging_sign_attached_rot_0",
    "block/dark_oak_hanging_sign_attached_rot_1",
    "block/dark_oak_hanging_sign_attached_rot_2",
    "block/dark_oak_hanging_sign_attached_rot_3",
    "block/dark_oak_hanging_sign_rot_0",
    "block/dark_oak_hanging_sign_rot_1",
    "block/dark_oak_hanging_sign_rot_2",
    "block/dark_oak_hanging_sign_rot_3",
    "block/dark_oak_leaves",
    "block/dark_oak_log",
    "block/dark_oak_log_horizontal",
    "block/dark_oak_planks",
    "block/dark_oak_pressure_plate",
    "block/dark_oak_pressure_plate_down",
    "block/dark_oak_sapling",
    "block/dark_oak_shelf",
    "block/dark_oak_shelf_center",
    "block/dark_oak_shelf_inventory",
    "block/dark_oak_shelf_left",
    "block/dark_oak_shelf_right",
    "block/dark_oak_shelf_unconnected",
    "block/dark_oak_shelf_unpowered",
    "block/dark_oak_sign_rot_0",
    "block/dark_oak_sign_rot_1",
    "block/dark_oak_sign_rot_2",
    "block/dark_oak_sign_rot_3",
    "block/dark_oak_slab",
    "block/dark_oak_slab_top",
    "block/dark_oak_stairs",
    "block/dark_oak_stairs_inner",
    "block/dark_oak_stairs_outer",
    "block/dark_oak_trapdoor_bottom",
    "block/dark_oak_trapdoor_open",
    "block/dark_oak_trapdoor_top",
    "block/dark_oak_wall_hanging_sign",
    "block/dark_oak_wall_sign",
    "block/dark_oak_wood",
    "block/dark_prismarine",
    "block/dark_prismarine_slab",
    "block/dark_prismarine_slab_top",
    "block/dark_prismarine_stairs",
    "block/dark_prismarine_stairs_inner",
    "block/dark_prismarine_stairs_outer",
    "block/daylight_detector",
    "block/daylight_detector_inverted",
    "block/dead_brain_coral",
    "block/dead_brain_coral_block",
    "block/dead_brain_coral_fan",
    "block/dead_brain_coral_wall_fan",
    "block/dead_bubble_coral",
    "block/dead_bubble_coral_block",
    "block/dead_bubble_coral_fan",
    "block/dead_bubble_coral_wall_fan",
    "block/dead_bush",
    "block/dead_fire_coral",
    "block/dead_fire_coral_block",
    "block/dead_fire_coral_fan",
    "block/dead_fire_coral_wall_fan",
    "block/dead_horn_coral",
    "block/dead_horn_coral_block",
    "block/dead_horn_coral_fan",
    "block/dead_horn_coral_wall_fan",
    "block/dead_sea_pickle",
    "block/dead_tube_coral",
    "block/dead_tube_coral_block",
    "block/dead_tube_coral_fan",
    "block/dead_tube_coral_wall_fan",
    "block/decorated_pot",
    "block/deepslate",
    "block/deepslate_brick_slab",
    "block/deepslate_brick_slab_top",
    "block/deepslate_brick_stairs",
    "block/deepslate_brick_stairs_inner",
    "block/deepslate_brick_stairs_outer",
    "block/deepslate_brick_wall_inventory",
    "block/deepslate_brick_wall_post",
    "block/deepslate_brick_wall_side",
    "block/deepslate_brick_wall_side_tall",
    "block/deepslate_bricks",
    "block/deepslate_coal_ore",
    "block/deepslate_copper_ore",
    "block/deepslate_diamond_ore",
    "block/deepslate_emerald_ore",
    "block/deepslate_gold_ore",
    "block/deepslate_iron_ore",
    "block/deepslate_lapis_ore",
    "block/deepslate_mirrored",
    "block/deepslate_redstone_ore",
    "block/deepslate_tile_slab",
    "block/deepslate_tile_slab_top",
    "block/deepslate_tile_stairs",
    "block/deepslate_tile_stairs_inner",
    "block/deepslate_tile_stairs_outer",
    "block/deepslate_tile_wall_inventory",
    "block/deepslate_tile_wall_post",
    "block/deepslate_tile_wall_side",
    "block/deepslate_tile_wall_side_tall",
    "block/deepslate_tiles",
    "block/detector_rail",
    "block/detector_rail_on",
    "block/detector_rail_on_raised_ne",
    "block/detector_rail_on_raised_sw",
    "block/detector_rail_raised_ne",
    "block/detector_rail_raised_sw",
    "block/diamond_block",
    "block/diamond_ore",
    "block/diorite",
    "block/diorite_slab",
    "block/diorite_slab_top",
    "block/diorite_stairs",
    "block/diorite_stairs_inner",
    "block/diorite_stairs_outer",
    "block/diorite_wall_inventory",
    "block/diorite_wall_post",
    "block/diorite_wall_side",
    "block/diorite_wall_side_tall",
    "block/dirt",
    "block/dirt_path",
    "block/dispenser",
    "block/dispenser_vertical",
    "block/door_bottom_left",
    "block/door_bottom_left_open",
    "block/door_bottom_right",
    "block/door_bottom_right_open",
    "block/door_top_left",
    "block/door_top_left_open",
    "block/door_top_right",
    "block/door_top_right_open",
    "block/dragon_egg",
    "block/dried_ghast",
    "block/dried_ghast_hydration_0",
    "block/dried_ghast_hydration_1",
    "block/dried_ghast_hydration_2",
    "block/dried_ghast_hydration_3",
    "block/dried_kelp_block",
    "block/dripstone_block",
    "block/dropper",
    "block/dropper_vertical",
    "block/emerald_block",
    "block/emerald_ore",
    "block/enchanting_table",
    "block/end_gateway",
    "block/end_portal",
    "block/end_portal_frame",
    "block/end_portal_frame_filled",
    "block/end_rod",
    "block/end_stone",
    "block/end_stone_brick_slab",
    "block/end_stone_brick_slab_top",
    "block/end_stone_brick_stairs",
    "block/end_stone_brick_stairs_inner",
    "block/end_stone_brick_stairs_outer",
    "block/end_stone_brick_wall_inventory",
    "block/end_stone_brick_wall_post",
    "block/end_stone_brick_wall_side",
    "block/end_stone_brick_wall_side_tall",
    "block/end_stone_bricks",
    "block/ender_chest",
    "block/exposed_chiseled_copper",
    "block/exposed_copper",
    "block/exposed_copper_bars_cap",
    "block/exposed_copper_bars_cap_alt",
    "block/exposed_copper_bars_post",
    "block/exposed_copper_bars_post_ends",
    "block/exposed_copper_bars_side",
    "block/exposed_copper_bars_side_alt",
    "block/exposed_copper_bulb",
    "block/exposed_copper_bulb_lit",
    "block/exposed_copper_bulb_lit_powered",
    "block/exposed_copper_bulb_powered",
    "block/exposed_copper_chain",
    "block/exposed_copper_chest",
    "block/exposed_copper_door_bottom_left",
    "block/exposed_copper_door_bottom_left_open",
    "block/exposed_copper_door_bottom_right",
    "block/exposed_copper_door_bottom_right_open",
    "block/exposed_copper_door_top_left",
    "block/exposed_copper_door_top_left_open",
    "block/exposed_copper_door_top_right",
    "block/exposed_copper_door_top_right_open",
    "block/exposed_copper_golem_statue",
    "block/exposed_copper_grate",
    "block/exposed_copper_lantern",
    "block/exposed_copper_lantern_hanging",
    "block/exposed_copper_trapdoor_bottom",
    "block/exposed_copper_trapdoor_open",
    "block/exposed_copper_trapdoor_top",
    "block/exposed_cut_copper",
    "block/exposed_cut_copper_slab",
    "block/exposed_cut_copper_slab_top",
    "block/exposed_cut_copper_stairs",
    "block/exposed_cut_copper_stairs_inner",
    "block/exposed_cut_copper_stairs_outer",
    "block/exposed_lightning_rod",
    "block/farmland",
    "block/farmland_moist",
    "block/fence_inventory",
    "block/fence_post",
    "block/fence_side",
    "block/fern",
    "block/fire_coral",
    "block/fire_coral_block",
    "block/fire_coral_fan",
    "block/fire_coral_wall_fan",
    "block/fire_floor0",
    "block/fire_floor1",
    "block/fire_side0",
    "block/fire_side1",
    "block/fire_side_alt0",
    "block/fire_side_alt1",
    "block/fire_up0",
    "block/fire_up1",
    "block/fire_up_alt0",
    "block/fire_up_alt1",
    "block/firefly_bush",
    "block/fletching_table",
    "block/flower_pot",
    "block/flower_pot_cross",
    "block/flower_pot_cross_emissive",
    "block/flowerbed_1",
    "block/flowerbed_2",
    "block/flowerbed_3",
    "block/flowerbed_4",
    "block/flowering_azalea",
    "block/flowering_azalea_leaves",
    "block/four_dead_sea_pickles",
    "block/four_sea_pickles",
    "block/four_slightly_cracked_turtle_eggs",
    "block/four_turtle_eggs",
    "block/four_very_cracked_turtle_eggs",
    "block/frogspawn",
    "block/frosted_ice_0",
    "block/frosted_ice_1",
    "block/frosted_ice_2",
    "block/frosted_ice_3",
    "block/furnace",
    "block/furnace_on",
    "block/gilded_blackstone",
    "block/glass",
    "block/glass_pane_noside",
    "block/glass_pane_noside_alt",
    "block/glass_pane_post",
    "block/glass_pane_side",
    "block/glass_pane_side_alt",
    "block/glow_item_frame",
    "block/glow_item_frame_map",
    "block/glow_lichen",
    "block/glowstone",
    "block/gold_block",
    "block/gold_ore",
    "block/golden_dandelion",
    "block/granite",
    "block/granite_slab",
    "block/granite_slab_top",
    "block/granite_stairs",
    "block/granite_stairs_inner",
    "block/granite_stairs_outer",
    "block/granite_wall_inventory",
    "block/granite_wall_post",
    "block/granite_wall_side",
    "block/granite_wall_side_tall",
    "block/grass_block",
    "block/grass_block_snow",
    "block/gravel",
    "block/gray_bed_foot",
    "block/gray_bed_head",
    "block/gray_candle_cake",
    "block/gray_candle_cake_lit",
    "block/gray_candle_four_candles",
    "block/gray_candle_four_candles_lit",
    "block/gray_candle_one_candle",
    "block/gray_candle_one_candle_lit",
    "block/gray_candle_three_candles",
    "block/gray_candle_three_candles_lit",
    "block/gray_candle_two_candles",
    "block/gray_candle_two_candles_lit",
    "block/gray_carpet",
    "block/gray_concrete",
    "block/gray_concrete_powder",
    "block/gray_concrete_slab",
    "block/gray_concrete_slab_top",
    "block/gray_concrete_stairs",
    "block/gray_concrete_stairs_inner",
    "block/gray_concrete_stairs_outer",
    "block/gray_glazed_terracotta",
    "block/gray_shulker_box",
    "block/gray_stained_glass",
    "block/gray_stained_glass_pane_noside",
    "block/gray_stained_glass_pane_noside_alt",
    "block/gray_stained_glass_pane_post",
    "block/gray_stained_glass_pane_side",
    "block/gray_stained_glass_pane_side_alt",
    "block/gray_terracotta",
    "block/gray_wool",
    "block/gray_wool_slab",
    "block/gray_wool_slab_top",
    "block/gray_wool_stairs",
    "block/gray_wool_stairs_inner",
    "block/gray_wool_stairs_outer",
    "block/green_bed_foot",
    "block/green_bed_head",
    "block/green_candle_cake",
    "block/green_candle_cake_lit",
    "block/green_candle_four_candles",
    "block/green_candle_four_candles_lit",
    "block/green_candle_one_candle",
    "block/green_candle_one_candle_lit",
    "block/green_candle_three_candles",
    "block/green_candle_three_candles_lit",
    "block/green_candle_two_candles",
    "block/green_candle_two_candles_lit",
    "block/green_carpet",
    "block/green_concrete",
    "block/green_concrete_powder",
    "block/green_concrete_slab",
    "block/green_concrete_slab_top",
    "block/green_concrete_stairs",
    "block/green_concrete_stairs_inner",
    "block/green_concrete_stairs_outer",
    "block/green_glazed_terracotta",
    "block/green_shulker_box",
    "block/green_stained_glass",
    "block/green_stained_glass_pane_noside",
    "block/green_stained_glass_pane_noside_alt",
    "block/green_stained_glass_pane_post",
    "block/green_stained_glass_pane_side",
    "block/green_stained_glass_pane_side_alt",
    "block/green_terracotta",
    "block/green_wool",
    "block/green_wool_slab",
    "block/green_wool_slab_top",
    "block/green_wool_stairs",
    "block/green_wool_stairs_inner",
    "block/green_wool_stairs_outer",
    "block/grindstone",
    "block/hanging_roots",
    "block/hay_block",
    "block/hay_block_horizontal",
    "block/heavy_core",
    "block/heavy_weighted_pressure_plate",
    "block/heavy_weighted_pressure_plate_down",
    "block/honey_block",
    "block/honeycomb_block",
    "block/hopper",
    "block/hopper_side",
    "block/horn_coral",
    "block/horn_coral_block",
    "block/horn_coral_fan",
    "block/horn_coral_wall_fan",
    "block/ice",
    "block/inner_stairs",
    "block/iron_bars_cap",
    "block/iron_bars_cap_alt",
    "block/iron_bars_post",
    "block/iron_bars_post_ends",
    "block/iron_bars_side",
    "block/iron_bars_side_alt",
    "block/iron_block",
    "block/iron_chain",
    "block/iron_door_bottom_left",
    "block/iron_door_bottom_left_open",
    "block/iron_door_bottom_right",
    "block/iron_door_bottom_right_open",
    "block/iron_door_top_left",
    "block/iron_door_top_left_open",
    "block/iron_door_top_right",
    "block/iron_door_top_right_open",
    "block/iron_ore",
    "block/iron_trapdoor_bottom",
    "block/iron_trapdoor_open",
    "block/iron_trapdoor_top",
    "block/item_frame",
    "block/item_frame_map",
    "block/jack_o_lantern",
    "block/jigsaw",
    "block/jukebox",
    "block/jungle_button",
    "block/jungle_button_inventory",
    "block/jungle_button_pressed",
    "block/jungle_door_bottom_left",
    "block/jungle_door_bottom_left_open",
    "block/jungle_door_bottom_right",
    "block/jungle_door_bottom_right_open",
    "block/jungle_door_top_left",
    "block/jungle_door_top_left_open",
    "block/jungle_door_top_right",
    "block/jungle_door_top_right_open",
    "block/jungle_fence_gate",
    "block/jungle_fence_gate_open",
    "block/jungle_fence_gate_wall",
    "block/jungle_fence_gate_wall_open",
    "block/jungle_fence_inventory",
    "block/jungle_fence_post",
    "block/jungle_fence_side",
    "block/jungle_hanging_sign_attached_rot_0",
    "block/jungle_hanging_sign_attached_rot_1",
    "block/jungle_hanging_sign_attached_rot_2",
    "block/jungle_hanging_sign_attached_rot_3",
    "block/jungle_hanging_sign_rot_0",
    "block/jungle_hanging_sign_rot_1",
    "block/jungle_hanging_sign_rot_2",
    "block/jungle_hanging_sign_rot_3",
    "block/jungle_leaves",
    "block/jungle_log",
    "block/jungle_log_horizontal",
    "block/jungle_planks",
    "block/jungle_pressure_plate",
    "block/jungle_pressure_plate_down",
    "block/jungle_sapling",
    "block/jungle_shelf",
    "block/jungle_shelf_center",
    "block/jungle_shelf_inventory",
    "block/jungle_shelf_left",
    "block/jungle_shelf_right",
    "block/jungle_shelf_unconnected",
    "block/jungle_shelf_unpowered",
    "block/jungle_sign_rot_0",
    "block/jungle_sign_rot_1",
    "block/jungle_sign_rot_2",
    "block/jungle_sign_rot_3",
    "block/jungle_slab",
    "block/jungle_slab_top",
    "block/jungle_stairs",
    "block/jungle_stairs_inner",
    "block/jungle_stairs_outer",
    "block/jungle_trapdoor_bottom",
    "block/jungle_trapdoor_open",
    "block/jungle_trapdoor_top",
    "block/jungle_wall_hanging_sign",
    "block/jungle_wall_sign",
    "block/jungle_wood",
    "block/kelp",
    "block/kelp_plant",
    "block/ladder",
    "block/lantern",
    "block/lantern_hanging",
    "block/lapis_block",
    "block/lapis_ore",
    "block/large_amethyst_bud",
    "block/large_fern_bottom",
    "block/large_fern_top",
    "block/lava",
    "block/lava_cauldron",
    "block/leaf_litter_1",
    "block/leaf_litter_2",
    "block/leaf_litter_3",
    "block/leaf_litter_4",
    "block/leaves",
    "block/lectern",
    "block/lever",
    "block/lever_on",
    "block/light_00",
    "block/light_01",
    "block/light_02",
    "block/light_03",
    "block/light_04",
    "block/light_05",
    "block/light_06",
    "block/light_07",
    "block/light_08",
    "block/light_09",
    "block/light_10",
    "block/light_11",
    "block/light_12",
    "block/light_13",
    "block/light_14",
    "block/light_15",
    "block/light_blue_bed_foot",
    "block/light_blue_bed_head",
    "block/light_blue_candle_cake",
    "block/light_blue_candle_cake_lit",
    "block/light_blue_candle_four_candles",
    "block/light_blue_candle_four_candles_lit",
    "block/light_blue_candle_one_candle",
    "block/light_blue_candle_one_candle_lit",
    "block/light_blue_candle_three_candles",
    "block/light_blue_candle_three_candles_lit",
    "block/light_blue_candle_two_candles",
    "block/light_blue_candle_two_candles_lit",
    "block/light_blue_carpet",
    "block/light_blue_concrete",
    "block/light_blue_concrete_powder",
    "block/light_blue_concrete_slab",
    "block/light_blue_concrete_slab_top",
    "block/light_blue_concrete_stairs",
    "block/light_blue_concrete_stairs_inner",
    "block/light_blue_concrete_stairs_outer",
    "block/light_blue_glazed_terracotta",
    "block/light_blue_shulker_box",
    "block/light_blue_stained_glass",
    "block/light_blue_stained_glass_pane_noside",
    "block/light_blue_stained_glass_pane_noside_alt",
    "block/light_blue_stained_glass_pane_post",
    "block/light_blue_stained_glass_pane_side",
    "block/light_blue_stained_glass_pane_side_alt",
    "block/light_blue_terracotta",
    "block/light_blue_wool",
    "block/light_blue_wool_slab",
    "block/light_blue_wool_slab_top",
    "block/light_blue_wool_stairs",
    "block/light_blue_wool_stairs_inner",
    "block/light_blue_wool_stairs_outer",
    "block/light_gray_bed_foot",
    "block/light_gray_bed_head",
    "block/light_gray_candle_cake",
    "block/light_gray_candle_cake_lit",
    "block/light_gray_candle_four_candles",
    "block/light_gray_candle_four_candles_lit",
    "block/light_gray_candle_one_candle",
    "block/light_gray_candle_one_candle_lit",
    "block/light_gray_candle_three_candles",
    "block/light_gray_candle_three_candles_lit",
    "block/light_gray_candle_two_candles",
    "block/light_gray_candle_two_candles_lit",
    "block/light_gray_carpet",
    "block/light_gray_concrete",
    "block/light_gray_concrete_powder",
    "block/light_gray_concrete_slab",
    "block/light_gray_concrete_slab_top",
    "block/light_gray_concrete_stairs",
    "block/light_gray_concrete_stairs_inner",
    "block/light_gray_concrete_stairs_outer",
    "block/light_gray_glazed_terracotta",
    "block/light_gray_shulker_box",
    "block/light_gray_stained_glass",
    "block/light_gray_stained_glass_pane_noside",
    "block/light_gray_stained_glass_pane_noside_alt",
    "block/light_gray_stained_glass_pane_post",
    "block/light_gray_stained_glass_pane_side",
    "block/light_gray_stained_glass_pane_side_alt",
    "block/light_gray_terracotta",
    "block/light_gray_wool",
    "block/light_gray_wool_slab",
    "block/light_gray_wool_slab_top",
    "block/light_gray_wool_stairs",
    "block/light_gray_wool_stairs_inner",
    "block/light_gray_wool_stairs_outer",
    "block/light_weighted_pressure_plate",
    "block/light_weighted_pressure_plate_down",
    "block/lightning_rod",
    "block/lightning_rod_on",
    "block/lilac_bottom",
    "block/lilac_top",
    "block/lily_of_the_valley",
    "block/lily_pad",
    "block/lime_bed_foot",
    "block/lime_bed_head",
    "block/lime_candle_cake",
    "block/lime_candle_cake_lit",
    "block/lime_candle_four_candles",
    "block/lime_candle_four_candles_lit",
    "block/lime_candle_one_candle",
    "block/lime_candle_one_candle_lit",
    "block/lime_candle_three_candles",
    "block/lime_candle_three_candles_lit",
    "block/lime_candle_two_candles",
    "block/lime_candle_two_candles_lit",
    "block/lime_carpet",
    "block/lime_concrete",
    "block/lime_concrete_powder",
    "block/lime_concrete_slab",
    "block/lime_concrete_slab_top",
    "block/lime_concrete_stairs",
    "block/lime_concrete_stairs_inner",
    "block/lime_concrete_stairs_outer",
    "block/lime_glazed_terracotta",
    "block/lime_shulker_box",
    "block/lime_stained_glass",
    "block/lime_stained_glass_pane_noside",
    "block/lime_stained_glass_pane_noside_alt",
    "block/lime_stained_glass_pane_post",
    "block/lime_stained_glass_pane_side",
    "block/lime_stained_glass_pane_side_alt",
    "block/lime_terracotta",
    "block/lime_wool",
    "block/lime_wool_slab",
    "block/lime_wool_slab_top",
    "block/lime_wool_stairs",
    "block/lime_wool_stairs_inner",
    "block/lime_wool_stairs_outer",
    "block/lodestone",
    "block/loom",
    "block/magenta_bed_foot",
    "block/magenta_bed_head",
    "block/magenta_candle_cake",
    "block/magenta_candle_cake_lit",
    "block/magenta_candle_four_candles",
    "block/magenta_candle_four_candles_lit",
    "block/magenta_candle_one_candle",
    "block/magenta_candle_one_candle_lit",
    "block/magenta_candle_three_candles",
    "block/magenta_candle_three_candles_lit",
    "block/magenta_candle_two_candles",
    "block/magenta_candle_two_candles_lit",
    "block/magenta_carpet",
    "block/magenta_concrete",
    "block/magenta_concrete_powder",
    "block/magenta_concrete_slab",
    "block/magenta_concrete_slab_top",
    "block/magenta_concrete_stairs",
    "block/magenta_concrete_stairs_inner",
    "block/magenta_concrete_stairs_outer",
    "block/magenta_glazed_terracotta",
    "block/magenta_shulker_box",
    "block/magenta_stained_glass",
    "block/magenta_stained_glass_pane_noside",
    "block/magenta_stained_glass_pane_noside_alt",
    "block/magenta_stained_glass_pane_post",
    "block/magenta_stained_glass_pane_side",
    "block/magenta_stained_glass_pane_side_alt",
    "block/magenta_terracotta",
    "block/magenta_wool",
    "block/magenta_wool_slab",
    "block/magenta_wool_slab_top",
    "block/magenta_wool_stairs",
    "block/magenta_wool_stairs_inner",
    "block/magenta_wool_stairs_outer",
    "block/magma_block",
    "block/mangrove_button",
    "block/mangrove_button_inventory",
    "block/mangrove_button_pressed",
    "block/mangrove_door_bottom_left",
    "block/mangrove_door_bottom_left_open",
    "block/mangrove_door_bottom_right",
    "block/mangrove_door_bottom_right_open",
    "block/mangrove_door_top_left",
    "block/mangrove_door_top_left_open",
    "block/mangrove_door_top_right",
    "block/mangrove_door_top_right_open",
    "block/mangrove_fence_gate",
    "block/mangrove_fence_gate_open",
    "block/mangrove_fence_gate_wall",
    "block/mangrove_fence_gate_wall_open",
    "block/mangrove_fence_inventory",
    "block/mangrove_fence_post",
    "block/mangrove_fence_side",
    "block/mangrove_hanging_sign_attached_rot_0",
    "block/mangrove_hanging_sign_attached_rot_1",
    "block/mangrove_hanging_sign_attached_rot_2",
    "block/mangrove_hanging_sign_attached_rot_3",
    "block/mangrove_hanging_sign_rot_0",
    "block/mangrove_hanging_sign_rot_1",
    "block/mangrove_hanging_sign_rot_2",
    "block/mangrove_hanging_sign_rot_3",
    "block/mangrove_leaves",
    "block/mangrove_log",
    "block/mangrove_log_horizontal",
    "block/mangrove_planks",
    "block/mangrove_pressure_plate",
    "block/mangrove_pressure_plate_down",
    "block/mangrove_propagule",
    "block/mangrove_propagule_hanging_0",
    "block/mangrove_propagule_hanging_1",
    "block/mangrove_propagule_hanging_2",
    "block/mangrove_propagule_hanging_3",
    "block/mangrove_propagule_hanging_4",
    "block/mangrove_roots",
    "block/mangrove_shelf",
    "block/mangrove_shelf_center",
    "block/mangrove_shelf_inventory",
    "block/mangrove_shelf_left",
    "block/mangrove_shelf_right",
    "block/mangrove_shelf_unconnected",
    "block/mangrove_shelf_unpowered",
    "block/mangrove_sign_rot_0",
    "block/mangrove_sign_rot_1",
    "block/mangrove_sign_rot_2",
    "block/mangrove_sign_rot_3",
    "block/mangrove_slab",
    "block/mangrove_slab_top",
    "block/mangrove_stairs",
    "block/mangrove_stairs_inner",
    "block/mangrove_stairs_outer",
    "block/mangrove_trapdoor_bottom",
    "block/mangrove_trapdoor_open",
    "block/mangrove_trapdoor_top",
    "block/mangrove_wall_hanging_sign",
    "block/mangrove_wall_sign",
    "block/mangrove_wood",
    "block/medium_amethyst_bud",
    "block/melon",
    "block/melon_stem_stage0",
    "block/melon_stem_stage1",
    "block/melon_stem_stage2",
    "block/melon_stem_stage3",
    "block/melon_stem_stage4",
    "block/melon_stem_stage5",
    "block/melon_stem_stage6",
    "block/melon_stem_stage7",
    "block/moss_block",
    "block/moss_carpet",
    "block/mossy_carpet_side",
    "block/mossy_cobblestone",
    "block/mossy_cobblestone_slab",
    "block/mossy_cobblestone_slab_top",
    "block/mossy_cobblestone_stairs",
    "block/mossy_cobblestone_stairs_inner",
    "block/mossy_cobblestone_stairs_outer",
    "block/mossy_cobblestone_wall_inventory",
    "block/mossy_cobblestone_wall_post",
    "block/mossy_cobblestone_wall_side",
    "block/mossy_cobblestone_wall_side_tall",
    "block/mossy_stone_brick_slab",
    "block/mossy_stone_brick_slab_top",
    "block/mossy_stone_brick_stairs",
    "block/mossy_stone_brick_stairs_inner",
    "block/mossy_stone_brick_stairs_outer",
    "block/mossy_stone_brick_wall_inventory",
    "block/mossy_stone_brick_wall_post",
    "block/mossy_stone_brick_wall_side",
    "block/mossy_stone_brick_wall_side_tall",
    "block/mossy_stone_bricks",
    "block/moving_piston",
    "block/mud",
    "block/mud_brick_slab",
    "block/mud_brick_slab_top",
    "block/mud_brick_stairs",
    "block/mud_brick_stairs_inner",
    "block/mud_brick_stairs_outer",
    "block/mud_brick_wall_inventory",
    "block/mud_brick_wall_post",
    "block/mud_brick_wall_side",
    "block/mud_brick_wall_side_tall",
    "block/mud_bricks",
    "block/mud_bricks_north_west_mirrored",
    "block/muddy_mangrove_roots",
    "block/mushroom_block_inside",
    "block/mushroom_stem",
    "block/mushroom_stem_inventory",
    "block/mycelium",
    "block/nether_brick_fence_inventory",
    "block/nether_brick_fence_post",
    "block/nether_brick_fence_side",
    "block/nether_brick_slab",
    "block/nether_brick_slab_top",
    "block/nether_brick_stairs",
    "block/nether_brick_stairs_inner",
    "block/nether_brick_stairs_outer",
    "block/nether_brick_wall_inventory",
    "block/nether_brick_wall_post",
    "block/nether_brick_wall_side",
    "block/nether_brick_wall_side_tall",
    "block/nether_bricks",
    "block/nether_gold_ore",
    "block/nether_portal_ew",
    "block/nether_portal_ns",
    "block/nether_quartz_ore",
    "block/nether_sprouts",
    "block/nether_wart_block",
    "block/nether_wart_stage0",
    "block/nether_wart_stage1",
    "block/nether_wart_stage2",
    "block/netherite_block",
    "block/netherrack",
    "block/note_block",
    "block/oak_button",
    "block/oak_button_inventory",
    "block/oak_button_pressed",
    "block/oak_door_bottom_left",
    "block/oak_door_bottom_left_open",
    "block/oak_door_bottom_right",
    "block/oak_door_bottom_right_open",
    "block/oak_door_top_left",
    "block/oak_door_top_left_open",
    "block/oak_door_top_right",
    "block/oak_door_top_right_open",
    "block/oak_fence_gate",
    "block/oak_fence_gate_open",
    "block/oak_fence_gate_wall",
    "block/oak_fence_gate_wall_open",
    "block/oak_fence_inventory",
    "block/oak_fence_post",
    "block/oak_fence_side",
    "block/oak_hanging_sign_attached_rot_0",
    "block/oak_hanging_sign_attached_rot_1",
    "block/oak_hanging_sign_attached_rot_2",
    "block/oak_hanging_sign_attached_rot_3",
    "block/oak_hanging_sign_rot_0",
    "block/oak_hanging_sign_rot_1",
    "block/oak_hanging_sign_rot_2",
    "block/oak_hanging_sign_rot_3",
    "block/oak_leaves",
    "block/oak_log",
    "block/oak_log_horizontal",
    "block/oak_planks",
    "block/oak_pressure_plate",
    "block/oak_pressure_plate_down",
    "block/oak_sapling",
    "block/oak_shelf",
    "block/oak_shelf_center",
    "block/oak_shelf_inventory",
    "block/oak_shelf_left",
    "block/oak_shelf_right",
    "block/oak_shelf_unconnected",
    "block/oak_shelf_unpowered",
    "block/oak_sign_rot_0",
    "block/oak_sign_rot_1",
    "block/oak_sign_rot_2",
    "block/oak_sign_rot_3",
    "block/oak_slab",
    "block/oak_slab_top",
    "block/oak_stairs",
    "block/oak_stairs_inner",
    "block/oak_stairs_outer",
    "block/oak_trapdoor_bottom",
    "block/oak_trapdoor_open",
    "block/oak_trapdoor_top",
    "block/oak_wall_hanging_sign",
    "block/oak_wall_sign",
    "block/oak_wood",
    "block/observer",
    "block/observer_on",
    "block/obsidian",
    "block/ochre_froglight",
    "block/ochre_froglight_horizontal",
    "block/open_eyeblossom",
    "block/orange_bed_foot",
    "block/orange_bed_head",
    "block/orange_candle_cake",
    "block/orange_candle_cake_lit",
    "block/orange_candle_four_candles",
    "block/orange_candle_four_candles_lit",
    "block/orange_candle_one_candle",
    "block/orange_candle_one_candle_lit",
    "block/orange_candle_three_candles",
    "block/orange_candle_three_candles_lit",
    "block/orange_candle_two_candles",
    "block/orange_candle_two_candles_lit",
    "block/orange_carpet",
    "block/orange_concrete",
    "block/orange_concrete_powder",
    "block/orange_concrete_slab",
    "block/orange_concrete_slab_top",
    "block/orange_concrete_stairs",
    "block/orange_concrete_stairs_inner",
    "block/orange_concrete_stairs_outer",
    "block/orange_glazed_terracotta",
    "block/orange_poplar_leaves",
    "block/orange_shulker_box",
    "block/orange_stained_glass",
    "block/orange_stained_glass_pane_noside",
    "block/orange_stained_glass_pane_noside_alt",
    "block/orange_stained_glass_pane_post",
    "block/orange_stained_glass_pane_side",
    "block/orange_stained_glass_pane_side_alt",
    "block/orange_terracotta",
    "block/orange_tulip",
    "block/orange_wool",
    "block/orange_wool_slab",
    "block/orange_wool_slab_top",
    "block/orange_wool_stairs",
    "block/orange_wool_stairs_inner",
    "block/orange_wool_stairs_outer",
    "block/orientable",
    "block/orientable_vertical",
    "block/orientable_with_bottom",
    "block/outer_stairs",
    "block/oxeye_daisy",
    "block/oxidized_chiseled_copper",
    "block/oxidized_copper",
    "block/oxidized_copper_bars_cap",
    "block/oxidized_copper_bars_cap_alt",
    "block/oxidized_copper_bars_post",
    "block/oxidized_copper_bars_post_ends",
    "block/oxidized_copper_bars_side",
    "block/oxidized_copper_bars_side_alt",
    "block/oxidized_copper_bulb",
    "block/oxidized_copper_bulb_lit",
    "block/oxidized_copper_bulb_lit_powered",
    "block/oxidized_copper_bulb_powered",
    "block/oxidized_copper_chain",
    "block/oxidized_copper_chest",
    "block/oxidized_copper_door_bottom_left",
    "block/oxidized_copper_door_bottom_left_open",
    "block/oxidized_copper_door_bottom_right",
    "block/oxidized_copper_door_bottom_right_open",
    "block/oxidized_copper_door_top_left",
    "block/oxidized_copper_door_top_left_open",
    "block/oxidized_copper_door_top_right",
    "block/oxidized_copper_door_top_right_open",
    "block/oxidized_copper_golem_statue",
    "block/oxidized_copper_grate",
    "block/oxidized_copper_lantern",
    "block/oxidized_copper_lantern_hanging",
    "block/oxidized_copper_trapdoor_bottom",
    "block/oxidized_copper_trapdoor_open",
    "block/oxidized_copper_trapdoor_top",
    "block/oxidized_cut_copper",
    "block/oxidized_cut_copper_slab",
    "block/oxidized_cut_copper_slab_top",
    "block/oxidized_cut_copper_stairs",
    "block/oxidized_cut_copper_stairs_inner",
    "block/oxidized_cut_copper_stairs_outer",
    "block/oxidized_lightning_rod",
    "block/packed_ice",
    "block/packed_mud",
    "block/pale_hanging_moss",
    "block/pale_hanging_moss_tip",
    "block/pale_moss_block",
    "block/pale_moss_carpet",
    "block/pale_moss_carpet_side_small",
    "block/pale_moss_carpet_side_tall",
    "block/pale_oak_button",
    "block/pale_oak_button_inventory",
    "block/pale_oak_button_pressed",
    "block/pale_oak_door_bottom_left",
    "block/pale_oak_door_bottom_left_open",
    "block/pale_oak_door_bottom_right",
    "block/pale_oak_door_bottom_right_open",
    "block/pale_oak_door_top_left",
    "block/pale_oak_door_top_left_open",
    "block/pale_oak_door_top_right",
    "block/pale_oak_door_top_right_open",
    "block/pale_oak_fence_gate",
    "block/pale_oak_fence_gate_open",
    "block/pale_oak_fence_gate_wall",
    "block/pale_oak_fence_gate_wall_open",
    "block/pale_oak_fence_inventory",
    "block/pale_oak_fence_post",
    "block/pale_oak_fence_side",
    "block/pale_oak_hanging_sign_attached_rot_0",
    "block/pale_oak_hanging_sign_attached_rot_1",
    "block/pale_oak_hanging_sign_attached_rot_2",
    "block/pale_oak_hanging_sign_attached_rot_3",
    "block/pale_oak_hanging_sign_rot_0",
    "block/pale_oak_hanging_sign_rot_1",
    "block/pale_oak_hanging_sign_rot_2",
    "block/pale_oak_hanging_sign_rot_3",
    "block/pale_oak_leaves",
    "block/pale_oak_log",
    "block/pale_oak_log_horizontal",
    "block/pale_oak_planks",
    "block/pale_oak_pressure_plate",
    "block/pale_oak_pressure_plate_down",
    "block/pale_oak_sapling",
    "block/pale_oak_shelf",
    "block/pale_oak_shelf_center",
    "block/pale_oak_shelf_inventory",
    "block/pale_oak_shelf_left",
    "block/pale_oak_shelf_right",
    "block/pale_oak_shelf_unconnected",
    "block/pale_oak_shelf_unpowered",
    "block/pale_oak_sign_rot_0",
    "block/pale_oak_sign_rot_1",
    "block/pale_oak_sign_rot_2",
    "block/pale_oak_sign_rot_3",
    "block/pale_oak_slab",
    "block/pale_oak_slab_top",
    "block/pale_oak_stairs",
    "block/pale_oak_stairs_inner",
    "block/pale_oak_stairs_outer",
    "block/pale_oak_trapdoor_bottom",
    "block/pale_oak_trapdoor_open",
    "block/pale_oak_trapdoor_top",
    "block/pale_oak_wall_hanging_sign",
    "block/pale_oak_wall_sign",
    "block/pale_oak_wood",
    "block/pearlescent_froglight",
    "block/pearlescent_froglight_horizontal",
    "block/peony_bottom",
    "block/peony_top",
    "block/petrified_oak_slab",
    "block/petrified_oak_slab_top",
    "block/pink_bed_foot",
    "block/pink_bed_head",
    "block/pink_candle_cake",
    "block/pink_candle_cake_lit",
    "block/pink_candle_four_candles",
    "block/pink_candle_four_candles_lit",
    "block/pink_candle_one_candle",
    "block/pink_candle_one_candle_lit",
    "block/pink_candle_three_candles",
    "block/pink_candle_three_candles_lit",
    "block/pink_candle_two_candles",
    "block/pink_candle_two_candles_lit",
    "block/pink_carpet",
    "block/pink_concrete",
    "block/pink_concrete_powder",
    "block/pink_concrete_slab",
    "block/pink_concrete_slab_top",
    "block/pink_concrete_stairs",
    "block/pink_concrete_stairs_inner",
    "block/pink_concrete_stairs_outer",
    "block/pink_glazed_terracotta",
    "block/pink_petals_1",
    "block/pink_petals_2",
    "block/pink_petals_3",
    "block/pink_petals_4",
    "block/pink_shulker_box",
    "block/pink_stained_glass",
    "block/pink_stained_glass_pane_noside",
    "block/pink_stained_glass_pane_noside_alt",
    "block/pink_stained_glass_pane_post",
    "block/pink_stained_glass_pane_side",
    "block/pink_stained_glass_pane_side_alt",
    "block/pink_terracotta",
    "block/pink_tulip",
    "block/pink_wool",
    "block/pink_wool_slab",
    "block/pink_wool_slab_top",
    "block/pink_wool_stairs",
    "block/pink_wool_stairs_inner",
    "block/pink_wool_stairs_outer",
    "block/piston",
    "block/piston_base",
    "block/piston_extended",
    "block/piston_head",
    "block/piston_head_short",
    "block/piston_head_short_sticky",
    "block/piston_head_sticky",
    "block/piston_inventory",
    "block/pitcher_crop_bottom_stage_0",
    "block/pitcher_crop_bottom_stage_1",
    "block/pitcher_crop_bottom_stage_2",
    "block/pitcher_crop_bottom_stage_3",
    "block/pitcher_crop_bottom_stage_4",
    "block/pitcher_crop_top_stage_0",
    "block/pitcher_crop_top_stage_1",
    "block/pitcher_crop_top_stage_2",
    "block/pitcher_crop_top_stage_3",
    "block/pitcher_crop_top_stage_4",
    "block/pitcher_plant_bottom",
    "block/pitcher_plant_top",
    "block/podzol",
    "block/pointed_dripstone",
    "block/pointed_dripstone_down_base",
    "block/pointed_dripstone_down_frustum",
    "block/pointed_dripstone_down_middle",
    "block/pointed_dripstone_down_tip",
    "block/pointed_dripstone_down_tip_merge",
    "block/pointed_dripstone_up_base",
    "block/pointed_dripstone_up_frustum",
    "block/pointed_dripstone_up_middle",
    "block/pointed_dripstone_up_tip",
    "block/pointed_dripstone_up_tip_merge",
    "block/polished_andesite",
    "block/polished_andesite_slab",
    "block/polished_andesite_slab_top",
    "block/polished_andesite_stairs",
    "block/polished_andesite_stairs_inner",
    "block/polished_andesite_stairs_outer",
    "block/polished_basalt",
    "block/polished_blackstone",
    "block/polished_blackstone_brick_slab",
    "block/polished_blackstone_brick_slab_top",
    "block/polished_blackstone_brick_stairs",
    "block/polished_blackstone_brick_stairs_inner",
    "block/polished_blackstone_brick_stairs_outer",
    "block/polished_blackstone_brick_wall_inventory",
    "block/polished_blackstone_brick_wall_post",
    "block/polished_blackstone_brick_wall_side",
    "block/polished_blackstone_brick_wall_side_tall",
    "block/polished_blackstone_bricks",
    "block/polished_blackstone_button",
    "block/polished_blackstone_button_inventory",
    "block/polished_blackstone_button_pressed",
    "block/polished_blackstone_pressure_plate",
    "block/polished_blackstone_pressure_plate_down",
    "block/polished_blackstone_slab",
    "block/polished_blackstone_slab_top",
    "block/polished_blackstone_stairs",
    "block/polished_blackstone_stairs_inner",
    "block/polished_blackstone_stairs_outer",
    "block/polished_blackstone_wall_inventory",
    "block/polished_blackstone_wall_post",
    "block/polished_blackstone_wall_side",
    "block/polished_blackstone_wall_side_tall",
    "block/polished_cinnabar",
    "block/polished_cinnabar_slab",
    "block/polished_cinnabar_slab_top",
    "block/polished_cinnabar_stairs",
    "block/polished_cinnabar_stairs_inner",
    "block/polished_cinnabar_stairs_outer",
    "block/polished_cinnabar_wall_inventory",
    "block/polished_cinnabar_wall_post",
    "block/polished_cinnabar_wall_side",
    "block/polished_cinnabar_wall_side_tall",
    "block/polished_deepslate",
    "block/polished_deepslate_slab",
    "block/polished_deepslate_slab_top",
    "block/polished_deepslate_stairs",
    "block/polished_deepslate_stairs_inner",
    "block/polished_deepslate_stairs_outer",
    "block/polished_deepslate_wall_inventory",
    "block/polished_deepslate_wall_post",
    "block/polished_deepslate_wall_side",
    "block/polished_deepslate_wall_side_tall",
    "block/polished_diorite",
    "block/polished_diorite_slab",
    "block/polished_diorite_slab_top",
    "block/polished_diorite_stairs",
    "block/polished_diorite_stairs_inner",
    "block/polished_diorite_stairs_outer",
    "block/polished_granite",
    "block/polished_granite_slab",
    "block/polished_granite_slab_top",
    "block/polished_granite_stairs",
    "block/polished_granite_stairs_inner",
    "block/polished_granite_stairs_outer",
    "block/polished_sulfur",
    "block/polished_sulfur_slab",
    "block/polished_sulfur_slab_top",
    "block/polished_sulfur_stairs",
    "block/polished_sulfur_stairs_inner",
    "block/polished_sulfur_stairs_outer",
    "block/polished_sulfur_wall_inventory",
    "block/polished_sulfur_wall_post",
    "block/polished_sulfur_wall_side",
    "block/polished_sulfur_wall_side_tall",
    "block/polished_tuff",
    "block/polished_tuff_slab",
    "block/polished_tuff_slab_top",
    "block/polished_tuff_stairs",
    "block/polished_tuff_stairs_inner",
    "block/polished_tuff_stairs_outer",
    "block/polished_tuff_wall_inventory",
    "block/polished_tuff_wall_post",
    "block/polished_tuff_wall_side",
    "block/polished_tuff_wall_side_tall",
    "block/poplar_button",
    "block/poplar_button_inventory",
    "block/poplar_button_pressed",
    "block/poplar_door_bottom_left",
    "block/poplar_door_bottom_left_open",
    "block/poplar_door_bottom_right",
    "block/poplar_door_bottom_right_open",
    "block/poplar_door_top_left",
    "block/poplar_door_top_left_open",
    "block/poplar_door_top_right",
    "block/poplar_door_top_right_open",
    "block/poplar_fence_gate",
    "block/poplar_fence_gate_open",
    "block/poplar_fence_gate_wall",
    "block/poplar_fence_gate_wall_open",
    "block/poplar_fence_inventory",
    "block/poplar_fence_post",
    "block/poplar_fence_side",
    "block/poplar_hanging_sign_attached_rot_0",
    "block/poplar_hanging_sign_attached_rot_1",
    "block/poplar_hanging_sign_attached_rot_2",
    "block/poplar_hanging_sign_attached_rot_3",
    "block/poplar_hanging_sign_rot_0",
    "block/poplar_hanging_sign_rot_1",
    "block/poplar_hanging_sign_rot_2",
    "block/poplar_hanging_sign_rot_3",
    "block/poplar_log",
    "block/poplar_log_horizontal",
    "block/poplar_planks",
    "block/poplar_pressure_plate",
    "block/poplar_pressure_plate_down",
    "block/poplar_sapling",
    "block/poplar_shelf",
    "block/poplar_shelf_center",
    "block/poplar_shelf_inventory",
    "block/poplar_shelf_left",
    "block/poplar_shelf_right",
    "block/poplar_shelf_unconnected",
    "block/poplar_shelf_unpowered",
    "block/poplar_sign_rot_0",
    "block/poplar_sign_rot_1",
    "block/poplar_sign_rot_2",
    "block/poplar_sign_rot_3",
    "block/poplar_slab",
    "block/poplar_slab_top",
    "block/poplar_stairs",
    "block/poplar_stairs_inner",
    "block/poplar_stairs_outer",
    "block/poplar_trapdoor_bottom",
    "block/poplar_trapdoor_open",
    "block/poplar_trapdoor_top",
    "block/poplar_wall_hanging_sign",
    "block/poplar_wall_sign",
    "block/poplar_wood",
    "block/poppy",
    "block/potatoes_stage0",
    "block/potatoes_stage1",
    "block/potatoes_stage2",
    "block/potatoes_stage3",
    "block/potent_sulfur",
    "block/potted_acacia_sapling",
    "block/potted_allium",
    "block/potted_azalea_bush",
    "block/potted_azure_bluet",
    "block/potted_bamboo",
    "block/potted_birch_sapling",
    "block/potted_blue_orchid",
    "block/potted_brown_mushroom",
    "block/potted_cactus",
    "block/potted_cherry_sapling",
    "block/potted_closed_eyeblossom",
    "block/potted_cornflower",
    "block/potted_crimson_fungus",
    "block/potted_crimson_roots",
    "block/potted_dandelion",
    "block/potted_dark_oak_sapling",
    "block/potted_dead_bush",
    "block/potted_fern",
    "block/potted_flowering_azalea_bush",
    "block/potted_golden_dandelion",
    "block/potted_jungle_sapling",
    "block/potted_lily_of_the_valley",
    "block/potted_mangrove_propagule",
    "block/potted_oak_sapling",
    "block/potted_open_eyeblossom",
    "block/potted_orange_tulip",
    "block/potted_oxeye_daisy",
    "block/potted_pale_oak_sapling",
    "block/potted_pink_tulip",
    "block/potted_poplar_sapling",
    "block/potted_poppy",
    "block/potted_red_mushroom",
    "block/potted_red_tulip",
    "block/potted_spruce_sapling",
    "block/potted_torchflower",
    "block/potted_warped_fungus",
    "block/potted_warped_roots",
    "block/potted_white_tulip",
    "block/potted_wither_rose",
    "block/powder_snow",
    "block/powder_snow_cauldron_full",
    "block/powder_snow_cauldron_level1",
    "block/powder_snow_cauldron_level2",
    "block/powered_rail",
    "block/powered_rail_on",
    "block/powered_rail_on_raised_ne",
    "block/powered_rail_on_raised_sw",
    "block/powered_rail_raised_ne",
    "block/powered_rail_raised_sw",
    "block/pressure_plate_down",
    "block/pressure_plate_up",
    "block/prismarine",
    "block/prismarine_brick_slab",
    "block/prismarine_brick_slab_top",
    "block/prismarine_brick_stairs",
    "block/prismarine_brick_stairs_inner",
    "block/prismarine_brick_stairs_outer",
    "block/prismarine_bricks",
    "block/prismarine_slab",
    "block/prismarine_slab_top",
    "block/prismarine_stairs",
    "block/prismarine_stairs_inner",
    "block/prismarine_stairs_outer",
    "block/prismarine_wall_inventory",
    "block/prismarine_wall_post",
    "block/prismarine_wall_side",
    "block/prismarine_wall_side_tall",
    "block/pumpkin",
    "block/pumpkin_stem_stage0",
    "block/pumpkin_stem_stage1",
    "block/pumpkin_stem_stage2",
    "block/pumpkin_stem_stage3",
    "block/pumpkin_stem_stage4",
    "block/pumpkin_stem_stage5",
    "block/pumpkin_stem_stage6",
    "block/pumpkin_stem_stage7",
    "block/purple_bed_foot",
    "block/purple_bed_head",
    "block/purple_candle_cake",
    "block/purple_candle_cake_lit",
    "block/purple_candle_four_candles",
    "block/purple_candle_four_candles_lit",
    "block/purple_candle_one_candle",
    "block/purple_candle_one_candle_lit",
    "block/purple_candle_three_candles",
    "block/purple_candle_three_candles_lit",
    "block/purple_candle_two_candles",
    "block/purple_candle_two_candles_lit",
    "block/purple_carpet",
    "block/purple_concrete",
    "block/purple_concrete_powder",
    "block/purple_concrete_slab",
    "block/purple_concrete_slab_top",
    "block/purple_concrete_stairs",
    "block/purple_concrete_stairs_inner",
    "block/purple_concrete_stairs_outer",
    "block/purple_glazed_terracotta",
    "block/purple_shulker_box",
    "block/purple_stained_glass",
    "block/purple_stained_glass_pane_noside",
    "block/purple_stained_glass_pane_noside_alt",
    "block/purple_stained_glass_pane_post",
    "block/purple_stained_glass_pane_side",
    "block/purple_stained_glass_pane_side_alt",
    "block/purple_terracotta",
    "block/purple_wool",
    "block/purple_wool_slab",
    "block/purple_wool_slab_top",
    "block/purple_wool_stairs",
    "block/purple_wool_stairs_inner",
    "block/purple_wool_stairs_outer",
    "block/purpur_block",
    "block/purpur_pillar",
    "block/purpur_pillar_horizontal",
    "block/purpur_slab",
    "block/purpur_slab_top",
    "block/purpur_stairs",
    "block/purpur_stairs_inner",
    "block/purpur_stairs_outer",
    "block/quartz_block",
    "block/quartz_bricks",
    "block/quartz_pillar",
    "block/quartz_pillar_horizontal",
    "block/quartz_slab",
    "block/quartz_slab_top",
    "block/quartz_stairs",
    "block/quartz_stairs_inner",
    "block/quartz_stairs_outer",
    "block/rail",
    "block/rail_corner",
    "block/rail_curved",
    "block/rail_flat",
    "block/rail_raised_ne",
    "block/rail_raised_sw",
    "block/raw_copper_block",
    "block/raw_gold_block",
    "block/raw_iron_block",
    "block/red_bed_foot",
    "block/red_bed_head",
    "block/red_candle_cake",
    "block/red_candle_cake_lit",
    "block/red_candle_four_candles",
    "block/red_candle_four_candles_lit",
    "block/red_candle_one_candle",
    "block/red_candle_one_candle_lit",
    "block/red_candle_three_candles",
    "block/red_candle_three_candles_lit",
    "block/red_candle_two_candles",
    "block/red_candle_two_candles_lit",
    "block/red_carpet",
    "block/red_concrete",
    "block/red_concrete_powder",
    "block/red_concrete_slab",
    "block/red_concrete_slab_top",
    "block/red_concrete_stairs",
    "block/red_concrete_stairs_inner",
    "block/red_concrete_stairs_outer",
    "block/red_glazed_terracotta",
    "block/red_mushroom",
    "block/red_mushroom_block",
    "block/red_mushroom_block_inventory",
    "block/red_nether_brick_slab",
    "block/red_nether_brick_slab_top",
    "block/red_nether_brick_stairs",
    "block/red_nether_brick_stairs_inner",
    "block/red_nether_brick_stairs_outer",
    "block/red_nether_brick_wall_inventory",
    "block/red_nether_brick_wall_post",
    "block/red_nether_brick_wall_side",
    "block/red_nether_brick_wall_side_tall",
    "block/red_nether_bricks",
    "block/red_poplar_leaves",
    "block/red_sand",
    "block/red_sandstone",
    "block/red_sandstone_slab",
    "block/red_sandstone_slab_top",
    "block/red_sandstone_stairs",
    "block/red_sandstone_stairs_inner",
    "block/red_sandstone_stairs_outer",
    "block/red_sandstone_wall_inventory",
    "block/red_sandstone_wall_post",
    "block/red_sandstone_wall_side",
    "block/red_sandstone_wall_side_tall",
    "block/red_shrub",
    "block/red_shulker_box",
    "block/red_stained_glass",
    "block/red_stained_glass_pane_noside",
    "block/red_stained_glass_pane_noside_alt",
    "block/red_stained_glass_pane_post",
    "block/red_stained_glass_pane_side",
    "block/red_stained_glass_pane_side_alt",
    "block/red_terracotta",
    "block/red_tulip",
    "block/red_wool",
    "block/red_wool_slab",
    "block/red_wool_slab_top",
    "block/red_wool_stairs",
    "block/red_wool_stairs_inner",
    "block/red_wool_stairs_outer",
    "block/redstone_block",
    "block/redstone_dust_dot",
    "block/redstone_dust_side",
    "block/redstone_dust_side0",
    "block/redstone_dust_side1",
    "block/redstone_dust_side_alt",
    "block/redstone_dust_side_alt0",
    "block/redstone_dust_side_alt1",
    "block/redstone_dust_up",
    "block/redstone_lamp",
    "block/redstone_lamp_on",
    "block/redstone_ore",
    "block/redstone_torch",
    "block/redstone_torch_off",
    "block/redstone_wall_torch",
    "block/redstone_wall_torch_off",
    "block/reinforced_deepslate",
    "block/repeater_1tick",
    "block/repeater_1tick_locked",
    "block/repeater_1tick_on",
    "block/repeater_1tick_on_locked",
    "block/repeater_2tick",
    "block/repeater_2tick_locked",
    "block/repeater_2tick_on",
    "block/repeater_2tick_on_locked",
    "block/repeater_3tick",
    "block/repeater_3tick_locked",
    "block/repeater_3tick_on",
    "block/repeater_3tick_on_locked",
    "block/repeater_4tick",
    "block/repeater_4tick_locked",
    "block/repeater_4tick_on",
    "block/repeater_4tick_on_locked",
    "block/repeating_command_block",
    "block/repeating_command_block_conditional",
    "block/resin_block",
    "block/resin_brick_slab",
    "block/resin_brick_slab_top",
    "block/resin_brick_stairs",
    "block/resin_brick_stairs_inner",
    "block/resin_brick_stairs_outer",
    "block/resin_brick_wall_inventory",
    "block/resin_brick_wall_post",
    "block/resin_brick_wall_side",
    "block/resin_brick_wall_side_tall",
    "block/resin_bricks",
    "block/resin_clump",
    "block/respawn_anchor_0",
    "block/respawn_anchor_1",
    "block/respawn_anchor_2",
    "block/respawn_anchor_3",
    "block/respawn_anchor_4",
    "block/rooted_dirt",
    "block/rose_bush_bottom",
    "block/rose_bush_top",
    "block/sand",
    "block/sandstone",
    "block/sandstone_slab",
    "block/sandstone_slab_top",
    "block/sandstone_stairs",
    "block/sandstone_stairs_inner",
    "block/sandstone_stairs_outer",
    "block/sandstone_wall_inventory",
    "block/sandstone_wall_post",
    "block/sandstone_wall_side",
    "block/sandstone_wall_side_tall",
    "block/scaffolding_stable",
    "block/scaffolding_unstable",
    "block/sculk",
    "block/sculk_catalyst",
    "block/sculk_catalyst_bloom",
    "block/sculk_mirrored",
    "block/sculk_sensor",
    "block/sculk_sensor_active",
    "block/sculk_sensor_inactive",
    "block/sculk_shrieker",
    "block/sculk_shrieker_can_summon",
    "block/sculk_vein",
    "block/sea_lantern",
    "block/sea_pickle",
    "block/seagrass",
    "block/shelf_mushroom_stage0",
    "block/shelf_mushroom_stage1",
    "block/short_dry_grass",
    "block/short_grass",
    "block/shroomlight",
    "block/shulker_box",
    "block/skull",
    "block/slab",
    "block/slab_top",
    "block/slightly_cracked_turtle_egg",
    "block/slime_block",
    "block/small_amethyst_bud",
    "block/small_dripleaf_bottom",
    "block/small_dripleaf_top",
    "block/smithing_table",
    "block/smoker",
    "block/smoker_on",
    "block/smooth_basalt",
    "block/smooth_quartz",
    "block/smooth_quartz_slab",
    "block/smooth_quartz_slab_top",
    "block/smooth_quartz_stairs",
    "block/smooth_quartz_stairs_inner",
    "block/smooth_quartz_stairs_outer",
    "block/smooth_red_sandstone",
    "block/smooth_red_sandstone_slab",
    "block/smooth_red_sandstone_slab_top",
    "block/smooth_red_sandstone_stairs",
    "block/smooth_red_sandstone_stairs_inner",
    "block/smooth_red_sandstone_stairs_outer",
    "block/smooth_sandstone",
    "block/smooth_sandstone_slab",
    "block/smooth_sandstone_slab_top",
    "block/smooth_sandstone_stairs",
    "block/smooth_sandstone_stairs_inner",
    "block/smooth_sandstone_stairs_outer",
    "block/smooth_stone",
    "block/smooth_stone_slab",
    "block/smooth_stone_slab_double",
    "block/smooth_stone_slab_top",
    "block/sniffer_egg",
    "block/sniffer_egg_not_cracked",
    "block/sniffer_egg_slightly_cracked",
    "block/sniffer_egg_very_cracked",
    "block/snow_block",
    "block/snow_height10",
    "block/snow_height12",
    "block/snow_height14",
    "block/snow_height2",
    "block/snow_height4",
    "block/snow_height6",
    "block/snow_height8",
    "block/soul_campfire",
    "block/soul_fire_floor0",
    "block/soul_fire_floor1",
    "block/soul_fire_side0",
    "block/soul_fire_side1",
    "block/soul_fire_side_alt0",
    "block/soul_fire_side_alt1",
    "block/soul_lantern",
    "block/soul_lantern_hanging",
    "block/soul_sand",
    "block/soul_soil",
    "block/soul_torch",
    "block/soul_wall_torch",
    "block/spawner",
    "block/sponge",
    "block/spore_blossom",
    "block/spruce_button",
    "block/spruce_button_inventory",
    "block/spruce_button_pressed",
    "block/spruce_door_bottom_left",
    "block/spruce_door_bottom_left_open",
    "block/spruce_door_bottom_right",
    "block/spruce_door_bottom_right_open",
    "block/spruce_door_top_left",
    "block/spruce_door_top_left_open",
    "block/spruce_door_top_right",
    "block/spruce_door_top_right_open",
    "block/spruce_fence_gate",
    "block/spruce_fence_gate_open",
    "block/spruce_fence_gate_wall",
    "block/spruce_fence_gate_wall_open",
    "block/spruce_fence_inventory",
    "block/spruce_fence_post",
    "block/spruce_fence_side",
    "block/spruce_hanging_sign_attached_rot_0",
    "block/spruce_hanging_sign_attached_rot_1",
    "block/spruce_hanging_sign_attached_rot_2",
    "block/spruce_hanging_sign_attached_rot_3",
    "block/spruce_hanging_sign_rot_0",
    "block/spruce_hanging_sign_rot_1",
    "block/spruce_hanging_sign_rot_2",
    "block/spruce_hanging_sign_rot_3",
    "block/spruce_leaves",
    "block/spruce_log",
    "block/spruce_log_horizontal",
    "block/spruce_planks",
    "block/spruce_pressure_plate",
    "block/spruce_pressure_plate_down",
    "block/spruce_sapling",
    "block/spruce_shelf",
    "block/spruce_shelf_center",
    "block/spruce_shelf_inventory",
    "block/spruce_shelf_left",
    "block/spruce_shelf_right",
    "block/spruce_shelf_unconnected",
    "block/spruce_shelf_unpowered",
    "block/spruce_sign_rot_0",
    "block/spruce_sign_rot_1",
    "block/spruce_sign_rot_2",
    "block/spruce_sign_rot_3",
    "block/spruce_slab",
    "block/spruce_slab_top",
    "block/spruce_stairs",
    "block/spruce_stairs_inner",
    "block/spruce_stairs_outer",
    "block/spruce_trapdoor_bottom",
    "block/spruce_trapdoor_open",
    "block/spruce_trapdoor_top",
    "block/spruce_wall_hanging_sign",
    "block/spruce_wall_sign",
    "block/spruce_wood",
    "block/stairs",
    "block/stem_fruit",
    "block/stem_growth0",
    "block/stem_growth1",
    "block/stem_growth2",
    "block/stem_growth3",
    "block/stem_growth4",
    "block/stem_growth5",
    "block/stem_growth6",
    "block/stem_growth7",
    "block/sticky_piston",
    "block/sticky_piston_inventory",
    "block/stone",
    "block/stone_brick_slab",
    "block/stone_brick_slab_top",
    "block/stone_brick_stairs",
    "block/stone_brick_stairs_inner",
    "block/stone_brick_stairs_outer",
    "block/stone_brick_wall_inventory",
    "block/stone_brick_wall_post",
    "block/stone_brick_wall_side",
    "block/stone_brick_wall_side_tall",
    "block/stone_bricks",
    "block/stone_button",
    "block/stone_button_inventory",
    "block/stone_button_pressed",
    "block/stone_mirrored",
    "block/stone_pressure_plate",
    "block/stone_pressure_plate_down",
    "block/stone_slab",
    "block/stone_slab_top",
    "block/stone_stairs",
    "block/stone_stairs_inner",
    "block/stone_stairs_outer",
    "block/stonecutter",
    "block/straw_bed_foot",
    "block/straw_bed_head",
    "block/stripped_acacia_log",
    "block/stripped_acacia_log_horizontal",
    "block/stripped_acacia_wood",
    "block/stripped_bamboo_block",
    "block/stripped_bamboo_block_x",
    "block/stripped_bamboo_block_y",
    "block/stripped_bamboo_block_z",
    "block/stripped_birch_log",
    "block/stripped_birch_log_horizontal",
    "block/stripped_birch_wood",
    "block/stripped_cherry_log",
    "block/stripped_cherry_log_x",
    "block/stripped_cherry_log_y",
    "block/stripped_cherry_log_z",
    "block/stripped_cherry_wood",
    "block/stripped_crimson_hyphae",
    "block/stripped_crimson_stem",
    "block/stripped_dark_oak_log",
    "block/stripped_dark_oak_log_horizontal",
    "block/stripped_dark_oak_wood",
    "block/stripped_jungle_log",
    "block/stripped_jungle_log_horizontal",
    "block/stripped_jungle_wood",
    "block/stripped_mangrove_log",
    "block/stripped_mangrove_log_horizontal",
    "block/stripped_mangrove_wood",
    "block/stripped_oak_log",
    "block/stripped_oak_log_horizontal",
    "block/stripped_oak_wood",
    "block/stripped_pale_oak_log",
    "block/stripped_pale_oak_log_horizontal",
    "block/stripped_pale_oak_wood",
    "block/stripped_poplar_log",
    "block/stripped_poplar_log_horizontal",
    "block/stripped_poplar_wood",
    "block/stripped_spruce_log",
    "block/stripped_spruce_log_horizontal",
    "block/stripped_spruce_wood",
    "block/stripped_warped_hyphae",
    "block/stripped_warped_stem",
    "block/structure_block",
    "block/structure_block_corner",
    "block/structure_block_data",
    "block/structure_block_load",
    "block/structure_block_save",
    "block/structure_void",
    "block/sugar_cane",
    "block/sulfur",
    "block/sulfur_brick_slab",
    "block/sulfur_brick_slab_top",
    "block/sulfur_brick_stairs",
    "block/sulfur_brick_stairs_inner",
    "block/sulfur_brick_stairs_outer",
    "block/sulfur_brick_wall_inventory",
    "block/sulfur_brick_wall_post",
    "block/sulfur_brick_wall_side",
    "block/sulfur_brick_wall_side_tall",
    "block/sulfur_bricks",
    "block/sulfur_slab",
    "block/sulfur_slab_top",
    "block/sulfur_spike_down_base",
    "block/sulfur_spike_down_frustum",
    "block/sulfur_spike_down_middle",
    "block/sulfur_spike_down_tip",
    "block/sulfur_spike_down_tip_merge",
    "block/sulfur_spike_up_base",
    "block/sulfur_spike_up_frustum",
    "block/sulfur_spike_up_middle",
    "block/sulfur_spike_up_tip",
    "block/sulfur_spike_up_tip_merge",
    "block/sulfur_stairs",
    "block/sulfur_stairs_inner",
    "block/sulfur_stairs_outer",
    "block/sulfur_wall_inventory",
    "block/sulfur_wall_post",
    "block/sulfur_wall_side",
    "block/sulfur_wall_side_tall",
    "block/sunflower_bottom",
    "block/sunflower_top",
    "block/suspicious_gravel_0",
    "block/suspicious_gravel_1",
    "block/suspicious_gravel_2",
    "block/suspicious_gravel_3",
    "block/suspicious_sand_0",
    "block/suspicious_sand_1",
    "block/suspicious_sand_2",
    "block/suspicious_sand_3",
    "block/sweet_berry_bush_stage0",
    "block/sweet_berry_bush_stage1",
    "block/sweet_berry_bush_stage2",
    "block/sweet_berry_bush_stage3",
    "block/tall_dry_grass",
    "block/tall_grass_bottom",
    "block/tall_grass_top",
    "block/tall_seagrass_bottom",
    "block/tall_seagrass_top",
    "block/target",
    "block/template_anvil",
    "block/template_attached_hanging_sign_rot_0",
    "block/template_attached_hanging_sign_rot_1",
    "block/template_attached_hanging_sign_rot_2",
    "block/template_attached_hanging_sign_rot_3",
    "block/template_azalea",
    "block/template_bars_cap",
    "block/template_bars_cap_alt",
    "block/template_bars_post",
    "block/template_bars_post_ends",
    "block/template_bars_side",
    "block/template_bars_side_alt",
    "block/template_bed",
    "block/template_bed_foot",
    "block/template_bed_head",
    "block/template_cake_with_candle",
    "block/template_campfire",
    "block/template_candle",
    "block/template_cauldron_full",
    "block/template_cauldron_level1",
    "block/template_cauldron_level2",
    "block/template_chain",
    "block/template_chiseled_bookshelf_slot_bottom_left",
    "block/template_chiseled_bookshelf_slot_bottom_mid",
    "block/template_chiseled_bookshelf_slot_bottom_right",
    "block/template_chiseled_bookshelf_slot_top_left",
    "block/template_chiseled_bookshelf_slot_top_mid",
    "block/template_chiseled_bookshelf_slot_top_right",
    "block/template_chorus_flower",
    "block/template_command_block",
    "block/template_cube_bottom_top_indented",
    "block/template_custom_fence_gate",
    "block/template_custom_fence_gate_open",
    "block/template_custom_fence_gate_wall",
    "block/template_custom_fence_gate_wall_open",
    "block/template_daylight_detector",
    "block/template_fence_gate",
    "block/template_fence_gate_open",
    "block/template_fence_gate_wall",
    "block/template_fence_gate_wall_open",
    "block/template_fire_floor",
    "block/template_fire_side",
    "block/template_fire_side_alt",
    "block/template_fire_up",
    "block/template_fire_up_alt",
    "block/template_four_candles",
    "block/template_four_turtle_eggs",
    "block/template_glass_pane_noside",
    "block/template_glass_pane_noside_alt",
    "block/template_glass_pane_post",
    "block/template_glass_pane_side",
    "block/template_glass_pane_side_alt",
    "block/template_glazed_terracotta",
    "block/template_hanging_lantern",
    "block/template_hanging_sign_rot_0",
    "block/template_hanging_sign_rot_1",
    "block/template_hanging_sign_rot_2",
    "block/template_hanging_sign_rot_3",
    "block/template_item_frame",
    "block/template_item_frame_map",
    "block/template_lantern",
    "block/template_leaf_litter_1",
    "block/template_leaf_litter_2",
    "block/template_leaf_litter_3",
    "block/template_leaf_litter_4",
    "block/template_lightning_rod",
    "block/template_orientable_trapdoor_bottom",
    "block/template_orientable_trapdoor_open",
    "block/template_orientable_trapdoor_top",
    "block/template_piston",
    "block/template_piston_head",
    "block/template_piston_head_short",
    "block/template_potted_azalea_bush",
    "block/template_rail_raised_ne",
    "block/template_rail_raised_sw",
    "block/template_redstone_torch",
    "block/template_redstone_torch_wall",
    "block/template_sculk_shrieker",
    "block/template_seagrass",
    "block/template_shelf_body",
    "block/template_shelf_center",
    "block/template_shelf_inventory",
    "block/template_shelf_left",
    "block/template_shelf_right",
    "block/template_shelf_unconnected",
    "block/template_shelf_unpowered",
    "block/template_sign_rot_0",
    "block/template_sign_rot_1",
    "block/template_sign_rot_2",
    "block/template_sign_rot_3",
    "block/template_single_face",
    "block/template_three_candles",
    "block/template_three_turtle_eggs",
    "block/template_torch",
    "block/template_torch_unlit",
    "block/template_torch_wall",
    "block/template_torch_wall_unlit",
    "block/template_trapdoor_bottom",
    "block/template_trapdoor_open",
    "block/template_trapdoor_top",
    "block/template_turtle_egg",
    "block/template_two_candles",
    "block/template_two_turtle_eggs",
    "block/template_vault",
    "block/template_wall_hanging_sign",
    "block/template_wall_post",
    "block/template_wall_side",
    "block/template_wall_side_tall",
    "block/template_wall_sign",
    "block/terracotta",
    "block/test_block_accept",
    "block/test_block_fail",
    "block/test_block_log",
    "block/test_block_start",
    "block/test_instance_block",
    "block/thin_block",
    "block/three_dead_sea_pickles",
    "block/three_sea_pickles",
    "block/three_slightly_cracked_turtle_eggs",
    "block/three_turtle_eggs",
    "block/three_very_cracked_turtle_eggs",
    "block/tinted_cross",
    "block/tinted_flower_pot_cross",
    "block/tinted_glass",
    "block/tnt",
    "block/torch",
    "block/torchflower",
    "block/torchflower_crop_stage0",
    "block/torchflower_crop_stage1",
    "block/trapped_chest",
    "block/trial_spawner",
    "block/trial_spawner_active",
    "block/trial_spawner_active_ominous",
    "block/trial_spawner_ejecting_reward",
    "block/trial_spawner_ejecting_reward_ominous",
    "block/trial_spawner_inactive_ominous",
    "block/tripwire_attached_n",
    "block/tripwire_attached_ne",
    "block/tripwire_attached_ns",
    "block/tripwire_attached_nse",
    "block/tripwire_attached_nsew",
    "block/tripwire_hook",
    "block/tripwire_hook_attached",
    "block/tripwire_hook_attached_on",
    "block/tripwire_hook_on",
    "block/tripwire_n",
    "block/tripwire_ne",
    "block/tripwire_ns",
    "block/tripwire_nse",
    "block/tripwire_nsew",
    "block/tube_coral",
    "block/tube_coral_block",
    "block/tube_coral_fan",
    "block/tube_coral_wall_fan",
    "block/tuff",
    "block/tuff_brick_slab",
    "block/tuff_brick_slab_top",
    "block/tuff_brick_stairs",
    "block/tuff_brick_stairs_inner",
    "block/tuff_brick_stairs_outer",
    "block/tuff_brick_wall_inventory",
    "block/tuff_brick_wall_post",
    "block/tuff_brick_wall_side",
    "block/tuff_brick_wall_side_tall",
    "block/tuff_bricks",
    "block/tuff_slab",
    "block/tuff_slab_top",
    "block/tuff_stairs",
    "block/tuff_stairs_inner",
    "block/tuff_stairs_outer",
    "block/tuff_wall_inventory",
    "block/tuff_wall_post",
    "block/tuff_wall_side",
    "block/tuff_wall_side_tall",
    "block/turtle_egg",
    "block/twisting_vines",
    "block/twisting_vines_plant",
    "block/two_dead_sea_pickles",
    "block/two_sea_pickles",
    "block/two_slightly_cracked_turtle_eggs",
    "block/two_turtle_eggs",
    "block/two_very_cracked_turtle_eggs",
    "block/vault",
    "block/vault_active",
    "block/vault_active_ominous",
    "block/vault_ejecting_reward",
    "block/vault_ejecting_reward_ominous",
    "block/vault_ominous",
    "block/vault_unlocking",
    "block/vault_unlocking_ominous",
    "block/verdant_froglight",
    "block/verdant_froglight_horizontal",
    "block/very_cracked_turtle_egg",
    "block/vine",
    "block/wall_inventory",
    "block/wall_torch",
    "block/warped_button",
    "block/warped_button_inventory",
    "block/warped_button_pressed",
    "block/warped_door_bottom_left",
    "block/warped_door_bottom_left_open",
    "block/warped_door_bottom_right",
    "block/warped_door_bottom_right_open",
    "block/warped_door_top_left",
    "block/warped_door_top_left_open",
    "block/warped_door_top_right",
    "block/warped_door_top_right_open",
    "block/warped_fence_gate",
    "block/warped_fence_gate_open",
    "block/warped_fence_gate_wall",
    "block/warped_fence_gate_wall_open",
    "block/warped_fence_inventory",
    "block/warped_fence_post",
    "block/warped_fence_side",
    "block/warped_fungus",
    "block/warped_hanging_sign_attached_rot_0",
    "block/warped_hanging_sign_attached_rot_1",
    "block/warped_hanging_sign_attached_rot_2",
    "block/warped_hanging_sign_attached_rot_3",
    "block/warped_hanging_sign_rot_0",
    "block/warped_hanging_sign_rot_1",
    "block/warped_hanging_sign_rot_2",
    "block/warped_hanging_sign_rot_3",
    "block/warped_hyphae",
    "block/warped_nylium",
    "block/warped_planks",
    "block/warped_pressure_plate",
    "block/warped_pressure_plate_down",
    "block/warped_roots",
    "block/warped_shelf",
    "block/warped_shelf_center",
    "block/warped_shelf_inventory",
    "block/warped_shelf_left",
    "block/warped_shelf_right",
    "block/warped_shelf_unconnected",
    "block/warped_shelf_unpowered",
    "block/warped_sign_rot_0",
    "block/warped_sign_rot_1",
    "block/warped_sign_rot_2",
    "block/warped_sign_rot_3",
    "block/warped_slab",
    "block/warped_slab_top",
    "block/warped_stairs",
    "block/warped_stairs_inner",
    "block/warped_stairs_outer",
    "block/warped_stem",
    "block/warped_trapdoor_bottom",
    "block/warped_trapdoor_open",
    "block/warped_trapdoor_top",
    "block/warped_wall_hanging_sign",
    "block/warped_wall_sign",
    "block/warped_wart_block",
    "block/water",
    "block/water_cauldron_full",
    "block/water_cauldron_level1",
    "block/water_cauldron_level2",
    "block/weathered_chiseled_copper",
    "block/weathered_copper",
    "block/weathered_copper_bars_cap",
    "block/weathered_copper_bars_cap_alt",
    "block/weathered_copper_bars_post",
    "block/weathered_copper_bars_post_ends",
    "block/weathered_copper_bars_side",
    "block/weathered_copper_bars_side_alt",
    "block/weathered_copper_bulb",
    "block/weathered_copper_bulb_lit",
    "block/weathered_copper_bulb_lit_powered",
    "block/weathered_copper_bulb_powered",
    "block/weathered_copper_chain",
    "block/weathered_copper_chest",
    "block/weathered_copper_door_bottom_left",
    "block/weathered_copper_door_bottom_left_open",
    "block/weathered_copper_door_bottom_right",
    "block/weathered_copper_door_bottom_right_open",
    "block/weathered_copper_door_top_left",
    "block/weathered_copper_door_top_left_open",
    "block/weathered_copper_door_top_right",
    "block/weathered_copper_door_top_right_open",
    "block/weathered_copper_golem_statue",
    "block/weathered_copper_grate",
    "block/weathered_copper_lantern",
    "block/weathered_copper_lantern_hanging",
    "block/weathered_copper_trapdoor_bottom",
    "block/weathered_copper_trapdoor_open",
    "block/weathered_copper_trapdoor_top",
    "block/weathered_cut_copper",
    "block/weathered_cut_copper_slab",
    "block/weathered_cut_copper_slab_top",
    "block/weathered_cut_copper_stairs",
    "block/weathered_cut_copper_stairs_inner",
    "block/weathered_cut_copper_stairs_outer",
    "block/weathered_lightning_rod",
    "block/weeping_vines",
    "block/weeping_vines_plant",
    "block/wet_sponge",
    "block/wheat_stage0",
    "block/wheat_stage1",
    "block/wheat_stage2",
    "block/wheat_stage3",
    "block/wheat_stage4",
    "block/wheat_stage5",
    "block/wheat_stage6",
    "block/wheat_stage7",
    "block/white_bed_foot",
    "block/white_bed_head",
    "block/white_candle_cake",
    "block/white_candle_cake_lit",
    "block/white_candle_four_candles",
    "block/white_candle_four_candles_lit",
    "block/white_candle_one_candle",
    "block/white_candle_one_candle_lit",
    "block/white_candle_three_candles",
    "block/white_candle_three_candles_lit",
    "block/white_candle_two_candles",
    "block/white_candle_two_candles_lit",
    "block/white_carpet",
    "block/white_concrete",
    "block/white_concrete_powder",
    "block/white_concrete_slab",
    "block/white_concrete_slab_top",
    "block/white_concrete_stairs",
    "block/white_concrete_stairs_inner",
    "block/white_concrete_stairs_outer",
    "block/white_glazed_terracotta",
    "block/white_shulker_box",
    "block/white_stained_glass",
    "block/white_stained_glass_pane_noside",
    "block/white_stained_glass_pane_noside_alt",
    "block/white_stained_glass_pane_post",
    "block/white_stained_glass_pane_side",
    "block/white_stained_glass_pane_side_alt",
    "block/white_terracotta",
    "block/white_tulip",
    "block/white_wool",
    "block/white_wool_slab",
    "block/white_wool_slab_top",
    "block/white_wool_stairs",
    "block/white_wool_stairs_inner",
    "block/white_wool_stairs_outer",
    "block/wildflowers_1",
    "block/wildflowers_2",
    "block/wildflowers_3",
    "block/wildflowers_4",
    "block/wither_rose",
    "block/yellow_bed_foot",
    "block/yellow_bed_head",
    "block/yellow_candle_cake",
    "block/yellow_candle_cake_lit",
    "block/yellow_candle_four_candles",
    "block/yellow_candle_four_candles_lit",
    "block/yellow_candle_one_candle",
    "block/yellow_candle_one_candle_lit",
    "block/yellow_candle_three_candles",
    "block/yellow_candle_three_candles_lit",
    "block/yellow_candle_two_candles",
    "block/yellow_candle_two_candles_lit",
    "block/yellow_carpet",
    "block/yellow_concrete",
    "block/yellow_concrete_powder",
    "block/yellow_concrete_slab",
    "block/yellow_concrete_slab_top",
    "block/yellow_concrete_stairs",
    "block/yellow_concrete_stairs_inner",
    "block/yellow_concrete_stairs_outer",
    "block/yellow_glazed_terracotta",
    "block/yellow_poplar_leaves",
    "block/yellow_shulker_box",
    "block/yellow_stained_glass",
    "block/yellow_stained_glass_pane_noside",
    "block/yellow_stained_glass_pane_noside_alt",
    "block/yellow_stained_glass_pane_post",
    "block/yellow_stained_glass_pane_side",
    "block/yellow_stained_glass_pane_side_alt",
    "block/yellow_terracotta",
    "block/yellow_wool",
    "block/yellow_wool_slab",
    "block/yellow_wool_slab_top",
    "block/yellow_wool_stairs",
    "block/yellow_wool_stairs_inner",
    "block/yellow_wool_stairs_outer",
    "item/abandoned_campsite_map",
    "item/acacia_boat",
    "item/acacia_chest_boat",
    "item/acacia_door",
    "item/acacia_hanging_sign",
    "item/acacia_sapling",
    "item/acacia_sign",
    "item/activator_rail",
    "item/air",
    "item/allay_spawn_egg",
    "item/allium",
    "item/amethyst_bud",
    "item/amethyst_cluster",
    "item/amethyst_shard",
    "item/ancient_city_map",
    "item/angler_pottery_sherd",
    "item/apple",
    "item/archer_pottery_sherd",
    "item/armadillo_scute",
    "item/armadillo_spawn_egg",
    "item/armor_stand",
    "item/arms_up_pottery_sherd",
    "item/arrow",
    "item/axolotl_bucket",
    "item/axolotl_spawn_egg",
    "item/azure_bluet",
    "item/baked_potato",
    "item/bamboo",
    "item/bamboo_chest_raft",
    "item/bamboo_door",
    "item/bamboo_hanging_sign",
    "item/bamboo_raft",
    "item/bamboo_sign",
    "item/barrier",
    "item/bat_spawn_egg",
    "item/bee_spawn_egg",
    "item/beef",
    "item/beetroot",
    "item/beetroot_seeds",
    "item/beetroot_soup",
    "item/bell",
    "item/big_dripleaf",
    "item/birch_boat",
    "item/birch_chest_boat",
    "item/birch_door",
    "item/birch_hanging_sign",
    "item/birch_sapling",
    "item/birch_sign",
    "item/black_bundle",
    "item/black_bundle_open_back",
    "item/black_bundle_open_front",
    "item/black_candle",
    "item/black_cushion",
    "item/black_dye",
    "item/black_harness",
    "item/black_shulker_box",
    "item/black_stained_glass_pane",
    "item/blade_pottery_sherd",
    "item/blaze_powder",
    "item/blaze_rod",
    "item/blaze_spawn_egg",
    "item/blue_bundle",
    "item/blue_bundle_open_back",
    "item/blue_bundle_open_front",
    "item/blue_candle",
    "item/blue_cushion",
    "item/blue_dye",
    "item/blue_egg",
    "item/blue_harness",
    "item/blue_orchid",
    "item/blue_shulker_box",
    "item/blue_stained_glass_pane",
    "item/bogged_spawn_egg",
    "item/bolt_armor_trim_smithing_template",
    "item/bone",
    "item/bone_meal",
    "item/book",
    "item/bordure_indented_banner_pattern",
    "item/bow",
    "item/bow_pulling_0",
    "item/bow_pulling_1",
    "item/bow_pulling_2",
    "item/bowl",
    "item/brain_coral",
    "item/brain_coral_fan",
    "item/bread",
    "item/breeze_rod",
    "item/breeze_spawn_egg",
    "item/brewer_pottery_sherd",
    "item/brewing_stand",
    "item/brick",
    "item/brown_bundle",
    "item/brown_bundle_open_back",
    "item/brown_bundle_open_front",
    "item/brown_candle",
    "item/brown_cushion",
    "item/brown_dye",
    "item/brown_egg",
    "item/brown_harness",
    "item/brown_mushroom",
    "item/brown_shulker_box",
    "item/brown_stained_glass_pane",
    "item/brush",
    "item/brush_brushing_0",
    "item/brush_brushing_1",
    "item/brush_brushing_2",
    "item/bubble_coral",
    "item/bubble_coral_fan",
    "item/bucket",
    "item/bundle",
    "item/bundle_open_back",
    "item/bundle_open_front",
    "item/buried_treasure_map",
    "item/burn_pottery_sherd",
    "item/bush",
    "item/cactus_flower",
    "item/cake",
    "item/camel_husk_spawn_egg",
    "item/camel_spawn_egg",
    "item/campfire",
    "item/candle",
    "item/carrot",
    "item/carrot_on_a_stick",
    "item/cat_spawn_egg",
    "item/cauldron",
    "item/cave_spider_spawn_egg",
    "item/chainmail_boots",
    "item/chainmail_boots_amethyst_trim",
    "item/chainmail_boots_copper_trim",
    "item/chainmail_boots_diamond_trim",
    "item/chainmail_boots_emerald_trim",
    "item/chainmail_boots_gold_trim",
    "item/chainmail_boots_iron_trim",
    "item/chainmail_boots_lapis_trim",
    "item/chainmail_boots_netherite_trim",
    "item/chainmail_boots_quartz_trim",
    "item/chainmail_boots_redstone_trim",
    "item/chainmail_boots_resin_trim",
    "item/chainmail_chestplate",
    "item/chainmail_chestplate_amethyst_trim",
    "item/chainmail_chestplate_copper_trim",
    "item/chainmail_chestplate_diamond_trim",
    "item/chainmail_chestplate_emerald_trim",
    "item/chainmail_chestplate_gold_trim",
    "item/chainmail_chestplate_iron_trim",
    "item/chainmail_chestplate_lapis_trim",
    "item/chainmail_chestplate_netherite_trim",
    "item/chainmail_chestplate_quartz_trim",
    "item/chainmail_chestplate_redstone_trim",
    "item/chainmail_chestplate_resin_trim",
    "item/chainmail_helmet",
    "item/chainmail_helmet_amethyst_trim",
    "item/chainmail_helmet_copper_trim",
    "item/chainmail_helmet_diamond_trim",
    "item/chainmail_helmet_emerald_trim",
    "item/chainmail_helmet_gold_trim",
    "item/chainmail_helmet_iron_trim",
    "item/chainmail_helmet_lapis_trim",
    "item/chainmail_helmet_netherite_trim",
    "item/chainmail_helmet_quartz_trim",
    "item/chainmail_helmet_redstone_trim",
    "item/chainmail_helmet_resin_trim",
    "item/chainmail_leggings",
    "item/chainmail_leggings_amethyst_trim",
    "item/chainmail_leggings_copper_trim",
    "item/chainmail_leggings_diamond_trim",
    "item/chainmail_leggings_emerald_trim",
    "item/chainmail_leggings_gold_trim",
    "item/chainmail_leggings_iron_trim",
    "item/chainmail_leggings_lapis_trim",
    "item/chainmail_leggings_netherite_trim",
    "item/chainmail_leggings_quartz_trim",
    "item/chainmail_leggings_redstone_trim",
    "item/chainmail_leggings_resin_trim",
    "item/charcoal",
    "item/cherry_boat",
    "item/cherry_chest_boat",
    "item/cherry_door",
    "item/cherry_hanging_sign",
    "item/cherry_sapling",
    "item/cherry_sign",
    "item/chest",
    "item/chest_minecart",
    "item/chicken",
    "item/chicken_spawn_egg",
    "item/chorus_fruit",
    "item/clay_ball",
    "item/clock_00",
    "item/clock_01",
    "item/clock_02",
    "item/clock_03",
    "item/clock_04",
    "item/clock_05",
    "item/clock_06",
    "item/clock_07",
    "item/clock_08",
    "item/clock_09",
    "item/clock_10",
    "item/clock_11",
    "item/clock_12",
    "item/clock_13",
    "item/clock_14",
    "item/clock_15",
    "item/clock_16",
    "item/clock_17",
    "item/clock_18",
    "item/clock_19",
    "item/clock_20",
    "item/clock_21",
    "item/clock_22",
    "item/clock_23",
    "item/clock_24",
    "item/clock_25",
    "item/clock_26",
    "item/clock_27",
    "item/clock_28",
    "item/clock_29",
    "item/clock_30",
    "item/clock_31",
    "item/clock_32",
    "item/clock_33",
    "item/clock_34",
    "item/clock_35",
    "item/clock_36",
    "item/clock_37",
    "item/clock_38",
    "item/clock_39",
    "item/clock_40",
    "item/clock_41",
    "item/clock_42",
    "item/clock_43",
    "item/clock_44",
    "item/clock_45",
    "item/clock_46",
    "item/clock_47",
    "item/clock_48",
    "item/clock_49",
    "item/clock_50",
    "item/clock_51",
    "item/clock_52",
    "item/clock_53",
    "item/clock_54",
    "item/clock_55",
    "item/clock_56",
    "item/clock_57",
    "item/clock_58",
    "item/clock_59",
    "item/clock_60",
    "item/clock_61",
    "item/clock_62",
    "item/clock_63",
    "item/closed_eyeblossom",
    "item/coal",
    "item/coast_armor_trim_smithing_template",
    "item/cobweb",
    "item/cocoa_beans",
    "item/cod",
    "item/cod_bucket",
    "item/cod_spawn_egg",
    "item/command_block_minecart",
    "item/comparator",
    "item/compass_00",
    "item/compass_01",
    "item/compass_02",
    "item/compass_03",
    "item/compass_04",
    "item/compass_05",
    "item/compass_06",
    "item/compass_07",
    "item/compass_08",
    "item/compass_09",
    "item/compass_10",
    "item/compass_11",
    "item/compass_12",
    "item/compass_13",
    "item/compass_14",
    "item/compass_15",
    "item/compass_16",
    "item/compass_17",
    "item/compass_18",
    "item/compass_19",
    "item/compass_20",
    "item/compass_21",
    "item/compass_22",
    "item/compass_23",
    "item/compass_24",
    "item/compass_25",
    "item/compass_26",
    "item/compass_27",
    "item/compass_28",
    "item/compass_29",
    "item/compass_30",
    "item/compass_31",
    "item/conduit",
    "item/cooked_beef",
    "item/cooked_chicken",
    "item/cooked_cod",
    "item/cooked_mutton",
    "item/cooked_porkchop",
    "item/cooked_rabbit",
    "item/cooked_salmon",
    "item/cookie",
    "item/copper_axe",
    "item/copper_bars",
    "item/copper_boots",
    "item/copper_boots_amethyst_trim",
    "item/copper_boots_copper_trim",
    "item/copper_boots_diamond_trim",
    "item/copper_boots_emerald_trim",
    "item/copper_boots_gold_trim",
    "item/copper_boots_iron_trim",
    "item/copper_boots_lapis_trim",
    "item/copper_boots_netherite_trim",
    "item/copper_boots_quartz_trim",
    "item/copper_boots_redstone_trim",
    "item/copper_boots_resin_trim",
    "item/copper_chain",
    "item/copper_chest",
    "item/copper_chestplate",
    "item/copper_chestplate_amethyst_trim",
    "item/copper_chestplate_copper_trim",
    "item/copper_chestplate_diamond_trim",
    "item/copper_chestplate_emerald_trim",
    "item/copper_chestplate_gold_trim",
    "item/copper_chestplate_iron_trim",
    "item/copper_chestplate_lapis_trim",
    "item/copper_chestplate_netherite_trim",
    "item/copper_chestplate_quartz_trim",
    "item/copper_chestplate_redstone_trim",
    "item/copper_chestplate_resin_trim",
    "item/copper_door",
    "item/copper_golem_spawn_egg",
    "item/copper_helmet",
    "item/copper_helmet_amethyst_trim",
    "item/copper_helmet_copper_trim",
    "item/copper_helmet_diamond_trim",
    "item/copper_helmet_emerald_trim",
    "item/copper_helmet_gold_trim",
    "item/copper_helmet_iron_trim",
    "item/copper_helmet_lapis_trim",
    "item/copper_helmet_netherite_trim",
    "item/copper_helmet_quartz_trim",
    "item/copper_helmet_redstone_trim",
    "item/copper_helmet_resin_trim",
    "item/copper_hoe",
    "item/copper_horse_armor",
    "item/copper_ingot",
    "item/copper_lantern",
    "item/copper_leggings",
    "item/copper_leggings_amethyst_trim",
    "item/copper_leggings_copper_trim",
    "item/copper_leggings_diamond_trim",
    "item/copper_leggings_emerald_trim",
    "item/copper_leggings_gold_trim",
    "item/copper_leggings_iron_trim",
    "item/copper_leggings_lapis_trim",
    "item/copper_leggings_netherite_trim",
    "item/copper_leggings_quartz_trim",
    "item/copper_leggings_redstone_trim",
    "item/copper_leggings_resin_trim",
    "item/copper_nautilus_armor",
    "item/copper_nugget",
    "item/copper_pickaxe",
    "item/copper_shovel",
    "item/copper_spear",
    "item/copper_spear_in_hand",
    "item/copper_sword",
    "item/copper_torch",
    "item/cornflower",
    "item/cow_spawn_egg",
    "item/creaking_spawn_egg",
    "item/creeper_banner_pattern",
    "item/creeper_spawn_egg",
    "item/crimson_door",
    "item/crimson_fungus",
    "item/crimson_hanging_sign",
    "item/crimson_roots",
    "item/crimson_sign",
    "item/crossbow",
    "item/crossbow_arrow",
    "item/crossbow_firework",
    "item/crossbow_pulling_0",
    "item/crossbow_pulling_1",
    "item/crossbow_pulling_2",
    "item/cyan_bundle",
    "item/cyan_bundle_open_back",
    "item/cyan_bundle_open_front",
    "item/cyan_candle",
    "item/cyan_cushion",
    "item/cyan_dye",
    "item/cyan_harness",
    "item/cyan_shulker_box",
    "item/cyan_stained_glass_pane",
    "item/dandelion",
    "item/danger_pottery_sherd",
    "item/dark_oak_boat",
    "item/dark_oak_chest_boat",
    "item/dark_oak_door",
    "item/dark_oak_hanging_sign",
    "item/dark_oak_sapling",
    "item/dark_oak_sign",
    "item/dead_brain_coral",
    "item/dead_brain_coral_fan",
    "item/dead_bubble_coral",
    "item/dead_bubble_coral_fan",
    "item/dead_bush",
    "item/dead_fire_coral",
    "item/dead_fire_coral_fan",
    "item/dead_horn_coral",
    "item/dead_horn_coral_fan",
    "item/dead_tube_coral",
    "item/dead_tube_coral_fan",
    "item/debug_stick",
    "item/decorated_pot",
    "item/desert_pyramid_map",
    "item/desert_village_map",
    "item/detector_rail",
    "item/diamond",
    "item/diamond_axe",
    "item/diamond_boots",
    "item/diamond_boots_amethyst_trim",
    "item/diamond_boots_copper_trim",
    "item/diamond_boots_diamond_trim",
    "item/diamond_boots_emerald_trim",
    "item/diamond_boots_gold_trim",
    "item/diamond_boots_iron_trim",
    "item/diamond_boots_lapis_trim",
    "item/diamond_boots_netherite_trim",
    "item/diamond_boots_quartz_trim",
    "item/diamond_boots_redstone_trim",
    "item/diamond_boots_resin_trim",
    "item/diamond_chestplate",
    "item/diamond_chestplate_amethyst_trim",
    "item/diamond_chestplate_copper_trim",
    "item/diamond_chestplate_diamond_trim",
    "item/diamond_chestplate_emerald_trim",
    "item/diamond_chestplate_gold_trim",
    "item/diamond_chestplate_iron_trim",
    "item/diamond_chestplate_lapis_trim",
    "item/diamond_chestplate_netherite_trim",
    "item/diamond_chestplate_quartz_trim",
    "item/diamond_chestplate_redstone_trim",
    "item/diamond_chestplate_resin_trim",
    "item/diamond_helmet",
    "item/diamond_helmet_amethyst_trim",
    "item/diamond_helmet_copper_trim",
    "item/diamond_helmet_diamond_trim",
    "item/diamond_helmet_emerald_trim",
    "item/diamond_helmet_gold_trim",
    "item/diamond_helmet_iron_trim",
    "item/diamond_helmet_lapis_trim",
    "item/diamond_helmet_netherite_trim",
    "item/diamond_helmet_quartz_trim",
    "item/diamond_helmet_redstone_trim",
    "item/diamond_helmet_resin_trim",
    "item/diamond_hoe",
    "item/diamond_horse_armor",
    "item/diamond_leggings",
    "item/diamond_leggings_amethyst_trim",
    "item/diamond_leggings_copper_trim",
    "item/diamond_leggings_diamond_trim",
    "item/diamond_leggings_emerald_trim",
    "item/diamond_leggings_gold_trim",
    "item/diamond_leggings_iron_trim",
    "item/diamond_leggings_lapis_trim",
    "item/diamond_leggings_netherite_trim",
    "item/diamond_leggings_quartz_trim",
    "item/diamond_leggings_redstone_trim",
    "item/diamond_leggings_resin_trim",
    "item/diamond_nautilus_armor",
    "item/diamond_pickaxe",
    "item/diamond_shovel",
    "item/diamond_spear",
    "item/diamond_spear_in_hand",
    "item/diamond_sword",
    "item/disc_fragment_5",
    "item/dolphin_spawn_egg",
    "item/donkey_spawn_egg",
    "item/dragon_breath",
    "item/dragon_head",
    "item/dried_kelp",
    "item/drowned_spawn_egg",
    "item/dune_armor_trim_smithing_template",
    "item/echo_shard",
    "item/egg",
    "item/elder_guardian_spawn_egg",
    "item/elytra",
    "item/elytra_broken",
    "item/emerald",
    "item/enchanted_book",
    "item/enchanted_golden_apple",
    "item/end_crystal",
    "item/ender_chest",
    "item/ender_dragon_spawn_egg",
    "item/ender_eye",
    "item/ender_pearl",
    "item/enderman_spawn_egg",
    "item/endermite_spawn_egg",
    "item/evoker_spawn_egg",
    "item/experience_bottle",
    "item/explorer_pottery_sherd",
    "item/exposed_copper_bars",
    "item/exposed_copper_chain",
    "item/exposed_copper_chest",
    "item/exposed_copper_door",
    "item/exposed_copper_lantern",
    "item/eye_armor_trim_smithing_template",
    "item/feather",
    "item/fermented_spider_eye",
    "item/fern",
    "item/field_masoned_banner_pattern",
    "item/filled_map",
    "item/fire_charge",
    "item/fire_coral",
    "item/fire_coral_fan",
    "item/firefly_bush",
    "item/firework_rocket",
    "item/firework_star",
    "item/fishing_rod",
    "item/fishing_rod_cast",
    "item/flint",
    "item/flint_and_steel",
    "item/flow_armor_trim_smithing_template",
    "item/flow_banner_pattern",
    "item/flow_pottery_sherd",
    "item/flower_banner_pattern",
    "item/flower_pot",
    "item/fox_spawn_egg",
    "item/friend_pottery_sherd",
    "item/frog_spawn_egg",
    "item/frogspawn",
    "item/furnace_minecart",
    "item/generated",
    "item/ghast_spawn_egg",
    "item/ghast_tear",
    "item/glass_bottle",
    "item/glass_pane",
    "item/glistering_melon_slice",
    "item/globe_banner_pattern",
    "item/glow_berries",
    "item/glow_ink_sac",
    "item/glow_item_frame",
    "item/glow_lichen",
    "item/glow_squid_spawn_egg",
    "item/glowstone_dust",
    "item/goat_horn",
    "item/goat_spawn_egg",
    "item/gold_ingot",
    "item/gold_nugget",
    "item/golden_apple",
    "item/golden_axe",
    "item/golden_boots",
    "item/golden_boots_amethyst_trim",
    "item/golden_boots_copper_trim",
    "item/golden_boots_diamond_trim",
    "item/golden_boots_emerald_trim",
    "item/golden_boots_gold_trim",
    "item/golden_boots_iron_trim",
    "item/golden_boots_lapis_trim",
    "item/golden_boots_netherite_trim",
    "item/golden_boots_quartz_trim",
    "item/golden_boots_redstone_trim",
    "item/golden_boots_resin_trim",
    "item/golden_carrot",
    "item/golden_chestplate",
    "item/golden_chestplate_amethyst_trim",
    "item/golden_chestplate_copper_trim",
    "item/golden_chestplate_diamond_trim",
    "item/golden_chestplate_emerald_trim",
    "item/golden_chestplate_gold_trim",
    "item/golden_chestplate_iron_trim",
    "item/golden_chestplate_lapis_trim",
    "item/golden_chestplate_netherite_trim",
    "item/golden_chestplate_quartz_trim",
    "item/golden_chestplate_redstone_trim",
    "item/golden_chestplate_resin_trim",
    "item/golden_dandelion",
    "item/golden_helmet",
    "item/golden_helmet_amethyst_trim",
    "item/golden_helmet_copper_trim",
    "item/golden_helmet_diamond_trim",
    "item/golden_helmet_emerald_trim",
    "item/golden_helmet_gold_trim",
    "item/golden_helmet_iron_trim",
    "item/golden_helmet_lapis_trim",
    "item/golden_helmet_netherite_trim",
    "item/golden_helmet_quartz_trim",
    "item/golden_helmet_redstone_trim",
    "item/golden_helmet_resin_trim",
    "item/golden_hoe",
    "item/golden_horse_armor",
    "item/golden_leggings",
    "item/golden_leggings_amethyst_trim",
    "item/golden_leggings_copper_trim",
    "item/golden_leggings_diamond_trim",
    "item/golden_leggings_emerald_trim",
    "item/golden_leggings_gold_trim",
    "item/golden_leggings_iron_trim",
    "item/golden_leggings_lapis_trim",
    "item/golden_leggings_netherite_trim",
    "item/golden_leggings_quartz_trim",
    "item/golden_leggings_redstone_trim",
    "item/golden_leggings_resin_trim",
    "item/golden_nautilus_armor",
    "item/golden_pickaxe",
    "item/golden_shovel",
    "item/golden_spear",
    "item/golden_spear_in_hand",
    "item/golden_sword",
    "item/gray_bundle",
    "item/gray_bundle_open_back",
    "item/gray_bundle_open_front",
    "item/gray_candle",
    "item/gray_cushion",
    "item/gray_dye",
    "item/gray_harness",
    "item/gray_shulker_box",
    "item/gray_stained_glass_pane",
    "item/green_bundle",
    "item/green_bundle_open_back",
    "item/green_bundle_open_front",
    "item/green_candle",
    "item/green_cushion",
    "item/green_dye",
    "item/green_harness",
    "item/green_shulker_box",
    "item/green_stained_glass_pane",
    "item/guardian_spawn_egg",
    "item/gunpowder",
    "item/guster_banner_pattern",
    "item/guster_pottery_sherd",
    "item/handheld",
    "item/handheld_mace",
    "item/handheld_rod",
    "item/hanging_roots",
    "item/happy_ghast_spawn_egg",
    "item/heart_of_the_sea",
    "item/heart_pottery_sherd",
    "item/heartbreak_pottery_sherd",
    "item/hoglin_spawn_egg",
    "item/honey_bottle",
    "item/honeycomb",
    "item/hopper",
    "item/hopper_minecart",
    "item/horn_coral",
    "item/horn_coral_fan",
    "item/horse_spawn_egg",
    "item/host_armor_trim_smithing_template",
    "item/howl_pottery_sherd",
    "item/husk_spawn_egg",
    "item/ink_sac",
    "item/iron_axe",
    "item/iron_bars",
    "item/iron_boots",
    "item/iron_boots_amethyst_trim",
    "item/iron_boots_copper_trim",
    "item/iron_boots_diamond_trim",
    "item/iron_boots_emerald_trim",
    "item/iron_boots_gold_trim",
    "item/iron_boots_iron_trim",
    "item/iron_boots_lapis_trim",
    "item/iron_boots_netherite_trim",
    "item/iron_boots_quartz_trim",
    "item/iron_boots_redstone_trim",
    "item/iron_boots_resin_trim",
    "item/iron_chain",
    "item/iron_chestplate",
    "item/iron_chestplate_amethyst_trim",
    "item/iron_chestplate_copper_trim",
    "item/iron_chestplate_diamond_trim",
    "item/iron_chestplate_emerald_trim",
    "item/iron_chestplate_gold_trim",
    "item/iron_chestplate_iron_trim",
    "item/iron_chestplate_lapis_trim",
    "item/iron_chestplate_netherite_trim",
    "item/iron_chestplate_quartz_trim",
    "item/iron_chestplate_redstone_trim",
    "item/iron_chestplate_resin_trim",
    "item/iron_door",
    "item/iron_golem_spawn_egg",
    "item/iron_helmet",
    "item/iron_helmet_amethyst_trim",
    "item/iron_helmet_copper_trim",
    "item/iron_helmet_diamond_trim",
    "item/iron_helmet_emerald_trim",
    "item/iron_helmet_gold_trim",
    "item/iron_helmet_iron_trim",
    "item/iron_helmet_lapis_trim",
    "item/iron_helmet_netherite_trim",
    "item/iron_helmet_quartz_trim",
    "item/iron_helmet_redstone_trim",
    "item/iron_helmet_resin_trim",
    "item/iron_hoe",
    "item/iron_horse_armor",
    "item/iron_ingot",
    "item/iron_leggings",
    "item/iron_leggings_amethyst_trim",
    "item/iron_leggings_copper_trim",
    "item/iron_leggings_diamond_trim",
    "item/iron_leggings_emerald_trim",
    "item/iron_leggings_gold_trim",
    "item/iron_leggings_iron_trim",
    "item/iron_leggings_lapis_trim",
    "item/iron_leggings_netherite_trim",
    "item/iron_leggings_quartz_trim",
    "item/iron_leggings_redstone_trim",
    "item/iron_leggings_resin_trim",
    "item/iron_nautilus_armor",
    "item/iron_nugget",
    "item/iron_pickaxe",
    "item/iron_shovel",
    "item/iron_spear",
    "item/iron_spear_in_hand",
    "item/iron_sword",
    "item/item_frame",
    "item/jungle_boat",
    "item/jungle_chest_boat",
    "item/jungle_door",
    "item/jungle_explorer_map",
    "item/jungle_hanging_sign",
    "item/jungle_sapling",
    "item/jungle_sign",
    "item/kelp",
    "item/knowledge_book",
    "item/ladder",
    "item/lantern",
    "item/lapis_lazuli",
    "item/large_amethyst_bud",
    "item/large_fern",
    "item/lava_bucket",
    "item/lead",
    "item/leaf_litter",
    "item/leather",
    "item/leather_boots",
    "item/leather_boots_amethyst_trim",
    "item/leather_boots_copper_trim",
    "item/leather_boots_diamond_trim",
    "item/leather_boots_emerald_trim",
    "item/leather_boots_gold_trim",
    "item/leather_boots_iron_trim",
    "item/leather_boots_lapis_trim",
    "item/leather_boots_netherite_trim",
    "item/leather_boots_quartz_trim",
    "item/leather_boots_redstone_trim",
    "item/leather_boots_resin_trim",
    "item/leather_chestplate",
    "item/leather_chestplate_amethyst_trim",
    "item/leather_chestplate_copper_trim",
    "item/leather_chestplate_diamond_trim",
    "item/leather_chestplate_emerald_trim",
    "item/leather_chestplate_gold_trim",
    "item/leather_chestplate_iron_trim",
    "item/leather_chestplate_lapis_trim",
    "item/leather_chestplate_netherite_trim",
    "item/leather_chestplate_quartz_trim",
    "item/leather_chestplate_redstone_trim",
    "item/leather_chestplate_resin_trim",
    "item/leather_helmet",
    "item/leather_helmet_amethyst_trim",
    "item/leather_helmet_copper_trim",
    "item/leather_helmet_diamond_trim",
    "item/leather_helmet_emerald_trim",
    "item/leather_helmet_gold_trim",
    "item/leather_helmet_iron_trim",
    "item/leather_helmet_lapis_trim",
    "item/leather_helmet_netherite_trim",
    "item/leather_helmet_quartz_trim",
    "item/leather_helmet_redstone_trim",
    "item/leather_helmet_resin_trim",
    "item/leather_horse_armor",
    "item/leather_leggings",
    "item/leather_leggings_amethyst_trim",
    "item/leather_leggings_copper_trim",
    "item/leather_leggings_diamond_trim",
    "item/leather_leggings_emerald_trim",
    "item/leather_leggings_gold_trim",
    "item/leather_leggings_iron_trim",
    "item/leather_leggings_lapis_trim",
    "item/leather_leggings_netherite_trim",
    "item/leather_leggings_quartz_trim",
    "item/leather_leggings_redstone_trim",
    "item/leather_leggings_resin_trim",
    "item/lever",
    "item/light_00",
    "item/light_01",
    "item/light_02",
    "item/light_03",
    "item/light_04",
    "item/light_05",
    "item/light_06",
    "item/light_07",
    "item/light_08",
    "item/light_09",
    "item/light_10",
    "item/light_11",
    "item/light_12",
    "item/light_13",
    "item/light_14",
    "item/light_15",
    "item/light_blue_bundle",
    "item/light_blue_bundle_open_back",
    "item/light_blue_bundle_open_front",
    "item/light_blue_candle",
    "item/light_blue_cushion",
    "item/light_blue_dye",
    "item/light_blue_harness",
    "item/light_blue_shulker_box",
    "item/light_blue_stained_glass_pane",
    "item/light_gray_bundle",
    "item/light_gray_bundle_open_back",
    "item/light_gray_bundle_open_front",
    "item/light_gray_candle",
    "item/light_gray_cushion",
    "item/light_gray_dye",
    "item/light_gray_harness",
    "item/light_gray_shulker_box",
    "item/light_gray_stained_glass_pane",
    "item/lilac",
    "item/lily_of_the_valley",
    "item/lily_pad",
    "item/lime_bundle",
    "item/lime_bundle_open_back",
    "item/lime_bundle_open_front",
    "item/lime_candle",
    "item/lime_cushion",
    "item/lime_dye",
    "item/lime_harness",
    "item/lime_shulker_box",
    "item/lime_stained_glass_pane",
    "item/lingering_potion",
    "item/llama_spawn_egg",
    "item/mace",
    "item/magenta_bundle",
    "item/magenta_bundle_open_back",
    "item/magenta_bundle_open_front",
    "item/magenta_candle",
    "item/magenta_cushion",
    "item/magenta_dye",
    "item/magenta_harness",
    "item/magenta_shulker_box",
    "item/magenta_stained_glass_pane",
    "item/magma_cream",
    "item/magma_cube_spawn_egg",
    "item/mangrove_boat",
    "item/mangrove_chest_boat",
    "item/mangrove_door",
    "item/mangrove_hanging_sign",
    "item/mangrove_propagule",
    "item/mangrove_sign",
    "item/map",
    "item/medium_amethyst_bud",
    "item/melon_seeds",
    "item/melon_slice",
    "item/milk_bucket",
    "item/minecart",
    "item/miner_pottery_sherd",
    "item/mineshaft_map",
    "item/mojang_banner_pattern",
    "item/mooshroom_spawn_egg",
    "item/mourner_pottery_sherd",
    "item/mule_spawn_egg",
    "item/mushroom_stew",
    "item/music_disc_11",
    "item/music_disc_13",
    "item/music_disc_5",
    "item/music_disc_blocks",
    "item/music_disc_bounce",
    "item/music_disc_cat",
    "item/music_disc_chirp",
    "item/music_disc_creator",
    "item/music_disc_creator_music_box",
    "item/music_disc_far",
    "item/music_disc_lava_chicken",
    "item/music_disc_mall",
    "item/music_disc_mellohi",
    "item/music_disc_otherside",
    "item/music_disc_pigstep",
    "item/music_disc_precipice",
    "item/music_disc_relic",
    "item/music_disc_stal",
    "item/music_disc_strad",
    "item/music_disc_tears",
    "item/music_disc_wait",
    "item/music_disc_ward",
    "item/mutton",
    "item/name_tag",
    "item/nautilus_shell",
    "item/nautilus_spawn_egg",
    "item/nether_brick",
    "item/nether_sprouts",
    "item/nether_star",
    "item/nether_wart",
    "item/netherite_axe",
    "item/netherite_boots",
    "item/netherite_boots_amethyst_trim",
    "item/netherite_boots_copper_trim",
    "item/netherite_boots_diamond_trim",
    "item/netherite_boots_emerald_trim",
    "item/netherite_boots_gold_trim",
    "item/netherite_boots_iron_trim",
    "item/netherite_boots_lapis_trim",
    "item/netherite_boots_netherite_trim",
    "item/netherite_boots_quartz_trim",
    "item/netherite_boots_redstone_trim",
    "item/netherite_boots_resin_trim",
    "item/netherite_chestplate",
    "item/netherite_chestplate_amethyst_trim",
    "item/netherite_chestplate_copper_trim",
    "item/netherite_chestplate_diamond_trim",
    "item/netherite_chestplate_emerald_trim",
    "item/netherite_chestplate_gold_trim",
    "item/netherite_chestplate_iron_trim",
    "item/netherite_chestplate_lapis_trim",
    "item/netherite_chestplate_netherite_trim",
    "item/netherite_chestplate_quartz_trim",
    "item/netherite_chestplate_redstone_trim",
    "item/netherite_chestplate_resin_trim",
    "item/netherite_helmet",
    "item/netherite_helmet_amethyst_trim",
    "item/netherite_helmet_copper_trim",
    "item/netherite_helmet_diamond_trim",
    "item/netherite_helmet_emerald_trim",
    "item/netherite_helmet_gold_trim",
    "item/netherite_helmet_iron_trim",
    "item/netherite_helmet_lapis_trim",
    "item/netherite_helmet_netherite_trim",
    "item/netherite_helmet_quartz_trim",
    "item/netherite_helmet_redstone_trim",
    "item/netherite_helmet_resin_trim",
    "item/netherite_hoe",
    "item/netherite_horse_armor",
    "item/netherite_ingot",
    "item/netherite_leggings",
    "item/netherite_leggings_amethyst_trim",
    "item/netherite_leggings_copper_trim",
    "item/netherite_leggings_diamond_trim",
    "item/netherite_leggings_emerald_trim",
    "item/netherite_leggings_gold_trim",
    "item/netherite_leggings_iron_trim",
    "item/netherite_leggings_lapis_trim",
    "item/netherite_leggings_netherite_trim",
    "item/netherite_leggings_quartz_trim",
    "item/netherite_leggings_redstone_trim",
    "item/netherite_leggings_resin_trim",
    "item/netherite_nautilus_armor",
    "item/netherite_pickaxe",
    "item/netherite_scrap",
    "item/netherite_shovel",
    "item/netherite_spear",
    "item/netherite_spear_in_hand",
    "item/netherite_sword",
    "item/netherite_upgrade_smithing_template",
    "item/oak_boat",
    "item/oak_chest_boat",
    "item/oak_door",
    "item/oak_hanging_sign",
    "item/oak_sapling",
    "item/oak_sign",
    "item/ocean_explorer_map",
    "item/ocelot_spawn_egg",
    "item/ominous_bottle",
    "item/ominous_trial_key",
    "item/open_eyeblossom",
    "item/orange_bundle",
    "item/orange_bundle_open_back",
    "item/orange_bundle_open_front",
    "item/orange_candle",
    "item/orange_cushion",
    "item/orange_dye",
    "item/orange_harness",
    "item/orange_shulker_box",
    "item/orange_stained_glass_pane",
    "item/orange_tulip",
    "item/oxeye_daisy",
    "item/oxidized_copper_bars",
    "item/oxidized_copper_chain",
    "item/oxidized_copper_chest",
    "item/oxidized_copper_door",
    "item/oxidized_copper_lantern",
    "item/painting",
    "item/pale_hanging_moss",
    "item/pale_oak_boat",
    "item/pale_oak_chest_boat",
    "item/pale_oak_door",
    "item/pale_oak_hanging_sign",
    "item/pale_oak_sapling",
    "item/pale_oak_sign",
    "item/panda_spawn_egg",
    "item/paper",
    "item/parched_spawn_egg",
    "item/parrot_spawn_egg",
    "item/peony",
    "item/phantom_membrane",
    "item/phantom_spawn_egg",
    "item/pig_spawn_egg",
    "item/piglin_banner_pattern",
    "item/piglin_brute_spawn_egg",
    "item/piglin_spawn_egg",
    "item/pillager_spawn_egg",
    "item/pink_bundle",
    "item/pink_bundle_open_back",
    "item/pink_bundle_open_front",
    "item/pink_candle",
    "item/pink_cushion",
    "item/pink_dye",
    "item/pink_harness",
    "item/pink_petals",
    "item/pink_shulker_box",
    "item/pink_stained_glass_pane",
    "item/pink_tulip",
    "item/pitcher_plant",
    "item/pitcher_pod",
    "item/plains_village_map",
    "item/plenty_pottery_sherd",
    "item/pointed_dripstone",
    "item/poisonous_potato",
    "item/polar_bear_spawn_egg",
    "item/poplar_boat",
    "item/poplar_chest_boat",
    "item/poplar_door",
    "item/poplar_hanging_sign",
    "item/poplar_sapling",
    "item/poplar_sign",
    "item/popped_chorus_fruit",
    "item/poppy",
    "item/porkchop",
    "item/potato",
    "item/potion",
    "item/powder_snow_bucket",
    "item/powered_rail",
    "item/prismarine_crystals",
    "item/prismarine_shard",
    "item/prize_pottery_sherd",
    "item/pufferfish",
    "item/pufferfish_bucket",
    "item/pufferfish_spawn_egg",
    "item/pumpkin_pie",
    "item/pumpkin_seeds",
    "item/purple_bundle",
    "item/purple_bundle_open_back",
    "item/purple_bundle_open_front",
    "item/purple_candle",
    "item/purple_cushion",
    "item/purple_dye",
    "item/purple_harness",
    "item/purple_shulker_box",
    "item/purple_stained_glass_pane",
    "item/quartz",
    "item/rabbit",
    "item/rabbit_foot",
    "item/rabbit_hide",
    "item/rabbit_spawn_egg",
    "item/rabbit_stew",
    "item/rail",
    "item/raiser_armor_trim_smithing_template",
    "item/ravager_spawn_egg",
    "item/raw_copper",
    "item/raw_gold",
    "item/raw_iron",
    "item/recovery_compass_00",
    "item/recovery_compass_01",
    "item/recovery_compass_02",
    "item/recovery_compass_03",
    "item/recovery_compass_04",
    "item/recovery_compass_05",
    "item/recovery_compass_06",
    "item/recovery_compass_07",
    "item/recovery_compass_08",
    "item/recovery_compass_09",
    "item/recovery_compass_10",
    "item/recovery_compass_11",
    "item/recovery_compass_12",
    "item/recovery_compass_13",
    "item/recovery_compass_14",
    "item/recovery_compass_15",
    "item/recovery_compass_16",
    "item/recovery_compass_17",
    "item/recovery_compass_18",
    "item/recovery_compass_19",
    "item/recovery_compass_20",
    "item/recovery_compass_21",
    "item/recovery_compass_22",
    "item/recovery_compass_23",
    "item/recovery_compass_24",
    "item/recovery_compass_25",
    "item/recovery_compass_26",
    "item/recovery_compass_27",
    "item/recovery_compass_28",
    "item/recovery_compass_29",
    "item/recovery_compass_30",
    "item/recovery_compass_31",
    "item/red_bundle",
    "item/red_bundle_open_back",
    "item/red_bundle_open_front",
    "item/red_candle",
    "item/red_cushion",
    "item/red_dye",
    "item/red_harness",
    "item/red_mushroom",
    "item/red_shrub",
    "item/red_shulker_box",
    "item/red_stained_glass_pane",
    "item/red_tulip",
    "item/redstone",
    "item/redstone_torch",
    "item/repeater",
    "item/resin_brick",
    "item/resin_clump",
    "item/rib_armor_trim_smithing_template",
    "item/rose_bush",
    "item/rotten_flesh",
    "item/saddle",
    "item/salmon",
    "item/salmon_bucket",
    "item/salmon_spawn_egg",
    "item/savanna_village_map",
    "item/scrape_pottery_sherd",
    "item/sculk_vein",
    "item/sea_pickle",
    "item/seagrass",
    "item/sentry_armor_trim_smithing_template",
    "item/shaper_armor_trim_smithing_template",
    "item/sheaf_pottery_sherd",
    "item/shears",
    "item/sheep_spawn_egg",
    "item/shelter_pottery_sherd",
    "item/shield",
    "item/shield_blocking",
    "item/short_dry_grass",
    "item/short_grass",
    "item/shulker_box",
    "item/shulker_shell",
    "item/shulker_spawn_egg",
    "item/silence_armor_trim_smithing_template",
    "item/silverfish_spawn_egg",
    "item/skeleton_horse_spawn_egg",
    "item/skeleton_spawn_egg",
    "item/skull_banner_pattern",
    "item/skull_pottery_sherd",
    "item/slime_ball",
    "item/slime_spawn_egg",
    "item/small_amethyst_bud",
    "item/small_dripleaf",
    "item/sniffer_egg",
    "item/sniffer_spawn_egg",
    "item/snort_pottery_sherd",
    "item/snout_armor_trim_smithing_template",
    "item/snow_golem_spawn_egg",
    "item/snowball",
    "item/snowy_village_map",
    "item/soul_campfire",
    "item/soul_lantern",
    "item/soul_torch",
    "item/spear_in_hand",
    "item/spectral_arrow",
    "item/spider_eye",
    "item/spider_spawn_egg",
    "item/spire_armor_trim_smithing_template",
    "item/splash_potion",
    "item/spruce_boat",
    "item/spruce_chest_boat",
    "item/spruce_door",
    "item/spruce_hanging_sign",
    "item/spruce_sapling",
    "item/spruce_sign",
    "item/spyglass",
    "item/spyglass_in_hand",
    "item/squid_spawn_egg",
    "item/stick",
    "item/stone_axe",
    "item/stone_hoe",
    "item/stone_pickaxe",
    "item/stone_shovel",
    "item/stone_spear",
    "item/stone_spear_in_hand",
    "item/stone_sword",
    "item/stray_spawn_egg",
    "item/strider_spawn_egg",
    "item/string",
    "item/structure_void",
    "item/sugar",
    "item/sugar_cane",
    "item/sulfur_cube_bucket",
    "item/sulfur_cube_spawn_egg",
    "item/sulfur_spike",
    "item/sunflower",
    "item/suspicious_stew",
    "item/swamp_explorer_map",
    "item/sweet_berries",
    "item/tadpole_bucket",
    "item/tadpole_spawn_egg",
    "item/taiga_village_map",
    "item/tall_dry_grass",
    "item/tall_grass",
    "item/template_banner",
    "item/template_bundle_open_back",
    "item/template_bundle_open_front",
    "item/template_chest",
    "item/template_copper_golem_statue",
    "item/template_music_disc",
    "item/template_shulker_box",
    "item/template_skull",
    "item/tide_armor_trim_smithing_template",
    "item/tipped_arrow",
    "item/tnt_minecart",
    "item/tooting_goat_horn",
    "item/torch",
    "item/torchflower",
    "item/torchflower_seeds",
    "item/totem_of_undying",
    "item/trader_llama_spawn_egg",
    "item/trapped_chest",
    "item/trial_explorer_map",
    "item/trial_key",
    "item/trident",
    "item/trident_in_hand",
    "item/trident_throwing",
    "item/tripwire_hook",
    "item/tropical_fish",
    "item/tropical_fish_bucket",
    "item/tropical_fish_spawn_egg",
    "item/tube_coral",
    "item/tube_coral_fan",
    "item/turtle_egg",
    "item/turtle_helmet",
    "item/turtle_helmet_amethyst_trim",
    "item/turtle_helmet_copper_trim",
    "item/turtle_helmet_diamond_trim",
    "item/turtle_helmet_emerald_trim",
    "item/turtle_helmet_gold_trim",
    "item/turtle_helmet_iron_trim",
    "item/turtle_helmet_lapis_trim",
    "item/turtle_helmet_netherite_trim",
    "item/turtle_helmet_quartz_trim",
    "item/turtle_helmet_redstone_trim",
    "item/turtle_helmet_resin_trim",
    "item/turtle_scute",
    "item/turtle_spawn_egg",
    "item/twisting_vines",
    "item/vex_armor_trim_smithing_template",
    "item/vex_spawn_egg",
    "item/villager_spawn_egg",
    "item/vindicator_spawn_egg",
    "item/vine",
    "item/wandering_trader_spawn_egg",
    "item/ward_armor_trim_smithing_template",
    "item/warden_spawn_egg",
    "item/warm_ocean_ruins_map",
    "item/warped_door",
    "item/warped_fungus",
    "item/warped_fungus_on_a_stick",
    "item/warped_hanging_sign",
    "item/warped_roots",
    "item/warped_sign",
    "item/water_bucket",
    "item/wayfinder_armor_trim_smithing_template",
    "item/weathered_copper_bars",
    "item/weathered_copper_chain",
    "item/weathered_copper_chest",
    "item/weathered_copper_door",
    "item/weathered_copper_lantern",
    "item/weeping_vines",
    "item/wheat",
    "item/wheat_seeds",
    "item/white_bundle",
    "item/white_bundle_open_back",
    "item/white_bundle_open_front",
    "item/white_candle",
    "item/white_cushion",
    "item/white_dye",
    "item/white_harness",
    "item/white_shulker_box",
    "item/white_stained_glass_pane",
    "item/white_tulip",
    "item/wild_armor_trim_smithing_template",
    "item/wildflowers",
    "item/wind_charge",
    "item/witch_spawn_egg",
    "item/wither_rose",
    "item/wither_skeleton_spawn_egg",
    "item/wither_spawn_egg",
    "item/wolf_armor",
    "item/wolf_armor_dyed",
    "item/wolf_spawn_egg",
    "item/wooden_axe",
    "item/wooden_hoe",
    "item/wooden_pickaxe",
    "item/wooden_shovel",
    "item/wooden_spear",
    "item/wooden_spear_in_hand",
    "item/wooden_sword",
    "item/woodland_explorer_map",
    "item/writable_book",
    "item/written_book",
    "item/yellow_bundle",
    "item/yellow_bundle_open_back",
    "item/yellow_bundle_open_front",
    "item/yellow_candle",
    "item/yellow_cushion",
    "item/yellow_dye",
    "item/yellow_harness",
    "item/yellow_shulker_box",
    "item/yellow_stained_glass_pane",
    "item/zoglin_spawn_egg",
    "item/zombie_horse_spawn_egg",
    "item/zombie_nautilus_spawn_egg",
    "item/zombie_spawn_egg",
    "item/zombie_villager_spawn_egg",
    "item/zombified_piglin_spawn_egg",
    "builtin/generated"
  ]);
});

// src/arguments/generated/_registry/post_effects.ts
var POST_EFFECTS_SET;
var init_post_effects = __esm(() => {
  init_sandstone();
  POST_EFFECTS_SET = new Set2([
    "blur",
    "creeper",
    "entity_outline",
    "invert",
    "spider"
  ]);
});

// src/arguments/generated/_registry/sounds.ts
var SOUNDS_SET;
var init_sounds = __esm(() => {
  init_sandstone();
  SOUNDS_SET = new Set2([
    "ambient/cave/cave1",
    "ambient/cave/cave10",
    "ambient/cave/cave11",
    "ambient/cave/cave12",
    "ambient/cave/cave13",
    "ambient/cave/cave14",
    "ambient/cave/cave15",
    "ambient/cave/cave16",
    "ambient/cave/cave17",
    "ambient/cave/cave18",
    "ambient/cave/cave19",
    "ambient/cave/cave2",
    "ambient/cave/cave20",
    "ambient/cave/cave21",
    "ambient/cave/cave22",
    "ambient/cave/cave23",
    "ambient/cave/cave3",
    "ambient/cave/cave4",
    "ambient/cave/cave5",
    "ambient/cave/cave6",
    "ambient/cave/cave7",
    "ambient/cave/cave8",
    "ambient/cave/cave9",
    "ambient/nether/basalt_deltas/active1",
    "ambient/nether/basalt_deltas/active2",
    "ambient/nether/basalt_deltas/active3",
    "ambient/nether/basalt_deltas/active4",
    "ambient/nether/basalt_deltas/ambience",
    "ambient/nether/basalt_deltas/basaltground1",
    "ambient/nether/basalt_deltas/basaltground2",
    "ambient/nether/basalt_deltas/basaltground3",
    "ambient/nether/basalt_deltas/basaltground4",
    "ambient/nether/basalt_deltas/click1",
    "ambient/nether/basalt_deltas/click2",
    "ambient/nether/basalt_deltas/click3",
    "ambient/nether/basalt_deltas/click4",
    "ambient/nether/basalt_deltas/click5",
    "ambient/nether/basalt_deltas/click6",
    "ambient/nether/basalt_deltas/click7",
    "ambient/nether/basalt_deltas/click8",
    "ambient/nether/basalt_deltas/debris1",
    "ambient/nether/basalt_deltas/debris2",
    "ambient/nether/basalt_deltas/debris3",
    "ambient/nether/basalt_deltas/heavy_click1",
    "ambient/nether/basalt_deltas/heavy_click2",
    "ambient/nether/basalt_deltas/long_debris1",
    "ambient/nether/basalt_deltas/long_debris2",
    "ambient/nether/basalt_deltas/plode1",
    "ambient/nether/basalt_deltas/plode2",
    "ambient/nether/basalt_deltas/plode3",
    "ambient/nether/basalt_deltas/twist1",
    "ambient/nether/basalt_deltas/twist2",
    "ambient/nether/basalt_deltas/twist3",
    "ambient/nether/basalt_deltas/twist4",
    "ambient/nether/crimson_forest/addition1",
    "ambient/nether/crimson_forest/addition2",
    "ambient/nether/crimson_forest/addition3",
    "ambient/nether/crimson_forest/ambience",
    "ambient/nether/crimson_forest/mood1",
    "ambient/nether/crimson_forest/mood2",
    "ambient/nether/crimson_forest/mood3",
    "ambient/nether/crimson_forest/mood4",
    "ambient/nether/crimson_forest/particles1",
    "ambient/nether/crimson_forest/particles2",
    "ambient/nether/crimson_forest/particles3",
    "ambient/nether/crimson_forest/shine1",
    "ambient/nether/crimson_forest/shine2",
    "ambient/nether/crimson_forest/shine3",
    "ambient/nether/crimson_forest/shroom1",
    "ambient/nether/crimson_forest/shroom2",
    "ambient/nether/crimson_forest/shroom3",
    "ambient/nether/crimson_forest/twang1",
    "ambient/nether/crimson_forest/voom1",
    "ambient/nether/crimson_forest/voom2",
    "ambient/nether/nether_wastes/addition1",
    "ambient/nether/nether_wastes/addition2",
    "ambient/nether/nether_wastes/addition3",
    "ambient/nether/nether_wastes/addition4",
    "ambient/nether/nether_wastes/addition5",
    "ambient/nether/nether_wastes/addition6",
    "ambient/nether/nether_wastes/addition7",
    "ambient/nether/nether_wastes/addition8",
    "ambient/nether/nether_wastes/ambience",
    "ambient/nether/nether_wastes/dark1",
    "ambient/nether/nether_wastes/dark2",
    "ambient/nether/nether_wastes/ground1",
    "ambient/nether/nether_wastes/ground2",
    "ambient/nether/nether_wastes/ground3",
    "ambient/nether/nether_wastes/ground4",
    "ambient/nether/nether_wastes/mood1",
    "ambient/nether/nether_wastes/mood2",
    "ambient/nether/nether_wastes/mood3",
    "ambient/nether/nether_wastes/mood4",
    "ambient/nether/nether_wastes/mood5",
    "ambient/nether/soulsand_valley/ambience",
    "ambient/nether/soulsand_valley/mood1",
    "ambient/nether/soulsand_valley/mood2",
    "ambient/nether/soulsand_valley/mood3",
    "ambient/nether/soulsand_valley/mood4",
    "ambient/nether/soulsand_valley/sand1",
    "ambient/nether/soulsand_valley/sand2",
    "ambient/nether/soulsand_valley/sand3",
    "ambient/nether/soulsand_valley/voices1",
    "ambient/nether/soulsand_valley/voices2",
    "ambient/nether/soulsand_valley/voices3",
    "ambient/nether/soulsand_valley/voices4",
    "ambient/nether/soulsand_valley/voices5",
    "ambient/nether/soulsand_valley/whisper1",
    "ambient/nether/soulsand_valley/whisper2",
    "ambient/nether/soulsand_valley/whisper3",
    "ambient/nether/soulsand_valley/whisper4",
    "ambient/nether/soulsand_valley/whisper5",
    "ambient/nether/soulsand_valley/whisper6",
    "ambient/nether/soulsand_valley/whisper7",
    "ambient/nether/soulsand_valley/whisper8",
    "ambient/nether/soulsand_valley/wind1",
    "ambient/nether/soulsand_valley/wind2",
    "ambient/nether/soulsand_valley/wind3",
    "ambient/nether/soulsand_valley/wind4",
    "ambient/nether/soulsand_valley/with1",
    "ambient/nether/warped_forest/addition1",
    "ambient/nether/warped_forest/addition2",
    "ambient/nether/warped_forest/addition3",
    "ambient/nether/warped_forest/addition4",
    "ambient/nether/warped_forest/addition5",
    "ambient/nether/warped_forest/addition6",
    "ambient/nether/warped_forest/ambience",
    "ambient/nether/warped_forest/creak1",
    "ambient/nether/warped_forest/creak2",
    "ambient/nether/warped_forest/creak3",
    "ambient/nether/warped_forest/creak4",
    "ambient/nether/warped_forest/creak5",
    "ambient/nether/warped_forest/enish1",
    "ambient/nether/warped_forest/enish2",
    "ambient/nether/warped_forest/enish3",
    "ambient/nether/warped_forest/help1",
    "ambient/nether/warped_forest/help2",
    "ambient/nether/warped_forest/here1",
    "ambient/nether/warped_forest/here2",
    "ambient/nether/warped_forest/here3",
    "ambient/nether/warped_forest/mood1",
    "ambient/nether/warped_forest/mood2",
    "ambient/nether/warped_forest/mood3",
    "ambient/nether/warped_forest/mood4",
    "ambient/nether/warped_forest/mood5",
    "ambient/nether/warped_forest/mood6",
    "ambient/nether/warped_forest/mood7",
    "ambient/nether/warped_forest/mood8",
    "ambient/nether/warped_forest/mood9",
    "ambient/underwater/additions/animal1",
    "ambient/underwater/additions/animal2",
    "ambient/underwater/additions/bass_whale1",
    "ambient/underwater/additions/bass_whale2",
    "ambient/underwater/additions/bubbles1",
    "ambient/underwater/additions/bubbles2",
    "ambient/underwater/additions/bubbles3",
    "ambient/underwater/additions/bubbles4",
    "ambient/underwater/additions/bubbles5",
    "ambient/underwater/additions/bubbles6",
    "ambient/underwater/additions/crackles1",
    "ambient/underwater/additions/crackles2",
    "ambient/underwater/additions/dark1",
    "ambient/underwater/additions/dark2",
    "ambient/underwater/additions/dark3",
    "ambient/underwater/additions/dark4",
    "ambient/underwater/additions/driplets1",
    "ambient/underwater/additions/driplets2",
    "ambient/underwater/additions/earth_crack",
    "ambient/underwater/additions/water1",
    "ambient/underwater/additions/water2",
    "ambient/underwater/enter1",
    "ambient/underwater/enter2",
    "ambient/underwater/enter3",
    "ambient/underwater/exit1",
    "ambient/underwater/exit2",
    "ambient/underwater/exit3",
    "ambient/underwater/underwater_ambience",
    "ambient/weather/end_flash1",
    "ambient/weather/end_flash2",
    "ambient/weather/end_flash3",
    "ambient/weather/end_flash4",
    "ambient/weather/end_flash5",
    "ambient/weather/end_flash6",
    "ambient/weather/end_flash7",
    "ambient/weather/end_flash8",
    "ambient/weather/rain1",
    "ambient/weather/rain2",
    "ambient/weather/rain3",
    "ambient/weather/rain4",
    "ambient/weather/rain5",
    "ambient/weather/rain6",
    "ambient/weather/rain7",
    "ambient/weather/rain8",
    "ambient/weather/thunder1",
    "ambient/weather/thunder2",
    "ambient/weather/thunder3",
    "block/amethyst/break1",
    "block/amethyst/break2",
    "block/amethyst/break3",
    "block/amethyst/break4",
    "block/amethyst/place1",
    "block/amethyst/place2",
    "block/amethyst/place3",
    "block/amethyst/place4",
    "block/amethyst/resonate1",
    "block/amethyst/resonate2",
    "block/amethyst/resonate3",
    "block/amethyst/resonate4",
    "block/amethyst/shimmer",
    "block/amethyst/step1",
    "block/amethyst/step10",
    "block/amethyst/step11",
    "block/amethyst/step12",
    "block/amethyst/step13",
    "block/amethyst/step14",
    "block/amethyst/step2",
    "block/amethyst/step3",
    "block/amethyst/step4",
    "block/amethyst/step5",
    "block/amethyst/step6",
    "block/amethyst/step7",
    "block/amethyst/step8",
    "block/amethyst/step9",
    "block/amethyst_cluster/break1",
    "block/amethyst_cluster/break2",
    "block/amethyst_cluster/break3",
    "block/amethyst_cluster/break4",
    "block/amethyst_cluster/place1",
    "block/amethyst_cluster/place2",
    "block/amethyst_cluster/place3",
    "block/amethyst_cluster/place4",
    "block/ancient_debris/break1",
    "block/ancient_debris/break2",
    "block/ancient_debris/break3",
    "block/ancient_debris/break4",
    "block/ancient_debris/break5",
    "block/azalea/break1",
    "block/azalea/break2",
    "block/azalea/break3",
    "block/azalea/break4",
    "block/azalea/break5",
    "block/azalea/break6",
    "block/azalea/step1",
    "block/azalea/step2",
    "block/azalea/step3",
    "block/azalea/step4",
    "block/azalea/step5",
    "block/azalea/step6",
    "block/azalea_leaves/break1",
    "block/azalea_leaves/break2",
    "block/azalea_leaves/break3",
    "block/azalea_leaves/break4",
    "block/azalea_leaves/break5",
    "block/azalea_leaves/break6",
    "block/azalea_leaves/break7",
    "block/azalea_leaves/step1",
    "block/azalea_leaves/step2",
    "block/azalea_leaves/step3",
    "block/azalea_leaves/step4",
    "block/azalea_leaves/step5",
    "block/bamboo/place1",
    "block/bamboo/place2",
    "block/bamboo/place3",
    "block/bamboo/place4",
    "block/bamboo/place5",
    "block/bamboo/place6",
    "block/bamboo/sapling_hit1",
    "block/bamboo/sapling_hit2",
    "block/bamboo/sapling_hit3",
    "block/bamboo/sapling_hit4",
    "block/bamboo/sapling_hit5",
    "block/bamboo/sapling_place1",
    "block/bamboo/sapling_place2",
    "block/bamboo/sapling_place3",
    "block/bamboo/sapling_place4",
    "block/bamboo/sapling_place5",
    "block/bamboo/sapling_place6",
    "block/bamboo/step1",
    "block/bamboo/step2",
    "block/bamboo/step3",
    "block/bamboo/step4",
    "block/bamboo/step5",
    "block/bamboo/step6",
    "block/bamboo_wood/break1",
    "block/bamboo_wood/break2",
    "block/bamboo_wood/break3",
    "block/bamboo_wood/break4",
    "block/bamboo_wood/break5",
    "block/bamboo_wood/step1",
    "block/bamboo_wood/step2",
    "block/bamboo_wood/step3",
    "block/bamboo_wood/step4",
    "block/bamboo_wood/step5",
    "block/bamboo_wood/step6",
    "block/bamboo_wood_button/bamboo_wood_button",
    "block/bamboo_wood_door/toggle1",
    "block/bamboo_wood_door/toggle2",
    "block/bamboo_wood_door/toggle3",
    "block/bamboo_wood_door/toggle4",
    "block/bamboo_wood_fence/toggle1",
    "block/bamboo_wood_fence/toggle2",
    "block/bamboo_wood_fence/toggle3",
    "block/bamboo_wood_fence/toggle4",
    "block/bamboo_wood_hanging_sign/break1",
    "block/bamboo_wood_hanging_sign/break2",
    "block/bamboo_wood_hanging_sign/break3",
    "block/bamboo_wood_hanging_sign/break4",
    "block/bamboo_wood_hanging_sign/step1",
    "block/bamboo_wood_hanging_sign/step2",
    "block/bamboo_wood_hanging_sign/step3",
    "block/bamboo_wood_hanging_sign/step4",
    "block/bamboo_wood_trapdoor/toggle1",
    "block/bamboo_wood_trapdoor/toggle2",
    "block/bamboo_wood_trapdoor/toggle3",
    "block/bamboo_wood_trapdoor/toggle4",
    "block/barrel/close",
    "block/barrel/open1",
    "block/barrel/open2",
    "block/basalt/break1",
    "block/basalt/break2",
    "block/basalt/break3",
    "block/basalt/break4",
    "block/basalt/break5",
    "block/basalt/step1",
    "block/basalt/step2",
    "block/basalt/step3",
    "block/basalt/step4",
    "block/basalt/step5",
    "block/basalt/step6",
    "block/beacon/activate",
    "block/beacon/ambient",
    "block/beacon/deactivate",
    "block/beacon/power1",
    "block/beacon/power2",
    "block/beacon/power3",
    "block/beehive/drip1",
    "block/beehive/drip2",
    "block/beehive/drip3",
    "block/beehive/drip4",
    "block/beehive/drip5",
    "block/beehive/drip6",
    "block/beehive/enter",
    "block/beehive/exit",
    "block/beehive/shear",
    "block/beehive/work1",
    "block/beehive/work2",
    "block/beehive/work3",
    "block/beehive/work4",
    "block/bell/bell_use01",
    "block/bell/bell_use02",
    "block/bell/resonate",
    "block/big_dripleaf/break1",
    "block/big_dripleaf/break2",
    "block/big_dripleaf/break3",
    "block/big_dripleaf/break4",
    "block/big_dripleaf/break5",
    "block/big_dripleaf/break6",
    "block/big_dripleaf/step1",
    "block/big_dripleaf/step2",
    "block/big_dripleaf/step3",
    "block/big_dripleaf/step4",
    "block/big_dripleaf/step5",
    "block/big_dripleaf/step6",
    "block/big_dripleaf/tilt_down1",
    "block/big_dripleaf/tilt_down2",
    "block/big_dripleaf/tilt_down3",
    "block/big_dripleaf/tilt_down4",
    "block/big_dripleaf/tilt_down5",
    "block/big_dripleaf/tilt_up1",
    "block/big_dripleaf/tilt_up2",
    "block/big_dripleaf/tilt_up3",
    "block/big_dripleaf/tilt_up4",
    "block/blastfurnace/blastfurnace1",
    "block/blastfurnace/blastfurnace2",
    "block/blastfurnace/blastfurnace3",
    "block/blastfurnace/blastfurnace4",
    "block/blastfurnace/blastfurnace5",
    "block/bone_block/break1",
    "block/bone_block/break2",
    "block/bone_block/break3",
    "block/bone_block/break4",
    "block/bone_block/break5",
    "block/bone_block/step1",
    "block/bone_block/step2",
    "block/bone_block/step3",
    "block/bone_block/step4",
    "block/bone_block/step5",
    "block/brewing_stand/brew1",
    "block/brewing_stand/brew2",
    "block/bubble_column/bubble1",
    "block/bubble_column/bubble2",
    "block/bubble_column/bubble3",
    "block/bubble_column/upwards_ambient1",
    "block/bubble_column/upwards_ambient2",
    "block/bubble_column/upwards_ambient3",
    "block/bubble_column/upwards_ambient4",
    "block/bubble_column/upwards_ambient5",
    "block/bubble_column/upwards_inside",
    "block/bubble_column/whirlpool_ambient1",
    "block/bubble_column/whirlpool_ambient2",
    "block/bubble_column/whirlpool_ambient3",
    "block/bubble_column/whirlpool_ambient4",
    "block/bubble_column/whirlpool_ambient5",
    "block/bubble_column/whirlpool_inside",
    "block/cactus_flower/break1",
    "block/cactus_flower/break2",
    "block/cactus_flower/break3",
    "block/cactus_flower/break4",
    "block/cactus_flower/break5",
    "block/cactus_flower/place1",
    "block/cactus_flower/place2",
    "block/cactus_flower/place3",
    "block/cactus_flower/place4",
    "block/cake/add_candle1",
    "block/cake/add_candle2",
    "block/cake/add_candle3",
    "block/calcite/break1",
    "block/calcite/break2",
    "block/calcite/break3",
    "block/calcite/break4",
    "block/calcite/place1",
    "block/calcite/place2",
    "block/calcite/place3",
    "block/calcite/place4",
    "block/calcite/step1",
    "block/calcite/step2",
    "block/calcite/step3",
    "block/calcite/step4",
    "block/calcite/step5",
    "block/calcite/step6",
    "block/campfire/crackle1",
    "block/campfire/crackle2",
    "block/campfire/crackle3",
    "block/campfire/crackle4",
    "block/campfire/crackle5",
    "block/campfire/crackle6",
    "block/candle/ambient1",
    "block/candle/ambient2",
    "block/candle/ambient3",
    "block/candle/ambient4",
    "block/candle/ambient5",
    "block/candle/ambient6",
    "block/candle/ambient7",
    "block/candle/ambient8",
    "block/candle/ambient9",
    "block/candle/break1",
    "block/candle/break2",
    "block/candle/break3",
    "block/candle/break4",
    "block/candle/break5",
    "block/candle/extinguish1",
    "block/candle/extinguish2",
    "block/candle/extinguish3",
    "block/candle/step1",
    "block/candle/step2",
    "block/candle/step3",
    "block/candle/step4",
    "block/candle/step5",
    "block/cauldron/dye1",
    "block/cauldron/dye2",
    "block/cauldron/dye3",
    "block/cave_vines/break1",
    "block/cave_vines/break2",
    "block/cave_vines/break3",
    "block/cave_vines/break4",
    "block/cave_vines/break5",
    "block/chain/break1",
    "block/chain/break2",
    "block/chain/break3",
    "block/chain/break4",
    "block/chain/step1",
    "block/chain/step2",
    "block/chain/step3",
    "block/chain/step4",
    "block/chain/step5",
    "block/chain/step6",
    "block/cherry_leaves/break1",
    "block/cherry_leaves/break2",
    "block/cherry_leaves/break3",
    "block/cherry_leaves/break4",
    "block/cherry_leaves/break5",
    "block/cherry_leaves/step1",
    "block/cherry_leaves/step2",
    "block/cherry_leaves/step3",
    "block/cherry_leaves/step4",
    "block/cherry_leaves/step5",
    "block/cherry_wood/break1",
    "block/cherry_wood/break2",
    "block/cherry_wood/break3",
    "block/cherry_wood/break4",
    "block/cherry_wood/break5",
    "block/cherry_wood/step1",
    "block/cherry_wood/step2",
    "block/cherry_wood/step3",
    "block/cherry_wood/step4",
    "block/cherry_wood/step5",
    "block/cherry_wood/step6",
    "block/cherry_wood_hanging_sign/break1",
    "block/cherry_wood_hanging_sign/break2",
    "block/cherry_wood_hanging_sign/break3",
    "block/cherry_wood_hanging_sign/break4",
    "block/cherry_wood_hanging_sign/step1",
    "block/cherry_wood_hanging_sign/step2",
    "block/cherry_wood_hanging_sign/step3",
    "block/cherry_wood_hanging_sign/step4",
    "block/cherrywood_button/cherrywood_click",
    "block/cherrywood_door/toggle1",
    "block/cherrywood_door/toggle2",
    "block/cherrywood_door/toggle3",
    "block/cherrywood_door/toggle4",
    "block/cherrywood_fence_gate/toggle1",
    "block/cherrywood_fence_gate/toggle2",
    "block/cherrywood_fence_gate/toggle3",
    "block/cherrywood_trapdoor/toggle1",
    "block/cherrywood_trapdoor/toggle2",
    "block/cherrywood_trapdoor/toggle3",
    "block/chest/close1",
    "block/chest/close2",
    "block/chest/close3",
    "block/chest/close_locked",
    "block/chest/open",
    "block/chest/open_locked",
    "block/chiseled_bookshelf/break1",
    "block/chiseled_bookshelf/break2",
    "block/chiseled_bookshelf/break3",
    "block/chiseled_bookshelf/break4",
    "block/chiseled_bookshelf/break5",
    "block/chiseled_bookshelf/break6",
    "block/chiseled_bookshelf/insert1",
    "block/chiseled_bookshelf/insert2",
    "block/chiseled_bookshelf/insert3",
    "block/chiseled_bookshelf/insert4",
    "block/chiseled_bookshelf/insert_enchanted1",
    "block/chiseled_bookshelf/insert_enchanted2",
    "block/chiseled_bookshelf/insert_enchanted3",
    "block/chiseled_bookshelf/insert_enchanted4",
    "block/chiseled_bookshelf/pickup1",
    "block/chiseled_bookshelf/pickup2",
    "block/chiseled_bookshelf/pickup3",
    "block/chiseled_bookshelf/pickup_enchanted1",
    "block/chiseled_bookshelf/pickup_enchanted2",
    "block/chiseled_bookshelf/pickup_enchanted3",
    "block/chiseled_bookshelf/step1",
    "block/chiseled_bookshelf/step2",
    "block/chiseled_bookshelf/step3",
    "block/chiseled_bookshelf/step4",
    "block/chiseled_bookshelf/step5",
    "block/chorus_flower/death1",
    "block/chorus_flower/death2",
    "block/chorus_flower/death3",
    "block/chorus_flower/grow1",
    "block/chorus_flower/grow2",
    "block/chorus_flower/grow3",
    "block/chorus_flower/grow4",
    "block/cinnabar/break1",
    "block/cinnabar/break2",
    "block/cinnabar/break3",
    "block/cinnabar/break4",
    "block/cinnabar/break5",
    "block/cinnabar/break6",
    "block/cinnabar/break7",
    "block/cinnabar/hit1",
    "block/cinnabar/hit2",
    "block/cinnabar/hit3",
    "block/cinnabar/hit4",
    "block/cinnabar/hit5",
    "block/cinnabar/hit6",
    "block/cinnabar/hit7",
    "block/cinnabar/place1",
    "block/cinnabar/place2",
    "block/cinnabar/place3",
    "block/cinnabar/place4",
    "block/cinnabar/place5",
    "block/cinnabar/place6",
    "block/cinnabar/place7",
    "block/cinnabar/step1",
    "block/cinnabar/step2",
    "block/cinnabar/step3",
    "block/cinnabar/step4",
    "block/cinnabar/step5",
    "block/cinnabar/step6",
    "block/cinnabar/step7",
    "block/cobweb/break1",
    "block/cobweb/break2",
    "block/cobweb/break3",
    "block/cobweb/break4",
    "block/cobweb/break5",
    "block/cobweb/break6",
    "block/cobweb/step1",
    "block/cobweb/step2",
    "block/cobweb/step3",
    "block/cobweb/step4",
    "block/cobweb/step5",
    "block/cobweb/step6",
    "block/composter/empty1",
    "block/composter/empty2",
    "block/composter/empty3",
    "block/composter/fill1",
    "block/composter/fill2",
    "block/composter/fill3",
    "block/composter/fill4",
    "block/composter/fill_success1",
    "block/composter/fill_success2",
    "block/composter/fill_success3",
    "block/composter/fill_success4",
    "block/composter/ready1",
    "block/composter/ready2",
    "block/composter/ready3",
    "block/composter/ready4",
    "block/conduit/activate",
    "block/conduit/ambient",
    "block/conduit/attack1",
    "block/conduit/attack2",
    "block/conduit/attack3",
    "block/conduit/deactivate",
    "block/conduit/short1",
    "block/conduit/short2",
    "block/conduit/short3",
    "block/conduit/short4",
    "block/conduit/short5",
    "block/conduit/short6",
    "block/conduit/short7",
    "block/conduit/short8",
    "block/conduit/short9",
    "block/copper/break1",
    "block/copper/break2",
    "block/copper/break3",
    "block/copper/break4",
    "block/copper/step1",
    "block/copper/step2",
    "block/copper/step3",
    "block/copper/step4",
    "block/copper/step5",
    "block/copper/step6",
    "block/copper_bulb/break1",
    "block/copper_bulb/break2",
    "block/copper_bulb/break3",
    "block/copper_bulb/break4",
    "block/copper_bulb/place1",
    "block/copper_bulb/place2",
    "block/copper_bulb/place3",
    "block/copper_bulb/place4",
    "block/copper_bulb/step1",
    "block/copper_bulb/step2",
    "block/copper_bulb/step3",
    "block/copper_bulb/step4",
    "block/copper_bulb/step5",
    "block/copper_bulb/step6",
    "block/copper_bulb/toggle",
    "block/copper_chest/copper_chest_close1",
    "block/copper_chest/copper_chest_close2",
    "block/copper_chest/copper_chest_close3",
    "block/copper_chest/copper_chest_open1",
    "block/copper_chest/copper_chest_open2",
    "block/copper_chest/copper_chest_open3",
    "block/copper_chest/copper_chest_oxidized_close1",
    "block/copper_chest/copper_chest_oxidized_close2",
    "block/copper_chest/copper_chest_oxidized_close3",
    "block/copper_chest/copper_chest_oxidized_open1",
    "block/copper_chest/copper_chest_oxidized_open2",
    "block/copper_chest/copper_chest_oxidized_open3",
    "block/copper_chest/copper_chest_weathered_close1",
    "block/copper_chest/copper_chest_weathered_close2",
    "block/copper_chest/copper_chest_weathered_close3",
    "block/copper_chest/copper_chest_weathered_open1",
    "block/copper_chest/copper_chest_weathered_open2",
    "block/copper_chest/copper_chest_weathered_open3",
    "block/copper_door/toggle1",
    "block/copper_door/toggle2",
    "block/copper_door/toggle3",
    "block/copper_grate/break1",
    "block/copper_grate/break2",
    "block/copper_grate/break3",
    "block/copper_grate/break4",
    "block/copper_grate/step1",
    "block/copper_grate/step2",
    "block/copper_grate/step3",
    "block/copper_grate/step4",
    "block/copper_grate/step5",
    "block/copper_grate/step6",
    "block/copper_statue/become_statue1",
    "block/copper_statue/become_statue2",
    "block/copper_statue/become_statue3",
    "block/copper_statue/become_statue4",
    "block/copper_statue/break1",
    "block/copper_statue/break2",
    "block/copper_statue/break3",
    "block/copper_statue/hit1",
    "block/copper_statue/hit2",
    "block/copper_statue/hit3",
    "block/copper_statue/hit4",
    "block/copper_statue/place1",
    "block/copper_statue/place2",
    "block/copper_statue/place3",
    "block/copper_statue/place4",
    "block/copper_trapdoor/toggle1",
    "block/copper_trapdoor/toggle2",
    "block/copper_trapdoor/toggle3",
    "block/copper_trapdoor/toggle4",
    "block/crafter/craft",
    "block/crafter/fail",
    "block/creaking_heart/break/creaking_heart_break",
    "block/creaking_heart/fall/creaking_heart_fall",
    "block/creaking_heart/hit/creaking_heart_hit1",
    "block/creaking_heart/hit/creaking_heart_hit2",
    "block/creaking_heart/hit/creaking_heart_hit3",
    "block/creaking_heart/hit/creaking_heart_hit4",
    "block/creaking_heart/hit/creaking_heart_hit5",
    "block/creaking_heart/hurt/trail1",
    "block/creaking_heart/hurt/trail2",
    "block/creaking_heart/hurt/trail3",
    "block/creaking_heart/hurt/trail4",
    "block/creaking_heart/hurt/trail5",
    "block/creaking_heart/hurt/trail6",
    "block/creaking_heart/hurt/trail7",
    "block/creaking_heart/idle/creaking_heart_idle1",
    "block/creaking_heart/idle/creaking_heart_idle2",
    "block/creaking_heart/idle/creaking_heart_idle3",
    "block/creaking_heart/idle/creaking_heart_idle4",
    "block/creaking_heart/place/creaking_heart_place1",
    "block/creaking_heart/place/creaking_heart_place2",
    "block/creaking_heart/place/creaking_heart_place3",
    "block/creaking_heart/place/creaking_heart_place4",
    "block/creaking_heart/spawnmob/creaking_heart_spawnmob",
    "block/creaking_heart/step/creaking_heart_step1",
    "block/creaking_heart/step/creaking_heart_step2",
    "block/creaking_heart/step/creaking_heart_step3",
    "block/creaking_heart/step/creaking_heart_step4",
    "block/creaking_heart/step/creaking_heart_step5",
    "block/creaking_heart/step/creaking_heart_step6",
    "block/deadbush/sandblock_version/bushrustle1",
    "block/deadbush/sandblock_version/bushrustle2",
    "block/deadbush/sandblock_version/bushrustle3",
    "block/deadbush/sandblock_version/creakysand1",
    "block/deadbush/sandblock_version/crickets",
    "block/deadbush/sandblock_version/howlingwind1",
    "block/deadbush/sandblock_version/insect1",
    "block/deadbush/sandblock_version/leaves",
    "block/deadbush/sandblock_version/movingsand1",
    "block/deadbush/sandblock_version/movingsand2",
    "block/deadbush/sandblock_version/movingsand3",
    "block/decorated_pot/break1",
    "block/decorated_pot/break2",
    "block/decorated_pot/break3",
    "block/decorated_pot/break4",
    "block/decorated_pot/insert1",
    "block/decorated_pot/insert2",
    "block/decorated_pot/insert3",
    "block/decorated_pot/insert4",
    "block/decorated_pot/insert_fail1",
    "block/decorated_pot/insert_fail2",
    "block/decorated_pot/insert_fail3",
    "block/decorated_pot/insert_fail4",
    "block/decorated_pot/insert_fail5",
    "block/decorated_pot/shatter1",
    "block/decorated_pot/shatter2",
    "block/decorated_pot/shatter3",
    "block/decorated_pot/shatter4",
    "block/decorated_pot/shatter5",
    "block/decorated_pot/step1",
    "block/decorated_pot/step2",
    "block/decorated_pot/step3",
    "block/decorated_pot/step4",
    "block/decorated_pot/step5",
    "block/deepslate/break1",
    "block/deepslate/break2",
    "block/deepslate/break3",
    "block/deepslate/break4",
    "block/deepslate/place1",
    "block/deepslate/place2",
    "block/deepslate/place3",
    "block/deepslate/place4",
    "block/deepslate/place5",
    "block/deepslate/place6",
    "block/deepslate/step1",
    "block/deepslate/step2",
    "block/deepslate/step3",
    "block/deepslate/step4",
    "block/deepslate/step5",
    "block/deepslate/step6",
    "block/deepslate_bricks/place1",
    "block/deepslate_bricks/place2",
    "block/deepslate_bricks/place3",
    "block/deepslate_bricks/place4",
    "block/deepslate_bricks/place5",
    "block/deepslate_bricks/place6",
    "block/deepslate_bricks/step1",
    "block/deepslate_bricks/step2",
    "block/deepslate_bricks/step3",
    "block/deepslate_bricks/step4",
    "block/deepslate_bricks/step5",
    "block/dried_ghast/ambient1",
    "block/dried_ghast/ambient2",
    "block/dried_ghast/ambient3",
    "block/dried_ghast/ambient4",
    "block/dried_ghast/ambient_water1",
    "block/dried_ghast/ambient_water2",
    "block/dried_ghast/break",
    "block/dried_ghast/place1",
    "block/dried_ghast/place2",
    "block/dried_ghast/place3",
    "block/dried_ghast/place4",
    "block/dried_ghast/place5",
    "block/dried_ghast/place6",
    "block/dried_ghast/placeinwater",
    "block/dried_ghast/step1",
    "block/dried_ghast/step2",
    "block/dried_ghast/step3",
    "block/dried_ghast/step4",
    "block/dried_ghast/step5",
    "block/dried_ghast/step6",
    "block/dried_ghast/transition",
    "block/dripstone/break1",
    "block/dripstone/break2",
    "block/dripstone/break3",
    "block/dripstone/break4",
    "block/dripstone/break5",
    "block/dripstone/step1",
    "block/dripstone/step2",
    "block/dripstone/step3",
    "block/dripstone/step4",
    "block/dripstone/step5",
    "block/dripstone/step6",
    "block/dry_grass/wind1",
    "block/dry_grass/wind10",
    "block/dry_grass/wind11",
    "block/dry_grass/wind12",
    "block/dry_grass/wind2",
    "block/dry_grass/wind3",
    "block/dry_grass/wind4",
    "block/dry_grass/wind5",
    "block/dry_grass/wind6",
    "block/dry_grass/wind7",
    "block/dry_grass/wind8",
    "block/dry_grass/wind9",
    "block/enchantment_table/enchant1",
    "block/enchantment_table/enchant2",
    "block/enchantment_table/enchant3",
    "block/end_portal/endportal",
    "block/end_portal/eyeplace1",
    "block/end_portal/eyeplace2",
    "block/end_portal/eyeplace3",
    "block/enderchest/close",
    "block/enderchest/open",
    "block/eyeblossom/eyeblossom_close1",
    "block/eyeblossom/eyeblossom_close2",
    "block/eyeblossom/eyeblossom_close3",
    "block/eyeblossom/eyeblossom_close_long",
    "block/eyeblossom/eyeblossom_idle1",
    "block/eyeblossom/eyeblossom_idle2",
    "block/eyeblossom/eyeblossom_idle3",
    "block/eyeblossom/eyeblossom_idle4",
    "block/eyeblossom/eyeblossom_idle5",
    "block/eyeblossom/eyeblossom_idle6",
    "block/eyeblossom/eyeblossom_open1",
    "block/eyeblossom/eyeblossom_open2",
    "block/eyeblossom/eyeblossom_open3",
    "block/eyeblossom/eyeblossom_open4",
    "block/eyeblossom/eyeblossom_open_long",
    "block/fence_gate/close1",
    "block/fence_gate/close2",
    "block/fence_gate/open1",
    "block/fence_gate/open2",
    "block/firefly_bush/firefly_bush1",
    "block/firefly_bush/firefly_bush10",
    "block/firefly_bush/firefly_bush11",
    "block/firefly_bush/firefly_bush2",
    "block/firefly_bush/firefly_bush3",
    "block/firefly_bush/firefly_bush4",
    "block/firefly_bush/firefly_bush5",
    "block/firefly_bush/firefly_bush6",
    "block/firefly_bush/firefly_bush7",
    "block/firefly_bush/firefly_bush8",
    "block/firefly_bush/firefly_bush9",
    "block/fletching_table/fletching_table1",
    "block/fletching_table/fletching_table2",
    "block/froglight/break1",
    "block/froglight/break2",
    "block/froglight/break3",
    "block/froglight/break4",
    "block/froglight/step1",
    "block/froglight/step2",
    "block/froglight/step3",
    "block/froglight/step4",
    "block/froglight/step5",
    "block/froglight/step6",
    "block/frogspawn/break1",
    "block/frogspawn/break2",
    "block/frogspawn/break3",
    "block/frogspawn/break4",
    "block/frogspawn/hatch1",
    "block/frogspawn/hatch2",
    "block/frogspawn/hatch3",
    "block/frogspawn/hatch4",
    "block/frogspawn/hatch5",
    "block/frogspawn/step1",
    "block/frogspawn/step2",
    "block/frogspawn/step3",
    "block/frogspawn/step4",
    "block/frogspawn/step5",
    "block/frogspawn/step6",
    "block/fungus/break1",
    "block/fungus/break2",
    "block/fungus/break3",
    "block/fungus/break4",
    "block/fungus/break5",
    "block/fungus/break6",
    "block/furnace/fire_crackle1",
    "block/furnace/fire_crackle2",
    "block/furnace/fire_crackle3",
    "block/furnace/fire_crackle4",
    "block/furnace/fire_crackle5",
    "block/grindstone/grindstone1",
    "block/grindstone/grindstone2",
    "block/grindstone/grindstone3",
    "block/hanging_roots/break1",
    "block/hanging_roots/break2",
    "block/hanging_roots/break3",
    "block/hanging_roots/break4",
    "block/hanging_roots/step1",
    "block/hanging_roots/step2",
    "block/hanging_roots/step3",
    "block/hanging_roots/step4",
    "block/hanging_roots/step5",
    "block/hanging_roots/step6",
    "block/hanging_sign/break1",
    "block/hanging_sign/break2",
    "block/hanging_sign/break3",
    "block/hanging_sign/break4",
    "block/hanging_sign/step1",
    "block/hanging_sign/step2",
    "block/hanging_sign/step3",
    "block/hanging_sign/step4",
    "block/heavy_core/break1",
    "block/heavy_core/break2",
    "block/heavy_core/break3",
    "block/heavy_core/break4",
    "block/heavy_core/step1",
    "block/heavy_core/step2",
    "block/heavy_core/step3",
    "block/heavy_core/step4",
    "block/honeyblock/break1",
    "block/honeyblock/break2",
    "block/honeyblock/break3",
    "block/honeyblock/break4",
    "block/honeyblock/break5",
    "block/honeyblock/slide1",
    "block/honeyblock/slide2",
    "block/honeyblock/slide3",
    "block/honeyblock/slide4",
    "block/honeyblock/step1",
    "block/honeyblock/step2",
    "block/honeyblock/step3",
    "block/honeyblock/step4",
    "block/honeyblock/step5",
    "block/iron/break1",
    "block/iron/break2",
    "block/iron/break3",
    "block/iron/break4",
    "block/iron/break5",
    "block/iron/break6",
    "block/iron/break7",
    "block/iron/break8",
    "block/iron/step1",
    "block/iron/step2",
    "block/iron/step3",
    "block/iron/step4",
    "block/iron_door/close1",
    "block/iron_door/close2",
    "block/iron_door/close3",
    "block/iron_door/close4",
    "block/iron_door/open1",
    "block/iron_door/open2",
    "block/iron_door/open3",
    "block/iron_door/open4",
    "block/iron_trapdoor/close1",
    "block/iron_trapdoor/close2",
    "block/iron_trapdoor/close3",
    "block/iron_trapdoor/close4",
    "block/iron_trapdoor/open1",
    "block/iron_trapdoor/open2",
    "block/iron_trapdoor/open3",
    "block/iron_trapdoor/open4",
    "block/lantern/break1",
    "block/lantern/break2",
    "block/lantern/break3",
    "block/lantern/break4",
    "block/lantern/break5",
    "block/lantern/break6",
    "block/lantern/place1",
    "block/lantern/place2",
    "block/lantern/place3",
    "block/lantern/place4",
    "block/lantern/place5",
    "block/lantern/place6",
    "block/leaf_litter/break1",
    "block/leaf_litter/break2",
    "block/leaf_litter/break3",
    "block/leaf_litter/break4",
    "block/leaf_litter/break5",
    "block/leaf_litter/place1",
    "block/leaf_litter/place2",
    "block/leaf_litter/place3",
    "block/leaf_litter/place4",
    "block/leaf_litter/place5",
    "block/leaf_litter/step1",
    "block/leaf_litter/step2",
    "block/leaf_litter/step3",
    "block/leaf_litter/step4",
    "block/leaf_litter/step5",
    "block/leaf_litter/step6",
    "block/lodestone/lock1",
    "block/lodestone/lock2",
    "block/lodestone/place1",
    "block/lodestone/place2",
    "block/lodestone/place3",
    "block/lodestone/place4",
    "block/mangrove_roots/break1",
    "block/mangrove_roots/break2",
    "block/mangrove_roots/break3",
    "block/mangrove_roots/break4",
    "block/mangrove_roots/break5",
    "block/mangrove_roots/break6",
    "block/mangrove_roots/step1",
    "block/mangrove_roots/step2",
    "block/mangrove_roots/step3",
    "block/mangrove_roots/step4",
    "block/mangrove_roots/step5",
    "block/mangrove_roots/step6",
    "block/moss/break1",
    "block/moss/break2",
    "block/moss/break3",
    "block/moss/break4",
    "block/moss/break5",
    "block/moss/step1",
    "block/moss/step2",
    "block/moss/step3",
    "block/moss/step4",
    "block/moss/step5",
    "block/moss/step6",
    "block/mud/break1",
    "block/mud/break2",
    "block/mud/break3",
    "block/mud/break4",
    "block/mud/break5",
    "block/mud/break6",
    "block/mud/step1",
    "block/mud/step2",
    "block/mud/step3",
    "block/mud/step4",
    "block/mud/step5",
    "block/mud/step6",
    "block/mud_bricks/break1",
    "block/mud_bricks/break2",
    "block/mud_bricks/break3",
    "block/mud_bricks/break4",
    "block/mud_bricks/break5",
    "block/mud_bricks/break6",
    "block/mud_bricks/step1",
    "block/mud_bricks/step2",
    "block/mud_bricks/step3",
    "block/mud_bricks/step4",
    "block/mud_bricks/step5",
    "block/mud_bricks/step6",
    "block/muddy_mangrove_roots/break1",
    "block/muddy_mangrove_roots/break2",
    "block/muddy_mangrove_roots/break3",
    "block/muddy_mangrove_roots/break4",
    "block/muddy_mangrove_roots/break5",
    "block/muddy_mangrove_roots/break6",
    "block/muddy_mangrove_roots/step1",
    "block/muddy_mangrove_roots/step2",
    "block/muddy_mangrove_roots/step3",
    "block/muddy_mangrove_roots/step4",
    "block/muddy_mangrove_roots/step5",
    "block/muddy_mangrove_roots/step6",
    "block/nether_bricks/break1",
    "block/nether_bricks/break2",
    "block/nether_bricks/break3",
    "block/nether_bricks/break4",
    "block/nether_bricks/break5",
    "block/nether_bricks/break6",
    "block/nether_bricks/step1",
    "block/nether_bricks/step2",
    "block/nether_bricks/step3",
    "block/nether_bricks/step4",
    "block/nether_bricks/step5",
    "block/nether_bricks/step6",
    "block/nether_ore/break1",
    "block/nether_ore/break2",
    "block/nether_ore/break3",
    "block/nether_ore/break4",
    "block/nether_ore/step1",
    "block/nether_ore/step2",
    "block/nether_ore/step3",
    "block/nether_ore/step4",
    "block/nether_ore/step5",
    "block/nether_sprouts/break1",
    "block/nether_sprouts/break2",
    "block/nether_sprouts/break3",
    "block/nether_sprouts/break4",
    "block/nether_sprouts/step1",
    "block/nether_sprouts/step2",
    "block/nether_sprouts/step3",
    "block/nether_sprouts/step4",
    "block/nether_sprouts/step5",
    "block/nether_wood/break1",
    "block/nether_wood/break2",
    "block/nether_wood/break3",
    "block/nether_wood/break4",
    "block/nether_wood/step1",
    "block/nether_wood/step2",
    "block/nether_wood/step3",
    "block/nether_wood/step4",
    "block/nether_wood/step5",
    "block/nether_wood_button/nether_wood_button",
    "block/nether_wood_door/toggle1",
    "block/nether_wood_door/toggle2",
    "block/nether_wood_door/toggle3",
    "block/nether_wood_door/toggle4",
    "block/nether_wood_fence/toggle1",
    "block/nether_wood_fence/toggle2",
    "block/nether_wood_fence/toggle3",
    "block/nether_wood_fence/toggle4",
    "block/nether_wood_hanging_sign/break1",
    "block/nether_wood_hanging_sign/break2",
    "block/nether_wood_hanging_sign/break3",
    "block/nether_wood_hanging_sign/break4",
    "block/nether_wood_hanging_sign/step1",
    "block/nether_wood_hanging_sign/step2",
    "block/nether_wood_hanging_sign/step3",
    "block/nether_wood_hanging_sign/step4",
    "block/nether_wood_trapdoor/toggle1",
    "block/nether_wood_trapdoor/toggle2",
    "block/nether_wood_trapdoor/toggle3",
    "block/nether_wood_trapdoor/toggle4",
    "block/netherite/break1",
    "block/netherite/break2",
    "block/netherite/break3",
    "block/netherite/break4",
    "block/netherite/step1",
    "block/netherite/step2",
    "block/netherite/step3",
    "block/netherite/step4",
    "block/netherite/step5",
    "block/netherite/step6",
    "block/netherrack/break1",
    "block/netherrack/break2",
    "block/netherrack/break3",
    "block/netherrack/break4",
    "block/netherrack/break5",
    "block/netherrack/break6",
    "block/netherrack/step1",
    "block/netherrack/step2",
    "block/netherrack/step3",
    "block/netherrack/step4",
    "block/netherrack/step5",
    "block/netherrack/step6",
    "block/netherwart/break1",
    "block/netherwart/break2",
    "block/netherwart/break3",
    "block/netherwart/break4",
    "block/netherwart/break5",
    "block/netherwart/break6",
    "block/netherwart/step1",
    "block/netherwart/step2",
    "block/netherwart/step3",
    "block/netherwart/step4",
    "block/netherwart/step5",
    "block/nylium/break1",
    "block/nylium/break2",
    "block/nylium/break3",
    "block/nylium/break4",
    "block/nylium/break5",
    "block/nylium/break6",
    "block/nylium/step1",
    "block/nylium/step2",
    "block/nylium/step3",
    "block/nylium/step4",
    "block/nylium/step5",
    "block/nylium/step6",
    "block/packed_mud/break1",
    "block/packed_mud/break2",
    "block/packed_mud/break3",
    "block/packed_mud/break4",
    "block/packed_mud/break5",
    "block/packed_mud/break6",
    "block/packed_mud/step1",
    "block/packed_mud/step2",
    "block/packed_mud/step3",
    "block/packed_mud/step4",
    "block/packed_mud/step5",
    "block/packed_mud/step6",
    "block/pale_hanging_moss/pale_hanging_moss1",
    "block/pale_hanging_moss/pale_hanging_moss10",
    "block/pale_hanging_moss/pale_hanging_moss11",
    "block/pale_hanging_moss/pale_hanging_moss12",
    "block/pale_hanging_moss/pale_hanging_moss13",
    "block/pale_hanging_moss/pale_hanging_moss14",
    "block/pale_hanging_moss/pale_hanging_moss15",
    "block/pale_hanging_moss/pale_hanging_moss2",
    "block/pale_hanging_moss/pale_hanging_moss3",
    "block/pale_hanging_moss/pale_hanging_moss4",
    "block/pale_hanging_moss/pale_hanging_moss5",
    "block/pale_hanging_moss/pale_hanging_moss6",
    "block/pale_hanging_moss/pale_hanging_moss7",
    "block/pale_hanging_moss/pale_hanging_moss8",
    "block/pale_hanging_moss/pale_hanging_moss9",
    "block/pointed_dripstone/drip_lava1",
    "block/pointed_dripstone/drip_lava2",
    "block/pointed_dripstone/drip_lava3",
    "block/pointed_dripstone/drip_lava4",
    "block/pointed_dripstone/drip_lava5",
    "block/pointed_dripstone/drip_lava6",
    "block/pointed_dripstone/drip_lava_cauldron1",
    "block/pointed_dripstone/drip_lava_cauldron2",
    "block/pointed_dripstone/drip_lava_cauldron3",
    "block/pointed_dripstone/drip_lava_cauldron4",
    "block/pointed_dripstone/drip_water1",
    "block/pointed_dripstone/drip_water10",
    "block/pointed_dripstone/drip_water11",
    "block/pointed_dripstone/drip_water12",
    "block/pointed_dripstone/drip_water13",
    "block/pointed_dripstone/drip_water14",
    "block/pointed_dripstone/drip_water15",
    "block/pointed_dripstone/drip_water2",
    "block/pointed_dripstone/drip_water3",
    "block/pointed_dripstone/drip_water4",
    "block/pointed_dripstone/drip_water5",
    "block/pointed_dripstone/drip_water6",
    "block/pointed_dripstone/drip_water7",
    "block/pointed_dripstone/drip_water8",
    "block/pointed_dripstone/drip_water9",
    "block/pointed_dripstone/drip_water_cauldron1",
    "block/pointed_dripstone/drip_water_cauldron2",
    "block/pointed_dripstone/drip_water_cauldron3",
    "block/pointed_dripstone/drip_water_cauldron4",
    "block/pointed_dripstone/drip_water_cauldron5",
    "block/pointed_dripstone/drip_water_cauldron6",
    "block/pointed_dripstone/drip_water_cauldron7",
    "block/pointed_dripstone/drip_water_cauldron8",
    "block/pointed_dripstone/land1",
    "block/pointed_dripstone/land2",
    "block/pointed_dripstone/land3",
    "block/pointed_dripstone/land4",
    "block/pointed_dripstone/land5",
    "block/poplar_leaves/ambient1",
    "block/poplar_leaves/ambient10",
    "block/poplar_leaves/ambient11",
    "block/poplar_leaves/ambient12",
    "block/poplar_leaves/ambient13",
    "block/poplar_leaves/ambient14",
    "block/poplar_leaves/ambient15",
    "block/poplar_leaves/ambient16",
    "block/poplar_leaves/ambient17",
    "block/poplar_leaves/ambient18",
    "block/poplar_leaves/ambient19",
    "block/poplar_leaves/ambient2",
    "block/poplar_leaves/ambient20",
    "block/poplar_leaves/ambient21",
    "block/poplar_leaves/ambient22",
    "block/poplar_leaves/ambient23",
    "block/poplar_leaves/ambient24",
    "block/poplar_leaves/ambient3",
    "block/poplar_leaves/ambient4",
    "block/poplar_leaves/ambient5",
    "block/poplar_leaves/ambient6",
    "block/poplar_leaves/ambient7",
    "block/poplar_leaves/ambient8",
    "block/poplar_leaves/ambient9",
    "block/poplar_leaves/wind1",
    "block/poplar_leaves/wind2",
    "block/poplar_leaves/wind3",
    "block/potent_sulfur/break1",
    "block/potent_sulfur/break2",
    "block/potent_sulfur/break3",
    "block/potent_sulfur/break4",
    "block/potent_sulfur/break5",
    "block/potent_sulfur/break6",
    "block/potent_sulfur/break7",
    "block/potent_sulfur/geyser_continuous/eruption1",
    "block/potent_sulfur/geyser_continuous/eruption2",
    "block/potent_sulfur/geyser_continuous/eruption3",
    "block/potent_sulfur/geyser_continuous/eruption4",
    "block/potent_sulfur/geyser_continuous/eruption5",
    "block/potent_sulfur/geyser_continuous/eruption6",
    "block/potent_sulfur/geyser_continuous/eruption_active1",
    "block/potent_sulfur/geyser_continuous/eruption_active2",
    "block/potent_sulfur/geyser_continuous/eruption_active3",
    "block/potent_sulfur/geyser_continuous/eruption_active4",
    "block/potent_sulfur/geyser_continuous/eruption_active5",
    "block/potent_sulfur/geyser_continuous/eruption_active6",
    "block/potent_sulfur/geyser_continuous/eruption_active7",
    "block/potent_sulfur/hit1",
    "block/potent_sulfur/hit2",
    "block/potent_sulfur/hit3",
    "block/potent_sulfur/hit4",
    "block/potent_sulfur/hit5",
    "block/potent_sulfur/hit6",
    "block/potent_sulfur/hit7",
    "block/potent_sulfur/noxious_gas/ambient1",
    "block/potent_sulfur/noxious_gas/ambient10",
    "block/potent_sulfur/noxious_gas/ambient11",
    "block/potent_sulfur/noxious_gas/ambient12",
    "block/potent_sulfur/noxious_gas/ambient13",
    "block/potent_sulfur/noxious_gas/ambient14",
    "block/potent_sulfur/noxious_gas/ambient2",
    "block/potent_sulfur/noxious_gas/ambient3",
    "block/potent_sulfur/noxious_gas/ambient4",
    "block/potent_sulfur/noxious_gas/ambient5",
    "block/potent_sulfur/noxious_gas/ambient6",
    "block/potent_sulfur/noxious_gas/ambient7",
    "block/potent_sulfur/noxious_gas/ambient8",
    "block/potent_sulfur/noxious_gas/ambient9",
    "block/potent_sulfur/place1",
    "block/potent_sulfur/place2",
    "block/potent_sulfur/place3",
    "block/potent_sulfur/place4",
    "block/potent_sulfur/place5",
    "block/potent_sulfur/place6",
    "block/potent_sulfur/place7",
    "block/potent_sulfur/place8",
    "block/potent_sulfur/step1",
    "block/potent_sulfur/step2",
    "block/potent_sulfur/step3",
    "block/potent_sulfur/step4",
    "block/potent_sulfur/step5",
    "block/potent_sulfur/step6",
    "block/potent_sulfur/step7",
    "block/potent_sulfur/sulfur_spring/eruption1",
    "block/potent_sulfur/sulfur_spring/eruption2",
    "block/potent_sulfur/sulfur_spring/eruption3",
    "block/potent_sulfur/sulfur_spring/eruption4",
    "block/potent_sulfur/sulfur_spring/eruption5",
    "block/potent_sulfur/sulfur_spring/eruption6",
    "block/potent_sulfur/sulfur_spring/eruption7",
    "block/potent_sulfur/sulfur_spring/eruption8",
    "block/potent_sulfur/sulfur_spring/eruption_active1",
    "block/potent_sulfur/sulfur_spring/eruption_active2",
    "block/potent_sulfur/sulfur_spring/eruption_active3",
    "block/potent_sulfur/sulfur_spring/eruption_active4",
    "block/potent_sulfur/sulfur_spring/eruption_active5",
    "block/potent_sulfur/sulfur_spring/eruption_active6",
    "block/potent_sulfur/sulfur_spring/eruption_active7",
    "block/potent_sulfur/sulfur_spring/eruption_active8",
    "block/powder_snow/break1",
    "block/powder_snow/break2",
    "block/powder_snow/break3",
    "block/powder_snow/break4",
    "block/powder_snow/break5",
    "block/powder_snow/break6",
    "block/powder_snow/break7",
    "block/powder_snow/step1",
    "block/powder_snow/step10",
    "block/powder_snow/step2",
    "block/powder_snow/step3",
    "block/powder_snow/step4",
    "block/powder_snow/step5",
    "block/powder_snow/step6",
    "block/powder_snow/step7",
    "block/powder_snow/step8",
    "block/powder_snow/step9",
    "block/pumpkin/carve1",
    "block/pumpkin/carve2",
    "block/red_shrub/break1",
    "block/red_shrub/break2",
    "block/red_shrub/break3",
    "block/red_shrub/break4",
    "block/red_shrub/place1",
    "block/red_shrub/place2",
    "block/red_shrub/place3",
    "block/red_shrub/place4",
    "block/resin/resin_break1",
    "block/resin/resin_break2",
    "block/resin/resin_break3",
    "block/resin/resin_break4",
    "block/resin/resin_break5",
    "block/resin/resin_fall",
    "block/resin/resin_place1",
    "block/resin/resin_place2",
    "block/resin/resin_place3",
    "block/resin/resin_place4",
    "block/resin/resin_step1",
    "block/resin/resin_step2",
    "block/resin/resin_step3",
    "block/resin/resin_step4",
    "block/resin/resin_step5",
    "block/resin_bricks/resin_brick_break",
    "block/resin_bricks/resin_brick_fall",
    "block/resin_bricks/resin_brick_hit1",
    "block/resin_bricks/resin_brick_hit2",
    "block/resin_bricks/resin_brick_hit3",
    "block/resin_bricks/resin_brick_hit4",
    "block/resin_bricks/resin_brick_hit5",
    "block/resin_bricks/resin_brick_place1",
    "block/resin_bricks/resin_brick_place2",
    "block/resin_bricks/resin_brick_place3",
    "block/resin_bricks/resin_brick_place4",
    "block/resin_bricks/resin_brick_place5",
    "block/resin_bricks/resin_brick_step1",
    "block/resin_bricks/resin_brick_step2",
    "block/resin_bricks/resin_brick_step3",
    "block/resin_bricks/resin_brick_step4",
    "block/resin_bricks/resin_brick_step5",
    "block/respawn_anchor/ambient1",
    "block/respawn_anchor/ambient2",
    "block/respawn_anchor/ambient3",
    "block/respawn_anchor/charge1",
    "block/respawn_anchor/charge2",
    "block/respawn_anchor/charge3",
    "block/respawn_anchor/deplete1",
    "block/respawn_anchor/deplete2",
    "block/respawn_anchor/set_spawn1",
    "block/respawn_anchor/set_spawn2",
    "block/respawn_anchor/set_spawn3",
    "block/rooted_dirt/break1",
    "block/rooted_dirt/break2",
    "block/rooted_dirt/break3",
    "block/rooted_dirt/break4",
    "block/rooted_dirt/step1",
    "block/rooted_dirt/step2",
    "block/rooted_dirt/step3",
    "block/rooted_dirt/step4",
    "block/rooted_dirt/step5",
    "block/rooted_dirt/step6",
    "block/roots/break1",
    "block/roots/break2",
    "block/roots/break3",
    "block/roots/break4",
    "block/roots/break5",
    "block/roots/break6",
    "block/roots/step1",
    "block/roots/step2",
    "block/roots/step3",
    "block/roots/step4",
    "block/roots/step5",
    "block/sand/sand1",
    "block/sand/sand10",
    "block/sand/sand11",
    "block/sand/sand12",
    "block/sand/sand13",
    "block/sand/sand14",
    "block/sand/sand15",
    "block/sand/sand16",
    "block/sand/sand17",
    "block/sand/sand18",
    "block/sand/sand19",
    "block/sand/sand2",
    "block/sand/sand20",
    "block/sand/sand21",
    "block/sand/sand3",
    "block/sand/sand4",
    "block/sand/sand5",
    "block/sand/sand6",
    "block/sand/sand7",
    "block/sand/sand8",
    "block/sand/sand9",
    "block/scaffold/place1",
    "block/scaffold/place2",
    "block/scaffold/place3",
    "block/scaffold/place4",
    "block/sculk/break1",
    "block/sculk/break10",
    "block/sculk/break11",
    "block/sculk/break12",
    "block/sculk/break13",
    "block/sculk/break14",
    "block/sculk/break2",
    "block/sculk/break3",
    "block/sculk/break4",
    "block/sculk/break5",
    "block/sculk/break6",
    "block/sculk/break7",
    "block/sculk/break8",
    "block/sculk/break9",
    "block/sculk/charge1",
    "block/sculk/charge2",
    "block/sculk/charge3",
    "block/sculk/charge4",
    "block/sculk/charge5",
    "block/sculk/place1",
    "block/sculk/place2",
    "block/sculk/place3",
    "block/sculk/place4",
    "block/sculk/place5",
    "block/sculk/spread1",
    "block/sculk/spread2",
    "block/sculk/spread3",
    "block/sculk/spread4",
    "block/sculk/spread5",
    "block/sculk/step1",
    "block/sculk/step2",
    "block/sculk/step3",
    "block/sculk/step4",
    "block/sculk/step5",
    "block/sculk/step6",
    "block/sculk_catalyst/break1",
    "block/sculk_catalyst/break10",
    "block/sculk_catalyst/break2",
    "block/sculk_catalyst/break3",
    "block/sculk_catalyst/break4",
    "block/sculk_catalyst/break5",
    "block/sculk_catalyst/break6",
    "block/sculk_catalyst/break7",
    "block/sculk_catalyst/break8",
    "block/sculk_catalyst/break9",
    "block/sculk_catalyst/place1",
    "block/sculk_catalyst/place2",
    "block/sculk_catalyst/place3",
    "block/sculk_catalyst/place4",
    "block/sculk_catalyst/place5",
    "block/sculk_catalyst/step1",
    "block/sculk_catalyst/step2",
    "block/sculk_catalyst/step3",
    "block/sculk_catalyst/step4",
    "block/sculk_catalyst/step5",
    "block/sculk_catalyst/step6",
    "block/sculk_sensor/break1",
    "block/sculk_sensor/break2",
    "block/sculk_sensor/break3",
    "block/sculk_sensor/break4",
    "block/sculk_sensor/break5",
    "block/sculk_sensor/place1",
    "block/sculk_sensor/place2",
    "block/sculk_sensor/place3",
    "block/sculk_sensor/place4",
    "block/sculk_sensor/place5",
    "block/sculk_sensor/sculk_clicking1",
    "block/sculk_sensor/sculk_clicking2",
    "block/sculk_sensor/sculk_clicking3",
    "block/sculk_sensor/sculk_clicking4",
    "block/sculk_sensor/sculk_clicking5",
    "block/sculk_sensor/sculk_clicking6",
    "block/sculk_sensor/sculk_clicking_stop1",
    "block/sculk_sensor/sculk_clicking_stop2",
    "block/sculk_sensor/sculk_clicking_stop3",
    "block/sculk_sensor/sculk_clicking_stop4",
    "block/sculk_sensor/sculk_clicking_stop5",
    "block/sculk_shrieker/break1",
    "block/sculk_shrieker/break2",
    "block/sculk_shrieker/break3",
    "block/sculk_shrieker/break4",
    "block/sculk_shrieker/break5",
    "block/sculk_shrieker/break6",
    "block/sculk_shrieker/place1",
    "block/sculk_shrieker/place2",
    "block/sculk_shrieker/place3",
    "block/sculk_shrieker/place4",
    "block/sculk_shrieker/place5",
    "block/sculk_shrieker/shriek1",
    "block/sculk_shrieker/shriek2",
    "block/sculk_shrieker/shriek3",
    "block/sculk_shrieker/shriek4",
    "block/sculk_shrieker/shriek5",
    "block/sculk_vein/break1",
    "block/sculk_vein/break2",
    "block/sculk_vein/break3",
    "block/sculk_vein/break4",
    "block/sculk_vein/break5",
    "block/shelf/activate1",
    "block/shelf/activate2",
    "block/shelf/activate3",
    "block/shelf/deactivate1",
    "block/shelf/deactivate2",
    "block/shelf/deactivate3",
    "block/shelf/multi_swap1",
    "block/shelf/multi_swap2",
    "block/shelf/multi_swap3",
    "block/shelf/place_item1",
    "block/shelf/place_item2",
    "block/shelf/place_item3",
    "block/shelf/place_item4",
    "block/shelf/single_swap1",
    "block/shelf/single_swap2",
    "block/shelf/single_swap3",
    "block/shelf/single_swap4",
    "block/shelf_mushroom/bounce1",
    "block/shelf_mushroom/bounce2",
    "block/shelf_mushroom/bounce3",
    "block/shelf_mushroom/bounce4",
    "block/shelf_mushroom/bounce5",
    "block/shelf_mushroom/break1",
    "block/shelf_mushroom/break2",
    "block/shelf_mushroom/break3",
    "block/shelf_mushroom/break4",
    "block/shelf_mushroom/break5",
    "block/shelf_mushroom/break6",
    "block/shelf_mushroom/place1",
    "block/shelf_mushroom/place2",
    "block/shelf_mushroom/place3",
    "block/shelf_mushroom/place4",
    "block/shelf_mushroom/place5",
    "block/shelf_mushroom/place6",
    "block/shelf_mushroom/step1",
    "block/shelf_mushroom/step2",
    "block/shelf_mushroom/step3",
    "block/shelf_mushroom/step4",
    "block/shelf_mushroom/step5",
    "block/shelf_mushroom/step6",
    "block/shroomlight/break1",
    "block/shroomlight/break2",
    "block/shroomlight/break3",
    "block/shroomlight/break4",
    "block/shroomlight/break5",
    "block/shroomlight/step1",
    "block/shroomlight/step2",
    "block/shroomlight/step3",
    "block/shroomlight/step4",
    "block/shroomlight/step5",
    "block/shroomlight/step6",
    "block/shulker_box/close",
    "block/shulker_box/open",
    "block/sign/waxed_interact_fail1",
    "block/sign/waxed_interact_fail2",
    "block/sign/waxed_interact_fail3",
    "block/smithing_table/smithing_table1",
    "block/smithing_table/smithing_table2",
    "block/smithing_table/smithing_table3",
    "block/smoker/smoker1",
    "block/smoker/smoker2",
    "block/smoker/smoker3",
    "block/smoker/smoker4",
    "block/smoker/smoker5",
    "block/soul_sand/break1",
    "block/soul_sand/break2",
    "block/soul_sand/break3",
    "block/soul_sand/break4",
    "block/soul_sand/break5",
    "block/soul_sand/break6",
    "block/soul_sand/break7",
    "block/soul_sand/break8",
    "block/soul_sand/break9",
    "block/soul_sand/step1",
    "block/soul_sand/step2",
    "block/soul_sand/step3",
    "block/soul_sand/step4",
    "block/soul_sand/step5",
    "block/soul_soil/break1",
    "block/soul_soil/break2",
    "block/soul_soil/break3",
    "block/soul_soil/break4",
    "block/soul_soil/break5",
    "block/soul_soil/break6",
    "block/soul_soil/step1",
    "block/soul_soil/step2",
    "block/soul_soil/step3",
    "block/soul_soil/step4",
    "block/soul_soil/step5",
    "block/spawner/break1",
    "block/spawner/break2",
    "block/spawner/break3",
    "block/spawner/break4",
    "block/spawner/step1",
    "block/spawner/step2",
    "block/spawner/step3",
    "block/spawner/step4",
    "block/spawner/step5",
    "block/sponge/absorb1",
    "block/sponge/absorb2",
    "block/sponge/absorb3",
    "block/sponge/break1",
    "block/sponge/break2",
    "block/sponge/break3",
    "block/sponge/break4",
    "block/sponge/step1",
    "block/sponge/step2",
    "block/sponge/step3",
    "block/sponge/step4",
    "block/sponge/step5",
    "block/sponge/step6",
    "block/sponge/wet_sponge/break1",
    "block/sponge/wet_sponge/break2",
    "block/sponge/wet_sponge/break3",
    "block/sponge/wet_sponge/break4",
    "block/sponge/wet_sponge/step1",
    "block/sponge/wet_sponge/step2",
    "block/sponge/wet_sponge/step3",
    "block/sponge/wet_sponge/step4",
    "block/spore_blossom/break1",
    "block/spore_blossom/break2",
    "block/spore_blossom/break3",
    "block/spore_blossom/break4",
    "block/spore_blossom/break5",
    "block/spore_blossom/step1",
    "block/spore_blossom/step2",
    "block/spore_blossom/step3",
    "block/spore_blossom/step4",
    "block/spore_blossom/step5",
    "block/spore_blossom/step6",
    "block/stem/break1",
    "block/stem/break2",
    "block/stem/break3",
    "block/stem/break4",
    "block/stem/break5",
    "block/stem/break6",
    "block/stem/step1",
    "block/stem/step2",
    "block/stem/step3",
    "block/stem/step4",
    "block/stem/step5",
    "block/stem/step6",
    "block/straw_bed/break1",
    "block/straw_bed/break2",
    "block/straw_bed/break3",
    "block/straw_bed/break4",
    "block/straw_bed/break_leave",
    "block/straw_bed/hit1",
    "block/straw_bed/hit2",
    "block/straw_bed/hit3",
    "block/straw_bed/hit4",
    "block/straw_bed/hit5",
    "block/straw_bed/hit6",
    "block/straw_bed/place1",
    "block/straw_bed/place2",
    "block/straw_bed/place3",
    "block/straw_bed/place4",
    "block/straw_bed/step1",
    "block/straw_bed/step2",
    "block/straw_bed/step3",
    "block/straw_bed/step4",
    "block/straw_bed/step5",
    "block/straw_bed/step6",
    "block/sulfur/break1",
    "block/sulfur/break2",
    "block/sulfur/break3",
    "block/sulfur/break4",
    "block/sulfur/break5",
    "block/sulfur/break6",
    "block/sulfur/break7",
    "block/sulfur/hit1",
    "block/sulfur/hit2",
    "block/sulfur/hit3",
    "block/sulfur/hit4",
    "block/sulfur/hit5",
    "block/sulfur/hit6",
    "block/sulfur/hit7",
    "block/sulfur/place1",
    "block/sulfur/place2",
    "block/sulfur/place3",
    "block/sulfur/place4",
    "block/sulfur/place5",
    "block/sulfur/place6",
    "block/sulfur/place7",
    "block/sulfur/place8",
    "block/sulfur/step1",
    "block/sulfur/step2",
    "block/sulfur/step3",
    "block/sulfur/step4",
    "block/sulfur/step5",
    "block/sulfur/step6",
    "block/sulfur/step7",
    "block/sulfur_spike/land1",
    "block/sulfur_spike/land2",
    "block/sulfur_spike/land3",
    "block/sulfur_spike/land4",
    "block/sulfur_spike/land5",
    "block/sulfur_spike/land6",
    "block/sulfur_spike/land7",
    "block/suspicious_gravel/break1",
    "block/suspicious_gravel/break2",
    "block/suspicious_gravel/break3",
    "block/suspicious_gravel/break4",
    "block/suspicious_gravel/break5",
    "block/suspicious_gravel/break6",
    "block/suspicious_gravel/place1",
    "block/suspicious_gravel/place2",
    "block/suspicious_gravel/place3",
    "block/suspicious_gravel/place4",
    "block/suspicious_gravel/step1",
    "block/suspicious_gravel/step2",
    "block/suspicious_gravel/step3",
    "block/suspicious_gravel/step4",
    "block/suspicious_sand/break1",
    "block/suspicious_sand/break2",
    "block/suspicious_sand/break3",
    "block/suspicious_sand/break4",
    "block/suspicious_sand/break5",
    "block/suspicious_sand/break6",
    "block/suspicious_sand/place1",
    "block/suspicious_sand/place2",
    "block/suspicious_sand/place3",
    "block/suspicious_sand/place4",
    "block/suspicious_sand/place5",
    "block/suspicious_sand/step1",
    "block/suspicious_sand/step2",
    "block/suspicious_sand/step3",
    "block/suspicious_sand/step4",
    "block/suspicious_sand/step5",
    "block/sweet_berry_bush/break1",
    "block/sweet_berry_bush/break2",
    "block/sweet_berry_bush/break3",
    "block/sweet_berry_bush/break4",
    "block/sweet_berry_bush/place1",
    "block/sweet_berry_bush/place2",
    "block/sweet_berry_bush/place3",
    "block/sweet_berry_bush/place4",
    "block/sweet_berry_bush/place5",
    "block/sweet_berry_bush/place6",
    "block/trial_spawner/about_to_spawn_item",
    "block/trial_spawner/ambient1",
    "block/trial_spawner/ambient2",
    "block/trial_spawner/ambient3",
    "block/trial_spawner/ambient4",
    "block/trial_spawner/ambient5",
    "block/trial_spawner/ambient_ominous1",
    "block/trial_spawner/ambient_ominous2",
    "block/trial_spawner/ambient_ominous3",
    "block/trial_spawner/ambient_ominous4",
    "block/trial_spawner/ambient_ominous5",
    "block/trial_spawner/break1",
    "block/trial_spawner/break2",
    "block/trial_spawner/break3",
    "block/trial_spawner/close_shutter",
    "block/trial_spawner/detect_player1",
    "block/trial_spawner/detect_player2",
    "block/trial_spawner/detect_player3",
    "block/trial_spawner/eject_item1",
    "block/trial_spawner/ominous_activate",
    "block/trial_spawner/open_shutter",
    "block/trial_spawner/place1",
    "block/trial_spawner/place2",
    "block/trial_spawner/place3",
    "block/trial_spawner/spawn1",
    "block/trial_spawner/spawn2",
    "block/trial_spawner/spawn3",
    "block/trial_spawner/spawn4",
    "block/trial_spawner/spawn_item1",
    "block/trial_spawner/spawn_item2",
    "block/trial_spawner/spawn_item3",
    "block/trial_spawner/spawn_item_begin1",
    "block/trial_spawner/spawn_item_begin2",
    "block/trial_spawner/spawn_item_begin3",
    "block/trial_spawner/step1",
    "block/trial_spawner/step2",
    "block/trial_spawner/step3",
    "block/trial_spawner/step4",
    "block/trial_spawner/step5",
    "block/tuff/break1",
    "block/tuff/break2",
    "block/tuff/break3",
    "block/tuff/break4",
    "block/tuff/break5",
    "block/tuff/step1",
    "block/tuff/step2",
    "block/tuff/step3",
    "block/tuff/step4",
    "block/tuff/step5",
    "block/tuff/step6",
    "block/tuff_bricks/place1",
    "block/tuff_bricks/place2",
    "block/tuff_bricks/place3",
    "block/tuff_bricks/place4",
    "block/tuff_bricks/place5",
    "block/tuff_bricks/step1",
    "block/tuff_bricks/step2",
    "block/tuff_bricks/step3",
    "block/tuff_bricks/step4",
    "block/tuff_bricks/step5",
    "block/tuff_bricks/step6",
    "block/vault/activate",
    "block/vault/ambient1",
    "block/vault/ambient2",
    "block/vault/ambient3",
    "block/vault/break1",
    "block/vault/break2",
    "block/vault/break3",
    "block/vault/break4",
    "block/vault/deactivate",
    "block/vault/eject1",
    "block/vault/eject2",
    "block/vault/eject3",
    "block/vault/insert",
    "block/vault/insert_fail",
    "block/vault/open_shutter",
    "block/vault/place1",
    "block/vault/place2",
    "block/vault/place3",
    "block/vault/place4",
    "block/vault/reject_rewarded_player",
    "block/vault/step1",
    "block/vault/step2",
    "block/vault/step3",
    "block/vault/step4",
    "block/vault/step5",
    "block/vault/step6",
    "block/vault/step7",
    "block/vault/step8",
    "block/vine/break1",
    "block/vine/break2",
    "block/vine/break3",
    "block/vine/break4",
    "block/vine/climb1",
    "block/vine/climb2",
    "block/vine/climb3",
    "block/vine/climb4",
    "block/vine/climb5",
    "block/waterlily/place1",
    "block/waterlily/place2",
    "block/waterlily/place3",
    "block/waterlily/place4",
    "block/wooden_door/close1",
    "block/wooden_door/close2",
    "block/wooden_door/close3",
    "block/wooden_door/open1",
    "block/wooden_door/open2",
    "block/wooden_trapdoor/close1",
    "block/wooden_trapdoor/close2",
    "block/wooden_trapdoor/close3",
    "block/wooden_trapdoor/open1",
    "block/wooden_trapdoor/open2",
    "block/wooden_trapdoor/open3",
    "block/wooden_trapdoor/open4",
    "block/wooden_trapdoor/open5",
    "damage/fallbig",
    "damage/fallsmall",
    "damage/hit1",
    "damage/hit2",
    "damage/hit3",
    "dig/cloth1",
    "dig/cloth2",
    "dig/cloth3",
    "dig/cloth4",
    "dig/coral1",
    "dig/coral2",
    "dig/coral3",
    "dig/coral4",
    "dig/grass1",
    "dig/grass2",
    "dig/grass3",
    "dig/grass4",
    "dig/gravel1",
    "dig/gravel2",
    "dig/gravel3",
    "dig/gravel4",
    "dig/sand1",
    "dig/sand2",
    "dig/sand3",
    "dig/sand4",
    "dig/snow1",
    "dig/snow2",
    "dig/snow3",
    "dig/snow4",
    "dig/stone1",
    "dig/stone2",
    "dig/stone3",
    "dig/stone4",
    "dig/wet_grass1",
    "dig/wet_grass2",
    "dig/wet_grass3",
    "dig/wet_grass4",
    "dig/wood1",
    "dig/wood2",
    "dig/wood3",
    "dig/wood4",
    "enchant/soulspeed/soulspeed1",
    "enchant/soulspeed/soulspeed10",
    "enchant/soulspeed/soulspeed11",
    "enchant/soulspeed/soulspeed12",
    "enchant/soulspeed/soulspeed13",
    "enchant/soulspeed/soulspeed2",
    "enchant/soulspeed/soulspeed3",
    "enchant/soulspeed/soulspeed4",
    "enchant/soulspeed/soulspeed5",
    "enchant/soulspeed/soulspeed6",
    "enchant/soulspeed/soulspeed7",
    "enchant/soulspeed/soulspeed8",
    "enchant/soulspeed/soulspeed9",
    "enchant/thorns/hit1",
    "enchant/thorns/hit2",
    "enchant/thorns/hit3",
    "enchant/thorns/hit4",
    "entity/armorstand/break1",
    "entity/armorstand/break2",
    "entity/armorstand/break3",
    "entity/armorstand/break4",
    "entity/armorstand/hit1",
    "entity/armorstand/hit2",
    "entity/armorstand/hit3",
    "entity/armorstand/hit4",
    "entity/boat/paddle_land1",
    "entity/boat/paddle_land2",
    "entity/boat/paddle_land3",
    "entity/boat/paddle_land4",
    "entity/boat/paddle_land5",
    "entity/boat/paddle_land6",
    "entity/boat/paddle_water1",
    "entity/boat/paddle_water2",
    "entity/boat/paddle_water3",
    "entity/boat/paddle_water4",
    "entity/boat/paddle_water5",
    "entity/boat/paddle_water6",
    "entity/boat/paddle_water7",
    "entity/boat/paddle_water8",
    "entity/bobber/castfast",
    "entity/bobber/retrieve1",
    "entity/bobber/retrieve2",
    "entity/bobber/retrieve3",
    "entity/cow/milk1",
    "entity/cow/milk2",
    "entity/cow/milk3",
    "entity/cushion/break1",
    "entity/cushion/break2",
    "entity/cushion/break3",
    "entity/cushion/get_up1",
    "entity/cushion/get_up2",
    "entity/cushion/get_up3",
    "entity/cushion/place1",
    "entity/cushion/place2",
    "entity/cushion/place3",
    "entity/cushion/place4",
    "entity/cushion/place5",
    "entity/cushion/place6",
    "entity/cushion/sit1",
    "entity/cushion/sit2",
    "entity/cushion/sit3",
    "entity/endereye/dead1",
    "entity/endereye/dead2",
    "entity/endereye/endereye_launch1",
    "entity/endereye/endereye_launch2",
    "entity/fish/flop1",
    "entity/fish/flop2",
    "entity/fish/flop3",
    "entity/fish/flop4",
    "entity/fish/hurt1",
    "entity/fish/hurt2",
    "entity/fish/hurt3",
    "entity/fish/hurt4",
    "entity/fish/swim1",
    "entity/fish/swim2",
    "entity/fish/swim3",
    "entity/fish/swim4",
    "entity/fish/swim5",
    "entity/fish/swim6",
    "entity/fish/swim7",
    "entity/itemframe/add_item1",
    "entity/itemframe/add_item2",
    "entity/itemframe/add_item3",
    "entity/itemframe/add_item4",
    "entity/itemframe/break1",
    "entity/itemframe/break2",
    "entity/itemframe/break3",
    "entity/itemframe/place1",
    "entity/itemframe/place2",
    "entity/itemframe/place3",
    "entity/itemframe/place4",
    "entity/itemframe/remove_item1",
    "entity/itemframe/remove_item2",
    "entity/itemframe/remove_item3",
    "entity/itemframe/remove_item4",
    "entity/itemframe/rotate_item1",
    "entity/itemframe/rotate_item2",
    "entity/itemframe/rotate_item3",
    "entity/itemframe/rotate_item4",
    "entity/leashknot/break",
    "entity/leashknot/leash1",
    "entity/leashknot/leash2",
    "entity/leashknot/leash3",
    "entity/leashknot/unleash1",
    "entity/leashknot/unleash2",
    "entity/leashknot/unleash3",
    "entity/painting/break1",
    "entity/painting/break2",
    "entity/painting/break3",
    "entity/painting/place1",
    "entity/painting/place2",
    "entity/painting/place3",
    "entity/painting/place4",
    "entity/player/attack/crit1",
    "entity/player/attack/crit2",
    "entity/player/attack/crit3",
    "entity/player/attack/knockback1",
    "entity/player/attack/knockback2",
    "entity/player/attack/knockback3",
    "entity/player/attack/knockback4",
    "entity/player/attack/strong1",
    "entity/player/attack/strong2",
    "entity/player/attack/strong3",
    "entity/player/attack/strong4",
    "entity/player/attack/strong5",
    "entity/player/attack/strong6",
    "entity/player/attack/sweep1",
    "entity/player/attack/sweep2",
    "entity/player/attack/sweep3",
    "entity/player/attack/sweep4",
    "entity/player/attack/sweep5",
    "entity/player/attack/sweep6",
    "entity/player/attack/sweep7",
    "entity/player/attack/weak1",
    "entity/player/attack/weak2",
    "entity/player/attack/weak3",
    "entity/player/attack/weak4",
    "entity/player/hurt/berrybush_hurt1",
    "entity/player/hurt/berrybush_hurt2",
    "entity/player/hurt/drown1",
    "entity/player/hurt/drown2",
    "entity/player/hurt/drown3",
    "entity/player/hurt/drown4",
    "entity/player/hurt/fire_hurt1",
    "entity/player/hurt/fire_hurt2",
    "entity/player/hurt/fire_hurt3",
    "entity/player/hurt/freeze_hurt1",
    "entity/player/hurt/freeze_hurt2",
    "entity/player/hurt/freeze_hurt3",
    "entity/player/hurt/freeze_hurt4",
    "entity/player/hurt/freeze_hurt5",
    "entity/shulker/ambient1",
    "entity/shulker/ambient2",
    "entity/shulker/ambient3",
    "entity/shulker/ambient4",
    "entity/shulker/ambient5",
    "entity/shulker/ambient6",
    "entity/shulker/ambient7",
    "entity/shulker/close1",
    "entity/shulker/close2",
    "entity/shulker/close3",
    "entity/shulker/close4",
    "entity/shulker/close5",
    "entity/shulker/death1",
    "entity/shulker/death2",
    "entity/shulker/death3",
    "entity/shulker/death4",
    "entity/shulker/hurt1",
    "entity/shulker/hurt2",
    "entity/shulker/hurt3",
    "entity/shulker/hurt4",
    "entity/shulker/hurt_closed1",
    "entity/shulker/hurt_closed2",
    "entity/shulker/hurt_closed3",
    "entity/shulker/hurt_closed4",
    "entity/shulker/hurt_closed5",
    "entity/shulker/open1",
    "entity/shulker/open2",
    "entity/shulker/open3",
    "entity/shulker/open4",
    "entity/shulker/open5",
    "entity/shulker/shoot1",
    "entity/shulker/shoot2",
    "entity/shulker/shoot3",
    "entity/shulker/shoot4",
    "entity/shulker_bullet/hit1",
    "entity/shulker_bullet/hit2",
    "entity/shulker_bullet/hit3",
    "entity/shulker_bullet/hit4",
    "entity/snowman/death1",
    "entity/snowman/death2",
    "entity/snowman/death3",
    "entity/snowman/hurt1",
    "entity/snowman/hurt2",
    "entity/snowman/hurt3",
    "entity/wind_charge/wind_burst1",
    "entity/wind_charge/wind_burst2",
    "entity/wind_charge/wind_burst3",
    "entity/witch/ambient1",
    "entity/witch/ambient2",
    "entity/witch/ambient3",
    "entity/witch/ambient4",
    "entity/witch/ambient5",
    "entity/witch/celebrate",
    "entity/witch/death1",
    "entity/witch/death2",
    "entity/witch/death3",
    "entity/witch/drink1",
    "entity/witch/drink2",
    "entity/witch/drink3",
    "entity/witch/drink4",
    "entity/witch/hurt1",
    "entity/witch/hurt2",
    "entity/witch/hurt3",
    "entity/witch/throw1",
    "entity/witch/throw2",
    "entity/witch/throw3",
    "event/mob_effects/bad_omen",
    "event/mob_effects/raid_omen",
    "event/mob_effects/trial_omen",
    "event/raid/raidhorn_01",
    "event/raid/raidhorn_02",
    "event/raid/raidhorn_03",
    "event/raid/raidhorn_04",
    "fire/fire",
    "fire/ignite",
    "fireworks/blast1",
    "fireworks/blast_far1",
    "fireworks/largeblast1",
    "fireworks/largeblast_far1",
    "fireworks/launch1",
    "fireworks/twinkle1",
    "fireworks/twinkle_far1",
    "item/armor/break_wolf",
    "item/armor/crack_wolf1",
    "item/armor/crack_wolf2",
    "item/armor/crack_wolf3",
    "item/armor/crack_wolf4",
    "item/armor/damage_wolf1",
    "item/armor/damage_wolf2",
    "item/armor/damage_wolf3",
    "item/armor/damage_wolf4",
    "item/armor/equip_chain1",
    "item/armor/equip_chain2",
    "item/armor/equip_chain3",
    "item/armor/equip_chain4",
    "item/armor/equip_chain5",
    "item/armor/equip_chain6",
    "item/armor/equip_copper1",
    "item/armor/equip_copper2",
    "item/armor/equip_copper3",
    "item/armor/equip_copper4",
    "item/armor/equip_copper5",
    "item/armor/equip_copper6",
    "item/armor/equip_diamond1",
    "item/armor/equip_diamond2",
    "item/armor/equip_diamond3",
    "item/armor/equip_diamond4",
    "item/armor/equip_diamond5",
    "item/armor/equip_diamond6",
    "item/armor/equip_generic1",
    "item/armor/equip_generic2",
    "item/armor/equip_generic3",
    "item/armor/equip_generic4",
    "item/armor/equip_generic5",
    "item/armor/equip_generic6",
    "item/armor/equip_gold1",
    "item/armor/equip_gold2",
    "item/armor/equip_gold3",
    "item/armor/equip_gold4",
    "item/armor/equip_gold5",
    "item/armor/equip_gold6",
    "item/armor/equip_iron1",
    "item/armor/equip_iron2",
    "item/armor/equip_iron3",
    "item/armor/equip_iron4",
    "item/armor/equip_iron5",
    "item/armor/equip_iron6",
    "item/armor/equip_leather1",
    "item/armor/equip_leather2",
    "item/armor/equip_leather3",
    "item/armor/equip_leather4",
    "item/armor/equip_leather5",
    "item/armor/equip_leather6",
    "item/armor/equip_netherite1",
    "item/armor/equip_netherite2",
    "item/armor/equip_netherite3",
    "item/armor/equip_netherite4",
    "item/armor/equip_wolf1",
    "item/armor/equip_wolf2",
    "item/armor/repair_wolf1",
    "item/armor/repair_wolf2",
    "item/armor/repair_wolf3",
    "item/armor/repair_wolf4",
    "item/armor/unequip_wolf1",
    "item/armor/unequip_wolf2",
    "item/axe/scrape1",
    "item/axe/scrape2",
    "item/axe/scrape3",
    "item/axe/strip1",
    "item/axe/strip2",
    "item/axe/strip3",
    "item/axe/strip4",
    "item/axe/wax_off1",
    "item/axe/wax_off2",
    "item/axe/wax_off3",
    "item/bonemeal/bonemeal1",
    "item/bonemeal/bonemeal2",
    "item/bonemeal/bonemeal3",
    "item/bonemeal/bonemeal4",
    "item/bonemeal/bonemeal5",
    "item/book/close_put1",
    "item/book/close_put2",
    "item/book/open_flip1",
    "item/book/open_flip2",
    "item/book/open_flip3",
    "item/bottle/drink_honey1",
    "item/bottle/drink_honey2",
    "item/bottle/drink_honey3",
    "item/bottle/empty1",
    "item/bottle/empty2",
    "item/bottle/fill1",
    "item/bottle/fill2",
    "item/bottle/fill3",
    "item/bottle/fill4",
    "item/bottle/fill_dragonbreath1",
    "item/bottle/fill_dragonbreath2",
    "item/brush/brush_sand_complete1",
    "item/brush/brush_sand_complete2",
    "item/brush/brush_sand_complete3",
    "item/brush/brush_sand_complete4",
    "item/brush/brush_sand_complete5",
    "item/brush/brushing_generic1",
    "item/brush/brushing_generic2",
    "item/brush/brushing_generic3",
    "item/brush/brushing_generic4",
    "item/brush/brushing_gravel1",
    "item/brush/brushing_gravel2",
    "item/brush/brushing_gravel3",
    "item/brush/brushing_gravel4",
    "item/brush/brushing_gravel_complete1",
    "item/brush/brushing_gravel_complete2",
    "item/brush/brushing_gravel_complete3",
    "item/brush/brushing_gravel_complete4",
    "item/brush/brushing_sand1",
    "item/brush/brushing_sand2",
    "item/brush/brushing_sand3",
    "item/brush/brushing_sand4",
    "item/bucket/empty1",
    "item/bucket/empty2",
    "item/bucket/empty3",
    "item/bucket/empty_fish1",
    "item/bucket/empty_fish2",
    "item/bucket/empty_fish3",
    "item/bucket/empty_lava1",
    "item/bucket/empty_lava2",
    "item/bucket/empty_lava3",
    "item/bucket/empty_powder_snow1",
    "item/bucket/empty_powder_snow2",
    "item/bucket/emptysulfurcube1",
    "item/bucket/emptysulfurcube2",
    "item/bucket/emptysulfurcube3",
    "item/bucket/fill1",
    "item/bucket/fill2",
    "item/bucket/fill3",
    "item/bucket/fill_axolotl1",
    "item/bucket/fill_axolotl2",
    "item/bucket/fill_axolotl3",
    "item/bucket/fill_fish1",
    "item/bucket/fill_fish2",
    "item/bucket/fill_fish3",
    "item/bucket/fill_lava1",
    "item/bucket/fill_lava2",
    "item/bucket/fill_lava3",
    "item/bucket/fill_powder_snow1",
    "item/bucket/fill_powder_snow2",
    "item/bucket/fillsulfurcube1",
    "item/bucket/fillsulfurcube2",
    "item/bucket/fillsulfurcube3",
    "item/bundle/drop_contents1",
    "item/bundle/drop_contents2",
    "item/bundle/drop_contents3",
    "item/bundle/insert1",
    "item/bundle/insert2",
    "item/bundle/insert3",
    "item/bundle/insert_fail",
    "item/bundle/remove_one1",
    "item/bundle/remove_one2",
    "item/bundle/remove_one3",
    "item/crossbow/loading_end",
    "item/crossbow/loading_middle1",
    "item/crossbow/loading_middle2",
    "item/crossbow/loading_middle3",
    "item/crossbow/loading_middle4",
    "item/crossbow/loading_start",
    "item/crossbow/quick_charge/quick1_1",
    "item/crossbow/quick_charge/quick1_2",
    "item/crossbow/quick_charge/quick1_3",
    "item/crossbow/quick_charge/quick2_1",
    "item/crossbow/quick_charge/quick2_2",
    "item/crossbow/quick_charge/quick2_3",
    "item/crossbow/quick_charge/quick3_1",
    "item/crossbow/quick_charge/quick3_2",
    "item/crossbow/quick_charge/quick3_3",
    "item/crossbow/shoot1",
    "item/crossbow/shoot2",
    "item/crossbow/shoot3",
    "item/dye/dye",
    "item/elytra/elytra_loop",
    "item/goat_horn/call0",
    "item/goat_horn/call1",
    "item/goat_horn/call2",
    "item/goat_horn/call3",
    "item/goat_horn/call4",
    "item/goat_horn/call5",
    "item/goat_horn/call6",
    "item/goat_horn/call7",
    "item/golden_dandelion/unuse",
    "item/golden_dandelion/use",
    "item/hoe/till1",
    "item/hoe/till2",
    "item/hoe/till3",
    "item/hoe/till4",
    "item/honeycomb/wax_on1",
    "item/honeycomb/wax_on2",
    "item/honeycomb/wax_on3",
    "item/ink_sac/ink_sac1",
    "item/ink_sac/ink_sac2",
    "item/ink_sac/ink_sac3",
    "item/mace/smash_air1",
    "item/mace/smash_air2",
    "item/mace/smash_air3",
    "item/mace/smash_ground1",
    "item/mace/smash_ground2",
    "item/mace/smash_ground3",
    "item/mace/smash_ground4",
    "item/mace/smash_ground_heavy",
    "item/ominous_bottle/dispose",
    "item/plant/crop1",
    "item/plant/crop2",
    "item/plant/crop3",
    "item/plant/crop4",
    "item/plant/crop5",
    "item/plant/crop6",
    "item/plant/netherwart1",
    "item/plant/netherwart2",
    "item/plant/netherwart3",
    "item/plant/netherwart4",
    "item/plant/netherwart5",
    "item/plant/netherwart6",
    "item/shield/block1",
    "item/shield/block2",
    "item/shield/block3",
    "item/shield/block4",
    "item/shield/block5",
    "item/shovel/flatten1",
    "item/shovel/flatten2",
    "item/shovel/flatten3",
    "item/shovel/flatten4",
    "item/spear/attack1",
    "item/spear/attack2",
    "item/spear/attack3",
    "item/spear/hit1",
    "item/spear/hit2",
    "item/spear/hit3",
    "item/spear/lunge1",
    "item/spear/lunge2",
    "item/spear/lunge3",
    "item/spear/use",
    "item/spear/wood/attack1",
    "item/spear/wood/attack2",
    "item/spear/wood/attack3",
    "item/spear/wood/hit1",
    "item/spear/wood/hit2",
    "item/spear/wood/hit3",
    "item/spear/wood/use",
    "item/spyglass/stop",
    "item/spyglass/use",
    "item/sweet_berries/pick_from_bush1",
    "item/sweet_berries/pick_from_bush2",
    "item/totem/use_totem",
    "item/trident/ground_impact1",
    "item/trident/ground_impact2",
    "item/trident/ground_impact3",
    "item/trident/ground_impact4",
    "item/trident/pierce1",
    "item/trident/pierce2",
    "item/trident/pierce3",
    "item/trident/return1",
    "item/trident/return2",
    "item/trident/return3",
    "item/trident/riptide1",
    "item/trident/riptide2",
    "item/trident/riptide3",
    "item/trident/throw1",
    "item/trident/throw2",
    "item/trident/thunder1",
    "item/trident/thunder2",
    "liquid/heavy_splash",
    "liquid/lava",
    "liquid/lavapop",
    "liquid/splash",
    "liquid/splash2",
    "liquid/swim1",
    "liquid/swim10",
    "liquid/swim11",
    "liquid/swim12",
    "liquid/swim13",
    "liquid/swim14",
    "liquid/swim15",
    "liquid/swim16",
    "liquid/swim17",
    "liquid/swim18",
    "liquid/swim2",
    "liquid/swim3",
    "liquid/swim4",
    "liquid/swim5",
    "liquid/swim6",
    "liquid/swim7",
    "liquid/swim8",
    "liquid/swim9",
    "liquid/water",
    "minecart/base",
    "minecart/inside",
    "minecart/inside_underwater1",
    "minecart/inside_underwater2",
    "minecart/inside_underwater3",
    "mob/allay/death1",
    "mob/allay/death2",
    "mob/allay/hurt1",
    "mob/allay/hurt2",
    "mob/allay/idle_with_item1",
    "mob/allay/idle_with_item2",
    "mob/allay/idle_with_item3",
    "mob/allay/idle_with_item4",
    "mob/allay/idle_without_item1",
    "mob/allay/idle_without_item2",
    "mob/allay/idle_without_item3",
    "mob/allay/idle_without_item4",
    "mob/allay/item_given1",
    "mob/allay/item_given2",
    "mob/allay/item_given3",
    "mob/allay/item_given4",
    "mob/allay/item_taken1",
    "mob/allay/item_taken2",
    "mob/allay/item_taken3",
    "mob/allay/item_taken4",
    "mob/allay/item_thrown1",
    "mob/armadillo/ambient1",
    "mob/armadillo/ambient2",
    "mob/armadillo/ambient3",
    "mob/armadillo/ambient4",
    "mob/armadillo/ambient5",
    "mob/armadillo/ambient6",
    "mob/armadillo/ambient7",
    "mob/armadillo/ambient8",
    "mob/armadillo/brush_armadillo1",
    "mob/armadillo/brush_armadillo2",
    "mob/armadillo/death1",
    "mob/armadillo/death2",
    "mob/armadillo/death3",
    "mob/armadillo/death4",
    "mob/armadillo/eat1",
    "mob/armadillo/eat2",
    "mob/armadillo/eat3",
    "mob/armadillo/hurt1",
    "mob/armadillo/hurt2",
    "mob/armadillo/hurt3",
    "mob/armadillo/hurt4",
    "mob/armadillo/hurt5",
    "mob/armadillo/hurt_reduced1",
    "mob/armadillo/hurt_reduced2",
    "mob/armadillo/hurt_reduced3",
    "mob/armadillo/hurt_reduced4",
    "mob/armadillo/land1",
    "mob/armadillo/land2",
    "mob/armadillo/land3",
    "mob/armadillo/land4",
    "mob/armadillo/peek",
    "mob/armadillo/roll1",
    "mob/armadillo/roll2",
    "mob/armadillo/roll3",
    "mob/armadillo/roll4",
    "mob/armadillo/scute_drop1",
    "mob/armadillo/scute_drop2",
    "mob/armadillo/step1",
    "mob/armadillo/step2",
    "mob/armadillo/step3",
    "mob/armadillo/step4",
    "mob/armadillo/step5",
    "mob/armadillo/unroll_finish1",
    "mob/armadillo/unroll_finish2",
    "mob/armadillo/unroll_start",
    "mob/axolotl/attack1",
    "mob/axolotl/attack2",
    "mob/axolotl/attack3",
    "mob/axolotl/attack4",
    "mob/axolotl/death1",
    "mob/axolotl/death2",
    "mob/axolotl/hurt1",
    "mob/axolotl/hurt2",
    "mob/axolotl/hurt3",
    "mob/axolotl/hurt4",
    "mob/axolotl/idle1",
    "mob/axolotl/idle2",
    "mob/axolotl/idle3",
    "mob/axolotl/idle4",
    "mob/axolotl/idle5",
    "mob/axolotl/idle_air1",
    "mob/axolotl/idle_air2",
    "mob/axolotl/idle_air3",
    "mob/axolotl/idle_air4",
    "mob/axolotl/idle_air5",
    "mob/baby_nautilus/ambient1",
    "mob/baby_nautilus/ambient2",
    "mob/baby_nautilus/ambient3",
    "mob/baby_nautilus/ambient4",
    "mob/baby_nautilus/ambient5",
    "mob/baby_nautilus/ambient6",
    "mob/baby_nautilus/ambient_land1",
    "mob/baby_nautilus/ambient_land2",
    "mob/baby_nautilus/ambient_land3",
    "mob/baby_nautilus/ambient_land4",
    "mob/baby_nautilus/death",
    "mob/baby_nautilus/death_land",
    "mob/baby_nautilus/eat1",
    "mob/baby_nautilus/eat2",
    "mob/baby_nautilus/hurt1",
    "mob/baby_nautilus/hurt2",
    "mob/baby_nautilus/hurt3",
    "mob/baby_nautilus/hurt4",
    "mob/baby_nautilus/hurt_land1",
    "mob/baby_nautilus/hurt_land2",
    "mob/baby_nautilus/hurt_land3",
    "mob/baby_nautilus/hurt_land4",
    "mob/bat/death",
    "mob/bat/hurt1",
    "mob/bat/hurt2",
    "mob/bat/hurt3",
    "mob/bat/hurt4",
    "mob/bat/idle1",
    "mob/bat/idle2",
    "mob/bat/idle3",
    "mob/bat/idle4",
    "mob/bat/loop",
    "mob/bat/takeoff",
    "mob/bee/aggressive1",
    "mob/bee/aggressive2",
    "mob/bee/aggressive3",
    "mob/bee/death1",
    "mob/bee/death2",
    "mob/bee/hurt1",
    "mob/bee/hurt2",
    "mob/bee/hurt3",
    "mob/bee/loop1",
    "mob/bee/loop2",
    "mob/bee/loop3",
    "mob/bee/loop4",
    "mob/bee/loop5",
    "mob/bee/pollinate1",
    "mob/bee/pollinate2",
    "mob/bee/pollinate3",
    "mob/bee/pollinate4",
    "mob/bee/sting",
    "mob/blaze/breathe1",
    "mob/blaze/breathe2",
    "mob/blaze/breathe3",
    "mob/blaze/breathe4",
    "mob/blaze/death",
    "mob/blaze/hit1",
    "mob/blaze/hit2",
    "mob/blaze/hit3",
    "mob/blaze/hit4",
    "mob/bogged/ambient1",
    "mob/bogged/ambient2",
    "mob/bogged/ambient3",
    "mob/bogged/ambient4",
    "mob/bogged/death",
    "mob/bogged/hurt1",
    "mob/bogged/hurt2",
    "mob/bogged/hurt3",
    "mob/bogged/hurt4",
    "mob/bogged/step1",
    "mob/bogged/step2",
    "mob/bogged/step3",
    "mob/bogged/step4",
    "mob/breeze/charge1",
    "mob/breeze/charge2",
    "mob/breeze/charge3",
    "mob/breeze/death1",
    "mob/breeze/death2",
    "mob/breeze/deflect1",
    "mob/breeze/deflect2",
    "mob/breeze/deflect3",
    "mob/breeze/hurt1",
    "mob/breeze/hurt2",
    "mob/breeze/hurt3",
    "mob/breeze/idle1",
    "mob/breeze/idle2",
    "mob/breeze/idle3",
    "mob/breeze/idle4",
    "mob/breeze/idle_air1",
    "mob/breeze/idle_air2",
    "mob/breeze/idle_air3",
    "mob/breeze/idle_air4",
    "mob/breeze/inhale1",
    "mob/breeze/inhale2",
    "mob/breeze/jump1",
    "mob/breeze/jump2",
    "mob/breeze/land1",
    "mob/breeze/land2",
    "mob/breeze/shoot",
    "mob/breeze/slide1",
    "mob/breeze/slide2",
    "mob/breeze/slide3",
    "mob/breeze/slide4",
    "mob/breeze/whirl",
    "mob/breeze/wind_burst1",
    "mob/breeze/wind_burst2",
    "mob/breeze/wind_burst3",
    "mob/camel/ambient1",
    "mob/camel/ambient2",
    "mob/camel/ambient3",
    "mob/camel/ambient4",
    "mob/camel/ambient5",
    "mob/camel/ambient6",
    "mob/camel/ambient7",
    "mob/camel/ambient8",
    "mob/camel/dash1",
    "mob/camel/dash2",
    "mob/camel/dash3",
    "mob/camel/dash4",
    "mob/camel/dash5",
    "mob/camel/dash6",
    "mob/camel/dash_ready1",
    "mob/camel/death1",
    "mob/camel/death2",
    "mob/camel/eat1",
    "mob/camel/eat2",
    "mob/camel/eat3",
    "mob/camel/eat4",
    "mob/camel/eat5",
    "mob/camel/hurt1",
    "mob/camel/hurt2",
    "mob/camel/hurt3",
    "mob/camel/hurt4",
    "mob/camel/sit1",
    "mob/camel/sit2",
    "mob/camel/sit3",
    "mob/camel/sit4",
    "mob/camel/stand1",
    "mob/camel/stand2",
    "mob/camel/stand3",
    "mob/camel/stand4",
    "mob/camel/stand5",
    "mob/camel/step1",
    "mob/camel/step2",
    "mob/camel/step3",
    "mob/camel/step4",
    "mob/camel/step5",
    "mob/camel/step6",
    "mob/camel/step_sand1",
    "mob/camel/step_sand2",
    "mob/camel/step_sand3",
    "mob/camel/step_sand4",
    "mob/camel/step_sand5",
    "mob/camel/step_sand6",
    "mob/camel_husk/ambient1",
    "mob/camel_husk/ambient2",
    "mob/camel_husk/ambient3",
    "mob/camel_husk/ambient4",
    "mob/camel_husk/ambient5",
    "mob/camel_husk/ambient6",
    "mob/camel_husk/ambient7",
    "mob/camel_husk/ambient8",
    "mob/camel_husk/dash1",
    "mob/camel_husk/dash2",
    "mob/camel_husk/dash3",
    "mob/camel_husk/dash4",
    "mob/camel_husk/dash5",
    "mob/camel_husk/dash6",
    "mob/camel_husk/dash_ready",
    "mob/camel_husk/death1",
    "mob/camel_husk/death2",
    "mob/camel_husk/eat1",
    "mob/camel_husk/eat2",
    "mob/camel_husk/eat3",
    "mob/camel_husk/eat4",
    "mob/camel_husk/eat5",
    "mob/camel_husk/hurt1",
    "mob/camel_husk/hurt2",
    "mob/camel_husk/hurt3",
    "mob/camel_husk/hurt4",
    "mob/camel_husk/sit1",
    "mob/camel_husk/sit2",
    "mob/camel_husk/sit3",
    "mob/camel_husk/sit4",
    "mob/camel_husk/stand1",
    "mob/camel_husk/stand2",
    "mob/camel_husk/stand3",
    "mob/camel_husk/stand4",
    "mob/camel_husk/stand5",
    "mob/camel_husk/step1",
    "mob/camel_husk/step2",
    "mob/camel_husk/step3",
    "mob/camel_husk/step4",
    "mob/camel_husk/step5",
    "mob/camel_husk/step6",
    "mob/camel_husk/step_sand1",
    "mob/camel_husk/step_sand2",
    "mob/camel_husk/step_sand3",
    "mob/camel_husk/step_sand4",
    "mob/camel_husk/step_sand5",
    "mob/camel_husk/step_sand6",
    "mob/cat/baby_cat/ambient1",
    "mob/cat/baby_cat/ambient2",
    "mob/cat/baby_cat/ambient3",
    "mob/cat/baby_cat/ambient4",
    "mob/cat/baby_cat/ambient5",
    "mob/cat/baby_cat/ambient6",
    "mob/cat/baby_cat/ambient7",
    "mob/cat/baby_cat/death",
    "mob/cat/baby_cat/hurt1",
    "mob/cat/baby_cat/hurt2",
    "mob/cat/baby_cat/hurt3",
    "mob/cat/beg1",
    "mob/cat/beg2",
    "mob/cat/beg3",
    "mob/cat/eat1",
    "mob/cat/eat2",
    "mob/cat/hiss1",
    "mob/cat/hiss2",
    "mob/cat/hiss3",
    "mob/cat/hitt1",
    "mob/cat/hitt2",
    "mob/cat/hitt3",
    "mob/cat/meow1",
    "mob/cat/meow2",
    "mob/cat/meow3",
    "mob/cat/meow4",
    "mob/cat/ocelot/death1",
    "mob/cat/ocelot/death2",
    "mob/cat/ocelot/death3",
    "mob/cat/ocelot/idle1",
    "mob/cat/ocelot/idle2",
    "mob/cat/ocelot/idle3",
    "mob/cat/ocelot/idle4",
    "mob/cat/purr1",
    "mob/cat/purr2",
    "mob/cat/purr3",
    "mob/cat/purreow1",
    "mob/cat/purreow2",
    "mob/cat/royal/ambient1",
    "mob/cat/royal/ambient2",
    "mob/cat/royal/ambient3",
    "mob/cat/royal/ambient4",
    "mob/cat/royal/ambient5",
    "mob/cat/royal/ambient6",
    "mob/cat/royal/death",
    "mob/cat/royal/hurt1",
    "mob/cat/royal/hurt2",
    "mob/cat/royal/hurt3",
    "mob/cat/stray/idle1",
    "mob/cat/stray/idle2",
    "mob/cat/stray/idle3",
    "mob/cat/stray/idle4",
    "mob/chicken/baby_chicken/ambient1",
    "mob/chicken/baby_chicken/ambient2",
    "mob/chicken/baby_chicken/death",
    "mob/chicken/baby_chicken/hurt1",
    "mob/chicken/baby_chicken/hurt2",
    "mob/chicken/baby_chicken/hurt3",
    "mob/chicken/baby_chicken/hurt4",
    "mob/chicken/baby_chicken/step",
    "mob/chicken/hurt1",
    "mob/chicken/hurt2",
    "mob/chicken/picky/ambient1",
    "mob/chicken/picky/ambient2",
    "mob/chicken/picky/ambient3",
    "mob/chicken/picky/ambient4",
    "mob/chicken/picky/ambient5",
    "mob/chicken/picky/ambient6",
    "mob/chicken/picky/ambient7",
    "mob/chicken/picky/ambient8",
    "mob/chicken/picky/death",
    "mob/chicken/picky/hurt1",
    "mob/chicken/picky/hurt2",
    "mob/chicken/picky/hurt3",
    "mob/chicken/plop",
    "mob/chicken/say1",
    "mob/chicken/say2",
    "mob/chicken/say3",
    "mob/chicken/step1",
    "mob/chicken/step2",
    "mob/coppergolem/item_drop",
    "mob/coppergolem/item_no_drop",
    "mob/coppergolem/no_item_get",
    "mob/coppergolem/no_item_no_get",
    "mob/coppergolem/oxidized/death",
    "mob/coppergolem/oxidized/hurt1",
    "mob/coppergolem/oxidized/hurt2",
    "mob/coppergolem/oxidized/hurt3",
    "mob/coppergolem/oxidized/hurt4",
    "mob/coppergolem/oxidized/spin1",
    "mob/coppergolem/oxidized/spin2",
    "mob/coppergolem/oxidized/spin3",
    "mob/coppergolem/oxidized/spin4",
    "mob/coppergolem/oxidized/spin5",
    "mob/coppergolem/oxidized/spin6",
    "mob/coppergolem/oxidized/spin7",
    "mob/coppergolem/oxidized/step1",
    "mob/coppergolem/oxidized/step2",
    "mob/coppergolem/oxidized/step3",
    "mob/coppergolem/oxidized/step4",
    "mob/coppergolem/oxidized/step5",
    "mob/coppergolem/oxidized/step6",
    "mob/coppergolem/oxidized/step7",
    "mob/coppergolem/oxidized/step8",
    "mob/coppergolem/oxidized/step9",
    "mob/coppergolem/regular/death",
    "mob/coppergolem/regular/hurt1",
    "mob/coppergolem/regular/hurt2",
    "mob/coppergolem/regular/hurt3",
    "mob/coppergolem/regular/hurt4",
    "mob/coppergolem/regular/spin1",
    "mob/coppergolem/regular/spin2",
    "mob/coppergolem/regular/spin3",
    "mob/coppergolem/regular/spin4",
    "mob/coppergolem/regular/spin5",
    "mob/coppergolem/regular/spin6",
    "mob/coppergolem/regular/spin7",
    "mob/coppergolem/regular/step1",
    "mob/coppergolem/regular/step2",
    "mob/coppergolem/regular/step3",
    "mob/coppergolem/regular/step4",
    "mob/coppergolem/regular/step5",
    "mob/coppergolem/regular/step6",
    "mob/coppergolem/regular/step7",
    "mob/coppergolem/regular/step8",
    "mob/coppergolem/regular/step9",
    "mob/coppergolem/spawn",
    "mob/coppergolem/weathered/death",
    "mob/coppergolem/weathered/hurt1",
    "mob/coppergolem/weathered/hurt2",
    "mob/coppergolem/weathered/hurt3",
    "mob/coppergolem/weathered/hurt4",
    "mob/coppergolem/weathered/spin1",
    "mob/coppergolem/weathered/spin2",
    "mob/coppergolem/weathered/spin3",
    "mob/coppergolem/weathered/spin4",
    "mob/coppergolem/weathered/spin5",
    "mob/coppergolem/weathered/spin6",
    "mob/coppergolem/weathered/spin7",
    "mob/coppergolem/weathered/step1",
    "mob/coppergolem/weathered/step2",
    "mob/coppergolem/weathered/step3",
    "mob/coppergolem/weathered/step4",
    "mob/coppergolem/weathered/step5",
    "mob/coppergolem/weathered/step6",
    "mob/coppergolem/weathered/step7",
    "mob/coppergolem/weathered/step8",
    "mob/coppergolem/weathered/step9",
    "mob/cow/hurt1",
    "mob/cow/hurt2",
    "mob/cow/hurt3",
    "mob/cow/moody/ambient1",
    "mob/cow/moody/ambient2",
    "mob/cow/moody/ambient3",
    "mob/cow/moody/ambient4",
    "mob/cow/moody/ambient5",
    "mob/cow/moody/ambient6",
    "mob/cow/moody/ambient7",
    "mob/cow/moody/ambient8",
    "mob/cow/moody/ambient9",
    "mob/cow/moody/death1",
    "mob/cow/moody/death2",
    "mob/cow/moody/hit1",
    "mob/cow/moody/hit2",
    "mob/cow/moody/hit3",
    "mob/cow/moody/hit4",
    "mob/cow/say1",
    "mob/cow/say2",
    "mob/cow/say3",
    "mob/cow/say4",
    "mob/cow/step1",
    "mob/cow/step2",
    "mob/cow/step3",
    "mob/cow/step4",
    "mob/creaking/creaking_activate",
    "mob/creaking/creaking_attack1",
    "mob/creaking/creaking_attack2",
    "mob/creaking/creaking_attack3",
    "mob/creaking/creaking_attack4",
    "mob/creaking/creaking_deactivate",
    "mob/creaking/creaking_death",
    "mob/creaking/creaking_freeze1",
    "mob/creaking/creaking_freeze2",
    "mob/creaking/creaking_freeze3",
    "mob/creaking/creaking_freeze4",
    "mob/creaking/creaking_idle1",
    "mob/creaking/creaking_idle2",
    "mob/creaking/creaking_idle3",
    "mob/creaking/creaking_idle4",
    "mob/creaking/creaking_idle5",
    "mob/creaking/creaking_idle6",
    "mob/creaking/creaking_spawn",
    "mob/creaking/creaking_step1",
    "mob/creaking/creaking_step2",
    "mob/creaking/creaking_step3",
    "mob/creaking/creaking_step4",
    "mob/creaking/creaking_step5",
    "mob/creaking/creaking_sway1",
    "mob/creaking/creaking_sway2",
    "mob/creaking/creaking_sway3",
    "mob/creaking/creaking_sway4",
    "mob/creaking/creaking_twitch",
    "mob/creaking/creaking_unfreeze1",
    "mob/creaking/creaking_unfreeze2",
    "mob/creaking/creaking_unfreeze3",
    "mob/creaking/parrot_imitate_creaking",
    "mob/creeper/death",
    "mob/creeper/say1",
    "mob/creeper/say2",
    "mob/creeper/say3",
    "mob/creeper/say4",
    "mob/dolphin/attack1",
    "mob/dolphin/attack2",
    "mob/dolphin/attack3",
    "mob/dolphin/blowhole1",
    "mob/dolphin/blowhole2",
    "mob/dolphin/death1",
    "mob/dolphin/death2",
    "mob/dolphin/eat1",
    "mob/dolphin/eat2",
    "mob/dolphin/eat3",
    "mob/dolphin/hurt1",
    "mob/dolphin/hurt2",
    "mob/dolphin/hurt3",
    "mob/dolphin/idle1",
    "mob/dolphin/idle2",
    "mob/dolphin/idle3",
    "mob/dolphin/idle4",
    "mob/dolphin/idle5",
    "mob/dolphin/idle6",
    "mob/dolphin/idle_water1",
    "mob/dolphin/idle_water10",
    "mob/dolphin/idle_water2",
    "mob/dolphin/idle_water3",
    "mob/dolphin/idle_water4",
    "mob/dolphin/idle_water5",
    "mob/dolphin/idle_water6",
    "mob/dolphin/idle_water7",
    "mob/dolphin/idle_water8",
    "mob/dolphin/idle_water9",
    "mob/dolphin/jump1",
    "mob/dolphin/jump2",
    "mob/dolphin/jump3",
    "mob/dolphin/play1",
    "mob/dolphin/play2",
    "mob/dolphin/splash1",
    "mob/dolphin/splash2",
    "mob/dolphin/splash3",
    "mob/dolphin/swim1",
    "mob/dolphin/swim2",
    "mob/dolphin/swim3",
    "mob/dolphin/swim4",
    "mob/drowned/convert1",
    "mob/drowned/convert2",
    "mob/drowned/convert3",
    "mob/drowned/death1",
    "mob/drowned/death2",
    "mob/drowned/hurt1",
    "mob/drowned/hurt2",
    "mob/drowned/hurt3",
    "mob/drowned/idle1",
    "mob/drowned/idle2",
    "mob/drowned/idle3",
    "mob/drowned/idle4",
    "mob/drowned/idle5",
    "mob/drowned/step1",
    "mob/drowned/step2",
    "mob/drowned/step3",
    "mob/drowned/step4",
    "mob/drowned/step5",
    "mob/drowned/water/death1",
    "mob/drowned/water/death2",
    "mob/drowned/water/hurt1",
    "mob/drowned/water/hurt2",
    "mob/drowned/water/hurt3",
    "mob/drowned/water/idle1",
    "mob/drowned/water/idle2",
    "mob/drowned/water/idle3",
    "mob/drowned/water/idle4",
    "mob/enderdragon/end",
    "mob/enderdragon/growl1",
    "mob/enderdragon/growl2",
    "mob/enderdragon/growl3",
    "mob/enderdragon/growl4",
    "mob/enderdragon/hit1",
    "mob/enderdragon/hit2",
    "mob/enderdragon/hit3",
    "mob/enderdragon/hit4",
    "mob/enderdragon/wings1",
    "mob/enderdragon/wings2",
    "mob/enderdragon/wings3",
    "mob/enderdragon/wings4",
    "mob/enderdragon/wings5",
    "mob/enderdragon/wings6",
    "mob/endermen/death",
    "mob/endermen/hit1",
    "mob/endermen/hit2",
    "mob/endermen/hit3",
    "mob/endermen/hit4",
    "mob/endermen/idle1",
    "mob/endermen/idle2",
    "mob/endermen/idle3",
    "mob/endermen/idle4",
    "mob/endermen/idle5",
    "mob/endermen/portal",
    "mob/endermen/portal2",
    "mob/endermen/scream1",
    "mob/endermen/scream2",
    "mob/endermen/scream3",
    "mob/endermen/scream4",
    "mob/endermen/stare",
    "mob/evocation_illager/cast1",
    "mob/evocation_illager/cast2",
    "mob/evocation_illager/celebrate",
    "mob/evocation_illager/death1",
    "mob/evocation_illager/death2",
    "mob/evocation_illager/fangs",
    "mob/evocation_illager/hurt1",
    "mob/evocation_illager/hurt2",
    "mob/evocation_illager/idle1",
    "mob/evocation_illager/idle2",
    "mob/evocation_illager/idle3",
    "mob/evocation_illager/idle4",
    "mob/evocation_illager/prepare_attack1",
    "mob/evocation_illager/prepare_attack2",
    "mob/evocation_illager/prepare_summon",
    "mob/evocation_illager/prepare_wololo",
    "mob/fox/aggro1",
    "mob/fox/aggro2",
    "mob/fox/aggro3",
    "mob/fox/aggro4",
    "mob/fox/aggro5",
    "mob/fox/aggro6",
    "mob/fox/aggro7",
    "mob/fox/bite1",
    "mob/fox/bite2",
    "mob/fox/bite3",
    "mob/fox/death1",
    "mob/fox/death2",
    "mob/fox/eat1",
    "mob/fox/eat2",
    "mob/fox/eat3",
    "mob/fox/hurt1",
    "mob/fox/hurt2",
    "mob/fox/hurt3",
    "mob/fox/hurt4",
    "mob/fox/idle1",
    "mob/fox/idle2",
    "mob/fox/idle3",
    "mob/fox/idle4",
    "mob/fox/idle5",
    "mob/fox/idle6",
    "mob/fox/screech1",
    "mob/fox/screech2",
    "mob/fox/screech3",
    "mob/fox/screech4",
    "mob/fox/sleep1",
    "mob/fox/sleep2",
    "mob/fox/sleep3",
    "mob/fox/sleep4",
    "mob/fox/sleep5",
    "mob/fox/sniff1",
    "mob/fox/sniff2",
    "mob/fox/sniff3",
    "mob/fox/sniff4",
    "mob/fox/spit1",
    "mob/fox/spit2",
    "mob/fox/spit3",
    "mob/frog/death1",
    "mob/frog/death2",
    "mob/frog/death3",
    "mob/frog/eat1",
    "mob/frog/eat2",
    "mob/frog/eat3",
    "mob/frog/eat4",
    "mob/frog/hurt1",
    "mob/frog/hurt2",
    "mob/frog/hurt3",
    "mob/frog/hurt4",
    "mob/frog/hurt5",
    "mob/frog/idle1",
    "mob/frog/idle2",
    "mob/frog/idle3",
    "mob/frog/idle4",
    "mob/frog/idle5",
    "mob/frog/idle6",
    "mob/frog/idle7",
    "mob/frog/idle8",
    "mob/frog/lay_spawn1",
    "mob/frog/lay_spawn2",
    "mob/frog/long_jump1",
    "mob/frog/long_jump2",
    "mob/frog/long_jump3",
    "mob/frog/long_jump4",
    "mob/frog/step1",
    "mob/frog/step2",
    "mob/frog/step3",
    "mob/frog/step4",
    "mob/frog/tongue1",
    "mob/frog/tongue2",
    "mob/frog/tongue3",
    "mob/frog/tongue4",
    "mob/ghast/affectionate_scream",
    "mob/ghast/charge",
    "mob/ghast/death",
    "mob/ghast/fireball4",
    "mob/ghast/moan1",
    "mob/ghast/moan2",
    "mob/ghast/moan3",
    "mob/ghast/moan4",
    "mob/ghast/moan5",
    "mob/ghast/moan6",
    "mob/ghast/moan7",
    "mob/ghast/scream1",
    "mob/ghast/scream2",
    "mob/ghast/scream3",
    "mob/ghast/scream4",
    "mob/ghast/scream5",
    "mob/ghastling/death",
    "mob/ghastling/ghastling1",
    "mob/ghastling/ghastling2",
    "mob/ghastling/ghastling3",
    "mob/ghastling/ghastling4",
    "mob/ghastling/ghastling5",
    "mob/ghastling/ghastling6",
    "mob/ghastling/ghastling7",
    "mob/ghastling/hurt1",
    "mob/ghastling/hurt2",
    "mob/ghastling/hurt3",
    "mob/ghastling/hurt4",
    "mob/ghastling/hurt5",
    "mob/ghastling/spawn",
    "mob/glow_squid/ambient1",
    "mob/glow_squid/ambient2",
    "mob/glow_squid/ambient3",
    "mob/glow_squid/ambient4",
    "mob/glow_squid/ambient5",
    "mob/glow_squid/death1",
    "mob/glow_squid/death2",
    "mob/glow_squid/death3",
    "mob/glow_squid/hurt1",
    "mob/glow_squid/hurt2",
    "mob/glow_squid/hurt3",
    "mob/glow_squid/hurt4",
    "mob/glow_squid/squirt1",
    "mob/glow_squid/squirt2",
    "mob/glow_squid/squirt3",
    "mob/goat/death1",
    "mob/goat/death2",
    "mob/goat/death3",
    "mob/goat/death4",
    "mob/goat/death5",
    "mob/goat/eat1",
    "mob/goat/eat2",
    "mob/goat/eat3",
    "mob/goat/horn_break1",
    "mob/goat/horn_break2",
    "mob/goat/horn_break3",
    "mob/goat/horn_break4",
    "mob/goat/hurt1",
    "mob/goat/hurt2",
    "mob/goat/hurt3",
    "mob/goat/hurt4",
    "mob/goat/idle1",
    "mob/goat/idle2",
    "mob/goat/idle3",
    "mob/goat/idle4",
    "mob/goat/idle5",
    "mob/goat/idle6",
    "mob/goat/idle7",
    "mob/goat/idle8",
    "mob/goat/impact1",
    "mob/goat/impact2",
    "mob/goat/impact3",
    "mob/goat/jump1",
    "mob/goat/jump2",
    "mob/goat/pre_ram1",
    "mob/goat/pre_ram2",
    "mob/goat/pre_ram3",
    "mob/goat/pre_ram4",
    "mob/goat/scream1",
    "mob/goat/scream2",
    "mob/goat/scream3",
    "mob/goat/scream4",
    "mob/goat/scream5",
    "mob/goat/scream6",
    "mob/goat/scream7",
    "mob/goat/scream8",
    "mob/goat/scream9",
    "mob/goat/screaming_death1",
    "mob/goat/screaming_death2",
    "mob/goat/screaming_death3",
    "mob/goat/screaming_hurt1",
    "mob/goat/screaming_hurt2",
    "mob/goat/screaming_hurt3",
    "mob/goat/screaming_milk1",
    "mob/goat/screaming_milk2",
    "mob/goat/screaming_milk3",
    "mob/goat/screaming_milk4",
    "mob/goat/screaming_milk5",
    "mob/goat/screaming_pre_ram1",
    "mob/goat/screaming_pre_ram2",
    "mob/goat/screaming_pre_ram3",
    "mob/goat/screaming_pre_ram4",
    "mob/goat/screaming_pre_ram5",
    "mob/goat/step1",
    "mob/goat/step2",
    "mob/goat/step3",
    "mob/goat/step4",
    "mob/goat/step5",
    "mob/goat/step6",
    "mob/guardian/attack_loop",
    "mob/guardian/curse",
    "mob/guardian/elder_death",
    "mob/guardian/elder_hit1",
    "mob/guardian/elder_hit2",
    "mob/guardian/elder_hit3",
    "mob/guardian/elder_hit4",
    "mob/guardian/elder_idle1",
    "mob/guardian/elder_idle2",
    "mob/guardian/elder_idle3",
    "mob/guardian/elder_idle4",
    "mob/guardian/flop1",
    "mob/guardian/flop2",
    "mob/guardian/flop3",
    "mob/guardian/flop4",
    "mob/guardian/guardian_death",
    "mob/guardian/guardian_hit1",
    "mob/guardian/guardian_hit2",
    "mob/guardian/guardian_hit3",
    "mob/guardian/guardian_hit4",
    "mob/guardian/guardian_idle1",
    "mob/guardian/guardian_idle2",
    "mob/guardian/guardian_idle3",
    "mob/guardian/guardian_idle4",
    "mob/guardian/land_death",
    "mob/guardian/land_hit1",
    "mob/guardian/land_hit2",
    "mob/guardian/land_hit3",
    "mob/guardian/land_hit4",
    "mob/guardian/land_idle1",
    "mob/guardian/land_idle2",
    "mob/guardian/land_idle3",
    "mob/guardian/land_idle4",
    "mob/happy_ghast/ambient1",
    "mob/happy_ghast/ambient10",
    "mob/happy_ghast/ambient11",
    "mob/happy_ghast/ambient12",
    "mob/happy_ghast/ambient13",
    "mob/happy_ghast/ambient14",
    "mob/happy_ghast/ambient2",
    "mob/happy_ghast/ambient3",
    "mob/happy_ghast/ambient4",
    "mob/happy_ghast/ambient5",
    "mob/happy_ghast/ambient6",
    "mob/happy_ghast/ambient7",
    "mob/happy_ghast/ambient8",
    "mob/happy_ghast/ambient9",
    "mob/happy_ghast/death",
    "mob/happy_ghast/ghast_ride",
    "mob/happy_ghast/goggles_down",
    "mob/happy_ghast/goggles_up",
    "mob/happy_ghast/harness_equip",
    "mob/happy_ghast/harness_unequip",
    "mob/happy_ghast/hurt1",
    "mob/happy_ghast/hurt2",
    "mob/happy_ghast/hurt3",
    "mob/happy_ghast/hurt4",
    "mob/happy_ghast/hurt5",
    "mob/happy_ghast/hurt6",
    "mob/hoglin/angry1",
    "mob/hoglin/angry2",
    "mob/hoglin/angry3",
    "mob/hoglin/angry4",
    "mob/hoglin/angry5",
    "mob/hoglin/angry6",
    "mob/hoglin/attack1",
    "mob/hoglin/attack2",
    "mob/hoglin/converted1",
    "mob/hoglin/converted2",
    "mob/hoglin/death1",
    "mob/hoglin/death2",
    "mob/hoglin/death3",
    "mob/hoglin/hurt1",
    "mob/hoglin/hurt2",
    "mob/hoglin/hurt3",
    "mob/hoglin/hurt4",
    "mob/hoglin/idle1",
    "mob/hoglin/idle10",
    "mob/hoglin/idle11",
    "mob/hoglin/idle2",
    "mob/hoglin/idle3",
    "mob/hoglin/idle4",
    "mob/hoglin/idle5",
    "mob/hoglin/idle6",
    "mob/hoglin/idle7",
    "mob/hoglin/idle8",
    "mob/hoglin/idle9",
    "mob/hoglin/retreat1",
    "mob/hoglin/retreat2",
    "mob/hoglin/retreat3",
    "mob/hoglin/step1",
    "mob/hoglin/step2",
    "mob/hoglin/step3",
    "mob/hoglin/step4",
    "mob/hoglin/step5",
    "mob/hoglin/step6",
    "mob/horse/angry1",
    "mob/horse/armor",
    "mob/horse/armor_unequip",
    "mob/horse/baby_horse/ambient1",
    "mob/horse/baby_horse/ambient2",
    "mob/horse/baby_horse/ambient3",
    "mob/horse/baby_horse/ambient4",
    "mob/horse/baby_horse/ambient5",
    "mob/horse/baby_horse/ambient6",
    "mob/horse/baby_horse/ambient7",
    "mob/horse/baby_horse/ambient8",
    "mob/horse/baby_horse/angry",
    "mob/horse/baby_horse/death",
    "mob/horse/baby_horse/eat1",
    "mob/horse/baby_horse/eat2",
    "mob/horse/baby_horse/eat3",
    "mob/horse/baby_horse/eat4",
    "mob/horse/baby_horse/eat5",
    "mob/horse/baby_horse/hurt1",
    "mob/horse/baby_horse/hurt2",
    "mob/horse/baby_horse/hurt3",
    "mob/horse/baby_horse/land",
    "mob/horse/baby_horse/step1",
    "mob/horse/baby_horse/step2",
    "mob/horse/baby_horse/step3",
    "mob/horse/baby_horse/step4",
    "mob/horse/baby_horse/step5",
    "mob/horse/baby_horse/step6",
    "mob/horse/breathe1",
    "mob/horse/breathe2",
    "mob/horse/breathe3",
    "mob/horse/death",
    "mob/horse/donkey/angry1",
    "mob/horse/donkey/angry2",
    "mob/horse/donkey/death",
    "mob/horse/donkey/hit1",
    "mob/horse/donkey/hit2",
    "mob/horse/donkey/hit3",
    "mob/horse/donkey/idle1",
    "mob/horse/donkey/idle2",
    "mob/horse/donkey/idle3",
    "mob/horse/eat1",
    "mob/horse/eat2",
    "mob/horse/eat3",
    "mob/horse/eat4",
    "mob/horse/eat5",
    "mob/horse/gallop1",
    "mob/horse/gallop2",
    "mob/horse/gallop3",
    "mob/horse/gallop4",
    "mob/horse/hit1",
    "mob/horse/hit2",
    "mob/horse/hit3",
    "mob/horse/hit4",
    "mob/horse/idle1",
    "mob/horse/idle2",
    "mob/horse/idle3",
    "mob/horse/jump",
    "mob/horse/land",
    "mob/horse/leather",
    "mob/horse/saddle_unequip",
    "mob/horse/skeleton/death",
    "mob/horse/skeleton/hit1",
    "mob/horse/skeleton/hit2",
    "mob/horse/skeleton/hit3",
    "mob/horse/skeleton/hit4",
    "mob/horse/skeleton/idle1",
    "mob/horse/skeleton/idle2",
    "mob/horse/skeleton/idle3",
    "mob/horse/skeleton/water/gallop1",
    "mob/horse/skeleton/water/gallop2",
    "mob/horse/skeleton/water/gallop3",
    "mob/horse/skeleton/water/gallop4",
    "mob/horse/skeleton/water/idle1",
    "mob/horse/skeleton/water/idle2",
    "mob/horse/skeleton/water/idle3",
    "mob/horse/skeleton/water/idle4",
    "mob/horse/skeleton/water/idle5",
    "mob/horse/skeleton/water/jump",
    "mob/horse/skeleton/water/soft1",
    "mob/horse/skeleton/water/soft2",
    "mob/horse/skeleton/water/soft3",
    "mob/horse/skeleton/water/soft4",
    "mob/horse/skeleton/water/soft5",
    "mob/horse/skeleton/water/soft6",
    "mob/horse/soft1",
    "mob/horse/soft2",
    "mob/horse/soft3",
    "mob/horse/soft4",
    "mob/horse/soft5",
    "mob/horse/soft6",
    "mob/horse/wood1",
    "mob/horse/wood2",
    "mob/horse/wood3",
    "mob/horse/wood4",
    "mob/horse/wood5",
    "mob/horse/wood6",
    "mob/horse/zombie/angry",
    "mob/horse/zombie/death",
    "mob/horse/zombie/hit1",
    "mob/horse/zombie/hit2",
    "mob/horse/zombie/hit3",
    "mob/horse/zombie/hit4",
    "mob/horse/zombie/idle1",
    "mob/horse/zombie/idle2",
    "mob/horse/zombie/idle3",
    "mob/husk/convert1",
    "mob/husk/convert2",
    "mob/husk/death1",
    "mob/husk/death2",
    "mob/husk/hurt1",
    "mob/husk/hurt2",
    "mob/husk/idle1",
    "mob/husk/idle2",
    "mob/husk/idle3",
    "mob/husk/step1",
    "mob/husk/step2",
    "mob/husk/step3",
    "mob/husk/step4",
    "mob/husk/step5",
    "mob/illusion_illager/death1",
    "mob/illusion_illager/death2",
    "mob/illusion_illager/hurt1",
    "mob/illusion_illager/hurt2",
    "mob/illusion_illager/hurt3",
    "mob/illusion_illager/idle1",
    "mob/illusion_illager/idle2",
    "mob/illusion_illager/idle3",
    "mob/illusion_illager/idle4",
    "mob/illusion_illager/mirror_move1",
    "mob/illusion_illager/mirror_move2",
    "mob/illusion_illager/prepare_blind",
    "mob/illusion_illager/prepare_mirror",
    "mob/irongolem/damage1",
    "mob/irongolem/damage2",
    "mob/irongolem/death",
    "mob/irongolem/hit1",
    "mob/irongolem/hit2",
    "mob/irongolem/hit3",
    "mob/irongolem/hit4",
    "mob/irongolem/repair",
    "mob/irongolem/throw",
    "mob/irongolem/walk1",
    "mob/irongolem/walk2",
    "mob/irongolem/walk3",
    "mob/irongolem/walk4",
    "mob/llama/angry1",
    "mob/llama/death1",
    "mob/llama/death2",
    "mob/llama/eat1",
    "mob/llama/eat2",
    "mob/llama/eat3",
    "mob/llama/hurt1",
    "mob/llama/hurt2",
    "mob/llama/hurt3",
    "mob/llama/idle1",
    "mob/llama/idle2",
    "mob/llama/idle3",
    "mob/llama/idle4",
    "mob/llama/idle5",
    "mob/llama/spit1",
    "mob/llama/spit2",
    "mob/llama/step1",
    "mob/llama/step2",
    "mob/llama/step3",
    "mob/llama/step4",
    "mob/llama/step5",
    "mob/llama/swag",
    "mob/llama/unequip",
    "mob/magmacube/big1",
    "mob/magmacube/big2",
    "mob/magmacube/big3",
    "mob/magmacube/big4",
    "mob/magmacube/jump1",
    "mob/magmacube/jump2",
    "mob/magmacube/jump3",
    "mob/magmacube/jump4",
    "mob/magmacube/small1",
    "mob/magmacube/small2",
    "mob/magmacube/small3",
    "mob/magmacube/small4",
    "mob/magmacube/small5",
    "mob/mooshroom/convert1",
    "mob/mooshroom/convert2",
    "mob/mooshroom/eat1",
    "mob/mooshroom/eat2",
    "mob/mooshroom/eat3",
    "mob/mooshroom/eat4",
    "mob/mooshroom/milk1",
    "mob/mooshroom/milk2",
    "mob/mooshroom/milk3",
    "mob/nautilus/ambient1",
    "mob/nautilus/ambient2",
    "mob/nautilus/ambient3",
    "mob/nautilus/ambient4",
    "mob/nautilus/ambient5",
    "mob/nautilus/ambient6",
    "mob/nautilus/ambient7",
    "mob/nautilus/ambient8",
    "mob/nautilus/ambient_land1",
    "mob/nautilus/ambient_land2",
    "mob/nautilus/ambient_land3",
    "mob/nautilus/ambient_land4",
    "mob/nautilus/ambient_land5",
    "mob/nautilus/ambient_land6",
    "mob/nautilus/ambient_land7",
    "mob/nautilus/dash1",
    "mob/nautilus/dash2",
    "mob/nautilus/dash3",
    "mob/nautilus/dash4",
    "mob/nautilus/dash_land1",
    "mob/nautilus/dash_land2",
    "mob/nautilus/dash_land3",
    "mob/nautilus/dash_land4",
    "mob/nautilus/dash_ready1",
    "mob/nautilus/dash_ready2",
    "mob/nautilus/dash_ready3",
    "mob/nautilus/dash_ready_land1",
    "mob/nautilus/dash_ready_land2",
    "mob/nautilus/dash_ready_land3",
    "mob/nautilus/dash_ready_land4",
    "mob/nautilus/death",
    "mob/nautilus/death_land",
    "mob/nautilus/eat1",
    "mob/nautilus/eat2",
    "mob/nautilus/hurt1",
    "mob/nautilus/hurt2",
    "mob/nautilus/hurt3",
    "mob/nautilus/hurt4",
    "mob/nautilus/hurt_land1",
    "mob/nautilus/hurt_land2",
    "mob/nautilus/hurt_land3",
    "mob/nautilus/hurt_land4",
    "mob/nautilus/nautilus_saddle_equip",
    "mob/nautilus/nautilus_saddle_underwater_equip",
    "mob/nautilus/ride",
    "mob/nautilus/swim1",
    "mob/nautilus/swim2",
    "mob/nautilus/swim3",
    "mob/nautilus/swim4",
    "mob/nautilus/swim5",
    "mob/nautilus/swim6",
    "mob/nautilus/swim7",
    "mob/nautilus/swim8",
    "mob/nautilus/swim9",
    "mob/panda/aggressive/aggressive1",
    "mob/panda/aggressive/aggressive2",
    "mob/panda/aggressive/aggressive3",
    "mob/panda/aggressive/aggressive4",
    "mob/panda/bite1",
    "mob/panda/bite2",
    "mob/panda/bite3",
    "mob/panda/cant_breed1",
    "mob/panda/cant_breed2",
    "mob/panda/cant_breed3",
    "mob/panda/cant_breed4",
    "mob/panda/cant_breed5",
    "mob/panda/death1",
    "mob/panda/death2",
    "mob/panda/death3",
    "mob/panda/death4",
    "mob/panda/eat1",
    "mob/panda/eat10",
    "mob/panda/eat11",
    "mob/panda/eat12",
    "mob/panda/eat2",
    "mob/panda/eat3",
    "mob/panda/eat4",
    "mob/panda/eat5",
    "mob/panda/eat6",
    "mob/panda/eat7",
    "mob/panda/eat8",
    "mob/panda/eat9",
    "mob/panda/hurt1",
    "mob/panda/hurt2",
    "mob/panda/hurt3",
    "mob/panda/hurt4",
    "mob/panda/hurt5",
    "mob/panda/hurt6",
    "mob/panda/idle1",
    "mob/panda/idle2",
    "mob/panda/idle3",
    "mob/panda/idle4",
    "mob/panda/nosebreath1",
    "mob/panda/nosebreath2",
    "mob/panda/nosebreath3",
    "mob/panda/pant1",
    "mob/panda/pant2",
    "mob/panda/pre_sneeze",
    "mob/panda/sneeze1",
    "mob/panda/sneeze2",
    "mob/panda/sneeze3",
    "mob/panda/step1",
    "mob/panda/step2",
    "mob/panda/step3",
    "mob/panda/step4",
    "mob/panda/step5",
    "mob/panda/worried/worried1",
    "mob/panda/worried/worried2",
    "mob/panda/worried/worried3",
    "mob/panda/worried/worried4",
    "mob/panda/worried/worried5",
    "mob/panda/worried/worried6",
    "mob/parched/ambient1",
    "mob/parched/ambient2",
    "mob/parched/ambient3",
    "mob/parched/ambient4",
    "mob/parched/death",
    "mob/parched/hurt1",
    "mob/parched/hurt2",
    "mob/parched/hurt3",
    "mob/parched/hurt4",
    "mob/parched/step1",
    "mob/parched/step2",
    "mob/parched/step3",
    "mob/parched/step4",
    "mob/parrot/death1",
    "mob/parrot/death2",
    "mob/parrot/death3",
    "mob/parrot/death4",
    "mob/parrot/eat1",
    "mob/parrot/eat2",
    "mob/parrot/eat3",
    "mob/parrot/fly1",
    "mob/parrot/fly2",
    "mob/parrot/fly3",
    "mob/parrot/fly4",
    "mob/parrot/fly5",
    "mob/parrot/fly6",
    "mob/parrot/fly7",
    "mob/parrot/fly8",
    "mob/parrot/hurt1",
    "mob/parrot/hurt2",
    "mob/parrot/idle1",
    "mob/parrot/idle2",
    "mob/parrot/idle3",
    "mob/parrot/idle4",
    "mob/parrot/idle5",
    "mob/parrot/idle6",
    "mob/parrot/step1",
    "mob/parrot/step2",
    "mob/parrot/step3",
    "mob/parrot/step4",
    "mob/parrot/step5",
    "mob/phantom/bite1",
    "mob/phantom/bite2",
    "mob/phantom/death1",
    "mob/phantom/death2",
    "mob/phantom/death3",
    "mob/phantom/flap1",
    "mob/phantom/flap2",
    "mob/phantom/flap3",
    "mob/phantom/flap4",
    "mob/phantom/flap5",
    "mob/phantom/flap6",
    "mob/phantom/hurt1",
    "mob/phantom/hurt2",
    "mob/phantom/hurt3",
    "mob/phantom/idle1",
    "mob/phantom/idle2",
    "mob/phantom/idle3",
    "mob/phantom/idle4",
    "mob/phantom/idle5",
    "mob/phantom/swoop1",
    "mob/phantom/swoop2",
    "mob/phantom/swoop3",
    "mob/phantom/swoop4",
    "mob/pig/baby_pig/ambient1",
    "mob/pig/baby_pig/ambient2",
    "mob/pig/baby_pig/ambient3",
    "mob/pig/baby_pig/ambient4",
    "mob/pig/baby_pig/ambient5",
    "mob/pig/baby_pig/ambient6",
    "mob/pig/baby_pig/death",
    "mob/pig/baby_pig/eat1",
    "mob/pig/baby_pig/eat2",
    "mob/pig/baby_pig/hit1",
    "mob/pig/baby_pig/hit2",
    "mob/pig/baby_pig/hit3",
    "mob/pig/baby_pig/step1",
    "mob/pig/baby_pig/step2",
    "mob/pig/baby_pig/step3",
    "mob/pig/baby_pig/step4",
    "mob/pig/baby_pig/step5",
    "mob/pig/big/ambient1",
    "mob/pig/big/ambient2",
    "mob/pig/big/ambient3",
    "mob/pig/big/ambient4",
    "mob/pig/big/ambient5",
    "mob/pig/big/ambient6",
    "mob/pig/big/ambient7",
    "mob/pig/big/ambient8",
    "mob/pig/big/ambient9",
    "mob/pig/big/death",
    "mob/pig/big/eat1",
    "mob/pig/big/eat2",
    "mob/pig/big/hit1",
    "mob/pig/big/hit2",
    "mob/pig/big/hit3",
    "mob/pig/death",
    "mob/pig/eat1",
    "mob/pig/eat2",
    "mob/pig/mini/ambient1",
    "mob/pig/mini/ambient2",
    "mob/pig/mini/ambient3",
    "mob/pig/mini/ambient4",
    "mob/pig/mini/ambient5",
    "mob/pig/mini/ambient6",
    "mob/pig/mini/death",
    "mob/pig/mini/eat1",
    "mob/pig/mini/eat2",
    "mob/pig/mini/hurt1",
    "mob/pig/mini/hurt2",
    "mob/pig/mini/hurt3",
    "mob/pig/say1",
    "mob/pig/say2",
    "mob/pig/say3",
    "mob/pig/step1",
    "mob/pig/step2",
    "mob/pig/step3",
    "mob/pig/step4",
    "mob/pig/step5",
    "mob/piglin/admire1",
    "mob/piglin/admire2",
    "mob/piglin/angry1",
    "mob/piglin/angry2",
    "mob/piglin/angry3",
    "mob/piglin/angry4",
    "mob/piglin/celebrate1",
    "mob/piglin/celebrate2",
    "mob/piglin/celebrate3",
    "mob/piglin/celebrate4",
    "mob/piglin/converted1",
    "mob/piglin/converted2",
    "mob/piglin/death1",
    "mob/piglin/death2",
    "mob/piglin/death3",
    "mob/piglin/death4",
    "mob/piglin/hurt1",
    "mob/piglin/hurt2",
    "mob/piglin/hurt3",
    "mob/piglin/idle1",
    "mob/piglin/idle2",
    "mob/piglin/idle3",
    "mob/piglin/idle4",
    "mob/piglin/idle5",
    "mob/piglin/jealous1",
    "mob/piglin/jealous2",
    "mob/piglin/jealous3",
    "mob/piglin/jealous4",
    "mob/piglin/jealous5",
    "mob/piglin/retreat1",
    "mob/piglin/retreat2",
    "mob/piglin/retreat3",
    "mob/piglin/retreat4",
    "mob/piglin/step1",
    "mob/piglin/step2",
    "mob/piglin/step3",
    "mob/piglin/step4",
    "mob/piglin/step5",
    "mob/piglin_brute/angry1",
    "mob/piglin_brute/angry2",
    "mob/piglin_brute/angry3",
    "mob/piglin_brute/angry4",
    "mob/piglin_brute/angry5",
    "mob/piglin_brute/death1",
    "mob/piglin_brute/death2",
    "mob/piglin_brute/death3",
    "mob/piglin_brute/hurt1",
    "mob/piglin_brute/hurt2",
    "mob/piglin_brute/hurt3",
    "mob/piglin_brute/hurt4",
    "mob/piglin_brute/idle1",
    "mob/piglin_brute/idle2",
    "mob/piglin_brute/idle3",
    "mob/piglin_brute/idle4",
    "mob/piglin_brute/idle5",
    "mob/piglin_brute/idle6",
    "mob/piglin_brute/idle7",
    "mob/piglin_brute/idle8",
    "mob/piglin_brute/idle9",
    "mob/piglin_brute/step1",
    "mob/piglin_brute/step2",
    "mob/piglin_brute/step3",
    "mob/piglin_brute/step4",
    "mob/piglin_brute/step5",
    "mob/pillager/celebrate1",
    "mob/pillager/celebrate2",
    "mob/pillager/celebrate3",
    "mob/pillager/celebrate4",
    "mob/pillager/death1",
    "mob/pillager/death2",
    "mob/pillager/horn_celebrate",
    "mob/pillager/hurt1",
    "mob/pillager/hurt2",
    "mob/pillager/hurt3",
    "mob/pillager/idle1",
    "mob/pillager/idle2",
    "mob/pillager/idle3",
    "mob/pillager/idle4",
    "mob/polarbear/death1",
    "mob/polarbear/death2",
    "mob/polarbear/death3",
    "mob/polarbear/hurt1",
    "mob/polarbear/hurt2",
    "mob/polarbear/hurt3",
    "mob/polarbear/hurt4",
    "mob/polarbear/idle1",
    "mob/polarbear/idle2",
    "mob/polarbear/idle3",
    "mob/polarbear/idle4",
    "mob/polarbear/step1",
    "mob/polarbear/step2",
    "mob/polarbear/step3",
    "mob/polarbear/step4",
    "mob/polarbear/warning1",
    "mob/polarbear/warning2",
    "mob/polarbear/warning3",
    "mob/polarbear_baby/idle1",
    "mob/polarbear_baby/idle2",
    "mob/polarbear_baby/idle3",
    "mob/polarbear_baby/idle4",
    "mob/pufferfish/blow_out1",
    "mob/pufferfish/blow_out2",
    "mob/pufferfish/blow_up1",
    "mob/pufferfish/blow_up2",
    "mob/pufferfish/death1",
    "mob/pufferfish/death2",
    "mob/pufferfish/flop1",
    "mob/pufferfish/flop2",
    "mob/pufferfish/flop3",
    "mob/pufferfish/flop4",
    "mob/pufferfish/hurt1",
    "mob/pufferfish/hurt2",
    "mob/pufferfish/sting1",
    "mob/pufferfish/sting2",
    "mob/rabbit/attack1",
    "mob/rabbit/attack2",
    "mob/rabbit/attack3",
    "mob/rabbit/attack4",
    "mob/rabbit/bunnymurder",
    "mob/rabbit/hop1",
    "mob/rabbit/hop2",
    "mob/rabbit/hop3",
    "mob/rabbit/hop4",
    "mob/rabbit/hurt1",
    "mob/rabbit/hurt2",
    "mob/rabbit/hurt3",
    "mob/rabbit/hurt4",
    "mob/rabbit/idle1",
    "mob/rabbit/idle2",
    "mob/rabbit/idle3",
    "mob/rabbit/idle4",
    "mob/ravager/bite1",
    "mob/ravager/bite2",
    "mob/ravager/bite3",
    "mob/ravager/celebrate1",
    "mob/ravager/celebrate2",
    "mob/ravager/death1",
    "mob/ravager/death2",
    "mob/ravager/death3",
    "mob/ravager/hurt1",
    "mob/ravager/hurt2",
    "mob/ravager/hurt3",
    "mob/ravager/hurt4",
    "mob/ravager/idle1",
    "mob/ravager/idle2",
    "mob/ravager/idle3",
    "mob/ravager/idle4",
    "mob/ravager/idle5",
    "mob/ravager/idle6",
    "mob/ravager/idle7",
    "mob/ravager/idle8",
    "mob/ravager/roar1",
    "mob/ravager/roar2",
    "mob/ravager/roar3",
    "mob/ravager/roar4",
    "mob/ravager/step1",
    "mob/ravager/step2",
    "mob/ravager/step3",
    "mob/ravager/step4",
    "mob/ravager/step5",
    "mob/ravager/stun1",
    "mob/ravager/stun2",
    "mob/ravager/stun3",
    "mob/sheep/say1",
    "mob/sheep/say2",
    "mob/sheep/say3",
    "mob/sheep/shear",
    "mob/sheep/step1",
    "mob/sheep/step2",
    "mob/sheep/step3",
    "mob/sheep/step4",
    "mob/sheep/step5",
    "mob/silverfish/hit1",
    "mob/silverfish/hit2",
    "mob/silverfish/hit3",
    "mob/silverfish/kill",
    "mob/silverfish/say1",
    "mob/silverfish/say2",
    "mob/silverfish/say3",
    "mob/silverfish/say4",
    "mob/silverfish/step1",
    "mob/silverfish/step2",
    "mob/silverfish/step3",
    "mob/silverfish/step4",
    "mob/skeleton/death",
    "mob/skeleton/hurt1",
    "mob/skeleton/hurt2",
    "mob/skeleton/hurt3",
    "mob/skeleton/hurt4",
    "mob/skeleton/say1",
    "mob/skeleton/say2",
    "mob/skeleton/say3",
    "mob/skeleton/step1",
    "mob/skeleton/step2",
    "mob/skeleton/step3",
    "mob/skeleton/step4",
    "mob/slime/attack1",
    "mob/slime/attack2",
    "mob/slime/big1",
    "mob/slime/big2",
    "mob/slime/big3",
    "mob/slime/big4",
    "mob/slime/small1",
    "mob/slime/small2",
    "mob/slime/small3",
    "mob/slime/small4",
    "mob/slime/small5",
    "mob/sniffer/death1",
    "mob/sniffer/death2",
    "mob/sniffer/digging_stop1",
    "mob/sniffer/digging_stop2",
    "mob/sniffer/eat1",
    "mob/sniffer/eat2",
    "mob/sniffer/eat3",
    "mob/sniffer/happy1",
    "mob/sniffer/happy2",
    "mob/sniffer/happy3",
    "mob/sniffer/happy4",
    "mob/sniffer/happy5",
    "mob/sniffer/hurt1",
    "mob/sniffer/hurt2",
    "mob/sniffer/hurt3",
    "mob/sniffer/idle1",
    "mob/sniffer/idle10",
    "mob/sniffer/idle11",
    "mob/sniffer/idle2",
    "mob/sniffer/idle3",
    "mob/sniffer/idle4",
    "mob/sniffer/idle5",
    "mob/sniffer/idle6",
    "mob/sniffer/idle7",
    "mob/sniffer/idle8",
    "mob/sniffer/idle9",
    "mob/sniffer/longdig1",
    "mob/sniffer/longdig2",
    "mob/sniffer/scenting1",
    "mob/sniffer/scenting2",
    "mob/sniffer/scenting3",
    "mob/sniffer/searching1",
    "mob/sniffer/searching2",
    "mob/sniffer/searching3",
    "mob/sniffer/searching4",
    "mob/sniffer/searching5",
    "mob/sniffer/searching6",
    "mob/sniffer/sniffing1",
    "mob/sniffer/sniffing2",
    "mob/sniffer/sniffing3",
    "mob/sniffer/step1",
    "mob/sniffer/step2",
    "mob/sniffer/step3",
    "mob/sniffer/step4",
    "mob/sniffer/step5",
    "mob/sniffer/step6",
    "mob/spider/death",
    "mob/spider/say1",
    "mob/spider/say2",
    "mob/spider/say3",
    "mob/spider/say4",
    "mob/spider/step1",
    "mob/spider/step2",
    "mob/spider/step3",
    "mob/spider/step4",
    "mob/squid/ambient1",
    "mob/squid/ambient2",
    "mob/squid/ambient3",
    "mob/squid/ambient4",
    "mob/squid/ambient5",
    "mob/squid/death1",
    "mob/squid/death2",
    "mob/squid/death3",
    "mob/squid/hurt1",
    "mob/squid/hurt2",
    "mob/squid/hurt3",
    "mob/squid/hurt4",
    "mob/squid/squirt1",
    "mob/squid/squirt2",
    "mob/squid/squirt3",
    "mob/stray/convert1",
    "mob/stray/convert2",
    "mob/stray/convert3",
    "mob/stray/death1",
    "mob/stray/death2",
    "mob/stray/hurt1",
    "mob/stray/hurt2",
    "mob/stray/hurt3",
    "mob/stray/hurt4",
    "mob/stray/idle1",
    "mob/stray/idle2",
    "mob/stray/idle3",
    "mob/stray/idle4",
    "mob/stray/step1",
    "mob/stray/step2",
    "mob/stray/step3",
    "mob/stray/step4",
    "mob/strider/death1",
    "mob/strider/death2",
    "mob/strider/death3",
    "mob/strider/death4",
    "mob/strider/eat1",
    "mob/strider/eat2",
    "mob/strider/eat3",
    "mob/strider/happy1",
    "mob/strider/happy2",
    "mob/strider/happy3",
    "mob/strider/happy4",
    "mob/strider/happy5",
    "mob/strider/hurt1",
    "mob/strider/hurt2",
    "mob/strider/hurt3",
    "mob/strider/hurt4",
    "mob/strider/idle1",
    "mob/strider/idle2",
    "mob/strider/idle3",
    "mob/strider/idle4",
    "mob/strider/idle5",
    "mob/strider/idle6",
    "mob/strider/retreat1",
    "mob/strider/retreat2",
    "mob/strider/retreat3",
    "mob/strider/retreat4",
    "mob/strider/retreat5",
    "mob/strider/step1",
    "mob/strider/step2",
    "mob/strider/step3",
    "mob/strider/step4",
    "mob/strider/step5",
    "mob/strider/step_lava1",
    "mob/strider/step_lava2",
    "mob/strider/step_lava3",
    "mob/strider/step_lava4",
    "mob/strider/step_lava5",
    "mob/strider/step_lava6",
    "mob/sulfur_cube/absorb1",
    "mob/sulfur_cube/absorb2",
    "mob/sulfur_cube/ball/bounce1",
    "mob/sulfur_cube/ball/bounce2",
    "mob/sulfur_cube/ball/bounce3",
    "mob/sulfur_cube/ball/bounce4",
    "mob/sulfur_cube/ball/bounce5",
    "mob/sulfur_cube/ball/bounce6",
    "mob/sulfur_cube/ball/bounce7",
    "mob/sulfur_cube/ball/bounce8",
    "mob/sulfur_cube/ball/bouncy_hit1",
    "mob/sulfur_cube/ball/bouncy_hit2",
    "mob/sulfur_cube/ball/bouncy_hit3",
    "mob/sulfur_cube/ball/bouncy_hit4",
    "mob/sulfur_cube/ball/bouncy_push1",
    "mob/sulfur_cube/ball/bouncy_push2",
    "mob/sulfur_cube/ball/bouncy_push3",
    "mob/sulfur_cube/ball/bouncy_push4",
    "mob/sulfur_cube/ball/explosive_hit1",
    "mob/sulfur_cube/ball/explosive_hit2",
    "mob/sulfur_cube/ball/explosive_hit3",
    "mob/sulfur_cube/ball/explosive_hit4",
    "mob/sulfur_cube/ball/explosive_push1",
    "mob/sulfur_cube/ball/explosive_push2",
    "mob/sulfur_cube/ball/explosive_push3",
    "mob/sulfur_cube/ball/explosive_push4",
    "mob/sulfur_cube/ball/fastflat_hit1",
    "mob/sulfur_cube/ball/fastflat_hit2",
    "mob/sulfur_cube/ball/fastflat_hit3",
    "mob/sulfur_cube/ball/fastflat_hit4",
    "mob/sulfur_cube/ball/fastflat_push1",
    "mob/sulfur_cube/ball/fastflat_push2",
    "mob/sulfur_cube/ball/fastflat_push3",
    "mob/sulfur_cube/ball/fastflat_push4",
    "mob/sulfur_cube/ball/fastsliding_hit1",
    "mob/sulfur_cube/ball/fastsliding_hit2",
    "mob/sulfur_cube/ball/fastsliding_hit3",
    "mob/sulfur_cube/ball/fastsliding_hit4",
    "mob/sulfur_cube/ball/fastsliding_push1",
    "mob/sulfur_cube/ball/fastsliding_push2",
    "mob/sulfur_cube/ball/fastsliding_push3",
    "mob/sulfur_cube/ball/fastsliding_push4",
    "mob/sulfur_cube/ball/highresistance_hit1",
    "mob/sulfur_cube/ball/highresistance_hit2",
    "mob/sulfur_cube/ball/highresistance_hit3",
    "mob/sulfur_cube/ball/highresistance_hit4",
    "mob/sulfur_cube/ball/highresistance_push1",
    "mob/sulfur_cube/ball/highresistance_push2",
    "mob/sulfur_cube/ball/highresistance_push3",
    "mob/sulfur_cube/ball/highresistance_push4",
    "mob/sulfur_cube/ball/hot_hit1",
    "mob/sulfur_cube/ball/hot_hit2",
    "mob/sulfur_cube/ball/hot_hit3",
    "mob/sulfur_cube/ball/hot_hit4",
    "mob/sulfur_cube/ball/hot_push1",
    "mob/sulfur_cube/ball/hot_push2",
    "mob/sulfur_cube/ball/hot_push3",
    "mob/sulfur_cube/ball/hot_push4",
    "mob/sulfur_cube/ball/light_hit1",
    "mob/sulfur_cube/ball/light_hit2",
    "mob/sulfur_cube/ball/light_hit3",
    "mob/sulfur_cube/ball/light_hit4",
    "mob/sulfur_cube/ball/light_push1",
    "mob/sulfur_cube/ball/light_push2",
    "mob/sulfur_cube/ball/light_push3",
    "mob/sulfur_cube/ball/light_push4",
    "mob/sulfur_cube/ball/regular_hit1",
    "mob/sulfur_cube/ball/regular_hit2",
    "mob/sulfur_cube/ball/regular_hit3",
    "mob/sulfur_cube/ball/regular_hit4",
    "mob/sulfur_cube/ball/regular_push1",
    "mob/sulfur_cube/ball/regular_push2",
    "mob/sulfur_cube/ball/regular_push3",
    "mob/sulfur_cube/ball/regular_push4",
    "mob/sulfur_cube/ball/slowflat_hit1",
    "mob/sulfur_cube/ball/slowflat_hit2",
    "mob/sulfur_cube/ball/slowflat_hit3",
    "mob/sulfur_cube/ball/slowflat_hit4",
    "mob/sulfur_cube/ball/slowflat_push1",
    "mob/sulfur_cube/ball/slowflat_push2",
    "mob/sulfur_cube/ball/slowflat_push3",
    "mob/sulfur_cube/ball/slowflat_push4",
    "mob/sulfur_cube/ball/slowsliding_hit1",
    "mob/sulfur_cube/ball/slowsliding_hit2",
    "mob/sulfur_cube/ball/slowsliding_hit3",
    "mob/sulfur_cube/ball/slowsliding_hit4",
    "mob/sulfur_cube/ball/slowsliding_push1",
    "mob/sulfur_cube/ball/slowsliding_push2",
    "mob/sulfur_cube/ball/slowsliding_push3",
    "mob/sulfur_cube/ball/slowsliding_push4",
    "mob/sulfur_cube/ball/sticky_hit1",
    "mob/sulfur_cube/ball/sticky_hit2",
    "mob/sulfur_cube/ball/sticky_hit3",
    "mob/sulfur_cube/ball/sticky_hit4",
    "mob/sulfur_cube/ball/sticky_push1",
    "mob/sulfur_cube/ball/sticky_push2",
    "mob/sulfur_cube/ball/sticky_push3",
    "mob/sulfur_cube/ball/sticky_push4",
    "mob/sulfur_cube/death",
    "mob/sulfur_cube/eject1",
    "mob/sulfur_cube/eject2",
    "mob/sulfur_cube/hit1",
    "mob/sulfur_cube/hit2",
    "mob/sulfur_cube/hit3",
    "mob/sulfur_cube/hit4",
    "mob/sulfur_cube/jump1",
    "mob/sulfur_cube/jump10",
    "mob/sulfur_cube/jump11",
    "mob/sulfur_cube/jump2",
    "mob/sulfur_cube/jump3",
    "mob/sulfur_cube/jump4",
    "mob/sulfur_cube/jump5",
    "mob/sulfur_cube/jump6",
    "mob/sulfur_cube/jump7",
    "mob/sulfur_cube/jump8",
    "mob/sulfur_cube/jump9",
    "mob/sulfur_cube/small_sulfur_cube/death",
    "mob/sulfur_cube/small_sulfur_cube/eat1",
    "mob/sulfur_cube/small_sulfur_cube/eat2",
    "mob/sulfur_cube/small_sulfur_cube/hit1",
    "mob/sulfur_cube/small_sulfur_cube/hit2",
    "mob/sulfur_cube/small_sulfur_cube/hit3",
    "mob/sulfur_cube/small_sulfur_cube/hit4",
    "mob/sulfur_cube/small_sulfur_cube/jump1",
    "mob/sulfur_cube/small_sulfur_cube/jump10",
    "mob/sulfur_cube/small_sulfur_cube/jump11",
    "mob/sulfur_cube/small_sulfur_cube/jump2",
    "mob/sulfur_cube/small_sulfur_cube/jump3",
    "mob/sulfur_cube/small_sulfur_cube/jump4",
    "mob/sulfur_cube/small_sulfur_cube/jump5",
    "mob/sulfur_cube/small_sulfur_cube/jump6",
    "mob/sulfur_cube/small_sulfur_cube/jump7",
    "mob/sulfur_cube/small_sulfur_cube/jump8",
    "mob/sulfur_cube/small_sulfur_cube/jump9",
    "mob/sulfur_cube/small_sulfur_cube/squish1",
    "mob/sulfur_cube/small_sulfur_cube/squish10",
    "mob/sulfur_cube/small_sulfur_cube/squish2",
    "mob/sulfur_cube/small_sulfur_cube/squish3",
    "mob/sulfur_cube/small_sulfur_cube/squish4",
    "mob/sulfur_cube/small_sulfur_cube/squish5",
    "mob/sulfur_cube/small_sulfur_cube/squish6",
    "mob/sulfur_cube/small_sulfur_cube/squish7",
    "mob/sulfur_cube/small_sulfur_cube/squish8",
    "mob/sulfur_cube/small_sulfur_cube/squish9",
    "mob/sulfur_cube/squish1",
    "mob/sulfur_cube/squish10",
    "mob/sulfur_cube/squish11",
    "mob/sulfur_cube/squish2",
    "mob/sulfur_cube/squish3",
    "mob/sulfur_cube/squish4",
    "mob/sulfur_cube/squish5",
    "mob/sulfur_cube/squish6",
    "mob/sulfur_cube/squish7",
    "mob/sulfur_cube/squish8",
    "mob/sulfur_cube/squish9",
    "mob/tadpole/death1",
    "mob/tadpole/death2",
    "mob/tadpole/hurt1",
    "mob/tadpole/hurt2",
    "mob/tadpole/hurt3",
    "mob/tadpole/hurt4",
    "mob/turtle/armor",
    "mob/turtle/baby/death1",
    "mob/turtle/baby/death2",
    "mob/turtle/baby/egg_hatched1",
    "mob/turtle/baby/egg_hatched2",
    "mob/turtle/baby/egg_hatched3",
    "mob/turtle/baby/hurt1",
    "mob/turtle/baby/hurt2",
    "mob/turtle/baby/shamble1",
    "mob/turtle/baby/shamble2",
    "mob/turtle/baby/shamble3",
    "mob/turtle/baby/shamble4",
    "mob/turtle/death1",
    "mob/turtle/death2",
    "mob/turtle/death3",
    "mob/turtle/egg/drop_egg1",
    "mob/turtle/egg/drop_egg2",
    "mob/turtle/egg/egg_break1",
    "mob/turtle/egg/egg_break2",
    "mob/turtle/egg/egg_crack1",
    "mob/turtle/egg/egg_crack2",
    "mob/turtle/egg/egg_crack3",
    "mob/turtle/egg/egg_crack4",
    "mob/turtle/egg/egg_crack5",
    "mob/turtle/egg/jump_egg1",
    "mob/turtle/egg/jump_egg2",
    "mob/turtle/egg/jump_egg3",
    "mob/turtle/egg/jump_egg4",
    "mob/turtle/hurt1",
    "mob/turtle/hurt2",
    "mob/turtle/hurt3",
    "mob/turtle/hurt4",
    "mob/turtle/hurt5",
    "mob/turtle/idle1",
    "mob/turtle/idle2",
    "mob/turtle/idle3",
    "mob/turtle/swim/swim1",
    "mob/turtle/swim/swim2",
    "mob/turtle/swim/swim3",
    "mob/turtle/swim/swim4",
    "mob/turtle/swim/swim5",
    "mob/turtle/walk1",
    "mob/turtle/walk2",
    "mob/turtle/walk3",
    "mob/turtle/walk4",
    "mob/turtle/walk5",
    "mob/vex/charge1",
    "mob/vex/charge2",
    "mob/vex/charge3",
    "mob/vex/death1",
    "mob/vex/death2",
    "mob/vex/hurt1",
    "mob/vex/hurt2",
    "mob/vex/idle1",
    "mob/vex/idle2",
    "mob/vex/idle3",
    "mob/vex/idle4",
    "mob/villager/death",
    "mob/villager/haggle1",
    "mob/villager/haggle2",
    "mob/villager/haggle3",
    "mob/villager/hit1",
    "mob/villager/hit2",
    "mob/villager/hit3",
    "mob/villager/hit4",
    "mob/villager/idle1",
    "mob/villager/idle2",
    "mob/villager/idle3",
    "mob/villager/no1",
    "mob/villager/no2",
    "mob/villager/no3",
    "mob/villager/yes1",
    "mob/villager/yes2",
    "mob/villager/yes3",
    "mob/vindication_illager/celebrate1",
    "mob/vindication_illager/celebrate2",
    "mob/vindication_illager/death1",
    "mob/vindication_illager/death2",
    "mob/vindication_illager/hurt1",
    "mob/vindication_illager/hurt2",
    "mob/vindication_illager/hurt3",
    "mob/vindication_illager/idle1",
    "mob/vindication_illager/idle2",
    "mob/vindication_illager/idle3",
    "mob/vindication_illager/idle4",
    "mob/vindication_illager/idle5",
    "mob/wandering_trader/appeared1",
    "mob/wandering_trader/appeared2",
    "mob/wandering_trader/death",
    "mob/wandering_trader/disappeared1",
    "mob/wandering_trader/disappeared2",
    "mob/wandering_trader/drink_milk1",
    "mob/wandering_trader/drink_milk2",
    "mob/wandering_trader/drink_milk3",
    "mob/wandering_trader/drink_milk4",
    "mob/wandering_trader/drink_milk5",
    "mob/wandering_trader/drink_potion",
    "mob/wandering_trader/haggle1",
    "mob/wandering_trader/haggle2",
    "mob/wandering_trader/haggle3",
    "mob/wandering_trader/hurt1",
    "mob/wandering_trader/hurt2",
    "mob/wandering_trader/hurt3",
    "mob/wandering_trader/hurt4",
    "mob/wandering_trader/idle1",
    "mob/wandering_trader/idle2",
    "mob/wandering_trader/idle3",
    "mob/wandering_trader/idle4",
    "mob/wandering_trader/idle5",
    "mob/wandering_trader/no1",
    "mob/wandering_trader/no2",
    "mob/wandering_trader/no3",
    "mob/wandering_trader/no4",
    "mob/wandering_trader/no5",
    "mob/wandering_trader/reappeared1",
    "mob/wandering_trader/reappeared2",
    "mob/wandering_trader/yes1",
    "mob/wandering_trader/yes2",
    "mob/wandering_trader/yes3",
    "mob/wandering_trader/yes4",
    "mob/warden/agitated_1",
    "mob/warden/agitated_2",
    "mob/warden/agitated_3",
    "mob/warden/agitated_4",
    "mob/warden/agitated_5",
    "mob/warden/agitated_6",
    "mob/warden/ambient_1",
    "mob/warden/ambient_10",
    "mob/warden/ambient_11",
    "mob/warden/ambient_12",
    "mob/warden/ambient_2",
    "mob/warden/ambient_3",
    "mob/warden/ambient_4",
    "mob/warden/ambient_5",
    "mob/warden/ambient_6",
    "mob/warden/ambient_7",
    "mob/warden/ambient_8",
    "mob/warden/ambient_9",
    "mob/warden/angry_1",
    "mob/warden/angry_2",
    "mob/warden/angry_3",
    "mob/warden/angry_4",
    "mob/warden/angry_5",
    "mob/warden/angry_6",
    "mob/warden/attack_impact_1",
    "mob/warden/attack_impact_2",
    "mob/warden/death_1",
    "mob/warden/death_2",
    "mob/warden/dig",
    "mob/warden/emerge",
    "mob/warden/heartbeat_1",
    "mob/warden/heartbeat_2",
    "mob/warden/heartbeat_3",
    "mob/warden/heartbeat_4",
    "mob/warden/hurt_1",
    "mob/warden/hurt_2",
    "mob/warden/hurt_3",
    "mob/warden/hurt_4",
    "mob/warden/listening_1",
    "mob/warden/listening_2",
    "mob/warden/listening_3",
    "mob/warden/listening_4",
    "mob/warden/listening_5",
    "mob/warden/listening_angry_1",
    "mob/warden/listening_angry_2",
    "mob/warden/listening_angry_3",
    "mob/warden/listening_angry_4",
    "mob/warden/listening_angry_5",
    "mob/warden/nearby_close_1",
    "mob/warden/nearby_close_2",
    "mob/warden/nearby_close_3",
    "mob/warden/nearby_close_4",
    "mob/warden/nearby_closer_1",
    "mob/warden/nearby_closer_2",
    "mob/warden/nearby_closer_3",
    "mob/warden/nearby_closest_1",
    "mob/warden/nearby_closest_2",
    "mob/warden/nearby_closest_3",
    "mob/warden/roar_1",
    "mob/warden/roar_2",
    "mob/warden/roar_3",
    "mob/warden/roar_4",
    "mob/warden/roar_5",
    "mob/warden/sniff_1",
    "mob/warden/sniff_2",
    "mob/warden/sniff_3",
    "mob/warden/sniff_4",
    "mob/warden/sonic_boom1",
    "mob/warden/sonic_boom2",
    "mob/warden/sonic_boom3",
    "mob/warden/sonic_boom4",
    "mob/warden/sonic_charge1",
    "mob/warden/sonic_charge2",
    "mob/warden/sonic_charge3",
    "mob/warden/sonic_charge4",
    "mob/warden/step_1",
    "mob/warden/step_2",
    "mob/warden/step_3",
    "mob/warden/step_4",
    "mob/warden/tendril_clicks_1",
    "mob/warden/tendril_clicks_2",
    "mob/warden/tendril_clicks_3",
    "mob/warden/tendril_clicks_4",
    "mob/warden/tendril_clicks_5",
    "mob/warden/tendril_clicks_6",
    "mob/wither/death",
    "mob/wither/hurt1",
    "mob/wither/hurt2",
    "mob/wither/hurt3",
    "mob/wither/hurt4",
    "mob/wither/idle1",
    "mob/wither/idle2",
    "mob/wither/idle3",
    "mob/wither/idle4",
    "mob/wither/shoot",
    "mob/wither/spawn",
    "mob/wither_skeleton/death1",
    "mob/wither_skeleton/death2",
    "mob/wither_skeleton/hurt1",
    "mob/wither_skeleton/hurt2",
    "mob/wither_skeleton/hurt3",
    "mob/wither_skeleton/hurt4",
    "mob/wither_skeleton/idle1",
    "mob/wither_skeleton/idle2",
    "mob/wither_skeleton/idle3",
    "mob/wither_skeleton/step1",
    "mob/wither_skeleton/step2",
    "mob/wither_skeleton/step3",
    "mob/wither_skeleton/step4",
    "mob/wolf/angry/bark1",
    "mob/wolf/angry/bark2",
    "mob/wolf/angry/bark3",
    "mob/wolf/angry/death",
    "mob/wolf/angry/growl1",
    "mob/wolf/angry/growl2",
    "mob/wolf/angry/growl3",
    "mob/wolf/angry/hurt1",
    "mob/wolf/angry/hurt2",
    "mob/wolf/angry/hurt3",
    "mob/wolf/angry/panting",
    "mob/wolf/angry/whine",
    "mob/wolf/baby/ambient1",
    "mob/wolf/baby/ambient2",
    "mob/wolf/baby/ambient3",
    "mob/wolf/baby/ambient4",
    "mob/wolf/baby/ambient5",
    "mob/wolf/baby/ambient6",
    "mob/wolf/baby/ambient7",
    "mob/wolf/baby/ambient8",
    "mob/wolf/baby/angry1",
    "mob/wolf/baby/angry2",
    "mob/wolf/baby/angry3",
    "mob/wolf/baby/angry4",
    "mob/wolf/baby/death",
    "mob/wolf/baby/hurt1",
    "mob/wolf/baby/hurt2",
    "mob/wolf/baby/hurt3",
    "mob/wolf/baby/pant1",
    "mob/wolf/baby/pant2",
    "mob/wolf/baby/pant3",
    "mob/wolf/baby/step1",
    "mob/wolf/baby/step2",
    "mob/wolf/baby/step3",
    "mob/wolf/baby/step4",
    "mob/wolf/baby/step5",
    "mob/wolf/baby/whine1",
    "mob/wolf/baby/whine2",
    "mob/wolf/big/bark1",
    "mob/wolf/big/bark2",
    "mob/wolf/big/bark3",
    "mob/wolf/big/death",
    "mob/wolf/big/growl1",
    "mob/wolf/big/growl2",
    "mob/wolf/big/growl3",
    "mob/wolf/big/hurt1",
    "mob/wolf/big/hurt2",
    "mob/wolf/big/hurt3",
    "mob/wolf/big/panting",
    "mob/wolf/big/whine",
    "mob/wolf/classic/bark1",
    "mob/wolf/classic/bark2",
    "mob/wolf/classic/bark3",
    "mob/wolf/classic/death",
    "mob/wolf/classic/growl1",
    "mob/wolf/classic/growl2",
    "mob/wolf/classic/growl3",
    "mob/wolf/classic/hurt1",
    "mob/wolf/classic/hurt2",
    "mob/wolf/classic/hurt3",
    "mob/wolf/classic/panting",
    "mob/wolf/classic/whine",
    "mob/wolf/cute/bark1",
    "mob/wolf/cute/bark2",
    "mob/wolf/cute/bark3",
    "mob/wolf/cute/death",
    "mob/wolf/cute/growl1",
    "mob/wolf/cute/growl2",
    "mob/wolf/cute/growl3",
    "mob/wolf/cute/hurt1",
    "mob/wolf/cute/hurt2",
    "mob/wolf/cute/hurt3",
    "mob/wolf/cute/panting",
    "mob/wolf/cute/whine",
    "mob/wolf/grumpy/bark1",
    "mob/wolf/grumpy/bark2",
    "mob/wolf/grumpy/bark3",
    "mob/wolf/grumpy/death",
    "mob/wolf/grumpy/growl1",
    "mob/wolf/grumpy/growl2",
    "mob/wolf/grumpy/growl3",
    "mob/wolf/grumpy/hurt1",
    "mob/wolf/grumpy/hurt2",
    "mob/wolf/grumpy/hurt3",
    "mob/wolf/grumpy/panting",
    "mob/wolf/grumpy/whine",
    "mob/wolf/puglin/bark1",
    "mob/wolf/puglin/bark2",
    "mob/wolf/puglin/bark3",
    "mob/wolf/puglin/death",
    "mob/wolf/puglin/growl1",
    "mob/wolf/puglin/growl2",
    "mob/wolf/puglin/growl3",
    "mob/wolf/puglin/hurt1",
    "mob/wolf/puglin/hurt2",
    "mob/wolf/puglin/hurt3",
    "mob/wolf/puglin/panting",
    "mob/wolf/puglin/whine",
    "mob/wolf/sad/bark1",
    "mob/wolf/sad/bark2",
    "mob/wolf/sad/bark3",
    "mob/wolf/sad/death",
    "mob/wolf/sad/growl1",
    "mob/wolf/sad/growl2",
    "mob/wolf/sad/growl3",
    "mob/wolf/sad/hurt1",
    "mob/wolf/sad/hurt2",
    "mob/wolf/sad/hurt3",
    "mob/wolf/sad/panting",
    "mob/wolf/sad/whine",
    "mob/wolf/shake",
    "mob/wolf/step1",
    "mob/wolf/step2",
    "mob/wolf/step3",
    "mob/wolf/step4",
    "mob/wolf/step5",
    "mob/zoglin/angry1",
    "mob/zoglin/angry2",
    "mob/zoglin/angry3",
    "mob/zoglin/attack1",
    "mob/zoglin/attack2",
    "mob/zoglin/death1",
    "mob/zoglin/death2",
    "mob/zoglin/death3",
    "mob/zoglin/hurt1",
    "mob/zoglin/hurt2",
    "mob/zoglin/hurt3",
    "mob/zoglin/idle1",
    "mob/zoglin/idle2",
    "mob/zoglin/idle3",
    "mob/zoglin/idle4",
    "mob/zoglin/idle5",
    "mob/zoglin/idle6",
    "mob/zoglin/step1",
    "mob/zoglin/step2",
    "mob/zoglin/step3",
    "mob/zoglin/step4",
    "mob/zoglin/step5",
    "mob/zombie/death",
    "mob/zombie/hurt1",
    "mob/zombie/hurt2",
    "mob/zombie/infect",
    "mob/zombie/metal1",
    "mob/zombie/metal2",
    "mob/zombie/metal3",
    "mob/zombie/remedy",
    "mob/zombie/say1",
    "mob/zombie/say2",
    "mob/zombie/say3",
    "mob/zombie/step1",
    "mob/zombie/step2",
    "mob/zombie/step3",
    "mob/zombie/step4",
    "mob/zombie/step5",
    "mob/zombie/unfect",
    "mob/zombie/wood1",
    "mob/zombie/wood2",
    "mob/zombie/wood3",
    "mob/zombie/wood4",
    "mob/zombie/woodbreak",
    "mob/zombie_nautilus/ambient1",
    "mob/zombie_nautilus/ambient2",
    "mob/zombie_nautilus/ambient3",
    "mob/zombie_nautilus/ambient4",
    "mob/zombie_nautilus/ambient5",
    "mob/zombie_nautilus/ambient_land1",
    "mob/zombie_nautilus/ambient_land2",
    "mob/zombie_nautilus/ambient_land3",
    "mob/zombie_nautilus/ambient_land4",
    "mob/zombie_nautilus/ambient_land5",
    "mob/zombie_nautilus/ambient_land6",
    "mob/zombie_nautilus/dash_land1",
    "mob/zombie_nautilus/dash_land2",
    "mob/zombie_nautilus/dash_land3",
    "mob/zombie_nautilus/dash_land4",
    "mob/zombie_nautilus/dash_ready1",
    "mob/zombie_nautilus/dash_ready2",
    "mob/zombie_nautilus/dash_ready3",
    "mob/zombie_nautilus/dash_ready_land1",
    "mob/zombie_nautilus/dash_ready_land2",
    "mob/zombie_nautilus/dash_ready_land3",
    "mob/zombie_nautilus/dash_ready_land4",
    "mob/zombie_nautilus/death",
    "mob/zombie_nautilus/death_land",
    "mob/zombie_nautilus/eat1",
    "mob/zombie_nautilus/eat2",
    "mob/zombie_nautilus/hurt1",
    "mob/zombie_nautilus/hurt2",
    "mob/zombie_nautilus/hurt3",
    "mob/zombie_nautilus/hurt4",
    "mob/zombie_nautilus/hurt_land1",
    "mob/zombie_nautilus/hurt_land2",
    "mob/zombie_nautilus/hurt_land3",
    "mob/zombie_nautilus/hurt_land4",
    "mob/zombie_villager/death",
    "mob/zombie_villager/hurt1",
    "mob/zombie_villager/hurt2",
    "mob/zombie_villager/say1",
    "mob/zombie_villager/say2",
    "mob/zombie_villager/say3",
    "mob/zombified_piglin/zpig1",
    "mob/zombified_piglin/zpig2",
    "mob/zombified_piglin/zpig3",
    "mob/zombified_piglin/zpig4",
    "mob/zombified_piglin/zpigangry1",
    "mob/zombified_piglin/zpigangry2",
    "mob/zombified_piglin/zpigangry3",
    "mob/zombified_piglin/zpigangry4",
    "mob/zombified_piglin/zpigdeath",
    "mob/zombified_piglin/zpighurt1",
    "mob/zombified_piglin/zpighurt2",
    "music/game/a_familiar_room",
    "music/game/an_ordinary_day",
    "music/game/ancestry",
    "music/game/below_and_above",
    "music/game/broken_clocks",
    "music/game/bromeliad",
    "music/game/clark",
    "music/game/comforting_memories",
    "music/game/creative/aria_math",
    "music/game/creative/biome_fest",
    "music/game/creative/blind_spots",
    "music/game/creative/dreiton",
    "music/game/creative/haunt_muskie",
    "music/game/creative/taswell",
    "music/game/crescent_dunes",
    "music/game/danny",
    "music/game/deeper",
    "music/game/dry_hands",
    "music/game/ebb",
    "music/game/echo_in_the_wind",
    "music/game/eld_unknown",
    "music/game/end/alpha",
    "music/game/end/boss",
    "music/game/end/the_end",
    "music/game/endless",
    "music/game/featherfall",
    "music/game/fireflies",
    "music/game/floating_dream",
    "music/game/haggstrom",
    "music/game/home",
    "music/game/infinite_amethyst",
    "music/game/key",
    "music/game/komorebi",
    "music/game/left_to_bloom",
    "music/game/lilypad",
    "music/game/living_mice",
    "music/game/memories",
    "music/game/mice_on_venus",
    "music/game/minecraft",
    "music/game/nether/ballad_of_the_cats",
    "music/game/nether/concrete_halls",
    "music/game/nether/crimson_forest/chrysopoeia",
    "music/game/nether/dead_voxel",
    "music/game/nether/nether_wastes/rubedo",
    "music/game/nether/soulsand_valley/so_below",
    "music/game/nether/warmth",
    "music/game/nightly",
    "music/game/one_more_day",
    "music/game/os_piano",
    "music/game/oxygene",
    "music/game/pokopoko",
    "music/game/puzzlebox",
    "music/game/shores",
    "music/game/stand_tall",
    "music/game/subwoofer_lullaby",
    "music/game/swamp/aerie",
    "music/game/swamp/firebugs",
    "music/game/swamp/labyrinthine",
    "music/game/sweden",
    "music/game/watcher",
    "music/game/water/axolotl",
    "music/game/water/dragon_fish",
    "music/game/water/shuniji",
    "music/game/wending",
    "music/game/wet_hands",
    "music/game/yakusoku",
    "music/menu/beginning_2",
    "music/menu/floating_trees",
    "music/menu/moog_city_2",
    "music/menu/mutation",
    "note/banjo",
    "note/bass",
    "note/bassattack",
    "note/bd",
    "note/bell",
    "note/bit",
    "note/cow_bell",
    "note/didgeridoo",
    "note/flute",
    "note/guitar",
    "note/harp",
    "note/harp2",
    "note/hat",
    "note/icechime",
    "note/iron_xylophone",
    "note/pling",
    "note/snare",
    "note/trumpet",
    "note/trumpet_exposed",
    "note/trumpet_oxidized",
    "note/trumpet_weathered",
    "note/xylobone",
    "portal/portal",
    "portal/travel",
    "portal/trigger",
    "random/anvil_break",
    "random/anvil_land",
    "random/anvil_use",
    "random/bow",
    "random/bowhit1",
    "random/bowhit2",
    "random/bowhit3",
    "random/bowhit4",
    "random/break",
    "random/breath",
    "random/burp",
    "random/chestclosed",
    "random/chestopen",
    "random/classic_hurt",
    "random/click",
    "random/click_stereo",
    "random/door_close",
    "random/door_open",
    "random/drink",
    "random/eat1",
    "random/eat2",
    "random/eat3",
    "random/explode1",
    "random/explode2",
    "random/explode3",
    "random/explode4",
    "random/fizz",
    "random/fuse",
    "random/glass1",
    "random/glass2",
    "random/glass3",
    "random/levelup",
    "random/orb",
    "random/pop",
    "random/splash",
    "random/successful_hit",
    "random/wood_click",
    "records/11",
    "records/13",
    "records/5",
    "records/blocks",
    "records/bounce",
    "records/cat",
    "records/chirp",
    "records/creator",
    "records/creator_music_box",
    "records/far",
    "records/lava_chicken",
    "records/mall",
    "records/mellohi",
    "records/otherside",
    "records/pigstep",
    "records/precipice",
    "records/relic",
    "records/stal",
    "records/strad",
    "records/tears",
    "records/wait",
    "records/ward",
    "step/cloth1",
    "step/cloth2",
    "step/cloth3",
    "step/cloth4",
    "step/coral1",
    "step/coral2",
    "step/coral3",
    "step/coral4",
    "step/coral5",
    "step/coral6",
    "step/grass1",
    "step/grass2",
    "step/grass3",
    "step/grass4",
    "step/grass5",
    "step/grass6",
    "step/gravel1",
    "step/gravel2",
    "step/gravel3",
    "step/gravel4",
    "step/ladder1",
    "step/ladder2",
    "step/ladder3",
    "step/ladder4",
    "step/ladder5",
    "step/sand1",
    "step/sand2",
    "step/sand3",
    "step/sand4",
    "step/sand5",
    "step/scaffold1",
    "step/scaffold2",
    "step/scaffold3",
    "step/scaffold4",
    "step/scaffold5",
    "step/scaffold6",
    "step/scaffold7",
    "step/snow1",
    "step/snow2",
    "step/snow3",
    "step/snow4",
    "step/stone1",
    "step/stone2",
    "step/stone3",
    "step/stone4",
    "step/stone5",
    "step/stone6",
    "step/wet_grass1",
    "step/wet_grass2",
    "step/wet_grass3",
    "step/wet_grass4",
    "step/wet_grass5",
    "step/wet_grass6",
    "step/wood1",
    "step/wood2",
    "step/wood3",
    "step/wood4",
    "step/wood5",
    "step/wood6",
    "tile/piston/in",
    "tile/piston/out",
    "ui/cartography_table/drawmap1",
    "ui/cartography_table/drawmap2",
    "ui/cartography_table/drawmap3",
    "ui/hud/hud_bubble",
    "ui/loom/select_pattern1",
    "ui/loom/select_pattern2",
    "ui/loom/select_pattern3",
    "ui/loom/select_pattern4",
    "ui/loom/select_pattern5",
    "ui/loom/take_result1",
    "ui/loom/take_result2",
    "ui/stonecutter/cut1",
    "ui/stonecutter/cut2",
    "ui/toast/challenge_complete",
    "ui/toast/in",
    "ui/toast/out"
  ]);
});

// src/arguments/generated/_registry/textures.ts
var TEXTURES_SET;
var init_textures = __esm(() => {
  init_sandstone();
  TEXTURES_SET = new Set2([
    "block/acacia_door_bottom",
    "block/acacia_door_top",
    "block/acacia_hanging_sign",
    "block/acacia_leaves",
    "block/acacia_log",
    "block/acacia_log_top",
    "block/acacia_planks",
    "block/acacia_sapling",
    "block/acacia_shelf",
    "block/acacia_sign",
    "block/acacia_trapdoor",
    "block/activator_rail",
    "block/activator_rail_on",
    "block/allium",
    "block/amethyst_block",
    "block/amethyst_cluster",
    "block/ancient_debris_side",
    "block/ancient_debris_top",
    "block/andesite",
    "block/anvil",
    "block/anvil_top",
    "block/attached_melon_stem",
    "block/attached_pumpkin_stem",
    "block/azalea_leaves",
    "block/azalea_plant",
    "block/azalea_side",
    "block/azalea_top",
    "block/azure_bluet",
    "block/bamboo_block",
    "block/bamboo_block_top",
    "block/bamboo_door_bottom",
    "block/bamboo_door_top",
    "block/bamboo_fence",
    "block/bamboo_fence_gate",
    "block/bamboo_fence_gate_particle",
    "block/bamboo_fence_particle",
    "block/bamboo_hanging_sign",
    "block/bamboo_large_leaves",
    "block/bamboo_mosaic",
    "block/bamboo_planks",
    "block/bamboo_shelf",
    "block/bamboo_sign",
    "block/bamboo_singleleaf",
    "block/bamboo_small_leaves",
    "block/bamboo_stage0",
    "block/bamboo_stalk",
    "block/bamboo_trapdoor",
    "block/barrel_bottom",
    "block/barrel_side",
    "block/barrel_top",
    "block/barrel_top_open",
    "block/basalt_side",
    "block/basalt_top",
    "block/beacon",
    "block/bed_down",
    "block/bed_head_north",
    "block/bedrock",
    "block/bee_nest_bottom",
    "block/bee_nest_front",
    "block/bee_nest_front_honey",
    "block/bee_nest_side",
    "block/bee_nest_top",
    "block/beehive_end",
    "block/beehive_front",
    "block/beehive_front_honey",
    "block/beehive_side",
    "block/beetroots_stage0",
    "block/beetroots_stage1",
    "block/beetroots_stage2",
    "block/beetroots_stage3",
    "block/bell_bottom",
    "block/bell_side",
    "block/bell_top",
    "block/big_dripleaf_side",
    "block/big_dripleaf_stem",
    "block/big_dripleaf_tip",
    "block/big_dripleaf_top",
    "block/birch_door_bottom",
    "block/birch_door_top",
    "block/birch_hanging_sign",
    "block/birch_leaves",
    "block/birch_log",
    "block/birch_log_top",
    "block/birch_planks",
    "block/birch_sapling",
    "block/birch_shelf",
    "block/birch_sign",
    "block/birch_trapdoor",
    "block/black_bed_foot_east",
    "block/black_bed_foot_south",
    "block/black_bed_foot_up",
    "block/black_bed_foot_west",
    "block/black_bed_head_east",
    "block/black_bed_head_up",
    "block/black_bed_head_west",
    "block/black_candle",
    "block/black_candle_lit",
    "block/black_concrete",
    "block/black_concrete_powder",
    "block/black_glazed_terracotta",
    "block/black_shulker_box",
    "block/black_stained_glass",
    "block/black_stained_glass_pane_top",
    "block/black_terracotta",
    "block/black_wool",
    "block/blackstone",
    "block/blackstone_top",
    "block/blast_furnace_front",
    "block/blast_furnace_front_on",
    "block/blast_furnace_side",
    "block/blast_furnace_top",
    "block/blue_bed_foot_east",
    "block/blue_bed_foot_south",
    "block/blue_bed_foot_up",
    "block/blue_bed_foot_west",
    "block/blue_bed_head_east",
    "block/blue_bed_head_up",
    "block/blue_bed_head_west",
    "block/blue_candle",
    "block/blue_candle_lit",
    "block/blue_concrete",
    "block/blue_concrete_powder",
    "block/blue_glazed_terracotta",
    "block/blue_ice",
    "block/blue_orchid",
    "block/blue_shulker_box",
    "block/blue_stained_glass",
    "block/blue_stained_glass_pane_top",
    "block/blue_terracotta",
    "block/blue_wool",
    "block/bone_block_side",
    "block/bone_block_top",
    "block/bookshelf",
    "block/brain_coral",
    "block/brain_coral_block",
    "block/brain_coral_fan",
    "block/brewing_stand",
    "block/brewing_stand_base",
    "block/bricks",
    "block/brown_bed_foot_east",
    "block/brown_bed_foot_south",
    "block/brown_bed_foot_up",
    "block/brown_bed_foot_west",
    "block/brown_bed_head_east",
    "block/brown_bed_head_up",
    "block/brown_bed_head_west",
    "block/brown_candle",
    "block/brown_candle_lit",
    "block/brown_concrete",
    "block/brown_concrete_powder",
    "block/brown_glazed_terracotta",
    "block/brown_mushroom",
    "block/brown_mushroom_block",
    "block/brown_shulker_box",
    "block/brown_stained_glass",
    "block/brown_stained_glass_pane_top",
    "block/brown_terracotta",
    "block/brown_wool",
    "block/bubble_coral",
    "block/bubble_coral_block",
    "block/bubble_coral_fan",
    "block/budding_amethyst",
    "block/bush",
    "block/cactus_bottom",
    "block/cactus_flower",
    "block/cactus_side",
    "block/cactus_top",
    "block/cake_bottom",
    "block/cake_inner",
    "block/cake_side",
    "block/cake_top",
    "block/calcite",
    "block/calibrated_sculk_sensor_amethyst",
    "block/calibrated_sculk_sensor_input_side",
    "block/calibrated_sculk_sensor_top",
    "block/campfire_fire",
    "block/campfire_log",
    "block/campfire_log_lit",
    "block/candle",
    "block/candle_lit",
    "block/carrots_stage0",
    "block/carrots_stage1",
    "block/carrots_stage2",
    "block/carrots_stage3",
    "block/cartography_table_side1",
    "block/cartography_table_side2",
    "block/cartography_table_side3",
    "block/cartography_table_top",
    "block/carved_pumpkin",
    "block/cauldron_bottom",
    "block/cauldron_inner",
    "block/cauldron_side",
    "block/cauldron_top",
    "block/cave_vines",
    "block/cave_vines_lit",
    "block/cave_vines_plant",
    "block/cave_vines_plant_lit",
    "block/chain_command_block_back",
    "block/chain_command_block_conditional",
    "block/chain_command_block_front",
    "block/chain_command_block_side",
    "block/cherry_door_bottom",
    "block/cherry_door_top",
    "block/cherry_hanging_sign",
    "block/cherry_leaves",
    "block/cherry_log",
    "block/cherry_log_top",
    "block/cherry_planks",
    "block/cherry_sapling",
    "block/cherry_shelf",
    "block/cherry_sign",
    "block/cherry_trapdoor",
    "block/chipped_anvil_top",
    "block/chiseled_bookshelf_empty",
    "block/chiseled_bookshelf_occupied",
    "block/chiseled_bookshelf_side",
    "block/chiseled_bookshelf_top",
    "block/chiseled_cinnabar",
    "block/chiseled_copper",
    "block/chiseled_deepslate",
    "block/chiseled_nether_bricks",
    "block/chiseled_polished_blackstone",
    "block/chiseled_quartz_block",
    "block/chiseled_quartz_block_top",
    "block/chiseled_red_sandstone",
    "block/chiseled_resin_bricks",
    "block/chiseled_sandstone",
    "block/chiseled_stone_bricks",
    "block/chiseled_sulfur",
    "block/chiseled_tuff",
    "block/chiseled_tuff_bricks",
    "block/chiseled_tuff_bricks_top",
    "block/chiseled_tuff_top",
    "block/chorus_flower",
    "block/chorus_flower_dead",
    "block/chorus_plant",
    "block/cinnabar",
    "block/cinnabar_bricks",
    "block/clay",
    "block/closed_eyeblossom",
    "block/coal_block",
    "block/coal_ore",
    "block/coarse_dirt",
    "block/cobbled_deepslate",
    "block/cobblestone",
    "block/cobweb",
    "block/cocoa_stage0",
    "block/cocoa_stage1",
    "block/cocoa_stage2",
    "block/command_block_back",
    "block/command_block_conditional",
    "block/command_block_front",
    "block/command_block_side",
    "block/comparator",
    "block/comparator_on",
    "block/composter_bottom",
    "block/composter_compost",
    "block/composter_ready",
    "block/composter_side",
    "block/composter_top",
    "block/conduit",
    "block/copper_bars",
    "block/copper_block",
    "block/copper_bulb",
    "block/copper_bulb_lit",
    "block/copper_bulb_lit_powered",
    "block/copper_bulb_powered",
    "block/copper_chain",
    "block/copper_door_bottom",
    "block/copper_door_top",
    "block/copper_grate",
    "block/copper_lantern",
    "block/copper_ore",
    "block/copper_torch",
    "block/copper_trapdoor",
    "block/cornflower",
    "block/cracked_deepslate_bricks",
    "block/cracked_deepslate_tiles",
    "block/cracked_nether_bricks",
    "block/cracked_polished_blackstone_bricks",
    "block/cracked_stone_bricks",
    "block/crafter_bottom",
    "block/crafter_east",
    "block/crafter_east_crafting",
    "block/crafter_east_triggered",
    "block/crafter_north",
    "block/crafter_north_crafting",
    "block/crafter_south",
    "block/crafter_south_triggered",
    "block/crafter_top",
    "block/crafter_top_crafting",
    "block/crafter_top_triggered",
    "block/crafter_west",
    "block/crafter_west_crafting",
    "block/crafter_west_triggered",
    "block/crafting_table_front",
    "block/crafting_table_side",
    "block/crafting_table_top",
    "block/creaking_heart",
    "block/creaking_heart_awake",
    "block/creaking_heart_dormant",
    "block/creaking_heart_top",
    "block/creaking_heart_top_awake",
    "block/creaking_heart_top_dormant",
    "block/crimson_door_bottom",
    "block/crimson_door_top",
    "block/crimson_fungus",
    "block/crimson_hanging_sign",
    "block/crimson_nylium",
    "block/crimson_nylium_side",
    "block/crimson_planks",
    "block/crimson_roots",
    "block/crimson_roots_pot",
    "block/crimson_shelf",
    "block/crimson_sign",
    "block/crimson_stem",
    "block/crimson_stem_top",
    "block/crimson_trapdoor",
    "block/crying_obsidian",
    "block/cut_copper",
    "block/cut_red_sandstone",
    "block/cut_sandstone",
    "block/cyan_bed_foot_east",
    "block/cyan_bed_foot_south",
    "block/cyan_bed_foot_up",
    "block/cyan_bed_foot_west",
    "block/cyan_bed_head_east",
    "block/cyan_bed_head_up",
    "block/cyan_bed_head_west",
    "block/cyan_candle",
    "block/cyan_candle_lit",
    "block/cyan_concrete",
    "block/cyan_concrete_powder",
    "block/cyan_glazed_terracotta",
    "block/cyan_shulker_box",
    "block/cyan_stained_glass",
    "block/cyan_stained_glass_pane_top",
    "block/cyan_terracotta",
    "block/cyan_wool",
    "block/damaged_anvil_top",
    "block/dandelion",
    "block/dark_oak_door_bottom",
    "block/dark_oak_door_top",
    "block/dark_oak_hanging_sign",
    "block/dark_oak_leaves",
    "block/dark_oak_log",
    "block/dark_oak_log_top",
    "block/dark_oak_planks",
    "block/dark_oak_sapling",
    "block/dark_oak_shelf",
    "block/dark_oak_sign",
    "block/dark_oak_trapdoor",
    "block/dark_prismarine",
    "block/daylight_detector_inverted_top",
    "block/daylight_detector_side",
    "block/daylight_detector_top",
    "block/dead_brain_coral",
    "block/dead_brain_coral_block",
    "block/dead_brain_coral_fan",
    "block/dead_bubble_coral",
    "block/dead_bubble_coral_block",
    "block/dead_bubble_coral_fan",
    "block/dead_bush",
    "block/dead_fire_coral",
    "block/dead_fire_coral_block",
    "block/dead_fire_coral_fan",
    "block/dead_horn_coral",
    "block/dead_horn_coral_block",
    "block/dead_horn_coral_fan",
    "block/dead_tube_coral",
    "block/dead_tube_coral_block",
    "block/dead_tube_coral_fan",
    "block/debug",
    "block/debug2",
    "block/deepslate",
    "block/deepslate_bricks",
    "block/deepslate_coal_ore",
    "block/deepslate_copper_ore",
    "block/deepslate_diamond_ore",
    "block/deepslate_emerald_ore",
    "block/deepslate_gold_ore",
    "block/deepslate_iron_ore",
    "block/deepslate_lapis_ore",
    "block/deepslate_redstone_ore",
    "block/deepslate_tiles",
    "block/deepslate_top",
    "block/destroy_oit_stage_0",
    "block/destroy_oit_stage_1",
    "block/destroy_oit_stage_2",
    "block/destroy_oit_stage_3",
    "block/destroy_oit_stage_4",
    "block/destroy_oit_stage_5",
    "block/destroy_oit_stage_6",
    "block/destroy_oit_stage_7",
    "block/destroy_oit_stage_8",
    "block/destroy_oit_stage_9",
    "block/destroy_stage_0",
    "block/destroy_stage_1",
    "block/destroy_stage_2",
    "block/destroy_stage_3",
    "block/destroy_stage_4",
    "block/destroy_stage_5",
    "block/destroy_stage_6",
    "block/destroy_stage_7",
    "block/destroy_stage_8",
    "block/destroy_stage_9",
    "block/detector_rail",
    "block/detector_rail_on",
    "block/diamond_block",
    "block/diamond_ore",
    "block/diorite",
    "block/dirt",
    "block/dirt_path_side",
    "block/dirt_path_top",
    "block/dispenser_front",
    "block/dispenser_front_vertical",
    "block/dragon_egg",
    "block/dried_ghast_hydration_0_bottom",
    "block/dried_ghast_hydration_0_east",
    "block/dried_ghast_hydration_0_north",
    "block/dried_ghast_hydration_0_south",
    "block/dried_ghast_hydration_0_tentacles",
    "block/dried_ghast_hydration_0_top",
    "block/dried_ghast_hydration_0_west",
    "block/dried_ghast_hydration_1_bottom",
    "block/dried_ghast_hydration_1_east",
    "block/dried_ghast_hydration_1_north",
    "block/dried_ghast_hydration_1_south",
    "block/dried_ghast_hydration_1_tentacles",
    "block/dried_ghast_hydration_1_top",
    "block/dried_ghast_hydration_1_west",
    "block/dried_ghast_hydration_2_bottom",
    "block/dried_ghast_hydration_2_east",
    "block/dried_ghast_hydration_2_north",
    "block/dried_ghast_hydration_2_south",
    "block/dried_ghast_hydration_2_tentacles",
    "block/dried_ghast_hydration_2_top",
    "block/dried_ghast_hydration_2_west",
    "block/dried_ghast_hydration_3_bottom",
    "block/dried_ghast_hydration_3_east",
    "block/dried_ghast_hydration_3_north",
    "block/dried_ghast_hydration_3_south",
    "block/dried_ghast_hydration_3_tentacles",
    "block/dried_ghast_hydration_3_top",
    "block/dried_ghast_hydration_3_west",
    "block/dried_kelp_bottom",
    "block/dried_kelp_side",
    "block/dried_kelp_top",
    "block/dripstone_block",
    "block/dropper_front",
    "block/dropper_front_vertical",
    "block/emerald_block",
    "block/emerald_ore",
    "block/enchanting_table_bottom",
    "block/enchanting_table_side",
    "block/enchanting_table_top",
    "block/end_portal_frame_eye",
    "block/end_portal_frame_side",
    "block/end_portal_frame_top",
    "block/end_rod",
    "block/end_stone",
    "block/end_stone_bricks",
    "block/exposed_chiseled_copper",
    "block/exposed_copper",
    "block/exposed_copper_bars",
    "block/exposed_copper_bulb",
    "block/exposed_copper_bulb_lit",
    "block/exposed_copper_bulb_lit_powered",
    "block/exposed_copper_bulb_powered",
    "block/exposed_copper_chain",
    "block/exposed_copper_door_bottom",
    "block/exposed_copper_door_top",
    "block/exposed_copper_grate",
    "block/exposed_copper_lantern",
    "block/exposed_copper_trapdoor",
    "block/exposed_cut_copper",
    "block/exposed_lightning_rod",
    "block/farmland",
    "block/farmland_moist",
    "block/fern",
    "block/fire_0",
    "block/fire_1",
    "block/fire_coral",
    "block/fire_coral_block",
    "block/fire_coral_fan",
    "block/firefly_bush",
    "block/firefly_bush_emissive",
    "block/fletching_table_front",
    "block/fletching_table_side",
    "block/fletching_table_top",
    "block/flower_pot",
    "block/flowering_azalea_leaves",
    "block/flowering_azalea_side",
    "block/flowering_azalea_top",
    "block/frogspawn",
    "block/frosted_ice_0",
    "block/frosted_ice_1",
    "block/frosted_ice_2",
    "block/frosted_ice_3",
    "block/furnace_front",
    "block/furnace_front_on",
    "block/furnace_side",
    "block/furnace_top",
    "block/gilded_blackstone",
    "block/glass",
    "block/glass_pane_top",
    "block/glow_item_frame",
    "block/glow_lichen",
    "block/glowstone",
    "block/gold_block",
    "block/gold_ore",
    "block/golden_dandelion",
    "block/granite",
    "block/grass_block_side",
    "block/grass_block_side_overlay",
    "block/grass_block_snow",
    "block/grass_block_top",
    "block/gravel",
    "block/gray_bed_foot_east",
    "block/gray_bed_foot_south",
    "block/gray_bed_foot_up",
    "block/gray_bed_foot_west",
    "block/gray_bed_head_east",
    "block/gray_bed_head_up",
    "block/gray_bed_head_west",
    "block/gray_candle",
    "block/gray_candle_lit",
    "block/gray_concrete",
    "block/gray_concrete_powder",
    "block/gray_glazed_terracotta",
    "block/gray_shulker_box",
    "block/gray_stained_glass",
    "block/gray_stained_glass_pane_top",
    "block/gray_terracotta",
    "block/gray_wool",
    "block/green_bed_foot_east",
    "block/green_bed_foot_south",
    "block/green_bed_foot_up",
    "block/green_bed_foot_west",
    "block/green_bed_head_east",
    "block/green_bed_head_up",
    "block/green_bed_head_west",
    "block/green_candle",
    "block/green_candle_lit",
    "block/green_concrete",
    "block/green_concrete_powder",
    "block/green_glazed_terracotta",
    "block/green_shulker_box",
    "block/green_stained_glass",
    "block/green_stained_glass_pane_top",
    "block/green_terracotta",
    "block/green_wool",
    "block/grindstone_pivot",
    "block/grindstone_round",
    "block/grindstone_side",
    "block/hanging_roots",
    "block/hay_block_side",
    "block/hay_block_top",
    "block/heavy_core",
    "block/honey_block_bottom",
    "block/honey_block_side",
    "block/honey_block_top",
    "block/honeycomb_block",
    "block/hopper_inside",
    "block/hopper_outside",
    "block/hopper_top",
    "block/horn_coral",
    "block/horn_coral_block",
    "block/horn_coral_fan",
    "block/ice",
    "block/iron_bars",
    "block/iron_block",
    "block/iron_chain",
    "block/iron_door_bottom",
    "block/iron_door_top",
    "block/iron_ore",
    "block/iron_trapdoor",
    "block/item_frame",
    "block/jack_o_lantern",
    "block/jigsaw_bottom",
    "block/jigsaw_lock",
    "block/jigsaw_side",
    "block/jigsaw_top",
    "block/jukebox_side",
    "block/jukebox_top",
    "block/jungle_door_bottom",
    "block/jungle_door_top",
    "block/jungle_hanging_sign",
    "block/jungle_leaves",
    "block/jungle_log",
    "block/jungle_log_top",
    "block/jungle_planks",
    "block/jungle_sapling",
    "block/jungle_shelf",
    "block/jungle_sign",
    "block/jungle_trapdoor",
    "block/kelp",
    "block/kelp_plant",
    "block/ladder",
    "block/lantern",
    "block/lapis_block",
    "block/lapis_ore",
    "block/large_amethyst_bud",
    "block/large_fern_bottom",
    "block/large_fern_top",
    "block/lava_flow",
    "block/lava_still",
    "block/leaf_litter",
    "block/lectern_base",
    "block/lectern_front",
    "block/lectern_sides",
    "block/lectern_top",
    "block/lever",
    "block/light_blue_bed_foot_east",
    "block/light_blue_bed_foot_south",
    "block/light_blue_bed_foot_up",
    "block/light_blue_bed_foot_west",
    "block/light_blue_bed_head_east",
    "block/light_blue_bed_head_up",
    "block/light_blue_bed_head_west",
    "block/light_blue_candle",
    "block/light_blue_candle_lit",
    "block/light_blue_concrete",
    "block/light_blue_concrete_powder",
    "block/light_blue_glazed_terracotta",
    "block/light_blue_shulker_box",
    "block/light_blue_stained_glass",
    "block/light_blue_stained_glass_pane_top",
    "block/light_blue_terracotta",
    "block/light_blue_wool",
    "block/light_gray_bed_foot_east",
    "block/light_gray_bed_foot_south",
    "block/light_gray_bed_foot_up",
    "block/light_gray_bed_foot_west",
    "block/light_gray_bed_head_east",
    "block/light_gray_bed_head_up",
    "block/light_gray_bed_head_west",
    "block/light_gray_candle",
    "block/light_gray_candle_lit",
    "block/light_gray_concrete",
    "block/light_gray_concrete_powder",
    "block/light_gray_glazed_terracotta",
    "block/light_gray_shulker_box",
    "block/light_gray_stained_glass",
    "block/light_gray_stained_glass_pane_top",
    "block/light_gray_terracotta",
    "block/light_gray_wool",
    "block/lightning_rod",
    "block/lightning_rod_on",
    "block/lilac_bottom",
    "block/lilac_top",
    "block/lily_of_the_valley",
    "block/lily_pad",
    "block/lime_bed_foot_east",
    "block/lime_bed_foot_south",
    "block/lime_bed_foot_up",
    "block/lime_bed_foot_west",
    "block/lime_bed_head_east",
    "block/lime_bed_head_up",
    "block/lime_bed_head_west",
    "block/lime_candle",
    "block/lime_candle_lit",
    "block/lime_concrete",
    "block/lime_concrete_powder",
    "block/lime_glazed_terracotta",
    "block/lime_shulker_box",
    "block/lime_stained_glass",
    "block/lime_stained_glass_pane_top",
    "block/lime_terracotta",
    "block/lime_wool",
    "block/lodestone_side",
    "block/lodestone_top",
    "block/loom_bottom",
    "block/loom_front",
    "block/loom_side",
    "block/loom_top",
    "block/magenta_bed_foot_east",
    "block/magenta_bed_foot_south",
    "block/magenta_bed_foot_up",
    "block/magenta_bed_foot_west",
    "block/magenta_bed_head_east",
    "block/magenta_bed_head_up",
    "block/magenta_bed_head_west",
    "block/magenta_candle",
    "block/magenta_candle_lit",
    "block/magenta_concrete",
    "block/magenta_concrete_powder",
    "block/magenta_glazed_terracotta",
    "block/magenta_shulker_box",
    "block/magenta_stained_glass",
    "block/magenta_stained_glass_pane_top",
    "block/magenta_terracotta",
    "block/magenta_wool",
    "block/magma",
    "block/mangrove_door_bottom",
    "block/mangrove_door_top",
    "block/mangrove_hanging_sign",
    "block/mangrove_leaves",
    "block/mangrove_log",
    "block/mangrove_log_top",
    "block/mangrove_planks",
    "block/mangrove_propagule",
    "block/mangrove_propagule_hanging",
    "block/mangrove_roots_side",
    "block/mangrove_roots_top",
    "block/mangrove_shelf",
    "block/mangrove_sign",
    "block/mangrove_trapdoor",
    "block/medium_amethyst_bud",
    "block/melon_side",
    "block/melon_stem",
    "block/melon_top",
    "block/moss_block",
    "block/mossy_cobblestone",
    "block/mossy_stone_bricks",
    "block/mud",
    "block/mud_bricks",
    "block/muddy_mangrove_roots_side",
    "block/muddy_mangrove_roots_top",
    "block/mushroom_block_inside",
    "block/mushroom_stem",
    "block/mycelium_side",
    "block/mycelium_top",
    "block/nether_bricks",
    "block/nether_gold_ore",
    "block/nether_portal",
    "block/nether_quartz_ore",
    "block/nether_sprouts",
    "block/nether_wart_block",
    "block/nether_wart_stage0",
    "block/nether_wart_stage1",
    "block/nether_wart_stage2",
    "block/netherite_block",
    "block/netherrack",
    "block/note_block",
    "block/oak_door_bottom",
    "block/oak_door_top",
    "block/oak_hanging_sign",
    "block/oak_leaves",
    "block/oak_log",
    "block/oak_log_top",
    "block/oak_planks",
    "block/oak_sapling",
    "block/oak_shelf",
    "block/oak_sign",
    "block/oak_trapdoor",
    "block/observer_back",
    "block/observer_back_on",
    "block/observer_front",
    "block/observer_side",
    "block/observer_top",
    "block/obsidian",
    "block/ochre_froglight_side",
    "block/ochre_froglight_top",
    "block/open_eyeblossom",
    "block/open_eyeblossom_emissive",
    "block/orange_bed_foot_east",
    "block/orange_bed_foot_south",
    "block/orange_bed_foot_up",
    "block/orange_bed_foot_west",
    "block/orange_bed_head_east",
    "block/orange_bed_head_up",
    "block/orange_bed_head_west",
    "block/orange_candle",
    "block/orange_candle_lit",
    "block/orange_concrete",
    "block/orange_concrete_powder",
    "block/orange_glazed_terracotta",
    "block/orange_poplar_leaves",
    "block/orange_shulker_box",
    "block/orange_stained_glass",
    "block/orange_stained_glass_pane_top",
    "block/orange_terracotta",
    "block/orange_tulip",
    "block/orange_wool",
    "block/oxeye_daisy",
    "block/oxidized_chiseled_copper",
    "block/oxidized_copper",
    "block/oxidized_copper_bars",
    "block/oxidized_copper_bulb",
    "block/oxidized_copper_bulb_lit",
    "block/oxidized_copper_bulb_lit_powered",
    "block/oxidized_copper_bulb_powered",
    "block/oxidized_copper_chain",
    "block/oxidized_copper_door_bottom",
    "block/oxidized_copper_door_top",
    "block/oxidized_copper_grate",
    "block/oxidized_copper_lantern",
    "block/oxidized_copper_trapdoor",
    "block/oxidized_cut_copper",
    "block/oxidized_lightning_rod",
    "block/packed_ice",
    "block/packed_mud",
    "block/pale_hanging_moss",
    "block/pale_hanging_moss_tip",
    "block/pale_moss_block",
    "block/pale_moss_carpet",
    "block/pale_moss_carpet_side_small",
    "block/pale_moss_carpet_side_tall",
    "block/pale_oak_door_bottom",
    "block/pale_oak_door_top",
    "block/pale_oak_hanging_sign",
    "block/pale_oak_leaves",
    "block/pale_oak_log",
    "block/pale_oak_log_top",
    "block/pale_oak_planks",
    "block/pale_oak_sapling",
    "block/pale_oak_shelf",
    "block/pale_oak_sign",
    "block/pale_oak_trapdoor",
    "block/pearlescent_froglight_side",
    "block/pearlescent_froglight_top",
    "block/peony_bottom",
    "block/peony_top",
    "block/pink_bed_foot_east",
    "block/pink_bed_foot_south",
    "block/pink_bed_foot_up",
    "block/pink_bed_foot_west",
    "block/pink_bed_head_east",
    "block/pink_bed_head_up",
    "block/pink_bed_head_west",
    "block/pink_candle",
    "block/pink_candle_lit",
    "block/pink_concrete",
    "block/pink_concrete_powder",
    "block/pink_glazed_terracotta",
    "block/pink_petals",
    "block/pink_petals_stem",
    "block/pink_shulker_box",
    "block/pink_stained_glass",
    "block/pink_stained_glass_pane_top",
    "block/pink_terracotta",
    "block/pink_tulip",
    "block/pink_wool",
    "block/piston_bottom",
    "block/piston_inner",
    "block/piston_side",
    "block/piston_top",
    "block/piston_top_sticky",
    "block/pitcher_crop_bottom",
    "block/pitcher_crop_bottom_stage_1",
    "block/pitcher_crop_bottom_stage_2",
    "block/pitcher_crop_bottom_stage_3",
    "block/pitcher_crop_bottom_stage_4",
    "block/pitcher_crop_side",
    "block/pitcher_crop_top",
    "block/pitcher_crop_top_stage_3",
    "block/pitcher_crop_top_stage_4",
    "block/podzol_side",
    "block/podzol_top",
    "block/pointed_dripstone_down_base",
    "block/pointed_dripstone_down_frustum",
    "block/pointed_dripstone_down_middle",
    "block/pointed_dripstone_down_tip",
    "block/pointed_dripstone_down_tip_merge",
    "block/pointed_dripstone_up_base",
    "block/pointed_dripstone_up_frustum",
    "block/pointed_dripstone_up_middle",
    "block/pointed_dripstone_up_tip",
    "block/pointed_dripstone_up_tip_merge",
    "block/polished_andesite",
    "block/polished_basalt_side",
    "block/polished_basalt_top",
    "block/polished_blackstone",
    "block/polished_blackstone_bricks",
    "block/polished_cinnabar",
    "block/polished_deepslate",
    "block/polished_diorite",
    "block/polished_granite",
    "block/polished_sulfur",
    "block/polished_tuff",
    "block/poplar_door_bottom",
    "block/poplar_door_top",
    "block/poplar_hanging_sign",
    "block/poplar_log",
    "block/poplar_log_top",
    "block/poplar_planks",
    "block/poplar_sapling",
    "block/poplar_shelf",
    "block/poplar_sign",
    "block/poplar_trapdoor",
    "block/poppy",
    "block/potatoes_stage0",
    "block/potatoes_stage1",
    "block/potatoes_stage2",
    "block/potatoes_stage3",
    "block/potent_sulfur",
    "block/potted_azalea_bush_plant",
    "block/potted_azalea_bush_side",
    "block/potted_azalea_bush_top",
    "block/potted_flowering_azalea_bush_plant",
    "block/potted_flowering_azalea_bush_side",
    "block/potted_flowering_azalea_bush_top",
    "block/powder_snow",
    "block/powered_rail",
    "block/powered_rail_on",
    "block/prismarine",
    "block/prismarine_bricks",
    "block/pumpkin_side",
    "block/pumpkin_stem",
    "block/pumpkin_top",
    "block/purple_bed_foot_east",
    "block/purple_bed_foot_south",
    "block/purple_bed_foot_up",
    "block/purple_bed_foot_west",
    "block/purple_bed_head_east",
    "block/purple_bed_head_up",
    "block/purple_bed_head_west",
    "block/purple_candle",
    "block/purple_candle_lit",
    "block/purple_concrete",
    "block/purple_concrete_powder",
    "block/purple_glazed_terracotta",
    "block/purple_shulker_box",
    "block/purple_stained_glass",
    "block/purple_stained_glass_pane_top",
    "block/purple_terracotta",
    "block/purple_wool",
    "block/purpur_block",
    "block/purpur_pillar_side",
    "block/purpur_pillar_top",
    "block/quartz_block_bottom",
    "block/quartz_block_side",
    "block/quartz_block_top",
    "block/quartz_bricks",
    "block/quartz_pillar_side",
    "block/quartz_pillar_top",
    "block/rail",
    "block/rail_corner",
    "block/raw_copper_block",
    "block/raw_gold_block",
    "block/raw_iron_block",
    "block/red_bed_foot_east",
    "block/red_bed_foot_south",
    "block/red_bed_foot_up",
    "block/red_bed_foot_west",
    "block/red_bed_head_east",
    "block/red_bed_head_up",
    "block/red_bed_head_west",
    "block/red_candle",
    "block/red_candle_lit",
    "block/red_concrete",
    "block/red_concrete_powder",
    "block/red_glazed_terracotta",
    "block/red_mushroom",
    "block/red_mushroom_block",
    "block/red_nether_bricks",
    "block/red_poplar_leaves",
    "block/red_sand",
    "block/red_sandstone",
    "block/red_sandstone_bottom",
    "block/red_sandstone_top",
    "block/red_shrub",
    "block/red_shulker_box",
    "block/red_stained_glass",
    "block/red_stained_glass_pane_top",
    "block/red_terracotta",
    "block/red_tulip",
    "block/red_wool",
    "block/redstone_block",
    "block/redstone_dust_dot",
    "block/redstone_dust_line0",
    "block/redstone_dust_line1",
    "block/redstone_dust_overlay",
    "block/redstone_lamp",
    "block/redstone_lamp_on",
    "block/redstone_ore",
    "block/redstone_torch",
    "block/redstone_torch_off",
    "block/reinforced_deepslate_bottom",
    "block/reinforced_deepslate_side",
    "block/reinforced_deepslate_top",
    "block/repeater",
    "block/repeater_on",
    "block/repeating_command_block_back",
    "block/repeating_command_block_conditional",
    "block/repeating_command_block_front",
    "block/repeating_command_block_side",
    "block/resin_block",
    "block/resin_bricks",
    "block/resin_clump",
    "block/respawn_anchor_bottom",
    "block/respawn_anchor_side0",
    "block/respawn_anchor_side1",
    "block/respawn_anchor_side2",
    "block/respawn_anchor_side3",
    "block/respawn_anchor_side4",
    "block/respawn_anchor_top",
    "block/respawn_anchor_top_off",
    "block/rooted_dirt",
    "block/rose_bush_bottom",
    "block/rose_bush_top",
    "block/sand",
    "block/sandstone",
    "block/sandstone_bottom",
    "block/sandstone_top",
    "block/scaffolding_bottom",
    "block/scaffolding_side",
    "block/scaffolding_top",
    "block/sculk",
    "block/sculk_catalyst_bottom",
    "block/sculk_catalyst_side",
    "block/sculk_catalyst_side_bloom",
    "block/sculk_catalyst_top",
    "block/sculk_catalyst_top_bloom",
    "block/sculk_sensor_bottom",
    "block/sculk_sensor_side",
    "block/sculk_sensor_tendril_active",
    "block/sculk_sensor_tendril_inactive",
    "block/sculk_sensor_top",
    "block/sculk_shrieker_bottom",
    "block/sculk_shrieker_can_summon_inner_top",
    "block/sculk_shrieker_inner_top",
    "block/sculk_shrieker_side",
    "block/sculk_shrieker_top",
    "block/sculk_vein",
    "block/sea_lantern",
    "block/sea_pickle",
    "block/seagrass",
    "block/shelf_mushroom_particle",
    "block/shelf_mushroom_stage0",
    "block/shelf_mushroom_stage1",
    "block/short_dry_grass",
    "block/short_grass",
    "block/shroomlight",
    "block/shulker_box",
    "block/slime_block",
    "block/small_amethyst_bud",
    "block/small_dripleaf_side",
    "block/small_dripleaf_stem_bottom",
    "block/small_dripleaf_stem_top",
    "block/small_dripleaf_top",
    "block/smithing_table_bottom",
    "block/smithing_table_front",
    "block/smithing_table_side",
    "block/smithing_table_top",
    "block/smoker_bottom",
    "block/smoker_front",
    "block/smoker_front_on",
    "block/smoker_side",
    "block/smoker_top",
    "block/smooth_basalt",
    "block/smooth_stone",
    "block/smooth_stone_slab_side",
    "block/sniffer_egg_not_cracked_bottom",
    "block/sniffer_egg_not_cracked_east",
    "block/sniffer_egg_not_cracked_north",
    "block/sniffer_egg_not_cracked_south",
    "block/sniffer_egg_not_cracked_top",
    "block/sniffer_egg_not_cracked_west",
    "block/sniffer_egg_slightly_cracked_bottom",
    "block/sniffer_egg_slightly_cracked_east",
    "block/sniffer_egg_slightly_cracked_north",
    "block/sniffer_egg_slightly_cracked_south",
    "block/sniffer_egg_slightly_cracked_top",
    "block/sniffer_egg_slightly_cracked_west",
    "block/sniffer_egg_very_cracked_bottom",
    "block/sniffer_egg_very_cracked_east",
    "block/sniffer_egg_very_cracked_north",
    "block/sniffer_egg_very_cracked_south",
    "block/sniffer_egg_very_cracked_top",
    "block/sniffer_egg_very_cracked_west",
    "block/snow",
    "block/soul_campfire_fire",
    "block/soul_campfire_log_lit",
    "block/soul_fire_0",
    "block/soul_fire_1",
    "block/soul_lantern",
    "block/soul_sand",
    "block/soul_soil",
    "block/soul_torch",
    "block/spawner",
    "block/sponge",
    "block/spore_blossom",
    "block/spore_blossom_base",
    "block/spruce_door_bottom",
    "block/spruce_door_top",
    "block/spruce_hanging_sign",
    "block/spruce_leaves",
    "block/spruce_log",
    "block/spruce_log_top",
    "block/spruce_planks",
    "block/spruce_sapling",
    "block/spruce_shelf",
    "block/spruce_sign",
    "block/spruce_trapdoor",
    "block/stone",
    "block/stone_bricks",
    "block/stonecutter_bottom",
    "block/stonecutter_saw",
    "block/stonecutter_side",
    "block/stonecutter_top",
    "block/straw_bed",
    "block/straw_bed_particle",
    "block/stripped_acacia_log",
    "block/stripped_acacia_log_top",
    "block/stripped_bamboo_block",
    "block/stripped_bamboo_block_top",
    "block/stripped_birch_log",
    "block/stripped_birch_log_top",
    "block/stripped_cherry_log",
    "block/stripped_cherry_log_top",
    "block/stripped_crimson_stem",
    "block/stripped_crimson_stem_top",
    "block/stripped_dark_oak_log",
    "block/stripped_dark_oak_log_top",
    "block/stripped_jungle_log",
    "block/stripped_jungle_log_top",
    "block/stripped_mangrove_log",
    "block/stripped_mangrove_log_top",
    "block/stripped_oak_log",
    "block/stripped_oak_log_top",
    "block/stripped_pale_oak_log",
    "block/stripped_pale_oak_log_top",
    "block/stripped_poplar_log",
    "block/stripped_poplar_log_top",
    "block/stripped_spruce_log",
    "block/stripped_spruce_log_top",
    "block/stripped_warped_stem",
    "block/stripped_warped_stem_top",
    "block/structure_block",
    "block/structure_block_corner",
    "block/structure_block_data",
    "block/structure_block_load",
    "block/structure_block_save",
    "block/sugar_cane",
    "block/sulfur",
    "block/sulfur_bricks",
    "block/sulfur_spike_down_base",
    "block/sulfur_spike_down_frustum",
    "block/sulfur_spike_down_middle",
    "block/sulfur_spike_down_tip",
    "block/sulfur_spike_down_tip_merge",
    "block/sulfur_spike_up_base",
    "block/sulfur_spike_up_frustum",
    "block/sulfur_spike_up_middle",
    "block/sulfur_spike_up_tip",
    "block/sulfur_spike_up_tip_merge",
    "block/sunflower_back",
    "block/sunflower_bottom",
    "block/sunflower_front",
    "block/sunflower_top",
    "block/suspicious_gravel_0",
    "block/suspicious_gravel_1",
    "block/suspicious_gravel_2",
    "block/suspicious_gravel_3",
    "block/suspicious_sand_0",
    "block/suspicious_sand_1",
    "block/suspicious_sand_2",
    "block/suspicious_sand_3",
    "block/sweet_berry_bush_stage0",
    "block/sweet_berry_bush_stage1",
    "block/sweet_berry_bush_stage2",
    "block/sweet_berry_bush_stage3",
    "block/tall_dry_grass",
    "block/tall_grass_bottom",
    "block/tall_grass_top",
    "block/tall_seagrass_bottom",
    "block/tall_seagrass_top",
    "block/target_side",
    "block/target_top",
    "block/terracotta",
    "block/test_block_accept",
    "block/test_block_fail",
    "block/test_block_log",
    "block/test_block_start",
    "block/test_instance_block",
    "block/tinted_glass",
    "block/tnt_bottom",
    "block/tnt_side",
    "block/tnt_top",
    "block/torch",
    "block/torchflower",
    "block/torchflower_crop_stage0",
    "block/torchflower_crop_stage1",
    "block/trial_spawner_bottom",
    "block/trial_spawner_side_active",
    "block/trial_spawner_side_active_ominous",
    "block/trial_spawner_side_inactive",
    "block/trial_spawner_side_inactive_ominous",
    "block/trial_spawner_top_active",
    "block/trial_spawner_top_active_ominous",
    "block/trial_spawner_top_ejecting_reward",
    "block/trial_spawner_top_ejecting_reward_ominous",
    "block/trial_spawner_top_inactive",
    "block/trial_spawner_top_inactive_ominous",
    "block/tripwire",
    "block/tripwire_hook",
    "block/tube_coral",
    "block/tube_coral_block",
    "block/tube_coral_fan",
    "block/tuff",
    "block/tuff_bricks",
    "block/turtle_egg",
    "block/turtle_egg_slightly_cracked",
    "block/turtle_egg_very_cracked",
    "block/twisting_vines",
    "block/twisting_vines_plant",
    "block/vault_bottom",
    "block/vault_bottom_ominous",
    "block/vault_front_ejecting",
    "block/vault_front_ejecting_ominous",
    "block/vault_front_off",
    "block/vault_front_off_ominous",
    "block/vault_front_on",
    "block/vault_front_on_ominous",
    "block/vault_side_off",
    "block/vault_side_off_ominous",
    "block/vault_side_on",
    "block/vault_side_on_ominous",
    "block/vault_top",
    "block/vault_top_ejecting",
    "block/vault_top_ejecting_ominous",
    "block/vault_top_ominous",
    "block/verdant_froglight_side",
    "block/verdant_froglight_top",
    "block/vine",
    "block/warped_door_bottom",
    "block/warped_door_top",
    "block/warped_fungus",
    "block/warped_hanging_sign",
    "block/warped_nylium",
    "block/warped_nylium_side",
    "block/warped_planks",
    "block/warped_roots",
    "block/warped_roots_pot",
    "block/warped_shelf",
    "block/warped_sign",
    "block/warped_stem",
    "block/warped_stem_top",
    "block/warped_trapdoor",
    "block/warped_wart_block",
    "block/water_flow",
    "block/water_overlay",
    "block/water_still",
    "block/weathered_chiseled_copper",
    "block/weathered_copper",
    "block/weathered_copper_bars",
    "block/weathered_copper_bulb",
    "block/weathered_copper_bulb_lit",
    "block/weathered_copper_bulb_lit_powered",
    "block/weathered_copper_bulb_powered",
    "block/weathered_copper_chain",
    "block/weathered_copper_door_bottom",
    "block/weathered_copper_door_top",
    "block/weathered_copper_grate",
    "block/weathered_copper_lantern",
    "block/weathered_copper_trapdoor",
    "block/weathered_cut_copper",
    "block/weathered_lightning_rod",
    "block/weeping_vines",
    "block/weeping_vines_plant",
    "block/wet_sponge",
    "block/wheat_stage0",
    "block/wheat_stage1",
    "block/wheat_stage2",
    "block/wheat_stage3",
    "block/wheat_stage4",
    "block/wheat_stage5",
    "block/wheat_stage6",
    "block/wheat_stage7",
    "block/white_bed_foot_east",
    "block/white_bed_foot_south",
    "block/white_bed_foot_up",
    "block/white_bed_foot_west",
    "block/white_bed_head_east",
    "block/white_bed_head_up",
    "block/white_bed_head_west",
    "block/white_candle",
    "block/white_candle_lit",
    "block/white_concrete",
    "block/white_concrete_powder",
    "block/white_glazed_terracotta",
    "block/white_shulker_box",
    "block/white_stained_glass",
    "block/white_stained_glass_pane_top",
    "block/white_terracotta",
    "block/white_tulip",
    "block/white_wool",
    "block/wildflowers",
    "block/wildflowers_stem",
    "block/wither_rose",
    "block/yellow_bed_foot_east",
    "block/yellow_bed_foot_south",
    "block/yellow_bed_foot_up",
    "block/yellow_bed_foot_west",
    "block/yellow_bed_head_east",
    "block/yellow_bed_head_up",
    "block/yellow_bed_head_west",
    "block/yellow_candle",
    "block/yellow_candle_lit",
    "block/yellow_concrete",
    "block/yellow_concrete_powder",
    "block/yellow_glazed_terracotta",
    "block/yellow_poplar_leaves",
    "block/yellow_shulker_box",
    "block/yellow_stained_glass",
    "block/yellow_stained_glass_pane_top",
    "block/yellow_terracotta",
    "block/yellow_wool",
    "colormap/dry_foliage",
    "colormap/foliage",
    "colormap/grass",
    "effect/dither",
    "entity/allay/allay",
    "entity/armadillo/armadillo",
    "entity/armadillo/armadillo_baby",
    "entity/armorstand/armorstand",
    "entity/axolotl/axolotl_blue",
    "entity/axolotl/axolotl_blue_baby",
    "entity/axolotl/axolotl_cyan",
    "entity/axolotl/axolotl_cyan_baby",
    "entity/axolotl/axolotl_gold",
    "entity/axolotl/axolotl_gold_baby",
    "entity/axolotl/axolotl_lucy",
    "entity/axolotl/axolotl_lucy_baby",
    "entity/axolotl/axolotl_wild",
    "entity/axolotl/axolotl_wild_baby",
    "entity/banner/banner_base",
    "entity/banner/base",
    "entity/banner/border",
    "entity/banner/bricks",
    "entity/banner/circle",
    "entity/banner/creeper",
    "entity/banner/cross",
    "entity/banner/curly_border",
    "entity/banner/diagonal_left",
    "entity/banner/diagonal_right",
    "entity/banner/diagonal_up_left",
    "entity/banner/diagonal_up_right",
    "entity/banner/flow",
    "entity/banner/flower",
    "entity/banner/globe",
    "entity/banner/gradient",
    "entity/banner/gradient_up",
    "entity/banner/guster",
    "entity/banner/half_horizontal",
    "entity/banner/half_horizontal_bottom",
    "entity/banner/half_vertical",
    "entity/banner/half_vertical_right",
    "entity/banner/mojang",
    "entity/banner/piglin",
    "entity/banner/rhombus",
    "entity/banner/skull",
    "entity/banner/small_stripes",
    "entity/banner/square_bottom_left",
    "entity/banner/square_bottom_right",
    "entity/banner/square_top_left",
    "entity/banner/square_top_right",
    "entity/banner/straight_cross",
    "entity/banner/stripe_bottom",
    "entity/banner/stripe_center",
    "entity/banner/stripe_downleft",
    "entity/banner/stripe_downright",
    "entity/banner/stripe_left",
    "entity/banner/stripe_middle",
    "entity/banner/stripe_right",
    "entity/banner/stripe_top",
    "entity/banner/triangle_bottom",
    "entity/banner/triangle_top",
    "entity/banner/triangles_bottom",
    "entity/banner/triangles_top",
    "entity/bat/bat",
    "entity/beacon/beacon_beam",
    "entity/bear/polarbear",
    "entity/bear/polarbear_baby",
    "entity/bee/bee",
    "entity/bee/bee_angry",
    "entity/bee/bee_angry_baby",
    "entity/bee/bee_angry_nectar",
    "entity/bee/bee_angry_nectar_baby",
    "entity/bee/bee_baby",
    "entity/bee/bee_nectar",
    "entity/bee/bee_nectar_baby",
    "entity/bee/bee_stinger",
    "entity/bell/bell_body",
    "entity/blaze/blaze",
    "entity/boat/acacia",
    "entity/boat/bamboo",
    "entity/boat/birch",
    "entity/boat/cherry",
    "entity/boat/dark_oak",
    "entity/boat/jungle",
    "entity/boat/mangrove",
    "entity/boat/oak",
    "entity/boat/pale_oak",
    "entity/boat/poplar",
    "entity/boat/spruce",
    "entity/breeze/breeze",
    "entity/breeze/breeze_eyes",
    "entity/breeze/breeze_wind",
    "entity/camel/camel",
    "entity/camel/camel_baby",
    "entity/camel/camel_husk",
    "entity/cat/cat_all_black",
    "entity/cat/cat_all_black_baby",
    "entity/cat/cat_black",
    "entity/cat/cat_black_baby",
    "entity/cat/cat_british_shorthair",
    "entity/cat/cat_british_shorthair_baby",
    "entity/cat/cat_calico",
    "entity/cat/cat_calico_baby",
    "entity/cat/cat_collar",
    "entity/cat/cat_collar_baby",
    "entity/cat/cat_jellie",
    "entity/cat/cat_jellie_baby",
    "entity/cat/cat_persian",
    "entity/cat/cat_persian_baby",
    "entity/cat/cat_ragdoll",
    "entity/cat/cat_ragdoll_baby",
    "entity/cat/cat_red",
    "entity/cat/cat_red_baby",
    "entity/cat/cat_siamese",
    "entity/cat/cat_siamese_baby",
    "entity/cat/cat_tabby",
    "entity/cat/cat_tabby_baby",
    "entity/cat/cat_white",
    "entity/cat/cat_white_baby",
    "entity/cat/ocelot",
    "entity/cat/ocelot_baby",
    "entity/chest/christmas",
    "entity/chest/christmas_left",
    "entity/chest/christmas_right",
    "entity/chest/copper",
    "entity/chest/copper_exposed",
    "entity/chest/copper_exposed_left",
    "entity/chest/copper_exposed_right",
    "entity/chest/copper_left",
    "entity/chest/copper_oxidized",
    "entity/chest/copper_oxidized_left",
    "entity/chest/copper_oxidized_right",
    "entity/chest/copper_right",
    "entity/chest/copper_weathered",
    "entity/chest/copper_weathered_left",
    "entity/chest/copper_weathered_right",
    "entity/chest/ender",
    "entity/chest/normal",
    "entity/chest/normal_left",
    "entity/chest/normal_right",
    "entity/chest/trapped",
    "entity/chest/trapped_left",
    "entity/chest/trapped_right",
    "entity/chest_boat/acacia",
    "entity/chest_boat/bamboo",
    "entity/chest_boat/birch",
    "entity/chest_boat/cherry",
    "entity/chest_boat/dark_oak",
    "entity/chest_boat/jungle",
    "entity/chest_boat/mangrove",
    "entity/chest_boat/oak",
    "entity/chest_boat/pale_oak",
    "entity/chest_boat/poplar",
    "entity/chest_boat/spruce",
    "entity/chicken/chicken_cold",
    "entity/chicken/chicken_cold_baby",
    "entity/chicken/chicken_temperate",
    "entity/chicken/chicken_temperate_baby",
    "entity/chicken/chicken_warm",
    "entity/chicken/chicken_warm_baby",
    "entity/conduit/base",
    "entity/conduit/break_particle",
    "entity/conduit/cage",
    "entity/conduit/closed_eye",
    "entity/conduit/open_eye",
    "entity/conduit/wind",
    "entity/conduit/wind_vertical",
    "entity/copper_golem/copper_golem",
    "entity/copper_golem/copper_golem_exposed",
    "entity/copper_golem/copper_golem_eyes",
    "entity/copper_golem/copper_golem_eyes_exposed",
    "entity/copper_golem/copper_golem_eyes_oxidized",
    "entity/copper_golem/copper_golem_eyes_weathered",
    "entity/copper_golem/copper_golem_oxidized",
    "entity/copper_golem/copper_golem_weathered",
    "entity/cow/cow_cold",
    "entity/cow/cow_cold_baby",
    "entity/cow/cow_temperate",
    "entity/cow/cow_temperate_baby",
    "entity/cow/cow_warm",
    "entity/cow/cow_warm_baby",
    "entity/cow/mooshroom_brown",
    "entity/cow/mooshroom_brown_baby",
    "entity/cow/mooshroom_red",
    "entity/cow/mooshroom_red_baby",
    "entity/creaking/creaking",
    "entity/creaking/creaking_eyes",
    "entity/creeper/creeper",
    "entity/creeper/creeper_armor",
    "entity/cushion/black_cushion",
    "entity/cushion/blue_cushion",
    "entity/cushion/brown_cushion",
    "entity/cushion/cyan_cushion",
    "entity/cushion/gray_cushion",
    "entity/cushion/green_cushion",
    "entity/cushion/light_blue_cushion",
    "entity/cushion/light_gray_cushion",
    "entity/cushion/lime_cushion",
    "entity/cushion/magenta_cushion",
    "entity/cushion/orange_cushion",
    "entity/cushion/pink_cushion",
    "entity/cushion/purple_cushion",
    "entity/cushion/red_cushion",
    "entity/cushion/white_cushion",
    "entity/cushion/yellow_cushion",
    "entity/decorated_pot/angler_pottery_pattern",
    "entity/decorated_pot/archer_pottery_pattern",
    "entity/decorated_pot/arms_up_pottery_pattern",
    "entity/decorated_pot/blade_pottery_pattern",
    "entity/decorated_pot/brewer_pottery_pattern",
    "entity/decorated_pot/burn_pottery_pattern",
    "entity/decorated_pot/danger_pottery_pattern",
    "entity/decorated_pot/decorated_pot_base",
    "entity/decorated_pot/decorated_pot_side",
    "entity/decorated_pot/explorer_pottery_pattern",
    "entity/decorated_pot/flow_pottery_pattern",
    "entity/decorated_pot/friend_pottery_pattern",
    "entity/decorated_pot/guster_pottery_pattern",
    "entity/decorated_pot/heart_pottery_pattern",
    "entity/decorated_pot/heartbreak_pottery_pattern",
    "entity/decorated_pot/howl_pottery_pattern",
    "entity/decorated_pot/miner_pottery_pattern",
    "entity/decorated_pot/mourner_pottery_pattern",
    "entity/decorated_pot/plenty_pottery_pattern",
    "entity/decorated_pot/prize_pottery_pattern",
    "entity/decorated_pot/scrape_pottery_pattern",
    "entity/decorated_pot/sheaf_pottery_pattern",
    "entity/decorated_pot/shelter_pottery_pattern",
    "entity/decorated_pot/skull_pottery_pattern",
    "entity/decorated_pot/snort_pottery_pattern",
    "entity/dolphin/dolphin",
    "entity/dolphin/dolphin_baby",
    "entity/enchantment/enchanting_table_book",
    "entity/end_crystal/end_crystal",
    "entity/end_crystal/end_crystal_beam",
    "entity/end_portal/end_gateway_beam",
    "entity/end_portal/end_portal",
    "entity/enderdragon/dragon",
    "entity/enderdragon/dragon_exploding",
    "entity/enderdragon/dragon_eyes",
    "entity/enderdragon/dragon_fireball",
    "entity/enderman/enderman",
    "entity/enderman/enderman_eyes",
    "entity/endermite/endermite",
    "entity/equipment/camel_husk_saddle/saddle",
    "entity/equipment/camel_saddle/saddle",
    "entity/equipment/donkey_saddle/saddle",
    "entity/equipment/happy_ghast_body/black_harness",
    "entity/equipment/happy_ghast_body/blue_harness",
    "entity/equipment/happy_ghast_body/brown_harness",
    "entity/equipment/happy_ghast_body/cyan_harness",
    "entity/equipment/happy_ghast_body/gray_harness",
    "entity/equipment/happy_ghast_body/green_harness",
    "entity/equipment/happy_ghast_body/light_blue_harness",
    "entity/equipment/happy_ghast_body/light_gray_harness",
    "entity/equipment/happy_ghast_body/lime_harness",
    "entity/equipment/happy_ghast_body/magenta_harness",
    "entity/equipment/happy_ghast_body/orange_harness",
    "entity/equipment/happy_ghast_body/pink_harness",
    "entity/equipment/happy_ghast_body/purple_harness",
    "entity/equipment/happy_ghast_body/red_harness",
    "entity/equipment/happy_ghast_body/white_harness",
    "entity/equipment/happy_ghast_body/yellow_harness",
    "entity/equipment/horse_body/copper",
    "entity/equipment/horse_body/diamond",
    "entity/equipment/horse_body/gold",
    "entity/equipment/horse_body/iron",
    "entity/equipment/horse_body/leather",
    "entity/equipment/horse_body/leather_overlay",
    "entity/equipment/horse_body/netherite",
    "entity/equipment/horse_saddle/saddle",
    "entity/equipment/humanoid/chainmail",
    "entity/equipment/humanoid/copper",
    "entity/equipment/humanoid/diamond",
    "entity/equipment/humanoid/gold",
    "entity/equipment/humanoid/iron",
    "entity/equipment/humanoid/leather",
    "entity/equipment/humanoid/leather_overlay",
    "entity/equipment/humanoid/netherite",
    "entity/equipment/humanoid/turtle_scute",
    "entity/equipment/humanoid_baby/chainmail",
    "entity/equipment/humanoid_baby/copper",
    "entity/equipment/humanoid_baby/diamond",
    "entity/equipment/humanoid_baby/gold",
    "entity/equipment/humanoid_baby/iron",
    "entity/equipment/humanoid_baby/leather",
    "entity/equipment/humanoid_baby/leather_overlay",
    "entity/equipment/humanoid_baby/netherite",
    "entity/equipment/humanoid_baby/turtle_scute",
    "entity/equipment/humanoid_leggings/chainmail",
    "entity/equipment/humanoid_leggings/copper",
    "entity/equipment/humanoid_leggings/diamond",
    "entity/equipment/humanoid_leggings/gold",
    "entity/equipment/humanoid_leggings/iron",
    "entity/equipment/humanoid_leggings/leather",
    "entity/equipment/humanoid_leggings/leather_overlay",
    "entity/equipment/humanoid_leggings/netherite",
    "entity/equipment/llama_body/black",
    "entity/equipment/llama_body/blue",
    "entity/equipment/llama_body/brown",
    "entity/equipment/llama_body/cyan",
    "entity/equipment/llama_body/gray",
    "entity/equipment/llama_body/green",
    "entity/equipment/llama_body/light_blue",
    "entity/equipment/llama_body/light_gray",
    "entity/equipment/llama_body/lime",
    "entity/equipment/llama_body/magenta",
    "entity/equipment/llama_body/orange",
    "entity/equipment/llama_body/pink",
    "entity/equipment/llama_body/purple",
    "entity/equipment/llama_body/red",
    "entity/equipment/llama_body/trader_llama",
    "entity/equipment/llama_body/trader_llama_baby",
    "entity/equipment/llama_body/white",
    "entity/equipment/llama_body/yellow",
    "entity/equipment/mule_saddle/saddle",
    "entity/equipment/nautilus_body/copper",
    "entity/equipment/nautilus_body/diamond",
    "entity/equipment/nautilus_body/gold",
    "entity/equipment/nautilus_body/iron",
    "entity/equipment/nautilus_body/netherite",
    "entity/equipment/nautilus_saddle/saddle",
    "entity/equipment/pig_saddle/saddle",
    "entity/equipment/skeleton_horse_saddle/saddle",
    "entity/equipment/strider_saddle/saddle",
    "entity/equipment/wings/elytra",
    "entity/equipment/wolf_body/armadillo_scute",
    "entity/equipment/wolf_body/armadillo_scute_overlay",
    "entity/equipment/zombie_horse_saddle/saddle",
    "entity/experience/experience_orb",
    "entity/fish/cod",
    "entity/fish/pufferfish",
    "entity/fish/salmon",
    "entity/fish/tropical_a",
    "entity/fish/tropical_a_pattern_1",
    "entity/fish/tropical_a_pattern_2",
    "entity/fish/tropical_a_pattern_3",
    "entity/fish/tropical_a_pattern_4",
    "entity/fish/tropical_a_pattern_5",
    "entity/fish/tropical_a_pattern_6",
    "entity/fish/tropical_b",
    "entity/fish/tropical_b_pattern_1",
    "entity/fish/tropical_b_pattern_2",
    "entity/fish/tropical_b_pattern_3",
    "entity/fish/tropical_b_pattern_4",
    "entity/fish/tropical_b_pattern_5",
    "entity/fish/tropical_b_pattern_6",
    "entity/fishing/fishing_hook",
    "entity/fox/fox",
    "entity/fox/fox_baby",
    "entity/fox/fox_sleep",
    "entity/fox/fox_sleep_baby",
    "entity/fox/fox_snow",
    "entity/fox/fox_snow_baby",
    "entity/fox/fox_snow_sleep",
    "entity/fox/fox_snow_sleep_baby",
    "entity/frog/frog_cold",
    "entity/frog/frog_temperate",
    "entity/frog/frog_warm",
    "entity/ghast/ghast",
    "entity/ghast/ghast_shooting",
    "entity/ghast/happy_ghast",
    "entity/ghast/happy_ghast_baby",
    "entity/ghast/happy_ghast_ropes",
    "entity/goat/goat",
    "entity/goat/goat_baby",
    "entity/guardian/guardian",
    "entity/guardian/guardian_beam",
    "entity/guardian/guardian_elder",
    "entity/hoglin/hoglin",
    "entity/hoglin/hoglin_baby",
    "entity/hoglin/zoglin",
    "entity/hoglin/zoglin_baby",
    "entity/horse/donkey",
    "entity/horse/donkey_baby",
    "entity/horse/horse_black",
    "entity/horse/horse_black_baby",
    "entity/horse/horse_brown",
    "entity/horse/horse_brown_baby",
    "entity/horse/horse_chestnut",
    "entity/horse/horse_chestnut_baby",
    "entity/horse/horse_creamy",
    "entity/horse/horse_creamy_baby",
    "entity/horse/horse_darkbrown",
    "entity/horse/horse_darkbrown_baby",
    "entity/horse/horse_gray",
    "entity/horse/horse_gray_baby",
    "entity/horse/horse_markings_blackdots",
    "entity/horse/horse_markings_blackdots_baby",
    "entity/horse/horse_markings_white",
    "entity/horse/horse_markings_white_baby",
    "entity/horse/horse_markings_whitedots",
    "entity/horse/horse_markings_whitedots_baby",
    "entity/horse/horse_markings_whitefield",
    "entity/horse/horse_markings_whitefield_baby",
    "entity/horse/horse_skeleton",
    "entity/horse/horse_skeleton_baby",
    "entity/horse/horse_white",
    "entity/horse/horse_white_baby",
    "entity/horse/horse_zombie",
    "entity/horse/horse_zombie_baby",
    "entity/horse/mule",
    "entity/horse/mule_baby",
    "entity/illager/evoker",
    "entity/illager/evoker_fangs",
    "entity/illager/illusioner",
    "entity/illager/pillager",
    "entity/illager/ravager",
    "entity/illager/vex",
    "entity/illager/vex_charging",
    "entity/illager/vindicator",
    "entity/iron_golem/iron_golem",
    "entity/iron_golem/iron_golem_crackiness_high",
    "entity/iron_golem/iron_golem_crackiness_low",
    "entity/iron_golem/iron_golem_crackiness_medium",
    "entity/lead_knot/lead_knot",
    "entity/llama/llama_brown",
    "entity/llama/llama_brown_baby",
    "entity/llama/llama_creamy",
    "entity/llama/llama_creamy_baby",
    "entity/llama/llama_gray",
    "entity/llama/llama_gray_baby",
    "entity/llama/llama_spit",
    "entity/llama/llama_white",
    "entity/llama/llama_white_baby",
    "entity/minecart/minecart",
    "entity/nautilus/nautilus",
    "entity/nautilus/nautilus_baby",
    "entity/nautilus/zombie_nautilus",
    "entity/nautilus/zombie_nautilus_coral",
    "entity/panda/aggressive_panda_baby",
    "entity/panda/brown_panda_baby",
    "entity/panda/lazy_panda_baby",
    "entity/panda/panda",
    "entity/panda/panda_aggressive",
    "entity/panda/panda_baby",
    "entity/panda/panda_brown",
    "entity/panda/panda_lazy",
    "entity/panda/panda_playful",
    "entity/panda/panda_weak",
    "entity/panda/panda_worried",
    "entity/panda/playful_panda_baby",
    "entity/panda/weak_panda_baby",
    "entity/panda/worried_panda_baby",
    "entity/parrot/parrot_blue",
    "entity/parrot/parrot_green",
    "entity/parrot/parrot_grey",
    "entity/parrot/parrot_red_blue",
    "entity/parrot/parrot_yellow_blue",
    "entity/phantom/phantom",
    "entity/phantom/phantom_eyes",
    "entity/pig/pig_cold",
    "entity/pig/pig_cold_baby",
    "entity/pig/pig_temperate",
    "entity/pig/pig_temperate_baby",
    "entity/pig/pig_warm",
    "entity/pig/pig_warm_baby",
    "entity/piglin/piglin",
    "entity/piglin/piglin_baby",
    "entity/piglin/piglin_brute",
    "entity/piglin/zombified_piglin",
    "entity/piglin/zombified_piglin_baby",
    "entity/player/slim/alex",
    "entity/player/slim/ari",
    "entity/player/slim/efe",
    "entity/player/slim/kai",
    "entity/player/slim/makena",
    "entity/player/slim/noor",
    "entity/player/slim/steve",
    "entity/player/slim/sunny",
    "entity/player/slim/zuri",
    "entity/player/wide/alex",
    "entity/player/wide/ari",
    "entity/player/wide/efe",
    "entity/player/wide/kai",
    "entity/player/wide/makena",
    "entity/player/wide/noor",
    "entity/player/wide/steve",
    "entity/player/wide/sunny",
    "entity/player/wide/zuri",
    "entity/projectiles/arrow",
    "entity/projectiles/arrow_spectral",
    "entity/projectiles/arrow_tipped",
    "entity/projectiles/wind_charge",
    "entity/rabbit/rabbit_black",
    "entity/rabbit/rabbit_black_baby",
    "entity/rabbit/rabbit_brown",
    "entity/rabbit/rabbit_brown_baby",
    "entity/rabbit/rabbit_caerbannog",
    "entity/rabbit/rabbit_caerbannog_baby",
    "entity/rabbit/rabbit_gold",
    "entity/rabbit/rabbit_gold_baby",
    "entity/rabbit/rabbit_salt",
    "entity/rabbit/rabbit_salt_baby",
    "entity/rabbit/rabbit_toast",
    "entity/rabbit/rabbit_toast_baby",
    "entity/rabbit/rabbit_white",
    "entity/rabbit/rabbit_white_baby",
    "entity/rabbit/rabbit_white_splotched",
    "entity/rabbit/rabbit_white_splotched_baby",
    "entity/sheep/sheep",
    "entity/sheep/sheep_baby",
    "entity/sheep/sheep_wool",
    "entity/sheep/sheep_wool_baby",
    "entity/sheep/sheep_wool_undercoat",
    "entity/shield/base",
    "entity/shield/border",
    "entity/shield/bricks",
    "entity/shield/circle",
    "entity/shield/creeper",
    "entity/shield/cross",
    "entity/shield/curly_border",
    "entity/shield/diagonal_left",
    "entity/shield/diagonal_right",
    "entity/shield/diagonal_up_left",
    "entity/shield/diagonal_up_right",
    "entity/shield/flow",
    "entity/shield/flower",
    "entity/shield/globe",
    "entity/shield/gradient",
    "entity/shield/gradient_up",
    "entity/shield/guster",
    "entity/shield/half_horizontal",
    "entity/shield/half_horizontal_bottom",
    "entity/shield/half_vertical",
    "entity/shield/half_vertical_right",
    "entity/shield/mojang",
    "entity/shield/piglin",
    "entity/shield/rhombus",
    "entity/shield/shield_base",
    "entity/shield/shield_base_nopattern",
    "entity/shield/skull",
    "entity/shield/small_stripes",
    "entity/shield/square_bottom_left",
    "entity/shield/square_bottom_right",
    "entity/shield/square_top_left",
    "entity/shield/square_top_right",
    "entity/shield/straight_cross",
    "entity/shield/stripe_bottom",
    "entity/shield/stripe_center",
    "entity/shield/stripe_downleft",
    "entity/shield/stripe_downright",
    "entity/shield/stripe_left",
    "entity/shield/stripe_middle",
    "entity/shield/stripe_right",
    "entity/shield/stripe_top",
    "entity/shield/triangle_bottom",
    "entity/shield/triangle_top",
    "entity/shield/triangles_bottom",
    "entity/shield/triangles_top",
    "entity/shulker/shulker",
    "entity/shulker/shulker_black",
    "entity/shulker/shulker_blue",
    "entity/shulker/shulker_brown",
    "entity/shulker/shulker_cyan",
    "entity/shulker/shulker_gray",
    "entity/shulker/shulker_green",
    "entity/shulker/shulker_light_blue",
    "entity/shulker/shulker_light_gray",
    "entity/shulker/shulker_lime",
    "entity/shulker/shulker_magenta",
    "entity/shulker/shulker_orange",
    "entity/shulker/shulker_pink",
    "entity/shulker/shulker_purple",
    "entity/shulker/shulker_red",
    "entity/shulker/shulker_white",
    "entity/shulker/shulker_yellow",
    "entity/shulker/spark",
    "entity/silverfish/silverfish",
    "entity/skeleton/bogged",
    "entity/skeleton/bogged_overlay",
    "entity/skeleton/parched",
    "entity/skeleton/skeleton",
    "entity/skeleton/stray",
    "entity/skeleton/stray_overlay",
    "entity/skeleton/wither_skeleton",
    "entity/slime/magmacube",
    "entity/slime/slime",
    "entity/sniffer/sniffer",
    "entity/sniffer/snifflet",
    "entity/snow_golem/snow_golem",
    "entity/spider/cave_spider",
    "entity/spider/spider",
    "entity/spider/spider_eyes",
    "entity/squid/glow_squid",
    "entity/squid/glow_squid_baby",
    "entity/squid/squid",
    "entity/squid/squid_baby",
    "entity/strider/strider",
    "entity/strider/strider_baby",
    "entity/strider/strider_cold",
    "entity/strider/strider_cold_baby",
    "entity/sulfur_cube/sulfur_cube_inner",
    "entity/sulfur_cube/sulfur_cube_inner_small",
    "entity/sulfur_cube/sulfur_cube_outer",
    "entity/sulfur_cube/sulfur_cube_outer_small",
    "entity/tadpole/tadpole",
    "entity/trident/trident",
    "entity/trident/trident_riptide",
    "entity/turtle/turtle",
    "entity/turtle/turtle_baby",
    "entity/villager/baby/desert",
    "entity/villager/baby/jungle",
    "entity/villager/baby/plains",
    "entity/villager/baby/savanna",
    "entity/villager/baby/snow",
    "entity/villager/baby/swamp",
    "entity/villager/baby/taiga",
    "entity/villager/profession/armorer",
    "entity/villager/profession/butcher",
    "entity/villager/profession/cartographer",
    "entity/villager/profession/cleric",
    "entity/villager/profession/farmer",
    "entity/villager/profession/fisherman",
    "entity/villager/profession/fletcher",
    "entity/villager/profession/leatherworker",
    "entity/villager/profession/librarian",
    "entity/villager/profession/mason",
    "entity/villager/profession/nitwit",
    "entity/villager/profession/shepherd",
    "entity/villager/profession/toolsmith",
    "entity/villager/profession/weaponsmith",
    "entity/villager/profession_level/diamond",
    "entity/villager/profession_level/emerald",
    "entity/villager/profession_level/gold",
    "entity/villager/profession_level/iron",
    "entity/villager/profession_level/stone",
    "entity/villager/type/desert",
    "entity/villager/type/jungle",
    "entity/villager/type/plains",
    "entity/villager/type/savanna",
    "entity/villager/type/snow",
    "entity/villager/type/swamp",
    "entity/villager/type/taiga",
    "entity/villager/villager",
    "entity/villager/villager_baby",
    "entity/wandering_trader/wandering_trader",
    "entity/warden/warden",
    "entity/warden/warden_bioluminescent_layer",
    "entity/warden/warden_heart",
    "entity/warden/warden_pulsating_spots_1",
    "entity/warden/warden_pulsating_spots_2",
    "entity/witch/witch",
    "entity/wither/wither",
    "entity/wither/wither_armor",
    "entity/wither/wither_invulnerable",
    "entity/wolf/wolf",
    "entity/wolf/wolf_angry",
    "entity/wolf/wolf_angry_baby",
    "entity/wolf/wolf_armor_crackiness_high",
    "entity/wolf/wolf_armor_crackiness_low",
    "entity/wolf/wolf_armor_crackiness_medium",
    "entity/wolf/wolf_ashen",
    "entity/wolf/wolf_ashen_angry",
    "entity/wolf/wolf_ashen_angry_baby",
    "entity/wolf/wolf_ashen_baby",
    "entity/wolf/wolf_ashen_tame",
    "entity/wolf/wolf_ashen_tame_baby",
    "entity/wolf/wolf_baby",
    "entity/wolf/wolf_black",
    "entity/wolf/wolf_black_angry",
    "entity/wolf/wolf_black_angry_baby",
    "entity/wolf/wolf_black_baby",
    "entity/wolf/wolf_black_tame",
    "entity/wolf/wolf_black_tame_baby",
    "entity/wolf/wolf_chestnut",
    "entity/wolf/wolf_chestnut_angry",
    "entity/wolf/wolf_chestnut_angry_baby",
    "entity/wolf/wolf_chestnut_baby",
    "entity/wolf/wolf_chestnut_tame",
    "entity/wolf/wolf_chestnut_tame_baby",
    "entity/wolf/wolf_collar",
    "entity/wolf/wolf_collar_baby",
    "entity/wolf/wolf_rusty",
    "entity/wolf/wolf_rusty_angry",
    "entity/wolf/wolf_rusty_angry_baby",
    "entity/wolf/wolf_rusty_baby",
    "entity/wolf/wolf_rusty_tame",
    "entity/wolf/wolf_rusty_tame_baby",
    "entity/wolf/wolf_snowy",
    "entity/wolf/wolf_snowy_angry",
    "entity/wolf/wolf_snowy_angry_baby",
    "entity/wolf/wolf_snowy_baby",
    "entity/wolf/wolf_snowy_tame",
    "entity/wolf/wolf_snowy_tame_baby",
    "entity/wolf/wolf_spotted",
    "entity/wolf/wolf_spotted_angry",
    "entity/wolf/wolf_spotted_angry_baby",
    "entity/wolf/wolf_spotted_baby",
    "entity/wolf/wolf_spotted_tame",
    "entity/wolf/wolf_spotted_tame_baby",
    "entity/wolf/wolf_striped",
    "entity/wolf/wolf_striped_angry",
    "entity/wolf/wolf_striped_angry_baby",
    "entity/wolf/wolf_striped_baby",
    "entity/wolf/wolf_striped_tame",
    "entity/wolf/wolf_striped_tame_baby",
    "entity/wolf/wolf_tame",
    "entity/wolf/wolf_tame_baby",
    "entity/wolf/wolf_woods",
    "entity/wolf/wolf_woods_angry",
    "entity/wolf/wolf_woods_angry_baby",
    "entity/wolf/wolf_woods_baby",
    "entity/wolf/wolf_woods_tame",
    "entity/wolf/wolf_woods_tame_baby",
    "entity/zombie/drowned",
    "entity/zombie/drowned_baby",
    "entity/zombie/drowned_outer_layer",
    "entity/zombie/drowned_outer_layer_baby",
    "entity/zombie/husk",
    "entity/zombie/husk_baby",
    "entity/zombie/zombie",
    "entity/zombie/zombie_baby",
    "entity/zombie_villager/baby/desert",
    "entity/zombie_villager/baby/jungle",
    "entity/zombie_villager/baby/plains",
    "entity/zombie_villager/baby/savanna",
    "entity/zombie_villager/baby/snow",
    "entity/zombie_villager/baby/swamp",
    "entity/zombie_villager/baby/taiga",
    "entity/zombie_villager/profession/armorer",
    "entity/zombie_villager/profession/butcher",
    "entity/zombie_villager/profession/cartographer",
    "entity/zombie_villager/profession/cleric",
    "entity/zombie_villager/profession/farmer",
    "entity/zombie_villager/profession/fisherman",
    "entity/zombie_villager/profession/fletcher",
    "entity/zombie_villager/profession/leatherworker",
    "entity/zombie_villager/profession/librarian",
    "entity/zombie_villager/profession/mason",
    "entity/zombie_villager/profession/nitwit",
    "entity/zombie_villager/profession/shepherd",
    "entity/zombie_villager/profession/toolsmith",
    "entity/zombie_villager/profession/weaponsmith",
    "entity/zombie_villager/profession_level/diamond",
    "entity/zombie_villager/profession_level/emerald",
    "entity/zombie_villager/profession_level/gold",
    "entity/zombie_villager/profession_level/iron",
    "entity/zombie_villager/profession_level/stone",
    "entity/zombie_villager/type/desert",
    "entity/zombie_villager/type/jungle",
    "entity/zombie_villager/type/plains",
    "entity/zombie_villager/type/savanna",
    "entity/zombie_villager/type/snow",
    "entity/zombie_villager/type/swamp",
    "entity/zombie_villager/type/taiga",
    "entity/zombie_villager/zombie_villager",
    "entity/zombie_villager/zombie_villager_baby",
    "environment/celestial/end_flash",
    "environment/celestial/moon/first_quarter",
    "environment/celestial/moon/full_moon",
    "environment/celestial/moon/new_moon",
    "environment/celestial/moon/third_quarter",
    "environment/celestial/moon/waning_crescent",
    "environment/celestial/moon/waning_gibbous",
    "environment/celestial/moon/waxing_crescent",
    "environment/celestial/moon/waxing_gibbous",
    "environment/celestial/sun",
    "environment/clouds",
    "environment/end_sky",
    "environment/rain",
    "environment/snow",
    "font/accented",
    "font/ascii",
    "font/ascii_sga",
    "font/asciillager",
    "font/nonlatin_european",
    "gui/advancements/backgrounds/adventure",
    "gui/advancements/backgrounds/end",
    "gui/advancements/backgrounds/husbandry",
    "gui/advancements/backgrounds/nether",
    "gui/advancements/backgrounds/stone",
    "gui/advancements/window",
    "gui/book",
    "gui/container/anvil",
    "gui/container/beacon",
    "gui/container/blast_furnace",
    "gui/container/brewing_stand",
    "gui/container/cartography_table",
    "gui/container/crafter",
    "gui/container/crafting_table",
    "gui/container/creative_inventory/tab_inventory",
    "gui/container/creative_inventory/tab_item_search",
    "gui/container/creative_inventory/tab_items",
    "gui/container/dispenser",
    "gui/container/enchanting_table",
    "gui/container/furnace",
    "gui/container/gamemode_switcher",
    "gui/container/generic_54",
    "gui/container/grindstone",
    "gui/container/hopper",
    "gui/container/horse",
    "gui/container/inventory",
    "gui/container/loom",
    "gui/container/nautilus",
    "gui/container/shulker_box",
    "gui/container/smithing",
    "gui/container/smoker",
    "gui/container/stonecutter",
    "gui/container/villager",
    "gui/footer_separator",
    "gui/hanging_signs/acacia",
    "gui/hanging_signs/bamboo",
    "gui/hanging_signs/birch",
    "gui/hanging_signs/cherry",
    "gui/hanging_signs/crimson",
    "gui/hanging_signs/dark_oak",
    "gui/hanging_signs/jungle",
    "gui/hanging_signs/mangrove",
    "gui/hanging_signs/oak",
    "gui/hanging_signs/pale_oak",
    "gui/hanging_signs/poplar",
    "gui/hanging_signs/spruce",
    "gui/hanging_signs/warped",
    "gui/header_separator",
    "gui/inworld_footer_separator",
    "gui/inworld_header_separator",
    "gui/inworld_menu_background",
    "gui/inworld_menu_list_background",
    "gui/menu_background",
    "gui/menu_list_background",
    "gui/presets/isles",
    "gui/realms/adventure",
    "gui/realms/empty_frame",
    "gui/realms/experience",
    "gui/realms/inspiration",
    "gui/realms/new_world",
    "gui/realms/no_realms",
    "gui/realms/snapshot_realms",
    "gui/realms/survival_spawn",
    "gui/realms/upload",
    "gui/recipe_book",
    "gui/signs/acacia",
    "gui/signs/bamboo",
    "gui/signs/birch",
    "gui/signs/cherry",
    "gui/signs/crimson",
    "gui/signs/dark_oak",
    "gui/signs/jungle",
    "gui/signs/mangrove",
    "gui/signs/oak",
    "gui/signs/pale_oak",
    "gui/signs/poplar",
    "gui/signs/spruce",
    "gui/signs/warped",
    "gui/sprites/advancements/box_obtained",
    "gui/sprites/advancements/box_unobtained",
    "gui/sprites/advancements/challenge_frame_obtained",
    "gui/sprites/advancements/challenge_frame_unobtained",
    "gui/sprites/advancements/goal_frame_obtained",
    "gui/sprites/advancements/goal_frame_unobtained",
    "gui/sprites/advancements/tab_above_left",
    "gui/sprites/advancements/tab_above_left_selected",
    "gui/sprites/advancements/tab_above_middle",
    "gui/sprites/advancements/tab_above_middle_selected",
    "gui/sprites/advancements/tab_above_right",
    "gui/sprites/advancements/tab_above_right_selected",
    "gui/sprites/advancements/tab_below_left",
    "gui/sprites/advancements/tab_below_left_selected",
    "gui/sprites/advancements/tab_below_middle",
    "gui/sprites/advancements/tab_below_middle_selected",
    "gui/sprites/advancements/tab_below_right",
    "gui/sprites/advancements/tab_below_right_selected",
    "gui/sprites/advancements/tab_left_bottom",
    "gui/sprites/advancements/tab_left_bottom_selected",
    "gui/sprites/advancements/tab_left_middle",
    "gui/sprites/advancements/tab_left_middle_selected",
    "gui/sprites/advancements/tab_left_top",
    "gui/sprites/advancements/tab_left_top_selected",
    "gui/sprites/advancements/tab_right_bottom",
    "gui/sprites/advancements/tab_right_bottom_selected",
    "gui/sprites/advancements/tab_right_middle",
    "gui/sprites/advancements/tab_right_middle_selected",
    "gui/sprites/advancements/tab_right_top",
    "gui/sprites/advancements/tab_right_top_selected",
    "gui/sprites/advancements/task_frame_obtained",
    "gui/sprites/advancements/task_frame_unobtained",
    "gui/sprites/advancements/title_box",
    "gui/sprites/boss_bar/blue_background",
    "gui/sprites/boss_bar/blue_progress",
    "gui/sprites/boss_bar/green_background",
    "gui/sprites/boss_bar/green_progress",
    "gui/sprites/boss_bar/notched_10_background",
    "gui/sprites/boss_bar/notched_10_progress",
    "gui/sprites/boss_bar/notched_12_background",
    "gui/sprites/boss_bar/notched_12_progress",
    "gui/sprites/boss_bar/notched_20_background",
    "gui/sprites/boss_bar/notched_20_progress",
    "gui/sprites/boss_bar/notched_6_background",
    "gui/sprites/boss_bar/notched_6_progress",
    "gui/sprites/boss_bar/pink_background",
    "gui/sprites/boss_bar/pink_progress",
    "gui/sprites/boss_bar/purple_background",
    "gui/sprites/boss_bar/purple_progress",
    "gui/sprites/boss_bar/red_background",
    "gui/sprites/boss_bar/red_progress",
    "gui/sprites/boss_bar/white_background",
    "gui/sprites/boss_bar/white_progress",
    "gui/sprites/boss_bar/yellow_background",
    "gui/sprites/boss_bar/yellow_progress",
    "gui/sprites/container/anvil/error",
    "gui/sprites/container/anvil/text_field",
    "gui/sprites/container/anvil/text_field_disabled",
    "gui/sprites/container/beacon/button",
    "gui/sprites/container/beacon/button_disabled",
    "gui/sprites/container/beacon/button_highlighted",
    "gui/sprites/container/beacon/button_selected",
    "gui/sprites/container/beacon/cancel",
    "gui/sprites/container/beacon/confirm",
    "gui/sprites/container/blast_furnace/burn_progress",
    "gui/sprites/container/blast_furnace/lit_progress",
    "gui/sprites/container/brewing_stand/brew_progress",
    "gui/sprites/container/brewing_stand/bubbles",
    "gui/sprites/container/brewing_stand/fuel_length",
    "gui/sprites/container/bundle/bundle_progressbar_border",
    "gui/sprites/container/bundle/bundle_progressbar_fill",
    "gui/sprites/container/bundle/bundle_progressbar_full",
    "gui/sprites/container/bundle/slot_background",
    "gui/sprites/container/bundle/slot_highlight_back",
    "gui/sprites/container/bundle/slot_highlight_front",
    "gui/sprites/container/cartography_table/duplicated_map",
    "gui/sprites/container/cartography_table/error",
    "gui/sprites/container/cartography_table/locked",
    "gui/sprites/container/cartography_table/map",
    "gui/sprites/container/cartography_table/scaled_map",
    "gui/sprites/container/crafter/disabled_slot",
    "gui/sprites/container/crafter/powered_redstone",
    "gui/sprites/container/crafter/unpowered_redstone",
    "gui/sprites/container/creative_inventory/scroller",
    "gui/sprites/container/creative_inventory/scroller_disabled",
    "gui/sprites/container/creative_inventory/tab_bottom_selected_1",
    "gui/sprites/container/creative_inventory/tab_bottom_selected_2",
    "gui/sprites/container/creative_inventory/tab_bottom_selected_3",
    "gui/sprites/container/creative_inventory/tab_bottom_selected_4",
    "gui/sprites/container/creative_inventory/tab_bottom_selected_5",
    "gui/sprites/container/creative_inventory/tab_bottom_selected_6",
    "gui/sprites/container/creative_inventory/tab_bottom_selected_7",
    "gui/sprites/container/creative_inventory/tab_bottom_unselected_1",
    "gui/sprites/container/creative_inventory/tab_bottom_unselected_2",
    "gui/sprites/container/creative_inventory/tab_bottom_unselected_3",
    "gui/sprites/container/creative_inventory/tab_bottom_unselected_4",
    "gui/sprites/container/creative_inventory/tab_bottom_unselected_5",
    "gui/sprites/container/creative_inventory/tab_bottom_unselected_6",
    "gui/sprites/container/creative_inventory/tab_bottom_unselected_7",
    "gui/sprites/container/creative_inventory/tab_top_selected_1",
    "gui/sprites/container/creative_inventory/tab_top_selected_2",
    "gui/sprites/container/creative_inventory/tab_top_selected_3",
    "gui/sprites/container/creative_inventory/tab_top_selected_4",
    "gui/sprites/container/creative_inventory/tab_top_selected_5",
    "gui/sprites/container/creative_inventory/tab_top_selected_6",
    "gui/sprites/container/creative_inventory/tab_top_selected_7",
    "gui/sprites/container/creative_inventory/tab_top_unselected_1",
    "gui/sprites/container/creative_inventory/tab_top_unselected_2",
    "gui/sprites/container/creative_inventory/tab_top_unselected_3",
    "gui/sprites/container/creative_inventory/tab_top_unselected_4",
    "gui/sprites/container/creative_inventory/tab_top_unselected_5",
    "gui/sprites/container/creative_inventory/tab_top_unselected_6",
    "gui/sprites/container/creative_inventory/tab_top_unselected_7",
    "gui/sprites/container/enchanting_table/enchantment_slot",
    "gui/sprites/container/enchanting_table/enchantment_slot_disabled",
    "gui/sprites/container/enchanting_table/enchantment_slot_highlighted",
    "gui/sprites/container/enchanting_table/level_1",
    "gui/sprites/container/enchanting_table/level_1_disabled",
    "gui/sprites/container/enchanting_table/level_2",
    "gui/sprites/container/enchanting_table/level_2_disabled",
    "gui/sprites/container/enchanting_table/level_3",
    "gui/sprites/container/enchanting_table/level_3_disabled",
    "gui/sprites/container/furnace/burn_progress",
    "gui/sprites/container/furnace/lit_progress",
    "gui/sprites/container/grindstone/error",
    "gui/sprites/container/horse/chest_slots",
    "gui/sprites/container/inventory/effect_background",
    "gui/sprites/container/inventory/effect_background_ambient",
    "gui/sprites/container/loom/error",
    "gui/sprites/container/loom/pattern",
    "gui/sprites/container/loom/pattern_highlighted",
    "gui/sprites/container/loom/pattern_selected",
    "gui/sprites/container/loom/scroller",
    "gui/sprites/container/loom/scroller_disabled",
    "gui/sprites/container/slot",
    "gui/sprites/container/slot/amethyst_shard",
    "gui/sprites/container/slot/axe",
    "gui/sprites/container/slot/banner",
    "gui/sprites/container/slot/banner_pattern",
    "gui/sprites/container/slot/boots",
    "gui/sprites/container/slot/brewing_fuel",
    "gui/sprites/container/slot/chestplate",
    "gui/sprites/container/slot/diamond",
    "gui/sprites/container/slot/dye",
    "gui/sprites/container/slot/emerald",
    "gui/sprites/container/slot/helmet",
    "gui/sprites/container/slot/hoe",
    "gui/sprites/container/slot/horse_armor",
    "gui/sprites/container/slot/ingot",
    "gui/sprites/container/slot/lapis_lazuli",
    "gui/sprites/container/slot/leggings",
    "gui/sprites/container/slot/llama_armor",
    "gui/sprites/container/slot/nautilus_armor",
    "gui/sprites/container/slot/nautilus_armor_inventory",
    "gui/sprites/container/slot/pickaxe",
    "gui/sprites/container/slot/potion",
    "gui/sprites/container/slot/quartz",
    "gui/sprites/container/slot/redstone_dust",
    "gui/sprites/container/slot/saddle",
    "gui/sprites/container/slot/shield",
    "gui/sprites/container/slot/shovel",
    "gui/sprites/container/slot/smithing_template_armor_trim",
    "gui/sprites/container/slot/smithing_template_netherite_upgrade",
    "gui/sprites/container/slot/spear",
    "gui/sprites/container/slot/sword",
    "gui/sprites/container/slot_highlight_back",
    "gui/sprites/container/slot_highlight_front",
    "gui/sprites/container/smithing/error",
    "gui/sprites/container/smoker/burn_progress",
    "gui/sprites/container/smoker/lit_progress",
    "gui/sprites/container/stonecutter/recipe",
    "gui/sprites/container/stonecutter/recipe_highlighted",
    "gui/sprites/container/stonecutter/recipe_selected",
    "gui/sprites/container/stonecutter/scroller",
    "gui/sprites/container/stonecutter/scroller_disabled",
    "gui/sprites/container/villager/discount_strikethrough",
    "gui/sprites/container/villager/experience_bar_background",
    "gui/sprites/container/villager/experience_bar_current",
    "gui/sprites/container/villager/experience_bar_result",
    "gui/sprites/container/villager/out_of_stock",
    "gui/sprites/container/villager/scroller",
    "gui/sprites/container/villager/scroller_disabled",
    "gui/sprites/container/villager/trade_arrow",
    "gui/sprites/container/villager/trade_arrow_out_of_stock",
    "gui/sprites/dialog/warning_button",
    "gui/sprites/dialog/warning_button_disabled",
    "gui/sprites/dialog/warning_button_highlighted",
    "gui/sprites/friends/accept",
    "gui/sprites/friends/accept_highlighted",
    "gui/sprites/friends/background",
    "gui/sprites/friends/background_dark",
    "gui/sprites/friends/button",
    "gui/sprites/friends/button_disabled",
    "gui/sprites/friends/button_highlighted",
    "gui/sprites/friends/cancel",
    "gui/sprites/friends/friends",
    "gui/sprites/friends/illustrations_00",
    "gui/sprites/friends/list_separator_top",
    "gui/sprites/friends/loading",
    "gui/sprites/friends/reject",
    "gui/sprites/friends/reject_highlighted",
    "gui/sprites/friends/remove",
    "gui/sprites/friends/send_request",
    "gui/sprites/friends/toast_background",
    "gui/sprites/gamemode_switcher/selection",
    "gui/sprites/gamemode_switcher/slot",
    "gui/sprites/hud/air",
    "gui/sprites/hud/air_bursting",
    "gui/sprites/hud/air_empty",
    "gui/sprites/hud/armor_empty",
    "gui/sprites/hud/armor_full",
    "gui/sprites/hud/armor_half",
    "gui/sprites/hud/crosshair",
    "gui/sprites/hud/crosshair_attack_indicator_background",
    "gui/sprites/hud/crosshair_attack_indicator_full",
    "gui/sprites/hud/crosshair_attack_indicator_progress",
    "gui/sprites/hud/effect_background",
    "gui/sprites/hud/effect_background_ambient",
    "gui/sprites/hud/experience_bar_background",
    "gui/sprites/hud/experience_bar_progress",
    "gui/sprites/hud/food_empty",
    "gui/sprites/hud/food_empty_hunger",
    "gui/sprites/hud/food_full",
    "gui/sprites/hud/food_full_hunger",
    "gui/sprites/hud/food_half",
    "gui/sprites/hud/food_half_hunger",
    "gui/sprites/hud/heart/absorbing_full",
    "gui/sprites/hud/heart/absorbing_full_blinking",
    "gui/sprites/hud/heart/absorbing_half",
    "gui/sprites/hud/heart/absorbing_half_blinking",
    "gui/sprites/hud/heart/absorbing_hardcore_full",
    "gui/sprites/hud/heart/absorbing_hardcore_full_blinking",
    "gui/sprites/hud/heart/absorbing_hardcore_half",
    "gui/sprites/hud/heart/absorbing_hardcore_half_blinking",
    "gui/sprites/hud/heart/container",
    "gui/sprites/hud/heart/container_blinking",
    "gui/sprites/hud/heart/container_hardcore",
    "gui/sprites/hud/heart/container_hardcore_blinking",
    "gui/sprites/hud/heart/frozen_full",
    "gui/sprites/hud/heart/frozen_full_blinking",
    "gui/sprites/hud/heart/frozen_half",
    "gui/sprites/hud/heart/frozen_half_blinking",
    "gui/sprites/hud/heart/frozen_hardcore_full",
    "gui/sprites/hud/heart/frozen_hardcore_full_blinking",
    "gui/sprites/hud/heart/frozen_hardcore_half",
    "gui/sprites/hud/heart/frozen_hardcore_half_blinking",
    "gui/sprites/hud/heart/full",
    "gui/sprites/hud/heart/full_blinking",
    "gui/sprites/hud/heart/half",
    "gui/sprites/hud/heart/half_blinking",
    "gui/sprites/hud/heart/hardcore_full",
    "gui/sprites/hud/heart/hardcore_full_blinking",
    "gui/sprites/hud/heart/hardcore_half",
    "gui/sprites/hud/heart/hardcore_half_blinking",
    "gui/sprites/hud/heart/poisoned_full",
    "gui/sprites/hud/heart/poisoned_full_blinking",
    "gui/sprites/hud/heart/poisoned_half",
    "gui/sprites/hud/heart/poisoned_half_blinking",
    "gui/sprites/hud/heart/poisoned_hardcore_full",
    "gui/sprites/hud/heart/poisoned_hardcore_full_blinking",
    "gui/sprites/hud/heart/poisoned_hardcore_half",
    "gui/sprites/hud/heart/poisoned_hardcore_half_blinking",
    "gui/sprites/hud/heart/vehicle_container",
    "gui/sprites/hud/heart/vehicle_full",
    "gui/sprites/hud/heart/vehicle_half",
    "gui/sprites/hud/heart/withered_full",
    "gui/sprites/hud/heart/withered_full_blinking",
    "gui/sprites/hud/heart/withered_half",
    "gui/sprites/hud/heart/withered_half_blinking",
    "gui/sprites/hud/heart/withered_hardcore_full",
    "gui/sprites/hud/heart/withered_hardcore_full_blinking",
    "gui/sprites/hud/heart/withered_hardcore_half",
    "gui/sprites/hud/heart/withered_hardcore_half_blinking",
    "gui/sprites/hud/hotbar",
    "gui/sprites/hud/hotbar_attack_indicator_background",
    "gui/sprites/hud/hotbar_attack_indicator_progress",
    "gui/sprites/hud/hotbar_offhand_left",
    "gui/sprites/hud/hotbar_offhand_right",
    "gui/sprites/hud/hotbar_selection",
    "gui/sprites/hud/jump_bar_background",
    "gui/sprites/hud/jump_bar_cooldown",
    "gui/sprites/hud/jump_bar_progress",
    "gui/sprites/hud/locator_bar_arrow_down",
    "gui/sprites/hud/locator_bar_arrow_up",
    "gui/sprites/hud/locator_bar_background",
    "gui/sprites/hud/locator_bar_dot/bowtie",
    "gui/sprites/hud/locator_bar_dot/default_0",
    "gui/sprites/hud/locator_bar_dot/default_1",
    "gui/sprites/hud/locator_bar_dot/default_2",
    "gui/sprites/hud/locator_bar_dot/default_3",
    "gui/sprites/icon/accessibility",
    "gui/sprites/icon/chat_modified",
    "gui/sprites/icon/checkmark",
    "gui/sprites/icon/draft_report",
    "gui/sprites/icon/info",
    "gui/sprites/icon/invite",
    "gui/sprites/icon/language",
    "gui/sprites/icon/link",
    "gui/sprites/icon/link_highlighted",
    "gui/sprites/icon/music_notes",
    "gui/sprites/icon/new_realm",
    "gui/sprites/icon/news",
    "gui/sprites/icon/ping_1",
    "gui/sprites/icon/ping_2",
    "gui/sprites/icon/ping_3",
    "gui/sprites/icon/ping_4",
    "gui/sprites/icon/ping_5",
    "gui/sprites/icon/ping_unknown",
    "gui/sprites/icon/search",
    "gui/sprites/icon/trial_available",
    "gui/sprites/icon/unseen_notification",
    "gui/sprites/icon/video_link",
    "gui/sprites/icon/video_link_highlighted",
    "gui/sprites/notification/1",
    "gui/sprites/notification/2",
    "gui/sprites/notification/3",
    "gui/sprites/notification/4",
    "gui/sprites/notification/5",
    "gui/sprites/notification/more",
    "gui/sprites/pause_menu/bug",
    "gui/sprites/pause_menu/player_reporting",
    "gui/sprites/pause_menu/social_interactions",
    "gui/sprites/pending_invite/accept",
    "gui/sprites/pending_invite/accept_highlighted",
    "gui/sprites/pending_invite/reject",
    "gui/sprites/pending_invite/reject_highlighted",
    "gui/sprites/player_list/make_operator",
    "gui/sprites/player_list/remove_operator",
    "gui/sprites/player_list/remove_player",
    "gui/sprites/popup/background",
    "gui/sprites/realm_status/closed",
    "gui/sprites/realm_status/expired",
    "gui/sprites/realm_status/expires_soon",
    "gui/sprites/realm_status/open",
    "gui/sprites/recipe_book/button",
    "gui/sprites/recipe_book/button_highlighted",
    "gui/sprites/recipe_book/crafting_overlay",
    "gui/sprites/recipe_book/crafting_overlay_disabled",
    "gui/sprites/recipe_book/crafting_overlay_disabled_highlighted",
    "gui/sprites/recipe_book/crafting_overlay_highlighted",
    "gui/sprites/recipe_book/filter_disabled",
    "gui/sprites/recipe_book/filter_disabled_highlighted",
    "gui/sprites/recipe_book/filter_enabled",
    "gui/sprites/recipe_book/filter_enabled_highlighted",
    "gui/sprites/recipe_book/furnace_filter_disabled",
    "gui/sprites/recipe_book/furnace_filter_disabled_highlighted",
    "gui/sprites/recipe_book/furnace_filter_enabled",
    "gui/sprites/recipe_book/furnace_filter_enabled_highlighted",
    "gui/sprites/recipe_book/furnace_overlay",
    "gui/sprites/recipe_book/furnace_overlay_disabled",
    "gui/sprites/recipe_book/furnace_overlay_disabled_highlighted",
    "gui/sprites/recipe_book/furnace_overlay_highlighted",
    "gui/sprites/recipe_book/overlay_recipe",
    "gui/sprites/recipe_book/page_backward",
    "gui/sprites/recipe_book/page_backward_highlighted",
    "gui/sprites/recipe_book/page_forward",
    "gui/sprites/recipe_book/page_forward_highlighted",
    "gui/sprites/recipe_book/slot_craftable",
    "gui/sprites/recipe_book/slot_many_craftable",
    "gui/sprites/recipe_book/slot_many_uncraftable",
    "gui/sprites/recipe_book/slot_uncraftable",
    "gui/sprites/recipe_book/tab",
    "gui/sprites/recipe_book/tab_selected",
    "gui/sprites/server_list/incompatible",
    "gui/sprites/server_list/join",
    "gui/sprites/server_list/join_highlighted",
    "gui/sprites/server_list/move_down",
    "gui/sprites/server_list/move_down_highlighted",
    "gui/sprites/server_list/move_up",
    "gui/sprites/server_list/move_up_highlighted",
    "gui/sprites/server_list/ping_1",
    "gui/sprites/server_list/ping_2",
    "gui/sprites/server_list/ping_3",
    "gui/sprites/server_list/ping_4",
    "gui/sprites/server_list/ping_5",
    "gui/sprites/server_list/pinging_1",
    "gui/sprites/server_list/pinging_2",
    "gui/sprites/server_list/pinging_3",
    "gui/sprites/server_list/pinging_4",
    "gui/sprites/server_list/pinging_5",
    "gui/sprites/server_list/unreachable",
    "gui/sprites/social_interactions/background",
    "gui/sprites/social_interactions/mute_button",
    "gui/sprites/social_interactions/mute_button_highlighted",
    "gui/sprites/social_interactions/report_button",
    "gui/sprites/social_interactions/report_button_disabled",
    "gui/sprites/social_interactions/report_button_highlighted",
    "gui/sprites/social_interactions/unmute_button",
    "gui/sprites/social_interactions/unmute_button_highlighted",
    "gui/sprites/spectator/close",
    "gui/sprites/spectator/scroll_left",
    "gui/sprites/spectator/scroll_right",
    "gui/sprites/spectator/teleport_to_player",
    "gui/sprites/spectator/teleport_to_team",
    "gui/sprites/statistics/block_mined",
    "gui/sprites/statistics/header",
    "gui/sprites/statistics/item_broken",
    "gui/sprites/statistics/item_crafted",
    "gui/sprites/statistics/item_dropped",
    "gui/sprites/statistics/item_picked_up",
    "gui/sprites/statistics/item_used",
    "gui/sprites/statistics/sort_down",
    "gui/sprites/statistics/sort_up",
    "gui/sprites/toast/advancement",
    "gui/sprites/toast/mouse",
    "gui/sprites/toast/movement_keys",
    "gui/sprites/toast/now_playing",
    "gui/sprites/toast/recipe",
    "gui/sprites/toast/recipe_book",
    "gui/sprites/toast/right_click",
    "gui/sprites/toast/social_interactions",
    "gui/sprites/toast/system",
    "gui/sprites/toast/tree",
    "gui/sprites/toast/tutorial",
    "gui/sprites/toast/wooden_planks",
    "gui/sprites/tooltip/background",
    "gui/sprites/tooltip/frame",
    "gui/sprites/transferable_list/move_down",
    "gui/sprites/transferable_list/move_down_highlighted",
    "gui/sprites/transferable_list/move_up",
    "gui/sprites/transferable_list/move_up_highlighted",
    "gui/sprites/transferable_list/select",
    "gui/sprites/transferable_list/select_highlighted",
    "gui/sprites/transferable_list/unselect",
    "gui/sprites/transferable_list/unselect_highlighted",
    "gui/sprites/widget/button",
    "gui/sprites/widget/button_disabled",
    "gui/sprites/widget/button_highlighted",
    "gui/sprites/widget/checkbox",
    "gui/sprites/widget/checkbox_highlighted",
    "gui/sprites/widget/checkbox_selected",
    "gui/sprites/widget/checkbox_selected_highlighted",
    "gui/sprites/widget/cross_button",
    "gui/sprites/widget/cross_button_highlighted",
    "gui/sprites/widget/locked_button",
    "gui/sprites/widget/locked_button_disabled",
    "gui/sprites/widget/locked_button_highlighted",
    "gui/sprites/widget/page_backward",
    "gui/sprites/widget/page_backward_highlighted",
    "gui/sprites/widget/page_forward",
    "gui/sprites/widget/page_forward_highlighted",
    "gui/sprites/widget/preedit",
    "gui/sprites/widget/scroller",
    "gui/sprites/widget/scroller_background",
    "gui/sprites/widget/slider",
    "gui/sprites/widget/slider_handle",
    "gui/sprites/widget/slider_handle_highlighted",
    "gui/sprites/widget/slider_highlighted",
    "gui/sprites/widget/slot_frame",
    "gui/sprites/widget/tab",
    "gui/sprites/widget/tab_highlighted",
    "gui/sprites/widget/tab_selected",
    "gui/sprites/widget/tab_selected_highlighted",
    "gui/sprites/widget/text_field",
    "gui/sprites/widget/text_field_highlighted",
    "gui/sprites/widget/unlocked_button",
    "gui/sprites/widget/unlocked_button_disabled",
    "gui/sprites/widget/unlocked_button_highlighted",
    "gui/sprites/world_list/error",
    "gui/sprites/world_list/error_highlighted",
    "gui/sprites/world_list/join",
    "gui/sprites/world_list/join_highlighted",
    "gui/sprites/world_list/marked_join",
    "gui/sprites/world_list/marked_join_highlighted",
    "gui/sprites/world_list/warning",
    "gui/sprites/world_list/warning_highlighted",
    "gui/tab_header_background",
    "gui/title/background/panorama_0",
    "gui/title/background/panorama_1",
    "gui/title/background/panorama_2",
    "gui/title/background/panorama_3",
    "gui/title/background/panorama_4",
    "gui/title/background/panorama_5",
    "gui/title/background/panorama_overlay",
    "gui/title/edition",
    "gui/title/minceraft",
    "gui/title/minecraft",
    "gui/title/mojangstudios",
    "gui/title/realms",
    "item/abandoned_campsite_map",
    "item/acacia_boat",
    "item/acacia_chest_boat",
    "item/acacia_door",
    "item/acacia_hanging_sign",
    "item/acacia_sign",
    "item/allay_spawn_egg",
    "item/amethyst_shard",
    "item/ancient_city_map",
    "item/angler_pottery_sherd",
    "item/apple",
    "item/archer_pottery_sherd",
    "item/armadillo_scute",
    "item/armadillo_spawn_egg",
    "item/armor_stand",
    "item/arms_up_pottery_sherd",
    "item/arrow",
    "item/axolotl_bucket",
    "item/axolotl_spawn_egg",
    "item/baked_potato",
    "item/bamboo",
    "item/bamboo_chest_raft",
    "item/bamboo_door",
    "item/bamboo_hanging_sign",
    "item/bamboo_raft",
    "item/bamboo_sign",
    "item/barrier",
    "item/bat_spawn_egg",
    "item/bee_spawn_egg",
    "item/beef",
    "item/beetroot",
    "item/beetroot_seeds",
    "item/beetroot_soup",
    "item/bell",
    "item/birch_boat",
    "item/birch_chest_boat",
    "item/birch_door",
    "item/birch_hanging_sign",
    "item/birch_sign",
    "item/black_bundle",
    "item/black_bundle_open_back",
    "item/black_bundle_open_front",
    "item/black_candle",
    "item/black_cushion",
    "item/black_dye",
    "item/black_harness",
    "item/blade_pottery_sherd",
    "item/blaze_powder",
    "item/blaze_rod",
    "item/blaze_spawn_egg",
    "item/blue_bundle",
    "item/blue_bundle_open_back",
    "item/blue_bundle_open_front",
    "item/blue_candle",
    "item/blue_cushion",
    "item/blue_dye",
    "item/blue_egg",
    "item/blue_harness",
    "item/bogged_spawn_egg",
    "item/bolt_armor_trim_smithing_template",
    "item/bone",
    "item/bone_meal",
    "item/book",
    "item/bordure_indented_banner_pattern",
    "item/bow",
    "item/bow_pulling_0",
    "item/bow_pulling_1",
    "item/bow_pulling_2",
    "item/bowl",
    "item/bread",
    "item/breeze_rod",
    "item/breeze_spawn_egg",
    "item/brewer_pottery_sherd",
    "item/brewing_stand",
    "item/brick",
    "item/brown_bundle",
    "item/brown_bundle_open_back",
    "item/brown_bundle_open_front",
    "item/brown_candle",
    "item/brown_cushion",
    "item/brown_dye",
    "item/brown_egg",
    "item/brown_harness",
    "item/brush",
    "item/bucket",
    "item/bundle",
    "item/bundle_open_back",
    "item/bundle_open_front",
    "item/buried_treasure_map",
    "item/burn_pottery_sherd",
    "item/cake",
    "item/camel_husk_spawn_egg",
    "item/camel_spawn_egg",
    "item/campfire",
    "item/candle",
    "item/carrot",
    "item/carrot_on_a_stick",
    "item/cat_spawn_egg",
    "item/cauldron",
    "item/cave_spider_spawn_egg",
    "item/chainmail_boots",
    "item/chainmail_chestplate",
    "item/chainmail_helmet",
    "item/chainmail_leggings",
    "item/charcoal",
    "item/cherry_boat",
    "item/cherry_chest_boat",
    "item/cherry_door",
    "item/cherry_hanging_sign",
    "item/cherry_sign",
    "item/chest_minecart",
    "item/chicken",
    "item/chicken_spawn_egg",
    "item/chorus_fruit",
    "item/clay_ball",
    "item/clock_00",
    "item/clock_01",
    "item/clock_02",
    "item/clock_03",
    "item/clock_04",
    "item/clock_05",
    "item/clock_06",
    "item/clock_07",
    "item/clock_08",
    "item/clock_09",
    "item/clock_10",
    "item/clock_11",
    "item/clock_12",
    "item/clock_13",
    "item/clock_14",
    "item/clock_15",
    "item/clock_16",
    "item/clock_17",
    "item/clock_18",
    "item/clock_19",
    "item/clock_20",
    "item/clock_21",
    "item/clock_22",
    "item/clock_23",
    "item/clock_24",
    "item/clock_25",
    "item/clock_26",
    "item/clock_27",
    "item/clock_28",
    "item/clock_29",
    "item/clock_30",
    "item/clock_31",
    "item/clock_32",
    "item/clock_33",
    "item/clock_34",
    "item/clock_35",
    "item/clock_36",
    "item/clock_37",
    "item/clock_38",
    "item/clock_39",
    "item/clock_40",
    "item/clock_41",
    "item/clock_42",
    "item/clock_43",
    "item/clock_44",
    "item/clock_45",
    "item/clock_46",
    "item/clock_47",
    "item/clock_48",
    "item/clock_49",
    "item/clock_50",
    "item/clock_51",
    "item/clock_52",
    "item/clock_53",
    "item/clock_54",
    "item/clock_55",
    "item/clock_56",
    "item/clock_57",
    "item/clock_58",
    "item/clock_59",
    "item/clock_60",
    "item/clock_61",
    "item/clock_62",
    "item/clock_63",
    "item/coal",
    "item/coast_armor_trim_smithing_template",
    "item/cocoa_beans",
    "item/cod",
    "item/cod_bucket",
    "item/cod_spawn_egg",
    "item/command_block_minecart",
    "item/comparator",
    "item/compass_00",
    "item/compass_01",
    "item/compass_02",
    "item/compass_03",
    "item/compass_04",
    "item/compass_05",
    "item/compass_06",
    "item/compass_07",
    "item/compass_08",
    "item/compass_09",
    "item/compass_10",
    "item/compass_11",
    "item/compass_12",
    "item/compass_13",
    "item/compass_14",
    "item/compass_15",
    "item/compass_16",
    "item/compass_17",
    "item/compass_18",
    "item/compass_19",
    "item/compass_20",
    "item/compass_21",
    "item/compass_22",
    "item/compass_23",
    "item/compass_24",
    "item/compass_25",
    "item/compass_26",
    "item/compass_27",
    "item/compass_28",
    "item/compass_29",
    "item/compass_30",
    "item/compass_31",
    "item/cooked_beef",
    "item/cooked_chicken",
    "item/cooked_cod",
    "item/cooked_mutton",
    "item/cooked_porkchop",
    "item/cooked_rabbit",
    "item/cooked_salmon",
    "item/cookie",
    "item/copper_axe",
    "item/copper_boots",
    "item/copper_chain",
    "item/copper_chestplate",
    "item/copper_door",
    "item/copper_golem_spawn_egg",
    "item/copper_helmet",
    "item/copper_hoe",
    "item/copper_horse_armor",
    "item/copper_ingot",
    "item/copper_lantern",
    "item/copper_leggings",
    "item/copper_nautilus_armor",
    "item/copper_nugget",
    "item/copper_pickaxe",
    "item/copper_shovel",
    "item/copper_spear",
    "item/copper_spear_in_hand",
    "item/copper_sword",
    "item/cow_spawn_egg",
    "item/creaking_spawn_egg",
    "item/creeper_banner_pattern",
    "item/creeper_spawn_egg",
    "item/crimson_door",
    "item/crimson_hanging_sign",
    "item/crimson_sign",
    "item/crossbow_arrow",
    "item/crossbow_firework",
    "item/crossbow_pulling_0",
    "item/crossbow_pulling_1",
    "item/crossbow_pulling_2",
    "item/crossbow_standby",
    "item/cyan_bundle",
    "item/cyan_bundle_open_back",
    "item/cyan_bundle_open_front",
    "item/cyan_candle",
    "item/cyan_cushion",
    "item/cyan_dye",
    "item/cyan_harness",
    "item/danger_pottery_sherd",
    "item/dark_oak_boat",
    "item/dark_oak_chest_boat",
    "item/dark_oak_door",
    "item/dark_oak_hanging_sign",
    "item/dark_oak_sign",
    "item/desert_pyramid_map",
    "item/desert_village_map",
    "item/diamond",
    "item/diamond_axe",
    "item/diamond_boots",
    "item/diamond_chestplate",
    "item/diamond_helmet",
    "item/diamond_hoe",
    "item/diamond_horse_armor",
    "item/diamond_leggings",
    "item/diamond_nautilus_armor",
    "item/diamond_pickaxe",
    "item/diamond_shovel",
    "item/diamond_spear",
    "item/diamond_spear_in_hand",
    "item/diamond_sword",
    "item/disc_fragment_5",
    "item/dolphin_spawn_egg",
    "item/donkey_spawn_egg",
    "item/dragon_breath",
    "item/dried_kelp",
    "item/drowned_spawn_egg",
    "item/dune_armor_trim_smithing_template",
    "item/echo_shard",
    "item/egg",
    "item/elder_guardian_spawn_egg",
    "item/elytra",
    "item/elytra_broken",
    "item/emerald",
    "item/enchanted_book",
    "item/end_crystal",
    "item/ender_dragon_spawn_egg",
    "item/ender_eye",
    "item/ender_pearl",
    "item/enderman_spawn_egg",
    "item/endermite_spawn_egg",
    "item/evoker_spawn_egg",
    "item/experience_bottle",
    "item/explorer_pottery_sherd",
    "item/exposed_copper_chain",
    "item/exposed_copper_door",
    "item/exposed_copper_lantern",
    "item/eye_armor_trim_smithing_template",
    "item/feather",
    "item/fermented_spider_eye",
    "item/field_masoned_banner_pattern",
    "item/filled_map",
    "item/fire_charge",
    "item/firefly_bush",
    "item/firework_rocket",
    "item/firework_star",
    "item/firework_star_overlay",
    "item/fishing_rod",
    "item/fishing_rod_cast",
    "item/flint",
    "item/flint_and_steel",
    "item/flow_armor_trim_smithing_template",
    "item/flow_banner_pattern",
    "item/flow_pottery_sherd",
    "item/flower_banner_pattern",
    "item/flower_pot",
    "item/fox_spawn_egg",
    "item/friend_pottery_sherd",
    "item/frog_spawn_egg",
    "item/furnace_minecart",
    "item/ghast_spawn_egg",
    "item/ghast_tear",
    "item/glass_bottle",
    "item/glistering_melon_slice",
    "item/globe_banner_pattern",
    "item/glow_berries",
    "item/glow_ink_sac",
    "item/glow_item_frame",
    "item/glow_squid_spawn_egg",
    "item/glowstone_dust",
    "item/goat_horn",
    "item/goat_spawn_egg",
    "item/gold_ingot",
    "item/gold_nugget",
    "item/golden_apple",
    "item/golden_axe",
    "item/golden_boots",
    "item/golden_carrot",
    "item/golden_chestplate",
    "item/golden_helmet",
    "item/golden_hoe",
    "item/golden_horse_armor",
    "item/golden_leggings",
    "item/golden_nautilus_armor",
    "item/golden_pickaxe",
    "item/golden_shovel",
    "item/golden_spear",
    "item/golden_spear_in_hand",
    "item/golden_sword",
    "item/gray_bundle",
    "item/gray_bundle_open_back",
    "item/gray_bundle_open_front",
    "item/gray_candle",
    "item/gray_cushion",
    "item/gray_dye",
    "item/gray_harness",
    "item/green_bundle",
    "item/green_bundle_open_back",
    "item/green_bundle_open_front",
    "item/green_candle",
    "item/green_cushion",
    "item/green_dye",
    "item/green_harness",
    "item/guardian_spawn_egg",
    "item/gunpowder",
    "item/guster_banner_pattern",
    "item/guster_pottery_sherd",
    "item/happy_ghast_spawn_egg",
    "item/heart_of_the_sea",
    "item/heart_pottery_sherd",
    "item/heartbreak_pottery_sherd",
    "item/hoglin_spawn_egg",
    "item/honey_bottle",
    "item/honeycomb",
    "item/hopper",
    "item/hopper_minecart",
    "item/horse_spawn_egg",
    "item/host_armor_trim_smithing_template",
    "item/howl_pottery_sherd",
    "item/husk_spawn_egg",
    "item/ink_sac",
    "item/iron_axe",
    "item/iron_boots",
    "item/iron_chain",
    "item/iron_chestplate",
    "item/iron_door",
    "item/iron_golem_spawn_egg",
    "item/iron_helmet",
    "item/iron_hoe",
    "item/iron_horse_armor",
    "item/iron_ingot",
    "item/iron_leggings",
    "item/iron_nautilus_armor",
    "item/iron_nugget",
    "item/iron_pickaxe",
    "item/iron_shovel",
    "item/iron_spear",
    "item/iron_spear_in_hand",
    "item/iron_sword",
    "item/item_frame",
    "item/jungle_boat",
    "item/jungle_chest_boat",
    "item/jungle_door",
    "item/jungle_hanging_sign",
    "item/jungle_sign",
    "item/jungle_temple_map",
    "item/kelp",
    "item/knowledge_book",
    "item/lantern",
    "item/lapis_lazuli",
    "item/lava_bucket",
    "item/lead",
    "item/leaf_litter",
    "item/leather",
    "item/leather_boots",
    "item/leather_boots_overlay",
    "item/leather_chestplate",
    "item/leather_chestplate_overlay",
    "item/leather_helmet",
    "item/leather_helmet_overlay",
    "item/leather_horse_armor",
    "item/leather_horse_armor_overlay",
    "item/leather_leggings",
    "item/leather_leggings_overlay",
    "item/light_00",
    "item/light_01",
    "item/light_02",
    "item/light_03",
    "item/light_04",
    "item/light_05",
    "item/light_06",
    "item/light_07",
    "item/light_08",
    "item/light_09",
    "item/light_10",
    "item/light_11",
    "item/light_12",
    "item/light_13",
    "item/light_14",
    "item/light_15",
    "item/light_blue_bundle",
    "item/light_blue_bundle_open_back",
    "item/light_blue_bundle_open_front",
    "item/light_blue_candle",
    "item/light_blue_cushion",
    "item/light_blue_dye",
    "item/light_blue_harness",
    "item/light_gray_bundle",
    "item/light_gray_bundle_open_back",
    "item/light_gray_bundle_open_front",
    "item/light_gray_candle",
    "item/light_gray_cushion",
    "item/light_gray_dye",
    "item/light_gray_harness",
    "item/lime_bundle",
    "item/lime_bundle_open_back",
    "item/lime_bundle_open_front",
    "item/lime_candle",
    "item/lime_cushion",
    "item/lime_dye",
    "item/lime_harness",
    "item/lingering_potion",
    "item/llama_spawn_egg",
    "item/mace",
    "item/magenta_bundle",
    "item/magenta_bundle_open_back",
    "item/magenta_bundle_open_front",
    "item/magenta_candle",
    "item/magenta_cushion",
    "item/magenta_dye",
    "item/magenta_harness",
    "item/magma_cream",
    "item/magma_cube_spawn_egg",
    "item/mangrove_boat",
    "item/mangrove_chest_boat",
    "item/mangrove_door",
    "item/mangrove_hanging_sign",
    "item/mangrove_propagule",
    "item/mangrove_sign",
    "item/map",
    "item/melon_seeds",
    "item/melon_slice",
    "item/milk_bucket",
    "item/minecart",
    "item/miner_pottery_sherd",
    "item/mineshaft_map",
    "item/mojang_banner_pattern",
    "item/mooshroom_spawn_egg",
    "item/mourner_pottery_sherd",
    "item/mule_spawn_egg",
    "item/mushroom_stew",
    "item/music_disc_11",
    "item/music_disc_13",
    "item/music_disc_5",
    "item/music_disc_blocks",
    "item/music_disc_bounce",
    "item/music_disc_cat",
    "item/music_disc_chirp",
    "item/music_disc_creator",
    "item/music_disc_creator_music_box",
    "item/music_disc_far",
    "item/music_disc_lava_chicken",
    "item/music_disc_mall",
    "item/music_disc_mellohi",
    "item/music_disc_otherside",
    "item/music_disc_pigstep",
    "item/music_disc_precipice",
    "item/music_disc_relic",
    "item/music_disc_stal",
    "item/music_disc_strad",
    "item/music_disc_tears",
    "item/music_disc_wait",
    "item/music_disc_ward",
    "item/mutton",
    "item/name_tag",
    "item/nautilus_shell",
    "item/nautilus_spawn_egg",
    "item/nether_brick",
    "item/nether_sprouts",
    "item/nether_star",
    "item/nether_wart",
    "item/netherite_axe",
    "item/netherite_boots",
    "item/netherite_chestplate",
    "item/netherite_helmet",
    "item/netherite_hoe",
    "item/netherite_horse_armor",
    "item/netherite_ingot",
    "item/netherite_leggings",
    "item/netherite_nautilus_armor",
    "item/netherite_pickaxe",
    "item/netherite_scrap",
    "item/netherite_shovel",
    "item/netherite_spear",
    "item/netherite_spear_in_hand",
    "item/netherite_sword",
    "item/netherite_upgrade_smithing_template",
    "item/oak_boat",
    "item/oak_chest_boat",
    "item/oak_door",
    "item/oak_hanging_sign",
    "item/oak_sign",
    "item/ocean_monument_map",
    "item/ocelot_spawn_egg",
    "item/ominous_bottle",
    "item/ominous_trial_key",
    "item/orange_bundle",
    "item/orange_bundle_open_back",
    "item/orange_bundle_open_front",
    "item/orange_candle",
    "item/orange_cushion",
    "item/orange_dye",
    "item/orange_harness",
    "item/oxidized_copper_chain",
    "item/oxidized_copper_door",
    "item/oxidized_copper_lantern",
    "item/painting",
    "item/pale_oak_boat",
    "item/pale_oak_chest_boat",
    "item/pale_oak_door",
    "item/pale_oak_hanging_sign",
    "item/pale_oak_sign",
    "item/panda_spawn_egg",
    "item/paper",
    "item/parched_spawn_egg",
    "item/parrot_spawn_egg",
    "item/phantom_membrane",
    "item/phantom_spawn_egg",
    "item/pig_spawn_egg",
    "item/piglin_banner_pattern",
    "item/piglin_brute_spawn_egg",
    "item/piglin_spawn_egg",
    "item/pillager_spawn_egg",
    "item/pink_bundle",
    "item/pink_bundle_open_back",
    "item/pink_bundle_open_front",
    "item/pink_candle",
    "item/pink_cushion",
    "item/pink_dye",
    "item/pink_harness",
    "item/pink_petals",
    "item/pitcher_plant",
    "item/pitcher_pod",
    "item/plains_village_map",
    "item/plenty_pottery_sherd",
    "item/pointed_dripstone",
    "item/poisonous_potato",
    "item/polar_bear_spawn_egg",
    "item/poplar_boat",
    "item/poplar_chest_boat",
    "item/poplar_door",
    "item/poplar_hanging_sign",
    "item/poplar_sign",
    "item/popped_chorus_fruit",
    "item/porkchop",
    "item/potato",
    "item/potion",
    "item/potion_overlay",
    "item/powder_snow_bucket",
    "item/prismarine_crystals",
    "item/prismarine_shard",
    "item/prize_pottery_sherd",
    "item/pufferfish",
    "item/pufferfish_bucket",
    "item/pufferfish_spawn_egg",
    "item/pumpkin_pie",
    "item/pumpkin_seeds",
    "item/purple_bundle",
    "item/purple_bundle_open_back",
    "item/purple_bundle_open_front",
    "item/purple_candle",
    "item/purple_cushion",
    "item/purple_dye",
    "item/purple_harness",
    "item/quartz",
    "item/rabbit",
    "item/rabbit_foot",
    "item/rabbit_hide",
    "item/rabbit_spawn_egg",
    "item/rabbit_stew",
    "item/raiser_armor_trim_smithing_template",
    "item/ravager_spawn_egg",
    "item/raw_copper",
    "item/raw_gold",
    "item/raw_iron",
    "item/recovery_compass_00",
    "item/recovery_compass_01",
    "item/recovery_compass_02",
    "item/recovery_compass_03",
    "item/recovery_compass_04",
    "item/recovery_compass_05",
    "item/recovery_compass_06",
    "item/recovery_compass_07",
    "item/recovery_compass_08",
    "item/recovery_compass_09",
    "item/recovery_compass_10",
    "item/recovery_compass_11",
    "item/recovery_compass_12",
    "item/recovery_compass_13",
    "item/recovery_compass_14",
    "item/recovery_compass_15",
    "item/recovery_compass_16",
    "item/recovery_compass_17",
    "item/recovery_compass_18",
    "item/recovery_compass_19",
    "item/recovery_compass_20",
    "item/recovery_compass_21",
    "item/recovery_compass_22",
    "item/recovery_compass_23",
    "item/recovery_compass_24",
    "item/recovery_compass_25",
    "item/recovery_compass_26",
    "item/recovery_compass_27",
    "item/recovery_compass_28",
    "item/recovery_compass_29",
    "item/recovery_compass_30",
    "item/recovery_compass_31",
    "item/red_bundle",
    "item/red_bundle_open_back",
    "item/red_bundle_open_front",
    "item/red_candle",
    "item/red_cushion",
    "item/red_dye",
    "item/red_harness",
    "item/redstone",
    "item/repeater",
    "item/resin_brick",
    "item/resin_clump",
    "item/rib_armor_trim_smithing_template",
    "item/rotten_flesh",
    "item/saddle",
    "item/salmon",
    "item/salmon_bucket",
    "item/salmon_spawn_egg",
    "item/savanna_village_map",
    "item/scrape_pottery_sherd",
    "item/sea_pickle",
    "item/seagrass",
    "item/sentry_armor_trim_smithing_template",
    "item/shaper_armor_trim_smithing_template",
    "item/sheaf_pottery_sherd",
    "item/shears",
    "item/sheep_spawn_egg",
    "item/shelter_pottery_sherd",
    "item/shulker_shell",
    "item/shulker_spawn_egg",
    "item/silence_armor_trim_smithing_template",
    "item/silverfish_spawn_egg",
    "item/skeleton_horse_spawn_egg",
    "item/skeleton_spawn_egg",
    "item/skull_banner_pattern",
    "item/skull_pottery_sherd",
    "item/slime_ball",
    "item/slime_spawn_egg",
    "item/sniffer_egg",
    "item/sniffer_spawn_egg",
    "item/snort_pottery_sherd",
    "item/snout_armor_trim_smithing_template",
    "item/snow_golem_spawn_egg",
    "item/snowball",
    "item/snowy_village_map",
    "item/soul_campfire",
    "item/soul_lantern",
    "item/spectral_arrow",
    "item/spider_eye",
    "item/spider_spawn_egg",
    "item/spire_armor_trim_smithing_template",
    "item/splash_potion",
    "item/spruce_boat",
    "item/spruce_chest_boat",
    "item/spruce_door",
    "item/spruce_hanging_sign",
    "item/spruce_sign",
    "item/spyglass",
    "item/spyglass_model",
    "item/squid_spawn_egg",
    "item/stick",
    "item/stone_axe",
    "item/stone_hoe",
    "item/stone_pickaxe",
    "item/stone_shovel",
    "item/stone_spear",
    "item/stone_spear_in_hand",
    "item/stone_sword",
    "item/stray_spawn_egg",
    "item/strider_spawn_egg",
    "item/string",
    "item/structure_void",
    "item/sugar",
    "item/sugar_cane",
    "item/sulfur_cube_bucket",
    "item/sulfur_cube_spawn_egg",
    "item/sulfur_spike",
    "item/suspicious_stew",
    "item/swamp_hut_map",
    "item/sweet_berries",
    "item/tadpole_bucket",
    "item/tadpole_spawn_egg",
    "item/taiga_village_map",
    "item/tide_armor_trim_smithing_template",
    "item/tipped_arrow_base",
    "item/tipped_arrow_head",
    "item/tnt_minecart",
    "item/torchflower_seeds",
    "item/totem_of_undying",
    "item/trader_llama_spawn_egg",
    "item/trial_chamber_map",
    "item/trial_key",
    "item/trident",
    "item/tropical_fish",
    "item/tropical_fish_bucket",
    "item/tropical_fish_spawn_egg",
    "item/turtle_egg",
    "item/turtle_helmet",
    "item/turtle_scute",
    "item/turtle_spawn_egg",
    "item/vex_armor_trim_smithing_template",
    "item/vex_spawn_egg",
    "item/villager_spawn_egg",
    "item/vindicator_spawn_egg",
    "item/wandering_trader_spawn_egg",
    "item/ward_armor_trim_smithing_template",
    "item/warden_spawn_egg",
    "item/warm_ocean_ruins_map",
    "item/warped_door",
    "item/warped_fungus_on_a_stick",
    "item/warped_hanging_sign",
    "item/warped_sign",
    "item/water_bucket",
    "item/wayfinder_armor_trim_smithing_template",
    "item/weathered_copper_chain",
    "item/weathered_copper_door",
    "item/weathered_copper_lantern",
    "item/wheat",
    "item/wheat_seeds",
    "item/white_bundle",
    "item/white_bundle_open_back",
    "item/white_bundle_open_front",
    "item/white_candle",
    "item/white_cushion",
    "item/white_dye",
    "item/white_harness",
    "item/wild_armor_trim_smithing_template",
    "item/wildflowers",
    "item/wind_charge",
    "item/witch_spawn_egg",
    "item/wither_skeleton_spawn_egg",
    "item/wither_spawn_egg",
    "item/wolf_armor",
    "item/wolf_armor_overlay",
    "item/wolf_spawn_egg",
    "item/wooden_axe",
    "item/wooden_hoe",
    "item/wooden_pickaxe",
    "item/wooden_shovel",
    "item/wooden_spear",
    "item/wooden_spear_in_hand",
    "item/wooden_sword",
    "item/woodland_mansion_map",
    "item/writable_book",
    "item/written_book",
    "item/yellow_bundle",
    "item/yellow_bundle_open_back",
    "item/yellow_bundle_open_front",
    "item/yellow_candle",
    "item/yellow_cushion",
    "item/yellow_dye",
    "item/yellow_harness",
    "item/zoglin_spawn_egg",
    "item/zombie_horse_spawn_egg",
    "item/zombie_nautilus_spawn_egg",
    "item/zombie_spawn_egg",
    "item/zombie_villager_spawn_egg",
    "item/zombified_piglin_spawn_egg",
    "map/decorations/abandoned_camp",
    "map/decorations/ancient_city",
    "map/decorations/black_banner",
    "map/decorations/blue_banner",
    "map/decorations/blue_marker",
    "map/decorations/brown_banner",
    "map/decorations/cyan_banner",
    "map/decorations/desert_pyramid",
    "map/decorations/desert_village",
    "map/decorations/frame",
    "map/decorations/gray_banner",
    "map/decorations/green_banner",
    "map/decorations/jungle_temple",
    "map/decorations/light_blue_banner",
    "map/decorations/light_gray_banner",
    "map/decorations/lime_banner",
    "map/decorations/magenta_banner",
    "map/decorations/mineshaft",
    "map/decorations/ocean_monument",
    "map/decorations/orange_banner",
    "map/decorations/pink_banner",
    "map/decorations/plains_village",
    "map/decorations/player",
    "map/decorations/player_off_limits",
    "map/decorations/player_off_map",
    "map/decorations/purple_banner",
    "map/decorations/red_banner",
    "map/decorations/red_marker",
    "map/decorations/red_x",
    "map/decorations/savanna_village",
    "map/decorations/snowy_village",
    "map/decorations/swamp_hut",
    "map/decorations/taiga_village",
    "map/decorations/target_point",
    "map/decorations/target_x",
    "map/decorations/trial_chambers",
    "map/decorations/warm_ocean_ruins",
    "map/decorations/white_banner",
    "map/decorations/woodland_mansion",
    "map/decorations/yellow_banner",
    "map/map_background",
    "map/map_background_checkerboard",
    "misc/credits_vignette",
    "misc/enchanted_glint_armor",
    "misc/enchanted_glint_item",
    "misc/forcefield",
    "misc/nausea",
    "misc/powder_snow_outline",
    "misc/pumpkinblur",
    "misc/shadow",
    "misc/spyglass_scope",
    "misc/underwater",
    "misc/unknown_pack",
    "misc/unknown_server",
    "misc/vignette",
    "mob_effect/absorption",
    "mob_effect/bad_omen",
    "mob_effect/blindness",
    "mob_effect/breath_of_the_nautilus",
    "mob_effect/conduit_power",
    "mob_effect/darkness",
    "mob_effect/dolphins_grace",
    "mob_effect/fire_resistance",
    "mob_effect/glowing",
    "mob_effect/haste",
    "mob_effect/health_boost",
    "mob_effect/hero_of_the_village",
    "mob_effect/hunger",
    "mob_effect/infested",
    "mob_effect/instant_damage",
    "mob_effect/instant_health",
    "mob_effect/invisibility",
    "mob_effect/jump_boost",
    "mob_effect/levitation",
    "mob_effect/luck",
    "mob_effect/mining_fatigue",
    "mob_effect/nausea",
    "mob_effect/night_vision",
    "mob_effect/oozing",
    "mob_effect/poison",
    "mob_effect/raid_omen",
    "mob_effect/regeneration",
    "mob_effect/resistance",
    "mob_effect/saturation",
    "mob_effect/slow_falling",
    "mob_effect/slowness",
    "mob_effect/speed",
    "mob_effect/strength",
    "mob_effect/trial_omen",
    "mob_effect/unluck",
    "mob_effect/water_breathing",
    "mob_effect/weakness",
    "mob_effect/weaving",
    "mob_effect/wind_charged",
    "mob_effect/wither",
    "painting/alban",
    "painting/aztec",
    "painting/aztec2",
    "painting/back",
    "painting/backyard",
    "painting/baroque",
    "painting/bomb",
    "painting/bouquet",
    "painting/burning_skull",
    "painting/bust",
    "painting/cavebird",
    "painting/changing",
    "painting/cotan",
    "painting/courbet",
    "painting/creebet",
    "painting/dennis",
    "painting/donkey_kong",
    "painting/earth",
    "painting/endboss",
    "painting/fern",
    "painting/fighters",
    "painting/finding",
    "painting/fire",
    "painting/graham",
    "painting/humble",
    "painting/kebab",
    "painting/lowmist",
    "painting/match",
    "painting/meditative",
    "painting/orb",
    "painting/owlemons",
    "painting/passage",
    "painting/pigscene",
    "painting/plant",
    "painting/pointer",
    "painting/pond",
    "painting/pool",
    "painting/prairie_ride",
    "painting/sea",
    "painting/skeleton",
    "painting/skull_and_roses",
    "painting/stage",
    "painting/sunflowers",
    "painting/sunset",
    "painting/tides",
    "painting/unpacked",
    "painting/void",
    "painting/wanderer",
    "painting/wasteland",
    "painting/water",
    "painting/wind",
    "painting/wither",
    "palettes/trim/amethyst",
    "palettes/trim/copper",
    "palettes/trim/copper_darker",
    "palettes/trim/diamond",
    "palettes/trim/diamond_darker",
    "palettes/trim/emerald",
    "palettes/trim/gold",
    "palettes/trim/gold_darker",
    "palettes/trim/iron",
    "palettes/trim/iron_darker",
    "palettes/trim/lapis",
    "palettes/trim/netherite",
    "palettes/trim/netherite_darker",
    "palettes/trim/quartz",
    "palettes/trim/redstone",
    "palettes/trim/resin",
    "palettes/trim_base",
    "particle/angry",
    "particle/big_smoke_0",
    "particle/big_smoke_1",
    "particle/big_smoke_10",
    "particle/big_smoke_11",
    "particle/big_smoke_2",
    "particle/big_smoke_3",
    "particle/big_smoke_4",
    "particle/big_smoke_5",
    "particle/big_smoke_6",
    "particle/big_smoke_7",
    "particle/big_smoke_8",
    "particle/big_smoke_9",
    "particle/bubble",
    "particle/bubble_pop_0",
    "particle/bubble_pop_1",
    "particle/bubble_pop_2",
    "particle/bubble_pop_3",
    "particle/bubble_pop_4",
    "particle/bubble_white",
    "particle/cherry_0",
    "particle/cherry_1",
    "particle/cherry_10",
    "particle/cherry_11",
    "particle/cherry_2",
    "particle/cherry_3",
    "particle/cherry_4",
    "particle/cherry_5",
    "particle/cherry_6",
    "particle/cherry_7",
    "particle/cherry_8",
    "particle/cherry_9",
    "particle/copper_fire_flame",
    "particle/critical_hit",
    "particle/damage",
    "particle/drip_fall",
    "particle/drip_hang",
    "particle/drip_land",
    "particle/effect_0",
    "particle/effect_1",
    "particle/effect_2",
    "particle/effect_3",
    "particle/effect_4",
    "particle/effect_5",
    "particle/effect_6",
    "particle/effect_7",
    "particle/enchanted_hit",
    "particle/explosion_0",
    "particle/explosion_1",
    "particle/explosion_10",
    "particle/explosion_11",
    "particle/explosion_12",
    "particle/explosion_13",
    "particle/explosion_14",
    "particle/explosion_15",
    "particle/explosion_2",
    "particle/explosion_3",
    "particle/explosion_4",
    "particle/explosion_5",
    "particle/explosion_6",
    "particle/explosion_7",
    "particle/explosion_8",
    "particle/explosion_9",
    "particle/firefly",
    "particle/flame",
    "particle/flash",
    "particle/generic_0",
    "particle/generic_1",
    "particle/generic_2",
    "particle/generic_3",
    "particle/generic_4",
    "particle/generic_5",
    "particle/generic_6",
    "particle/generic_7",
    "particle/geyser_base_01",
    "particle/geyser_base_02",
    "particle/geyser_base_03",
    "particle/geyser_base_04",
    "particle/geyser_base_05",
    "particle/geyser_base_06",
    "particle/geyser_base_07",
    "particle/geyser_base_08",
    "particle/geyser_plume_01",
    "particle/geyser_plume_02",
    "particle/geyser_plume_03",
    "particle/geyser_plume_04",
    "particle/geyser_plume_05",
    "particle/geyser_plume_06",
    "particle/geyser_plume_07",
    "particle/geyser_plume_08",
    "particle/geyser_poof_01",
    "particle/geyser_poof_02",
    "particle/geyser_poof_03",
    "particle/geyser_poof_04",
    "particle/geyser_poof_05",
    "particle/geyser_poof_06",
    "particle/geyser_poof_07",
    "particle/geyser_poof_08",
    "particle/glint",
    "particle/glitter_0",
    "particle/glitter_1",
    "particle/glitter_2",
    "particle/glitter_3",
    "particle/glitter_4",
    "particle/glitter_5",
    "particle/glitter_6",
    "particle/glitter_7",
    "particle/glow",
    "particle/goldheart_0",
    "particle/goldheart_1",
    "particle/goldheart_2",
    "particle/gust_0",
    "particle/gust_1",
    "particle/gust_10",
    "particle/gust_11",
    "particle/gust_2",
    "particle/gust_3",
    "particle/gust_4",
    "particle/gust_5",
    "particle/gust_6",
    "particle/gust_7",
    "particle/gust_8",
    "particle/gust_9",
    "particle/heart",
    "particle/infested",
    "particle/lava",
    "particle/leaf_0",
    "particle/leaf_1",
    "particle/leaf_10",
    "particle/leaf_11",
    "particle/leaf_2",
    "particle/leaf_3",
    "particle/leaf_4",
    "particle/leaf_5",
    "particle/leaf_6",
    "particle/leaf_7",
    "particle/leaf_8",
    "particle/leaf_9",
    "particle/nautilus",
    "particle/note",
    "particle/noxious_gas_01",
    "particle/noxious_gas_02",
    "particle/noxious_gas_03",
    "particle/noxious_gas_04",
    "particle/noxious_gas_05",
    "particle/noxious_gas_06",
    "particle/noxious_gas_07",
    "particle/noxious_gas_08",
    "particle/ominous_spawning",
    "particle/orange_poplar_1",
    "particle/orange_poplar_2",
    "particle/orange_poplar_3",
    "particle/orange_poplar_4",
    "particle/pale_oak_0",
    "particle/pale_oak_1",
    "particle/pale_oak_10",
    "particle/pale_oak_11",
    "particle/pale_oak_2",
    "particle/pale_oak_3",
    "particle/pale_oak_4",
    "particle/pale_oak_5",
    "particle/pale_oak_6",
    "particle/pale_oak_7",
    "particle/pale_oak_8",
    "particle/pale_oak_9",
    "particle/raid_omen",
    "particle/red_poplar_1",
    "particle/red_poplar_2",
    "particle/red_poplar_3",
    "particle/red_poplar_4",
    "particle/sculk_charge_0",
    "particle/sculk_charge_1",
    "particle/sculk_charge_2",
    "particle/sculk_charge_3",
    "particle/sculk_charge_4",
    "particle/sculk_charge_5",
    "particle/sculk_charge_6",
    "particle/sculk_charge_pop_0",
    "particle/sculk_charge_pop_1",
    "particle/sculk_charge_pop_2",
    "particle/sculk_charge_pop_3",
    "particle/sculk_soul_0",
    "particle/sculk_soul_1",
    "particle/sculk_soul_10",
    "particle/sculk_soul_2",
    "particle/sculk_soul_3",
    "particle/sculk_soul_4",
    "particle/sculk_soul_5",
    "particle/sculk_soul_6",
    "particle/sculk_soul_7",
    "particle/sculk_soul_8",
    "particle/sculk_soul_9",
    "particle/sga_a",
    "particle/sga_b",
    "particle/sga_c",
    "particle/sga_d",
    "particle/sga_e",
    "particle/sga_f",
    "particle/sga_g",
    "particle/sga_h",
    "particle/sga_i",
    "particle/sga_j",
    "particle/sga_k",
    "particle/sga_l",
    "particle/sga_m",
    "particle/sga_n",
    "particle/sga_o",
    "particle/sga_p",
    "particle/sga_q",
    "particle/sga_r",
    "particle/sga_s",
    "particle/sga_t",
    "particle/sga_u",
    "particle/sga_v",
    "particle/sga_w",
    "particle/sga_x",
    "particle/sga_y",
    "particle/sga_z",
    "particle/shriek",
    "particle/small_gust_0",
    "particle/small_gust_1",
    "particle/small_gust_2",
    "particle/small_gust_3",
    "particle/small_gust_4",
    "particle/small_gust_5",
    "particle/small_gust_6",
    "particle/sonic_boom_0",
    "particle/sonic_boom_1",
    "particle/sonic_boom_10",
    "particle/sonic_boom_11",
    "particle/sonic_boom_12",
    "particle/sonic_boom_13",
    "particle/sonic_boom_14",
    "particle/sonic_boom_15",
    "particle/sonic_boom_2",
    "particle/sonic_boom_3",
    "particle/sonic_boom_4",
    "particle/sonic_boom_5",
    "particle/sonic_boom_6",
    "particle/sonic_boom_7",
    "particle/sonic_boom_8",
    "particle/sonic_boom_9",
    "particle/soul_0",
    "particle/soul_1",
    "particle/soul_10",
    "particle/soul_2",
    "particle/soul_3",
    "particle/soul_4",
    "particle/soul_5",
    "particle/soul_6",
    "particle/soul_7",
    "particle/soul_8",
    "particle/soul_9",
    "particle/soul_fire_flame",
    "particle/spark_0",
    "particle/spark_1",
    "particle/spark_2",
    "particle/spark_3",
    "particle/spark_4",
    "particle/spark_5",
    "particle/spark_6",
    "particle/spark_7",
    "particle/spell_0",
    "particle/spell_1",
    "particle/spell_2",
    "particle/spell_3",
    "particle/spell_4",
    "particle/spell_5",
    "particle/spell_6",
    "particle/spell_7",
    "particle/splash_0",
    "particle/splash_1",
    "particle/splash_2",
    "particle/splash_3",
    "particle/sulfur_cube_goo",
    "particle/sweep_0",
    "particle/sweep_1",
    "particle/sweep_2",
    "particle/sweep_3",
    "particle/sweep_4",
    "particle/sweep_5",
    "particle/sweep_6",
    "particle/sweep_7",
    "particle/trial_omen",
    "particle/trial_spawner_detection_0",
    "particle/trial_spawner_detection_1",
    "particle/trial_spawner_detection_2",
    "particle/trial_spawner_detection_3",
    "particle/trial_spawner_detection_4",
    "particle/trial_spawner_detection_ominous_0",
    "particle/trial_spawner_detection_ominous_1",
    "particle/trial_spawner_detection_ominous_2",
    "particle/trial_spawner_detection_ominous_3",
    "particle/trial_spawner_detection_ominous_4",
    "particle/vault_connection",
    "particle/vibration",
    "particle/yellow_poplar_1",
    "particle/yellow_poplar_2",
    "particle/yellow_poplar_3",
    "particle/yellow_poplar_4",
    "trims/entity/humanoid/bolt",
    "trims/entity/humanoid/coast",
    "trims/entity/humanoid/dune",
    "trims/entity/humanoid/eye",
    "trims/entity/humanoid/flow",
    "trims/entity/humanoid/host",
    "trims/entity/humanoid/raiser",
    "trims/entity/humanoid/rib",
    "trims/entity/humanoid/sentry",
    "trims/entity/humanoid/shaper",
    "trims/entity/humanoid/silence",
    "trims/entity/humanoid/snout",
    "trims/entity/humanoid/spire",
    "trims/entity/humanoid/tide",
    "trims/entity/humanoid/vex",
    "trims/entity/humanoid/ward",
    "trims/entity/humanoid/wayfinder",
    "trims/entity/humanoid/wild",
    "trims/entity/humanoid_leggings/bolt",
    "trims/entity/humanoid_leggings/coast",
    "trims/entity/humanoid_leggings/dune",
    "trims/entity/humanoid_leggings/eye",
    "trims/entity/humanoid_leggings/flow",
    "trims/entity/humanoid_leggings/host",
    "trims/entity/humanoid_leggings/raiser",
    "trims/entity/humanoid_leggings/rib",
    "trims/entity/humanoid_leggings/sentry",
    "trims/entity/humanoid_leggings/shaper",
    "trims/entity/humanoid_leggings/silence",
    "trims/entity/humanoid_leggings/snout",
    "trims/entity/humanoid_leggings/spire",
    "trims/entity/humanoid_leggings/tide",
    "trims/entity/humanoid_leggings/vex",
    "trims/entity/humanoid_leggings/ward",
    "trims/entity/humanoid_leggings/wayfinder",
    "trims/entity/humanoid_leggings/wild",
    "trims/items/boots_trim",
    "trims/items/chestplate_trim",
    "trims/items/helmet_trim",
    "trims/items/leggings_trim"
  ]);
});

// src/arguments/generated/_registry/activities.ts
var ACTIVITIES_SET;
var init_activities = __esm(() => {
  init_sandstone();
  ACTIVITIES_SET = new Set2([
    "admire_item",
    "avoid",
    "celebrate",
    "core",
    "dig",
    "emerge",
    "fight",
    "hide",
    "idle",
    "investigate",
    "lay_spawn",
    "long_jump",
    "meet",
    "panic",
    "play",
    "play_dead",
    "pre_raid",
    "raid",
    "ram",
    "rest",
    "ride",
    "roar",
    "sniff",
    "swim",
    "tongue",
    "work"
  ]);
});

// src/arguments/generated/_registry/attributes.ts
var ATTRIBUTES_SET;
var init_attributes = __esm(() => {
  init_sandstone();
  ATTRIBUTES_SET = new Set2([
    "air_drag_modifier",
    "armor",
    "armor_toughness",
    "attack_damage",
    "attack_knockback",
    "attack_speed",
    "below_name_distance",
    "block_break_speed",
    "block_interaction_range",
    "bounciness",
    "burning_time",
    "camera_distance",
    "entity_interaction_range",
    "explosion_knockback_resistance",
    "fall_damage_multiplier",
    "flying_speed",
    "follow_range",
    "friction_modifier",
    "gravity",
    "jump_strength",
    "knockback_resistance",
    "luck",
    "max_absorption",
    "max_health",
    "mining_efficiency",
    "movement_efficiency",
    "movement_speed",
    "name_tag_distance",
    "oxygen_bonus",
    "safe_fall_distance",
    "scale",
    "sneaking_speed",
    "spawn_reinforcements",
    "step_height",
    "submerged_mining_speed",
    "sweeping_damage_ratio",
    "tempt_range",
    "water_movement_efficiency",
    "waypoint_receive_range",
    "waypoint_transmit_range"
  ]);
});

// src/arguments/generated/_registry/attribute_types.ts
var ATTRIBUTE_TYPES_SET;
var init_attribute_types = __esm(() => {
  init_sandstone();
  ATTRIBUTE_TYPES_SET = new Set2([
    "activity",
    "ambient_particles",
    "ambient_sounds",
    "angle_degrees",
    "argb_color",
    "background_music",
    "bed_rule",
    "boolean",
    "float",
    "integer",
    "mob_spawn_settings",
    "moon_phase",
    "particle",
    "rgb_color",
    "tri_state"
  ]);
});

// src/arguments/generated/_registry/blocks.ts
var BLOCKS_SET;
var init_blocks2 = __esm(() => {
  init_sandstone();
  BLOCKS_SET = new Set2([
    "acacia_button",
    "acacia_door",
    "acacia_fence",
    "acacia_fence_gate",
    "acacia_hanging_sign",
    "acacia_leaves",
    "acacia_log",
    "acacia_planks",
    "acacia_pressure_plate",
    "acacia_sapling",
    "acacia_shelf",
    "acacia_sign",
    "acacia_slab",
    "acacia_stairs",
    "acacia_trapdoor",
    "acacia_wall_hanging_sign",
    "acacia_wall_sign",
    "acacia_wood",
    "activator_rail",
    "air",
    "allium",
    "amethyst_block",
    "amethyst_cluster",
    "ancient_debris",
    "andesite",
    "andesite_slab",
    "andesite_stairs",
    "andesite_wall",
    "anvil",
    "attached_melon_stem",
    "attached_pumpkin_stem",
    "azalea",
    "azalea_leaves",
    "azure_bluet",
    "bamboo",
    "bamboo_block",
    "bamboo_button",
    "bamboo_door",
    "bamboo_fence",
    "bamboo_fence_gate",
    "bamboo_hanging_sign",
    "bamboo_mosaic",
    "bamboo_mosaic_slab",
    "bamboo_mosaic_stairs",
    "bamboo_planks",
    "bamboo_pressure_plate",
    "bamboo_sapling",
    "bamboo_shelf",
    "bamboo_sign",
    "bamboo_slab",
    "bamboo_stairs",
    "bamboo_trapdoor",
    "bamboo_wall_hanging_sign",
    "bamboo_wall_sign",
    "barrel",
    "barrier",
    "basalt",
    "beacon",
    "bedrock",
    "bee_nest",
    "beehive",
    "beetroots",
    "bell",
    "big_dripleaf",
    "big_dripleaf_stem",
    "birch_button",
    "birch_door",
    "birch_fence",
    "birch_fence_gate",
    "birch_hanging_sign",
    "birch_leaves",
    "birch_log",
    "birch_planks",
    "birch_pressure_plate",
    "birch_sapling",
    "birch_shelf",
    "birch_sign",
    "birch_slab",
    "birch_stairs",
    "birch_trapdoor",
    "birch_wall_hanging_sign",
    "birch_wall_sign",
    "birch_wood",
    "black_banner",
    "black_bed",
    "black_candle",
    "black_candle_cake",
    "black_carpet",
    "black_concrete",
    "black_concrete_powder",
    "black_concrete_slab",
    "black_concrete_stairs",
    "black_glazed_terracotta",
    "black_shulker_box",
    "black_stained_glass",
    "black_stained_glass_pane",
    "black_terracotta",
    "black_wall_banner",
    "black_wool",
    "black_wool_slab",
    "black_wool_stairs",
    "blackstone",
    "blackstone_slab",
    "blackstone_stairs",
    "blackstone_wall",
    "blast_furnace",
    "blue_banner",
    "blue_bed",
    "blue_candle",
    "blue_candle_cake",
    "blue_carpet",
    "blue_concrete",
    "blue_concrete_powder",
    "blue_concrete_slab",
    "blue_concrete_stairs",
    "blue_glazed_terracotta",
    "blue_ice",
    "blue_orchid",
    "blue_shulker_box",
    "blue_stained_glass",
    "blue_stained_glass_pane",
    "blue_terracotta",
    "blue_wall_banner",
    "blue_wool",
    "blue_wool_slab",
    "blue_wool_stairs",
    "bone_block",
    "bookshelf",
    "brain_coral",
    "brain_coral_block",
    "brain_coral_fan",
    "brain_coral_wall_fan",
    "brewing_stand",
    "brick_slab",
    "brick_stairs",
    "brick_wall",
    "bricks",
    "brown_banner",
    "brown_bed",
    "brown_candle",
    "brown_candle_cake",
    "brown_carpet",
    "brown_concrete",
    "brown_concrete_powder",
    "brown_concrete_slab",
    "brown_concrete_stairs",
    "brown_glazed_terracotta",
    "brown_mushroom",
    "brown_mushroom_block",
    "brown_shulker_box",
    "brown_stained_glass",
    "brown_stained_glass_pane",
    "brown_terracotta",
    "brown_wall_banner",
    "brown_wool",
    "brown_wool_slab",
    "brown_wool_stairs",
    "bubble_column",
    "bubble_coral",
    "bubble_coral_block",
    "bubble_coral_fan",
    "bubble_coral_wall_fan",
    "budding_amethyst",
    "bush",
    "cactus",
    "cactus_flower",
    "cake",
    "calcite",
    "calibrated_sculk_sensor",
    "campfire",
    "candle",
    "candle_cake",
    "carrots",
    "cartography_table",
    "carved_pumpkin",
    "cauldron",
    "cave_air",
    "cave_vines",
    "cave_vines_plant",
    "chain_command_block",
    "cherry_button",
    "cherry_door",
    "cherry_fence",
    "cherry_fence_gate",
    "cherry_hanging_sign",
    "cherry_leaves",
    "cherry_log",
    "cherry_planks",
    "cherry_pressure_plate",
    "cherry_sapling",
    "cherry_shelf",
    "cherry_sign",
    "cherry_slab",
    "cherry_stairs",
    "cherry_trapdoor",
    "cherry_wall_hanging_sign",
    "cherry_wall_sign",
    "cherry_wood",
    "chest",
    "chipped_anvil",
    "chiseled_bookshelf",
    "chiseled_cinnabar",
    "chiseled_copper",
    "chiseled_deepslate",
    "chiseled_nether_bricks",
    "chiseled_polished_blackstone",
    "chiseled_quartz_block",
    "chiseled_red_sandstone",
    "chiseled_resin_bricks",
    "chiseled_sandstone",
    "chiseled_stone_bricks",
    "chiseled_sulfur",
    "chiseled_tuff",
    "chiseled_tuff_bricks",
    "chorus_flower",
    "chorus_plant",
    "cinnabar",
    "cinnabar_brick_slab",
    "cinnabar_brick_stairs",
    "cinnabar_brick_wall",
    "cinnabar_bricks",
    "cinnabar_slab",
    "cinnabar_stairs",
    "cinnabar_wall",
    "clay",
    "closed_eyeblossom",
    "coal_block",
    "coal_ore",
    "coarse_dirt",
    "cobbled_deepslate",
    "cobbled_deepslate_slab",
    "cobbled_deepslate_stairs",
    "cobbled_deepslate_wall",
    "cobblestone",
    "cobblestone_slab",
    "cobblestone_stairs",
    "cobblestone_wall",
    "cobweb",
    "cocoa",
    "command_block",
    "comparator",
    "composter",
    "conduit",
    "copper_bars",
    "copper_block",
    "copper_bulb",
    "copper_chain",
    "copper_chest",
    "copper_door",
    "copper_golem_statue",
    "copper_grate",
    "copper_lantern",
    "copper_ore",
    "copper_torch",
    "copper_trapdoor",
    "copper_wall_torch",
    "cornflower",
    "cracked_deepslate_bricks",
    "cracked_deepslate_tiles",
    "cracked_nether_bricks",
    "cracked_polished_blackstone_bricks",
    "cracked_stone_bricks",
    "crafter",
    "crafting_table",
    "creaking_heart",
    "creeper_head",
    "creeper_wall_head",
    "crimson_button",
    "crimson_door",
    "crimson_fence",
    "crimson_fence_gate",
    "crimson_fungus",
    "crimson_hanging_sign",
    "crimson_hyphae",
    "crimson_nylium",
    "crimson_planks",
    "crimson_pressure_plate",
    "crimson_roots",
    "crimson_shelf",
    "crimson_sign",
    "crimson_slab",
    "crimson_stairs",
    "crimson_stem",
    "crimson_trapdoor",
    "crimson_wall_hanging_sign",
    "crimson_wall_sign",
    "crying_obsidian",
    "cut_copper",
    "cut_copper_slab",
    "cut_copper_stairs",
    "cut_red_sandstone",
    "cut_red_sandstone_slab",
    "cut_sandstone",
    "cut_sandstone_slab",
    "cyan_banner",
    "cyan_bed",
    "cyan_candle",
    "cyan_candle_cake",
    "cyan_carpet",
    "cyan_concrete",
    "cyan_concrete_powder",
    "cyan_concrete_slab",
    "cyan_concrete_stairs",
    "cyan_glazed_terracotta",
    "cyan_shulker_box",
    "cyan_stained_glass",
    "cyan_stained_glass_pane",
    "cyan_terracotta",
    "cyan_wall_banner",
    "cyan_wool",
    "cyan_wool_slab",
    "cyan_wool_stairs",
    "damaged_anvil",
    "dandelion",
    "dark_oak_button",
    "dark_oak_door",
    "dark_oak_fence",
    "dark_oak_fence_gate",
    "dark_oak_hanging_sign",
    "dark_oak_leaves",
    "dark_oak_log",
    "dark_oak_planks",
    "dark_oak_pressure_plate",
    "dark_oak_sapling",
    "dark_oak_shelf",
    "dark_oak_sign",
    "dark_oak_slab",
    "dark_oak_stairs",
    "dark_oak_trapdoor",
    "dark_oak_wall_hanging_sign",
    "dark_oak_wall_sign",
    "dark_oak_wood",
    "dark_prismarine",
    "dark_prismarine_slab",
    "dark_prismarine_stairs",
    "daylight_detector",
    "dead_brain_coral",
    "dead_brain_coral_block",
    "dead_brain_coral_fan",
    "dead_brain_coral_wall_fan",
    "dead_bubble_coral",
    "dead_bubble_coral_block",
    "dead_bubble_coral_fan",
    "dead_bubble_coral_wall_fan",
    "dead_bush",
    "dead_fire_coral",
    "dead_fire_coral_block",
    "dead_fire_coral_fan",
    "dead_fire_coral_wall_fan",
    "dead_horn_coral",
    "dead_horn_coral_block",
    "dead_horn_coral_fan",
    "dead_horn_coral_wall_fan",
    "dead_tube_coral",
    "dead_tube_coral_block",
    "dead_tube_coral_fan",
    "dead_tube_coral_wall_fan",
    "decorated_pot",
    "deepslate",
    "deepslate_brick_slab",
    "deepslate_brick_stairs",
    "deepslate_brick_wall",
    "deepslate_bricks",
    "deepslate_coal_ore",
    "deepslate_copper_ore",
    "deepslate_diamond_ore",
    "deepslate_emerald_ore",
    "deepslate_gold_ore",
    "deepslate_iron_ore",
    "deepslate_lapis_ore",
    "deepslate_redstone_ore",
    "deepslate_tile_slab",
    "deepslate_tile_stairs",
    "deepslate_tile_wall",
    "deepslate_tiles",
    "detector_rail",
    "diamond_block",
    "diamond_ore",
    "diorite",
    "diorite_slab",
    "diorite_stairs",
    "diorite_wall",
    "dirt",
    "dirt_path",
    "dispenser",
    "dragon_egg",
    "dragon_head",
    "dragon_wall_head",
    "dried_ghast",
    "dried_kelp_block",
    "dripstone_block",
    "dropper",
    "emerald_block",
    "emerald_ore",
    "enchanting_table",
    "end_gateway",
    "end_portal",
    "end_portal_frame",
    "end_rod",
    "end_stone",
    "end_stone_brick_slab",
    "end_stone_brick_stairs",
    "end_stone_brick_wall",
    "end_stone_bricks",
    "ender_chest",
    "exposed_chiseled_copper",
    "exposed_copper",
    "exposed_copper_bars",
    "exposed_copper_bulb",
    "exposed_copper_chain",
    "exposed_copper_chest",
    "exposed_copper_door",
    "exposed_copper_golem_statue",
    "exposed_copper_grate",
    "exposed_copper_lantern",
    "exposed_copper_trapdoor",
    "exposed_cut_copper",
    "exposed_cut_copper_slab",
    "exposed_cut_copper_stairs",
    "exposed_lightning_rod",
    "farmland",
    "fern",
    "fire",
    "fire_coral",
    "fire_coral_block",
    "fire_coral_fan",
    "fire_coral_wall_fan",
    "firefly_bush",
    "fletching_table",
    "flower_pot",
    "flowering_azalea",
    "flowering_azalea_leaves",
    "frogspawn",
    "frosted_ice",
    "furnace",
    "gilded_blackstone",
    "glass",
    "glass_pane",
    "glow_lichen",
    "glowstone",
    "gold_block",
    "gold_ore",
    "golden_dandelion",
    "granite",
    "granite_slab",
    "granite_stairs",
    "granite_wall",
    "grass_block",
    "gravel",
    "gray_banner",
    "gray_bed",
    "gray_candle",
    "gray_candle_cake",
    "gray_carpet",
    "gray_concrete",
    "gray_concrete_powder",
    "gray_concrete_slab",
    "gray_concrete_stairs",
    "gray_glazed_terracotta",
    "gray_shulker_box",
    "gray_stained_glass",
    "gray_stained_glass_pane",
    "gray_terracotta",
    "gray_wall_banner",
    "gray_wool",
    "gray_wool_slab",
    "gray_wool_stairs",
    "green_banner",
    "green_bed",
    "green_candle",
    "green_candle_cake",
    "green_carpet",
    "green_concrete",
    "green_concrete_powder",
    "green_concrete_slab",
    "green_concrete_stairs",
    "green_glazed_terracotta",
    "green_shulker_box",
    "green_stained_glass",
    "green_stained_glass_pane",
    "green_terracotta",
    "green_wall_banner",
    "green_wool",
    "green_wool_slab",
    "green_wool_stairs",
    "grindstone",
    "hanging_roots",
    "hay_block",
    "heavy_core",
    "heavy_weighted_pressure_plate",
    "honey_block",
    "honeycomb_block",
    "hopper",
    "horn_coral",
    "horn_coral_block",
    "horn_coral_fan",
    "horn_coral_wall_fan",
    "ice",
    "infested_chiseled_stone_bricks",
    "infested_cobblestone",
    "infested_cracked_stone_bricks",
    "infested_deepslate",
    "infested_mossy_stone_bricks",
    "infested_stone",
    "infested_stone_bricks",
    "iron_bars",
    "iron_block",
    "iron_chain",
    "iron_door",
    "iron_ore",
    "iron_trapdoor",
    "jack_o_lantern",
    "jigsaw",
    "jukebox",
    "jungle_button",
    "jungle_door",
    "jungle_fence",
    "jungle_fence_gate",
    "jungle_hanging_sign",
    "jungle_leaves",
    "jungle_log",
    "jungle_planks",
    "jungle_pressure_plate",
    "jungle_sapling",
    "jungle_shelf",
    "jungle_sign",
    "jungle_slab",
    "jungle_stairs",
    "jungle_trapdoor",
    "jungle_wall_hanging_sign",
    "jungle_wall_sign",
    "jungle_wood",
    "kelp",
    "kelp_plant",
    "ladder",
    "lantern",
    "lapis_block",
    "lapis_ore",
    "large_amethyst_bud",
    "large_fern",
    "lava",
    "lava_cauldron",
    "leaf_litter",
    "lectern",
    "lever",
    "light",
    "light_blue_banner",
    "light_blue_bed",
    "light_blue_candle",
    "light_blue_candle_cake",
    "light_blue_carpet",
    "light_blue_concrete",
    "light_blue_concrete_powder",
    "light_blue_concrete_slab",
    "light_blue_concrete_stairs",
    "light_blue_glazed_terracotta",
    "light_blue_shulker_box",
    "light_blue_stained_glass",
    "light_blue_stained_glass_pane",
    "light_blue_terracotta",
    "light_blue_wall_banner",
    "light_blue_wool",
    "light_blue_wool_slab",
    "light_blue_wool_stairs",
    "light_gray_banner",
    "light_gray_bed",
    "light_gray_candle",
    "light_gray_candle_cake",
    "light_gray_carpet",
    "light_gray_concrete",
    "light_gray_concrete_powder",
    "light_gray_concrete_slab",
    "light_gray_concrete_stairs",
    "light_gray_glazed_terracotta",
    "light_gray_shulker_box",
    "light_gray_stained_glass",
    "light_gray_stained_glass_pane",
    "light_gray_terracotta",
    "light_gray_wall_banner",
    "light_gray_wool",
    "light_gray_wool_slab",
    "light_gray_wool_stairs",
    "light_weighted_pressure_plate",
    "lightning_rod",
    "lilac",
    "lily_of_the_valley",
    "lily_pad",
    "lime_banner",
    "lime_bed",
    "lime_candle",
    "lime_candle_cake",
    "lime_carpet",
    "lime_concrete",
    "lime_concrete_powder",
    "lime_concrete_slab",
    "lime_concrete_stairs",
    "lime_glazed_terracotta",
    "lime_shulker_box",
    "lime_stained_glass",
    "lime_stained_glass_pane",
    "lime_terracotta",
    "lime_wall_banner",
    "lime_wool",
    "lime_wool_slab",
    "lime_wool_stairs",
    "lodestone",
    "loom",
    "magenta_banner",
    "magenta_bed",
    "magenta_candle",
    "magenta_candle_cake",
    "magenta_carpet",
    "magenta_concrete",
    "magenta_concrete_powder",
    "magenta_concrete_slab",
    "magenta_concrete_stairs",
    "magenta_glazed_terracotta",
    "magenta_shulker_box",
    "magenta_stained_glass",
    "magenta_stained_glass_pane",
    "magenta_terracotta",
    "magenta_wall_banner",
    "magenta_wool",
    "magenta_wool_slab",
    "magenta_wool_stairs",
    "magma_block",
    "mangrove_button",
    "mangrove_door",
    "mangrove_fence",
    "mangrove_fence_gate",
    "mangrove_hanging_sign",
    "mangrove_leaves",
    "mangrove_log",
    "mangrove_planks",
    "mangrove_pressure_plate",
    "mangrove_propagule",
    "mangrove_roots",
    "mangrove_shelf",
    "mangrove_sign",
    "mangrove_slab",
    "mangrove_stairs",
    "mangrove_trapdoor",
    "mangrove_wall_hanging_sign",
    "mangrove_wall_sign",
    "mangrove_wood",
    "medium_amethyst_bud",
    "melon",
    "melon_stem",
    "moss_block",
    "moss_carpet",
    "mossy_cobblestone",
    "mossy_cobblestone_slab",
    "mossy_cobblestone_stairs",
    "mossy_cobblestone_wall",
    "mossy_stone_brick_slab",
    "mossy_stone_brick_stairs",
    "mossy_stone_brick_wall",
    "mossy_stone_bricks",
    "moving_piston",
    "mud",
    "mud_brick_slab",
    "mud_brick_stairs",
    "mud_brick_wall",
    "mud_bricks",
    "muddy_mangrove_roots",
    "mushroom_stem",
    "mycelium",
    "nether_brick_fence",
    "nether_brick_slab",
    "nether_brick_stairs",
    "nether_brick_wall",
    "nether_bricks",
    "nether_gold_ore",
    "nether_portal",
    "nether_quartz_ore",
    "nether_sprouts",
    "nether_wart",
    "nether_wart_block",
    "netherite_block",
    "netherrack",
    "note_block",
    "oak_button",
    "oak_door",
    "oak_fence",
    "oak_fence_gate",
    "oak_hanging_sign",
    "oak_leaves",
    "oak_log",
    "oak_planks",
    "oak_pressure_plate",
    "oak_sapling",
    "oak_shelf",
    "oak_sign",
    "oak_slab",
    "oak_stairs",
    "oak_trapdoor",
    "oak_wall_hanging_sign",
    "oak_wall_sign",
    "oak_wood",
    "observer",
    "obsidian",
    "ochre_froglight",
    "open_eyeblossom",
    "orange_banner",
    "orange_bed",
    "orange_candle",
    "orange_candle_cake",
    "orange_carpet",
    "orange_concrete",
    "orange_concrete_powder",
    "orange_concrete_slab",
    "orange_concrete_stairs",
    "orange_glazed_terracotta",
    "orange_poplar_leaves",
    "orange_shulker_box",
    "orange_stained_glass",
    "orange_stained_glass_pane",
    "orange_terracotta",
    "orange_tulip",
    "orange_wall_banner",
    "orange_wool",
    "orange_wool_slab",
    "orange_wool_stairs",
    "oxeye_daisy",
    "oxidized_chiseled_copper",
    "oxidized_copper",
    "oxidized_copper_bars",
    "oxidized_copper_bulb",
    "oxidized_copper_chain",
    "oxidized_copper_chest",
    "oxidized_copper_door",
    "oxidized_copper_golem_statue",
    "oxidized_copper_grate",
    "oxidized_copper_lantern",
    "oxidized_copper_trapdoor",
    "oxidized_cut_copper",
    "oxidized_cut_copper_slab",
    "oxidized_cut_copper_stairs",
    "oxidized_lightning_rod",
    "packed_ice",
    "packed_mud",
    "pale_hanging_moss",
    "pale_moss_block",
    "pale_moss_carpet",
    "pale_oak_button",
    "pale_oak_door",
    "pale_oak_fence",
    "pale_oak_fence_gate",
    "pale_oak_hanging_sign",
    "pale_oak_leaves",
    "pale_oak_log",
    "pale_oak_planks",
    "pale_oak_pressure_plate",
    "pale_oak_sapling",
    "pale_oak_shelf",
    "pale_oak_sign",
    "pale_oak_slab",
    "pale_oak_stairs",
    "pale_oak_trapdoor",
    "pale_oak_wall_hanging_sign",
    "pale_oak_wall_sign",
    "pale_oak_wood",
    "pearlescent_froglight",
    "peony",
    "petrified_oak_slab",
    "piglin_head",
    "piglin_wall_head",
    "pink_banner",
    "pink_bed",
    "pink_candle",
    "pink_candle_cake",
    "pink_carpet",
    "pink_concrete",
    "pink_concrete_powder",
    "pink_concrete_slab",
    "pink_concrete_stairs",
    "pink_glazed_terracotta",
    "pink_petals",
    "pink_shulker_box",
    "pink_stained_glass",
    "pink_stained_glass_pane",
    "pink_terracotta",
    "pink_tulip",
    "pink_wall_banner",
    "pink_wool",
    "pink_wool_slab",
    "pink_wool_stairs",
    "piston",
    "piston_head",
    "pitcher_crop",
    "pitcher_plant",
    "player_head",
    "player_wall_head",
    "podzol",
    "pointed_dripstone",
    "polished_andesite",
    "polished_andesite_slab",
    "polished_andesite_stairs",
    "polished_basalt",
    "polished_blackstone",
    "polished_blackstone_brick_slab",
    "polished_blackstone_brick_stairs",
    "polished_blackstone_brick_wall",
    "polished_blackstone_bricks",
    "polished_blackstone_button",
    "polished_blackstone_pressure_plate",
    "polished_blackstone_slab",
    "polished_blackstone_stairs",
    "polished_blackstone_wall",
    "polished_cinnabar",
    "polished_cinnabar_slab",
    "polished_cinnabar_stairs",
    "polished_cinnabar_wall",
    "polished_deepslate",
    "polished_deepslate_slab",
    "polished_deepslate_stairs",
    "polished_deepslate_wall",
    "polished_diorite",
    "polished_diorite_slab",
    "polished_diorite_stairs",
    "polished_granite",
    "polished_granite_slab",
    "polished_granite_stairs",
    "polished_sulfur",
    "polished_sulfur_slab",
    "polished_sulfur_stairs",
    "polished_sulfur_wall",
    "polished_tuff",
    "polished_tuff_slab",
    "polished_tuff_stairs",
    "polished_tuff_wall",
    "poplar_button",
    "poplar_door",
    "poplar_fence",
    "poplar_fence_gate",
    "poplar_hanging_sign",
    "poplar_log",
    "poplar_planks",
    "poplar_pressure_plate",
    "poplar_sapling",
    "poplar_shelf",
    "poplar_sign",
    "poplar_slab",
    "poplar_stairs",
    "poplar_trapdoor",
    "poplar_wall_hanging_sign",
    "poplar_wall_sign",
    "poplar_wood",
    "poppy",
    "potatoes",
    "potent_sulfur",
    "potted_acacia_sapling",
    "potted_allium",
    "potted_azalea_bush",
    "potted_azure_bluet",
    "potted_bamboo",
    "potted_birch_sapling",
    "potted_blue_orchid",
    "potted_brown_mushroom",
    "potted_cactus",
    "potted_cherry_sapling",
    "potted_closed_eyeblossom",
    "potted_cornflower",
    "potted_crimson_fungus",
    "potted_crimson_roots",
    "potted_dandelion",
    "potted_dark_oak_sapling",
    "potted_dead_bush",
    "potted_fern",
    "potted_flowering_azalea_bush",
    "potted_golden_dandelion",
    "potted_jungle_sapling",
    "potted_lily_of_the_valley",
    "potted_mangrove_propagule",
    "potted_oak_sapling",
    "potted_open_eyeblossom",
    "potted_orange_tulip",
    "potted_oxeye_daisy",
    "potted_pale_oak_sapling",
    "potted_pink_tulip",
    "potted_poplar_sapling",
    "potted_poppy",
    "potted_red_mushroom",
    "potted_red_tulip",
    "potted_spruce_sapling",
    "potted_torchflower",
    "potted_warped_fungus",
    "potted_warped_roots",
    "potted_white_tulip",
    "potted_wither_rose",
    "powder_snow",
    "powder_snow_cauldron",
    "powered_rail",
    "prismarine",
    "prismarine_brick_slab",
    "prismarine_brick_stairs",
    "prismarine_bricks",
    "prismarine_slab",
    "prismarine_stairs",
    "prismarine_wall",
    "pumpkin",
    "pumpkin_stem",
    "purple_banner",
    "purple_bed",
    "purple_candle",
    "purple_candle_cake",
    "purple_carpet",
    "purple_concrete",
    "purple_concrete_powder",
    "purple_concrete_slab",
    "purple_concrete_stairs",
    "purple_glazed_terracotta",
    "purple_shulker_box",
    "purple_stained_glass",
    "purple_stained_glass_pane",
    "purple_terracotta",
    "purple_wall_banner",
    "purple_wool",
    "purple_wool_slab",
    "purple_wool_stairs",
    "purpur_block",
    "purpur_pillar",
    "purpur_slab",
    "purpur_stairs",
    "quartz_block",
    "quartz_bricks",
    "quartz_pillar",
    "quartz_slab",
    "quartz_stairs",
    "rail",
    "raw_copper_block",
    "raw_gold_block",
    "raw_iron_block",
    "red_banner",
    "red_bed",
    "red_candle",
    "red_candle_cake",
    "red_carpet",
    "red_concrete",
    "red_concrete_powder",
    "red_concrete_slab",
    "red_concrete_stairs",
    "red_glazed_terracotta",
    "red_mushroom",
    "red_mushroom_block",
    "red_nether_brick_slab",
    "red_nether_brick_stairs",
    "red_nether_brick_wall",
    "red_nether_bricks",
    "red_poplar_leaves",
    "red_sand",
    "red_sandstone",
    "red_sandstone_slab",
    "red_sandstone_stairs",
    "red_sandstone_wall",
    "red_shrub",
    "red_shulker_box",
    "red_stained_glass",
    "red_stained_glass_pane",
    "red_terracotta",
    "red_tulip",
    "red_wall_banner",
    "red_wool",
    "red_wool_slab",
    "red_wool_stairs",
    "redstone_block",
    "redstone_lamp",
    "redstone_ore",
    "redstone_torch",
    "redstone_wall_torch",
    "redstone_wire",
    "reinforced_deepslate",
    "repeater",
    "repeating_command_block",
    "resin_block",
    "resin_brick_slab",
    "resin_brick_stairs",
    "resin_brick_wall",
    "resin_bricks",
    "resin_clump",
    "respawn_anchor",
    "rooted_dirt",
    "rose_bush",
    "sand",
    "sandstone",
    "sandstone_slab",
    "sandstone_stairs",
    "sandstone_wall",
    "scaffolding",
    "sculk",
    "sculk_catalyst",
    "sculk_sensor",
    "sculk_shrieker",
    "sculk_vein",
    "sea_lantern",
    "sea_pickle",
    "seagrass",
    "shelf_mushroom",
    "short_dry_grass",
    "short_grass",
    "shroomlight",
    "shulker_box",
    "skeleton_skull",
    "skeleton_wall_skull",
    "slime_block",
    "small_amethyst_bud",
    "small_dripleaf",
    "smithing_table",
    "smoker",
    "smooth_basalt",
    "smooth_quartz",
    "smooth_quartz_slab",
    "smooth_quartz_stairs",
    "smooth_red_sandstone",
    "smooth_red_sandstone_slab",
    "smooth_red_sandstone_stairs",
    "smooth_sandstone",
    "smooth_sandstone_slab",
    "smooth_sandstone_stairs",
    "smooth_stone",
    "smooth_stone_slab",
    "sniffer_egg",
    "snow",
    "snow_block",
    "soul_campfire",
    "soul_fire",
    "soul_lantern",
    "soul_sand",
    "soul_soil",
    "soul_torch",
    "soul_wall_torch",
    "spawner",
    "sponge",
    "spore_blossom",
    "spruce_button",
    "spruce_door",
    "spruce_fence",
    "spruce_fence_gate",
    "spruce_hanging_sign",
    "spruce_leaves",
    "spruce_log",
    "spruce_planks",
    "spruce_pressure_plate",
    "spruce_sapling",
    "spruce_shelf",
    "spruce_sign",
    "spruce_slab",
    "spruce_stairs",
    "spruce_trapdoor",
    "spruce_wall_hanging_sign",
    "spruce_wall_sign",
    "spruce_wood",
    "sticky_piston",
    "stone",
    "stone_brick_slab",
    "stone_brick_stairs",
    "stone_brick_wall",
    "stone_bricks",
    "stone_button",
    "stone_pressure_plate",
    "stone_slab",
    "stone_stairs",
    "stonecutter",
    "straw_bed",
    "stripped_acacia_log",
    "stripped_acacia_wood",
    "stripped_bamboo_block",
    "stripped_birch_log",
    "stripped_birch_wood",
    "stripped_cherry_log",
    "stripped_cherry_wood",
    "stripped_crimson_hyphae",
    "stripped_crimson_stem",
    "stripped_dark_oak_log",
    "stripped_dark_oak_wood",
    "stripped_jungle_log",
    "stripped_jungle_wood",
    "stripped_mangrove_log",
    "stripped_mangrove_wood",
    "stripped_oak_log",
    "stripped_oak_wood",
    "stripped_pale_oak_log",
    "stripped_pale_oak_wood",
    "stripped_poplar_log",
    "stripped_poplar_wood",
    "stripped_spruce_log",
    "stripped_spruce_wood",
    "stripped_warped_hyphae",
    "stripped_warped_stem",
    "structure_block",
    "structure_void",
    "sugar_cane",
    "sulfur",
    "sulfur_brick_slab",
    "sulfur_brick_stairs",
    "sulfur_brick_wall",
    "sulfur_bricks",
    "sulfur_slab",
    "sulfur_spike",
    "sulfur_stairs",
    "sulfur_wall",
    "sunflower",
    "suspicious_gravel",
    "suspicious_sand",
    "sweet_berry_bush",
    "tall_dry_grass",
    "tall_grass",
    "tall_seagrass",
    "target",
    "terracotta",
    "test_block",
    "test_instance_block",
    "tinted_glass",
    "tnt",
    "torch",
    "torchflower",
    "torchflower_crop",
    "trapped_chest",
    "trial_spawner",
    "tripwire",
    "tripwire_hook",
    "tube_coral",
    "tube_coral_block",
    "tube_coral_fan",
    "tube_coral_wall_fan",
    "tuff",
    "tuff_brick_slab",
    "tuff_brick_stairs",
    "tuff_brick_wall",
    "tuff_bricks",
    "tuff_slab",
    "tuff_stairs",
    "tuff_wall",
    "turtle_egg",
    "twisting_vines",
    "twisting_vines_plant",
    "vault",
    "verdant_froglight",
    "vine",
    "void_air",
    "wall_torch",
    "warped_button",
    "warped_door",
    "warped_fence",
    "warped_fence_gate",
    "warped_fungus",
    "warped_hanging_sign",
    "warped_hyphae",
    "warped_nylium",
    "warped_planks",
    "warped_pressure_plate",
    "warped_roots",
    "warped_shelf",
    "warped_sign",
    "warped_slab",
    "warped_stairs",
    "warped_stem",
    "warped_trapdoor",
    "warped_wall_hanging_sign",
    "warped_wall_sign",
    "warped_wart_block",
    "water",
    "water_cauldron",
    "waxed_chiseled_copper",
    "waxed_copper_bars",
    "waxed_copper_block",
    "waxed_copper_bulb",
    "waxed_copper_chain",
    "waxed_copper_chest",
    "waxed_copper_door",
    "waxed_copper_golem_statue",
    "waxed_copper_grate",
    "waxed_copper_lantern",
    "waxed_copper_trapdoor",
    "waxed_cut_copper",
    "waxed_cut_copper_slab",
    "waxed_cut_copper_stairs",
    "waxed_exposed_chiseled_copper",
    "waxed_exposed_copper",
    "waxed_exposed_copper_bars",
    "waxed_exposed_copper_bulb",
    "waxed_exposed_copper_chain",
    "waxed_exposed_copper_chest",
    "waxed_exposed_copper_door",
    "waxed_exposed_copper_golem_statue",
    "waxed_exposed_copper_grate",
    "waxed_exposed_copper_lantern",
    "waxed_exposed_copper_trapdoor",
    "waxed_exposed_cut_copper",
    "waxed_exposed_cut_copper_slab",
    "waxed_exposed_cut_copper_stairs",
    "waxed_exposed_lightning_rod",
    "waxed_lightning_rod",
    "waxed_oxidized_chiseled_copper",
    "waxed_oxidized_copper",
    "waxed_oxidized_copper_bars",
    "waxed_oxidized_copper_bulb",
    "waxed_oxidized_copper_chain",
    "waxed_oxidized_copper_chest",
    "waxed_oxidized_copper_door",
    "waxed_oxidized_copper_golem_statue",
    "waxed_oxidized_copper_grate",
    "waxed_oxidized_copper_lantern",
    "waxed_oxidized_copper_trapdoor",
    "waxed_oxidized_cut_copper",
    "waxed_oxidized_cut_copper_slab",
    "waxed_oxidized_cut_copper_stairs",
    "waxed_oxidized_lightning_rod",
    "waxed_weathered_chiseled_copper",
    "waxed_weathered_copper",
    "waxed_weathered_copper_bars",
    "waxed_weathered_copper_bulb",
    "waxed_weathered_copper_chain",
    "waxed_weathered_copper_chest",
    "waxed_weathered_copper_door",
    "waxed_weathered_copper_golem_statue",
    "waxed_weathered_copper_grate",
    "waxed_weathered_copper_lantern",
    "waxed_weathered_copper_trapdoor",
    "waxed_weathered_cut_copper",
    "waxed_weathered_cut_copper_slab",
    "waxed_weathered_cut_copper_stairs",
    "waxed_weathered_lightning_rod",
    "weathered_chiseled_copper",
    "weathered_copper",
    "weathered_copper_bars",
    "weathered_copper_bulb",
    "weathered_copper_chain",
    "weathered_copper_chest",
    "weathered_copper_door",
    "weathered_copper_golem_statue",
    "weathered_copper_grate",
    "weathered_copper_lantern",
    "weathered_copper_trapdoor",
    "weathered_cut_copper",
    "weathered_cut_copper_slab",
    "weathered_cut_copper_stairs",
    "weathered_lightning_rod",
    "weeping_vines",
    "weeping_vines_plant",
    "wet_sponge",
    "wheat",
    "white_banner",
    "white_bed",
    "white_candle",
    "white_candle_cake",
    "white_carpet",
    "white_concrete",
    "white_concrete_powder",
    "white_concrete_slab",
    "white_concrete_stairs",
    "white_glazed_terracotta",
    "white_shulker_box",
    "white_stained_glass",
    "white_stained_glass_pane",
    "white_terracotta",
    "white_tulip",
    "white_wall_banner",
    "white_wool",
    "white_wool_slab",
    "white_wool_stairs",
    "wildflowers",
    "wither_rose",
    "wither_skeleton_skull",
    "wither_skeleton_wall_skull",
    "yellow_banner",
    "yellow_bed",
    "yellow_candle",
    "yellow_candle_cake",
    "yellow_carpet",
    "yellow_concrete",
    "yellow_concrete_powder",
    "yellow_concrete_slab",
    "yellow_concrete_stairs",
    "yellow_glazed_terracotta",
    "yellow_poplar_leaves",
    "yellow_shulker_box",
    "yellow_stained_glass",
    "yellow_stained_glass_pane",
    "yellow_terracotta",
    "yellow_wall_banner",
    "yellow_wool",
    "yellow_wool_slab",
    "yellow_wool_stairs",
    "zombie_head",
    "zombie_wall_head"
  ]);
});

// src/arguments/generated/_registry/block_entity_types.ts
var BLOCK_ENTITY_TYPES_SET;
var init_block_entity_types = __esm(() => {
  init_sandstone();
  BLOCK_ENTITY_TYPES_SET = new Set2([
    "banner",
    "barrel",
    "beacon",
    "beehive",
    "bell",
    "blast_furnace",
    "brewing_stand",
    "brushable_block",
    "calibrated_sculk_sensor",
    "campfire",
    "chest",
    "chiseled_bookshelf",
    "command_block",
    "comparator",
    "conduit",
    "copper_golem_statue",
    "crafter",
    "creaking_heart",
    "daylight_detector",
    "decorated_pot",
    "dispenser",
    "dropper",
    "enchanting_table",
    "end_gateway",
    "end_portal",
    "ender_chest",
    "furnace",
    "hanging_sign",
    "hopper",
    "jigsaw",
    "jukebox",
    "lectern",
    "mob_spawner",
    "piston",
    "potent_sulfur",
    "sculk_catalyst",
    "sculk_sensor",
    "sculk_shrieker",
    "shelf",
    "shulker_box",
    "sign",
    "skull",
    "smoker",
    "structure_block",
    "test_block",
    "test_instance_block",
    "trapped_chest",
    "trial_spawner",
    "vault"
  ]);
});

// src/arguments/generated/_registry/block_predicate_types.ts
var BLOCK_PREDICATE_TYPES_SET;
var init_block_predicate_types = __esm(() => {
  init_sandstone();
  BLOCK_PREDICATE_TYPES_SET = new Set2([
    "all_of",
    "any_of",
    "has_sturdy_face",
    "height_range",
    "inside_world_bounds",
    "matching_biomes",
    "matching_block_tag",
    "matching_blocks",
    "matching_fluids",
    "not",
    "replaceable",
    "solid",
    "true",
    "unobstructed",
    "would_survive"
  ]);
});

// src/arguments/generated/_registry/chunk_statuses.ts
var CHUNK_STATUSES_SET;
var init_chunk_statuses = __esm(() => {
  init_sandstone();
  CHUNK_STATUSES_SET = new Set2([
    "biomes",
    "carvers",
    "empty",
    "features",
    "full",
    "initialize_light",
    "light",
    "noise",
    "spawn",
    "structure_references",
    "structure_starts",
    "surface"
  ]);
});

// src/arguments/generated/_registry/command_argument_types.ts
var COMMAND_ARGUMENT_TYPES_SET;
var init_command_argument_types = __esm(() => {
  init_sandstone();
  COMMAND_ARGUMENT_TYPES_SET = new Set2([
    "angle",
    "block_pos",
    "block_predicate",
    "block_state",
    "brigadier",
    "brigadier",
    "brigadier",
    "brigadier",
    "brigadier",
    "brigadier",
    "column_pos",
    "component",
    "dialog",
    "dimension",
    "entity",
    "entity_anchor",
    "feature",
    "float_range",
    "function",
    "game_profile",
    "gamemode",
    "heightmap",
    "hex_color",
    "int_range",
    "item_predicate",
    "item_slot",
    "item_slots",
    "item_stack",
    "loot_modifier",
    "loot_predicate",
    "loot_table",
    "message",
    "nbt_compound_tag",
    "nbt_path",
    "nbt_tag",
    "objective",
    "objective_criteria",
    "operation",
    "particle",
    "resource",
    "resource_key",
    "resource_location",
    "resource_or_tag",
    "resource_or_tag_key",
    "resource_selector",
    "rotation",
    "score_holder",
    "scoreboard_slot",
    "slot_source",
    "style",
    "swing_animation",
    "swizzle",
    "team",
    "team_color",
    "template_mirror",
    "template_rotation",
    "time",
    "uuid",
    "vec2",
    "vec3"
  ]);
});

// src/arguments/generated/_registry/consume_effect_types.ts
var CONSUME_EFFECT_TYPES_SET;
var init_consume_effect_types = __esm(() => {
  init_sandstone();
  CONSUME_EFFECT_TYPES_SET = new Set2([
    "apply_effects",
    "clear_all_effects",
    "play_sound",
    "remove_effects",
    "teleport_randomly"
  ]);
});

// src/arguments/generated/_registry/creative_mode_tabs.ts
var CREATIVE_MODE_TABS_SET;
var init_creative_mode_tabs = __esm(() => {
  init_sandstone();
  CREATIVE_MODE_TABS_SET = new Set2([
    "building_blocks",
    "colored_blocks",
    "combat",
    "food_and_drinks",
    "functional_blocks",
    "hotbar",
    "ingredients",
    "inventory",
    "natural_blocks",
    "op_blocks",
    "redstone_blocks",
    "search",
    "spawn_eggs",
    "tools_and_utilities"
  ]);
});

// src/arguments/generated/_registry/custom_stats.ts
var CUSTOM_STATS_SET;
var init_custom_stats = __esm(() => {
  init_sandstone();
  CUSTOM_STATS_SET = new Set2([
    "animals_bred",
    "aviate_one_cm",
    "bell_ring",
    "boat_one_cm",
    "clean_armor",
    "clean_banner",
    "clean_shulker_box",
    "climb_one_cm",
    "crouch_one_cm",
    "damage_absorbed",
    "damage_blocked_by_shield",
    "damage_dealt",
    "damage_dealt_absorbed",
    "damage_dealt_resisted",
    "damage_resisted",
    "damage_taken",
    "deaths",
    "drop",
    "eat_cake_slice",
    "enchant_item",
    "fall_one_cm",
    "fill_cauldron",
    "fish_caught",
    "fly_one_cm",
    "happy_ghast_one_cm",
    "horse_one_cm",
    "inspect_dispenser",
    "inspect_dropper",
    "inspect_hopper",
    "interact_with_anvil",
    "interact_with_beacon",
    "interact_with_blast_furnace",
    "interact_with_brewingstand",
    "interact_with_campfire",
    "interact_with_cartography_table",
    "interact_with_crafting_table",
    "interact_with_furnace",
    "interact_with_grindstone",
    "interact_with_lectern",
    "interact_with_loom",
    "interact_with_smithing_table",
    "interact_with_smoker",
    "interact_with_stonecutter",
    "jump",
    "leave_game",
    "minecart_one_cm",
    "mob_kills",
    "nautilus_one_cm",
    "open_barrel",
    "open_chest",
    "open_enderchest",
    "open_shulker_box",
    "pig_one_cm",
    "play_noteblock",
    "play_record",
    "play_time",
    "player_kills",
    "pot_flower",
    "raid_trigger",
    "raid_win",
    "sleep_in_bed",
    "sleep_in_straw_bed",
    "sneak_time",
    "sprint_one_cm",
    "strider_one_cm",
    "swim_one_cm",
    "talked_to_villager",
    "target_hit",
    "time_since_death",
    "time_since_rest",
    "total_world_time",
    "traded_with_villager",
    "trigger_trapped_chest",
    "tune_noteblock",
    "use_cauldron",
    "walk_on_water_one_cm",
    "walk_one_cm",
    "walk_under_water_one_cm"
  ]);
});

// src/arguments/generated/_registry/data_component_predicate_types.ts
var DATA_COMPONENT_PREDICATE_TYPES_SET;
var init_data_component_predicate_types = __esm(() => {
  init_sandstone();
  DATA_COMPONENT_PREDICATE_TYPES_SET = new Set2([
    "attribute_modifiers",
    "bundle_contents",
    "container",
    "custom_data",
    "damage",
    "enchantments",
    "firework_explosion",
    "fireworks",
    "jukebox_playable",
    "potion_contents",
    "stored_enchantments",
    "trim",
    "villager/variant",
    "writable_book_content",
    "written_book_content"
  ]);
});

// src/arguments/generated/_registry/data_component_types.ts
var DATA_COMPONENT_TYPES_SET;
var init_data_component_types = __esm(() => {
  init_sandstone();
  DATA_COMPONENT_TYPES_SET = new Set2([
    "additional_trade_cost",
    "attack_animation",
    "attack_range",
    "attribute_modifiers",
    "axolotl/variant",
    "banner_patterns",
    "base_color",
    "bees",
    "block_entity_data",
    "block_state",
    "block_transformer",
    "blocks_attacks",
    "break_sound",
    "brewing_fuel",
    "bucket_entity_data",
    "bundle_contents",
    "can_break",
    "can_place_on",
    "cat/collar",
    "cat/sound_variant",
    "cat/variant",
    "charged_projectiles",
    "chicken/sound_variant",
    "chicken/variant",
    "compostable",
    "consumable",
    "container",
    "container_loot",
    "cooking_fuel",
    "cow/sound_variant",
    "cow/variant",
    "creative_slot_lock",
    "cushion/color",
    "custom_data",
    "custom_model_data",
    "custom_name",
    "damage",
    "damage_resistant",
    "damage_type",
    "death_protection",
    "debug_stick_state",
    "dye",
    "dyed_color",
    "enchantable",
    "enchantment_glint_override",
    "enchantments",
    "entity_data",
    "equippable",
    "firework_explosion",
    "fireworks",
    "food",
    "fox/variant",
    "frog/variant",
    "glider",
    "horse/variant",
    "instrument",
    "intangible_projectile",
    "interact_animation",
    "item_model",
    "item_name",
    "jukebox_playable",
    "kinetic_weapon",
    "llama/variant",
    "lock",
    "lodestone_tracker",
    "lore",
    "map_decorations",
    "map_id",
    "map_post_processing",
    "max_damage",
    "max_stack_size",
    "minimum_attack_charge",
    "mob_visibility",
    "mooshroom/variant",
    "note_block_sound",
    "ominous_bottle_amplifier",
    "painting/variant",
    "parrot/variant",
    "piercing_weapon",
    "pig/sound_variant",
    "pig/variant",
    "pot_decorations",
    "potion_contents",
    "potion_duration_scale",
    "profile",
    "provides_banner_patterns",
    "provides_pottery_pattern",
    "provides_trim_material",
    "rabbit/variant",
    "rarity",
    "recipes",
    "repair_cost",
    "repairable",
    "salmon/size",
    "sheep/color",
    "shulker/color",
    "sign_text_back",
    "sign_text_front",
    "stored_enchantments",
    "sulfur_cube_content",
    "suspicious_stew_effects",
    "tool",
    "tooltip_display",
    "tooltip_style",
    "trim",
    "tropical_fish/base_color",
    "tropical_fish/pattern",
    "tropical_fish/pattern_color",
    "unbreakable",
    "use_cooldown",
    "use_effects",
    "use_remainder",
    "villager/variant",
    "villager_food",
    "waxed",
    "weapon",
    "wolf/collar",
    "wolf/sound_variant",
    "wolf/variant",
    "writable_book_content",
    "written_book_content",
    "zombie_nautilus/variant"
  ]);
});

// src/arguments/generated/_registry/debug_subscriptions.ts
var DEBUG_SUBSCRIPTIONS_SET;
var init_debug_subscriptions = __esm(() => {
  init_sandstone();
  DEBUG_SUBSCRIPTIONS_SET = new Set2([
    "bee_hives",
    "bees",
    "brains",
    "breezes",
    "dedicated_server_tick_time",
    "entity_block_intersections",
    "entity_paths",
    "game_event_listeners",
    "game_events",
    "goal_selectors",
    "neighbor_updates",
    "pois",
    "raids",
    "redstone_wire_orientations",
    "structures",
    "village_sections"
  ]);
});

// src/arguments/generated/_registry/dialog_action_types.ts
var DIALOG_ACTION_TYPES_SET;
var init_dialog_action_types = __esm(() => {
  init_sandstone();
  DIALOG_ACTION_TYPES_SET = new Set2([
    "change_page",
    "copy_to_clipboard",
    "custom",
    "dynamic/custom",
    "dynamic/run_command",
    "open_url",
    "run_command",
    "show_dialog",
    "suggest_command"
  ]);
});

// src/arguments/generated/_registry/dialog_body_types.ts
var DIALOG_BODY_TYPES_SET;
var init_dialog_body_types = __esm(() => {
  init_sandstone();
  DIALOG_BODY_TYPES_SET = new Set2([
    "item",
    "plain_message"
  ]);
});

// src/arguments/generated/_registry/dialog_types.ts
var DIALOG_TYPES_SET;
var init_dialog_types = __esm(() => {
  init_sandstone();
  DIALOG_TYPES_SET = new Set2([
    "confirmation",
    "dialog_list",
    "multi_action",
    "notice",
    "server_links"
  ]);
});

// src/arguments/generated/_registry/enchantment_effect_component_types.ts
var ENCHANTMENT_EFFECT_COMPONENT_TYPES_SET;
var init_enchantment_effect_component_types = __esm(() => {
  init_sandstone();
  ENCHANTMENT_EFFECT_COMPONENT_TYPES_SET = new Set2([
    "ammo_use",
    "armor_effectiveness",
    "attributes",
    "block_experience",
    "crossbow_charge_time",
    "crossbow_charging_sounds",
    "damage",
    "damage_immunity",
    "damage_protection",
    "equipment_drops",
    "fishing_luck_bonus",
    "fishing_time_reduction",
    "hit_block",
    "item_damage",
    "knockback",
    "location_changed",
    "mob_experience",
    "post_attack",
    "post_piercing_attack",
    "prevent_armor_change",
    "prevent_equipment_drop",
    "projectile_count",
    "projectile_piercing",
    "projectile_spawned",
    "projectile_spread",
    "repair_with_xp",
    "smash_damage_per_fallen_block",
    "tick",
    "trident_return_acceleration",
    "trident_sound",
    "trident_spin_attack_strength"
  ]);
});

// src/arguments/generated/_registry/enchantment_entity_effect_types.ts
var ENCHANTMENT_ENTITY_EFFECT_TYPES_SET;
var init_enchantment_entity_effect_types = __esm(() => {
  init_sandstone();
  ENCHANTMENT_ENTITY_EFFECT_TYPES_SET = new Set2([
    "all_of",
    "apply_exhaustion",
    "apply_impulse",
    "apply_mob_effect",
    "change_item_damage",
    "damage_entity",
    "explode",
    "ignite",
    "play_sound",
    "replace_block",
    "replace_disk",
    "run_function",
    "set_block_properties",
    "spawn_particles",
    "summon_entity"
  ]);
});

// src/arguments/generated/_registry/enchantment_level_based_value_types.ts
var ENCHANTMENT_LEVEL_BASED_VALUE_TYPES_SET;
var init_enchantment_level_based_value_types = __esm(() => {
  init_sandstone();
  ENCHANTMENT_LEVEL_BASED_VALUE_TYPES_SET = new Set2([
    "clamped",
    "exponent",
    "fraction",
    "levels_squared",
    "linear",
    "lookup"
  ]);
});

// src/arguments/generated/_registry/enchantment_location_based_effect_types.ts
var ENCHANTMENT_LOCATION_BASED_EFFECT_TYPES_SET;
var init_enchantment_location_based_effect_types = __esm(() => {
  init_sandstone();
  ENCHANTMENT_LOCATION_BASED_EFFECT_TYPES_SET = new Set2([
    "all_of",
    "apply_exhaustion",
    "apply_impulse",
    "apply_mob_effect",
    "attribute",
    "change_item_damage",
    "damage_entity",
    "explode",
    "ignite",
    "play_sound",
    "replace_block",
    "replace_disk",
    "run_function",
    "set_block_properties",
    "spawn_particles",
    "summon_entity"
  ]);
});

// src/arguments/generated/_registry/enchantment_provider_types.ts
var ENCHANTMENT_PROVIDER_TYPES_SET;
var init_enchantment_provider_types = __esm(() => {
  init_sandstone();
  ENCHANTMENT_PROVIDER_TYPES_SET = new Set2([
    "by_cost",
    "by_cost_with_difficulty",
    "single"
  ]);
});

// src/arguments/generated/_registry/enchantment_value_effect_types.ts
var ENCHANTMENT_VALUE_EFFECT_TYPES_SET;
var init_enchantment_value_effect_types = __esm(() => {
  init_sandstone();
  ENCHANTMENT_VALUE_EFFECT_TYPES_SET = new Set2([
    "add",
    "all_of",
    "exponential",
    "multiply",
    "remove_binomial",
    "set"
  ]);
});

// src/arguments/generated/_registry/entity_sub_predicate_types.ts
var ENTITY_SUB_PREDICATE_TYPES_SET;
var init_entity_sub_predicate_types = __esm(() => {
  init_sandstone();
  ENTITY_SUB_PREDICATE_TYPES_SET = new Set2([
    "components",
    "distance",
    "effects",
    "entity_tags",
    "entity_type",
    "equipment",
    "flags",
    "location",
    "movement",
    "movement_affected_by",
    "nbt",
    "passenger",
    "periodic_tick",
    "predicates",
    "slots",
    "stepping_on",
    "targeted_entity",
    "team",
    "type_specific/cube_mob",
    "type_specific/fishing_hook",
    "type_specific/lightning",
    "type_specific/player",
    "type_specific/raider",
    "type_specific/sheep",
    "vehicle"
  ]);
});

// src/arguments/generated/_registry/entity_types.ts
var ENTITY_TYPES_SET;
var init_entity_types = __esm(() => {
  init_sandstone();
  ENTITY_TYPES_SET = new Set2([
    "acacia_boat",
    "acacia_chest_boat",
    "allay",
    "area_effect_cloud",
    "armadillo",
    "armor_stand",
    "arrow",
    "axolotl",
    "bamboo_chest_raft",
    "bamboo_raft",
    "bat",
    "bee",
    "birch_boat",
    "birch_chest_boat",
    "blaze",
    "block_display",
    "bogged",
    "breeze",
    "breeze_wind_charge",
    "camel",
    "camel_husk",
    "cat",
    "cave_spider",
    "cherry_boat",
    "cherry_chest_boat",
    "chest_minecart",
    "chicken",
    "cod",
    "command_block_minecart",
    "copper_golem",
    "cow",
    "creaking",
    "creeper",
    "cushion",
    "dark_oak_boat",
    "dark_oak_chest_boat",
    "dolphin",
    "donkey",
    "dragon_fireball",
    "drowned",
    "egg",
    "elder_guardian",
    "end_crystal",
    "ender_dragon",
    "ender_pearl",
    "enderman",
    "endermite",
    "evoker",
    "evoker_fangs",
    "experience_bottle",
    "experience_orb",
    "eye_of_ender",
    "falling_block",
    "fireball",
    "firework_rocket",
    "fishing_bobber",
    "fox",
    "frog",
    "furnace_minecart",
    "ghast",
    "giant",
    "glow_item_frame",
    "glow_squid",
    "goat",
    "guardian",
    "happy_ghast",
    "hoglin",
    "hopper_minecart",
    "horse",
    "husk",
    "illusioner",
    "interaction",
    "iron_golem",
    "item",
    "item_display",
    "item_frame",
    "jungle_boat",
    "jungle_chest_boat",
    "leash_knot",
    "lightning_bolt",
    "lingering_potion",
    "llama",
    "llama_spit",
    "magma_cube",
    "mangrove_boat",
    "mangrove_chest_boat",
    "mannequin",
    "marker",
    "minecart",
    "mooshroom",
    "mule",
    "nautilus",
    "oak_boat",
    "oak_chest_boat",
    "ocelot",
    "ominous_item_spawner",
    "painting",
    "pale_oak_boat",
    "pale_oak_chest_boat",
    "panda",
    "parched",
    "parrot",
    "phantom",
    "pig",
    "piglin",
    "piglin_brute",
    "pillager",
    "player",
    "polar_bear",
    "poplar_boat",
    "poplar_chest_boat",
    "pufferfish",
    "rabbit",
    "ravager",
    "salmon",
    "sheep",
    "shulker",
    "shulker_bullet",
    "silverfish",
    "skeleton",
    "skeleton_horse",
    "slime",
    "small_fireball",
    "sniffer",
    "snow_golem",
    "snowball",
    "spawner_minecart",
    "spectral_arrow",
    "spider",
    "splash_potion",
    "spruce_boat",
    "spruce_chest_boat",
    "squid",
    "stray",
    "strider",
    "sulfur_cube",
    "tadpole",
    "text_display",
    "tnt",
    "tnt_minecart",
    "trader_llama",
    "trident",
    "tropical_fish",
    "turtle",
    "vex",
    "villager",
    "vindicator",
    "wandering_trader",
    "warden",
    "wind_charge",
    "witch",
    "wither",
    "wither_skeleton",
    "wither_skull",
    "wolf",
    "zoglin",
    "zombie",
    "zombie_horse",
    "zombie_nautilus",
    "zombie_villager",
    "zombified_piglin"
  ]);
});

// src/arguments/generated/_registry/environment_attributes.ts
var ENVIRONMENT_ATTRIBUTES_SET;
var init_environment_attributes = __esm(() => {
  init_sandstone();
  ENVIRONMENT_ATTRIBUTES_SET = new Set2([
    "audio/ambient_sounds",
    "audio/background_music",
    "audio/firefly_bush_sounds",
    "audio/music_volume",
    "gameplay/baby_villager_activity",
    "gameplay/bed_rule",
    "gameplay/bees_stay_in_hive",
    "gameplay/can_pillager_patrol_spawn",
    "gameplay/can_start_raid",
    "gameplay/cat_waking_up_gift_chance",
    "gameplay/creaking_active",
    "gameplay/creature_world_gen_spawn_probability",
    "gameplay/eyeblossom_open",
    "gameplay/fast_lava",
    "gameplay/increased_fire_burnout",
    "gameplay/monsters_burn",
    "gameplay/natural_mob_spawns",
    "gameplay/nether_portal_spawns_piglin",
    "gameplay/piglins_zombify",
    "gameplay/respawn_anchor_works",
    "gameplay/sky_light_level",
    "gameplay/snow_golem_melts",
    "gameplay/straw_bed_rule",
    "gameplay/surface_slime_spawn_chance",
    "gameplay/turtle_egg_hatch_chance",
    "gameplay/villager_activity",
    "gameplay/water_evaporates",
    "visual/ambient_light_color",
    "visual/ambient_particles",
    "visual/block_light_tint",
    "visual/cloud_color",
    "visual/cloud_fog_end_distance",
    "visual/cloud_height",
    "visual/default_dripstone_particle",
    "visual/fog_color",
    "visual/fog_end_distance",
    "visual/fog_start_distance",
    "visual/moon_angle",
    "visual/moon_phase",
    "visual/night_vision_color",
    "visual/sky_color",
    "visual/sky_fog_end_distance",
    "visual/sky_light_color",
    "visual/sky_light_factor",
    "visual/star_angle",
    "visual/star_brightness",
    "visual/sun_angle",
    "visual/sunrise_sunset_color",
    "visual/water_fog_color",
    "visual/water_fog_end_distance",
    "visual/water_fog_start_distance"
  ]);
});

// src/arguments/generated/_registry/float_provider_types.ts
var FLOAT_PROVIDER_TYPES_SET;
var init_float_provider_types = __esm(() => {
  init_sandstone();
  FLOAT_PROVIDER_TYPES_SET = new Set2([
    "clamped_normal",
    "constant",
    "trapezoid",
    "uniform"
  ]);
});

// src/arguments/generated/_registry/fluids.ts
var FLUIDS_SET;
var init_fluids = __esm(() => {
  init_sandstone();
  FLUIDS_SET = new Set2([
    "empty",
    "flowing_lava",
    "flowing_water",
    "lava",
    "water"
  ]);
});

// src/arguments/generated/_registry/game_events.ts
var GAME_EVENTS_SET;
var init_game_events = __esm(() => {
  init_sandstone();
  GAME_EVENTS_SET = new Set2([
    "block_activate",
    "block_attach",
    "block_change",
    "block_close",
    "block_deactivate",
    "block_destroy",
    "block_detach",
    "block_open",
    "block_place",
    "bounce",
    "container_close",
    "container_open",
    "drink",
    "eat",
    "elytra_glide",
    "entity_action",
    "entity_damage",
    "entity_die",
    "entity_dismount",
    "entity_interact",
    "entity_mount",
    "entity_place",
    "equip",
    "explode",
    "flap",
    "fluid_pickup",
    "fluid_place",
    "hit_ground",
    "instrument_play",
    "item_interact_finish",
    "item_interact_start",
    "jukebox_play",
    "jukebox_stop_play",
    "lightning_strike",
    "note_block_play",
    "prime_fuse",
    "projectile_land",
    "projectile_shoot",
    "resonate_1",
    "resonate_10",
    "resonate_11",
    "resonate_12",
    "resonate_13",
    "resonate_14",
    "resonate_15",
    "resonate_2",
    "resonate_3",
    "resonate_4",
    "resonate_5",
    "resonate_6",
    "resonate_7",
    "resonate_8",
    "resonate_9",
    "sculk_sensor_tendrils_clicking",
    "shear",
    "shriek",
    "splash",
    "step",
    "swim",
    "teleport",
    "unequip"
  ]);
});

// src/arguments/generated/_registry/game_rules.ts
var GAME_RULES_SET;
var init_game_rules = __esm(() => {
  init_sandstone();
  GAME_RULES_SET = new Set2([
    "advance_time",
    "advance_weather",
    "allow_entering_nether_using_portals",
    "block_drops",
    "block_explosion_drop_decay",
    "command_block_output",
    "command_blocks_work",
    "drowning_damage",
    "elytra_movement_check",
    "ender_pearls_vanish_on_death",
    "entity_drops",
    "fall_damage",
    "fire_damage",
    "fire_spread_radius_around_player",
    "forgive_dead_players",
    "freeze_damage",
    "global_sound_events",
    "immediate_respawn",
    "keep_inventory",
    "lava_source_conversion",
    "limited_crafting",
    "locator_bar",
    "log_admin_commands",
    "max_block_modifications",
    "max_command_forks",
    "max_command_sequence_length",
    "max_entity_cramming",
    "max_minecart_speed",
    "max_snow_accumulation_height",
    "mob_drops",
    "mob_explosion_drop_decay",
    "mob_griefing",
    "natural_health_regeneration",
    "player_movement_check",
    "players_nether_portal_creative_delay",
    "players_nether_portal_default_delay",
    "players_sleeping_percentage",
    "projectiles_can_break_blocks",
    "pvp",
    "raids",
    "random_tick_speed",
    "reduced_debug_info",
    "respawn_radius",
    "send_command_feedback",
    "show_advancement_messages",
    "show_death_messages",
    "spawn_mobs",
    "spawn_monsters",
    "spawn_patrols",
    "spawn_phantoms",
    "spawn_wandering_traders",
    "spawn_wardens",
    "spawner_blocks_work",
    "spectators_generate_chunks",
    "spread_vines",
    "tnt_explodes",
    "tnt_explosion_drop_decay",
    "universal_anger",
    "water_source_conversion"
  ]);
});

// src/arguments/generated/_registry/height_provider_types.ts
var HEIGHT_PROVIDER_TYPES_SET;
var init_height_provider_types = __esm(() => {
  init_sandstone();
  HEIGHT_PROVIDER_TYPES_SET = new Set2([
    "biased_to_bottom",
    "constant",
    "trapezoid",
    "uniform",
    "very_biased_to_bottom",
    "weighted_list"
  ]);
});

// src/arguments/generated/_registry/incoming_rpc_methods.ts
var INCOMING_RPC_METHODS_SET;
var init_incoming_rpc_methods = __esm(() => {
  init_sandstone();
  INCOMING_RPC_METHODS_SET = new Set2([
    "allowlist",
    "allowlist/add",
    "allowlist/clear",
    "allowlist/remove",
    "allowlist/set",
    "bans",
    "bans/add",
    "bans/clear",
    "bans/remove",
    "bans/set",
    "gamerules",
    "gamerules/update",
    "ip_bans",
    "ip_bans/add",
    "ip_bans/clear",
    "ip_bans/remove",
    "ip_bans/set",
    "operators",
    "operators/add",
    "operators/clear",
    "operators/remove",
    "operators/set",
    "players",
    "players/kick",
    "rpc.discover",
    "server/save",
    "server/status",
    "server/stop",
    "server/system_message",
    "serversettings/accept_transfers",
    "serversettings/accept_transfers/set",
    "serversettings/allow_flight",
    "serversettings/allow_flight/set",
    "serversettings/autosave",
    "serversettings/autosave/set",
    "serversettings/difficulty",
    "serversettings/difficulty/set",
    "serversettings/enforce_allowlist",
    "serversettings/enforce_allowlist/set",
    "serversettings/entity_broadcast_range",
    "serversettings/entity_broadcast_range/set",
    "serversettings/force_game_mode",
    "serversettings/force_game_mode/set",
    "serversettings/game_mode",
    "serversettings/game_mode/set",
    "serversettings/hide_online_players",
    "serversettings/hide_online_players/set",
    "serversettings/max_players",
    "serversettings/max_players/set",
    "serversettings/motd",
    "serversettings/motd/set",
    "serversettings/operator_user_permission_level",
    "serversettings/operator_user_permission_level/set",
    "serversettings/pause_when_empty_seconds",
    "serversettings/pause_when_empty_seconds/set",
    "serversettings/player_idle_timeout",
    "serversettings/player_idle_timeout/set",
    "serversettings/simulation_distance",
    "serversettings/simulation_distance/set",
    "serversettings/spawn_protection_radius",
    "serversettings/spawn_protection_radius/set",
    "serversettings/status_heartbeat_interval",
    "serversettings/status_heartbeat_interval/set",
    "serversettings/status_replies",
    "serversettings/status_replies/set",
    "serversettings/use_allowlist",
    "serversettings/use_allowlist/set",
    "serversettings/view_distance",
    "serversettings/view_distance/set"
  ]);
});

// src/arguments/generated/_registry/input_control_types.ts
var INPUT_CONTROL_TYPES_SET;
var init_input_control_types = __esm(() => {
  init_sandstone();
  INPUT_CONTROL_TYPES_SET = new Set2([
    "boolean",
    "number_range",
    "single_option",
    "text"
  ]);
});

// src/arguments/generated/_registry/int_provider_types.ts
var INT_PROVIDER_TYPES_SET;
var init_int_provider_types = __esm(() => {
  init_sandstone();
  INT_PROVIDER_TYPES_SET = new Set2([
    "biased_to_bottom",
    "clamped",
    "clamped_normal",
    "constant",
    "trapezoid",
    "uniform",
    "very_biased_to_bottom",
    "weighted_list"
  ]);
});

// src/arguments/generated/_registry/items.ts
var ITEMS_SET;
var init_items2 = __esm(() => {
  init_sandstone();
  ITEMS_SET = new Set2([
    "abandoned_campsite_map",
    "acacia_boat",
    "acacia_button",
    "acacia_chest_boat",
    "acacia_door",
    "acacia_fence",
    "acacia_fence_gate",
    "acacia_hanging_sign",
    "acacia_leaves",
    "acacia_log",
    "acacia_planks",
    "acacia_pressure_plate",
    "acacia_sapling",
    "acacia_shelf",
    "acacia_sign",
    "acacia_slab",
    "acacia_stairs",
    "acacia_trapdoor",
    "acacia_wood",
    "activator_rail",
    "air",
    "allay_spawn_egg",
    "allium",
    "amethyst_block",
    "amethyst_cluster",
    "amethyst_shard",
    "ancient_city_map",
    "ancient_debris",
    "andesite",
    "andesite_slab",
    "andesite_stairs",
    "andesite_wall",
    "angler_pottery_sherd",
    "anvil",
    "apple",
    "archer_pottery_sherd",
    "armadillo_scute",
    "armadillo_spawn_egg",
    "armor_stand",
    "arms_up_pottery_sherd",
    "arrow",
    "axolotl_bucket",
    "axolotl_spawn_egg",
    "azalea",
    "azalea_leaves",
    "azure_bluet",
    "baked_potato",
    "bamboo",
    "bamboo_block",
    "bamboo_button",
    "bamboo_chest_raft",
    "bamboo_door",
    "bamboo_fence",
    "bamboo_fence_gate",
    "bamboo_hanging_sign",
    "bamboo_mosaic",
    "bamboo_mosaic_slab",
    "bamboo_mosaic_stairs",
    "bamboo_planks",
    "bamboo_pressure_plate",
    "bamboo_raft",
    "bamboo_shelf",
    "bamboo_sign",
    "bamboo_slab",
    "bamboo_stairs",
    "bamboo_trapdoor",
    "barrel",
    "barrier",
    "basalt",
    "bat_spawn_egg",
    "beacon",
    "bedrock",
    "bee_nest",
    "bee_spawn_egg",
    "beef",
    "beehive",
    "beetroot",
    "beetroot_seeds",
    "beetroot_soup",
    "bell",
    "big_dripleaf",
    "birch_boat",
    "birch_button",
    "birch_chest_boat",
    "birch_door",
    "birch_fence",
    "birch_fence_gate",
    "birch_hanging_sign",
    "birch_leaves",
    "birch_log",
    "birch_planks",
    "birch_pressure_plate",
    "birch_sapling",
    "birch_shelf",
    "birch_sign",
    "birch_slab",
    "birch_stairs",
    "birch_trapdoor",
    "birch_wood",
    "black_banner",
    "black_bed",
    "black_bundle",
    "black_candle",
    "black_carpet",
    "black_concrete",
    "black_concrete_powder",
    "black_concrete_slab",
    "black_concrete_stairs",
    "black_cushion",
    "black_dye",
    "black_glazed_terracotta",
    "black_harness",
    "black_shulker_box",
    "black_stained_glass",
    "black_stained_glass_pane",
    "black_terracotta",
    "black_wool",
    "black_wool_slab",
    "black_wool_stairs",
    "blackstone",
    "blackstone_slab",
    "blackstone_stairs",
    "blackstone_wall",
    "blade_pottery_sherd",
    "blast_furnace",
    "blaze_powder",
    "blaze_rod",
    "blaze_spawn_egg",
    "blue_banner",
    "blue_bed",
    "blue_bundle",
    "blue_candle",
    "blue_carpet",
    "blue_concrete",
    "blue_concrete_powder",
    "blue_concrete_slab",
    "blue_concrete_stairs",
    "blue_cushion",
    "blue_dye",
    "blue_egg",
    "blue_glazed_terracotta",
    "blue_harness",
    "blue_ice",
    "blue_orchid",
    "blue_shulker_box",
    "blue_stained_glass",
    "blue_stained_glass_pane",
    "blue_terracotta",
    "blue_wool",
    "blue_wool_slab",
    "blue_wool_stairs",
    "bogged_spawn_egg",
    "bolt_armor_trim_smithing_template",
    "bone",
    "bone_block",
    "bone_meal",
    "book",
    "bookshelf",
    "bordure_indented_banner_pattern",
    "bow",
    "bowl",
    "brain_coral",
    "brain_coral_block",
    "brain_coral_fan",
    "bread",
    "breeze_rod",
    "breeze_spawn_egg",
    "brewer_pottery_sherd",
    "brewing_stand",
    "brick",
    "brick_slab",
    "brick_stairs",
    "brick_wall",
    "bricks",
    "brown_banner",
    "brown_bed",
    "brown_bundle",
    "brown_candle",
    "brown_carpet",
    "brown_concrete",
    "brown_concrete_powder",
    "brown_concrete_slab",
    "brown_concrete_stairs",
    "brown_cushion",
    "brown_dye",
    "brown_egg",
    "brown_glazed_terracotta",
    "brown_harness",
    "brown_mushroom",
    "brown_mushroom_block",
    "brown_shulker_box",
    "brown_stained_glass",
    "brown_stained_glass_pane",
    "brown_terracotta",
    "brown_wool",
    "brown_wool_slab",
    "brown_wool_stairs",
    "brush",
    "bubble_coral",
    "bubble_coral_block",
    "bubble_coral_fan",
    "bucket",
    "budding_amethyst",
    "bundle",
    "buried_treasure_map",
    "burn_pottery_sherd",
    "bush",
    "cactus",
    "cactus_flower",
    "cake",
    "calcite",
    "calibrated_sculk_sensor",
    "camel_husk_spawn_egg",
    "camel_spawn_egg",
    "campfire",
    "candle",
    "carrot",
    "carrot_on_a_stick",
    "cartography_table",
    "carved_pumpkin",
    "cat_spawn_egg",
    "cauldron",
    "cave_spider_spawn_egg",
    "chain_command_block",
    "chainmail_boots",
    "chainmail_chestplate",
    "chainmail_helmet",
    "chainmail_leggings",
    "charcoal",
    "cherry_boat",
    "cherry_button",
    "cherry_chest_boat",
    "cherry_door",
    "cherry_fence",
    "cherry_fence_gate",
    "cherry_hanging_sign",
    "cherry_leaves",
    "cherry_log",
    "cherry_planks",
    "cherry_pressure_plate",
    "cherry_sapling",
    "cherry_shelf",
    "cherry_sign",
    "cherry_slab",
    "cherry_stairs",
    "cherry_trapdoor",
    "cherry_wood",
    "chest",
    "chest_minecart",
    "chicken",
    "chicken_spawn_egg",
    "chipped_anvil",
    "chiseled_bookshelf",
    "chiseled_cinnabar",
    "chiseled_copper",
    "chiseled_deepslate",
    "chiseled_nether_bricks",
    "chiseled_polished_blackstone",
    "chiseled_quartz_block",
    "chiseled_red_sandstone",
    "chiseled_resin_bricks",
    "chiseled_sandstone",
    "chiseled_stone_bricks",
    "chiseled_sulfur",
    "chiseled_tuff",
    "chiseled_tuff_bricks",
    "chorus_flower",
    "chorus_fruit",
    "chorus_plant",
    "cinnabar",
    "cinnabar_brick_slab",
    "cinnabar_brick_stairs",
    "cinnabar_brick_wall",
    "cinnabar_bricks",
    "cinnabar_slab",
    "cinnabar_stairs",
    "cinnabar_wall",
    "clay",
    "clay_ball",
    "clock",
    "closed_eyeblossom",
    "coal",
    "coal_block",
    "coal_ore",
    "coarse_dirt",
    "coast_armor_trim_smithing_template",
    "cobbled_deepslate",
    "cobbled_deepslate_slab",
    "cobbled_deepslate_stairs",
    "cobbled_deepslate_wall",
    "cobblestone",
    "cobblestone_slab",
    "cobblestone_stairs",
    "cobblestone_wall",
    "cobweb",
    "cocoa_beans",
    "cod",
    "cod_bucket",
    "cod_spawn_egg",
    "command_block",
    "command_block_minecart",
    "comparator",
    "compass",
    "composter",
    "conduit",
    "cooked_beef",
    "cooked_chicken",
    "cooked_cod",
    "cooked_mutton",
    "cooked_porkchop",
    "cooked_rabbit",
    "cooked_salmon",
    "cookie",
    "copper_axe",
    "copper_bars",
    "copper_block",
    "copper_boots",
    "copper_bulb",
    "copper_chain",
    "copper_chest",
    "copper_chestplate",
    "copper_door",
    "copper_golem_spawn_egg",
    "copper_golem_statue",
    "copper_grate",
    "copper_helmet",
    "copper_hoe",
    "copper_horse_armor",
    "copper_ingot",
    "copper_lantern",
    "copper_leggings",
    "copper_nautilus_armor",
    "copper_nugget",
    "copper_ore",
    "copper_pickaxe",
    "copper_shovel",
    "copper_spear",
    "copper_sword",
    "copper_torch",
    "copper_trapdoor",
    "cornflower",
    "cow_spawn_egg",
    "cracked_deepslate_bricks",
    "cracked_deepslate_tiles",
    "cracked_nether_bricks",
    "cracked_polished_blackstone_bricks",
    "cracked_stone_bricks",
    "crafter",
    "crafting_table",
    "creaking_heart",
    "creaking_spawn_egg",
    "creeper_banner_pattern",
    "creeper_head",
    "creeper_spawn_egg",
    "crimson_button",
    "crimson_door",
    "crimson_fence",
    "crimson_fence_gate",
    "crimson_fungus",
    "crimson_hanging_sign",
    "crimson_hyphae",
    "crimson_nylium",
    "crimson_planks",
    "crimson_pressure_plate",
    "crimson_roots",
    "crimson_shelf",
    "crimson_sign",
    "crimson_slab",
    "crimson_stairs",
    "crimson_stem",
    "crimson_trapdoor",
    "crossbow",
    "crying_obsidian",
    "cut_copper",
    "cut_copper_slab",
    "cut_copper_stairs",
    "cut_red_sandstone",
    "cut_red_sandstone_slab",
    "cut_sandstone",
    "cut_sandstone_slab",
    "cyan_banner",
    "cyan_bed",
    "cyan_bundle",
    "cyan_candle",
    "cyan_carpet",
    "cyan_concrete",
    "cyan_concrete_powder",
    "cyan_concrete_slab",
    "cyan_concrete_stairs",
    "cyan_cushion",
    "cyan_dye",
    "cyan_glazed_terracotta",
    "cyan_harness",
    "cyan_shulker_box",
    "cyan_stained_glass",
    "cyan_stained_glass_pane",
    "cyan_terracotta",
    "cyan_wool",
    "cyan_wool_slab",
    "cyan_wool_stairs",
    "damaged_anvil",
    "dandelion",
    "danger_pottery_sherd",
    "dark_oak_boat",
    "dark_oak_button",
    "dark_oak_chest_boat",
    "dark_oak_door",
    "dark_oak_fence",
    "dark_oak_fence_gate",
    "dark_oak_hanging_sign",
    "dark_oak_leaves",
    "dark_oak_log",
    "dark_oak_planks",
    "dark_oak_pressure_plate",
    "dark_oak_sapling",
    "dark_oak_shelf",
    "dark_oak_sign",
    "dark_oak_slab",
    "dark_oak_stairs",
    "dark_oak_trapdoor",
    "dark_oak_wood",
    "dark_prismarine",
    "dark_prismarine_slab",
    "dark_prismarine_stairs",
    "daylight_detector",
    "dead_brain_coral",
    "dead_brain_coral_block",
    "dead_brain_coral_fan",
    "dead_bubble_coral",
    "dead_bubble_coral_block",
    "dead_bubble_coral_fan",
    "dead_bush",
    "dead_fire_coral",
    "dead_fire_coral_block",
    "dead_fire_coral_fan",
    "dead_horn_coral",
    "dead_horn_coral_block",
    "dead_horn_coral_fan",
    "dead_tube_coral",
    "dead_tube_coral_block",
    "dead_tube_coral_fan",
    "debug_stick",
    "decorated_pot",
    "deepslate",
    "deepslate_brick_slab",
    "deepslate_brick_stairs",
    "deepslate_brick_wall",
    "deepslate_bricks",
    "deepslate_coal_ore",
    "deepslate_copper_ore",
    "deepslate_diamond_ore",
    "deepslate_emerald_ore",
    "deepslate_gold_ore",
    "deepslate_iron_ore",
    "deepslate_lapis_ore",
    "deepslate_redstone_ore",
    "deepslate_tile_slab",
    "deepslate_tile_stairs",
    "deepslate_tile_wall",
    "deepslate_tiles",
    "desert_pyramid_map",
    "desert_village_map",
    "detector_rail",
    "diamond",
    "diamond_axe",
    "diamond_block",
    "diamond_boots",
    "diamond_chestplate",
    "diamond_helmet",
    "diamond_hoe",
    "diamond_horse_armor",
    "diamond_leggings",
    "diamond_nautilus_armor",
    "diamond_ore",
    "diamond_pickaxe",
    "diamond_shovel",
    "diamond_spear",
    "diamond_sword",
    "diorite",
    "diorite_slab",
    "diorite_stairs",
    "diorite_wall",
    "dirt",
    "dirt_path",
    "disc_fragment_5",
    "dispenser",
    "dolphin_spawn_egg",
    "donkey_spawn_egg",
    "dragon_breath",
    "dragon_egg",
    "dragon_head",
    "dried_ghast",
    "dried_kelp",
    "dried_kelp_block",
    "dripstone_block",
    "dropper",
    "drowned_spawn_egg",
    "dune_armor_trim_smithing_template",
    "echo_shard",
    "egg",
    "elder_guardian_spawn_egg",
    "elytra",
    "emerald",
    "emerald_block",
    "emerald_ore",
    "enchanted_book",
    "enchanted_golden_apple",
    "enchanting_table",
    "end_crystal",
    "end_portal_frame",
    "end_rod",
    "end_stone",
    "end_stone_brick_slab",
    "end_stone_brick_stairs",
    "end_stone_brick_wall",
    "end_stone_bricks",
    "ender_chest",
    "ender_dragon_spawn_egg",
    "ender_eye",
    "ender_pearl",
    "enderman_spawn_egg",
    "endermite_spawn_egg",
    "evoker_spawn_egg",
    "experience_bottle",
    "explorer_pottery_sherd",
    "exposed_chiseled_copper",
    "exposed_copper",
    "exposed_copper_bars",
    "exposed_copper_bulb",
    "exposed_copper_chain",
    "exposed_copper_chest",
    "exposed_copper_door",
    "exposed_copper_golem_statue",
    "exposed_copper_grate",
    "exposed_copper_lantern",
    "exposed_copper_trapdoor",
    "exposed_cut_copper",
    "exposed_cut_copper_slab",
    "exposed_cut_copper_stairs",
    "exposed_lightning_rod",
    "eye_armor_trim_smithing_template",
    "farmland",
    "feather",
    "fermented_spider_eye",
    "fern",
    "field_masoned_banner_pattern",
    "filled_map",
    "fire_charge",
    "fire_coral",
    "fire_coral_block",
    "fire_coral_fan",
    "firefly_bush",
    "firework_rocket",
    "firework_star",
    "fishing_rod",
    "fletching_table",
    "flint",
    "flint_and_steel",
    "flow_armor_trim_smithing_template",
    "flow_banner_pattern",
    "flow_pottery_sherd",
    "flower_banner_pattern",
    "flower_pot",
    "flowering_azalea",
    "flowering_azalea_leaves",
    "fox_spawn_egg",
    "friend_pottery_sherd",
    "frog_spawn_egg",
    "frogspawn",
    "furnace",
    "furnace_minecart",
    "ghast_spawn_egg",
    "ghast_tear",
    "gilded_blackstone",
    "glass",
    "glass_bottle",
    "glass_pane",
    "glistering_melon_slice",
    "globe_banner_pattern",
    "glow_berries",
    "glow_ink_sac",
    "glow_item_frame",
    "glow_lichen",
    "glow_squid_spawn_egg",
    "glowstone",
    "glowstone_dust",
    "goat_horn",
    "goat_spawn_egg",
    "gold_block",
    "gold_ingot",
    "gold_nugget",
    "gold_ore",
    "golden_apple",
    "golden_axe",
    "golden_boots",
    "golden_carrot",
    "golden_chestplate",
    "golden_dandelion",
    "golden_helmet",
    "golden_hoe",
    "golden_horse_armor",
    "golden_leggings",
    "golden_nautilus_armor",
    "golden_pickaxe",
    "golden_shovel",
    "golden_spear",
    "golden_sword",
    "granite",
    "granite_slab",
    "granite_stairs",
    "granite_wall",
    "grass_block",
    "gravel",
    "gray_banner",
    "gray_bed",
    "gray_bundle",
    "gray_candle",
    "gray_carpet",
    "gray_concrete",
    "gray_concrete_powder",
    "gray_concrete_slab",
    "gray_concrete_stairs",
    "gray_cushion",
    "gray_dye",
    "gray_glazed_terracotta",
    "gray_harness",
    "gray_shulker_box",
    "gray_stained_glass",
    "gray_stained_glass_pane",
    "gray_terracotta",
    "gray_wool",
    "gray_wool_slab",
    "gray_wool_stairs",
    "green_banner",
    "green_bed",
    "green_bundle",
    "green_candle",
    "green_carpet",
    "green_concrete",
    "green_concrete_powder",
    "green_concrete_slab",
    "green_concrete_stairs",
    "green_cushion",
    "green_dye",
    "green_glazed_terracotta",
    "green_harness",
    "green_shulker_box",
    "green_stained_glass",
    "green_stained_glass_pane",
    "green_terracotta",
    "green_wool",
    "green_wool_slab",
    "green_wool_stairs",
    "grindstone",
    "guardian_spawn_egg",
    "gunpowder",
    "guster_banner_pattern",
    "guster_pottery_sherd",
    "hanging_roots",
    "happy_ghast_spawn_egg",
    "hay_block",
    "heart_of_the_sea",
    "heart_pottery_sherd",
    "heartbreak_pottery_sherd",
    "heavy_core",
    "heavy_weighted_pressure_plate",
    "hoglin_spawn_egg",
    "honey_block",
    "honey_bottle",
    "honeycomb",
    "honeycomb_block",
    "hopper",
    "hopper_minecart",
    "horn_coral",
    "horn_coral_block",
    "horn_coral_fan",
    "horse_spawn_egg",
    "host_armor_trim_smithing_template",
    "howl_pottery_sherd",
    "husk_spawn_egg",
    "ice",
    "infested_chiseled_stone_bricks",
    "infested_cobblestone",
    "infested_cracked_stone_bricks",
    "infested_deepslate",
    "infested_mossy_stone_bricks",
    "infested_stone",
    "infested_stone_bricks",
    "ink_sac",
    "iron_axe",
    "iron_bars",
    "iron_block",
    "iron_boots",
    "iron_chain",
    "iron_chestplate",
    "iron_door",
    "iron_golem_spawn_egg",
    "iron_helmet",
    "iron_hoe",
    "iron_horse_armor",
    "iron_ingot",
    "iron_leggings",
    "iron_nautilus_armor",
    "iron_nugget",
    "iron_ore",
    "iron_pickaxe",
    "iron_shovel",
    "iron_spear",
    "iron_sword",
    "iron_trapdoor",
    "item_frame",
    "jack_o_lantern",
    "jigsaw",
    "jukebox",
    "jungle_boat",
    "jungle_button",
    "jungle_chest_boat",
    "jungle_door",
    "jungle_explorer_map",
    "jungle_fence",
    "jungle_fence_gate",
    "jungle_hanging_sign",
    "jungle_leaves",
    "jungle_log",
    "jungle_planks",
    "jungle_pressure_plate",
    "jungle_sapling",
    "jungle_shelf",
    "jungle_sign",
    "jungle_slab",
    "jungle_stairs",
    "jungle_trapdoor",
    "jungle_wood",
    "kelp",
    "knowledge_book",
    "ladder",
    "lantern",
    "lapis_block",
    "lapis_lazuli",
    "lapis_ore",
    "large_amethyst_bud",
    "large_fern",
    "lava_bucket",
    "lead",
    "leaf_litter",
    "leather",
    "leather_boots",
    "leather_chestplate",
    "leather_helmet",
    "leather_horse_armor",
    "leather_leggings",
    "lectern",
    "lever",
    "light",
    "light_blue_banner",
    "light_blue_bed",
    "light_blue_bundle",
    "light_blue_candle",
    "light_blue_carpet",
    "light_blue_concrete",
    "light_blue_concrete_powder",
    "light_blue_concrete_slab",
    "light_blue_concrete_stairs",
    "light_blue_cushion",
    "light_blue_dye",
    "light_blue_glazed_terracotta",
    "light_blue_harness",
    "light_blue_shulker_box",
    "light_blue_stained_glass",
    "light_blue_stained_glass_pane",
    "light_blue_terracotta",
    "light_blue_wool",
    "light_blue_wool_slab",
    "light_blue_wool_stairs",
    "light_gray_banner",
    "light_gray_bed",
    "light_gray_bundle",
    "light_gray_candle",
    "light_gray_carpet",
    "light_gray_concrete",
    "light_gray_concrete_powder",
    "light_gray_concrete_slab",
    "light_gray_concrete_stairs",
    "light_gray_cushion",
    "light_gray_dye",
    "light_gray_glazed_terracotta",
    "light_gray_harness",
    "light_gray_shulker_box",
    "light_gray_stained_glass",
    "light_gray_stained_glass_pane",
    "light_gray_terracotta",
    "light_gray_wool",
    "light_gray_wool_slab",
    "light_gray_wool_stairs",
    "light_weighted_pressure_plate",
    "lightning_rod",
    "lilac",
    "lily_of_the_valley",
    "lily_pad",
    "lime_banner",
    "lime_bed",
    "lime_bundle",
    "lime_candle",
    "lime_carpet",
    "lime_concrete",
    "lime_concrete_powder",
    "lime_concrete_slab",
    "lime_concrete_stairs",
    "lime_cushion",
    "lime_dye",
    "lime_glazed_terracotta",
    "lime_harness",
    "lime_shulker_box",
    "lime_stained_glass",
    "lime_stained_glass_pane",
    "lime_terracotta",
    "lime_wool",
    "lime_wool_slab",
    "lime_wool_stairs",
    "lingering_potion",
    "llama_spawn_egg",
    "lodestone",
    "loom",
    "mace",
    "magenta_banner",
    "magenta_bed",
    "magenta_bundle",
    "magenta_candle",
    "magenta_carpet",
    "magenta_concrete",
    "magenta_concrete_powder",
    "magenta_concrete_slab",
    "magenta_concrete_stairs",
    "magenta_cushion",
    "magenta_dye",
    "magenta_glazed_terracotta",
    "magenta_harness",
    "magenta_shulker_box",
    "magenta_stained_glass",
    "magenta_stained_glass_pane",
    "magenta_terracotta",
    "magenta_wool",
    "magenta_wool_slab",
    "magenta_wool_stairs",
    "magma_block",
    "magma_cream",
    "magma_cube_spawn_egg",
    "mangrove_boat",
    "mangrove_button",
    "mangrove_chest_boat",
    "mangrove_door",
    "mangrove_fence",
    "mangrove_fence_gate",
    "mangrove_hanging_sign",
    "mangrove_leaves",
    "mangrove_log",
    "mangrove_planks",
    "mangrove_pressure_plate",
    "mangrove_propagule",
    "mangrove_roots",
    "mangrove_shelf",
    "mangrove_sign",
    "mangrove_slab",
    "mangrove_stairs",
    "mangrove_trapdoor",
    "mangrove_wood",
    "map",
    "medium_amethyst_bud",
    "melon",
    "melon_seeds",
    "melon_slice",
    "milk_bucket",
    "minecart",
    "miner_pottery_sherd",
    "mineshaft_map",
    "mojang_banner_pattern",
    "mooshroom_spawn_egg",
    "moss_block",
    "moss_carpet",
    "mossy_cobblestone",
    "mossy_cobblestone_slab",
    "mossy_cobblestone_stairs",
    "mossy_cobblestone_wall",
    "mossy_stone_brick_slab",
    "mossy_stone_brick_stairs",
    "mossy_stone_brick_wall",
    "mossy_stone_bricks",
    "mourner_pottery_sherd",
    "mud",
    "mud_brick_slab",
    "mud_brick_stairs",
    "mud_brick_wall",
    "mud_bricks",
    "muddy_mangrove_roots",
    "mule_spawn_egg",
    "mushroom_stem",
    "mushroom_stew",
    "music_disc_11",
    "music_disc_13",
    "music_disc_5",
    "music_disc_blocks",
    "music_disc_bounce",
    "music_disc_cat",
    "music_disc_chirp",
    "music_disc_creator",
    "music_disc_creator_music_box",
    "music_disc_far",
    "music_disc_lava_chicken",
    "music_disc_mall",
    "music_disc_mellohi",
    "music_disc_otherside",
    "music_disc_pigstep",
    "music_disc_precipice",
    "music_disc_relic",
    "music_disc_stal",
    "music_disc_strad",
    "music_disc_tears",
    "music_disc_wait",
    "music_disc_ward",
    "mutton",
    "mycelium",
    "name_tag",
    "nautilus_shell",
    "nautilus_spawn_egg",
    "nether_brick",
    "nether_brick_fence",
    "nether_brick_slab",
    "nether_brick_stairs",
    "nether_brick_wall",
    "nether_bricks",
    "nether_gold_ore",
    "nether_quartz_ore",
    "nether_sprouts",
    "nether_star",
    "nether_wart",
    "nether_wart_block",
    "netherite_axe",
    "netherite_block",
    "netherite_boots",
    "netherite_chestplate",
    "netherite_helmet",
    "netherite_hoe",
    "netherite_horse_armor",
    "netherite_ingot",
    "netherite_leggings",
    "netherite_nautilus_armor",
    "netherite_pickaxe",
    "netherite_scrap",
    "netherite_shovel",
    "netherite_spear",
    "netherite_sword",
    "netherite_upgrade_smithing_template",
    "netherrack",
    "note_block",
    "oak_boat",
    "oak_button",
    "oak_chest_boat",
    "oak_door",
    "oak_fence",
    "oak_fence_gate",
    "oak_hanging_sign",
    "oak_leaves",
    "oak_log",
    "oak_planks",
    "oak_pressure_plate",
    "oak_sapling",
    "oak_shelf",
    "oak_sign",
    "oak_slab",
    "oak_stairs",
    "oak_trapdoor",
    "oak_wood",
    "observer",
    "obsidian",
    "ocean_explorer_map",
    "ocelot_spawn_egg",
    "ochre_froglight",
    "ominous_bottle",
    "ominous_trial_key",
    "open_eyeblossom",
    "orange_banner",
    "orange_bed",
    "orange_bundle",
    "orange_candle",
    "orange_carpet",
    "orange_concrete",
    "orange_concrete_powder",
    "orange_concrete_slab",
    "orange_concrete_stairs",
    "orange_cushion",
    "orange_dye",
    "orange_glazed_terracotta",
    "orange_harness",
    "orange_poplar_leaves",
    "orange_shulker_box",
    "orange_stained_glass",
    "orange_stained_glass_pane",
    "orange_terracotta",
    "orange_tulip",
    "orange_wool",
    "orange_wool_slab",
    "orange_wool_stairs",
    "oxeye_daisy",
    "oxidized_chiseled_copper",
    "oxidized_copper",
    "oxidized_copper_bars",
    "oxidized_copper_bulb",
    "oxidized_copper_chain",
    "oxidized_copper_chest",
    "oxidized_copper_door",
    "oxidized_copper_golem_statue",
    "oxidized_copper_grate",
    "oxidized_copper_lantern",
    "oxidized_copper_trapdoor",
    "oxidized_cut_copper",
    "oxidized_cut_copper_slab",
    "oxidized_cut_copper_stairs",
    "oxidized_lightning_rod",
    "packed_ice",
    "packed_mud",
    "painting",
    "pale_hanging_moss",
    "pale_moss_block",
    "pale_moss_carpet",
    "pale_oak_boat",
    "pale_oak_button",
    "pale_oak_chest_boat",
    "pale_oak_door",
    "pale_oak_fence",
    "pale_oak_fence_gate",
    "pale_oak_hanging_sign",
    "pale_oak_leaves",
    "pale_oak_log",
    "pale_oak_planks",
    "pale_oak_pressure_plate",
    "pale_oak_sapling",
    "pale_oak_shelf",
    "pale_oak_sign",
    "pale_oak_slab",
    "pale_oak_stairs",
    "pale_oak_trapdoor",
    "pale_oak_wood",
    "panda_spawn_egg",
    "paper",
    "parched_spawn_egg",
    "parrot_spawn_egg",
    "pearlescent_froglight",
    "peony",
    "petrified_oak_slab",
    "phantom_membrane",
    "phantom_spawn_egg",
    "pig_spawn_egg",
    "piglin_banner_pattern",
    "piglin_brute_spawn_egg",
    "piglin_head",
    "piglin_spawn_egg",
    "pillager_spawn_egg",
    "pink_banner",
    "pink_bed",
    "pink_bundle",
    "pink_candle",
    "pink_carpet",
    "pink_concrete",
    "pink_concrete_powder",
    "pink_concrete_slab",
    "pink_concrete_stairs",
    "pink_cushion",
    "pink_dye",
    "pink_glazed_terracotta",
    "pink_harness",
    "pink_petals",
    "pink_shulker_box",
    "pink_stained_glass",
    "pink_stained_glass_pane",
    "pink_terracotta",
    "pink_tulip",
    "pink_wool",
    "pink_wool_slab",
    "pink_wool_stairs",
    "piston",
    "pitcher_plant",
    "pitcher_pod",
    "plains_village_map",
    "player_head",
    "plenty_pottery_sherd",
    "podzol",
    "pointed_dripstone",
    "poisonous_potato",
    "polar_bear_spawn_egg",
    "polished_andesite",
    "polished_andesite_slab",
    "polished_andesite_stairs",
    "polished_basalt",
    "polished_blackstone",
    "polished_blackstone_brick_slab",
    "polished_blackstone_brick_stairs",
    "polished_blackstone_brick_wall",
    "polished_blackstone_bricks",
    "polished_blackstone_button",
    "polished_blackstone_pressure_plate",
    "polished_blackstone_slab",
    "polished_blackstone_stairs",
    "polished_blackstone_wall",
    "polished_cinnabar",
    "polished_cinnabar_slab",
    "polished_cinnabar_stairs",
    "polished_cinnabar_wall",
    "polished_deepslate",
    "polished_deepslate_slab",
    "polished_deepslate_stairs",
    "polished_deepslate_wall",
    "polished_diorite",
    "polished_diorite_slab",
    "polished_diorite_stairs",
    "polished_granite",
    "polished_granite_slab",
    "polished_granite_stairs",
    "polished_sulfur",
    "polished_sulfur_slab",
    "polished_sulfur_stairs",
    "polished_sulfur_wall",
    "polished_tuff",
    "polished_tuff_slab",
    "polished_tuff_stairs",
    "polished_tuff_wall",
    "poplar_boat",
    "poplar_button",
    "poplar_chest_boat",
    "poplar_door",
    "poplar_fence",
    "poplar_fence_gate",
    "poplar_hanging_sign",
    "poplar_log",
    "poplar_planks",
    "poplar_pressure_plate",
    "poplar_sapling",
    "poplar_shelf",
    "poplar_sign",
    "poplar_slab",
    "poplar_stairs",
    "poplar_trapdoor",
    "poplar_wood",
    "popped_chorus_fruit",
    "poppy",
    "porkchop",
    "potato",
    "potent_sulfur",
    "potion",
    "powder_snow_bucket",
    "powered_rail",
    "prismarine",
    "prismarine_brick_slab",
    "prismarine_brick_stairs",
    "prismarine_bricks",
    "prismarine_crystals",
    "prismarine_shard",
    "prismarine_slab",
    "prismarine_stairs",
    "prismarine_wall",
    "prize_pottery_sherd",
    "pufferfish",
    "pufferfish_bucket",
    "pufferfish_spawn_egg",
    "pumpkin",
    "pumpkin_pie",
    "pumpkin_seeds",
    "purple_banner",
    "purple_bed",
    "purple_bundle",
    "purple_candle",
    "purple_carpet",
    "purple_concrete",
    "purple_concrete_powder",
    "purple_concrete_slab",
    "purple_concrete_stairs",
    "purple_cushion",
    "purple_dye",
    "purple_glazed_terracotta",
    "purple_harness",
    "purple_shulker_box",
    "purple_stained_glass",
    "purple_stained_glass_pane",
    "purple_terracotta",
    "purple_wool",
    "purple_wool_slab",
    "purple_wool_stairs",
    "purpur_block",
    "purpur_pillar",
    "purpur_slab",
    "purpur_stairs",
    "quartz",
    "quartz_block",
    "quartz_bricks",
    "quartz_pillar",
    "quartz_slab",
    "quartz_stairs",
    "rabbit",
    "rabbit_foot",
    "rabbit_hide",
    "rabbit_spawn_egg",
    "rabbit_stew",
    "rail",
    "raiser_armor_trim_smithing_template",
    "ravager_spawn_egg",
    "raw_copper",
    "raw_copper_block",
    "raw_gold",
    "raw_gold_block",
    "raw_iron",
    "raw_iron_block",
    "recovery_compass",
    "red_banner",
    "red_bed",
    "red_bundle",
    "red_candle",
    "red_carpet",
    "red_concrete",
    "red_concrete_powder",
    "red_concrete_slab",
    "red_concrete_stairs",
    "red_cushion",
    "red_dye",
    "red_glazed_terracotta",
    "red_harness",
    "red_mushroom",
    "red_mushroom_block",
    "red_nether_brick_slab",
    "red_nether_brick_stairs",
    "red_nether_brick_wall",
    "red_nether_bricks",
    "red_poplar_leaves",
    "red_sand",
    "red_sandstone",
    "red_sandstone_slab",
    "red_sandstone_stairs",
    "red_sandstone_wall",
    "red_shrub",
    "red_shulker_box",
    "red_stained_glass",
    "red_stained_glass_pane",
    "red_terracotta",
    "red_tulip",
    "red_wool",
    "red_wool_slab",
    "red_wool_stairs",
    "redstone",
    "redstone_block",
    "redstone_lamp",
    "redstone_ore",
    "redstone_torch",
    "reinforced_deepslate",
    "repeater",
    "repeating_command_block",
    "resin_block",
    "resin_brick",
    "resin_brick_slab",
    "resin_brick_stairs",
    "resin_brick_wall",
    "resin_bricks",
    "resin_clump",
    "respawn_anchor",
    "rib_armor_trim_smithing_template",
    "rooted_dirt",
    "rose_bush",
    "rotten_flesh",
    "saddle",
    "salmon",
    "salmon_bucket",
    "salmon_spawn_egg",
    "sand",
    "sandstone",
    "sandstone_slab",
    "sandstone_stairs",
    "sandstone_wall",
    "savanna_village_map",
    "scaffolding",
    "scrape_pottery_sherd",
    "sculk",
    "sculk_catalyst",
    "sculk_sensor",
    "sculk_shrieker",
    "sculk_vein",
    "sea_lantern",
    "sea_pickle",
    "seagrass",
    "sentry_armor_trim_smithing_template",
    "shaper_armor_trim_smithing_template",
    "sheaf_pottery_sherd",
    "shears",
    "sheep_spawn_egg",
    "shelf_mushroom",
    "shelter_pottery_sherd",
    "shield",
    "short_dry_grass",
    "short_grass",
    "shroomlight",
    "shulker_box",
    "shulker_shell",
    "shulker_spawn_egg",
    "silence_armor_trim_smithing_template",
    "silverfish_spawn_egg",
    "skeleton_horse_spawn_egg",
    "skeleton_skull",
    "skeleton_spawn_egg",
    "skull_banner_pattern",
    "skull_pottery_sherd",
    "slime_ball",
    "slime_block",
    "slime_spawn_egg",
    "small_amethyst_bud",
    "small_dripleaf",
    "smithing_table",
    "smoker",
    "smooth_basalt",
    "smooth_quartz",
    "smooth_quartz_slab",
    "smooth_quartz_stairs",
    "smooth_red_sandstone",
    "smooth_red_sandstone_slab",
    "smooth_red_sandstone_stairs",
    "smooth_sandstone",
    "smooth_sandstone_slab",
    "smooth_sandstone_stairs",
    "smooth_stone",
    "smooth_stone_slab",
    "sniffer_egg",
    "sniffer_spawn_egg",
    "snort_pottery_sherd",
    "snout_armor_trim_smithing_template",
    "snow",
    "snow_block",
    "snow_golem_spawn_egg",
    "snowball",
    "snowy_village_map",
    "soul_campfire",
    "soul_lantern",
    "soul_sand",
    "soul_soil",
    "soul_torch",
    "spawner",
    "spectral_arrow",
    "spider_eye",
    "spider_spawn_egg",
    "spire_armor_trim_smithing_template",
    "splash_potion",
    "sponge",
    "spore_blossom",
    "spruce_boat",
    "spruce_button",
    "spruce_chest_boat",
    "spruce_door",
    "spruce_fence",
    "spruce_fence_gate",
    "spruce_hanging_sign",
    "spruce_leaves",
    "spruce_log",
    "spruce_planks",
    "spruce_pressure_plate",
    "spruce_sapling",
    "spruce_shelf",
    "spruce_sign",
    "spruce_slab",
    "spruce_stairs",
    "spruce_trapdoor",
    "spruce_wood",
    "spyglass",
    "squid_spawn_egg",
    "stick",
    "sticky_piston",
    "stone",
    "stone_axe",
    "stone_brick_slab",
    "stone_brick_stairs",
    "stone_brick_wall",
    "stone_bricks",
    "stone_button",
    "stone_hoe",
    "stone_pickaxe",
    "stone_pressure_plate",
    "stone_shovel",
    "stone_slab",
    "stone_spear",
    "stone_stairs",
    "stone_sword",
    "stonecutter",
    "straw_bed",
    "stray_spawn_egg",
    "strider_spawn_egg",
    "string",
    "stripped_acacia_log",
    "stripped_acacia_wood",
    "stripped_bamboo_block",
    "stripped_birch_log",
    "stripped_birch_wood",
    "stripped_cherry_log",
    "stripped_cherry_wood",
    "stripped_crimson_hyphae",
    "stripped_crimson_stem",
    "stripped_dark_oak_log",
    "stripped_dark_oak_wood",
    "stripped_jungle_log",
    "stripped_jungle_wood",
    "stripped_mangrove_log",
    "stripped_mangrove_wood",
    "stripped_oak_log",
    "stripped_oak_wood",
    "stripped_pale_oak_log",
    "stripped_pale_oak_wood",
    "stripped_poplar_log",
    "stripped_poplar_wood",
    "stripped_spruce_log",
    "stripped_spruce_wood",
    "stripped_warped_hyphae",
    "stripped_warped_stem",
    "structure_block",
    "structure_void",
    "sugar",
    "sugar_cane",
    "sulfur",
    "sulfur_brick_slab",
    "sulfur_brick_stairs",
    "sulfur_brick_wall",
    "sulfur_bricks",
    "sulfur_cube_bucket",
    "sulfur_cube_spawn_egg",
    "sulfur_slab",
    "sulfur_spike",
    "sulfur_stairs",
    "sulfur_wall",
    "sunflower",
    "suspicious_gravel",
    "suspicious_sand",
    "suspicious_stew",
    "swamp_explorer_map",
    "sweet_berries",
    "tadpole_bucket",
    "tadpole_spawn_egg",
    "taiga_village_map",
    "tall_dry_grass",
    "tall_grass",
    "target",
    "terracotta",
    "test_block",
    "test_instance_block",
    "tide_armor_trim_smithing_template",
    "tinted_glass",
    "tipped_arrow",
    "tnt",
    "tnt_minecart",
    "torch",
    "torchflower",
    "torchflower_seeds",
    "totem_of_undying",
    "trader_llama_spawn_egg",
    "trapped_chest",
    "trial_explorer_map",
    "trial_key",
    "trial_spawner",
    "trident",
    "tripwire_hook",
    "tropical_fish",
    "tropical_fish_bucket",
    "tropical_fish_spawn_egg",
    "tube_coral",
    "tube_coral_block",
    "tube_coral_fan",
    "tuff",
    "tuff_brick_slab",
    "tuff_brick_stairs",
    "tuff_brick_wall",
    "tuff_bricks",
    "tuff_slab",
    "tuff_stairs",
    "tuff_wall",
    "turtle_egg",
    "turtle_helmet",
    "turtle_scute",
    "turtle_spawn_egg",
    "twisting_vines",
    "vault",
    "verdant_froglight",
    "vex_armor_trim_smithing_template",
    "vex_spawn_egg",
    "villager_spawn_egg",
    "vindicator_spawn_egg",
    "vine",
    "wandering_trader_spawn_egg",
    "ward_armor_trim_smithing_template",
    "warden_spawn_egg",
    "warm_ocean_ruins_map",
    "warped_button",
    "warped_door",
    "warped_fence",
    "warped_fence_gate",
    "warped_fungus",
    "warped_fungus_on_a_stick",
    "warped_hanging_sign",
    "warped_hyphae",
    "warped_nylium",
    "warped_planks",
    "warped_pressure_plate",
    "warped_roots",
    "warped_shelf",
    "warped_sign",
    "warped_slab",
    "warped_stairs",
    "warped_stem",
    "warped_trapdoor",
    "warped_wart_block",
    "water_bucket",
    "waxed_chiseled_copper",
    "waxed_copper_bars",
    "waxed_copper_block",
    "waxed_copper_bulb",
    "waxed_copper_chain",
    "waxed_copper_chest",
    "waxed_copper_door",
    "waxed_copper_golem_statue",
    "waxed_copper_grate",
    "waxed_copper_lantern",
    "waxed_copper_trapdoor",
    "waxed_cut_copper",
    "waxed_cut_copper_slab",
    "waxed_cut_copper_stairs",
    "waxed_exposed_chiseled_copper",
    "waxed_exposed_copper",
    "waxed_exposed_copper_bars",
    "waxed_exposed_copper_bulb",
    "waxed_exposed_copper_chain",
    "waxed_exposed_copper_chest",
    "waxed_exposed_copper_door",
    "waxed_exposed_copper_golem_statue",
    "waxed_exposed_copper_grate",
    "waxed_exposed_copper_lantern",
    "waxed_exposed_copper_trapdoor",
    "waxed_exposed_cut_copper",
    "waxed_exposed_cut_copper_slab",
    "waxed_exposed_cut_copper_stairs",
    "waxed_exposed_lightning_rod",
    "waxed_lightning_rod",
    "waxed_oxidized_chiseled_copper",
    "waxed_oxidized_copper",
    "waxed_oxidized_copper_bars",
    "waxed_oxidized_copper_bulb",
    "waxed_oxidized_copper_chain",
    "waxed_oxidized_copper_chest",
    "waxed_oxidized_copper_door",
    "waxed_oxidized_copper_golem_statue",
    "waxed_oxidized_copper_grate",
    "waxed_oxidized_copper_lantern",
    "waxed_oxidized_copper_trapdoor",
    "waxed_oxidized_cut_copper",
    "waxed_oxidized_cut_copper_slab",
    "waxed_oxidized_cut_copper_stairs",
    "waxed_oxidized_lightning_rod",
    "waxed_weathered_chiseled_copper",
    "waxed_weathered_copper",
    "waxed_weathered_copper_bars",
    "waxed_weathered_copper_bulb",
    "waxed_weathered_copper_chain",
    "waxed_weathered_copper_chest",
    "waxed_weathered_copper_door",
    "waxed_weathered_copper_golem_statue",
    "waxed_weathered_copper_grate",
    "waxed_weathered_copper_lantern",
    "waxed_weathered_copper_trapdoor",
    "waxed_weathered_cut_copper",
    "waxed_weathered_cut_copper_slab",
    "waxed_weathered_cut_copper_stairs",
    "waxed_weathered_lightning_rod",
    "wayfinder_armor_trim_smithing_template",
    "weathered_chiseled_copper",
    "weathered_copper",
    "weathered_copper_bars",
    "weathered_copper_bulb",
    "weathered_copper_chain",
    "weathered_copper_chest",
    "weathered_copper_door",
    "weathered_copper_golem_statue",
    "weathered_copper_grate",
    "weathered_copper_lantern",
    "weathered_copper_trapdoor",
    "weathered_cut_copper",
    "weathered_cut_copper_slab",
    "weathered_cut_copper_stairs",
    "weathered_lightning_rod",
    "weeping_vines",
    "wet_sponge",
    "wheat",
    "wheat_seeds",
    "white_banner",
    "white_bed",
    "white_bundle",
    "white_candle",
    "white_carpet",
    "white_concrete",
    "white_concrete_powder",
    "white_concrete_slab",
    "white_concrete_stairs",
    "white_cushion",
    "white_dye",
    "white_glazed_terracotta",
    "white_harness",
    "white_shulker_box",
    "white_stained_glass",
    "white_stained_glass_pane",
    "white_terracotta",
    "white_tulip",
    "white_wool",
    "white_wool_slab",
    "white_wool_stairs",
    "wild_armor_trim_smithing_template",
    "wildflowers",
    "wind_charge",
    "witch_spawn_egg",
    "wither_rose",
    "wither_skeleton_skull",
    "wither_skeleton_spawn_egg",
    "wither_spawn_egg",
    "wolf_armor",
    "wolf_spawn_egg",
    "wooden_axe",
    "wooden_hoe",
    "wooden_pickaxe",
    "wooden_shovel",
    "wooden_spear",
    "wooden_sword",
    "woodland_explorer_map",
    "writable_book",
    "written_book",
    "yellow_banner",
    "yellow_bed",
    "yellow_bundle",
    "yellow_candle",
    "yellow_carpet",
    "yellow_concrete",
    "yellow_concrete_powder",
    "yellow_concrete_slab",
    "yellow_concrete_stairs",
    "yellow_cushion",
    "yellow_dye",
    "yellow_glazed_terracotta",
    "yellow_harness",
    "yellow_poplar_leaves",
    "yellow_shulker_box",
    "yellow_stained_glass",
    "yellow_stained_glass_pane",
    "yellow_terracotta",
    "yellow_wool",
    "yellow_wool_slab",
    "yellow_wool_stairs",
    "zoglin_spawn_egg",
    "zombie_head",
    "zombie_horse_spawn_egg",
    "zombie_nautilus_spawn_egg",
    "zombie_spawn_egg",
    "zombie_villager_spawn_egg",
    "zombified_piglin_spawn_egg"
  ]);
});

// src/arguments/generated/_registry/loot_condition_types.ts
var LOOT_CONDITION_TYPES_SET;
var init_loot_condition_types = __esm(() => {
  init_sandstone();
  LOOT_CONDITION_TYPES_SET = new Set2([
    "all_of",
    "any_of",
    "damage_source_properties",
    "enchantment_active_check",
    "entity_properties",
    "entity_scores",
    "environment_attribute_check",
    "inverted",
    "killed_by_player",
    "location_check",
    "match_block",
    "match_tool",
    "random_chance",
    "random_chance_with_enchanted_bonus",
    "survives_explosion",
    "table_bonus",
    "time_check",
    "value_check",
    "weather_check"
  ]);
});

// src/arguments/generated/_registry/loot_function_types.ts
var LOOT_FUNCTION_TYPES_SET;
var init_loot_function_types = __esm(() => {
  init_sandstone();
  LOOT_FUNCTION_TYPES_SET = new Set2([
    "apply_bonus",
    "copy_components",
    "copy_custom_data",
    "copy_name",
    "copy_state",
    "discard",
    "enchant_randomly",
    "enchant_with_levels",
    "enchanted_count_increase",
    "exploration_map",
    "explosion_decay",
    "fill_player_head",
    "filtered",
    "furnace_smelt",
    "limit_count",
    "modify_contents",
    "sequence",
    "set_attributes",
    "set_banner_pattern",
    "set_book_cover",
    "set_components",
    "set_contents",
    "set_count",
    "set_custom_data",
    "set_custom_model_data",
    "set_damage",
    "set_enchantments",
    "set_firework_explosion",
    "set_fireworks",
    "set_instrument",
    "set_item",
    "set_loot_table",
    "set_lore",
    "set_name",
    "set_ominous_bottle_amplifier",
    "set_potion",
    "set_random_dyes",
    "set_random_potion",
    "set_stew_effect",
    "set_writable_book_pages",
    "set_written_book_pages",
    "toggle_tooltips"
  ]);
});

// src/arguments/generated/_registry/loot_nbt_provider_types.ts
var LOOT_NBT_PROVIDER_TYPES_SET;
var init_loot_nbt_provider_types = __esm(() => {
  init_sandstone();
  LOOT_NBT_PROVIDER_TYPES_SET = new Set2([
    "context",
    "storage"
  ]);
});

// src/arguments/generated/_registry/loot_number_provider_types.ts
var LOOT_NUMBER_PROVIDER_TYPES_SET;
var init_loot_number_provider_types = __esm(() => {
  init_sandstone();
  LOOT_NUMBER_PROVIDER_TYPES_SET = new Set2([
    "binomial",
    "conditional",
    "constant",
    "enchantment_level",
    "environment_attribute",
    "number_dispatcher",
    "score",
    "storage",
    "sum",
    "uniform",
    "weighted_list"
  ]);
});

// src/arguments/generated/_registry/loot_pool_entry_types.ts
var LOOT_POOL_ENTRY_TYPES_SET;
var init_loot_pool_entry_types = __esm(() => {
  init_sandstone();
  LOOT_POOL_ENTRY_TYPES_SET = new Set2([
    "alternatives",
    "dynamic",
    "empty",
    "group",
    "item",
    "loot_table",
    "sequence",
    "slots",
    "tag"
  ]);
});

// src/arguments/generated/_registry/loot_score_provider_types.ts
var LOOT_SCORE_PROVIDER_TYPES_SET;
var init_loot_score_provider_types = __esm(() => {
  init_sandstone();
  LOOT_SCORE_PROVIDER_TYPES_SET = new Set2([
    "context",
    "fixed"
  ]);
});

// src/arguments/generated/_registry/map_decoration_types.ts
var MAP_DECORATION_TYPES_SET;
var init_map_decoration_types = __esm(() => {
  init_sandstone();
  MAP_DECORATION_TYPES_SET = new Set2([
    "abandoned_camp",
    "ancient_city",
    "banner_black",
    "banner_blue",
    "banner_brown",
    "banner_cyan",
    "banner_gray",
    "banner_green",
    "banner_light_blue",
    "banner_light_gray",
    "banner_lime",
    "banner_magenta",
    "banner_orange",
    "banner_pink",
    "banner_purple",
    "banner_red",
    "banner_white",
    "banner_yellow",
    "blue_marker",
    "desert_pyramid",
    "frame",
    "jungle_temple",
    "mansion",
    "mineshaft",
    "monument",
    "ocean_ruin_warm",
    "player",
    "player_off_limits",
    "player_off_map",
    "red_marker",
    "red_x",
    "swamp_hut",
    "target_point",
    "target_x",
    "trial_chambers",
    "village_desert",
    "village_plains",
    "village_savanna",
    "village_snowy",
    "village_taiga"
  ]);
});

// src/arguments/generated/_registry/memory_module_types.ts
var MEMORY_MODULE_TYPES_SET;
var init_memory_module_types = __esm(() => {
  init_sandstone();
  MEMORY_MODULE_TYPES_SET = new Set2([
    "admiring_disabled",
    "admiring_item",
    "angry_at",
    "ate_recently",
    "attack_cooling_down",
    "attack_target",
    "attack_target_cooldown",
    "avoid_target",
    "breed_target",
    "breeze_jump_cooldown",
    "breeze_jump_inhaling",
    "breeze_jump_target",
    "breeze_leaving_water",
    "breeze_shoot",
    "breeze_shoot_charging",
    "breeze_shoot_cooldown",
    "breeze_shoot_recover",
    "cant_reach_walk_target_since",
    "celebrate_location",
    "charge_cooldown_ticks",
    "dancing",
    "danger_detected_recently",
    "dig_cooldown",
    "disable_walk_to_admire_item",
    "disturbance_location",
    "doors_to_close",
    "dummy",
    "gaze_cooldown_ticks",
    "golem_detected_recently",
    "has_hunting_cooldown",
    "heard_bell_time",
    "hiding_place",
    "home",
    "hunted_recently",
    "hurt_by",
    "hurt_by_entity",
    "interaction_target",
    "is_emerging",
    "is_in_water",
    "is_panicking",
    "is_pregnant",
    "is_sniffing",
    "item_pickup_cooldown_ticks",
    "job_site",
    "last_slept",
    "last_woken",
    "last_worked_at_poi",
    "liked_noteblock",
    "liked_noteblock_cooldown_ticks",
    "liked_player",
    "long_jump_cooling_down",
    "long_jump_mid_jump",
    "look_target",
    "meeting_point",
    "mobs",
    "nearby_adult_piglins",
    "nearest_attackable",
    "nearest_bed",
    "nearest_hostile",
    "nearest_player_holding_wanted_item",
    "nearest_players",
    "nearest_repellent",
    "nearest_targetable_player_not_wearing_gold",
    "nearest_visible_adult",
    "nearest_visible_adult_hoglins",
    "nearest_visible_adult_piglin",
    "nearest_visible_adult_piglins",
    "nearest_visible_baby_hoglin",
    "nearest_visible_huntable_hoglin",
    "nearest_visible_nemesis",
    "nearest_visible_player",
    "nearest_visible_targetable_player",
    "nearest_visible_targetable_players",
    "nearest_visible_wanted_item",
    "nearest_visible_zombified",
    "pacified",
    "path",
    "play_dead_ticks",
    "potential_job_site",
    "ram_cooldown_ticks",
    "ram_target",
    "recent_projectile",
    "ride_target",
    "roar_sound_cooldown",
    "roar_sound_delay",
    "roar_target",
    "secondary_job_site",
    "sniff_cooldown",
    "sniffer_digging",
    "sniffer_explored_positions",
    "sniffer_happy",
    "sniffer_sniffing_target",
    "sonic_boom_cooldown",
    "sonic_boom_sound_cooldown",
    "sonic_boom_sound_delay",
    "spear_charge_position",
    "spear_engage_time",
    "spear_fleeing_position",
    "spear_fleeing_time",
    "spear_status",
    "temptation_cooldown_ticks",
    "tempting_player",
    "time_trying_to_reach_admire_item",
    "touch_cooldown",
    "transport_items_cooldown_ticks",
    "universal_anger",
    "unreachable_tongue_targets",
    "unreachable_transport_block_positions",
    "vibration_cooldown",
    "visible_adult_hoglin_count",
    "visible_adult_piglin_count",
    "visible_mobs",
    "visible_villager_babies",
    "visited_block_positions",
    "walk_target"
  ]);
});

// src/arguments/generated/_registry/menus.ts
var MENUS_SET;
var init_menus = __esm(() => {
  init_sandstone();
  MENUS_SET = new Set2([
    "anvil",
    "beacon",
    "blast_furnace",
    "brewing_stand",
    "cartography_table",
    "crafter_3x3",
    "crafting",
    "enchantment",
    "furnace",
    "generic_3x3",
    "generic_9x1",
    "generic_9x2",
    "generic_9x3",
    "generic_9x4",
    "generic_9x5",
    "generic_9x6",
    "grindstone",
    "hopper",
    "lectern",
    "loom",
    "merchant",
    "shulker_box",
    "smithing",
    "smoker",
    "stonecutter"
  ]);
});

// src/arguments/generated/_registry/mob_effects.ts
var MOB_EFFECTS_SET;
var init_mob_effects = __esm(() => {
  init_sandstone();
  MOB_EFFECTS_SET = new Set2([
    "absorption",
    "bad_omen",
    "blindness",
    "breath_of_the_nautilus",
    "conduit_power",
    "darkness",
    "dolphins_grace",
    "fire_resistance",
    "glowing",
    "haste",
    "health_boost",
    "hero_of_the_village",
    "hunger",
    "infested",
    "instant_damage",
    "instant_health",
    "invisibility",
    "jump_boost",
    "levitation",
    "luck",
    "mining_fatigue",
    "nausea",
    "night_vision",
    "oozing",
    "poison",
    "raid_omen",
    "regeneration",
    "resistance",
    "saturation",
    "slow_falling",
    "slowness",
    "speed",
    "strength",
    "trial_omen",
    "unluck",
    "water_breathing",
    "weakness",
    "weaving",
    "wind_charged",
    "wither"
  ]);
});

// src/arguments/generated/_registry/number_format_types.ts
var NUMBER_FORMAT_TYPES_SET;
var init_number_format_types = __esm(() => {
  init_sandstone();
  NUMBER_FORMAT_TYPES_SET = new Set2([
    "blank",
    "fixed",
    "styled"
  ]);
});

// src/arguments/generated/_registry/outgoing_rpc_methods.ts
var OUTGOING_RPC_METHODS_SET;
var init_outgoing_rpc_methods = __esm(() => {
  init_sandstone();
  OUTGOING_RPC_METHODS_SET = new Set2([
    "notification/allowlist/added",
    "notification/allowlist/removed",
    "notification/bans/added",
    "notification/bans/removed",
    "notification/gamerules/updated",
    "notification/ip_bans/added",
    "notification/ip_bans/removed",
    "notification/operators/added",
    "notification/operators/removed",
    "notification/players/joined",
    "notification/players/left",
    "notification/server/activity",
    "notification/server/saved",
    "notification/server/saving",
    "notification/server/started",
    "notification/server/status",
    "notification/server/stopping",
    "notification/world/upgrade_failed",
    "notification/world/upgrade_finished",
    "notification/world/upgrade_progress",
    "notification/world/upgrade_started"
  ]);
});

// src/arguments/generated/_registry/particle_types.ts
var PARTICLE_TYPES_SET;
var init_particle_types = __esm(() => {
  init_sandstone();
  PARTICLE_TYPES_SET = new Set2([
    "angry_villager",
    "ash",
    "block",
    "block_crumble",
    "block_marker",
    "bubble",
    "bubble_column_up",
    "bubble_pop",
    "campfire_cosy_smoke",
    "campfire_signal_smoke",
    "cherry_leaves",
    "cloud",
    "composter",
    "copper_fire_flame",
    "crimson_spore",
    "crit",
    "current_down",
    "damage_indicator",
    "dolphin",
    "dragon_breath",
    "dripping_dripstone_lava",
    "dripping_dripstone_water",
    "dripping_honey",
    "dripping_lava",
    "dripping_obsidian_tear",
    "dripping_water",
    "dust",
    "dust_color_transition",
    "dust_pillar",
    "dust_plume",
    "effect",
    "egg_crack",
    "elder_guardian",
    "electric_spark",
    "enchant",
    "enchanted_hit",
    "end_rod",
    "entity_effect",
    "explosion",
    "explosion_emitter",
    "falling_dripstone_lava",
    "falling_dripstone_water",
    "falling_dust",
    "falling_honey",
    "falling_lava",
    "falling_nectar",
    "falling_obsidian_tear",
    "falling_spore_blossom",
    "falling_water",
    "firefly",
    "firework",
    "fishing",
    "flame",
    "flash",
    "geyser",
    "geyser_base",
    "geyser_plume",
    "geyser_poof",
    "glow",
    "glow_squid_ink",
    "gust",
    "gust_emitter_large",
    "gust_emitter_small",
    "happy_villager",
    "heart",
    "infested",
    "instant_effect",
    "item",
    "item_cobweb",
    "item_slime",
    "item_snowball",
    "landing_honey",
    "landing_lava",
    "landing_obsidian_tear",
    "large_smoke",
    "lava",
    "mycelium",
    "nautilus",
    "note",
    "noxious_gas",
    "noxious_gas_cloud",
    "ominous_spawning",
    "orange_poplar_leaves",
    "pale_oak_leaves",
    "pause_mob_growth",
    "poof",
    "portal",
    "raid_omen",
    "rain",
    "red_poplar_leaves",
    "reset_mob_growth",
    "reverse_portal",
    "scrape",
    "sculk_charge",
    "sculk_charge_pop",
    "sculk_soul",
    "shriek",
    "small_flame",
    "small_gust",
    "smoke",
    "sneeze",
    "snowflake",
    "sonic_boom",
    "soul",
    "soul_fire_flame",
    "spit",
    "splash",
    "spore_blossom_air",
    "squid_ink",
    "sulfur_bubbles",
    "sulfur_cube_goo",
    "sweep_attack",
    "tinted_leaves",
    "totem_of_undying",
    "trail",
    "trial_omen",
    "trial_spawner_detection",
    "trial_spawner_detection_ominous",
    "underwater",
    "vault_connection",
    "vibration",
    "warped_spore",
    "wax_off",
    "wax_on",
    "white_ash",
    "white_smoke",
    "witch",
    "yellow_poplar_leaves"
  ]);
});

// src/arguments/generated/_registry/permission_check_types.ts
var PERMISSION_CHECK_TYPES_SET;
var init_permission_check_types = __esm(() => {
  init_sandstone();
  PERMISSION_CHECK_TYPES_SET = new Set2([
    "always_pass",
    "require"
  ]);
});

// src/arguments/generated/_registry/permission_types.ts
var PERMISSION_TYPES_SET;
var init_permission_types = __esm(() => {
  init_sandstone();
  PERMISSION_TYPES_SET = new Set2([
    "atom",
    "command_level"
  ]);
});

// src/arguments/generated/_registry/point_of_interest_types.ts
var POINT_OF_INTEREST_TYPES_SET;
var init_point_of_interest_types = __esm(() => {
  init_sandstone();
  POINT_OF_INTEREST_TYPES_SET = new Set2([
    "armorer",
    "bee_nest",
    "beehive",
    "butcher",
    "cartographer",
    "cleric",
    "farmer",
    "fisherman",
    "fletcher",
    "home",
    "leatherworker",
    "librarian",
    "lightning_rod",
    "lodestone",
    "mason",
    "meeting",
    "nether_portal",
    "shepherd",
    "test_instance",
    "toolsmith",
    "weaponsmith"
  ]);
});

// src/arguments/generated/_registry/pos_rule_tests.ts
var POS_RULE_TESTS_SET;
var init_pos_rule_tests = __esm(() => {
  init_sandstone();
  POS_RULE_TESTS_SET = new Set2([
    "always_true",
    "axis_aligned_linear_pos",
    "linear_pos"
  ]);
});

// src/arguments/generated/_registry/position_source_types.ts
var POSITION_SOURCE_TYPES_SET;
var init_position_source_types = __esm(() => {
  init_sandstone();
  POSITION_SOURCE_TYPES_SET = new Set2([
    "block",
    "entity"
  ]);
});

// src/arguments/generated/_registry/potions.ts
var POTIONS_SET;
var init_potions = __esm(() => {
  init_sandstone();
  POTIONS_SET = new Set2([
    "awkward",
    "fire_resistance",
    "harming",
    "healing",
    "infested",
    "invisibility",
    "leaping",
    "long_fire_resistance",
    "long_invisibility",
    "long_leaping",
    "long_night_vision",
    "long_poison",
    "long_regeneration",
    "long_slow_falling",
    "long_slowness",
    "long_strength",
    "long_swiftness",
    "long_turtle_master",
    "long_water_breathing",
    "long_weakness",
    "luck",
    "mundane",
    "night_vision",
    "oozing",
    "poison",
    "regeneration",
    "slow_falling",
    "slowness",
    "strength",
    "strong_harming",
    "strong_healing",
    "strong_leaping",
    "strong_poison",
    "strong_regeneration",
    "strong_slowness",
    "strong_strength",
    "strong_swiftness",
    "strong_turtle_master",
    "swiftness",
    "thick",
    "turtle_master",
    "water",
    "water_breathing",
    "weakness",
    "weaving",
    "wind_charged"
  ]);
});

// src/arguments/generated/_registry/recipe_book_categories.ts
var RECIPE_BOOK_CATEGORIES_SET;
var init_recipe_book_categories = __esm(() => {
  init_sandstone();
  RECIPE_BOOK_CATEGORIES_SET = new Set2([
    "blast_furnace_blocks",
    "blast_furnace_misc",
    "campfire",
    "crafting_building_blocks",
    "crafting_equipment",
    "crafting_misc",
    "crafting_redstone",
    "furnace_blocks",
    "furnace_food",
    "furnace_misc",
    "smithing",
    "smoker_food",
    "stonecutter"
  ]);
});

// src/arguments/generated/_registry/recipe_displays.ts
var RECIPE_DISPLAYS_SET;
var init_recipe_displays = __esm(() => {
  init_sandstone();
  RECIPE_DISPLAYS_SET = new Set2([
    "crafting_shaped",
    "crafting_shapeless",
    "furnace",
    "smithing",
    "stonecutter"
  ]);
});

// src/arguments/generated/_registry/recipe_serializers.ts
var RECIPE_SERIALIZERS_SET;
var init_recipe_serializers = __esm(() => {
  init_sandstone();
  RECIPE_SERIALIZERS_SET = new Set2([
    "blasting",
    "brewing",
    "campfire_cooking",
    "crafting_decorated_pot",
    "crafting_dye",
    "crafting_imbue",
    "crafting_shaped",
    "crafting_shapeless",
    "crafting_special_bannerduplicate",
    "crafting_special_bookcloning",
    "crafting_special_firework_rocket",
    "crafting_special_firework_star",
    "crafting_special_firework_star_fade",
    "crafting_special_mapextending",
    "crafting_special_repairitem",
    "crafting_special_shielddecoration",
    "crafting_transmute",
    "smelting",
    "smithing_transform",
    "smithing_trim",
    "smoking",
    "stonecutting"
  ]);
});

// src/arguments/generated/_registry/recipe_types.ts
var RECIPE_TYPES_SET;
var init_recipe_types = __esm(() => {
  init_sandstone();
  RECIPE_TYPES_SET = new Set2([
    "blasting",
    "brewing",
    "campfire_cooking",
    "crafting",
    "smelting",
    "smithing",
    "smoking",
    "stonecutting"
  ]);
});

// src/arguments/generated/_registry/rule_block_entity_modifiers.ts
var RULE_BLOCK_ENTITY_MODIFIERS_SET;
var init_rule_block_entity_modifiers = __esm(() => {
  init_sandstone();
  RULE_BLOCK_ENTITY_MODIFIERS_SET = new Set2([
    "append_loot",
    "append_static",
    "clear",
    "passthrough"
  ]);
});

// src/arguments/generated/_registry/rule_tests.ts
var RULE_TESTS_SET;
var init_rule_tests = __esm(() => {
  init_sandstone();
  RULE_TESTS_SET = new Set2([
    "all_of",
    "always_true",
    "any_of",
    "block_match",
    "blockstate_match",
    "height_match",
    "not",
    "random_block_match",
    "random_blockstate_match",
    "tag_match"
  ]);
});

// src/arguments/generated/_registry/sensor_types.ts
var SENSOR_TYPES_SET;
var init_sensor_types = __esm(() => {
  init_sandstone();
  SENSOR_TYPES_SET = new Set2([
    "armadillo_scare_detected",
    "axolotl_attackables",
    "breeze_attack_entity_sensor",
    "dummy",
    "food_temptations",
    "frog_attackables",
    "frog_temptations",
    "golem_detected",
    "hoglin_specific_sensor",
    "hurt_by",
    "is_in_water",
    "nautilus_temptations",
    "nearest_adult",
    "nearest_adult_any_type",
    "nearest_bed",
    "nearest_items",
    "nearest_living_entities",
    "nearest_players",
    "piglin_brute_specific_sensor",
    "piglin_specific_sensor",
    "secondary_pois",
    "villager_babies",
    "villager_hostiles",
    "warden_entity_sensor"
  ]);
});

// src/arguments/generated/_registry/slot_displays.ts
var SLOT_DISPLAYS_SET;
var init_slot_displays = __esm(() => {
  init_sandstone();
  SLOT_DISPLAYS_SET = new Set2([
    "any_fuel",
    "composite",
    "dyed",
    "empty",
    "item",
    "item_stack",
    "only_with_component",
    "smithing_trim",
    "tag",
    "with_any_potion",
    "with_remainder"
  ]);
});

// src/arguments/generated/_registry/slot_source_types.ts
var SLOT_SOURCE_TYPES_SET;
var init_slot_source_types = __esm(() => {
  init_sandstone();
  SLOT_SOURCE_TYPES_SET = new Set2([
    "contents",
    "empty",
    "filtered",
    "group",
    "limit_slots",
    "slot_range"
  ]);
});

// src/arguments/generated/_registry/sound_events.ts
var SOUND_EVENTS_SET;
var init_sound_events = __esm(() => {
  init_sandstone();
  SOUND_EVENTS_SET = new Set2([
    "ambient.basalt_deltas.additions",
    "ambient.basalt_deltas.loop",
    "ambient.basalt_deltas.mood",
    "ambient.cave",
    "ambient.crimson_forest.additions",
    "ambient.crimson_forest.loop",
    "ambient.crimson_forest.mood",
    "ambient.nether_wastes.additions",
    "ambient.nether_wastes.loop",
    "ambient.nether_wastes.mood",
    "ambient.soul_sand_valley.additions",
    "ambient.soul_sand_valley.loop",
    "ambient.soul_sand_valley.mood",
    "ambient.underwater.enter",
    "ambient.underwater.exit",
    "ambient.underwater.loop",
    "ambient.underwater.loop.additions",
    "ambient.underwater.loop.additions.rare",
    "ambient.underwater.loop.additions.ultra_rare",
    "ambient.warped_forest.additions",
    "ambient.warped_forest.loop",
    "ambient.warped_forest.mood",
    "block.amethyst_block.break",
    "block.amethyst_block.chime",
    "block.amethyst_block.fall",
    "block.amethyst_block.hit",
    "block.amethyst_block.place",
    "block.amethyst_block.resonate",
    "block.amethyst_block.step",
    "block.amethyst_cluster.break",
    "block.amethyst_cluster.fall",
    "block.amethyst_cluster.hit",
    "block.amethyst_cluster.place",
    "block.amethyst_cluster.step",
    "block.ancient_debris.break",
    "block.ancient_debris.fall",
    "block.ancient_debris.hit",
    "block.ancient_debris.place",
    "block.ancient_debris.step",
    "block.anvil.break",
    "block.anvil.destroy",
    "block.anvil.fall",
    "block.anvil.hit",
    "block.anvil.land",
    "block.anvil.place",
    "block.anvil.step",
    "block.anvil.use",
    "block.azalea.break",
    "block.azalea.fall",
    "block.azalea.hit",
    "block.azalea.place",
    "block.azalea.step",
    "block.azalea_leaves.break",
    "block.azalea_leaves.fall",
    "block.azalea_leaves.hit",
    "block.azalea_leaves.place",
    "block.azalea_leaves.step",
    "block.bamboo.break",
    "block.bamboo.fall",
    "block.bamboo.hit",
    "block.bamboo.place",
    "block.bamboo.step",
    "block.bamboo_sapling.break",
    "block.bamboo_sapling.hit",
    "block.bamboo_sapling.place",
    "block.bamboo_wood.break",
    "block.bamboo_wood.fall",
    "block.bamboo_wood.hit",
    "block.bamboo_wood.place",
    "block.bamboo_wood.step",
    "block.bamboo_wood_button.click_off",
    "block.bamboo_wood_button.click_on",
    "block.bamboo_wood_door.close",
    "block.bamboo_wood_door.open",
    "block.bamboo_wood_fence_gate.close",
    "block.bamboo_wood_fence_gate.open",
    "block.bamboo_wood_hanging_sign.break",
    "block.bamboo_wood_hanging_sign.fall",
    "block.bamboo_wood_hanging_sign.hit",
    "block.bamboo_wood_hanging_sign.place",
    "block.bamboo_wood_hanging_sign.step",
    "block.bamboo_wood_pressure_plate.click_off",
    "block.bamboo_wood_pressure_plate.click_on",
    "block.bamboo_wood_trapdoor.close",
    "block.bamboo_wood_trapdoor.open",
    "block.barrel.close",
    "block.barrel.open",
    "block.basalt.break",
    "block.basalt.fall",
    "block.basalt.hit",
    "block.basalt.place",
    "block.basalt.step",
    "block.beacon.activate",
    "block.beacon.ambient",
    "block.beacon.deactivate",
    "block.beacon.power_select",
    "block.beehive.drip",
    "block.beehive.enter",
    "block.beehive.exit",
    "block.beehive.shear",
    "block.beehive.work",
    "block.bell.resonate",
    "block.bell.use",
    "block.big_dripleaf.break",
    "block.big_dripleaf.fall",
    "block.big_dripleaf.hit",
    "block.big_dripleaf.place",
    "block.big_dripleaf.step",
    "block.big_dripleaf.tilt_down",
    "block.big_dripleaf.tilt_up",
    "block.blastfurnace.fire_crackle",
    "block.bone_block.break",
    "block.bone_block.fall",
    "block.bone_block.hit",
    "block.bone_block.place",
    "block.bone_block.step",
    "block.brewing_stand.brew",
    "block.bubble_column.bubble_pop",
    "block.bubble_column.upwards_ambient",
    "block.bubble_column.upwards_inside",
    "block.bubble_column.whirlpool_ambient",
    "block.bubble_column.whirlpool_inside",
    "block.cactus_flower.break",
    "block.cactus_flower.place",
    "block.cake.add_candle",
    "block.calcite.break",
    "block.calcite.fall",
    "block.calcite.hit",
    "block.calcite.place",
    "block.calcite.step",
    "block.campfire.crackle",
    "block.candle.ambient",
    "block.candle.break",
    "block.candle.extinguish",
    "block.candle.fall",
    "block.candle.hit",
    "block.candle.place",
    "block.candle.step",
    "block.cave_vines.break",
    "block.cave_vines.fall",
    "block.cave_vines.hit",
    "block.cave_vines.pick_berries",
    "block.cave_vines.place",
    "block.cave_vines.step",
    "block.chain.break",
    "block.chain.fall",
    "block.chain.hit",
    "block.chain.place",
    "block.chain.step",
    "block.cherry_leaves.break",
    "block.cherry_leaves.fall",
    "block.cherry_leaves.hit",
    "block.cherry_leaves.place",
    "block.cherry_leaves.step",
    "block.cherry_sapling.break",
    "block.cherry_sapling.fall",
    "block.cherry_sapling.hit",
    "block.cherry_sapling.place",
    "block.cherry_sapling.step",
    "block.cherry_wood.break",
    "block.cherry_wood.fall",
    "block.cherry_wood.hit",
    "block.cherry_wood.place",
    "block.cherry_wood.step",
    "block.cherry_wood_button.click_off",
    "block.cherry_wood_button.click_on",
    "block.cherry_wood_door.close",
    "block.cherry_wood_door.open",
    "block.cherry_wood_fence_gate.close",
    "block.cherry_wood_fence_gate.open",
    "block.cherry_wood_hanging_sign.break",
    "block.cherry_wood_hanging_sign.fall",
    "block.cherry_wood_hanging_sign.hit",
    "block.cherry_wood_hanging_sign.place",
    "block.cherry_wood_hanging_sign.step",
    "block.cherry_wood_pressure_plate.click_off",
    "block.cherry_wood_pressure_plate.click_on",
    "block.cherry_wood_trapdoor.close",
    "block.cherry_wood_trapdoor.open",
    "block.chest.close",
    "block.chest.locked",
    "block.chest.open",
    "block.chiseled_bookshelf.break",
    "block.chiseled_bookshelf.fall",
    "block.chiseled_bookshelf.hit",
    "block.chiseled_bookshelf.insert",
    "block.chiseled_bookshelf.insert.enchanted",
    "block.chiseled_bookshelf.pickup",
    "block.chiseled_bookshelf.pickup.enchanted",
    "block.chiseled_bookshelf.place",
    "block.chiseled_bookshelf.step",
    "block.chorus_flower.death",
    "block.chorus_flower.grow",
    "block.cinnabar.break",
    "block.cinnabar.fall",
    "block.cinnabar.hit",
    "block.cinnabar.place",
    "block.cinnabar.step",
    "block.cobweb.break",
    "block.cobweb.fall",
    "block.cobweb.hit",
    "block.cobweb.place",
    "block.cobweb.step",
    "block.comparator.click",
    "block.composter.empty",
    "block.composter.fill",
    "block.composter.fill_success",
    "block.composter.ready",
    "block.conduit.activate",
    "block.conduit.ambient",
    "block.conduit.ambient.short",
    "block.conduit.attack.target",
    "block.conduit.deactivate",
    "block.copper.break",
    "block.copper.fall",
    "block.copper.hit",
    "block.copper.place",
    "block.copper.step",
    "block.copper_bulb.break",
    "block.copper_bulb.fall",
    "block.copper_bulb.hit",
    "block.copper_bulb.place",
    "block.copper_bulb.step",
    "block.copper_bulb.turn_off",
    "block.copper_bulb.turn_on",
    "block.copper_chest.close",
    "block.copper_chest.open",
    "block.copper_chest_oxidized.close",
    "block.copper_chest_oxidized.open",
    "block.copper_chest_weathered.close",
    "block.copper_chest_weathered.open",
    "block.copper_door.close",
    "block.copper_door.open",
    "block.copper_golem_statue.break",
    "block.copper_golem_statue.fall",
    "block.copper_golem_statue.hit",
    "block.copper_golem_statue.place",
    "block.copper_golem_statue.step",
    "block.copper_grate.break",
    "block.copper_grate.fall",
    "block.copper_grate.hit",
    "block.copper_grate.place",
    "block.copper_grate.step",
    "block.copper_trapdoor.close",
    "block.copper_trapdoor.open",
    "block.coral_block.break",
    "block.coral_block.fall",
    "block.coral_block.hit",
    "block.coral_block.place",
    "block.coral_block.step",
    "block.crafter.craft",
    "block.crafter.fail",
    "block.creaking_heart.break",
    "block.creaking_heart.fall",
    "block.creaking_heart.hit",
    "block.creaking_heart.hurt",
    "block.creaking_heart.idle",
    "block.creaking_heart.place",
    "block.creaking_heart.spawn",
    "block.creaking_heart.step",
    "block.crop.break",
    "block.deadbush.idle",
    "block.decorated_pot.break",
    "block.decorated_pot.fall",
    "block.decorated_pot.hit",
    "block.decorated_pot.insert",
    "block.decorated_pot.insert_fail",
    "block.decorated_pot.place",
    "block.decorated_pot.shatter",
    "block.decorated_pot.step",
    "block.deepslate.break",
    "block.deepslate.fall",
    "block.deepslate.hit",
    "block.deepslate.place",
    "block.deepslate.step",
    "block.deepslate_bricks.break",
    "block.deepslate_bricks.fall",
    "block.deepslate_bricks.hit",
    "block.deepslate_bricks.place",
    "block.deepslate_bricks.step",
    "block.deepslate_tiles.break",
    "block.deepslate_tiles.fall",
    "block.deepslate_tiles.hit",
    "block.deepslate_tiles.place",
    "block.deepslate_tiles.step",
    "block.dispenser.dispense",
    "block.dispenser.fail",
    "block.dispenser.launch",
    "block.dried_ghast.ambient",
    "block.dried_ghast.ambient_water",
    "block.dried_ghast.break",
    "block.dried_ghast.fall",
    "block.dried_ghast.place",
    "block.dried_ghast.place_in_water",
    "block.dried_ghast.step",
    "block.dried_ghast.transition",
    "block.dripstone_block.break",
    "block.dripstone_block.fall",
    "block.dripstone_block.hit",
    "block.dripstone_block.place",
    "block.dripstone_block.step",
    "block.dry_grass.ambient",
    "block.enchantment_table.use",
    "block.end_gateway.spawn",
    "block.end_portal.spawn",
    "block.end_portal_frame.fill",
    "block.ender_chest.close",
    "block.ender_chest.open",
    "block.eyeblossom.close",
    "block.eyeblossom.close_long",
    "block.eyeblossom.idle",
    "block.eyeblossom.open",
    "block.eyeblossom.open_long",
    "block.fence_gate.close",
    "block.fence_gate.open",
    "block.fire.ambient",
    "block.fire.extinguish",
    "block.firefly_bush.idle",
    "block.flowering_azalea.break",
    "block.flowering_azalea.fall",
    "block.flowering_azalea.hit",
    "block.flowering_azalea.place",
    "block.flowering_azalea.step",
    "block.froglight.break",
    "block.froglight.fall",
    "block.froglight.hit",
    "block.froglight.place",
    "block.froglight.step",
    "block.frogspawn.break",
    "block.frogspawn.fall",
    "block.frogspawn.hatch",
    "block.frogspawn.hit",
    "block.frogspawn.place",
    "block.frogspawn.step",
    "block.fungus.break",
    "block.fungus.fall",
    "block.fungus.hit",
    "block.fungus.place",
    "block.fungus.step",
    "block.furnace.fire_crackle",
    "block.gilded_blackstone.break",
    "block.gilded_blackstone.fall",
    "block.gilded_blackstone.hit",
    "block.gilded_blackstone.place",
    "block.gilded_blackstone.step",
    "block.glass.break",
    "block.glass.fall",
    "block.glass.hit",
    "block.glass.place",
    "block.glass.step",
    "block.grass.break",
    "block.grass.fall",
    "block.grass.hit",
    "block.grass.place",
    "block.grass.step",
    "block.gravel.break",
    "block.gravel.fall",
    "block.gravel.hit",
    "block.gravel.place",
    "block.gravel.step",
    "block.grindstone.use",
    "block.growing_plant.crop",
    "block.hanging_roots.break",
    "block.hanging_roots.fall",
    "block.hanging_roots.hit",
    "block.hanging_roots.place",
    "block.hanging_roots.step",
    "block.hanging_sign.break",
    "block.hanging_sign.fall",
    "block.hanging_sign.hit",
    "block.hanging_sign.place",
    "block.hanging_sign.step",
    "block.hanging_sign.waxed_interact_fail",
    "block.heavy_core.break",
    "block.heavy_core.fall",
    "block.heavy_core.hit",
    "block.heavy_core.place",
    "block.heavy_core.step",
    "block.honey_block.break",
    "block.honey_block.fall",
    "block.honey_block.hit",
    "block.honey_block.place",
    "block.honey_block.slide",
    "block.honey_block.step",
    "block.iron.break",
    "block.iron.fall",
    "block.iron.hit",
    "block.iron.place",
    "block.iron.step",
    "block.iron_door.close",
    "block.iron_door.open",
    "block.iron_trapdoor.close",
    "block.iron_trapdoor.open",
    "block.ladder.break",
    "block.ladder.fall",
    "block.ladder.hit",
    "block.ladder.place",
    "block.ladder.step",
    "block.lantern.break",
    "block.lantern.fall",
    "block.lantern.hit",
    "block.lantern.place",
    "block.lantern.step",
    "block.large_amethyst_bud.break",
    "block.large_amethyst_bud.place",
    "block.lava.ambient",
    "block.lava.extinguish",
    "block.lava.pop",
    "block.leaf_litter.break",
    "block.leaf_litter.fall",
    "block.leaf_litter.hit",
    "block.leaf_litter.place",
    "block.leaf_litter.step",
    "block.lever.click",
    "block.lily_pad.place",
    "block.lodestone.break",
    "block.lodestone.fall",
    "block.lodestone.hit",
    "block.lodestone.place",
    "block.lodestone.step",
    "block.mangrove_roots.break",
    "block.mangrove_roots.fall",
    "block.mangrove_roots.hit",
    "block.mangrove_roots.place",
    "block.mangrove_roots.step",
    "block.medium_amethyst_bud.break",
    "block.medium_amethyst_bud.place",
    "block.metal.break",
    "block.metal.fall",
    "block.metal.hit",
    "block.metal.place",
    "block.metal.step",
    "block.metal_pressure_plate.click_off",
    "block.metal_pressure_plate.click_on",
    "block.moss.break",
    "block.moss.fall",
    "block.moss.hit",
    "block.moss.place",
    "block.moss.step",
    "block.moss_carpet.break",
    "block.moss_carpet.fall",
    "block.moss_carpet.hit",
    "block.moss_carpet.place",
    "block.moss_carpet.step",
    "block.mud.break",
    "block.mud.fall",
    "block.mud.hit",
    "block.mud.place",
    "block.mud.step",
    "block.mud_bricks.break",
    "block.mud_bricks.fall",
    "block.mud_bricks.hit",
    "block.mud_bricks.place",
    "block.mud_bricks.step",
    "block.muddy_mangrove_roots.break",
    "block.muddy_mangrove_roots.fall",
    "block.muddy_mangrove_roots.hit",
    "block.muddy_mangrove_roots.place",
    "block.muddy_mangrove_roots.step",
    "block.nether_bricks.break",
    "block.nether_bricks.fall",
    "block.nether_bricks.hit",
    "block.nether_bricks.place",
    "block.nether_bricks.step",
    "block.nether_gold_ore.break",
    "block.nether_gold_ore.fall",
    "block.nether_gold_ore.hit",
    "block.nether_gold_ore.place",
    "block.nether_gold_ore.step",
    "block.nether_ore.break",
    "block.nether_ore.fall",
    "block.nether_ore.hit",
    "block.nether_ore.place",
    "block.nether_ore.step",
    "block.nether_sprouts.break",
    "block.nether_sprouts.fall",
    "block.nether_sprouts.hit",
    "block.nether_sprouts.place",
    "block.nether_sprouts.step",
    "block.nether_wart.break",
    "block.nether_wood.break",
    "block.nether_wood.fall",
    "block.nether_wood.hit",
    "block.nether_wood.place",
    "block.nether_wood.step",
    "block.nether_wood_button.click_off",
    "block.nether_wood_button.click_on",
    "block.nether_wood_door.close",
    "block.nether_wood_door.open",
    "block.nether_wood_fence_gate.close",
    "block.nether_wood_fence_gate.open",
    "block.nether_wood_hanging_sign.break",
    "block.nether_wood_hanging_sign.fall",
    "block.nether_wood_hanging_sign.hit",
    "block.nether_wood_hanging_sign.place",
    "block.nether_wood_hanging_sign.step",
    "block.nether_wood_pressure_plate.click_off",
    "block.nether_wood_pressure_plate.click_on",
    "block.nether_wood_trapdoor.close",
    "block.nether_wood_trapdoor.open",
    "block.netherite_block.break",
    "block.netherite_block.fall",
    "block.netherite_block.hit",
    "block.netherite_block.place",
    "block.netherite_block.step",
    "block.netherrack.break",
    "block.netherrack.fall",
    "block.netherrack.hit",
    "block.netherrack.place",
    "block.netherrack.step",
    "block.note_block.banjo",
    "block.note_block.basedrum",
    "block.note_block.bass",
    "block.note_block.bell",
    "block.note_block.bit",
    "block.note_block.chime",
    "block.note_block.cow_bell",
    "block.note_block.didgeridoo",
    "block.note_block.flute",
    "block.note_block.guitar",
    "block.note_block.harp",
    "block.note_block.hat",
    "block.note_block.imitate.creeper",
    "block.note_block.imitate.ender_dragon",
    "block.note_block.imitate.piglin",
    "block.note_block.imitate.skeleton",
    "block.note_block.imitate.wither_skeleton",
    "block.note_block.imitate.zombie",
    "block.note_block.iron_xylophone",
    "block.note_block.pling",
    "block.note_block.snare",
    "block.note_block.trumpet",
    "block.note_block.trumpet_exposed",
    "block.note_block.trumpet_oxidized",
    "block.note_block.trumpet_weathered",
    "block.note_block.xylophone",
    "block.nylium.break",
    "block.nylium.fall",
    "block.nylium.hit",
    "block.nylium.place",
    "block.nylium.step",
    "block.packed_mud.break",
    "block.packed_mud.fall",
    "block.packed_mud.hit",
    "block.packed_mud.place",
    "block.packed_mud.step",
    "block.pale_hanging_moss.idle",
    "block.pink_petals.break",
    "block.pink_petals.fall",
    "block.pink_petals.hit",
    "block.pink_petals.place",
    "block.pink_petals.step",
    "block.piston.contract",
    "block.piston.extend",
    "block.pointed_dripstone.break",
    "block.pointed_dripstone.drip_lava",
    "block.pointed_dripstone.drip_lava_into_cauldron",
    "block.pointed_dripstone.drip_water",
    "block.pointed_dripstone.drip_water_into_cauldron",
    "block.pointed_dripstone.fall",
    "block.pointed_dripstone.hit",
    "block.pointed_dripstone.land",
    "block.pointed_dripstone.place",
    "block.pointed_dripstone.step",
    "block.polished_deepslate.break",
    "block.polished_deepslate.fall",
    "block.polished_deepslate.hit",
    "block.polished_deepslate.place",
    "block.polished_deepslate.step",
    "block.polished_tuff.break",
    "block.polished_tuff.fall",
    "block.polished_tuff.hit",
    "block.polished_tuff.place",
    "block.polished_tuff.step",
    "block.poplar_leaves.ambient",
    "block.poplar_leaves.break",
    "block.poplar_leaves.fall",
    "block.poplar_leaves.hit",
    "block.poplar_leaves.place",
    "block.poplar_leaves.step",
    "block.portal.ambient",
    "block.portal.travel",
    "block.portal.trigger",
    "block.potent_sulfur.break",
    "block.potent_sulfur.fall",
    "block.potent_sulfur.geyser_continuous_eruption",
    "block.potent_sulfur.geyser_continuous_eruption_active",
    "block.potent_sulfur.geyser_eruption",
    "block.potent_sulfur.geyser_eruption_active",
    "block.potent_sulfur.hit",
    "block.potent_sulfur.noxious_gas",
    "block.potent_sulfur.place",
    "block.potent_sulfur.step",
    "block.powder_snow.break",
    "block.powder_snow.fall",
    "block.powder_snow.hit",
    "block.powder_snow.place",
    "block.powder_snow.step",
    "block.pumpkin.carve",
    "block.red_shrub.break",
    "block.red_shrub.place",
    "block.redstone_torch.burnout",
    "block.resin.break",
    "block.resin.fall",
    "block.resin.place",
    "block.resin.step",
    "block.resin_bricks.break",
    "block.resin_bricks.fall",
    "block.resin_bricks.hit",
    "block.resin_bricks.place",
    "block.resin_bricks.step",
    "block.respawn_anchor.ambient",
    "block.respawn_anchor.charge",
    "block.respawn_anchor.deplete",
    "block.respawn_anchor.set_spawn",
    "block.rooted_dirt.break",
    "block.rooted_dirt.fall",
    "block.rooted_dirt.hit",
    "block.rooted_dirt.place",
    "block.rooted_dirt.step",
    "block.roots.break",
    "block.roots.fall",
    "block.roots.hit",
    "block.roots.place",
    "block.roots.step",
    "block.sand.break",
    "block.sand.fall",
    "block.sand.hit",
    "block.sand.idle",
    "block.sand.place",
    "block.sand.step",
    "block.scaffolding.break",
    "block.scaffolding.fall",
    "block.scaffolding.hit",
    "block.scaffolding.place",
    "block.scaffolding.step",
    "block.sculk.break",
    "block.sculk.charge",
    "block.sculk.fall",
    "block.sculk.hit",
    "block.sculk.place",
    "block.sculk.spread",
    "block.sculk.step",
    "block.sculk_catalyst.bloom",
    "block.sculk_catalyst.break",
    "block.sculk_catalyst.fall",
    "block.sculk_catalyst.hit",
    "block.sculk_catalyst.place",
    "block.sculk_catalyst.step",
    "block.sculk_sensor.break",
    "block.sculk_sensor.clicking",
    "block.sculk_sensor.clicking_stop",
    "block.sculk_sensor.fall",
    "block.sculk_sensor.hit",
    "block.sculk_sensor.place",
    "block.sculk_sensor.step",
    "block.sculk_shrieker.break",
    "block.sculk_shrieker.fall",
    "block.sculk_shrieker.hit",
    "block.sculk_shrieker.place",
    "block.sculk_shrieker.shriek",
    "block.sculk_shrieker.step",
    "block.sculk_vein.break",
    "block.sculk_vein.fall",
    "block.sculk_vein.hit",
    "block.sculk_vein.place",
    "block.sculk_vein.step",
    "block.shelf.activate",
    "block.shelf.break",
    "block.shelf.deactivate",
    "block.shelf.fall",
    "block.shelf.hit",
    "block.shelf.multi_swap",
    "block.shelf.place",
    "block.shelf.place_item",
    "block.shelf.single_swap",
    "block.shelf.step",
    "block.shelf.take_item",
    "block.shelf_mushroom.bounce",
    "block.shelf_mushroom.break",
    "block.shelf_mushroom.fall",
    "block.shelf_mushroom.place",
    "block.shelf_mushroom.step",
    "block.shroomlight.break",
    "block.shroomlight.fall",
    "block.shroomlight.hit",
    "block.shroomlight.place",
    "block.shroomlight.step",
    "block.shulker_box.close",
    "block.shulker_box.open",
    "block.sign.waxed_interact_fail",
    "block.slime_block.break",
    "block.slime_block.fall",
    "block.slime_block.hit",
    "block.slime_block.place",
    "block.slime_block.step",
    "block.small_amethyst_bud.break",
    "block.small_amethyst_bud.place",
    "block.small_dripleaf.break",
    "block.small_dripleaf.fall",
    "block.small_dripleaf.hit",
    "block.small_dripleaf.place",
    "block.small_dripleaf.step",
    "block.smithing_table.use",
    "block.smoker.smoke",
    "block.sniffer_egg.crack",
    "block.sniffer_egg.hatch",
    "block.sniffer_egg.plop",
    "block.snow.break",
    "block.snow.fall",
    "block.snow.hit",
    "block.snow.place",
    "block.snow.step",
    "block.soul_sand.break",
    "block.soul_sand.fall",
    "block.soul_sand.hit",
    "block.soul_sand.place",
    "block.soul_sand.step",
    "block.soul_soil.break",
    "block.soul_soil.fall",
    "block.soul_soil.hit",
    "block.soul_soil.place",
    "block.soul_soil.step",
    "block.spawner.break",
    "block.spawner.fall",
    "block.spawner.hit",
    "block.spawner.place",
    "block.spawner.step",
    "block.sponge.absorb",
    "block.sponge.break",
    "block.sponge.fall",
    "block.sponge.hit",
    "block.sponge.place",
    "block.sponge.step",
    "block.spore_blossom.break",
    "block.spore_blossom.fall",
    "block.spore_blossom.hit",
    "block.spore_blossom.place",
    "block.spore_blossom.step",
    "block.stem.break",
    "block.stem.fall",
    "block.stem.hit",
    "block.stem.place",
    "block.stem.step",
    "block.stone.break",
    "block.stone.fall",
    "block.stone.hit",
    "block.stone.place",
    "block.stone.step",
    "block.stone_button.click_off",
    "block.stone_button.click_on",
    "block.stone_pressure_plate.click_off",
    "block.stone_pressure_plate.click_on",
    "block.straw_bed.break",
    "block.straw_bed.break_leave",
    "block.straw_bed.fall",
    "block.straw_bed.hit",
    "block.straw_bed.place",
    "block.straw_bed.step",
    "block.sulfur.break",
    "block.sulfur.fall",
    "block.sulfur.hit",
    "block.sulfur.place",
    "block.sulfur.step",
    "block.sulfur_spike.break",
    "block.sulfur_spike.fall",
    "block.sulfur_spike.hit",
    "block.sulfur_spike.land",
    "block.sulfur_spike.place",
    "block.sulfur_spike.step",
    "block.suspicious_gravel.break",
    "block.suspicious_gravel.fall",
    "block.suspicious_gravel.hit",
    "block.suspicious_gravel.place",
    "block.suspicious_gravel.step",
    "block.suspicious_sand.break",
    "block.suspicious_sand.fall",
    "block.suspicious_sand.hit",
    "block.suspicious_sand.place",
    "block.suspicious_sand.step",
    "block.sweet_berry_bush.break",
    "block.sweet_berry_bush.pick_berries",
    "block.sweet_berry_bush.place",
    "block.trial_spawner.about_to_spawn_item",
    "block.trial_spawner.ambient",
    "block.trial_spawner.ambient_ominous",
    "block.trial_spawner.break",
    "block.trial_spawner.close_shutter",
    "block.trial_spawner.detect_player",
    "block.trial_spawner.eject_item",
    "block.trial_spawner.fall",
    "block.trial_spawner.hit",
    "block.trial_spawner.ominous_activate",
    "block.trial_spawner.open_shutter",
    "block.trial_spawner.place",
    "block.trial_spawner.spawn_item",
    "block.trial_spawner.spawn_item_begin",
    "block.trial_spawner.spawn_mob",
    "block.trial_spawner.step",
    "block.tripwire.attach",
    "block.tripwire.click_off",
    "block.tripwire.click_on",
    "block.tripwire.detach",
    "block.tuff.break",
    "block.tuff.fall",
    "block.tuff.hit",
    "block.tuff.place",
    "block.tuff.step",
    "block.tuff_bricks.break",
    "block.tuff_bricks.fall",
    "block.tuff_bricks.hit",
    "block.tuff_bricks.place",
    "block.tuff_bricks.step",
    "block.vault.activate",
    "block.vault.ambient",
    "block.vault.break",
    "block.vault.close_shutter",
    "block.vault.deactivate",
    "block.vault.eject_item",
    "block.vault.fall",
    "block.vault.hit",
    "block.vault.insert_item",
    "block.vault.insert_item_fail",
    "block.vault.open_shutter",
    "block.vault.place",
    "block.vault.reject_rewarded_player",
    "block.vault.step",
    "block.vine.break",
    "block.vine.fall",
    "block.vine.hit",
    "block.vine.place",
    "block.vine.step",
    "block.wart_block.break",
    "block.wart_block.fall",
    "block.wart_block.hit",
    "block.wart_block.place",
    "block.wart_block.step",
    "block.water.ambient",
    "block.weeping_vines.break",
    "block.weeping_vines.fall",
    "block.weeping_vines.hit",
    "block.weeping_vines.place",
    "block.weeping_vines.step",
    "block.wet_grass.break",
    "block.wet_grass.fall",
    "block.wet_grass.hit",
    "block.wet_grass.place",
    "block.wet_grass.step",
    "block.wet_sponge.break",
    "block.wet_sponge.dries",
    "block.wet_sponge.fall",
    "block.wet_sponge.hit",
    "block.wet_sponge.place",
    "block.wet_sponge.step",
    "block.wood.break",
    "block.wood.fall",
    "block.wood.hit",
    "block.wood.place",
    "block.wood.step",
    "block.wooden_button.click_off",
    "block.wooden_button.click_on",
    "block.wooden_door.close",
    "block.wooden_door.open",
    "block.wooden_pressure_plate.click_off",
    "block.wooden_pressure_plate.click_on",
    "block.wooden_trapdoor.close",
    "block.wooden_trapdoor.open",
    "block.wool.break",
    "block.wool.fall",
    "block.wool.hit",
    "block.wool.place",
    "block.wool.step",
    "enchant.thorns.hit",
    "entity.allay.ambient_with_item",
    "entity.allay.ambient_without_item",
    "entity.allay.death",
    "entity.allay.hurt",
    "entity.allay.item_given",
    "entity.allay.item_taken",
    "entity.allay.item_thrown",
    "entity.armadillo.ambient",
    "entity.armadillo.brush",
    "entity.armadillo.death",
    "entity.armadillo.eat",
    "entity.armadillo.hurt",
    "entity.armadillo.hurt_reduced",
    "entity.armadillo.land",
    "entity.armadillo.peek",
    "entity.armadillo.roll",
    "entity.armadillo.scute_drop",
    "entity.armadillo.step",
    "entity.armadillo.unroll_finish",
    "entity.armadillo.unroll_start",
    "entity.armor_stand.break",
    "entity.armor_stand.fall",
    "entity.armor_stand.hit",
    "entity.armor_stand.place",
    "entity.arrow.hit",
    "entity.arrow.hit_player",
    "entity.arrow.shoot",
    "entity.axolotl.attack",
    "entity.axolotl.death",
    "entity.axolotl.hurt",
    "entity.axolotl.idle_air",
    "entity.axolotl.idle_water",
    "entity.axolotl.splash",
    "entity.axolotl.swim",
    "entity.baby_cat.ambient",
    "entity.baby_cat.beg_for_food",
    "entity.baby_cat.death",
    "entity.baby_cat.eat",
    "entity.baby_cat.hiss",
    "entity.baby_cat.hurt",
    "entity.baby_cat.purr",
    "entity.baby_cat.purreow",
    "entity.baby_cat.stray_ambient",
    "entity.baby_chicken.ambient",
    "entity.baby_chicken.death",
    "entity.baby_chicken.hurt",
    "entity.baby_chicken.step",
    "entity.baby_horse.ambient",
    "entity.baby_horse.angry",
    "entity.baby_horse.breathe",
    "entity.baby_horse.death",
    "entity.baby_horse.eat",
    "entity.baby_horse.hurt",
    "entity.baby_horse.land",
    "entity.baby_horse.step",
    "entity.baby_nautilus.ambient",
    "entity.baby_nautilus.ambient_land",
    "entity.baby_nautilus.death",
    "entity.baby_nautilus.death_land",
    "entity.baby_nautilus.eat",
    "entity.baby_nautilus.hurt",
    "entity.baby_nautilus.hurt_land",
    "entity.baby_nautilus.swim",
    "entity.baby_pig.ambient",
    "entity.baby_pig.death",
    "entity.baby_pig.eat",
    "entity.baby_pig.hurt",
    "entity.baby_pig.step",
    "entity.baby_wolf.ambient",
    "entity.baby_wolf.death",
    "entity.baby_wolf.growl",
    "entity.baby_wolf.hurt",
    "entity.baby_wolf.pant",
    "entity.baby_wolf.step",
    "entity.baby_wolf.whine",
    "entity.bat.ambient",
    "entity.bat.death",
    "entity.bat.hurt",
    "entity.bat.loop",
    "entity.bat.takeoff",
    "entity.bee.death",
    "entity.bee.hurt",
    "entity.bee.loop",
    "entity.bee.loop_aggressive",
    "entity.bee.pollinate",
    "entity.bee.sting",
    "entity.blaze.ambient",
    "entity.blaze.burn",
    "entity.blaze.death",
    "entity.blaze.hurt",
    "entity.blaze.shoot",
    "entity.boat.paddle_land",
    "entity.boat.paddle_water",
    "entity.bogged.ambient",
    "entity.bogged.death",
    "entity.bogged.hurt",
    "entity.bogged.shear",
    "entity.bogged.step",
    "entity.breeze.charge",
    "entity.breeze.death",
    "entity.breeze.deflect",
    "entity.breeze.hurt",
    "entity.breeze.idle_air",
    "entity.breeze.idle_ground",
    "entity.breeze.inhale",
    "entity.breeze.jump",
    "entity.breeze.land",
    "entity.breeze.shoot",
    "entity.breeze.slide",
    "entity.breeze.whirl",
    "entity.breeze.wind_burst",
    "entity.camel.ambient",
    "entity.camel.dash",
    "entity.camel.dash_ready",
    "entity.camel.death",
    "entity.camel.eat",
    "entity.camel.hurt",
    "entity.camel.saddle",
    "entity.camel.sit",
    "entity.camel.stand",
    "entity.camel.step",
    "entity.camel.step_sand",
    "entity.camel_husk.ambient",
    "entity.camel_husk.dash",
    "entity.camel_husk.dash_ready",
    "entity.camel_husk.death",
    "entity.camel_husk.eat",
    "entity.camel_husk.hurt",
    "entity.camel_husk.saddle",
    "entity.camel_husk.sit",
    "entity.camel_husk.stand",
    "entity.camel_husk.step",
    "entity.camel_husk.step_sand",
    "entity.cat.ambient",
    "entity.cat.beg_for_food",
    "entity.cat.death",
    "entity.cat.eat",
    "entity.cat.hiss",
    "entity.cat.hurt",
    "entity.cat.purr",
    "entity.cat.purreow",
    "entity.cat.stray_ambient",
    "entity.cat_royal.ambient",
    "entity.cat_royal.beg_for_food",
    "entity.cat_royal.death",
    "entity.cat_royal.eat",
    "entity.cat_royal.hiss",
    "entity.cat_royal.hurt",
    "entity.cat_royal.purr",
    "entity.cat_royal.purreow",
    "entity.cat_royal.stray_ambient",
    "entity.chicken.ambient",
    "entity.chicken.death",
    "entity.chicken.egg",
    "entity.chicken.hurt",
    "entity.chicken.step",
    "entity.chicken_picky.ambient",
    "entity.chicken_picky.death",
    "entity.chicken_picky.hurt",
    "entity.cod.ambient",
    "entity.cod.death",
    "entity.cod.flop",
    "entity.cod.hurt",
    "entity.copper_golem.death",
    "entity.copper_golem.hurt",
    "entity.copper_golem.item_drop",
    "entity.copper_golem.item_no_drop",
    "entity.copper_golem.no_item_get",
    "entity.copper_golem.no_item_no_get",
    "entity.copper_golem.shear",
    "entity.copper_golem.spawn",
    "entity.copper_golem.spin",
    "entity.copper_golem.step",
    "entity.copper_golem_become_statue",
    "entity.copper_golem_oxidized.death",
    "entity.copper_golem_oxidized.hurt",
    "entity.copper_golem_oxidized.spin",
    "entity.copper_golem_oxidized.step",
    "entity.copper_golem_weathered.death",
    "entity.copper_golem_weathered.hurt",
    "entity.copper_golem_weathered.spin",
    "entity.copper_golem_weathered.step",
    "entity.cow.ambient",
    "entity.cow.death",
    "entity.cow.hurt",
    "entity.cow.milk",
    "entity.cow.step",
    "entity.cow_moody.ambient",
    "entity.cow_moody.death",
    "entity.cow_moody.hurt",
    "entity.cow_moody.step",
    "entity.creaking.activate",
    "entity.creaking.ambient",
    "entity.creaking.attack",
    "entity.creaking.deactivate",
    "entity.creaking.death",
    "entity.creaking.freeze",
    "entity.creaking.spawn",
    "entity.creaking.step",
    "entity.creaking.sway",
    "entity.creaking.twitch",
    "entity.creaking.unfreeze",
    "entity.creeper.death",
    "entity.creeper.hurt",
    "entity.creeper.primed",
    "entity.cushion.break",
    "entity.cushion.get_up",
    "entity.cushion.place",
    "entity.cushion.sit",
    "entity.dolphin.ambient",
    "entity.dolphin.ambient_water",
    "entity.dolphin.attack",
    "entity.dolphin.death",
    "entity.dolphin.eat",
    "entity.dolphin.hurt",
    "entity.dolphin.jump",
    "entity.dolphin.play",
    "entity.dolphin.splash",
    "entity.dolphin.swim",
    "entity.donkey.ambient",
    "entity.donkey.angry",
    "entity.donkey.chest",
    "entity.donkey.death",
    "entity.donkey.eat",
    "entity.donkey.hurt",
    "entity.donkey.jump",
    "entity.dragon_fireball.explode",
    "entity.drowned.ambient",
    "entity.drowned.ambient_water",
    "entity.drowned.death",
    "entity.drowned.death_water",
    "entity.drowned.hurt",
    "entity.drowned.hurt_water",
    "entity.drowned.shoot",
    "entity.drowned.step",
    "entity.drowned.swim",
    "entity.egg.throw",
    "entity.elder_guardian.ambient",
    "entity.elder_guardian.ambient_land",
    "entity.elder_guardian.curse",
    "entity.elder_guardian.death",
    "entity.elder_guardian.death_land",
    "entity.elder_guardian.flop",
    "entity.elder_guardian.hurt",
    "entity.elder_guardian.hurt_land",
    "entity.ender_dragon.ambient",
    "entity.ender_dragon.death",
    "entity.ender_dragon.flap",
    "entity.ender_dragon.growl",
    "entity.ender_dragon.hurt",
    "entity.ender_dragon.shoot",
    "entity.ender_eye.death",
    "entity.ender_eye.launch",
    "entity.ender_pearl.throw",
    "entity.enderman.ambient",
    "entity.enderman.death",
    "entity.enderman.hurt",
    "entity.enderman.scream",
    "entity.enderman.stare",
    "entity.enderman.teleport",
    "entity.endermite.ambient",
    "entity.endermite.death",
    "entity.endermite.hurt",
    "entity.endermite.step",
    "entity.evoker.ambient",
    "entity.evoker.cast_spell",
    "entity.evoker.celebrate",
    "entity.evoker.death",
    "entity.evoker.hurt",
    "entity.evoker.prepare_attack",
    "entity.evoker.prepare_summon",
    "entity.evoker.prepare_wololo",
    "entity.evoker_fangs.attack",
    "entity.experience_bottle.throw",
    "entity.experience_orb.pickup",
    "entity.firework_rocket.blast",
    "entity.firework_rocket.blast_far",
    "entity.firework_rocket.large_blast",
    "entity.firework_rocket.large_blast_far",
    "entity.firework_rocket.launch",
    "entity.firework_rocket.shoot",
    "entity.firework_rocket.twinkle",
    "entity.firework_rocket.twinkle_far",
    "entity.fish.swim",
    "entity.fishing_bobber.retrieve",
    "entity.fishing_bobber.splash",
    "entity.fishing_bobber.throw",
    "entity.fox.aggro",
    "entity.fox.ambient",
    "entity.fox.bite",
    "entity.fox.death",
    "entity.fox.eat",
    "entity.fox.hurt",
    "entity.fox.screech",
    "entity.fox.sleep",
    "entity.fox.sniff",
    "entity.fox.spit",
    "entity.fox.teleport",
    "entity.frog.ambient",
    "entity.frog.death",
    "entity.frog.eat",
    "entity.frog.hurt",
    "entity.frog.lay_spawn",
    "entity.frog.long_jump",
    "entity.frog.step",
    "entity.frog.tongue",
    "entity.generic.big_fall",
    "entity.generic.burn",
    "entity.generic.death",
    "entity.generic.drink",
    "entity.generic.eat",
    "entity.generic.explode",
    "entity.generic.extinguish_fire",
    "entity.generic.hurt",
    "entity.generic.small_fall",
    "entity.generic.splash",
    "entity.generic.swim",
    "entity.ghast.ambient",
    "entity.ghast.death",
    "entity.ghast.hurt",
    "entity.ghast.scream",
    "entity.ghast.shoot",
    "entity.ghast.warn",
    "entity.ghastling.ambient",
    "entity.ghastling.death",
    "entity.ghastling.hurt",
    "entity.ghastling.spawn",
    "entity.glow_item_frame.add_item",
    "entity.glow_item_frame.break",
    "entity.glow_item_frame.place",
    "entity.glow_item_frame.remove_item",
    "entity.glow_item_frame.rotate_item",
    "entity.glow_squid.ambient",
    "entity.glow_squid.death",
    "entity.glow_squid.hurt",
    "entity.glow_squid.squirt",
    "entity.goat.ambient",
    "entity.goat.death",
    "entity.goat.eat",
    "entity.goat.horn_break",
    "entity.goat.hurt",
    "entity.goat.long_jump",
    "entity.goat.milk",
    "entity.goat.prepare_ram",
    "entity.goat.ram_impact",
    "entity.goat.screaming.ambient",
    "entity.goat.screaming.death",
    "entity.goat.screaming.eat",
    "entity.goat.screaming.hurt",
    "entity.goat.screaming.long_jump",
    "entity.goat.screaming.milk",
    "entity.goat.screaming.prepare_ram",
    "entity.goat.screaming.ram_impact",
    "entity.goat.step",
    "entity.guardian.ambient",
    "entity.guardian.ambient_land",
    "entity.guardian.attack",
    "entity.guardian.death",
    "entity.guardian.death_land",
    "entity.guardian.flop",
    "entity.guardian.hurt",
    "entity.guardian.hurt_land",
    "entity.happy_ghast.ambient",
    "entity.happy_ghast.death",
    "entity.happy_ghast.equip",
    "entity.happy_ghast.harness_goggles_down",
    "entity.happy_ghast.harness_goggles_up",
    "entity.happy_ghast.hurt",
    "entity.happy_ghast.riding",
    "entity.happy_ghast.unequip",
    "entity.hoglin.ambient",
    "entity.hoglin.angry",
    "entity.hoglin.attack",
    "entity.hoglin.converted_to_zombified",
    "entity.hoglin.death",
    "entity.hoglin.hurt",
    "entity.hoglin.retreat",
    "entity.hoglin.step",
    "entity.horse.ambient",
    "entity.horse.angry",
    "entity.horse.armor",
    "entity.horse.breathe",
    "entity.horse.death",
    "entity.horse.eat",
    "entity.horse.gallop",
    "entity.horse.hurt",
    "entity.horse.jump",
    "entity.horse.land",
    "entity.horse.saddle",
    "entity.horse.step",
    "entity.horse.step_wood",
    "entity.hostile.big_fall",
    "entity.hostile.death",
    "entity.hostile.hurt",
    "entity.hostile.small_fall",
    "entity.hostile.splash",
    "entity.hostile.swim",
    "entity.husk.ambient",
    "entity.husk.converted_to_zombie",
    "entity.husk.death",
    "entity.husk.hurt",
    "entity.husk.step",
    "entity.illusioner.ambient",
    "entity.illusioner.cast_spell",
    "entity.illusioner.death",
    "entity.illusioner.hurt",
    "entity.illusioner.mirror_move",
    "entity.illusioner.prepare_blindness",
    "entity.illusioner.prepare_mirror",
    "entity.iron_golem.attack",
    "entity.iron_golem.damage",
    "entity.iron_golem.death",
    "entity.iron_golem.hurt",
    "entity.iron_golem.repair",
    "entity.iron_golem.step",
    "entity.item.break",
    "entity.item.pickup",
    "entity.item_frame.add_item",
    "entity.item_frame.break",
    "entity.item_frame.place",
    "entity.item_frame.remove_item",
    "entity.item_frame.rotate_item",
    "entity.lightning_bolt.impact",
    "entity.lightning_bolt.thunder",
    "entity.lingering_potion.throw",
    "entity.llama.ambient",
    "entity.llama.angry",
    "entity.llama.chest",
    "entity.llama.death",
    "entity.llama.eat",
    "entity.llama.hurt",
    "entity.llama.spit",
    "entity.llama.step",
    "entity.llama.swag",
    "entity.magma_cube.death",
    "entity.magma_cube.death_small",
    "entity.magma_cube.hurt",
    "entity.magma_cube.hurt_small",
    "entity.magma_cube.jump",
    "entity.magma_cube.squish",
    "entity.magma_cube.squish_small",
    "entity.minecart.inside",
    "entity.minecart.inside.underwater",
    "entity.minecart.riding",
    "entity.mooshroom.convert",
    "entity.mooshroom.eat",
    "entity.mooshroom.milk",
    "entity.mooshroom.shear",
    "entity.mooshroom.suspicious_milk",
    "entity.mule.ambient",
    "entity.mule.angry",
    "entity.mule.chest",
    "entity.mule.death",
    "entity.mule.eat",
    "entity.mule.hurt",
    "entity.mule.jump",
    "entity.nautilus.ambient",
    "entity.nautilus.ambient_land",
    "entity.nautilus.dash",
    "entity.nautilus.dash_land",
    "entity.nautilus.dash_ready",
    "entity.nautilus.dash_ready_land",
    "entity.nautilus.death",
    "entity.nautilus.death_land",
    "entity.nautilus.eat",
    "entity.nautilus.hurt",
    "entity.nautilus.hurt_land",
    "entity.nautilus.riding",
    "entity.nautilus.swim",
    "entity.ocelot.ambient",
    "entity.ocelot.death",
    "entity.ocelot.hurt",
    "entity.painting.break",
    "entity.painting.place",
    "entity.panda.aggressive_ambient",
    "entity.panda.ambient",
    "entity.panda.bite",
    "entity.panda.cant_breed",
    "entity.panda.death",
    "entity.panda.eat",
    "entity.panda.hurt",
    "entity.panda.pre_sneeze",
    "entity.panda.sneeze",
    "entity.panda.step",
    "entity.panda.worried_ambient",
    "entity.parched.ambient",
    "entity.parched.death",
    "entity.parched.hurt",
    "entity.parched.step",
    "entity.parrot.ambient",
    "entity.parrot.death",
    "entity.parrot.eat",
    "entity.parrot.fly",
    "entity.parrot.hurt",
    "entity.parrot.imitate.blaze",
    "entity.parrot.imitate.bogged",
    "entity.parrot.imitate.breeze",
    "entity.parrot.imitate.camel_husk",
    "entity.parrot.imitate.creaking",
    "entity.parrot.imitate.creeper",
    "entity.parrot.imitate.drowned",
    "entity.parrot.imitate.elder_guardian",
    "entity.parrot.imitate.ender_dragon",
    "entity.parrot.imitate.endermite",
    "entity.parrot.imitate.evoker",
    "entity.parrot.imitate.ghast",
    "entity.parrot.imitate.guardian",
    "entity.parrot.imitate.hoglin",
    "entity.parrot.imitate.husk",
    "entity.parrot.imitate.illusioner",
    "entity.parrot.imitate.magma_cube",
    "entity.parrot.imitate.parched",
    "entity.parrot.imitate.phantom",
    "entity.parrot.imitate.piglin",
    "entity.parrot.imitate.piglin_brute",
    "entity.parrot.imitate.pillager",
    "entity.parrot.imitate.ravager",
    "entity.parrot.imitate.shulker",
    "entity.parrot.imitate.silverfish",
    "entity.parrot.imitate.skeleton",
    "entity.parrot.imitate.slime",
    "entity.parrot.imitate.spider",
    "entity.parrot.imitate.stray",
    "entity.parrot.imitate.vex",
    "entity.parrot.imitate.vindicator",
    "entity.parrot.imitate.warden",
    "entity.parrot.imitate.witch",
    "entity.parrot.imitate.wither",
    "entity.parrot.imitate.wither_skeleton",
    "entity.parrot.imitate.zoglin",
    "entity.parrot.imitate.zombie",
    "entity.parrot.imitate.zombie_horse",
    "entity.parrot.imitate.zombie_nautilus",
    "entity.parrot.imitate.zombie_villager",
    "entity.parrot.step",
    "entity.phantom.ambient",
    "entity.phantom.bite",
    "entity.phantom.death",
    "entity.phantom.flap",
    "entity.phantom.hurt",
    "entity.phantom.swoop",
    "entity.pig.ambient",
    "entity.pig.death",
    "entity.pig.eat",
    "entity.pig.hurt",
    "entity.pig.saddle",
    "entity.pig.step",
    "entity.pig_big.ambient",
    "entity.pig_big.death",
    "entity.pig_big.eat",
    "entity.pig_big.hurt",
    "entity.pig_mini.ambient",
    "entity.pig_mini.death",
    "entity.pig_mini.eat",
    "entity.pig_mini.hurt",
    "entity.piglin.admiring_item",
    "entity.piglin.ambient",
    "entity.piglin.angry",
    "entity.piglin.celebrate",
    "entity.piglin.converted_to_zombified",
    "entity.piglin.death",
    "entity.piglin.hurt",
    "entity.piglin.jealous",
    "entity.piglin.retreat",
    "entity.piglin.step",
    "entity.piglin_brute.ambient",
    "entity.piglin_brute.angry",
    "entity.piglin_brute.converted_to_zombified",
    "entity.piglin_brute.death",
    "entity.piglin_brute.hurt",
    "entity.piglin_brute.step",
    "entity.pillager.ambient",
    "entity.pillager.celebrate",
    "entity.pillager.death",
    "entity.pillager.hurt",
    "entity.player.attack.crit",
    "entity.player.attack.knockback",
    "entity.player.attack.nodamage",
    "entity.player.attack.strong",
    "entity.player.attack.sweep",
    "entity.player.attack.weak",
    "entity.player.big_fall",
    "entity.player.breath",
    "entity.player.burp",
    "entity.player.death",
    "entity.player.hurt",
    "entity.player.hurt_drown",
    "entity.player.hurt_freeze",
    "entity.player.hurt_on_fire",
    "entity.player.hurt_sweet_berry_bush",
    "entity.player.levelup",
    "entity.player.small_fall",
    "entity.player.splash",
    "entity.player.splash.high_speed",
    "entity.player.swim",
    "entity.player.teleport",
    "entity.polar_bear.ambient",
    "entity.polar_bear.ambient_baby",
    "entity.polar_bear.death",
    "entity.polar_bear.hurt",
    "entity.polar_bear.step",
    "entity.polar_bear.warning",
    "entity.puffer_fish.blow_out",
    "entity.puffer_fish.blow_up",
    "entity.puffer_fish.death",
    "entity.puffer_fish.flop",
    "entity.puffer_fish.hurt",
    "entity.puffer_fish.sting",
    "entity.rabbit.ambient",
    "entity.rabbit.attack",
    "entity.rabbit.death",
    "entity.rabbit.hurt",
    "entity.rabbit.jump",
    "entity.ravager.ambient",
    "entity.ravager.attack",
    "entity.ravager.celebrate",
    "entity.ravager.death",
    "entity.ravager.hurt",
    "entity.ravager.roar",
    "entity.ravager.step",
    "entity.ravager.stunned",
    "entity.salmon.ambient",
    "entity.salmon.death",
    "entity.salmon.flop",
    "entity.salmon.hurt",
    "entity.sheep.ambient",
    "entity.sheep.death",
    "entity.sheep.hurt",
    "entity.sheep.shear",
    "entity.sheep.step",
    "entity.shulker.ambient",
    "entity.shulker.close",
    "entity.shulker.death",
    "entity.shulker.hurt",
    "entity.shulker.hurt_closed",
    "entity.shulker.open",
    "entity.shulker.shoot",
    "entity.shulker.teleport",
    "entity.shulker_bullet.hit",
    "entity.shulker_bullet.hurt",
    "entity.silverfish.ambient",
    "entity.silverfish.death",
    "entity.silverfish.hurt",
    "entity.silverfish.step",
    "entity.skeleton.ambient",
    "entity.skeleton.converted_to_stray",
    "entity.skeleton.death",
    "entity.skeleton.hurt",
    "entity.skeleton.shoot",
    "entity.skeleton.step",
    "entity.skeleton_horse.ambient",
    "entity.skeleton_horse.ambient_water",
    "entity.skeleton_horse.death",
    "entity.skeleton_horse.gallop_water",
    "entity.skeleton_horse.hurt",
    "entity.skeleton_horse.jump_water",
    "entity.skeleton_horse.step_water",
    "entity.skeleton_horse.swim",
    "entity.slime.attack",
    "entity.slime.death",
    "entity.slime.death_small",
    "entity.slime.hurt",
    "entity.slime.hurt_small",
    "entity.slime.jump",
    "entity.slime.jump_small",
    "entity.slime.squish",
    "entity.slime.squish_small",
    "entity.small_sulfur_cube.death",
    "entity.small_sulfur_cube.eat",
    "entity.small_sulfur_cube.hurt",
    "entity.small_sulfur_cube.jump",
    "entity.small_sulfur_cube.squish",
    "entity.sniffer.death",
    "entity.sniffer.digging",
    "entity.sniffer.digging_stop",
    "entity.sniffer.drop_seed",
    "entity.sniffer.eat",
    "entity.sniffer.happy",
    "entity.sniffer.hurt",
    "entity.sniffer.idle",
    "entity.sniffer.scenting",
    "entity.sniffer.searching",
    "entity.sniffer.sniffing",
    "entity.sniffer.step",
    "entity.snow_golem.ambient",
    "entity.snow_golem.death",
    "entity.snow_golem.hurt",
    "entity.snow_golem.shear",
    "entity.snow_golem.shoot",
    "entity.snowball.throw",
    "entity.spider.ambient",
    "entity.spider.death",
    "entity.spider.hurt",
    "entity.spider.step",
    "entity.splash_potion.break",
    "entity.splash_potion.throw",
    "entity.squid.ambient",
    "entity.squid.death",
    "entity.squid.hurt",
    "entity.squid.squirt",
    "entity.stray.ambient",
    "entity.stray.death",
    "entity.stray.hurt",
    "entity.stray.step",
    "entity.strider.ambient",
    "entity.strider.death",
    "entity.strider.eat",
    "entity.strider.happy",
    "entity.strider.hurt",
    "entity.strider.retreat",
    "entity.strider.saddle",
    "entity.strider.step",
    "entity.strider.step_lava",
    "entity.sulfur_cube.absorb",
    "entity.sulfur_cube.bounce",
    "entity.sulfur_cube.bouncy.hit",
    "entity.sulfur_cube.bouncy.push",
    "entity.sulfur_cube.death",
    "entity.sulfur_cube.eject",
    "entity.sulfur_cube.explosive.hit",
    "entity.sulfur_cube.explosive.push",
    "entity.sulfur_cube.fast_flat.hit",
    "entity.sulfur_cube.fast_flat.push",
    "entity.sulfur_cube.fast_sliding.hit",
    "entity.sulfur_cube.fast_sliding.push",
    "entity.sulfur_cube.high_resistance.hit",
    "entity.sulfur_cube.high_resistance.push",
    "entity.sulfur_cube.hot.hit",
    "entity.sulfur_cube.hot.push",
    "entity.sulfur_cube.hurt",
    "entity.sulfur_cube.jump",
    "entity.sulfur_cube.light.hit",
    "entity.sulfur_cube.light.push",
    "entity.sulfur_cube.regular.hit",
    "entity.sulfur_cube.regular.push",
    "entity.sulfur_cube.slow_bouncy.hit",
    "entity.sulfur_cube.slow_bouncy.push",
    "entity.sulfur_cube.slow_flat.hit",
    "entity.sulfur_cube.slow_flat.push",
    "entity.sulfur_cube.slow_sliding.hit",
    "entity.sulfur_cube.slow_sliding.push",
    "entity.sulfur_cube.squish",
    "entity.sulfur_cube.sticky.hit",
    "entity.sulfur_cube.sticky.push",
    "entity.tadpole.death",
    "entity.tadpole.flop",
    "entity.tadpole.grow_up",
    "entity.tadpole.hurt",
    "entity.tnt.primed",
    "entity.tropical_fish.ambient",
    "entity.tropical_fish.death",
    "entity.tropical_fish.flop",
    "entity.tropical_fish.hurt",
    "entity.turtle.ambient_land",
    "entity.turtle.death",
    "entity.turtle.death_baby",
    "entity.turtle.egg_break",
    "entity.turtle.egg_crack",
    "entity.turtle.egg_hatch",
    "entity.turtle.hurt",
    "entity.turtle.hurt_baby",
    "entity.turtle.lay_egg",
    "entity.turtle.shamble",
    "entity.turtle.shamble_baby",
    "entity.turtle.swim",
    "entity.vex.ambient",
    "entity.vex.charge",
    "entity.vex.death",
    "entity.vex.hurt",
    "entity.villager.ambient",
    "entity.villager.celebrate",
    "entity.villager.death",
    "entity.villager.hurt",
    "entity.villager.no",
    "entity.villager.trade",
    "entity.villager.work_armorer",
    "entity.villager.work_butcher",
    "entity.villager.work_cartographer",
    "entity.villager.work_cleric",
    "entity.villager.work_farmer",
    "entity.villager.work_fisherman",
    "entity.villager.work_fletcher",
    "entity.villager.work_leatherworker",
    "entity.villager.work_librarian",
    "entity.villager.work_mason",
    "entity.villager.work_shepherd",
    "entity.villager.work_toolsmith",
    "entity.villager.work_weaponsmith",
    "entity.villager.yes",
    "entity.vindicator.ambient",
    "entity.vindicator.celebrate",
    "entity.vindicator.death",
    "entity.vindicator.hurt",
    "entity.wandering_trader.ambient",
    "entity.wandering_trader.death",
    "entity.wandering_trader.disappeared",
    "entity.wandering_trader.drink_milk",
    "entity.wandering_trader.drink_potion",
    "entity.wandering_trader.hurt",
    "entity.wandering_trader.no",
    "entity.wandering_trader.reappeared",
    "entity.wandering_trader.trade",
    "entity.wandering_trader.yes",
    "entity.warden.agitated",
    "entity.warden.ambient",
    "entity.warden.angry",
    "entity.warden.attack_impact",
    "entity.warden.death",
    "entity.warden.dig",
    "entity.warden.emerge",
    "entity.warden.heartbeat",
    "entity.warden.hurt",
    "entity.warden.listening",
    "entity.warden.listening_angry",
    "entity.warden.nearby_close",
    "entity.warden.nearby_closer",
    "entity.warden.nearby_closest",
    "entity.warden.roar",
    "entity.warden.sniff",
    "entity.warden.sonic_boom",
    "entity.warden.sonic_charge",
    "entity.warden.step",
    "entity.warden.tendril_clicks",
    "entity.wind_charge.throw",
    "entity.wind_charge.wind_burst",
    "entity.witch.ambient",
    "entity.witch.celebrate",
    "entity.witch.death",
    "entity.witch.drink",
    "entity.witch.hurt",
    "entity.witch.throw",
    "entity.wither.ambient",
    "entity.wither.break_block",
    "entity.wither.death",
    "entity.wither.hurt",
    "entity.wither.shoot",
    "entity.wither.spawn",
    "entity.wither_skeleton.ambient",
    "entity.wither_skeleton.death",
    "entity.wither_skeleton.hurt",
    "entity.wither_skeleton.step",
    "entity.wolf.ambient",
    "entity.wolf.death",
    "entity.wolf.growl",
    "entity.wolf.hurt",
    "entity.wolf.pant",
    "entity.wolf.shake",
    "entity.wolf.step",
    "entity.wolf.whine",
    "entity.wolf_angry.ambient",
    "entity.wolf_angry.death",
    "entity.wolf_angry.growl",
    "entity.wolf_angry.hurt",
    "entity.wolf_angry.pant",
    "entity.wolf_angry.whine",
    "entity.wolf_big.ambient",
    "entity.wolf_big.death",
    "entity.wolf_big.growl",
    "entity.wolf_big.hurt",
    "entity.wolf_big.pant",
    "entity.wolf_big.whine",
    "entity.wolf_cute.ambient",
    "entity.wolf_cute.death",
    "entity.wolf_cute.growl",
    "entity.wolf_cute.hurt",
    "entity.wolf_cute.pant",
    "entity.wolf_cute.whine",
    "entity.wolf_grumpy.ambient",
    "entity.wolf_grumpy.death",
    "entity.wolf_grumpy.growl",
    "entity.wolf_grumpy.hurt",
    "entity.wolf_grumpy.pant",
    "entity.wolf_grumpy.whine",
    "entity.wolf_puglin.ambient",
    "entity.wolf_puglin.death",
    "entity.wolf_puglin.growl",
    "entity.wolf_puglin.hurt",
    "entity.wolf_puglin.pant",
    "entity.wolf_puglin.whine",
    "entity.wolf_sad.ambient",
    "entity.wolf_sad.death",
    "entity.wolf_sad.growl",
    "entity.wolf_sad.hurt",
    "entity.wolf_sad.pant",
    "entity.wolf_sad.whine",
    "entity.zoglin.ambient",
    "entity.zoglin.angry",
    "entity.zoglin.attack",
    "entity.zoglin.death",
    "entity.zoglin.hurt",
    "entity.zoglin.step",
    "entity.zombie.ambient",
    "entity.zombie.attack_iron_door",
    "entity.zombie.attack_wooden_door",
    "entity.zombie.break_wooden_door",
    "entity.zombie.converted_to_drowned",
    "entity.zombie.death",
    "entity.zombie.destroy_egg",
    "entity.zombie.hurt",
    "entity.zombie.infect",
    "entity.zombie.step",
    "entity.zombie_horse.ambient",
    "entity.zombie_horse.angry",
    "entity.zombie_horse.death",
    "entity.zombie_horse.eat",
    "entity.zombie_horse.hurt",
    "entity.zombie_nautilus.ambient",
    "entity.zombie_nautilus.ambient_land",
    "entity.zombie_nautilus.dash",
    "entity.zombie_nautilus.dash_land",
    "entity.zombie_nautilus.dash_ready",
    "entity.zombie_nautilus.dash_ready_land",
    "entity.zombie_nautilus.death",
    "entity.zombie_nautilus.death_land",
    "entity.zombie_nautilus.eat",
    "entity.zombie_nautilus.hurt",
    "entity.zombie_nautilus.hurt_land",
    "entity.zombie_nautilus.swim",
    "entity.zombie_villager.ambient",
    "entity.zombie_villager.converted",
    "entity.zombie_villager.cure",
    "entity.zombie_villager.death",
    "entity.zombie_villager.hurt",
    "entity.zombie_villager.step",
    "entity.zombified_piglin.ambient",
    "entity.zombified_piglin.angry",
    "entity.zombified_piglin.death",
    "entity.zombified_piglin.hurt",
    "event.mob_effect.bad_omen",
    "event.mob_effect.raid_omen",
    "event.mob_effect.trial_omen",
    "event.raid.horn",
    "intentionally_empty",
    "item.armor.equip_chain",
    "item.armor.equip_copper",
    "item.armor.equip_diamond",
    "item.armor.equip_elytra",
    "item.armor.equip_generic",
    "item.armor.equip_gold",
    "item.armor.equip_iron",
    "item.armor.equip_leather",
    "item.armor.equip_nautilus",
    "item.armor.equip_netherite",
    "item.armor.equip_turtle",
    "item.armor.equip_wolf",
    "item.armor.unequip_nautilus",
    "item.armor.unequip_wolf",
    "item.axe.scrape",
    "item.axe.strip",
    "item.axe.wax_off",
    "item.bone_meal.use",
    "item.book.page_turn",
    "item.book.put",
    "item.bottle.empty",
    "item.bottle.fill",
    "item.bottle.fill_dragonbreath",
    "item.brush.brushing.generic",
    "item.brush.brushing.gravel",
    "item.brush.brushing.gravel.complete",
    "item.brush.brushing.sand",
    "item.brush.brushing.sand.complete",
    "item.bucket.empty",
    "item.bucket.empty_axolotl",
    "item.bucket.empty_fish",
    "item.bucket.empty_lava",
    "item.bucket.empty_powder_snow",
    "item.bucket.empty_sulfur_cube",
    "item.bucket.empty_tadpole",
    "item.bucket.fill",
    "item.bucket.fill_axolotl",
    "item.bucket.fill_fish",
    "item.bucket.fill_lava",
    "item.bucket.fill_powder_snow",
    "item.bucket.fill_sulfur_cube",
    "item.bucket.fill_tadpole",
    "item.bundle.drop_contents",
    "item.bundle.insert",
    "item.bundle.insert_fail",
    "item.bundle.remove_one",
    "item.chorus_fruit.teleport",
    "item.crop.plant",
    "item.crossbow.hit",
    "item.crossbow.loading_end",
    "item.crossbow.loading_middle",
    "item.crossbow.loading_start",
    "item.crossbow.quick_charge_1",
    "item.crossbow.quick_charge_2",
    "item.crossbow.quick_charge_3",
    "item.crossbow.shoot",
    "item.dye.use",
    "item.elytra.flying",
    "item.firecharge.use",
    "item.flintandsteel.use",
    "item.glow_ink_sac.use",
    "item.goat_horn.sound.0",
    "item.goat_horn.sound.1",
    "item.goat_horn.sound.2",
    "item.goat_horn.sound.3",
    "item.goat_horn.sound.4",
    "item.goat_horn.sound.5",
    "item.goat_horn.sound.6",
    "item.goat_horn.sound.7",
    "item.golden_dandelion.unuse",
    "item.golden_dandelion.use",
    "item.hoe.till",
    "item.honey_bottle.drink",
    "item.honeycomb.wax_on",
    "item.horse_armor.unequip",
    "item.ink_sac.use",
    "item.lead.break",
    "item.lead.tied",
    "item.lead.untied",
    "item.llama_carpet.unequip",
    "item.lodestone_compass.lock",
    "item.mace.smash_air",
    "item.mace.smash_ground",
    "item.mace.smash_ground_heavy",
    "item.nautilus_saddle_equip",
    "item.nautilus_saddle_underwater_equip",
    "item.nether_wart.plant",
    "item.ominous_bottle.dispose",
    "item.saddle.unequip",
    "item.shears.snip",
    "item.shield.block",
    "item.shield.break",
    "item.shovel.flatten",
    "item.spear.attack",
    "item.spear.hit",
    "item.spear.lunge_1",
    "item.spear.lunge_2",
    "item.spear.lunge_3",
    "item.spear.use",
    "item.spear_wood.attack",
    "item.spear_wood.hit",
    "item.spear_wood.use",
    "item.spyglass.stop_using",
    "item.spyglass.use",
    "item.totem.use",
    "item.trident.hit",
    "item.trident.hit_ground",
    "item.trident.return",
    "item.trident.riptide_1",
    "item.trident.riptide_2",
    "item.trident.riptide_3",
    "item.trident.throw",
    "item.trident.thunder",
    "item.wolf_armor.break",
    "item.wolf_armor.crack",
    "item.wolf_armor.damage",
    "item.wolf_armor.repair",
    "music.creative",
    "music.credits",
    "music.dragon",
    "music.end",
    "music.game",
    "music.menu",
    "music.nether.basalt_deltas",
    "music.nether.crimson_forest",
    "music.nether.nether_wastes",
    "music.nether.soul_sand_valley",
    "music.nether.warped_forest",
    "music.overworld.badlands",
    "music.overworld.bamboo_jungle",
    "music.overworld.cherry_grove",
    "music.overworld.deep_dark",
    "music.overworld.desert",
    "music.overworld.dripstone_caves",
    "music.overworld.flower_forest",
    "music.overworld.forest",
    "music.overworld.frozen_peaks",
    "music.overworld.grove",
    "music.overworld.jagged_peaks",
    "music.overworld.jungle",
    "music.overworld.lush_caves",
    "music.overworld.meadow",
    "music.overworld.old_growth_taiga",
    "music.overworld.snowy_slopes",
    "music.overworld.sparse_jungle",
    "music.overworld.stony_peaks",
    "music.overworld.sulfur_caves",
    "music.overworld.swamp",
    "music.under_water",
    "music_disc.11",
    "music_disc.13",
    "music_disc.5",
    "music_disc.blocks",
    "music_disc.bounce",
    "music_disc.cat",
    "music_disc.chirp",
    "music_disc.creator",
    "music_disc.creator_music_box",
    "music_disc.far",
    "music_disc.lava_chicken",
    "music_disc.mall",
    "music_disc.mellohi",
    "music_disc.otherside",
    "music_disc.pigstep",
    "music_disc.precipice",
    "music_disc.relic",
    "music_disc.stal",
    "music_disc.strad",
    "music_disc.tears",
    "music_disc.wait",
    "music_disc.ward",
    "particle.soul_escape",
    "ui.button.click",
    "ui.cartography_table.take_result",
    "ui.hud.bubble_pop",
    "ui.loom.select_pattern",
    "ui.loom.take_result",
    "ui.stonecutter.select_recipe",
    "ui.stonecutter.take_result",
    "ui.toast.challenge_complete",
    "ui.toast.in",
    "ui.toast.out",
    "weather.end_flash",
    "weather.rain",
    "weather.rain.above"
  ]);
});

// src/arguments/generated/_registry/spawn_condition_types.ts
var SPAWN_CONDITION_TYPES_SET;
var init_spawn_condition_types = __esm(() => {
  init_sandstone();
  SPAWN_CONDITION_TYPES_SET = new Set2([
    "biome",
    "moon_brightness",
    "structure"
  ]);
});

// src/arguments/generated/_registry/stat_types.ts
var STAT_TYPES_SET;
var init_stat_types = __esm(() => {
  init_sandstone();
  STAT_TYPES_SET = new Set2([
    "broken",
    "crafted",
    "custom",
    "dropped",
    "killed",
    "killed_by",
    "mined",
    "picked_up",
    "used"
  ]);
});

// src/arguments/generated/_registry/test_environment_definition_types.ts
var TEST_ENVIRONMENT_DEFINITION_TYPES_SET;
var init_test_environment_definition_types = __esm(() => {
  init_sandstone();
  TEST_ENVIRONMENT_DEFINITION_TYPES_SET = new Set2([
    "all_of",
    "clock_time",
    "difficulty",
    "function",
    "game_rules",
    "timeline_attributes",
    "weather"
  ]);
});

// src/arguments/generated/_registry/test_functions.ts
var TEST_FUNCTIONS_SET;
var init_test_functions = __esm(() => {
  init_sandstone();
  TEST_FUNCTIONS_SET = new Set2([
    "always_pass"
  ]);
});

// src/arguments/generated/_registry/test_instance_types.ts
var TEST_INSTANCE_TYPES_SET;
var init_test_instance_types = __esm(() => {
  init_sandstone();
  TEST_INSTANCE_TYPES_SET = new Set2([
    "block_based",
    "function"
  ]);
});

// src/arguments/generated/_registry/trigger_types.ts
var TRIGGER_TYPES_SET;
var init_trigger_types = __esm(() => {
  init_sandstone();
  TRIGGER_TYPES_SET = new Set2([
    "allay_drop_item_on_block",
    "any_block_use",
    "avoid_vibration",
    "bee_nest_destroyed",
    "bred_animals",
    "brewed_potion",
    "changed_dimension",
    "channeled_lightning",
    "construct_beacon",
    "consume_item",
    "crafter_recipe_crafted",
    "cured_zombie_villager",
    "default_block_use",
    "effects_changed",
    "enchanted_item",
    "enter_block",
    "entity_hurt_player",
    "entity_killed_player",
    "fall_after_explosion",
    "fall_from_height",
    "filled_bucket",
    "fishing_rod_hooked",
    "hero_of_the_village",
    "impossible",
    "inventory_changed",
    "item_durability_changed",
    "item_used_on_block",
    "kill_mob_near_sculk_catalyst",
    "killed_by_arrow",
    "levitation",
    "lightning_strike",
    "location",
    "nether_travel",
    "placed_block",
    "player_generates_container_loot",
    "player_hurt_entity",
    "player_interacted_with_entity",
    "player_killed_entity",
    "player_sheared_equipment",
    "recipe_crafted",
    "recipe_unlocked",
    "ride_entity_in_lava",
    "shot_crossbow",
    "slept_in_bed",
    "slide_down_block",
    "spear_mobs",
    "started_riding",
    "summoned_entity",
    "tame_animal",
    "target_hit",
    "thrown_item_picked_up_by_entity",
    "thrown_item_picked_up_by_player",
    "tick",
    "used_ender_eye",
    "used_totem",
    "using_item",
    "villager_trade",
    "voluntary_exile"
  ]);
});

// src/arguments/generated/_registry/ticket_types.ts
var TICKET_TYPES_SET;
var init_ticket_types = __esm(() => {
  init_sandstone();
  TICKET_TYPES_SET = new Set2([
    "dragon",
    "ender_pearl",
    "forced",
    "player_loading",
    "player_simulation",
    "player_spawn",
    "portal",
    "spawn_search",
    "unknown"
  ]);
});

// src/arguments/generated/_registry/villager_professions.ts
var VILLAGER_PROFESSIONS_SET;
var init_villager_professions = __esm(() => {
  init_sandstone();
  VILLAGER_PROFESSIONS_SET = new Set2([
    "armorer",
    "butcher",
    "cartographer",
    "cleric",
    "farmer",
    "fisherman",
    "fletcher",
    "leatherworker",
    "librarian",
    "mason",
    "nitwit",
    "none",
    "shepherd",
    "toolsmith",
    "weaponsmith"
  ]);
});

// src/arguments/generated/_registry/villager_types.ts
var VILLAGER_TYPES_SET;
var init_villager_types = __esm(() => {
  init_sandstone();
  VILLAGER_TYPES_SET = new Set2([
    "desert",
    "jungle",
    "plains",
    "savanna",
    "snow",
    "swamp",
    "taiga"
  ]);
});

// src/arguments/generated/_registry/worldgen_biome_sources.ts
var WORLDGEN_BIOME_SOURCES_SET;
var init_worldgen_biome_sources = __esm(() => {
  init_sandstone();
  WORLDGEN_BIOME_SOURCES_SET = new Set2([
    "checkerboard",
    "fixed",
    "multi_noise",
    "the_end"
  ]);
});

// src/arguments/generated/_registry/worldgen_block_state_provider_types.ts
var WORLDGEN_BLOCK_STATE_PROVIDER_TYPES_SET;
var init_worldgen_block_state_provider_types = __esm(() => {
  init_sandstone();
  WORLDGEN_BLOCK_STATE_PROVIDER_TYPES_SET = new Set2([
    "copy_properties_provider",
    "dual_noise_provider",
    "noise_provider",
    "noise_threshold_provider",
    "random_block_provider",
    "randomized_int_state_provider",
    "rotated_block_provider",
    "rule_based_state_provider",
    "simple_state_provider",
    "weighted_state_provider"
  ]);
});

// src/arguments/generated/_registry/worldgen_carver_types.ts
var WORLDGEN_CARVER_TYPES_SET;
var init_worldgen_carver_types = __esm(() => {
  init_sandstone();
  WORLDGEN_CARVER_TYPES_SET = new Set2([
    "canyon",
    "cave"
  ]);
});

// src/arguments/generated/_registry/worldgen_chunk_generators.ts
var WORLDGEN_CHUNK_GENERATORS_SET;
var init_worldgen_chunk_generators = __esm(() => {
  init_sandstone();
  WORLDGEN_CHUNK_GENERATORS_SET = new Set2([
    "debug",
    "flat",
    "noise"
  ]);
});

// src/arguments/generated/_registry/worldgen_density_function_types.ts
var WORLDGEN_DENSITY_FUNCTION_TYPES_SET;
var init_worldgen_density_function_types = __esm(() => {
  init_sandstone();
  WORLDGEN_DENSITY_FUNCTION_TYPES_SET = new Set2([
    "abs",
    "add",
    "beardifier",
    "blend_alpha",
    "blend_density",
    "blend_offset",
    "cache_2d",
    "cache_all_in_cell",
    "cache_once",
    "ceil",
    "clamp",
    "constant",
    "cube",
    "distance_to_point",
    "div",
    "end_outer_islands",
    "find_top_surface",
    "flat_cache",
    "floor",
    "gradient",
    "half_negative",
    "interpolated",
    "interval_select",
    "lerp",
    "log",
    "max",
    "min",
    "mul",
    "negate",
    "noise",
    "old_blended_noise",
    "pow",
    "quarter_negative",
    "range_choice",
    "reciprocal",
    "round",
    "shift",
    "shift_a",
    "shift_b",
    "shifted_noise",
    "sign",
    "slice",
    "spline",
    "sqrt",
    "square",
    "squeeze",
    "sub",
    "truncate"
  ]);
});

// src/arguments/generated/_registry/worldgen_feature_size_types.ts
var WORLDGEN_FEATURE_SIZE_TYPES_SET;
var init_worldgen_feature_size_types = __esm(() => {
  init_sandstone();
  WORLDGEN_FEATURE_SIZE_TYPES_SET = new Set2([
    "three_layers_feature_size",
    "two_layers_feature_size"
  ]);
});

// src/arguments/generated/_registry/worldgen_feature_types.ts
var WORLDGEN_FEATURE_TYPES_SET;
var init_worldgen_feature_types = __esm(() => {
  init_sandstone();
  WORLDGEN_FEATURE_TYPES_SET = new Set2([
    "bamboo",
    "block_blob",
    "block_column",
    "block_pile",
    "blue_ice",
    "bonus_chest",
    "chorus_plant",
    "coral_claw",
    "coral_tree",
    "delta_feature",
    "desert_well",
    "disk",
    "end_gateway",
    "end_island",
    "end_platform",
    "end_podium",
    "end_spike",
    "fallen_tree",
    "fill_layer",
    "fossil",
    "freeze_top_layer",
    "geode",
    "huge_brown_mushroom",
    "huge_fungus",
    "huge_red_mushroom",
    "iceberg",
    "lake",
    "large_dripstone",
    "monster_room",
    "multiface_growth",
    "netherrack_replace_blobs",
    "no_op",
    "ore",
    "overlay",
    "projected_random_patchy_square",
    "random_boolean_selector",
    "random_neighbor_spread",
    "random_selector",
    "replace_single_block",
    "root_system",
    "scattered_ore",
    "sculk_patch",
    "sequence",
    "simple_block",
    "simple_random_selector",
    "single_block_pillar",
    "speleothem",
    "speleothem_cluster",
    "spike",
    "spring_feature",
    "stepped_column_cluster",
    "template",
    "tree",
    "underwater_magma",
    "vegetation_patch",
    "vines",
    "void_start_platform",
    "waterlogged_vegetation_patch",
    "weighted_random_selector"
  ]);
});

// src/arguments/generated/_registry/worldgen_foliage_placer_types.ts
var WORLDGEN_FOLIAGE_PLACER_TYPES_SET;
var init_worldgen_foliage_placer_types = __esm(() => {
  init_sandstone();
  WORLDGEN_FOLIAGE_PLACER_TYPES_SET = new Set2([
    "acacia_foliage_placer",
    "blob_foliage_placer",
    "bush_foliage_placer",
    "cherry_foliage_placer",
    "dark_oak_foliage_placer",
    "fancy_foliage_placer",
    "jungle_foliage_placer",
    "mega_pine_foliage_placer",
    "pine_foliage_placer",
    "poplar_foliage_placer",
    "random_spread_foliage_placer",
    "spruce_foliage_placer"
  ]);
});

// src/arguments/generated/_registry/worldgen_material_condition_types.ts
var WORLDGEN_MATERIAL_CONDITION_TYPES_SET;
var init_worldgen_material_condition_types = __esm(() => {
  init_sandstone();
  WORLDGEN_MATERIAL_CONDITION_TYPES_SET = new Set2([
    "above_preliminary_surface",
    "biome",
    "hole",
    "noise_threshold",
    "not",
    "steep",
    "stone_depth",
    "temperature",
    "vertical_gradient",
    "water",
    "y_above"
  ]);
});

// src/arguments/generated/_registry/worldgen_material_rule_types.ts
var WORLDGEN_MATERIAL_RULE_TYPES_SET;
var init_worldgen_material_rule_types = __esm(() => {
  init_sandstone();
  WORLDGEN_MATERIAL_RULE_TYPES_SET = new Set2([
    "bandlands",
    "block",
    "condition",
    "sequence"
  ]);
});

// src/arguments/generated/_registry/worldgen_placement_modifier_types.ts
var WORLDGEN_PLACEMENT_MODIFIER_TYPES_SET;
var init_worldgen_placement_modifier_types = __esm(() => {
  init_sandstone();
  WORLDGEN_PLACEMENT_MODIFIER_TYPES_SET = new Set2([
    "biome",
    "block_predicate_filter",
    "count",
    "count_on_every_layer",
    "cuboid",
    "environment_scan",
    "fixed_placement",
    "height_range",
    "heightmap",
    "in_square",
    "noise_based_count",
    "noise_threshold_count",
    "offset",
    "random_chance",
    "rarity_filter",
    "surface_relative_threshold_filter",
    "surface_water_depth_filter"
  ]);
});

// src/arguments/generated/_registry/worldgen_pool_alias_bindings.ts
var WORLDGEN_POOL_ALIAS_BINDINGS_SET;
var init_worldgen_pool_alias_bindings = __esm(() => {
  init_sandstone();
  WORLDGEN_POOL_ALIAS_BINDINGS_SET = new Set2([
    "direct",
    "random",
    "random_group"
  ]);
});

// src/arguments/generated/_registry/worldgen_root_placer_types.ts
var WORLDGEN_ROOT_PLACER_TYPES_SET;
var init_worldgen_root_placer_types = __esm(() => {
  init_sandstone();
  WORLDGEN_ROOT_PLACER_TYPES_SET = new Set2([
    "mangrove_root_placer"
  ]);
});

// src/arguments/generated/_registry/worldgen_structure_pieces.ts
var WORLDGEN_STRUCTURE_PIECES_SET;
var init_worldgen_structure_pieces = __esm(() => {
  init_sandstone();
  WORLDGEN_STRUCTURE_PIECES_SET = new Set2([
    "btp",
    "ecp",
    "iglu",
    "jigsaw",
    "mscorridor",
    "mscrossing",
    "msroom",
    "msstairs",
    "nebcr",
    "nebef",
    "nebs",
    "neccs",
    "nece",
    "necsr",
    "nectb",
    "nefos",
    "nemt",
    "nerc",
    "nesc",
    "nesclt",
    "nescrt",
    "nescsc",
    "nesr",
    "nestart",
    "omb",
    "omcr",
    "omdxr",
    "omdxyr",
    "omdyr",
    "omdyzr",
    "omdzr",
    "omentry",
    "ompenthouse",
    "omsimple",
    "omsimplet",
    "omwr",
    "orp",
    "rupo",
    "sh5c",
    "shcc",
    "shfc",
    "shipwreck",
    "shli",
    "shlt",
    "shph",
    "shpr",
    "shrc",
    "shrt",
    "shs",
    "shsd",
    "shssd",
    "shstart",
    "tedp",
    "tejp",
    "tesh",
    "wmp"
  ]);
});

// src/arguments/generated/_registry/worldgen_structure_placements.ts
var WORLDGEN_STRUCTURE_PLACEMENTS_SET;
var init_worldgen_structure_placements = __esm(() => {
  init_sandstone();
  WORLDGEN_STRUCTURE_PLACEMENTS_SET = new Set2([
    "concentric_rings",
    "dimension_origin",
    "random_spread"
  ]);
});

// src/arguments/generated/_registry/worldgen_structure_pool_elements.ts
var WORLDGEN_STRUCTURE_POOL_ELEMENTS_SET;
var init_worldgen_structure_pool_elements = __esm(() => {
  init_sandstone();
  WORLDGEN_STRUCTURE_POOL_ELEMENTS_SET = new Set2([
    "empty_pool_element",
    "feature_pool_element",
    "legacy_single_pool_element",
    "list_pool_element",
    "single_pool_element"
  ]);
});

// src/arguments/generated/_registry/worldgen_structure_processors.ts
var WORLDGEN_STRUCTURE_PROCESSORS_SET;
var init_worldgen_structure_processors = __esm(() => {
  init_sandstone();
  WORLDGEN_STRUCTURE_PROCESSORS_SET = new Set2([
    "blackstone_replace",
    "block_age",
    "block_ignore",
    "block_rot",
    "capped",
    "gravity",
    "jigsaw_replacement",
    "lava_submerged_block",
    "nop",
    "protected_blocks",
    "rule"
  ]);
});

// src/arguments/generated/_registry/worldgen_structure_types.ts
var WORLDGEN_STRUCTURE_TYPES_SET;
var init_worldgen_structure_types = __esm(() => {
  init_sandstone();
  WORLDGEN_STRUCTURE_TYPES_SET = new Set2([
    "buried_treasure",
    "desert_pyramid",
    "end_city",
    "fortress",
    "igloo",
    "jigsaw",
    "jungle_temple",
    "mineshaft",
    "nether_fossil",
    "ocean_monument",
    "ocean_ruin",
    "ruined_portal",
    "shipwreck",
    "stronghold",
    "swamp_hut",
    "woodland_mansion"
  ]);
});

// src/arguments/generated/_registry/worldgen_tree_decorator_types.ts
var WORLDGEN_TREE_DECORATOR_TYPES_SET;
var init_worldgen_tree_decorator_types = __esm(() => {
  init_sandstone();
  WORLDGEN_TREE_DECORATOR_TYPES_SET = new Set2([
    "alter_ground",
    "attached_to_leaves",
    "attached_to_logs",
    "beehive",
    "cocoa",
    "creaking_heart",
    "leave_vine",
    "pale_moss",
    "place_on_ground",
    "shelf_mushroom",
    "trunk_vine"
  ]);
});

// src/arguments/generated/_registry/worldgen_trunk_placer_types.ts
var WORLDGEN_TRUNK_PLACER_TYPES_SET;
var init_worldgen_trunk_placer_types = __esm(() => {
  init_sandstone();
  WORLDGEN_TRUNK_PLACER_TYPES_SET = new Set2([
    "bending_trunk_placer",
    "cherry_trunk_placer",
    "dark_oak_trunk_placer",
    "fancy_trunk_placer",
    "forking_trunk_placer",
    "giant_trunk_placer",
    "mega_jungle_trunk_placer",
    "poplar_trunk_placer",
    "straight_trunk_placer",
    "upwards_branching_trunk_placer"
  ]);
});

// src/arguments/generated/registry-sets.ts
var init_registry_sets = __esm(() => {
  init_advancements();
  init_banner_patterns();
  init_cat_sound_variants();
  init_cat_variants();
  init_chat_types();
  init_chicken_sound_variants();
  init_chicken_variants();
  init_cow_sound_variants();
  init_cow_variants();
  init_damage_types();
  init_decorated_pot_patterns();
  init_dialogs();
  init_dimensions();
  init_dimension_types();
  init_enchantments();
  init_enchantment_providers();
  init_frog_variants();
  init_instruments();
  init_jukebox_songs();
  init_loot_tables();
  init_number_providers();
  init_painting_variants();
  init_pig_sound_variants();
  init_pig_variants();
  init_predicates();
  init_recipes();
  init_structures();
  init_sulfur_cube_archetypes();
  init_test_environments();
  init_test_instances();
  init_timelines();
  init_trade_sets();
  init_trial_spawners();
  init_trim_materials();
  init_trim_patterns();
  init_villager_trades();
  init_wolf_sound_variants();
  init_wolf_variants();
  init_world_clocks();
  init_zombie_nautilus_variants();
  init_tag_banner_patterns();
  init_tag_damage_types();
  init_tag_dialogs();
  init_tag_enchantments();
  init_tag_instruments();
  init_tag_painting_variants();
  init_tag_timelines();
  init_tag_villager_trades();
  init_tag_blocks();
  init_tag_entity_types();
  init_tag_fluids();
  init_tag_game_events();
  init_tag_items();
  init_tag_point_of_interest_types();
  init_tag_potions();
  init_tag_worldgen_features();
  init_tag_worldgen_biomes();
  init_tag_worldgen_flat_level_generator_presets();
  init_tag_worldgen_structures();
  init_tag_worldgen_world_presets();
  init_worldgen_biomes();
  init_worldgen_carvers();
  init_worldgen_density_functions();
  init_worldgen_features();
  init_worldgen_flat_level_generator_presets();
  init_worldgen_material_conditions();
  init_worldgen_material_rules();
  init_worldgen_multi_noise_biome_source_parameter_lists();
  init_worldgen_noises();
  init_worldgen_noise_settings();
  init_worldgen_placed_features();
  init_worldgen_processor_lists();
  init_worldgen_structures();
  init_worldgen_structure_sets();
  init_worldgen_template_pools();
  init_worldgen_world_presets();
  init_translation_keys();
  init_atlases();
  init_block_definitions();
  init_equipments();
  init_fonts();
  init_item_definitions();
  init_langs();
  init_models();
  init_post_effects();
  init_sounds();
  init_textures();
  init_activities();
  init_attributes();
  init_attribute_types();
  init_blocks2();
  init_block_entity_types();
  init_block_predicate_types();
  init_chunk_statuses();
  init_command_argument_types();
  init_consume_effect_types();
  init_creative_mode_tabs();
  init_custom_stats();
  init_data_component_predicate_types();
  init_data_component_types();
  init_debug_subscriptions();
  init_dialog_action_types();
  init_dialog_body_types();
  init_dialog_types();
  init_enchantment_effect_component_types();
  init_enchantment_entity_effect_types();
  init_enchantment_level_based_value_types();
  init_enchantment_location_based_effect_types();
  init_enchantment_provider_types();
  init_enchantment_value_effect_types();
  init_entity_sub_predicate_types();
  init_entity_types();
  init_environment_attributes();
  init_float_provider_types();
  init_fluids();
  init_game_events();
  init_game_rules();
  init_height_provider_types();
  init_incoming_rpc_methods();
  init_input_control_types();
  init_int_provider_types();
  init_items2();
  init_loot_condition_types();
  init_loot_function_types();
  init_loot_nbt_provider_types();
  init_loot_number_provider_types();
  init_loot_pool_entry_types();
  init_loot_score_provider_types();
  init_map_decoration_types();
  init_memory_module_types();
  init_menus();
  init_mob_effects();
  init_number_format_types();
  init_outgoing_rpc_methods();
  init_particle_types();
  init_permission_check_types();
  init_permission_types();
  init_point_of_interest_types();
  init_pos_rule_tests();
  init_position_source_types();
  init_potions();
  init_recipe_book_categories();
  init_recipe_displays();
  init_recipe_serializers();
  init_recipe_types();
  init_rule_block_entity_modifiers();
  init_rule_tests();
  init_sensor_types();
  init_slot_displays();
  init_slot_source_types();
  init_sound_events();
  init_spawn_condition_types();
  init_stat_types();
  init_test_environment_definition_types();
  init_test_functions();
  init_test_instance_types();
  init_trigger_types();
  init_ticket_types();
  init_villager_professions();
  init_villager_types();
  init_worldgen_biome_sources();
  init_worldgen_block_state_provider_types();
  init_worldgen_carver_types();
  init_worldgen_chunk_generators();
  init_worldgen_density_function_types();
  init_worldgen_feature_size_types();
  init_worldgen_feature_types();
  init_worldgen_foliage_placer_types();
  init_worldgen_material_condition_types();
  init_worldgen_material_rule_types();
  init_worldgen_placement_modifier_types();
  init_worldgen_pool_alias_bindings();
  init_worldgen_root_placer_types();
  init_worldgen_structure_pieces();
  init_worldgen_structure_placements();
  init_worldgen_structure_pool_elements();
  init_worldgen_structure_processors();
  init_worldgen_structure_types();
  init_worldgen_tree_decorator_types();
  init_worldgen_trunk_placer_types();
});

// src/arguments/generated/resources.ts
var RESOURCE_CLASS_TYPES;
var init_resources3 = __esm(() => {
  init_sandstone();
  RESOURCE_CLASS_TYPES = [
    [AdvancementClass, "advancement"],
    [BannerPatternClass, "banner_pattern"],
    [ChatTypeClass, "chat_type"],
    [DamageTypeClass, "damage_type"],
    [DecoratedPotPatternClass, "decorated_pot_pattern"],
    [DialogClass, "dialog"],
    [EnchantmentClass, "enchantment"],
    [EnchantmentProviderClass, "enchantment_provider"],
    [MCFunctionClass, "function"],
    [InstrumentClass, "instrument"],
    [ItemModifierClass, "item_modifier"],
    [JukeboxSongClass, "jukebox_song"],
    [LootTableClass, "loot_table"],
    [PredicateClass, "predicate"],
    [RecipeClass, "recipe"],
    [SlotSourceClass, "slot_source"],
    [StructureClass, "structure"],
    [SulfurCubeArchetypeClass, "sulfur_cube_archetype"],
    [TestEnvironmentClass, "test_environment"],
    [TestInstanceClass, "test_instance"],
    [TimelineClass, "timeline"],
    [TradeSetClass, "trade_set"],
    [TrialSpawnerClass, "trial_spawner"],
    [TrimMaterialClass, "trim_material"],
    [TrimPatternClass, "trim_pattern"],
    [VillagerTradeClass, "villager_trade"],
    [WorldClockClass, "world_clock"],
    [AtlasClass, "atlas"],
    [BlockStateDefinitionClass, "block_definition"],
    [EquipmentClass, "equipment"],
    [FontClass, "font"],
    [ItemModelDefinitionClass, "item_definition"],
    [LanguageClass, "lang"],
    [ModelClass, "model"],
    [ParticleClass, "particle"],
    [PostEffectClass, "post_effect"],
    [SoundEventClass, "sound"],
    [TextureClass, "texture"],
    [WaypointStyleClass, "waypoint_style"],
    [TagClass, "tag"]
  ];
});
// src/arguments/index.ts
var init_arguments = __esm(() => {
  init_basics();
  init_registry();
  init_registry_sets();
  init_resource_paths();
  init_resources3();
});

// src/core/resources/resourcepack/itemDefinition.ts
var exports_itemDefinition = {};
__export(exports_itemDefinition, {
  ItemModelDefinitionNode: () => ItemModelDefinitionNode,
  ItemModelDefinitionClass: () => ItemModelDefinitionClass,
  ItemModelBuilder: () => ItemModelBuilder
});
function normalizeModel(input) {
  if (typeof input === "string" || input instanceof ModelClass) {
    return { type: "model", model: input };
  }
  return input;
}
var ItemModelBuilder, ItemModelDefinitionNode, ItemModelDefinitionClass;
var init_itemDefinition = __esm(() => {
  init_arguments();
  init_nodes();
  init_resource();
  init_model();
  init_ItemPredicate();
      });

// src/variables/ItemPredicate.ts
import * as util11 from "util";
var ItemPredicateClass;
var init_ItemPredicate = __esm(() => {
  init_NBTs();
  init_utils();
  });

// src/variables/DataSets.ts
function DataIndexMapInternal(pack2, initialize, dataPoint2) {
  const indexMap = new DataIndexMapClass(pack2, initialize, dataPoint2);
  return new Proxy(indexMap, {
    get(target, p, receiver) {
      if (p in target) {
        return Reflect.get(target, p, receiver);
      }
      return target.get(p);
    },
    set(target, p, value, receiver) {
      if (p in target) {
        return Reflect.set(target, p, value, receiver);
      }
      target.set(p, value);
      return true;
    }
  });
}
function DataArrayInternal(pack2, initialize, dataPoint2) {
  const array = new DataArrayClass(pack2, initialize, dataPoint2);
  return new Proxy(array, {
    get(target, p, receiver) {
      if (typeof p === "string" && p in target) {
        return Reflect.get(target, p, receiver);
      }
      return target.get(Number(p));
    },
    set(target, p, value, receiver) {
      if (typeof p === "string" && p in target) {
        return Reflect.set(target, p, value, receiver);
      }
      target.set(Number(p), value);
      return true;
    }
  });
}
var IterableDataClass, DataIndexMapClass, DataArrayClass;
var init_DataSets = __esm(() => {
  init_Macro();
  init_Data();
  init_Score();
      });

// src/variables/Selector.ts
import * as util12 from "util";
function parseScore(core, scores) {
  return `{${Object.entries(scores).map(([scoreName, value]) => [scoreName, rangeParser(core, value)].join("=")).join(", ")}}`;
}
function parseAdvancements(advancements) {
  return `{${Object.entries(advancements).map(([advancementName, value]) => {
    if (typeof value === "boolean") {
      return [advancementName, value].join("=");
    }
    if (Array.isArray(value)) {
      if (Array.isArray(value[0])) {
        return [
          advancementName,
          `{${value.map((_value) => _value.join("=")).join(",")}}`
        ].join("=");
      }
      return [advancementName, `{${value.join("=")}}`].join("=");
    }
    return [advancementName, parseAdvancements(value)].join("=");
  }).join(", ")}}`;
}
var SelectorClass;
var init_Selector = __esm(() => {
  init_NBTs();
  init_parsers();
  init_utils();
  });

// src/variables/Label.ts

class EntityLabel {
  pack;
  label;
  selector;
  originalSelector;
  test = this;
  constructor(pack2, entity, label2) {
    this.pack = pack2;
    this.originalSelector = entity._toSelector();
    this.label = label2;
    const selector3 = typeof this.originalSelector === "string" ? new SelectorClass(this.pack, "@s") : new SelectorClass(this.pack, this.originalSelector.target, { ...this.originalSelector.arguments });
    if (selector3.arguments) {
      if (selector3.arguments.tag) {
        if (typeof selector3.arguments.tag === "string" || !Array.isArray(selector3.arguments.tag)) {
          selector3.arguments.tag = [selector3.arguments.tag, label2.fullName];
        } else {
          selector3.arguments.tag = [...selector3.arguments.tag, label2.fullName];
        }
      } else
        selector3.arguments.tag = [label2.fullName];
    } else
      selector3.arguments = { tag: [label2.fullName] };
    this.selector = selector3;
  }
  add = () => this.pack.commands.tag(this.originalSelector).add(this.label.fullName);
  remove = () => this.pack.commands.tag(this.originalSelector).remove(this.label.fullName);
  set(set) {
    if (typeof set === "boolean") {
      if (set)
        this.add();
      else
        this.remove();
    } else {
      this.pack._.if(set, () => this.add()).else(() => this.remove());
    }
  }
  toggle() {
    this.pack._.if(this.test, () => this.remove()).else(() => this.add());
  }
  toString = () => `Whether ${this.originalSelector.toString()} has the label ${this.label.toString()}`;
  _toMinecraftCondition = () => new this.pack.conditions.Label(this.pack.core, this);
  _toSelector = () => this.selector._toSelector();
  toNBT = () => this.selector._toSelector().toNBT();
  _toChatComponent = () => this.selector._toSelector()._toChatComponent();
}
var LabelClass;
var init_Label = __esm(() => {
  init_utils();
  init_Selector();
  });

// src/variables/Loop.ts
var LoopArgument;
var init_Loop = __esm(() => {
  init_function();
  init_nodes();
  });

// src/variables/Objective.ts
import * as util13 from "util";
var _RawObjectiveClass, ObjectiveClass;
var init_Objective = __esm(() => {
  init_utils();
  init_JSONTextComponentClass();
  init_parsers();
  init_Score();
    });

// src/variables/Trigger.ts
class TriggerClass {
  sandstoneCore;
  name;
  callback;
  pollingEvery;
  objective;
  constructor(sandstoneCore2, name, callback, pollingEvery) {
    this.sandstoneCore = sandstoneCore2;
    this.name = name;
    this.callback = callback;
    this.pollingEvery = pollingEvery;
    this.objective = new ObjectiveClass(sandstoneCore2.pack, name, "trigger", undefined, { creator: "sandstone" });
    const { registerNewObjective, MCFunction, commands: commands2 } = sandstoneCore2.pack;
    registerNewObjective(this.objective);
    if (!sandstoneCore2.checkTriggers[pollingEvery]) {
      sandstoneCore2.checkTriggers[pollingEvery] = MCFunction(`triggers/check/${pollingEvery}`, {
        creator: "sandstone",
        runEvery: pollingEvery
      });
    }
    sandstoneCore2.checkTriggers[pollingEvery].push(() => {
      commands2.execute.as(`@a[scores={${name}=1..}]`).at("@s").run(() => {
        const score2 = this.objective("@s");
        if (callback instanceof _RawMCFunctionClass || typeof callback === "function") {
          callback();
        } else if (callback[0] === "num") {
          score2.match(1, callback[1], callback[2])();
        } else {
          callback[1](score2);
        }
        score2["="](0);
      });
    });
  }
  toString = () => this.name;
}
var init_Trigger = __esm(() => {
  init_mcfunction();
  init_Objective();
});

// src/variables/UUID.ts
class UUIDClass {
  core;
  primarySource;
  known;
  scores;
  data;
  selector;
  constructor(core, _source, options) {
    this.core = core;
    let source = _source;
    if (typeof source === "string") {
      source = this.stringToArray(_source);
    }
    if (Array.isArray(source)) {
      if (typeof source[0] === "number") {
        this.primarySource = "known";
        this.known = source;
      } else {
        this.primarySource = "scores";
        this.scores = source;
      }
    } else if (source instanceof SelectorClass || source instanceof SelectorPickClass) {
      this.primarySource = "selector";
      const selectorResult = source._toSelector();
      if (typeof selectorResult !== "string") {
        this.selector = selectorResult;
      }
    } else {
      this.primarySource = "data";
      this.data = source;
    }
    if (options) {
      if (options.sources) {
        if (this.primarySource !== "known" && options.sources[this.primarySource]) {
          throw new Error("Attempted to set UUID source of the same type as the primary source in options!");
        }
        if (options.sources.scores) {
          this.setScores(options.sources.scores === true ? undefined : options.sources.scores);
        }
        if (options.sources.data) {
          this.setData(options.sources.data === true ? undefined : options.sources.data);
        }
        if (options.sources.selector) {
          this.selector = options.sources.selector;
        }
      }
    }
  }
  stringToArray(uuid3) {
    uuid3 = uuid3.trim();
    if (uuid3.includes("-")) {
      uuid3 = uuid3.split("-").map((g, i) => g.padStart(UUID_GROUP_SIZES[i], "0")).join("");
    } else {
      uuid3 = uuid3.padStart(32, "0");
    }
    UUIDData.setBigUint64(0, BigInt(`0x${uuid3.substring(0, 16)}`), false);
    UUIDData.setBigUint64(8, BigInt(`0x${uuid3.substring(16)}`), false);
    const array = [];
    for (let i = 0;i < 4; i++) {
      array.push(UUIDData.getInt32(i * 4, false));
    }
    return array;
  }
  arrayToString(array) {
    if (this.known || array) {
      if (!array) {
        array = this.known;
      }
      for (let i = 0;i < 4; i++) {
        UUIDData.setInt32(i * 4, array[i], false);
      }
      const hex = UUIDData.getBigUint64(0, false).toString(16).padStart(16, "0") + UUIDData.getBigUint64(8, false).toString(16).padStart(16, "0");
      const groups = [];
      let groupStart = 0;
      for (const groupSize of UUID_GROUP_SIZES) {
        groups.push(hex.substring(groupStart, groupStart + groupSize));
        groupStart += groupSize;
      }
      return groups.join("-");
    }
    throw new Error("Cannot convert a non-existent UUID array to a string!");
  }
  setKnown(uuid3) {
    this.known = uuid3;
    return this;
  }
  setScores(scores) {
    const { core } = this;
    const { Data, getTempStorage, initMCFunction, Variable } = core.pack;
    const handleConversions = (_scores) => {
      switch (this.primarySource) {
        case "known":
          {
            for (let i = 0;i < 4; i++) {
              _scores[i].set(this.known[i]);
            }
          }
          break;
        case "data":
          {
            let dataPoint2 = this.data;
            if (dataPoint2.type !== "storage") {
              const tempPoint = getTempStorage("UUID");
              tempPoint.set(dataPoint2);
              dataPoint2 = tempPoint;
            }
            for (let i = 0;i < 4; i++) {
              _scores[i].set(dataPoint2.select([i]));
            }
          }
          break;
        case "selector":
          {
            const storagePoint = getTempStorage("UUID");
            storagePoint.set(Data("entity", this.selector, "UUID"));
            for (let i = 0;i < 4; i++) {
              _scores[i].set(storagePoint.select([i]));
            }
          }
          break;
        default:
          break;
      }
    };
    if (scores === undefined) {
      handleConversions([Variable(), Variable(), Variable(), Variable()]);
    } else if (Array.isArray(scores[0])) {
      if (core.mcfunctionStack.length !== 0) {
        core.getCurrentMCFunctionOrThrow().resource.push(() => handleConversions(scores[0]));
      } else {
        initMCFunction.push(() => handleConversions(scores[0]));
      }
    } else {
      this.scores = scores;
    }
    return this;
  }
  setData(data2) {
    if (Array.isArray(data2) || data2 === undefined) {
      const { Data, DataVariable, ResolveNBT } = this.core.pack;
      if (data2 === undefined) {
        this.data = DataVariable(undefined, "__sandstone");
      } else {
        this.data = data2[0];
      }
      switch (this.primarySource) {
        case "known":
          {
            this.data.set(new NBTIntArray(this.known));
          }
          break;
        case "scores":
          {
            ResolveNBT(this.scores.map((score2) => ResolveNBTPart(score2)), this.data, true);
          }
          break;
        case "selector":
          {
            this.data.set(Data("entity", this.selector, "UUID"));
          }
          break;
        default:
          break;
      }
    } else {
      this.data = data2;
    }
    return this;
  }
  setSelector(selector3) {
    this.selector = selector3;
    return this;
  }
  convertForMacro() {
    if (this.known || this.selector) {
      return this;
    }
    this.core.depend("sgu");
    const pack2 = this.core.pack;
    const { Data, MCFunction, getTempStorage, commands: commands2 } = pack2;
    const { data: data2 } = commands2;
    let sourceData = this.data;
    if (!sourceData && this.scores) {
      this.setData();
      sourceData = this.data;
    }
    if (!sourceData) {
      throw new Error("No data source available for UUID conversion");
    }
    const tempUUID = getTempStorage("uuid");
    tempUUID.set(sourceData);
    const guInput = Data("storage", GU.STORAGE, GU.INPUT);
    guInput.set(tempUUID);
    commands2.functionCmd("gu:generate_from_storage");
    const cacheKeyVar = this.primarySource === "scores" && this.scores ? this.scores[0] : tempUUID;
    const currentFunction = this.core.getCurrentMCFunctionOrThrow();
    const cacheFunction = MCFunction(`${currentFunction.resource.name}/__uuid_cache`, [cacheKeyVar], () => {
      data2.modify.storage(UUID_CACHE.STORAGE, '"$(env_0)"').set.from.storage(GU.STORAGE, GU.OUTPUT);
    }, { creator: "sandstone", onConflict: "rename" });
    cacheFunction();
    return this;
  }
  get execute() {
    const { commands: commands2 } = this.core.pack;
    if (this.known) {
      return commands2.execute.as(this.arrayToString());
    }
    if (this.selector) {
      return commands2.execute.as(this.selector);
    }
    if (this.data || this.scores) {
      const pack2 = this.core.pack;
      const { MCFunction, getTempStorage, commands: commands3, Macro: Macro2, Data } = pack2;
      const { data: data2 } = commands3;
      let sourceData = this.data;
      if (!sourceData && this.scores) {
        this.setData();
        sourceData = this.data;
      }
      if (!sourceData) {
        throw new Error("No data source available for UUID execute");
      }
      const tempUUID = getTempStorage("uuid");
      tempUUID.set(sourceData);
      const cacheKeyVar = this.primarySource === "scores" && this.scores ? this.scores[0] : tempUUID;
      const currentFunction = this.core.getCurrentMCFunctionOrThrow();
      const uuidLookup = Data("storage", "__sandstone:temp", "uuid_lookup");
      MCFunction(`${currentFunction.resource.name}/__uuid_lookup`, [cacheKeyVar], () => {
        Macro2.data.modify(uuidLookup.select("uuid_string")).set.from.storage(UUID_CACHE.STORAGE, Macro2`"${cacheKeyVar}"`);
      }, { creator: "sandstone", onConflict: "rename" })();
      const deferredExecute = new ExecuteCommand(pack2, false, undefined, false);
      return createDeferredMacroExecute(pack2, deferredExecute, {
        childFunctionName: "__uuid_execute",
        prependArgs: () => [["as", "$(uuid_string)"]],
        macroStorage: uuidLookup
      });
    }
    throw new Error("Cannot use execute on a UUID with no available source. " + "The UUID must have at least one of: known value, selector, data, or scores.");
  }
  toString() {
    if (this.known) {
      return JSON.stringify(this.known);
    }
    return this.selector?.toString() || "Stored in scores or data storage";
  }
  _toChatComponent() {
    if (this.known) {
      return { selector: this.arrayToString() };
    }
    if (this.selector) {
      return { selector: this.selector.toString() };
    }
    if (this.scores) {
      return [...this.scores];
    }
    return this.data;
  }
  _toMinecraftCondition = () => new this.core.pack.conditions.UUID(this.core, this);
  _toSelector() {
    const selector3 = this.known ? this.arrayToString() : this.selector;
    if (!selector3) {
      throw new Error("Cannot create a selector without a UUID or existing selector");
    }
    return selector3;
  }
  toNBT() {
    const selector3 = this._toSelector();
    if (typeof selector3 === "string") {
      return `'${selector3}'`;
    }
    return selector3.toNBT();
  }
}
var GU, UUID_CACHE, UUIDData, UUID_GROUP_SIZES;
var init_UUID = __esm(() => {
  init_execute();
  init_abstractClasses();
  init_nbt();
  init_ResolveNBT();
  init_Selector();
  GU = {
    STORAGE: "gu:main",
    INPUT: "in",
    OUTPUT: "out"
  };
  UUID_CACHE = {
    STORAGE: "__sandstone:uuid_cache"
  };
  UUIDData = new DataView(new Uint8Array(16).buffer);
  UUID_GROUP_SIZES = [8, 4, 4, 4, 12];
});

// src/variables/index.ts
var init_variables2 = __esm(() => {
  init_abstractClasses();
  init_Coordinates();
  init_Data();
  init_ItemPredicate();
  init_DataSets();
  init_JSONTextComponentClass();
  init_Label();
  init_Loop();
  init_nbt();
  init_Objective();
  init_parsers();
  init_ResolveNBT();
  init_Score();
  init_Selector();
  init_Trigger();
  init_UUID();
});

// src/index.ts
init_pack2();
init_utils();
init_Coordinates();
init_ResolveNBT();
init_NBTs();
init_variables2();
init_core();
init_resources();
init_variables2();
init_core();
init_commands2();
init_flow();
init_pack2();
init_arguments();
var _sandstonePack2;
var sandstonePack2 = new Proxy({}, {
  get(_target, prop) {
    if (!_sandstonePack2) {
      if (hasContext()) {
        const ctx = getSandstoneContext();
        _sandstonePack2 = new SandstonePack(ctx.namespace, ctx.packUid);
      } else {
        _sandstonePack2 = new SandstonePack("default", "0");
      }
    }
    return _sandstonePack2[prop];
  }
});
function createSandstonePack(context) {
  setSandstoneContext(context);
  _sandstonePack2 = new SandstonePack(context.namespace, context.packUid);
  return _sandstonePack2;
}
function resetSandstonePack() {
  if (_sandstonePack2) {
    _sandstonePack2.reset();
  }
}
var commandsProxy2 = new Proxy({}, {
  get(_2, prop) {
    const fn = (...args) => {
      const cmd = sandstonePack2.commands[prop];
      if (typeof cmd === "function") {
        return cmd(...args);
      }
      throw new Error(`Command '${prop}' is not callable`);
    };
    return new Proxy(fn, {
      get(_target, subProp) {
        const cmd = sandstonePack2.commands[prop];
        return cmd[subProp];
      },
      apply(_target, _thisArg, args) {
        const cmd = sandstonePack2.commands[prop];
        if (typeof cmd === "function") {
          return cmd(...args);
        }
        throw new Error(`Command '${prop}' is not callable`);
      }
    });
  }
});
var {
  advancement: advancement4,
  attribute: attribute2,
  bossbar: bossbar2,
  clear: clear2,
  clone: clone2,
  comment: comment2,
  damage: damage2,
  data: data2,
  datapack: datapack3,
  debug: debug2,
  dialog: dialog3,
  defaultgamemode: defaultgamemode2,
  difficulty: difficulty2,
  effect: effect2,
  enchant: enchant2,
  execute: execute2,
  experience: experience2,
  fillbiome: fillbiome2,
  functionCmd,
  forceload: forceload2,
  gamemode: gamemode2,
  gamerule: gamerule2,
  help: help2,
  kill: kill2,
  list: list2,
  locate: locate2,
  loot: loot2,
  me: me2,
  msg,
  particle: particle3,
  perf,
  playsound: playsound2,
  place: place2,
  random: random2,
  raw: raw2,
  recipe: recipe3,
  reload: reload2,
  returnCmd,
  rotate: rotate2,
  ride: ride2,
  item: item2,
  jfr,
  say: say2,
  schedule: schedule2,
  scoreboard: scoreboard2,
  seed: seed2,
  setidletimeout: setidletimeout2,
  setworldspawn: setworldspawn2,
  spawnpoint: spawnpoint2,
  spectate: spectate2,
  spreadplayers: spreadplayers2,
  stopsound: stopsound2,
  stopwatch: stopwatch2,
  swing: swing2,
  tag: tag4,
  team: team2,
  teammsg,
  teleport: teleport2,
  tellraw: tellraw2,
  test: test2,
  time: time2,
  title: title2,
  trigger: trigger2,
  transfer: transfer2,
  version: version2,
  waypoint: waypoint2,
  w,
  weather: weather2,
  worldborder: worldborder2,
  tm,
  tp,
  xp,
  tell: tell2
} = commandsProxy2;
var give2 = (...args) => sandstonePack2.commands.give(...args);
var setblock2 = (...args) => sandstonePack2.commands.setblock(...args);
var fill2 = (...args) => sandstonePack2.commands.fill(...args);
var summon2 = (...args) => sandstonePack2.commands.summon(...args);
var packMethodsProxy2 = new Proxy({}, {
  get(_2, prop) {
    const fn = (...args) => {
      const method = sandstonePack2[prop];
      if (typeof method === "function") {
        return method(...args);
      }
      throw new Error(`Pack method '${prop}' is not callable`);
    };
    return new Proxy(fn, {
      get(_target, subProp) {
        const method = sandstonePack2[prop];
        const value = method[subProp];
        if (typeof value === "function" && typeof value.bind === "function") {
          return value.bind(method);
        }
        return value;
      },
      apply(_target, _thisArg, args) {
        const method = sandstonePack2[prop];
        if (typeof method === "function") {
          return method(...args);
        }
        throw new Error(`Pack method '${prop}' is not callable`);
      }
    });
  }
});
var _2 = new Proxy({}, {
  get(_target, prop) {
    return sandstonePack2._[prop];
  }
});
var {
  RawResource,
  MCFunction,
  Advancement,
  BannerPattern,
  ChatType,
  DamageType,
  DecoratedPotPattern,
  Dialog,
  Enchantment,
  EnchantmentProvider,
  Instrument,
  ItemModifier,
  JukeboxSong,
  LootTable,
  Predicate,
  Recipe,
  SlotSource,
  SulfurCubeArchetype,
  Tag,
  TestEnvironment,
  TestInstance,
  Timeline,
  TradeSet,
  TrialSpawner,
  TrimMaterial,
  TrimPattern,
  VillagerTrade,
  WorldClock,
  Atlas,
  BlockStateDefinition,
  Equipment,
  Font,
  ItemModelDefinition,
  Language,
  Model,
  Particle: ParticleResource,
  PostEffect,
  Shader,
  SoundEvent,
  SoundsIndex,
  PlainText,
  Texture,
  WaypointStyle,
  Objective: Objective2,
  Macro: Macro2,
  Variable,
  flowVariable,
  Trigger: Trigger2,
  Label: Label2,
  Data: Data2,
  DataVariable,
  getTempStorage,
  ResolveNBT: ResolveNBT2,
  DataIndexMap,
  DataArray,
  Selector: Selector2,
  UUID: UUID2,
  ItemPredicate: ItemPredicate2,
  makeCustomResource,
  loadTags,
  defaultNamespace
} = packMethodsProxy2;
var Variant = (...args) => sandstonePack2.Variant(...args);
var { absolute: absolute2, relative: relative2, local: local2 } = exports_Coordinates;
var abs = absolute2;
var rel = relative2;
var loc = local2;
var { getVanillaResource: getVanillaResource2, getExistingResource: getExistingResource2, depend: depend2 } = sandstonePack2.core;
var mcMetaCache2 = new Proxy({}, {
  get: () => sandstonePack2.core.mcMetaCache
});
export {
  xp,
  worldborder2 as worldborder,
  withCommands,
  weather2 as weather,
  waypoint2 as waypoint,
  w,
  version2 as version,
  trigger2 as trigger,
  transfer2 as transfer,
  tp,
  tm,
  title2 as title,
  time2 as time,
  test2 as test,
  tellraw2 as tellraw,
  tell2 as tell,
  teleport2 as teleport,
  teammsg,
  team2 as team,
  targetParser,
  tag4 as tag,
  swing2 as swing,
  summon2 as summon,
  structureRotationParser,
  structureMirrorParser,
  stopwatch2 as stopwatch,
  stopsound2 as stopsound,
  spreadplayers2 as spreadplayers,
  spectate2 as spectate,
  spawnpoint2 as spawnpoint,
  setworldspawn2 as setworldspawn,
  setidletimeout2 as setidletimeout,
  setblock2 as setblock,
  setSandstoneContext,
  seed2 as seed,
  scoreboard2 as scoreboard,
  schedule2 as schedule,
  say2 as say,
  sanitizeValue,
  sandstonePack2 as sandstonePack,
  rotationParser,
  rotate2 as rotate,
  ride2 as ride,
  returnCmd,
  resetSandstonePack,
  resetContext,
  reload2 as reload,
  relative2 as relative,
  rel,
  recipe3 as recipe,
  raw2 as raw,
  rangeParser,
  randomUUID,
  random2 as random,
  playsound2 as playsound,
  place2 as place,
  perf,
  particle3 as particle,
  parseNBT,
  parseJSONText,
  nbtResolver,
  msg,
  me2 as me,
  mcMetaCache2 as mcMetaCache,
  makeCustomResource,
  loot2 as loot,
  locate2 as locate,
  local2 as local,
  loc,
  loadTags,
  list2 as list,
  kill2 as kill,
  jsonStringify,
  jfr,
  item2 as item,
  isMacroArgument,
  help2 as help,
  hasContext,
  give2 as give,
  getVanillaResource2 as getVanillaResource,
  getTempStorage,
  getSandstoneContext,
  getResourceTypeFromInstance,
  getExistingResource2 as getExistingResource,
  gamerule2 as gamerule,
  gamemode2 as gamemode,
  functionCmd,
  forceload2 as forceload,
  flowVariable,
  fillbiome2 as fillbiome,
  fill2 as fill,
  experience2 as experience,
  executeSwitch,
  execute2 as execute,
  enchant2 as enchant,
  effect2 as effect,
  difficulty2 as difficulty,
  dialog3 as dialog,
  depend2 as depend,
  defaultgamemode2 as defaultgamemode,
  defaultVisitors,
  defaultNamespace,
  debug2 as debug,
  datapack3 as datapack,
  data2 as data,
  damage2 as damage,
  createSandstonePack,
  createDeferredMacroExecute,
  coordinatesParser,
  conditionToNode,
  componentPatchStringifier,
  comment2 as comment,
  clone2 as clone,
  clear2 as clear,
  bossbar2 as bossbar,
  blockStateStringifier,
  attribute2 as attribute,
  advancement4 as advancement,
  absolute2 as absolute,
  abs,
  _ShowAlias,
  _RawObjectiveClass,
  _RawMCFunctionClass,
  _RawLabelClass,
  _2 as _,
  ZOMBIE_NAUTILUS_VARIANTS_SET,
  WorldClockNode,
  WorldClockClass,
  WorldClock,
  WorldBorderNode,
  WorldBorderCommand,
  WithNodeVisitor,
  WithClass,
  WeatherCommandNode,
  WeatherCommand,
  WaypointStyleNode,
  WaypointStyleClass,
  WaypointStyle,
  WaypointModifyArguments,
  WaypointCommandNode,
  WaypointCommand,
  WORLD_CLOCKS_SET,
  WORLDGEN_WORLD_PRESETS_SET,
  WORLDGEN_TRUNK_PLACER_TYPES_SET,
  WORLDGEN_TREE_DECORATOR_TYPES_SET,
  WORLDGEN_TEMPLATE_POOLS_SET,
  WORLDGEN_STRUCTURE_TYPES_SET,
  WORLDGEN_STRUCTURE_SETS_SET,
  WORLDGEN_STRUCTURE_PROCESSORS_SET,
  WORLDGEN_STRUCTURE_POOL_ELEMENTS_SET,
  WORLDGEN_STRUCTURE_PLACEMENTS_SET,
  WORLDGEN_STRUCTURE_PIECES_SET,
  WORLDGEN_STRUCTURES_SET,
  WORLDGEN_ROOT_PLACER_TYPES_SET,
  WORLDGEN_PROCESSOR_LISTS_SET,
  WORLDGEN_POOL_ALIAS_BINDINGS_SET,
  WORLDGEN_PLACEMENT_MODIFIER_TYPES_SET,
  WORLDGEN_PLACED_FEATURES_SET,
  WORLDGEN_NOISE_SETTINGS_SET,
  WORLDGEN_NOISES_SET,
  WORLDGEN_MULTI_NOISE_BIOME_SOURCE_PARAMETER_LISTS_SET,
  WORLDGEN_MATERIAL_RULE_TYPES_SET,
  WORLDGEN_MATERIAL_RULES_SET,
  WORLDGEN_MATERIAL_CONDITION_TYPES_SET,
  WORLDGEN_MATERIAL_CONDITIONS_SET,
  WORLDGEN_FOLIAGE_PLACER_TYPES_SET,
  WORLDGEN_FLAT_LEVEL_GENERATOR_PRESETS_SET,
  WORLDGEN_FEATURE_TYPES_SET,
  WORLDGEN_FEATURE_SIZE_TYPES_SET,
  WORLDGEN_FEATURES_SET,
  WORLDGEN_DENSITY_FUNCTION_TYPES_SET,
  WORLDGEN_DENSITY_FUNCTIONS_SET,
  WORLDGEN_CHUNK_GENERATORS_SET,
  WORLDGEN_CARVER_TYPES_SET,
  WORLDGEN_CARVERS_SET,
  WORLDGEN_BLOCK_STATE_PROVIDER_TYPES_SET,
  WORLDGEN_BIOME_SOURCES_SET,
  WORLDGEN_BIOMES_SET,
  WOLF_VARIANTS_SET,
  WOLF_SOUND_VARIANTS_SET,
  VillagerTradeNode,
  VillagerTradeClass,
  VillagerTrade,
  VersionCommandNode,
  VersionCommand,
  VectorClass,
  VariantNode,
  VariantClass,
  Variant,
  Variable,
  VILLAGER_TYPES_SET,
  VILLAGER_TRADES_SET,
  VILLAGER_PROFESSIONS_SET,
  UntilClass,
  UnifyChainedExecutesVisitor,
  UUIDConditionNode,
  UUIDClass,
  UUID2 as UUID,
  TrimPatternNode,
  TrimPatternClass,
  TrimPattern,
  TrimMaterialNode,
  TrimMaterialClass,
  TrimMaterial,
  TriggerCommandNode,
  TriggerCommand,
  TriggerClass,
  TriggerArgumentsCommand,
  Trigger2 as Trigger,
  TrialSpawnerNode,
  TrialSpawnerClass,
  TrialSpawner,
  TransferCommandNode,
  TransferCommand,
  TradeSetNode,
  TradeSetClass,
  TradeSet,
  TitleCommandNode,
  TitleCommand,
  TitleArgumentsCommand,
  TimelineNode,
  TimelineClass,
  Timeline,
  TimeCommandNode,
  TimeCommand,
  TimeArguments,
  ThrowPropagationVisitor,
  ThrowNode,
  ThrowInlineVisitor,
  TextureNode,
  TextureClass,
  Texture,
  TextComponentClass,
  TestInstanceNode,
  TestInstanceClass,
  TestInstance,
  TestEnvironmentNode,
  TestEnvironmentClass,
  TestEnvironment,
  TestCommandNode,
  TestCommand,
  TellRawCommandNode,
  TellRawCommand,
  TellCommandNode,
  TellCommand,
  TeleportFacingCommand,
  TeleportCommandNode,
  TeleportCommand,
  TeamMessageCommandNode,
  TeamMessageCommand,
  TeamCommandNode,
  TeamCommand,
  TargetlessDataPointClass,
  TargetlessDataClass,
  TagNode,
  TagConditionNode,
  TagCommandNode,
  TagCommand,
  TagClass,
  TagArgumentsCommand,
  Tag,
  TRIM_PATTERNS_SET,
  TRIM_MATERIALS_SET,
  TRIGGER_TYPES_SET,
  TRIAL_SPAWNERS_SET,
  TRANSLATION_KEYS_SET,
  TRADE_SETS_SET,
  TIMELINES_SET,
  TICKET_TYPES_SET,
  TEXTURES_SET,
  TEST_INSTANCE_TYPES_SET,
  TEST_INSTANCES_SET,
  TEST_FUNCTIONS_SET,
  TEST_ENVIRONMENT_DEFINITION_TYPES_SET,
  TEST_ENVIRONMENTS_SET,
  TAG_WORLDGEN_WORLD_PRESETS_SET,
  TAG_WORLDGEN_STRUCTURES_SET,
  TAG_WORLDGEN_FLAT_LEVEL_GENERATOR_PRESETS_SET,
  TAG_WORLDGEN_FEATURES_SET,
  TAG_WORLDGEN_BIOMES_SET,
  TAG_VILLAGER_TRADES_SET,
  TAG_TIMELINES_SET,
  TAG_POTIONS_SET,
  TAG_POINT_OF_INTEREST_TYPES_SET,
  TAG_PAINTING_VARIANTS_SET,
  TAG_ITEMS_SET,
  TAG_INSTRUMENTS_SET,
  TAG_GAME_EVENTS_SET,
  TAG_FLUIDS_SET,
  TAG_ENTITY_TYPES_SET,
  TAG_ENCHANTMENTS_SET,
  TAG_DIALOGS_SET,
  TAG_DAMAGE_TYPES_SET,
  TAG_BLOCKS_SET,
  TAG_BANNER_PATTERNS_SET,
  SwitchTransformationVisitor,
  SwitchNode,
  SwingCommandNode,
  SwingCommand,
  SummonCommandNode,
  SummonCommand,
  SulfurCubeArchetypeNode,
  SulfurCubeArchetypeClass,
  SulfurCubeArchetype,
  StructureNode,
  StructureClass,
  StringDataPointClass,
  StopwatchCommandNode,
  StopwatchCommand,
  StopSoundCommandNode,
  StopSoundCommand,
  StaticCaseNode,
  SpreadPlayersNode,
  SpreadPlayersCommand,
  SpectateCommandNode,
  SpectateCommand,
  SpawnPointCommandNode,
  SpawnPointCommand,
  SoundsIndexNode,
  SoundsIndexClass,
  SoundsIndex,
  SoundEventNode,
  SoundEventClass,
  SoundEvent,
  SlotsEntityConditionNode,
  SlotsBlockConditionNode,
  SlotSourceNode,
  SlotSourceConditionNode,
  SlotSourceClass,
  SlotSource,
  SleepClass,
  SingleExecuteNode,
  SingleConditionNode,
  SimplifyReturnRunFunctionVisitor,
  SimplifyExecuteFunctionVisitor,
  ShaderNode,
  ShaderClass,
  Shader,
  SetWorldSpawnCommandNode,
  SetWorldSpawnCommand,
  SetIdleTimeoutCommandNode,
  SetIdleTimeoutCommand,
  SetBlockCommandNode,
  SetBlockCommand,
  Set2 as Set,
  SelectorPickClass,
  SelectorConditionNode,
  SelectorClass,
  Selector2 as Selector,
  SeedCommandNode,
  SeedCommand,
  ScoreboardPlayersDisplayCommand,
  ScoreboardObjectivesModifyCommand,
  ScoreboardCommandNode,
  ScoreboardCommand,
  ScoreConditionNode,
  Score,
  ScheduleCommandNode,
  ScheduleCommand,
  SayCommandNode,
  SayCommand,
  SandstonePack,
  SandstoneCore,
  SandstoneConditions,
  SandstoneCommands,
  SULFUR_CUBE_ARCHETYPES_SET,
  STRUCTURES_SET,
  STAT_TYPES_SET,
  SPAWN_CONDITION_TYPES_SET,
  SOUND_EVENTS_SET,
  SOUNDS_SET,
  SLOT_SOURCE_TYPES_SET,
  SLOT_DISPLAYS_SET,
  SENSOR_TYPES_SET,
  RotateFacingArguments,
  RotateCommandNode,
  RotateCommand,
  RideCommandNode,
  RideCommand,
  RideArgumentsCommand,
  ReturnRunCommandNode,
  ReturnCommandNode,
  ReturnCommand,
  ReturnArgumentsCommand,
  ResourcePackDependencies,
  ResourcePack,
  ResourceNodesMap,
  ResourceClass,
  ResolvedNBT,
  ResolveNBTPartClass,
  ResolveNBTPart,
  ResolveNBTNode,
  ResolveNBTClass,
  ResolveNBT2 as ResolveNBT,
  ReloadCommandNode,
  ReloadCommand,
  RecipeNode,
  RecipeCommandNode,
  RecipeCommand,
  RecipeClass,
  Recipe,
  RawResource,
  RawCommandNode,
  RawCommand,
  RandomCommandNode,
  RandomCommand,
  RULE_TESTS_SET,
  RULE_BLOCK_ENTITY_MODIFIERS_SET,
  RESOURCE_PATHS,
  RESOURCE_CLASS_TYPES,
  REGISTRIES_SET,
  RECIPE_TYPES_SET,
  RECIPE_SERIALIZERS_SET,
  RECIPE_DISPLAYS_SET,
  RECIPE_BOOK_CATEGORIES_SET,
  RECIPES_SET,
  PredicateNode,
  PredicateConditionNode,
  PredicateClass,
  Predicate,
  PostEffectNode,
  PostEffectCommandNode,
  PostEffectCommand,
  PostEffectClass,
  PostEffect,
  PlaySoundCommandNode,
  PlaySoundCommand,
  PlainTextNode,
  PlainTextClass,
  PlainText,
  PlaceCommandNode,
  PlaceCommand,
  PerfCommandNode,
  PerfCommand,
  ParticleResource,
  ParticleNode,
  ParticleCommandNode,
  ParticleCommand,
  ParticleClass,
  PackType,
  PREDICATES_SET,
  POTIONS_SET,
  POS_RULE_TESTS_SET,
  POST_EFFECTS_SET,
  POSITION_SOURCE_TYPES_SET,
  POINT_OF_INTEREST_TYPES_SET,
  PIG_VARIANTS_SET,
  PIG_SOUND_VARIANTS_SET,
  PERMISSION_TYPES_SET,
  PERMISSION_CHECK_TYPES_SET,
  PARTICLE_TYPES_SET,
  PAINTING_VARIANTS_SET,
  OrTransformationVisitor,
  OrNode,
  OptimizeMacroTemporariesVisitor,
  ObjectiveClass,
  Objective2 as Objective,
  OUTGOING_RPC_METHODS_SET,
  NotNode,
  NotNBT,
  Node,
  NUMBER_PROVIDERS_SET,
  NUMBER_FORMAT_TYPES_SET,
  NBTpathToString,
  NBTTypedArray,
  NBTString,
  NBTShort,
  NBTPrimitive,
  NBTLongArray,
  NBTLong,
  NBTIntArray,
  NBTInt,
  NBTFloat,
  NBTDouble,
  NBTClass,
  NBTByteArray,
  NBTByte,
  NBTAnyValue,
  NBT,
  ModelNode,
  ModelClass,
  Model,
  MeCommandNode,
  MeCommand,
  MacroLiteral,
  MacroArgument,
  Macro2 as Macro,
  MODELS_SET,
  MOB_EFFECTS_SET,
  MENUS_SET,
  MEMORY_MODULE_TYPES_SET,
  MCFunctionNode,
  MCFunctionClass,
  MCFunction,
  MAP_DECORATION_TYPES_SET,
  LootTableNode,
  LootTableClass,
  LootTable,
  LootSourceCommand,
  LootCommandNode,
  LootCommand,
  LoopTransformationVisitor,
  LoopNode,
  LoopArgument,
  LocateCommandNode,
  LocateCommand,
  LoadedConditionNode,
  ListResource,
  ListCommandNode,
  ListCommand,
  LanguageNode,
  LanguageClass,
  Language,
  LabelConditionNode,
  LabelClass,
  Label2 as Label,
  LOOT_TABLES_SET,
  LOOT_SCORE_PROVIDER_TYPES_SET,
  LOOT_POOL_ENTRY_TYPES_SET,
  LOOT_NUMBER_PROVIDER_TYPES_SET,
  LOOT_NBT_PROVIDER_TYPES_SET,
  LOOT_FUNCTION_TYPES_SET,
  LOOT_CONDITION_TYPES_SET,
  LANGS_SET,
  KillCommandNode,
  KillCommand,
  JukeboxSongNode,
  JukeboxSongClass,
  JukeboxSong,
  JUKEBOX_SONGS_SET,
  JSONTextComponentClass,
  JFRCommandNode,
  JFRCommand,
  IterableDataClass,
  ItemsEntityConditionNode,
  ItemsBlockConditionNode,
  ItemSourceCommand,
  ItemPredicateClass,
  ItemPredicate2 as ItemPredicate,
  ItemModifierNode,
  ItemModifierClass,
  ItemModifier,
  ItemModelDefinitionNode,
  ItemModelDefinitionClass,
  ItemModelDefinition,
  ItemModelBuilder,
  ItemCommandNode,
  ItemCommand,
  InstrumentNode,
  InstrumentClass,
  Instrument,
  InlineFunctionCallVisitor,
  InitObjectivesVisitor,
  InitConstantsVisitor,
  IfStatement,
  IfNode,
  IfElseTransformationVisitor,
  ITEM_DEFINITIONS_SET,
  ITEMS_SET,
  INT_PROVIDER_TYPES_SET,
  INSTRUMENTS_SET,
  INPUT_CONTROL_TYPES_SET,
  INCOMING_RPC_METHODS_SET,
  HelpCommandNode,
  HelpCommand,
  HEIGHT_PROVIDER_TYPES_SET,
  GiveCommandNode,
  GiveCommand,
  GenerateLazyMCFunction,
  GameRuleCommandNode,
  GameRuleCommand,
  GameModeCommandNode,
  GameModeCommand,
  GAME_RULES_SET,
  GAME_EVENTS_SET,
  FunctionConditionNode,
  FunctionCommandNode,
  FunctionCommand,
  ForceLoadCommandNode,
  ForceLoadCommand,
  FontNode,
  FontClass,
  Font,
  FlowClauseNode,
  Flow,
  FinalCommandOutput,
  FillReplaceFilterCommand,
  FillCommandNode,
  FillCommand,
  FillBiomeCommandNode,
  FillBiomeCommand,
  FillArgumentsCommand,
  FROG_VARIANTS_SET,
  FONTS_SET,
  FLUIDS_SET,
  FLOAT_PROVIDER_TYPES_SET,
  ExperienceCommandNode,
  ExperienceCommand,
  ExecuteStoreCommand,
  ExecuteStoreArgsCommand,
  ExecuteSlotsCommand,
  ExecuteRotatedAsCommand,
  ExecutePositionedCommand,
  ExecuteItemsCommand,
  ExecuteIfUnlessCommand,
  ExecuteFacingEntityCommand,
  ExecuteDataArgsCommand,
  ExecuteCommandPart,
  ExecuteCommandNode,
  ExecuteCommand,
  EquipmentNode,
  EquipmentClass,
  Equipment,
  EntityLabel,
  EnchantmentProviderNode,
  EnchantmentProviderClass,
  EnchantmentProvider,
  EnchantmentNode,
  EnchantmentClass,
  Enchantment,
  EnchantCommandNode,
  EnchantCommand,
  ElseStatement,
  ElseNode,
  EffectCommandNode,
  EffectCommand,
  EQUIPMENTS_SET,
  ENVIRONMENT_ATTRIBUTES_SET,
  ENTITY_TYPES_SET,
  ENTITY_SUB_PREDICATE_TYPES_SET,
  ENCHANTMENT_VALUE_EFFECT_TYPES_SET,
  ENCHANTMENT_PROVIDER_TYPES_SET,
  ENCHANTMENT_PROVIDERS_SET,
  ENCHANTMENT_LOCATION_BASED_EFFECT_TYPES_SET,
  ENCHANTMENT_LEVEL_BASED_VALUE_TYPES_SET,
  ENCHANTMENT_ENTITY_EFFECT_TYPES_SET,
  ENCHANTMENT_EFFECT_COMPONENT_TYPES_SET,
  ENCHANTMENTS_SET,
  DimensionConditionNode,
  DifficultyCommandNode,
  DifficultyCommand,
  DialogNode,
  DialogCommandNode,
  DialogCommand,
  DialogClass,
  Dialog,
  DefaultGameModeCommandNode,
  DefaultGameModeCommand,
  DefaultCaseNode,
  DecoratedPotPatternNode,
  DecoratedPotPatternClass,
  DecoratedPotPattern,
  DebugCommandNode,
  DebugCommand,
  DataVariable,
  DataRemoveCommand,
  DataPointPickClass,
  DataPointExistsConditionNode,
  DataPointEqualsConditionNode,
  DataPointClass,
  DataPackEnableCommand,
  DataPackDependencies,
  DataPackCommandNode,
  DataPackCommand,
  DataPack,
  DataModifyValuesCommand,
  DataModifyTypeCommand,
  DataModifyFromCommand,
  DataModifyCommand,
  DataMergeCommand,
  DataIndexMapInternal,
  DataIndexMapClass,
  DataIndexMap,
  DataGetCommand,
  DataCommandNode,
  DataCommand,
  DataClass,
  DataArrayInternal,
  DataArrayClass,
  DataArray,
  Data2 as Data,
  DamageTypeNode,
  DamageTypeClass,
  DamageType,
  DamageSourceCommand,
  DamageCommandNode,
  DamageCommand,
  DamageCauseCommand,
  DIMENSION_TYPES_SET,
  DIMENSIONS_SET,
  DIALOG_TYPES_SET,
  DIALOG_BODY_TYPES_SET,
  DIALOG_ACTION_TYPES_SET,
  DIALOGS_SET,
  DECORATED_POT_PATTERNS_SET,
  DEBUG_SUBSCRIPTIONS_SET,
  DATA_COMPONENT_TYPES_SET,
  DATA_COMPONENT_PREDICATE_TYPES_SET,
  DAMAGE_TYPES_SET,
  CustomResourceNode,
  CustomResourceClass,
  ContainerNode,
  ContainerCommandsToMCFunctionVisitor,
  ContainerCommandNode,
  ConditionalDataPointPickClass,
  ConditionTextComponentClass,
  ConditionNode,
  ConditionClass,
  ConditionCaseNode,
  CommentCommandNode,
  CommentCommand,
  CommandNode,
  CommandArguments,
  CloneToDimensionCommand,
  CloneStrictOptionsCommand,
  CloneOptionsCommand,
  CloneModeCommand,
  CloneFromDimensionCommand,
  CloneCommandNode,
  CloneCommand,
  ClearCommandNode,
  ClearCommand,
  ChatTypeNode,
  ChatTypeClass,
  ChatType,
  CaseStatement,
  CallableResourceClass,
  CUSTOM_STATS_SET,
  CREATIVE_MODE_TABS_SET,
  COW_VARIANTS_SET,
  COW_SOUND_VARIANTS_SET,
  CONSUME_EFFECT_TYPES_SET,
  COMMAND_ARGUMENT_TYPES_SET,
  CHUNK_STATUSES_SET,
  CHICKEN_VARIANTS_SET,
  CHICKEN_SOUND_VARIANTS_SET,
  CHAT_TYPES_SET,
  CAT_VARIANTS_SET,
  CAT_SOUND_VARIANTS_SET,
  BossBarSetCommand,
  BossBarCommandNode,
  BossBarCommand,
  BlocksConditionNode,
  BlockStateDefinitionNode,
  BlockStateDefinitionClass,
  BlockStateDefinition,
  BlockConditionNode,
  BiomeConditionNode,
  BannerPatternNode,
  BannerPatternClass,
  BannerPattern,
  BLOCK_PREDICATE_TYPES_SET,
  BLOCK_ENTITY_TYPES_SET,
  BLOCK_DEFINITIONS_SET,
  BLOCKS_SET,
  BANNER_PATTERNS_SET,
  AwaitNode,
  AttributeOperationCommand,
  AttributeCommandNode,
  AttributeCommand,
  AttachClass,
  AtlasNode,
  AtlasClass,
  Atlas,
  AndNode,
  AdvancementNode,
  AdvancementConditionNode,
  AdvancementCommandNode,
  AdvancementCommand,
  AdvancementClass,
  AdvancementArgumentsCommand,
  Advancement,
  ATTRIBUTE_TYPES_SET,
  ATTRIBUTES_SET,
  ATLASES_SET,
  ADVANCEMENTS_SET,
  ACTIVITIES_SET
};

//# debugId=CCE75EFFFBF1E53164756E2164756E21
//# sourceMappingURL=index.js.map
